
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f1q41", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("bj515", function(module, exports) {

$parcel$export(module.exports, "allCommands", () => $f26232106cde7c91$export$9a98b353f0f5e18e);
$parcel$export(module.exports, "primaryCommand", () => $f26232106cde7c91$export$9cc71d049314b67f);
$parcel$export(module.exports, "actionForCommand", () => $f26232106cde7c91$export$15f221b053afd71e);
$parcel$export(module.exports, "actionForKeyCode", () => $f26232106cde7c91$export$1ed0c2638cbd476d);
$parcel$export(module.exports, "default", () => $f26232106cde7c91$export$2e2bcd8739ae039);

var $aGCFn = parcelRequire("aGCFn");

var $fRSJ8 = parcelRequire("fRSJ8");

var $ls8n9 = parcelRequire("ls8n9");

var $8D2Sv = parcelRequire("8D2Sv");

var $51Ld3 = parcelRequire("51Ld3");
const $f26232106cde7c91$var$actions = [
    {
        description: "Static",
        keycode: "Digit8",
        commands: [
            "eight",
            "8",
            "ate",
            "static"
        ],
        callback: (effects)=>(0, $51Ld3.default).addTo(effects)
    },
    {
        description: "LiveVideo",
        keycode: "Digit9",
        commands: [
            "nine",
            "9",
            "live",
            "video"
        ],
        callback: (effects, video)=>(0, $ls8n9.default).addTo(effects, video)
    },
    {
        description: "Reset",
        keycode: "Digit0",
        commands: [
            "zero",
            "0",
            "reset",
            "clear",
            "start over",
            "restart"
        ],
        // TODO detach handlers?
        callback: (effects)=>effects.splice(0)
    },
    {
        description: "Freeze",
        keycode: "Digit1",
        commands: [
            "one",
            "1",
            "won",
            "freeze",
            "free",
            "fries",
            "frieze",
            "priest",
            "prince",
            "trees"
        ],
        callback: (effects)=>(0, $fRSJ8.default).addTo(effects)
    },
    {
        description: "Shadow",
        keycode: "Digit2",
        commands: [
            "two",
            "2",
            "to",
            "too",
            "shadow",
            "start shadow",
            "shout out",
            "shut up",
            "add shadow",
            "at shadow"
        ],
        callback: (effects)=>(0, $8D2Sv.default).addTo(effects)
    },
    {
        description: "Cannon",
        keycode: "Digit3",
        commands: [
            "three",
            "3",
            "cannon",
            "start cannon",
            "start canon",
            "canon",
            "add cannon",
            "add canon",
            "at cannon",
            "at canon"
        ],
        callback: (effects)=>(0, $aGCFn.default).addTo(effects)
    },
    {
        description: "Show/hide controls",
        keycode: "KeyH",
        commands: [],
        // no-op; handled by dat.gui directly
        callback: (_effects)=>{}
    }
];
const $f26232106cde7c91$export$9a98b353f0f5e18e = ()=>$f26232106cde7c91$var$actions.map((action)=>action.commands).flat();
const $f26232106cde7c91$export$9cc71d049314b67f = (action)=>action.commands[0];
const $f26232106cde7c91$export$b25c2ba67ba8ea30 = ()=>$f26232106cde7c91$var$actions.map((action)=>$f26232106cde7c91$export$9cc71d049314b67f(action)).filter((command)=>!!command);
const $f26232106cde7c91$export$8ac875047f8f2a99 = ()=>$f26232106cde7c91$var$actions.map((action)=>action.commands.slice(1)).flat();
const $f26232106cde7c91$export$15f221b053afd71e = (command)=>$f26232106cde7c91$var$actions.find((action)=>action.commands.includes(command));
const $f26232106cde7c91$export$1ed0c2638cbd476d = (keycode)=>$f26232106cde7c91$var$actions.find((action)=>action.keycode === keycode);
var $f26232106cde7c91$export$2e2bcd8739ae039 = $f26232106cde7c91$var$actions;

});
parcelRegister("aGCFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f7ad7d75e965416$export$2e2bcd8739ae039);

var $fqqUr = parcelRequire("fqqUr");

var $4ynSh = parcelRequire("4ynSh");

var $doWik = parcelRequire("doWik");

var $dOTXv = parcelRequire("dOTXv");

var $8L83R = parcelRequire("8L83R");
/**
 * increases the delay on a logarithmic scale, so that there's a greater delay up front and closer together the more Cannons are added
 */ const $1f7ad7d75e965416$var$computeDelay = (effects)=>{
    const numExistingCannons = effects.reduce((prev, effect)=>effect instanceof $1f7ad7d75e965416$export$2e2bcd8739ae039 ? prev + 1 : prev, 0);
    // the numbers are somewhat arbitrary; played around until it looked good
    return 2 * Math.log(numExistingCannons + 1) + 6;
};
class $1f7ad7d75e965416$export$2e2bcd8739ae039 extends (0, $dOTXv.default) {
    /** @param delay - the amount of time to wait, in seconds */ constructor({ delay: delay = 1, color: color = $8L83R.BLACK }){
        super(), // there isn't a way to retrieve from Stats, so hard code
        // TODO calculate this based on the time since the last call to onAnimationFrame()
        this.FRAMES_PER_SECOND = 63;
        this.delay = delay;
        this.color = color;
        const framesToKeep = this.delay * this.FRAMES_PER_SECOND;
        this.poses = new (0, $fqqUr.MaxSizeQueue)(framesToKeep);
    }
    /**
   * @returns the oldest saved frame
   */ poseToDisplay() {
        return this.poses.peek();
    }
    sortVal(_currentPose) {
        const oldPose = this.poseToDisplay();
        // TODO confirm whether this race condition still exists
        if (!oldPose) return null;
        return (0, $doWik.getAverageDepth)(oldPose.keypoints);
    }
    async onAnimationFrame(pose, canvas) {
        this.poses.push(pose);
        const oldPose = this.poseToDisplay();
        (0, $4ynSh.drawSkeleton)(oldPose, canvas, this.color);
    }
    /**
   * Adds a Cannon to the list of effects.
   * @param effects - gets modified
   */ static addTo(effects) {
        const delay = $1f7ad7d75e965416$var$computeDelay(effects);
        const color = $8L83R.getNext();
        const effect = new $1f7ad7d75e965416$export$2e2bcd8739ae039({
            delay: delay,
            color: color
        });
        effects.push(effect);
    }
}

});
parcelRegister("fqqUr", function(module, exports) {

$parcel$export(module.exports, "MaxSizeQueue", () => $3b12d1cfc6ae3da6$export$fd6c2d816ef24a1a);
class $3b12d1cfc6ae3da6$export$fd6c2d816ef24a1a {
    constructor(maxSize){
        this.items = [];
        this.maxSize = maxSize;
    }
    peek() {
        return this.items[0];
    }
    push(item) {
        this.items.push(item);
        if (this.items.length > this.maxSize) this.items.shift();
    }
}

});

parcelRegister("4ynSh", function(module, exports) {

$parcel$export(module.exports, "drawMask", () => $5b1f9d4c348729d8$export$36ff583a570c1e17);
$parcel$export(module.exports, "drawSkeleton", () => $5b1f9d4c348729d8$export$7925fe44416bc3a);

var $7eahY = parcelRequire("7eahY");

var $jaTVV = parcelRequire("jaTVV");

var $8L83R = parcelRequire("8L83R");
const $5b1f9d4c348729d8$var$getMask = async (segmentation, color = (0, $8L83R.BLACK))=>{
    const backgroundColor = (0, $8L83R.CLEAR);
    const drawContour = false;
    // https://github.com/tensorflow/tfjs-models/blob/master/body-segmentation/README.md#bodysegmentationtobinarymask
    const coloredPartImage = await (0, $jaTVV.toBinaryMask)(segmentation, color, backgroundColor, drawContour);
    return coloredPartImage;
};
let $5b1f9d4c348729d8$var$canvas2;
const $5b1f9d4c348729d8$var$drawImageDataWithTransparency = (canvas, imageData)=>{
    // Render to offscreen canvas to convert the ImageData to something that can be used by drawImage(), which supports transparency. putImageData() overwrites with transparent pixels.
    // https://stackoverflow.com/a/53239232/358804
    const width = canvas.width();
    const height = canvas.height();
    if (!$5b1f9d4c348729d8$var$canvas2 || $5b1f9d4c348729d8$var$canvas2.width !== width || $5b1f9d4c348729d8$var$canvas2.height !== height) // cache the canvas
    $5b1f9d4c348729d8$var$canvas2 = new OffscreenCanvas(width, height);
    const ctx2 = $5b1f9d4c348729d8$var$canvas2.getContext("2d");
    if (!ctx2) return;
    ctx2.putImageData(imageData, 0, 0);
    canvas.context.drawImage($5b1f9d4c348729d8$var$canvas2, 0, 0);
};
const $5b1f9d4c348729d8$export$36ff583a570c1e17 = async (segmentation, canvas, color = (0, $8L83R.BLACK))=>{
    const coloredPartImage = await $5b1f9d4c348729d8$var$getMask(segmentation, color);
    $5b1f9d4c348729d8$var$drawImageDataWithTransparency(canvas, coloredPartImage);
};
const $5b1f9d4c348729d8$export$7925fe44416bc3a = (pose, canvas, color = (0, $8L83R.BLACK))=>{
    const skeleton = new (0, $7eahY.default)(pose, color);
    skeleton.draw(canvas);
};

});
parcelRegister("7eahY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a9aaa76a2222a7$export$2e2bcd8739ae039);

var $gvL88 = parcelRequire("gvL88");

var $3HJq6 = parcelRequire("3HJq6");

var $8L83R = parcelRequire("8L83R");

var $doWik = parcelRequire("doWik");
const $b0a9aaa76a2222a7$var$params = {
    STATE: {
        model: (0, $3HJq6.MODEL),
        modelConfig: {
            scoreThreshold: 0.1
        }
    }
};
// based on
// https://github.com/tensorflow/tfjs-models/blob/4e8fa791175b9f637cbecdbc579ab71d3f35e48c/pose-detection/demos/live_video/src/camera.js#L203-L234
class $b0a9aaa76a2222a7$var$Camera {
    constructor(ctx){
        this.ctx = ctx;
    }
    drawSkeleton(keypoints, { color: color = $8L83R.BLACK, lineWidth: lineWidth = 6 }) {
        const colorStr = $8L83R.toRGBA(color);
        this.ctx.fillStyle = colorStr;
        this.ctx.strokeStyle = colorStr;
        this.ctx.lineWidth = lineWidth;
        $gvL88.util.getAdjacentPairs($b0a9aaa76a2222a7$var$params.STATE.model).forEach(([i, j])=>{
            const kp1 = keypoints[i];
            const kp2 = keypoints[j];
            // If score is null, just show the keypoint.
            const score1 = kp1.score != null ? kp1.score : 1;
            const score2 = kp2.score != null ? kp2.score : 1;
            const scoreThreshold = $b0a9aaa76a2222a7$var$params.STATE.modelConfig.scoreThreshold || 0;
            if (score1 >= scoreThreshold && score2 >= scoreThreshold) {
                this.ctx.beginPath();
                this.ctx.moveTo(kp1.x, kp1.y);
                this.ctx.lineTo(kp2.x, kp2.y);
                this.ctx.stroke();
            }
        });
    }
}
class $b0a9aaa76a2222a7$export$2e2bcd8739ae039 {
    constructor(pose, color = $8L83R.BLACK){
        this.keypoints = pose.keypoints;
        this.color = color;
    }
    draw(canvas) {
        const camera = new $b0a9aaa76a2222a7$var$Camera(canvas.context);
        canvas.context.lineCap = "round";
        const lineWidth = (0, $doWik.calculateLineWidth)(this.keypoints);
        camera.drawSkeleton(this.keypoints, {
            color: this.color,
            lineWidth: lineWidth
        });
    }
}

});
parcelRegister("gvL88", function(module, exports) {

$parcel$export(module.exports, "SupportedModels", () => $c05419b1d6c7e886$export$2f09812b4c450c2b);
$parcel$export(module.exports, "util", () => $c05419b1d6c7e886$export$7debb50ef11d5e0b);
$parcel$export(module.exports, "createDetector", () => $c05419b1d6c7e886$export$5221435586e5381b);
/**
    * @license
    * Copyright 2023 Google LLC. All Rights Reserved.
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    * http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    * =============================================================================
    */ 
var $xjHPn = parcelRequire("xjHPn");
parcelRequire("i64bB");
var $hgacW = parcelRequire("hgacW");
var $jctS7 = parcelRequire("jctS7");
var $c2DT1 = parcelRequire("c2DT1");
var $cpgue = parcelRequire("cpgue");
var $inFmq = parcelRequire("inFmq");
var $cOWuO = parcelRequire("cOWuO");
var $iTu6j = parcelRequire("iTu6j");
var $1QPqB = parcelRequire("1QPqB");
var $ibsdL = parcelRequire("ibsdL");
var $2PcQK = parcelRequire("2PcQK");
var $iPDWZ = parcelRequire("iPDWZ");
var $aosGd = parcelRequire("aosGd");
var $6V8xR = parcelRequire("6V8xR");
var $ejlRR = parcelRequire("ejlRR");
var $jZc0w = parcelRequire("jZc0w");
var $fSZF6 = parcelRequire("fSZF6");
var $4sqA7 = parcelRequire("4sqA7");
var $3xp7o = parcelRequire("3xp7o");
var $jvtSq = parcelRequire("jvtSq");
var $79KOG = parcelRequire("79KOG");
var $iDd8d = parcelRequire("iDd8d");
var $kX8Hd = parcelRequire("kX8Hd");
var $7kouu = parcelRequire("7kouu");
var $9jCh7 = parcelRequire("9jCh7");
var $lalFM = parcelRequire("lalFM");
var $gmMlv = parcelRequire("gmMlv");
var $jjNRA = parcelRequire("jjNRA");
var $hxi4c = parcelRequire("hxi4c");
parcelRequire("40l72");
var $bVQtG = parcelRequire("bVQtG");
parcelRequire("3Rm2E");
var $9Dn6G = parcelRequire("9Dn6G");
var $j8LvK = parcelRequire("j8LvK");
var $c05419b1d6c7e886$var$L = function(t, e) {
    return ($c05419b1d6c7e886$var$L = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    })(t, e);
};
function $c05419b1d6c7e886$var$V(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function n() {
        this.constructor = t;
    }
    $c05419b1d6c7e886$var$L(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
}
var $c05419b1d6c7e886$var$B = function() {
    return ($c05419b1d6c7e886$var$B = Object.assign || function(t) {
        for(var e, n = 1, i = arguments.length; n < i; n++)for(var r in e = arguments[n])Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        return t;
    }).apply(this, arguments);
};
function $c05419b1d6c7e886$var$N(t, e, n, i) {
    return new (n || (n = Promise))(function(r, o) {
        function a(t) {
            try {
                u(i.next(t));
            } catch (t) {
                o(t);
            }
        }
        function s(t) {
            try {
                u(i.throw(t));
            } catch (t) {
                o(t);
            }
        }
        function u(t) {
            var e;
            t.done ? r(t.value) : (e = t.value, e instanceof n ? e : new n(function(t) {
                t(e);
            })).then(a, s);
        }
        u((i = i.apply(t, e || [])).next());
    });
}
function $c05419b1d6c7e886$var$D(t, e) {
    var n, i, r, o, a = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function s(o) {
        return function(s) {
            return function(o) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (n = 1, i && (r = 2 & o[0] ? i.return : o[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, o[1])).done) return r;
                    switch(i = 0, r && (o = [
                        2 & o[0],
                        r.value
                    ]), o[0]){
                        case 0:
                        case 1:
                            r = o;
                            break;
                        case 4:
                            return a.label++, {
                                value: o[1],
                                done: !1
                            };
                        case 5:
                            a.label++, i = o[1], o = [
                                0
                            ];
                            continue;
                        case 7:
                            o = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(r = a.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                a.label = o[1];
                                break;
                            }
                            if (6 === o[0] && a.label < r[1]) {
                                a.label = r[1], r = o;
                                break;
                            }
                            if (r && a.label < r[2]) {
                                a.label = r[2], a.ops.push(o);
                                break;
                            }
                            r[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    o = e.call(t, a);
                } catch (t) {
                    o = [
                        6,
                        t
                    ], i = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                    value: o[0] ? o[1] : void 0,
                    done: !0
                };
            }([
                o,
                s
            ]);
        };
    }
}
function $c05419b1d6c7e886$var$K(t, e, n) {
    if (n || 2 === arguments.length) for(var i, r = 0, o = e.length; r < o; r++)!i && r in e || (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
    return t.concat(i || Array.prototype.slice.call(e));
}
var $c05419b1d6c7e886$var$U = [
    "nose",
    "left_eye",
    "right_eye",
    "left_ear",
    "right_ear",
    "left_shoulder",
    "right_shoulder",
    "left_elbow",
    "right_elbow",
    "left_wrist",
    "right_wrist",
    "left_hip",
    "right_hip",
    "left_knee",
    "right_knee",
    "left_ankle",
    "right_ankle"
], $c05419b1d6c7e886$var$j = [
    "nose",
    "left_eye_inner",
    "left_eye",
    "left_eye_outer",
    "right_eye_inner",
    "right_eye",
    "right_eye_outer",
    "left_ear",
    "right_ear",
    "mouth_left",
    "mouth_right",
    "left_shoulder",
    "right_shoulder",
    "left_elbow",
    "right_elbow",
    "left_wrist",
    "right_wrist",
    "left_pinky",
    "right_pinky",
    "left_index",
    "right_index",
    "left_thumb",
    "right_thumb",
    "left_hip",
    "right_hip",
    "left_knee",
    "right_knee",
    "left_ankle",
    "right_ankle",
    "left_heel",
    "right_heel",
    "left_foot_index",
    "right_foot_index"
], $c05419b1d6c7e886$var$H = {
    left: [
        1,
        2,
        3,
        7,
        9,
        11,
        13,
        15,
        17,
        19,
        21,
        23,
        25,
        27,
        29,
        31
    ],
    right: [
        4,
        5,
        6,
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30,
        32
    ],
    middle: [
        0
    ]
}, $c05419b1d6c7e886$var$q = {
    left: [
        1,
        3,
        5,
        7,
        9,
        11,
        13,
        15
    ],
    right: [
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        16
    ],
    middle: [
        0
    ]
}, $c05419b1d6c7e886$var$X = [
    [
        0,
        1
    ],
    [
        0,
        2
    ],
    [
        1,
        3
    ],
    [
        2,
        4
    ],
    [
        5,
        6
    ],
    [
        5,
        7
    ],
    [
        5,
        11
    ],
    [
        6,
        8
    ],
    [
        6,
        12
    ],
    [
        7,
        9
    ],
    [
        8,
        10
    ],
    [
        11,
        12
    ],
    [
        11,
        13
    ],
    [
        12,
        14
    ],
    [
        13,
        15
    ],
    [
        14,
        16
    ]
], $c05419b1d6c7e886$var$Y = [
    [
        0,
        1
    ],
    [
        0,
        4
    ],
    [
        1,
        2
    ],
    [
        2,
        3
    ],
    [
        3,
        7
    ],
    [
        4,
        5
    ],
    [
        5,
        6
    ],
    [
        6,
        8
    ],
    [
        9,
        10
    ],
    [
        11,
        12
    ],
    [
        11,
        13
    ],
    [
        11,
        23
    ],
    [
        12,
        14
    ],
    [
        14,
        16
    ],
    [
        12,
        24
    ],
    [
        13,
        15
    ],
    [
        15,
        17
    ],
    [
        16,
        18
    ],
    [
        16,
        20
    ],
    [
        15,
        17
    ],
    [
        15,
        19
    ],
    [
        15,
        21
    ],
    [
        16,
        22
    ],
    [
        17,
        19
    ],
    [
        18,
        20
    ],
    [
        23,
        25
    ],
    [
        23,
        24
    ],
    [
        24,
        26
    ],
    [
        25,
        27
    ],
    [
        26,
        28
    ],
    [
        27,
        29
    ],
    [
        28,
        30
    ],
    [
        27,
        31
    ],
    [
        28,
        32
    ],
    [
        29,
        31
    ],
    [
        30,
        32
    ]
];
function $c05419b1d6c7e886$var$W(t) {
    return t instanceof SVGAnimatedLength ? t.baseVal.value : t;
}
function $c05419b1d6c7e886$var$G(t) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var i, r;
        return $c05419b1d6c7e886$var$D(this, function(o) {
            switch(o.label){
                case 0:
                    return i = document.createElement("canvas"), t instanceof (0, $9jCh7.Tensor) ? [
                        4,
                        (0, $cpgue).toPixels(t, i)
                    ] : [
                        3,
                        2
                    ];
                case 1:
                    return o.sent(), [
                        3,
                        3
                    ];
                case 2:
                    i.width = $c05419b1d6c7e886$var$W(t.width), i.height = $c05419b1d6c7e886$var$W(t.height), r = i.getContext("2d"), t instanceof ImageData ? r.putImageData(t, 0, 0) : r.drawImage(t, 0, 0), o.label = 3;
                case 3:
                    return [
                        2,
                        i
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$Q(t) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var i, r, o, a, s, u;
        return $c05419b1d6c7e886$var$D(this, function(h) {
            switch(h.label){
                case 0:
                    return t instanceof (0, $9jCh7.Tensor) ? (i = t.shape.slice(0, 2), r = i[0], o = i[1], a = ImageData.bind, [
                        4,
                        (0, $cpgue).toPixels(t)
                    ]) : [
                        3,
                        2
                    ];
                case 1:
                    return [
                        2,
                        new (a.apply(ImageData, [
                            void 0,
                            h.sent(),
                            o,
                            r
                        ]))
                    ];
                case 2:
                    return s = document.createElement("canvas"), u = s.getContext("2d"), s.width = $c05419b1d6c7e886$var$W(t.width), s.height = $c05419b1d6c7e886$var$W(t.height), u.drawImage(t, 0, 0), [
                        2,
                        u.getImageData(0, 0, s.width, s.height)
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$Z(t) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var e, i;
        return $c05419b1d6c7e886$var$D(this, function(r) {
            switch(r.label){
                case 0:
                    return t instanceof SVGImageElement || t instanceof OffscreenCanvas ? [
                        4,
                        $c05419b1d6c7e886$var$G(t)
                    ] : [
                        3,
                        2
                    ];
                case 1:
                    return i = r.sent(), [
                        3,
                        3
                    ];
                case 2:
                    i = t, r.label = 3;
                case 3:
                    return e = i, [
                        2,
                        (0, $cpgue).fromPixels(e, 4)
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$$(t) {
    if (t < 0 || t >= 256) throw new Error("Mask value must be in range [0, 255] but got ".concat(t));
    if (!Number.isInteger(t)) throw new Error("Mask value must be an integer but got ".concat(t));
}
var $c05419b1d6c7e886$var$J = {
    runtime: "mediapipe",
    enableSmoothing: !0,
    enableSegmentation: !1,
    smoothSegmentation: !0,
    modelType: "full"
};
var $c05419b1d6c7e886$var$tt = function() {
    function t(t) {
        this.mask = t;
    }
    return t.prototype.toCanvasImageSource = function() {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            return $c05419b1d6c7e886$var$D(this, function(t) {
                return [
                    2,
                    this.mask
                ];
            });
        });
    }, t.prototype.toImageData = function() {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            return $c05419b1d6c7e886$var$D(this, function(t) {
                return [
                    2,
                    $c05419b1d6c7e886$var$Q(this.mask)
                ];
            });
        });
    }, t.prototype.toTensor = function() {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            return $c05419b1d6c7e886$var$D(this, function(t) {
                return [
                    2,
                    $c05419b1d6c7e886$var$Z(this.mask)
                ];
            });
        });
    }, t.prototype.getUnderlyingType = function() {
        return "canvasimagesource";
    }, t;
}();
function $c05419b1d6c7e886$var$et(t) {
    return $c05419b1d6c7e886$var$$(t), "person";
}
var $c05419b1d6c7e886$var$nt = function() {
    function i(e) {
        var n, i = this;
        switch(this.width = 0, this.height = 0, this.selfieMode = !1, this.poseSolution = new (0, $xjHPn.Pose)({
            locateFile: function(t, n) {
                if (e.solutionPath) {
                    var i = e.solutionPath.replace(/\/+$/, "");
                    return "".concat(i, "/").concat(t);
                }
                return "".concat(n, "/").concat(t);
            }
        }), e.modelType){
            case "lite":
                n = 0;
                break;
            case "heavy":
                n = 2;
                break;
            case "full":
            default:
                n = 1;
        }
        this.poseSolution.setOptions({
            modelComplexity: n,
            smoothLandmarks: e.enableSmoothing,
            enableSegmentation: e.enableSegmentation,
            smoothSegmentation: e.smoothSegmentation,
            selfieMode: this.selfieMode
        }), this.poseSolution.onResults(function(t) {
            if (i.height = t.image.height, i.width = t.image.width, null == t.poseLandmarks) i.poses = [];
            else {
                var e = i.translateOutput(t.poseLandmarks, t.poseWorldLandmarks);
                t.segmentationMask && (e.segmentation = {
                    maskValueToLabel: $c05419b1d6c7e886$var$et,
                    mask: new $c05419b1d6c7e886$var$tt(t.segmentationMask)
                }), i.poses = [
                    e
                ];
            }
        });
    }
    return i.prototype.translateOutput = function(t, e) {
        var n = this, i = {
            keypoints: t.map(function(t, e) {
                return {
                    x: t.x * n.width,
                    y: t.y * n.height,
                    z: t.z,
                    score: t.visibility,
                    name: $c05419b1d6c7e886$var$j[e]
                };
            })
        };
        return null != e && (i.keypoints3D = e.map(function(t, e) {
            return {
                x: t.x,
                y: t.y,
                z: t.z,
                score: t.visibility,
                name: $c05419b1d6c7e886$var$j[e]
            };
        })), i;
    }, i.prototype.estimatePoses = function(t, i, r) {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var o, a;
            return $c05419b1d6c7e886$var$D(this, function(s) {
                switch(s.label){
                    case 0:
                        return i && i.flipHorizontal && i.flipHorizontal !== this.selfieMode && (this.selfieMode = i.flipHorizontal, this.poseSolution.setOptions({
                            selfieMode: this.selfieMode
                        })), t instanceof (0, $9jCh7.Tensor) ? (a = ImageData.bind, [
                            4,
                            (0, $cpgue).toPixels(t)
                        ]) : [
                            3,
                            2
                        ];
                    case 1:
                        return o = new (a.apply(ImageData, [
                            void 0,
                            s.sent(),
                            t.shape[1],
                            t.shape[0]
                        ])), [
                            3,
                            3
                        ];
                    case 2:
                        o = t, s.label = 3;
                    case 3:
                        return t = o, [
                            4,
                            this.poseSolution.send({
                                image: t
                            }, r)
                        ];
                    case 4:
                        return s.sent(), [
                            2,
                            this.poses
                        ];
                }
            });
        });
    }, i.prototype.dispose = function() {
        this.poseSolution.close();
    }, i.prototype.reset = function() {
        this.poseSolution.reset();
    }, i.prototype.initialize = function() {
        return this.poseSolution.initialize();
    }, i;
}();
function $c05419b1d6c7e886$var$it(t) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var e, n;
        return $c05419b1d6c7e886$var$D(this, function(i) {
            switch(i.label){
                case 0:
                    return e = function(t) {
                        if (null == t) return $c05419b1d6c7e886$var$B({}, $c05419b1d6c7e886$var$J);
                        var e = $c05419b1d6c7e886$var$B({}, t);
                        return e.runtime = "mediapipe", null == e.enableSegmentation && (e.enableSegmentation = $c05419b1d6c7e886$var$J.enableSegmentation), null == e.enableSmoothing && (e.enableSmoothing = $c05419b1d6c7e886$var$J.enableSmoothing), null == e.smoothSegmentation && (e.smoothSegmentation = $c05419b1d6c7e886$var$J.smoothSegmentation), null == e.modelType && (e.modelType = $c05419b1d6c7e886$var$J.modelType), e;
                    }(t), [
                        4,
                        (n = new $c05419b1d6c7e886$var$nt(e)).initialize()
                    ];
                case 1:
                    return i.sent(), [
                        2,
                        n
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$rt(t) {
    return t instanceof (0, $9jCh7.Tensor) ? {
        height: t.shape[0],
        width: t.shape[1]
    } : {
        height: t.height,
        width: t.width
    };
}
function $c05419b1d6c7e886$var$ot(t) {
    return t - 2 * Math.PI * Math.floor((t + Math.PI) / (2 * Math.PI));
}
function $c05419b1d6c7e886$var$at(t) {
    return t instanceof (0, $9jCh7.Tensor) ? t : (0, $cpgue).fromPixels(t);
}
function $c05419b1d6c7e886$var$st(t, e, n) {
    return $c05419b1d6c7e886$var$ut(n, "inputResolution"), [
        1 / n.width * t[0][0] * e.width,
        1 / n.height * t[0][1] * e.width,
        t[0][3] * e.width,
        1 / n.width * t[1][0] * e.height,
        1 / n.height * t[1][1] * e.height,
        t[1][3] * e.height,
        0,
        0
    ];
}
function $c05419b1d6c7e886$var$ut(t, e) {
    (0, $jjNRA).assert(0 !== t.width, function() {
        return "".concat(e, " width cannot be 0.");
    }), (0, $jjNRA).assert(0 !== t.height, function() {
        return "".concat(e, " height cannot be 0.");
    });
}
function $c05419b1d6c7e886$var$ht(t, e, n) {
    var i = n.rotationVectorStartKeypointIndex, r = n.rotationVectorEndKeypointIndex, o = t.locationData, a = o.relativeKeypoints[i].x * e.width, s = o.relativeKeypoints[i].y * e.height, u = o.relativeKeypoints[r].x * e.width, h = o.relativeKeypoints[r].y * e.height, l = 2 * Math.sqrt((u - a) * (u - a) + (h - s) * (h - s)), c = function(t, e, n) {
        var i, r = t.locationData, o = n.rotationVectorStartKeypointIndex, a = n.rotationVectorEndKeypointIndex;
        i = n.rotationVectorTargetAngle ? n.rotationVectorTargetAngle : Math.PI * n.rotationVectorTargetAngleDegree / 180;
        var s = r.relativeKeypoints[o].x * e.width, u = r.relativeKeypoints[o].y * e.height, h = r.relativeKeypoints[a].x * e.width, l = r.relativeKeypoints[a].y * e.height;
        return $c05419b1d6c7e886$var$ot(i - Math.atan2(-(l - u), h - s));
    }(t, e, n);
    return {
        xCenter: a / e.width,
        yCenter: s / e.height,
        width: l / e.width,
        height: l / e.height,
        rotation: c
    };
}
function $c05419b1d6c7e886$var$lt(t) {
    if (16 !== t.length) throw new Error("Array length must be 16 but got ".concat(t.length));
    return [
        [
            t[0],
            t[1],
            t[2],
            t[3]
        ],
        [
            t[4],
            t[5],
            t[6],
            t[7]
        ],
        [
            t[8],
            t[9],
            t[10],
            t[11]
        ],
        [
            t[12],
            t[13],
            t[14],
            t[15]
        ]
    ];
}
function $c05419b1d6c7e886$var$ct(t, e, n, i, r, o, a) {
    return t[e][r] * (t[n][o] * t[i][a] - t[n][a] * t[i][o]);
}
function $c05419b1d6c7e886$var$pt(t, e, n) {
    var i = (e + 1) % 4, r = (e + 2) % 4, o = (e + 3) % 4, a = (n + 1) % 4, s = (n + 2) % 4, u = (n + 3) % 4;
    return $c05419b1d6c7e886$var$ct(t, i, r, o, a, s, u) + $c05419b1d6c7e886$var$ct(t, r, o, i, a, s, u) + $c05419b1d6c7e886$var$ct(t, o, i, r, a, s, u);
}
function $c05419b1d6c7e886$var$ft(t, e, n) {
    void 0 === n && (n = {
        ignoreRotation: !1
    });
    for(var i = [], r = 0, o = t; r < o.length; r++){
        var a = o[r], s = a.x - .5, u = a.y - .5, h = n.ignoreRotation ? 0 : e.rotation, l = Math.cos(h) * s - Math.sin(h) * u, c = Math.sin(h) * s + Math.cos(h) * u;
        l = l * e.width + e.xCenter, c = c * e.height + e.yCenter;
        var p = a.z * e.width, f = $c05419b1d6c7e886$var$B({}, a);
        f.x = l, f.y = c, f.z = p, i.push(f);
    }
    return i;
}
function $c05419b1d6c7e886$var$dt(t, e) {
    var n = function(t, e, n, i) {
        var r = e - t, o = i - n;
        if (0 === r) throw new Error("Original min and max are both ".concat(t, ", range cannot be 0."));
        var a = o / r;
        return {
            scale: a,
            offset: n - t * a
        };
    }(0, 255, e[0], e[1]);
    return (0, $c2DT1.tidy)(function() {
        return (0, $hgacW.add)((0, $jZc0w.mul)(t, n.scale), n.offset);
    });
}
function $c05419b1d6c7e886$var$mt(t, e, n) {
    var i, o, a, c, p, f, d, m, g, y, v, x, w, k, b = e.outputTensorSize, M = e.keepAspectRatio, S = e.borderMode, T = e.outputTensorFloatRange, P = $c05419b1d6c7e886$var$rt(t), F = function(t, e) {
        return e ? {
            xCenter: e.xCenter * t.width,
            yCenter: e.yCenter * t.height,
            width: e.width * t.width,
            height: e.height * t.height,
            rotation: e.rotation
        } : {
            xCenter: .5 * t.width,
            yCenter: .5 * t.height,
            width: t.width,
            height: t.height,
            rotation: 0
        };
    }(P, n), _ = function(t, e, n) {
        if (void 0 === n && (n = !1), !n) return {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        };
        var i = e.height, r = e.width;
        $c05419b1d6c7e886$var$ut(e, "targetSize"), $c05419b1d6c7e886$var$ut(t, "roi");
        var o, a, s = i / r, u = t.height / t.width, h = 0, l = 0;
        return s > u ? (o = t.width, a = t.width * s, l = (1 - u / s) / 2) : (o = t.height / s, a = t.height, h = (1 - s / u) / 2), t.width = o, t.height = a, {
            top: l,
            left: h,
            right: h,
            bottom: l
        };
    }(F, b, M), O = (i = F, o = P.width, a = P.height, c = !1, p = i.width, f = i.height, d = c ? -1 : 1, m = Math.cos(i.rotation), g = Math.sin(i.rotation), y = i.xCenter, v = i.yCenter, x = 1 / o, w = 1 / a, (k = new Array(16))[0] = p * m * d * x, k[1] = -f * g * x, k[2] = 0, k[3] = (-0.5 * p * m * d + .5 * f * g + y) * x, k[4] = p * g * d * w, k[5] = f * m * w, k[6] = 0, k[7] = (-0.5 * f * m - .5 * p * g * d + v) * w, k[8] = 0, k[9] = 0, k[10] = p * x, k[11] = 0, k[12] = 0, k[13] = 0, k[14] = 0, k[15] = 1, $c05419b1d6c7e886$var$lt(k));
    return {
        imageTensor: (0, $c2DT1.tidy)(function() {
            var e = $c05419b1d6c7e886$var$at(t), n = (0, $gmMlv.tensor2d)($c05419b1d6c7e886$var$st(O, P, b), [
                1,
                8
            ]), i = "zero" === S ? "constant" : "nearest", r = (0, $aosGd.image).transform((0, $iPDWZ.expandDims)((0, $inFmq.cast)(e, "float32")), n, "bilinear", i, 0, [
                b.height,
                b.width
            ]);
            return null != T ? $c05419b1d6c7e886$var$dt(r, T) : r;
        }),
        padding: _,
        transformationMatrix: O
    };
}
function $c05419b1d6c7e886$var$gt(t, e, n, i) {
    return 1 === i ? .5 * (t + e) : t + (e - t) * n / (i - 1);
}
function $c05419b1d6c7e886$var$yt(t) {
    return (0, $c2DT1.tidy)(function() {
        var e = function(t) {
            return (0, $c2DT1.tidy)(function() {
                return [
                    (0, $79KOG.slice)(t, [
                        0,
                        0,
                        0
                    ], [
                        1,
                        -1,
                        1
                    ]),
                    (0, $79KOG.slice)(t, [
                        0,
                        0,
                        1
                    ], [
                        1,
                        -1,
                        -1
                    ])
                ];
            });
        }(t), n = e[0], i = e[1];
        return {
            boxes: (0, $kX8Hd.squeeze)(i),
            logits: (0, $kX8Hd.squeeze)(n)
        };
    });
}
function $c05419b1d6c7e886$var$vt(t) {
    return null != t && null != t.currentTime;
}
function $c05419b1d6c7e886$var$xt(t) {
    for(var e = {
        locationData: {
            relativeKeypoints: []
        }
    }, n = Number.MAX_SAFE_INTEGER, i = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER, o = Number.MIN_SAFE_INTEGER, a = 0; a < t.length; ++a){
        var s = t[a];
        n = Math.min(n, s.x), i = Math.max(i, s.x), r = Math.min(r, s.y), o = Math.max(o, s.y), e.locationData.relativeKeypoints.push({
            x: s.x,
            y: s.y
        });
    }
    return e.locationData.relativeBoundingBox = {
        xMin: n,
        yMin: r,
        xMax: i,
        yMax: o,
        width: i - n,
        height: o - r
    }, e;
}
function $c05419b1d6c7e886$var$wt(t, e, n, i) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var i, r, o, a, h;
        return $c05419b1d6c7e886$var$D(this, function(l) {
            switch(l.label){
                case 0:
                    return t.sort(function(t, e) {
                        return Math.max.apply(Math, e.score) - Math.max.apply(Math, t.score);
                    }), i = (0, $gmMlv.tensor2d)(t.map(function(t) {
                        return [
                            t.locationData.relativeBoundingBox.yMin,
                            t.locationData.relativeBoundingBox.xMin,
                            t.locationData.relativeBoundingBox.yMax,
                            t.locationData.relativeBoundingBox.xMax
                        ];
                    })), r = (0, $lalFM.tensor1d)(t.map(function(t) {
                        return t.score[0];
                    })), [
                        4,
                        (0, $aosGd.image).nonMaxSuppressionAsync(i, r, e, n)
                    ];
                case 1:
                    return [
                        4,
                        (o = l.sent()).array()
                    ];
                case 2:
                    return a = l.sent(), h = t.filter(function(t, e) {
                        return a.indexOf(e) > -1;
                    }), (0, $c2DT1.dispose)([
                        i,
                        r,
                        o
                    ]), [
                        2,
                        h
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$kt(t, e) {
    return t.map(function(t) {
        var n = $c05419b1d6c7e886$var$B($c05419b1d6c7e886$var$B({}, t), {
            x: t.x * e.width,
            y: t.y * e.height
        });
        return null != t.z && (n.z = t.z * e.width), n;
    });
}
function $c05419b1d6c7e886$var$bt(t, e, n) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var i, r, o, a, s, u, h, l, c, f, d, m, g, y, v, x, w, k, b, M, S, T, P, F;
        return $c05419b1d6c7e886$var$D(this, function(_) {
            switch(_.label){
                case 0:
                    if (i = (0, $kX8Hd.squeeze)(e, [
                        0
                    ]), r = i.shape, o = r[0], a = r[1], s = r[2], t.length !== s) throw new Error("Expected heatmap to have same number of channels as the number of landmarks. But got landmarks length: " + "".concat(t.length, ", heatmap length: ").concat(s));
                    return u = [], [
                        4,
                        i.buffer()
                    ];
                case 1:
                    for(h = _.sent(), l = 0; l < t.length; l++)if (c = t[l], f = $c05419b1d6c7e886$var$B({}, c), u.push(f), d = Math.trunc(f.x * a), m = Math.trunc(f.y * o), !(d < 0 || d >= a || m < 0 || d >= o)) {
                        for(g = Math.trunc((n.kernelSize - 1) / 2), y = Math.max(0, d - g), v = Math.min(a, d + g + 1), x = Math.max(0, m - g), w = Math.min(o, m + g + 1), k = 0, b = 0, M = 0, S = 0, T = x; T < w; ++T)for(P = y; P < v; ++P)F = h.get(T, P, l), k += F, S = Math.max(S, F), b += P * F, M += T * F;
                        S >= n.minConfidenceToRefine && k > 0 && (f.x = b / a / k, f.y = M / o / k);
                    }
                    return i.dispose(), [
                        2,
                        u
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$Mt(t, e) {
    var n = e.left, i = e.top, r = e.left + e.right, o = e.top + e.bottom;
    return t.map(function(t) {
        return $c05419b1d6c7e886$var$B($c05419b1d6c7e886$var$B({}, t), {
            x: (t.x - n) / (1 - r),
            y: (t.y - i) / (1 - o),
            z: t.z / (1 - r)
        });
    });
}
function $c05419b1d6c7e886$var$St(t, e, n) {
    return "webgl" === (0, $c2DT1.getBackend)() ? function(t, e, n) {
        var i = n.combineWithPreviousRatio.toFixed(2), o = {
            variableNames: [
                "prevMask",
                "newMask"
            ],
            outputShape: t.shape,
            userCode: "\n  void main() {\n      ivec2 coords = getOutputCoords();\n      int height = coords[0];\n      int width = coords[1];\n\n      float prevMaskValue = getPrevMask(height, width);\n      float newMaskValue = getNewMask(height, width);\n\n      /*\n      * Assume p := newMaskValue\n      * H(p) := 1 + (p * log(p) + (1-p) * log(1-p)) / log(2)\n      * uncertainty alpha(p) =\n      *   Clamp(1 - (1 - H(p)) * (1 - H(p)), 0, 1) [squaring the\n      * uncertainty]\n      *\n      * The following polynomial approximates uncertainty alpha as a\n      * function of (p + 0.5):\n      */\n      const float c1 = 5.68842;\n      const float c2 = -0.748699;\n      const float c3 = -57.8051;\n      const float c4 = 291.309;\n      const float c5 = -624.717;\n      float t = newMaskValue - 0.5;\n      float x = t * t;\n\n      float uncertainty =\n        1.0 - min(1.0, x * (c1 + x * (c2 + x * (c3 + x * (c4 + x * c5)))));\n\n      float outputValue = newMaskValue + (prevMaskValue - newMaskValue) *\n                             (uncertainty * ".concat(i, ");\n\n      setOutput(outputValue);\n    }\n")
        }, a = (0, $c2DT1.backend)();
        return (0, $c2DT1.tidy)(function() {
            var n = a.compileAndRun(o, [
                t,
                e
            ]);
            return (0, $c2DT1.engine)().makeTensorFromDataId(n.dataId, n.shape, n.dtype);
        });
    }(t, e, n) : (0, $c2DT1.tidy)(function() {
        var i = (0, $7kouu.sub)(e, .5), r = (0, $iDd8d.square)(i), s = (0, $7kouu.sub)(1, (0, $6V8xR.minimum)(1, (0, $jZc0w.mul)(r, (0, $hgacW.add)(5.68842, (0, $jZc0w.mul)(r, (0, $hgacW.add)(-0.748699, (0, $jZc0w.mul)(r, (0, $hgacW.add)(-57.8051, (0, $jZc0w.mul)(r, (0, $hgacW.add)(291.309, (0, $jZc0w.mul)(r, -624.717)))))))))));
        return (0, $hgacW.add)(e, (0, $jZc0w.mul)((0, $7kouu.sub)(t, e), (0, $jZc0w.mul)(s, n.combineWithPreviousRatio)));
    });
}
function $c05419b1d6c7e886$var$Tt(t, e, n) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var i, s, u, h, l;
        return $c05419b1d6c7e886$var$D(this, function(d) {
            switch(d.label){
                case 0:
                    return i = t[0], s = t[1], u = function(t, e, n) {
                        return (0, $c2DT1.tidy)(function() {
                            var i, r, s, u;
                            n.reverseOutputOrder ? (r = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                0,
                                n.boxCoordOffset + 0
                            ], [
                                -1,
                                1
                            ])), i = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                0,
                                n.boxCoordOffset + 1
                            ], [
                                -1,
                                1
                            ])), u = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                0,
                                n.boxCoordOffset + 2
                            ], [
                                -1,
                                1
                            ])), s = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                0,
                                n.boxCoordOffset + 3
                            ], [
                                -1,
                                1
                            ]))) : (i = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                0,
                                n.boxCoordOffset + 0
                            ], [
                                -1,
                                1
                            ])), r = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                0,
                                n.boxCoordOffset + 1
                            ], [
                                -1,
                                1
                            ])), s = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                0,
                                n.boxCoordOffset + 2
                            ], [
                                -1,
                                1
                            ])), u = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                0,
                                n.boxCoordOffset + 3
                            ], [
                                -1,
                                1
                            ]))), r = (0, $hgacW.add)((0, $jZc0w.mul)((0, $1QPqB.div)(r, n.xScale), e.w), e.x), i = (0, $hgacW.add)((0, $jZc0w.mul)((0, $1QPqB.div)(i, n.yScale), e.h), e.y), n.applyExponentialOnBoxSize ? (s = (0, $jZc0w.mul)((0, $2PcQK.exp)((0, $1QPqB.div)(s, n.hScale)), e.h), u = (0, $jZc0w.mul)((0, $2PcQK.exp)((0, $1QPqB.div)(u, n.wScale)), e.w)) : (s = (0, $jZc0w.mul)((0, $1QPqB.div)(s, n.hScale), e.h), u = (0, $jZc0w.mul)((0, $1QPqB.div)(u, n.wScale), e.h));
                            var h = (0, $7kouu.sub)(i, (0, $1QPqB.div)(s, 2)), l = (0, $7kouu.sub)(r, (0, $1QPqB.div)(u, 2)), f = (0, $hgacW.add)(i, (0, $1QPqB.div)(s, 2)), d = (0, $hgacW.add)(r, (0, $1QPqB.div)(u, 2)), m = (0, $iTu6j.concat)([
                                (0, $4sqA7.reshape)(h, [
                                    n.numBoxes,
                                    1
                                ]),
                                (0, $4sqA7.reshape)(l, [
                                    n.numBoxes,
                                    1
                                ]),
                                (0, $4sqA7.reshape)(f, [
                                    n.numBoxes,
                                    1
                                ]),
                                (0, $4sqA7.reshape)(d, [
                                    n.numBoxes,
                                    1
                                ])
                            ], 1);
                            if (n.numKeypoints) for(var g = 0; g < n.numKeypoints; ++g){
                                var v = n.keypointCoordOffset + g * n.numValuesPerKeypoint, x = void 0, w = void 0;
                                n.reverseOutputOrder ? (x = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                    0,
                                    v
                                ], [
                                    -1,
                                    1
                                ])), w = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                    0,
                                    v + 1
                                ], [
                                    -1,
                                    1
                                ]))) : (w = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                    0,
                                    v
                                ], [
                                    -1,
                                    1
                                ])), x = (0, $kX8Hd.squeeze)((0, $79KOG.slice)(t, [
                                    0,
                                    v + 1
                                ], [
                                    -1,
                                    1
                                ])));
                                var T = (0, $hgacW.add)((0, $jZc0w.mul)((0, $1QPqB.div)(x, n.xScale), e.w), e.x), P = (0, $hgacW.add)((0, $jZc0w.mul)((0, $1QPqB.div)(w, n.yScale), e.h), e.y);
                                m = (0, $iTu6j.concat)([
                                    m,
                                    (0, $4sqA7.reshape)(T, [
                                        n.numBoxes,
                                        1
                                    ]),
                                    (0, $4sqA7.reshape)(P, [
                                        n.numBoxes,
                                        1
                                    ])
                                ], 1);
                            }
                            return m;
                        });
                    }(s, e, n), h = (0, $c2DT1.tidy)(function() {
                        var t = i;
                        return n.sigmoidScore ? (null != n.scoreClippingThresh && (t = (0, $cOWuO.clipByValue)(i, -n.scoreClippingThresh, n.scoreClippingThresh)), t = (0, $jvtSq.sigmoid)(t)) : t;
                    }), [
                        4,
                        $c05419b1d6c7e886$var$Pt(u, h, n)
                    ];
                case 1:
                    return l = d.sent(), (0, $c2DT1.dispose)([
                        u,
                        h
                    ]), [
                        2,
                        l
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$Pt(t, e, n) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var i, r, o, a, s, u, h, l, c, p, f, d;
        return $c05419b1d6c7e886$var$D(this, function(m) {
            switch(m.label){
                case 0:
                    return i = [], [
                        4,
                        t.data()
                    ];
                case 1:
                    return r = m.sent(), [
                        4,
                        e.data()
                    ];
                case 2:
                    for(o = m.sent(), a = 0; a < n.numBoxes; ++a)if (!(null != n.minScoreThresh && o[a] < n.minScoreThresh || (s = a * n.numCoords, u = $c05419b1d6c7e886$var$Ft(r[s + 0], r[s + 1], r[s + 2], r[s + 3], o[a], n.flipVertically, a), (h = u.locationData.relativeBoundingBox).width < 0 || h.height < 0))) {
                        if (n.numKeypoints > 0) for((l = u.locationData).relativeKeypoints = [], c = n.numKeypoints * n.numValuesPerKeypoint, p = 0; p < c; p += n.numValuesPerKeypoint)f = s + n.keypointCoordOffset + p, d = {
                            x: r[f + 0],
                            y: n.flipVertically ? 1 - r[f + 1] : r[f + 1]
                        }, l.relativeKeypoints.push(d);
                        i.push(u);
                    }
                    return [
                        2,
                        i
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$Ft(t, e, n, i, r, o, a) {
    return {
        score: [
            r
        ],
        ind: a,
        locationData: {
            relativeBoundingBox: {
                xMin: e,
                yMin: o ? 1 - n : t,
                xMax: i,
                yMax: o ? 1 - t : n,
                width: i - e,
                height: n - t
            }
        }
    };
}
function $c05419b1d6c7e886$var$_t(t, e) {
    return "none" === t ? e : function(t) {
        return 1 / (1 + Math.exp(-t));
    }(e);
}
function $c05419b1d6c7e886$var$Ot(t, e, n, i) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var r, o, a, s, u, h, l, c;
        return $c05419b1d6c7e886$var$D(this, function(p) {
            switch(p.label){
                case 0:
                    return n = n || e.flipHorizontally || !1, i = i || e.flipVertically || !1, r = t.size, o = r / e.numLandmarks, [
                        4,
                        t.data()
                    ];
                case 1:
                    for(a = p.sent(), s = [], u = 0; u < e.numLandmarks; ++u)h = u * o, (c = {
                        x: 0,
                        y: 0
                    }).x = n ? e.inputImageWidth - a[h] : a[h], o > 1 && (c.y = i ? e.inputImageHeight - a[h + 1] : a[h + 1]), o > 2 && (c.z = a[h + 2]), o > 3 && (c.score = $c05419b1d6c7e886$var$_t(e.visibilityActivation, a[h + 3])), s.push(c);
                    for(l = 0; l < s.length; ++l)(c = s[l]).x = c.x / e.inputImageWidth, c.y = c.y / e.inputImageHeight, c.z = c.z / e.inputImageWidth / (e.normalizeZ || 1);
                    return [
                        2,
                        s
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$It(t, e, n) {
    var i = t.width, r = t.height, o = t.rotation;
    if (null == n.rotation && null == n.rotationDegree || (o = function(t, e) {
        null != e.rotation ? t += e.rotation : null != e.rotationDegree && (t += Math.PI * e.rotationDegree / 180);
        return $c05419b1d6c7e886$var$ot(t);
    }(o, n)), 0 === o) t.xCenter = t.xCenter + i * n.shiftX, t.yCenter = t.yCenter + r * n.shiftY;
    else {
        var a = (e.width * i * n.shiftX * Math.cos(o) - e.height * r * n.shiftY * Math.sin(o)) / e.width, s = (e.width * i * n.shiftX * Math.sin(o) + e.height * r * n.shiftY * Math.cos(o)) / e.height;
        t.xCenter = t.xCenter + a, t.yCenter = t.yCenter + s;
    }
    if (n.squareLong) {
        var u = Math.max(i * e.width, r * e.height);
        i = u / e.width, r = u / e.height;
    } else if (n.squareShort) {
        var h = Math.min(i * e.width, r * e.height);
        i = h / e.width, r = h / e.height;
    }
    return t.width = i * n.scaleX, t.height = r * n.scaleY, t;
}
function $c05419b1d6c7e886$var$At(t, e) {
    return t.map(function(t) {
        var n = $c05419b1d6c7e886$var$B($c05419b1d6c7e886$var$B({}, t), {
            x: t.x / e.width,
            y: t.y / e.height
        });
        return null != t.z && (t.z = t.z / e.width), n;
    });
}
var $c05419b1d6c7e886$var$zt = function() {
    function t(t) {
        this.alpha = t, this.initialized = !1;
    }
    return t.prototype.apply = function(t, e) {
        var n;
        return this.initialized ? n = null == e ? this.storedValue + this.alpha * (t - this.storedValue) : this.storedValue + this.alpha * e * Math.asinh((t - this.storedValue) / e) : (n = t, this.initialized = !0), this.rawValue = t, this.storedValue = n, n;
    }, t.prototype.applyWithAlpha = function(t, e, n) {
        return this.alpha = e, this.apply(t, n);
    }, t.prototype.hasLastRawValue = function() {
        return this.initialized;
    }, t.prototype.lastRawValue = function() {
        return this.rawValue;
    }, t.prototype.reset = function() {
        this.initialized = !1;
    }, t;
}(), $c05419b1d6c7e886$var$Ct = function() {
    function t(t) {
        this.frequency = t.frequency, this.minCutOff = t.minCutOff, this.beta = t.beta, this.thresholdCutOff = t.thresholdCutOff, this.thresholdBeta = t.thresholdBeta, this.derivateCutOff = t.derivateCutOff, this.x = new $c05419b1d6c7e886$var$zt(this.getAlpha(this.minCutOff)), this.dx = new $c05419b1d6c7e886$var$zt(this.getAlpha(this.derivateCutOff)), this.lastTimestamp = 0;
    }
    return t.prototype.apply = function(t, e, n) {
        if (null == t) return t;
        var i = Math.trunc(e);
        if (this.lastTimestamp >= i) return t;
        0 !== this.lastTimestamp && 0 !== i && (this.frequency = 1 / (1e-6 * (i - this.lastTimestamp))), this.lastTimestamp = i;
        var r = this.x.hasLastRawValue() ? (t - this.x.lastRawValue()) * n * this.frequency : 0, o = this.dx.applyWithAlpha(r, this.getAlpha(this.derivateCutOff)), a = this.minCutOff + this.beta * Math.abs(o), s = null != this.thresholdCutOff ? this.thresholdCutOff + this.thresholdBeta * Math.abs(o) : null;
        return this.x.applyWithAlpha(t, this.getAlpha(a), s);
    }, t.prototype.getAlpha = function(t) {
        return 1 / (1 + this.frequency / (2 * Math.PI * t));
    }, t;
}(), $c05419b1d6c7e886$var$Et = function() {
    function t(t) {
        this.config = t;
    }
    return t.prototype.apply = function(t, e, n) {
        var i = this;
        if (null == t) return this.reset(), null;
        this.initializeFiltersIfEmpty(t);
        var r = 1;
        if (!this.config.disableValueScaling) {
            if (n < this.config.minAllowedObjectScale) return $c05419b1d6c7e886$var$K([], t, !0);
            r = 1 / n;
        }
        return t.map(function(t, n) {
            var o = $c05419b1d6c7e886$var$B($c05419b1d6c7e886$var$B({}, t), {
                x: i.xFilters[n].apply(t.x, e, r),
                y: i.yFilters[n].apply(t.y, e, r)
            });
            return null != t.z && (o.z = i.zFilters[n].apply(t.z, e, r)), o;
        });
    }, t.prototype.reset = function() {
        this.xFilters = null, this.yFilters = null, this.zFilters = null;
    }, t.prototype.initializeFiltersIfEmpty = function(t) {
        var e = this;
        null != this.xFilters && this.xFilters.length === t.length || (this.xFilters = t.map(function(t) {
            return new $c05419b1d6c7e886$var$Ct(e.config);
        }), this.yFilters = t.map(function(t) {
            return new $c05419b1d6c7e886$var$Ct(e.config);
        }), this.zFilters = t.map(function(t) {
            return new $c05419b1d6c7e886$var$Ct(e.config);
        }));
    }, t;
}(), $c05419b1d6c7e886$var$Rt = function() {
    function t(t) {
        this.config = t, this.window = [], this.lowPassFilter = new $c05419b1d6c7e886$var$zt(1), this.lastValue = 0, this.lastValueScale = 1, this.lastTimestamp = -1;
    }
    return t.prototype.apply = function(t, e, n) {
        if (null == t) return t;
        var i, r = Math.trunc(e);
        if (this.lastTimestamp >= r) return t;
        if (-1 === this.lastTimestamp) i = 1;
        else {
            for(var o = t * n - this.lastValue * this.lastValueScale, a = r - this.lastTimestamp, s = o, u = a, h = (1 + this.window.length) * (1e6 / 30), l = 0, c = this.window; l < c.length; l++){
                var p = c[l];
                if (u + p.duration > h) break;
                s += p.distance, u += p.duration;
            }
            var f = s / (1e-6 * u);
            i = 1 - 1 / (1 + this.config.velocityScale * Math.abs(f)), this.window.unshift({
                distance: o,
                duration: a
            }), this.window.length > this.config.windowSize && this.window.pop();
        }
        return this.lastValue = t, this.lastValueScale = n, this.lastTimestamp = r, this.lowPassFilter.applyWithAlpha(t, i);
    }, t;
}(), $c05419b1d6c7e886$var$Lt = function() {
    function t(t) {
        this.config = t;
    }
    return t.prototype.apply = function(t, e, n) {
        var i = this;
        if (null == t) return this.reset(), null;
        var r = 1;
        if (!this.config.disableValueScaling) {
            if (n < this.config.minAllowedObjectScale) return $c05419b1d6c7e886$var$K([], t, !0);
            r = 1 / n;
        }
        return this.initializeFiltersIfEmpty(t), t.map(function(t, n) {
            var o = $c05419b1d6c7e886$var$B($c05419b1d6c7e886$var$B({}, t), {
                x: i.xFilters[n].apply(t.x, e, r),
                y: i.yFilters[n].apply(t.y, e, r)
            });
            return null != t.z && (o.z = i.zFilters[n].apply(t.z, e, r)), o;
        });
    }, t.prototype.reset = function() {
        this.xFilters = null, this.yFilters = null, this.zFilters = null;
    }, t.prototype.initializeFiltersIfEmpty = function(t) {
        var e = this;
        null != this.xFilters && this.xFilters.length === t.length || (this.xFilters = t.map(function(t) {
            return new $c05419b1d6c7e886$var$Rt(e.config);
        }), this.yFilters = t.map(function(t) {
            return new $c05419b1d6c7e886$var$Rt(e.config);
        }), this.zFilters = t.map(function(t) {
            return new $c05419b1d6c7e886$var$Rt(e.config);
        }));
    }, t;
}(), $c05419b1d6c7e886$var$Vt = function() {
    function t(t) {
        if (null != t.velocityFilter) this.keypointsFilter = new $c05419b1d6c7e886$var$Lt(t.velocityFilter);
        else {
            if (null == t.oneEuroFilter) throw new Error("Either configure velocityFilter or oneEuroFilter, but got " + "".concat(t, "."));
            this.keypointsFilter = new $c05419b1d6c7e886$var$Et(t.oneEuroFilter);
        }
    }
    return t.prototype.apply = function(t, e, n, i, r) {
        if (void 0 === i && (i = !1), null == t) return this.keypointsFilter.reset(), null;
        var o = null != r ? function(t, e) {
            return (t.width * e.width + t.height * e.height) / 2;
        }(r, n) : 1, a = i ? $c05419b1d6c7e886$var$kt(t, n) : t, s = this.keypointsFilter.apply(a, e, o);
        return i ? $c05419b1d6c7e886$var$At(s, n) : s;
    }, t;
}(), $c05419b1d6c7e886$var$Bt = function() {
    function t(t) {
        this.alpha = t.alpha;
    }
    return t.prototype.apply = function(t) {
        var e = this;
        if (null == t) return this.visibilityFilters = null, null;
        null != this.visibilityFilters && this.visibilityFilters.length === t.length || (this.visibilityFilters = t.map(function(t) {
            return new $c05419b1d6c7e886$var$zt(e.alpha);
        }));
        for(var n = [], i = 0; i < t.length; ++i){
            var r = t[i], o = $c05419b1d6c7e886$var$B({}, r);
            o.score = this.visibilityFilters[i].apply(r.score), n.push(o);
        }
        return n;
    }, t;
}(), $c05419b1d6c7e886$var$Nt = {
    reduceBoxesInLowestlayer: !1,
    interpolatedScaleAspectRatio: 1,
    featureMapHeight: [],
    featureMapWidth: [],
    numLayers: 5,
    minScale: .1484375,
    maxScale: .75,
    inputSizeHeight: 224,
    inputSizeWidth: 224,
    anchorOffsetX: .5,
    anchorOffsetY: .5,
    strides: [
        8,
        16,
        32,
        32,
        32
    ],
    aspectRatios: [
        1
    ],
    fixedAnchorSize: !0
}, $c05419b1d6c7e886$var$Dt = {
    runtime: "tfjs",
    modelType: "full",
    enableSmoothing: !0,
    enableSegmentation: !1,
    smoothSegmentation: !0,
    detectorModelUrl: "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/detector/1",
    landmarkModelUrl: "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/full/2"
}, $c05419b1d6c7e886$var$Kt = {
    maxPoses: 1,
    flipHorizontal: !1
}, $c05419b1d6c7e886$var$Ut = {
    applyExponentialOnBoxSize: !1,
    flipVertically: !1,
    ignoreClasses: [],
    numClasses: 1,
    numBoxes: 2254,
    numCoords: 12,
    boxCoordOffset: 0,
    keypointCoordOffset: 4,
    numKeypoints: 4,
    numValuesPerKeypoint: 2,
    sigmoidScore: !0,
    scoreClippingThresh: 100,
    reverseOutputOrder: !0,
    xScale: 224,
    yScale: 224,
    hScale: 224,
    wScale: 224,
    minScoreThresh: .5
}, $c05419b1d6c7e886$var$jt = .3, $c05419b1d6c7e886$var$Ht = {
    shiftX: 0,
    shiftY: 0,
    scaleX: 1.25,
    scaleY: 1.25,
    squareLong: !0
}, $c05419b1d6c7e886$var$qt = {
    outputTensorSize: {
        width: 224,
        height: 224
    },
    keepAspectRatio: !0,
    outputTensorFloatRange: [
        -1,
        1
    ],
    borderMode: "zero"
}, $c05419b1d6c7e886$var$Xt = {
    outputTensorSize: {
        width: 256,
        height: 256
    },
    keepAspectRatio: !0,
    outputTensorFloatRange: [
        0,
        1
    ],
    borderMode: "zero"
}, $c05419b1d6c7e886$var$Yt = {
    numLandmarks: 39,
    inputImageWidth: 256,
    inputImageHeight: 256,
    visibilityActivation: "sigmoid",
    flipHorizontally: !1,
    flipVertically: !1
}, $c05419b1d6c7e886$var$Wt = {
    numLandmarks: 39,
    inputImageWidth: 1,
    inputImageHeight: 1,
    visibilityActivation: "sigmoid",
    flipHorizontally: !1,
    flipVertically: !1
}, $c05419b1d6c7e886$var$Gt = {
    kernelSize: 7,
    minConfidenceToRefine: .5
}, $c05419b1d6c7e886$var$Qt = {
    alpha: .1
}, $c05419b1d6c7e886$var$Zt = {
    oneEuroFilter: {
        frequency: 30,
        minCutOff: .05,
        beta: 80,
        derivateCutOff: 1,
        minAllowedObjectScale: 1e-6
    }
}, $c05419b1d6c7e886$var$$t = {
    oneEuroFilter: {
        frequency: 30,
        minCutOff: .01,
        beta: 10,
        derivateCutOff: 1,
        minAllowedObjectScale: 1e-6
    }
}, $c05419b1d6c7e886$var$Jt = {
    oneEuroFilter: {
        frequency: 30,
        minCutOff: .1,
        beta: 40,
        derivateCutOff: 1,
        minAllowedObjectScale: 1e-6,
        disableValueScaling: !0
    }
}, $c05419b1d6c7e886$var$te = {
    activation: "none"
}, $c05419b1d6c7e886$var$ee = {
    combineWithPreviousRatio: .7
};
var $c05419b1d6c7e886$var$ne = function() {
    function t(t) {
        this.mask = t;
    }
    return t.prototype.toCanvasImageSource = function() {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            return $c05419b1d6c7e886$var$D(this, function(t) {
                return [
                    2,
                    $c05419b1d6c7e886$var$G(this.mask)
                ];
            });
        });
    }, t.prototype.toImageData = function() {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            return $c05419b1d6c7e886$var$D(this, function(t) {
                return [
                    2,
                    $c05419b1d6c7e886$var$Q(this.mask)
                ];
            });
        });
    }, t.prototype.toTensor = function() {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            return $c05419b1d6c7e886$var$D(this, function(t) {
                return [
                    2,
                    this.mask
                ];
            });
        });
    }, t.prototype.getUnderlyingType = function() {
        return "tensor";
    }, t;
}();
function $c05419b1d6c7e886$var$ie(t) {
    return $c05419b1d6c7e886$var$$(t), "person";
}
var $c05419b1d6c7e886$var$re = function() {
    function t(t, e, n, i, r, o) {
        this.detectorModel = t, this.landmarkModel = e, this.enableSmoothing = n, this.enableSegmentation = i, this.smoothSegmentation = r, this.modelType = o, this.regionOfInterest = null, this.prevFilteredSegmentationMask = null, this.anchors = function(t) {
            null == t.reduceBoxesInLowestLayer && (t.reduceBoxesInLowestLayer = !1), null == t.interpolatedScaleAspectRatio && (t.interpolatedScaleAspectRatio = 1), null == t.fixedAnchorSize && (t.fixedAnchorSize = !1);
            for(var e = [], n = 0; n < t.numLayers;){
                for(var i = [], r = [], o = [], a = [], s = n; s < t.strides.length && t.strides[s] === t.strides[n];){
                    var u = $c05419b1d6c7e886$var$gt(t.minScale, t.maxScale, s, t.strides.length);
                    if (0 === s && t.reduceBoxesInLowestLayer) o.push(1), o.push(2), o.push(.5), a.push(.1), a.push(u), a.push(u);
                    else {
                        for(var h = 0; h < t.aspectRatios.length; ++h)o.push(t.aspectRatios[h]), a.push(u);
                        if (t.interpolatedScaleAspectRatio > 0) {
                            var l = s === t.strides.length - 1 ? 1 : $c05419b1d6c7e886$var$gt(t.minScale, t.maxScale, s + 1, t.strides.length);
                            a.push(Math.sqrt(u * l)), o.push(t.interpolatedScaleAspectRatio);
                        }
                    }
                    s++;
                }
                for(var c = 0; c < o.length; ++c){
                    var p = Math.sqrt(o[c]);
                    i.push(a[c] / p), r.push(a[c] * p);
                }
                var f = 0, d = 0;
                if (t.featureMapHeight.length > 0) f = t.featureMapHeight[n], d = t.featureMapWidth[n];
                else {
                    var m = t.strides[n];
                    f = Math.ceil(t.inputSizeHeight / m), d = Math.ceil(t.inputSizeWidth / m);
                }
                for(var g = 0; g < f; ++g)for(var y = 0; y < d; ++y)for(var v = 0; v < i.length; ++v){
                    var x = {
                        xCenter: (y + t.anchorOffsetX) / d,
                        yCenter: (g + t.anchorOffsetY) / f,
                        width: 0,
                        height: 0
                    };
                    t.fixedAnchorSize ? (x.width = 1, x.height = 1) : (x.width = r[v], x.height = i[v]), e.push(x);
                }
                n = s;
            }
            return e;
        }($c05419b1d6c7e886$var$Nt);
        var a = (0, $lalFM.tensor1d)(this.anchors.map(function(t) {
            return t.width;
        })), u = (0, $lalFM.tensor1d)(this.anchors.map(function(t) {
            return t.height;
        })), h = (0, $lalFM.tensor1d)(this.anchors.map(function(t) {
            return t.xCenter;
        })), l = (0, $lalFM.tensor1d)(this.anchors.map(function(t) {
            return t.yCenter;
        }));
        this.anchorTensor = {
            x: h,
            y: l,
            w: a,
            h: u
        }, this.prevFilteredSegmentationMask = this.enableSegmentation ? (0, $gmMlv.tensor2d)([], [
            0,
            0
        ]) : null;
    }
    return t.prototype.estimatePoses = function(t, e, n) {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var i, o, a, s, u, c, p, d, m, g, y, v, x, w, k, b, M, S, T, P, O, I, A;
            return $c05419b1d6c7e886$var$D(this, function(z) {
                switch(z.label){
                    case 0:
                        return i = function(t) {
                            var e;
                            if (null == (e = null == t ? $c05419b1d6c7e886$var$Kt : $c05419b1d6c7e886$var$B({}, t)).maxPoses && (e.maxPoses = 1), e.maxPoses <= 0) throw new Error("Invalid maxPoses ".concat(e.maxPoses, ". Should be > 0."));
                            if (e.maxPoses > 1) throw new Error("Multi-pose detection is not implemented yet. Please set maxPoses to 1.");
                            return e;
                        }(e), null == t ? (this.reset(), [
                            2,
                            []
                        ]) : (this.maxPoses = i.maxPoses, this.timestamp = null != n ? 1e3 * n : $c05419b1d6c7e886$var$vt(t) ? 1e6 * t.currentTime : null, o = $c05419b1d6c7e886$var$rt(t), a = (0, $c2DT1.tidy)(function() {
                            return (0, $inFmq.cast)($c05419b1d6c7e886$var$at(t), "float32");
                        }), null != (s = this.regionOfInterest) ? [
                            3,
                            2
                        ] : [
                            4,
                            this.detectPose(a)
                        ]);
                    case 1:
                        if (0 === (u = z.sent()).length) return this.reset(), a.dispose(), [
                            2,
                            []
                        ];
                        c = u[0], s = this.poseDetectionToRoi(c, o), z.label = 2;
                    case 2:
                        return [
                            4,
                            this.poseLandmarksByRoi(s, a)
                        ];
                    case 3:
                        return p = z.sent(), a.dispose(), null == p ? (this.reset(), [
                            2,
                            []
                        ]) : (d = p.landmarks, m = p.auxiliaryLandmarks, g = p.poseScore, y = p.worldLandmarks, v = p.segmentationMask, x = this.poseLandmarkFiltering(d, m, y, o), w = x.actualLandmarksFiltered, k = x.auxiliaryLandmarksFiltered, b = x.actualWorldLandmarksFiltered, M = this.poseLandmarksToRoi(k, o), this.regionOfInterest = M, S = this.smoothSegmentation && null != v ? this.poseSegmentationFiltering(v) : v, null != (T = null != w ? $c05419b1d6c7e886$var$kt(w, o) : null) && T.forEach(function(t, e) {
                            t.name = $c05419b1d6c7e886$var$j[e];
                        }), null != (P = b) && P.forEach(function(t, e) {
                            t.name = $c05419b1d6c7e886$var$j[e];
                        }), O = {
                            score: g,
                            keypoints: T,
                            keypoints3D: P
                        }, null !== S && (I = (0, $c2DT1.tidy)(function() {
                            var t = (0, $iPDWZ.expandDims)(S, 2), e = (0, $fSZF6.pad)(t, [
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    1
                                ]
                            ]);
                            return (0, $ejlRR.mirrorPad)(e, [
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    2
                                ]
                            ], "symmetric");
                        }), this.smoothSegmentation || (0, $c2DT1.dispose)(S), A = {
                            maskValueToLabel: $c05419b1d6c7e886$var$ie,
                            mask: new $c05419b1d6c7e886$var$ne(I)
                        }, O.segmentation = A), [
                            2,
                            [
                                O
                            ]
                        ]);
                }
            });
        });
    }, t.prototype.poseSegmentationFiltering = function(t) {
        var e = this.prevFilteredSegmentationMask;
        return 0 === e.size ? this.prevFilteredSegmentationMask = t : (this.prevFilteredSegmentationMask = $c05419b1d6c7e886$var$St(e, t, $c05419b1d6c7e886$var$ee), (0, $c2DT1.dispose)(t)), (0, $c2DT1.dispose)(e), this.prevFilteredSegmentationMask;
    }, t.prototype.dispose = function() {
        this.detectorModel.dispose(), this.landmarkModel.dispose(), (0, $c2DT1.dispose)([
            this.anchorTensor.x,
            this.anchorTensor.y,
            this.anchorTensor.w,
            this.anchorTensor.h,
            this.prevFilteredSegmentationMask
        ]);
    }, t.prototype.reset = function() {
        this.regionOfInterest = null, this.enableSegmentation && ((0, $c2DT1.dispose)(this.prevFilteredSegmentationMask), this.prevFilteredSegmentationMask = (0, $gmMlv.tensor2d)([], [
            0,
            0
        ])), this.visibilitySmoothingFilterActual = null, this.visibilitySmoothingFilterAuxiliary = null, this.landmarksSmoothingFilterActual = null, this.landmarksSmoothingFilterAuxiliary = null;
    }, t.prototype.detectPose = function(t) {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var e, n, i, r, o, a, s, u, h, l;
            return $c05419b1d6c7e886$var$D(this, function(c) {
                switch(c.label){
                    case 0:
                        return e = $c05419b1d6c7e886$var$mt(t, $c05419b1d6c7e886$var$qt), n = e.imageTensor, i = e.padding, r = this.detectorModel.predict(n), o = $c05419b1d6c7e886$var$yt(r), a = o.boxes, [
                            4,
                            $c05419b1d6c7e886$var$Tt([
                                s = o.logits,
                                a
                            ], this.anchorTensor, $c05419b1d6c7e886$var$Ut)
                        ];
                    case 1:
                        return 0 === (u = c.sent()).length ? ((0, $c2DT1.dispose)([
                            n,
                            r,
                            s,
                            a
                        ]), [
                            2,
                            u
                        ]) : [
                            4,
                            $c05419b1d6c7e886$var$wt(u, this.maxPoses, $c05419b1d6c7e886$var$jt)
                        ];
                    case 2:
                        return h = c.sent(), l = function(t, e) {
                            void 0 === t && (t = []);
                            for(var n = e.left, i = e.top, r = e.left + e.right, o = e.top + e.bottom, a = 0; a < t.length; a++){
                                var s = t[a], u = s.locationData.relativeBoundingBox, h = (u.xMin - n) / (1 - r), l = (u.yMin - i) / (1 - o), c = u.width / (1 - r), p = u.height / (1 - o);
                                u.xMin = h, u.yMin = l, u.width = c, u.height = p, u.xMax = h + c, u.yMax = l + p;
                                var f = s.locationData.relativeKeypoints;
                                f && f.forEach(function(t) {
                                    var e = (t.x - n) / (1 - r), a = (t.y - i) / (1 - o);
                                    t.x = e, t.y = a;
                                });
                            }
                            return t;
                        }(h, i), (0, $c2DT1.dispose)([
                            n,
                            r,
                            s,
                            a
                        ]), [
                            2,
                            l
                        ];
                }
            });
        });
    }, t.prototype.poseDetectionToRoi = function(t, e) {
        return $c05419b1d6c7e886$var$It($c05419b1d6c7e886$var$ht(t, e, {
            rotationVectorEndKeypointIndex: 1,
            rotationVectorStartKeypointIndex: 0,
            rotationVectorTargetAngleDegree: 90
        }), e, $c05419b1d6c7e886$var$Ht);
    }, t.prototype.poseLandmarksByRoi = function(t, e) {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var n, i, r, o, a, s, u, h, l, c, p, d, m, g;
            return $c05419b1d6c7e886$var$D(this, function(y) {
                switch(y.label){
                    case 0:
                        if (n = $c05419b1d6c7e886$var$rt(e), i = $c05419b1d6c7e886$var$mt(e, $c05419b1d6c7e886$var$Xt, t), r = i.imageTensor, o = i.padding, a = i.transformationMatrix, "lite" !== this.modelType && "full" !== this.modelType && "heavy" !== this.modelType) throw new Error("Model type must be one of lite, full or heavy," + "but got ".concat(this.modelType));
                        return s = [
                            "ld_3d",
                            "output_poseflag",
                            "activation_heatmap",
                            "world_3d"
                        ], this.enableSegmentation && s.push("activation_segmentation"), u = this.landmarkModel.execute(r, s), [
                            4,
                            this.tensorsToPoseLandmarksAndSegmentation(u)
                        ];
                    case 1:
                        return null == (h = y.sent()) ? ((0, $c2DT1.dispose)(u), (0, $c2DT1.dispose)(r), [
                            2,
                            null
                        ]) : (l = h.landmarks, c = h.auxiliaryLandmarks, p = h.poseScore, d = h.worldLandmarks, m = h.segmentationMask, [
                            4,
                            this.poseLandmarksAndSegmentationInverseProjection(n, t, o, a, l, c, d, m)
                        ]);
                    case 2:
                        return g = y.sent(), (0, $c2DT1.dispose)(u), (0, $c2DT1.dispose)(r), [
                            2,
                            $c05419b1d6c7e886$var$B({
                                poseScore: p
                            }, g)
                        ];
                }
            });
        });
    }, t.prototype.poseLandmarksAndSegmentationInverseProjection = function(t, e, n, i, o, a, h, l) {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var c, d, m, g, y, v;
            return $c05419b1d6c7e886$var$D(this, function(x) {
                return c = $c05419b1d6c7e886$var$Mt(o, n), d = $c05419b1d6c7e886$var$Mt(a, n), m = $c05419b1d6c7e886$var$ft(c, e), g = $c05419b1d6c7e886$var$ft(d, e), y = function(t, e) {
                    for(var n = [], i = 0, r = t; i < r.length; i++){
                        var o = r[i], a = o.x, s = o.y, u = e.rotation, h = Math.cos(u) * a - Math.sin(u) * s, l = Math.sin(u) * a + Math.cos(u) * s, c = $c05419b1d6c7e886$var$B({}, o);
                        c.x = h, c.y = l, n.push(c);
                    }
                    return n;
                }(h, e), v = null, this.enableSegmentation && (v = (0, $c2DT1.tidy)(function() {
                    var e = l.shape, n = e[0], r = e[1], o = function(t) {
                        var e = $c05419b1d6c7e886$var$lt(new Array(16).fill(0));
                        e[0][0] = $c05419b1d6c7e886$var$pt(t, 0, 0), e[1][0] = -$c05419b1d6c7e886$var$pt(t, 0, 1), e[2][0] = $c05419b1d6c7e886$var$pt(t, 0, 2), e[3][0] = -$c05419b1d6c7e886$var$pt(t, 0, 3), e[0][2] = $c05419b1d6c7e886$var$pt(t, 2, 0), e[1][2] = -$c05419b1d6c7e886$var$pt(t, 2, 1), e[2][2] = $c05419b1d6c7e886$var$pt(t, 2, 2), e[3][2] = -$c05419b1d6c7e886$var$pt(t, 2, 3), e[0][1] = -$c05419b1d6c7e886$var$pt(t, 1, 0), e[1][1] = $c05419b1d6c7e886$var$pt(t, 1, 1), e[2][1] = -$c05419b1d6c7e886$var$pt(t, 1, 2), e[3][1] = $c05419b1d6c7e886$var$pt(t, 1, 3), e[0][3] = -$c05419b1d6c7e886$var$pt(t, 3, 0), e[1][3] = $c05419b1d6c7e886$var$pt(t, 3, 1), e[2][3] = -$c05419b1d6c7e886$var$pt(t, 3, 2), e[3][3] = $c05419b1d6c7e886$var$pt(t, 3, 3);
                        for(var n = t[0][0] * e[0][0] + t[1][0] * e[0][1] + t[2][0] * e[0][2] + t[3][0] * e[0][3], i = 0; i < e.length; i++)for(var r = 0; r < e.length; r++)e[i][r] /= n;
                        return e;
                    }(i), a = (0, $gmMlv.tensor2d)($c05419b1d6c7e886$var$st(o, {
                        width: r,
                        height: n
                    }, t), [
                        1,
                        8
                    ]), h = [
                        1,
                        n,
                        r,
                        1
                    ];
                    return (0, $kX8Hd.squeeze)((0, $aosGd.image).transform((0, $4sqA7.reshape)(l, h), a, "bilinear", "constant", 0, [
                        t.height,
                        t.width
                    ]), [
                        0,
                        3
                    ]);
                }), (0, $c2DT1.dispose)(l)), [
                    2,
                    {
                        landmarks: m,
                        auxiliaryLandmarks: g,
                        worldLandmarks: y,
                        segmentationMask: v
                    }
                ];
            });
        });
    }, t.prototype.tensorsToPoseLandmarksAndSegmentation = function(t) {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var e, n, i, o, a, s, h, l, c, f, d, m, g;
            return $c05419b1d6c7e886$var$D(this, function(y) {
                switch(y.label){
                    case 0:
                        return e = t[0], n = t[1], i = t[2], o = t[3], a = this.enableSegmentation ? t[4] : null, [
                            4,
                            n.data()
                        ];
                    case 1:
                        return (s = y.sent()[0]) < .5 ? [
                            2,
                            null
                        ] : [
                            4,
                            $c05419b1d6c7e886$var$Ot(e, $c05419b1d6c7e886$var$Yt)
                        ];
                    case 2:
                        return [
                            4,
                            $c05419b1d6c7e886$var$bt(y.sent(), i, $c05419b1d6c7e886$var$Gt)
                        ];
                    case 3:
                        return h = y.sent(), l = h.slice(0, 33), c = h.slice(33, 35), [
                            4,
                            $c05419b1d6c7e886$var$Ot(o, $c05419b1d6c7e886$var$Wt)
                        ];
                    case 4:
                        return f = y.sent(), d = f.slice(0, 33), m = function(t, e, n) {
                            void 0 === n && (n = !0);
                            for(var i = [], r = 0; r < t.length; r++){
                                var o = $c05419b1d6c7e886$var$B({}, e[r]);
                                n && (o.score = t[r].score), i.push(o);
                            }
                            return i;
                        }(l, d, !0), g = this.enableSegmentation ? function(t, e, n) {
                            return (0, $c2DT1.tidy)(function() {
                                var i = (0, $kX8Hd.squeeze)(t, [
                                    0
                                ]), r = i.shape[2];
                                if (1 === r) {
                                    var o = i;
                                    switch(e.activation){
                                        case "none":
                                            break;
                                        case "sigmoid":
                                            o = (0, $jvtSq.sigmoid)(o);
                                            break;
                                        case "softmax":
                                            throw new Error("Softmax activation requires two channels.");
                                        default:
                                            throw new Error("Activation not supported (".concat(e.activation, ")"));
                                    }
                                    var a = n ? (0, $aosGd.image).resizeBilinear(o, [
                                        n.height,
                                        n.width
                                    ]) : o;
                                    return (0, $kX8Hd.squeeze)(a, [
                                        2
                                    ]);
                                }
                                throw new Error("Unsupported number of tensor channels ".concat(r));
                            });
                        }(a, $c05419b1d6c7e886$var$te) : null, [
                            2,
                            {
                                landmarks: l,
                                auxiliaryLandmarks: c,
                                poseScore: s,
                                worldLandmarks: m,
                                segmentationMask: g
                            }
                        ];
                }
            });
        });
    }, t.prototype.poseLandmarksToRoi = function(t, e) {
        return $c05419b1d6c7e886$var$It($c05419b1d6c7e886$var$ht($c05419b1d6c7e886$var$xt(t), e, {
            rotationVectorStartKeypointIndex: 0,
            rotationVectorEndKeypointIndex: 1,
            rotationVectorTargetAngleDegree: 90
        }), e, $c05419b1d6c7e886$var$Ht);
    }, t.prototype.poseLandmarkFiltering = function(t, e, n, i) {
        var r, o, a;
        if (null != this.timestamp && this.enableSmoothing) {
            var s = $c05419b1d6c7e886$var$ht($c05419b1d6c7e886$var$xt(e), i, {
                rotationVectorEndKeypointIndex: 0,
                rotationVectorStartKeypointIndex: 1,
                rotationVectorTargetAngleDegree: 90
            });
            null == this.visibilitySmoothingFilterActual && (this.visibilitySmoothingFilterActual = new $c05419b1d6c7e886$var$Bt($c05419b1d6c7e886$var$Qt)), r = this.visibilitySmoothingFilterActual.apply(t), null == this.visibilitySmoothingFilterAuxiliary && (this.visibilitySmoothingFilterAuxiliary = new $c05419b1d6c7e886$var$Bt($c05419b1d6c7e886$var$Qt)), o = this.visibilitySmoothingFilterAuxiliary.apply(e), a = this.visibilitySmoothingFilterActual.apply(n), null == this.landmarksSmoothingFilterActual && (this.landmarksSmoothingFilterActual = new $c05419b1d6c7e886$var$Vt($c05419b1d6c7e886$var$Zt)), r = this.landmarksSmoothingFilterActual.apply(r, this.timestamp, i, !0, s), null == this.landmarksSmoothingFilterAuxiliary && (this.landmarksSmoothingFilterAuxiliary = new $c05419b1d6c7e886$var$Vt($c05419b1d6c7e886$var$$t)), o = this.landmarksSmoothingFilterAuxiliary.apply(o, this.timestamp, i, !0, s), null == this.worldLandmarksSmoothingFilterActual && (this.worldLandmarksSmoothingFilterActual = new $c05419b1d6c7e886$var$Vt($c05419b1d6c7e886$var$Jt)), a = this.worldLandmarksSmoothingFilterActual.apply(n, this.timestamp);
        } else r = t, o = e, a = n;
        return {
            actualLandmarksFiltered: r,
            auxiliaryLandmarksFiltered: o,
            actualWorldLandmarksFiltered: a
        };
    }, t;
}();
function $c05419b1d6c7e886$var$oe(t) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var e, n, i, r, o, a;
        return $c05419b1d6c7e886$var$D(this, function(s) {
            switch(s.label){
                case 0:
                    return e = function(t) {
                        var e = $c05419b1d6c7e886$var$B({}, null == t ? $c05419b1d6c7e886$var$Dt : t);
                        if (null == e.enableSmoothing && (e.enableSmoothing = $c05419b1d6c7e886$var$Dt.enableSmoothing), null == e.enableSegmentation && (e.enableSegmentation = $c05419b1d6c7e886$var$Dt.enableSegmentation), null == e.smoothSegmentation && (e.smoothSegmentation = $c05419b1d6c7e886$var$Dt.smoothSegmentation), null == e.modelType && (e.modelType = $c05419b1d6c7e886$var$Dt.modelType), null == e.detectorModelUrl && (e.detectorModelUrl = $c05419b1d6c7e886$var$Dt.detectorModelUrl), null == e.landmarkModelUrl) switch(e.modelType){
                            case "lite":
                                e.landmarkModelUrl = "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/lite/2";
                                break;
                            case "heavy":
                                e.landmarkModelUrl = "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/heavy/2";
                                break;
                            case "full":
                            default:
                                e.landmarkModelUrl = "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/full/2";
                        }
                        return e;
                    }(t), n = "string" == typeof e.detectorModelUrl && e.detectorModelUrl.indexOf("https://tfhub.dev") > -1, i = "string" == typeof e.landmarkModelUrl && e.landmarkModelUrl.indexOf("https://tfhub.dev") > -1, [
                        4,
                        Promise.all([
                            (0, $bVQtG.loadGraphModel)(e.detectorModelUrl, {
                                fromTFHub: n
                            }),
                            (0, $bVQtG.loadGraphModel)(e.landmarkModelUrl, {
                                fromTFHub: i
                            })
                        ])
                    ];
                case 1:
                    return r = s.sent(), o = r[0], a = r[1], [
                        2,
                        new $c05419b1d6c7e886$var$re(o, a, e.enableSmoothing, e.enableSegmentation, e.smoothSegmentation, e.modelType)
                    ];
            }
        });
    });
}
var $c05419b1d6c7e886$export$71a8b12e11ac26f3, $c05419b1d6c7e886$export$2f09812b4c450c2b, $c05419b1d6c7e886$var$ue = function() {
    function t(t) {
        !function(t) {
            if (t.maxTracks < 1) throw new Error("Must specify 'maxTracks' to be at least 1, but " + "encountered ".concat(t.maxTracks));
            if (t.maxAge <= 0) throw new Error("Must specify 'maxAge' to be positive, but " + "encountered ".concat(t.maxAge));
            if (void 0 !== t.keypointTrackerParams) {
                if (t.keypointTrackerParams.keypointConfidenceThreshold < 0 || t.keypointTrackerParams.keypointConfidenceThreshold > 1) throw new Error("Must specify 'keypointConfidenceThreshold' to be in the range [0, 1], but encountered " + "".concat(t.keypointTrackerParams.keypointConfidenceThreshold));
                if (t.keypointTrackerParams.minNumberOfKeypoints < 1) throw new Error("Must specify 'minNumberOfKeypoints' to be at least 1, but " + "encountered ".concat(t.keypointTrackerParams.minNumberOfKeypoints));
                for(var e = 0, n = t.keypointTrackerParams.keypointFalloff; e < n.length; e++){
                    var i = n[e];
                    if (i <= 0) throw new Error("Must specify each keypoint falloff parameterto be positive " + "but encountered ".concat(i));
                }
            }
        }(t), this.tracks = [], this.maxTracks = t.maxTracks, this.maxAge = 1e3 * t.maxAge, this.minSimilarity = t.minSimilarity, this.nextID = 1;
    }
    return t.prototype.apply = function(t, e) {
        this.filterOldTracks(e);
        var n = this.computeSimilarity(t);
        return this.assignTracks(t, n, e), this.updateTracks(e), t;
    }, t.prototype.getTracks = function() {
        return this.tracks.slice();
    }, t.prototype.getTrackIDs = function() {
        return new Set(this.tracks.map(function(t) {
            return t.id;
        }));
    }, t.prototype.filterOldTracks = function(t) {
        var e = this;
        this.tracks = this.tracks.filter(function(n) {
            return t - n.lastTimestamp <= e.maxAge;
        });
    }, t.prototype.assignTracks = function(t, e, n) {
        for(var i = Array.from(Array(e[0].length).keys()), r = [], o = 0, a = Array.from(Array(t.length).keys()); o < a.length; o++){
            var s = a[o];
            if (0 !== i.length) {
                for(var u = -1, h = -1, l = 0, c = i; l < c.length; l++){
                    var p = c[l], f = e[s][p];
                    f >= this.minSimilarity && f > h && (u = p, h = f);
                }
                if (u >= 0) {
                    var d = this.tracks[u];
                    d = Object.assign(d, this.createTrack(t[s], n, d.id)), t[s].id = d.id;
                    var m = i.indexOf(u);
                    i.splice(m, 1);
                } else r.push(s);
            } else r.push(s);
        }
        for(var g = 0, y = r; g < y.length; g++){
            s = y[g];
            var v = this.createTrack(t[s], n);
            this.tracks.push(v), t[s].id = v.id;
        }
    }, t.prototype.updateTracks = function(t) {
        this.tracks.sort(function(t, e) {
            return e.lastTimestamp - t.lastTimestamp;
        }), this.tracks = this.tracks.slice(0, this.maxTracks);
    }, t.prototype.createTrack = function(t, e, n) {
        var i = {
            id: n || this.nextTrackID(),
            lastTimestamp: e,
            keypoints: $c05419b1d6c7e886$var$K([], t.keypoints, !0).map(function(t) {
                return $c05419b1d6c7e886$var$B({}, t);
            })
        };
        return void 0 !== t.box && (i.box = $c05419b1d6c7e886$var$B({}, t.box)), i;
    }, t.prototype.nextTrackID = function() {
        var t = this.nextID;
        return this.nextID += 1, t;
    }, t.prototype.remove = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        this.tracks = this.tracks.filter(function(e) {
            return !t.includes(e.id);
        });
    }, t.prototype.reset = function() {
        this.tracks = [];
    }, t;
}(), $c05419b1d6c7e886$var$he = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $c05419b1d6c7e886$var$V(e, t), e.prototype.computeSimilarity = function(t) {
        var e = this;
        return 0 === t.length || 0 === this.tracks.length ? [
            []
        ] : t.map(function(t) {
            return e.tracks.map(function(n) {
                return e.iou(t, n);
            });
        });
    }, e.prototype.iou = function(t, e) {
        var n = Math.max(t.box.xMin, e.box.xMin), i = Math.max(t.box.yMin, e.box.yMin), r = Math.min(t.box.xMax, e.box.xMax), o = Math.min(t.box.yMax, e.box.yMax);
        if (n >= r || i >= o) return 0;
        var a = (r - n) * (o - i);
        return a / (t.box.width * t.box.height + e.box.width * e.box.height - a);
    }, e;
}($c05419b1d6c7e886$var$ue), $c05419b1d6c7e886$var$le = function(t) {
    function e(e) {
        var n = t.call(this, e) || this;
        return n.keypointThreshold = e.keypointTrackerParams.keypointConfidenceThreshold, n.keypointFalloff = e.keypointTrackerParams.keypointFalloff, n.minNumKeyoints = e.keypointTrackerParams.minNumberOfKeypoints, n;
    }
    return $c05419b1d6c7e886$var$V(e, t), e.prototype.computeSimilarity = function(t) {
        if (0 === t.length || 0 === this.tracks.length) return [
            []
        ];
        for(var e = [], n = 0, i = t; n < i.length; n++){
            for(var r = i[n], o = [], a = 0, s = this.tracks; a < s.length; a++){
                var u = s[a];
                o.push(this.oks(r, u));
            }
            e.push(o);
        }
        return e;
    }, e.prototype.oks = function(t, e) {
        for(var n = this.area(e.keypoints) + 1e-6, i = 0, r = 0, o = 0; o < t.keypoints.length; ++o){
            var a = t.keypoints[o], s = e.keypoints[o];
            if (!(a.score < this.keypointThreshold || s.score < this.keypointThreshold)) {
                r += 1;
                var u = Math.pow(a.x - s.x, 2) + Math.pow(a.y - s.y, 2), h = 2 * this.keypointFalloff[o];
                i += Math.exp(-1 * u / (2 * n * Math.pow(h, 2)));
            }
        }
        return r < this.minNumKeyoints ? 0 : i / r;
    }, e.prototype.area = function(t) {
        var e = this, n = t.filter(function(t) {
            return t.score > e.keypointThreshold;
        }), i = Math.min.apply(Math, $c05419b1d6c7e886$var$K([
            1
        ], n.map(function(t) {
            return t.x;
        }), !1)), r = Math.max.apply(Math, $c05419b1d6c7e886$var$K([
            0
        ], n.map(function(t) {
            return t.x;
        }), !1)), o = Math.min.apply(Math, $c05419b1d6c7e886$var$K([
            1
        ], n.map(function(t) {
            return t.y;
        }), !1));
        return (r - i) * (Math.max.apply(Math, $c05419b1d6c7e886$var$K([
            0
        ], n.map(function(t) {
            return t.y;
        }), !1)) - o);
    }, e;
}($c05419b1d6c7e886$var$ue);
function $c05419b1d6c7e886$var$ce(t) {
    switch(t){
        case $c05419b1d6c7e886$export$2f09812b4c450c2b.BlazePose:
            return $c05419b1d6c7e886$var$j.reduce(function(t, e, n) {
                return t[e] = n, t;
            }, {});
        case $c05419b1d6c7e886$export$2f09812b4c450c2b.PoseNet:
        case $c05419b1d6c7e886$export$2f09812b4c450c2b.MoveNet:
            return $c05419b1d6c7e886$var$U.reduce(function(t, e, n) {
                return t[e] = n, t;
            }, {});
        default:
            throw new Error("Model ".concat(t, " is not supported."));
    }
}
!function(t) {
    t.Keypoint = "keypoint", t.BoundingBox = "boundingBox";
}($c05419b1d6c7e886$export$71a8b12e11ac26f3 || ($c05419b1d6c7e886$export$71a8b12e11ac26f3 = {})), function(t) {
    t.MoveNet = "MoveNet", t.BlazePose = "BlazePose", t.PoseNet = "PoseNet";
}($c05419b1d6c7e886$export$2f09812b4c450c2b || ($c05419b1d6c7e886$export$2f09812b4c450c2b = {}));
var $c05419b1d6c7e886$export$7debb50ef11d5e0b = Object.freeze({
    __proto__: null,
    getKeypointIndexBySide: function(t) {
        switch(t){
            case $c05419b1d6c7e886$export$2f09812b4c450c2b.BlazePose:
                return $c05419b1d6c7e886$var$H;
            case $c05419b1d6c7e886$export$2f09812b4c450c2b.PoseNet:
            case $c05419b1d6c7e886$export$2f09812b4c450c2b.MoveNet:
                return $c05419b1d6c7e886$var$q;
            default:
                throw new Error("Model ".concat(t, " is not supported."));
        }
    },
    getAdjacentPairs: function(t) {
        switch(t){
            case $c05419b1d6c7e886$export$2f09812b4c450c2b.BlazePose:
                return $c05419b1d6c7e886$var$Y;
            case $c05419b1d6c7e886$export$2f09812b4c450c2b.PoseNet:
            case $c05419b1d6c7e886$export$2f09812b4c450c2b.MoveNet:
                return $c05419b1d6c7e886$var$X;
            default:
                throw new Error("Model ".concat(t, " is not supported."));
        }
    },
    getKeypointIndexByName: $c05419b1d6c7e886$var$ce
}), $c05419b1d6c7e886$var$fe = [
    "SinglePose.Lightning",
    "SinglePose.Thunder",
    "MultiPose.Lightning"
], $c05419b1d6c7e886$var$de = {
    modelType: "SinglePose.Lightning",
    enableSmoothing: !0
}, $c05419b1d6c7e886$var$me = {}, $c05419b1d6c7e886$var$ge = {
    frequency: 30,
    minCutOff: 2.5,
    beta: 300,
    derivateCutOff: 2.5,
    thresholdCutOff: .5,
    thresholdBeta: 5,
    disableValueScaling: !0
}, $c05419b1d6c7e886$var$ye = {
    maxTracks: 18,
    maxAge: 1e3,
    minSimilarity: .2,
    keypointTrackerParams: {
        keypointConfidenceThreshold: .3,
        keypointFalloff: [
            .026,
            .025,
            .025,
            .035,
            .035,
            .079,
            .079,
            .072,
            .072,
            .062,
            .062,
            .107,
            .107,
            .087,
            .087,
            .089,
            .089
        ],
        minNumberOfKeypoints: 4
    }
}, $c05419b1d6c7e886$var$ve = {
    maxTracks: 18,
    maxAge: 1e3,
    minSimilarity: .15,
    trackerParams: {}
};
function $c05419b1d6c7e886$var$xe(t, e, n, i) {
    for(var r = {}, o = 0, a = $c05419b1d6c7e886$var$U; o < a.length; o++){
        var s = a[o];
        r[s] = [
            e[n[s]].y * i.height,
            e[n[s]].x * i.width
        ];
    }
    if (function(t, e) {
        return (t[e.left_hip].score > .2 || t[e.right_hip].score > .2) && (t[e.left_shoulder].score > .2 || t[e.right_shoulder].score > .2);
    }(e, n)) {
        var u = (r.left_hip[0] + r.right_hip[0]) / 2, h = (r.left_hip[1] + r.right_hip[1]) / 2, l = function(t, e, n, i, r) {
            for(var o = [
                "left_shoulder",
                "right_shoulder",
                "left_hip",
                "right_hip"
            ], a = 0, s = 0, u = 0; u < o.length; u++)(f = Math.abs(i - n[o[u]][0])) > a && (a = f), (d = Math.abs(r - n[o[u]][1])) > s && (s = d);
            for(var h = 0, l = 0, c = 0, p = Object.keys(n); c < p.length; c++){
                var f, d, m = p[c];
                if (!(t[e[m]].score < .2)) (f = Math.abs(i - n[m][0])) > h && (h = f), (d = Math.abs(r - n[m][1])) > l && (l = d);
            }
            return [
                a,
                s,
                h,
                l
            ];
        }(e, n, r, u, h), c = l[0], p = l[1], f = l[2], d = l[3], m = Math.max(1.9 * p, 1.9 * c, 1.2 * f, 1.2 * d), g = [
            u - (m = Math.min(m, Math.max(h, i.width - h, u, i.height - u))),
            h - m
        ];
        if (m > Math.max(i.width, i.height) / 2) return $c05419b1d6c7e886$var$we(null == t, i);
        var y = 2 * m;
        return {
            yMin: g[0] / i.height,
            xMin: g[1] / i.width,
            yMax: (g[0] + y) / i.height,
            xMax: (g[1] + y) / i.width,
            height: (g[0] + y) / i.height - g[0] / i.height,
            width: (g[1] + y) / i.width - g[1] / i.width
        };
    }
    return $c05419b1d6c7e886$var$we(null == t, i);
}
function $c05419b1d6c7e886$var$we(t, e) {
    var n, i, r, o;
    return t ? e.width > e.height ? (n = 1, i = e.height / e.width, r = 0, o = (e.width / 2 - e.height / 2) / e.width) : (n = e.width / e.height, i = 1, r = (e.height / 2 - e.width / 2) / e.height, o = 0) : e.width > e.height ? (n = e.width / e.height, i = 1, r = (e.height / 2 - e.width / 2) / e.height, o = 0) : (n = 1, i = e.height / e.width, r = 0, o = (e.width / 2 - e.height / 2) / e.width), {
        yMin: r,
        xMin: o,
        yMax: r + n,
        xMax: o + i,
        height: n,
        width: i
    };
}
function $c05419b1d6c7e886$var$ke(t) {
    var e, n = null == t ? $c05419b1d6c7e886$var$de : $c05419b1d6c7e886$var$B({}, t);
    if (null == n.modelType) n.modelType = "SinglePose.Lightning";
    else if ($c05419b1d6c7e886$var$fe.indexOf(n.modelType) < 0) throw new Error("Invalid architecture ".concat(n.modelType, ". ") + "Should be one of ".concat($c05419b1d6c7e886$var$fe));
    if (null == n.enableSmoothing && (n.enableSmoothing = !0), null != n.minPoseScore && (n.minPoseScore < 0 || n.minPoseScore > 1)) throw new Error("minPoseScore should be between 0.0 and 1.0");
    if (null != n.multiPoseMaxDimension && (n.multiPoseMaxDimension % 32 != 0 || n.multiPoseMaxDimension < 32)) throw new Error("multiPoseMaxDimension must be a multiple of 32 and higher than 0");
    if ("MultiPose.Lightning" === n.modelType && null == n.enableTracking && (n.enableTracking = !0), "MultiPose.Lightning" === n.modelType && !0 === n.enableTracking) {
        if (null == n.trackerType && (n.trackerType = $c05419b1d6c7e886$export$71a8b12e11ac26f3.BoundingBox), n.trackerType === $c05419b1d6c7e886$export$71a8b12e11ac26f3.Keypoint) null != n.trackerConfig ? n.trackerConfig = function(t) {
            var e = $c05419b1d6c7e886$var$be($c05419b1d6c7e886$var$ye, t);
            e.keypointTrackerParams = $c05419b1d6c7e886$var$B({}, $c05419b1d6c7e886$var$ye.keypointTrackerParams), null != t.keypointTrackerParams && (null != t.keypointTrackerParams.keypointConfidenceThreshold && (e.keypointTrackerParams.keypointConfidenceThreshold = t.keypointTrackerParams.keypointConfidenceThreshold), null != t.keypointTrackerParams.keypointFalloff && (e.keypointTrackerParams.keypointFalloff = t.keypointTrackerParams.keypointFalloff), null != t.keypointTrackerParams.minNumberOfKeypoints && (e.keypointTrackerParams.minNumberOfKeypoints = t.keypointTrackerParams.minNumberOfKeypoints));
            return e;
        }(n.trackerConfig) : n.trackerConfig = $c05419b1d6c7e886$var$ye;
        else {
            if (n.trackerType !== $c05419b1d6c7e886$export$71a8b12e11ac26f3.BoundingBox) throw new Error("Tracker type not supported by MoveNet");
            null != n.trackerConfig ? n.trackerConfig = (e = n.trackerConfig, $c05419b1d6c7e886$var$be($c05419b1d6c7e886$var$ve, e)) : n.trackerConfig = $c05419b1d6c7e886$var$ve;
        }
    }
    return n;
}
function $c05419b1d6c7e886$var$be(t, e) {
    var n = {
        maxTracks: t.maxTracks,
        maxAge: t.maxAge,
        minSimilarity: t.minSimilarity
    };
    return null != e.maxTracks && (n.maxTracks = e.maxTracks), null != e.maxAge && (n.maxAge = e.maxAge), null != e.minSimilarity && (n.minSimilarity = e.minSimilarity), n;
}
var $c05419b1d6c7e886$var$Me = function() {
    function t(t, e) {
        this.moveNetModel = t, this.modelInputResolution = {
            height: 0,
            width: 0
        }, this.keypointIndexByName = $c05419b1d6c7e886$var$ce($c05419b1d6c7e886$export$2f09812b4c450c2b.MoveNet), "SinglePose.Lightning" === e.modelType ? (this.modelInputResolution.width = 192, this.modelInputResolution.height = 192) : "SinglePose.Thunder" === e.modelType && (this.modelInputResolution.width = 256, this.modelInputResolution.height = 256), this.multiPoseModel = "MultiPose.Lightning" === e.modelType, this.multiPoseModel || (this.keypointFilter = new $c05419b1d6c7e886$var$Et($c05419b1d6c7e886$var$ge), this.cropRegionFilterYMin = new $c05419b1d6c7e886$var$zt(.9), this.cropRegionFilterXMin = new $c05419b1d6c7e886$var$zt(.9), this.cropRegionFilterYMax = new $c05419b1d6c7e886$var$zt(.9), this.cropRegionFilterXMax = new $c05419b1d6c7e886$var$zt(.9)), this.enableSmoothing = e.enableSmoothing, e.minPoseScore ? this.minPoseScore = e.minPoseScore : this.minPoseScore = .25, e.multiPoseMaxDimension ? this.multiPoseMaxDimension = e.multiPoseMaxDimension : this.multiPoseMaxDimension = 256, this.enableTracking = e.enableTracking, this.multiPoseModel && this.enableTracking && (e.trackerType === $c05419b1d6c7e886$export$71a8b12e11ac26f3.Keypoint ? this.tracker = new $c05419b1d6c7e886$var$le(e.trackerConfig) : e.trackerType === $c05419b1d6c7e886$export$71a8b12e11ac26f3.BoundingBox && (this.tracker = new $c05419b1d6c7e886$var$he(e.trackerConfig)), this.enableSmoothing && (this.keypointFilterMap = new Map));
    }
    return t.prototype.runSinglePersonPoseModel = function(t) {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var e, n, i, r, o;
            return $c05419b1d6c7e886$var$D(this, function(a) {
                switch(a.label){
                    case 0:
                        if (4 !== (e = this.moveNetModel.execute(t)).shape.length || 1 !== e.shape[0] || 1 !== e.shape[1] || 17 !== e.shape[2] || 3 !== e.shape[3]) throw e.dispose(), new Error("Unexpected output shape from model: [".concat(e.shape, "]"));
                        return "webgpu" === (0, $c2DT1.getBackend)() ? [
                            3,
                            1
                        ] : (n = e.dataSync(), [
                            3,
                            3
                        ]);
                    case 1:
                        return [
                            4,
                            e.data()
                        ];
                    case 2:
                        n = a.sent(), a.label = 3;
                    case 3:
                        for(e.dispose(), i = {
                            keypoints: [],
                            score: 0
                        }, r = 0, o = 0; o < 17; ++o)i.keypoints[o] = {
                            y: n[3 * o],
                            x: n[3 * o + 1],
                            score: n[3 * o + 2]
                        }, i.keypoints[o].score > .2 && (++r, i.score += i.keypoints[o].score);
                        return r > 0 && (i.score /= r), [
                            2,
                            i
                        ];
                }
            });
        });
    }, t.prototype.runMultiPersonPoseModel = function(t) {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var e, n, i, r, o, a, s, u;
            return $c05419b1d6c7e886$var$D(this, function(h) {
                switch(h.label){
                    case 0:
                        if (3 !== (e = this.moveNetModel.execute(t)).shape.length || 1 !== e.shape[0] || 56 !== e.shape[2]) throw e.dispose(), new Error("Unexpected output shape from model: [".concat(e.shape, "]"));
                        return "webgpu" === (0, $c2DT1.getBackend)() ? [
                            3,
                            1
                        ] : (n = e.dataSync(), [
                            3,
                            3
                        ]);
                    case 1:
                        return [
                            4,
                            e.data()
                        ];
                    case 2:
                        n = h.sent(), h.label = 3;
                    case 3:
                        for(e.dispose(), i = [], r = n.length / 56, o = 0; o < r; ++o)for(i[o] = {
                            keypoints: []
                        }, a = 56 * o + 51, i[o].box = {
                            yMin: n[a],
                            xMin: n[a + 1],
                            yMax: n[a + 2],
                            xMax: n[a + 3],
                            width: n[a + 3] - n[a + 1],
                            height: n[a + 2] - n[a]
                        }, s = 56 * o + 55, i[o].score = n[s], i[o].keypoints = [], u = 0; u < 17; ++u)i[o].keypoints[u] = {
                            y: n[56 * o + 3 * u],
                            x: n[56 * o + 3 * u + 1],
                            score: n[56 * o + 3 * u + 2]
                        };
                        return [
                            2,
                            i
                        ];
                }
            });
        });
    }, t.prototype.estimatePoses = function(t, n, i) {
        return void 0 === n && (n = $c05419b1d6c7e886$var$me), $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var r, o, a, s, u, l;
            return $c05419b1d6c7e886$var$D(this, function(c) {
                switch(c.label){
                    case 0:
                        return n = function(t) {
                            return null == t ? $c05419b1d6c7e886$var$me : $c05419b1d6c7e886$var$B({}, t);
                        }(n), null == t ? (this.reset(), [
                            2,
                            []
                        ]) : (null == i ? $c05419b1d6c7e886$var$vt(t) && (i = 1e6 * t.currentTime) : i *= 1e3, r = $c05419b1d6c7e886$var$at(t), o = $c05419b1d6c7e886$var$rt(r), a = (0, $iPDWZ.expandDims)(r, 0), t instanceof (0, $9jCh7.Tensor) || r.dispose(), s = [], this.multiPoseModel ? [
                            3,
                            2
                        ] : [
                            4,
                            this.estimateSinglePose(a, o, i)
                        ]);
                    case 1:
                        return s = c.sent(), [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.estimateMultiplePoses(a, o, i)
                        ];
                    case 3:
                        s = c.sent(), c.label = 4;
                    case 4:
                        for(u = 0; u < s.length; ++u)for(l = 0; l < s[u].keypoints.length; ++l)s[u].keypoints[l].name = $c05419b1d6c7e886$var$U[l], s[u].keypoints[l].y *= o.height, s[u].keypoints[l].x *= o.width;
                        return [
                            2,
                            s
                        ];
                }
            });
        });
    }, t.prototype.estimateSinglePose = function(t, e, n) {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var i, o, a, h, c = this;
            return $c05419b1d6c7e886$var$D(this, function(p) {
                switch(p.label){
                    case 0:
                        return this.cropRegion || (this.cropRegion = $c05419b1d6c7e886$var$we(null == this.cropRegion, e)), i = (0, $c2DT1.tidy)(function() {
                            var e = (0, $gmMlv.tensor2d)([
                                [
                                    c.cropRegion.yMin,
                                    c.cropRegion.xMin,
                                    c.cropRegion.yMax,
                                    c.cropRegion.xMax
                                ]
                            ]), n = (0, $hxi4c.zeros)([
                                1
                            ], "int32"), i = [
                                c.modelInputResolution.height,
                                c.modelInputResolution.width
                            ];
                            return (0, $inFmq.cast)((0, $aosGd.image).cropAndResize(t, e, n, i, "bilinear", 0), "int32");
                        }), t.dispose(), [
                            4,
                            this.runSinglePersonPoseModel(i)
                        ];
                    case 1:
                        if (o = p.sent(), i.dispose(), o.score < this.minPoseScore) return this.reset(), [
                            2,
                            []
                        ];
                        for(a = 0; a < o.keypoints.length; ++a)o.keypoints[a].y = this.cropRegion.yMin + o.keypoints[a].y * this.cropRegion.height, o.keypoints[a].x = this.cropRegion.xMin + o.keypoints[a].x * this.cropRegion.width;
                        return null != n && this.enableSmoothing && (o.keypoints = this.keypointFilter.apply(o.keypoints, n, 1)), h = $c05419b1d6c7e886$var$xe(this.cropRegion, o.keypoints, this.keypointIndexByName, e), this.cropRegion = this.filterCropRegion(h), [
                            2,
                            [
                                o
                            ]
                        ];
                }
            });
        });
    }, t.prototype.estimateMultiplePoses = function(t, e, n) {
        return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var i, r, o, a, s, h, c, p, f, d, m, g = this;
            return $c05419b1d6c7e886$var$D(this, function(y) {
                switch(y.label){
                    case 0:
                        return e.width > e.height ? (r = this.multiPoseMaxDimension, o = Math.round(this.multiPoseMaxDimension * e.height / e.width), i = (0, $aosGd.image).resizeBilinear(t, [
                            o,
                            r
                        ]), s = r, h = 32 * Math.ceil(o / 32), a = (0, $fSZF6.pad)(i, [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                h - o
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ])) : (r = Math.round(this.multiPoseMaxDimension * e.width / e.height), o = this.multiPoseMaxDimension, i = (0, $aosGd.image).resizeBilinear(t, [
                            o,
                            r
                        ]), s = 32 * Math.ceil(r / 32), h = o, a = (0, $fSZF6.pad)(i, [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                s - r
                            ],
                            [
                                0,
                                0
                            ]
                        ])), i.dispose(), t.dispose(), c = (0, $inFmq.cast)(a, "int32"), a.dispose(), [
                            4,
                            this.runMultiPersonPoseModel(c)
                        ];
                    case 1:
                        for(p = y.sent(), c.dispose(), p = p.filter(function(t) {
                            return t.score >= g.minPoseScore;
                        }), d = 0; d < p.length; ++d)for(f = 0; f < p[d].keypoints.length; ++f)p[d].keypoints[f].y *= h / o, p[d].keypoints[f].x *= s / r;
                        if (this.enableTracking && (this.tracker.apply(p, n), this.enableSmoothing)) {
                            for(d = 0; d < p.length; ++d)this.keypointFilterMap.has(p[d].id) || this.keypointFilterMap.set(p[d].id, new $c05419b1d6c7e886$var$Et($c05419b1d6c7e886$var$ge)), p[d].keypoints = this.keypointFilterMap.get(p[d].id).apply(p[d].keypoints, n, 1);
                            m = this.tracker.getTrackIDs(), this.keypointFilterMap.forEach(function(t, e) {
                                m.has(e) || g.keypointFilterMap.delete(e);
                            });
                        }
                        return [
                            2,
                            p
                        ];
                }
            });
        });
    }, t.prototype.filterCropRegion = function(t) {
        if (t) {
            var e = this.cropRegionFilterYMin.apply(t.yMin), n = this.cropRegionFilterXMin.apply(t.xMin), i = this.cropRegionFilterYMax.apply(t.yMax), r = this.cropRegionFilterXMax.apply(t.xMax);
            return {
                yMin: e,
                xMin: n,
                yMax: i,
                xMax: r,
                height: i - e,
                width: r - n
            };
        }
        return this.cropRegionFilterYMin.reset(), this.cropRegionFilterXMin.reset(), this.cropRegionFilterYMax.reset(), this.cropRegionFilterXMax.reset(), null;
    }, t.prototype.dispose = function() {
        this.moveNetModel.dispose();
    }, t.prototype.reset = function() {
        this.cropRegion = null, this.resetFilters();
    }, t.prototype.resetFilters = function() {
        this.keypointFilter.reset(), this.cropRegionFilterYMin.reset(), this.cropRegionFilterXMin.reset(), this.cropRegionFilterYMax.reset(), this.cropRegionFilterXMax.reset();
    }, t;
}();
function $c05419b1d6c7e886$var$Se(t) {
    return void 0 === t && (t = $c05419b1d6c7e886$var$de), $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var e, n, i, r;
        return $c05419b1d6c7e886$var$D(this, function(o) {
            switch(o.label){
                case 0:
                    return e = $c05419b1d6c7e886$var$ke(t), i = !0, e.modelUrl ? (i = "string" == typeof e.modelUrl && e.modelUrl.indexOf("https://tfhub.dev") > -1, [
                        4,
                        (0, $bVQtG.loadGraphModel)(e.modelUrl, {
                            fromTFHub: i
                        })
                    ]) : [
                        3,
                        2
                    ];
                case 1:
                    return n = o.sent(), [
                        3,
                        4
                    ];
                case 2:
                    return r = void 0, "SinglePose.Lightning" === e.modelType ? r = "https://tfhub.dev/google/tfjs-model/movenet/singlepose/lightning/4" : "SinglePose.Thunder" === e.modelType ? r = "https://tfhub.dev/google/tfjs-model/movenet/singlepose/thunder/4" : "MultiPose.Lightning" === e.modelType && (r = "https://tfhub.dev/google/tfjs-model/movenet/multipose/lightning/1"), [
                        4,
                        (0, $bVQtG.loadGraphModel)(r, {
                            fromTFHub: i
                        })
                    ];
                case 3:
                    n = o.sent(), o.label = 4;
                case 4:
                    return "webgl" === (0, $c2DT1.getBackend)() && (0, $ibsdL.env)().set("TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD", 0), [
                        2,
                        new $c05419b1d6c7e886$var$Me(n, e)
                    ];
            }
        });
    });
}
var $c05419b1d6c7e886$var$Te = {
    architecture: "MobileNetV1",
    outputStride: 16,
    multiplier: .75,
    inputResolution: {
        height: 257,
        width: 257
    }
}, $c05419b1d6c7e886$var$Pe = [
    "MobileNetV1",
    "ResNet50"
], $c05419b1d6c7e886$var$Fe = {
    MobileNetV1: [
        8,
        16
    ],
    ResNet50: [
        16
    ]
}, $c05419b1d6c7e886$var$_e = [
    8,
    16,
    32
], $c05419b1d6c7e886$var$Oe = {
    MobileNetV1: [
        .5,
        .75,
        1
    ],
    ResNet50: [
        1
    ]
}, $c05419b1d6c7e886$var$Ie = [
    1,
    2,
    4
], $c05419b1d6c7e886$var$Ae = {
    maxPoses: 1,
    flipHorizontal: !1
}, $c05419b1d6c7e886$var$ze = {
    maxPoses: 5,
    flipHorizontal: !1,
    scoreThreshold: .5,
    nmsRadius: 20
}, $c05419b1d6c7e886$var$Ce = [
    -123.15,
    -115.9,
    -103.06
];
function $c05419b1d6c7e886$var$Ee(t) {
    return Math.floor(t / 2);
}
var $c05419b1d6c7e886$var$Re = function() {
    function t(t, e) {
        this.priorityQueue = new Array(t), this.numberOfElements = -1, this.getElementValue = e;
    }
    return t.prototype.enqueue = function(t) {
        this.priorityQueue[++this.numberOfElements] = t, this.swim(this.numberOfElements);
    }, t.prototype.dequeue = function() {
        var t = this.priorityQueue[0];
        return this.exchange(0, this.numberOfElements--), this.sink(0), this.priorityQueue[this.numberOfElements + 1] = null, t;
    }, t.prototype.empty = function() {
        return -1 === this.numberOfElements;
    }, t.prototype.size = function() {
        return this.numberOfElements + 1;
    }, t.prototype.all = function() {
        return this.priorityQueue.slice(0, this.numberOfElements + 1);
    }, t.prototype.max = function() {
        return this.priorityQueue[0];
    }, t.prototype.swim = function(t) {
        for(; t > 0 && this.less($c05419b1d6c7e886$var$Ee(t), t);)this.exchange(t, $c05419b1d6c7e886$var$Ee(t)), t = $c05419b1d6c7e886$var$Ee(t);
    }, t.prototype.sink = function(t) {
        for(; 2 * t <= this.numberOfElements;){
            var e = 2 * t;
            if (e < this.numberOfElements && this.less(e, e + 1) && e++, !this.less(t, e)) break;
            this.exchange(t, e), t = e;
        }
    }, t.prototype.getValueAt = function(t) {
        return this.getElementValue(this.priorityQueue[t]);
    }, t.prototype.less = function(t, e) {
        return this.getValueAt(t) < this.getValueAt(e);
    }, t.prototype.exchange = function(t, e) {
        var n = this.priorityQueue[t];
        this.priorityQueue[t] = this.priorityQueue[e], this.priorityQueue[e] = n;
    }, t;
}();
function $c05419b1d6c7e886$var$Le(t, e, n, i, r, o) {
    for(var a = o.shape, s = a[0], u = a[1], h = !0, l = Math.max(n - r, 0), c = Math.min(n + r + 1, s), p = l; p < c; ++p){
        for(var f = Math.max(i - r, 0), d = Math.min(i + r + 1, u), m = f; m < d; ++m)if (o.get(p, m, t) > e) {
            h = !1;
            break;
        }
        if (!h) break;
    }
    return h;
}
function $c05419b1d6c7e886$var$Ve(t) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        return $c05419b1d6c7e886$var$D(this, function(e) {
            return [
                2,
                Promise.all(t.map(function(t) {
                    return t.buffer();
                }))
            ];
        });
    });
}
function $c05419b1d6c7e886$var$Be(t, e, n, i) {
    return {
        y: i.get(t, e, n),
        x: i.get(t, e, n + 17)
    };
}
function $c05419b1d6c7e886$var$Ne(t, e, n) {
    var i = $c05419b1d6c7e886$var$Be(t.heatmapY, t.heatmapX, t.id, n), r = i.y, o = i.x;
    return {
        x: t.heatmapX * e + o,
        y: t.heatmapY * e + r
    };
}
function $c05419b1d6c7e886$var$De(t, e, n, i) {
    var r = n.x, o = n.y;
    return t.some(function(t) {
        var n, a, s, u, h, l, c = t.keypoints;
        return n = o, a = r, s = c[i].y, u = c[i].x, (h = s - n) * h + (l = u - a) * l <= e;
    });
}
var $c05419b1d6c7e886$var$Ke = $c05419b1d6c7e886$var$U.reduce(function(t, e, n) {
    return t[e] = n, t;
}, {}), $c05419b1d6c7e886$var$Ue = [
    [
        "nose",
        "left_eye"
    ],
    [
        "left_eye",
        "left_ear"
    ],
    [
        "nose",
        "right_eye"
    ],
    [
        "right_eye",
        "right_ear"
    ],
    [
        "nose",
        "left_shoulder"
    ],
    [
        "left_shoulder",
        "left_elbow"
    ],
    [
        "left_elbow",
        "left_wrist"
    ],
    [
        "left_shoulder",
        "left_hip"
    ],
    [
        "left_hip",
        "left_knee"
    ],
    [
        "left_knee",
        "left_ankle"
    ],
    [
        "nose",
        "right_shoulder"
    ],
    [
        "right_shoulder",
        "right_elbow"
    ],
    [
        "right_elbow",
        "right_wrist"
    ],
    [
        "right_shoulder",
        "right_hip"
    ],
    [
        "right_hip",
        "right_knee"
    ],
    [
        "right_knee",
        "right_ankle"
    ]
].map(function(t) {
    var e = t[0], n = t[1];
    return [
        $c05419b1d6c7e886$var$Ke[e],
        $c05419b1d6c7e886$var$Ke[n]
    ];
}), $c05419b1d6c7e886$var$je = $c05419b1d6c7e886$var$Ue.map(function(t) {
    return t[1];
}), $c05419b1d6c7e886$var$He = $c05419b1d6c7e886$var$Ue.map(function(t) {
    return t[0];
});
function $c05419b1d6c7e886$var$qe(t, e, n) {
    return t < e ? e : t > n ? n : t;
}
function $c05419b1d6c7e886$var$Xe(t, e, n, i) {
    return {
        y: $c05419b1d6c7e886$var$qe(Math.round(t.y / e), 0, n - 1),
        x: $c05419b1d6c7e886$var$qe(Math.round(t.x / e), 0, i - 1)
    };
}
function $c05419b1d6c7e886$var$Ye(t, e) {
    return {
        x: t.x + e.x,
        y: t.y + e.y
    };
}
function $c05419b1d6c7e886$var$We(t, e, n, i, r, o, a, s) {
    void 0 === s && (s = 2);
    for(var u = i.shape, h = u[0], l = u[1], c = {
        y: e.y,
        x: e.x
    }, p = $c05419b1d6c7e886$var$Ye(c, function(t, e, n) {
        var i = n.shape[2] / 2;
        return {
            y: n.get(e.y, e.x, t),
            x: n.get(e.y, e.x, i + t)
        };
    }(t, $c05419b1d6c7e886$var$Xe(c, o, h, l), a)), f = 0; f < s; f++){
        var d = $c05419b1d6c7e886$var$Xe(p, o, h, l), m = $c05419b1d6c7e886$var$Be(d.y, d.x, n, r);
        p = $c05419b1d6c7e886$var$Ye({
            x: d.x * o,
            y: d.y * o
        }, {
            x: m.x,
            y: m.y
        });
    }
    var g = $c05419b1d6c7e886$var$Xe(p, o, h, l), y = i.get(g.y, g.x, n);
    return {
        y: p.y,
        x: p.x,
        name: $c05419b1d6c7e886$var$U[n],
        score: y
    };
}
function $c05419b1d6c7e886$var$Ge(t, e, n, i, r, o) {
    var a = e.shape[2], s = $c05419b1d6c7e886$var$je.length, u = new Array(a), h = t.part, l = t.score, c = $c05419b1d6c7e886$var$Ne(h, i, n);
    u[h.id] = {
        score: l,
        name: $c05419b1d6c7e886$var$U[h.id],
        y: c.y,
        x: c.x
    };
    for(var p = s - 1; p >= 0; --p){
        var f = $c05419b1d6c7e886$var$je[p], d = $c05419b1d6c7e886$var$He[p];
        u[f] && !u[d] && (u[d] = $c05419b1d6c7e886$var$We(p, u[f], d, e, n, i, o));
    }
    for(p = 0; p < s; ++p){
        f = $c05419b1d6c7e886$var$He[p], d = $c05419b1d6c7e886$var$je[p];
        u[f] && !u[d] && (u[d] = $c05419b1d6c7e886$var$We(p, u[f], d, e, n, i, r));
    }
    return u;
}
function $c05419b1d6c7e886$var$Qe(t, e, n) {
    return n.reduce(function(n, i, r) {
        var o = i.y, a = i.x, s = i.score;
        return $c05419b1d6c7e886$var$De(t, e, {
            y: o,
            x: a
        }, r) || (n += s), n;
    }, 0) / n.length;
}
function $c05419b1d6c7e886$var$Ze(t, e, n, i, r, o, a, s) {
    return void 0 === a && (a = .5), void 0 === s && (s = 20), $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var u, h, l, c, p, f, d, m, g, y, v, x;
        return $c05419b1d6c7e886$var$D(this, function(w) {
            switch(w.label){
                case 0:
                    return [
                        4,
                        $c05419b1d6c7e886$var$Ve([
                            t,
                            e,
                            n,
                            i
                        ])
                    ];
                case 1:
                    for(u = w.sent(), h = u[0], l = u[1], c = u[2], p = u[3], f = [], d = function(t, e, n) {
                        for(var i = n.shape, r = i[0], o = i[1], a = i[2], s = new $c05419b1d6c7e886$var$Re(r * o * a, function(t) {
                            return t.score;
                        }), u = 0; u < r; ++u)for(var h = 0; h < o; ++h)for(var l = 0; l < a; ++l){
                            var c = n.get(u, h, l);
                            c < t || $c05419b1d6c7e886$var$Le(l, c, u, h, e, n) && s.enqueue({
                                score: c,
                                part: {
                                    heatmapY: u,
                                    heatmapX: h,
                                    id: l
                                }
                            });
                        }
                        return s;
                    }(a, 1, h), m = s * s; f.length < o && !d.empty();)g = d.dequeue(), y = $c05419b1d6c7e886$var$Ne(g.part, r, l), $c05419b1d6c7e886$var$De(f, m, y, g.part.id) || (v = $c05419b1d6c7e886$var$Ge(g, h, l, r, c, p), x = $c05419b1d6c7e886$var$Qe(f, m, v), f.push({
                        keypoints: v,
                        score: x
                    }));
                    return [
                        2,
                        f
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$$e() {
    for(var t, e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
    switch(e.length){
        case 0:
            t = "fn main() ";
            break;
        case 1:
            t = "fn main(".concat(e[0], " : i32)");
            break;
        default:
            throw Error("Unreachable");
    }
    return t;
}
var $c05419b1d6c7e886$var$Je = function() {
    function t(t) {
        this.variableNames = [
            "A",
            "B"
        ], this.size = !0;
        this.workgroupSize = [
            32,
            1,
            1
        ], this.outputShape = [
            t[0],
            1
        ], this.dispatchLayout = (0, $9Dn6G).flatDispatchLayout(this.outputShape), this.dispatch = (0, $9Dn6G).computeDispatch(this.dispatchLayout, this.outputShape, this.workgroupSize), this.shaderKey = "getpointsConfidenceOp";
    }
    return t.prototype.getUserCode = function() {
        return "\n        ".concat($c05419b1d6c7e886$var$$e("index"), " {\n          if (index < uniforms.size) {\n            let y = B[index * 2];\n            let x = B[index * 2 + 1];\n            let outIndex = y * uniforms.aShape.x * uniforms.aShape.z + x * uniforms.aShape.z + index;\n            result[index] = A[outIndex];\n          }\n        }\n        ");
    }, t;
}();
function $c05419b1d6c7e886$var$tn(t, e) {
    if ((0, $c2DT1.backend)() instanceof (0, $j8LvK.WebGPUBackend)) return function(t, e) {
        var n = (0, $c2DT1.backend)(), i = new $c05419b1d6c7e886$var$Je(e.shape), r = n.runWebGPUProgram(i, [
            t,
            e
        ], "float32");
        return (0, $c2DT1.engine)().makeTensorFromTensorInfo(r);
    }(t, e);
    throw new Error("getPointsConfidenceWebGPU is not supported in this backend!");
}
var $c05419b1d6c7e886$var$en = function() {
    function t(t) {
        if (this.variableNames = [
            "A",
            "B"
        ], this.size = !0, this.supportedLastDimension = 2, 2 !== t.length || t[1] !== this.supportedLastDimension) throw new Error("GetOffsetVectorsProgram only supports shape of [x, ".concat(this.supportedLastDimension, "], but current shape is ").concat(t));
        this.workgroupSize = [
            32,
            1,
            1
        ], this.outputShape = t;
        var e = [
            t[0],
            1
        ];
        this.dispatchLayout = (0, $9Dn6G).flatDispatchLayout(e), this.dispatch = (0, $9Dn6G).computeDispatch(this.dispatchLayout, e, this.workgroupSize), this.shaderKey = "GetOffsetVectors";
    }
    return t.prototype.getUserCode = function() {
        return "\n    fn getOffsetPoint(y: i32, x: i32, index: i32) -> vec2<i32> {\n      let outIndexY = y * uniforms.bShape.x * uniforms.bShape.y + x * uniforms.bShape.y + index;\n      let outIndexX = outIndexY + uniforms.bShape.z;\n      let outY = i32(B[outIndexY]);\n      let outX = i32(B[outIndexX]);\n      return vec2<i32>(outY, outX);\n    }\n\n    ".concat($c05419b1d6c7e886$var$$e("index"), " {\n      if (index < uniforms.size) {\n        let indexY = index * ").concat(this.supportedLastDimension, ";\n        let indexX = indexY + 1;\n        let heatmapY = A[indexY];\n        let heatmapX = A[indexX];\n        let out = getOffsetPoint(i32(heatmapY), i32(heatmapX), index);\n        result[indexY] = f32(out[0]);\n        result[indexX] = f32(out[1]);\n      }\n    }\n    ");
    }, t;
}();
function $c05419b1d6c7e886$var$nn(t, e) {
    if ((0, $c2DT1.backend)() instanceof (0, $j8LvK.WebGPUBackend)) return function(t, e) {
        var n = (0, $c2DT1.backend)(), i = new $c05419b1d6c7e886$var$en(t.shape), r = n.runWebGPUProgram(i, [
            t,
            e
        ], "float32");
        return (0, $c2DT1.engine)().makeTensorFromTensorInfo(r);
    }(t, e);
    throw new Error("getOffsetVectorsGPU is not supported in this backend!");
}
function $c05419b1d6c7e886$var$rn(t) {
    var e = t.shape, n = e[0], i = e[1], o = e[2];
    return (0, $c2DT1.tidy)(function() {
        var e, s, u = (0, $4sqA7.reshape)(t, [
            n * i,
            o
        ]), l = (0, $jctS7.argMax)(u, 0), c = (0, $iPDWZ.expandDims)((0, $1QPqB.div)(l, (0, $3xp7o.scalar)(i, "int32")), 1), p = (0, $iPDWZ.expandDims)((e = l, s = i, (0, $c2DT1.tidy)(function() {
            var t = (0, $1QPqB.div)(e, (0, $3xp7o.scalar)(s, "int32"));
            return (0, $7kouu.sub)(e, (0, $jZc0w.mul)(t, (0, $3xp7o.scalar)(s, "int32")));
        })), 1);
        return (0, $iTu6j.concat)([
            c,
            p
        ], 1);
    });
}
function $c05419b1d6c7e886$var$on(t, e, n) {
    return (0, $c2DT1.tidy)(function() {
        var i = function(t, e) {
            for(var n = [], i = 0; i < $c05419b1d6c7e886$var$U.length; i++){
                var r = t.get(i, 0).valueOf(), o = t.get(i, 1).valueOf(), a = $c05419b1d6c7e886$var$an(r, o, i, e), u = a.x, h = a.y;
                n.push(h), n.push(u);
            }
            return (0, $gmMlv.tensor2d)(n, [
                $c05419b1d6c7e886$var$U.length,
                2
            ]);
        }(t, n);
        return (0, $hgacW.add)((0, $inFmq.cast)((0, $jZc0w.mul)(t.toTensor(), (0, $3xp7o.scalar)(e, "int32")), "float32"), i);
    });
}
function $c05419b1d6c7e886$var$an(t, e, n, i) {
    return {
        y: i.get(t, e, n),
        x: i.get(t, e, n + $c05419b1d6c7e886$var$U.length)
    };
}
function $c05419b1d6c7e886$var$sn(t, e, n) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var i, r, o, a, s, u, h, l, c, p;
        return $c05419b1d6c7e886$var$D(this, function(f) {
            switch(f.label){
                case 0:
                    return i = 0, r = $c05419b1d6c7e886$var$rn(t), [
                        4,
                        Promise.all([
                            t.buffer(),
                            e.buffer(),
                            r.buffer()
                        ])
                    ];
                case 1:
                    return o = f.sent(), a = o[0], s = o[1], u = o[2], [
                        4,
                        (h = $c05419b1d6c7e886$var$on(u, n, s)).buffer()
                    ];
                case 2:
                    return l = f.sent(), c = Array.from(function(t, e) {
                        for(var n = e.shape[0], i = new Float32Array(n), r = 0; r < n; r++){
                            var o = e.get(r, 0), a = e.get(r, 1);
                            i[r] = t.get(o, a, r);
                        }
                        return i;
                    }(a, u)), p = c.map(function(t, e) {
                        return i += t, {
                            y: l.get(e, 0),
                            x: l.get(e, 1),
                            score: t,
                            name: $c05419b1d6c7e886$var$U[e]
                        };
                    }), r.dispose(), h.dispose(), [
                        2,
                        {
                            keypoints: p,
                            score: i / p.length
                        }
                    ];
            }
        });
    });
}
function $c05419b1d6c7e886$var$un(t, e, n) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var i, s, u;
        return $c05419b1d6c7e886$var$D(this, function(h) {
            return i = $c05419b1d6c7e886$var$rn(t), s = function(t, e, n) {
                return (0, $c2DT1.tidy)(function() {
                    var i = $c05419b1d6c7e886$var$nn(t, n);
                    return (0, $hgacW.add)((0, $inFmq.cast)((0, $jZc0w.mul)(t, (0, $3xp7o.scalar)(e, "int32")), "float32"), i);
                });
            }(i, n, e), u = $c05419b1d6c7e886$var$tn(t, i), [
                2,
                [
                    s,
                    u
                ]
            ];
        });
    });
}
function $c05419b1d6c7e886$var$hn(t, e) {
    return (t - 1) % e == 0;
}
var $c05419b1d6c7e886$var$ln = "https://storage.googleapis.com/tfjs-models/savedmodel/posenet/mobilenet/", $c05419b1d6c7e886$var$cn = "https://storage.googleapis.com/tfjs-models/savedmodel/posenet/resnet50/";
function $c05419b1d6c7e886$var$pn(t, e) {
    return function(t, e) {
        return (t - 1) % e == 0;
    }(t, e) ? t : Math.floor(t / e) * e + 1;
}
var $c05419b1d6c7e886$var$fn = function() {
    function t(t, e) {
        this.posenetModel = t;
        var n = this.posenetModel.inputs[0].shape;
        (0, $jjNRA).assert(-1 === n[1] && -1 === n[2], function() {
            return "Input shape [".concat(n[1], ", ").concat(n[2], "] ") + "must both be equal to or -1";
        });
        var r, o, a = (r = e.inputResolution, o = e.outputStride, {
            height: $c05419b1d6c7e886$var$pn(r.height, o),
            width: $c05419b1d6c7e886$var$pn(r.width, o)
        });
        !function(t) {
            (0, $jjNRA).assert($c05419b1d6c7e886$var$_e.indexOf(t) >= 0, function() {
                return "outputStride of ".concat(t, " is invalid. ") + "It must be either 8 or 16.";
            });
        }(e.outputStride), function(t, e) {
            (0, $jjNRA).assert($c05419b1d6c7e886$var$hn(t.height, e), function() {
                return "height of ".concat(t.height, " is invalid for output stride ") + "".concat(e, ".");
            }), (0, $jjNRA).assert($c05419b1d6c7e886$var$hn(t.width, e), function() {
                return "width of ".concat(t.width, " is invalid for output stride ") + "".concat(e, ".");
            });
        }(a, e.outputStride), this.inputResolution = a, this.outputStride = e.outputStride, this.architecture = e.architecture;
    }
    return t.prototype.estimatePoses = function(t, e) {
        return void 0 === e && (e = $c05419b1d6c7e886$var$Ae), $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            return $c05419b1d6c7e886$var$D(this, function(n) {
                return [
                    2,
                    this.estimatePosesGPU(t, e, !1)
                ];
            });
        });
    }, t.prototype.estimatePosesGPU = function(t, e, n) {
        return void 0 === e && (e = $c05419b1d6c7e886$var$Ae), void 0 === n && (n = !1), $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
            var i, r, a, s, u, h, l, c, d, m, g, y, v, x, w, k, b, M;
            return $c05419b1d6c7e886$var$D(this, function(S) {
                switch(S.label){
                    case 0:
                        return i = function(t) {
                            var e = t;
                            if (null == e.maxPoses && (e.maxPoses = 1), e.maxPoses <= 0) throw new Error("Invalid maxPoses ".concat(e.maxPoses, ". Should be > 0."));
                            if (e.maxPoses > 1) {
                                if ((e = $c05419b1d6c7e886$var$B($c05419b1d6c7e886$var$B({}, $c05419b1d6c7e886$var$ze), e)).scoreThreshold < 0 || e.scoreThreshold > 1) throw new Error("Invalid scoreThreshold ".concat(e.scoreThreshold, ". ") + "Should be in range [0.0, 1.0]");
                                if (e.nmsRadius <= 0) throw new Error("Invalid nmsRadius ".concat(e.nmsRadius, "."));
                            }
                            return e;
                        }(e), null == t ? [
                            2,
                            n ? [
                                [],
                                []
                            ] : []
                        ] : (this.maxPoses = i.maxPoses, r = $c05419b1d6c7e886$var$mt(t, {
                            outputTensorSize: this.inputResolution,
                            keepAspectRatio: !0,
                            borderMode: "replicate"
                        }), a = r.imageTensor, s = r.padding, u = "ResNet50" === this.architecture ? (0, $hgacW.add)(a, $c05419b1d6c7e886$var$Ce) : $c05419b1d6c7e886$var$dt(a, [
                            -1,
                            1
                        ]), h = this.posenetModel.predict(u), "ResNet50" === this.architecture ? (l = (0, $kX8Hd.squeeze)(h[2], [
                            0
                        ]), c = (0, $kX8Hd.squeeze)(h[3], [
                            0
                        ]), d = (0, $kX8Hd.squeeze)(h[0], [
                            0
                        ]), m = (0, $kX8Hd.squeeze)(h[1], [
                            0
                        ])) : (l = (0, $kX8Hd.squeeze)(h[0], [
                            0
                        ]), c = (0, $kX8Hd.squeeze)(h[1], [
                            0
                        ]), d = (0, $kX8Hd.squeeze)(h[2], [
                            0
                        ]), m = (0, $kX8Hd.squeeze)(h[3], [
                            0
                        ])), g = (0, $jvtSq.sigmoid)(c), 1 !== this.maxPoses ? [
                            3,
                            5
                        ] : n ? [
                            4,
                            $c05419b1d6c7e886$var$un(g, l, this.outputStride)
                        ] : [
                            3,
                            2
                        ]);
                    case 1:
                        return v = S.sent(), w = v[0], x = v[1], y = [
                            w,
                            x
                        ], [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            $c05419b1d6c7e886$var$sn(g, l, this.outputStride)
                        ];
                    case 3:
                        w = S.sent(), y = [
                            w
                        ], S.label = 4;
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        if (n) throw new Error("GPU renderer only supports single pose!");
                        return [
                            4,
                            $c05419b1d6c7e886$var$Ze(g, l, d, m, this.outputStride, this.maxPoses, i.scoreThreshold, i.nmsRadius)
                        ];
                    case 6:
                        y = S.sent(), S.label = 7;
                    case 7:
                        if (n) {
                            if (!0 === i.flipHorizontal) throw new Error("flipHorizontal is not supported!");
                            k = this.getCanvasInfo($c05419b1d6c7e886$var$rt(t), this.inputResolution, s);
                        } else M = $c05419b1d6c7e886$var$rt(t), b = function(t, e, n, i) {
                            var r = e.height, o = e.width, a = r / (n.height * (1 - i.top - i.bottom)), s = o / (n.width * (1 - i.left - i.right)), u = -i.top * n.height, h = -i.left * n.width;
                            if (1 === s && 1 === a && 0 === u && 0 === h) return t;
                            for(var l = 0, c = t; l < c.length; l++)for(var p = 0, f = c[l].keypoints; p < f.length; p++){
                                var d = f[p];
                                d.x = (d.x + h) * s, d.y = (d.y + u) * a;
                            }
                            return t;
                        }(y, M, this.inputResolution, s), i.flipHorizontal && (b = function(t, e) {
                            for(var n = 0, i = t; n < i.length; n++)for(var r = 0, o = i[n].keypoints; r < o.length; r++){
                                var a = o[r];
                                a.x = e.width - 1 - a.x;
                            }
                            return t;
                        }(b, M));
                        return a.dispose(), u.dispose(), (0, $c2DT1.dispose)(h), l.dispose(), c.dispose(), d.dispose(), m.dispose(), g.dispose(), [
                            2,
                            n ? [
                                y,
                                k
                            ] : b
                        ];
                }
            });
        });
    }, t.prototype.getCanvasInfo = function(t, e, n) {
        var i = t.height, r = t.width, o = i / (e.height * (1 - n.top - n.bottom)), a = r / (e.width * (1 - n.left - n.right)), s = -n.top * e.height;
        return [
            -n.left * e.width,
            s,
            a,
            o,
            t.width,
            t.height
        ];
    }, t.prototype.dispose = function() {
        this.posenetModel.dispose();
    }, t.prototype.reset = function() {}, t;
}();
function $c05419b1d6c7e886$var$dn(t) {
    return void 0 === t && (t = $c05419b1d6c7e886$var$Te), $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var e, n, i, r, o;
        return $c05419b1d6c7e886$var$D(this, function(a) {
            switch(a.label){
                case 0:
                    return "ResNet50" !== (e = function(t) {
                        var e = t || $c05419b1d6c7e886$var$Te;
                        if (null == e.architecture && (e.architecture = "MobileNetV1"), $c05419b1d6c7e886$var$Pe.indexOf(e.architecture) < 0) throw new Error("Invalid architecture ".concat(e.architecture, ". ") + "Should be one of ".concat($c05419b1d6c7e886$var$Pe));
                        if (null == e.inputResolution && (e.inputResolution = {
                            height: 257,
                            width: 257
                        }), null == e.outputStride && (e.outputStride = 16), $c05419b1d6c7e886$var$Fe[e.architecture].indexOf(e.outputStride) < 0) throw new Error("Invalid outputStride ".concat(e.outputStride, ". ") + "Should be one of ".concat($c05419b1d6c7e886$var$Fe[e.architecture], " ") + "for architecture ".concat(e.architecture, "."));
                        if (null == e.multiplier && (e.multiplier = 1), $c05419b1d6c7e886$var$Oe[e.architecture].indexOf(e.multiplier) < 0) throw new Error("Invalid multiplier ".concat(e.multiplier, ". ") + "Should be one of ".concat($c05419b1d6c7e886$var$Oe[e.architecture], " ") + "for architecture ".concat(e.architecture, "."));
                        if (null == e.quantBytes && (e.quantBytes = 4), $c05419b1d6c7e886$var$Ie.indexOf(e.quantBytes) < 0) throw new Error("Invalid quantBytes ".concat(e.quantBytes, ". ") + "Should be one of ".concat($c05419b1d6c7e886$var$Ie, " ") + "for architecture ".concat(e.architecture, "."));
                        if ("MobileNetV1" === e.architecture && 32 === e.outputStride && 1 !== e.multiplier) throw new Error("When using an output stride of 32, you must select 1 as the multiplier.");
                        return e;
                    }(t)).architecture ? [
                        3,
                        2
                    ] : (s = e.outputStride, u = e.quantBytes, h = "model-stride".concat(s, ".json"), n = 4 === u ? $c05419b1d6c7e886$var$cn + "float/" + h : $c05419b1d6c7e886$var$cn + "quant".concat(u, "/") + h, [
                        4,
                        (0, $bVQtG.loadGraphModel)(e.modelUrl || n)
                    ]);
                case 1:
                    return i = a.sent(), [
                        2,
                        new $c05419b1d6c7e886$var$fn(i, e)
                    ];
                case 2:
                    return r = function(t, e, n) {
                        var i = {
                            1: "100",
                            .75: "075",
                            .5: "050"
                        }, r = "model-stride".concat(t, ".json");
                        return 4 === n ? $c05419b1d6c7e886$var$ln + "float/".concat(i[e], "/") + r : $c05419b1d6c7e886$var$ln + "quant".concat(n, "/").concat(i[e], "/") + r;
                    }(e.outputStride, e.multiplier, e.quantBytes), [
                        4,
                        (0, $bVQtG.loadGraphModel)(e.modelUrl || r)
                    ];
                case 3:
                    return o = a.sent(), [
                        2,
                        new $c05419b1d6c7e886$var$fn(o, e)
                    ];
            }
            var s, u, h;
        });
    });
}
function $c05419b1d6c7e886$export$5221435586e5381b(t, e) {
    return $c05419b1d6c7e886$var$N(this, void 0, void 0, function() {
        var n, i;
        return $c05419b1d6c7e886$var$D(this, function(r) {
            switch(t){
                case $c05419b1d6c7e886$export$2f09812b4c450c2b.PoseNet:
                    return [
                        2,
                        $c05419b1d6c7e886$var$dn(e)
                    ];
                case $c05419b1d6c7e886$export$2f09812b4c450c2b.BlazePose:
                    if (i = void 0, null != (n = e)) {
                        if ("tfjs" === n.runtime) return [
                            2,
                            $c05419b1d6c7e886$var$oe(e)
                        ];
                        if ("mediapipe" === n.runtime) return [
                            2,
                            $c05419b1d6c7e886$var$it(e)
                        ];
                        i = n.runtime;
                    }
                    throw new Error("Expect modelConfig.runtime to be either 'tfjs' " + "or 'mediapipe', but got ".concat(i));
                case $c05419b1d6c7e886$export$2f09812b4c450c2b.MoveNet:
                    return [
                        2,
                        $c05419b1d6c7e886$var$Se(e)
                    ];
                default:
                    throw new Error("".concat(t, " is not a supported model name."));
            }
        });
    });
}
var $c05419b1d6c7e886$export$b5d09566951d5e0f = {
    keypointsToNormalizedKeypoints: $c05419b1d6c7e886$var$At
}, $c05419b1d6c7e886$export$86beb49ae50c5d8b = {
    modelType: {
        SINGLEPOSE_LIGHTNING: "SinglePose.Lightning",
        SINGLEPOSE_THUNDER: "SinglePose.Thunder",
        MULTIPOSE_LIGHTNING: "MultiPose.Lightning"
    }
};

});
parcelRegister("xjHPn", function(module, exports) {
(function() {
    'use strict';
    var x;
    function aa(a) {
        var b = 0;
        return function() {
            return b < a.length ? {
                done: !1,
                value: a[b++]
            } : {
                done: !0
            };
        };
    }
    var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ca(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var y = ca(this);
    function z(a, b) {
        if (b) a: {
            var c = y;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && ba(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    z("Symbol", function(a) {
        function b(g) {
            if (this instanceof b) throw new TypeError("Symbol is not a constructor");
            return new c(d + (g || "") + "_" + e++, g);
        }
        function c(g, f) {
            this.h = g;
            ba(this, "description", {
                configurable: !0,
                writable: !0,
                value: f
            });
        }
        if (a) return a;
        c.prototype.toString = function() {
            return this.h;
        };
        var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
        return b;
    });
    z("Symbol.iterator", function(a) {
        if (a) return a;
        a = Symbol("Symbol.iterator");
        for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
            var d = y[b[c]];
            "function" === typeof d && "function" != typeof d.prototype[a] && ba(d.prototype, a, {
                configurable: !0,
                writable: !0,
                value: function() {
                    return da(aa(this));
                }
            });
        }
        return a;
    });
    function da(a) {
        a = {
            next: a
        };
        a[Symbol.iterator] = function() {
            return this;
        };
        return a;
    }
    function A(a) {
        var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
        return b ? b.call(a) : {
            next: aa(a)
        };
    }
    function ea(a) {
        if (!(a instanceof Array)) {
            a = A(a);
            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
            a = c;
        }
        return a;
    }
    var fa = "function" == typeof Object.assign ? Object.assign : function(a, b) {
        for(var c = 1; c < arguments.length; c++){
            var d = arguments[c];
            if (d) for(var e in d)Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
        }
        return a;
    };
    z("Object.assign", function(a) {
        return a || fa;
    });
    var ha = "function" == typeof Object.create ? Object.create : function(a) {
        function b() {}
        b.prototype = a;
        return new b;
    }, ia;
    if ("function" == typeof Object.setPrototypeOf) ia = Object.setPrototypeOf;
    else {
        var ja;
        a: {
            var ka = {
                a: !0
            }, la = {};
            try {
                la.__proto__ = ka;
                ja = la.a;
                break a;
            } catch (a) {}
            ja = !1;
        }
        ia = ja ? function(a, b) {
            a.__proto__ = b;
            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
            return a;
        } : null;
    }
    var ma = ia;
    function na(a, b) {
        a.prototype = ha(b.prototype);
        a.prototype.constructor = a;
        if (ma) ma(a, b);
        else for(var c in b)if ("prototype" != c) {
            if (Object.defineProperties) {
                var d = Object.getOwnPropertyDescriptor(b, c);
                d && Object.defineProperty(a, c, d);
            } else a[c] = b[c];
        }
        a.za = b.prototype;
    }
    function oa() {
        this.m = !1;
        this.j = null;
        this.i = void 0;
        this.h = 1;
        this.v = this.s = 0;
        this.l = null;
    }
    function pa(a) {
        if (a.m) throw new TypeError("Generator is already running");
        a.m = !0;
    }
    oa.prototype.u = function(a) {
        this.i = a;
    };
    function qa(a, b) {
        a.l = {
            ma: b,
            na: !0
        };
        a.h = a.s || a.v;
    }
    oa.prototype.return = function(a) {
        this.l = {
            return: a
        };
        this.h = this.v;
    };
    function D(a, b, c) {
        a.h = c;
        return {
            value: b
        };
    }
    function ra(a) {
        this.h = new oa;
        this.i = a;
    }
    function sa(a, b) {
        pa(a.h);
        var c = a.h.j;
        if (c) return ta(a, "return" in c ? c["return"] : function(d) {
            return {
                value: d,
                done: !0
            };
        }, b, a.h.return);
        a.h.return(b);
        return ua(a);
    }
    function ta(a, b, c, d) {
        try {
            var e = b.call(a.h.j, c);
            if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
            if (!e.done) return a.h.m = !1, e;
            var g = e.value;
        } catch (f) {
            return a.h.j = null, qa(a.h, f), ua(a);
        }
        a.h.j = null;
        d.call(a.h, g);
        return ua(a);
    }
    function ua(a) {
        for(; a.h.h;)try {
            var b = a.i(a.h);
            if (b) return a.h.m = !1, {
                value: b.value,
                done: !1
            };
        } catch (c) {
            a.h.i = void 0, qa(a.h, c);
        }
        a.h.m = !1;
        if (a.h.l) {
            b = a.h.l;
            a.h.l = null;
            if (b.na) throw b.ma;
            return {
                value: b.return,
                done: !0
            };
        }
        return {
            value: void 0,
            done: !0
        };
    }
    function va(a) {
        this.next = function(b) {
            pa(a.h);
            a.h.j ? b = ta(a, a.h.j.next, b, a.h.u) : (a.h.u(b), b = ua(a));
            return b;
        };
        this.throw = function(b) {
            pa(a.h);
            a.h.j ? b = ta(a, a.h.j["throw"], b, a.h.u) : (qa(a.h, b), b = ua(a));
            return b;
        };
        this.return = function(b) {
            return sa(a, b);
        };
        this[Symbol.iterator] = function() {
            return this;
        };
    }
    function wa(a) {
        function b(d) {
            return a.next(d);
        }
        function c(d) {
            return a.throw(d);
        }
        return new Promise(function(d, e) {
            function g(f) {
                f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
            }
            g(a.next());
        });
    }
    function E(a) {
        return wa(new va(new ra(a)));
    }
    z("Promise", function(a) {
        function b(f) {
            this.i = 0;
            this.j = void 0;
            this.h = [];
            this.u = !1;
            var h = this.l();
            try {
                f(h.resolve, h.reject);
            } catch (k) {
                h.reject(k);
            }
        }
        function c() {
            this.h = null;
        }
        function d(f) {
            return f instanceof b ? f : new b(function(h) {
                h(f);
            });
        }
        if (a) return a;
        c.prototype.i = function(f) {
            if (null == this.h) {
                this.h = [];
                var h = this;
                this.j(function() {
                    h.m();
                });
            }
            this.h.push(f);
        };
        var e = y.setTimeout;
        c.prototype.j = function(f) {
            e(f, 0);
        };
        c.prototype.m = function() {
            for(; this.h && this.h.length;){
                var f = this.h;
                this.h = [];
                for(var h = 0; h < f.length; ++h){
                    var k = f[h];
                    f[h] = null;
                    try {
                        k();
                    } catch (l) {
                        this.l(l);
                    }
                }
            }
            this.h = null;
        };
        c.prototype.l = function(f) {
            this.j(function() {
                throw f;
            });
        };
        b.prototype.l = function() {
            function f(l) {
                return function(m) {
                    k || (k = !0, l.call(h, m));
                };
            }
            var h = this, k = !1;
            return {
                resolve: f(this.I),
                reject: f(this.m)
            };
        };
        b.prototype.I = function(f) {
            if (f === this) this.m(new TypeError("A Promise cannot resolve to itself"));
            else if (f instanceof b) this.L(f);
            else {
                a: switch(typeof f){
                    case "object":
                        var h = null != f;
                        break a;
                    case "function":
                        h = !0;
                        break a;
                    default:
                        h = !1;
                }
                h ? this.F(f) : this.s(f);
            }
        };
        b.prototype.F = function(f) {
            var h = void 0;
            try {
                h = f.then;
            } catch (k) {
                this.m(k);
                return;
            }
            "function" == typeof h ? this.M(h, f) : this.s(f);
        };
        b.prototype.m = function(f) {
            this.v(2, f);
        };
        b.prototype.s = function(f) {
            this.v(1, f);
        };
        b.prototype.v = function(f, h) {
            if (0 != this.i) throw Error("Cannot settle(" + f + ", " + h + "): Promise already settled in state" + this.i);
            this.i = f;
            this.j = h;
            2 === this.i && this.K();
            this.H();
        };
        b.prototype.K = function() {
            var f = this;
            e(function() {
                if (f.D()) {
                    var h = y.console;
                    "undefined" !== typeof h && h.error(f.j);
                }
            }, 1);
        };
        b.prototype.D = function() {
            if (this.u) return !1;
            var f = y.CustomEvent, h = y.Event, k = y.dispatchEvent;
            if ("undefined" === typeof k) return !0;
            "function" === typeof f ? f = new f("unhandledrejection", {
                cancelable: !0
            }) : "function" === typeof h ? f = new h("unhandledrejection", {
                cancelable: !0
            }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", !1, !0, f));
            f.promise = this;
            f.reason = this.j;
            return k(f);
        };
        b.prototype.H = function() {
            if (null != this.h) {
                for(var f = 0; f < this.h.length; ++f)g.i(this.h[f]);
                this.h = null;
            }
        };
        var g = new c;
        b.prototype.L = function(f) {
            var h = this.l();
            f.T(h.resolve, h.reject);
        };
        b.prototype.M = function(f, h) {
            var k = this.l();
            try {
                f.call(h, k.resolve, k.reject);
            } catch (l) {
                k.reject(l);
            }
        };
        b.prototype.then = function(f, h) {
            function k(p, n) {
                return "function" == typeof p ? function(q) {
                    try {
                        l(p(q));
                    } catch (t) {
                        m(t);
                    }
                } : n;
            }
            var l, m, r = new b(function(p, n) {
                l = p;
                m = n;
            });
            this.T(k(f, l), k(h, m));
            return r;
        };
        b.prototype.catch = function(f) {
            return this.then(void 0, f);
        };
        b.prototype.T = function(f, h) {
            function k() {
                switch(l.i){
                    case 1:
                        f(l.j);
                        break;
                    case 2:
                        h(l.j);
                        break;
                    default:
                        throw Error("Unexpected state: " + l.i);
                }
            }
            var l = this;
            null == this.h ? g.i(k) : this.h.push(k);
            this.u = !0;
        };
        b.resolve = d;
        b.reject = function(f) {
            return new b(function(h, k) {
                k(f);
            });
        };
        b.race = function(f) {
            return new b(function(h, k) {
                for(var l = A(f), m = l.next(); !m.done; m = l.next())d(m.value).T(h, k);
            });
        };
        b.all = function(f) {
            var h = A(f), k = h.next();
            return k.done ? d([]) : new b(function(l, m) {
                function r(q) {
                    return function(t) {
                        p[q] = t;
                        n--;
                        0 == n && l(p);
                    };
                }
                var p = [], n = 0;
                do p.push(void 0), n++, d(k.value).T(r(p.length - 1), m), k = h.next();
                while (!k.done);
            });
        };
        return b;
    });
    function xa(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var g = c++;
                    return {
                        value: b(g, a[g]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    z("Array.prototype.keys", function(a) {
        return a ? a : function() {
            return xa(this, function(b) {
                return b;
            });
        };
    });
    z("Array.prototype.fill", function(a) {
        return a ? a : function(b, c, d) {
            var e = this.length || 0;
            0 > c && (c = Math.max(0, e + c));
            if (null == d || d > e) d = e;
            d = Number(d);
            0 > d && (d = Math.max(0, e + d));
            for(c = Number(c || 0); c < d; c++)this[c] = b;
            return this;
        };
    });
    function F(a) {
        return a ? a : Array.prototype.fill;
    }
    z("Int8Array.prototype.fill", F);
    z("Uint8Array.prototype.fill", F);
    z("Uint8ClampedArray.prototype.fill", F);
    z("Int16Array.prototype.fill", F);
    z("Uint16Array.prototype.fill", F);
    z("Int32Array.prototype.fill", F);
    z("Uint32Array.prototype.fill", F);
    z("Float32Array.prototype.fill", F);
    z("Float64Array.prototype.fill", F);
    z("Object.is", function(a) {
        return a ? a : function(b, c) {
            return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
        };
    });
    z("Array.prototype.includes", function(a) {
        return a ? a : function(b, c) {
            var d = this;
            d instanceof String && (d = String(d));
            var e = d.length;
            c = c || 0;
            for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                var g = d[c];
                if (g === b || Object.is(g, b)) return !0;
            }
            return !1;
        };
    });
    z("String.prototype.includes", function(a) {
        return a ? a : function(b, c) {
            if (null == this) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
            return -1 !== this.indexOf(b, c || 0);
        };
    });
    var ya = this || self;
    function G(a, b) {
        a = a.split(".");
        var c = ya;
        a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
        for(var d; a.length && (d = a.shift());)a.length || void 0 === b ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
    }
    function Aa(a) {
        var b;
        a: {
            if (b = ya.navigator) {
                if (b = b.userAgent) break a;
            }
            b = "";
        }
        return -1 != b.indexOf(a);
    }
    var Ba = Array.prototype.map ? function(a, b) {
        return Array.prototype.map.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = Array(c), e = "string" === typeof a ? a.split("") : a, g = 0; g < c; g++)g in e && (d[g] = b.call(void 0, e[g], g, a));
        return d;
    };
    var Ca = {}, Da = null;
    function Ea(a) {
        var b = a.length, c = 3 * b / 4;
        c % 3 ? c = Math.floor(c) : -1 != "=.".indexOf(a[b - 1]) && (c = -1 != "=.".indexOf(a[b - 2]) ? c - 2 : c - 1);
        var d = new Uint8Array(c), e = 0;
        Fa(a, function(g) {
            d[e++] = g;
        });
        return e !== c ? d.subarray(0, e) : d;
    }
    function Fa(a, b) {
        function c(k) {
            for(; d < a.length;){
                var l = a.charAt(d++), m = Da[l];
                if (null != m) return m;
                if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
            }
            return k;
        }
        Ga();
        for(var d = 0;;){
            var e = c(-1), g = c(0), f = c(64), h = c(64);
            if (64 === h && -1 === e) break;
            b(e << 2 | g >> 4);
            64 != f && (b(g << 4 & 240 | f >> 2), 64 != h && b(f << 6 & 192 | h));
        }
    }
    function Ga() {
        if (!Da) {
            Da = {};
            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                "+/=",
                "+/",
                "-_=",
                "-_.",
                "-_"
            ], c = 0; 5 > c; c++){
                var d = a.concat(b[c].split(""));
                Ca[c] = d;
                for(var e = 0; e < d.length; e++){
                    var g = d[e];
                    void 0 === Da[g] && (Da[g] = e);
                }
            }
        }
    }
    var Ha = "undefined" !== typeof Uint8Array, Ia = !(Aa("Trident") || Aa("MSIE")) && "function" === typeof ya.btoa;
    function Ja(a) {
        if (!Ia) {
            var b;
            void 0 === b && (b = 0);
            Ga();
            b = Ca[b];
            for(var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3){
                var f = a[e], h = a[e + 1], k = a[e + 2], l = b[f >> 2];
                f = b[(f & 3) << 4 | h >> 4];
                h = b[(h & 15) << 2 | k >> 6];
                k = b[k & 63];
                c[g++] = l + f + h + k;
            }
            l = 0;
            k = d;
            switch(a.length - e){
                case 2:
                    l = a[e + 1], k = b[(l & 15) << 2] || d;
                case 1:
                    a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
            }
            return c.join("");
        }
        for(b = ""; 10240 < a.length;)b += String.fromCharCode.apply(null, a.subarray(0, 10240)), a = a.subarray(10240);
        b += String.fromCharCode.apply(null, a);
        return btoa(b);
    }
    var Ka = RegExp("[-_.]", "g");
    function La(a) {
        switch(a){
            case "-":
                return "+";
            case "_":
                return "/";
            case ".":
                return "=";
            default:
                return "";
        }
    }
    function Ma(a) {
        if (!Ia) return Ea(a);
        Ka.test(a) && (a = a.replace(Ka, La));
        a = atob(a);
        for(var b = new Uint8Array(a.length), c = 0; c < a.length; c++)b[c] = a.charCodeAt(c);
        return b;
    }
    var Na;
    function Oa() {
        return Na || (Na = new Uint8Array(0));
    }
    var Pa = {};
    var Qa = "function" === typeof Uint8Array.prototype.slice, H = 0, K = 0;
    function Ra(a) {
        var b = 0 > a;
        a = Math.abs(a);
        var c = a >>> 0;
        a = Math.floor((a - c) / 4294967296);
        b && (c = A(Sa(c, a)), b = c.next().value, a = c.next().value, c = b);
        H = c >>> 0;
        K = a >>> 0;
    }
    var Ta = "function" === typeof BigInt;
    function Sa(a, b) {
        b = ~b;
        a ? a = ~a + 1 : b += 1;
        return [
            a,
            b
        ];
    }
    function Ua(a, b) {
        this.i = a >>> 0;
        this.h = b >>> 0;
    }
    function Va(a) {
        if (!a) return Wa || (Wa = new Ua(0, 0));
        if (!/^-?\d+$/.test(a)) return null;
        if (16 > a.length) Ra(Number(a));
        else if (Ta) a = BigInt(a), H = Number(a & BigInt(4294967295)) >>> 0, K = Number(a >> BigInt(32) & BigInt(4294967295));
        else {
            var b = +("-" === a[0]);
            K = H = 0;
            for(var c = a.length, d = b, e = (c - b) % 6 + b; e <= c; d = e, e += 6)d = Number(a.slice(d, e)), K *= 1E6, H = 1E6 * H + d, 4294967296 <= H && (K += H / 4294967296 | 0, H %= 4294967296);
            b && (b = A(Sa(H, K)), a = b.next().value, b = b.next().value, H = a, K = b);
        }
        return new Ua(H, K);
    }
    var Wa;
    function Xa(a, b) {
        return Error("Invalid wire type: " + a + " (at position " + b + ")");
    }
    function Ya() {
        return Error("Failed to read varint, encoding is invalid.");
    }
    function Za(a, b) {
        return Error("Tried to read past the end of the data " + b + " > " + a);
    }
    function L() {
        throw Error("Invalid UTF8");
    }
    function $a(a, b) {
        b = String.fromCharCode.apply(null, b);
        return null == a ? b : a + b;
    }
    var ab = void 0, bb, cb = "undefined" !== typeof TextDecoder, db, eb = "undefined" !== typeof TextEncoder;
    var fb;
    function gb(a) {
        if (a !== Pa) throw Error("illegal external caller");
    }
    function hb(a, b) {
        gb(b);
        this.V = a;
        if (null != a && 0 === a.length) throw Error("ByteString should be constructed with non-empty values");
    }
    function ib() {
        return fb || (fb = new hb(null, Pa));
    }
    function jb(a) {
        gb(Pa);
        var b = a.V;
        b = null == b || Ha && null != b && b instanceof Uint8Array ? b : "string" === typeof b ? Ma(b) : null;
        return null == b ? b : a.V = b;
    }
    function kb(a) {
        if ("string" === typeof a) return {
            buffer: Ma(a),
            C: !1
        };
        if (Array.isArray(a)) return {
            buffer: new Uint8Array(a),
            C: !1
        };
        if (a.constructor === Uint8Array) return {
            buffer: a,
            C: !1
        };
        if (a.constructor === ArrayBuffer) return {
            buffer: new Uint8Array(a),
            C: !1
        };
        if (a.constructor === hb) return {
            buffer: jb(a) || Oa(),
            C: !0
        };
        if (a instanceof Uint8Array) return {
            buffer: new Uint8Array(a.buffer, a.byteOffset, a.byteLength),
            C: !1
        };
        throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, a ByteString or an Array of numbers");
    }
    function lb(a, b) {
        this.i = null;
        this.m = !1;
        this.h = this.j = this.l = 0;
        mb(this, a, b);
    }
    function mb(a, b, c) {
        c = void 0 === c ? {} : c;
        a.S = void 0 === c.S ? !1 : c.S;
        b && (b = kb(b), a.i = b.buffer, a.m = b.C, a.l = 0, a.j = a.i.length, a.h = a.l);
    }
    lb.prototype.reset = function() {
        this.h = this.l;
    };
    function M(a, b) {
        a.h = b;
        if (b > a.j) throw Za(a.j, b);
    }
    function nb(a) {
        var b = a.i, c = a.h, d = b[c++], e = d & 127;
        if (d & 128 && (d = b[c++], e |= (d & 127) << 7, d & 128 && (d = b[c++], e |= (d & 127) << 14, d & 128 && (d = b[c++], e |= (d & 127) << 21, d & 128 && (d = b[c++], e |= d << 28, d & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128))))) throw Ya();
        M(a, c);
        return e;
    }
    function ob(a, b) {
        if (0 > b) throw Error("Tried to read a negative byte length: " + b);
        var c = a.h, d = c + b;
        if (d > a.j) throw Za(b, a.j - c);
        a.h = d;
        return c;
    }
    var pb = [];
    function qb() {
        this.h = [];
    }
    qb.prototype.length = function() {
        return this.h.length;
    };
    qb.prototype.end = function() {
        var a = this.h;
        this.h = [];
        return a;
    };
    function rb(a, b, c) {
        for(; 0 < c || 127 < b;)a.h.push(b & 127 | 128), b = (b >>> 7 | c << 25) >>> 0, c >>>= 7;
        a.h.push(b);
    }
    function N(a, b) {
        for(; 127 < b;)a.h.push(b & 127 | 128), b >>>= 7;
        a.h.push(b);
    }
    function sb(a, b) {
        if (pb.length) {
            var c = pb.pop();
            mb(c, a, b);
            a = c;
        } else a = new lb(a, b);
        this.h = a;
        this.j = this.h.h;
        this.i = this.l = -1;
        this.setOptions(b);
    }
    sb.prototype.setOptions = function(a) {
        a = void 0 === a ? {} : a;
        this.ca = void 0 === a.ca ? !1 : a.ca;
    };
    sb.prototype.reset = function() {
        this.h.reset();
        this.j = this.h.h;
        this.i = this.l = -1;
    };
    function tb(a) {
        var b = a.h;
        if (b.h == b.j) return !1;
        a.j = a.h.h;
        var c = nb(a.h) >>> 0;
        b = c >>> 3;
        c &= 7;
        if (!(0 <= c && 5 >= c)) throw Xa(c, a.j);
        if (1 > b) throw Error("Invalid field number: " + b + " (at position " + a.j + ")");
        a.l = b;
        a.i = c;
        return !0;
    }
    function ub(a) {
        switch(a.i){
            case 0:
                if (0 != a.i) ub(a);
                else a: {
                    a = a.h;
                    for(var b = a.h, c = b + 10, d = a.i; b < c;)if (0 === (d[b++] & 128)) {
                        M(a, b);
                        break a;
                    }
                    throw Ya();
                }
                break;
            case 1:
                a = a.h;
                M(a, a.h + 8);
                break;
            case 2:
                2 != a.i ? ub(a) : (b = nb(a.h) >>> 0, a = a.h, M(a, a.h + b));
                break;
            case 5:
                a = a.h;
                M(a, a.h + 4);
                break;
            case 3:
                b = a.l;
                do {
                    if (!tb(a)) throw Error("Unmatched start-group tag: stream EOF");
                    if (4 == a.i) {
                        if (a.l != b) throw Error("Unmatched end-group tag");
                        break;
                    }
                    ub(a);
                }while (1);
                break;
            default:
                throw Xa(a.i, a.j);
        }
    }
    var vb = [];
    function wb() {
        this.j = [];
        this.i = 0;
        this.h = new qb;
    }
    function O(a, b) {
        0 !== b.length && (a.j.push(b), a.i += b.length);
    }
    function xb(a, b) {
        if (b = b.R) {
            O(a, a.h.end());
            for(var c = 0; c < b.length; c++)O(a, jb(b[c]) || Oa());
        }
    }
    var P = "function" === typeof Symbol && "symbol" === typeof Symbol() ? Symbol() : void 0;
    function Q(a, b) {
        if (P) return a[P] |= b;
        if (void 0 !== a.A) return a.A |= b;
        Object.defineProperties(a, {
            A: {
                value: b,
                configurable: !0,
                writable: !0,
                enumerable: !1
            }
        });
        return b;
    }
    function yb(a, b) {
        P ? a[P] && (a[P] &= ~b) : void 0 !== a.A && (a.A &= ~b);
    }
    function R(a) {
        var b;
        P ? b = a[P] : b = a.A;
        return null == b ? 0 : b;
    }
    function S(a, b) {
        P ? a[P] = b : void 0 !== a.A ? a.A = b : Object.defineProperties(a, {
            A: {
                value: b,
                configurable: !0,
                writable: !0,
                enumerable: !1
            }
        });
    }
    function zb(a) {
        Q(a, 1);
        return a;
    }
    function Ab(a, b) {
        S(b, (a | 0) & -51);
    }
    function Bb(a, b) {
        S(b, (a | 18) & -41);
    }
    var Cb = {};
    function Db(a) {
        return null !== a && "object" === typeof a && !Array.isArray(a) && a.constructor === Object;
    }
    var Eb, Fb = [];
    S(Fb, 23);
    Eb = Object.freeze(Fb);
    function Gb(a) {
        if (R(a.o) & 2) throw Error("Cannot mutate an immutable Message");
    }
    function Hb(a) {
        var b = a.length;
        (b = b ? a[b - 1] : void 0) && Db(b) ? b.g = 1 : (b = {}, a.push((b.g = 1, b)));
    }
    function Ib(a) {
        var b = a.i + a.G;
        return a.B || (a.B = a.o[b] = {});
    }
    function T(a, b) {
        return -1 === b ? null : b >= a.i ? a.B ? a.B[b] : void 0 : a.o[b + a.G];
    }
    function V(a, b, c, d) {
        Gb(a);
        Jb(a, b, c, d);
    }
    function Jb(a, b, c, d) {
        a.j && (a.j = void 0);
        b >= a.i || d ? Ib(a)[b] = c : (a.o[b + a.G] = c, (a = a.B) && b in a && delete a[b]);
    }
    function Kb(a, b, c, d) {
        var e = T(a, b);
        Array.isArray(e) || (e = Eb);
        var g = R(e);
        g & 1 || zb(e);
        if (d) g & 2 || Q(e, 2), c & 1 || Object.freeze(e);
        else {
            d = !(c & 2);
            var f = g & 2;
            c & 1 || !f ? d && g & 16 && !f && yb(e, 16) : (e = zb(Array.prototype.slice.call(e)), Jb(a, b, e));
        }
        return e;
    }
    function Lb(a, b) {
        var c = T(a, b);
        var d = null == c ? c : "number" === typeof c || "NaN" === c || "Infinity" === c || "-Infinity" === c ? Number(c) : void 0;
        null != d && d !== c && Jb(a, b, d);
        return d;
    }
    function Mb(a, b, c, d, e) {
        a.h || (a.h = {});
        var g = a.h[c], f = Kb(a, c, 3, e);
        if (!g) {
            var h = f;
            g = [];
            var k = !!(R(a.o) & 16);
            f = !!(R(h) & 2);
            var l = h;
            !e && f && (h = Array.prototype.slice.call(h));
            for(var m = f, r = 0; r < h.length; r++){
                var p = h[r];
                var n = b, q = !1;
                q = void 0 === q ? !1 : q;
                p = Array.isArray(p) ? new n(p) : q ? new n : void 0;
                if (void 0 !== p) {
                    n = p.o;
                    var t = q = R(n);
                    f && (t |= 2);
                    k && (t |= 16);
                    t != q && S(n, t);
                    n = t;
                    m = m || !!(2 & n);
                    g.push(p);
                }
            }
            a.h[c] = g;
            k = R(h);
            b = k | 33;
            b = m ? b & -9 : b | 8;
            k != b && (m = h, Object.isFrozen(m) && (m = Array.prototype.slice.call(m)), S(m, b), h = m);
            l !== h && Jb(a, c, h);
            (e || d && f) && Q(g, 2);
            d && Object.freeze(g);
            return g;
        }
        e || (e = Object.isFrozen(g), d && !e ? Object.freeze(g) : !d && e && (g = Array.prototype.slice.call(g), a.h[c] = g));
        return g;
    }
    function Nb(a, b, c) {
        var d = !!(R(a.o) & 2);
        b = Mb(a, b, c, d, d);
        a = Kb(a, c, 3, d);
        if (!(d || R(a) & 8)) {
            for(d = 0; d < b.length; d++){
                c = b[d];
                if (R(c.o) & 2) {
                    var e = Ob(c, !1);
                    e.j = c;
                } else e = c;
                c !== e && (b[d] = e, a[d] = e.o);
            }
            Q(a, 8);
        }
        return b;
    }
    function W(a, b, c) {
        if (null != c && "number" !== typeof c) throw Error("Value of float/double field must be a number|null|undefined, found " + typeof c + ": " + c);
        V(a, b, c);
    }
    function Pb(a, b, c, d, e) {
        Gb(a);
        var g = Mb(a, c, b, !1, !1);
        c = null != d ? d : new c;
        a = Kb(a, b, 2, !1);
        void 0 != e ? (g.splice(e, 0, c), a.splice(e, 0, c.o)) : (g.push(c), a.push(c.o));
        c.C() && yb(a, 8);
        return c;
    }
    function Qb(a, b) {
        return null == a ? b : a;
    }
    function X(a, b, c) {
        c = void 0 === c ? 0 : c;
        return Qb(Lb(a, b), c);
    }
    var Rb;
    function Sb(a) {
        switch(typeof a){
            case "number":
                return isFinite(a) ? a : String(a);
            case "object":
                if (a) {
                    if (Array.isArray(a)) {
                        if (0 !== (R(a) & 128)) return a = Array.prototype.slice.call(a), Hb(a), a;
                    } else {
                        if (Ha && null != a && a instanceof Uint8Array) return Ja(a);
                        if (a instanceof hb) {
                            var b = a.V;
                            return null == b ? "" : "string" === typeof b ? b : a.V = Ja(b);
                        }
                    }
                }
        }
        return a;
    }
    function Tb(a, b, c, d) {
        if (null != a) {
            if (Array.isArray(a)) a = Ub(a, b, c, void 0 !== d);
            else if (Db(a)) {
                var e = {}, g;
                for(g in a)e[g] = Tb(a[g], b, c, d);
                a = e;
            } else a = b(a, d);
            return a;
        }
    }
    function Ub(a, b, c, d) {
        var e = R(a);
        d = d ? !!(e & 16) : void 0;
        a = Array.prototype.slice.call(a);
        for(var g = 0; g < a.length; g++)a[g] = Tb(a[g], b, c, d);
        c(e, a);
        return a;
    }
    function Vb(a) {
        return a.ja === Cb ? a.toJSON() : Sb(a);
    }
    function Wb(a, b) {
        a & 128 && Hb(b);
    }
    function Xb(a, b, c) {
        c = void 0 === c ? Bb : c;
        if (null != a) {
            if (Ha && a instanceof Uint8Array) return a.length ? new hb(new Uint8Array(a), Pa) : ib();
            if (Array.isArray(a)) {
                var d = R(a);
                if (d & 2) return a;
                if (b && !(d & 32) && (d & 16 || 0 === d)) return S(a, d | 2), a;
                a = Ub(a, Xb, d & 4 ? Bb : c, !0);
                b = R(a);
                b & 4 && b & 2 && Object.freeze(a);
                return a;
            }
            return a.ja === Cb ? Yb(a) : a;
        }
    }
    function Zb(a, b, c, d, e, g, f) {
        if (a = a.h && a.h[c]) {
            d = R(a);
            d & 2 ? d = a : (g = Ba(a, Yb), Bb(d, g), Object.freeze(g), d = g);
            Gb(b);
            f = null == d ? Eb : zb([]);
            if (null != d) {
                g = !!d.length;
                for(a = 0; a < d.length; a++){
                    var h = d[a];
                    g = g && !(R(h.o) & 2);
                    f[a] = h.o;
                }
                g = (g ? 8 : 0) | 1;
                a = R(f);
                (a & g) !== g && (Object.isFrozen(f) && (f = Array.prototype.slice.call(f)), S(f, a | g));
                b.h || (b.h = {});
                b.h[c] = d;
            } else b.h && (b.h[c] = void 0);
            Jb(b, c, f, e);
        } else V(b, c, Xb(d, g, f), e);
    }
    function Yb(a) {
        if (R(a.o) & 2) return a;
        a = Ob(a, !0);
        Q(a.o, 2);
        return a;
    }
    function Ob(a, b) {
        var c = a.o, d = [];
        Q(d, 16);
        var e = a.constructor.h;
        e && d.push(e);
        e = a.B;
        if (e) {
            d.length = c.length;
            d.fill(void 0, d.length, c.length);
            var g = {};
            d[d.length - 1] = g;
        }
        0 !== (R(c) & 128) && Hb(d);
        b = b || a.C() ? Bb : Ab;
        g = a.constructor;
        Rb = d;
        d = new g(d);
        Rb = void 0;
        a.R && (d.R = a.R.slice());
        g = !!(R(c) & 16);
        for(var f = e ? c.length - 1 : c.length, h = 0; h < f; h++)Zb(a, d, h - a.G, c[h], !1, g, b);
        if (e) for(var k in e)Zb(a, d, +k, e[k], !0, g, b);
        return d;
    }
    function Y(a, b, c) {
        null == a && (a = Rb);
        Rb = void 0;
        var d = this.constructor.i || 0, e = 0 < d, g = this.constructor.h, f = !1;
        if (null == a) {
            a = g ? [
                g
            ] : [];
            var h = 48;
            var k = !0;
            e && (d = 0, h |= 128);
            S(a, h);
        } else {
            if (!Array.isArray(a)) throw Error();
            if (g && g !== a[0]) throw Error();
            var l = h = Q(a, 0);
            if (k = 0 !== (16 & l)) (f = 0 !== (32 & l)) || (l |= 32);
            if (e) {
                if (128 & l) d = 0;
                else if (0 < a.length) {
                    var m = a[a.length - 1];
                    if (Db(m) && "g" in m) {
                        d = 0;
                        l |= 128;
                        delete m.g;
                        var r = !0, p;
                        for(p in m){
                            r = !1;
                            break;
                        }
                        r && a.pop();
                    }
                }
            } else if (128 & l) throw Error();
            h !== l && S(a, l);
        }
        this.G = (g ? 0 : -1) - d;
        this.h = void 0;
        this.o = a;
        a: {
            g = this.o.length;
            d = g - 1;
            if (g && (g = this.o[d], Db(g))) {
                this.B = g;
                this.i = d - this.G;
                break a;
            }
            void 0 !== b && -1 < b ? (this.i = Math.max(b, d + 1 - this.G), this.B = void 0) : this.i = Number.MAX_VALUE;
        }
        if (!e && this.B && "g" in this.B) throw Error('Unexpected "g" flag in sparse object of message that is not a group type.');
        if (c) {
            b = k && !f && !0;
            e = this.i;
            var n;
            for(k = 0; k < c.length; k++)f = c[k], f < e ? (f += this.G, (d = a[f]) ? $b(d, b) : a[f] = Eb) : (n || (n = Ib(this)), (d = n[f]) ? $b(d, b) : n[f] = Eb);
        }
    }
    Y.prototype.toJSON = function() {
        return Ub(this.o, Vb, Wb);
    };
    Y.prototype.C = function() {
        return !!(R(this.o) & 2);
    };
    function $b(a, b) {
        if (Array.isArray(a)) {
            var c = R(a), d = 1;
            !b || c & 2 || (d |= 16);
            (c & d) !== d && S(a, c | d);
        }
    }
    Y.prototype.ja = Cb;
    Y.prototype.toString = function() {
        return this.o.toString();
    };
    function ac(a, b, c) {
        if (c) {
            var d = {}, e;
            for(e in c){
                var g = c[e], f = g.ra;
                f || (d.J = g.xa || g.oa.W, g.ia ? (d.aa = bc(g.ia), f = function(h) {
                    return function(k, l, m) {
                        return h.J(k, l, m, h.aa);
                    };
                }(d)) : g.ka ? (d.Z = cc(g.da.P, g.ka), f = function(h) {
                    return function(k, l, m) {
                        return h.J(k, l, m, h.Z);
                    };
                }(d)) : f = d.J, g.ra = f);
                f(b, a, g.da);
                d = {
                    J: d.J,
                    aa: d.aa,
                    Z: d.Z
                };
            }
        }
        xb(b, a);
    }
    var dc = Symbol();
    function ec(a, b, c) {
        return a[dc] || (a[dc] = function(d, e) {
            return b(d, e, c);
        });
    }
    function fc(a) {
        var b = a[dc];
        if (!b) {
            var c = gc(a);
            b = function(d, e) {
                return hc(d, e, c);
            };
            a[dc] = b;
        }
        return b;
    }
    function ic(a) {
        var b = a.ia;
        if (b) return fc(b);
        if (b = a.wa) return ec(a.da.P, b, a.ka);
    }
    function jc(a) {
        var b = ic(a), c = a.da, d = a.oa.U;
        return b ? function(e, g) {
            return d(e, g, c, b);
        } : function(e, g) {
            return d(e, g, c);
        };
    }
    function kc(a, b) {
        var c = a[b];
        "function" == typeof c && 0 === c.length && (c = c(), a[b] = c);
        return Array.isArray(c) && (lc in c || mc in c || 0 < c.length && "function" == typeof c[0]) ? c : void 0;
    }
    function nc(a, b, c, d, e, g) {
        b.P = a[0];
        var f = 1;
        if (a.length > f && "number" !== typeof a[f]) {
            var h = a[f++];
            c(b, h);
        }
        for(; f < a.length;){
            c = a[f++];
            for(var k = f + 1; k < a.length && "number" !== typeof a[k];)k++;
            h = a[f++];
            k -= f;
            switch(k){
                case 0:
                    d(b, c, h);
                    break;
                case 1:
                    (k = kc(a, f)) ? (f++, e(b, c, h, k)) : d(b, c, h, a[f++]);
                    break;
                case 2:
                    k = f++;
                    k = kc(a, k);
                    e(b, c, h, k, a[f++]);
                    break;
                case 3:
                    g(b, c, h, a[f++], a[f++], a[f++]);
                    break;
                case 4:
                    g(b, c, h, a[f++], a[f++], a[f++], a[f++]);
                    break;
                default:
                    throw Error("unexpected number of binary field arguments: " + k);
            }
        }
        return b;
    }
    var oc = Symbol();
    function bc(a) {
        var b = a[oc];
        if (!b) {
            var c = pc(a);
            b = function(d, e) {
                return qc(d, e, c);
            };
            a[oc] = b;
        }
        return b;
    }
    function cc(a, b) {
        var c = a[oc];
        c || (c = function(d, e) {
            return ac(d, e, b);
        }, a[oc] = c);
        return c;
    }
    var mc = Symbol();
    function rc(a, b) {
        a.push(b);
    }
    function sc(a, b, c) {
        a.push(b, c.W);
    }
    function tc(a, b, c, d) {
        var e = bc(d), g = pc(d).P, f = c.W;
        a.push(b, function(h, k, l) {
            return f(h, k, l, g, e);
        });
    }
    function uc(a, b, c, d, e, g) {
        var f = cc(d, g), h = c.W;
        a.push(b, function(k, l, m) {
            return h(k, l, m, d, f);
        });
    }
    function pc(a) {
        var b = a[mc];
        if (b) return b;
        b = nc(a, a[mc] = [], rc, sc, tc, uc);
        lc in a && mc in a && (a.length = 0);
        return b;
    }
    var lc = Symbol();
    function vc(a, b) {
        a[0] = b;
    }
    function wc(a, b, c, d) {
        var e = c.U;
        a[b] = d ? function(g, f, h) {
            return e(g, f, h, d);
        } : e;
    }
    function xc(a, b, c, d, e) {
        var g = c.U, f = fc(d), h = gc(d).P;
        a[b] = function(k, l, m) {
            return g(k, l, m, h, f, e);
        };
    }
    function yc(a, b, c, d, e, g, f) {
        var h = c.U, k = ec(d, e, g);
        a[b] = function(l, m, r) {
            return h(l, m, r, d, k, f);
        };
    }
    function gc(a) {
        var b = a[lc];
        if (b) return b;
        b = nc(a, a[lc] = {}, vc, wc, xc, yc);
        lc in a && mc in a && (a.length = 0);
        return b;
    }
    function hc(a, b, c) {
        for(; tb(b) && 4 != b.i;){
            var d = b.l, e = c[d];
            if (!e) {
                var g = c[0];
                g && (g = g[d]) && (e = c[d] = jc(g));
            }
            if (!e || !e(b, a, d)) {
                e = b;
                d = a;
                g = e.j;
                ub(e);
                var f = e;
                if (!f.ca) {
                    e = f.h.h - g;
                    f.h.h = g;
                    f = f.h;
                    if (0 == e) e = ib();
                    else {
                        g = ob(f, e);
                        if (f.S && f.m) e = f.i.subarray(g, g + e);
                        else {
                            f = f.i;
                            var h = g;
                            e = g + e;
                            e = h === e ? Oa() : Qa ? f.slice(h, e) : new Uint8Array(f.subarray(h, e));
                        }
                        e = 0 == e.length ? ib() : new hb(e, Pa);
                    }
                    (g = d.R) ? g.push(e) : d.R = [
                        e
                    ];
                }
            }
        }
        return a;
    }
    function qc(a, b, c) {
        for(var d = c.length, e = 1 == d % 2, g = e ? 1 : 0; g < d; g += 2)(0, c[g + 1])(b, a, c[g]);
        ac(a, b, e ? c[0] : void 0);
    }
    function zc(a, b) {
        return {
            U: a,
            W: b
        };
    }
    var Z = zc(function(a, b, c) {
        if (5 !== a.i) return !1;
        a = a.h;
        var d = a.i, e = a.h, g = d[e];
        var f = d[e + 1];
        var h = d[e + 2];
        d = d[e + 3];
        M(a, a.h + 4);
        f = (g << 0 | f << 8 | h << 16 | d << 24) >>> 0;
        a = 2 * (f >> 31) + 1;
        g = f >>> 23 & 255;
        f &= 8388607;
        V(b, c, 255 == g ? f ? NaN : Infinity * a : 0 == g ? a * Math.pow(2, -149) * f : a * Math.pow(2, g - 150) * (f + Math.pow(2, 23)));
        return !0;
    }, function(a, b, c) {
        b = Lb(b, c);
        if (null != b) {
            N(a.h, 8 * c + 5);
            a = a.h;
            var d = +b;
            0 === d ? 0 < 1 / d ? H = K = 0 : (K = 0, H = 2147483648) : isNaN(d) ? (K = 0, H = 2147483647) : (d = (c = 0 > d ? -2147483648 : 0) ? -d : d, 3.4028234663852886E38 < d ? (K = 0, H = (c | 2139095040) >>> 0) : 1.1754943508222875E-38 > d ? (d = Math.round(d / Math.pow(2, -149)), K = 0, H = (c | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, K = 0, H = (c | b + 127 << 23 | d & 8388607) >>> 0));
            c = H;
            a.h.push(c >>> 0 & 255);
            a.h.push(c >>> 8 & 255);
            a.h.push(c >>> 16 & 255);
            a.h.push(c >>> 24 & 255);
        }
    }), Ac = zc(function(a, b, c) {
        if (0 !== a.i) return !1;
        var d = a.h, e = 0, g = a = 0, f = d.i, h = d.h;
        do {
            var k = f[h++];
            e |= (k & 127) << g;
            g += 7;
        }while (32 > g && k & 128);
        32 < g && (a |= (k & 127) >> 4);
        for(g = 3; 32 > g && k & 128; g += 7)k = f[h++], a |= (k & 127) << g;
        M(d, h);
        if (128 > k) {
            d = e >>> 0;
            k = a >>> 0;
            if (a = k & 2147483648) d = ~d + 1 >>> 0, k = ~k >>> 0, 0 == d && (k = k + 1 >>> 0);
            d = 4294967296 * k + (d >>> 0);
        } else throw Ya();
        V(b, c, a ? -d : d);
        return !0;
    }, function(a, b, c) {
        b = T(b, c);
        null != b && ("string" === typeof b && Va(b), null != b && (N(a.h, 8 * c), "number" === typeof b ? (a = a.h, Ra(b), rb(a, H, K)) : (c = Va(b), rb(a.h, c.i, c.h))));
    }), Bc = zc(function(a, b, c) {
        if (0 !== a.i) return !1;
        V(b, c, nb(a.h));
        return !0;
    }, function(a, b, c) {
        b = T(b, c);
        if (null != b && null != b) {
            if (N(a.h, 8 * c), a = a.h, c = b, 0 <= c) N(a, c);
            else {
                for(b = 0; 9 > b; b++)a.h.push(c & 127 | 128), c >>= 7;
                a.h.push(1);
            }
        }
    }), Cc = zc(function(a, b, c) {
        if (2 !== a.i) return !1;
        var d = nb(a.h) >>> 0;
        a = a.h;
        var e = ob(a, d);
        a = a.i;
        if (cb) {
            var g = a, f;
            (f = bb) || (f = bb = new TextDecoder("utf-8", {
                fatal: !0
            }));
            a = e + d;
            g = 0 === e && a === g.length ? g : g.subarray(e, a);
            try {
                var h = f.decode(g);
            } catch (r) {
                if (void 0 === ab) {
                    try {
                        f.decode(new Uint8Array([
                            128
                        ]));
                    } catch (p) {}
                    try {
                        f.decode(new Uint8Array([
                            97
                        ])), ab = !0;
                    } catch (p) {
                        ab = !1;
                    }
                }
                !ab && (bb = void 0);
                throw r;
            }
        } else {
            h = e;
            d = h + d;
            e = [];
            for(var k = null, l, m; h < d;)l = a[h++], 128 > l ? e.push(l) : 224 > l ? h >= d ? L() : (m = a[h++], 194 > l || 128 !== (m & 192) ? (h--, L()) : e.push((l & 31) << 6 | m & 63)) : 240 > l ? h >= d - 1 ? L() : (m = a[h++], 128 !== (m & 192) || 224 === l && 160 > m || 237 === l && 160 <= m || 128 !== ((g = a[h++]) & 192) ? (h--, L()) : e.push((l & 15) << 12 | (m & 63) << 6 | g & 63)) : 244 >= l ? h >= d - 2 ? L() : (m = a[h++], 128 !== (m & 192) || 0 !== (l << 28) + (m - 144) >> 30 || 128 !== ((g = a[h++]) & 192) || 128 !== ((f = a[h++]) & 192) ? (h--, L()) : (l = (l & 7) << 18 | (m & 63) << 12 | (g & 63) << 6 | f & 63, l -= 65536, e.push((l >> 10 & 1023) + 55296, (l & 1023) + 56320))) : L(), 8192 <= e.length && (k = $a(k, e), e.length = 0);
            h = $a(k, e);
        }
        V(b, c, h);
        return !0;
    }, function(a, b, c) {
        b = T(b, c);
        if (null != b) {
            var d = !1;
            d = void 0 === d ? !1 : d;
            if (eb) {
                if (d && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(b)) throw Error("Found an unpaired surrogate");
                b = (db || (db = new TextEncoder)).encode(b);
            } else {
                for(var e = 0, g = new Uint8Array(3 * b.length), f = 0; f < b.length; f++){
                    var h = b.charCodeAt(f);
                    if (128 > h) g[e++] = h;
                    else {
                        if (2048 > h) g[e++] = h >> 6 | 192;
                        else {
                            if (55296 <= h && 57343 >= h) {
                                if (56319 >= h && f < b.length) {
                                    var k = b.charCodeAt(++f);
                                    if (56320 <= k && 57343 >= k) {
                                        h = 1024 * (h - 55296) + k - 56320 + 65536;
                                        g[e++] = h >> 18 | 240;
                                        g[e++] = h >> 12 & 63 | 128;
                                        g[e++] = h >> 6 & 63 | 128;
                                        g[e++] = h & 63 | 128;
                                        continue;
                                    } else f--;
                                }
                                if (d) throw Error("Found an unpaired surrogate");
                                h = 65533;
                            }
                            g[e++] = h >> 12 | 224;
                            g[e++] = h >> 6 & 63 | 128;
                        }
                        g[e++] = h & 63 | 128;
                    }
                }
                b = e === g.length ? g : g.subarray(0, e);
            }
            N(a.h, 8 * c + 2);
            N(a.h, b.length);
            O(a, a.h.end());
            O(a, b);
        }
    }), Dc = zc(function(a, b, c, d, e) {
        if (2 !== a.i) return !1;
        b = Pb(b, c, d);
        c = a.h.j;
        d = nb(a.h) >>> 0;
        var g = a.h.h + d, f = g - c;
        0 >= f && (a.h.j = g, e(b, a, void 0, void 0, void 0), f = g - a.h.h);
        if (f) throw Error("Message parsing ended unexpectedly. Expected to read " + (d + " bytes, instead read " + (d - f) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
        a.h.h = g;
        a.h.j = c;
        return !0;
    }, function(a, b, c, d, e) {
        b = Nb(b, d, c);
        if (null != b) for(d = 0; d < b.length; d++){
            var g = a;
            N(g.h, 8 * c + 2);
            var f = g.h.end();
            O(g, f);
            f.push(g.i);
            g = f;
            e(b[d], a);
            f = a;
            var h = g.pop();
            for(h = f.i + f.h.length() - h; 127 < h;)g.push(h & 127 | 128), h >>>= 7, f.i++;
            g.push(h);
            f.i++;
        }
    });
    function Ec(a) {
        return function(b, c) {
            a: {
                if (vb.length) {
                    var d = vb.pop();
                    d.setOptions(c);
                    mb(d.h, b, c);
                    b = d;
                } else b = new sb(b, c);
                try {
                    var e = gc(a);
                    var g = hc(new e.P, b, e);
                    break a;
                } finally{
                    e = b.h, e.i = null, e.m = !1, e.l = 0, e.j = 0, e.h = 0, e.S = !1, b.l = -1, b.i = -1, 100 > vb.length && vb.push(b);
                }
                g = void 0;
            }
            return g;
        };
    }
    function Fc(a) {
        return function() {
            var b = new wb;
            qc(this, b, pc(a));
            O(b, b.h.end());
            for(var c = new Uint8Array(b.i), d = b.j, e = d.length, g = 0, f = 0; f < e; f++){
                var h = d[f];
                c.set(h, g);
                g += h.length;
            }
            b.j = [
                c
            ];
            return c;
        };
    }
    function Gc(a) {
        Y.call(this, a);
    }
    na(Gc, Y);
    var Hc = [
        Gc,
        1,
        Bc,
        2,
        Z,
        3,
        Cc,
        4,
        Cc
    ];
    Gc.prototype.l = Fc(Hc);
    function Ic(a) {
        Y.call(this, a, -1, Jc);
    }
    na(Ic, Y);
    Ic.prototype.addClassification = function(a, b) {
        Pb(this, 1, Gc, a, b);
        return this;
    };
    var Jc = [
        1
    ], Kc = Ec([
        Ic,
        1,
        Dc,
        Hc
    ]);
    function Lc(a) {
        Y.call(this, a);
    }
    na(Lc, Y);
    var Mc = [
        Lc,
        1,
        Z,
        2,
        Z,
        3,
        Z,
        4,
        Z,
        5,
        Z
    ];
    Lc.prototype.l = Fc(Mc);
    function Nc(a) {
        Y.call(this, a, -1, Oc);
    }
    na(Nc, Y);
    var Oc = [
        1
    ], Pc = Ec([
        Nc,
        1,
        Dc,
        Mc
    ]);
    function Qc(a) {
        Y.call(this, a);
    }
    na(Qc, Y);
    var Rc = [
        Qc,
        1,
        Z,
        2,
        Z,
        3,
        Z,
        4,
        Z,
        5,
        Z,
        6,
        Ac
    ], Sc = Ec(Rc);
    Qc.prototype.l = Fc(Rc);
    function Tc(a, b, c) {
        c = a.createShader(0 === c ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
        a.shaderSource(c, b);
        a.compileShader(c);
        if (!a.getShaderParameter(c, a.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
        return c;
    }
    function Uc(a) {
        return Nb(a, Gc, 1).map(function(b) {
            var c = T(b, 1);
            return {
                index: null == c ? 0 : c,
                qa: X(b, 2),
                label: null != T(b, 3) ? Qb(T(b, 3), "") : void 0,
                displayName: null != T(b, 4) ? Qb(T(b, 4), "") : void 0
            };
        });
    }
    function Vc(a) {
        return {
            x: X(a, 1),
            y: X(a, 2),
            z: X(a, 3),
            visibility: null != Lb(a, 4) ? X(a, 4) : void 0
        };
    }
    function Wc(a) {
        return Nb(Pc(a), Lc, 1).map(Vc);
    }
    function Xc(a, b) {
        this.i = a;
        this.h = b;
        this.m = 0;
    }
    function Yc(a, b, c) {
        Zc(a, b);
        if ("function" === typeof a.h.canvas.transferToImageBitmap) return Promise.resolve(a.h.canvas.transferToImageBitmap());
        if (c) return Promise.resolve(a.h.canvas);
        if ("function" === typeof createImageBitmap) return createImageBitmap(a.h.canvas);
        void 0 === a.j && (a.j = document.createElement("canvas"));
        return new Promise(function(d) {
            a.j.height = a.h.canvas.height;
            a.j.width = a.h.canvas.width;
            a.j.getContext("2d", {}).drawImage(a.h.canvas, 0, 0, a.h.canvas.width, a.h.canvas.height);
            d(a.j);
        });
    }
    function Zc(a, b) {
        var c = a.h;
        if (void 0 === a.s) {
            var d = Tc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = Tc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
            c.attachShader(g, d);
            c.attachShader(g, e);
            c.linkProgram(g);
            if (!c.getProgramParameter(g, c.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
            d = a.s = g;
            c.useProgram(d);
            e = c.getUniformLocation(d, "sampler0");
            a.l = {
                O: c.getAttribLocation(d, "aVertex"),
                N: c.getAttribLocation(d, "aTex"),
                ya: e
            };
            a.v = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, a.v);
            c.enableVertexAttribArray(a.l.O);
            c.vertexAttribPointer(a.l.O, 2, c.FLOAT, !1, 0, 0);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                -1,
                -1,
                -1,
                1,
                1,
                1,
                1,
                -1
            ]), c.STATIC_DRAW);
            c.bindBuffer(c.ARRAY_BUFFER, null);
            a.u = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, a.u);
            c.enableVertexAttribArray(a.l.N);
            c.vertexAttribPointer(a.l.N, 2, c.FLOAT, !1, 0, 0);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                0,
                1,
                0,
                0,
                1,
                0,
                1,
                1
            ]), c.STATIC_DRAW);
            c.bindBuffer(c.ARRAY_BUFFER, null);
            c.uniform1i(e, 0);
        }
        d = a.l;
        c.useProgram(a.s);
        c.canvas.width = b.width;
        c.canvas.height = b.height;
        c.viewport(0, 0, b.width, b.height);
        c.activeTexture(c.TEXTURE0);
        a.i.bindTexture2d(b.glName);
        c.enableVertexAttribArray(d.O);
        c.bindBuffer(c.ARRAY_BUFFER, a.v);
        c.vertexAttribPointer(d.O, 2, c.FLOAT, !1, 0, 0);
        c.enableVertexAttribArray(d.N);
        c.bindBuffer(c.ARRAY_BUFFER, a.u);
        c.vertexAttribPointer(d.N, 2, c.FLOAT, !1, 0, 0);
        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
        c.clearColor(0, 0, 0, 0);
        c.clear(c.COLOR_BUFFER_BIT);
        c.colorMask(!0, !0, !0, !0);
        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
        c.disableVertexAttribArray(d.O);
        c.disableVertexAttribArray(d.N);
        c.bindBuffer(c.ARRAY_BUFFER, null);
        a.i.bindTexture2d(0);
    }
    function $c(a) {
        this.h = a;
    }
    var ad = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        2,
        1,
        0,
        10,
        9,
        1,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]);
    function bd(a, b) {
        return b + a;
    }
    function cd(a, b) {
        window[a] = b;
    }
    function dd(a) {
        var b = document.createElement("script");
        b.setAttribute("src", a);
        b.setAttribute("crossorigin", "anonymous");
        return new Promise(function(c) {
            b.addEventListener("load", function() {
                c();
            }, !1);
            b.addEventListener("error", function() {
                c();
            }, !1);
            document.body.appendChild(b);
        });
    }
    function ed() {
        return E(function(a) {
            switch(a.h){
                case 1:
                    return a.s = 2, D(a, WebAssembly.instantiate(ad), 4);
                case 4:
                    a.h = 3;
                    a.s = 0;
                    break;
                case 2:
                    return a.s = 0, a.l = null, a.return(!1);
                case 3:
                    return a.return(!0);
            }
        });
    }
    function fd(a) {
        this.h = a;
        this.listeners = {};
        this.l = {};
        this.L = {};
        this.s = {};
        this.v = {};
        this.M = this.u = this.ga = !0;
        this.I = Promise.resolve();
        this.fa = "";
        this.D = {};
        this.locateFile = a && a.locateFile || bd;
        if ("object" === typeof window) var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
        else if ("undefined" !== typeof location) b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
        else throw Error("solutions can only be loaded on a web page or in a web worker");
        this.ha = b;
        if (a.options) {
            b = A(Object.keys(a.options));
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = a.options[c].default;
                void 0 !== d && (this.l[c] = "function" === typeof d ? d() : d);
            }
        }
    }
    x = fd.prototype;
    x.close = function() {
        this.j && this.j.delete();
        return Promise.resolve();
    };
    function gd(a) {
        var b, c, d, e, g, f, h, k, l, m, r;
        return E(function(p) {
            switch(p.h){
                case 1:
                    if (!a.ga) return p.return();
                    b = void 0 === a.h.files ? [] : "function" === typeof a.h.files ? a.h.files(a.l) : a.h.files;
                    return D(p, ed(), 2);
                case 2:
                    c = p.i;
                    if ("object" === typeof window) return cd("createMediapipeSolutionsWasm", {
                        locateFile: a.locateFile
                    }), cd("createMediapipeSolutionsPackedAssets", {
                        locateFile: a.locateFile
                    }), f = b.filter(function(n) {
                        return void 0 !== n.data;
                    }), h = b.filter(function(n) {
                        return void 0 === n.data;
                    }), k = Promise.all(f.map(function(n) {
                        var q = hd(a, n.url);
                        if (void 0 !== n.path) {
                            var t = n.path;
                            q = q.then(function(w) {
                                a.overrideFile(t, w);
                                return Promise.resolve(w);
                            });
                        }
                        return q;
                    })), l = Promise.all(h.map(function(n) {
                        return void 0 === n.simd || n.simd && c || !n.simd && !c ? dd(a.locateFile(n.url, a.ha)) : Promise.resolve();
                    })).then(function() {
                        var n, q, t;
                        return E(function(w) {
                            if (1 == w.h) return n = window.createMediapipeSolutionsWasm, q = window.createMediapipeSolutionsPackedAssets, t = a, D(w, n(q), 2);
                            t.i = w.i;
                            w.h = 0;
                        });
                    }), m = function() {
                        return E(function(n) {
                            a.h.graph && a.h.graph.url ? n = D(n, hd(a, a.h.graph.url), 0) : (n.h = 0, n = void 0);
                            return n;
                        });
                    }(), D(p, Promise.all([
                        l,
                        k,
                        m
                    ]), 7);
                    if ("function" !== typeof importScripts) throw Error("solutions can only be loaded on a web page or in a web worker");
                    d = b.filter(function(n) {
                        return void 0 === n.simd || n.simd && c || !n.simd && !c;
                    }).map(function(n) {
                        return a.locateFile(n.url, a.ha);
                    });
                    importScripts.apply(null, ea(d));
                    e = a;
                    return D(p, createMediapipeSolutionsWasm(Module), 6);
                case 6:
                    e.i = p.i;
                    a.m = new OffscreenCanvas(1, 1);
                    a.i.canvas = a.m;
                    g = a.i.GL.createContext(a.m, {
                        antialias: !1,
                        alpha: !1,
                        va: "undefined" !== typeof WebGL2RenderingContext ? 2 : 1
                    });
                    a.i.GL.makeContextCurrent(g);
                    p.h = 4;
                    break;
                case 7:
                    a.m = document.createElement("canvas");
                    r = a.m.getContext("webgl2", {});
                    if (!r && (r = a.m.getContext("webgl", {}), !r)) return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
                    a.K = r;
                    a.i.canvas = a.m;
                    a.i.createContext(a.m, !0, !0, {});
                case 4:
                    a.j = new a.i.SolutionWasm, a.ga = !1, p.h = 0;
            }
        });
    }
    function id(a) {
        var b, c, d, e, g, f, h, k;
        return E(function(l) {
            if (1 == l.h) {
                if (a.h.graph && a.h.graph.url && a.fa === a.h.graph.url) return l.return();
                a.u = !0;
                if (!a.h.graph || !a.h.graph.url) {
                    l.h = 2;
                    return;
                }
                a.fa = a.h.graph.url;
                return D(l, hd(a, a.h.graph.url), 3);
            }
            2 != l.h && (b = l.i, a.j.loadGraph(b));
            c = A(Object.keys(a.D));
            for(d = c.next(); !d.done; d = c.next())e = d.value, a.j.overrideFile(e, a.D[e]);
            a.D = {};
            if (a.h.listeners) for(g = A(a.h.listeners), f = g.next(); !f.done; f = g.next())h = f.value, jd(a, h);
            k = a.l;
            a.l = {};
            a.setOptions(k);
            l.h = 0;
        });
    }
    x.reset = function() {
        var a = this;
        return E(function(b) {
            a.j && (a.j.reset(), a.s = {}, a.v = {});
            b.h = 0;
        });
    };
    x.setOptions = function(a, b) {
        var c = this;
        if (b = b || this.h.options) {
            for(var d = [], e = [], g = {}, f = A(Object.keys(a)), h = f.next(); !h.done; g = {
                X: g.X,
                Y: g.Y
            }, h = f.next())if (h = h.value, !(h in this.l && this.l[h] === a[h])) {
                this.l[h] = a[h];
                var k = b[h];
                void 0 !== k && (k.onChange && (g.X = k.onChange, g.Y = a[h], d.push(function(l) {
                    return function() {
                        var m;
                        return E(function(r) {
                            if (1 == r.h) return D(r, l.X(l.Y), 2);
                            m = r.i;
                            !0 === m && (c.u = !0);
                            r.h = 0;
                        });
                    };
                }(g))), k.graphOptionXref && (h = Object.assign({}, {
                    calculatorName: "",
                    calculatorIndex: 0
                }, k.graphOptionXref, {
                    valueNumber: 1 === k.type ? a[h] : 0,
                    valueBoolean: 0 === k.type ? a[h] : !1,
                    valueString: 2 === k.type ? a[h] : ""
                }), e.push(h)));
            }
            if (0 !== d.length || 0 !== e.length) this.u = !0, this.H = (void 0 === this.H ? [] : this.H).concat(e), this.F = (void 0 === this.F ? [] : this.F).concat(d);
        }
    };
    function kd(a) {
        var b, c, d, e, g, f, h;
        return E(function(k) {
            switch(k.h){
                case 1:
                    if (!a.u) return k.return();
                    if (!a.F) {
                        k.h = 2;
                        break;
                    }
                    b = A(a.F);
                    c = b.next();
                case 3:
                    if (c.done) {
                        k.h = 5;
                        break;
                    }
                    d = c.value;
                    return D(k, d(), 4);
                case 4:
                    c = b.next();
                    k.h = 3;
                    break;
                case 5:
                    a.F = void 0;
                case 2:
                    if (a.H) {
                        e = new a.i.GraphOptionChangeRequestList;
                        g = A(a.H);
                        for(f = g.next(); !f.done; f = g.next())h = f.value, e.push_back(h);
                        a.j.changeOptions(e);
                        e.delete();
                        a.H = void 0;
                    }
                    a.u = !1;
                    k.h = 0;
            }
        });
    }
    x.initialize = function() {
        var a = this;
        return E(function(b) {
            return 1 == b.h ? D(b, gd(a), 2) : 3 != b.h ? D(b, id(a), 3) : D(b, kd(a), 0);
        });
    };
    function hd(a, b) {
        var c, d;
        return E(function(e) {
            if (b in a.L) return e.return(a.L[b]);
            c = a.locateFile(b, "");
            d = fetch(c).then(function(g) {
                return g.arrayBuffer();
            });
            a.L[b] = d;
            return e.return(d);
        });
    }
    x.overrideFile = function(a, b) {
        this.j ? this.j.overrideFile(a, b) : this.D[a] = b;
    };
    x.clearOverriddenFiles = function() {
        this.D = {};
        this.j && this.j.clearOverriddenFiles();
    };
    x.send = function(a, b) {
        var c = this, d, e, g, f, h, k, l, m, r;
        return E(function(p) {
            switch(p.h){
                case 1:
                    if (!c.h.inputs) return p.return();
                    d = 1E3 * (void 0 === b || null === b ? performance.now() : b);
                    return D(p, c.I, 2);
                case 2:
                    return D(p, c.initialize(), 3);
                case 3:
                    e = new c.i.PacketDataList;
                    g = A(Object.keys(a));
                    for(f = g.next(); !f.done; f = g.next())if (h = f.value, k = c.h.inputs[h]) {
                        a: {
                            var n = a[h];
                            switch(k.type){
                                case "video":
                                    var q = c.s[k.stream];
                                    q || (q = new Xc(c.i, c.K), c.s[k.stream] = q);
                                    0 === q.m && (q.m = q.i.createTexture());
                                    if ("undefined" !== typeof HTMLVideoElement && n instanceof HTMLVideoElement) {
                                        var t = n.videoWidth;
                                        var w = n.videoHeight;
                                    } else "undefined" !== typeof HTMLImageElement && n instanceof HTMLImageElement ? (t = n.naturalWidth, w = n.naturalHeight) : (t = n.width, w = n.height);
                                    w = {
                                        glName: q.m,
                                        width: t,
                                        height: w
                                    };
                                    t = q.h;
                                    t.canvas.width = w.width;
                                    t.canvas.height = w.height;
                                    t.activeTexture(t.TEXTURE0);
                                    q.i.bindTexture2d(q.m);
                                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n);
                                    q.i.bindTexture2d(0);
                                    q = w;
                                    break a;
                                case "detections":
                                    q = c.s[k.stream];
                                    q || (q = new $c(c.i), c.s[k.stream] = q);
                                    q.data || (q.data = new q.h.DetectionListData);
                                    q.data.reset(n.length);
                                    for(w = 0; w < n.length; ++w){
                                        t = n[w];
                                        var v = q.data, B = v.setBoundingBox, J = w;
                                        var I = t.la;
                                        var u = new Qc;
                                        W(u, 1, I.sa);
                                        W(u, 2, I.ta);
                                        W(u, 3, I.height);
                                        W(u, 4, I.width);
                                        W(u, 5, I.rotation);
                                        V(u, 6, I.pa);
                                        I = u.l();
                                        B.call(v, J, I);
                                        if (t.ea) for(v = 0; v < t.ea.length; ++v){
                                            u = t.ea[v];
                                            B = q.data;
                                            J = B.addNormalizedLandmark;
                                            I = w;
                                            u = Object.assign({}, u, {
                                                visibility: u.visibility ? u.visibility : 0
                                            });
                                            var C = new Lc;
                                            W(C, 1, u.x);
                                            W(C, 2, u.y);
                                            W(C, 3, u.z);
                                            u.visibility && W(C, 4, u.visibility);
                                            u = C.l();
                                            J.call(B, I, u);
                                        }
                                        if (t.ba) for(v = 0; v < t.ba.length; ++v)B = q.data, J = B.addClassification, I = w, u = t.ba[v], C = new Gc, W(C, 2, u.qa), u.index && V(C, 1, u.index), u.label && V(C, 3, u.label), u.displayName && V(C, 4, u.displayName), u = C.l(), J.call(B, I, u);
                                    }
                                    q = q.data;
                                    break a;
                                default:
                                    q = {};
                            }
                        }
                        l = q;
                        m = k.stream;
                        switch(k.type){
                            case "video":
                                e.pushTexture2d(Object.assign({}, l, {
                                    stream: m,
                                    timestamp: d
                                }));
                                break;
                            case "detections":
                                r = l;
                                r.stream = m;
                                r.timestamp = d;
                                e.pushDetectionList(r);
                                break;
                            default:
                                throw Error("Unknown input config type: '" + k.type + "'");
                        }
                    }
                    c.j.send(e);
                    return D(p, c.I, 4);
                case 4:
                    e.delete(), p.h = 0;
            }
        });
    };
    function ld(a, b, c) {
        var d, e, g, f, h, k, l, m, r, p, n, q, t, w;
        return E(function(v) {
            switch(v.h){
                case 1:
                    if (!c) return v.return(b);
                    d = {};
                    e = 0;
                    g = A(Object.keys(c));
                    for(f = g.next(); !f.done; f = g.next())h = f.value, k = c[h], "string" !== typeof k && "texture" === k.type && void 0 !== b[k.stream] && ++e;
                    1 < e && (a.M = !1);
                    l = A(Object.keys(c));
                    f = l.next();
                case 2:
                    if (f.done) {
                        v.h = 4;
                        break;
                    }
                    m = f.value;
                    r = c[m];
                    if ("string" === typeof r) return t = d, w = m, D(v, md(a, m, b[r]), 14);
                    p = b[r.stream];
                    if ("detection_list" === r.type) {
                        if (p) {
                            var B = p.getRectList();
                            for(var J = p.getLandmarksList(), I = p.getClassificationsList(), u = [], C = 0; C < B.size(); ++C){
                                var U = Sc(B.get(C)), pd = X(U, 1), qd = X(U, 2), rd = X(U, 3), sd = X(U, 4), td = X(U, 5, 0), za = void 0;
                                za = void 0 === za ? 0 : za;
                                U = {
                                    la: {
                                        sa: pd,
                                        ta: qd,
                                        height: rd,
                                        width: sd,
                                        rotation: td,
                                        pa: Qb(T(U, 6), za)
                                    },
                                    ea: Wc(J.get(C)),
                                    ba: Uc(Kc(I.get(C)))
                                };
                                u.push(U);
                            }
                            B = u;
                        } else B = [];
                        d[m] = B;
                        v.h = 7;
                        break;
                    }
                    if ("proto_list" === r.type) {
                        if (p) {
                            B = Array(p.size());
                            for(J = 0; J < p.size(); J++)B[J] = p.get(J);
                            p.delete();
                        } else B = [];
                        d[m] = B;
                        v.h = 7;
                        break;
                    }
                    if (void 0 === p) {
                        v.h = 3;
                        break;
                    }
                    if ("float_list" === r.type) {
                        d[m] = p;
                        v.h = 7;
                        break;
                    }
                    if ("proto" === r.type) {
                        d[m] = p;
                        v.h = 7;
                        break;
                    }
                    if ("texture" !== r.type) throw Error("Unknown output config type: '" + r.type + "'");
                    n = a.v[m];
                    n || (n = new Xc(a.i, a.K), a.v[m] = n);
                    return D(v, Yc(n, p, a.M), 13);
                case 13:
                    q = v.i, d[m] = q;
                case 7:
                    r.transform && d[m] && (d[m] = r.transform(d[m]));
                    v.h = 3;
                    break;
                case 14:
                    t[w] = v.i;
                case 3:
                    f = l.next();
                    v.h = 2;
                    break;
                case 4:
                    return v.return(d);
            }
        });
    }
    function md(a, b, c) {
        var d;
        return E(function(e) {
            return "number" === typeof c || c instanceof Uint8Array || c instanceof a.i.Uint8BlobList ? e.return(c) : c instanceof a.i.Texture2dDataOut ? (d = a.v[b], d || (d = new Xc(a.i, a.K), a.v[b] = d), e.return(Yc(d, c, a.M))) : e.return(void 0);
        });
    }
    function jd(a, b) {
        for(var c = b.name || "$", d = [].concat(ea(b.wants)), e = new a.i.StringList, g = A(b.wants), f = g.next(); !f.done; f = g.next())e.push_back(f.value);
        g = a.i.PacketListener.implement({
            onResults: function(h) {
                for(var k = {}, l = 0; l < b.wants.length; ++l)k[d[l]] = h.get(l);
                var m = a.listeners[c];
                m && (a.I = ld(a, k, b.outs).then(function(r) {
                    r = m(r);
                    for(var p = 0; p < b.wants.length; ++p){
                        var n = k[d[p]];
                        "object" === typeof n && n.hasOwnProperty && n.hasOwnProperty("delete") && n.delete();
                    }
                    r && (a.I = r);
                }));
            }
        });
        a.j.attachMultiListener(e, g);
        e.delete();
    }
    x.onResults = function(a, b) {
        this.listeners[b || "$"] = a;
    };
    G("Solution", fd);
    G("OptionType", {
        BOOL: 0,
        NUMBER: 1,
        ua: 2,
        0: "BOOL",
        1: "NUMBER",
        2: "STRING"
    });
    function nd(a) {
        void 0 === a && (a = 0);
        switch(a){
            case 1:
                return "pose_landmark_full.tflite";
            case 2:
                return "pose_landmark_heavy.tflite";
            default:
                return "pose_landmark_lite.tflite";
        }
    }
    function od(a) {
        var b = this;
        a = a || {};
        this.h = new fd({
            locateFile: a.locateFile,
            files: function(c) {
                return [
                    {
                        url: "pose_solution_packed_assets_loader.js"
                    },
                    {
                        simd: !1,
                        url: "pose_solution_wasm_bin.js"
                    },
                    {
                        simd: !0,
                        url: "pose_solution_simd_wasm_bin.js"
                    },
                    {
                        data: !0,
                        url: nd(c.modelComplexity)
                    }
                ];
            },
            graph: {
                url: "pose_web.binarypb"
            },
            listeners: [
                {
                    wants: [
                        "pose_landmarks",
                        "world_landmarks",
                        "segmentation_mask",
                        "image_transformed"
                    ],
                    outs: {
                        image: {
                            type: "texture",
                            stream: "image_transformed"
                        },
                        poseLandmarks: {
                            type: "proto",
                            stream: "pose_landmarks",
                            transform: Wc
                        },
                        poseWorldLandmarks: {
                            type: "proto",
                            stream: "world_landmarks",
                            transform: Wc
                        },
                        segmentationMask: {
                            type: "texture",
                            stream: "segmentation_mask"
                        }
                    }
                }
            ],
            inputs: {
                image: {
                    type: "video",
                    stream: "input_frames_gpu"
                }
            },
            options: {
                useCpuInference: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "InferenceCalculator",
                        fieldName: "use_cpu_inference"
                    },
                    default: "object" !== typeof window || void 0 === window.navigator ? !1 : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                },
                selfieMode: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "GlScalerCalculator",
                        calculatorIndex: 1,
                        fieldName: "flip_horizontal"
                    }
                },
                modelComplexity: {
                    type: 1,
                    graphOptionXref: {
                        calculatorType: "ConstantSidePacketCalculator",
                        calculatorName: "ConstantSidePacketCalculatorModelComplexity",
                        fieldName: "int_value"
                    },
                    onChange: function(c) {
                        var d, e, g;
                        return E(function(f) {
                            if (1 == f.h) return d = nd(c), e = "third_party/mediapipe/modules/pose_landmark/" + d, D(f, hd(b.h, d), 2);
                            g = f.i;
                            b.h.overrideFile(e, g);
                            return f.return(!0);
                        });
                    }
                },
                smoothLandmarks: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "ConstantSidePacketCalculator",
                        calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks",
                        fieldName: "bool_value"
                    }
                },
                enableSegmentation: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "ConstantSidePacketCalculator",
                        calculatorName: "ConstantSidePacketCalculatorEnableSegmentation",
                        fieldName: "bool_value"
                    }
                },
                smoothSegmentation: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "ConstantSidePacketCalculator",
                        calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation",
                        fieldName: "bool_value"
                    }
                },
                minDetectionConfidence: {
                    type: 1,
                    graphOptionXref: {
                        calculatorType: "TensorsToDetectionsCalculator",
                        calculatorName: "poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator",
                        fieldName: "min_score_thresh"
                    }
                },
                minTrackingConfidence: {
                    type: 1,
                    graphOptionXref: {
                        calculatorType: "ThresholdingCalculator",
                        calculatorName: "poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator",
                        fieldName: "threshold"
                    }
                }
            }
        });
    }
    x = od.prototype;
    x.reset = function() {
        this.h.reset();
    };
    x.close = function() {
        this.h.close();
        return Promise.resolve();
    };
    x.onResults = function(a) {
        this.h.onResults(a);
    };
    x.initialize = function() {
        var a = this;
        return E(function(b) {
            return D(b, a.h.initialize(), 0);
        });
    };
    x.send = function(a, b) {
        var c = this;
        return E(function(d) {
            return D(d, c.h.send(a, b), 0);
        });
    };
    x.setOptions = function(a) {
        this.h.setOptions(a);
    };
    G("Pose", od);
    G("POSE_CONNECTIONS", [
        [
            0,
            1
        ],
        [
            1,
            2
        ],
        [
            2,
            3
        ],
        [
            3,
            7
        ],
        [
            0,
            4
        ],
        [
            4,
            5
        ],
        [
            5,
            6
        ],
        [
            6,
            8
        ],
        [
            9,
            10
        ],
        [
            11,
            12
        ],
        [
            11,
            13
        ],
        [
            13,
            15
        ],
        [
            15,
            17
        ],
        [
            15,
            19
        ],
        [
            15,
            21
        ],
        [
            17,
            19
        ],
        [
            12,
            14
        ],
        [
            14,
            16
        ],
        [
            16,
            18
        ],
        [
            16,
            20
        ],
        [
            16,
            22
        ],
        [
            18,
            20
        ],
        [
            11,
            23
        ],
        [
            12,
            24
        ],
        [
            23,
            24
        ],
        [
            23,
            25
        ],
        [
            24,
            26
        ],
        [
            25,
            27
        ],
        [
            26,
            28
        ],
        [
            27,
            29
        ],
        [
            28,
            30
        ],
        [
            29,
            31
        ],
        [
            30,
            32
        ],
        [
            27,
            31
        ],
        [
            28,
            32
        ]
    ]);
    G("POSE_LANDMARKS", {
        NOSE: 0,
        LEFT_EYE_INNER: 1,
        LEFT_EYE: 2,
        LEFT_EYE_OUTER: 3,
        RIGHT_EYE_INNER: 4,
        RIGHT_EYE: 5,
        RIGHT_EYE_OUTER: 6,
        LEFT_EAR: 7,
        RIGHT_EAR: 8,
        LEFT_RIGHT: 9,
        RIGHT_LEFT: 10,
        LEFT_SHOULDER: 11,
        RIGHT_SHOULDER: 12,
        LEFT_ELBOW: 13,
        RIGHT_ELBOW: 14,
        LEFT_WRIST: 15,
        RIGHT_WRIST: 16,
        LEFT_PINKY: 17,
        RIGHT_PINKY: 18,
        LEFT_INDEX: 19,
        RIGHT_INDEX: 20,
        LEFT_THUMB: 21,
        RIGHT_THUMB: 22,
        LEFT_HIP: 23,
        RIGHT_HIP: 24,
        LEFT_KNEE: 25,
        RIGHT_KNEE: 26,
        LEFT_ANKLE: 27,
        RIGHT_ANKLE: 28,
        LEFT_HEEL: 29,
        RIGHT_HEEL: 30,
        LEFT_FOOT_INDEX: 31,
        RIGHT_FOOT_INDEX: 32
    });
    G("POSE_LANDMARKS_LEFT", {
        LEFT_EYE_INNER: 1,
        LEFT_EYE: 2,
        LEFT_EYE_OUTER: 3,
        LEFT_EAR: 7,
        LEFT_RIGHT: 9,
        LEFT_SHOULDER: 11,
        LEFT_ELBOW: 13,
        LEFT_WRIST: 15,
        LEFT_PINKY: 17,
        LEFT_INDEX: 19,
        LEFT_THUMB: 21,
        LEFT_HIP: 23,
        LEFT_KNEE: 25,
        LEFT_ANKLE: 27,
        LEFT_HEEL: 29,
        LEFT_FOOT_INDEX: 31
    });
    G("POSE_LANDMARKS_RIGHT", {
        RIGHT_EYE_INNER: 4,
        RIGHT_EYE: 5,
        RIGHT_EYE_OUTER: 6,
        RIGHT_EAR: 8,
        RIGHT_LEFT: 10,
        RIGHT_SHOULDER: 12,
        RIGHT_ELBOW: 14,
        RIGHT_WRIST: 16,
        RIGHT_PINKY: 18,
        RIGHT_INDEX: 20,
        RIGHT_THUMB: 22,
        RIGHT_HIP: 24,
        RIGHT_KNEE: 26,
        RIGHT_ANKLE: 28,
        RIGHT_HEEL: 30,
        RIGHT_FOOT_INDEX: 32
    });
    G("POSE_LANDMARKS_NEUTRAL", {
        NOSE: 0
    });
    G("VERSION", "0.5.1675469404");
}).call(module.exports);

});

parcelRegister("i64bB", function(module, exports) {
$parcel$export(module.exports, "_FusedMatMul", () => (parcelRequire("hl418"))._FusedMatMul);
$parcel$export(module.exports, "Abs", () => (parcelRequire("hl418")).Abs);
$parcel$export(module.exports, "Acos", () => (parcelRequire("hl418")).Acos);
$parcel$export(module.exports, "Acosh", () => (parcelRequire("hl418")).Acosh);
$parcel$export(module.exports, "Add", () => (parcelRequire("hl418")).Add);
$parcel$export(module.exports, "AddN", () => (parcelRequire("hl418")).AddN);
$parcel$export(module.exports, "All", () => (parcelRequire("hl418")).All);
$parcel$export(module.exports, "Any", () => (parcelRequire("hl418")).Any);
$parcel$export(module.exports, "ArgMax", () => (parcelRequire("hl418")).ArgMax);
$parcel$export(module.exports, "ArgMin", () => (parcelRequire("hl418")).ArgMin);
$parcel$export(module.exports, "Asin", () => (parcelRequire("hl418")).Asin);
$parcel$export(module.exports, "Asinh", () => (parcelRequire("hl418")).Asinh);
$parcel$export(module.exports, "Atan", () => (parcelRequire("hl418")).Atan);
$parcel$export(module.exports, "Atan2", () => (parcelRequire("hl418")).Atan2);
$parcel$export(module.exports, "Atanh", () => (parcelRequire("hl418")).Atanh);
$parcel$export(module.exports, "AvgPool", () => (parcelRequire("hl418")).AvgPool);
$parcel$export(module.exports, "AvgPool3D", () => (parcelRequire("hl418")).AvgPool3D);
$parcel$export(module.exports, "AvgPool3DGrad", () => (parcelRequire("hl418")).AvgPool3DGrad);
$parcel$export(module.exports, "AvgPoolGrad", () => (parcelRequire("hl418")).AvgPoolGrad);
$parcel$export(module.exports, "BatchMatMul", () => (parcelRequire("hl418")).BatchMatMul);
$parcel$export(module.exports, "BatchToSpaceND", () => (parcelRequire("hl418")).BatchToSpaceND);
$parcel$export(module.exports, "Bincount", () => (parcelRequire("hl418")).Bincount);
$parcel$export(module.exports, "BitwiseAnd", () => (parcelRequire("hl418")).BitwiseAnd);
$parcel$export(module.exports, "BroadcastArgs", () => (parcelRequire("hl418")).BroadcastArgs);
$parcel$export(module.exports, "Cast", () => (parcelRequire("hl418")).Cast);
$parcel$export(module.exports, "Ceil", () => (parcelRequire("hl418")).Ceil);
$parcel$export(module.exports, "ClipByValue", () => (parcelRequire("hl418")).ClipByValue);
$parcel$export(module.exports, "Complex", () => (parcelRequire("hl418")).Complex);
$parcel$export(module.exports, "ComplexAbs", () => (parcelRequire("hl418")).ComplexAbs);
$parcel$export(module.exports, "Concat", () => (parcelRequire("hl418")).Concat);
$parcel$export(module.exports, "Conv2D", () => (parcelRequire("hl418")).Conv2D);
$parcel$export(module.exports, "Conv2DBackpropFilter", () => (parcelRequire("hl418")).Conv2DBackpropFilter);
$parcel$export(module.exports, "Conv2DBackpropInput", () => (parcelRequire("hl418")).Conv2DBackpropInput);
$parcel$export(module.exports, "Conv3D", () => (parcelRequire("hl418")).Conv3D);
$parcel$export(module.exports, "Conv3DBackpropFilterV2", () => (parcelRequire("hl418")).Conv3DBackpropFilterV2);
$parcel$export(module.exports, "Conv3DBackpropInputV2", () => (parcelRequire("hl418")).Conv3DBackpropInputV2);
$parcel$export(module.exports, "Cos", () => (parcelRequire("hl418")).Cos);
$parcel$export(module.exports, "Cosh", () => (parcelRequire("hl418")).Cosh);
$parcel$export(module.exports, "CropAndResize", () => (parcelRequire("hl418")).CropAndResize);
$parcel$export(module.exports, "Cumprod", () => (parcelRequire("hl418")).Cumprod);
$parcel$export(module.exports, "Cumsum", () => (parcelRequire("hl418")).Cumsum);
$parcel$export(module.exports, "DenseBincount", () => (parcelRequire("hl418")).DenseBincount);
$parcel$export(module.exports, "DepthToSpace", () => (parcelRequire("hl418")).DepthToSpace);
$parcel$export(module.exports, "DepthwiseConv2dNative", () => (parcelRequire("hl418")).DepthwiseConv2dNative);
$parcel$export(module.exports, "DepthwiseConv2dNativeBackpropFilter", () => (parcelRequire("hl418")).DepthwiseConv2dNativeBackpropFilter);
$parcel$export(module.exports, "DepthwiseConv2dNativeBackpropInput", () => (parcelRequire("hl418")).DepthwiseConv2dNativeBackpropInput);
$parcel$export(module.exports, "Diag", () => (parcelRequire("hl418")).Diag);
$parcel$export(module.exports, "Dilation2D", () => (parcelRequire("hl418")).Dilation2D);
$parcel$export(module.exports, "Dilation2DBackpropFilter", () => (parcelRequire("hl418")).Dilation2DBackpropFilter);
$parcel$export(module.exports, "Dilation2DBackpropInput", () => (parcelRequire("hl418")).Dilation2DBackpropInput);
$parcel$export(module.exports, "Draw", () => (parcelRequire("hl418")).Draw);
$parcel$export(module.exports, "Einsum", () => (parcelRequire("hl418")).Einsum);
$parcel$export(module.exports, "Elu", () => (parcelRequire("hl418")).Elu);
$parcel$export(module.exports, "EluGrad", () => (parcelRequire("hl418")).EluGrad);
$parcel$export(module.exports, "Equal", () => (parcelRequire("hl418")).Equal);
$parcel$export(module.exports, "Erf", () => (parcelRequire("hl418")).Erf);
$parcel$export(module.exports, "Exp", () => (parcelRequire("hl418")).Exp);
$parcel$export(module.exports, "ExpandDims", () => (parcelRequire("hl418")).ExpandDims);
$parcel$export(module.exports, "Expm1", () => (parcelRequire("hl418")).Expm1);
$parcel$export(module.exports, "FFT", () => (parcelRequire("hl418")).FFT);
$parcel$export(module.exports, "Fill", () => (parcelRequire("hl418")).Fill);
$parcel$export(module.exports, "FlipLeftRight", () => (parcelRequire("hl418")).FlipLeftRight);
$parcel$export(module.exports, "Floor", () => (parcelRequire("hl418")).Floor);
$parcel$export(module.exports, "FloorDiv", () => (parcelRequire("hl418")).FloorDiv);
$parcel$export(module.exports, "FromPixels", () => (parcelRequire("hl418")).FromPixels);
$parcel$export(module.exports, "FusedBatchNorm", () => (parcelRequire("hl418")).FusedBatchNorm);
$parcel$export(module.exports, "FusedConv2D", () => (parcelRequire("hl418")).FusedConv2D);
$parcel$export(module.exports, "FusedDepthwiseConv2D", () => (parcelRequire("hl418")).FusedDepthwiseConv2D);
$parcel$export(module.exports, "GatherNd", () => (parcelRequire("hl418")).GatherNd);
$parcel$export(module.exports, "GatherV2", () => (parcelRequire("hl418")).GatherV2);
$parcel$export(module.exports, "Greater", () => (parcelRequire("hl418")).Greater);
$parcel$export(module.exports, "GreaterEqual", () => (parcelRequire("hl418")).GreaterEqual);
$parcel$export(module.exports, "Identity", () => (parcelRequire("hl418")).Identity);
$parcel$export(module.exports, "IFFT", () => (parcelRequire("hl418")).IFFT);
$parcel$export(module.exports, "Imag", () => (parcelRequire("hl418")).Imag);
$parcel$export(module.exports, "IsFinite", () => (parcelRequire("hl418")).IsFinite);
$parcel$export(module.exports, "IsInf", () => (parcelRequire("hl418")).IsInf);
$parcel$export(module.exports, "IsNan", () => (parcelRequire("hl418")).IsNan);
$parcel$export(module.exports, "LeakyRelu", () => (parcelRequire("hl418")).LeakyRelu);
$parcel$export(module.exports, "Less", () => (parcelRequire("hl418")).Less);
$parcel$export(module.exports, "LessEqual", () => (parcelRequire("hl418")).LessEqual);
$parcel$export(module.exports, "LinSpace", () => (parcelRequire("hl418")).LinSpace);
$parcel$export(module.exports, "Log", () => (parcelRequire("hl418")).Log);
$parcel$export(module.exports, "Log1p", () => (parcelRequire("hl418")).Log1p);
$parcel$export(module.exports, "LogicalAnd", () => (parcelRequire("hl418")).LogicalAnd);
$parcel$export(module.exports, "LogicalNot", () => (parcelRequire("hl418")).LogicalNot);
$parcel$export(module.exports, "LogicalOr", () => (parcelRequire("hl418")).LogicalOr);
$parcel$export(module.exports, "LRN", () => (parcelRequire("hl418")).LRN);
$parcel$export(module.exports, "LRNGrad", () => (parcelRequire("hl418")).LRNGrad);
$parcel$export(module.exports, "Max", () => (parcelRequire("hl418")).Max);
$parcel$export(module.exports, "Maximum", () => (parcelRequire("hl418")).Maximum);
$parcel$export(module.exports, "MaxPool", () => (parcelRequire("hl418")).MaxPool);
$parcel$export(module.exports, "MaxPool3D", () => (parcelRequire("hl418")).MaxPool3D);
$parcel$export(module.exports, "MaxPool3DGrad", () => (parcelRequire("hl418")).MaxPool3DGrad);
$parcel$export(module.exports, "MaxPoolGrad", () => (parcelRequire("hl418")).MaxPoolGrad);
$parcel$export(module.exports, "MaxPoolWithArgmax", () => (parcelRequire("hl418")).MaxPoolWithArgmax);
$parcel$export(module.exports, "Mean", () => (parcelRequire("hl418")).Mean);
$parcel$export(module.exports, "Min", () => (parcelRequire("hl418")).Min);
$parcel$export(module.exports, "Minimum", () => (parcelRequire("hl418")).Minimum);
$parcel$export(module.exports, "MirrorPad", () => (parcelRequire("hl418")).MirrorPad);
$parcel$export(module.exports, "Mod", () => (parcelRequire("hl418")).Mod);
$parcel$export(module.exports, "Multinomial", () => (parcelRequire("hl418")).Multinomial);
$parcel$export(module.exports, "Multiply", () => (parcelRequire("hl418")).Multiply);
$parcel$export(module.exports, "Neg", () => (parcelRequire("hl418")).Neg);
$parcel$export(module.exports, "NonMaxSuppressionV3", () => (parcelRequire("hl418")).NonMaxSuppressionV3);
$parcel$export(module.exports, "NonMaxSuppressionV4", () => (parcelRequire("hl418")).NonMaxSuppressionV4);
$parcel$export(module.exports, "NonMaxSuppressionV5", () => (parcelRequire("hl418")).NonMaxSuppressionV5);
$parcel$export(module.exports, "NotEqual", () => (parcelRequire("hl418")).NotEqual);
$parcel$export(module.exports, "OneHot", () => (parcelRequire("hl418")).OneHot);
$parcel$export(module.exports, "OnesLike", () => (parcelRequire("hl418")).OnesLike);
$parcel$export(module.exports, "Pack", () => (parcelRequire("hl418")).Pack);
$parcel$export(module.exports, "PadV2", () => (parcelRequire("hl418")).PadV2);
$parcel$export(module.exports, "Pow", () => (parcelRequire("hl418")).Pow);
$parcel$export(module.exports, "Prelu", () => (parcelRequire("hl418")).Prelu);
$parcel$export(module.exports, "Prod", () => (parcelRequire("hl418")).Prod);
$parcel$export(module.exports, "RaggedGather", () => (parcelRequire("hl418")).RaggedGather);
$parcel$export(module.exports, "RaggedRange", () => (parcelRequire("hl418")).RaggedRange);
$parcel$export(module.exports, "RaggedTensorToTensor", () => (parcelRequire("hl418")).RaggedTensorToTensor);
$parcel$export(module.exports, "Range", () => (parcelRequire("hl418")).Range);
$parcel$export(module.exports, "Real", () => (parcelRequire("hl418")).Real);
$parcel$export(module.exports, "RealDiv", () => (parcelRequire("hl418")).RealDiv);
$parcel$export(module.exports, "Reciprocal", () => (parcelRequire("hl418")).Reciprocal);
$parcel$export(module.exports, "Relu", () => (parcelRequire("hl418")).Relu);
$parcel$export(module.exports, "Relu6", () => (parcelRequire("hl418")).Relu6);
$parcel$export(module.exports, "Reshape", () => (parcelRequire("hl418")).Reshape);
$parcel$export(module.exports, "ResizeBilinear", () => (parcelRequire("hl418")).ResizeBilinear);
$parcel$export(module.exports, "ResizeBilinearGrad", () => (parcelRequire("hl418")).ResizeBilinearGrad);
$parcel$export(module.exports, "ResizeNearestNeighbor", () => (parcelRequire("hl418")).ResizeNearestNeighbor);
$parcel$export(module.exports, "ResizeNearestNeighborGrad", () => (parcelRequire("hl418")).ResizeNearestNeighborGrad);
$parcel$export(module.exports, "Reverse", () => (parcelRequire("hl418")).Reverse);
$parcel$export(module.exports, "RotateWithOffset", () => (parcelRequire("hl418")).RotateWithOffset);
$parcel$export(module.exports, "Round", () => (parcelRequire("hl418")).Round);
$parcel$export(module.exports, "Rsqrt", () => (parcelRequire("hl418")).Rsqrt);
$parcel$export(module.exports, "ScatterNd", () => (parcelRequire("hl418")).ScatterNd);
$parcel$export(module.exports, "SearchSorted", () => (parcelRequire("hl418")).SearchSorted);
$parcel$export(module.exports, "Select", () => (parcelRequire("hl418")).Select);
$parcel$export(module.exports, "Selu", () => (parcelRequire("hl418")).Selu);
$parcel$export(module.exports, "Sigmoid", () => (parcelRequire("hl418")).Sigmoid);
$parcel$export(module.exports, "Sign", () => (parcelRequire("hl418")).Sign);
$parcel$export(module.exports, "Sin", () => (parcelRequire("hl418")).Sin);
$parcel$export(module.exports, "Sinh", () => (parcelRequire("hl418")).Sinh);
$parcel$export(module.exports, "Slice", () => (parcelRequire("hl418")).Slice);
$parcel$export(module.exports, "Softmax", () => (parcelRequire("hl418")).Softmax);
$parcel$export(module.exports, "Softplus", () => (parcelRequire("hl418")).Softplus);
$parcel$export(module.exports, "SpaceToBatchND", () => (parcelRequire("hl418")).SpaceToBatchND);
$parcel$export(module.exports, "SparseFillEmptyRows", () => (parcelRequire("hl418")).SparseFillEmptyRows);
$parcel$export(module.exports, "SparseReshape", () => (parcelRequire("hl418")).SparseReshape);
$parcel$export(module.exports, "SparseSegmentMean", () => (parcelRequire("hl418")).SparseSegmentMean);
$parcel$export(module.exports, "SparseSegmentSum", () => (parcelRequire("hl418")).SparseSegmentSum);
$parcel$export(module.exports, "SparseToDense", () => (parcelRequire("hl418")).SparseToDense);
$parcel$export(module.exports, "SplitV", () => (parcelRequire("hl418")).SplitV);
$parcel$export(module.exports, "Sqrt", () => (parcelRequire("hl418")).Sqrt);
$parcel$export(module.exports, "Square", () => (parcelRequire("hl418")).Square);
$parcel$export(module.exports, "SquaredDifference", () => (parcelRequire("hl418")).SquaredDifference);
$parcel$export(module.exports, "StaticRegexReplace", () => (parcelRequire("hl418")).StaticRegexReplace);
$parcel$export(module.exports, "Step", () => (parcelRequire("hl418")).Step);
$parcel$export(module.exports, "StridedSlice", () => (parcelRequire("hl418")).StridedSlice);
$parcel$export(module.exports, "StringNGrams", () => (parcelRequire("hl418")).StringNGrams);
$parcel$export(module.exports, "StringSplit", () => (parcelRequire("hl418")).StringSplit);
$parcel$export(module.exports, "StringToHashBucketFast", () => (parcelRequire("hl418")).StringToHashBucketFast);
$parcel$export(module.exports, "Sub", () => (parcelRequire("hl418")).Sub);
$parcel$export(module.exports, "Sum", () => (parcelRequire("hl418")).Sum);
$parcel$export(module.exports, "Tan", () => (parcelRequire("hl418")).Tan);
$parcel$export(module.exports, "Tanh", () => (parcelRequire("hl418")).Tanh);
$parcel$export(module.exports, "TensorScatterUpdate", () => (parcelRequire("hl418")).TensorScatterUpdate);
$parcel$export(module.exports, "Tile", () => (parcelRequire("hl418")).Tile);
$parcel$export(module.exports, "TopK", () => (parcelRequire("hl418")).TopK);
$parcel$export(module.exports, "Transform", () => (parcelRequire("hl418")).Transform);
$parcel$export(module.exports, "Transpose", () => (parcelRequire("hl418")).Transpose);
$parcel$export(module.exports, "Unique", () => (parcelRequire("hl418")).Unique);
$parcel$export(module.exports, "Unpack", () => (parcelRequire("hl418")).Unpack);
$parcel$export(module.exports, "UnsortedSegmentSum", () => (parcelRequire("hl418")).UnsortedSegmentSum);
$parcel$export(module.exports, "ZerosLike", () => (parcelRequire("hl418")).ZerosLike);
$parcel$export(module.exports, "abs", () => (parcelRequire("7j49I")).abs);
$parcel$export(module.exports, "add", () => (parcelRequire("hgacW")).add);
$parcel$export(module.exports, "all", () => (parcelRequire("baxp3")).all);
$parcel$export(module.exports, "any", () => (parcelRequire("3cXYO")).any);
$parcel$export(module.exports, "argMax", () => (parcelRequire("jctS7")).argMax);
$parcel$export(module.exports, "avgPool", () => (parcelRequire("j4oHC")).avgPool);
$parcel$export(module.exports, "avgPool3d", () => (parcelRequire("ku2lx")).avgPool3d);
$parcel$export(module.exports, "backend", () => (parcelRequire("c2DT1")).backend);
$parcel$export(module.exports, "dispose", () => (parcelRequire("c2DT1")).dispose);
$parcel$export(module.exports, "enableProdMode", () => (parcelRequire("c2DT1")).enableProdMode);
$parcel$export(module.exports, "engine", () => (parcelRequire("c2DT1")).engine);
$parcel$export(module.exports, "getBackend", () => (parcelRequire("c2DT1")).getBackend);
$parcel$export(module.exports, "keep", () => (parcelRequire("c2DT1")).keep);
$parcel$export(module.exports, "memory", () => (parcelRequire("c2DT1")).memory);
$parcel$export(module.exports, "registerBackend", () => (parcelRequire("c2DT1")).registerBackend);
$parcel$export(module.exports, "setBackend", () => (parcelRequire("c2DT1")).setBackend);
$parcel$export(module.exports, "tidy", () => (parcelRequire("c2DT1")).tidy);
$parcel$export(module.exports, "batchNorm2d", () => (parcelRequire("kKS8R")).batchNorm2d);
$parcel$export(module.exports, "batchNorm3d", () => (parcelRequire("3KWPF")).batchNorm3d);
$parcel$export(module.exports, "batchNorm4d", () => (parcelRequire("34sL5")).batchNorm4d);
$parcel$export(module.exports, "broadcastTo", () => (parcelRequire("aeB3Z")).broadcastTo);
$parcel$export(module.exports, "buffer", () => (parcelRequire("iG87S")).buffer);
$parcel$export(module.exports, "cast", () => (parcelRequire("inFmq")).cast);
$parcel$export(module.exports, "clipByValue", () => (parcelRequire("cOWuO")).clipByValue);
$parcel$export(module.exports, "clone", () => (parcelRequire("5TuCW")).clone);
$parcel$export(module.exports, "concat", () => (parcelRequire("iTu6j")).concat);
$parcel$export(module.exports, "concat1d", () => (parcelRequire("4TU82")).concat1d);
$parcel$export(module.exports, "concat2d", () => (parcelRequire("7PZdE")).concat2d);
$parcel$export(module.exports, "concat3d", () => (parcelRequire("ljqPW")).concat3d);
$parcel$export(module.exports, "concat4d", () => (parcelRequire("9Grxx")).concat4d);
$parcel$export(module.exports, "conv1d", () => (parcelRequire("ebPOp")).conv1d);
$parcel$export(module.exports, "conv2d", () => (parcelRequire("5Nkm1")).conv2d);
$parcel$export(module.exports, "conv2dTranspose", () => (parcelRequire("5rn1J")).conv2dTranspose);
$parcel$export(module.exports, "conv3d", () => (parcelRequire("kj7tM")).conv3d);
$parcel$export(module.exports, "conv3dTranspose", () => (parcelRequire("7Zgyq")).conv3dTranspose);
$parcel$export(module.exports, "DataStorage", () => (parcelRequire("fJqML")).DataStorage);
$parcel$export(module.exports, "KernelBackend", () => (parcelRequire("fJqML")).KernelBackend);
$parcel$export(module.exports, "denseBincount", () => (parcelRequire("8maH5")).denseBincount);
$parcel$export(module.exports, "depthwiseConv2d", () => (parcelRequire("182Rc")).depthwiseConv2d);
$parcel$export(module.exports, "div", () => (parcelRequire("1QPqB")).div);
$parcel$export(module.exports, "elu", () => (parcelRequire("7UQTl")).elu);
$parcel$export(module.exports, "env", () => (parcelRequire("ibsdL")).env);
$parcel$export(module.exports, "equal", () => (parcelRequire("7R9HC")).equal);
$parcel$export(module.exports, "erf", () => (parcelRequire("3q8h0")).erf);
$parcel$export(module.exports, "exp", () => (parcelRequire("2PcQK")).exp);
$parcel$export(module.exports, "expandDims", () => (parcelRequire("iPDWZ")).expandDims);
$parcel$export(module.exports, "eye", () => (parcelRequire("9gIZb")).eye);
$parcel$export(module.exports, "fill", () => (parcelRequire("gYive")).fill);
$parcel$export(module.exports, "floor", () => (parcelRequire("4ZUCz")).floor);
$parcel$export(module.exports, "gather", () => (parcelRequire("3qUjU")).gather);
$parcel$export(module.exports, "greater", () => (parcelRequire("bRRKf")).greater);
$parcel$export(module.exports, "greaterEqual", () => (parcelRequire("l0Zxl")).greaterEqual);
$parcel$export(module.exports, "leakyRelu", () => (parcelRequire("3XskU")).leakyRelu);
$parcel$export(module.exports, "log", () => (parcelRequire("dcoCo")).log);
$parcel$export(module.exports, "log1p", () => (parcelRequire("5QUXI")).log1p);
$parcel$export(module.exports, "logicalAnd", () => (parcelRequire("kg1Wp")).logicalAnd);
$parcel$export(module.exports, "logSoftmax", () => (parcelRequire("2NPdY")).logSoftmax);
$parcel$export(module.exports, "logSumExp", () => (parcelRequire("9dGIC")).logSumExp);
$parcel$export(module.exports, "matMul", () => (parcelRequire("aUFou")).matMul);
$parcel$export(module.exports, "max", () => (parcelRequire("05cMR")).max);
$parcel$export(module.exports, "maximum", () => (parcelRequire("g5Jt1")).maximum);
$parcel$export(module.exports, "maxPool", () => (parcelRequire("gscJF")).maxPool);
$parcel$export(module.exports, "maxPool3d", () => (parcelRequire("gF4tm")).maxPool3d);
$parcel$export(module.exports, "mean", () => (parcelRequire("67GCc")).mean);
$parcel$export(module.exports, "min", () => (parcelRequire("fySTI")).min);
$parcel$export(module.exports, "minimum", () => (parcelRequire("6V8xR")).minimum);
$parcel$export(module.exports, "mirrorPad", () => (parcelRequire("ejlRR")).mirrorPad);
$parcel$export(module.exports, "moments", () => (parcelRequire("jV1KY")).moments);
$parcel$export(module.exports, "mul", () => (parcelRequire("jZc0w")).mul);
$parcel$export(module.exports, "neg", () => (parcelRequire("15cGp")).neg);
$parcel$export(module.exports, "nextFrame", () => (parcelRequire("9LtVT")).nextFrame);
$parcel$export(module.exports, "notEqual", () => (parcelRequire("8WSnu")).notEqual);
$parcel$export(module.exports, "oneHot", () => (parcelRequire("i3U4j")).oneHot);
$parcel$export(module.exports, "ones", () => (parcelRequire("fOBRA")).ones);
$parcel$export(module.exports, "onesLike", () => (parcelRequire("67iid")).onesLike);
$parcel$export(module.exports, "Optimizer", () => (parcelRequire("kULIJ")).Optimizer);
$parcel$export(module.exports, "pad", () => (parcelRequire("fSZF6")).pad);
$parcel$export(module.exports, "pow", () => (parcelRequire("ad1of")).pow);
$parcel$export(module.exports, "prelu", () => (parcelRequire("a3pvF")).prelu);
$parcel$export(module.exports, "randomNormal", () => (parcelRequire("h2Vnz")).randomNormal);
$parcel$export(module.exports, "randomUniform", () => (parcelRequire("j8sic")).randomUniform);
$parcel$export(module.exports, "range", () => (parcelRequire("80Ety")).range);
$parcel$export(module.exports, "registerKernel", () => (parcelRequire("eky5o")).registerKernel);
$parcel$export(module.exports, "relu", () => (parcelRequire("8wbQq")).relu);
$parcel$export(module.exports, "reshape", () => (parcelRequire("4sqA7")).reshape);
$parcel$export(module.exports, "reverse", () => (parcelRequire("6act6")).reverse);
$parcel$export(module.exports, "scalar", () => (parcelRequire("3xp7o")).scalar);
$parcel$export(module.exports, "selu", () => (parcelRequire("b636r")).selu);
$parcel$export(module.exports, "separableConv2d", () => (parcelRequire("8uLn4")).separableConv2d);
$parcel$export(module.exports, "sigmoid", () => (parcelRequire("jvtSq")).sigmoid);
$parcel$export(module.exports, "slice", () => (parcelRequire("79KOG")).slice);
$parcel$export(module.exports, "slice1d", () => (parcelRequire("5vfHb")).slice1d);
$parcel$export(module.exports, "slice2d", () => (parcelRequire("gKBEV")).slice2d);
$parcel$export(module.exports, "slice3d", () => (parcelRequire("22oMq")).slice3d);
$parcel$export(module.exports, "slice4d", () => (parcelRequire("8hEpb")).slice4d);
$parcel$export(module.exports, "softmax", () => (parcelRequire("dnEu5")).softmax);
$parcel$export(module.exports, "softplus", () => (parcelRequire("4Udpd")).softplus);
$parcel$export(module.exports, "split", () => (parcelRequire("9fmAX")).split);
$parcel$export(module.exports, "sqrt", () => (parcelRequire("iAb3z")).sqrt);
$parcel$export(module.exports, "square", () => (parcelRequire("iDd8d")).square);
$parcel$export(module.exports, "squeeze", () => (parcelRequire("kX8Hd")).squeeze);
$parcel$export(module.exports, "stack", () => (parcelRequire("8BrLX")).stack);
$parcel$export(module.exports, "sub", () => (parcelRequire("7kouu")).sub);
$parcel$export(module.exports, "sum", () => (parcelRequire("9NgTx")).sum);
$parcel$export(module.exports, "sumOutType", () => (parcelRequire("2MDja")).sumOutType);
$parcel$export(module.exports, "upcastType", () => (parcelRequire("2MDja")).upcastType);
$parcel$export(module.exports, "tanh", () => (parcelRequire("etcYL")).tanh);
$parcel$export(module.exports, "tensor", () => (parcelRequire("erbmM")).tensor);
$parcel$export(module.exports, "Tensor", () => (parcelRequire("9jCh7")).Tensor);
$parcel$export(module.exports, "TensorBuffer", () => (parcelRequire("9jCh7")).TensorBuffer);
$parcel$export(module.exports, "tensor1d", () => (parcelRequire("lalFM")).tensor1d);
$parcel$export(module.exports, "tensor2d", () => (parcelRequire("gmMlv")).tensor2d);
$parcel$export(module.exports, "tile", () => (parcelRequire("61ay4")).tile);
$parcel$export(module.exports, "train", () => (parcelRequire("dXS8M")).train);
$parcel$export(module.exports, "truncatedNormal", () => (parcelRequire("dE1HO")).truncatedNormal);
$parcel$export(module.exports, "unstack", () => (parcelRequire("gBOC6")).unstack);
$parcel$export(module.exports, "variable", () => (parcelRequire("eoViB")).variable);
$parcel$export(module.exports, "variableGrads", () => (parcelRequire("92fpA")).variableGrads);
$parcel$export(module.exports, "where", () => (parcelRequire("l2P14")).where);
$parcel$export(module.exports, "zeros", () => (parcelRequire("hxi4c")).zeros);
$parcel$export(module.exports, "zerosLike", () => (parcelRequire("8EjnK")).zerosLike);

$parcel$export(module.exports, "backend_util", () => (parcelRequire("7MaPk")));
$parcel$export(module.exports, "broadcast_util", () => (parcelRequire("8BaGO")));
$parcel$export(module.exports, "browser", () => (parcelRequire("cpgue")));
$parcel$export(module.exports, "device_util", () => (parcelRequire("4GTZ3")));
$parcel$export(module.exports, "fused", () => (parcelRequire("jDZRN")));
$parcel$export(module.exports, "io", () => (parcelRequire("9ELKf")));
$parcel$export(module.exports, "kernel_impls", () => (parcelRequire("lzjc8")));
$parcel$export(module.exports, "serialization", () => (parcelRequire("5IZxH")));
$parcel$export(module.exports, "slice_util", () => (parcelRequire("bszZn")));
$parcel$export(module.exports, "tensor_util", () => (parcelRequire("3w4Rg")));
$parcel$export(module.exports, "util", () => (parcelRequire("jjNRA")));
$parcel$export(module.exports, "version_core", () => (parcelRequire("kWDmn")).version);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Required side effectful code.
parcelRequire("99KqI");

var $5KHy0 = parcelRequire("5KHy0");
parcelRequire("hl418");parcelRequire("7j49I");parcelRequire("hgacW");parcelRequire("baxp3");parcelRequire("3cXYO");parcelRequire("jctS7");parcelRequire("j4oHC");parcelRequire("ku2lx");parcelRequire("c2DT1");
var $7MaPk = parcelRequire("7MaPk");parcelRequire("kKS8R");parcelRequire("3KWPF");parcelRequire("34sL5");
var $8BaGO = parcelRequire("8BaGO");parcelRequire("aeB3Z");
var $cpgue = parcelRequire("cpgue");parcelRequire("iG87S");parcelRequire("inFmq");parcelRequire("cOWuO");parcelRequire("5TuCW");parcelRequire("iTu6j");parcelRequire("4TU82");parcelRequire("7PZdE");parcelRequire("ljqPW");parcelRequire("9Grxx");parcelRequire("ebPOp");parcelRequire("5Nkm1");parcelRequire("5rn1J");parcelRequire("kj7tM");parcelRequire("7Zgyq");parcelRequire("fJqML");parcelRequire("8maH5");parcelRequire("182Rc");
var $4GTZ3 = parcelRequire("4GTZ3");parcelRequire("1QPqB");
var $5kLyC = parcelRequire("5kLyC");parcelRequire("7UQTl");parcelRequire("ibsdL");parcelRequire("7R9HC");parcelRequire("3q8h0");parcelRequire("2PcQK");parcelRequire("iPDWZ");parcelRequire("9gIZb");parcelRequire("gYive");parcelRequire("4ZUCz");
var $jDZRN = parcelRequire("jDZRN");parcelRequire("3qUjU");parcelRequire("bRRKf");parcelRequire("l0Zxl");
var $aosGd = parcelRequire("aosGd");
var $9ELKf = parcelRequire("9ELKf");
var $lzjc8 = parcelRequire("lzjc8");parcelRequire("3XskU");parcelRequire("dcoCo");parcelRequire("5QUXI");parcelRequire("kg1Wp");parcelRequire("2NPdY");parcelRequire("9dGIC");parcelRequire("aUFou");parcelRequire("05cMR");parcelRequire("g5Jt1");parcelRequire("gscJF");parcelRequire("gF4tm");parcelRequire("67GCc");parcelRequire("fySTI");parcelRequire("6V8xR");parcelRequire("ejlRR");parcelRequire("jV1KY");parcelRequire("jZc0w");parcelRequire("15cGp");parcelRequire("9LtVT");parcelRequire("8WSnu");parcelRequire("i3U4j");parcelRequire("fOBRA");parcelRequire("67iid");parcelRequire("kULIJ");parcelRequire("fSZF6");parcelRequire("ad1of");parcelRequire("a3pvF");parcelRequire("h2Vnz");parcelRequire("j8sic");parcelRequire("80Ety");parcelRequire("eky5o");parcelRequire("8wbQq");parcelRequire("4sqA7");parcelRequire("6act6");parcelRequire("3xp7o");parcelRequire("b636r");parcelRequire("8uLn4");
var $5IZxH = parcelRequire("5IZxH");parcelRequire("jvtSq");parcelRequire("79KOG");
var $bszZn = parcelRequire("bszZn");parcelRequire("5vfHb");parcelRequire("gKBEV");parcelRequire("22oMq");parcelRequire("8hEpb");parcelRequire("dnEu5");parcelRequire("4Udpd");parcelRequire("9fmAX");parcelRequire("iAb3z");parcelRequire("iDd8d");parcelRequire("kX8Hd");parcelRequire("8BrLX");parcelRequire("7kouu");parcelRequire("9NgTx");parcelRequire("2MDja");parcelRequire("etcYL");parcelRequire("erbmM");parcelRequire("9jCh7");
var $3w4Rg = parcelRequire("3w4Rg");parcelRequire("lalFM");parcelRequire("gmMlv");parcelRequire("61ay4");parcelRequire("dXS8M");
var $aDHKy = parcelRequire("aDHKy");parcelRequire("dE1HO");parcelRequire("gBOC6");
var $jjNRA = parcelRequire("jjNRA");parcelRequire("eoViB");parcelRequire("92fpA");
var $kWDmn = parcelRequire("kWDmn");parcelRequire("l2P14");parcelRequire("hxi4c");parcelRequire("8EjnK");
(0, $5KHy0.registerOptimizers)();
$parcel$exportWildcard(module.exports, $5kLyC);
$parcel$exportWildcard(module.exports, $aosGd);
$parcel$exportWildcard(module.exports, $aDHKy);

});
parcelRegister("99KqI", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Required side effectful code for tfjs-core
// Set up Engine and ENV

var $38WwN = parcelRequire("38WwN");
parcelRequire("dcHSK");
parcelRequire("1MXhU");
parcelRequire("lhiTQ");

var $iG87S = parcelRequire("iG87S");

var $inFmq = parcelRequire("inFmq");

var $5TuCW = parcelRequire("5TuCW");

var $bSp5U = parcelRequire("bSp5U");

var $9jCh7 = parcelRequire("9jCh7");
(0, $38WwN.getOrMakeEngine)();
const $6aa8f84e3c4f0382$var$opHandler = {
    buffer: $iG87S.buffer,
    cast: $inFmq.cast,
    clone: $5TuCW.clone,
    print: $bSp5U.print
};
(0, $9jCh7.setOpHandler)($6aa8f84e3c4f0382$var$opHandler);

});
parcelRegister("38WwN", function(module, exports) {

$parcel$export(module.exports, "ENGINE", () => $249f84ddb1ced836$export$33b63313cc511a3b);
$parcel$export(module.exports, "getOrMakeEngine", () => $249f84ddb1ced836$export$ca8737f6c8c212b8);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fJqML = parcelRequire("fJqML");

var $ibsdL = parcelRequire("ibsdL");

var $grcJs = parcelRequire("grcJs");

var $hl418 = parcelRequire("hl418");

var $eky5o = parcelRequire("eky5o");

var $cgHNs = parcelRequire("cgHNs");

var $8XpwP = parcelRequire("8XpwP");

var $8zD9D = parcelRequire("8zD9D");

var $9jCh7 = parcelRequire("9jCh7");

var $3w4Rg = parcelRequire("3w4Rg");

var $8cCb2 = parcelRequire("8cCb2");
var $jjNRA = parcelRequire("jjNRA");
function $249f84ddb1ced836$var$isRegisteredKernelInvocation(kernelInvocation) {
    return kernelInvocation.kernelName != null;
}
class $249f84ddb1ced836$var$EngineState {
    constructor(){
        // Public since optimizers will use it.
        this.registeredVariables = {};
        this.nextTapeNodeId = 0;
        this.numBytes = 0;
        this.numTensors = 0;
        this.numStringTensors = 0;
        this.numDataBuffers = 0;
        // Number of nested tf.grad() statements when computing higher-order
        // gradients. E.g. `1` for first-order gradients and `2` for second-order
        // gradients. Used to track if the tape should be removed after a backprop.
        this.gradientDepth = 0;
        // Number of nested kernel calls. When kernel depth is greater than 1, we turn
        // off the tape.
        this.kernelDepth = 0;
        this.scopeStack = [];
        /**
         * Keeps track of the number of data moves during a kernel execution. We
         * maintain a stack since kernels can call other kernels, recursively.
         */ this.numDataMovesStack = [];
        this.nextScopeId = 0;
        this.tensorInfo = new WeakMap();
        this.profiling = false;
        this.activeProfile = {
            newBytes: 0,
            newTensors: 0,
            peakBytes: 0,
            kernels: [],
            result: null,
            get kernelNames () {
                return Array.from(new Set(this.kernels.map((k)=>k.name)));
            }
        };
    }
    dispose() {
        for(const variableName in this.registeredVariables)this.registeredVariables[variableName].dispose();
    }
}
class $249f84ddb1ced836$export$2c3b404bf3a77a1f {
    constructor(ENV){
        this.ENV = ENV;
        this.registry = {};
        this.registryFactory = {};
        this.pendingBackendInitId = 0;
        this.state = new $249f84ddb1ced836$var$EngineState();
    }
    async ready() {
        if (this.pendingBackendInit != null) return this.pendingBackendInit.then(()=>{});
        if (this.backendInstance != null) return;
        const sortedBackends = this.getSortedBackends();
        for(let i = 0; i < sortedBackends.length; i++){
            const backendName = sortedBackends[i];
            const success = await this.initializeBackend(backendName).success;
            if (success) {
                await this.setBackend(backendName);
                return;
            }
        }
        throw new Error(`Could not initialize any backends, all backend initializations ` + `failed.`);
    }
    get backend() {
        if (this.pendingBackendInit != null) throw new Error(`Backend '${this.backendName}' has not yet been initialized. Make ` + `sure to await tf.ready() or await tf.setBackend() before calling ` + `other methods`);
        if (this.backendInstance == null) {
            const { name: name, asyncInit: asyncInit } = this.initializeBackendsAndReturnBest();
            if (asyncInit) throw new Error(`The highest priority backend '${name}' has not yet been ` + `initialized. Make sure to await tf.ready() or ` + `await tf.setBackend() before calling other methods`);
            this.setBackend(name);
        }
        return this.backendInstance;
    }
    backendNames() {
        return Object.keys(this.registryFactory);
    }
    findBackend(backendName) {
        if (!(backendName in this.registry)) {
            // If the backend hasn't been initialized but we have a registry entry for
            // it, initialize it and return it.
            if (backendName in this.registryFactory) {
                const { asyncInit: asyncInit } = this.initializeBackend(backendName);
                if (asyncInit) // Backend is not ready yet.
                return null;
            } else return null;
        }
        return this.registry[backendName];
    }
    findBackendFactory(backendName) {
        if (!(backendName in this.registryFactory)) return null;
        return this.registryFactory[backendName].factory;
    }
    registerBackend(backendName, factory, priority = 1) {
        if (backendName in this.registryFactory) {
            $cgHNs.warn(`${backendName} backend was already registered. ` + `Reusing existing backend factory.`);
            return false;
        }
        this.registryFactory[backendName] = {
            factory: factory,
            priority: priority
        };
        return true;
    }
    async setBackend(backendName) {
        if (this.registryFactory[backendName] == null) throw new Error(`Backend name '${backendName}' not found in registry`);
        this.backendName = backendName;
        if (this.registry[backendName] == null) {
            this.backendInstance = null;
            const { success: success, asyncInit: asyncInit } = this.initializeBackend(backendName);
            const result = asyncInit ? await success : success;
            if (!result) return false;
        }
        this.backendInstance = this.registry[backendName];
        this.setupRegisteredKernels();
        // Reset the profiler.
        this.profiler = new (0, $8XpwP.Profiler)(this.backendInstance);
        return true;
    }
    setupRegisteredKernels() {
        const kernels = (0, $eky5o.getKernelsForBackend)(this.backendName);
        kernels.forEach((kernel)=>{
            if (kernel.setupFunc != null) kernel.setupFunc(this.backendInstance);
        });
    }
    disposeRegisteredKernels(backendName) {
        const kernels = (0, $eky5o.getKernelsForBackend)(backendName);
        kernels.forEach((kernel)=>{
            if (kernel.disposeFunc != null) kernel.disposeFunc(this.registry[backendName]);
        });
    }
    /**
     * Initializes a backend by looking up the backend name in the factory
     * registry and calling the factory method. Returns a boolean representing
     * whether the initialization of the backend succeeded. Throws an error if
     * there is no backend in the factory registry.
     */ initializeBackend(backendName) {
        const registryFactoryEntry = this.registryFactory[backendName];
        if (registryFactoryEntry == null) throw new Error(`Cannot initialize backend ${backendName}, no registration found.`);
        try {
            const backend = registryFactoryEntry.factory();
            /* Test if the factory returns a promise.
            Done in a more liberal way than
            previous 'Promise.resolve(backend)===backend'
            as we needed to account for custom Promise
            implementations (e.g. Angular) */ if (backend && !(backend instanceof (0, $fJqML.KernelBackend)) && typeof backend.then === 'function') {
                const promiseId = ++this.pendingBackendInitId;
                const success = backend.then((backendInstance)=>{
                    // Outdated promise. Another backend was set in the meantime.
                    if (promiseId < this.pendingBackendInitId) return false;
                    this.registry[backendName] = backendInstance;
                    this.pendingBackendInit = null;
                    return true;
                }).catch((err)=>{
                    // Outdated promise. Another backend was set in the meantime.
                    if (promiseId < this.pendingBackendInitId) return false;
                    this.pendingBackendInit = null;
                    $cgHNs.warn(`Initialization of backend ${backendName} failed`);
                    $cgHNs.warn(err.stack || err.message);
                    return false;
                });
                this.pendingBackendInit = success;
                return {
                    success: success,
                    asyncInit: true
                };
            } else {
                this.registry[backendName] = backend;
                return {
                    success: true,
                    asyncInit: false
                };
            }
        } catch (err) {
            $cgHNs.warn(`Initialization of backend ${backendName} failed`);
            $cgHNs.warn(err.stack || err.message);
            return {
                success: false,
                asyncInit: false
            };
        }
    }
    removeBackend(backendName) {
        if (!(backendName in this.registryFactory)) throw new Error(`${backendName} backend not found in registry`);
        if (this.backendName === backendName && this.pendingBackendInit != null) // There is a pending promise of the backend we want to remove. Make it
        // obsolete.
        this.pendingBackendInitId++;
        if (backendName in this.registry) {
            this.disposeRegisteredKernels(backendName);
            this.registry[backendName].dispose();
            delete this.registry[backendName];
        }
        delete this.registryFactory[backendName];
        // Unset the backend if it is active.
        if (this.backendName === backendName) {
            this.pendingBackendInit = null;
            this.backendName = null;
            this.backendInstance = null;
        }
    }
    getSortedBackends() {
        if (Object.keys(this.registryFactory).length === 0) throw new Error('No backend found in registry.');
        return Object.keys(this.registryFactory).sort((a, b)=>{
            // Highest priority comes first.
            return this.registryFactory[b].priority - this.registryFactory[a].priority;
        });
    }
    initializeBackendsAndReturnBest() {
        const sortedBackends = this.getSortedBackends();
        for(let i = 0; i < sortedBackends.length; i++){
            const backendName = sortedBackends[i];
            const { success: success, asyncInit: asyncInit } = this.initializeBackend(backendName);
            if (asyncInit || success) return {
                name: backendName,
                asyncInit: asyncInit
            };
        }
        throw new Error(`Could not initialize any backends, all backend initializations ` + `failed.`);
    }
    moveData(backend, dataId) {
        const info = this.state.tensorInfo.get(dataId);
        const srcBackend = info.backend;
        const values = this.readSync(dataId);
        const refCount = srcBackend.refCount(dataId);
        // Delete the tensor from the old backend and move it to the new
        // backend.
        srcBackend.disposeData(dataId, true);
        info.backend = backend;
        backend.move(dataId, values, info.shape, info.dtype, refCount);
        if (this.shouldCheckForMemLeaks()) // Track the number of moves during a kernel execution to correctly
        // detect memory leaks.
        this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1]++;
    }
    tidy(nameOrFn, fn) {
        let name = null;
        if (fn == null) {
            // Called with only 1 argument.
            if (typeof nameOrFn !== 'function') throw new Error('Please provide a function to tidy()');
            fn = nameOrFn;
        } else {
            // Called with 2 arguments.
            if (typeof nameOrFn !== 'string' && !(nameOrFn instanceof String)) throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
            if (typeof fn !== 'function') throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
            name = nameOrFn;
        // TODO(nsthorat,smilkov): Do operation logging and performance
        // profiling.
        }
        let result;
        return this.scopedRun(()=>this.startScope(name), ()=>this.endScope(result), ()=>{
            result = fn();
            if (result instanceof Promise) console.error('Cannot return a Promise inside of tidy.');
            return result;
        });
    }
    scopedRun(start, end, f) {
        start();
        try {
            const res = f();
            end();
            return res;
        } catch (ex) {
            end();
            throw ex;
        }
    }
    nextTensorId() {
        return $249f84ddb1ced836$export$2c3b404bf3a77a1f.nextTensorId++;
    }
    nextVariableId() {
        return $249f84ddb1ced836$export$2c3b404bf3a77a1f.nextVariableId++;
    }
    /**
     * This method is called instead of the public-facing tensor.clone() when
     * saving a tensor for backwards pass. It makes sure to add the clone
     * operation to the tape regardless of being called inside a kernel
     * execution.
     */ clone(x) {
        const y = $249f84ddb1ced836$export$33b63313cc511a3b.runKernel((0, $hl418.Identity), {
            x: x
        });
        const inputs = {
            x: x
        };
        const grad = (dy)=>({
                x: ()=>{
                    const dtype = 'float32';
                    const gradInputs = {
                        x: dy
                    };
                    const attrs = {
                        dtype: dtype
                    };
                    return $249f84ddb1ced836$export$33b63313cc511a3b.runKernel((0, $hl418.Cast), gradInputs, // tslint:disable-next-line: no-unnecessary-type-assertion
                    attrs);
                }
            });
        const saved = [];
        this.addTapeNode(this.state.activeScope.name, inputs, [
            y
        ], grad, saved, {});
        return y;
    }
    /**
     * Execute a kernel with the given name and return the output tensor.
     *
     * @param kernelName The name of the kernel to execute.
     * @param inputs A map of input names to tensors.
     * @param attrs A map of attribute names to their values. An attribute is a
     *     primitive (non-tensor) input to the kernel.
     * @param inputsToSave A list of tensors, inputs to save for the backprop
     *     computation.
     * @param outputsToSave A list of booleans, specifying which output to save
     *     for the backprop computation. These are booleans since the output
     * tensors are not visible to the user.
     */ runKernel(kernelName, inputs, attrs) {
        if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
        // can be deferred until an op/ kernel is run).
        // The below getter has side effects that will try to initialize the
        // backend and set properties like this.backendName
        // tslint:disable-next-line: no-unused-expression
        this.backend;
        const hasKernel = (0, $eky5o.getKernel)(kernelName, this.backendName) != null;
        if (!hasKernel) throw new Error(`Kernel '${kernelName}' not registered for backend '${this.backendName}'`);
        return this.runKernelFunc({
            kernelName: kernelName,
            inputs: inputs,
            attrs: attrs
        });
    }
    shouldCheckForMemLeaks() {
        return this.ENV.getBool('IS_TEST');
    }
    checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos) {
        const numDataIdsAfter = this.backend.numDataIds();
        // Count the number of data ids associated with the result of the kernel.
        let numOutputDataIds = 0;
        outInfos.forEach((info)=>{
            // Complex numbers allocate 3 data ids, one for 'real', one for
            // 'imaginary', and one for the container that holds the former two.
            numOutputDataIds += info.dtype === 'complex64' ? 3 : 1;
        });
        // Account for the number of moves during kernel execution. A "data move"
        // can happen in the middle of a kernel execution, placing a new (key,value)
        // pair in the data storage. Since data moves have net zero effect (we
        // always remove the data from the old backend), we have to cancel them out
        // when detecting memory leaks.
        const numMoves = this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1];
        const dataIdsLeaked = numDataIdsAfter - numDataIdsBefore - numOutputDataIds - numMoves;
        if (dataIdsLeaked > 0) throw new Error(`Backend '${this.backendName}' has an internal memory leak ` + `(${dataIdsLeaked} data ids) after running '${kernelName}'`);
    }
    /**
     * Internal helper method to execute a kernel Func
     *
     * Use `runKernel` to execute kernels from outside of engine.
     */ runKernelFunc(kernelParams) {
        let outputs;
        let saved = [];
        const isTapeOn = this.isTapeOn();
        const startingBytecount = this.state.numBytes;
        const startingNumTensors = this.state.numTensors;
        if (this.shouldCheckForMemLeaks()) this.state.numDataMovesStack.push(0);
        let kernelFunc;
        if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
        // can be deferred until an op/ kernel is run).
        // The below getter has side effects that will try to initialize the
        // backend and set properties like this.backendName
        // tslint:disable-next-line: no-unused-expression
        this.backend;
        let out;
        const kernelOrScopeName = $249f84ddb1ced836$var$isRegisteredKernelInvocation(kernelParams) ? kernelParams.kernelName : this.state.activeScope != null ? this.state.activeScope.name : '';
        // Create the kernelFunc from either a registered kernel OR passed in
        // forward/backward functions (used by custom grad). In this context a
        // kernelFunc wraps a kernel implementation with some bookkeeping.
        if ($249f84ddb1ced836$var$isRegisteredKernelInvocation(kernelParams)) {
            const { kernelName: kernelName, inputs: inputs, attrs: attrs } = kernelParams;
            if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
            // can be deferred until an op/ kernel is run).
            // The below getter has side effects that will try to initialize the
            // backend and set properties like this.backendName
            // tslint:disable-next-line: no-unused-expression
            this.backend;
            const kernel = (0, $eky5o.getKernel)(kernelName, this.backendName);
            $8cCb2.assert(kernel != null, ()=>`Cannot find registered kernel '${kernelName}' for backend '${this.backendName}'`);
            kernelFunc = ()=>{
                const numDataIdsBefore = this.backend.numDataIds();
                out = kernel.kernelFunc({
                    inputs: inputs,
                    attrs: attrs,
                    backend: this.backend
                });
                const outInfos = Array.isArray(out) ? out : [
                    out
                ];
                if (this.shouldCheckForMemLeaks()) this.checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos);
                const outTensors = outInfos.map((outInfo)=>{
                    // todo (yassogba) remove this option (Tensor) when node backend
                    // methods have been modularized and they all return tensorInfo.
                    // TensorInfos do not have a rank attribute.
                    if (outInfo.rank != null) return outInfo;
                    return this.makeTensorFromTensorInfo(outInfo);
                });
                // Save any required inputs and outputs.
                // Do not save unless we are recording to the tape. Otherwise it would
                // cause a mem leak since there would be no backprop for these tensors
                // (which would otherwise dispose them).
                if (isTapeOn) {
                    const tensorsToSave = this.getTensorsForGradient(kernelName, inputs, outTensors);
                    saved = this.saveTensorsForBackwardMode(tensorsToSave);
                }
                return outTensors;
            };
        } else {
            const { forwardFunc: forwardFunc } = kernelParams;
            // Running a customGrad op.
            const saveFunc = (tensors)=>{
                // Do not save unless we are recording to the tape. Otherwise it would
                // cause a mem leak since we would never run backprop, which disposes
                // the kept tensors.
                if (!isTapeOn) return;
                saved = tensors.map((tensor)=>this.keep(this.clone(tensor)));
            };
            kernelFunc = ()=>{
                const numDataIdsBefore = this.backend.numDataIds();
                out = this.tidy(()=>forwardFunc(this.backend, saveFunc));
                const outs = Array.isArray(out) ? out : [
                    out
                ];
                if (this.shouldCheckForMemLeaks()) // Scope name is used to print a more helpful error message if needed.
                this.checkKernelForMemLeak(kernelOrScopeName, numDataIdsBefore, outs);
                return outs;
            };
        }
        //
        // Run the kernelFunc. Optionally profiling it.
        //
        const { inputs: inputs, attrs: attrs } = kernelParams;
        const backwardsFunc = $249f84ddb1ced836$var$isRegisteredKernelInvocation(kernelParams) ? null : kernelParams.backwardsFunc;
        let kernelProfile;
        this.scopedRun(// Stop recording to a tape when running a kernel.
        ()=>this.state.kernelDepth++, ()=>this.state.kernelDepth--, ()=>{
            if (!this.ENV.getBool('DEBUG') && !this.state.profiling) outputs = kernelFunc();
            else {
                kernelProfile = this.profiler.profileKernel(kernelOrScopeName, inputs, ()=>kernelFunc());
                if (this.ENV.getBool('DEBUG')) this.profiler.logKernelProfile(kernelProfile);
                outputs = kernelProfile.outputs;
            }
        });
        if (isTapeOn) this.addTapeNode(kernelOrScopeName, inputs, outputs, backwardsFunc, saved, attrs);
        if (this.state.profiling) this.state.activeProfile.kernels.push({
            name: kernelOrScopeName,
            bytesAdded: this.state.numBytes - startingBytecount,
            totalBytesSnapshot: this.state.numBytes,
            tensorsAdded: this.state.numTensors - startingNumTensors,
            totalTensorsSnapshot: this.state.numTensors,
            inputShapes: Object.keys(inputs).map((key)=>inputs[key] != null ? inputs[key].shape : null),
            outputShapes: outputs.map((item)=>item.shape),
            kernelTimeMs: kernelProfile.timeMs,
            extraInfo: kernelProfile.extraInfo
        });
        return Array.isArray(out) ? outputs : outputs[0];
    }
    /**
     * Saves tensors used in forward mode for use in backward mode.
     *
     * @param tensors the list of tensors to save.
     */ saveTensorsForBackwardMode(tensors) {
        const saved = tensors.map((tensor)=>this.keep(this.clone(tensor)));
        return saved;
    }
    /**
     * Returns a list of tensors to save for a given gradient calculation.
     *
     * @param kernelName name of kernel to look up gradient for.
     * @param inputs a map of input tensors.
     * @param outputs an array of output tensors from forward mode of kernel.
     */ getTensorsForGradient(kernelName, inputs, outputs) {
        const gradConfig = (0, $eky5o.getGradient)(kernelName);
        if (gradConfig != null) {
            const inputsToSave = gradConfig.inputsToSave || [];
            const outputsToSave = gradConfig.outputsToSave || [];
            // If saveAllInputs is true, all inputs will be saved. Otherwise, inputs
            // specified in inputsToSave will be saved.
            let inputTensorsToSave;
            if (gradConfig.saveAllInputs) {
                $8cCb2.assert(Array.isArray(inputs), ()=>'saveAllInputs is true, expected inputs to be an array.');
                inputTensorsToSave = Object.keys(inputs).map((key)=>inputs[key]);
            } else inputTensorsToSave = inputsToSave.map((inputName)=>inputs[inputName]);
            const outputTensorsToSave = outputs.filter((_, i)=>outputsToSave[i]);
            return inputTensorsToSave.concat(outputTensorsToSave);
        }
        // We return an empty list rather than throw an error because the kernel we
        // are looking up may not actually be relevant to backproping through the
        // overall function
        //
        // See 'does not error if irrelevant (pruned) ops are missing grads' test
        // in gradients_test.ts for an example.
        return [];
    }
    /**
     * Internal method used by public APIs for tensor creation. Makes a new
     * tensor with the provided shape, dtype and values. It always
     * creates a new data id and writes the values to the underlying backend.
     */ makeTensor(values, shape, dtype, backend) {
        if (values == null) throw new Error('Values passed to engine.makeTensor() are null');
        dtype = dtype || 'float32';
        backend = backend || this.backend;
        let backendVals = values;
        if (dtype === 'string' && $8cCb2.isString(values[0])) backendVals = values.map((d)=>$jjNRA.encodeString(d));
        const dataId = backend.write(backendVals, shape, dtype);
        const t = new (0, $9jCh7.Tensor)(shape, dtype, dataId, this.nextTensorId());
        this.trackTensor(t, backend);
        // Count bytes for string tensors.
        if (dtype === 'string') {
            const info = this.state.tensorInfo.get(dataId);
            const newBytes = (0, $8cCb2.bytesFromStringArray)(backendVals);
            this.state.numBytes += newBytes - info.bytes;
            info.bytes = newBytes;
        }
        return t;
    }
    /**
     * Internal method used by backends. Makes a new tensor
     * that is a wrapper around an existing data id. It doesn't create
     * a new data id, only increments the ref count used in memory tracking.
     * @deprecated
     */ makeTensorFromDataId(dataId, shape, dtype, backend) {
        dtype = dtype || 'float32';
        const tensorInfo = {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
        return this.makeTensorFromTensorInfo(tensorInfo, backend);
    }
    /**
     * Internal method used by backends. Makes a new tensor that is a wrapper
     * around an existing data id in TensorInfo. It doesn't create a new data id,
     * only increments the ref count used in memory tracking.
     */ makeTensorFromTensorInfo(tensorInfo, backend) {
        const { dataId: dataId, shape: shape, dtype: dtype } = tensorInfo;
        const t = new (0, $9jCh7.Tensor)(shape, dtype, dataId, this.nextTensorId());
        this.trackTensor(t, backend);
        return t;
    }
    makeVariable(initialValue, trainable = true, name, dtype) {
        name = name || this.nextVariableId().toString();
        if (dtype != null && dtype !== initialValue.dtype) initialValue = initialValue.cast(dtype);
        const v = new (0, $9jCh7.Variable)(initialValue, trainable, name, this.nextTensorId());
        if (this.state.registeredVariables[v.name] != null) throw new Error(`Variable with name ${v.name} was already registered`);
        this.state.registeredVariables[v.name] = v;
        this.incRef(v, this.backend);
        return v;
    }
    trackTensor(a, backend) {
        this.state.numTensors++;
        if (a.dtype === 'string') this.state.numStringTensors++;
        // Bytes for complex numbers are counted by their components. Bytes for
        // string tensors are counted when writing values.
        let bytes = 0;
        if (a.dtype !== 'complex64' && a.dtype !== 'string') bytes = a.size * $8cCb2.bytesPerElement(a.dtype);
        this.state.numBytes += bytes;
        if (!this.state.tensorInfo.has(a.dataId)) {
            this.state.numDataBuffers++;
            this.state.tensorInfo.set(a.dataId, {
                backend: backend || this.backend,
                dtype: a.dtype,
                shape: a.shape,
                bytes: bytes
            });
        }
        if (!(a instanceof (0, $9jCh7.Variable))) this.track(a);
    }
    // Track the tensor by dataId and increase the refCount for the dataId in the
    // backend.
    // TODO(pyu10055): This is currently used by makeVariable method, to increase
    // refCount on the backend for the dataId. It can potentially be replaced with
    // Identity op indead of calling backend directly.
    incRef(a, backend) {
        this.trackTensor(a, backend);
        this.backend.incRef(a.dataId);
    }
    removeDataId(dataId, backend) {
        if (this.state.tensorInfo.has(dataId) && this.state.tensorInfo.get(dataId).backend === backend) {
            this.state.tensorInfo.delete(dataId);
            this.state.numDataBuffers--;
        }
    }
    disposeTensor(a) {
        if (!this.state.tensorInfo.has(a.dataId)) return;
        const info = this.state.tensorInfo.get(a.dataId);
        this.state.numTensors--;
        if (a.dtype === 'string') {
            this.state.numStringTensors--;
            this.state.numBytes -= info.bytes;
        }
        // Don't count bytes for complex numbers as they are counted by their
        // components.
        if (a.dtype !== 'complex64' && a.dtype !== 'string') {
            const bytes = a.size * $8cCb2.bytesPerElement(a.dtype);
            this.state.numBytes -= bytes;
        }
        // Remove the reference to dataId if backend dispose the data successfully
        if (info.backend.disposeData(a.dataId)) this.removeDataId(a.dataId, info.backend);
    // TODO(nsthorat): Construct an error and save the stack trace for
    // debugging when in debug mode. Creating a stack trace is too expensive
    // to do unconditionally.
    }
    disposeVariables() {
        for(const varName in this.state.registeredVariables){
            const v = this.state.registeredVariables[varName];
            this.disposeVariable(v);
        }
    }
    disposeVariable(v) {
        this.disposeTensor(v);
        if (this.state.registeredVariables[v.name] != null) delete this.state.registeredVariables[v.name];
    }
    memory() {
        const info = this.backend.memory();
        info.numTensors = this.state.numTensors;
        info.numDataBuffers = this.state.numDataBuffers;
        info.numBytes = this.state.numBytes;
        if (this.state.numStringTensors > 0) {
            info.unreliable = true;
            if (info.reasons == null) info.reasons = [];
            info.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)");
        }
        return info;
    }
    async profile(query) {
        this.state.profiling = true;
        const startBytes = this.state.numBytes;
        const startNumTensors = this.state.numTensors;
        this.state.activeProfile.kernels = [];
        this.state.activeProfile.result = await query();
        this.state.profiling = false;
        this.state.activeProfile.peakBytes = Math.max(...this.state.activeProfile.kernels.map((d)=>d.totalBytesSnapshot));
        this.state.activeProfile.newBytes = this.state.numBytes - startBytes;
        this.state.activeProfile.newTensors = this.state.numTensors - startNumTensors;
        for (const kernel of this.state.activeProfile.kernels){
            kernel.kernelTimeMs = await kernel.kernelTimeMs;
            kernel.extraInfo = await kernel.extraInfo;
        }
        return this.state.activeProfile;
    }
    isTapeOn() {
        return this.state.gradientDepth > 0 && this.state.kernelDepth === 0;
    }
    addTapeNode(kernelName, inputs, outputs, gradientsFunc, saved, attrs) {
        const tapeNode = {
            id: this.state.nextTapeNodeId++,
            kernelName: kernelName,
            inputs: inputs,
            outputs: outputs,
            saved: saved
        };
        const gradConfig = (0, $eky5o.getGradient)(kernelName);
        if (gradConfig != null) gradientsFunc = gradConfig.gradFunc;
        if (gradientsFunc != null) tapeNode.gradient = (dys)=>{
            // TODO(smilkov): To optimize back-prop, pass dys that are not used in
            // the backprop graph to the user as null instead of zeros
            dys = dys.map((dy, i)=>{
                if (dy == null) {
                    const output = outputs[i];
                    const vals = $8cCb2.makeZerosTypedArray(output.size, output.dtype);
                    return this.makeTensor(vals, output.shape, output.dtype);
                }
                return dy;
            });
            // Grad functions of ops with single outputs expect a dy, while ops
            // with multiple outputs expect dys (array of dy).
            return gradientsFunc(dys.length > 1 ? dys : dys[0], saved, attrs);
        };
        this.state.activeTape.push(tapeNode);
    }
    keep(result) {
        result.kept = true;
        return result;
    }
    startTape() {
        if (this.state.gradientDepth === 0) this.state.activeTape = [];
        this.state.gradientDepth++;
    }
    endTape() {
        this.state.gradientDepth--;
    }
    /**
     * Start a scope. Use this with endScope() to achieve the same functionality
     * as scope() without the need for a function closure.
     */ startScope(name) {
        const scopeInfo = {
            track: [],
            name: 'unnamed scope',
            id: this.state.nextScopeId++
        };
        if (name) scopeInfo.name = name;
        this.state.scopeStack.push(scopeInfo);
        this.state.activeScope = scopeInfo;
    }
    /**
     * End a scope. Use this with startScope() to achieve the same functionality
     * as scope() without the need for a function closure.
     */ endScope(result) {
        const tensorsToTrackInParent = (0, $3w4Rg.getTensorsInContainer)(result);
        const tensorsToTrackInParentSet = new Set(tensorsToTrackInParent.map((t)=>t.id));
        // Dispose the arrays tracked in this scope.
        for(let i = 0; i < this.state.activeScope.track.length; i++){
            const tensor = this.state.activeScope.track[i];
            if (!tensor.kept && !tensorsToTrackInParentSet.has(tensor.id)) tensor.dispose();
        }
        const oldScope = this.state.scopeStack.pop();
        this.state.activeScope = this.state.scopeStack.length === 0 ? null : this.state.scopeStack[this.state.scopeStack.length - 1];
        // Track the current result in the parent scope.
        tensorsToTrackInParent.forEach((tensor)=>{
            // Only track the tensor if was allocated in the inner scope and is not
            // globally kept.
            if (!tensor.kept && tensor.scopeId === oldScope.id) this.track(tensor);
        });
    }
    /**
     * Returns gradients of `f` with respect to each of the `xs`. The gradients
     * returned are of the same length as `xs`, but some might be null if `f`
     * was not a function of that `x`. It also takes optional dy to multiply the
     * gradient, which defaults to `1`.
     */ gradients(f, xs, dy, allowNoGradients = false) {
        $8cCb2.assert(xs.length > 0, ()=>'gradients() received an empty list of xs.');
        if (dy != null && dy.dtype !== 'float32') throw new Error(`dy must have 'float32' dtype, but has '${dy.dtype}'`);
        const y = this.scopedRun(()=>this.startTape(), ()=>this.endTape(), ()=>this.tidy('forward', f));
        $8cCb2.assert(y instanceof (0, $9jCh7.Tensor), ()=>'The result y returned by f() must be a tensor.');
        // Filter out the nodes that don't connect x => y.
        const filteredTape = (0, $8zD9D.getFilteredNodesXToY)(this.state.activeTape, xs, y);
        if (!allowNoGradients && filteredTape.length === 0 && xs.length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
        return this.tidy('backward', ()=>{
            const accumulatedGradientMap = {};
            accumulatedGradientMap[y.id] = dy == null ? $249f84ddb1ced836$var$ones(y.shape) : dy;
            // Backprop gradients through the filtered nodes.
            (0, $8zD9D.backpropagateGradients)(accumulatedGradientMap, filteredTape, // Pass the tidy function to avoid circular dep with `tape.ts`.
            (f)=>this.tidy(f), // Pass an add function to avoide a circular dep with `tape.ts`.
            $249f84ddb1ced836$export$e16d8520af44a096);
            const grads = xs.map((x)=>accumulatedGradientMap[x.id]);
            if (this.state.gradientDepth === 0) {
                // This means that we are not computing higher-order gradients
                // and can clean up the tape.
                this.state.activeTape.forEach((node)=>{
                    for (const tensor of node.saved)tensor.dispose();
                });
                this.state.activeTape = null;
            }
            return {
                value: y,
                grads: grads
            };
        });
    }
    customGrad(f) {
        $8cCb2.assert($8cCb2.isFunction(f), ()=>'The f passed in customGrad(f) must be a function.');
        return (...inputs)=>{
            $8cCb2.assert(inputs.every((t)=>t instanceof (0, $9jCh7.Tensor)), ()=>"The args passed in customGrad(f)(x1, x2,...) must all be tensors");
            let res;
            const inputMap = {};
            inputs.forEach((input, i)=>{
                inputMap[i] = input;
            });
            const forwardFunc = (_, save)=>{
                res = f(...[
                    ...inputs,
                    save
                ]);
                $8cCb2.assert(res.value instanceof (0, $9jCh7.Tensor), ()=>"The function f passed in customGrad(f) must return an object where `obj.value` is a tensor");
                $8cCb2.assert($8cCb2.isFunction(res.gradFunc), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function.");
                return res.value;
            };
            const backwardsFunc = (dy, saved)=>{
                const gradRes = res.gradFunc(dy, saved);
                const grads = Array.isArray(gradRes) ? gradRes : [
                    gradRes
                ];
                $8cCb2.assert(grads.length === inputs.length, ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...).");
                $8cCb2.assert(grads.every((t)=>t instanceof (0, $9jCh7.Tensor)), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors.");
                const gradMap = {};
                grads.forEach((grad, i)=>{
                    gradMap[i] = ()=>grad;
                });
                return gradMap;
            };
            return this.runKernelFunc({
                forwardFunc: forwardFunc,
                backwardsFunc: backwardsFunc,
                inputs: inputMap
            });
        };
    }
    readSync(dataId) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.readSync(dataId);
    }
    read(dataId) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.read(dataId);
    }
    readToGPU(dataId, options) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.readToGPU(dataId, options);
    }
    async time(query) {
        const start = (0, $jjNRA.now)();
        const timingInfo = await this.backend.time(query);
        timingInfo.wallMs = (0, $jjNRA.now)() - start;
        return timingInfo;
    }
    /**
     * Tracks a Tensor in the current scope to be automatically cleaned up
     * when the current scope ends, and returns the value.
     *
     * @param result The Tensor to track in the current scope.
     */ track(result) {
        if (this.state.activeScope != null) {
            result.scopeId = this.state.activeScope.id;
            this.state.activeScope.track.push(result);
        }
        return result;
    }
    get registeredVariables() {
        return this.state.registeredVariables;
    }
    /**
     * Resets the engine state. Removes all backends but does not remove
     * registered backend factories.
     */ reset() {
        // Make any pending promise obsolete.
        this.pendingBackendInitId++;
        this.state.dispose();
        this.ENV.reset();
        this.state = new $249f84ddb1ced836$var$EngineState();
        for(const backendName in this.registry){
            this.disposeRegisteredKernels(backendName);
            this.registry[backendName].dispose();
            delete this.registry[backendName];
        }
        this.backendName = null;
        this.backendInstance = null;
        this.pendingBackendInit = null;
    }
}
$249f84ddb1ced836$export$2c3b404bf3a77a1f.nextTensorId = 0;
$249f84ddb1ced836$export$2c3b404bf3a77a1f.nextVariableId = 0;
function $249f84ddb1ced836$var$ones(shape) {
    const values = (0, $8cCb2.makeOnesTypedArray)((0, $8cCb2.sizeFromShape)(shape), 'float32');
    return $249f84ddb1ced836$export$33b63313cc511a3b.makeTensor(values, shape, 'float32');
}
function $249f84ddb1ced836$export$ca8737f6c8c212b8() {
    const ns = (0, $grcJs.getGlobalNamespace)();
    if (ns._tfengine == null) {
        const environment = new (0, $ibsdL.Environment)(ns);
        ns._tfengine = new $249f84ddb1ced836$export$2c3b404bf3a77a1f(environment);
    }
    (0, $ibsdL.setEnvironmentGlobal)(ns._tfengine.ENV);
    // Tell the current tensor interface that the global engine is responsible
    // for tracking.
    (0, $9jCh7.setTensorTracker)(()=>ns._tfengine);
    return ns._tfengine;
}
const $249f84ddb1ced836$export$33b63313cc511a3b = $249f84ddb1ced836$export$ca8737f6c8c212b8();
function $249f84ddb1ced836$export$e16d8520af44a096(a, b) {
    // We duplicate Add here to avoid a circular dependency with add.ts.
    const inputs = {
        a: a,
        b: b
    };
    return $249f84ddb1ced836$export$33b63313cc511a3b.runKernel((0, $hl418.Add), inputs);
}

});
parcelRegister("fJqML", function(module, exports) {

$parcel$export(module.exports, "DataStorage", () => $b73fd602f21aa26c$export$e95767ffe2e60cec);
$parcel$export(module.exports, "KernelBackend", () => $b73fd602f21aa26c$export$543916c62202b50a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $b73fd602f21aa26c$export$76e53a66c52b6d4d = 1e-7;
const $b73fd602f21aa26c$export$49716d145771e6a2 = 1e-4;
class $b73fd602f21aa26c$export$e95767ffe2e60cec {
    constructor(backend, dataMover){
        this.backend = backend;
        this.dataMover = dataMover;
        this.data = new WeakMap();
        this.dataIdsCount = 0;
    }
    get(dataId) {
        if (!this.data.has(dataId)) this.dataMover.moveData(this.backend, dataId);
        return this.data.get(dataId);
    }
    set(dataId, value) {
        this.dataIdsCount++;
        this.data.set(dataId, value);
    }
    has(dataId) {
        return this.data.has(dataId);
    }
    delete(dataId) {
        this.dataIdsCount--;
        return this.data.delete(dataId);
    }
    numDataIds() {
        return this.dataIdsCount;
    }
}
class $b73fd602f21aa26c$export$543916c62202b50a {
    refCount(dataId) {
        return $b73fd602f21aa26c$var$notYetImplemented('refCount');
    }
    incRef(dataId) {
        return $b73fd602f21aa26c$var$notYetImplemented('incRef');
    }
    timerAvailable() {
        return true;
    }
    time(f) {
        return $b73fd602f21aa26c$var$notYetImplemented('time');
    }
    read(dataId) {
        return $b73fd602f21aa26c$var$notYetImplemented('read');
    }
    readSync(dataId) {
        return $b73fd602f21aa26c$var$notYetImplemented('readSync');
    }
    readToGPU(dataId, options) {
        return $b73fd602f21aa26c$var$notYetImplemented('readToGPU');
    }
    numDataIds() {
        return $b73fd602f21aa26c$var$notYetImplemented('numDataIds');
    }
    disposeData(dataId, force) {
        return $b73fd602f21aa26c$var$notYetImplemented('disposeData');
    }
    write(values, shape, dtype) {
        return $b73fd602f21aa26c$var$notYetImplemented('write');
    }
    move(dataId, values, shape, dtype, refCount) {
        return $b73fd602f21aa26c$var$notYetImplemented('move');
    }
    createTensorFromGPUData(values, shape, dtype) {
        return $b73fd602f21aa26c$var$notYetImplemented('createTensorFromGPUData');
    }
    memory() {
        return $b73fd602f21aa26c$var$notYetImplemented('memory');
    }
    /** Returns the highest precision for floats in bits (e.g. 16 or 32) */ floatPrecision() {
        return $b73fd602f21aa26c$var$notYetImplemented('floatPrecision');
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? $b73fd602f21aa26c$export$76e53a66c52b6d4d : $b73fd602f21aa26c$export$49716d145771e6a2;
    }
    dispose() {
        return $b73fd602f21aa26c$var$notYetImplemented('dispose');
    }
}
function $b73fd602f21aa26c$var$notYetImplemented(kernelName) {
    throw new Error(`'${kernelName}' not yet implemented or not found in the registry. ` + `This kernel may not be supported by the tfjs backend you have chosen`);
}

});

parcelRegister("ibsdL", function(module, exports) {

$parcel$export(module.exports, "Environment", () => $d3cf252ef4ef8e7f$export$7dc6752a22ab011a);
$parcel$export(module.exports, "env", () => $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3);
$parcel$export(module.exports, "setEnvironmentGlobal", () => $d3cf252ef4ef8e7f$export$3ef32a49eeda04cc);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
// Expects flags from URL in the format ?tfjsflags=FLAG1:1,FLAG2:true.
const $d3cf252ef4ef8e7f$var$TENSORFLOWJS_FLAGS_PREFIX = 'tfjsflags';
class $d3cf252ef4ef8e7f$export$7dc6752a22ab011a {
    // tslint:disable-next-line: no-any
    constructor(global){
        this.global = global;
        this.flags = {};
        this.flagRegistry = {};
        this.urlFlags = {};
        // Jasmine spies on this in 'environment_test.ts'
        this.getQueryParams = $d3cf252ef4ef8e7f$export$e2de15bbd9edf9c6;
        this.populateURLFlags();
    }
    setPlatform(platformName, platform) {
        if (this.platform != null) {
            if (!($d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3().getBool('IS_TEST') || $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3().getBool('PROD'))) console.warn(`Platform ${this.platformName} has already been set. ` + `Overwriting the platform with ${platformName}.`);
        }
        this.platformName = platformName;
        this.platform = platform;
    }
    registerFlag(flagName, evaluationFn, setHook) {
        this.flagRegistry[flagName] = {
            evaluationFn: evaluationFn,
            setHook: setHook
        };
        // Override the flag value from the URL. This has to happen here because
        // the environment is initialized before flags get registered.
        if (this.urlFlags[flagName] != null) {
            const flagValue = this.urlFlags[flagName];
            if (!($d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3().getBool('IS_TEST') || $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3().getBool('PROD'))) console.warn(`Setting feature override from URL ${flagName}: ${flagValue}.`);
            this.set(flagName, flagValue);
        }
    }
    async getAsync(flagName) {
        if (flagName in this.flags) return this.flags[flagName];
        this.flags[flagName] = await this.evaluateFlag(flagName);
        return this.flags[flagName];
    }
    get(flagName) {
        if (flagName in this.flags) return this.flags[flagName];
        const flagValue = this.evaluateFlag(flagName);
        if ((0, $8cCb2.isPromise)(flagValue)) throw new Error(`Flag ${flagName} cannot be synchronously evaluated. ` + `Please use getAsync() instead.`);
        this.flags[flagName] = flagValue;
        return this.flags[flagName];
    }
    getNumber(flagName) {
        return this.get(flagName);
    }
    getBool(flagName) {
        return this.get(flagName);
    }
    getString(flagName) {
        return this.get(flagName);
    }
    getFlags() {
        return this.flags;
    }
    // For backwards compatibility.
    get features() {
        return this.flags;
    }
    set(flagName, value) {
        if (this.flagRegistry[flagName] == null) throw new Error(`Cannot set flag ${flagName} as it has not been registered.`);
        this.flags[flagName] = value;
        if (this.flagRegistry[flagName].setHook != null) this.flagRegistry[flagName].setHook(value);
    }
    evaluateFlag(flagName) {
        if (this.flagRegistry[flagName] == null) throw new Error(`Cannot evaluate flag '${flagName}': no evaluation function found.`);
        return this.flagRegistry[flagName].evaluationFn();
    }
    setFlags(flags) {
        this.flags = Object.assign({}, flags);
    }
    reset() {
        this.flags = {};
        this.urlFlags = {};
        this.populateURLFlags();
    }
    populateURLFlags() {
        if (typeof this.global === 'undefined' || typeof this.global.location === 'undefined' || typeof this.global.location.search === 'undefined') return;
        const urlParams = this.getQueryParams(this.global.location.search);
        if ($d3cf252ef4ef8e7f$var$TENSORFLOWJS_FLAGS_PREFIX in urlParams) {
            const keyValues = urlParams[$d3cf252ef4ef8e7f$var$TENSORFLOWJS_FLAGS_PREFIX].split(',');
            keyValues.forEach((keyValue)=>{
                const [key, value] = keyValue.split(':');
                this.urlFlags[key] = $d3cf252ef4ef8e7f$var$parseValue(key, value);
            });
        }
    }
}
function $d3cf252ef4ef8e7f$export$e2de15bbd9edf9c6(queryString) {
    const params = {};
    queryString.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, (s, ...t)=>{
        $d3cf252ef4ef8e7f$var$decodeParam(params, t[0], t[1]);
        return t.join('=');
    });
    return params;
}
function $d3cf252ef4ef8e7f$var$decodeParam(params, name, value) {
    params[decodeURIComponent(name)] = decodeURIComponent(value || '');
}
function $d3cf252ef4ef8e7f$var$parseValue(flagName, value) {
    const lowerCaseValue = value.toLowerCase();
    if (lowerCaseValue === 'true' || lowerCaseValue === 'false') return lowerCaseValue === 'true';
    else if (`${+lowerCaseValue}` === lowerCaseValue) return +lowerCaseValue;
    else return value;
}
function $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3() {
    return $d3cf252ef4ef8e7f$export$83401e34d5e11bf4;
}
let $d3cf252ef4ef8e7f$export$83401e34d5e11bf4 = null;
function $d3cf252ef4ef8e7f$export$3ef32a49eeda04cc(environment) {
    $d3cf252ef4ef8e7f$export$83401e34d5e11bf4 = environment;
}

});
parcelRegister("8cCb2", function(module, exports) {

$parcel$export(module.exports, "shuffle", () => $5f8d0ee7a8d35dfe$export$448332262467e042);
$parcel$export(module.exports, "swap", () => $5f8d0ee7a8d35dfe$export$b0e76d9850c64156);
$parcel$export(module.exports, "shuffleCombo", () => $5f8d0ee7a8d35dfe$export$ae1498b5fd31a179);
$parcel$export(module.exports, "clamp", () => $5f8d0ee7a8d35dfe$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "nearestLargerEven", () => $5f8d0ee7a8d35dfe$export$ece2fd7300c99d1f);
$parcel$export(module.exports, "sum", () => $5f8d0ee7a8d35dfe$export$8a63f25cc62965f1);
$parcel$export(module.exports, "randUniform", () => $5f8d0ee7a8d35dfe$export$1c2519d52242937);
$parcel$export(module.exports, "distSquared", () => $5f8d0ee7a8d35dfe$export$499eb56409f6cbc2);
$parcel$export(module.exports, "assert", () => $5f8d0ee7a8d35dfe$export$a7a9523472993e97);
$parcel$export(module.exports, "assertShapesMatch", () => $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782);
$parcel$export(module.exports, "arraysEqual", () => $5f8d0ee7a8d35dfe$export$234180f8206db11b);
$parcel$export(module.exports, "assertNonNull", () => $5f8d0ee7a8d35dfe$export$44a06cc2759dd036);
$parcel$export(module.exports, "sizeFromShape", () => $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f);
$parcel$export(module.exports, "isScalarShape", () => $5f8d0ee7a8d35dfe$export$d58b8d1ec2129064);
$parcel$export(module.exports, "arraysEqualWithNull", () => $5f8d0ee7a8d35dfe$export$9efb31c074e61de7);
$parcel$export(module.exports, "isInt", () => $5f8d0ee7a8d35dfe$export$357fc28f6427af8b);
$parcel$export(module.exports, "tanh", () => $5f8d0ee7a8d35dfe$export$7128670e45beef9a);
$parcel$export(module.exports, "sizeToSquarishShape", () => $5f8d0ee7a8d35dfe$export$55bdc5631791c247);
$parcel$export(module.exports, "createShuffledIndices", () => $5f8d0ee7a8d35dfe$export$49070d702e17365);
$parcel$export(module.exports, "rightPad", () => $5f8d0ee7a8d35dfe$export$390245bab32fb60f);
$parcel$export(module.exports, "repeatedTry", () => $5f8d0ee7a8d35dfe$export$aa345f93372ddb7b);
$parcel$export(module.exports, "inferFromImplicitShape", () => $5f8d0ee7a8d35dfe$export$e9459a51c182ffc2);
$parcel$export(module.exports, "parseAxisParam", () => $5f8d0ee7a8d35dfe$export$72b84eb9fe1f482);
$parcel$export(module.exports, "squeezeShape", () => $5f8d0ee7a8d35dfe$export$3106ace2a3b5396d);
$parcel$export(module.exports, "getTypedArrayFromDType", () => $5f8d0ee7a8d35dfe$export$3b783bdb77632623);
$parcel$export(module.exports, "getArrayFromDType", () => $5f8d0ee7a8d35dfe$export$24f13f6206df8f7c);
$parcel$export(module.exports, "checkConversionForErrors", () => $5f8d0ee7a8d35dfe$export$579cf7b8ff0a87a3);
$parcel$export(module.exports, "isValidDtype", () => $5f8d0ee7a8d35dfe$export$a6a3df2178ac9529);
$parcel$export(module.exports, "hasEncodingLoss", () => $5f8d0ee7a8d35dfe$export$9130d84b35fa7b98);
$parcel$export(module.exports, "bytesPerElement", () => $5f8d0ee7a8d35dfe$export$3f355ce86503b89f);
$parcel$export(module.exports, "bytesFromStringArray", () => $5f8d0ee7a8d35dfe$export$c474902e1102282d);
$parcel$export(module.exports, "isString", () => $5f8d0ee7a8d35dfe$export$844ec244b1367d54);
$parcel$export(module.exports, "isBoolean", () => $5f8d0ee7a8d35dfe$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isNumber", () => $5f8d0ee7a8d35dfe$export$7e4aa119212bc614);
$parcel$export(module.exports, "inferDtype", () => $5f8d0ee7a8d35dfe$export$2005775d905d2dc2);
$parcel$export(module.exports, "isFunction", () => $5f8d0ee7a8d35dfe$export$f6e2535fb5126e54);
$parcel$export(module.exports, "nearestDivisor", () => $5f8d0ee7a8d35dfe$export$c0ff3276320ddb5e);
$parcel$export(module.exports, "computeStrides", () => $5f8d0ee7a8d35dfe$export$6ad0292cf4d50f79);
$parcel$export(module.exports, "toNestedArray", () => $5f8d0ee7a8d35dfe$export$3983c25181aa68cc);
$parcel$export(module.exports, "convertBackendValuesAndArrayBuffer", () => $5f8d0ee7a8d35dfe$export$568d15cfc23dac5d);
$parcel$export(module.exports, "makeOnesTypedArray", () => $5f8d0ee7a8d35dfe$export$b915f681a907ae99);
$parcel$export(module.exports, "makeZerosTypedArray", () => $5f8d0ee7a8d35dfe$export$edbc8aedac4e036f);
$parcel$export(module.exports, "makeZerosNestedTypedArray", () => $5f8d0ee7a8d35dfe$export$eef638260c005c74);
$parcel$export(module.exports, "assertNonNegativeIntegerDimensions", () => $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5);
$parcel$export(module.exports, "locToIndex", () => $5f8d0ee7a8d35dfe$export$a14b009c502dc3b4);
$parcel$export(module.exports, "indexToLoc", () => $5f8d0ee7a8d35dfe$export$2d1ada4c755a8699);
$parcel$export(module.exports, "isPromise", () => $5f8d0ee7a8d35dfe$export$4369c812aac99591);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Shuffles the array in-place using Fisher-Yates algorithm.
 *
 * ```js
 * const a = [1, 2, 3, 4, 5];
 * tf.util.shuffle(a);
 * console.log(a);
 * ```
 *
 * @param array The array to shuffle in-place.
 *
 * @doc {heading: 'Util', namespace: 'util'}
 */ // tslint:disable-next-line:no-any
function $5f8d0ee7a8d35dfe$export$448332262467e042(array) {
    let counter = array.length;
    let index = 0;
    // While there are elements in the array
    while(counter > 0){
        // Pick a random index
        index = Math.random() * counter | 0;
        // Decrease counter by 1
        counter--;
        // And swap the last element with it
        $5f8d0ee7a8d35dfe$export$b0e76d9850c64156(array, counter, index);
    }
}
function $5f8d0ee7a8d35dfe$export$ae1498b5fd31a179(// tslint:disable-next-line:no-any
array, // tslint:disable-next-line:no-any
array2) {
    if (array.length !== array2.length) throw new Error(`Array sizes must match to be shuffled together ` + `First array length was ${array.length}` + `Second array length was ${array2.length}`);
    let counter = array.length;
    let index = 0;
    // While there are elements in the array
    while(counter > 0){
        // Pick a random index
        index = Math.random() * counter | 0;
        // Decrease counter by 1
        counter--;
        // And swap the last element of each array with it
        $5f8d0ee7a8d35dfe$export$b0e76d9850c64156(array, counter, index);
        $5f8d0ee7a8d35dfe$export$b0e76d9850c64156(array2, counter, index);
    }
}
function $5f8d0ee7a8d35dfe$export$7d15b64cf5a3a4c4(min, x, max) {
    return Math.max(min, Math.min(x, max));
}
function $5f8d0ee7a8d35dfe$export$ece2fd7300c99d1f(val) {
    return val % 2 === 0 ? val : val + 1;
}
function $5f8d0ee7a8d35dfe$export$b0e76d9850c64156(object, left, right) {
    const temp = object[left];
    object[left] = object[right];
    object[right] = temp;
}
function $5f8d0ee7a8d35dfe$export$8a63f25cc62965f1(arr) {
    let sum = 0;
    for(let i = 0; i < arr.length; i++)sum += arr[i];
    return sum;
}
function $5f8d0ee7a8d35dfe$export$1c2519d52242937(a, b) {
    const r = Math.random();
    return b * r + (1 - r) * a;
}
function $5f8d0ee7a8d35dfe$export$499eb56409f6cbc2(a, b) {
    let result = 0;
    for(let i = 0; i < a.length; i++){
        const diff = Number(a[i]) - Number(b[i]);
        result += diff * diff;
    }
    return result;
}
function $5f8d0ee7a8d35dfe$export$a7a9523472993e97(expr, msg) {
    if (!expr) throw new Error(typeof msg === 'string' ? msg : msg());
}
function $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782(shapeA, shapeB, errorMessagePrefix = '') {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$234180f8206db11b(shapeA, shapeB), ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
}
function $5f8d0ee7a8d35dfe$export$44a06cc2759dd036(a) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(a != null, ()=>`The input to the tensor constructor must be a non-null value.`);
}
function $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f(shape) {
    if (shape.length === 0) // Scalar.
    return 1;
    let size = shape[0];
    for(let i = 1; i < shape.length; i++)size *= shape[i];
    return size;
}
function $5f8d0ee7a8d35dfe$export$d58b8d1ec2129064(shape) {
    return shape.length === 0;
}
function $5f8d0ee7a8d35dfe$export$9efb31c074e61de7(n1, n2) {
    if (n1 === n2) return true;
    if (n1 == null || n2 == null) return false;
    if (n1.length !== n2.length) return false;
    for(let i = 0; i < n1.length; i++){
        if (n1[i] !== null && n2[i] !== null && n1[i] !== n2[i]) return false;
    }
    return true;
}
function $5f8d0ee7a8d35dfe$export$234180f8206db11b(n1, n2) {
    if (n1 === n2) return true;
    if (n1 == null || n2 == null) return false;
    if (n1.length !== n2.length) return false;
    for(let i = 0; i < n1.length; i++){
        if (n1[i] !== n2[i]) return false;
    }
    return true;
}
function $5f8d0ee7a8d35dfe$export$357fc28f6427af8b(a) {
    return a % 1 === 0;
}
function $5f8d0ee7a8d35dfe$export$7128670e45beef9a(x) {
    // tslint:disable-next-line:no-any
    if (Math.tanh != null) // tslint:disable-next-line:no-any
    return Math.tanh(x);
    if (x === Infinity) return 1;
    else if (x === -Infinity) return -1;
    else {
        const e2x = Math.exp(2 * x);
        return (e2x - 1) / (e2x + 1);
    }
}
function $5f8d0ee7a8d35dfe$export$55bdc5631791c247(size) {
    const width = Math.ceil(Math.sqrt(size));
    return [
        width,
        Math.ceil(size / width)
    ];
}
function $5f8d0ee7a8d35dfe$export$49070d702e17365(n) {
    const shuffledIndices = new Uint32Array(n);
    for(let i = 0; i < n; ++i)shuffledIndices[i] = i;
    $5f8d0ee7a8d35dfe$export$448332262467e042(shuffledIndices);
    return shuffledIndices;
}
function $5f8d0ee7a8d35dfe$export$390245bab32fb60f(a, size) {
    if (size <= a.length) return a;
    return a + ' '.repeat(size - a.length);
}
function $5f8d0ee7a8d35dfe$export$aa345f93372ddb7b(checkFn, delayFn = (counter)=>0, maxCounter, scheduleFn) {
    return new Promise((resolve, reject)=>{
        let tryCount = 0;
        const tryFn = ()=>{
            if (checkFn()) {
                resolve();
                return;
            }
            tryCount++;
            const nextBackoff = delayFn(tryCount);
            if (maxCounter != null && tryCount >= maxCounter) {
                reject();
                return;
            }
            if (scheduleFn != null) scheduleFn(tryFn, nextBackoff);
            else // google3 does not allow assigning another variable to setTimeout.
            // Don't refactor this so scheduleFn has a default value of setTimeout.
            setTimeout(tryFn, nextBackoff);
        };
        tryFn();
    });
}
function $5f8d0ee7a8d35dfe$export$e9459a51c182ffc2(shape, size) {
    let shapeProd = 1;
    let implicitIdx = -1;
    for(let i = 0; i < shape.length; ++i){
        if (shape[i] >= 0) shapeProd *= shape[i];
        else if (shape[i] === -1) {
            if (implicitIdx !== -1) throw Error(`Shapes can only have 1 implicit size. ` + `Found -1 at dim ${implicitIdx} and dim ${i}`);
            implicitIdx = i;
        } else if (shape[i] < 0) throw Error(`Shapes can not be < 0. Found ${shape[i]} at dim ${i}`);
    }
    if (implicitIdx === -1) {
        if (size > 0 && size !== shapeProd) throw Error(`Size(${size}) must match the product of shape ${shape}`);
        return shape;
    }
    if (shapeProd === 0) throw Error(`Cannot infer the missing size in [${shape}] when ` + `there are 0 elements`);
    if (size % shapeProd !== 0) throw Error(`The implicit shape can't be a fractional number. ` + `Got ${size} / ${shapeProd}`);
    const newShape = shape.slice();
    newShape[implicitIdx] = size / shapeProd;
    return newShape;
}
function $5f8d0ee7a8d35dfe$export$72b84eb9fe1f482(axis, shape) {
    const rank = shape.length;
    // Normalize input
    axis = axis == null ? shape.map((s, i)=>i) : [].concat(axis);
    // Check for valid range
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(axis.every((ax)=>ax >= -rank && ax < rank), ()=>`All values in axis param must be in range [-${rank}, ${rank}) but ` + `got axis ${axis}`);
    // Check for only integers
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(axis.every((ax)=>$5f8d0ee7a8d35dfe$export$357fc28f6427af8b(ax)), ()=>`All values in axis param must be integers but ` + `got axis ${axis}`);
    // Handle negative axis.
    return axis.map((a)=>a < 0 ? rank + a : a);
}
function $5f8d0ee7a8d35dfe$export$3106ace2a3b5396d(shape, axis) {
    const newShape = [];
    const keptDims = [];
    const isEmptyArray = axis != null && Array.isArray(axis) && axis.length === 0;
    const axes = axis == null || isEmptyArray ? null : $5f8d0ee7a8d35dfe$export$72b84eb9fe1f482(axis, shape).sort();
    let j = 0;
    for(let i = 0; i < shape.length; ++i){
        if (axes != null) {
            if (axes[j] === i && shape[i] !== 1) throw new Error(`Can't squeeze axis ${i} since its dim '${shape[i]}' is not 1`);
            if ((axes[j] == null || axes[j] > i) && shape[i] === 1) {
                newShape.push(shape[i]);
                keptDims.push(i);
            }
            if (axes[j] <= i) j++;
        }
        if (shape[i] !== 1) {
            newShape.push(shape[i]);
            keptDims.push(i);
        }
    }
    return {
        newShape: newShape,
        keptDims: keptDims
    };
}
function $5f8d0ee7a8d35dfe$export$3b783bdb77632623(dtype, size) {
    return $5f8d0ee7a8d35dfe$export$24f13f6206df8f7c(dtype, size);
}
function $5f8d0ee7a8d35dfe$export$24f13f6206df8f7c(dtype, size) {
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else if (dtype === 'string') values = new Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    return values;
}
function $5f8d0ee7a8d35dfe$export$579cf7b8ff0a87a3(vals, dtype) {
    for(let i = 0; i < vals.length; i++){
        const num = vals[i];
        if (isNaN(num) || !isFinite(num)) throw Error(`A tensor of type ${dtype} being uploaded contains ${num}.`);
    }
}
function $5f8d0ee7a8d35dfe$export$a6a3df2178ac9529(dtype) {
    return dtype === 'bool' || dtype === 'complex64' || dtype === 'float32' || dtype === 'int32' || dtype === 'string';
}
function $5f8d0ee7a8d35dfe$export$9130d84b35fa7b98(oldType, newType) {
    if (newType === 'complex64') return false;
    if (newType === 'float32' && oldType !== 'complex64') return false;
    if (newType === 'int32' && oldType !== 'float32' && oldType !== 'complex64') return false;
    if (newType === 'bool' && oldType === 'bool') return false;
    return true;
}
function $5f8d0ee7a8d35dfe$export$3f355ce86503b89f(dtype) {
    if (dtype === 'float32' || dtype === 'int32') return 4;
    else if (dtype === 'complex64') return 8;
    else if (dtype === 'bool') return 1;
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $5f8d0ee7a8d35dfe$export$c474902e1102282d(arr) {
    if (arr == null) return 0;
    let bytes = 0;
    arr.forEach((x)=>bytes += x.length);
    return bytes;
}
function $5f8d0ee7a8d35dfe$export$844ec244b1367d54(value) {
    return typeof value === 'string' || value instanceof String;
}
function $5f8d0ee7a8d35dfe$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $5f8d0ee7a8d35dfe$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $5f8d0ee7a8d35dfe$export$2005775d905d2dc2(values) {
    if (Array.isArray(values)) return $5f8d0ee7a8d35dfe$export$2005775d905d2dc2(values[0]);
    if (values instanceof Float32Array) return 'float32';
    else if (values instanceof Int32Array || values instanceof Uint8Array || values instanceof Uint8ClampedArray) return 'int32';
    else if ($5f8d0ee7a8d35dfe$export$7e4aa119212bc614(values)) return 'float32';
    else if ($5f8d0ee7a8d35dfe$export$844ec244b1367d54(values)) return 'string';
    else if ($5f8d0ee7a8d35dfe$export$f9ce7b637dfbe238(values)) return 'bool';
    return 'float32';
}
function $5f8d0ee7a8d35dfe$export$f6e2535fb5126e54(f) {
    return !!(f && f.constructor && f.call && f.apply);
}
function $5f8d0ee7a8d35dfe$export$c0ff3276320ddb5e(size, start) {
    for(let i = start; i < size; ++i){
        if (size % i === 0) return i;
    }
    return size;
}
function $5f8d0ee7a8d35dfe$export$6ad0292cf4d50f79(shape) {
    const rank = shape.length;
    if (rank < 2) return [];
    // Last dimension has implicit stride of 1, thus having D-1 (instead of D)
    // strides.
    const strides = new Array(rank - 1);
    strides[rank - 2] = shape[rank - 1];
    for(let i = rank - 3; i >= 0; --i)strides[i] = strides[i + 1] * shape[i + 1];
    return strides;
}
function $5f8d0ee7a8d35dfe$var$createNestedArray(offset, shape, a, isComplex = false) {
    const ret = new Array();
    if (shape.length === 1) {
        const d = shape[0] * (isComplex ? 2 : 1);
        for(let i = 0; i < d; i++)ret[i] = a[offset + i];
    } else {
        const d = shape[0];
        const rest = shape.slice(1);
        const len = rest.reduce((acc, c)=>acc * c) * (isComplex ? 2 : 1);
        for(let i = 0; i < d; i++)ret[i] = $5f8d0ee7a8d35dfe$var$createNestedArray(offset + i * len, rest, a, isComplex);
    }
    return ret;
}
function $5f8d0ee7a8d35dfe$export$3983c25181aa68cc(shape, a, isComplex = false) {
    if (shape.length === 0) // Scalar type should return a single number.
    return a[0];
    const size = shape.reduce((acc, c)=>acc * c) * (isComplex ? 2 : 1);
    if (size === 0) // A tensor with shape zero should be turned into empty list.
    return [];
    if (size !== a.length) throw new Error(`[${shape}] does not match the input size ${a.length}${isComplex ? ' for a complex tensor' : ''}.`);
    return $5f8d0ee7a8d35dfe$var$createNestedArray(0, shape, a, isComplex);
}
function $5f8d0ee7a8d35dfe$export$568d15cfc23dac5d(data, dtype) {
    // If is type Uint8Array[], return it directly.
    if (Array.isArray(data)) return data;
    if (dtype === 'float32') return data instanceof Float32Array ? data : new Float32Array(data);
    else if (dtype === 'int32') return data instanceof Int32Array ? data : new Int32Array(data);
    else if (dtype === 'bool' || dtype === 'string') return Uint8Array.from(new Int32Array(data));
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $5f8d0ee7a8d35dfe$export$b915f681a907ae99(size, dtype) {
    const array = $5f8d0ee7a8d35dfe$export$edbc8aedac4e036f(size, dtype);
    for(let i = 0; i < array.length; i++)array[i] = 1;
    return array;
}
function $5f8d0ee7a8d35dfe$export$edbc8aedac4e036f(size, dtype) {
    if (dtype == null || dtype === 'float32' || dtype === 'complex64') return new Float32Array(size);
    else if (dtype === 'int32') return new Int32Array(size);
    else if (dtype === 'bool') return new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
}
function $5f8d0ee7a8d35dfe$export$eef638260c005c74(shape, dtype) {
    const size = shape.reduce((prev, curr)=>prev * curr, 1);
    if (dtype == null || dtype === 'float32') return $5f8d0ee7a8d35dfe$export$3983c25181aa68cc(shape, new Float32Array(size));
    else if (dtype === 'int32') return $5f8d0ee7a8d35dfe$export$3983c25181aa68cc(shape, new Int32Array(size));
    else if (dtype === 'bool') return $5f8d0ee7a8d35dfe$export$3983c25181aa68cc(shape, new Uint8Array(size));
    else throw new Error(`Unknown data type ${dtype}`);
}
function $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5(shape) {
    shape.forEach((dimSize)=>{
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(Number.isInteger(dimSize) && dimSize >= 0, ()=>`Tensor must have a shape comprised of positive integers but got ` + `shape [${shape}].`);
    });
}
function $5f8d0ee7a8d35dfe$export$a14b009c502dc3b4(locs, rank, strides) {
    if (rank === 0) return 0;
    else if (rank === 1) return locs[0];
    let index = locs[locs.length - 1];
    for(let i = 0; i < locs.length - 1; ++i)index += strides[i] * locs[i];
    return index;
}
function $5f8d0ee7a8d35dfe$export$2d1ada4c755a8699(index, rank, strides) {
    if (rank === 0) return [];
    else if (rank === 1) return [
        index
    ];
    const locs = new Array(rank);
    for(let i = 0; i < locs.length - 1; ++i){
        locs[i] = Math.floor(index / strides[i]);
        index -= locs[i] * strides[i];
    }
    locs[locs.length - 1] = index;
    return locs;
}
function $5f8d0ee7a8d35dfe$export$4369c812aac99591(object) {
    //  We chose to not use 'obj instanceOf Promise' for two reasons:
    //  1. It only reliably works for es6 Promise, not other Promise
    //  implementations.
    //  2. It doesn't work with framework that uses zone.js. zone.js monkey
    //  patch the async calls, so it is possible the obj (patched) is
    //  comparing to a pre-patched Promise.
    return object && object.then && typeof object.then === 'function';
}

});


parcelRegister("grcJs", function(module, exports) {

$parcel$export(module.exports, "getGlobalNamespace", () => $bf790b47f177f8e9$export$5054b240ae6849b7);
$parcel$export(module.exports, "getGlobal", () => $bf790b47f177f8e9$export$a4e55266d2135a7f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Note that the identifier globalNameSpace is scoped to this module, but will
// always resolve to the same global object regardless of how the module is
// resolved.
// tslint:disable-next-line:no-any

var $hPtJY = parcelRequire("hPtJY");
let $bf790b47f177f8e9$var$globalNameSpace;
function $bf790b47f177f8e9$export$5054b240ae6849b7() {
    if ($bf790b47f177f8e9$var$globalNameSpace == null) {
        // tslint:disable-next-line:no-any
        let ns;
        if (typeof window !== 'undefined') ns = window;
        else if (typeof $parcel$global !== 'undefined') ns = $parcel$global;
        else if (typeof $hPtJY !== 'undefined') ns = $hPtJY;
        else if (typeof self !== 'undefined') ns = self;
        else throw new Error('Could not find a global object');
        $bf790b47f177f8e9$var$globalNameSpace = ns;
    }
    return $bf790b47f177f8e9$var$globalNameSpace;
}
// tslint:disable-next-line:no-any
function $bf790b47f177f8e9$var$getGlobalMap() {
    const ns = $bf790b47f177f8e9$export$5054b240ae6849b7();
    if (ns._tfGlobals == null) ns._tfGlobals = new Map();
    return ns._tfGlobals;
}
function $bf790b47f177f8e9$export$a4e55266d2135a7f(key, init) {
    const globalMap = $bf790b47f177f8e9$var$getGlobalMap();
    if (globalMap.has(key)) return globalMap.get(key);
    else {
        const singleton = init();
        globalMap.set(key, singleton);
        return globalMap.get(key);
    }
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("hl418", function(module, exports) {

$parcel$export(module.exports, "Abs", () => $c9f78399309a8a0d$export$b73c596ee8758a66);
$parcel$export(module.exports, "Acos", () => $c9f78399309a8a0d$export$3b952c9980dac550);
$parcel$export(module.exports, "Acosh", () => $c9f78399309a8a0d$export$987da490b7c2e7dd);
$parcel$export(module.exports, "Add", () => $c9f78399309a8a0d$export$d0265b2c425512d6);
$parcel$export(module.exports, "AddN", () => $c9f78399309a8a0d$export$eef235ad06d3226a);
$parcel$export(module.exports, "All", () => $c9f78399309a8a0d$export$5dceb1ab650a1776);
$parcel$export(module.exports, "Any", () => $c9f78399309a8a0d$export$b24b633b1364b94b);
$parcel$export(module.exports, "ArgMax", () => $c9f78399309a8a0d$export$17612294a1503e1c);
$parcel$export(module.exports, "ArgMin", () => $c9f78399309a8a0d$export$baabd09270cbbd94);
$parcel$export(module.exports, "Asin", () => $c9f78399309a8a0d$export$664c8ca7e7e5c126);
$parcel$export(module.exports, "Asinh", () => $c9f78399309a8a0d$export$847c88940cb7dcb5);
$parcel$export(module.exports, "Atan", () => $c9f78399309a8a0d$export$bac667d46ac043ae);
$parcel$export(module.exports, "Atanh", () => $c9f78399309a8a0d$export$98981a86fa2b1366);
$parcel$export(module.exports, "Atan2", () => $c9f78399309a8a0d$export$3bf4c619ce589f4b);
$parcel$export(module.exports, "AvgPool", () => $c9f78399309a8a0d$export$37f2cc7be1add88c);
$parcel$export(module.exports, "AvgPoolGrad", () => $c9f78399309a8a0d$export$9873fd6046cd6951);
$parcel$export(module.exports, "AvgPool3D", () => $c9f78399309a8a0d$export$390ecb697af103f6);
$parcel$export(module.exports, "AvgPool3DGrad", () => $c9f78399309a8a0d$export$7163112adf28c062);
$parcel$export(module.exports, "BatchMatMul", () => $c9f78399309a8a0d$export$9a3bf60b23f63c8);
$parcel$export(module.exports, "BatchToSpaceND", () => $c9f78399309a8a0d$export$e2743f47f61cca1f);
$parcel$export(module.exports, "Bincount", () => $c9f78399309a8a0d$export$45dfbbff595c32aa);
$parcel$export(module.exports, "BitwiseAnd", () => $c9f78399309a8a0d$export$a9e259e32a62221f);
$parcel$export(module.exports, "BroadcastTo", () => $c9f78399309a8a0d$export$ea5eeb875a7c4dd1);
$parcel$export(module.exports, "BroadcastArgs", () => $c9f78399309a8a0d$export$32877b1d6d497805);
$parcel$export(module.exports, "Cast", () => $c9f78399309a8a0d$export$107ecfb3d1ccbd77);
$parcel$export(module.exports, "Ceil", () => $c9f78399309a8a0d$export$d4a1bccfd52ebd3);
$parcel$export(module.exports, "ClipByValue", () => $c9f78399309a8a0d$export$611c0e357ac37f7d);
$parcel$export(module.exports, "Complex", () => $c9f78399309a8a0d$export$50ceb3fb9926e63e);
$parcel$export(module.exports, "ComplexAbs", () => $c9f78399309a8a0d$export$32902e58f1b48f4b);
$parcel$export(module.exports, "Concat", () => $c9f78399309a8a0d$export$936bbfc007425eea);
$parcel$export(module.exports, "Conv2D", () => $c9f78399309a8a0d$export$57742e605d475795);
$parcel$export(module.exports, "Conv2DBackpropFilter", () => $c9f78399309a8a0d$export$32a8943c0f1ca5a7);
$parcel$export(module.exports, "Conv2DBackpropInput", () => $c9f78399309a8a0d$export$e26961e8ed0eb404);
$parcel$export(module.exports, "Conv3D", () => $c9f78399309a8a0d$export$9d3874201dd21933);
$parcel$export(module.exports, "Conv3DBackpropFilterV2", () => $c9f78399309a8a0d$export$dd2885efe6043eee);
$parcel$export(module.exports, "Conv3DBackpropInputV2", () => $c9f78399309a8a0d$export$a54f552d6d7d521f);
$parcel$export(module.exports, "Cos", () => $c9f78399309a8a0d$export$ddfd0a983d257666);
$parcel$export(module.exports, "Cosh", () => $c9f78399309a8a0d$export$5e311a1c57b0d27c);
$parcel$export(module.exports, "Cumprod", () => $c9f78399309a8a0d$export$e581acc6014c47a);
$parcel$export(module.exports, "Cumsum", () => $c9f78399309a8a0d$export$706617d894ad63da);
$parcel$export(module.exports, "CropAndResize", () => $c9f78399309a8a0d$export$50bc9557793c2e04);
$parcel$export(module.exports, "DenseBincount", () => $c9f78399309a8a0d$export$5bab6834954299c5);
$parcel$export(module.exports, "DepthToSpace", () => $c9f78399309a8a0d$export$fb0ee52d0cd6f233);
$parcel$export(module.exports, "DepthwiseConv2dNative", () => $c9f78399309a8a0d$export$7c0fc590ff9e156f);
$parcel$export(module.exports, "DepthwiseConv2dNativeBackpropFilter", () => $c9f78399309a8a0d$export$c99f139e0d4d1833);
$parcel$export(module.exports, "DepthwiseConv2dNativeBackpropInput", () => $c9f78399309a8a0d$export$8649ca3b17033a24);
$parcel$export(module.exports, "Diag", () => $c9f78399309a8a0d$export$ca73a25315ddeb7f);
$parcel$export(module.exports, "Dilation2D", () => $c9f78399309a8a0d$export$dbbb7830c6497701);
$parcel$export(module.exports, "Dilation2DBackpropInput", () => $c9f78399309a8a0d$export$5dd675a6b0f37e17);
$parcel$export(module.exports, "Dilation2DBackpropFilter", () => $c9f78399309a8a0d$export$91add972be69d592);
$parcel$export(module.exports, "Draw", () => $c9f78399309a8a0d$export$dca20402ebea5ece);
$parcel$export(module.exports, "RealDiv", () => $c9f78399309a8a0d$export$b9880b86e1014bb8);
$parcel$export(module.exports, "Einsum", () => $c9f78399309a8a0d$export$2541d8be32f3c641);
$parcel$export(module.exports, "Elu", () => $c9f78399309a8a0d$export$64636e173424d83d);
$parcel$export(module.exports, "EluGrad", () => $c9f78399309a8a0d$export$9906be4699a73c53);
$parcel$export(module.exports, "Erf", () => $c9f78399309a8a0d$export$c2ee2551ce71f1d0);
$parcel$export(module.exports, "Equal", () => $c9f78399309a8a0d$export$8dcf9f58ce5cdfc);
$parcel$export(module.exports, "Exp", () => $c9f78399309a8a0d$export$f908be7a96fb3363);
$parcel$export(module.exports, "ExpandDims", () => $c9f78399309a8a0d$export$2391750b1d901146);
$parcel$export(module.exports, "Expm1", () => $c9f78399309a8a0d$export$261f26143a1ff3);
$parcel$export(module.exports, "FFT", () => $c9f78399309a8a0d$export$677347237c014ba);
$parcel$export(module.exports, "Fill", () => $c9f78399309a8a0d$export$ffffe40bfa0649a3);
$parcel$export(module.exports, "FlipLeftRight", () => $c9f78399309a8a0d$export$34e7296fc8558df5);
$parcel$export(module.exports, "Floor", () => $c9f78399309a8a0d$export$4880b0ae5643c62b);
$parcel$export(module.exports, "FloorDiv", () => $c9f78399309a8a0d$export$d79b5692ede26c2f);
$parcel$export(module.exports, "FusedBatchNorm", () => $c9f78399309a8a0d$export$3821a0416660aaa2);
$parcel$export(module.exports, "GatherV2", () => $c9f78399309a8a0d$export$ccd988942e5c0181);
$parcel$export(module.exports, "GatherNd", () => $c9f78399309a8a0d$export$4ef6e37a23721703);
$parcel$export(module.exports, "Greater", () => $c9f78399309a8a0d$export$d0a25eac5ee3f515);
$parcel$export(module.exports, "GreaterEqual", () => $c9f78399309a8a0d$export$3b7d21bc9aee0851);
$parcel$export(module.exports, "Identity", () => $c9f78399309a8a0d$export$544bf02140fa9a77);
$parcel$export(module.exports, "IFFT", () => $c9f78399309a8a0d$export$21c6f576ae8100e8);
$parcel$export(module.exports, "Imag", () => $c9f78399309a8a0d$export$303b4473993a24f);
$parcel$export(module.exports, "IsFinite", () => $c9f78399309a8a0d$export$b9fcc0946d7d485e);
$parcel$export(module.exports, "IsInf", () => $c9f78399309a8a0d$export$74b5a3bc735b152);
$parcel$export(module.exports, "IsNan", () => $c9f78399309a8a0d$export$9912dc4fc649dbec);
$parcel$export(module.exports, "LeakyRelu", () => $c9f78399309a8a0d$export$f0c7162bb7af1a2d);
$parcel$export(module.exports, "Less", () => $c9f78399309a8a0d$export$728c50f1c88ac779);
$parcel$export(module.exports, "LessEqual", () => $c9f78399309a8a0d$export$84afd0d8f7fb8c5d);
$parcel$export(module.exports, "LinSpace", () => $c9f78399309a8a0d$export$34f0ab8eba543ee6);
$parcel$export(module.exports, "Log", () => $c9f78399309a8a0d$export$ce30dbb46644d06c);
$parcel$export(module.exports, "Log1p", () => $c9f78399309a8a0d$export$70f05bf9ddcfca68);
$parcel$export(module.exports, "LogicalAnd", () => $c9f78399309a8a0d$export$8a27ff10dff4d6e5);
$parcel$export(module.exports, "LogicalNot", () => $c9f78399309a8a0d$export$4393bee5596c68c2);
$parcel$export(module.exports, "LogicalOr", () => $c9f78399309a8a0d$export$c49f9f5ffc6f678c);
$parcel$export(module.exports, "LogSoftmax", () => $c9f78399309a8a0d$export$85b5bcbd60848a10);
$parcel$export(module.exports, "LRN", () => $c9f78399309a8a0d$export$eb2f713fc3e1ca9a);
$parcel$export(module.exports, "LRNGrad", () => $c9f78399309a8a0d$export$73ba43cd0ce95b10);
$parcel$export(module.exports, "Max", () => $c9f78399309a8a0d$export$d36c09e5d02927e7);
$parcel$export(module.exports, "Maximum", () => $c9f78399309a8a0d$export$d8d02ac92d161004);
$parcel$export(module.exports, "MaxPool", () => $c9f78399309a8a0d$export$39ea33024ddd5cf);
$parcel$export(module.exports, "MaxPoolGrad", () => $c9f78399309a8a0d$export$f0f010b1d1db8a46);
$parcel$export(module.exports, "MaxPool3D", () => $c9f78399309a8a0d$export$88fdc64af890fc53);
$parcel$export(module.exports, "MaxPool3DGrad", () => $c9f78399309a8a0d$export$52be2c00371a1350);
$parcel$export(module.exports, "MaxPoolWithArgmax", () => $c9f78399309a8a0d$export$deac4b7497b4047f);
$parcel$export(module.exports, "Mean", () => $c9f78399309a8a0d$export$1c2d59c4b681fbd8);
$parcel$export(module.exports, "Min", () => $c9f78399309a8a0d$export$dfed19fabc75a31d);
$parcel$export(module.exports, "Minimum", () => $c9f78399309a8a0d$export$23cb308301e89d6b);
$parcel$export(module.exports, "MirrorPad", () => $c9f78399309a8a0d$export$f4c0e95fd7fd31e5);
$parcel$export(module.exports, "Mod", () => $c9f78399309a8a0d$export$e4835a5e3f3674d5);
$parcel$export(module.exports, "Multinomial", () => $c9f78399309a8a0d$export$ee0a8cfb693e0e3f);
$parcel$export(module.exports, "Multiply", () => $c9f78399309a8a0d$export$f14f83b3b531d498);
$parcel$export(module.exports, "Neg", () => $c9f78399309a8a0d$export$c07c549000872073);
$parcel$export(module.exports, "NotEqual", () => $c9f78399309a8a0d$export$385ebe9945cae0c5);
$parcel$export(module.exports, "NonMaxSuppressionV3", () => $c9f78399309a8a0d$export$5e11788439c2f04);
$parcel$export(module.exports, "NonMaxSuppressionV4", () => $c9f78399309a8a0d$export$7df908154366fe7f);
$parcel$export(module.exports, "NonMaxSuppressionV5", () => $c9f78399309a8a0d$export$cb45d3fcefce2ef0);
$parcel$export(module.exports, "OnesLike", () => $c9f78399309a8a0d$export$a2962e735c809d91);
$parcel$export(module.exports, "OneHot", () => $c9f78399309a8a0d$export$18982b43ba8c02e9);
$parcel$export(module.exports, "Pack", () => $c9f78399309a8a0d$export$c26f40b29201e5b7);
$parcel$export(module.exports, "PadV2", () => $c9f78399309a8a0d$export$5d47ba206577f0f2);
$parcel$export(module.exports, "Pow", () => $c9f78399309a8a0d$export$ce28d653ec559ee);
$parcel$export(module.exports, "Prelu", () => $c9f78399309a8a0d$export$a42f35f308fc2fa3);
$parcel$export(module.exports, "Prod", () => $c9f78399309a8a0d$export$b8a16d526a791fb0);
$parcel$export(module.exports, "RaggedGather", () => $c9f78399309a8a0d$export$ffee9c5b4fce08a1);
$parcel$export(module.exports, "RaggedRange", () => $c9f78399309a8a0d$export$9d0615a9a6d213d2);
$parcel$export(module.exports, "RaggedTensorToTensor", () => $c9f78399309a8a0d$export$616d73a9ab7617c7);
$parcel$export(module.exports, "Range", () => $c9f78399309a8a0d$export$9a58ef0d7ad3278c);
$parcel$export(module.exports, "Real", () => $c9f78399309a8a0d$export$f41305719b94e675);
$parcel$export(module.exports, "Reciprocal", () => $c9f78399309a8a0d$export$c6e4a23ed5e0415b);
$parcel$export(module.exports, "Relu", () => $c9f78399309a8a0d$export$9a6ff968bf961432);
$parcel$export(module.exports, "Reshape", () => $c9f78399309a8a0d$export$755ddd847e5abe03);
$parcel$export(module.exports, "ResizeNearestNeighbor", () => $c9f78399309a8a0d$export$6c8d8ec26192bb18);
$parcel$export(module.exports, "ResizeNearestNeighborGrad", () => $c9f78399309a8a0d$export$b84ac31c55aa023b);
$parcel$export(module.exports, "ResizeBilinear", () => $c9f78399309a8a0d$export$24f2f15d869e0fd);
$parcel$export(module.exports, "ResizeBilinearGrad", () => $c9f78399309a8a0d$export$2d3cf759f1538c13);
$parcel$export(module.exports, "Relu6", () => $c9f78399309a8a0d$export$3be9e924f629054e);
$parcel$export(module.exports, "Reverse", () => $c9f78399309a8a0d$export$53c81f36b32e1bba);
$parcel$export(module.exports, "Round", () => $c9f78399309a8a0d$export$c5ed3eef16c0612f);
$parcel$export(module.exports, "Rsqrt", () => $c9f78399309a8a0d$export$7cc53aa09f5f3a2d);
$parcel$export(module.exports, "ScatterNd", () => $c9f78399309a8a0d$export$28eef6f0168af686);
$parcel$export(module.exports, "TensorScatterUpdate", () => $c9f78399309a8a0d$export$20050a140fd1de77);
$parcel$export(module.exports, "SearchSorted", () => $c9f78399309a8a0d$export$9a1405490b09867e);
$parcel$export(module.exports, "Select", () => $c9f78399309a8a0d$export$ef9b1a59e592288f);
$parcel$export(module.exports, "Selu", () => $c9f78399309a8a0d$export$6760d858e6f2594a);
$parcel$export(module.exports, "Slice", () => $c9f78399309a8a0d$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "Sin", () => $c9f78399309a8a0d$export$75be1b631f7687);
$parcel$export(module.exports, "Sinh", () => $c9f78399309a8a0d$export$b8c187376329d79b);
$parcel$export(module.exports, "Sign", () => $c9f78399309a8a0d$export$1db683ad541682f6);
$parcel$export(module.exports, "Sigmoid", () => $c9f78399309a8a0d$export$fde18c826dda6b1b);
$parcel$export(module.exports, "Softplus", () => $c9f78399309a8a0d$export$c5af433747f1fd0a);
$parcel$export(module.exports, "Sqrt", () => $c9f78399309a8a0d$export$21ab404ab9d512a6);
$parcel$export(module.exports, "Sum", () => $c9f78399309a8a0d$export$534760f50726d5);
$parcel$export(module.exports, "SpaceToBatchND", () => $c9f78399309a8a0d$export$f63ac5409312707c);
$parcel$export(module.exports, "SplitV", () => $c9f78399309a8a0d$export$8dffabb4071f05aa);
$parcel$export(module.exports, "Softmax", () => $c9f78399309a8a0d$export$350a526055d3ca6e);
$parcel$export(module.exports, "SparseFillEmptyRows", () => $c9f78399309a8a0d$export$8f1933853a5c8cca);
$parcel$export(module.exports, "SparseReshape", () => $c9f78399309a8a0d$export$f08f0dca44fa542);
$parcel$export(module.exports, "SparseSegmentMean", () => $c9f78399309a8a0d$export$610b077aecc2447b);
$parcel$export(module.exports, "SparseSegmentSum", () => $c9f78399309a8a0d$export$68351c28d7116b56);
$parcel$export(module.exports, "SparseToDense", () => $c9f78399309a8a0d$export$2c426709a9332421);
$parcel$export(module.exports, "SquaredDifference", () => $c9f78399309a8a0d$export$2f922d20d66089c6);
$parcel$export(module.exports, "Square", () => $c9f78399309a8a0d$export$b09fb900337259de);
$parcel$export(module.exports, "StaticRegexReplace", () => $c9f78399309a8a0d$export$2fbaa77553edaeff);
$parcel$export(module.exports, "StridedSlice", () => $c9f78399309a8a0d$export$60c7f9ac271417a9);
$parcel$export(module.exports, "StringNGrams", () => $c9f78399309a8a0d$export$11a7f4af7d96ad41);
$parcel$export(module.exports, "StringSplit", () => $c9f78399309a8a0d$export$7e266f7223b9d396);
$parcel$export(module.exports, "StringToHashBucketFast", () => $c9f78399309a8a0d$export$a5639899909bc8ae);
$parcel$export(module.exports, "Sub", () => $c9f78399309a8a0d$export$d7a01e11500dfb6f);
$parcel$export(module.exports, "Tan", () => $c9f78399309a8a0d$export$115b2d5263ba5985);
$parcel$export(module.exports, "Tanh", () => $c9f78399309a8a0d$export$893b6e865e352c83);
$parcel$export(module.exports, "Tile", () => $c9f78399309a8a0d$export$235cb65c20ad2b7);
$parcel$export(module.exports, "TopK", () => $c9f78399309a8a0d$export$c593cd1ea0d02ebd);
$parcel$export(module.exports, "Transform", () => $c9f78399309a8a0d$export$563a914cafbdc389);
$parcel$export(module.exports, "Transpose", () => $c9f78399309a8a0d$export$7e714455f9a1f8f7);
$parcel$export(module.exports, "Unique", () => $c9f78399309a8a0d$export$8e3adf126971a183);
$parcel$export(module.exports, "Unpack", () => $c9f78399309a8a0d$export$441ad6bfc5db8ab4);
$parcel$export(module.exports, "UnsortedSegmentSum", () => $c9f78399309a8a0d$export$af810663cded5fe2);
$parcel$export(module.exports, "ZerosLike", () => $c9f78399309a8a0d$export$430969a37eda1e88);
$parcel$export(module.exports, "Step", () => $c9f78399309a8a0d$export$fd55ce593607084a);
$parcel$export(module.exports, "FromPixels", () => $c9f78399309a8a0d$export$d0eb4e7054966c48);
$parcel$export(module.exports, "RotateWithOffset", () => $c9f78399309a8a0d$export$c5a44649815d1c3);
$parcel$export(module.exports, "_FusedMatMul", () => $c9f78399309a8a0d$export$8d1af0f7c2a4da9e);
$parcel$export(module.exports, "FusedConv2D", () => $c9f78399309a8a0d$export$86f8a8e3a8f2a8f2);
$parcel$export(module.exports, "FusedDepthwiseConv2D", () => $c9f78399309a8a0d$export$5a249e8f498c02c1);
const $c9f78399309a8a0d$export$b73c596ee8758a66 = 'Abs';
const $c9f78399309a8a0d$export$3b952c9980dac550 = 'Acos';
const $c9f78399309a8a0d$export$987da490b7c2e7dd = 'Acosh';
const $c9f78399309a8a0d$export$d0265b2c425512d6 = 'Add';
const $c9f78399309a8a0d$export$eef235ad06d3226a = 'AddN';
const $c9f78399309a8a0d$export$5dceb1ab650a1776 = 'All';
const $c9f78399309a8a0d$export$b24b633b1364b94b = 'Any';
const $c9f78399309a8a0d$export$17612294a1503e1c = 'ArgMax';
const $c9f78399309a8a0d$export$baabd09270cbbd94 = 'ArgMin';
const $c9f78399309a8a0d$export$664c8ca7e7e5c126 = 'Asin';
const $c9f78399309a8a0d$export$847c88940cb7dcb5 = 'Asinh';
const $c9f78399309a8a0d$export$bac667d46ac043ae = 'Atan';
const $c9f78399309a8a0d$export$98981a86fa2b1366 = 'Atanh';
const $c9f78399309a8a0d$export$3bf4c619ce589f4b = 'Atan2';
const $c9f78399309a8a0d$export$37f2cc7be1add88c = 'AvgPool';
const $c9f78399309a8a0d$export$9873fd6046cd6951 = 'AvgPoolGrad';
const $c9f78399309a8a0d$export$390ecb697af103f6 = 'AvgPool3D';
const $c9f78399309a8a0d$export$7163112adf28c062 = 'AvgPool3DGrad';
const $c9f78399309a8a0d$export$9a3bf60b23f63c8 = 'BatchMatMul';
const $c9f78399309a8a0d$export$e2743f47f61cca1f = 'BatchToSpaceND';
const $c9f78399309a8a0d$export$45dfbbff595c32aa = 'Bincount';
const $c9f78399309a8a0d$export$a9e259e32a62221f = 'BitwiseAnd';
const $c9f78399309a8a0d$export$ea5eeb875a7c4dd1 = 'BroadcastTo';
const $c9f78399309a8a0d$export$32877b1d6d497805 = 'BroadcastArgs';
const $c9f78399309a8a0d$export$107ecfb3d1ccbd77 = 'Cast';
const $c9f78399309a8a0d$export$d4a1bccfd52ebd3 = 'Ceil';
const $c9f78399309a8a0d$export$611c0e357ac37f7d = 'ClipByValue';
const $c9f78399309a8a0d$export$50ceb3fb9926e63e = 'Complex';
const $c9f78399309a8a0d$export$32902e58f1b48f4b = 'ComplexAbs';
const $c9f78399309a8a0d$export$936bbfc007425eea = 'Concat';
const $c9f78399309a8a0d$export$57742e605d475795 = 'Conv2D';
const $c9f78399309a8a0d$export$32a8943c0f1ca5a7 = 'Conv2DBackpropFilter';
const $c9f78399309a8a0d$export$e26961e8ed0eb404 = 'Conv2DBackpropInput';
const $c9f78399309a8a0d$export$9d3874201dd21933 = 'Conv3D';
const $c9f78399309a8a0d$export$dd2885efe6043eee = 'Conv3DBackpropFilterV2';
const $c9f78399309a8a0d$export$a54f552d6d7d521f = 'Conv3DBackpropInputV2';
const $c9f78399309a8a0d$export$ddfd0a983d257666 = 'Cos';
const $c9f78399309a8a0d$export$5e311a1c57b0d27c = 'Cosh';
const $c9f78399309a8a0d$export$e581acc6014c47a = 'Cumprod';
const $c9f78399309a8a0d$export$706617d894ad63da = 'Cumsum';
const $c9f78399309a8a0d$export$50bc9557793c2e04 = 'CropAndResize';
const $c9f78399309a8a0d$export$5bab6834954299c5 = 'DenseBincount';
const $c9f78399309a8a0d$export$fb0ee52d0cd6f233 = 'DepthToSpace';
const $c9f78399309a8a0d$export$7c0fc590ff9e156f = 'DepthwiseConv2dNative';
const $c9f78399309a8a0d$export$c99f139e0d4d1833 = 'DepthwiseConv2dNativeBackpropFilter';
const $c9f78399309a8a0d$export$8649ca3b17033a24 = 'DepthwiseConv2dNativeBackpropInput';
const $c9f78399309a8a0d$export$ca73a25315ddeb7f = 'Diag';
const $c9f78399309a8a0d$export$dbbb7830c6497701 = 'Dilation2D';
const $c9f78399309a8a0d$export$5dd675a6b0f37e17 = 'Dilation2DBackpropInput';
const $c9f78399309a8a0d$export$91add972be69d592 = 'Dilation2DBackpropFilter';
const $c9f78399309a8a0d$export$dca20402ebea5ece = 'Draw';
const $c9f78399309a8a0d$export$b9880b86e1014bb8 = 'RealDiv';
const $c9f78399309a8a0d$export$2541d8be32f3c641 = 'Einsum';
const $c9f78399309a8a0d$export$64636e173424d83d = 'Elu';
const $c9f78399309a8a0d$export$9906be4699a73c53 = 'EluGrad';
const $c9f78399309a8a0d$export$c2ee2551ce71f1d0 = 'Erf';
const $c9f78399309a8a0d$export$8dcf9f58ce5cdfc = 'Equal';
const $c9f78399309a8a0d$export$f908be7a96fb3363 = 'Exp';
const $c9f78399309a8a0d$export$2391750b1d901146 = 'ExpandDims';
const $c9f78399309a8a0d$export$261f26143a1ff3 = 'Expm1';
const $c9f78399309a8a0d$export$677347237c014ba = 'FFT';
const $c9f78399309a8a0d$export$ffffe40bfa0649a3 = 'Fill';
const $c9f78399309a8a0d$export$34e7296fc8558df5 = 'FlipLeftRight';
const $c9f78399309a8a0d$export$4880b0ae5643c62b = 'Floor';
const $c9f78399309a8a0d$export$d79b5692ede26c2f = 'FloorDiv';
const $c9f78399309a8a0d$export$3821a0416660aaa2 = 'FusedBatchNorm';
const $c9f78399309a8a0d$export$ccd988942e5c0181 = 'GatherV2';
const $c9f78399309a8a0d$export$4ef6e37a23721703 = 'GatherNd';
const $c9f78399309a8a0d$export$d0a25eac5ee3f515 = 'Greater';
const $c9f78399309a8a0d$export$3b7d21bc9aee0851 = 'GreaterEqual';
const $c9f78399309a8a0d$export$544bf02140fa9a77 = 'Identity';
const $c9f78399309a8a0d$export$21c6f576ae8100e8 = 'IFFT';
const $c9f78399309a8a0d$export$303b4473993a24f = 'Imag';
const $c9f78399309a8a0d$export$b9fcc0946d7d485e = 'IsFinite';
const $c9f78399309a8a0d$export$74b5a3bc735b152 = 'IsInf';
const $c9f78399309a8a0d$export$9912dc4fc649dbec = 'IsNan';
const $c9f78399309a8a0d$export$f0c7162bb7af1a2d = 'LeakyRelu';
const $c9f78399309a8a0d$export$728c50f1c88ac779 = 'Less';
const $c9f78399309a8a0d$export$84afd0d8f7fb8c5d = 'LessEqual';
const $c9f78399309a8a0d$export$34f0ab8eba543ee6 = 'LinSpace';
const $c9f78399309a8a0d$export$ce30dbb46644d06c = 'Log';
const $c9f78399309a8a0d$export$70f05bf9ddcfca68 = 'Log1p';
const $c9f78399309a8a0d$export$8a27ff10dff4d6e5 = 'LogicalAnd';
const $c9f78399309a8a0d$export$4393bee5596c68c2 = 'LogicalNot';
const $c9f78399309a8a0d$export$c49f9f5ffc6f678c = 'LogicalOr';
const $c9f78399309a8a0d$export$656629b293485eff = 'LogicalXor';
const $c9f78399309a8a0d$export$85b5bcbd60848a10 = 'LogSoftmax';
const $c9f78399309a8a0d$export$9ec35fe80d53e931 = 'LowerBound';
const $c9f78399309a8a0d$export$eb2f713fc3e1ca9a = 'LRN';
const $c9f78399309a8a0d$export$73ba43cd0ce95b10 = 'LRNGrad';
const $c9f78399309a8a0d$export$b4571177c51d555b = 'MatrixBandPart';
const $c9f78399309a8a0d$export$d36c09e5d02927e7 = 'Max';
const $c9f78399309a8a0d$export$d8d02ac92d161004 = 'Maximum';
const $c9f78399309a8a0d$export$39ea33024ddd5cf = 'MaxPool';
const $c9f78399309a8a0d$export$f0f010b1d1db8a46 = 'MaxPoolGrad';
const $c9f78399309a8a0d$export$88fdc64af890fc53 = 'MaxPool3D';
const $c9f78399309a8a0d$export$52be2c00371a1350 = 'MaxPool3DGrad';
const $c9f78399309a8a0d$export$deac4b7497b4047f = 'MaxPoolWithArgmax';
const $c9f78399309a8a0d$export$1c2d59c4b681fbd8 = 'Mean';
const $c9f78399309a8a0d$export$dfed19fabc75a31d = 'Min';
const $c9f78399309a8a0d$export$23cb308301e89d6b = 'Minimum';
const $c9f78399309a8a0d$export$f4c0e95fd7fd31e5 = 'MirrorPad';
const $c9f78399309a8a0d$export$e4835a5e3f3674d5 = 'Mod';
const $c9f78399309a8a0d$export$ee0a8cfb693e0e3f = 'Multinomial';
const $c9f78399309a8a0d$export$f14f83b3b531d498 = 'Multiply';
const $c9f78399309a8a0d$export$c07c549000872073 = 'Neg';
const $c9f78399309a8a0d$export$385ebe9945cae0c5 = 'NotEqual';
const $c9f78399309a8a0d$export$5e11788439c2f04 = 'NonMaxSuppressionV3';
const $c9f78399309a8a0d$export$7df908154366fe7f = 'NonMaxSuppressionV4';
const $c9f78399309a8a0d$export$cb45d3fcefce2ef0 = 'NonMaxSuppressionV5';
const $c9f78399309a8a0d$export$a2962e735c809d91 = 'OnesLike';
const $c9f78399309a8a0d$export$18982b43ba8c02e9 = 'OneHot';
const $c9f78399309a8a0d$export$c26f40b29201e5b7 = 'Pack';
const $c9f78399309a8a0d$export$5d47ba206577f0f2 = 'PadV2';
const $c9f78399309a8a0d$export$14963ee5c8637e11 = 'Pool';
const $c9f78399309a8a0d$export$ce28d653ec559ee = 'Pow';
const $c9f78399309a8a0d$export$a42f35f308fc2fa3 = 'Prelu';
const $c9f78399309a8a0d$export$b8a16d526a791fb0 = 'Prod';
const $c9f78399309a8a0d$export$ffee9c5b4fce08a1 = 'RaggedGather';
const $c9f78399309a8a0d$export$9d0615a9a6d213d2 = 'RaggedRange';
const $c9f78399309a8a0d$export$616d73a9ab7617c7 = 'RaggedTensorToTensor';
const $c9f78399309a8a0d$export$9a58ef0d7ad3278c = 'Range';
const $c9f78399309a8a0d$export$f41305719b94e675 = 'Real';
const $c9f78399309a8a0d$export$c6e4a23ed5e0415b = 'Reciprocal';
const $c9f78399309a8a0d$export$9a6ff968bf961432 = 'Relu';
const $c9f78399309a8a0d$export$755ddd847e5abe03 = 'Reshape';
const $c9f78399309a8a0d$export$6c8d8ec26192bb18 = 'ResizeNearestNeighbor';
const $c9f78399309a8a0d$export$b84ac31c55aa023b = 'ResizeNearestNeighborGrad';
const $c9f78399309a8a0d$export$24f2f15d869e0fd = 'ResizeBilinear';
const $c9f78399309a8a0d$export$2d3cf759f1538c13 = 'ResizeBilinearGrad';
const $c9f78399309a8a0d$export$3be9e924f629054e = 'Relu6';
const $c9f78399309a8a0d$export$53c81f36b32e1bba = 'Reverse';
const $c9f78399309a8a0d$export$c5ed3eef16c0612f = 'Round';
const $c9f78399309a8a0d$export$7cc53aa09f5f3a2d = 'Rsqrt';
const $c9f78399309a8a0d$export$28eef6f0168af686 = 'ScatterNd';
const $c9f78399309a8a0d$export$20050a140fd1de77 = 'TensorScatterUpdate';
const $c9f78399309a8a0d$export$9a1405490b09867e = 'SearchSorted';
const $c9f78399309a8a0d$export$ef9b1a59e592288f = 'Select';
const $c9f78399309a8a0d$export$6760d858e6f2594a = 'Selu';
const $c9f78399309a8a0d$export$b3f2e2de3a8baa1e = 'Slice';
const $c9f78399309a8a0d$export$75be1b631f7687 = 'Sin';
const $c9f78399309a8a0d$export$b8c187376329d79b = 'Sinh';
const $c9f78399309a8a0d$export$1db683ad541682f6 = 'Sign';
const $c9f78399309a8a0d$export$fde18c826dda6b1b = 'Sigmoid';
const $c9f78399309a8a0d$export$c5af433747f1fd0a = 'Softplus';
const $c9f78399309a8a0d$export$21ab404ab9d512a6 = 'Sqrt';
const $c9f78399309a8a0d$export$534760f50726d5 = 'Sum';
const $c9f78399309a8a0d$export$f63ac5409312707c = 'SpaceToBatchND';
const $c9f78399309a8a0d$export$8dffabb4071f05aa = 'SplitV';
const $c9f78399309a8a0d$export$350a526055d3ca6e = 'Softmax';
const $c9f78399309a8a0d$export$8f1933853a5c8cca = 'SparseFillEmptyRows';
const $c9f78399309a8a0d$export$f08f0dca44fa542 = 'SparseReshape';
const $c9f78399309a8a0d$export$610b077aecc2447b = 'SparseSegmentMean';
const $c9f78399309a8a0d$export$68351c28d7116b56 = 'SparseSegmentSum';
const $c9f78399309a8a0d$export$2c426709a9332421 = 'SparseToDense';
const $c9f78399309a8a0d$export$2f922d20d66089c6 = 'SquaredDifference';
const $c9f78399309a8a0d$export$b09fb900337259de = 'Square';
const $c9f78399309a8a0d$export$2fbaa77553edaeff = 'StaticRegexReplace';
const $c9f78399309a8a0d$export$60c7f9ac271417a9 = 'StridedSlice';
const $c9f78399309a8a0d$export$11a7f4af7d96ad41 = 'StringNGrams';
const $c9f78399309a8a0d$export$7e266f7223b9d396 = 'StringSplit';
const $c9f78399309a8a0d$export$a5639899909bc8ae = 'StringToHashBucketFast';
const $c9f78399309a8a0d$export$d7a01e11500dfb6f = 'Sub';
const $c9f78399309a8a0d$export$115b2d5263ba5985 = 'Tan';
const $c9f78399309a8a0d$export$893b6e865e352c83 = 'Tanh';
const $c9f78399309a8a0d$export$235cb65c20ad2b7 = 'Tile';
const $c9f78399309a8a0d$export$c593cd1ea0d02ebd = 'TopK';
const $c9f78399309a8a0d$export$563a914cafbdc389 = 'Transform';
const $c9f78399309a8a0d$export$7e714455f9a1f8f7 = 'Transpose';
const $c9f78399309a8a0d$export$8e3adf126971a183 = 'Unique';
const $c9f78399309a8a0d$export$441ad6bfc5db8ab4 = 'Unpack';
const $c9f78399309a8a0d$export$af810663cded5fe2 = 'UnsortedSegmentSum';
const $c9f78399309a8a0d$export$7dc194c8da2f9058 = 'UpperBound';
const $c9f78399309a8a0d$export$430969a37eda1e88 = 'ZerosLike';
const $c9f78399309a8a0d$export$fd55ce593607084a = 'Step';
const $c9f78399309a8a0d$export$d0eb4e7054966c48 = 'FromPixels';
const $c9f78399309a8a0d$export$c5a44649815d1c3 = 'RotateWithOffset';
const $c9f78399309a8a0d$export$8d1af0f7c2a4da9e = '_FusedMatMul';
const $c9f78399309a8a0d$export$86f8a8e3a8f2a8f2 = 'FusedConv2D';
const $c9f78399309a8a0d$export$5a249e8f498c02c1 = 'FusedDepthwiseConv2D';

});

parcelRegister("eky5o", function(module, exports) {

$parcel$export(module.exports, "getKernel", () => $a6ed5fb1cf7ee2a4$export$1b85808c967cc434);
$parcel$export(module.exports, "getGradient", () => $a6ed5fb1cf7ee2a4$export$e14995d3ec1747ee);
$parcel$export(module.exports, "getKernelsForBackend", () => $a6ed5fb1cf7ee2a4$export$e4b8d76e176eaecc);
$parcel$export(module.exports, "registerKernel", () => $a6ed5fb1cf7ee2a4$export$f3f7c443f3a606e6);
$parcel$export(module.exports, "registerGradient", () => $a6ed5fb1cf7ee2a4$export$de9396b872fdfcc3);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ibsdL = parcelRequire("ibsdL");

var $grcJs = parcelRequire("grcJs");

var $cgHNs = parcelRequire("cgHNs");
const $a6ed5fb1cf7ee2a4$var$kernelRegistry = (0, $grcJs.getGlobal)('kernelRegistry', ()=>new Map());
const $a6ed5fb1cf7ee2a4$var$gradRegistry = (0, $grcJs.getGlobal)('gradRegistry', ()=>new Map());
function $a6ed5fb1cf7ee2a4$export$1b85808c967cc434(kernelName, backendName) {
    const key = $a6ed5fb1cf7ee2a4$var$makeKey(kernelName, backendName);
    return $a6ed5fb1cf7ee2a4$var$kernelRegistry.get(key);
}
function $a6ed5fb1cf7ee2a4$export$e14995d3ec1747ee(kernelName) {
    return $a6ed5fb1cf7ee2a4$var$gradRegistry.get(kernelName);
}
function $a6ed5fb1cf7ee2a4$export$e4b8d76e176eaecc(backendName) {
    const it = $a6ed5fb1cf7ee2a4$var$kernelRegistry.entries();
    const result = [];
    while(true){
        const { done: done, value: value } = it.next();
        if (done) break;
        const [key, config] = value;
        const [backend] = key.split('_');
        if (backend === backendName) result.push(config);
    }
    return result;
}
function $a6ed5fb1cf7ee2a4$export$f3f7c443f3a606e6(config) {
    const { kernelName: kernelName, backendName: backendName } = config;
    const key = $a6ed5fb1cf7ee2a4$var$makeKey(kernelName, backendName);
    if ($a6ed5fb1cf7ee2a4$var$kernelRegistry.has(key)) $cgHNs.warn(`The kernel '${kernelName}' for backend ` + `'${backendName}' is already registered`);
    $a6ed5fb1cf7ee2a4$var$kernelRegistry.set(key, config);
}
function $a6ed5fb1cf7ee2a4$export$de9396b872fdfcc3(config) {
    const { kernelName: kernelName } = config;
    if ($a6ed5fb1cf7ee2a4$var$gradRegistry.has(kernelName)) // TODO (yassogba) after 3.0 assess whether we need to keep this gated
    // to debug mode.
    {
        if ((0, $ibsdL.env)().getBool('DEBUG')) $cgHNs.warn(`Overriding the gradient for '${kernelName}'`);
    }
    $a6ed5fb1cf7ee2a4$var$gradRegistry.set(kernelName, config);
}
function $a6ed5fb1cf7ee2a4$export$1c3fb41896379a12(kernelName, backendName) {
    const key = $a6ed5fb1cf7ee2a4$var$makeKey(kernelName, backendName);
    if (!$a6ed5fb1cf7ee2a4$var$kernelRegistry.has(key)) throw new Error(`The kernel '${kernelName}' for backend ` + `'${backendName}' is not registered`);
    $a6ed5fb1cf7ee2a4$var$kernelRegistry.delete(key);
}
function $a6ed5fb1cf7ee2a4$export$41b3e24402efeb81(kernelName) {
    if (!$a6ed5fb1cf7ee2a4$var$gradRegistry.has(kernelName)) throw new Error(`The gradient '${kernelName}' for backend is not registered`);
    $a6ed5fb1cf7ee2a4$var$gradRegistry.delete(kernelName);
}
function $a6ed5fb1cf7ee2a4$export$fb249e95c44186e6(registeredBackendName, newBackendName) {
    const kernels = $a6ed5fb1cf7ee2a4$export$e4b8d76e176eaecc(registeredBackendName);
    kernels.forEach((kernelConfig)=>{
        const newKernelConfig = Object.assign({}, kernelConfig, {
            backendName: newBackendName
        });
        $a6ed5fb1cf7ee2a4$export$f3f7c443f3a606e6(newKernelConfig);
    });
}
function $a6ed5fb1cf7ee2a4$var$makeKey(kernelName, backendName) {
    return `${backendName}_${kernelName}`;
}

});
parcelRegister("cgHNs", function(module, exports) {

$parcel$export(module.exports, "warn", () => $8ee8f3c328242644$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "log", () => $8ee8f3c328242644$export$bef1f36f5486a6a3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ibsdL = parcelRequire("ibsdL");
function $8ee8f3c328242644$export$c106dd0671a0fc2d(...msg) {
    if (!((0, $ibsdL.env)().getBool('IS_TEST') || (0, $ibsdL.env)().getBool('PROD'))) console.warn(...msg);
}
function $8ee8f3c328242644$export$bef1f36f5486a6a3(...msg) {
    if (!((0, $ibsdL.env)().getBool('IS_TEST') || (0, $ibsdL.env)().getBool('PROD'))) console.log(...msg);
}

});


parcelRegister("8XpwP", function(module, exports) {

$parcel$export(module.exports, "Profiler", () => $6857a2d26887063c$export$e2c29f18771995cb);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ibsdL = parcelRequire("ibsdL");

var $jjNRA = parcelRequire("jjNRA");
var $8cCb2 = parcelRequire("8cCb2");
class $6857a2d26887063c$export$e2c29f18771995cb {
    constructor(backendTimer, logger){
        this.backendTimer = backendTimer;
        this.logger = logger;
        if (logger == null) this.logger = new $6857a2d26887063c$export$efa9a398d6368992();
    }
    profileKernel(kernelName, inputs, f) {
        let outputs;
        const holdResultWrapperFn = ()=>{
            outputs = f();
        };
        let timer;
        const start = $jjNRA.now();
        if (this.backendTimer.timerAvailable()) timer = this.backendTimer.time(holdResultWrapperFn);
        else {
            holdResultWrapperFn();
            for (const output of outputs)output.dataSync();
            timer = Promise.resolve({
                kernelMs: $jjNRA.now() - start
            });
        }
        if ((0, $ibsdL.env)().getBool('CHECK_COMPUTATION_FOR_ERRORS')) for(let i = 0; i < outputs.length; i++){
            const output = outputs[i];
            // Dangling promise here because we don't want to propagate up
            // asynchronicity.
            output.data().then((tensorVals)=>{
                $6857a2d26887063c$export$7f6e9a47e989eedc(tensorVals, output.dtype, kernelName);
            });
        }
        const kernelProfile = {
            kernelName: kernelName,
            outputs: outputs,
            inputs: inputs,
            timeMs: timer.then((timing)=>timing.kernelMs),
            extraInfo: timer.then((timing)=>timing.getExtraProfileInfo != null ? timing.getExtraProfileInfo() : '')
        };
        return kernelProfile;
    }
    logKernelProfile(kernelProfile) {
        const { kernelName: kernelName, outputs: outputs, timeMs: timeMs, inputs: inputs, extraInfo: extraInfo } = kernelProfile;
        outputs.forEach((result)=>{
            Promise.all([
                result.data(),
                timeMs,
                extraInfo
            ]).then((valueContainer)=>{
                this.logger.logKernelProfile(kernelName, result, valueContainer[0], valueContainer[1], inputs, valueContainer[2]);
            });
        });
    }
}
function $6857a2d26887063c$export$7f6e9a47e989eedc(vals, dtype, kernelName) {
    if (dtype !== 'float32') // Only floating point computations will generate NaN values
    return false;
    for(let i = 0; i < vals.length; i++){
        const num = vals[i];
        if (isNaN(num) || !isFinite(num)) {
            // Throwing custom exception so behavior is testable.
            console.warn(`Found ${num} in the result of '${kernelName}'`);
            return true;
        }
    }
    return false;
}
class $6857a2d26887063c$export$efa9a398d6368992 {
    logKernelProfile(name, result, vals, timeMs, inputs, extraInfo) {
        const time = typeof timeMs === 'number' ? $8cCb2.rightPad(`${timeMs}ms`, 9) : timeMs['error'];
        const paddedName = $8cCb2.rightPad(name, 25);
        const rank = result.rank;
        const size = result.size;
        const shape = $8cCb2.rightPad(result.shape.toString(), 14);
        let inputShapesDescription = '';
        for(const name in inputs){
            const input = inputs[name];
            if (input != null) {
                // The input might be a non-tensor (e.g HTMLImageElement), in which case
                // we claim the output shape as input shape.
                const inputShape = input.shape || result.shape;
                const inputRank = inputShape.length;
                inputShapesDescription += `${name}: ${inputRank}D ${inputRank > 0 ? inputShape : ''} `;
            }
        }
        console.log(`%c${paddedName}\t%c${time}\t%c${rank}D ${shape}\t%c${size}\t%c${inputShapesDescription}\t%c${extraInfo}`, 'font-weight:bold', 'color:red', 'color:blue', 'color: orange', 'color: green', 'color: steelblue');
    }
}

});
parcelRegister("jjNRA", function(module, exports) {

$parcel$export(module.exports, "createScalarValue", () => $e10678764dab7ea0$export$cd3f28d8002ec2a2);
$parcel$export(module.exports, "encodeString", () => $e10678764dab7ea0$export$8146d2e653b87d6a);
$parcel$export(module.exports, "toTypedArray", () => $e10678764dab7ea0$export$965adc581230795c);
$parcel$export(module.exports, "flatten", () => $e10678764dab7ea0$export$bffa455ba8c619a6);
$parcel$export(module.exports, "now", () => $e10678764dab7ea0$export$461939dd4422153);
$parcel$export(module.exports, "fetch", () => $e10678764dab7ea0$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "decodeString", () => $e10678764dab7ea0$export$a0fb664af7d0cc44);
$parcel$export(module.exports, "isTypedArray", () => $e10678764dab7ea0$export$b119cc7e1840e59c);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ibsdL = parcelRequire("ibsdL");

var $6LqZS = parcelRequire("6LqZS");

var $8cCb2 = parcelRequire("8cCb2");

var $dI8yQ = parcelRequire("dI8yQ");
function $e10678764dab7ea0$export$cd3f28d8002ec2a2(value, dtype) {
    if (dtype === 'string') return $e10678764dab7ea0$export$8146d2e653b87d6a(value);
    return $e10678764dab7ea0$export$965adc581230795c([
        value
    ], dtype);
}
function $e10678764dab7ea0$var$noConversionNeeded(a, dtype) {
    return a instanceof Float32Array && dtype === 'float32' || a instanceof Int32Array && dtype === 'int32' || a instanceof Uint8Array && dtype === 'bool';
}
function $e10678764dab7ea0$export$965adc581230795c(a, dtype) {
    if (dtype === 'string') throw new Error('Cannot convert a string[] to a TypedArray');
    if (Array.isArray(a)) a = $e10678764dab7ea0$export$bffa455ba8c619a6(a);
    if ((0, $ibsdL.env)().getBool('DEBUG')) $8cCb2.checkConversionForErrors(a, dtype);
    if ($e10678764dab7ea0$var$noConversionNeeded(a, dtype)) return a;
    if (dtype == null || dtype === 'float32' || dtype === 'complex64') return new Float32Array(a);
    else if (dtype === 'int32') return new Int32Array(a);
    else if (dtype === 'bool') {
        const bool = new Uint8Array(a.length);
        for(let i = 0; i < bool.length; ++i)if (Math.round(a[i]) !== 0) bool[i] = 1;
        return bool;
    } else throw new Error(`Unknown data type ${dtype}`);
}
function $e10678764dab7ea0$export$461939dd4422153() {
    return (0, $ibsdL.env)().platform.now();
}
function $e10678764dab7ea0$export$e7aa7bc5c1b3cfb3(path, requestInits) {
    return (0, $ibsdL.env)().platform.fetch(path, requestInits);
}
function $e10678764dab7ea0$export$8146d2e653b87d6a(s, encoding = 'utf-8') {
    encoding = encoding || 'utf-8';
    return (0, $ibsdL.env)().platform.encode(s, encoding);
}
function $e10678764dab7ea0$export$a0fb664af7d0cc44(bytes, encoding = 'utf-8') {
    encoding = encoding || 'utf-8';
    return (0, $ibsdL.env)().platform.decode(bytes, encoding);
}
function $e10678764dab7ea0$export$b119cc7e1840e59c(a) {
    // TODO(mattsoulanille): Remove this fallback in 5.0.0
    if ((0, $ibsdL.env)().platform.isTypedArray != null) return (0, $ibsdL.env)().platform.isTypedArray(a);
    else return (0, $6LqZS.isTypedArrayBrowser)(a);
}
function $e10678764dab7ea0$export$bffa455ba8c619a6(arr, result = [], skipTypedArray = false) {
    if (result == null) result = [];
    if (typeof arr === 'boolean' || typeof arr === 'number' || typeof arr === 'string' || $8cCb2.isPromise(arr) || arr == null || $e10678764dab7ea0$export$b119cc7e1840e59c(arr) && skipTypedArray) result.push(arr);
    else if (Array.isArray(arr) || $e10678764dab7ea0$export$b119cc7e1840e59c(arr)) for(let i = 0; i < arr.length; ++i)$e10678764dab7ea0$export$bffa455ba8c619a6(arr[i], result, skipTypedArray);
    else {
        let maxIndex = -1;
        for (const key of Object.keys(arr))// 0 or positive integer.
        if (/^([1-9]+[0-9]*|0)$/.test(key)) maxIndex = Math.max(maxIndex, Number(key));
        for(let i = 0; i <= maxIndex; i++)// tslint:disable-next-line: no-unnecessary-type-assertion
        $e10678764dab7ea0$export$bffa455ba8c619a6(arr[i], result, skipTypedArray);
    }
    return result;
}
$parcel$exportWildcard(module.exports, $8cCb2);
$parcel$exportWildcard(module.exports, $dI8yQ);

});
parcelRegister("6LqZS", function(module, exports) {

$parcel$export(module.exports, "isTypedArrayBrowser", () => $4ecc12e21462e25f$export$632e6430b2d784cd);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $4ecc12e21462e25f$export$632e6430b2d784cd(a) {
    return a instanceof Float32Array || a instanceof Int32Array || a instanceof Uint8Array || a instanceof Uint8ClampedArray;
}

});

parcelRegister("dI8yQ", function(module, exports) {

$parcel$export(module.exports, "hexToLong", () => $9fb60678e6950826$export$20e49d17901a85a5);
$parcel$export(module.exports, "fingerPrint64", () => $9fb60678e6950826$export$919ee948dc019032);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Workaround for allowing cjs module to be included in bundle created by
// rollup.

var $iPWI7 = parcelRequire("iPWI7");
// tslint:disable-next-line
const $9fb60678e6950826$var$Long = // tslint:disable-next-line
$iPWI7.default || $iPWI7;
function $9fb60678e6950826$export$20e49d17901a85a5(hex) {
    return $9fb60678e6950826$var$Long.fromString(hex, true, 16);
}
// Some primes between 2^63 and 2^64 for various uses.
// Hex 0xc3a5c85c97cb3127
const $9fb60678e6950826$var$k0 = $9fb60678e6950826$export$20e49d17901a85a5('c3a5c85c97cb3127');
// Hex 0xb492b66fbe98f273
const $9fb60678e6950826$var$k1 = $9fb60678e6950826$export$20e49d17901a85a5('b492b66fbe98f273');
// Hex 0x9ae16a3b2f90404f
const $9fb60678e6950826$var$k2 = $9fb60678e6950826$export$20e49d17901a85a5('9ae16a3b2f90404f');
function $9fb60678e6950826$var$shiftMix(val) {
    return val.xor(val.shru(47));
}
function $9fb60678e6950826$var$fetch(s, offset, numBytes) {
    const bytes = s.slice(offset, offset + numBytes);
    return $9fb60678e6950826$var$Long.fromBytes(Array.from(bytes), true, true);
}
function $9fb60678e6950826$var$fetch64(s, offset) {
    return $9fb60678e6950826$var$fetch(s, offset, 8);
}
function $9fb60678e6950826$var$fetch32(s, offset) {
    return $9fb60678e6950826$var$fetch(s, offset, 4);
}
function $9fb60678e6950826$var$rotate64(val, shift) {
    // Avoid shifting by 64: doing so yields an undefined result.
    return shift === 0 ? val : val.shru(shift).or(val.shl(64 - shift));
}
function $9fb60678e6950826$var$hashLen16(u, v, mul = $9fb60678e6950826$export$20e49d17901a85a5('9ddfea08eb382d69')) {
    // Murmur-inspired hashing.
    let a = u.xor(v).mul(mul);
    a = a.xor(a.shru(47));
    let b = v.xor(a).mul(mul);
    b = b.xor(b.shru(47));
    b = b.mul(mul);
    return b;
}
// Return a 16-byte hash for 48 bytes.  Quick and dirty.
// Callers do best to use "random-looking" values for a and b.
function $9fb60678e6950826$var$weakHashLen32WithSeeds(w, x, y, z, a, b) {
    a = a.add(w);
    b = $9fb60678e6950826$var$rotate64(b.add(a).add(z), 21);
    const c = a;
    a = a.add(x);
    a = a.add(y);
    b = b.add($9fb60678e6950826$var$rotate64(a, 44));
    return [
        a.add(z),
        b.add(c)
    ];
}
function $9fb60678e6950826$var$weakHashLen32WithSeedsStr(s, offset, a, b) {
    return $9fb60678e6950826$var$weakHashLen32WithSeeds($9fb60678e6950826$var$fetch64(s, offset), $9fb60678e6950826$var$fetch64(s, offset + 8), $9fb60678e6950826$var$fetch64(s, offset + 16), $9fb60678e6950826$var$fetch64(s, offset + 24), a, b);
}
function $9fb60678e6950826$var$hashLen0to16(s, len = s.length) {
    if (len >= 8) {
        const mul = $9fb60678e6950826$var$k2.add(len * 2);
        const a = $9fb60678e6950826$var$fetch64(s, 0).add($9fb60678e6950826$var$k2);
        const b = $9fb60678e6950826$var$fetch64(s, len - 8);
        const c = $9fb60678e6950826$var$rotate64(b, 37).mul(mul).add(a);
        const d = $9fb60678e6950826$var$rotate64(a, 25).add(b).mul(mul);
        return $9fb60678e6950826$var$hashLen16(c, d, mul);
    }
    if (len >= 4) {
        const mul = $9fb60678e6950826$var$k2.add(len * 2);
        const a = $9fb60678e6950826$var$fetch32(s, 0);
        return $9fb60678e6950826$var$hashLen16(a.shl(3).add(len), $9fb60678e6950826$var$fetch32(s, len - 4), mul);
    }
    if (len > 0) {
        const a = s[0];
        const b = s[len >> 1];
        const c = s[len - 1];
        const y = a + (b << 8);
        const z = len + (c << 2);
        return $9fb60678e6950826$var$shiftMix($9fb60678e6950826$var$k2.mul(y).xor($9fb60678e6950826$var$k0.mul(z))).mul($9fb60678e6950826$var$k2);
    }
    return $9fb60678e6950826$var$k2;
}
function $9fb60678e6950826$var$hashLen17to32(s, len = s.length) {
    const mul = $9fb60678e6950826$var$k2.add(len * 2);
    const a = $9fb60678e6950826$var$fetch64(s, 0).mul($9fb60678e6950826$var$k1);
    const b = $9fb60678e6950826$var$fetch64(s, 8);
    const c = $9fb60678e6950826$var$fetch64(s, len - 8).mul(mul);
    const d = $9fb60678e6950826$var$fetch64(s, len - 16).mul($9fb60678e6950826$var$k2);
    return $9fb60678e6950826$var$hashLen16($9fb60678e6950826$var$rotate64(a.add(b), 43).add($9fb60678e6950826$var$rotate64(c, 30)).add(d), a.add($9fb60678e6950826$var$rotate64(b.add($9fb60678e6950826$var$k2), 18)).add(c), mul);
}
function $9fb60678e6950826$var$hashLen33to64(s, len = s.length) {
    const mul = $9fb60678e6950826$var$k2.add(len * 2);
    const a = $9fb60678e6950826$var$fetch64(s, 0).mul($9fb60678e6950826$var$k2);
    const b = $9fb60678e6950826$var$fetch64(s, 8);
    const c = $9fb60678e6950826$var$fetch64(s, len - 8).mul(mul);
    const d = $9fb60678e6950826$var$fetch64(s, len - 16).mul($9fb60678e6950826$var$k2);
    const y = $9fb60678e6950826$var$rotate64(a.add(b), 43).add($9fb60678e6950826$var$rotate64(c, 30)).add(d);
    const z = $9fb60678e6950826$var$hashLen16(y, a.add($9fb60678e6950826$var$rotate64(b.add($9fb60678e6950826$var$k2), 18)).add(c), mul);
    const e = $9fb60678e6950826$var$fetch64(s, 16).mul(mul);
    const f = $9fb60678e6950826$var$fetch64(s, 24);
    const g = y.add($9fb60678e6950826$var$fetch64(s, len - 32)).mul(mul);
    const h = z.add($9fb60678e6950826$var$fetch64(s, len - 24)).mul(mul);
    return $9fb60678e6950826$var$hashLen16($9fb60678e6950826$var$rotate64(e.add(f), 43).add($9fb60678e6950826$var$rotate64(g, 30)).add(h), e.add($9fb60678e6950826$var$rotate64(f.add(a), 18)).add(g), mul);
}
function $9fb60678e6950826$export$919ee948dc019032(s, len = s.length) {
    const seed = $9fb60678e6950826$var$Long.fromNumber(81, true);
    if (len <= 32) {
        if (len <= 16) return $9fb60678e6950826$var$hashLen0to16(s, len);
        else return $9fb60678e6950826$var$hashLen17to32(s, len);
    } else if (len <= 64) return $9fb60678e6950826$var$hashLen33to64(s, len);
    // For strings over 64 bytes we loop.  Internal state consists of
    // 56 bytes: v, w, x, y, and z.
    let x = seed;
    let y = seed.mul($9fb60678e6950826$var$k1).add(113);
    let z = $9fb60678e6950826$var$shiftMix(y.mul($9fb60678e6950826$var$k2).add(113)).mul($9fb60678e6950826$var$k2);
    let v = [
        $9fb60678e6950826$var$Long.UZERO,
        $9fb60678e6950826$var$Long.UZERO
    ];
    let w = [
        $9fb60678e6950826$var$Long.UZERO,
        $9fb60678e6950826$var$Long.UZERO
    ];
    x = x.mul($9fb60678e6950826$var$k2).add($9fb60678e6950826$var$fetch64(s, 0));
    let offset = 0;
    // Set end so that after the loop we have 1 to 64 bytes left to process.
    const end = (len - 1 >> 6) * 64;
    const last64 = end + (len - 1 & 63) - 63;
    do {
        x = $9fb60678e6950826$var$rotate64(x.add(y).add(v[0]).add($9fb60678e6950826$var$fetch64(s, offset + 8)), 37).mul($9fb60678e6950826$var$k1);
        y = $9fb60678e6950826$var$rotate64(y.add(v[1]).add($9fb60678e6950826$var$fetch64(s, offset + 48)), 42).mul($9fb60678e6950826$var$k1);
        x = x.xor(w[1]);
        y = y.add(v[0]).add($9fb60678e6950826$var$fetch64(s, offset + 40));
        z = $9fb60678e6950826$var$rotate64(z.add(w[0]), 33).mul($9fb60678e6950826$var$k1);
        v = $9fb60678e6950826$var$weakHashLen32WithSeedsStr(s, offset, v[1].mul($9fb60678e6950826$var$k1), x.add(w[0]));
        w = $9fb60678e6950826$var$weakHashLen32WithSeedsStr(s, offset + 32, z.add(w[1]), y.add($9fb60678e6950826$var$fetch64(s, offset + 16)));
        [z, x] = [
            x,
            z
        ];
        offset += 64;
    }while (offset !== end);
    const mul = $9fb60678e6950826$var$k1.add(z.and(0xff).shl(1));
    // Point to the last 64 bytes of input.
    offset = last64;
    w[0] = w[0].add(len - 1 & 63);
    v[0] = v[0].add(w[0]);
    w[0] = w[0].add(v[0]);
    x = $9fb60678e6950826$var$rotate64(x.add(y).add(v[0]).add($9fb60678e6950826$var$fetch64(s, offset + 8)), 37).mul(mul);
    y = $9fb60678e6950826$var$rotate64(y.add(v[1]).add($9fb60678e6950826$var$fetch64(s, offset + 48)), 42).mul(mul);
    x = x.xor(w[1].mul(9));
    y = y.add(v[0].mul(9).add($9fb60678e6950826$var$fetch64(s, offset + 40)));
    z = $9fb60678e6950826$var$rotate64(z.add(w[0]), 33).mul(mul);
    v = $9fb60678e6950826$var$weakHashLen32WithSeedsStr(s, offset, v[1].mul(mul), x.add(w[0]));
    w = $9fb60678e6950826$var$weakHashLen32WithSeedsStr(s, offset + 32, z.add(w[1]), y.add($9fb60678e6950826$var$fetch64(s, offset + 16)));
    [z, x] = [
        x,
        z
    ];
    return $9fb60678e6950826$var$hashLen16($9fb60678e6950826$var$hashLen16(v[0], w[0], mul).add($9fb60678e6950826$var$shiftMix(y).mul($9fb60678e6950826$var$k0)).add(z), $9fb60678e6950826$var$hashLen16(v[1], w[1], mul).add(x), mul);
}

});
parcelRegister("iPWI7", function(module, exports) {
module.exports = $db6a881889ec5536$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $db6a881889ec5536$var$wasm = null;
try {
    $db6a881889ec5536$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $db6a881889ec5536$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $db6a881889ec5536$var$Long.prototype.__isLong__;
Object.defineProperty($db6a881889ec5536$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $db6a881889ec5536$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $db6a881889ec5536$var$Long.isLong = $db6a881889ec5536$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $db6a881889ec5536$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $db6a881889ec5536$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $db6a881889ec5536$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $db6a881889ec5536$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $db6a881889ec5536$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $db6a881889ec5536$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $db6a881889ec5536$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $db6a881889ec5536$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $db6a881889ec5536$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromInt = $db6a881889ec5536$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $db6a881889ec5536$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $db6a881889ec5536$var$UZERO : $db6a881889ec5536$var$ZERO;
    if (unsigned) {
        if (value < 0) return $db6a881889ec5536$var$UZERO;
        if (value >= $db6a881889ec5536$var$TWO_PWR_64_DBL) return $db6a881889ec5536$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$db6a881889ec5536$var$TWO_PWR_63_DBL) return $db6a881889ec5536$var$MIN_VALUE;
        if (value + 1 >= $db6a881889ec5536$var$TWO_PWR_63_DBL) return $db6a881889ec5536$var$MAX_VALUE;
    }
    if (value < 0) return $db6a881889ec5536$var$fromNumber(-value, unsigned).neg();
    return $db6a881889ec5536$var$fromBits(value % $db6a881889ec5536$var$TWO_PWR_32_DBL | 0, value / $db6a881889ec5536$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromNumber = $db6a881889ec5536$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $db6a881889ec5536$var$fromBits(lowBits, highBits, unsigned) {
    return new $db6a881889ec5536$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromBits = $db6a881889ec5536$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $db6a881889ec5536$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $db6a881889ec5536$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $db6a881889ec5536$var$ZERO;
    if (typeof unsigned === 'number') // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    var p;
    if ((p = str.indexOf('-')) > 0) throw Error('interior hyphen');
    else if (p === 0) return $db6a881889ec5536$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $db6a881889ec5536$var$fromNumber($db6a881889ec5536$var$pow_dbl(radix, 8));
    var result = $db6a881889ec5536$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $db6a881889ec5536$var$fromNumber($db6a881889ec5536$var$pow_dbl(radix, size));
            result = result.mul(power).add($db6a881889ec5536$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($db6a881889ec5536$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromString = $db6a881889ec5536$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $db6a881889ec5536$var$fromValue(val, unsigned) {
    if (typeof val === 'number') return $db6a881889ec5536$var$fromNumber(val, unsigned);
    if (typeof val === 'string') return $db6a881889ec5536$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $db6a881889ec5536$var$fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $db6a881889ec5536$var$Long.fromValue = $db6a881889ec5536$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_32_DBL = $db6a881889ec5536$var$TWO_PWR_16_DBL * $db6a881889ec5536$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_64_DBL = $db6a881889ec5536$var$TWO_PWR_32_DBL * $db6a881889ec5536$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_63_DBL = $db6a881889ec5536$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_24 = $db6a881889ec5536$var$fromInt($db6a881889ec5536$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$ZERO = $db6a881889ec5536$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.ZERO = $db6a881889ec5536$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$UZERO = $db6a881889ec5536$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.UZERO = $db6a881889ec5536$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$ONE = $db6a881889ec5536$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.ONE = $db6a881889ec5536$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$UONE = $db6a881889ec5536$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.UONE = $db6a881889ec5536$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$NEG_ONE = $db6a881889ec5536$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.NEG_ONE = $db6a881889ec5536$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$MAX_VALUE = $db6a881889ec5536$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.MAX_VALUE = $db6a881889ec5536$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$MAX_UNSIGNED_VALUE = $db6a881889ec5536$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.MAX_UNSIGNED_VALUE = $db6a881889ec5536$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$MIN_VALUE = $db6a881889ec5536$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.MIN_VALUE = $db6a881889ec5536$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $db6a881889ec5536$var$LongPrototype = $db6a881889ec5536$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $db6a881889ec5536$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $db6a881889ec5536$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $db6a881889ec5536$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $db6a881889ec5536$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $db6a881889ec5536$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    if (this.isZero()) return '0';
    if (this.isNegative()) {
        if (this.eq($db6a881889ec5536$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $db6a881889ec5536$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return '-' + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $db6a881889ec5536$var$fromNumber($db6a881889ec5536$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = '';
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = '0' + digits;
            result = '' + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $db6a881889ec5536$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $db6a881889ec5536$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $db6a881889ec5536$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $db6a881889ec5536$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $db6a881889ec5536$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($db6a881889ec5536$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.eqz = $db6a881889ec5536$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.equals = function equals(other) {
    if (!$db6a881889ec5536$var$isLong(other)) other = $db6a881889ec5536$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.eq = $db6a881889ec5536$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.neq = $db6a881889ec5536$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.ne = $db6a881889ec5536$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.lt = $db6a881889ec5536$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.lte = $db6a881889ec5536$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.le = $db6a881889ec5536$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.gt = $db6a881889ec5536$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.gte = $db6a881889ec5536$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.ge = $db6a881889ec5536$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $db6a881889ec5536$var$LongPrototype.compare = function compare(other) {
    if (!$db6a881889ec5536$var$isLong(other)) other = $db6a881889ec5536$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $db6a881889ec5536$var$LongPrototype.comp = $db6a881889ec5536$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $db6a881889ec5536$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($db6a881889ec5536$var$MIN_VALUE)) return $db6a881889ec5536$var$MIN_VALUE;
    return this.not().add($db6a881889ec5536$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $db6a881889ec5536$var$LongPrototype.neg = $db6a881889ec5536$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $db6a881889ec5536$var$LongPrototype.add = function add(addend) {
    if (!$db6a881889ec5536$var$isLong(addend)) addend = $db6a881889ec5536$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $db6a881889ec5536$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $db6a881889ec5536$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$db6a881889ec5536$var$isLong(subtrahend)) subtrahend = $db6a881889ec5536$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $db6a881889ec5536$var$LongPrototype.sub = $db6a881889ec5536$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $db6a881889ec5536$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $db6a881889ec5536$var$ZERO;
    if (!$db6a881889ec5536$var$isLong(multiplier)) multiplier = $db6a881889ec5536$var$fromValue(multiplier);
    // use wasm support if present
    if ($db6a881889ec5536$var$wasm) {
        var low = $db6a881889ec5536$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $db6a881889ec5536$var$fromBits(low, $db6a881889ec5536$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $db6a881889ec5536$var$ZERO;
    if (this.eq($db6a881889ec5536$var$MIN_VALUE)) return multiplier.isOdd() ? $db6a881889ec5536$var$MIN_VALUE : $db6a881889ec5536$var$ZERO;
    if (multiplier.eq($db6a881889ec5536$var$MIN_VALUE)) return this.isOdd() ? $db6a881889ec5536$var$MIN_VALUE : $db6a881889ec5536$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($db6a881889ec5536$var$TWO_PWR_24) && multiplier.lt($db6a881889ec5536$var$TWO_PWR_24)) return $db6a881889ec5536$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $db6a881889ec5536$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $db6a881889ec5536$var$LongPrototype.mul = $db6a881889ec5536$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $db6a881889ec5536$var$LongPrototype.divide = function divide(divisor) {
    if (!$db6a881889ec5536$var$isLong(divisor)) divisor = $db6a881889ec5536$var$fromValue(divisor);
    if (divisor.isZero()) throw Error('division by zero');
    // use wasm support if present
    if ($db6a881889ec5536$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $db6a881889ec5536$var$wasm.div_u : $db6a881889ec5536$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $db6a881889ec5536$var$fromBits(low, $db6a881889ec5536$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $db6a881889ec5536$var$UZERO : $db6a881889ec5536$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($db6a881889ec5536$var$MIN_VALUE)) {
            if (divisor.eq($db6a881889ec5536$var$ONE) || divisor.eq($db6a881889ec5536$var$NEG_ONE)) return $db6a881889ec5536$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($db6a881889ec5536$var$MIN_VALUE)) return $db6a881889ec5536$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($db6a881889ec5536$var$ZERO)) return divisor.isNegative() ? $db6a881889ec5536$var$ONE : $db6a881889ec5536$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($db6a881889ec5536$var$MIN_VALUE)) return this.unsigned ? $db6a881889ec5536$var$UZERO : $db6a881889ec5536$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $db6a881889ec5536$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $db6a881889ec5536$var$UZERO;
        if (divisor.gt(this.shru(1))) return $db6a881889ec5536$var$UONE;
        res = $db6a881889ec5536$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $db6a881889ec5536$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $db6a881889ec5536$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $db6a881889ec5536$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $db6a881889ec5536$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $db6a881889ec5536$var$LongPrototype.div = $db6a881889ec5536$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $db6a881889ec5536$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$db6a881889ec5536$var$isLong(divisor)) divisor = $db6a881889ec5536$var$fromValue(divisor);
    // use wasm support if present
    if ($db6a881889ec5536$var$wasm) {
        var low = (this.unsigned ? $db6a881889ec5536$var$wasm.rem_u : $db6a881889ec5536$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $db6a881889ec5536$var$fromBits(low, $db6a881889ec5536$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $db6a881889ec5536$var$LongPrototype.mod = $db6a881889ec5536$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $db6a881889ec5536$var$LongPrototype.rem = $db6a881889ec5536$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $db6a881889ec5536$var$LongPrototype.not = function not() {
    return $db6a881889ec5536$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $db6a881889ec5536$var$LongPrototype.and = function and(other) {
    if (!$db6a881889ec5536$var$isLong(other)) other = $db6a881889ec5536$var$fromValue(other);
    return $db6a881889ec5536$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $db6a881889ec5536$var$LongPrototype.or = function or(other) {
    if (!$db6a881889ec5536$var$isLong(other)) other = $db6a881889ec5536$var$fromValue(other);
    return $db6a881889ec5536$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $db6a881889ec5536$var$LongPrototype.xor = function xor(other) {
    if (!$db6a881889ec5536$var$isLong(other)) other = $db6a881889ec5536$var$fromValue(other);
    return $db6a881889ec5536$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($db6a881889ec5536$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $db6a881889ec5536$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $db6a881889ec5536$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shl = $db6a881889ec5536$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($db6a881889ec5536$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $db6a881889ec5536$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $db6a881889ec5536$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shr = $db6a881889ec5536$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($db6a881889ec5536$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $db6a881889ec5536$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $db6a881889ec5536$var$fromBits(high, 0, this.unsigned);
        else return $db6a881889ec5536$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shru = $db6a881889ec5536$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shr_u = $db6a881889ec5536$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $db6a881889ec5536$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $db6a881889ec5536$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $db6a881889ec5536$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $db6a881889ec5536$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $db6a881889ec5536$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $db6a881889ec5536$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $db6a881889ec5536$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $db6a881889ec5536$var$Long.fromBytesLE(bytes, unsigned) : $db6a881889ec5536$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $db6a881889ec5536$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $db6a881889ec5536$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});




parcelRegister("8zD9D", function(module, exports) {

$parcel$export(module.exports, "getFilteredNodesXToY", () => $63dff6d774c8eeaf$export$13eebbb952f0db02);
$parcel$export(module.exports, "backpropagateGradients", () => $63dff6d774c8eeaf$export$2992958ba0a8790d);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
function $63dff6d774c8eeaf$export$13eebbb952f0db02(tape, xs, y) {
    // Forward pass to compute all the nodes and Tensors that are transitively a
    // function of x.
    const tensorsFromX = {};
    const nodesFromX = {};
    for(let i = 0; i < xs.length; i++)tensorsFromX[xs[i].id] = true;
    for(let i = 0; i < tape.length; i++){
        const node = tape[i];
        const nodeInputs = node.inputs;
        for(const inputName in nodeInputs){
            const input = nodeInputs[inputName];
            let anyInputFromX = false;
            for(let j = 0; j < xs.length; j++)if (tensorsFromX[input.id]) {
                node.outputs.forEach((output)=>tensorsFromX[output.id] = true);
                anyInputFromX = true;
                nodesFromX[node.id] = true;
                break;
            }
            if (anyInputFromX) break;
        }
    }
    // Backward pass to find all of the nodes and Tensors that lead to y.
    const tensorsLeadToY = {};
    tensorsLeadToY[y.id] = true;
    const nodesToY = {};
    for(let i = tape.length - 1; i >= 0; i--){
        const node = tape[i];
        const nodeInputs = node.inputs;
        // If any of the outputs lead to y, mark all of the inputs as leading to y.
        for(let j = 0; j < node.outputs.length; j++)if (tensorsLeadToY[node.outputs[j].id]) {
            for(const inputName in nodeInputs){
                tensorsLeadToY[nodeInputs[inputName].id] = true;
                nodesToY[node.id] = true;
            }
            break;
        }
    }
    // Return the paths that come from x and lead to y.
    const filteredTape = [];
    for(let i = 0; i < tape.length; i++){
        const node = tape[i];
        if (nodesFromX[node.id] && nodesToY[node.id]) {
            // Prune the inputs from the node that aren't a function of x.
            const prunedInputs = {};
            for(const inputName in node.inputs){
                const nodeInput = node.inputs[inputName];
                if (tensorsFromX[nodeInput.id]) prunedInputs[inputName] = nodeInput;
            }
            // Copy the node and overwrite inputsAndArgs to the pruned version.
            const prunedNode = Object.assign({}, node);
            prunedNode.inputs = prunedInputs;
            prunedNode.outputs = node.outputs;
            filteredTape.push(prunedNode);
        }
    }
    return filteredTape;
}
function $63dff6d774c8eeaf$export$2992958ba0a8790d(tensorAccumulatedGradientMap, filteredTape, tidy, add) {
    // Walk the tape backward and keep a map of Tensor to its gradient.
    for(let i = filteredTape.length - 1; i >= 0; i--){
        const node = filteredTape[i];
        const dys = [];
        node.outputs.forEach((o)=>{
            const gradTensor = tensorAccumulatedGradientMap[o.id];
            if (gradTensor != null) dys.push(gradTensor);
            else // This particular output is not in the back-propagation subgraph, so it
            // does not affect the final output, thus we put null for its dy.
            dys.push(null);
        });
        if (node.gradient == null) throw new Error(`Cannot compute gradient: gradient function not found ` + `for ${node.kernelName}.`);
        // Backprop dy through this node and accumulate gradients over the inputs.
        const inputGradients = node.gradient(dys);
        for(const inputName in node.inputs){
            if (!(inputName in inputGradients)) throw new Error(`Cannot backprop through input ${inputName}. ` + `Available gradients found: ${Object.keys(inputGradients)}.`);
            // Call the gradient function.
            const dx = tidy(()=>inputGradients[inputName]());
            if (dx.dtype !== 'float32') throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ` + `${inputName} must have 'float32' dtype, but has '${dx.dtype}'`);
            const x = node.inputs[inputName];
            if (!$8cCb2.arraysEqual(dx.shape, x.shape)) throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ` + `'${inputName}' has shape '${dx.shape}', which does not match ` + `the shape of the input '${x.shape}'`);
            if (tensorAccumulatedGradientMap[x.id] == null) tensorAccumulatedGradientMap[x.id] = dx;
            else {
                const curGradient = tensorAccumulatedGradientMap[x.id];
                tensorAccumulatedGradientMap[x.id] = add(curGradient, dx);
                curGradient.dispose();
            }
        }
    }
}

});

parcelRegister("9jCh7", function(module, exports) {

$parcel$export(module.exports, "TensorBuffer", () => $6c839404e55214b5$export$350df26cd52e08e1);
$parcel$export(module.exports, "setTensorTracker", () => $6c839404e55214b5$export$b1e34d2f0ffbbd85);
$parcel$export(module.exports, "setOpHandler", () => $6c839404e55214b5$export$1efe8d8b4884ad31);
$parcel$export(module.exports, "setDeprecationWarningFn", () => $6c839404e55214b5$export$ca605c1d8919649f);
$parcel$export(module.exports, "Tensor", () => $6c839404e55214b5$export$7b6b8d90402f8814);
$parcel$export(module.exports, "getGlobalTensorClass", () => $6c839404e55214b5$export$3cbd87e9d6a9b7ac);
$parcel$export(module.exports, "Variable", () => $6c839404e55214b5$export$c867a5c9595a1350);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Workaround for: https://github.com/bazelbuild/rules_nodejs/issues/1265
/// <reference types="@webgpu/types/dist" />

var $grcJs = parcelRequire("grcJs");

var $iODUZ = parcelRequire("iODUZ");

var $8cCb2 = parcelRequire("8cCb2");
var $jjNRA = parcelRequire("jjNRA");
class $6c839404e55214b5$export$350df26cd52e08e1 {
    constructor(shape, dtype, values){
        this.dtype = dtype;
        this.shape = shape.slice();
        this.size = $8cCb2.sizeFromShape(shape);
        if (values != null) {
            const n = values.length;
            $8cCb2.assert(n === this.size, ()=>`Length of values '${n}' does not match the size ` + `inferred by the shape '${this.size}'.`);
        }
        if (dtype === 'complex64') throw new Error(`complex64 dtype TensorBuffers are not supported. Please create ` + `a TensorBuffer for the real and imaginary parts separately and ` + `call tf.complex(real, imag).`);
        this.values = values || $8cCb2.getArrayFromDType(dtype, this.size);
        this.strides = (0, $8cCb2.computeStrides)(shape);
    }
    /**
     * Sets a value in the buffer at a given location.
     *
     * @param value The value to set.
     * @param locs  The location indices.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ set(value, ...locs) {
        if (locs.length === 0) locs = [
            0
        ];
        $8cCb2.assert(locs.length === this.rank, ()=>`The number of provided coordinates (${locs.length}) must ` + `match the rank (${this.rank})`);
        const index = this.locToIndex(locs);
        this.values[index] = value;
    }
    /**
     * Returns the value in the buffer at the provided location.
     *
     * @param locs The location indices.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ get(...locs) {
        if (locs.length === 0) locs = [
            0
        ];
        let i = 0;
        for (const loc of locs){
            if (loc < 0 || loc >= this.shape[i]) {
                const msg = `Requested out of range element at ${locs}. ` + `  Buffer shape=${this.shape}`;
                throw new Error(msg);
            }
            i++;
        }
        let index = locs[locs.length - 1];
        for(let i = 0; i < locs.length - 1; ++i)index += this.strides[i] * locs[i];
        return this.values[index];
    }
    locToIndex(locs) {
        if (this.rank === 0) return 0;
        else if (this.rank === 1) return locs[0];
        let index = locs[locs.length - 1];
        for(let i = 0; i < locs.length - 1; ++i)index += this.strides[i] * locs[i];
        return index;
    }
    indexToLoc(index) {
        if (this.rank === 0) return [];
        else if (this.rank === 1) return [
            index
        ];
        const locs = new Array(this.shape.length);
        for(let i = 0; i < locs.length - 1; ++i){
            locs[i] = Math.floor(index / this.strides[i]);
            index -= locs[i] * this.strides[i];
        }
        locs[locs.length - 1] = index;
        return locs;
    }
    get rank() {
        return this.shape.length;
    }
    /**
     * Creates an immutable `tf.Tensor` object from the buffer.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ toTensor() {
        return $6c839404e55214b5$var$trackerFn().makeTensor(this.values, this.shape, this.dtype);
    }
}
// For tracking tensor creation and disposal.
let $6c839404e55214b5$var$trackerFn = null;
// Used by chaining methods to call into ops.
let $6c839404e55214b5$var$opHandler = null;
// Used to warn about deprecated methods.
let $6c839404e55214b5$var$deprecationWarningFn = null;
function $6c839404e55214b5$export$b1e34d2f0ffbbd85(fn) {
    $6c839404e55214b5$var$trackerFn = fn;
}
function $6c839404e55214b5$export$1efe8d8b4884ad31(handler) {
    $6c839404e55214b5$var$opHandler = handler;
}
function $6c839404e55214b5$export$ca605c1d8919649f(fn) {
    $6c839404e55214b5$var$deprecationWarningFn = fn;
}
class $6c839404e55214b5$export$7b6b8d90402f8814 {
    constructor(shape, dtype, dataId, id){
        /** Whether this tensor has been globally kept. */ this.kept = false;
        this.isDisposedInternal = false;
        this.shape = shape.slice();
        this.dtype = dtype || 'float32';
        this.size = $8cCb2.sizeFromShape(shape);
        this.strides = (0, $8cCb2.computeStrides)(shape);
        this.dataId = dataId;
        this.id = id;
        this.rankType = this.rank < 5 ? this.rank.toString() : 'higher';
    }
    get rank() {
        return this.shape.length;
    }
    /**
     * Returns a promise of `tf.TensorBuffer` that holds the underlying data.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async buffer() {
        const vals = await this.data();
        return $6c839404e55214b5$var$opHandler.buffer(this.shape, this.dtype, vals);
    }
    /**
     * Returns a `tf.TensorBuffer` that holds the underlying data.
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ bufferSync() {
        return $6c839404e55214b5$var$opHandler.buffer(this.shape, this.dtype, this.dataSync());
    }
    /**
     * Returns the tensor data as a nested array. The transfer of data is done
     * asynchronously.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async array() {
        const vals = await this.data();
        return (0, $8cCb2.toNestedArray)(this.shape, vals, this.dtype === 'complex64');
    }
    /**
     * Returns the tensor data as a nested array. The transfer of data is done
     * synchronously.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ arraySync() {
        return (0, $8cCb2.toNestedArray)(this.shape, this.dataSync(), this.dtype === 'complex64');
    }
    /**
     * Asynchronously downloads the values from the `tf.Tensor`. Returns a
     * promise of `TypedArray` that resolves when the computation has finished.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async data() {
        this.throwIfDisposed();
        const data = $6c839404e55214b5$var$trackerFn().read(this.dataId);
        if (this.dtype === 'string') {
            const bytes = await data;
            try {
                return bytes.map((b)=>$jjNRA.decodeString(b));
            } catch (_a) {
                throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
            }
        }
        return data;
    }
    /**
     * Copy the tensor's data to a new GPU resource. Comparing to the `dataSync()`
     * and `data()`, this method prevents data from being downloaded to CPU.
     *
     * For WebGL backend, the data will be stored on a densely packed texture.
     * This means that the texture will use the RGBA channels to store value.
     *
     * For WebGPU backend, the data will be stored on a buffer. There is no
     * parameter, so can not use a user-defined size to create the buffer.
     *
     * @param options:
     *     For WebGL,
     *         - customTexShape: Optional. If set, will use the user defined
     *     texture shape to create the texture.
     *
     * @returns For WebGL backend, a GPUData contains the new texture and
     *     its information.
     *     {
     *        tensorRef: The tensor that is associated with this texture,
     *        texture: WebGLTexture,
     *        texShape: [number, number] // [height, width]
     *     }
     *
     *     For WebGPU backend, a GPUData contains the new buffer.
     *     {
     *        tensorRef: The tensor that is associated with this buffer,
     *        buffer: GPUBuffer,
     *     }
     *
     *     Remember to dispose the GPUData after it is used by
     *     `res.tensorRef.dispose()`.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dataToGPU(options) {
        this.throwIfDisposed();
        return $6c839404e55214b5$var$trackerFn().readToGPU(this.dataId, options);
    }
    /**
     * Synchronously downloads the values from the `tf.Tensor`. This blocks the
     * UI thread until the values are ready, which can cause performance issues.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dataSync() {
        this.throwIfDisposed();
        const data = $6c839404e55214b5$var$trackerFn().readSync(this.dataId);
        if (this.dtype === 'string') try {
            return data.map((b)=>$jjNRA.decodeString(b));
        } catch (_a) {
            throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
        }
        return data;
    }
    /** Returns the underlying bytes of the tensor's data. */ async bytes() {
        this.throwIfDisposed();
        const data = await $6c839404e55214b5$var$trackerFn().read(this.dataId);
        if (this.dtype === 'string') return data;
        else return new Uint8Array(data.buffer);
    }
    /**
     * Disposes `tf.Tensor` from memory.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dispose() {
        if (this.isDisposed) return;
        if (this.kerasMask) this.kerasMask.dispose();
        $6c839404e55214b5$var$trackerFn().disposeTensor(this);
        this.isDisposedInternal = true;
    }
    get isDisposed() {
        return this.isDisposedInternal;
    }
    throwIfDisposed() {
        if (this.isDisposed) throw new Error(`Tensor is disposed.`);
    }
    /**
     * Prints the `tf.Tensor`. See `tf.print` for details.
     *
     * @param verbose Whether to print verbose information about the tensor,
     *    including dtype and size.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ print(verbose = false) {
        return $6c839404e55214b5$var$opHandler.print(this, verbose);
    }
    /**
     * Returns a copy of the tensor. See `tf.clone` for details.
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ clone() {
        this.throwIfDisposed();
        return $6c839404e55214b5$var$opHandler.clone(this);
    }
    /**
     * Returns a human-readable description of the tensor. Useful for logging.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ toString(verbose = false) {
        const vals = this.dataSync();
        return (0, $iODUZ.tensorToString)(vals, this.shape, this.dtype, verbose);
    }
    cast(dtype) {
        this.throwIfDisposed();
        return $6c839404e55214b5$var$opHandler.cast(this, dtype);
    }
    variable(trainable = true, name, dtype) {
        this.throwIfDisposed();
        return $6c839404e55214b5$var$trackerFn().makeVariable(this, trainable, name, dtype);
    }
}
Object.defineProperty($6c839404e55214b5$export$7b6b8d90402f8814, Symbol.hasInstance, {
    value: (instance)=>{
        // Implementation note: we should use properties of the object that will be
        // defined before the constructor body has finished executing (methods).
        // This is because when this code is transpiled by babel, babel will call
        // classCallCheck before the constructor body is run.
        // See https://github.com/tensorflow/tfjs/issues/3384 for backstory.
        return !!instance && instance.data != null && instance.dataSync != null && instance.throwIfDisposed != null;
    }
});
function $6c839404e55214b5$export$3cbd87e9d6a9b7ac() {
    // Use getGlobal so that we can augment the Tensor class across package
    // boundaries because the node resolution alg may result in different modules
    // being returned for this file depending on the path they are loaded from.
    return (0, $grcJs.getGlobal)('Tensor', ()=>{
        return $6c839404e55214b5$export$7b6b8d90402f8814;
    });
}
// Global side effect. Cache global reference to Tensor class
$6c839404e55214b5$export$3cbd87e9d6a9b7ac();
class $6c839404e55214b5$export$c867a5c9595a1350 extends $6c839404e55214b5$export$7b6b8d90402f8814 {
    constructor(initialValue, trainable, name, tensorId){
        super(initialValue.shape, initialValue.dtype, initialValue.dataId, tensorId);
        this.trainable = trainable;
        this.name = name;
    }
    /**
     * Assign a new `tf.Tensor` to this variable. The new `tf.Tensor` must have
     * the same shape and dtype as the old `tf.Tensor`.
     *
     * @param newValue New tensor to be assigned to this variable.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ assign(newValue) {
        if (newValue.dtype !== this.dtype) throw new Error(`dtype of the new value (${newValue.dtype}) and ` + `previous value (${this.dtype}) must match`);
        if (!$8cCb2.arraysEqual(newValue.shape, this.shape)) throw new Error(`shape of the new value (${newValue.shape}) and ` + `previous value (${this.shape}) must match`);
        $6c839404e55214b5$var$trackerFn().disposeTensor(this);
        this.dataId = newValue.dataId;
        $6c839404e55214b5$var$trackerFn().incRef(this, null);
    }
    dispose() {
        $6c839404e55214b5$var$trackerFn().disposeVariable(this);
        this.isDisposedInternal = true;
    }
}
Object.defineProperty($6c839404e55214b5$export$c867a5c9595a1350, Symbol.hasInstance, {
    value: (instance)=>{
        return instance instanceof $6c839404e55214b5$export$7b6b8d90402f8814 && instance.assign != null && instance.assign instanceof Function;
    }
});

});
parcelRegister("iODUZ", function(module, exports) {

$parcel$export(module.exports, "tensorToString", () => $db2bdc726e48c731$export$7febe2c78b16daa7);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
// Maximum number of values before we decide to show ellipsis.
const $db2bdc726e48c731$var$FORMAT_LIMIT_NUM_VALS = 20;
// Number of first and last values to show when displaying a, b,...,y, z.
const $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS = 3;
// Number of significant digits to show.
const $db2bdc726e48c731$var$FORMAT_NUM_SIG_DIGITS = 7;
function $db2bdc726e48c731$export$7febe2c78b16daa7(vals, shape, dtype, verbose) {
    const strides = (0, $8cCb2.computeStrides)(shape);
    const padPerCol = $db2bdc726e48c731$var$computeMaxSizePerColumn(vals, shape, dtype, strides);
    const rank = shape.length;
    const valsLines = $db2bdc726e48c731$var$subTensorToString(vals, shape, dtype, strides, padPerCol);
    const lines = [
        'Tensor'
    ];
    if (verbose) {
        lines.push(`  dtype: ${dtype}`);
        lines.push(`  rank: ${rank}`);
        lines.push(`  shape: [${shape}]`);
        lines.push(`  values:`);
    }
    lines.push(valsLines.map((l)=>'    ' + l).join('\n'));
    return lines.join('\n');
}
function $db2bdc726e48c731$var$computeMaxSizePerColumn(vals, shape, dtype, strides) {
    const n = (0, $8cCb2.sizeFromShape)(shape);
    const numCols = strides[strides.length - 1];
    const padPerCol = new Array(numCols).fill(0);
    const rank = shape.length;
    const valuesOrTuples = dtype === 'complex64' ? $db2bdc726e48c731$var$createComplexTuples(vals) : vals;
    if (rank > 1) for(let row = 0; row < n / numCols; row++){
        const offset = row * numCols;
        for(let j = 0; j < numCols; j++)padPerCol[j] = Math.max(padPerCol[j], $db2bdc726e48c731$var$valToString(valuesOrTuples[offset + j], 0, dtype).length);
    }
    return padPerCol;
}
function $db2bdc726e48c731$var$valToString(val, pad, dtype) {
    let valStr;
    if (Array.isArray(val)) valStr = `${parseFloat(val[0].toFixed($db2bdc726e48c731$var$FORMAT_NUM_SIG_DIGITS))} + ` + `${parseFloat(val[1].toFixed($db2bdc726e48c731$var$FORMAT_NUM_SIG_DIGITS))}j`;
    else if ((0, $8cCb2.isString)(val)) valStr = `'${val}'`;
    else if (dtype === 'bool') valStr = $db2bdc726e48c731$var$boolNumToString(val);
    else valStr = parseFloat(val.toFixed($db2bdc726e48c731$var$FORMAT_NUM_SIG_DIGITS)).toString();
    return (0, $8cCb2.rightPad)(valStr, pad);
}
function $db2bdc726e48c731$var$boolNumToString(v) {
    return v === 0 ? 'false' : 'true';
}
function $db2bdc726e48c731$var$subTensorToString(vals, shape, dtype, strides, padPerCol, isLast = true) {
    const storagePerElement = dtype === 'complex64' ? 2 : 1;
    const size = shape[0];
    const rank = shape.length;
    if (rank === 0) {
        if (dtype === 'complex64') {
            const complexTuple = $db2bdc726e48c731$var$createComplexTuples(vals);
            return [
                $db2bdc726e48c731$var$valToString(complexTuple[0], 0, dtype)
            ];
        }
        if (dtype === 'bool') return [
            $db2bdc726e48c731$var$boolNumToString(vals[0])
        ];
        return [
            vals[0].toString()
        ];
    }
    if (rank === 1) {
        if (size > $db2bdc726e48c731$var$FORMAT_LIMIT_NUM_VALS) {
            const firstValsSize = $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS * storagePerElement;
            let firstVals = Array.from(vals.slice(0, firstValsSize));
            let lastVals = Array.from(vals.slice((size - $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS) * storagePerElement, size * storagePerElement));
            if (dtype === 'complex64') {
                firstVals = $db2bdc726e48c731$var$createComplexTuples(firstVals);
                lastVals = $db2bdc726e48c731$var$createComplexTuples(lastVals);
            }
            return [
                '[' + firstVals.map((x, i)=>$db2bdc726e48c731$var$valToString(x, padPerCol[i], dtype)).join(', ') + ', ..., ' + lastVals.map((x, i)=>$db2bdc726e48c731$var$valToString(x, padPerCol[size - $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS + i], dtype)).join(', ') + ']'
            ];
        }
        const displayVals = dtype === 'complex64' ? $db2bdc726e48c731$var$createComplexTuples(vals) : Array.from(vals);
        return [
            '[' + displayVals.map((x, i)=>$db2bdc726e48c731$var$valToString(x, padPerCol[i], dtype)).join(', ') + ']'
        ];
    }
    // The array is rank 2 or more.
    const subshape = shape.slice(1);
    const substrides = strides.slice(1);
    const stride = strides[0] * storagePerElement;
    const lines = [];
    if (size > $db2bdc726e48c731$var$FORMAT_LIMIT_NUM_VALS) {
        for(let i = 0; i < $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS; i++){
            const start = i * stride;
            const end = start + stride;
            lines.push(...$db2bdc726e48c731$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, false));
        }
        lines.push('...');
        for(let i = size - $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS; i < size; i++){
            const start = i * stride;
            const end = start + stride;
            lines.push(...$db2bdc726e48c731$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */ ));
        }
    } else for(let i = 0; i < size; i++){
        const start = i * stride;
        const end = start + stride;
        lines.push(...$db2bdc726e48c731$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */ ));
    }
    const sep = rank === 2 ? ',' : '';
    lines[0] = '[' + (size > 0 ? lines[0] + sep : '');
    for(let i = 1; i < lines.length - 1; i++)lines[i] = ' ' + lines[i] + sep;
    let newLineSep = ',\n';
    for(let i = 2; i < rank; i++)newLineSep += '\n';
    lines[lines.length - 1] = ' ' + lines[lines.length - 1] + ']' + (isLast ? '' : newLineSep);
    return lines;
}
function $db2bdc726e48c731$var$createComplexTuples(vals) {
    const complexTuples = [];
    for(let i = 0; i < vals.length; i += 2)complexTuples.push([
        vals[i],
        vals[i + 1]
    ]);
    return complexTuples;
}

});


parcelRegister("3w4Rg", function(module, exports) {

$parcel$export(module.exports, "makeTypesMatch", () => $28f820f91d9287a3$export$8b0e24c749a224d7);
$parcel$export(module.exports, "assertTypesMatch", () => $28f820f91d9287a3$export$8a66522456343d17);
$parcel$export(module.exports, "isTensorInList", () => $28f820f91d9287a3$export$537d2ee9de90a490);
$parcel$export(module.exports, "getTensorsInContainer", () => $28f820f91d9287a3$export$888c106d343989f5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9jCh7 = parcelRequire("9jCh7");

var $2MDja = parcelRequire("2MDja");

var $8cCb2 = parcelRequire("8cCb2");
function $28f820f91d9287a3$export$8b0e24c749a224d7(a, b) {
    if (a.dtype === b.dtype) return [
        a,
        b
    ];
    const dtype = (0, $2MDja.upcastType)(a.dtype, b.dtype);
    return [
        a.cast(dtype),
        b.cast(dtype)
    ];
}
function $28f820f91d9287a3$export$8a66522456343d17(a, b) {
    (0, $8cCb2.assert)(a.dtype === b.dtype, ()=>`The dtypes of the first(${a.dtype}) and` + ` second(${b.dtype}) input must match`);
}
function $28f820f91d9287a3$export$537d2ee9de90a490(tensor, tensorList) {
    return tensorList.some((x)=>x.id === tensor.id);
}
function $28f820f91d9287a3$export$888c106d343989f5(result) {
    const list = [];
    const seen = new Set();
    $28f820f91d9287a3$var$walkTensorContainer(result, list, seen);
    return list;
}
function $28f820f91d9287a3$var$walkTensorContainer(container, list, seen) {
    if (container == null) return;
    if (container instanceof (0, $9jCh7.Tensor)) {
        list.push(container);
        return;
    }
    if (!$28f820f91d9287a3$var$isIterable(container)) return;
    // Iteration over keys works also for arrays.
    const iterable = container;
    for(const k in iterable){
        const val = iterable[k];
        if (!seen.has(val)) {
            seen.add(val);
            $28f820f91d9287a3$var$walkTensorContainer(val, list, seen);
        }
    }
}
// tslint:disable-next-line:no-any
function $28f820f91d9287a3$var$isIterable(obj) {
    return Array.isArray(obj) || typeof obj === 'object';
}

});
parcelRegister("2MDja", function(module, exports) {

$parcel$export(module.exports, "upcastType", () => $206e8e4148e423f6$export$7bcca02d1a156bdf);
$parcel$export(module.exports, "sumOutType", () => $206e8e4148e423f6$export$3479b4fbed3c0d8d);
$parcel$export(module.exports, "isWebGLData", () => $206e8e4148e423f6$export$12371c78da2a116a);
$parcel$export(module.exports, "isWebGPUData", () => $206e8e4148e423f6$export$db4071ca636ae03b);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $206e8e4148e423f6$export$c36edca8f8f0427a;
(function(Rank) {
    Rank["R0"] = "R0";
    Rank["R1"] = "R1";
    Rank["R2"] = "R2";
    Rank["R3"] = "R3";
    Rank["R4"] = "R4";
    Rank["R5"] = "R5";
    Rank["R6"] = "R6";
})($206e8e4148e423f6$export$c36edca8f8f0427a || ($206e8e4148e423f6$export$c36edca8f8f0427a = {}));
// Looks for upcasting types. Used, for example, in operations with mixed dtype
// inputs.
var $206e8e4148e423f6$var$UpcastInt32AndMap;
(function(UpcastInt32AndMap) {
    UpcastInt32AndMap["float32"] = "float32";
    UpcastInt32AndMap["int32"] = "int32";
    UpcastInt32AndMap["bool"] = "int32";
    UpcastInt32AndMap["complex64"] = "complex64";
})($206e8e4148e423f6$var$UpcastInt32AndMap || ($206e8e4148e423f6$var$UpcastInt32AndMap = {}));
var $206e8e4148e423f6$var$UpcastBoolAndMap;
(function(UpcastBoolAndMap) {
    UpcastBoolAndMap["float32"] = "float32";
    UpcastBoolAndMap["int32"] = "int32";
    UpcastBoolAndMap["bool"] = "bool";
    UpcastBoolAndMap["complex64"] = "complex64";
})($206e8e4148e423f6$var$UpcastBoolAndMap || ($206e8e4148e423f6$var$UpcastBoolAndMap = {}));
var $206e8e4148e423f6$var$UpcastFloat32AndMap;
(function(UpcastFloat32AndMap) {
    UpcastFloat32AndMap["float32"] = "float32";
    UpcastFloat32AndMap["int32"] = "float32";
    UpcastFloat32AndMap["bool"] = "float32";
    UpcastFloat32AndMap["complex64"] = "complex64";
})($206e8e4148e423f6$var$UpcastFloat32AndMap || ($206e8e4148e423f6$var$UpcastFloat32AndMap = {}));
var $206e8e4148e423f6$var$UpcastComplex64AndMap;
(function(UpcastComplex64AndMap) {
    UpcastComplex64AndMap["float32"] = "complex64";
    UpcastComplex64AndMap["int32"] = "complex64";
    UpcastComplex64AndMap["bool"] = "complex64";
    UpcastComplex64AndMap["complex64"] = "complex64";
})($206e8e4148e423f6$var$UpcastComplex64AndMap || ($206e8e4148e423f6$var$UpcastComplex64AndMap = {}));
const $206e8e4148e423f6$var$upcastTypeMap = {
    'float32': $206e8e4148e423f6$var$UpcastFloat32AndMap,
    'int32': $206e8e4148e423f6$var$UpcastInt32AndMap,
    'bool': $206e8e4148e423f6$var$UpcastBoolAndMap,
    'complex64': $206e8e4148e423f6$var$UpcastComplex64AndMap
};
function $206e8e4148e423f6$export$7bcca02d1a156bdf(typeA, typeB) {
    if (typeA === 'string' || typeB === 'string') {
        if (typeA === 'string' && typeB === 'string') return 'string';
        throw new Error(`Can not upcast ${typeA} with ${typeB}`);
    }
    return $206e8e4148e423f6$var$upcastTypeMap[typeA][typeB];
}
function $206e8e4148e423f6$export$3479b4fbed3c0d8d(type) {
    return $206e8e4148e423f6$export$7bcca02d1a156bdf(type, 'int32');
}
function $206e8e4148e423f6$export$12371c78da2a116a(values) {
    return values != null && typeof values === 'object' && 'texture' in values && values.texture instanceof WebGLTexture;
}
function $206e8e4148e423f6$export$db4071ca636ae03b(values) {
    return typeof GPUBuffer !== 'undefined' && values != null && typeof values === 'object' && 'buffer' in values && values.buffer instanceof GPUBuffer;
}

});



parcelRegister("dcHSK", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("38WwN");

var $4GTZ3 = parcelRequire("4GTZ3");

var $ibsdL = parcelRequire("ibsdL");
const $99ce6f6ee5cbe792$var$ENV = (0, $ibsdL.env)();
/**
 * This file contains environment-related flag registrations.
 */ /** Whether to enable debug mode. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('DEBUG', ()=>false, (debugValue)=>{
    if (debugValue) console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
});
/** Whether we are in a browser (as versus, say, node.js) environment. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('IS_BROWSER', ()=>$4GTZ3.isBrowser());
/** Whether we are in a browser (as versus, say, node.js) environment. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('IS_NODE', ()=>false);
/** Whether this browser is Chrome. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('IS_CHROME', ()=>typeof navigator !== 'undefined' && navigator != null && navigator.userAgent != null && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
/** Whether this browser is Safari. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('IS_SAFARI', ()=>typeof navigator !== 'undefined' && navigator != null && navigator.userAgent != null && /Safari/.test(navigator.userAgent) && /Apple/.test(navigator.vendor));
/**
 * True when the environment is "production" where we disable safety checks
 * to gain performance.
 */ $99ce6f6ee5cbe792$var$ENV.registerFlag('PROD', ()=>false);
/**
 * Whether to do sanity checks when inferring a shape from user-provided
 * values, used when creating a new tensor.
 */ $99ce6f6ee5cbe792$var$ENV.registerFlag('TENSORLIKE_CHECK_SHAPE_CONSISTENCY', ()=>$99ce6f6ee5cbe792$var$ENV.getBool('DEBUG'));
/** Whether deprecation warnings are enabled. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('DEPRECATION_WARNINGS_ENABLED', ()=>true);
/** True if running unit tests. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('IS_TEST', ()=>false);
/** Whether to check computation result for errors. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('CHECK_COMPUTATION_FOR_ERRORS', ()=>$99ce6f6ee5cbe792$var$ENV.getBool('DEBUG'));
/** Whether the backend needs to wrap input to imageBitmap. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('WRAP_TO_IMAGEBITMAP', ()=>false);
/** Whether to enable canvas2d willReadFrequently for GPU backends */ $99ce6f6ee5cbe792$var$ENV.registerFlag('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU', ()=>false);
/** Whether to use setTimeoutCustom */ $99ce6f6ee5cbe792$var$ENV.registerFlag('USE_SETTIMEOUTCUSTOM', ()=>false);

});
parcelRegister("4GTZ3", function(module, exports) {

$parcel$export(module.exports, "mockIsMobile", () => $36a682e0812b3b99$export$f55f7bd5cb259cb2);
$parcel$export(module.exports, "isMobile", () => $36a682e0812b3b99$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "isBrowser", () => $36a682e0812b3b99$export$4e09c449d6c407f7);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line:no-any
function $36a682e0812b3b99$var$_isNavigatorDefined() {
    return typeof navigator !== 'undefined' && navigator != null;
}
let $36a682e0812b3b99$var$isMobileMockValue;
function $36a682e0812b3b99$export$f55f7bd5cb259cb2(value) {
    $36a682e0812b3b99$var$isMobileMockValue = value;
}
function $36a682e0812b3b99$export$d0a8044dce8ff2fc(nav) {
    if ($36a682e0812b3b99$var$isMobileMockValue !== undefined) return $36a682e0812b3b99$var$isMobileMockValue;
    if (nav || $36a682e0812b3b99$var$_isNavigatorDefined()) {
        if (!nav) nav = navigator;
        if (nav.product === 'ReactNative') return true;
        const a = nav.userAgent || nav.vendor || // tslint:disable-next-line:no-any
        (typeof window !== 'undefined' ? window.opera : '');
        // Use `navigator.userAgentData.mobile` as fallback.
        if (!a) {
            // tslint:disable-next-line:no-any
            const navAny = nav;
            return navAny.userAgentData && navAny.userAgentData.mobile;
        }
        // tslint:disable-next-line:max-line-length
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || // tslint:disable-next-line:max-line-length
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
    }
    return false;
}
function $36a682e0812b3b99$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' && window.document != null || //@ts-ignore
    typeof WorkerGlobalScope !== 'undefined';
}

});


parcelRegister("1MXhU", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("dcHSK");

var $ibsdL = parcelRequire("ibsdL");

var $caMdQ = parcelRequire("caMdQ");

var $h6KCl = parcelRequire("h6KCl");

var $1PMKz = parcelRequire("1PMKz");

var $6LqZS = parcelRequire("6LqZS");
class $14d84372e9b9718d$export$c812b315576f1552 {
    constructor(){
        // For setTimeoutCustom
        this.messageName = 'setTimeoutCustom';
        this.functionRefs = [];
        this.handledMessageCount = 0;
        this.hasEventListener = false;
    }
    fetch(path, init) {
        return fetch(path, init);
    }
    now() {
        return performance.now();
    }
    encode(text, encoding) {
        if (encoding !== 'utf-8' && encoding !== 'utf8') throw new Error(`Browser's encoder only supports utf-8, but got ${encoding}`);
        if (this.textEncoder == null) this.textEncoder = new TextEncoder();
        return this.textEncoder.encode(text);
    }
    decode(bytes, encoding) {
        return new TextDecoder(encoding).decode(bytes);
    }
    // If the setTimeout nesting level is greater than 5 and timeout is less
    // than 4ms, timeout will be clamped to 4ms, which hurts the perf.
    // Interleaving window.postMessage and setTimeout will trick the browser and
    // avoid the clamp.
    setTimeoutCustom(functionRef, delay) {
        if (typeof window === 'undefined' || !(0, $ibsdL.env)().getBool('USE_SETTIMEOUTCUSTOM')) {
            setTimeout(functionRef, delay);
            return;
        }
        this.functionRefs.push(functionRef);
        setTimeout(()=>{
            window.postMessage({
                name: this.messageName,
                index: this.functionRefs.length - 1
            }, '*');
        }, delay);
        if (!this.hasEventListener) {
            this.hasEventListener = true;
            window.addEventListener('message', (event)=>{
                if (event.source === window && event.data.name === this.messageName) {
                    event.stopPropagation();
                    const functionRef = this.functionRefs[event.data.index];
                    functionRef();
                    this.handledMessageCount++;
                    if (this.handledMessageCount === this.functionRefs.length) {
                        this.functionRefs = [];
                        this.handledMessageCount = 0;
                    }
                }
            }, true);
        }
    }
    isTypedArray(a) {
        return (0, $6LqZS.isTypedArrayBrowser)(a);
    }
}
if ((0, $ibsdL.env)().get('IS_BROWSER')) {
    (0, $ibsdL.env)().setPlatform('browser', new $14d84372e9b9718d$export$c812b315576f1552());
    // Register LocalStorage IOHandler
    try {
        (0, $1PMKz.ModelStoreManagerRegistry).registerManager((0, $h6KCl.BrowserLocalStorage).URL_SCHEME, new (0, $h6KCl.BrowserLocalStorageManager)());
    } catch (err) {}
    // Register IndexedDB IOHandler
    try {
        (0, $1PMKz.ModelStoreManagerRegistry).registerManager((0, $caMdQ.BrowserIndexedDB).URL_SCHEME, new (0, $caMdQ.BrowserIndexedDBManager)());
    } catch (err) {}
}

});
parcelRegister("caMdQ", function(module, exports) {

$parcel$export(module.exports, "BrowserIndexedDB", () => $8dcbd320ae526cfe$export$2c670ce804876090);
$parcel$export(module.exports, "BrowserIndexedDBManager", () => $8dcbd320ae526cfe$export$4b0775e2ff88802);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("dcHSK");

var $ibsdL = parcelRequire("ibsdL");

var $4FRLN = parcelRequire("4FRLN");

var $9RUNn = parcelRequire("9RUNn");

var $hBb8J = parcelRequire("hBb8J");
const $8dcbd320ae526cfe$var$DATABASE_NAME = 'tensorflowjs';
const $8dcbd320ae526cfe$var$DATABASE_VERSION = 1;
// Model data and ModelArtifactsInfo (metadata) are stored in two separate
// stores for efficient access of the list of stored models and their metadata.
// 1. The object store for model data: topology, weights and weight manifests.
const $8dcbd320ae526cfe$var$MODEL_STORE_NAME = 'models_store';
// 2. The object store for ModelArtifactsInfo, including meta-information such
//    as the type of topology (JSON vs binary), byte size of the topology, byte
//    size of the weights, etc.
const $8dcbd320ae526cfe$var$INFO_STORE_NAME = 'model_info_store';
async function $8dcbd320ae526cfe$export$24b6df48b2529372() {
    const idbFactory = $8dcbd320ae526cfe$var$getIndexedDBFactory();
    return new Promise((resolve, reject)=>{
        const deleteRequest = idbFactory.deleteDatabase($8dcbd320ae526cfe$var$DATABASE_NAME);
        deleteRequest.onsuccess = ()=>resolve();
        deleteRequest.onerror = (error)=>reject(error);
    });
}
function $8dcbd320ae526cfe$var$getIndexedDBFactory() {
    if (!(0, $ibsdL.env)().getBool('IS_BROWSER')) // TODO(cais): Add more info about what IOHandler subtypes are available.
    //   Maybe point to a doc page on the web and/or automatically determine
    //   the available IOHandlers and print them in the error message.
    throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
    // tslint:disable-next-line:no-any
    const theWindow = typeof window === 'undefined' ? self : window;
    const factory = theWindow.indexedDB || theWindow.mozIndexedDB || theWindow.webkitIndexedDB || theWindow.msIndexedDB || theWindow.shimIndexedDB;
    if (factory == null) throw new Error('The current browser does not appear to support IndexedDB.');
    return factory;
}
function $8dcbd320ae526cfe$var$setUpDatabase(openRequest) {
    const db = openRequest.result;
    db.createObjectStore($8dcbd320ae526cfe$var$MODEL_STORE_NAME, {
        keyPath: 'modelPath'
    });
    db.createObjectStore($8dcbd320ae526cfe$var$INFO_STORE_NAME, {
        keyPath: 'modelPath'
    });
}
/**
 * IOHandler subclass: Browser IndexedDB.
 *
 * See the doc string of `browserIndexedDB` for more details.
 */ class $8dcbd320ae526cfe$export$2c670ce804876090 {
    constructor(modelPath){
        this.indexedDB = $8dcbd320ae526cfe$var$getIndexedDBFactory();
        if (modelPath == null || !modelPath) throw new Error('For IndexedDB, modelPath must not be null, undefined or empty.');
        this.modelPath = modelPath;
    }
    async save(modelArtifacts) {
        // TODO(cais): Support saving GraphDef models.
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        return this.databaseAction(this.modelPath, modelArtifacts);
    }
    async load() {
        return this.databaseAction(this.modelPath);
    }
    /**
     * Perform database action to put model artifacts into or read model artifacts
     * from IndexedDB object store.
     *
     * Whether the action is put or get depends on whether `modelArtifacts` is
     * specified. If it is specified, the action will be put; otherwise the action
     * will be get.
     *
     * @param modelPath A unique string path for the model.
     * @param modelArtifacts If specified, it will be the model artifacts to be
     *   stored in IndexedDB.
     * @returns A `Promise` of `SaveResult`, if the action is put, or a `Promise`
     *   of `ModelArtifacts`, if the action is get.
     */ databaseAction(modelPath, modelArtifacts) {
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($8dcbd320ae526cfe$var$DATABASE_NAME, $8dcbd320ae526cfe$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$8dcbd320ae526cfe$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                if (modelArtifacts == null) {
                    // Read model out from object store.
                    const modelTx = db.transaction($8dcbd320ae526cfe$var$MODEL_STORE_NAME, 'readonly');
                    const modelStore = modelTx.objectStore($8dcbd320ae526cfe$var$MODEL_STORE_NAME);
                    const getRequest = modelStore.get(this.modelPath);
                    getRequest.onsuccess = ()=>{
                        if (getRequest.result == null) {
                            db.close();
                            return reject(new Error(`Cannot find model with path '${this.modelPath}' ` + `in IndexedDB.`));
                        } else resolve(getRequest.result.modelArtifacts);
                    };
                    getRequest.onerror = (error)=>{
                        db.close();
                        return reject(getRequest.error);
                    };
                    modelTx.oncomplete = ()=>db.close();
                } else {
                    // Put model into object store.
                    // Concatenate all the model weights into a single ArrayBuffer. Large
                    // models (~1GB) have problems saving if they are not concatenated.
                    // TODO(mattSoulanille): Save large models to multiple indexeddb
                    // records.
                    modelArtifacts.weightData = (0, $hBb8J.CompositeArrayBuffer).join(modelArtifacts.weightData);
                    const modelArtifactsInfo = (0, $4FRLN.getModelArtifactsInfoForJSON)(modelArtifacts);
                    // First, put ModelArtifactsInfo into info store.
                    const infoTx = db.transaction($8dcbd320ae526cfe$var$INFO_STORE_NAME, 'readwrite');
                    let infoStore = infoTx.objectStore($8dcbd320ae526cfe$var$INFO_STORE_NAME);
                    let putInfoRequest;
                    try {
                        putInfoRequest = infoStore.put({
                            modelPath: this.modelPath,
                            modelArtifactsInfo: modelArtifactsInfo
                        });
                    } catch (error) {
                        return reject(error);
                    }
                    let modelTx;
                    putInfoRequest.onsuccess = ()=>{
                        // Second, put model data into model store.
                        modelTx = db.transaction($8dcbd320ae526cfe$var$MODEL_STORE_NAME, 'readwrite');
                        const modelStore = modelTx.objectStore($8dcbd320ae526cfe$var$MODEL_STORE_NAME);
                        let putModelRequest;
                        try {
                            putModelRequest = modelStore.put({
                                modelPath: this.modelPath,
                                modelArtifacts: modelArtifacts,
                                modelArtifactsInfo: modelArtifactsInfo
                            });
                        } catch (error) {
                            // Sometimes, the serialized value is too large to store.
                            return reject(error);
                        }
                        putModelRequest.onsuccess = ()=>resolve({
                                modelArtifactsInfo: modelArtifactsInfo
                            });
                        putModelRequest.onerror = (error)=>{
                            // If the put-model request fails, roll back the info entry as
                            // well.
                            infoStore = infoTx.objectStore($8dcbd320ae526cfe$var$INFO_STORE_NAME);
                            const deleteInfoRequest = infoStore.delete(this.modelPath);
                            deleteInfoRequest.onsuccess = ()=>{
                                db.close();
                                return reject(putModelRequest.error);
                            };
                            deleteInfoRequest.onerror = (error)=>{
                                db.close();
                                return reject(putModelRequest.error);
                            };
                        };
                    };
                    putInfoRequest.onerror = (error)=>{
                        db.close();
                        return reject(putInfoRequest.error);
                    };
                    infoTx.oncomplete = ()=>{
                        if (modelTx == null) db.close();
                        else modelTx.oncomplete = ()=>db.close();
                    };
                }
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
}
$8dcbd320ae526cfe$export$2c670ce804876090.URL_SCHEME = 'indexeddb://';
const $8dcbd320ae526cfe$export$7375c81acb8edf6e = (url)=>{
    if (!(0, $ibsdL.env)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($8dcbd320ae526cfe$export$2c670ce804876090.URL_SCHEME)) return $8dcbd320ae526cfe$export$a4d8901e5a950049(url.slice($8dcbd320ae526cfe$export$2c670ce804876090.URL_SCHEME.length));
        else return null;
    }
};
(0, $9RUNn.IORouterRegistry).registerSaveRouter($8dcbd320ae526cfe$export$7375c81acb8edf6e);
(0, $9RUNn.IORouterRegistry).registerLoadRouter($8dcbd320ae526cfe$export$7375c81acb8edf6e);
function $8dcbd320ae526cfe$export$a4d8901e5a950049(modelPath) {
    return new $8dcbd320ae526cfe$export$2c670ce804876090(modelPath);
}
function $8dcbd320ae526cfe$var$maybeStripScheme(key) {
    return key.startsWith($8dcbd320ae526cfe$export$2c670ce804876090.URL_SCHEME) ? key.slice($8dcbd320ae526cfe$export$2c670ce804876090.URL_SCHEME.length) : key;
}
class $8dcbd320ae526cfe$export$4b0775e2ff88802 {
    constructor(){
        this.indexedDB = $8dcbd320ae526cfe$var$getIndexedDBFactory();
    }
    async listModels() {
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($8dcbd320ae526cfe$var$DATABASE_NAME, $8dcbd320ae526cfe$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$8dcbd320ae526cfe$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                const tx = db.transaction($8dcbd320ae526cfe$var$INFO_STORE_NAME, 'readonly');
                const store = tx.objectStore($8dcbd320ae526cfe$var$INFO_STORE_NAME);
                // tslint:disable:max-line-length
                // Need to cast `store` as `any` here because TypeScript's DOM
                // library does not have the `getAll()` method even though the
                // method is supported in the latest version of most mainstream
                // browsers:
                // https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/getAll
                // tslint:enable:max-line-length
                // tslint:disable-next-line:no-any
                const getAllInfoRequest = store.getAll();
                getAllInfoRequest.onsuccess = ()=>{
                    const out = {};
                    for (const item of getAllInfoRequest.result)out[item.modelPath] = item.modelArtifactsInfo;
                    resolve(out);
                };
                getAllInfoRequest.onerror = (error)=>{
                    db.close();
                    return reject(getAllInfoRequest.error);
                };
                tx.oncomplete = ()=>db.close();
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
    async removeModel(path) {
        path = $8dcbd320ae526cfe$var$maybeStripScheme(path);
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($8dcbd320ae526cfe$var$DATABASE_NAME, $8dcbd320ae526cfe$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$8dcbd320ae526cfe$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                const infoTx = db.transaction($8dcbd320ae526cfe$var$INFO_STORE_NAME, 'readwrite');
                const infoStore = infoTx.objectStore($8dcbd320ae526cfe$var$INFO_STORE_NAME);
                const getInfoRequest = infoStore.get(path);
                let modelTx;
                getInfoRequest.onsuccess = ()=>{
                    if (getInfoRequest.result == null) {
                        db.close();
                        return reject(new Error(`Cannot find model with path '${path}' ` + `in IndexedDB.`));
                    } else {
                        // First, delete the entry in the info store.
                        const deleteInfoRequest = infoStore.delete(path);
                        const deleteModelData = ()=>{
                            // Second, delete the entry in the model store.
                            modelTx = db.transaction($8dcbd320ae526cfe$var$MODEL_STORE_NAME, 'readwrite');
                            const modelStore = modelTx.objectStore($8dcbd320ae526cfe$var$MODEL_STORE_NAME);
                            const deleteModelRequest = modelStore.delete(path);
                            deleteModelRequest.onsuccess = ()=>resolve(getInfoRequest.result.modelArtifactsInfo);
                            deleteModelRequest.onerror = (error)=>reject(getInfoRequest.error);
                        };
                        // Proceed with deleting model data regardless of whether deletion
                        // of info data succeeds or not.
                        deleteInfoRequest.onsuccess = deleteModelData;
                        deleteInfoRequest.onerror = (error)=>{
                            deleteModelData();
                            db.close();
                            return reject(getInfoRequest.error);
                        };
                    }
                };
                getInfoRequest.onerror = (error)=>{
                    db.close();
                    return reject(getInfoRequest.error);
                };
                infoTx.oncomplete = ()=>{
                    if (modelTx == null) db.close();
                    else modelTx.oncomplete = ()=>db.close();
                };
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
}

});
parcelRegister("4FRLN", function(module, exports) {

$parcel$export(module.exports, "encodeWeights", () => $3674b353dc6c3d42$export$6c50c12dbd6168b);
$parcel$export(module.exports, "decodeWeights", () => $3674b353dc6c3d42$export$7a14c2428d4f4a2e);
$parcel$export(module.exports, "decodeWeightsStream", () => $3674b353dc6c3d42$export$6c19531ae9ba1204);
$parcel$export(module.exports, "arrayBufferToBase64String", () => $3674b353dc6c3d42$export$28e753ea3e93cabf);
$parcel$export(module.exports, "base64StringToArrayBuffer", () => $3674b353dc6c3d42$export$aa941b9d243f1be4);
$parcel$export(module.exports, "concatenateArrayBuffers", () => $3674b353dc6c3d42$export$9a3e9c78eb778da8);
$parcel$export(module.exports, "basename", () => $3674b353dc6c3d42$export$9bf319d8f74f51d1);
$parcel$export(module.exports, "getModelJSONForModelArtifacts", () => $3674b353dc6c3d42$export$a725daa2cfaa7bd5);
$parcel$export(module.exports, "getModelArtifactsForJSONSync", () => $3674b353dc6c3d42$export$ebf48c0f134e5c8);
$parcel$export(module.exports, "getModelArtifactsForJSON", () => $3674b353dc6c3d42$export$b867c14eedd5b8a2);
$parcel$export(module.exports, "getModelArtifactsInfoForJSON", () => $3674b353dc6c3d42$export$ece8b449d7d29272);
$parcel$export(module.exports, "getWeightSpecs", () => $3674b353dc6c3d42$export$9f3fe06e8e8def44);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $20oDZ = parcelRequire("20oDZ");

var $erbmM = parcelRequire("erbmM");

var $8cCb2 = parcelRequire("8cCb2");

var $2bXta = parcelRequire("2bXta");

var $hBb8J = parcelRequire("hBb8J");

var $c2DT1 = parcelRequire("c2DT1");

var $ibsdL = parcelRequire("ibsdL");

var $6ZWSX = parcelRequire("6ZWSX");
var $3674b353dc6c3d42$require$Buffer = $6ZWSX.Buffer;
/** Number of bytes reserved for the length of the string. (32bit integer). */ const $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH = 4;
async function $3674b353dc6c3d42$export$6c50c12dbd6168b(tensors, group) {
    // TODO(adarob, cais): Support quantization.
    const specs = [];
    const dataPromises = [];
    const names = Array.isArray(tensors) ? tensors.map((tensor)=>tensor.name) : Object.keys(tensors);
    for(let i = 0; i < names.length; ++i){
        const name = names[i];
        const t = Array.isArray(tensors) ? tensors[i].tensor : tensors[name];
        if (t.dtype !== 'float32' && t.dtype !== 'int32' && t.dtype !== 'bool' && t.dtype !== 'string' && t.dtype !== 'complex64') throw new Error(`Unsupported dtype in weight '${name}': ${t.dtype}`);
        const spec = {
            name: name,
            shape: t.shape,
            dtype: t.dtype
        };
        if (t.dtype === 'string') {
            const utf8bytes = new Promise(async (resolve)=>{
                const vals = await t.bytes();
                const totalNumBytes = vals.reduce((p, c)=>p + c.length, 0) + $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH * vals.length;
                const bytes = new Uint8Array(totalNumBytes);
                let offset = 0;
                for(let i = 0; i < vals.length; i++){
                    const val = vals[i];
                    const bytesOfLength = new Uint8Array(new Uint32Array([
                        val.length
                    ]).buffer);
                    bytes.set(bytesOfLength, offset);
                    offset += $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH;
                    bytes.set(val, offset);
                    offset += val.length;
                }
                resolve(bytes);
            });
            dataPromises.push(utf8bytes);
        } else dataPromises.push(t.data());
        if (group != null) spec.group = group;
        specs.push(spec);
    }
    const tensorValues = await Promise.all(dataPromises);
    return {
        data: $3674b353dc6c3d42$export$b9f790e5e2031778(tensorValues),
        specs: specs
    };
}
function $3674b353dc6c3d42$export$7a14c2428d4f4a2e(weightData, specs) {
    // TODO(adarob, cais): Support quantization.
    const compositeBuffer = new (0, $hBb8J.CompositeArrayBuffer)(weightData);
    const out = {};
    let offset = 0;
    for (const spec of specs){
        const byteLength = $3674b353dc6c3d42$var$getWeightBytelength(spec, (start, end)=>{
            return compositeBuffer.slice(offset + start, offset + end);
        });
        out[spec.name] = $3674b353dc6c3d42$var$decodeWeight(spec, compositeBuffer.slice(offset, offset + byteLength));
        offset += byteLength;
    }
    return out;
}
function $3674b353dc6c3d42$var$getWeightBytelength(spec, slice) {
    const size = (0, $8cCb2.sizeFromShape)(spec.shape);
    let bytesPerValue;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        bytesPerValue = (0, $2bXta.DTYPE_VALUE_SIZE_MAP)[quantization.dtype];
    } else if (spec.dtype === 'string') {
        // Can not statically determine string length.
        let byteLength = 0;
        for(let i = 0; i < size; i++)byteLength += $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH + new Uint32Array(slice(byteLength, byteLength + $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH))[0];
        return byteLength;
    } else bytesPerValue = (0, $2bXta.DTYPE_VALUE_SIZE_MAP)[spec.dtype];
    return size * bytesPerValue;
}
async function $3674b353dc6c3d42$var$getWeightBytelengthAsync(spec, slice) {
    const size = (0, $8cCb2.sizeFromShape)(spec.shape);
    let bytesPerValue;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        bytesPerValue = (0, $2bXta.DTYPE_VALUE_SIZE_MAP)[quantization.dtype];
    } else if (spec.dtype === 'string') {
        // Can not statically determine string length.
        let byteLength = 0;
        for(let i = 0; i < size; i++)byteLength += $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH + new Uint32Array(await slice(byteLength, byteLength + $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH))[0];
        return byteLength;
    } else bytesPerValue = (0, $2bXta.DTYPE_VALUE_SIZE_MAP)[spec.dtype];
    return size * bytesPerValue;
}
function $3674b353dc6c3d42$var$decodeWeight(spec, byteBuffer) {
    const name = spec.name;
    const dtype = spec.dtype;
    const shape = spec.shape;
    const size = (0, $8cCb2.sizeFromShape)(shape);
    let values;
    let offset = 0;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        if (quantization.dtype === 'uint8' || quantization.dtype === 'uint16') {
            if (!('min' in quantization && 'scale' in quantization)) throw new Error(`Weight ${spec.name} with quantization ${quantization.dtype} ` + `doesn't have corresponding metadata min and scale.`);
        } else if (quantization.dtype === 'float16') {
            if (dtype !== 'float32') throw new Error(`Weight ${spec.name} is quantized with ${quantization.dtype} ` + `which only supports weights of type float32 not ${dtype}.`);
        } else throw new Error(`Weight ${spec.name} has unknown ` + `quantization dtype ${quantization.dtype}. ` + `Supported quantization dtypes are: ` + `'uint8', 'uint16', and 'float16'.`);
        const quantizationSizeFactor = (0, $2bXta.DTYPE_VALUE_SIZE_MAP)[quantization.dtype];
        const quantizedArray = quantization.dtype === 'uint8' ? new Uint8Array(byteBuffer) : new Uint16Array(byteBuffer);
        if (dtype === 'float32') {
            if (quantization.dtype === 'uint8' || quantization.dtype === 'uint16') {
                values = new Float32Array(quantizedArray.length);
                for(let i = 0; i < quantizedArray.length; i++){
                    const v = quantizedArray[i];
                    values[i] = v * quantization.scale + quantization.min;
                }
            } else if (quantization.dtype === 'float16') {
                // TODO: This is inefficient. Make getFloat16Decoder efficient.
                const float16Decode = $3674b353dc6c3d42$export$6f94974d2b5810f7();
                values = float16Decode(quantizedArray);
            } else throw new Error(`Unsupported quantization type ${quantization.dtype} ` + `for weight type float32.`);
        } else if (dtype === 'int32') {
            if (quantization.dtype !== 'uint8' && quantization.dtype !== 'uint16') throw new Error(`Unsupported quantization type ${quantization.dtype} ` + `for weight type int32.`);
            values = new Int32Array(quantizedArray.length);
            for(let i = 0; i < quantizedArray.length; i++){
                const v = quantizedArray[i];
                values[i] = Math.round(v * quantization.scale + quantization.min);
            }
        } else throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
        offset += size * quantizationSizeFactor;
    } else if (dtype === 'string') {
        const size = (0, $8cCb2.sizeFromShape)(spec.shape);
        values = [];
        for(let i = 0; i < size; i++){
            const byteLength = new Uint32Array(byteBuffer.slice(offset, offset + $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH))[0];
            offset += $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH;
            const bytes = new Uint8Array(byteBuffer.slice(offset, offset + byteLength));
            values.push(bytes);
            offset += byteLength;
        }
    } else {
        const dtypeFactor = (0, $2bXta.DTYPE_VALUE_SIZE_MAP)[dtype];
        if (dtype === 'float32') values = new Float32Array(byteBuffer);
        else if (dtype === 'int32') values = new Int32Array(byteBuffer);
        else if (dtype === 'bool') values = new Uint8Array(byteBuffer);
        else if (dtype === 'complex64') {
            values = new Float32Array(byteBuffer);
            const real = new Float32Array(values.length / 2);
            const image = new Float32Array(values.length / 2);
            for(let i = 0; i < real.length; i++){
                real[i] = values[i * 2];
                image[i] = values[i * 2 + 1];
            }
            const realTensor = (0, $erbmM.tensor)(real, shape, 'float32');
            const imageTensor = (0, $erbmM.tensor)(image, shape, 'float32');
            const complexTensor = (0, $20oDZ.complex)(realTensor, imageTensor);
            realTensor.dispose();
            imageTensor.dispose();
            return complexTensor;
        } else throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
        offset += size * dtypeFactor;
    }
    return (0, $erbmM.tensor)(values, shape, dtype);
}
async function $3674b353dc6c3d42$var$readToLength(reader, initialData, length) {
    let data = new Uint8Array(initialData);
    while(data.byteLength < length){
        const { done: done, value: value } = await reader.read();
        if (done && value == null) {
            const missing = length - data.byteLength;
            throw new Error(`Reader is done but ${missing} bytes are still expected`);
        }
        // TODO: Don't create a new array every loop.
        const newData = new Uint8Array(data.length + value.byteLength);
        newData.set(data, 0);
        newData.set(new Uint8Array(value), data.length);
        data = newData;
    }
    return data.buffer;
}
async function $3674b353dc6c3d42$export$6c19531ae9ba1204(weightStream, specs) {
    const tensors = {};
    const reader = weightStream.getReader();
    let data = new ArrayBuffer(0);
    for (const spec of specs){
        const byteLength = await $3674b353dc6c3d42$var$getWeightBytelengthAsync(spec, async (start, end)=>{
            data = await $3674b353dc6c3d42$var$readToLength(reader, data, end);
            return data.slice(start, end);
        });
        data = await $3674b353dc6c3d42$var$readToLength(reader, data, byteLength);
        // Slice the tensor out
        const tensorData = data.slice(0, byteLength);
        data = data.slice(byteLength);
        const weightTensor = $3674b353dc6c3d42$var$decodeWeight(spec, tensorData);
        tensors[spec.name] = weightTensor;
        // TODO(mattsoulanille): Better way to call uploadToGPU.
        // TODO(mattsoulanille): Make this work for webgl too.
        if ((0, $c2DT1.getBackend)() === 'webgpu') {
            const b = (0, $c2DT1.backend)();
            if ('uploadToGPU' in b && (0, $8cCb2.sizeFromShape)(weightTensor.shape) >= (0, $ibsdL.env)().get('WEBGPU_CPU_HANDOFF_SIZE_THRESHOLD')) b.uploadToGPU(weightTensor.dataId);
        }
    }
    return tensors;
}
function $3674b353dc6c3d42$export$b9f790e5e2031778(xs) {
    // TODO(adarob, cais): Support quantization.
    if (xs === null) throw new Error(`Invalid input value: ${JSON.stringify(xs)}`);
    let totalByteLength = 0;
    // `normalizedXs` is here for this reason: a `TypedArray`'s `buffer'
    // can have a different byte length from that of the `TypedArray` itself,
    // for example, when the `TypedArray` is created from an offset in an
    // `ArrayBuffer`. `normliazedXs` holds `TypedArray`s whose `buffer`s match
    // the `TypedArray` in byte length. If an element of `xs` does not show
    // this property, a new `TypedArray` that satisfy this property will be
    // constructed and pushed into `normalizedXs`.
    const normalizedXs = [];
    xs.forEach((x)=>{
        totalByteLength += x.byteLength;
        // tslint:disable:no-any
        normalizedXs.push(x.byteLength === x.buffer.byteLength ? x : new x.constructor(x));
        if (!(x instanceof Float32Array || x instanceof Int32Array || x instanceof Uint8Array)) throw new Error(`Unsupported TypedArray subtype: ${x.constructor.name}`);
    // tslint:enable:no-any
    });
    const y = new Uint8Array(totalByteLength);
    let offset = 0;
    normalizedXs.forEach((x)=>{
        y.set(new Uint8Array(x.buffer), offset);
        offset += x.byteLength;
    });
    return y.buffer;
}
// Use Buffer on Node.js instead of Blob/atob/btoa
const $3674b353dc6c3d42$var$useNodeBuffer = typeof $3674b353dc6c3d42$require$Buffer !== 'undefined' && (typeof Blob === 'undefined' || typeof atob === 'undefined' || typeof btoa === 'undefined');
function $3674b353dc6c3d42$export$42600be9c932993b(str) {
    if ($3674b353dc6c3d42$var$useNodeBuffer) return $3674b353dc6c3d42$require$Buffer.byteLength(str, 'utf8');
    return new Blob([
        str
    ]).size;
}
function $3674b353dc6c3d42$export$28e753ea3e93cabf(buffer) {
    if ($3674b353dc6c3d42$var$useNodeBuffer) return $3674b353dc6c3d42$require$Buffer.from(buffer).toString('base64');
    const buf = new Uint8Array(buffer);
    let s = '';
    for(let i = 0, l = buf.length; i < l; i++)s += String.fromCharCode(buf[i]);
    return btoa(s);
}
function $3674b353dc6c3d42$export$aa941b9d243f1be4(str) {
    if ($3674b353dc6c3d42$var$useNodeBuffer) {
        const buf = $3674b353dc6c3d42$require$Buffer.from(str, 'base64');
        return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
    }
    const s = atob(str);
    const buffer = new Uint8Array(s.length);
    for(let i = 0; i < s.length; ++i)buffer.set([
        s.charCodeAt(i)
    ], i);
    return buffer.buffer;
}
function $3674b353dc6c3d42$export$9a3e9c78eb778da8(buffers) {
    return (0, $hBb8J.CompositeArrayBuffer).join(buffers);
}
function $3674b353dc6c3d42$export$9bf319d8f74f51d1(path) {
    const SEPARATOR = '/';
    path = path.trim();
    while(path.endsWith(SEPARATOR))path = path.slice(0, path.length - 1);
    const items = path.split(SEPARATOR);
    return items[items.length - 1];
}
function $3674b353dc6c3d42$export$a725daa2cfaa7bd5(artifacts, manifest) {
    const result = {
        modelTopology: artifacts.modelTopology,
        format: artifacts.format,
        generatedBy: artifacts.generatedBy,
        convertedBy: artifacts.convertedBy,
        weightsManifest: manifest
    };
    if (artifacts.signature != null) result.signature = artifacts.signature;
    if (artifacts.userDefinedMetadata != null) result.userDefinedMetadata = artifacts.userDefinedMetadata;
    if (artifacts.modelInitializer != null) result.modelInitializer = artifacts.modelInitializer;
    if (artifacts.initializerSignature != null) result.initializerSignature = artifacts.initializerSignature;
    if (artifacts.trainingConfig != null) result.trainingConfig = artifacts.trainingConfig;
    return result;
}
function $3674b353dc6c3d42$export$ebf48c0f134e5c8(modelJSON, weightSpecs, weightData) {
    const modelArtifacts = {
        modelTopology: modelJSON.modelTopology,
        format: modelJSON.format,
        generatedBy: modelJSON.generatedBy,
        convertedBy: modelJSON.convertedBy
    };
    if (modelJSON.trainingConfig != null) modelArtifacts.trainingConfig = modelJSON.trainingConfig;
    if (modelJSON.weightsManifest != null) {
        if (!weightSpecs) throw new Error('modelJSON has weightsManifest but weightSpecs is null');
        if (!weightData) throw new Error('modelJSON has weightsManifest but weightData is null');
        modelArtifacts.weightSpecs = weightSpecs;
        modelArtifacts.weightData = weightData;
    }
    if (modelJSON.signature != null) modelArtifacts.signature = modelJSON.signature;
    if (modelJSON.userDefinedMetadata != null) modelArtifacts.userDefinedMetadata = modelJSON.userDefinedMetadata;
    if (modelJSON.modelInitializer != null) modelArtifacts.modelInitializer = modelJSON.modelInitializer;
    if (modelJSON.initializerSignature != null) modelArtifacts.initializerSignature = modelJSON.initializerSignature;
    return modelArtifacts;
}
async function $3674b353dc6c3d42$export$b867c14eedd5b8a2(modelJSON, loadWeights) {
    let weightSpecs;
    let weightData;
    if (modelJSON.weightsManifest != null) [weightSpecs, weightData] = await loadWeights(modelJSON.weightsManifest);
    return $3674b353dc6c3d42$export$ebf48c0f134e5c8(modelJSON, weightSpecs, weightData);
}
function $3674b353dc6c3d42$export$ece8b449d7d29272(modelArtifacts) {
    if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error('Expected JSON model topology, received ArrayBuffer.');
    return {
        dateSaved: new Date(),
        modelTopologyType: 'JSON',
        modelTopologyBytes: modelArtifacts.modelTopology == null ? 0 : $3674b353dc6c3d42$export$42600be9c932993b(JSON.stringify(modelArtifacts.modelTopology)),
        weightSpecsBytes: modelArtifacts.weightSpecs == null ? 0 : $3674b353dc6c3d42$export$42600be9c932993b(JSON.stringify(modelArtifacts.weightSpecs)),
        weightDataBytes: modelArtifacts.weightData == null ? 0 : new (0, $hBb8J.CompositeArrayBuffer)(modelArtifacts.weightData).byteLength
    };
}
function $3674b353dc6c3d42$export$9f3fe06e8e8def44(weightsManifest) {
    const weightSpecs = [];
    for (const entry of weightsManifest)weightSpecs.push(...entry.weights);
    return weightSpecs;
}
/**
 * Computes mantisa table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 2048 mantissa lookup values.
 */ function $3674b353dc6c3d42$var$computeFloat16MantisaTable() {
    const convertMantissa = (i)=>{
        let m = i << 13;
        let e = 0;
        while((m & 0x00800000) === 0){
            e -= 0x00800000;
            m <<= 1;
        }
        m &= -8388609;
        e += 0x38800000;
        return m | e;
    };
    const mantisaTable = new Uint32Array(2048);
    mantisaTable[0] = 0;
    for(let i = 1; i < 1024; i++)mantisaTable[i] = convertMantissa(i);
    for(let i = 1024; i < 2048; i++)mantisaTable[i] = 0x38000000 + (i - 1024 << 13);
    return mantisaTable;
}
/**
 * Computes exponent table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 64 exponent lookup values.
 */ function $3674b353dc6c3d42$var$computeFloat16ExponentTable() {
    const exponentTable = new Uint32Array(64);
    exponentTable[0] = 0;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 31; i++)exponentTable[i] = i << 23;
    for(let i = 33; i < 63; i++)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    return exponentTable;
}
/**
 * Computes offset table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 6d offset values.
 */ function $3674b353dc6c3d42$var$computeFloat16OffsetTable() {
    const offsetTable = new Uint32Array(64);
    for(let i = 0; i < 64; i++)offsetTable[i] = 1024;
    offsetTable[0] = offsetTable[32] = 0;
    return offsetTable;
}
function $3674b353dc6c3d42$export$6f94974d2b5810f7() {
    // Algorithm is based off of
    // http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
    // Cache lookup tables
    const mantisaTable = $3674b353dc6c3d42$var$computeFloat16MantisaTable();
    const exponentTable = $3674b353dc6c3d42$var$computeFloat16ExponentTable();
    const offsetTable = $3674b353dc6c3d42$var$computeFloat16OffsetTable();
    return (quantizedArray)=>{
        const buffer = new ArrayBuffer(4 * quantizedArray.length);
        const bufferUint32View = new Uint32Array(buffer);
        for(let index = 0; index < quantizedArray.length; index++){
            const float16Bits = quantizedArray[index];
            const float32Bits = mantisaTable[offsetTable[float16Bits >> 10] + (float16Bits & 0x3ff)] + exponentTable[float16Bits >> 10];
            bufferUint32View[index] = float32Bits;
        }
        return new Float32Array(buffer);
    };
}

});
parcelRegister("20oDZ", function(module, exports) {

$parcel$export(module.exports, "complex", () => $175eb29e145dcf53$export$83a0e34f1302825b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Converts two real numbers to a complex number.
 *
 * Given a tensor `real` representing the real part of a complex number, and a
 * tensor `imag` representing the imaginary part of a complex number, this
 * operation returns complex numbers elementwise of the form [r0, i0, r1, i1],
 * where r represents the real part and i represents the imag part.
 *
 * The input tensors real and imag must have the same shape.
 *
 * ```js
 * const real = tf.tensor1d([2.25, 3.25]);
 * const imag = tf.tensor1d([4.75, 5.75]);
 * const complex = tf.complex(real, imag);
 *
 * complex.print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $175eb29e145dcf53$var$complex_(real, imag) {
    const $real = (0, $5xBLk.convertToTensor)(real, 'real', 'complex');
    const $imag = (0, $5xBLk.convertToTensor)(imag, 'imag', 'complex');
    $8cCb2.assertShapesMatch($real.shape, $imag.shape, `real and imag shapes, ${$real.shape} and ${$imag.shape}, ` + `must match in call to tf.complex().`);
    const inputs = {
        real: $real,
        imag: $imag
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Complex), inputs);
}
const $175eb29e145dcf53$export$83a0e34f1302825b = /* @__PURE__ */ (0, $jqSCG.op)({
    complex_: $175eb29e145dcf53$var$complex_
});

});
parcelRegister("5xBLk", function(module, exports) {

$parcel$export(module.exports, "inferShape", () => $010a899b69412c72$export$467a8ad638b9ad20);
$parcel$export(module.exports, "convertToTensor", () => $010a899b69412c72$export$ede379c4c939d71a);
$parcel$export(module.exports, "convertToTensorArray", () => $010a899b69412c72$export$758e66616b4d410b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $ibsdL = parcelRequire("ibsdL");

var $9jCh7 = parcelRequire("9jCh7");

var $2MDja = parcelRequire("2MDja");

var $8cCb2 = parcelRequire("8cCb2");
var $jjNRA = parcelRequire("jjNRA");

var $8cCb2 = parcelRequire("8cCb2");
function $010a899b69412c72$export$467a8ad638b9ad20(val, dtype) {
    let firstElem = val;
    if ((0, $jjNRA.isTypedArray)(val)) return dtype === 'string' ? [] : [
        val.length
    ];
    if ((0, $2MDja.isWebGLData)(val)) {
        const usedChannels = val.channels || 'RGBA';
        return [
            val.height,
            val.width * usedChannels.length
        ];
    } else if ((0, $2MDja.isWebGPUData)(val)) return [
        val.buffer.size / (dtype == null ? 4 : (0, $8cCb2.bytesPerElement)(dtype))
    ];
    if (!Array.isArray(val)) return []; // Scalar.
    const shape = [];
    while(Array.isArray(firstElem) || (0, $jjNRA.isTypedArray)(firstElem) && dtype !== 'string'){
        shape.push(firstElem.length);
        firstElem = firstElem[0];
    }
    if (Array.isArray(val) && (0, $ibsdL.env)().getBool('TENSORLIKE_CHECK_SHAPE_CONSISTENCY')) $010a899b69412c72$var$deepAssertShapeConsistency(val, shape, []);
    return shape;
}
function $010a899b69412c72$var$deepAssertShapeConsistency(val, shape, indices) {
    indices = indices || [];
    if (!Array.isArray(val) && !(0, $jjNRA.isTypedArray)(val)) {
        (0, $8cCb2.assert)(shape.length === 0, ()=>`Element arr[${indices.join('][')}] is a primitive, ` + `but should be an array/TypedArray of ${shape[0]} elements`);
        return;
    }
    (0, $8cCb2.assert)(shape.length > 0, ()=>`Element arr[${indices.join('][')}] should be a primitive, ` + `but is an array of ${val.length} elements`);
    (0, $8cCb2.assert)(val.length === shape[0], ()=>`Element arr[${indices.join('][')}] should have ${shape[0]} ` + `elements, but has ${val.length} elements`);
    const subShape = shape.slice(1);
    for(let i = 0; i < val.length; ++i)$010a899b69412c72$var$deepAssertShapeConsistency(val[i], subShape, indices.concat(i));
}
function $010a899b69412c72$var$assertDtype(expectedDtype, actualDType, argName, functionName) {
    if (expectedDtype === 'string_or_numeric') return;
    if (expectedDtype == null) throw new Error(`Expected dtype cannot be null.`);
    if (expectedDtype !== 'numeric' && expectedDtype !== actualDType || expectedDtype === 'numeric' && actualDType === 'string') throw new Error(`Argument '${argName}' passed to '${functionName}' must ` + `be ${expectedDtype} tensor, but got ${actualDType} tensor`);
}
function $010a899b69412c72$export$ede379c4c939d71a(x, argName, functionName, parseAsDtype = 'numeric') {
    if (x instanceof (0, $9jCh7.getGlobalTensorClass)()) {
        $010a899b69412c72$var$assertDtype(parseAsDtype, x.dtype, argName, functionName);
        return x;
    }
    let inferredDtype = (0, $8cCb2.inferDtype)(x);
    // If the user expects a bool/int/float, use that info to update the
    // inferredDtype when it is not a string.
    if (inferredDtype !== 'string' && [
        'bool',
        'int32',
        'float32'
    ].indexOf(parseAsDtype) >= 0) inferredDtype = parseAsDtype;
    $010a899b69412c72$var$assertDtype(parseAsDtype, inferredDtype, argName, functionName);
    if (x == null || !(0, $jjNRA.isTypedArray)(x) && !Array.isArray(x) && typeof x !== 'number' && typeof x !== 'boolean' && typeof x !== 'string') {
        const type = x == null ? 'null' : x.constructor.name;
        throw new Error(`Argument '${argName}' passed to '${functionName}' must be a ` + `Tensor or TensorLike, but got '${type}'`);
    }
    const inferredShape = $010a899b69412c72$export$467a8ad638b9ad20(x, inferredDtype);
    if (!(0, $jjNRA.isTypedArray)(x) && !Array.isArray(x)) x = [
        x
    ];
    const skipTypedArray = true;
    const values = inferredDtype !== 'string' ? (0, $jjNRA.toTypedArray)(x, inferredDtype) : (0, $jjNRA.flatten)(x, [], skipTypedArray);
    return (0, $38WwN.ENGINE).makeTensor(values, inferredShape, inferredDtype);
}
function $010a899b69412c72$export$758e66616b4d410b(arg, argName, functionName, parseAsDtype = 'numeric') {
    if (!Array.isArray(arg)) throw new Error(`Argument ${argName} passed to ${functionName} must be a ` + '`Tensor[]` or `TensorLike[]`');
    const tensors = arg;
    return tensors.map((t, i)=>$010a899b69412c72$export$ede379c4c939d71a(t, `${argName}[${i}]`, functionName, parseAsDtype));
}

});

parcelRegister("jqSCG", function(module, exports) {

$parcel$export(module.exports, "OP_SCOPE_SUFFIX", () => $e25ad0fc1c7fe06f$export$93114f1494faf9bb);
$parcel$export(module.exports, "op", () => $e25ad0fc1c7fe06f$export$f59964a629598e2);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $8cCb2 = parcelRequire("8cCb2");
const $e25ad0fc1c7fe06f$export$93114f1494faf9bb = '__op';
function $e25ad0fc1c7fe06f$export$f59964a629598e2(f) {
    const keys = Object.keys(f);
    if (keys.length !== 1) throw new Error(`Please provide an object with a single key ` + `(operation name) mapping to a function. Got an object with ` + `${keys.length} keys.`);
    let opName = keys[0];
    const fn = f[opName];
    // Strip the underscore from the end of the function name.
    if (opName.endsWith('_')) opName = opName.substring(0, opName.length - 1);
    // add an __op suffix to distinguish ops from kernels in tf.profile
    opName = opName + $e25ad0fc1c7fe06f$export$93114f1494faf9bb;
    // tslint:disable-next-line:no-any
    const f2 = (...args)=>{
        (0, $38WwN.ENGINE).startScope(opName);
        try {
            const result = fn(...args);
            if ((0, $8cCb2.isPromise)(result)) console.error('Cannot return a Promise inside of tidy.');
            (0, $38WwN.ENGINE).endScope(result);
            return result;
        } catch (ex) {
            (0, $38WwN.ENGINE).endScope(null);
            throw ex;
        }
    };
    Object.defineProperty(f2, 'name', {
        value: opName,
        configurable: true
    });
    // tslint:disable-next-line:no-any
    return f2;
}

});


parcelRegister("erbmM", function(module, exports) {

$parcel$export(module.exports, "tensor", () => $a82c6773538d9e64$export$65df3ad1ad888abb);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $dKr4X = parcelRequire("dKr4X");
function $a82c6773538d9e64$export$65df3ad1ad888abb(values, shape, dtype) {
    const inferredShape = (0, $5xBLk.inferShape)(values, dtype);
    return (0, $dKr4X.makeTensor)(values, shape, inferredShape, dtype);
}

});
parcelRegister("dKr4X", function(module, exports) {

$parcel$export(module.exports, "makeTensor", () => $a024938a45229223$export$f41686c891d7ebce);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $2MDja = parcelRequire("2MDja");

var $8cCb2 = parcelRequire("8cCb2");
var $jjNRA = parcelRequire("jjNRA");
function $a024938a45229223$export$f41686c891d7ebce(values, shape, inferredShape, dtype) {
    if (dtype == null) dtype = (0, $8cCb2.inferDtype)(values);
    else if (dtype === 'complex64') throw new Error(`Cannot construct a complex64 tensor directly. ` + `Please use tf.complex(real, imag).`);
    if ((0, $2MDja.isWebGPUData)(values) || (0, $2MDja.isWebGLData)(values)) {
        if (dtype !== 'float32' && dtype !== 'int32') throw new Error(`Creating tensor from GPU data only supports ` + `'float32'|'int32' dtype, while the dtype is ${dtype}.`);
        return (0, $38WwN.ENGINE).backend.createTensorFromGPUData(values, shape || inferredShape, dtype);
    }
    if (!(0, $jjNRA.isTypedArray)(values) && !Array.isArray(values) && typeof values !== 'number' && typeof values !== 'boolean' && typeof values !== 'string') throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");
    // Verify that the shape matches the inferred shape.
    if (shape != null) {
        (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
        const providedSize = (0, $8cCb2.sizeFromShape)(shape);
        const inferredSize = (0, $8cCb2.sizeFromShape)(inferredShape);
        (0, $8cCb2.assert)(providedSize === inferredSize, ()=>`Based on the provided shape, [${shape}], the tensor should have ` + `${providedSize} values but has ${inferredSize}`);
        for(let i = 0; i < inferredShape.length; ++i){
            const inferred = inferredShape[i];
            const flatDimsDontMatch = i === inferredShape.length - 1 ? inferred !== (0, $8cCb2.sizeFromShape)(shape.slice(i)) : true;
            (0, $8cCb2.assert)(inferredShape[i] === shape[i] || !flatDimsDontMatch, ()=>`Error creating a new Tensor. Inferred shape ` + `(${inferredShape}) does not match the provided ` + `shape (${shape}). `);
        }
    }
    if (!(0, $jjNRA.isTypedArray)(values) && !Array.isArray(values)) values = [
        values
    ];
    shape = shape || inferredShape;
    values = dtype !== 'string' ? (0, $jjNRA.toTypedArray)(values, dtype) : (0, $jjNRA.flatten)(values, [], true);
    return (0, $38WwN.ENGINE).makeTensor(values, shape, dtype);
}

});


parcelRegister("2bXta", function(module, exports) {

$parcel$export(module.exports, "DTYPE_VALUE_SIZE_MAP", () => $198abd4496908653$export$8103dee73e5eaa46);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /* Type definitions for exporting and importing of models. */ /**
 * A map from Tensor dtype to number of bytes per element of the Tensor.
 */ const $198abd4496908653$export$8103dee73e5eaa46 = {
    'float32': 4,
    'float16': 2,
    'int32': 4,
    'uint16': 2,
    'uint8': 1,
    'bool': 1,
    'complex64': 8
};

});

parcelRegister("hBb8J", function(module, exports) {

$parcel$export(module.exports, "CompositeArrayBuffer", () => $ccfe888395cdb33c$export$fd7a5551e5344016);

var $jjNRA = parcelRequire("jjNRA");
class $ccfe888395cdb33c$export$fd7a5551e5344016 {
    /**
     * Concatenate a number of ArrayBuffers into one.
     *
     * @param buffers An array of ArrayBuffers to concatenate, or a single
     *     ArrayBuffer.
     * @returns Result of concatenating `buffers` in order.
     */ static join(buffers) {
        return new $ccfe888395cdb33c$export$fd7a5551e5344016(buffers).slice();
    }
    constructor(buffers){
        this.shards = [];
        this.previousShardIndex = 0;
        if (buffers == null) return;
        // Normalize the `buffers` input to be `ArrayBuffer[]`.
        if (!(buffers instanceof Array)) buffers = [
            buffers
        ];
        buffers = buffers.map((bufferOrTypedArray)=>{
            if ($jjNRA.isTypedArray(bufferOrTypedArray)) return bufferOrTypedArray.buffer;
            return bufferOrTypedArray;
        });
        // Skip setting up shards if there are no buffers.
        if (buffers.length === 0) return;
        this.bufferUniformSize = buffers[0].byteLength;
        let start = 0;
        for(let i = 0; i < buffers.length; i++){
            const buffer = buffers[i];
            // Check that all buffers except the last one have the same length.
            if (i !== buffers.length - 1 && buffer.byteLength !== this.bufferUniformSize) // Unset the buffer uniform size, since the buffer sizes are not
            // uniform.
            this.bufferUniformSize = undefined;
            // Create the shards, including their start and end points.
            const end = start + buffer.byteLength;
            this.shards.push({
                buffer: buffer,
                start: start,
                end: end
            });
            start = end;
        }
        // Set the byteLength
        if (this.shards.length === 0) this.byteLength = 0;
        this.byteLength = this.shards[this.shards.length - 1].end;
    }
    slice(start = 0, end = this.byteLength) {
        // If there are no shards, then the CompositeArrayBuffer was initialized
        // with no data.
        if (this.shards.length === 0) return new ArrayBuffer(0);
        // NaN is treated as zero for slicing. This matches ArrayBuffer's behavior.
        start = isNaN(Number(start)) ? 0 : start;
        end = isNaN(Number(end)) ? 0 : end;
        // Fix the bounds to within the array.
        start = Math.max(0, start);
        end = Math.min(this.byteLength, end);
        if (end <= start) return new ArrayBuffer(0);
        const startShardIndex = this.findShardForByte(start);
        if (startShardIndex === -1) // This should not happen since the start and end indices are always
        // within 0 and the composite array's length.
        throw new Error(`Could not find start shard for byte ${start}`);
        const size = end - start;
        const outputBuffer = new ArrayBuffer(size);
        const outputArray = new Uint8Array(outputBuffer);
        let sliced = 0;
        for(let i = startShardIndex; i < this.shards.length; i++){
            const shard = this.shards[i];
            const globalStart = start + sliced;
            const localStart = globalStart - shard.start;
            const outputStart = sliced;
            const globalEnd = Math.min(end, shard.end);
            const localEnd = globalEnd - shard.start;
            const outputSlice = new Uint8Array(shard.buffer, localStart, localEnd - localStart);
            outputArray.set(outputSlice, outputStart);
            sliced += outputSlice.length;
            if (end < shard.end) break;
        }
        return outputBuffer;
    }
    /**
     * Get the index of the shard that contains the byte at `byteIndex`.
     */ findShardForByte(byteIndex) {
        if (this.shards.length === 0 || byteIndex < 0 || byteIndex >= this.byteLength) return -1;
        // If the buffers have a uniform size, compute the shard directly.
        if (this.bufferUniformSize != null) {
            this.previousShardIndex = Math.floor(byteIndex / this.bufferUniformSize);
            return this.previousShardIndex;
        }
        // If the buffers don't have a uniform size, we need to search for the
        // shard. That means we need a function to check where the byteIndex lies
        // relative to a given shard.
        function check(shard) {
            if (byteIndex < shard.start) return -1;
            if (byteIndex >= shard.end) return 1;
            return 0;
        }
        // For efficiency, try the previous shard first.
        if (check(this.shards[this.previousShardIndex]) === 0) return this.previousShardIndex;
        // Otherwise, use a generic search function.
        // This should almost never end up being used in practice since the weight
        // entries should always be in order.
        const index = $ccfe888395cdb33c$export$d76128d007d19019(this.shards, check);
        if (index === -1) return -1;
        this.previousShardIndex = index;
        return this.previousShardIndex;
    }
}
function $ccfe888395cdb33c$export$d76128d007d19019(sortedArray, compare) {
    // Binary search
    let min = 0;
    let max = sortedArray.length;
    while(min <= max){
        const middle = Math.floor((max - min) / 2) + min;
        const side = compare(sortedArray[middle]);
        if (side === 0) return middle;
        else if (side < 0) max = middle;
        else min = middle + 1;
    }
    return -1;
}

});

parcelRegister("c2DT1", function(module, exports) {

$parcel$export(module.exports, "enableProdMode", () => $8c449c89295c3cc4$export$1e73b1267274f27e);
$parcel$export(module.exports, "engine", () => $8c449c89295c3cc4$export$d3c662a6136faebb);
$parcel$export(module.exports, "memory", () => $8c449c89295c3cc4$export$827b61424e8f52d2);
$parcel$export(module.exports, "tidy", () => $8c449c89295c3cc4$export$b841c6a213a653eb);
$parcel$export(module.exports, "dispose", () => $8c449c89295c3cc4$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "keep", () => $8c449c89295c3cc4$export$fae3166c418e0471);
$parcel$export(module.exports, "setBackend", () => $8c449c89295c3cc4$export$7953970fabc9c2);
$parcel$export(module.exports, "getBackend", () => $8c449c89295c3cc4$export$b098501f764cdf30);
$parcel$export(module.exports, "registerBackend", () => $8c449c89295c3cc4$export$1ac8c3a90eff05d);
$parcel$export(module.exports, "backend", () => $8c449c89295c3cc4$export$32a253b6f8b50fb4);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $ibsdL = parcelRequire("ibsdL");

var $9jCh7 = parcelRequire("9jCh7");

var $3w4Rg = parcelRequire("3w4Rg");
function $8c449c89295c3cc4$export$1e73b1267274f27e() {
    (0, $ibsdL.env)().set('PROD', true);
}
function $8c449c89295c3cc4$export$ef8a131e8a882a3a() {
    (0, $ibsdL.env)().set('DEBUG', true);
}
function $8c449c89295c3cc4$export$cb100329fdb11914() {
    (0, $ibsdL.env)().set('DEPRECATION_WARNINGS_ENABLED', false);
    console.warn(`TensorFlow.js deprecation warnings have been disabled.`);
}
function $8c449c89295c3cc4$export$e46eea6a629d2da5(msg) {
    if ((0, $ibsdL.env)().getBool('DEPRECATION_WARNINGS_ENABLED')) console.warn(msg + ' You can disable deprecation warnings with ' + 'tf.disableDeprecationWarnings().');
}
(0, $9jCh7.setDeprecationWarningFn)($8c449c89295c3cc4$export$e46eea6a629d2da5);
function $8c449c89295c3cc4$export$f22ce7a2fa538c48() {
    (0, $38WwN.ENGINE).disposeVariables();
}
function $8c449c89295c3cc4$export$d3c662a6136faebb() {
    return 0, $38WwN.ENGINE;
}
function $8c449c89295c3cc4$export$827b61424e8f52d2() {
    return (0, $38WwN.ENGINE).memory();
}
function $8c449c89295c3cc4$export$4882ae973e0491e(f) {
    return (0, $38WwN.ENGINE).profile(f);
}
function $8c449c89295c3cc4$export$b841c6a213a653eb(nameOrFn, fn) {
    return (0, $38WwN.ENGINE).tidy(nameOrFn, fn);
}
function $8c449c89295c3cc4$export$fcfbbcec2cb820d5(container) {
    const tensors = (0, $3w4Rg.getTensorsInContainer)(container);
    tensors.forEach((tensor)=>tensor.dispose());
}
function $8c449c89295c3cc4$export$fae3166c418e0471(result) {
    return (0, $38WwN.ENGINE).keep(result);
}
function $8c449c89295c3cc4$export$2da9be4cfdb689b1(f) {
    return (0, $38WwN.ENGINE).time(f);
}
function $8c449c89295c3cc4$export$7953970fabc9c2(backendName) {
    return (0, $38WwN.ENGINE).setBackend(backendName);
}
function $8c449c89295c3cc4$export$28ee1007e174a2a6() {
    return (0, $38WwN.ENGINE).ready();
}
function $8c449c89295c3cc4$export$b098501f764cdf30() {
    return (0, $38WwN.ENGINE).backendName;
}
function $8c449c89295c3cc4$export$c299110fbe92c80c(name) {
    (0, $38WwN.ENGINE).removeBackend(name);
}
function $8c449c89295c3cc4$export$f94fbc07ea8e852e(name) {
    return (0, $38WwN.ENGINE).findBackend(name);
}
function $8c449c89295c3cc4$export$e4a6d214466a2c7b(name) {
    return (0, $38WwN.ENGINE).findBackendFactory(name);
}
function $8c449c89295c3cc4$export$1ac8c3a90eff05d(name, factory, priority = 1) {
    return (0, $38WwN.ENGINE).registerBackend(name, factory, priority);
}
function $8c449c89295c3cc4$export$32a253b6f8b50fb4() {
    return (0, $38WwN.ENGINE).backend;
}
function $8c449c89295c3cc4$export$5f05d56a0f2349cc(platformName, platform) {
    (0, $ibsdL.env)().setPlatform(platformName, platform);
}

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("9RUNn", function(module, exports) {

$parcel$export(module.exports, "IORouterRegistry", () => $72f51ea9c3e59639$export$512275d398c0bdcd);
$parcel$export(module.exports, "registerSaveRouter", () => $72f51ea9c3e59639$export$94da4683f36f634e);
$parcel$export(module.exports, "registerLoadRouter", () => $72f51ea9c3e59639$export$8bf64df3d1fb9866);
$parcel$export(module.exports, "getSaveHandlers", () => $72f51ea9c3e59639$export$88af18fd9ddb62ff);
$parcel$export(module.exports, "getLoadHandlers", () => $72f51ea9c3e59639$export$90c6c4d24103fa9a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $72f51ea9c3e59639$export$512275d398c0bdcd {
    constructor(){
        this.saveRouters = [];
        this.loadRouters = [];
    }
    static getInstance() {
        if ($72f51ea9c3e59639$export$512275d398c0bdcd.instance == null) $72f51ea9c3e59639$export$512275d398c0bdcd.instance = new $72f51ea9c3e59639$export$512275d398c0bdcd();
        return $72f51ea9c3e59639$export$512275d398c0bdcd.instance;
    }
    /**
     * Register a save-handler router.
     *
     * @param saveRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `save` method defined or `null`.
     */ static registerSaveRouter(saveRouter) {
        $72f51ea9c3e59639$export$512275d398c0bdcd.getInstance().saveRouters.push(saveRouter);
    }
    /**
     * Register a load-handler router.
     *
     * @param loadRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `load` method defined or `null`.
     */ static registerLoadRouter(loadRouter) {
        $72f51ea9c3e59639$export$512275d398c0bdcd.getInstance().loadRouters.push(loadRouter);
    }
    /**
     * Look up IOHandler for saving, given a URL-like string.
     *
     * @param url
     * @returns If only one match is found, an instance of IOHandler with the
     * `save` method defined. If no match is found, `null`.
     * @throws Error, if more than one match is found.
     */ static getSaveHandlers(url) {
        return $72f51ea9c3e59639$export$512275d398c0bdcd.getHandlers(url, 'save');
    }
    /**
     * Look up IOHandler for loading, given a URL-like string.
     *
     * @param url
     * @param loadOptions Optional, custom load options.
     * @returns All valid handlers for `url`, given the currently registered
     *   handler routers.
     */ static getLoadHandlers(url, loadOptions) {
        return $72f51ea9c3e59639$export$512275d398c0bdcd.getHandlers(url, 'load', loadOptions);
    }
    static getHandlers(url, handlerType, loadOptions) {
        const validHandlers = [];
        const routers = handlerType === 'load' ? $72f51ea9c3e59639$export$512275d398c0bdcd.getInstance().loadRouters : $72f51ea9c3e59639$export$512275d398c0bdcd.getInstance().saveRouters;
        routers.forEach((router)=>{
            const handler = router(url, loadOptions);
            if (handler !== null) validHandlers.push(handler);
        });
        return validHandlers;
    }
}
const $72f51ea9c3e59639$export$94da4683f36f634e = (loudRouter)=>$72f51ea9c3e59639$export$512275d398c0bdcd.registerSaveRouter(loudRouter);
const $72f51ea9c3e59639$export$8bf64df3d1fb9866 = (loudRouter)=>$72f51ea9c3e59639$export$512275d398c0bdcd.registerLoadRouter(loudRouter);
const $72f51ea9c3e59639$export$88af18fd9ddb62ff = (url)=>$72f51ea9c3e59639$export$512275d398c0bdcd.getSaveHandlers(url);
const $72f51ea9c3e59639$export$90c6c4d24103fa9a = (url, loadOptions)=>$72f51ea9c3e59639$export$512275d398c0bdcd.getLoadHandlers(url, loadOptions);

});


parcelRegister("h6KCl", function(module, exports) {

$parcel$export(module.exports, "BrowserLocalStorage", () => $c74728762db9681f$export$8984a84f7aef20de);
$parcel$export(module.exports, "BrowserLocalStorageManager", () => $c74728762db9681f$export$bb7e7fb445a616f4);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("dcHSK");

var $ibsdL = parcelRequire("ibsdL");

var $8cCb2 = parcelRequire("8cCb2");

var $4FRLN = parcelRequire("4FRLN");

var $hBb8J = parcelRequire("hBb8J");

var $9RUNn = parcelRequire("9RUNn");
const $c74728762db9681f$var$PATH_SEPARATOR = '/';
const $c74728762db9681f$var$PATH_PREFIX = 'tensorflowjs_models';
const $c74728762db9681f$var$INFO_SUFFIX = 'info';
const $c74728762db9681f$var$MODEL_TOPOLOGY_SUFFIX = 'model_topology';
const $c74728762db9681f$var$WEIGHT_SPECS_SUFFIX = 'weight_specs';
const $c74728762db9681f$var$WEIGHT_DATA_SUFFIX = 'weight_data';
const $c74728762db9681f$var$MODEL_METADATA_SUFFIX = 'model_metadata';
function $c74728762db9681f$export$af2a48c9611db360() {
    if (!(0, $ibsdL.env)().getBool('IS_BROWSER') || typeof window === 'undefined' || typeof window.localStorage === 'undefined') throw new Error("purgeLocalStorageModels() cannot proceed because local storage is unavailable in the current environment.");
    const LS = window.localStorage;
    const purgedModelPaths = [];
    for(let i = 0; i < LS.length; ++i){
        const key = LS.key(i);
        const prefix = $c74728762db9681f$var$PATH_PREFIX + $c74728762db9681f$var$PATH_SEPARATOR;
        if (key.startsWith(prefix) && key.length > prefix.length) {
            LS.removeItem(key);
            const modelName = $c74728762db9681f$var$getModelPathFromKey(key);
            if (purgedModelPaths.indexOf(modelName) === -1) purgedModelPaths.push(modelName);
        }
    }
    return purgedModelPaths;
}
function $c74728762db9681f$var$getModelKeys(path) {
    return {
        info: [
            $c74728762db9681f$var$PATH_PREFIX,
            path,
            $c74728762db9681f$var$INFO_SUFFIX
        ].join($c74728762db9681f$var$PATH_SEPARATOR),
        topology: [
            $c74728762db9681f$var$PATH_PREFIX,
            path,
            $c74728762db9681f$var$MODEL_TOPOLOGY_SUFFIX
        ].join($c74728762db9681f$var$PATH_SEPARATOR),
        weightSpecs: [
            $c74728762db9681f$var$PATH_PREFIX,
            path,
            $c74728762db9681f$var$WEIGHT_SPECS_SUFFIX
        ].join($c74728762db9681f$var$PATH_SEPARATOR),
        weightData: [
            $c74728762db9681f$var$PATH_PREFIX,
            path,
            $c74728762db9681f$var$WEIGHT_DATA_SUFFIX
        ].join($c74728762db9681f$var$PATH_SEPARATOR),
        modelMetadata: [
            $c74728762db9681f$var$PATH_PREFIX,
            path,
            $c74728762db9681f$var$MODEL_METADATA_SUFFIX
        ].join($c74728762db9681f$var$PATH_SEPARATOR)
    };
}
function $c74728762db9681f$var$removeItems(keys) {
    for (const key of Object.values(keys))window.localStorage.removeItem(key);
}
/**
 * Get model path from a local-storage key.
 *
 * E.g., 'tensorflowjs_models/my/model/1/info' --> 'my/model/1'
 *
 * @param key
 */ function $c74728762db9681f$var$getModelPathFromKey(key) {
    const items = key.split($c74728762db9681f$var$PATH_SEPARATOR);
    if (items.length < 3) throw new Error(`Invalid key format: ${key}`);
    return items.slice(1, items.length - 1).join($c74728762db9681f$var$PATH_SEPARATOR);
}
function $c74728762db9681f$var$maybeStripScheme(key) {
    return key.startsWith($c74728762db9681f$export$8984a84f7aef20de.URL_SCHEME) ? key.slice($c74728762db9681f$export$8984a84f7aef20de.URL_SCHEME.length) : key;
}
/**
 * IOHandler subclass: Browser Local Storage.
 *
 * See the doc string to `browserLocalStorage` for more details.
 */ class $c74728762db9681f$export$8984a84f7aef20de {
    constructor(modelPath){
        if (!(0, $ibsdL.env)().getBool('IS_BROWSER') || typeof window === 'undefined' || typeof window.localStorage === 'undefined') // TODO(cais): Add more info about what IOHandler subtypes are
        // available.
        //   Maybe point to a doc page on the web and/or automatically determine
        //   the available IOHandlers and print them in the error message.
        throw new Error('The current environment does not support local storage.');
        this.LS = window.localStorage;
        if (modelPath == null || !modelPath) throw new Error('For local storage, modelPath must not be null, undefined or empty.');
        this.modelPath = modelPath;
        this.keys = $c74728762db9681f$var$getModelKeys(this.modelPath);
    }
    /**
     * Save model artifacts to browser local storage.
     *
     * See the documentation to `browserLocalStorage` for details on the saved
     * artifacts.
     *
     * @param modelArtifacts The model artifacts to be stored.
     * @returns An instance of SaveResult.
     */ async save(modelArtifacts) {
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        else {
            const topology = JSON.stringify(modelArtifacts.modelTopology);
            const weightSpecs = JSON.stringify(modelArtifacts.weightSpecs);
            const modelArtifactsInfo = (0, $4FRLN.getModelArtifactsInfoForJSON)(modelArtifacts);
            // TODO(mattsoulanille): Support saving models over 2GB that exceed
            // Chrome's ArrayBuffer size limit.
            const weightBuffer = (0, $hBb8J.CompositeArrayBuffer).join(modelArtifacts.weightData);
            try {
                this.LS.setItem(this.keys.info, JSON.stringify(modelArtifactsInfo));
                this.LS.setItem(this.keys.topology, topology);
                this.LS.setItem(this.keys.weightSpecs, weightSpecs);
                this.LS.setItem(this.keys.weightData, (0, $4FRLN.arrayBufferToBase64String)(weightBuffer));
                // Note that JSON.stringify doesn't write out keys that have undefined
                // values, so for some keys, we set undefined instead of a null-ish
                // value.
                const metadata = {
                    format: modelArtifacts.format,
                    generatedBy: modelArtifacts.generatedBy,
                    convertedBy: modelArtifacts.convertedBy,
                    signature: modelArtifacts.signature != null ? modelArtifacts.signature : undefined,
                    userDefinedMetadata: modelArtifacts.userDefinedMetadata != null ? modelArtifacts.userDefinedMetadata : undefined,
                    modelInitializer: modelArtifacts.modelInitializer != null ? modelArtifacts.modelInitializer : undefined,
                    initializerSignature: modelArtifacts.initializerSignature != null ? modelArtifacts.initializerSignature : undefined,
                    trainingConfig: modelArtifacts.trainingConfig != null ? modelArtifacts.trainingConfig : undefined
                };
                this.LS.setItem(this.keys.modelMetadata, JSON.stringify(metadata));
                return {
                    modelArtifactsInfo: modelArtifactsInfo
                };
            } catch (err) {
                // If saving failed, clean up all items saved so far.
                $c74728762db9681f$var$removeItems(this.keys);
                throw new Error(`Failed to save model '${this.modelPath}' to local storage: ` + `size quota being exceeded is a possible cause of this failure: ` + `modelTopologyBytes=${modelArtifactsInfo.modelTopologyBytes}, ` + `weightSpecsBytes=${modelArtifactsInfo.weightSpecsBytes}, ` + `weightDataBytes=${modelArtifactsInfo.weightDataBytes}.`);
            }
        }
    }
    /**
     * Load a model from local storage.
     *
     * See the documentation to `browserLocalStorage` for details on the saved
     * artifacts.
     *
     * @returns The loaded model (if loading succeeds).
     */ async load() {
        const info = JSON.parse(this.LS.getItem(this.keys.info));
        if (info == null) throw new Error(`In local storage, there is no model with name '${this.modelPath}'`);
        if (info.modelTopologyType !== 'JSON') throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
        const out = {};
        // Load topology.
        const topology = JSON.parse(this.LS.getItem(this.keys.topology));
        if (topology == null) throw new Error(`In local storage, the topology of model '${this.modelPath}' ` + `is missing.`);
        out.modelTopology = topology;
        // Load weight specs.
        const weightSpecs = JSON.parse(this.LS.getItem(this.keys.weightSpecs));
        if (weightSpecs == null) throw new Error(`In local storage, the weight specs of model '${this.modelPath}' ` + `are missing.`);
        out.weightSpecs = weightSpecs;
        // Load meta-data fields.
        const metadataString = this.LS.getItem(this.keys.modelMetadata);
        if (metadataString != null) {
            const metadata = JSON.parse(metadataString);
            out.format = metadata.format;
            out.generatedBy = metadata.generatedBy;
            out.convertedBy = metadata.convertedBy;
            if (metadata.signature != null) out.signature = metadata.signature;
            if (metadata.userDefinedMetadata != null) out.userDefinedMetadata = metadata.userDefinedMetadata;
            if (metadata.modelInitializer != null) out.modelInitializer = metadata.modelInitializer;
            if (metadata.initializerSignature != null) out.initializerSignature = metadata.initializerSignature;
            if (metadata.trainingConfig != null) out.trainingConfig = metadata.trainingConfig;
        }
        // Load weight data.
        const weightDataBase64 = this.LS.getItem(this.keys.weightData);
        if (weightDataBase64 == null) throw new Error(`In local storage, the binary weight values of model ` + `'${this.modelPath}' are missing.`);
        out.weightData = (0, $4FRLN.base64StringToArrayBuffer)(weightDataBase64);
        return out;
    }
}
$c74728762db9681f$export$8984a84f7aef20de.URL_SCHEME = 'localstorage://';
const $c74728762db9681f$export$64ff64fd6b1180ae = (url)=>{
    if (!(0, $ibsdL.env)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($c74728762db9681f$export$8984a84f7aef20de.URL_SCHEME)) return $c74728762db9681f$export$96d8dd89e6c22307(url.slice($c74728762db9681f$export$8984a84f7aef20de.URL_SCHEME.length));
        else return null;
    }
};
(0, $9RUNn.IORouterRegistry).registerSaveRouter($c74728762db9681f$export$64ff64fd6b1180ae);
(0, $9RUNn.IORouterRegistry).registerLoadRouter($c74728762db9681f$export$64ff64fd6b1180ae);
function $c74728762db9681f$export$96d8dd89e6c22307(modelPath) {
    return new $c74728762db9681f$export$8984a84f7aef20de(modelPath);
}
class $c74728762db9681f$export$bb7e7fb445a616f4 {
    constructor(){
        (0, $8cCb2.assert)((0, $ibsdL.env)().getBool('IS_BROWSER'), ()=>'Current environment is not a web browser');
        (0, $8cCb2.assert)(typeof window === 'undefined' || typeof window.localStorage !== 'undefined', ()=>'Current browser does not appear to support localStorage');
        this.LS = window.localStorage;
    }
    async listModels() {
        const out = {};
        const prefix = $c74728762db9681f$var$PATH_PREFIX + $c74728762db9681f$var$PATH_SEPARATOR;
        const suffix = $c74728762db9681f$var$PATH_SEPARATOR + $c74728762db9681f$var$INFO_SUFFIX;
        for(let i = 0; i < this.LS.length; ++i){
            const key = this.LS.key(i);
            if (key.startsWith(prefix) && key.endsWith(suffix)) {
                const modelPath = $c74728762db9681f$var$getModelPathFromKey(key);
                out[modelPath] = JSON.parse(this.LS.getItem(key));
            }
        }
        return out;
    }
    async removeModel(path) {
        path = $c74728762db9681f$var$maybeStripScheme(path);
        const keys = $c74728762db9681f$var$getModelKeys(path);
        if (this.LS.getItem(keys.info) == null) throw new Error(`Cannot find model at path '${path}'`);
        const info = JSON.parse(this.LS.getItem(keys.info));
        $c74728762db9681f$var$removeItems(keys);
        return info;
    }
}

});

parcelRegister("1PMKz", function(module, exports) {

$parcel$export(module.exports, "ModelStoreManagerRegistry", () => $15605ea4e29ff52d$export$ccf7f72dec8f0028);
$parcel$export(module.exports, "listModels", () => $15605ea4e29ff52d$export$8d63af86d795ece4);
$parcel$export(module.exports, "removeModel", () => $15605ea4e29ff52d$export$e71037184d1ad0fd);
$parcel$export(module.exports, "copyModel", () => $15605ea4e29ff52d$export$b5971478866000ed);
$parcel$export(module.exports, "moveModel", () => $15605ea4e29ff52d$export$598f168272f4fec2);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Classes and functions for model management across multiple storage mediums.
 *
 * Supported client actions:
 * - Listing models on all registered storage mediums.
 * - Remove model by URL from any registered storage mediums, by using URL
 *   string.
 * - Moving or copying model from one path to another in the same medium or from
 *   one medium to another, by using URL strings.
 */ 
var $8cCb2 = parcelRequire("8cCb2");

var $9RUNn = parcelRequire("9RUNn");
const $15605ea4e29ff52d$var$URL_SCHEME_SUFFIX = '://';
class $15605ea4e29ff52d$export$ccf7f72dec8f0028 {
    constructor(){
        this.managers = {};
    }
    static getInstance() {
        if ($15605ea4e29ff52d$export$ccf7f72dec8f0028.instance == null) $15605ea4e29ff52d$export$ccf7f72dec8f0028.instance = new $15605ea4e29ff52d$export$ccf7f72dec8f0028();
        return $15605ea4e29ff52d$export$ccf7f72dec8f0028.instance;
    }
    /**
     * Register a save-handler router.
     *
     * @param saveRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `save` method defined or `null`.
     */ static registerManager(scheme, manager) {
        (0, $8cCb2.assert)(scheme != null, ()=>'scheme must not be undefined or null.');
        if (scheme.endsWith($15605ea4e29ff52d$var$URL_SCHEME_SUFFIX)) scheme = scheme.slice(0, scheme.indexOf($15605ea4e29ff52d$var$URL_SCHEME_SUFFIX));
        (0, $8cCb2.assert)(scheme.length > 0, ()=>'scheme must not be an empty string.');
        const registry = $15605ea4e29ff52d$export$ccf7f72dec8f0028.getInstance();
        (0, $8cCb2.assert)(registry.managers[scheme] == null, ()=>`A model store manager is already registered for scheme '${scheme}'.`);
        registry.managers[scheme] = manager;
    }
    static getManager(scheme) {
        const manager = $15605ea4e29ff52d$export$ccf7f72dec8f0028.getInstance().managers[scheme];
        if (manager == null) throw new Error(`Cannot find model manager for scheme '${scheme}'`);
        return manager;
    }
    static getSchemes() {
        return Object.keys($15605ea4e29ff52d$export$ccf7f72dec8f0028.getInstance().managers);
    }
}
/**
 * Helper method for parsing a URL string into a scheme and a path.
 *
 * @param url E.g., 'localstorage://my-model'
 * @returns A dictionary with two fields: scheme and path.
 *   Scheme: e.g., 'localstorage' in the example above.
 *   Path: e.g., 'my-model' in the example above.
 */ function $15605ea4e29ff52d$var$parseURL(url) {
    if (url.indexOf($15605ea4e29ff52d$var$URL_SCHEME_SUFFIX) === -1) throw new Error(`The url string provided does not contain a scheme. ` + `Supported schemes are: ` + `${$15605ea4e29ff52d$export$ccf7f72dec8f0028.getSchemes().join(',')}`);
    return {
        scheme: url.split($15605ea4e29ff52d$var$URL_SCHEME_SUFFIX)[0],
        path: url.split($15605ea4e29ff52d$var$URL_SCHEME_SUFFIX)[1]
    };
}
async function $15605ea4e29ff52d$var$cloneModelInternal(sourceURL, destURL, deleteSource = false) {
    (0, $8cCb2.assert)(sourceURL !== destURL, ()=>`Old path and new path are the same: '${sourceURL}'`);
    const loadHandlers = (0, $9RUNn.IORouterRegistry).getLoadHandlers(sourceURL);
    (0, $8cCb2.assert)(loadHandlers.length > 0, ()=>`Copying failed because no load handler is found for source URL ${sourceURL}.`);
    (0, $8cCb2.assert)(loadHandlers.length < 2, ()=>`Copying failed because more than one (${loadHandlers.length}) ` + `load handlers for source URL ${sourceURL}.`);
    const loadHandler = loadHandlers[0];
    const saveHandlers = (0, $9RUNn.IORouterRegistry).getSaveHandlers(destURL);
    (0, $8cCb2.assert)(saveHandlers.length > 0, ()=>`Copying failed because no save handler is found for destination ` + `URL ${destURL}.`);
    (0, $8cCb2.assert)(saveHandlers.length < 2, ()=>`Copying failed because more than one (${loadHandlers.length}) ` + `save handlers for destination URL ${destURL}.`);
    const saveHandler = saveHandlers[0];
    const sourceScheme = $15605ea4e29ff52d$var$parseURL(sourceURL).scheme;
    const sourcePath = $15605ea4e29ff52d$var$parseURL(sourceURL).path;
    const sameMedium = sourceScheme === $15605ea4e29ff52d$var$parseURL(sourceURL).scheme;
    const modelArtifacts = await loadHandler.load();
    // If moving within the same storage medium, remove the old model as soon as
    // the loading is done. Without doing this, it is possible that the combined
    // size of the two models will cause the cloning to fail.
    if (deleteSource && sameMedium) await $15605ea4e29ff52d$export$ccf7f72dec8f0028.getManager(sourceScheme).removeModel(sourcePath);
    const saveResult = await saveHandler.save(modelArtifacts);
    // If moving between mediums, the deletion is done after the save succeeds.
    // This guards against the case in which saving to the destination medium
    // fails.
    if (deleteSource && !sameMedium) await $15605ea4e29ff52d$export$ccf7f72dec8f0028.getManager(sourceScheme).removeModel(sourcePath);
    return saveResult.modelArtifactsInfo;
}
/**
 * List all models stored in registered storage mediums.
 *
 * For a web browser environment, the registered mediums are Local Storage and
 * IndexedDB.
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Delete the model.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 * ```
 *
 * @returns A `Promise` of a dictionary mapping URLs of existing models to
 * their model artifacts info. URLs include medium-specific schemes, e.g.,
 *   'indexeddb://my/model/1'. Model artifacts info include type of the
 * model's topology, byte sizes of the topology, weights, etc.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $15605ea4e29ff52d$export$8d63af86d795ece4() {
    const schemes = $15605ea4e29ff52d$export$ccf7f72dec8f0028.getSchemes();
    const out = {};
    for (const scheme of schemes){
        const schemeOut = await $15605ea4e29ff52d$export$ccf7f72dec8f0028.getManager(scheme).listModels();
        for(const path in schemeOut){
            const url = scheme + $15605ea4e29ff52d$var$URL_SCHEME_SUFFIX + path;
            out[url] = schemeOut[path];
        }
    }
    return out;
}
/**
 * Remove a model specified by URL from a registered storage medium.
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Delete the model.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 * ```
 *
 * @param url A URL to a stored model, with a scheme prefix, e.g.,
 *   'localstorage://my-model-1', 'indexeddb://my/model/2'.
 * @returns ModelArtifactsInfo of the deleted model (if and only if deletion
 *   is successful).
 * @throws Error if deletion fails, e.g., if no model exists at `path`.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $15605ea4e29ff52d$export$e71037184d1ad0fd(url) {
    const schemeAndPath = $15605ea4e29ff52d$var$parseURL(url);
    const manager = $15605ea4e29ff52d$export$ccf7f72dec8f0028.getManager(schemeAndPath.scheme);
    return manager.removeModel(schemeAndPath.path);
}
/**
 * Copy a model from one URL to another.
 *
 * This function supports:
 *
 * 1. Copying within a storage medium, e.g.,
 *    `tf.io.copyModel('localstorage://model-1', 'localstorage://model-2')`
 * 2. Copying between two storage mediums, e.g.,
 *    `tf.io.copyModel('localstorage://model-1', 'indexeddb://model-1')`
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Copy the model, from Local Storage to IndexedDB.
 * await tf.io.copyModel(
 *     'localstorage://demo/management/model1',
 *     'indexeddb://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Remove both models.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 * await tf.io.removeModel('indexeddb://demo/management/model1');
 * ```
 *
 * @param sourceURL Source URL of copying.
 * @param destURL Destination URL of copying.
 * @returns ModelArtifactsInfo of the copied model (if and only if copying
 *   is successful).
 * @throws Error if copying fails, e.g., if no model exists at `sourceURL`, or
 *   if `oldPath` and `newPath` are identical.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $15605ea4e29ff52d$export$b5971478866000ed(sourceURL, destURL) {
    const deleteSource = false;
    return $15605ea4e29ff52d$var$cloneModelInternal(sourceURL, destURL, deleteSource);
}
/**
 * Move a model from one URL to another.
 *
 * This function supports:
 *
 * 1. Moving within a storage medium, e.g.,
 *    `tf.io.moveModel('localstorage://model-1', 'localstorage://model-2')`
 * 2. Moving between two storage mediums, e.g.,
 *    `tf.io.moveModel('localstorage://model-1', 'indexeddb://model-1')`
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Move the model, from Local Storage to IndexedDB.
 * await tf.io.moveModel(
 *     'localstorage://demo/management/model1',
 *     'indexeddb://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Remove the moved model.
 * await tf.io.removeModel('indexeddb://demo/management/model1');
 * ```
 *
 * @param sourceURL Source URL of moving.
 * @param destURL Destination URL of moving.
 * @returns ModelArtifactsInfo of the copied model (if and only if copying
 *   is successful).
 * @throws Error if moving fails, e.g., if no model exists at `sourceURL`, or
 *   if `oldPath` and `newPath` are identical.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $15605ea4e29ff52d$export$598f168272f4fec2(sourceURL, destURL) {
    const deleteSource = true;
    return $15605ea4e29ff52d$var$cloneModelInternal(sourceURL, destURL, deleteSource);
}

});


parcelRegister("lhiTQ", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ibsdL = parcelRequire("ibsdL");

var $hPtJY = parcelRequire("hPtJY");

const $f7d9d89bc67d90a6$export$fc0623918121e18f = {
    // tslint:disable-next-line:no-require-imports
    importFetch: ()=>(parcelRequire("kjyEk"))
};
let $f7d9d89bc67d90a6$var$systemFetch;
function $f7d9d89bc67d90a6$export$ab67f817cc7ff6dc() {
    $f7d9d89bc67d90a6$var$systemFetch = null;
}
function $f7d9d89bc67d90a6$export$fec6b32271d1a551(fetchFn) {
    $f7d9d89bc67d90a6$var$systemFetch = fetchFn;
}
function $f7d9d89bc67d90a6$export$f53da9ce5ba19de0() {
    return $f7d9d89bc67d90a6$var$systemFetch;
}

class $f7d9d89bc67d90a6$export$7befb6c3de272049 {
    constructor(){
        // tslint:disable-next-line:no-require-imports
        this.util = (parcelRequire("kjyEk"));
        // According to the spec, the built-in encoder can do only UTF-8 encoding.
        // https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder/TextEncoder
        this.textEncoder = new this.util.TextEncoder();
    }
    fetch(path, requestInits) {
        if ((0, $ibsdL.env)().global.fetch != null) return (0, $ibsdL.env)().global.fetch(path, requestInits);
        if ($f7d9d89bc67d90a6$var$systemFetch == null) $f7d9d89bc67d90a6$var$systemFetch = $f7d9d89bc67d90a6$export$fc0623918121e18f.importFetch();
        return $f7d9d89bc67d90a6$var$systemFetch(path, requestInits);
    }
    now() {
        const time = $hPtJY.hrtime();
        return time[0] * 1000 + time[1] / 1000000;
    }
    encode(text, encoding) {
        if (encoding !== 'utf-8' && encoding !== 'utf8') throw new Error(`Node built-in encoder only supports utf-8, but got ${encoding}`);
        return this.textEncoder.encode(text);
    }
    decode(bytes, encoding) {
        if (bytes.length === 0) return '';
        return new this.util.TextDecoder(encoding).decode(bytes);
    }
    isTypedArray(a) {
        return this.util.types.isFloat32Array(a) || this.util.types.isInt32Array(a) || this.util.types.isUint8Array(a) || this.util.types.isUint8ClampedArray(a);
    }
}
if ((0, $ibsdL.env)().get('IS_NODE') && !(0, $ibsdL.env)().get('IS_BROWSER')) (0, $ibsdL.env)().setPlatform('node', new $f7d9d89bc67d90a6$export$7befb6c3de272049());

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("iG87S", function(module, exports) {

$parcel$export(module.exports, "buffer", () => $d99273e33e31a4d2$export$ab1029bcae9ddb4a);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9jCh7 = parcelRequire("9jCh7");

var $8cCb2 = parcelRequire("8cCb2");
function $d99273e33e31a4d2$export$ab1029bcae9ddb4a(shape, dtype = 'float32', values) {
    dtype = dtype || 'float32';
    $8cCb2.assertNonNegativeIntegerDimensions(shape);
    return new (0, $9jCh7.TensorBuffer)(shape, dtype, values);
}

});

parcelRegister("inFmq", function(module, exports) {

$parcel$export(module.exports, "cast", () => $d61a75572b5954a3$export$f2db7d5238e1d23f);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Casts a `tf.Tensor` to a new dtype.
 *
 * ```js
 * const x = tf.tensor1d([1.5, 2.5, 3]);
 * tf.cast(x, 'int32').print();
 * ```
 * @param x The input tensor to be casted.
 * @param dtype The dtype to cast the input tensor to.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $d61a75572b5954a3$var$cast_(x, dtype) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'cast');
    // Sanity checks.
    if (!$8cCb2.isValidDtype(dtype)) throw new Error(`Failed to cast to unknown dtype ${dtype}`);
    if (dtype === 'string' && $x.dtype !== 'string' || dtype !== 'string' && $x.dtype === 'string') throw new Error('Only strings can be casted to strings');
    const inputs = {
        x: $x
    };
    const attrs = {
        dtype: dtype
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Cast), inputs, attrs);
}
const $d61a75572b5954a3$export$f2db7d5238e1d23f = /* @__PURE__ */ (0, $jqSCG.op)({
    cast_: $d61a75572b5954a3$var$cast_
});

});

parcelRegister("5TuCW", function(module, exports) {

$parcel$export(module.exports, "clone", () => $44a9d8b42e3e34af$export$9cd59f9826255e47);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Creates a new tensor with the same values and shape as the specified
 * tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 *
 * x.clone().print();
 * ```
 *
 * @param x The tensor to clone.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $44a9d8b42e3e34af$var$clone_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'clone', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    // Note this op is called tf.identity in python. Hence the kernel name used
    // here.
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Identity), inputs);
}
const $44a9d8b42e3e34af$export$9cd59f9826255e47 = /* @__PURE__ */ (0, $jqSCG.op)({
    clone_: $44a9d8b42e3e34af$var$clone_
});

});

parcelRegister("bSp5U", function(module, exports) {

$parcel$export(module.exports, "print", () => $8a5834107ae482be$export$c2d084dc44961371);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Prints information about the `tf.Tensor` including its data.
 *
 * ```js
 * const verbose = true;
 * tf.tensor2d([1, 2, 3, 4], [2, 2]).print(verbose);
 * ```
 * @param x The tensor to be printed.
 * @param verbose Whether to print verbose information about the ` Tensor`,
 * including dtype and size.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $8a5834107ae482be$export$c2d084dc44961371(x, verbose = false) {
    console.log(x.toString(verbose));
}

});


parcelRegister("5KHy0", function(module, exports) {

$parcel$export(module.exports, "registerOptimizers", () => $4303074357071843$export$9a85654c75805c9a);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $Haryc = parcelRequire("Haryc");

var $7740A = parcelRequire("7740A");

var $cdIoP = parcelRequire("cdIoP");

var $9sl63 = parcelRequire("9sl63");

var $7GJGN = parcelRequire("7GJGN");

var $7qglv = parcelRequire("7qglv");

var $hR6PP = parcelRequire("hR6PP");

var $5IZxH = parcelRequire("5IZxH");
const $4303074357071843$var$OPTIMIZERS = [
    (0, $Haryc.AdadeltaOptimizer),
    (0, $7740A.AdagradOptimizer),
    (0, $cdIoP.AdamOptimizer),
    (0, $9sl63.AdamaxOptimizer),
    (0, $7GJGN.MomentumOptimizer),
    (0, $7qglv.RMSPropOptimizer),
    (0, $hR6PP.SGDOptimizer)
];
function $4303074357071843$export$9a85654c75805c9a() {
    for (const optimizer of $4303074357071843$var$OPTIMIZERS)(0, $5IZxH.registerClass)(optimizer);
}

});
parcelRegister("Haryc", function(module, exports) {

$parcel$export(module.exports, "AdadeltaOptimizer", () => $081c1e1a002596a7$export$d80a766c536c9aaf);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $c2DT1 = parcelRequire("c2DT1");

var $hgacW = parcelRequire("hgacW");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $iAb3z = parcelRequire("iAb3z");

var $iDd8d = parcelRequire("iDd8d");

var $8EjnK = parcelRequire("8EjnK");

var $kULIJ = parcelRequire("kULIJ");
class $081c1e1a002596a7$export$d80a766c536c9aaf extends (0, $kULIJ.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adadelta';
    }
    constructor(learningRate, rho, epsilon = null){
        super();
        this.learningRate = learningRate;
        this.rho = rho;
        this.epsilon = epsilon;
        this.accumulatedGrads = [];
        this.accumulatedUpdates = [];
        if (epsilon == null) this.epsilon = (0, $38WwN.ENGINE).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $38WwN.ENGINE).registeredVariables[name];
            const trainable = false;
            if (this.accumulatedGrads[i] == null) this.accumulatedGrads[i] = {
                originalName: `${name}/accum_grad`,
                variable: (0, $c2DT1.tidy)(()=>(0, $8EjnK.zerosLike)(value).variable(trainable))
            };
            if (this.accumulatedUpdates[i] == null) this.accumulatedUpdates[i] = {
                originalName: `${name}/accum_var`,
                variable: (0, $c2DT1.tidy)(()=>(0, $8EjnK.zerosLike)(value).variable(trainable))
            };
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedGrad = this.accumulatedGrads[i].variable;
            const accumulatedUpdate = this.accumulatedUpdates[i].variable;
            (0, $c2DT1.tidy)(()=>{
                const newAccumulatedGrad = (0, $hgacW.add)((0, $jZc0w.mul)(accumulatedGrad, this.rho), (0, $jZc0w.mul)((0, $iDd8d.square)(gradient), 1 - this.rho));
                const updates = (0, $jZc0w.mul)((0, $1QPqB.div)((0, $iAb3z.sqrt)((0, $hgacW.add)(accumulatedUpdate, this.epsilon)), (0, $iAb3z.sqrt)((0, $hgacW.add)(accumulatedGrad, this.epsilon))), gradient);
                const newAccumulatedUpdate = (0, $hgacW.add)((0, $jZc0w.mul)(accumulatedUpdate, this.rho), (0, $jZc0w.mul)((0, $iDd8d.square)(updates), 1 - this.rho));
                accumulatedGrad.assign(newAccumulatedGrad);
                accumulatedUpdate.assign(newAccumulatedUpdate);
                const newValue = (0, $hgacW.add)((0, $jZc0w.mul)(updates, -this.learningRate), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedUpdates != null) {
            (0, $c2DT1.dispose)(this.accumulatedGrads.map((v)=>v.variable));
            (0, $c2DT1.dispose)(this.accumulatedUpdates.map((v)=>v.variable));
        }
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedGrads,
            ...this.accumulatedUpdates
        ];
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const variableCount = weightValues.length / 2;
        const trainable = false;
        this.accumulatedGrads = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedUpdates = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'rho': this.rho,
            'epsilon': this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['rho'], config['epsilon']);
    }
}

});
parcelRegister("hgacW", function(module, exports) {

$parcel$export(module.exports, "add", () => $c90bd95bc0e58efa$export$e16d8520af44a096);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Adds two `tf.Tensor`s element-wise, A + B. Supports broadcasting.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.tensor1d([10, 20, 30, 40]);
 *
 * a.add(b).print();  // or tf.add(a, b)
 * ```
 *
 * ```js
 * // Broadcast add a with b.
 * const a = tf.scalar(5);
 * const b = tf.tensor1d([10, 20, 30, 40]);
 *
 * a.add(b).print();  // or tf.add(a, b)
 * ```
 * @param a The first `tf.Tensor` to add.
 * @param b The second `tf.Tensor` to add. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $c90bd95bc0e58efa$var$add_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'add');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'add');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Add), inputs);
}
const $c90bd95bc0e58efa$export$e16d8520af44a096 = /* @__PURE__ */ (0, $jqSCG.op)({
    add_: $c90bd95bc0e58efa$var$add_
});

});

parcelRegister("1QPqB", function(module, exports) {

$parcel$export(module.exports, "div", () => $15928a4fee5ff81f$export$159d9494db57879b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $6a2Ft = parcelRequire("6a2Ft");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.div(b).print();  // or tf.div(a, b)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 *
 * a.div(b).print();  // or tf.div(a, b)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $15928a4fee5ff81f$var$div_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'div');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'div');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    if ($a.dtype === 'int32' && $b.dtype === 'int32') return (0, $6a2Ft.floorDiv)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {};
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.RealDiv), inputs, attrs);
}
const $15928a4fee5ff81f$export$159d9494db57879b = /* @__PURE__ */ (0, $jqSCG.op)({
    div_: $15928a4fee5ff81f$var$div_
});

});
parcelRegister("6a2Ft", function(module, exports) {

$parcel$export(module.exports, "floorDiv", () => $47c5bf11930fb3f9$export$112397bc52715a8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
 * The result is rounded with floor function.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.floorDiv(b).print();  // or tf.div(a, b)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 *
 * a.floorDiv(b).print();  // or tf.floorDiv(a, b)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $47c5bf11930fb3f9$var$floorDiv_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'floorDiv');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'floorDiv');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.FloorDiv), inputs);
}
const $47c5bf11930fb3f9$export$112397bc52715a8 = /* @__PURE__ */ (0, $jqSCG.op)({
    floorDiv_: $47c5bf11930fb3f9$var$floorDiv_
});

});


parcelRegister("jZc0w", function(module, exports) {

$parcel$export(module.exports, "mul", () => $e8cd0739d0f73f4b$export$6e3a27864ab166fe);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Multiplies two `tf.Tensor`s element-wise, A * B. Supports broadcasting.
 *
 * We also expose `tf.mulStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.tensor1d([2, 3, 4, 5]);
 *
 * a.mul(b).print();  // or tf.mul(a, b)
 * ```
 *
 * ```js
 * // Broadcast mul a with b.
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.scalar(5);
 *
 * a.mul(b).print();  // or tf.mul(a, b)
 * ```
 * @param a The first tensor to multiply.
 * @param b The second tensor to multiply. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $e8cd0739d0f73f4b$var$mul_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'mul');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'mul');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Multiply), inputs);
}
const $e8cd0739d0f73f4b$export$6e3a27864ab166fe = /* @__PURE__ */ (0, $jqSCG.op)({
    mul_: $e8cd0739d0f73f4b$var$mul_
});

});

parcelRegister("iAb3z", function(module, exports) {

$parcel$export(module.exports, "sqrt", () => $d8742a69331de610$export$eba8049fb5020b81);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes square root of the input `tf.Tensor` element-wise: `y = sqrt(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 4, -1]);
 *
 * x.sqrt().print();  // or tf.sqrt(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d8742a69331de610$var$sqrt_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'sqrt', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Sqrt), inputs);
}
const $d8742a69331de610$export$eba8049fb5020b81 = /* @__PURE__ */ (0, $jqSCG.op)({
    sqrt_: $d8742a69331de610$var$sqrt_
});

});

parcelRegister("iDd8d", function(module, exports) {

$parcel$export(module.exports, "square", () => $03801900ae8a72ab$export$dd4f28cef696bc7d);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes square of `x` element-wise: `x ^ 2`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.sqrt(2), -1]);
 *
 * x.square().print();  // or tf.square(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $03801900ae8a72ab$var$square_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'square');
    const attrs = {};
    return (0, $38WwN.ENGINE).runKernel('Square', {
        x: $x
    }, attrs);
}
const $03801900ae8a72ab$export$dd4f28cef696bc7d = /* @__PURE__ */ (0, $jqSCG.op)({
    square_: $03801900ae8a72ab$var$square_
});

});

parcelRegister("8EjnK", function(module, exports) {

$parcel$export(module.exports, "zerosLike", () => $64c118098861f580$export$cb1f824e7733584d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Creates a `tf.Tensor` with all elements set to 0 with the same shape as the
 * given tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 * tf.zerosLike(x).print();
 * ```
 *
 * @param x The tensor of required shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $64c118098861f580$var$zerosLike_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'zerosLike');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.ZerosLike), inputs);
}
const $64c118098861f580$export$cb1f824e7733584d = /* @__PURE__ */ (0, $jqSCG.op)({
    zerosLike_: $64c118098861f580$var$zerosLike_
});

});

parcelRegister("kULIJ", function(module, exports) {

$parcel$export(module.exports, "Optimizer", () => $f39e0de69b839287$export$69ae9293516e70f0);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $c2DT1 = parcelRequire("c2DT1");

var $92fpA = parcelRequire("92fpA");

var $3xp7o = parcelRequire("3xp7o");

var $5IZxH = parcelRequire("5IZxH");
class $f39e0de69b839287$export$69ae9293516e70f0 extends (0, $5IZxH.Serializable) {
    /**
     * Executes `f()` and minimizes the scalar output of `f()` by computing
     * gradients of y with respect to the list of trainable variables provided by
     * `varList`. If no list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to minimize.
     * @param returnCost Whether to return the scalar cost value produced by
     * executing `f()`.
     * @param varList An optional list of variables to update. If specified, only
     * the trainable variables in varList will be updated by minimize. Defaults to
     * all trainable variables.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers'}
     */ minimize(f, returnCost = false, varList) {
        const { value: value, grads: grads } = this.computeGradients(f, varList);
        if (varList != null) {
            const gradArray = varList.map((v)=>({
                    name: v.name,
                    tensor: grads[v.name]
                }));
            this.applyGradients(gradArray);
        } else this.applyGradients(grads);
        // Dispose gradients.
        (0, $c2DT1.dispose)(grads);
        if (returnCost) return value;
        else {
            value.dispose();
            return null;
        }
    }
    /**
     * The number of iterations that this optimizer instance has been invoked for.
     */ get iterations() {
        if (this.iterations_ == null) this.iterations_ = 0;
        return this.iterations_;
    }
    incrementIterations() {
        this.iterations_ = this.iterations + 1;
    }
    /**
     * Executes f() and computes the gradient of the scalar output of f() with
     * respect to the list of trainable variables provided by `varList`. If no
     * list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to use for computing
     * gradients with respect to variables.
     * @param varList An optional list of variables to compute gradients with
     * respect to. If specified, only the trainable variables in varList will have
     * gradients computed with respect to. Defaults to all trainable variables.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers'}
     */ computeGradients(f, varList) {
        return (0, $92fpA.variableGrads)(f, varList);
    }
    /**
     * Dispose the variables (if any) owned by this optimizer instance.
     */ dispose() {
        if (this.iterations_ != null) (0, $c2DT1.dispose)(this.iterations_);
    }
    async saveIterations() {
        if (this.iterations_ == null) this.iterations_ = 0;
        return {
            name: 'iter',
            // TODO(cais): Use 'int64' type when available.
            tensor: (0, $3xp7o.scalar)(this.iterations_, 'int32')
        };
    }
    async getWeights() {
        throw new Error('getWeights() is not implemented for this optimizer yet.');
    }
    async setWeights(weightValues) {
        throw new Error(`setWeights() is not implemented for this optimizer class ` + `${this.getClassName()}`);
    }
    /**
     * Extract the first element of the weight values and set it
     * as the iterations counter variable of this instance of optimizer.
     *
     * @param weightValues
     * @returns Weight values with the first element consumed and excluded.
     */ async extractIterations(weightValues) {
        this.iterations_ = (await weightValues[0].tensor.data())[0];
        return weightValues.slice(1);
    }
}
Object.defineProperty($f39e0de69b839287$export$69ae9293516e70f0, Symbol.hasInstance, {
    value: (instance)=>{
        return instance.minimize != null && instance.computeGradients != null && instance.applyGradients != null;
    }
});

});
parcelRegister("92fpA", function(module, exports) {

$parcel$export(module.exports, "variableGrads", () => $694041655139423f$export$c756d9ed08b9677f);
$parcel$export(module.exports, "customGrad", () => $694041655139423f$export$5519f0eeb00c44e5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $9jCh7 = parcelRequire("9jCh7");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");
/**
 * Provided `f(x)`, returns another function `g(x, dy?)`, which gives the
 * gradient of `f(x)` with respect to `x`.
 *
 * If `dy` is provided, the gradient of `f(x).mul(dy).sum()` with respect to
 * `x` is computed instead. `f(x)` must take a single tensor `x` and return a
 * single tensor `y`. If `f()` takes multiple inputs, use `tf.grads` instead.
 *
 * ```js
 * // f(x) = x ^ 2
 * const f = x => x.square();
 * // f'(x) = 2x
 * const g = tf.grad(f);
 *
 * const x = tf.tensor1d([2, 3]);
 * g(x).print();
 * ```
 *
 * ```js
 * // f(x) = x ^ 3
 * const f = x => x.pow(tf.scalar(3, 'int32'));
 * // f'(x) = 3x ^ 2
 * const g = tf.grad(f);
 * // f''(x) = 6x
 * const gg = tf.grad(g);
 *
 * const x = tf.tensor1d([2, 3]);
 * gg(x).print();
 * ```
 *
 * @param f The function f(x), to compute gradient for.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$c24429b22bb73814(f) {
    $8cCb2.assert($8cCb2.isFunction(f), ()=>'The f passed in grad(f) must be a function');
    return (x, dy)=>{
        // x can be of any dtype, thus null as the last argument.
        const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'tf.grad', 'string_or_numeric');
        const $dy = dy != null ? (0, $5xBLk.convertToTensor)(dy, 'dy', 'tf.grad') : null;
        return (0, $38WwN.ENGINE).tidy(()=>{
            const { value: value, grads: grads } = (0, $38WwN.ENGINE).gradients(()=>f($x), [
                $x
            ], $dy);
            if ($dy != null) $8cCb2.assertShapesMatch(value.shape, $dy.shape, "The shape of dy passed in grad(f)(x, dy) must match the shape returned by f(x)");
            $694041655139423f$var$checkGrads(grads);
            return grads[0];
        });
    };
}
/**
 * Provided `f(x1, x2,...)`, returns another function `g([x1, x2,...], dy?)`,
 * which gives an array of gradients of `f()` with respect to each input
 * [`x1`,`x2`,...].
 *
 * If `dy` is passed when calling `g()`, the gradient of
 * `f(x1,...).mul(dy).sum()` with respect to each input is computed instead.
 * The provided `f` must take one or more tensors and return a single tensor
 * `y`. If `f()` takes a single input, we recommend using `tf.grad` instead.
 *
 * ```js
 * // f(a, b) = a * b
 * const f = (a, b) => a.mul(b);
 * // df / da = b, df / db = a
 * const g = tf.grads(f);
 *
 * const a = tf.tensor1d([2, 3]);
 * const b = tf.tensor1d([-2, -3]);
 * const [da, db] = g([a, b]);
 * console.log('da');
 * da.print();
 * console.log('db');
 * db.print();
 * ```
 *
 * @param f The function `f(x1, x2,...)` to compute gradients for.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$3f3749f5340c73f2(f) {
    $8cCb2.assert($8cCb2.isFunction(f), ()=>'The f passed in grads(f) must be a function');
    return (args, dy)=>{
        $8cCb2.assert(Array.isArray(args), ()=>"The args passed in grads(f)(args) must be an array of `Tensor`s or `TensorLike`s");
        // args can be of any dtype, thus null as the last argument.
        const $args = (0, $5xBLk.convertToTensorArray)(args, 'args', 'tf.grads', 'string_or_numeric');
        const $dy = dy != null ? (0, $5xBLk.convertToTensor)(dy, 'dy', 'tf.grads') : null;
        return (0, $38WwN.ENGINE).tidy(()=>{
            const { value: value, grads: grads } = (0, $38WwN.ENGINE).gradients(()=>f(...$args), $args, $dy);
            if ($dy != null) $8cCb2.assertShapesMatch(value.shape, $dy.shape, "The shape of dy passed in grads(f)([x1,...], dy) must match the shape returned by f([x1,...])");
            $694041655139423f$var$checkGrads(grads);
            return grads;
        });
    };
}
/**
 * Like `tf.grad`, but also returns the value of `f()`. Useful when `f()`
 * returns a metric you want to show.
 *
 * The result is a rich object with the following properties:
 * - grad: The gradient of `f(x)` w.r.t. `x` (result of `tf.grad`).
 * - value: The value returned by `f(x)`.
 *
 * ```js
 * // f(x) = x ^ 2
 * const f = x => x.square();
 * // f'(x) = 2x
 * const g = tf.valueAndGrad(f);
 *
 * const x = tf.tensor1d([2, 3]);
 * const {value, grad} = g(x);
 *
 * console.log('value');
 * value.print();
 * console.log('grad');
 * grad.print();
 * ```
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$9fbe39d4dcb3921e(f) {
    $8cCb2.assert($8cCb2.isFunction(f), ()=>'The f passed in valueAndGrad(f) must be a function');
    return (x, dy)=>{
        $8cCb2.assert(x instanceof (0, $9jCh7.Tensor), ()=>'The x passed in valueAndGrad(f)(x) must be a tensor');
        $8cCb2.assert(dy == null || dy instanceof (0, $9jCh7.Tensor), ()=>'The dy passed in valueAndGrad(f)(x, dy) must be a tensor');
        const { grads: grads, value: value } = (0, $38WwN.ENGINE).gradients(()=>f(x), [
            x
        ], dy);
        $694041655139423f$var$checkGrads(grads);
        return {
            grad: grads[0],
            value: value
        };
    };
}
/**
 * Like `tf.grads`, but returns also the value of `f()`. Useful when `f()`
 * returns a metric you want to show.
 *
 * The result is a rich object with the following properties:
 * - grads: The gradients of `f()` w.r.t. each input (result of `tf.grads`).
 * - value: The value returned by `f(x)`.
 *
 * ```js
 * // f(a, b) = a * b
 * const f = (a, b) => a.mul(b);
 * // df/da = b, df/db = a
 * const g = tf.valueAndGrads(f);
 *
 * const a = tf.tensor1d([2, 3]);
 * const b = tf.tensor1d([-2, -3]);
 * const {value, grads} = g([a, b]);
 *
 * const [da, db] = grads;
 *
 * console.log('value');
 * value.print();
 *
 * console.log('da');
 * da.print();
 * console.log('db');
 * db.print();
 * ```
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$c03281a254ef3cf0(f) {
    $8cCb2.assert($8cCb2.isFunction(f), ()=>'The f passed in valueAndGrads(f) must be a function');
    return (args, dy)=>{
        $8cCb2.assert(Array.isArray(args) && args.every((arg)=>arg instanceof (0, $9jCh7.Tensor)), ()=>"The args passed in valueAndGrads(f)(args) must be array of tensors");
        $8cCb2.assert(dy == null || dy instanceof (0, $9jCh7.Tensor), ()=>'The dy passed in valueAndGrads(f)(args, dy) must be a tensor');
        const res = (0, $38WwN.ENGINE).gradients(()=>f(...args), args, dy);
        if (dy != null) $8cCb2.assertShapesMatch(res.value.shape, dy.shape, "The shape of dy passed in valueAndGrads(f)([x1,...], dy) must match the shape returned by f([x1,...])");
        $694041655139423f$var$checkGrads(res.grads);
        return res;
    };
}
/**
 * Computes and returns the gradient of f(x) with respect to the list of
 * trainable variables provided by `varList`. If no list is provided, it
 * defaults to all trainable variables.
 *
 * ```js
 * const a = tf.variable(tf.tensor1d([3, 4]));
 * const b = tf.variable(tf.tensor1d([5, 6]));
 * const x = tf.tensor1d([1, 2]);
 *
 * // f(a, b) = a * x ^ 2 + b * x
 * const f = () => a.mul(x.square()).add(b.mul(x)).sum();
 * // df/da = x ^ 2, df/db = x
 * const {value, grads} = tf.variableGrads(f);
 *
 * Object.keys(grads).forEach(varName => grads[varName].print());
 * ```
 *
 * @param f The function to execute. f() should return a scalar.
 * @param varList The list of variables to compute the gradients with respect
 *     to. Defaults to all trainable variables.
 * @returns An object with the following keys and values:
 *   - `value`: The value of the function `f`.
 *   - `grads`: A map from the names of the variables to the gradients.
 *     If the `varList` argument is provided explicitly and contains a subset of
 *     non-trainable variables, this map in the return value will contain keys
 *     that map the names of the non-trainable variables to `null`.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$c756d9ed08b9677f(f, varList) {
    $8cCb2.assert($8cCb2.isFunction(f), ()=>'The f passed in variableGrads(f) must be a function');
    $8cCb2.assert(varList == null || Array.isArray(varList) && varList.every((v)=>v instanceof (0, $9jCh7.Variable)), ()=>"The varList passed in variableGrads(f, varList) must be an array of variables");
    const specifiedVarList = varList != null;
    if (!specifiedVarList) {
        // Get all of the trainable variables.
        varList = [];
        for(const varName in (0, $38WwN.ENGINE).registeredVariables)varList.push((0, $38WwN.ENGINE).registeredVariables[varName]);
    }
    const specifiedNonTrainable = specifiedVarList ? varList.filter((variable)=>!variable.trainable) : null;
    // Prune non-trainable variables.
    const originalVarCount = varList.length;
    varList = varList.filter((variable)=>variable.trainable);
    $8cCb2.assert(varList.length > 0, ()=>`variableGrads() expects at least one of the input variables to ` + `be trainable, but none of the ${originalVarCount} variables is ` + `trainable.`);
    const allowNoGradients = true;
    const { value: value, grads: grads } = (0, $38WwN.ENGINE).gradients(f, varList, null, allowNoGradients);
    $8cCb2.assert(grads.some((g)=>g != null), ()=>"Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize().");
    $8cCb2.assert(value.rank === 0, ()=>`The f passed in variableGrads(f) must return a scalar, but it ` + `returned a rank-${value.rank} tensor`);
    const namedGrads = {};
    varList.forEach((v, i)=>{
        if (grads[i] != null) namedGrads[v.name] = grads[i];
    });
    if (specifiedNonTrainable != null) // If varList is explicitly provided and contains non-trainable values,
    // add them to the returned gradients with `null` values.
    specifiedNonTrainable.forEach((v)=>namedGrads[v.name] = null);
    return {
        value: value,
        grads: namedGrads
    };
}
/**
 * Overrides the gradient computation of a function `f`.
 *
 * Takes a function
 * `f(...inputs, save) => {value: Tensor, gradFunc: (dy, saved) => Tensor[]}`
 * and returns another function `g(...inputs)` which takes the same inputs as
 * `f`. When called, `g` returns `f().value`. In backward mode, custom gradients
 * with respect to each input of `f` are computed using `f().gradFunc`.
 *
 * The `save` function passed to `f` should be used for saving tensors needed
 * in the gradient. And the `saved` passed to the `gradFunc` is a
 * `NamedTensorMap`, which contains those saved tensors.
 *
 * ```js
 * const customOp = tf.customGrad((x, save) => {
 *   // Save x to make sure it's available later for the gradient.
 *   save([x]);
 *   // Override gradient of our custom x ^ 2 op to be dy * abs(x);
 *   return {
 *     value: x.square(),
 *     // Note `saved.x` which points to the `x` we saved earlier.
 *     gradFunc: (dy, saved) => [dy.mul(saved[0].abs())]
 *   };
 * });
 *
 * const x = tf.tensor1d([-1, -2, 3]);
 * const dx = tf.grad(x => customOp(x));
 *
 * console.log(`f(x):`);
 * customOp(x).print();
 * console.log(`f'(x):`);
 * dx(x).print();
 * ```
 *
 * @param f The function to evaluate in forward mode, which should return
 *     `{value: Tensor, gradFunc: (dy, saved) => Tensor[]}`, where `gradFunc`
 *     returns the custom gradients of `f` with respect to its inputs.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$5519f0eeb00c44e5(f) {
    return (0, $38WwN.ENGINE).customGrad(f);
}
function $694041655139423f$var$checkGrads(grads) {
    const numNullGradients = grads.filter((g)=>g == null).length;
    if (numNullGradients > 0) throw new Error(`Cannot compute gradient of y=f(x) with respect to x. Make sure that
    the f you passed encloses all operations that lead from x to y.`);
}

});

parcelRegister("3xp7o", function(module, exports) {

$parcel$export(module.exports, "scalar", () => $2937f01f2600aea0$export$7de3fcd3cdba2a46);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jjNRA = parcelRequire("jjNRA");

var $dKr4X = parcelRequire("dKr4X");
function $2937f01f2600aea0$export$7de3fcd3cdba2a46(value, dtype) {
    if (((0, $jjNRA.isTypedArray)(value) && dtype !== 'string' || Array.isArray(value)) && dtype !== 'complex64') throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");
    if (dtype === 'string' && (0, $jjNRA.isTypedArray)(value) && !(value instanceof Uint8Array)) throw new Error("When making a scalar from encoded string, the value must be `Uint8Array`.");
    const shape = [];
    const inferredShape = [];
    return (0, $dKr4X.makeTensor)(value, shape, inferredShape, dtype);
}

});

parcelRegister("5IZxH", function(module, exports) {

$parcel$export(module.exports, "Serializable", () => $42b0cce2828065a4$export$64782a6a7800f48c);
$parcel$export(module.exports, "SerializationMap", () => $42b0cce2828065a4$export$3a868b20f0f2f6c0);
$parcel$export(module.exports, "registerClass", () => $42b0cce2828065a4$export$a3f7d716dc76cb2e);
$parcel$export(module.exports, "getRegisteredName", () => $42b0cce2828065a4$export$33f51542dd5bdf78);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
/**
 * Maps to mapping between the custom object and its name.
 *
 * After registering a custom class, these two maps will add key-value pairs
 * for the class object and the registered name.
 *
 * Therefore we can get the relative registered name by calling
 * getRegisteredName() function.
 *
 * For example:
 * GLOBAL_CUSTOM_OBJECT: {key=registeredName: value=corresponding
 * CustomObjectClass}
 *
 * GLOBAL_CUSTOM_NAMES: {key=CustomObjectClass: value=corresponding
 * registeredName}
 *
 */ const $42b0cce2828065a4$var$GLOBAL_CUSTOM_OBJECT = new Map();
const $42b0cce2828065a4$var$GLOBAL_CUSTOM_NAMES = new Map();
class $42b0cce2828065a4$export$64782a6a7800f48c {
    /**
     * Return the class name for this class to use in serialization contexts.
     *
     * Generally speaking this will be the same thing that constructor.name
     * would have returned.  However, the class name needs to be robust
     * against minification for serialization/deserialization to work properly.
     *
     * There's also places such as initializers.VarianceScaling, where
     * implementation details between different languages led to different
     * class hierarchies and a non-leaf node is used for serialization purposes.
     */ getClassName() {
        return this.constructor.className;
    }
    /**
     * Creates an instance of T from a ConfigDict.
     *
     * This works for most descendants of serializable.  A few need to
     * provide special handling.
     * @param cls A Constructor for the class to instantiate.
     * @param config The Configuration for the object.
     */ /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
class $42b0cce2828065a4$export$3a868b20f0f2f6c0 {
    constructor(){
        this.classNameMap = {};
    }
    /**
     * Returns the singleton instance of the map.
     */ static getMap() {
        if ($42b0cce2828065a4$export$3a868b20f0f2f6c0.instance == null) $42b0cce2828065a4$export$3a868b20f0f2f6c0.instance = new $42b0cce2828065a4$export$3a868b20f0f2f6c0();
        return $42b0cce2828065a4$export$3a868b20f0f2f6c0.instance;
    }
    /**
     * Registers the class as serializable.
     */ static register(cls) {
        $42b0cce2828065a4$export$3a868b20f0f2f6c0.getMap().classNameMap[cls.className] = [
            cls,
            cls.fromConfig
        ];
    }
}
function $42b0cce2828065a4$export$a3f7d716dc76cb2e(cls, pkg, name) {
    (0, $8cCb2.assert)(cls.className != null, ()=>`Class being registered does not have the static className ` + `property defined.`);
    (0, $8cCb2.assert)(typeof cls.className === 'string', ()=>`className is required to be a string, but got type ` + typeof cls.className);
    (0, $8cCb2.assert)(cls.className.length > 0, ()=>`Class being registered has an empty-string as its className, ` + `which is disallowed.`);
    if (typeof pkg === 'undefined') pkg = 'Custom';
    if (typeof name === 'undefined') name = cls.className;
    const className = name;
    const registerName = pkg + '>' + className;
    $42b0cce2828065a4$export$3a868b20f0f2f6c0.register(cls);
    $42b0cce2828065a4$var$GLOBAL_CUSTOM_OBJECT.set(registerName, cls);
    $42b0cce2828065a4$var$GLOBAL_CUSTOM_NAMES.set(cls, registerName);
    return cls;
}
function $42b0cce2828065a4$export$33f51542dd5bdf78(cls) {
    if ($42b0cce2828065a4$var$GLOBAL_CUSTOM_NAMES.has(cls)) return $42b0cce2828065a4$var$GLOBAL_CUSTOM_NAMES.get(cls);
    else return cls.className;
}

});



parcelRegister("7740A", function(module, exports) {

$parcel$export(module.exports, "AdagradOptimizer", () => $52dc4bd6634a3583$export$fa35e48f6f1caa57);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $c2DT1 = parcelRequire("c2DT1");

var $hgacW = parcelRequire("hgacW");

var $1QPqB = parcelRequire("1QPqB");

var $gYive = parcelRequire("gYive");

var $jZc0w = parcelRequire("jZc0w");

var $iAb3z = parcelRequire("iAb3z");

var $iDd8d = parcelRequire("iDd8d");

var $kULIJ = parcelRequire("kULIJ");
class $52dc4bd6634a3583$export$fa35e48f6f1caa57 extends (0, $kULIJ.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adagrad';
    }
    constructor(learningRate, initialAccumulatorValue = 0.1){
        super();
        this.learningRate = learningRate;
        this.initialAccumulatorValue = initialAccumulatorValue;
        this.accumulatedGrads = [];
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $38WwN.ENGINE).registeredVariables[name];
            if (this.accumulatedGrads[i] == null) {
                const trainable = false;
                this.accumulatedGrads[i] = {
                    originalName: `${name}/accumulator`,
                    variable: (0, $c2DT1.tidy)(()=>(0, $gYive.fill)(value.shape, this.initialAccumulatorValue).variable(trainable))
                };
            }
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedGrad = this.accumulatedGrads[i].variable;
            (0, $c2DT1.tidy)(()=>{
                const newAccumulatedGrad = (0, $hgacW.add)(accumulatedGrad, (0, $iDd8d.square)(gradient));
                accumulatedGrad.assign(newAccumulatedGrad);
                const newValue = (0, $hgacW.add)((0, $jZc0w.mul)((0, $1QPqB.div)(gradient, (0, $iAb3z.sqrt)((0, $hgacW.add)(newAccumulatedGrad, (0, $38WwN.ENGINE).backend.epsilon()))), -this.learningRate), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedGrads != null) (0, $c2DT1.dispose)(this.accumulatedGrads.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        return [
            await this.saveIterations()
        ].concat(this.accumulatedGrads.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const trainable = false;
        this.accumulatedGrads = weightValues.map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'initialAccumulatorValue': this.initialAccumulatorValue
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['initialAccumulatorValue']);
    }
}

});
parcelRegister("gYive", function(module, exports) {

$parcel$export(module.exports, "fill", () => $c5b09a3759406f8a$export$9563e054e6f787fb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $8cCb2 = parcelRequire("8cCb2");

var $8cCb2 = parcelRequire("8cCb2");
/**
 * Creates a `tf.Tensor` filled with a scalar value.
 *
 * ```js
 * tf.fill([2, 2], 4).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param value The scalar value to fill the tensor with.
 * @param dtype The type of an element in the resulting tensor. Defaults to
 *     'float32' if the given param value is a number, otherwise 'string'.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $c5b09a3759406f8a$export$9563e054e6f787fb(shape, value, dtype) {
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
    dtype = dtype || (0, $8cCb2.inferDtype)(value);
    const attrs = {
        shape: shape,
        value: value,
        dtype: dtype
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Fill), {}, attrs);
}

});


parcelRegister("cdIoP", function(module, exports) {

$parcel$export(module.exports, "AdamOptimizer", () => $8e5923bf3349c4f0$export$de1938eb5fee8ee2);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $c2DT1 = parcelRequire("c2DT1");

var $hgacW = parcelRequire("hgacW");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $ad1of = parcelRequire("ad1of");

var $3xp7o = parcelRequire("3xp7o");

var $iAb3z = parcelRequire("iAb3z");

var $iDd8d = parcelRequire("iDd8d");

var $7kouu = parcelRequire("7kouu");

var $8EjnK = parcelRequire("8EjnK");

var $kULIJ = parcelRequire("kULIJ");
class $8e5923bf3349c4f0$export$de1938eb5fee8ee2 extends (0, $kULIJ.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adam';
    }
    constructor(learningRate, beta1, beta2, epsilon = null){
        super();
        this.learningRate = learningRate;
        this.beta1 = beta1;
        this.beta2 = beta2;
        this.epsilon = epsilon;
        this.accumulatedFirstMoment = [];
        this.accumulatedSecondMoment = [];
        (0, $c2DT1.tidy)(()=>{
            // accB* will be updated by batch.
            this.accBeta1 = (0, $3xp7o.scalar)(beta1).variable();
            this.accBeta2 = (0, $3xp7o.scalar)(beta2).variable();
        });
        if (epsilon == null) this.epsilon = (0, $38WwN.ENGINE).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const varNames = Array.isArray(variableGradients) ? variableGradients.map((v)=>v.name) : Object.keys(variableGradients);
        (0, $c2DT1.tidy)(()=>{
            const oneMinusAccBeta1 = (0, $7kouu.sub)(1, this.accBeta1);
            const oneMinusAccBeta2 = (0, $7kouu.sub)(1, this.accBeta2);
            varNames.forEach((name, i)=>{
                const value = (0, $38WwN.ENGINE).registeredVariables[name];
                const trainable = false;
                if (this.accumulatedFirstMoment[i] == null) this.accumulatedFirstMoment[i] = {
                    originalName: `${name}/m`,
                    variable: (0, $c2DT1.tidy)(()=>(0, $8EjnK.zerosLike)(value).variable(trainable))
                };
                if (this.accumulatedSecondMoment[i] == null) this.accumulatedSecondMoment[i] = {
                    originalName: `${name}/v`,
                    variable: (0, $c2DT1.tidy)(()=>(0, $8EjnK.zerosLike)(value).variable(trainable))
                };
                const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
                if (gradient == null) return;
                const firstMoment = this.accumulatedFirstMoment[i].variable;
                const secondMoment = this.accumulatedSecondMoment[i].variable;
                const newFirstMoment = (0, $hgacW.add)((0, $jZc0w.mul)(firstMoment, this.beta1), (0, $jZc0w.mul)(gradient, 1 - this.beta1));
                const newSecondMoment = (0, $hgacW.add)((0, $jZc0w.mul)(secondMoment, this.beta2), (0, $jZc0w.mul)((0, $iDd8d.square)(gradient), 1 - this.beta2));
                const biasCorrectedFirstMoment = (0, $1QPqB.div)(newFirstMoment, oneMinusAccBeta1);
                const biasCorrectedSecondMoment = (0, $1QPqB.div)(newSecondMoment, oneMinusAccBeta2);
                firstMoment.assign(newFirstMoment);
                secondMoment.assign(newSecondMoment);
                const newValue = (0, $hgacW.add)((0, $jZc0w.mul)((0, $1QPqB.div)(biasCorrectedFirstMoment, (0, $hgacW.add)((0, $iAb3z.sqrt)(biasCorrectedSecondMoment), this.epsilon)), -this.learningRate), value);
                value.assign(newValue);
            });
            this.accBeta1.assign((0, $jZc0w.mul)(this.accBeta1, this.beta1));
            this.accBeta2.assign((0, $jZc0w.mul)(this.accBeta2, this.beta2));
        });
        this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose();
        this.accBeta2.dispose();
        if (this.accumulatedFirstMoment != null) (0, $c2DT1.dispose)(this.accumulatedFirstMoment.map((v)=>v.variable));
        if (this.accumulatedSecondMoment != null) (0, $c2DT1.dispose)(this.accumulatedSecondMoment.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedFirstMoment,
            ...this.accumulatedSecondMoment
        ];
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        (0, $c2DT1.tidy)(()=>{
            this.accBeta1.assign((0, $ad1of.pow)(this.beta1, this.iterations_ + 1));
            this.accBeta2.assign((0, $ad1of.pow)(this.beta2, this.iterations_ + 1));
        });
        const variableCount = weightValues.length / 2;
        const trainable = false;
        this.accumulatedFirstMoment = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedSecondMoment = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'beta1': this.beta1,
            'beta2': this.beta2,
            'epsilon': this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon']);
    }
}

});
parcelRegister("ad1of", function(module, exports) {

$parcel$export(module.exports, "pow", () => $76ec324d3dfd83d3$export$9c297f60e22e3389);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the power of one `tf.Tensor` to another. Supports broadcasting.
 *
 * Given a `tf.Tensor` x and a `tf.Tensor` y, this operation computes x^y for
 * corresponding elements in x and y. The result's dtype will be the upcasted
 * type of the `base` and `exp` dtypes.
 *
 * ```js
 * const a = tf.tensor([[2, 3], [4, 5]])
 * const b = tf.tensor([[1, 2], [3, 0]]).toInt();
 *
 * a.pow(b).print();  // or tf.pow(a, b)
 * ```
 *
 * ```js
 * const a = tf.tensor([[1, 2], [3, 4]])
 * const b = tf.tensor(2).toInt();
 *
 * a.pow(b).print();  // or tf.pow(a, b)
 * ```
 * We also expose `powStrict` which has the same signature as this op and
 * asserts that `base` and `exp` are the same shape (does not broadcast).
 *
 * @param base The base `tf.Tensor` to pow element-wise.
 * @param exp The exponent `tf.Tensor` to pow element-wise.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $76ec324d3dfd83d3$var$pow_(base, exp) {
    let $base = (0, $5xBLk.convertToTensor)(base, 'base', 'pow');
    let $exp = (0, $5xBLk.convertToTensor)(exp, 'exp', 'pow');
    [$base, $exp] = (0, $3w4Rg.makeTypesMatch)($base, $exp);
    const inputs = {
        a: $base,
        b: $exp
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Pow), inputs);
}
const $76ec324d3dfd83d3$export$9c297f60e22e3389 = /* @__PURE__ */ (0, $jqSCG.op)({
    pow_: $76ec324d3dfd83d3$var$pow_
});

});

parcelRegister("7kouu", function(module, exports) {

$parcel$export(module.exports, "sub", () => $555d660851b98db3$export$f93b5905241a7cca);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Subtracts two `tf.Tensor`s element-wise, A - B. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([10, 20, 30, 40]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.sub(b).print();  // or tf.sub(a, b)
 * ```
 *
 * ```js
 * // Broadcast subtract a with b.
 * const a = tf.tensor1d([10, 20, 30, 40]);
 * const b = tf.scalar(5);
 *
 * a.sub(b).print();  // or tf.sub(a, b)
 * ```
 * @param a The first `tf.Tensor` to subtract from.
 * @param b The second `tf.Tensor` to be subtracted. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $555d660851b98db3$var$sub_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'sub');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'sub');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Sub), inputs);
}
const $555d660851b98db3$export$f93b5905241a7cca = /* @__PURE__ */ (0, $jqSCG.op)({
    sub_: $555d660851b98db3$var$sub_
});

});


parcelRegister("9sl63", function(module, exports) {

$parcel$export(module.exports, "AdamaxOptimizer", () => $6e2717eed7ef3d6f$export$69957d0bff775eb6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $c2DT1 = parcelRequire("c2DT1");

var $7j49I = parcelRequire("7j49I");

var $hgacW = parcelRequire("hgacW");

var $1QPqB = parcelRequire("1QPqB");

var $g5Jt1 = parcelRequire("g5Jt1");

var $jZc0w = parcelRequire("jZc0w");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");

var $8EjnK = parcelRequire("8EjnK");

var $kULIJ = parcelRequire("kULIJ");
class $6e2717eed7ef3d6f$export$69957d0bff775eb6 extends (0, $kULIJ.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adamax';
    }
    constructor(learningRate, beta1, beta2, epsilon = null, decay = 0.0){
        super();
        this.learningRate = learningRate;
        this.beta1 = beta1;
        this.beta2 = beta2;
        this.epsilon = epsilon;
        this.decay = decay;
        this.accumulatedFirstMoment = [];
        this.accumulatedWeightedInfNorm = [];
        (0, $c2DT1.tidy)(()=>{
            this.iteration = (0, $3xp7o.scalar)(0).variable();
            this.accBeta1 = (0, $3xp7o.scalar)(beta1).variable();
        });
        if (epsilon == null) this.epsilon = (0, $38WwN.ENGINE).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        (0, $c2DT1.tidy)(()=>{
            const oneMinusAccBeta1 = (0, $7kouu.sub)(1, this.accBeta1);
            const lr = (0, $1QPqB.div)(-this.learningRate, (0, $hgacW.add)((0, $jZc0w.mul)(this.iteration, this.decay), 1));
            variableNames.forEach((name, i)=>{
                const value = (0, $38WwN.ENGINE).registeredVariables[name];
                const trainable = false;
                if (this.accumulatedFirstMoment[i] == null) this.accumulatedFirstMoment[i] = {
                    originalName: `${name}/m`,
                    variable: (0, $8EjnK.zerosLike)(value).variable(trainable)
                };
                if (this.accumulatedWeightedInfNorm[i] == null) this.accumulatedWeightedInfNorm[i] = {
                    originalName: `${name}/v`,
                    variable: (0, $8EjnK.zerosLike)(value).variable(trainable)
                };
                const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
                if (gradient == null) return;
                const firstMoment = this.accumulatedFirstMoment[i].variable;
                const weightedInfNorm = this.accumulatedWeightedInfNorm[i].variable;
                const newFirstMoment = (0, $hgacW.add)((0, $jZc0w.mul)(firstMoment, this.beta1), (0, $jZc0w.mul)(gradient, 1 - this.beta1));
                const ut0 = (0, $jZc0w.mul)(weightedInfNorm, this.beta2);
                const ut1 = (0, $7j49I.abs)(gradient);
                const newWeightedInfNorm = (0, $g5Jt1.maximum)(ut0, ut1);
                firstMoment.assign(newFirstMoment);
                weightedInfNorm.assign(newWeightedInfNorm);
                const newValue = (0, $hgacW.add)((0, $jZc0w.mul)((0, $1QPqB.div)(lr, oneMinusAccBeta1), (0, $1QPqB.div)(newFirstMoment, (0, $hgacW.add)(newWeightedInfNorm, this.epsilon))), value);
                value.assign(newValue);
            });
            this.iteration.assign((0, $hgacW.add)(this.iteration, 1));
            this.accBeta1.assign((0, $jZc0w.mul)(this.accBeta1, this.beta1));
        });
        this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose();
        this.iteration.dispose();
        if (this.accumulatedFirstMoment != null) (0, $c2DT1.dispose)(this.accumulatedFirstMoment.map((v)=>v.variable));
        if (this.accumulatedWeightedInfNorm != null) (0, $c2DT1.dispose)(this.accumulatedWeightedInfNorm.map((v)=>v.variable));
    }
    async getWeights() {
        throw new Error('getWeights() is not implemented for Adamax yet.');
    }
    async setWeights(weightValues) {
        throw new Error('setWeights() is not implemented for Adamax yet.');
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'beta1': this.beta1,
            'beta2': this.beta2,
            'epsilon': this.epsilon,
            'decay': this.decay
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon'], config['decay']);
    }
}

});
parcelRegister("7j49I", function(module, exports) {

$parcel$export(module.exports, "abs", () => $551d87f9cd40f29c$export$2335f513bbd82c6d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes absolute value element-wise: `abs(x)`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.abs().print();  // or tf.abs(x)
 * ```
 * @param x The input `tf.Tensor`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $551d87f9cd40f29c$var$abs_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'abs');
    if ($x.dtype === 'complex64') {
        const inputs = {
            x: $x
        };
        return (0, $38WwN.ENGINE).runKernel((0, $hl418.ComplexAbs), inputs);
    } else {
        const inputs = {
            x: $x
        };
        return (0, $38WwN.ENGINE).runKernel((0, $hl418.Abs), inputs);
    }
}
const $551d87f9cd40f29c$export$2335f513bbd82c6d = /* @__PURE__ */ (0, $jqSCG.op)({
    abs_: $551d87f9cd40f29c$var$abs_
});

});

parcelRegister("g5Jt1", function(module, exports) {

$parcel$export(module.exports, "maximum", () => $bb7061cc1559a0cf$export$b25e0be55f42c9a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $inFmq = parcelRequire("inFmq");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the max of a and b (`a > b ? a : b`) element-wise.
 * Supports broadcasting.
 *
 * We also expose `tf.maximumStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.maximum(b).print();  // or tf.maximum(a, b)
 * ```
 *
 * ```js
 * // Broadcast maximum a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.maximum(b).print();  // or tf.maximum(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $bb7061cc1559a0cf$var$maximum_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'maximum');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'maximum');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    if ($a.dtype === 'bool') {
        $a = (0, $inFmq.cast)($a, 'int32');
        $b = (0, $inFmq.cast)($b, 'int32');
    }
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Maximum), inputs);
}
const $bb7061cc1559a0cf$export$b25e0be55f42c9a = /* @__PURE__ */ (0, $jqSCG.op)({
    maximum_: $bb7061cc1559a0cf$var$maximum_
});

});
parcelRegister("8BaGO", function(module, exports) {

$parcel$export(module.exports, "getBroadcastDims", () => $642a122b4608acc0$export$fc823784344690e0);
$parcel$export(module.exports, "getReductionAxes", () => $642a122b4608acc0$export$9f11ec258a9b2804);
$parcel$export(module.exports, "assertAndGetBroadcastShape", () => $642a122b4608acc0$export$a3e2a38a57ec8318);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Returns the dimensions in the input shape that are broadcasted to
 * produce the provided output shape.
 *
 * The returned dimensions are 0-indexed and sorted. An example:
 * inShape = [4, 1, 3]
 * outShape = [5, 4, 3, 3]
 * result = [1]. Dimension 1 (2nd dimension of input) gets broadcasted 1 => 3.
 */ function $642a122b4608acc0$export$fc823784344690e0(inShape, outShape) {
    const inRank = inShape.length;
    const dims = [];
    for(let i = 0; i < inRank; i++){
        const dim = inRank - 1 - i;
        const a = inShape[dim] || 1;
        const b = outShape[outShape.length - 1 - i] || 1;
        if (b > 1 && a === 1) dims.unshift(dim);
    }
    return dims;
}
function $642a122b4608acc0$export$9f11ec258a9b2804(inShape, outShape) {
    const result = [];
    for(let i = 0; i < outShape.length; i++){
        const inDim = inShape[inShape.length - i - 1];
        const outAxis = outShape.length - i - 1;
        const outDim = outShape[outAxis];
        if (inDim == null || inDim === 1 && outDim > 1) result.unshift(outAxis);
    }
    return result;
}
function $642a122b4608acc0$export$a3e2a38a57ec8318(shapeA, shapeB) {
    const l = Math.max(shapeA.length, shapeB.length);
    const result = new Array(l);
    for(let i = 0; i < l; i++){
        let a = shapeA[shapeA.length - i - 1];
        if (a == null) a = 1;
        let b = shapeB[shapeB.length - i - 1];
        if (b == null) b = 1;
        if (a === 1) result[l - i - 1] = b;
        else if (b === 1) result[l - i - 1] = a;
        else if (a !== b) {
            const errMsg = `Operands could not be broadcast together with shapes ` + `${shapeA} and ${shapeB}.`;
            throw Error(errMsg);
        } else result[l - i - 1] = a;
    }
    return result;
}

});



parcelRegister("7GJGN", function(module, exports) {

$parcel$export(module.exports, "MomentumOptimizer", () => $598fe5979c627cee$export$1db7ecf1f8312c6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $c2DT1 = parcelRequire("c2DT1");

var $hgacW = parcelRequire("hgacW");

var $jZc0w = parcelRequire("jZc0w");

var $3xp7o = parcelRequire("3xp7o");

var $8EjnK = parcelRequire("8EjnK");

var $hR6PP = parcelRequire("hR6PP");
class $598fe5979c627cee$export$1db7ecf1f8312c6 extends (0, $hR6PP.SGDOptimizer) {
    /** @nocollapse */ // Name matters for Python compatibility.
    static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Momentum';
    }
    constructor(learningRate, momentum, useNesterov = false){
        super(learningRate);
        this.learningRate = learningRate;
        this.momentum = momentum;
        this.useNesterov = useNesterov;
        this.accumulations = [];
        this.m = (0, $3xp7o.scalar)(this.momentum);
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $38WwN.ENGINE).registeredVariables[name];
            if (this.accumulations[i] == null) {
                const trainable = false;
                this.accumulations[i] = {
                    originalName: `${name}/momentum`,
                    variable: (0, $c2DT1.tidy)(()=>(0, $8EjnK.zerosLike)(value).variable(trainable))
                };
            }
            const accumulation = this.accumulations[i].variable;
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            (0, $c2DT1.tidy)(()=>{
                let newValue;
                const newAccumulation = (0, $hgacW.add)((0, $jZc0w.mul)(this.m, accumulation), gradient);
                if (this.useNesterov) newValue = (0, $hgacW.add)((0, $jZc0w.mul)(this.c, (0, $hgacW.add)(gradient, (0, $jZc0w.mul)(newAccumulation, this.m))), value);
                else newValue = (0, $hgacW.add)((0, $jZc0w.mul)(this.c, newAccumulation), value);
                accumulation.assign(newAccumulation);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        this.m.dispose();
        if (this.accumulations != null) (0, $c2DT1.dispose)(this.accumulations.map((v)=>v.variable));
    }
    /**
     * Sets the momentum of the optimizer.
     *
     * @param momentum
     */ setMomentum(momentum) {
        this.momentum = momentum;
    }
    async getWeights() {
        // Order matters for Python compatibility.
        return [
            await this.saveIterations()
        ].concat(this.accumulations.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const trainable = false;
        this.accumulations = weightValues.map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'momentum': this.momentum,
            'useNesterov': this.useNesterov
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['momentum'], config['useNesterov']);
    }
}

});
parcelRegister("hR6PP", function(module, exports) {

$parcel$export(module.exports, "SGDOptimizer", () => $cffcb030baa5b575$export$97318dd520e1bd4f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $c2DT1 = parcelRequire("c2DT1");

var $hgacW = parcelRequire("hgacW");

var $jZc0w = parcelRequire("jZc0w");

var $3xp7o = parcelRequire("3xp7o");

var $kULIJ = parcelRequire("kULIJ");
class $cffcb030baa5b575$export$97318dd520e1bd4f extends (0, $kULIJ.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'SGD';
    }
    constructor(learningRate){
        super();
        this.learningRate = learningRate;
        this.setLearningRate(learningRate);
    }
    applyGradients(variableGradients) {
        const varNames = Array.isArray(variableGradients) ? variableGradients.map((v)=>v.name) : Object.keys(variableGradients);
        varNames.forEach((name, i)=>{
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const value = (0, $38WwN.ENGINE).registeredVariables[name];
            (0, $c2DT1.tidy)(()=>{
                const newValue = (0, $hgacW.add)((0, $jZc0w.mul)(this.c, gradient), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    /**
     * Sets the learning rate of the optimizer.
     */ setLearningRate(learningRate) {
        this.learningRate = learningRate;
        if (this.c != null) this.c.dispose();
        this.c = (0, $c2DT1.keep)((0, $3xp7o.scalar)(-learningRate));
    }
    dispose() {
        this.c.dispose();
    }
    async getWeights() {
        return [
            await this.saveIterations()
        ];
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        if (weightValues.length !== 0) throw new Error('SGD optimizer does not have settable weights.');
    }
    getConfig() {
        return {
            'learningRate': this.learningRate
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate']);
    }
}

});


parcelRegister("7qglv", function(module, exports) {

$parcel$export(module.exports, "RMSPropOptimizer", () => $5677a40ccf9c31ca$export$6e668138ce08e3bf);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $c2DT1 = parcelRequire("c2DT1");

var $hgacW = parcelRequire("hgacW");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $iAb3z = parcelRequire("iAb3z");

var $iDd8d = parcelRequire("iDd8d");

var $7kouu = parcelRequire("7kouu");

var $8EjnK = parcelRequire("8EjnK");

var $kULIJ = parcelRequire("kULIJ");
class $5677a40ccf9c31ca$export$6e668138ce08e3bf extends (0, $kULIJ.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'RMSProp';
    }
    constructor(learningRate, decay = 0.9, momentum = 0.0, epsilon = null, centered = false){
        super();
        this.learningRate = learningRate;
        this.decay = decay;
        this.momentum = momentum;
        this.epsilon = epsilon;
        this.accumulatedMeanSquares = [];
        this.accumulatedMoments = [];
        this.accumulatedMeanGrads = [];
        this.centered = centered;
        if (epsilon == null) this.epsilon = (0, $38WwN.ENGINE).backend.epsilon();
        if (learningRate == null) throw new Error(`learningRate for RMSPropOptimizer must be defined.`);
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $38WwN.ENGINE).registeredVariables[name];
            const trainable = false;
            if (this.accumulatedMeanSquares[i] == null) this.accumulatedMeanSquares[i] = {
                originalName: `${name}/rms`,
                variable: (0, $c2DT1.tidy)(()=>(0, $8EjnK.zerosLike)(value).variable(trainable))
            };
            if (this.accumulatedMoments[i] == null) this.accumulatedMoments[i] = {
                originalName: `${name}/momentum`,
                variable: (0, $c2DT1.tidy)(()=>(0, $8EjnK.zerosLike)(value).variable(trainable))
            };
            if (this.accumulatedMeanGrads[i] == null && this.centered) this.accumulatedMeanGrads[i] = {
                originalName: `${name}/mg`,
                variable: (0, $c2DT1.tidy)(()=>(0, $8EjnK.zerosLike)(value).variable(trainable))
            };
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedMeanSquare = this.accumulatedMeanSquares[i].variable;
            const accumulatedMoments = this.accumulatedMoments[i].variable;
            (0, $c2DT1.tidy)(()=>{
                const newAccumulatedMeanSquare = (0, $hgacW.add)((0, $jZc0w.mul)(accumulatedMeanSquare, this.decay), (0, $jZc0w.mul)((0, $iDd8d.square)(gradient), 1 - this.decay));
                if (this.centered) {
                    const accumulatedMeanGrad = this.accumulatedMeanGrads[i].variable;
                    // Centered gradient
                    const newAccumulatedMeanGrad = (0, $hgacW.add)((0, $jZc0w.mul)(accumulatedMeanGrad, this.decay), (0, $jZc0w.mul)(gradient, 1 - this.decay));
                    const gradContribution = (0, $1QPqB.div)((0, $jZc0w.mul)(gradient, this.learningRate), (0, $iAb3z.sqrt)((0, $7kouu.sub)(newAccumulatedMeanSquare, (0, $hgacW.add)((0, $iDd8d.square)(newAccumulatedMeanGrad), this.epsilon))));
                    const newAccumulatedMoments = (0, $hgacW.add)((0, $jZc0w.mul)(accumulatedMoments, this.momentum), gradContribution);
                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
                    accumulatedMeanGrad.assign(newAccumulatedMeanGrad);
                    accumulatedMoments.assign(newAccumulatedMoments);
                    const newValue = (0, $7kouu.sub)(value, newAccumulatedMoments);
                    value.assign(newValue);
                } else {
                    // Plain gradient
                    const newAccumulatedMeanSquare = (0, $hgacW.add)((0, $jZc0w.mul)(accumulatedMeanSquare, this.decay), (0, $jZc0w.mul)((0, $iDd8d.square)(gradient), 1 - this.decay));
                    const newAccumulatedMoments = (0, $hgacW.add)((0, $jZc0w.mul)(accumulatedMoments, this.momentum), (0, $1QPqB.div)((0, $jZc0w.mul)(gradient, this.learningRate), (0, $iAb3z.sqrt)((0, $hgacW.add)(newAccumulatedMeanSquare, this.epsilon))));
                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
                    accumulatedMoments.assign(newAccumulatedMoments);
                    const newValue = (0, $7kouu.sub)(value, newAccumulatedMoments);
                    value.assign(newValue);
                }
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedMeanSquares != null) (0, $c2DT1.dispose)(this.accumulatedMeanSquares.map((v)=>v.variable));
        if (this.accumulatedMeanGrads != null && this.centered) (0, $c2DT1.dispose)(this.accumulatedMeanGrads.map((v)=>v.variable));
        if (this.accumulatedMoments != null) (0, $c2DT1.dispose)(this.accumulatedMoments.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedMeanSquares,
            ...this.accumulatedMoments
        ];
        if (this.centered) variables.push(...this.accumulatedMeanGrads);
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const variableCount = this.centered ? weightValues.length / 3 : weightValues.length / 2;
        const trainable = false;
        this.accumulatedMeanSquares = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedMoments = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        if (this.centered) this.accumulatedMeanGrads = weightValues.slice(variableCount * 2, variableCount * 3).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'decay': this.decay,
            'momentum': this.momentum,
            'epsilon': this.epsilon,
            'centered': this.centered
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['decay'], config['momentum'], config['epsilon'], config['centered']);
    }
}

});


parcelRegister("baxp3", function(module, exports) {

$parcel$export(module.exports, "all", () => $821a8a0c94e26af7$export$84bf76cd7afc7469);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the logical and of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 1, 1], 'bool');
 *
 * x.all().print();  // or tf.all(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
 *
 * const axis = 1;
 * x.all(axis).print();  // or tf.all(x, axis)
 * ```
 *
 * @param x The input tensor. Must be of dtype bool.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $821a8a0c94e26af7$var$all_(x, axis = null, keepDims = false) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'all', 'bool');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.All), inputs, attrs);
}
const $821a8a0c94e26af7$export$84bf76cd7afc7469 = /* @__PURE__ */ (0, $jqSCG.op)({
    all_: $821a8a0c94e26af7$var$all_
});

});

parcelRegister("3cXYO", function(module, exports) {

$parcel$export(module.exports, "any", () => $256104da10806f8b$export$4154a199d7d90455);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the logical or of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 1, 1], 'bool');
 *
 * x.any().print();  // or tf.any(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
 *
 * const axis = 1;
 * x.any(axis).print();  // or tf.any(x, axis)
 * ```
 *
 * @param x The input tensor. Must be of dtype bool.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $256104da10806f8b$var$any_(x, axis = null, keepDims = false) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'any', 'bool');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Any), inputs, attrs);
}
const $256104da10806f8b$export$4154a199d7d90455 = /* @__PURE__ */ (0, $jqSCG.op)({
    any_: $256104da10806f8b$var$any_
});

});

parcelRegister("jctS7", function(module, exports) {

$parcel$export(module.exports, "argMax", () => $dfa64f3fd949567e$export$7980a683c1b852b4);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the indices of the maximum values along an `axis`.
 *
 * The result has the same shape as `input` with the dimension along `axis`
 * removed.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.argMax().print();  // or tf.argMax(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
 *
 * const axis = 1;
 * x.argMax(axis).print();  // or tf.argMax(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $dfa64f3fd949567e$var$argMax_(x, axis = 0) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'argMax');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.ArgMax), inputs, attrs);
}
const $dfa64f3fd949567e$export$7980a683c1b852b4 = /* @__PURE__ */ (0, $jqSCG.op)({
    argMax_: $dfa64f3fd949567e$var$argMax_
});

});

parcelRegister("j4oHC", function(module, exports) {

$parcel$export(module.exports, "avgPool", () => $de218d76756da0e0$export$d5c65a2abd3d97dc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $inFmq = parcelRequire("inFmq");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the 2D average pooling of an image.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *         https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $de218d76756da0e0$var$avgPool_(x, filterSize, strides, pad, dimRoundingMode) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'avgPool', 'float32');
    const dilations = 1;
    $8cCb2.assert($frznq.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $8cCb2.assert(x4D.rank === 4, ()=>`Error in avgPool: x must be rank 4 but got rank ${x4D.rank}.`);
    $frznq.checkPadOnDimRoundingMode('avgPool', pad, dimRoundingMode);
    const inputs = {
        x: x4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    let res = (0, $38WwN.ENGINE).runKernel((0, $hl418.AvgPool), inputs, attrs);
    res = (0, $inFmq.cast)(res, $x.dtype);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $de218d76756da0e0$export$d5c65a2abd3d97dc = /* @__PURE__ */ (0, $jqSCG.op)({
    avgPool_: $de218d76756da0e0$var$avgPool_
});

});
parcelRegister("frznq", function(module, exports) {

$parcel$export(module.exports, "computeDilation2DInfo", () => $b3e4d1c19b78487c$export$24e8a5cb688b9852);
$parcel$export(module.exports, "convertConv2DDataFormat", () => $b3e4d1c19b78487c$export$1641c6bb3eb9a5b4);
$parcel$export(module.exports, "computeConv2DInfo", () => $b3e4d1c19b78487c$export$fdd37387e0a3c672);
$parcel$export(module.exports, "computePool2DInfo", () => $b3e4d1c19b78487c$export$67e321f77840205c);
$parcel$export(module.exports, "computePool3DInfo", () => $b3e4d1c19b78487c$export$1382473b2833755b);
$parcel$export(module.exports, "computeConv3DInfo", () => $b3e4d1c19b78487c$export$e4819ceef3994d7b);
$parcel$export(module.exports, "computeDefaultPad", () => $b3e4d1c19b78487c$export$670354fdcb16da70);
$parcel$export(module.exports, "tupleValuesAreOne", () => $b3e4d1c19b78487c$export$f16174446c2d5b2a);
$parcel$export(module.exports, "eitherStridesOrDilationsAreOne", () => $b3e4d1c19b78487c$export$1e13dbff91e2f5ca);
$parcel$export(module.exports, "stridesOrDilationsArePositive", () => $b3e4d1c19b78487c$export$6f24ba18d950c7e3);
$parcel$export(module.exports, "checkPadOnDimRoundingMode", () => $b3e4d1c19b78487c$export$1b3400c26a44af8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
function $b3e4d1c19b78487c$export$24e8a5cb688b9852(inputShape, filterShape, strides, pad, dataFormat = 'NHWC', dilations) {
    // `computerConv2DInfo` require filterShape to be in the dimension of:
    // `[filterHeight, filterWidth, depth, outDepth]`, dilation2d doesn't have
    // outDepth, it should have the same depth as the input.
    // Input shape: [batch, height, width, inChannels]
    const inputChannels = inputShape[3];
    const $filterShape = [
        ...filterShape,
        inputChannels
    ];
    const $dataFormat = $b3e4d1c19b78487c$export$1641c6bb3eb9a5b4(dataFormat);
    return $b3e4d1c19b78487c$export$fdd37387e0a3c672(inputShape, $filterShape, strides, dilations, pad, null, null, $dataFormat);
}
function $b3e4d1c19b78487c$export$67e321f77840205c(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat = 'channelsLast') {
    const [filterHeight, filterWidth] = $b3e4d1c19b78487c$var$parseTupleParam(filterSize);
    let filterShape;
    if (dataFormat === 'channelsLast') filterShape = [
        filterHeight,
        filterWidth,
        inShape[3],
        inShape[3]
    ];
    else if (dataFormat === 'channelsFirst') filterShape = [
        filterHeight,
        filterWidth,
        inShape[1],
        inShape[1]
    ];
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    return $b3e4d1c19b78487c$export$fdd37387e0a3c672(inShape, filterShape, strides, dilations, pad, roundingMode, false, dataFormat);
}
function $b3e4d1c19b78487c$export$1382473b2833755b(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat = 'NDHWC') {
    const [filterDepth, filterHeight, filterWidth] = $b3e4d1c19b78487c$var$parse3TupleParam(filterSize);
    let filterShape;
    let $dataFormat;
    if (dataFormat === 'NDHWC') {
        $dataFormat = 'channelsLast';
        filterShape = [
            filterDepth,
            filterHeight,
            filterWidth,
            inShape[4],
            inShape[4]
        ];
    } else if (dataFormat === 'NCDHW') {
        $dataFormat = 'channelsFirst';
        filterShape = [
            filterDepth,
            filterHeight,
            filterWidth,
            inShape[1],
            inShape[1]
        ];
    } else throw new Error(`Unknown dataFormat ${dataFormat}`);
    return $b3e4d1c19b78487c$export$e4819ceef3994d7b(inShape, filterShape, strides, dilations, pad, false, $dataFormat, roundingMode);
}
function $b3e4d1c19b78487c$export$fdd37387e0a3c672(inShape, filterShape, strides, dilations, pad, roundingMode, depthwise = false, dataFormat = 'channelsLast') {
    let [batchSize, inHeight, inWidth, inChannels] = [
        -1,
        -1,
        -1,
        -1
    ];
    if (dataFormat === 'channelsLast') [batchSize, inHeight, inWidth, inChannels] = inShape;
    else if (dataFormat === 'channelsFirst') [batchSize, inChannels, inHeight, inWidth] = inShape;
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    const [filterHeight, filterWidth, , filterChannels] = filterShape;
    const [strideHeight, strideWidth] = $b3e4d1c19b78487c$var$parseTupleParam(strides);
    const [dilationHeight, dilationWidth] = $b3e4d1c19b78487c$var$parseTupleParam(dilations);
    const effectiveFilterHeight = $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterHeight, dilationHeight);
    const effectiveFilterWidth = $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterWidth, dilationWidth);
    const { padInfo: padInfo, outHeight: outHeight, outWidth: outWidth } = $b3e4d1c19b78487c$var$getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, effectiveFilterHeight, effectiveFilterWidth, roundingMode, dataFormat);
    const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
    let outShape;
    if (dataFormat === 'channelsFirst') outShape = [
        batchSize,
        outChannels,
        outHeight,
        outWidth
    ];
    else if (dataFormat === 'channelsLast') outShape = [
        batchSize,
        outHeight,
        outWidth,
        outChannels
    ];
    return {
        batchSize: batchSize,
        dataFormat: dataFormat,
        inHeight: inHeight,
        inWidth: inWidth,
        inChannels: inChannels,
        outHeight: outHeight,
        outWidth: outWidth,
        outChannels: outChannels,
        padInfo: padInfo,
        strideHeight: strideHeight,
        strideWidth: strideWidth,
        filterHeight: filterHeight,
        filterWidth: filterWidth,
        effectiveFilterHeight: effectiveFilterHeight,
        effectiveFilterWidth: effectiveFilterWidth,
        dilationHeight: dilationHeight,
        dilationWidth: dilationWidth,
        inShape: inShape,
        outShape: outShape,
        filterShape: filterShape
    };
}
function $b3e4d1c19b78487c$export$e4819ceef3994d7b(inShape, filterShape, strides, dilations, pad, depthwise = false, dataFormat = 'channelsLast', roundingMode) {
    let [batchSize, inDepth, inHeight, inWidth, inChannels] = [
        -1,
        -1,
        -1,
        -1,
        -1
    ];
    if (dataFormat === 'channelsLast') [batchSize, inDepth, inHeight, inWidth, inChannels] = inShape;
    else if (dataFormat === 'channelsFirst') [batchSize, inChannels, inDepth, inHeight, inWidth] = inShape;
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    const [filterDepth, filterHeight, filterWidth, , filterChannels] = filterShape;
    const [strideDepth, strideHeight, strideWidth] = $b3e4d1c19b78487c$var$parse3TupleParam(strides);
    const [dilationDepth, dilationHeight, dilationWidth] = $b3e4d1c19b78487c$var$parse3TupleParam(dilations);
    const effectiveFilterDepth = $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterDepth, dilationDepth);
    const effectiveFilterHeight = $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterHeight, dilationHeight);
    const effectiveFilterWidth = $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterWidth, dilationWidth);
    const { padInfo: padInfo, outDepth: outDepth, outHeight: outHeight, outWidth: outWidth } = $b3e4d1c19b78487c$var$get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, effectiveFilterDepth, effectiveFilterHeight, effectiveFilterWidth, roundingMode);
    const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
    let outShape;
    if (dataFormat === 'channelsFirst') outShape = [
        batchSize,
        outChannels,
        outDepth,
        outHeight,
        outWidth
    ];
    else if (dataFormat === 'channelsLast') outShape = [
        batchSize,
        outDepth,
        outHeight,
        outWidth,
        outChannels
    ];
    return {
        batchSize: batchSize,
        dataFormat: dataFormat,
        inDepth: inDepth,
        inHeight: inHeight,
        inWidth: inWidth,
        inChannels: inChannels,
        outDepth: outDepth,
        outHeight: outHeight,
        outWidth: outWidth,
        outChannels: outChannels,
        padInfo: padInfo,
        strideDepth: strideDepth,
        strideHeight: strideHeight,
        strideWidth: strideWidth,
        filterDepth: filterDepth,
        filterHeight: filterHeight,
        filterWidth: filterWidth,
        effectiveFilterDepth: effectiveFilterDepth,
        effectiveFilterHeight: effectiveFilterHeight,
        effectiveFilterWidth: effectiveFilterWidth,
        dilationDepth: dilationDepth,
        dilationHeight: dilationHeight,
        dilationWidth: dilationWidth,
        inShape: inShape,
        outShape: outShape,
        filterShape: filterShape
    };
}
function $b3e4d1c19b78487c$var$computeOutputShape2D(inShape, fieldSize, stride, zeroPad, roundingMode) {
    if (zeroPad == null) zeroPad = $b3e4d1c19b78487c$export$670354fdcb16da70(inShape, fieldSize, stride);
    const inputRows = inShape[0];
    const inputCols = inShape[1];
    const outputRows = $b3e4d1c19b78487c$var$round((inputRows - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    const outputCols = $b3e4d1c19b78487c$var$round((inputCols - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    return [
        outputRows,
        outputCols
    ];
}
function $b3e4d1c19b78487c$var$computeOutputShape4D(inShape, filterShape, outChannels, strides, zeroPad, roundingMode) {
    if (zeroPad == null) zeroPad = $b3e4d1c19b78487c$export$670354fdcb16da70(inShape, filterShape[0], strides[0]);
    const outShape = [
        0,
        0,
        0,
        outChannels
    ];
    for(let index = 0; index < 3; index++)if (inShape[index] + 2 * zeroPad >= filterShape[index]) outShape[index] = $b3e4d1c19b78487c$var$round((inShape[index] - filterShape[index] + 2 * zeroPad) / strides[index] + 1, roundingMode);
    return outShape;
}
function $b3e4d1c19b78487c$export$670354fdcb16da70(inputShape, fieldSize, stride, dilation = 1) {
    const effectiveFieldSize = $b3e4d1c19b78487c$var$getEffectiveFilterSize(fieldSize, dilation);
    return Math.floor((inputShape[0] * (stride - 1) - stride + effectiveFieldSize) / 2);
}
function $b3e4d1c19b78487c$var$parseTupleParam(param) {
    if (typeof param === 'number') return [
        param,
        param,
        param
    ];
    if (param.length === 2) return [
        param[0],
        param[1],
        1
    ];
    return param;
}
function $b3e4d1c19b78487c$var$parse3TupleParam(param) {
    return typeof param === 'number' ? [
        param,
        param,
        param
    ] : param;
}
/* See https://www.tensorflow.org/api_docs/python/tf/nn/atrous_conv2d
 * Atrous convolution is equivalent to standard convolution with upsampled
 * filters with effective_filter_height =
 * filter_height + (filter_height - 1) * (dilation - 1)
 * and effective_filter_width =
 * filter_width + (filter_width - 1) * (dilation - 1),
 * produced by inserting dilation - 1 zeros along consecutive elements across
 * the filters' spatial dimensions.
 * When there is a dilation, this converts a filter dimension to the
 * effective filter dimension, so it can be used in a standard convolution.
 */ function $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterSize, dilation) {
    if (dilation <= 1) return filterSize;
    return filterSize + (filterSize - 1) * (dilation - 1);
}
function $b3e4d1c19b78487c$var$getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, filterHeight, filterWidth, roundingMode, dataFormat) {
    let padInfo;
    let outHeight;
    let outWidth;
    if (typeof pad === 'number') {
        const padType = pad === 0 ? 'VALID' : 'NUMBER';
        padInfo = {
            top: pad,
            bottom: pad,
            left: pad,
            right: pad,
            type: padType
        };
        const outShape = $b3e4d1c19b78487c$var$computeOutputShape2D([
            inHeight,
            inWidth
        ], filterHeight, strideHeight, pad, roundingMode);
        outHeight = outShape[0];
        outWidth = outShape[1];
    } else if (pad === 'same') {
        outHeight = Math.ceil(inHeight / strideHeight);
        outWidth = Math.ceil(inWidth / strideWidth);
        const padAlongHeight = Math.max(0, (outHeight - 1) * strideHeight + filterHeight - inHeight);
        const padAlongWidth = Math.max(0, (outWidth - 1) * strideWidth + filterWidth - inWidth);
        const top = Math.floor(padAlongHeight / 2);
        const bottom = padAlongHeight - top;
        const left = Math.floor(padAlongWidth / 2);
        const right = padAlongWidth - left;
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            type: 'SAME'
        };
    } else if (pad === 'valid') {
        padInfo = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            type: 'VALID'
        };
        outHeight = Math.ceil((inHeight - filterHeight + 1) / strideHeight);
        outWidth = Math.ceil((inWidth - filterWidth + 1) / strideWidth);
    } else if (typeof pad === 'object') {
        const top = dataFormat === 'channelsLast' ? pad[1][0] : pad[2][0];
        const bottom = dataFormat === 'channelsLast' ? pad[1][1] : pad[2][1];
        const left = dataFormat === 'channelsLast' ? pad[2][0] : pad[3][0];
        const right = dataFormat === 'channelsLast' ? pad[2][1] : pad[3][1];
        const padType = top === 0 && bottom === 0 && left === 0 && right === 0 ? 'VALID' : 'EXPLICIT';
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            type: padType
        };
        outHeight = $b3e4d1c19b78487c$var$round((inHeight - filterHeight + top + bottom) / strideHeight + 1, roundingMode);
        outWidth = $b3e4d1c19b78487c$var$round((inWidth - filterWidth + left + right) / strideWidth + 1, roundingMode);
    } else throw Error(`Unknown padding parameter: ${pad}`);
    return {
        padInfo: padInfo,
        outHeight: outHeight,
        outWidth: outWidth
    };
}
function $b3e4d1c19b78487c$var$get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, filterDepth, filterHeight, filterWidth, roundingMode) {
    let padInfo;
    let outDepth;
    let outHeight;
    let outWidth;
    if (pad === 'valid') pad = 0;
    if (typeof pad === 'number') {
        const padType = pad === 0 ? 'VALID' : 'NUMBER';
        padInfo = {
            top: pad,
            bottom: pad,
            left: pad,
            right: pad,
            front: pad,
            back: pad,
            type: padType
        };
        const outShape = $b3e4d1c19b78487c$var$computeOutputShape4D([
            inDepth,
            inHeight,
            inWidth,
            1
        ], [
            filterDepth,
            filterHeight,
            filterWidth
        ], 1, [
            strideDepth,
            strideHeight,
            strideWidth
        ], pad, roundingMode);
        outDepth = outShape[0];
        outHeight = outShape[1];
        outWidth = outShape[2];
    } else if (pad === 'same') {
        outDepth = Math.ceil(inDepth / strideDepth);
        outHeight = Math.ceil(inHeight / strideHeight);
        outWidth = Math.ceil(inWidth / strideWidth);
        const padAlongDepth = (outDepth - 1) * strideDepth + filterDepth - inDepth;
        const padAlongHeight = (outHeight - 1) * strideHeight + filterHeight - inHeight;
        const padAlongWidth = (outWidth - 1) * strideWidth + filterWidth - inWidth;
        const front = Math.floor(padAlongDepth / 2);
        const back = padAlongDepth - front;
        const top = Math.floor(padAlongHeight / 2);
        const bottom = padAlongHeight - top;
        const left = Math.floor(padAlongWidth / 2);
        const right = padAlongWidth - left;
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            front: front,
            back: back,
            type: 'SAME'
        };
    } else throw Error(`Unknown padding parameter: ${pad}`);
    return {
        padInfo: padInfo,
        outDepth: outDepth,
        outHeight: outHeight,
        outWidth: outWidth
    };
}
/**
 * Rounds a value depending on the rounding mode
 * @param value
 * @param roundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $b3e4d1c19b78487c$var$round(value, roundingMode) {
    if (!roundingMode) return Math.trunc(value);
    switch(roundingMode){
        case 'round':
            // used for Caffe Conv
            return Math.round(value);
        case 'ceil':
            // used for Caffe Pool
            return Math.ceil(value);
        case 'floor':
            return Math.floor(value);
        default:
            throw new Error(`Unknown roundingMode ${roundingMode}`);
    }
}
function $b3e4d1c19b78487c$export$f16174446c2d5b2a(param) {
    const [dimA, dimB, dimC] = $b3e4d1c19b78487c$var$parseTupleParam(param);
    return dimA === 1 && dimB === 1 && dimC === 1;
}
function $b3e4d1c19b78487c$export$1e13dbff91e2f5ca(strides, dilations) {
    return $b3e4d1c19b78487c$export$f16174446c2d5b2a(strides) || $b3e4d1c19b78487c$export$f16174446c2d5b2a(dilations);
}
function $b3e4d1c19b78487c$export$6f24ba18d950c7e3(values) {
    return $b3e4d1c19b78487c$var$parseTupleParam(values).every((value)=>value > 0);
}
function $b3e4d1c19b78487c$export$1641c6bb3eb9a5b4(dataFormat) {
    if (dataFormat === 'NHWC') return 'channelsLast';
    else if (dataFormat === 'NCHW') return 'channelsFirst';
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
}
function $b3e4d1c19b78487c$export$1b3400c26a44af8(opDesc, pad, dimRoundingMode) {
    if (dimRoundingMode != null) {
        if (typeof pad === 'string') throw Error(`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${pad}.`);
        else if (typeof pad === 'number') $8cCb2.assert($8cCb2.isInt(pad), ()=>`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${pad}.`);
        else if (typeof pad === 'object') pad.forEach((p)=>{
            p.forEach((v)=>{
                $8cCb2.assert($8cCb2.isInt(v), ()=>`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${v}.`);
            });
        });
        else throw Error(`Error in ${opDesc}: Unknown padding parameter: ${pad}`);
    }
}

});

parcelRegister("4sqA7", function(module, exports) {

$parcel$export(module.exports, "reshape", () => $33ee657bc32918d5$export$9eaad88cf88cee2b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Reshapes a `tf.Tensor` to a given shape.
 *
 * Given an input tensor, returns a new tensor with the same values as the
 * input tensor with shape `shape`.
 *
 * If one component of shape is the special value -1, the size of that
 * dimension is computed so that the total size remains constant. In
 * particular, a shape of [-1] flattens into 1-D. At most one component of
 * shape can be -1.
 *
 * If shape is 1-D or higher, then the operation returns a tensor with shape
 * shape filled with the values of tensor. In this case, the number of
 * elements implied by shape must be the same as the number of elements in
 * tensor.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * x.reshape([2, 2]).print();
 * ```
 *
 * @param x The input tensor to be reshaped.
 * @param shape An array of integers defining the output tensor shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $33ee657bc32918d5$var$reshape_(x, shape) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'reshape', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    const attrs = {
        shape: shape
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Reshape), inputs, attrs);
}
const $33ee657bc32918d5$export$9eaad88cf88cee2b = /* @__PURE__ */ (0, $jqSCG.op)({
    reshape_: $33ee657bc32918d5$var$reshape_
});

});


parcelRegister("ku2lx", function(module, exports) {

$parcel$export(module.exports, "avgPool3d", () => $ee986deb13dc5b5f$export$ee1b0efb53eb29c3);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $inFmq = parcelRequire("inFmq");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the 3D average pooling.
 *
 * ```js
 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
 * const result = tf.avgPool3d(x, 2, 1, 'valid');
 * result.print();
 * ```
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     `[batch, depth, height, width, inChannels]`.
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     If `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideDepth == strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $ee986deb13dc5b5f$var$avgPool3d_(x, filterSize, strides, pad, dimRoundingMode, dataFormat = 'NDHWC') {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'avgPool3d', 'float32');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $8cCb2.assert(x5D.rank === 5, ()=>`Error in avgPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
    $8cCb2.assert(dataFormat === 'NDHWC', ()=>`Error in avgPool3d: Only NDHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    $8cCb2.assert(typeof strides === 'number' && strides > 0 || Array.isArray(strides) && strides[0] > 0 && strides[1] > 0 && strides[2] > 0, ()=>`Error in avgPool3d: Stride must be > 0, but got '${strides}'`);
    (0, $frznq.checkPadOnDimRoundingMode)('avgPool3d', pad, dimRoundingMode);
    const inputs = {
        x: x5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dataFormat: dataFormat
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    let res = (0, $38WwN.ENGINE).runKernel((0, $hl418.AvgPool3D), inputs, attrs);
    res = (0, $inFmq.cast)(res, x5D.dtype);
    if (reshapedTo5D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $ee986deb13dc5b5f$export$ee1b0efb53eb29c3 = /* @__PURE__ */ (0, $jqSCG.op)({
    avgPool3d_: $ee986deb13dc5b5f$var$avgPool3d_
});

});

parcelRegister("7MaPk", function(module, exports) {

$parcel$export(module.exports, "fromUint8ToStringArray", () => $5a956a12516ed8ee$export$debaff328bdca650);
$parcel$export(module.exports, "fromStringArrayToUint8", () => $5a956a12516ed8ee$export$ce1f4ec5bdd0ab9a);
$parcel$export(module.exports, "slice_util", () => (parcelRequire("bszZn")));
$parcel$export(module.exports, "upcastType", () => (parcelRequire("2MDja")).upcastType);
$parcel$export(module.exports, "segment_util", () => (parcelRequire("fHbAS")));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jjNRA = parcelRequire("jjNRA");

var $kTunp = parcelRequire("kTunp");

var $8BaGO = parcelRequire("8BaGO");

var $chyju = parcelRequire("chyju");

var $frznq = parcelRequire("frznq");

var $bzoAL = parcelRequire("bzoAL");

var $dlbe1 = parcelRequire("dlbe1");

var $kaAdl = parcelRequire("kaAdl");

var $4ldJF = parcelRequire("4ldJF");

var $bszZn = parcelRequire("bszZn");

var $2MDja = parcelRequire("2MDja");

var $aQHa6 = parcelRequire("aQHa6");

var $4h3p6 = parcelRequire("4h3p6");

var $4EvS9 = parcelRequire("4EvS9");

var $7wQGW = parcelRequire("7wQGW");

var $eowEY = parcelRequire("eowEY");

var $aMsMA = parcelRequire("aMsMA");

var $cgHNs = parcelRequire("cgHNs");

var $eCPD4 = parcelRequire("eCPD4");

var $izI5a = parcelRequire("izI5a");

var $4pqBf = parcelRequire("4pqBf");

var $5NPez = parcelRequire("5NPez");

var $2A2jF = parcelRequire("2A2jF");

var $6bLmC = parcelRequire("6bLmC");

var $fHbAS = parcelRequire("fHbAS");
function $5a956a12516ed8ee$export$debaff328bdca650(vals) {
    try {
        // Decode the bytes into string.
        return vals.map((val)=>(0, $jjNRA.decodeString)(val));
    } catch (err) {
        throw new Error(`Failed to decode encoded string bytes into utf-8, error: ${err}`);
    }
}
function $5a956a12516ed8ee$export$ce1f4ec5bdd0ab9a(strings) {
    return strings.map((s)=>(0, $jjNRA.encodeString)(s));
}
$parcel$exportWildcard(module.exports, $kTunp);
$parcel$exportWildcard(module.exports, $8BaGO);
$parcel$exportWildcard(module.exports, $chyju);
$parcel$exportWildcard(module.exports, $frznq);
$parcel$exportWildcard(module.exports, $bzoAL);
$parcel$exportWildcard(module.exports, $dlbe1);
$parcel$exportWildcard(module.exports, $kaAdl);
$parcel$exportWildcard(module.exports, $4ldJF);
$parcel$exportWildcard(module.exports, $aQHa6);
$parcel$exportWildcard(module.exports, $4h3p6);
$parcel$exportWildcard(module.exports, $4EvS9);
$parcel$exportWildcard(module.exports, $7wQGW);
$parcel$exportWildcard(module.exports, $eowEY);
$parcel$exportWildcard(module.exports, $aMsMA);
$parcel$exportWildcard(module.exports, $cgHNs);
$parcel$exportWildcard(module.exports, $eCPD4);
$parcel$exportWildcard(module.exports, $izI5a);
$parcel$exportWildcard(module.exports, $4pqBf);
$parcel$exportWildcard(module.exports, $5NPez);
$parcel$exportWildcard(module.exports, $2A2jF);
$parcel$exportWildcard(module.exports, $6bLmC);

});
parcelRegister("kTunp", function(module, exports) {

$parcel$export(module.exports, "axesAreInnerMostDims", () => $f36081d4d230c419$export$fcf762ecdaba1fc1);
$parcel$export(module.exports, "combineLocations", () => $f36081d4d230c419$export$6cfee5a53150f612);
$parcel$export(module.exports, "computeOutAndReduceShapes", () => $f36081d4d230c419$export$68ecd7df33283881);
$parcel$export(module.exports, "expandShapeToKeepDim", () => $f36081d4d230c419$export$e35db9afe008d7e3);
$parcel$export(module.exports, "assertAxesAreInnerMostDims", () => $f36081d4d230c419$export$f83b6b93f3b44c9c);
$parcel$export(module.exports, "getAxesPermutation", () => $f36081d4d230c419$export$d2a6288eef79b310);
$parcel$export(module.exports, "getUndoAxesPermutation", () => $f36081d4d230c419$export$2975b40e45f30ba8);
$parcel$export(module.exports, "getInnerMostAxes", () => $f36081d4d230c419$export$b62922ed36931ab6);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
function $f36081d4d230c419$export$fcf762ecdaba1fc1(axes, rank) {
    for(let i = 0; i < axes.length; ++i){
        if (axes[axes.length - i - 1] !== rank - 1 - i) return false;
    }
    return true;
}
function $f36081d4d230c419$export$6cfee5a53150f612(outputLoc, reduceLoc, axes) {
    const rank = outputLoc.length + reduceLoc.length;
    const loc = [];
    let outIdx = 0;
    let reduceIdx = 0;
    for(let dim = 0; dim < rank; dim++)if (axes.indexOf(dim) === -1) loc.push(outputLoc[outIdx++]);
    else loc.push(reduceLoc[reduceIdx++]);
    return loc;
}
function $f36081d4d230c419$export$68ecd7df33283881(aShape, axes) {
    const outShape = [];
    const rank = aShape.length;
    for(let dim = 0; dim < rank; dim++)if (axes.indexOf(dim) === -1) outShape.push(aShape[dim]);
    const reduceShape = axes.map((dim)=>aShape[dim]);
    return [
        outShape,
        reduceShape
    ];
}
function $f36081d4d230c419$export$e35db9afe008d7e3(shape, axes) {
    const reduceSubShape = axes.map((x)=>1);
    return $f36081d4d230c419$export$6cfee5a53150f612(shape, reduceSubShape, axes);
}
function $f36081d4d230c419$export$f83b6b93f3b44c9c(msg, axes, rank) {
    $8cCb2.assert($f36081d4d230c419$export$fcf762ecdaba1fc1(axes, rank), ()=>`${msg} supports only inner-most axes for now. ` + `Got axes ${axes} and rank-${rank} input.`);
}
function $f36081d4d230c419$export$d2a6288eef79b310(axes, rank) {
    if ($f36081d4d230c419$export$fcf762ecdaba1fc1(axes, rank)) return null;
    const result = [];
    for(let i = 0; i < rank; ++i)if (axes.indexOf(i) === -1) result.push(i);
    axes.forEach((axis)=>result.push(axis));
    return result;
}
function $f36081d4d230c419$export$2975b40e45f30ba8(axes) {
    return axes.map((axis, i)=>[
            i,
            axis
        ]).sort((a, b)=>a[1] - b[1]).map((x)=>x[0]);
}
function $f36081d4d230c419$export$b62922ed36931ab6(numAxes, rank) {
    const res = [];
    for(let i = rank - numAxes; i < rank; ++i)res.push(i);
    return res;
}

});

parcelRegister("chyju", function(module, exports) {

$parcel$export(module.exports, "assertParamsConsistent", () => $8f11b07965c032fa$export$ce1cccab5e7518dd);
$parcel$export(module.exports, "computeOutShape", () => $8f11b07965c032fa$export$22fa6b3b1305508e);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
function $8f11b07965c032fa$export$ce1cccab5e7518dd(shapes, axis) {
    const rank = shapes[0].length;
    shapes.forEach((shape, i)=>{
        $8cCb2.assert(shape.length === rank, ()=>`Error in concat${rank}D: rank of tensors[${i}] must be the same ` + `as the rank of the rest (${rank})`);
    });
    $8cCb2.assert(axis >= 0 && axis < rank, ()=>`Error in concat${rank}D: axis must be between 0 and ${rank - 1}.`);
    const firstShape = shapes[0];
    shapes.forEach((shape, i)=>{
        for(let r = 0; r < rank; r++)$8cCb2.assert(r === axis || shape[r] === firstShape[r], ()=>`Error in concat${rank}D: Shape of tensors[${i}] (${shape}) ` + `does not match the shape of the rest (${firstShape}) ` + `along the non-concatenated axis ${i}.`);
    });
}
function $8f11b07965c032fa$export$22fa6b3b1305508e(shapes, axis) {
    const outputShape = shapes[0].slice();
    for(let i = 1; i < shapes.length; i++)outputShape[axis] += shapes[i][axis];
    return outputShape;
}

});

parcelRegister("bzoAL", function(module, exports) {

$parcel$export(module.exports, "getFusedDyActivation", () => $86c60a0aff9fcea2$export$a1905aed55f51aef);
$parcel$export(module.exports, "getFusedBiasGradient", () => $86c60a0aff9fcea2$export$1a797e236ae09d1f);
$parcel$export(module.exports, "applyActivation", () => $86c60a0aff9fcea2$export$a0f250a2ba84196);
$parcel$export(module.exports, "shouldFuse", () => $86c60a0aff9fcea2$export$4904add493b957ab);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8BaGO = parcelRequire("8BaGO");

var $7UQTl = parcelRequire("7UQTl");

var $3XskU = parcelRequire("3XskU");

var $jZc0w = parcelRequire("jZc0w");

var $a3pvF = parcelRequire("a3pvF");

var $8wbQq = parcelRequire("8wbQq");

var $fvNYr = parcelRequire("fvNYr");

var $4sqA7 = parcelRequire("4sqA7");

var $jvtSq = parcelRequire("jvtSq");

var $lWdx1 = parcelRequire("lWdx1");

var $9NgTx = parcelRequire("9NgTx");
function $86c60a0aff9fcea2$export$a1905aed55f51aef(dy, y, activation) {
    if (activation == null || activation === 'linear') return dy;
    if (activation === 'relu') return (0, $jZc0w.mul)(dy, (0, $lWdx1.step)(y));
    throw new Error(`Cannot compute gradient for fused activation ${activation}.`);
}
function $86c60a0aff9fcea2$export$1a797e236ae09d1f(bias, dyActivation) {
    let res = dyActivation;
    const reduceAxes = $8BaGO.getReductionAxes(bias.shape, dyActivation.shape);
    if (reduceAxes.length > 0) res = (0, $9NgTx.sum)(res, reduceAxes);
    return (0, $4sqA7.reshape)(res, bias.shape);
}
function $86c60a0aff9fcea2$export$a0f250a2ba84196(x, activation, preluActivationWeights, leakyreluAlpha) {
    if (activation === 'linear') return x;
    else if (activation === 'relu') return (0, $8wbQq.relu)(x);
    else if (activation === 'elu') return (0, $7UQTl.elu)(x);
    else if (activation === 'relu6') return (0, $fvNYr.relu6)(x);
    else if (activation === 'prelu') return (0, $a3pvF.prelu)(x, preluActivationWeights);
    else if (activation === 'leakyrelu') return (0, $3XskU.leakyRelu)(x, leakyreluAlpha);
    else if (activation === 'sigmoid') return (0, $jvtSq.sigmoid)(x);
    throw new Error(`Unknown fused activation ${activation}.`);
}
const $86c60a0aff9fcea2$export$4904add493b957ab = (gradientDepth, activation)=>{
    const gradientMode = gradientDepth > 0;
    return !gradientMode || activation === 'linear';
};

});
parcelRegister("7UQTl", function(module, exports) {

$parcel$export(module.exports, "elu", () => $5c36ca87265596d3$export$796b583dd79d8524);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes exponential linear element-wise: `x > 0 ? x : (e ^ x) - 1`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 1, -3, 2]);
 *
 * x.elu().print();  // or tf.elu(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $5c36ca87265596d3$var$elu_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'elu', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Elu), inputs);
}
const $5c36ca87265596d3$export$796b583dd79d8524 = /* @__PURE__ */ (0, $jqSCG.op)({
    elu_: $5c36ca87265596d3$var$elu_
});

});

parcelRegister("3XskU", function(module, exports) {

$parcel$export(module.exports, "leakyRelu", () => $2e1cdcc1e07e834e$export$23a860e40a2c6b61);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes leaky rectified linear element-wise.
 *
 * See
 * [http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf](
 *     http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf)
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.leakyRelu(0.1).print();  // or tf.leakyRelu(x, 0.1)
 * ```
 * @param x The input tensor.
 * @param alpha The scaling factor for negative values, defaults to 0.2.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $2e1cdcc1e07e834e$var$leakyRelu_(x, alpha = 0.2) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'leakyRelu');
    const inputs = {
        x: $x
    };
    const attrs = {
        alpha: alpha
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.LeakyRelu), inputs, attrs);
}
const $2e1cdcc1e07e834e$export$23a860e40a2c6b61 = /* @__PURE__ */ (0, $jqSCG.op)({
    leakyRelu_: $2e1cdcc1e07e834e$var$leakyRelu_
});

});

parcelRegister("a3pvF", function(module, exports) {

$parcel$export(module.exports, "prelu", () => $751df8e2647ea232$export$5882f235222e6729);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes leaky rectified linear element-wise with parametric alphas.
 *
 * `x < 0 ? alpha * x : f(x) = x`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 * const alpha = tf.scalar(0.1);
 *
 * x.prelu(alpha).print();  // or tf.prelu(x, alpha)
 * ```
 * @param x The input tensor.
 * @param alpha Scaling factor for negative values.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $751df8e2647ea232$var$prelu_(x, alpha) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'prelu');
    const $alpha = (0, $5xBLk.convertToTensor)(alpha, 'alpha', 'prelu');
    const inputs = {
        x: $x,
        alpha: $alpha
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Prelu), inputs);
}
const $751df8e2647ea232$export$5882f235222e6729 = /* @__PURE__ */ (0, $jqSCG.op)({
    prelu_: $751df8e2647ea232$var$prelu_
});

});

parcelRegister("8wbQq", function(module, exports) {

$parcel$export(module.exports, "relu", () => $633a7fface57265e$export$16d1e4612cc0139f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes rectified linear element-wise: `max(x, 0)`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.relu().print();  // or tf.relu(x)
 * ```
 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
 *     `int32`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $633a7fface57265e$var$relu_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'relu');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Relu), inputs);
}
const $633a7fface57265e$export$16d1e4612cc0139f = /* @__PURE__ */ (0, $jqSCG.op)({
    relu_: $633a7fface57265e$var$relu_
});

});

parcelRegister("fvNYr", function(module, exports) {

$parcel$export(module.exports, "relu6", () => $b4b08408f5ab9172$export$4a62bcb95e9c44c4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes rectified linear 6 element-wise: `min(max(x, 0), 6)`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 8]);
 *
 * x.relu6().print();  // or tf.relu6(x)
 * ```
 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
 *     `int32`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $b4b08408f5ab9172$var$relu6_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'relu6');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Relu6), inputs);
}
const $b4b08408f5ab9172$export$4a62bcb95e9c44c4 = /* @__PURE__ */ (0, $jqSCG.op)({
    relu6_: $b4b08408f5ab9172$var$relu6_
});

});

parcelRegister("jvtSq", function(module, exports) {

$parcel$export(module.exports, "sigmoid", () => $e3381678584872cc$export$3b295495ca3cad7c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes sigmoid element-wise, `1 / (1 + exp(-x))`
 *
 * ```js
 * const x = tf.tensor1d([0, -1, 2, -3]);
 *
 * x.sigmoid().print();  // or tf.sigmoid(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $e3381678584872cc$var$sigmoid_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'sigmoid', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Sigmoid), inputs);
}
const $e3381678584872cc$export$3b295495ca3cad7c = /* @__PURE__ */ (0, $jqSCG.op)({
    sigmoid_: $e3381678584872cc$var$sigmoid_
});

});

parcelRegister("lWdx1", function(module, exports) {

$parcel$export(module.exports, "step", () => $ff8982de7da7934b$export$35d34bc0ed591a92);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes step of the input `tf.Tensor` element-wise: `x > 0 ? 1 : alpha`
 *
 * ```js
 * const x = tf.tensor1d([0, 2, -1, -3]);
 *
 * x.step(.5).print();  // or tf.step(x, .5)
 * ```
 * @param x The input tensor.
 * @param alpha The gradient when input is negative. Defaults to 0.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $ff8982de7da7934b$var$step_(x, alpha = 0.0) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'step');
    const inputs = {
        x: $x
    };
    const attrs = {
        alpha: alpha
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Step), inputs, attrs);
}
const $ff8982de7da7934b$export$35d34bc0ed591a92 = /* @__PURE__ */ (0, $jqSCG.op)({
    step_: $ff8982de7da7934b$var$step_
});

});

parcelRegister("9NgTx", function(module, exports) {

$parcel$export(module.exports, "sum", () => $7215cb99724b7643$export$8a63f25cc62965f1);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $inFmq = parcelRequire("inFmq");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the sum of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If axes has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.sum().print();  // or tf.sum(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.sum(axis).print();  // or tf.sum(x, axis)
 * ```
 *
 * @param x The input tensor to compute the sum over. If the dtype is `bool`
 *   it will be converted to `int32` and the output dtype will be `int32`.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $7215cb99724b7643$var$sum_(x, axis = null, keepDims = false) {
    let $x = (0, $5xBLk.convertToTensor)(x, 'x', 'sum');
    if ($x.dtype === 'bool') $x = (0, $inFmq.cast)($x, 'int32');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Sum), inputs, attrs);
}
const $7215cb99724b7643$export$8a63f25cc62965f1 = /* @__PURE__ */ (0, $jqSCG.op)({
    sum_: $7215cb99724b7643$var$sum_
});

});


parcelRegister("dlbe1", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
});

parcelRegister("kaAdl", function(module, exports) {

$parcel$export(module.exports, "RowPartitionType", () => $eaf0d5393d9bb67a$export$c56fa138ccffd243);
$parcel$export(module.exports, "combineRaggedTensorToTensorShapes", () => $eaf0d5393d9bb67a$export$ab67507eda6e05cb);
$parcel$export(module.exports, "getRowPartitionTypesHelper", () => $eaf0d5393d9bb67a$export$b8324e259bdd3daf);
$parcel$export(module.exports, "getRaggedRank", () => $eaf0d5393d9bb67a$export$1cdd548e021d4109);
$parcel$export(module.exports, "validateDefaultValueShape", () => $eaf0d5393d9bb67a$export$4170394182a906f5);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $eaf0d5393d9bb67a$export$c56fa138ccffd243;
(function(RowPartitionType) {
    RowPartitionType[RowPartitionType["FIRST_DIM_SIZE"] = 0] = "FIRST_DIM_SIZE";
    RowPartitionType[RowPartitionType["VALUE_ROWIDS"] = 1] = "VALUE_ROWIDS";
    RowPartitionType[RowPartitionType["ROW_LENGTHS"] = 2] = "ROW_LENGTHS";
    RowPartitionType[RowPartitionType["ROW_SPLITS"] = 3] = "ROW_SPLITS";
    RowPartitionType[RowPartitionType["ROW_LIMITS"] = 4] = "ROW_LIMITS";
    RowPartitionType[RowPartitionType["ROW_STARTS"] = 5] = "ROW_STARTS";
})($eaf0d5393d9bb67a$export$c56fa138ccffd243 || ($eaf0d5393d9bb67a$export$c56fa138ccffd243 = {}));
function $eaf0d5393d9bb67a$export$ab67507eda6e05cb(raggedRank, shape, valueShape) {
    // Test for consistency of valueShape and shape specified.
    // If shape is unspecified and valueShape is specified, then copy
    // over the size from the valueShape dimension.
    let outputShape = new Array();
    if (valueShape == null && shape == null) return outputShape;
    if (shape == null) // Here, value_shape must be of known size.
    while(outputShape.length < raggedRank + valueShape.length)outputShape.push(-1);
    else outputShape = shape.slice();
    if (valueShape == null) return outputShape;
    // At this point, valueShape and output_shape have known ranks.
    if (raggedRank + valueShape.length !== outputShape.length) throw new Error(`rt input.shape and shape=${shape} are incompatible: rt input.rank = ${raggedRank + valueShape.length}, but shape.rank = ${outputShape.length}`);
    for(let i = 1; i < valueShape.length; ++i){
        const valueDim = valueShape[i];
        const outputShapeDimIndex = outputShape[outputShape.length - valueShape.length + i];
        const outputShapeDim = outputShape[outputShapeDimIndex];
        if (valueDim >= 0) {
            if (outputShapeDim >= 0) {
                if (outputShapeDim !== valueDim) throw new Error(`rt input.shape and shape=${shape} are incompatible: rt input.shape[${i + raggedRank}] = ${valueDim} but shape[${i + raggedRank}] = ${outputShapeDim}`);
            } else outputShape[outputShapeDimIndex] = valueDim;
        }
    }
    return outputShape;
}
function $eaf0d5393d9bb67a$export$b8324e259bdd3daf(rowPartitionTypeStrings) {
    const stringToType = {
        'FIRST_DIM_SIZE': $eaf0d5393d9bb67a$export$c56fa138ccffd243.FIRST_DIM_SIZE,
        'VALUE_ROWIDS': $eaf0d5393d9bb67a$export$c56fa138ccffd243.VALUE_ROWIDS,
        'ROW_LENGTHS': $eaf0d5393d9bb67a$export$c56fa138ccffd243.ROW_LENGTHS,
        'ROW_SPLITS': $eaf0d5393d9bb67a$export$c56fa138ccffd243.ROW_SPLITS,
        'ROW_LIMITS': $eaf0d5393d9bb67a$export$c56fa138ccffd243.ROW_LIMITS,
        'ROW_STARTS': $eaf0d5393d9bb67a$export$c56fa138ccffd243.ROW_STARTS
    };
    const result = [];
    for (const typeStr of rowPartitionTypeStrings){
        if (typeStr in stringToType) result.push(stringToType[typeStr]);
        else break;
    }
    return result;
}
function $eaf0d5393d9bb67a$export$1cdd548e021d4109(rowPartitionTypes) {
    if (rowPartitionTypes.length === 0) return 0;
    if (rowPartitionTypes[0] === $eaf0d5393d9bb67a$export$c56fa138ccffd243.FIRST_DIM_SIZE) return rowPartitionTypes.length - 1;
    return rowPartitionTypes.length;
}
function $eaf0d5393d9bb67a$export$4170394182a906f5(defaultValueShape, valueShape) {
    if (defaultValueShape == null || valueShape == null) return;
    const defaultNDims = defaultValueShape.length;
    const valuesNDims = valueShape.length;
    if (defaultNDims >= valuesNDims) throw new Error(`defaultValue.shape=${defaultValueShape} and ragged tensor flatValues.shape=${valueShape}, are incompatible: defaultValue.rank = ${defaultNDims} must be less than ragged tensor input flatValues.rank = ${valuesNDims})`);
    for(let i = 0; i < Math.min(defaultNDims, valuesNDims - 1); ++i){
        const defaultDim = defaultValueShape[i];
        const valueDim = valueShape[i + 1];
        if (defaultDim >= 0 && valueDim >= 0 && defaultDim !== 1 && defaultDim !== valueDim) throw new Error(`defaultValue.shape=${defaultValueShape}, and ragged tensor input flatValues.shape=${valueShape} are incompatible: defaultValue.shape[${i - defaultValueShape.length}] = ${defaultDim} but ragged tensor input.flatValues.shape[${i - defaultValueShape.length}] = ${valueDim}`);
    }
}

});

parcelRegister("4ldJF", function(module, exports) {

$parcel$export(module.exports, "PARALLELIZE_THRESHOLD", () => $3293c731db2632b8$export$ee3544492fe530f6);
$parcel$export(module.exports, "computeOptimalWindowSize", () => $3293c731db2632b8$export$ee795473f4c8fb04);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Inputs of size above this threshold will be parallelized by calling multiple
 * shader programs.
 */ 
var $8cCb2 = parcelRequire("8cCb2");
const $3293c731db2632b8$export$ee3544492fe530f6 = 30;
function $3293c731db2632b8$export$ee795473f4c8fb04(inSize) {
    if (inSize <= $3293c731db2632b8$export$ee3544492fe530f6) return inSize;
    return (0, $8cCb2.nearestDivisor)(inSize, Math.floor(Math.sqrt(inSize)));
}

});

parcelRegister("bszZn", function(module, exports) {

$parcel$export(module.exports, "assertParamsValid", () => $857e39e1331d3036$export$1da6c8ba17e84239);
$parcel$export(module.exports, "maskToAxes", () => $857e39e1331d3036$export$ce8be3e704107015);
$parcel$export(module.exports, "computeOutShape", () => $857e39e1331d3036$export$22fa6b3b1305508e);
$parcel$export(module.exports, "stridesWithElidedDims", () => $857e39e1331d3036$export$7f5fa1173bdb6e15);
$parcel$export(module.exports, "getNormalizedAxes", () => $857e39e1331d3036$export$895fe9252fb79d1);
$parcel$export(module.exports, "startIndicesWithElidedDims", () => $857e39e1331d3036$export$a9f0de12634a4ce3);
$parcel$export(module.exports, "stopIndicesWithElidedDims", () => $857e39e1331d3036$export$19a416bd7e87244f);
$parcel$export(module.exports, "startForAxis", () => $857e39e1331d3036$export$643aca61b9318da8);
$parcel$export(module.exports, "stopForAxis", () => $857e39e1331d3036$export$612a961a199ffe65);
$parcel$export(module.exports, "stridesForAxis", () => $857e39e1331d3036$export$9e3fd91f45c1f07f);
$parcel$export(module.exports, "isSliceContinous", () => $857e39e1331d3036$export$9dc11bd6855e72c6);
$parcel$export(module.exports, "computeFlatOffset", () => $857e39e1331d3036$export$b01553f5da8f819c);
$parcel$export(module.exports, "parseSliceParams", () => $857e39e1331d3036$export$8448a0604fef5d62);
$parcel$export(module.exports, "sliceInfo", () => $857e39e1331d3036$export$54d224865abb6767);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
const $857e39e1331d3036$var$NEW_AXIS = -2;
const $857e39e1331d3036$var$SHRINK_AXIS = -1;
function $857e39e1331d3036$export$1da6c8ba17e84239(input, begin, size) {
    const inputRank = input.shape.length;
    $8cCb2.assert(inputRank === begin.length, ()=>`Error in slice${inputRank}D: Length of begin ${begin} must ` + `match the rank of the array (${inputRank}).`);
    $8cCb2.assert(inputRank === size.length, ()=>`Error in slice${inputRank}D: Length of size ${size} must ` + `match the rank of the array (${inputRank}).`);
    for(let i = 0; i < inputRank; ++i)$8cCb2.assert(begin[i] + size[i] <= input.shape[i], ()=>`Error in slice${inputRank}D: begin[${i}] + size[${i}] ` + `(${begin[i] + size[i]}) would overflow input.shape[${i}] (${input.shape[i]})`);
}
function $857e39e1331d3036$export$ce8be3e704107015(mask) {
    const axes = [];
    let axis = 0;
    while(mask > 0){
        if (mask & 1) axes.push(axis);
        mask /= 2;
        axis++;
    }
    return axes;
}
function $857e39e1331d3036$export$22fa6b3b1305508e(begin, end, strides) {
    const size = [];
    for(let axis = 0; axis < begin.length; axis++)size[axis] = Math.ceil((end[axis] - begin[axis]) / strides[axis]);
    return size;
}
function $857e39e1331d3036$export$7f5fa1173bdb6e15(strides, ellipsisInsertionIndex, numElidedAxes, inputShape) {
    const newStrides = [
        ...strides
    ];
    for(let i = newStrides.length; i < inputShape.length; i++)newStrides.push(1);
    for(let i = 0; i < numElidedAxes; i++)if (i === 0) newStrides[ellipsisInsertionIndex] = 1;
    else {
        newStrides.splice(ellipsisInsertionIndex, 0 /* num elements to delete */ , 1 /* element to add */ );
        newStrides.pop();
    }
    return newStrides;
}
function $857e39e1331d3036$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, normalizedAxis) {
    if (normalizedAxis <= ellipsisInsertionIndex) return normalizedAxis;
    return normalizedAxis - (numElidedAxes - 1);
}
function $857e39e1331d3036$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex) {
    const elidedAxes = [];
    for(let i = 0; i < numElidedAxes; i++)elidedAxes.push(ellipsisInsertionIndex + i);
    return elidedAxes;
}
function $857e39e1331d3036$export$895fe9252fb79d1(inputShape, ellipsisAxes, numInterpolatedAxes, begin, end, strides, beginMask, endMask, ellipsisMask) {
    const inputRank = inputShape.length;
    let normalizedBegin = new Array(inputRank), normalizedEnd = new Array(inputRank), normalizedStrides = new Array(inputRank);
    if (ellipsisAxes.length && numInterpolatedAxes > 0) {
        const fullIndex = ellipsisAxes[0];
        // The ellipsis applies to the masked index as well as any dimensions
        // that are interpolated.
        const numElidedAxes = numInterpolatedAxes + 1;
        normalizedBegin = $857e39e1331d3036$export$a9f0de12634a4ce3(beginMask, fullIndex, numElidedAxes, begin, inputShape);
        normalizedEnd = $857e39e1331d3036$export$19a416bd7e87244f(endMask, fullIndex, numElidedAxes, end, inputShape);
        normalizedStrides = $857e39e1331d3036$export$7f5fa1173bdb6e15(strides, fullIndex, numElidedAxes, inputShape);
    } else for(let axis = 0; axis < inputRank; axis++){
        normalizedBegin[axis] = $857e39e1331d3036$export$643aca61b9318da8(beginMask, begin, strides, inputShape, axis, ellipsisMask);
        normalizedEnd[axis] = $857e39e1331d3036$export$612a961a199ffe65(endMask, end, strides, inputShape, axis, ellipsisMask);
        normalizedStrides[axis] = $857e39e1331d3036$export$9e3fd91f45c1f07f(strides, axis, ellipsisMask);
    }
    return {
        begin: normalizedBegin,
        end: normalizedEnd,
        strides: normalizedStrides
    };
}
function $857e39e1331d3036$export$a9f0de12634a4ce3(beginMask, ellipsisInsertionIndex, numElidedAxes, originalBegin, inputShape) {
    const newIndices = [
        ...inputShape
    ];
    const elidedAxes = $857e39e1331d3036$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
    for(let axis = 0; axis < newIndices.length; axis++)if (elidedAxes.indexOf(axis) > -1) newIndices[axis] = 0;
    else {
        const originalAxis = $857e39e1331d3036$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
        let originalValue = originalBegin[originalAxis];
        if (beginMask & 1 << originalAxis) originalValue = 0;
        newIndices[axis] = originalValue;
    }
    return newIndices;
}
function $857e39e1331d3036$export$19a416bd7e87244f(endMask, ellipsisInsertionIndex, numElidedAxes, originalEnd, inputShape) {
    const newIndices = [
        ...inputShape
    ];
    const elidedAxes = $857e39e1331d3036$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
    for(let axis = 0; axis < newIndices.length; axis++)if (elidedAxes.indexOf(axis) > -1) newIndices[axis] = Number.MAX_SAFE_INTEGER;
    else {
        const originalAxis = $857e39e1331d3036$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
        let originalValue = originalEnd[originalAxis];
        if (endMask & 1 << originalAxis) originalValue = Number.MAX_SAFE_INTEGER;
        newIndices[axis] = originalValue;
    }
    for(let i = 0; i < newIndices.length; i++){
        // Handle negative indices
        const axisSize = inputShape[i];
        if (newIndices[i] < 0) newIndices[i] += axisSize;
        newIndices[i] = $8cCb2.clamp(0, newIndices[i], inputShape[i]);
    }
    return newIndices;
}
function $857e39e1331d3036$export$9e3fd91f45c1f07f(strides, axis, ellipsisMask) {
    let stride = strides[axis];
    if (ellipsisMask & 1 << axis || stride == null) stride = 1;
    return stride;
}
function $857e39e1331d3036$export$643aca61b9318da8(beginMask, startIndices, strides, inputShape, axis, ellipsisMask) {
    // Begin with the specified index
    let start = startIndices[axis];
    const stride = strides[axis] || 1;
    // Check the axis bit from right of masked axes, or the begin index is not set
    // for the axis.
    if (beginMask & 1 << axis || ellipsisMask & 1 << axis || start == null) {
        if (stride > 0) // Forward iteration - use the first element. These values will get
        // clamped below (Note: We could have set them to 0 and axis_size-1, but
        // use lowest() and max() to maintain symmetry with StopForAxis())
        start = Number.MIN_SAFE_INTEGER;
        else // Backward iteration - use the last element.
        start = Number.MAX_SAFE_INTEGER;
    }
    // Handle negative indices
    const axisSize = inputShape[axis];
    if (start < 0) start += axisSize;
    // Clamping
    start = $8cCb2.clamp(0, start, axisSize - 1);
    return start;
}
function $857e39e1331d3036$export$612a961a199ffe65(endMask, stopIndices, strides, inputShape, axis, ellipsisMask) {
    // Begin with the specified index
    let stop = stopIndices[axis];
    const stride = strides[axis] || 1;
    // Check the axis bit from right of masked axes, or if the stop index is not
    // set for this axis.
    if (endMask & 1 << axis || ellipsisMask & 1 << axis || stop == null) {
        if (stride > 0) // Forward iteration - use the last element. These values will get
        // clamped below
        stop = Number.MAX_SAFE_INTEGER;
        else // Backward iteration - use the first element.
        stop = Number.MIN_SAFE_INTEGER;
    }
    // Handle negative indices
    const axisSize = inputShape[axis];
    if (stop < 0) stop += axisSize;
    // Clamping
    // Because the end index points one past the last element, we need slightly
    // different clamping ranges depending on the direction.
    if (stride > 0) // Forward iteration
    stop = $8cCb2.clamp(0, stop, axisSize);
    else // Backward iteration
    stop = $8cCb2.clamp(-1, stop, axisSize - 1);
    return stop;
}
function $857e39e1331d3036$export$9dc11bd6855e72c6(shape, begin, size) {
    // Index of the first axis that has size > 1.
    let firstNonOneAxis = size.length;
    for(let i = 0; i < size.length; i++)if (size[i] > 1) {
        firstNonOneAxis = i;
        break;
    }
    for(let i = firstNonOneAxis + 1; i < size.length; i++){
        if (begin[i] > 0 || size[i] !== shape[i]) return false;
    }
    return true;
}
function $857e39e1331d3036$export$b01553f5da8f819c(begin, strides) {
    let flatOffset = begin.length > 0 ? begin[begin.length - 1] : 1;
    for(let i = 0; i < begin.length - 1; i++)flatOffset += begin[i] * strides[i];
    return flatOffset;
}
function $857e39e1331d3036$export$8448a0604fef5d62(x, begin, size) {
    // The following logic allows for more ergonomic calls.
    let begin_;
    const xRank = x.shape.length;
    if (typeof begin === 'number') begin_ = [
        begin,
        ...new Array(xRank - 1).fill(0)
    ];
    else if (begin.length < xRank) begin_ = begin.concat(new Array(xRank - begin.length).fill(0));
    else begin_ = begin.slice();
    begin_.forEach((d)=>{
        $8cCb2.assert(d !== -1, ()=>'slice() does not support negative begin indexing.');
    });
    let size_;
    if (size == null) size_ = new Array(xRank).fill(-1);
    else if (typeof size === 'number') size_ = [
        size,
        ...new Array(xRank - 1).fill(-1)
    ];
    else if (size.length < xRank) size_ = size.concat(new Array(xRank - size.length).fill(-1));
    else size_ = size;
    size_ = size_.map((d, i)=>{
        if (d >= 0) return d;
        else {
            $8cCb2.assert(d === -1, ()=>`Negative size values should be exactly -1 but got ` + `${d} for the slice() size at index ${i}.`);
            return x.shape[i] - begin_[i];
        }
    });
    return [
        begin_,
        size_
    ];
}
function $857e39e1331d3036$export$54d224865abb6767(xShape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
    let stridesNonNull;
    if (strides == null) {
        stridesNonNull = new Array(begin.length);
        stridesNonNull.fill(1);
    } else stridesNonNull = strides;
    // Only one non-zero bit is allowed in ellipsisMask, which means ellipsisMask
    // is a power of 2. Use bit compares to ensure ellipsisMask is 0 or a power
    // of 2. When i is a power of 2, i & (i - 1) is always 0.
    // Also ref:
    // https://stackoverflow.com/questions/600293/how-to-check-if-a-number-is-a-power-of-2
    if (ellipsisMask != null && (ellipsisMask & ellipsisMask - 1) !== 0) throw new Error('Multiple ellipses in slice is not allowed.');
    // Step 1: Account for ellipsis and new axis.
    // Check for ellipsis and count how many non-newaxis there are after.
    let ellipsisSeen = false;
    const sparseSpec = {
        dims: stridesNonNull.length,
        numAddAxisAfterEllipsis: 0,
        begin: begin.slice(),
        end: end.slice(),
        strides: stridesNonNull.slice(),
        beginMask: beginMask,
        endMask: endMask,
        ellipsisMask: ellipsisMask,
        newAxisMask: newAxisMask,
        shrinkAxisMask: shrinkAxisMask
    };
    for(let i = 0; i < sparseSpec.dims; i++){
        if (ellipsisSeen && (1 << i & newAxisMask) !== 0) sparseSpec.numAddAxisAfterEllipsis++;
        if (1 << i & ellipsisMask) ellipsisSeen = true;
    }
    // If no ellipsis insert one at the end.
    if (!ellipsisSeen) {
        sparseSpec.ellipsisMask |= 1 << sparseSpec.dims;
        sparseSpec.dims++; // this effects loop iteration below
    }
    // Step 2: Make a sparse spec into a full index spec.
    //
    // The sparse spec deos not correspond to the number of dimensions.
    // Make a dense spec that cooresponds to the number of dimensions.
    //
    // For example suppose foo[...,3:] on foo.shape = [2, 2, 3] then we need to
    // produce the missing beginMask for the first two dimensions i.e. from
    // beginMaskSpec = 0, endMaskSpec = 2, we achieve beginMask = 6 (110),
    // endMask = 7 (111).
    const denseSpec = {
        dims: xShape.length,
        beginMask: 0,
        endMask: 0,
        beginValid: false,
        endValid: false
    };
    $857e39e1331d3036$var$buildDenseSpec(sparseSpec, denseSpec);
    // Step 3: Make implicit ranges (non-zero beginMasks and endMasks) explicit
    // and bounds check.
    let isIdentity = true;
    let sliceDim0 = true;
    let isSimpleSlice = true;
    const processingShape = [];
    const finalShape = [];
    for(let i = 0; i < xShape.length; ++i){
        if (denseSpec.strides[i] === 0) throw Error(`strides[${i}] must be non-zero`);
        const shrinkI = !!(denseSpec.shrinkAxisMask & 1 << i);
        const dimI = xShape[i];
        if (dimI === -1) {
            processingShape.push(shrinkI ? 1 : -1);
            continue;
        }
        const masks = [
            denseSpec.beginMask & 1 << i,
            denseSpec.endMask & 1 << i
        ];
        const validRange = [
            denseSpec.strides[i] > 0 ? 0 : -1,
            denseSpec.strides[i] > 0 ? dimI : dimI - 1
        ];
        if (shrinkI && denseSpec.strides[i] <= 0) throw Error('only stride 1 allowed on non-range indexing.');
        isSimpleSlice = isSimpleSlice && denseSpec.strides[i] === 1;
        const beginAndEndMasked = !!(denseSpec.beginMask & 1 << i && denseSpec.endMask & 1 << i);
        if (denseSpec.beginValid && denseSpec.endValid) {
            if (shrinkI) {
                // If we are shrinking, the end index is now possibly incorrect. In
                // particular foo[-1] produces sparseBegin = -1, sparseEnd = 0.
                // and canonical puts these to n-1 and 0, which implies a degenerate
                // interval. Fortunately, it is now safe to re-create end as begin + 1.
                const xFwd = denseSpec.begin[i] < 0 ? dimI + denseSpec.begin[i] : denseSpec.begin[i];
                denseSpec.begin[i] = xFwd;
                denseSpec.end[i] = denseSpec.begin[i] + 1;
                if (xFwd < 0 || xFwd >= dimI) throw Error(`slice index ${denseSpec.begin[i]} of dimension ${i} out of bounds.`);
            } else {
                denseSpec.begin[i] = $857e39e1331d3036$var$canonical(denseSpec.begin[i], 0, denseSpec.strides[i], dimI, masks, validRange);
                denseSpec.end[i] = $857e39e1331d3036$var$canonical(denseSpec.end[i], 1, denseSpec.strides[i], dimI, masks, validRange);
            }
            // Update optimization values
            const takeAllInDimension = denseSpec.strides[i] === 1 && denseSpec.begin[i] === 0 && denseSpec.end[i] === dimI;
            isIdentity = isIdentity && takeAllInDimension;
            sliceDim0 = sliceDim0 && (i === 0 && denseSpec.strides[i] === 1 || takeAllInDimension);
        } else {
            isIdentity = isIdentity && denseSpec.strides[i] === 1 && beginAndEndMasked;
            sliceDim0 = sliceDim0 && (i === 0 && denseSpec.strides[i] === 1 || beginAndEndMasked);
        }
        // Compute the processing shape (the intermediate Eigen will produce)
        let intervalLength;
        let knownInterval = false;
        if (denseSpec.beginValid && denseSpec.endValid) {
            intervalLength = denseSpec.end[i] - denseSpec.begin[i];
            knownInterval = true;
        } else if (shrinkI) {
            // The dimension is still known as 1 for the processingShape, but will be
            // discarded for the final shape.
            intervalLength = 1;
            knownInterval = true;
        } else if (beginAndEndMasked) // Even if we don't have values for begin or end, we do know that this
        // dimension covers the whole interval. If we have shape information for
        // this dimension, that tells us the interval length.
        {
            if (dimI >= 0) {
                if (denseSpec.strides[i] < 0) intervalLength = -dimI;
                else intervalLength = dimI;
                knownInterval = true;
            }
        }
        if (knownInterval) {
            let sizeI;
            // Hold zero if the interval is degenerate, otherwise account for
            // remainder
            if (intervalLength === 0 || intervalLength < 0 !== denseSpec.strides[i] < 0) sizeI = 0;
            else sizeI = Math.trunc(intervalLength / denseSpec.strides[i]) + (intervalLength % denseSpec.strides[i] !== 0 ? 1 : 0);
            processingShape.push(sizeI);
        } else processingShape.push(-1);
    }
    // Step 4: Compute the final shape
    //
    // newAxis will increase dimension by 1 (with a one-size dimension)
    // slices like foo[3, ...] will reduce dimension by 1.
    // This cannot be done earlier, because it depends on Step 3.
    for(let denseDim = 0; denseDim < denseSpec.finalShapeGatherIndices.length; ++denseDim){
        const gatherIndex = denseSpec.finalShapeGatherIndices[denseDim];
        if (gatherIndex >= 0) finalShape.push(processingShape[gatherIndex]);
        else if (gatherIndex === $857e39e1331d3036$var$NEW_AXIS) finalShape.push(1);
    }
    const finalShapeSparse = finalShape.filter((dim, i)=>denseSpec.finalShapeGatherIndices[i] !== $857e39e1331d3036$var$NEW_AXIS);
    return {
        finalShapeSparse: finalShapeSparse,
        finalShape: finalShape,
        isIdentity: isIdentity,
        sliceDim0: sliceDim0,
        isSimpleSlice: isSimpleSlice,
        begin: denseSpec.begin,
        end: denseSpec.end,
        strides: denseSpec.strides
    };
}
function $857e39e1331d3036$var$buildDenseSpec(sparse, dense) {
    dense.beginMask = 0;
    dense.endMask = 0;
    dense.shrinkAxisMask = 0;
    let fullIndex = 0;
    dense.beginValid = sparse.begin != null;
    dense.endValid = sparse.end != null;
    dense.begin = new Array(dense.dims);
    dense.end = new Array(dense.dims);
    dense.strides = new Array(dense.dims);
    dense.finalShapeGatherIndices = [];
    dense.finalShapeGatherIndicesSparse = [];
    dense.inputShapeGatherIndicesSparse = new Array(dense.dims);
    for(let i = 0; i < sparse.dims; i++){
        if (1 << i & sparse.ellipsisMask) {
            // Only the bit that has ellipsis will fall in this condition.
            // Expand the ellipsis into the appropriate indices
            // Note: this only works because we guaranteed one ellipsis.
            const nextIndex = Math.min(dense.dims - (sparse.dims - i) + 1 + sparse.numAddAxisAfterEllipsis, dense.dims);
            for(; fullIndex < nextIndex; fullIndex++){
                // newAxis aren't real axis so you have to skip.
                dense.begin[fullIndex] = 0;
                dense.end[fullIndex] = 0;
                dense.strides[fullIndex] = 1;
                dense.beginMask |= 1 << fullIndex;
                dense.endMask |= 1 << fullIndex;
                dense.finalShapeGatherIndices.push(fullIndex);
                dense.finalShapeGatherIndicesSparse.push(-1);
                dense.inputShapeGatherIndicesSparse[fullIndex] = i;
            }
        } else if (1 << i & sparse.newAxisMask) {
            // Only the bit that has newAxis will fall in this condition.
            dense.finalShapeGatherIndices.push($857e39e1331d3036$var$NEW_AXIS);
            dense.finalShapeGatherIndicesSparse.push(-1);
        } else {
            if (fullIndex === dense.begin.length) throw Error(`Index out of range using input dim ${fullIndex}; input ` + `has only ${dense.dims} dims, ${dense.begin.length}.`);
            // Gather slicing spec into appropriate index.
            if (sparse.begin != null) dense.begin[fullIndex] = sparse.begin[i];
            if (sparse.end != null) dense.end[fullIndex] = sparse.end[i];
            dense.strides[fullIndex] = sparse.strides[i];
            if (sparse.beginMask & 1 << i) dense.beginMask |= 1 << fullIndex;
            if (sparse.endMask & 1 << i) dense.endMask |= 1 << fullIndex;
            // If shrink, record where to get the dimensionality from (i.e. newAxis)
            // creates a fake 1 size dimension. Also remember shrink axis (now in
            // dense form) so we can ignore dense.end below.
            if (sparse.shrinkAxisMask & 1 << i) {
                dense.finalShapeGatherIndices.push($857e39e1331d3036$var$SHRINK_AXIS);
                dense.finalShapeGatherIndicesSparse.push(-1);
                dense.shrinkAxisMask |= 1 << fullIndex;
            } else {
                dense.finalShapeGatherIndices.push(fullIndex);
                // Remember that where in the sparse shape the dense dim comes from.
                dense.finalShapeGatherIndicesSparse.push(i);
            }
            dense.inputShapeGatherIndicesSparse[fullIndex] = i;
            fullIndex++;
        }
    }
}
function $857e39e1331d3036$var$canonical(x, c, strideI, dimI, masks, validRange) {
    if (masks[c]) return strideI > 0 ? validRange[c] : validRange[c + 1 & 1];
    else {
        const xFwd = x < 0 ? dimI + x : x; // make negative indices positive
        return xFwd < validRange[0] ? validRange[0] : xFwd > validRange[1] ? validRange[1] : xFwd;
    }
}

});

parcelRegister("aQHa6", function(module, exports) {

$parcel$export(module.exports, "getImageCenter", () => $7e603dca0b7d8a65$export$3c8762d0dab347aa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Returns the image center in pixels.
function $7e603dca0b7d8a65$export$3c8762d0dab347aa(center, imageHeight, imageWidth) {
    const centerX = imageWidth * (typeof center === 'number' ? center : center[0]);
    const centerY = imageHeight * (typeof center === 'number' ? center : center[1]);
    return [
        centerX,
        centerY
    ];
}

});

parcelRegister("4h3p6", function(module, exports) {

$parcel$export(module.exports, "getReshaped", () => $31cb63e85869de81$export$4a6fd6a82dc667e2);
$parcel$export(module.exports, "getPermuted", () => $31cb63e85869de81$export$4def7dccf4cfc2e9);
$parcel$export(module.exports, "getReshapedPermuted", () => $31cb63e85869de81$export$2435a8b57f99e080);
$parcel$export(module.exports, "getSliceBeginCoords", () => $31cb63e85869de81$export$b9a01540baa98f86);
$parcel$export(module.exports, "getSliceSize", () => $31cb63e85869de81$export$2457416ec9e0c8d3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Gets the new shape of the input Tensor after it's been reshaped
 * to:
 * [blockShape[0], ..., blockShape[M-1], batch / prod(blockShape),
 * inputShape[1], ..., inputShape[N-1]]
 *
 * See step 1: https://www.tensorflow.org/api_docs/python/tf/batch_to_space_nd
 */ function $31cb63e85869de81$export$4a6fd6a82dc667e2(inputShape, blockShape, prod, batchToSpace = true) {
    let reshaped = [];
    if (batchToSpace) {
        reshaped = reshaped.concat(blockShape.slice(0));
        reshaped.push(inputShape[0] / prod);
        reshaped = reshaped.concat(inputShape.slice(1));
    } else {
        reshaped = reshaped.concat(inputShape[0]);
        const spatialLength = blockShape.length;
        for(let i = 0; i < spatialLength; ++i)reshaped = reshaped.concat([
            inputShape[i + 1] / blockShape[i],
            blockShape[i]
        ]);
        reshaped = reshaped.concat(inputShape.slice(spatialLength + 1));
    }
    return reshaped;
}
function $31cb63e85869de81$export$4def7dccf4cfc2e9(reshapedRank, blockShapeRank, batchToSpace = true) {
    const permuted = [];
    if (batchToSpace) {
        permuted.push(blockShapeRank);
        for(let i = blockShapeRank + 1; i < reshapedRank; ++i)if (i <= 2 * blockShapeRank) {
            permuted.push(i);
            permuted.push(i - (blockShapeRank + 1));
        } else permuted.push(i);
    } else {
        const permutedBeforeBatch = [];
        const permutedAfterBatch = [];
        for(let i = 1; i < reshapedRank; ++i)if (i >= blockShapeRank * 2 + 1 || i % 2 === 1) permutedAfterBatch.push(i);
        else permutedBeforeBatch.push(i);
        permuted.push(...permutedBeforeBatch);
        permuted.push(0);
        permuted.push(...permutedAfterBatch);
    }
    return permuted;
}
function $31cb63e85869de81$export$2435a8b57f99e080(inputShape, blockShape, prod, batchToSpace = true) {
    const reshapedPermuted = [];
    if (batchToSpace) reshapedPermuted.push(inputShape[0] / prod);
    else reshapedPermuted.push(inputShape[0] * prod);
    for(let i = 1; i < inputShape.length; ++i)if (i <= blockShape.length) {
        if (batchToSpace) reshapedPermuted.push(blockShape[i - 1] * inputShape[i]);
        else reshapedPermuted.push(inputShape[i] / blockShape[i - 1]);
    } else reshapedPermuted.push(inputShape[i]);
    return reshapedPermuted;
}
function $31cb63e85869de81$export$b9a01540baa98f86(crops, blockShape) {
    const sliceBeginCoords = [
        0
    ];
    for(let i = 0; i < blockShape; ++i)sliceBeginCoords.push(crops[i][0]);
    return sliceBeginCoords;
}
function $31cb63e85869de81$export$2457416ec9e0c8d3(uncroppedShape, crops, blockShape) {
    const sliceSize = uncroppedShape.slice(0, 1);
    for(let i = 0; i < blockShape; ++i)sliceSize.push(uncroppedShape[i + 1] - crops[i][0] - crops[i][1]);
    return sliceSize;
}

});

parcelRegister("4EvS9", function(module, exports) {

$parcel$export(module.exports, "prepareAndValidate", () => $36339f0b093f9859$export$6bb34ea9be10068f);

var $8cCb2 = parcelRequire("8cCb2");
function $36339f0b093f9859$export$6bb34ea9be10068f(tensor, indices) {
    const tensorRank = tensor.shape.length;
    const indicesRank = indices.shape.length;
    if (tensorRank < 1) throw new Error('tf.gatherND() expects the input to be rank 1 or higher,' + ` but the rank was ${tensorRank}.`);
    if (indicesRank < 1) throw new Error('tf.gatherND() expects the indices to be rank 1 or higher,' + ` but the rank was ${indicesRank}.`);
    if (indices.dtype !== 'int32') throw new Error('tf.gatherND() expects the indices to be int32 type,' + ` but the dtype was ${indices.dtype}.`);
    if (indices.shape[indicesRank - 1] > tensorRank) throw new Error('index innermost dimension length must be <= tensor rank; saw: ' + `${indices.shape[indicesRank - 1]} vs. ${tensorRank}`);
    if ((0, $8cCb2.sizeFromShape)(tensor.shape) === 0) throw new Error('Requested more than 0 entries, but input is empty.' + ` Input shape: ${tensor.shape}.`);
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    // The result shape is
    //   indices.shape[:-1] + params.shape[indices.shape[-1]:]
    let nResult = 1;
    for(let i = 0; i < indicesShape.length - 1; ++i)nResult *= indicesShape[i];
    const inputShape = tensor.shape;
    const resultShape = indicesShape.slice();
    resultShape.pop();
    let sliceSize = 1;
    for(let i = sliceRank; i < tensorRank; ++i){
        sliceSize *= inputShape[i];
        resultShape.push(inputShape[i]);
    }
    const strides = [
        ...(0, $8cCb2.computeStrides)(tensor.shape).map((stride)=>stride / sliceSize),
        1
    ].slice(0, sliceRank);
    return [
        resultShape,
        nResult,
        sliceSize,
        strides
    ];
}

});

parcelRegister("7wQGW", function(module, exports) {

$parcel$export(module.exports, "validateUpdateShape", () => $57b46503159dbf6f$export$9d843bc97e7022ed);
$parcel$export(module.exports, "validateInput", () => $57b46503159dbf6f$export$4d09d4ac8ba225dd);
$parcel$export(module.exports, "calculateShapes", () => $57b46503159dbf6f$export$4dc1a8917bf18661);

var $8cCb2 = parcelRequire("8cCb2");
function $57b46503159dbf6f$export$9d843bc97e7022ed(shape, indices, updates) {
    const sliceDim = indices.rank > 1 ? indices.shape[indices.rank - 1] : 1;
    const batchDim = indices.rank > 1 ? indices.rank - 1 : 1;
    const shapeError = 'Must have updates.shape = indices.shape[:batchDim] + ' + `shape[sliceDim:], got updates.shape: ${updates.shape}` + `, indices.shape: ${indices.shape}, shape: ${shape}` + `, sliceDim: ${sliceDim}, and batchDim: ${batchDim}.`;
    if (updates.rank < batchDim) throw new Error(shapeError + ` update.rank < ${batchDim}. `);
    if (shape.length < sliceDim + (updates.rank - batchDim)) throw new Error(shapeError + ` Output shape length < ${sliceDim + (updates.rank - batchDim)}`);
    if (updates.rank !== batchDim + shape.length - sliceDim) throw new Error(shapeError + ` update.rank != ${batchDim + shape.length - sliceDim}`);
    for(let d = 0; d < batchDim; ++d){
        if (updates.shape[d] !== indices.shape[d]) throw new Error(shapeError + ` updates.shape[${d}] (${updates.shape[d]}) != indices.shape[${d}] (${indices.shape[d]}).`);
    }
    for(let d = 0; d < updates.rank - batchDim; ++d){
        if (updates.shape[d + batchDim] !== shape[d + sliceDim]) throw new Error(shapeError + ` updates.shape[${d + batchDim}] (${updates.shape[d + batchDim]}) != shape[${d + batchDim}] (${shape[d + batchDim]})`);
    }
}
function $57b46503159dbf6f$export$4d09d4ac8ba225dd(updates, indices, shape) {
    if (indices.rank < 1) throw new Error('tf.scatterND() expects the indices to be rank 1 or higher,' + ` but the rank was ${indices.rank}.`);
    if (updates.rank < 1) throw new Error('tf.scatterND() expects the updates to be rank 1 or higher,' + ` but the rank was ${updates.rank}.`);
    if (indices.dtype !== 'int32') throw new Error(`The dtype of 'indices' should be int32, but got dtype: ${indices.dtype}`);
    if (shape.length < 1) throw new Error(`Output rank must be greater or equal to 1, but got shape: ${shape}`);
    if (shape.length === 0) {
        if (indices.size === 0) throw new Error(`Indices specified for empty output. indices shape: ${indices.shape}`);
        if (updates.size === 0) throw new Error(`Updates specified for empty output. updates shape: ${updates.shape}`);
    }
    $57b46503159dbf6f$export$9d843bc97e7022ed(shape, indices, updates);
}
function $57b46503159dbf6f$export$4dc1a8917bf18661(updates, indices, shape) {
    // Calculate the number of dimensions in indices
    const indicesRank = indices.shape.length;
    const sliceRank = indicesRank > 1 ? indices.shape[indicesRank - 1] : 1;
    // Calculate the number of elements that make up each slice of our updated
    // tensor. This allows us to work with flattened tensors and copy over whole
    // slices at a time.
    const totalNd = shape.length;
    let sliceSize = 1;
    for(let i = sliceRank; i < totalNd; ++i)sliceSize *= shape[i];
    const safeSliceDim = sliceRank < 1 ? 1 : sliceRank;
    const numUpdates = (0, $8cCb2.sizeFromShape)(indices.shape) / safeSliceDim;
    const strides = [
        ...(0, $8cCb2.computeStrides)(shape.slice(0, sliceRank)),
        1
    ];
    const outputSize = (0, $8cCb2.sizeFromShape)(shape);
    return {
        sliceRank: sliceRank,
        numUpdates: numUpdates,
        sliceSize: sliceSize,
        strides: strides,
        outputSize: outputSize
    };
}

});

parcelRegister("eowEY", function(module, exports) {

$parcel$export(module.exports, "SELU_SCALEALPHA", () => $a7aca423016084b8$export$49dc487a025ce2d0);
$parcel$export(module.exports, "SELU_SCALE", () => $a7aca423016084b8$export$e6ebc294ea9ea7e7);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $a7aca423016084b8$export$49dc487a025ce2d0 = 1.7580993408473768599402175208123;
const $a7aca423016084b8$export$e6ebc294ea9ea7e7 = 1.0507009873554804934193349852946;

});

parcelRegister("aMsMA", function(module, exports) {

$parcel$export(module.exports, "ERF_P", () => $7d94b6b022d70fbf$export$5588b9ca3e514e43);
$parcel$export(module.exports, "ERF_A1", () => $7d94b6b022d70fbf$export$2ac384940e9cdd31);
$parcel$export(module.exports, "ERF_A2", () => $7d94b6b022d70fbf$export$db2d4485da836713);
$parcel$export(module.exports, "ERF_A3", () => $7d94b6b022d70fbf$export$644ec7b31d43803f);
$parcel$export(module.exports, "ERF_A4", () => $7d94b6b022d70fbf$export$904f8b3bbafadf78);
$parcel$export(module.exports, "ERF_A5", () => $7d94b6b022d70fbf$export$e40fe2da7629526);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $7d94b6b022d70fbf$export$5588b9ca3e514e43 = 0.3275911;
const $7d94b6b022d70fbf$export$2ac384940e9cdd31 = 0.254829592;
const $7d94b6b022d70fbf$export$db2d4485da836713 = -0.284496736;
const $7d94b6b022d70fbf$export$644ec7b31d43803f = 1.421413741;
const $7d94b6b022d70fbf$export$904f8b3bbafadf78 = -1.453152027;
const $7d94b6b022d70fbf$export$e40fe2da7629526 = 1.061405429;

});

parcelRegister("eCPD4", function(module, exports) {

$parcel$export(module.exports, "mergeRealAndImagArrays", () => $aa5ca9cb878e8d20$export$e54cb13fcd32a531);
$parcel$export(module.exports, "splitRealAndImagArrays", () => $aa5ca9cb878e8d20$export$fa0ac0984ed1da1c);
$parcel$export(module.exports, "complexWithEvenIndex", () => $aa5ca9cb878e8d20$export$270b4351d25667e0);
$parcel$export(module.exports, "complexWithOddIndex", () => $aa5ca9cb878e8d20$export$36193f08102303b4);
$parcel$export(module.exports, "getComplexWithIndex", () => $aa5ca9cb878e8d20$export$628d071452d50aaf);
$parcel$export(module.exports, "assignToTypedArray", () => $aa5ca9cb878e8d20$export$b7f57c25a82b9fba);
$parcel$export(module.exports, "exponents", () => $aa5ca9cb878e8d20$export$7d98ee6b5f9e9f08);
$parcel$export(module.exports, "exponent", () => $aa5ca9cb878e8d20$export$abde88043842a778);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Merges real and imaginary Float32Arrays into a single complex Float32Array.
 *
 * The memory layout is interleaved as follows:
 * real: [r0, r1, r2]
 * imag: [i0, i1, i2]
 * complex: [r0, i0, r1, i1, r2, i2]
 *
 * This is the inverse of splitRealAndImagArrays.
 *
 * @param real The real values of the complex tensor values.
 * @param imag The imag values of the complex tensor values.
 * @returns A complex tensor as a Float32Array with merged values.
 */ function $aa5ca9cb878e8d20$export$e54cb13fcd32a531(real, imag) {
    if (real.length !== imag.length) throw new Error(`Cannot merge real and imag arrays of different lengths. real:` + `${real.length}, imag: ${imag.length}.`);
    const result = new Float32Array(real.length * 2);
    for(let i = 0; i < result.length; i += 2){
        result[i] = real[i / 2];
        result[i + 1] = imag[i / 2];
    }
    return result;
}
function $aa5ca9cb878e8d20$export$fa0ac0984ed1da1c(complex) {
    const real = new Float32Array(complex.length / 2);
    const imag = new Float32Array(complex.length / 2);
    for(let i = 0; i < complex.length; i += 2){
        real[i / 2] = complex[i];
        imag[i / 2] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $aa5ca9cb878e8d20$export$270b4351d25667e0(complex) {
    const len = Math.ceil(complex.length / 4);
    const real = new Float32Array(len);
    const imag = new Float32Array(len);
    for(let i = 0; i < complex.length; i += 4){
        real[Math.floor(i / 4)] = complex[i];
        imag[Math.floor(i / 4)] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $aa5ca9cb878e8d20$export$36193f08102303b4(complex) {
    const len = Math.floor(complex.length / 4);
    const real = new Float32Array(len);
    const imag = new Float32Array(len);
    for(let i = 2; i < complex.length; i += 4){
        real[Math.floor(i / 4)] = complex[i];
        imag[Math.floor(i / 4)] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $aa5ca9cb878e8d20$export$628d071452d50aaf(complex, index) {
    const real = complex[index * 2];
    const imag = complex[index * 2 + 1];
    return {
        real: real,
        imag: imag
    };
}
function $aa5ca9cb878e8d20$export$b7f57c25a82b9fba(data, real, imag, index) {
    data[index * 2] = real;
    data[index * 2 + 1] = imag;
}
function $aa5ca9cb878e8d20$export$7d98ee6b5f9e9f08(n, inverse) {
    const real = new Float32Array(n / 2);
    const imag = new Float32Array(n / 2);
    for(let i = 0; i < Math.ceil(n / 2); i++){
        const x = (inverse ? 2 : -2) * Math.PI * (i / n);
        real[i] = Math.cos(x);
        imag[i] = Math.sin(x);
    }
    return {
        real: real,
        imag: imag
    };
}
function $aa5ca9cb878e8d20$export$abde88043842a778(k, n, inverse) {
    const x = (inverse ? 2 : -2) * Math.PI * (k / n);
    const real = Math.cos(x);
    const imag = Math.sin(x);
    return {
        real: real,
        imag: imag
    };
}

});

parcelRegister("izI5a", function(module, exports) {

$parcel$export(module.exports, "decodeEinsumEquation", () => $d85db0b313b0b278$export$2f615958577142db);
$parcel$export(module.exports, "getEinsumPermutation", () => $d85db0b313b0b278$export$ce55bd5175fdcdbf);
$parcel$export(module.exports, "checkEinsumDimSizes", () => $d85db0b313b0b278$export$40ac7c38e2986bbe);
$parcel$export(module.exports, "getEinsumComputePath", () => $d85db0b313b0b278$export$3f6835c0d48b762d);
$parcel$export(module.exports, "isIdentityPermutation", () => $d85db0b313b0b278$export$6a8a32f5fc3d978e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
const $d85db0b313b0b278$var$ARROW = '->';
const $d85db0b313b0b278$var$ARROW_REGEX = /->/g;
const $d85db0b313b0b278$var$COMMA = ',';
const $d85db0b313b0b278$var$ELLIPSIS = '...';
function $d85db0b313b0b278$export$2f615958577142db(equation, numTensors) {
    equation = equation.replace(/\s/g, ''); // Remove witespace in equation.
    const numArrows = (equation.length - equation.replace($d85db0b313b0b278$var$ARROW_REGEX, '').length) / $d85db0b313b0b278$var$ARROW.length;
    if (numArrows < 1) throw new Error('Equations without an arrow are not supported.');
    else if (numArrows > 1) throw new Error(`Equation must contain exactly one arrow ("${$d85db0b313b0b278$var$ARROW}").`);
    const [inputString, outputString] = equation.split($d85db0b313b0b278$var$ARROW);
    (0, $8cCb2.assert)(inputString.indexOf($d85db0b313b0b278$var$ELLIPSIS) === -1, ()=>`The ellipsis notation ("${$d85db0b313b0b278$var$ELLIPSIS}") is not supported yet.`);
    const inputTerms = inputString.split($d85db0b313b0b278$var$COMMA);
    const numInputs = inputTerms.length;
    if (numTensors !== numInputs) throw new Error(`Expected ${numInputs} input tensors, received ${numTensors}`);
    if (numInputs > 2) throw new Error('Support for more than 2 input tensors is not implemented yet.');
    const allDims = [];
    for(let i = 0; i < outputString.length; ++i){
        const dimName = outputString[i];
        if (!inputTerms.some((inputTerm)=>inputTerm.indexOf(dimName) !== -1)) throw new Error(`Output subscripts contain the label ${dimName} ` + `not present in the input subscripts.`);
        if (allDims.indexOf(dimName) === -1) allDims.push(dimName);
    }
    for(let i = 0; i < inputString.length; ++i){
        const dimName = inputString[i];
        if (allDims.indexOf(dimName) === -1 && dimName !== $d85db0b313b0b278$var$COMMA) allDims.push(dimName);
    }
    const idDims = new Array(inputTerms.length);
    for(let i = 0; i < numInputs; ++i){
        if (new Set(inputTerms[i].split('')).size !== inputTerms[i].length) throw new Error(`Found duplicate axes in input component ${inputTerms[i]}. ` + `Support for duplicate axes in input is not implemented yet.`);
        idDims[i] = [];
        for(let j = 0; j < inputTerms[i].length; ++j)idDims[i].push(allDims.indexOf(inputTerms[i][j]));
    }
    const numDims = allDims.length; // Number of unique dimensions.
    const numOutDims = outputString.length; // Number of output dimensions.
    const summedDims = []; // Dimensions being summed over.
    for(let i = numOutDims; i < numDims; ++i)summedDims.push(i);
    return {
        allDims: allDims,
        summedDims: summedDims,
        idDims: idDims
    };
}
function $d85db0b313b0b278$export$ce55bd5175fdcdbf(nDims, idDims) {
    let permutationIndices = new Array(nDims);
    permutationIndices.fill(-1);
    for(let i = 0; i < idDims.length; ++i)permutationIndices[idDims[i]] = i;
    const expandDims = [];
    for(let i = 0; i < nDims; ++i)if (permutationIndices[i] === -1) expandDims.push(i);
    permutationIndices = permutationIndices.filter((d)=>d !== -1);
    return {
        permutationIndices: permutationIndices,
        expandDims: expandDims
    };
}
function $d85db0b313b0b278$export$40ac7c38e2986bbe(nDims, idDims, tensors) {
    const dimSizes = new Array(nDims);
    for(let i = 0; i < tensors.length; ++i){
        const shape = tensors[i].shape;
        for(let j = 0; j < idDims[i].length; ++j)if (dimSizes[idDims[i][j]] === undefined) dimSizes[idDims[i][j]] = shape[j];
        else (0, $8cCb2.assert)(dimSizes[idDims[i][j]] === shape[j], ()=>`Expected dimension ${dimSizes[idDims[i][j]]} at axis ${j} ` + `of input shaped ${JSON.stringify(shape)}, ` + `but got dimension ${shape[j]}`);
    }
}
function $d85db0b313b0b278$export$3f6835c0d48b762d(summedDims, idDims) {
    const path = summedDims;
    const steps = [];
    let nSteps = 0;
    if (summedDims.length === 0) // Einsum that involes no summing: e.g., transpose and outer product.
    path.push(-1);
    nSteps = summedDims.length + 1;
    for(let i = 0; i < nSteps; ++i)steps.push([]);
    const computedTermIndices = [];
    for(let i = 0; i < path.length; ++i){
        const summedDim = path[i];
        const termIndices = $d85db0b313b0b278$var$findTermsWithDim(idDims, summedDim);
        for (const termIndex of termIndices)if (computedTermIndices.indexOf(termIndex) === -1) {
            steps[i].push(termIndex);
            computedTermIndices.push(termIndex);
        }
    }
    return {
        path: path,
        steps: steps
    };
}
function $d85db0b313b0b278$export$6a8a32f5fc3d978e(perm) {
    return perm.every((dim, index)=>dim === index);
}
function $d85db0b313b0b278$var$findTermsWithDim(idDims, dim) {
    const termIndices = [];
    for(let i = 0; i < idDims.length; ++i)if (idDims[i].length === 0 || idDims[i].indexOf(dim) !== -1 || dim === -1) termIndices.push(i);
    return termIndices;
}

});

parcelRegister("4pqBf", function(module, exports) {

$parcel$export(module.exports, "prepareSplitSize", () => $335e215ffeab62fb$export$b45a3b30df9d4b49);

var $8cCb2 = parcelRequire("8cCb2");
function $335e215ffeab62fb$export$b45a3b30df9d4b49(x, numOrSizeSplits, axis = 0) {
    let splitSizes = [];
    if (typeof numOrSizeSplits === 'number') {
        (0, $8cCb2.assert)(x.shape[axis] % numOrSizeSplits === 0, ()=>'Number of splits must evenly divide the axis.');
        splitSizes = new Array(numOrSizeSplits).fill(x.shape[axis] / numOrSizeSplits);
    } else {
        const numOfNegs = numOrSizeSplits.reduce((count, value)=>{
            if (value === -1) count += 1;
            return count;
        }, 0);
        (0, $8cCb2.assert)(numOfNegs <= 1, ()=>'There should be only one negative value in split array.');
        const negIndex = numOrSizeSplits.indexOf(-1);
        // Allow the number of split array to be -1, which indicates the rest
        // of dimension is allocated to that split.
        if (negIndex !== -1) {
            const total = numOrSizeSplits.reduce((a, b)=>b > 0 ? a + b : a);
            numOrSizeSplits[negIndex] = x.shape[axis] - total;
        }
        (0, $8cCb2.assert)(x.shape[axis] === numOrSizeSplits.reduce((a, b)=>a + b), ()=>'The sum of sizes must match the size of the axis dimension.');
        splitSizes = numOrSizeSplits;
    }
    return splitSizes;
}

});

parcelRegister("5NPez", function(module, exports) {

$parcel$export(module.exports, "getSparseFillEmptyRowsIndicesDenseShapeMismatch", () => $4399455c72817f69$export$afc2f2dec50723b1);
$parcel$export(module.exports, "getSparseFillEmptyRowsNegativeIndexErrorMessage", () => $4399455c72817f69$export$69038529bd45dbce);
$parcel$export(module.exports, "getSparseFillEmptyRowsOutOfRangeIndexErrorMessage", () => $4399455c72817f69$export$4179b115ac384c01);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Generates sparse fill empty rows indices, dense shape mismatch error message.
 *
 * @param indicesLength The first dimension of indices.
 */ function $4399455c72817f69$export$afc2f2dec50723b1(indicesLength) {
    return `Received SparseTensor with denseShape[0] = 0 but
  indices.shape[0] = ${indicesLength}`;
}
function $4399455c72817f69$export$69038529bd45dbce(index, value) {
    return `indices(${index}, 0) is invalid: ${value} < 0`;
}
function $4399455c72817f69$export$4179b115ac384c01(index, value, limit) {
    return `indices(${index}, 0) is invalid: ${value} >= ${limit}`;
}

});

parcelRegister("2A2jF", function(module, exports) {

$parcel$export(module.exports, "getSparseReshapeMultipleNegativeOneOutputDimErrorMessage", () => $1e10bd84af2e2307$export$22b04105649d1e3d);
$parcel$export(module.exports, "getSparseReshapeNegativeOutputDimErrorMessage", () => $1e10bd84af2e2307$export$3350ee0ca4641eae);
$parcel$export(module.exports, "getSparseReshapeEmptyTensorZeroOutputDimErrorMessage", () => $1e10bd84af2e2307$export$632a7731cfb4dc4b);
$parcel$export(module.exports, "getSparseReshapeInputOutputMultipleErrorMessage", () => $1e10bd84af2e2307$export$6996eb40ec18f24);
$parcel$export(module.exports, "getSparseReshapeInputOutputMismatchErrorMessage", () => $1e10bd84af2e2307$export$7c74c1672e7ca2d1);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
function $1e10bd84af2e2307$export$22b04105649d1e3d(dim1, dim2) {
    return `only one output dimension may be -1, not both ${dim1} and ${dim2}`;
}
function $1e10bd84af2e2307$export$3350ee0ca4641eae(dim, value) {
    return `size ${dim} must be non-negative, not ${value}`;
}
function $1e10bd84af2e2307$export$632a7731cfb4dc4b() {
    return "reshape cannot infer the missing input size for an empty tensor unless all specified input sizes are non-zero";
}
function $1e10bd84af2e2307$export$6996eb40ec18f24(inputShape, outputShape) {
    const inputSize = (0, $8cCb2.sizeFromShape)(inputShape);
    const outputSize = (0, $8cCb2.sizeFromShape)(outputShape);
    return `Input to reshape is a SparseTensor with ${inputSize}
  dense values, but the requested shape requires a multiple of ${outputSize}. inputShape=${inputShape} outputShape= ${outputShape}`;
}
function $1e10bd84af2e2307$export$7c74c1672e7ca2d1(inputShape, outputShape) {
    const inputSize = (0, $8cCb2.sizeFromShape)(inputShape);
    const outputSize = (0, $8cCb2.sizeFromShape)(outputShape);
    return `Input to reshape is a tensor with ${inputSize} dense values, but the requested shape has ${outputSize}. inputShape=${inputShape} outputShape=${outputShape}`;
}

});

parcelRegister("6bLmC", function(module, exports) {

$parcel$export(module.exports, "getSparseSegmentReductionNegativeSegmentIdsErrorMessage", () => $4818829ad25e3220$export$cb1b83ffdf66736);
$parcel$export(module.exports, "getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage", () => $4818829ad25e3220$export$6f5af72ace1661e1);
$parcel$export(module.exports, "getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage", () => $4818829ad25e3220$export$bdc282d2ae15e823);
$parcel$export(module.exports, "getSparseSegmentReductionIndicesOutOfRangeErrorMessage", () => $4818829ad25e3220$export$c470f477911f1cb7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Generates sparse segment reduction negative segment ids error message.
 *
 */ function $4818829ad25e3220$export$cb1b83ffdf66736() {
    return `segment ids must be >= 0`;
}
function $4818829ad25e3220$export$6f5af72ace1661e1() {
    return `segment ids are not increasing`;
}
function $4818829ad25e3220$export$bdc282d2ae15e823(segmentId, outputRows) {
    return `Segment id ${segmentId} out of range [0, ${outputRows}), possibly because segmentIds input is not sorted.`;
}
function $4818829ad25e3220$export$c470f477911f1cb7(index, indexValue, inputRows) {
    return `Bad: indices[${index}] == ${indexValue} out of range [0, ${inputRows})`;
}

});

parcelRegister("fHbAS", function(module, exports) {

$parcel$export(module.exports, "segOpComputeOptimalWindowSize", () => $b6d3dd7a4e14edca$export$6ef0c7b128709ff);
$parcel$export(module.exports, "computeOutShape", () => $b6d3dd7a4e14edca$export$22fa6b3b1305508e);
$parcel$export(module.exports, "collectGatherOpShapeInfo", () => $b6d3dd7a4e14edca$export$fa9ad97afacf8191);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");

var $4ldJF = parcelRequire("4ldJF");
function $b6d3dd7a4e14edca$export$6ef0c7b128709ff(inSize, numSegments) {
    let done = false;
    let res;
    if (inSize <= (0, $4ldJF.PARALLELIZE_THRESHOLD)) {
        res = inSize;
        done = true;
    } else res = (0, $8cCb2.nearestDivisor)(inSize, Math.floor(Math.sqrt(inSize)));
    while(!done)if (res > numSegments || res === inSize) done = true;
    else res = (0, $8cCb2.nearestDivisor)(inSize, res + 1);
    return res;
}
function $b6d3dd7a4e14edca$export$22fa6b3b1305508e(aShape, axis, numSegments) {
    const outShape = [];
    const rank = aShape.length;
    for(let dim = 0; dim < rank; dim++)if (dim !== axis) outShape.push(aShape[dim]);
    else outShape.push(numSegments);
    return outShape;
}
function $b6d3dd7a4e14edca$export$fa9ad97afacf8191(x, indices, axis, batchDims) {
    const indicesRank = indices.shape.length;
    const xRank = x.shape.length;
    if (batchDims !== 0) {
        if (batchDims < -indicesRank || batchDims > indicesRank) throw new Error(`Expect batchDims in the range of [-${indicesRank}, ${indicesRank}], but got ${batchDims}`);
    }
    if (batchDims < 0) batchDims += indicesRank;
    if (batchDims > xRank) throw new Error(`batchDims (${batchDims}) must be less than rank(x) (
    ${xRank}).`);
    if (axis < batchDims) throw new Error(`batchDims (${batchDims}) must be less than or equal to axis (${axis}).`);
    for(let i = 0; i < batchDims; ++i){
        if (x.shape[i] !== indices.shape[i]) throw new Error(`x.shape[${i}]: ${x.shape[i]} should be equal to indices.shape[${i}]: ${indices.shape[i]}.`);
    }
    const dimSize = x.shape[axis];
    const outputShape = [];
    let batchSize = 1;
    let outerSize = 1;
    let sliceSize = 1;
    for(let i = 0; i < batchDims; ++i){
        outputShape.push(x.shape[i]);
        batchSize *= x.shape[i];
    }
    for(let i = batchDims; i < axis; i++){
        outputShape.push(x.shape[i]);
        outerSize *= x.shape[i];
    }
    for(let i = batchDims; i < indicesRank; i++)outputShape.push(indices.shape[i]);
    for(let i = axis + 1; i < xRank; i++){
        outputShape.push(x.shape[i]);
        sliceSize *= x.shape[i];
    }
    return {
        batchSize: batchSize,
        sliceSize: sliceSize,
        outerSize: outerSize,
        dimSize: dimSize,
        outputShape: outputShape
    };
}

});


parcelRegister("kKS8R", function(module, exports) {

$parcel$export(module.exports, "batchNorm2d", () => $f1c219fe7a1e385d$export$4104d1fc5afa918a);

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $5ULLz = parcelRequire("5ULLz");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Batch normalization, strictly for 2D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $f1c219fe7a1e385d$var$batchNorm2d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $5xBLk.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $5xBLk.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $5xBLk.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $5xBLk.convertToTensor)(offset, 'offset', 'batchNorm');
    $8cCb2.assert($x.rank === 2, ()=>`Error in batchNorm2D: x must be rank 2 but got rank ` + `${$x.rank}.`);
    $8cCb2.assert($mean.rank === 2 || $mean.rank === 1, ()=>`Error in batchNorm2D: mean must be rank 2 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $8cCb2.assert($variance.rank === 2 || $variance.rank === 1, ()=>`Error in batchNorm2D: variance must be rank 2 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $8cCb2.assert($scale.rank === 2 || $scale.rank === 1, ()=>`Error in batchNorm2D: scale must be rank 2 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $8cCb2.assert($offset.rank === 2 || $offset.rank === 1, ()=>`Error in batchNorm2D: offset must be rank 2 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $5ULLz.batchNorm)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $f1c219fe7a1e385d$export$4104d1fc5afa918a = /* @__PURE__ */ (0, $jqSCG.op)({
    batchNorm2d_: $f1c219fe7a1e385d$var$batchNorm2d_
});

});
parcelRegister("5ULLz", function(module, exports) {

$parcel$export(module.exports, "batchNorm", () => $44e73c16120369ac$export$8ea8088e6d0cdd02);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $1EYew = parcelRequire("1EYew");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Batch normalization.
 *
 * As described in
 * [http://arxiv.org/abs/1502.03167](http://arxiv.org/abs/1502.03167).
 *
 * Mean, variance, scale, and offset can be of two shapes:
 *   - The same shape as the input.
 *   - In the common case, the depth dimension is the last dimension of x, so
 *     the values would be a `tf.Tensor1D` of shape [depth].
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that parameters passed are of given rank
 *   - `tf.batchNorm2d`
 *   - `tf.batchNorm3d`
 *   - `tf.batchNorm4d`
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $44e73c16120369ac$var$batchNorm_(x, mean, variance, offset, scale, varianceEpsilon) {
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $5xBLk.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $5xBLk.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $5xBLk.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $5xBLk.convertToTensor)(offset, 'offset', 'batchNorm');
    $8cCb2.assert($mean.rank === $variance.rank, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    $8cCb2.assert($offset == null || $mean.rank === $offset.rank, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    $8cCb2.assert($scale == null || $mean.rank === $scale.rank, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    const x4D = (0, $1EYew.xAs4D)($x);
    const inputs = {
        x: x4D,
        scale: $scale,
        offset: $offset,
        mean: $mean,
        variance: $variance
    };
    const attrs = {
        varianceEpsilon: varianceEpsilon
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.FusedBatchNorm), inputs, attrs);
    return (0, $4sqA7.reshape)(res, $x.shape);
}
const $44e73c16120369ac$export$8ea8088e6d0cdd02 = /* @__PURE__ */ (0, $jqSCG.op)({
    batchNorm_: $44e73c16120369ac$var$batchNorm_
});

});
parcelRegister("1EYew", function(module, exports) {

$parcel$export(module.exports, "xAs4D", () => $13583fec5b92f414$export$b76c765a8a7b5836);

var $4sqA7 = parcelRequire("4sqA7");
function $13583fec5b92f414$export$b76c765a8a7b5836(x) {
    let x4D;
    if (x.rank === 0 || x.rank === 1) x4D = (0, $4sqA7.reshape)(x, [
        1,
        1,
        1,
        x.size
    ]);
    else if (x.rank === 2) x4D = (0, $4sqA7.reshape)(x, [
        1,
        1,
        x.shape[0],
        x.shape[1]
    ]);
    else if (x.rank === 3) x4D = (0, $4sqA7.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    else x4D = x;
    return x4D;
}

});



parcelRegister("3KWPF", function(module, exports) {

$parcel$export(module.exports, "batchNorm3d", () => $2bc34dd5a70650fd$export$76211212fb57f1fa);

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $5ULLz = parcelRequire("5ULLz");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Batch normalization, strictly for 3D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $2bc34dd5a70650fd$var$batchNorm3d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $5xBLk.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $5xBLk.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $5xBLk.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $5xBLk.convertToTensor)(offset, 'offset', 'batchNorm');
    $8cCb2.assert($x.rank === 3, ()=>`Error in batchNorm3D: x must be rank 3 but got rank ` + `${$x.rank}.`);
    $8cCb2.assert($mean.rank === 3 || $mean.rank === 1, ()=>`Error in batchNorm3D: mean must be rank 3 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $8cCb2.assert($variance.rank === 3 || $variance.rank === 1, ()=>`Error in batchNorm3D: variance must be rank 3 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $8cCb2.assert($scale.rank === 3 || $scale.rank === 1, ()=>`Error in batchNorm3D: scale must be rank 3 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $8cCb2.assert($offset.rank === 3 || $offset.rank === 1, ()=>`Error in batchNorm3D: offset must be rank 3 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $5ULLz.batchNorm)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $2bc34dd5a70650fd$export$76211212fb57f1fa = /* @__PURE__ */ (0, $jqSCG.op)({
    batchNorm3d_: $2bc34dd5a70650fd$var$batchNorm3d_
});

});

parcelRegister("34sL5", function(module, exports) {

$parcel$export(module.exports, "batchNorm4d", () => $23c80da7bb92eb50$export$4573a348ef14e569);

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $5ULLz = parcelRequire("5ULLz");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Batch normalization, strictly for 4D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $23c80da7bb92eb50$var$batchNorm4d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $5xBLk.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $5xBLk.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $5xBLk.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $5xBLk.convertToTensor)(offset, 'offset', 'batchNorm');
    $8cCb2.assert($x.rank === 4, ()=>`Error in batchNorm4D: x must be rank 4 but got rank ` + `${$x.rank}.`);
    $8cCb2.assert($mean.rank === 4 || $mean.rank === 1, ()=>`Error in batchNorm4D: mean must be rank 4 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $8cCb2.assert($variance.rank === 4 || $variance.rank === 1, ()=>`Error in batchNorm4D: variance must be rank 4 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $8cCb2.assert($scale.rank === 4 || $scale.rank === 1, ()=>`Error in batchNorm4D: scale must be rank 4 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $8cCb2.assert($offset.rank === 4 || $offset.rank === 1, ()=>`Error in batchNorm4D: offset must be rank 4 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $5ULLz.batchNorm)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $23c80da7bb92eb50$export$4573a348ef14e569 = /* @__PURE__ */ (0, $jqSCG.op)({
    batchNorm4d_: $23c80da7bb92eb50$var$batchNorm4d_
});

});

parcelRegister("aeB3Z", function(module, exports) {

$parcel$export(module.exports, "broadcastTo", () => $7737f62f876bfd57$export$ec9086aff2624eab);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $5TuCW = parcelRequire("5TuCW");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Broadcast an array to a compatible shape NumPy-style.
 *
 * The tensor's shape is compared to the broadcast shape from end to beginning.
 * Ones are prepended to the tensor's shape until it has the same length as
 * the broadcast shape. If input.shape[i]==shape[i], the (i+1)-th axis is
 * already broadcast-compatible. If input.shape[i]==1 and shape[i]==N, then
 * the input tensor is tiled N times along that axis (using tf.tile).
 *
 * @param input The tensor that is to be broadcasted.
 * @param shape The input is to be broadcast to this shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $7737f62f876bfd57$var$broadcastTo_(x, shape) {
    let input = (0, $5xBLk.convertToTensor)(x, 'broadcastTo', 'x');
    const xShape = input.shape;
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
    if (shape.length < input.rank) throw new Error(`broadcastTo(): shape.length=${shape.length} < input.rank=${input.rank}.`);
    if (shape.length > input.rank) {
        const newShape = input.shape.slice();
        while(newShape.length < shape.length)newShape.unshift(1);
        input = (0, $4sqA7.reshape)(input, newShape);
    }
    const inputShape = input.shape;
    const reps = Array.from(shape);
    for(let i = shape.length - 1; i >= 0; i--){
        if (inputShape[i] === shape[i]) reps[i] = 1;
        else if (input.shape[i] !== 1) throw new Error(`broadcastTo(): [${xShape}] cannot be broadcast to [${shape}].`);
    }
    const axes = reps.map((n, i)=>n > 1 ? i : -1).filter((i)=>i >= 0);
    if (axes.length === 0) return (0, $5TuCW.clone)(input);
    // TODO call broadcastTo kernel directly once backends implement broadcstTo
    const inputs = {
        x: input
    };
    const attrs = {
        reps: reps
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Tile), inputs, attrs);
}
const $7737f62f876bfd57$export$ec9086aff2624eab = /* @__PURE__ */ (0, $jqSCG.op)({
    broadcastTo_: $7737f62f876bfd57$var$broadcastTo_
});

});

parcelRegister("cpgue", function(module, exports) {

$parcel$export(module.exports, "fromPixelsAsync", () => $90849bbe88a0108e$export$6b17f27238fa6bff);
$parcel$export(module.exports, "toPixels", () => $90849bbe88a0108e$export$89b6cc959998e12e);
$parcel$export(module.exports, "draw", () => $90849bbe88a0108e$export$e529deb2bfd496dc);
$parcel$export(module.exports, "fromPixels", () => $90849bbe88a0108e$export$5a3bc84b10e77d32);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $ibsdL = parcelRequire("ibsdL");

var $hl418 = parcelRequire("hl418");

var $eky5o = parcelRequire("eky5o");

var $9jCh7 = parcelRequire("9jCh7");

var $5xBLk = parcelRequire("5xBLk");

var $inFmq = parcelRequire("inFmq");

var $jqSCG = parcelRequire("jqSCG");

var $6Fl9Q = parcelRequire("6Fl9Q");
let $90849bbe88a0108e$var$fromPixels2DContext;
let $90849bbe88a0108e$var$hasToPixelsWarned = false;
/**
 * Creates a `tf.Tensor` from an image.
 *
 * ```js
 * const image = new ImageData(1, 1);
 * image.data[0] = 100;
 * image.data[1] = 150;
 * image.data[2] = 200;
 * image.data[3] = 255;
 *
 * tf.browser.fromPixels(image).print();
 * ```
 *
 * @param pixels The input image to construct the tensor from. The
 * supported image types are all 4-channel. You can also pass in an image
 * object with following attributes:
 * `{data: Uint8Array; width: number; height: number}`
 * @param numChannels The number of channels of the output tensor. A
 * numChannels value less than 4 allows you to ignore channels. Defaults to
 * 3 (ignores alpha channel of input image).
 *
 * @returns A Tensor3D with the shape `[height, width, numChannels]`.
 *
 * Note: fromPixels can be lossy in some cases, same image may result in
 * slightly different tensor values, if rendered by different rendering
 * engines. This means that results from different browsers, or even same
 * browser with CPU and GPU rendering engines can be different. See discussion
 * in details:
 * https://github.com/tensorflow/tfjs/issues/5482
 *
 * @doc {heading: 'Browser', namespace: 'browser', ignoreCI: true}
 */ function $90849bbe88a0108e$var$fromPixels_(pixels, numChannels = 3) {
    // Sanity checks.
    if (numChannels > 4) throw new Error('Cannot construct Tensor with more than 4 channels from pixels.');
    if (pixels == null) throw new Error('pixels passed to tf.browser.fromPixels() can not be null');
    let isPixelData = false;
    let isImageData = false;
    let isVideo = false;
    let isImage = false;
    let isCanvasLike = false;
    let isImageBitmap = false;
    if (pixels.data instanceof Uint8Array) isPixelData = true;
    else if (typeof ImageData !== 'undefined' && pixels instanceof ImageData) isImageData = true;
    else if (typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement) isVideo = true;
    else if (typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement) isImage = true;
    else if (pixels.getContext != null) isCanvasLike = true;
    else if (typeof ImageBitmap !== 'undefined' && pixels instanceof ImageBitmap) isImageBitmap = true;
    else throw new Error('pixels passed to tf.browser.fromPixels() must be either an ' + `HTMLVideoElement, HTMLImageElement, HTMLCanvasElement, ImageData ` + `in browser, or OffscreenCanvas, ImageData in webworker` + ` or {data: Uint32Array, width: number, height: number}, ` + `but was ${pixels.constructor.name}`);
    // If the current backend has 'FromPixels' registered, it has a more
    // efficient way of handling pixel uploads, so we call that.
    const kernel = (0, $eky5o.getKernel)((0, $hl418.FromPixels), (0, $38WwN.ENGINE).backendName);
    if (kernel != null) {
        const inputs = {
            pixels: pixels
        };
        const attrs = {
            numChannels: numChannels
        };
        return (0, $38WwN.ENGINE).runKernel((0, $hl418.FromPixels), inputs, attrs);
    }
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    let vals;
    if (isCanvasLike) vals = // tslint:disable-next-line:no-any
    pixels.getContext('2d').getImageData(0, 0, width, height).data;
    else if (isImageData || isPixelData) vals = pixels.data;
    else if (isImage || isVideo || isImageBitmap) {
        if ($90849bbe88a0108e$var$fromPixels2DContext == null) {
            if (typeof document === 'undefined') {
                if (typeof OffscreenCanvas !== 'undefined' && typeof OffscreenCanvasRenderingContext2D !== 'undefined') // @ts-ignore
                $90849bbe88a0108e$var$fromPixels2DContext = new OffscreenCanvas(1, 1).getContext('2d');
                else throw new Error("Cannot parse input in current context. Reason: OffscreenCanvas Context2D rendering is not supported.");
            } else $90849bbe88a0108e$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                willReadFrequently: true
            });
        }
        $90849bbe88a0108e$var$fromPixels2DContext.canvas.width = width;
        $90849bbe88a0108e$var$fromPixels2DContext.canvas.height = height;
        $90849bbe88a0108e$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
        vals = $90849bbe88a0108e$var$fromPixels2DContext.getImageData(0, 0, width, height).data;
    }
    let values;
    if (numChannels === 4) values = new Int32Array(vals);
    else {
        const numPixels = width * height;
        values = new Int32Array(numPixels * numChannels);
        for(let i = 0; i < numPixels; i++)for(let channel = 0; channel < numChannels; ++channel)values[i * numChannels + channel] = vals[i * 4 + channel];
    }
    const outShape = [
        height,
        width,
        numChannels
    ];
    return (0, $6Fl9Q.tensor3d)(values, outShape, 'int32');
}
// Helper functions for |fromPixelsAsync| to check whether the input can
// be wrapped into imageBitmap.
function $90849bbe88a0108e$var$isPixelData(pixels) {
    return pixels != null && pixels.data instanceof Uint8Array;
}
function $90849bbe88a0108e$var$isImageBitmapFullySupported() {
    return typeof window !== 'undefined' && typeof ImageBitmap !== 'undefined' && window.hasOwnProperty('createImageBitmap');
}
function $90849bbe88a0108e$var$isNonEmptyPixels(pixels) {
    return pixels != null && pixels.width !== 0 && pixels.height !== 0;
}
function $90849bbe88a0108e$var$canWrapPixelsToImageBitmap(pixels) {
    return $90849bbe88a0108e$var$isImageBitmapFullySupported() && !(pixels instanceof ImageBitmap) && $90849bbe88a0108e$var$isNonEmptyPixels(pixels) && !$90849bbe88a0108e$var$isPixelData(pixels);
}
async function $90849bbe88a0108e$export$6b17f27238fa6bff(pixels, numChannels = 3) {
    let inputs = null;
    // Check whether the backend needs to wrap |pixels| to imageBitmap and
    // whether |pixels| can be wrapped to imageBitmap.
    if ((0, $ibsdL.env)().getBool('WRAP_TO_IMAGEBITMAP') && $90849bbe88a0108e$var$canWrapPixelsToImageBitmap(pixels)) {
        // Force the imageBitmap creation to not do any premultiply alpha
        // ops.
        let imageBitmap;
        try {
            // wrap in try-catch block, because createImageBitmap may not work
            // properly in some browsers, e.g.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1335594
            // tslint:disable-next-line: no-any
            imageBitmap = await createImageBitmap(pixels, {
                premultiplyAlpha: 'none'
            });
        } catch (e) {
            imageBitmap = null;
        }
        // createImageBitmap will clip the source size.
        // In some cases, the input will have larger size than its content.
        // E.g. new Image(10, 10) but with 1 x 1 content. Using
        // createImageBitmap will clip the size from 10 x 10 to 1 x 1, which
        // is not correct. We should avoid wrapping such resouce to
        // imageBitmap.
        if (imageBitmap != null && imageBitmap.width === pixels.width && imageBitmap.height === pixels.height) inputs = imageBitmap;
        else inputs = pixels;
    } else inputs = pixels;
    return $90849bbe88a0108e$var$fromPixels_(inputs, numChannels);
}
function $90849bbe88a0108e$var$validateImgTensor(img) {
    if (img.rank !== 2 && img.rank !== 3) throw new Error(`toPixels only supports rank 2 or 3 tensors, got rank ${img.rank}.`);
    const depth = img.rank === 2 ? 1 : img.shape[2];
    if (depth > 4 || depth === 2) throw new Error(`toPixels only supports depth of size ` + `1, 3 or 4 but got ${depth}`);
    if (img.dtype !== 'float32' && img.dtype !== 'int32') throw new Error(`Unsupported type for toPixels: ${img.dtype}.` + ` Please use float32 or int32 tensors.`);
}
function $90849bbe88a0108e$var$validateImageOptions(imageOptions) {
    const alpha = (imageOptions === null || imageOptions === void 0 ? void 0 : imageOptions.alpha) || 1;
    if (alpha > 1 || alpha < 0) throw new Error(`Alpha value ${alpha} is suppoed to be in range [0 - 1].`);
}
async function $90849bbe88a0108e$export$89b6cc959998e12e(img, canvas) {
    let $img = (0, $5xBLk.convertToTensor)(img, 'img', 'toPixels');
    if (!(img instanceof (0, $9jCh7.Tensor))) {
        // Assume int32 if user passed a native array.
        const originalImgTensor = $img;
        $img = (0, $inFmq.cast)(originalImgTensor, 'int32');
        originalImgTensor.dispose();
    }
    $90849bbe88a0108e$var$validateImgTensor($img);
    const [height, width] = $img.shape.slice(0, 2);
    const depth = $img.rank === 2 ? 1 : $img.shape[2];
    const data = await $img.data();
    const multiplier = $img.dtype === 'float32' ? 255 : 1;
    const bytes = new Uint8ClampedArray(width * height * 4);
    for(let i = 0; i < height * width; ++i){
        const rgba = [
            0,
            0,
            0,
            255
        ];
        for(let d = 0; d < depth; d++){
            const value = data[i * depth + d];
            if ($img.dtype === 'float32') {
                if (value < 0 || value > 1) throw new Error(`Tensor values for a float32 Tensor must be in the ` + `range [0 - 1] but encountered ${value}.`);
            } else if ($img.dtype === 'int32') {
                if (value < 0 || value > 255) throw new Error(`Tensor values for a int32 Tensor must be in the ` + `range [0 - 255] but encountered ${value}.`);
            }
            if (depth === 1) {
                rgba[0] = value * multiplier;
                rgba[1] = value * multiplier;
                rgba[2] = value * multiplier;
            } else rgba[d] = value * multiplier;
        }
        const j = i * 4;
        bytes[j + 0] = Math.round(rgba[0]);
        bytes[j + 1] = Math.round(rgba[1]);
        bytes[j + 2] = Math.round(rgba[2]);
        bytes[j + 3] = Math.round(rgba[3]);
    }
    if (canvas != null) {
        if (!$90849bbe88a0108e$var$hasToPixelsWarned) {
            const kernel = (0, $eky5o.getKernel)((0, $hl418.Draw), (0, $38WwN.ENGINE).backendName);
            if (kernel != null) {
                console.warn("tf.browser.toPixels is not efficient to draw tensor on canvas. Please try tf.browser.draw instead.");
                $90849bbe88a0108e$var$hasToPixelsWarned = true;
            }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        const imageData = new ImageData(bytes, width, height);
        ctx.putImageData(imageData, 0, 0);
    }
    if ($img !== img) $img.dispose();
    return bytes;
}
function $90849bbe88a0108e$export$e529deb2bfd496dc(image, canvas, options) {
    let $img = (0, $5xBLk.convertToTensor)(image, 'img', 'draw');
    if (!(image instanceof (0, $9jCh7.Tensor))) {
        // Assume int32 if user passed a native array.
        const originalImgTensor = $img;
        $img = (0, $inFmq.cast)(originalImgTensor, 'int32');
        originalImgTensor.dispose();
    }
    $90849bbe88a0108e$var$validateImgTensor($img);
    $90849bbe88a0108e$var$validateImageOptions(options === null || options === void 0 ? void 0 : options.imageOptions);
    const inputs = {
        image: $img
    };
    const attrs = {
        canvas: canvas,
        options: options
    };
    (0, $38WwN.ENGINE).runKernel((0, $hl418.Draw), inputs, attrs);
}
const $90849bbe88a0108e$export$5a3bc84b10e77d32 = /* @__PURE__ */ (0, $jqSCG.op)({
    fromPixels_: $90849bbe88a0108e$var$fromPixels_
});

});
parcelRegister("6Fl9Q", function(module, exports) {

$parcel$export(module.exports, "tensor3d", () => $4da6fbe2266e5502$export$aa36a9de53c6d912);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $dKr4X = parcelRequire("dKr4X");
function $4da6fbe2266e5502$export$aa36a9de53c6d912(values, shape, dtype) {
    (0, $8cCb2.assertNonNull)(values);
    if (shape != null && shape.length !== 3) throw new Error('tensor3d() requires shape to have three numbers');
    const inferredShape = (0, $5xBLk.inferShape)(values, dtype);
    if (inferredShape.length !== 3 && inferredShape.length !== 1) throw new Error('tensor3d() requires values to be number[][][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");
    return (0, $dKr4X.makeTensor)(values, shape, inferredShape, dtype);
}

});


parcelRegister("cOWuO", function(module, exports) {

$parcel$export(module.exports, "clipByValue", () => $9557879f1a67b9dc$export$fa97baf70ad024c0);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $gYive = parcelRequire("gYive");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Clips values element-wise. `max(min(x, clipValueMax), clipValueMin)`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.clipByValue(-2, 3).print();  // or tf.clipByValue(x, -2, 3)
 * ```
 * @param x The input tensor.
 * @param clipValueMin Lower bound of range to be clipped to.
 * @param clipValueMax Upper bound of range to be clipped to.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $9557879f1a67b9dc$var$clipByValue_(x, clipValueMin, clipValueMax) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'clipByValue');
    $8cCb2.assert(clipValueMin <= clipValueMax, ()=>`Error in clip: min (${clipValueMin}) must be ` + `less than or equal to max (${clipValueMax}).`);
    if (clipValueMin === clipValueMax) return (0, $gYive.fill)($x.shape, clipValueMin, $x.dtype);
    const inputs = {
        x: $x
    };
    const attrs = {
        clipValueMin: clipValueMin,
        clipValueMax: clipValueMax
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.ClipByValue), inputs, attrs);
}
const $9557879f1a67b9dc$export$fa97baf70ad024c0 = /* @__PURE__ */ (0, $jqSCG.op)({
    clipByValue_: $9557879f1a67b9dc$var$clipByValue_
});

});

parcelRegister("iTu6j", function(module, exports) {

$parcel$export(module.exports, "concat", () => $dc14b6735dbc478f$export$ee1b3e54f0441b22);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $5TuCW = parcelRequire("5TuCW");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Concatenates a list of `tf.Tensor`s along a given axis.
 *
 * The tensors ranks and types must match, and their sizes must match in all
 * dimensions except `axis`.
 *
 * Also available are stricter rank-specific methods that assert that
 * `tensors` are of the given rank:
 *   - `tf.concat1d`
 *   - `tf.concat2d`
 *   - `tf.concat3d`
 *   - `tf.concat4d`
 *
 * Except `tf.concat1d` (which does not have axis param), all methods have
 * same signature as this method.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * a.concat(b).print();  // or a.concat(b)
 * ```
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 * tf.concat([a, b, c]).print();
 * ```
 *
 * ```js
 * const a = tf.tensor2d([[1, 2], [10, 20]]);
 * const b = tf.tensor2d([[3, 4], [30, 40]]);
 * const axis = 1;
 * tf.concat([a, b], axis).print();
 * ```
 * @param tensors A list of tensors to concatenate.
 * @param axis The axis to concatenate along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $dc14b6735dbc478f$var$concat_(tensors, axis = 0) {
    (0, $8cCb2.assert)(tensors.length >= 1, ()=>'Pass at least one tensor to concat');
    const $tensors = (0, $5xBLk.convertToTensorArray)(tensors, 'tensors', 'concat', 'string_or_numeric');
    if ($tensors[0].dtype === 'complex64') $tensors.forEach((tensor)=>{
        if (tensor.dtype !== 'complex64') throw new Error(`Cannot concatenate complex64 tensors with a tensor
          with dtype ${tensor.dtype}. `);
    });
    if ($tensors.length === 1) return (0, $5TuCW.clone)($tensors[0]);
    const inputs = $tensors;
    const attr = {
        axis: axis
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Concat), inputs, attr);
}
const $dc14b6735dbc478f$export$ee1b3e54f0441b22 = /* @__PURE__ */ (0, $jqSCG.op)({
    concat_: $dc14b6735dbc478f$var$concat_
});

});

parcelRegister("4TU82", function(module, exports) {

$parcel$export(module.exports, "concat1d", () => $3917d674c96d0dbb$export$1e0bfb2ad280a475);

var $iTu6j = parcelRequire("iTu6j");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Concatenates a list of`tf.Tensor1D`s along an axis. See `concat` for details.
 *
 * For example, if:
 * A: shape(3) = |r1, g1, b1|
 * B: shape(2) = |r2, g2|
 * C = tf.concat1d([A, B]) == |r1, g1, b1, r2, g2|
 *
 * @param tensors A list of`tf.Tensor`s to concatenate.
 * @return The concatenated array.
 */ function $3917d674c96d0dbb$var$concat1d_(tensors) {
    return (0, $iTu6j.concat)(tensors, 0 /* axis */ );
}
const $3917d674c96d0dbb$export$1e0bfb2ad280a475 = /* @__PURE__ */ (0, $jqSCG.op)({
    concat1d_: $3917d674c96d0dbb$var$concat1d_
});

});

parcelRegister("7PZdE", function(module, exports) {

$parcel$export(module.exports, "concat2d", () => $5b4cc8a7f2cde29e$export$ba044983349051fd);

var $iTu6j = parcelRequire("iTu6j");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Concatenates a list of`tf.Tensor2D`s along an axis. See `concat` for details.
 *
 * For example, if:
 * A: shape(2, 3) = | r1, g1, b1 |
 *                  | r2, g2, b2 |
 *
 * B: shape(2, 3) = | r3, g3, b3 |
 *                  | r4, g4, b4 |
 *
 * C = tf.concat2d([A, B], axis)
 *
 * if axis = 0:
 * C: shape(4, 3) = | r1, g1, b1 |
 *                  | r2, g2, b2 |
 *                  | r3, g3, b3 |
 *                  | r4, g4, b4 |
 *
 * if axis = 1:
 * C = shape(2, 6) = | r1, g1, b1, r3, g3, b3 |
 *                   | r2, g2, b2, r4, g4, b4 |
 *
 *
 * @param tensors A list of `tf.Tensor`s to concatenate.
 * @param axis The axis to concatenate along.
 * @return The concatenated array.
 */ function $5b4cc8a7f2cde29e$var$concat2d_(tensors, axis) {
    return (0, $iTu6j.concat)(tensors, axis);
}
const $5b4cc8a7f2cde29e$export$ba044983349051fd = /* @__PURE__ */ (0, $jqSCG.op)({
    concat2d_: $5b4cc8a7f2cde29e$var$concat2d_
});

});

parcelRegister("ljqPW", function(module, exports) {

$parcel$export(module.exports, "concat3d", () => $f8403086914455d5$export$23e0f187dd67babf);

var $iTu6j = parcelRequire("iTu6j");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Concatenates a list of `tf.Tensor3D`s along an axis.
 * See `concat` for details.
 *
 * For example, if:
 * A: shape(2, 1, 3) = | r1, g1, b1 |
 *                     | r2, g2, b2 |
 *
 * B: shape(2, 1, 3) = | r3, g3, b3 |
 *                     | r4, g4, b4 |
 *
 * C = tf.concat3d([A, B], axis)
 *
 * if axis = 0:
 * C: shape(4, 1, 3) = | r1, g1, b1 |
 *                     | r2, g2, b2 |
 *                     | r3, g3, b3 |
 *                     | r4, g4, b4 |
 *
 * if axis = 1:
 * C: shape(2, 2, 3) = | r1, g1, b1, r3, g3, b3 |
 *                     | r2, g2, b2, r4, g4, b4 |
 *
 * if axis = 2:
 * C = shape(2, 1, 6) = | r1, g1, b1, r3, g3, b3 |
 *                      | r2, g2, b2, r4, g4, b4 |
 *
 * @param tensors A list of`tf.Tensor`s to concatenate.
 * @param axis The axis to concate along.
 * @return The concatenated array.
 */ function $f8403086914455d5$var$concat3d_(tensors, axis) {
    return (0, $iTu6j.concat)(tensors, axis);
}
const $f8403086914455d5$export$23e0f187dd67babf = /* @__PURE__ */ (0, $jqSCG.op)({
    concat3d_: $f8403086914455d5$var$concat3d_
});

});

parcelRegister("9Grxx", function(module, exports) {

$parcel$export(module.exports, "concat4d", () => $70cd662e381f1d83$export$731e01cced6c0a23);

var $iTu6j = parcelRequire("iTu6j");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Concatenates a list of `tf.Tensor4D`s along an axis.
 * See `concat` for details.
 *
 * @param tensors A list of `tf.Tensor`s to concatenate.
 * @param axis The axis to concate along.
 * @return The concatenated array.
 */ function $70cd662e381f1d83$var$concat4d_(tensors, axis) {
    return (0, $iTu6j.concat)(tensors, axis);
}
const $70cd662e381f1d83$export$731e01cced6c0a23 = /* @__PURE__ */ (0, $jqSCG.op)({
    concat4d_: $70cd662e381f1d83$var$concat4d_
});

});

parcelRegister("ebPOp", function(module, exports) {

$parcel$export(module.exports, "conv1d", () => $a54a489200625adb$export$d8aa844fa36b350e);

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $5Nkm1 = parcelRequire("5Nkm1");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes a 1D convolution over the input x.
 *
 * @param x The input tensor, of rank 3 or rank 2, of shape
 *     `[batch, width, inChannels]`. If rank 2, batch of 1 is assumed.
 * @param filter The filter, rank 3, of shape
 *     `[filterWidth, inDepth, outDepth]`.
 * @param stride The number of entries by which the filter is moved right at
 *     each step.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat An optional string from "NWC", "NCW". Defaults to "NWC",
 *     the data is stored in the order of [batch, in_width, in_channels]. Only
 *     "NWC" is currently supported.
 * @param dilation The dilation rate in which we sample input values in
 *     atrous convolution. Defaults to `1`. If it is greater than 1, then
 *     stride must be `1`.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $a54a489200625adb$var$conv1d_(x, filter, stride, pad, dataFormat = 'NWC', dilation = 1, dimRoundingMode) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'conv1d');
    const $filter = (0, $5xBLk.convertToTensor)(filter, 'filter', 'conv1d');
    let x3D = $x;
    let reshapedTo3D = false;
    if ($x.rank === 2) {
        reshapedTo3D = true;
        x3D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1]
        ]);
    }
    $8cCb2.assert(x3D.rank === 3, ()=>`Error in conv1d: input must be rank 3, but got rank ${x3D.rank}.`);
    $8cCb2.assert($filter.rank === 3, ()=>`Error in conv1d: filter must be rank 3, but got rank ` + `${$filter.rank}.`);
    $frznq.checkPadOnDimRoundingMode('conv1d', pad, dimRoundingMode);
    $8cCb2.assert(x3D.shape[2] === $filter.shape[1], ()=>`Error in conv1d: depth of input (${x3D.shape[2]}) must match ` + `input depth for filter ${$filter.shape[1]}.`);
    $8cCb2.assert($frznq.eitherStridesOrDilationsAreOne(stride, dilation), ()=>'Error in conv1D: Either stride or dilation must be 1. ' + `Got stride ${stride} and dilation '${dilation}'`);
    $8cCb2.assert($frznq.stridesOrDilationsArePositive(dilation), ()=>'Error in conv1D: Dilated rates should be larger than 0.');
    $8cCb2.assert($frznq.stridesOrDilationsArePositive(stride), ()=>'Error in conv1D: Stride should be larger than 0.');
    $8cCb2.assert(dataFormat === 'NWC', ()=>`Error in conv1d: got dataFormat of ${dataFormat} but only NWC is currently supported.`);
    const filter4D = (0, $4sqA7.reshape)($filter, [
        1,
        $filter.shape[0],
        $filter.shape[1],
        $filter.shape[2]
    ]);
    const input4D = (0, $4sqA7.reshape)(x3D, [
        x3D.shape[0],
        1,
        x3D.shape[1],
        x3D.shape[2]
    ]);
    const strides = [
        1,
        stride
    ];
    const dilations = [
        1,
        dilation
    ];
    const conv2dDataFormat = 'NHWC';
    const res = (0, $5Nkm1.conv2d)(input4D, filter4D, strides, pad, conv2dDataFormat, dilations, dimRoundingMode);
    if (reshapedTo3D) return (0, $4sqA7.reshape)(res, [
        res.shape[2],
        res.shape[3]
    ]);
    return (0, $4sqA7.reshape)(res, [
        res.shape[0],
        res.shape[2],
        res.shape[3]
    ]);
}
const $a54a489200625adb$export$d8aa844fa36b350e = /* @__PURE__ */ (0, $jqSCG.op)({
    conv1d_: $a54a489200625adb$var$conv1d_
});

});
parcelRegister("5Nkm1", function(module, exports) {

$parcel$export(module.exports, "conv2d", () => $43815144b11940c7$export$188f9215482e3db8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes a 2D convolution over the input x.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $43815144b11940c7$var$conv2d_(x, filter, strides, pad, dataFormat = 'NHWC', dilations = [
    1,
    1
], dimRoundingMode) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'conv2d', 'float32');
    const $filter = (0, $5xBLk.convertToTensor)(filter, 'filter', 'conv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $8cCb2.assert(x4D.rank === 4, ()=>`Error in conv2d: input must be rank 4, but got rank ${x4D.rank}.`);
    $8cCb2.assert($filter.rank === 4, ()=>`Error in conv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    $frznq.checkPadOnDimRoundingMode('conv2d', pad, dimRoundingMode);
    const inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $8cCb2.assert(inDepth === $filter.shape[2], ()=>`Error in conv2d: depth of input (${inDepth}) must match ` + `input depth for filter ${$filter.shape[2]}.`);
    $8cCb2.assert($frznq.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in conv2D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $8cCb2.assert($frznq.stridesOrDilationsArePositive(dilations), ()=>'Error in conv2D: Dilated rates should be larger than 0.');
    $8cCb2.assert($frznq.stridesOrDilationsArePositive(strides), ()=>'Error in conv2D: Strides should be larger than 0.');
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.Conv2D), inputs, attrs);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $43815144b11940c7$export$188f9215482e3db8 = /* @__PURE__ */ (0, $jqSCG.op)({
    conv2d_: $43815144b11940c7$var$conv2d_
});

});


parcelRegister("5rn1J", function(module, exports) {

$parcel$export(module.exports, "conv2dTranspose", () => $3f61560f269899e2$export$d5e924cbc07fb966);

var $5xBLk = parcelRequire("5xBLk");

var $6eptr = parcelRequire("6eptr");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the transposed 2D convolution of an image, also known as a
 * deconvolution.
 *
 * @param x The input image, of rank 4 or rank 3, of shape
 *   `[batch, height, width, inDepth]`. If rank 3, batch of 1 is assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, outDepth, inDepth]`.
 *     `inDepth` must match `inDepth` in `x`.
 * @param outputShape Output shape, of rank 4 or rank 3:
 *     `[batch, height, width, outDepth]`. If rank 3, batch of 1 is assumed.
 * @param strides The strides of the original convolution:
 *     `[strideHeight, strideWidth]`.
 * @param pad  The type of padding algorithm used in the non-transpose version
 *    of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $3f61560f269899e2$var$conv2dTranspose_(x, filter, outputShape, strides, pad, dimRoundingMode) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'conv2dTranspose');
    const $filter = (0, $5xBLk.convertToTensor)(filter, 'filter', 'conv2dTranspose');
    return (0, $6eptr.conv2DBackpropInput)(outputShape, $x, $filter, strides, pad, 'NHWC', dimRoundingMode);
}
const $3f61560f269899e2$export$d5e924cbc07fb966 = /* @__PURE__ */ (0, $jqSCG.op)({
    conv2dTranspose_: $3f61560f269899e2$var$conv2dTranspose_
});

});
parcelRegister("6eptr", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropInput", () => $4897cf7297aaab1d$export$633310eed0c26e72);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $8cCb2 = parcelRequire("8cCb2");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the derivative of the input of a 2D convolution.
 *
 * @param xShape The shape of the input: [batch, height, width, inDepth].
 * If length of 3, batch of 1 is assumed.
 * @param dy The derivative of the output, of rank 4 or rank 3 of shape
 *   `[batch, outHeight, outWidth, outDepth]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm used:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $4897cf7297aaab1d$var$conv2DBackpropInput_(xShape, dy, filter, strides, pad, dataFormat = 'NHWC', dimRoundingMode) {
    $8cCb2.assert(xShape.length === dy.rank, ()=>`Length of inShape ` + `(${xShape.length}) and rank of dy (${dy.rank}) must match`);
    let xShape4D = xShape;
    let dy4D = dy;
    let reshapedTo4D = false;
    if (dy.rank === 3) {
        reshapedTo4D = true;
        dy4D = (0, $4sqA7.reshape)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2]
        ]);
        xShape4D = [
            1,
            xShape[0],
            xShape[1],
            xShape[2]
        ];
    }
    $8cCb2.assert(xShape4D.length === 4, ()=>`Error in conv2dDerInput: inShape must be length 4, but got length ` + `${xShape4D.length}.`);
    $8cCb2.assert(dy4D.rank === 4, ()=>`Error in conv2dDerInput: dy must be rank 4, but got ` + `rank ${dy4D.rank}`);
    $8cCb2.assert(filter.rank === 4, ()=>`Error in conv2dDerInput: filter must be rank 4, but got ` + `rank ${filter.rank}`);
    const inDepth = dataFormat === 'NHWC' ? xShape4D[3] : xShape4D[1];
    const outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
    $8cCb2.assert(inDepth === filter.shape[2], ()=>`Error in conv2dDerInput: depth of input (${inDepth}) must ` + `match input depth for filter ${filter.shape[2]}.`);
    $8cCb2.assert(outDepth === filter.shape[3], ()=>`Error in conv2dDerInput: depth of output (${outDepth}) must ` + `match output depth for filter ${filter.shape[3]}.`);
    $frznq.checkPadOnDimRoundingMode('conv2dDerInput', pad, dimRoundingMode);
    const inputs = {
        dy: dy4D,
        filter: filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dimRoundingMode: dimRoundingMode,
        inputShape: xShape4D
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.Conv2DBackpropInput), inputs, attrs);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $4897cf7297aaab1d$export$633310eed0c26e72 = /* @__PURE__ */ (0, $jqSCG.op)({
    conv2DBackpropInput_: $4897cf7297aaab1d$var$conv2DBackpropInput_
});

});


parcelRegister("kj7tM", function(module, exports) {

$parcel$export(module.exports, "conv3d", () => $ec8b6241dd6bfd55$export$c476b02bcf7b2def);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes a 3D convolution over the input x.
 *
 * @param x The input tensor, of rank 5 or rank 4, of shape
 *     `[batch, depth, height, width, channels]`. If rank 4,
 * batch of 1 is assumed.
 * @param filter The filter, rank 5, of shape
 *     `[filterDepth, filterHeight, filterWidth, inChannels, outChannels]`.
 *      inChannels must match between input and filter.
 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat: An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @param dilations The dilation rates: `[dilationDepth, dilationHeight,
 *     dilationWidth]` in which we sample input values across the height
 *     and width dimensions in atrous convolution. Defaults to `[1, 1, 1]`.
 *     If `dilations` is a single number, then
 *     `dilationDepth == dilationHeight == dilationWidth`. If it is greater
 *     than 1, then all values of `strides` must be 1.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $ec8b6241dd6bfd55$var$conv3d_(x, filter, strides, pad, dataFormat = 'NDHWC', dilations = [
    1,
    1,
    1
]) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'conv3d');
    const $filter = (0, $5xBLk.convertToTensor)(filter, 'filter', 'conv3d');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $8cCb2.assert(x5D.rank === 5, ()=>`Error in conv3d: input must be rank 5, but got rank ${x5D.rank}.`);
    $8cCb2.assert($filter.rank === 5, ()=>`Error in conv3d: filter must be rank 5, but got rank ` + `${$filter.rank}.`);
    $8cCb2.assert(x5D.shape[4] === $filter.shape[3], ()=>`Error in conv3d: depth of input (${x5D.shape[4]}) must match ` + `input depth for filter ${$filter.shape[3]}.`);
    $8cCb2.assert((0, $frznq.eitherStridesOrDilationsAreOne)(strides, dilations), ()=>'Error in conv3D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $8cCb2.assert(dataFormat === 'NDHWC', ()=>`Error in conv3d: got dataFormat of ${dataFormat} but only NDHWC is currently supported.`);
    $8cCb2.assert((0, $frznq.stridesOrDilationsArePositive)(dilations), ()=>'Error in conv3D: Dilated rates should be larger than 0.');
    $8cCb2.assert((0, $frznq.stridesOrDilationsArePositive)(strides), ()=>'Error in conv3D: Strides should be larger than 0.');
    const inputs = {
        x: x5D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.Conv3D), inputs, attrs);
    if (reshapedTo5D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $ec8b6241dd6bfd55$export$c476b02bcf7b2def = /* @__PURE__ */ (0, $jqSCG.op)({
    conv3d_: $ec8b6241dd6bfd55$var$conv3d_
});

});

parcelRegister("7Zgyq", function(module, exports) {

$parcel$export(module.exports, "conv3dTranspose", () => $5d0b12361a33af6c$export$5eac62031b3f449f);

var $5xBLk = parcelRequire("5xBLk");

var $AHZ4U = parcelRequire("AHZ4U");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the transposed 3D convolution of a volume, also known as a
 * deconvolution.
 *
 * @param x The input image, of rank 5 or rank 4, of shape
 *   `[batch, depth, height, width, inDepth]`. If rank 4, batch of 1 is assumed.
 * @param filter The filter, rank 4, of shape
 *     `[depth, filterHeight, filterWidth, outDepth, inDepth]`.
 *     `inDepth` must match `inDepth` in `x`.
 * @param outputShape Output shape, of rank 5 or rank 4:
 *     `[batch, depth, height, width, outDepth]`. If rank 3, batch of 1 is
 *    assumed.
 * @param strides The strides of the original convolution:
 *     `[strideDepth, strideHeight, strideWidth]`.
 * @param pad  The type of padding algorithm used in the non-transpose version
 *    of the op.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $5d0b12361a33af6c$var$conv3dTranspose_(x, filter, outputShape, strides, pad) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'conv3dTranspose');
    const $filter = (0, $5xBLk.convertToTensor)(filter, 'filter', 'conv3dTranspose');
    return (0, $AHZ4U.conv3DBackpropInput)(outputShape, $x, $filter, strides, pad);
}
const $5d0b12361a33af6c$export$5eac62031b3f449f = /* @__PURE__ */ (0, $jqSCG.op)({
    conv3dTranspose_: $5d0b12361a33af6c$var$conv3dTranspose_
});

});
parcelRegister("AHZ4U", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropInput", () => $06e57b3d65a6c21e$export$deb6d1ca1fa2977b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the derivative of the input of a 3D convolution.
 *
 * @param xShape The shape of the input: [batch, depth, height, width,
 * in_channels]. If length of 4, batch of 1 is assumed.
 * @param dy The derivative of the output, of rank 5 or rank 4 of shape
 *   `[batch, outDepth, outHeight, outWidth, in_channels]`.
 * If rank 4, batch of 1 is assumed.
 * @param filter The filter, rank 5, of shape
 *     `[filterDepth, filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm used:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 */ function $06e57b3d65a6c21e$var$conv3DBackpropInput_(xShape, dy, filter, strides, pad) {
    $8cCb2.assert(xShape.length === dy.rank, ()=>`Length of inShape ` + `(${xShape.length}) and rank of dy (${dy.rank}) must match`);
    let xShape5D = xShape;
    let dy5D = dy;
    let reshapedTo5D = false;
    if (dy.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $4sqA7.reshape)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2],
            dy.shape[3]
        ]);
        xShape5D = [
            1,
            xShape[0],
            xShape[1],
            xShape[2],
            xShape[3]
        ];
    }
    const inDepth = xShape5D[4];
    const outDepth = dy5D.shape[4];
    $8cCb2.assert(xShape5D.length === 5, ()=>`Error in conv3dDerInput: inShape must be length 5, but got length ` + `${xShape5D.length}.`);
    $8cCb2.assert(dy5D.rank === 5, ()=>`Error in conv3dDerInput: dy must be rank 5, but got ` + `rank ${dy5D.rank}`);
    $8cCb2.assert(filter.rank === 5, ()=>`Error in conv3dDerInput: filter must be rank 5, but got ` + `rank ${filter.rank}`);
    $8cCb2.assert(inDepth === filter.shape[3], ()=>`Error in conv3dDerInput: depth of input (${inDepth}) must ` + `match input depth for filter ${filter.shape[3]}.`);
    $8cCb2.assert(outDepth === filter.shape[4], ()=>`Error in conv3dDerInput: depth of output (${outDepth}) must ` + `match output depth for filter ${filter.shape[4]}.`);
    const inputs = {
        dy: dy5D,
        filter: filter
    };
    const attrs = {
        pad: pad,
        strides: strides,
        inputShape: xShape5D
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.Conv3DBackpropInputV2), inputs, attrs);
    if (reshapedTo5D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $06e57b3d65a6c21e$export$deb6d1ca1fa2977b = /* @__PURE__ */ (0, $jqSCG.op)({
    conv3DBackpropInput_: $06e57b3d65a6c21e$var$conv3DBackpropInput_
});

});


parcelRegister("8maH5", function(module, exports) {

$parcel$export(module.exports, "denseBincount", () => $6158ac691c62a7b2$export$436934e6cf1946f1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Outputs a vector with length `size` and the same dtype as `weights`.
 *
 * If `weights` are empty, then index `i` stores the number of times the value
 * `i` is counted in `x`. If `weights` are non-empty, then index `i` stores the
 * sum of the value in `weights` at each index where the corresponding value in
 * `x` is `i`.
 *
 * Values in `x` outside of the range [0, size) are ignored.
 *
 * @param x The input int tensor, rank 1 or rank 2.
 * @param weights The weights tensor, must have the same shape as x, or a
 *     length-0 Tensor, in which case it acts as all weights equal to 1.
 * @param size Non-negative integer.
 * @param binaryOutput Optional. Whether the kernel should count the appearance
 *     or number of occurrences. Defaults to False.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $6158ac691c62a7b2$var$denseBincount_(x, weights, size, binaryOutput = false) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'denseBincount');
    const $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'denseBincount');
    $8cCb2.assert($x.dtype === 'int32', ()=>`Error in denseBincount: input ` + `dtype must be int32, but got ${$x.dtype}`);
    $8cCb2.assert($x.rank <= 2, ()=>`Error in denseBincount: input must be at most rank 2, but got ` + `rank ${$x.rank}.`);
    $8cCb2.assert(size >= 0, ()=>`size must be non-negative, but got ${size}.`);
    $8cCb2.assert($weights.size === $x.size || $weights.size === 0, ()=>`Error in denseBincount: weights must have the same shape as x or ` + `0-length, but got x shape: ${$x.shape}, weights shape: ` + `${$weights.shape}.`);
    const inputs = {
        x: $x,
        weights: $weights
    };
    const attrs = {
        size: size,
        binaryOutput: binaryOutput
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.DenseBincount), inputs, attrs);
}
const $6158ac691c62a7b2$export$436934e6cf1946f1 = /* @__PURE__ */ (0, $jqSCG.op)({
    denseBincount_: $6158ac691c62a7b2$var$denseBincount_
});

});

parcelRegister("182Rc", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2d", () => $0d28c12ba7a09138$export$48a8ad9494a8fad8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Depthwise 2D convolution.
 *
 * Given a 4D `input` array and a `filter` array of shape
 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
 * `inChannels` convolutional filters of depth 1, this op applies a
 * different filter to each input channel (expanding from 1 channel to
 * `channelMultiplier` channels for each), then concatenates the results
 * together. The output has `inChannels * channelMultiplier` channels.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
 * for more details.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $0d28c12ba7a09138$var$depthwiseConv2d_(x, filter, strides, pad, dataFormat = 'NHWC', dilations = [
    1,
    1
], dimRoundingMode) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'depthwiseConv2d', 'float32');
    const $filter = (0, $5xBLk.convertToTensor)(filter, 'filter', 'depthwiseConv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $8cCb2.assert(x4D.rank === 4, ()=>`Error in depthwiseConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $8cCb2.assert($filter.rank === 4, ()=>`Error in depthwiseConv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    const inChannels = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $8cCb2.assert(inChannels === $filter.shape[2], ()=>`Error in depthwiseConv2d: number of input channels ` + `(${inChannels}) must match the inChannels dimension in ` + `filter ${$filter.shape[2]}.`);
    $frznq.checkPadOnDimRoundingMode('depthwiseConv2d', pad, dimRoundingMode);
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.DepthwiseConv2dNative), inputs, attrs);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $0d28c12ba7a09138$export$48a8ad9494a8fad8 = /* @__PURE__ */ (0, $jqSCG.op)({
    depthwiseConv2d_: $0d28c12ba7a09138$var$depthwiseConv2d_
});

});

parcelRegister("5kLyC", function(module, exports) {

$parcel$export(module.exports, "dropout", () => $3e23b5eb4f133b27$export$fe05aa12367b4e47);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9jCh7 = parcelRequire("9jCh7");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $hgacW = parcelRequire("hgacW");

var $1QPqB = parcelRequire("1QPqB");

var $273XW = parcelRequire("273XW");

var $4ZUCz = parcelRequire("4ZUCz");

var $jZc0w = parcelRequire("jZc0w");

var $jqSCG = parcelRequire("jqSCG");

var $j8sic = parcelRequire("j8sic");
/**
 * Computes dropout.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 2, 1]);
 * const rate = 0.75;
 * const output = tf.dropout(x, rate);
 * output.print();
 * ```
 *
 * @param x A floating point Tensor or TensorLike.
 * @param rate A float in the range [0, 1). The probability that each element
 *   of x is discarded.
 * @param noiseShape An array of numbers of type int32, representing the
 * shape for randomly generated keep/drop flags. If the noiseShape has null
 * value, it will be automatically replaced with the x's relative dimension
 * size. Optional.
 * @param seed Used to create random seeds. Optional.
 * @returns A Tensor of the same shape of x.
 *
 * @doc {heading: 'Operations', subheading: 'Dropout'}
 */ function $3e23b5eb4f133b27$var$dropout_(x, rate, noiseShape, seed) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'dropout');
    $8cCb2.assert($x.dtype === 'float32', ()=>`x has to be a floating point tensor since it's going to be ` + `scaled, but got a ${$x.dtype} tensor instead.`);
    $8cCb2.assert(rate >= 0 && rate < 1, ()=>`rate must be a float in the range [0, 1), but got ${rate}.`);
    if (rate === 0) return x instanceof (0, $9jCh7.Tensor) ? $x.clone() : $x;
    const $noiseShape = (0, $273XW.getNoiseShape)($x, noiseShape);
    const keepProb = 1 - rate;
    const multiplier = (0, $1QPqB.div)((0, $4ZUCz.floor)((0, $hgacW.add)((0, $j8sic.randomUniform)($noiseShape, 0, 1, 'float32', seed), keepProb)), keepProb);
    return (0, $jZc0w.mul)($x, multiplier);
}
const $3e23b5eb4f133b27$export$fe05aa12367b4e47 = /* @__PURE__ */ (0, $jqSCG.op)({
    dropout_: $3e23b5eb4f133b27$var$dropout_
});

});
parcelRegister("273XW", function(module, exports) {

$parcel$export(module.exports, "getNoiseShape", () => $189f4fc2b10a031f$export$5cc59b1f6d856c8e);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
function $189f4fc2b10a031f$export$5cc59b1f6d856c8e(x, noiseShape) {
    if (noiseShape == null) return x.shape.slice();
    if ($8cCb2.arraysEqual(x.shape, noiseShape)) return noiseShape;
    if (x.shape.length === noiseShape.length) {
        const newDimension = [];
        for(let i = 0; i < x.shape.length; i++)if (noiseShape[i] == null && x.shape[i] != null) newDimension.push(x.shape[i]);
        else newDimension.push(noiseShape[i]);
        return newDimension;
    }
    return noiseShape;
}

});

parcelRegister("4ZUCz", function(module, exports) {

$parcel$export(module.exports, "floor", () => $3a38c7b29dbfd7e8$export$a3fe094919f356fd);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes floor of input `tf.Tensor` element-wise: `floor(x)`.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.floor().print();  // or tf.floor(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $3a38c7b29dbfd7e8$var$floor_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'floor', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Floor), inputs);
}
const $3a38c7b29dbfd7e8$export$a3fe094919f356fd = /* @__PURE__ */ (0, $jqSCG.op)({
    floor_: $3a38c7b29dbfd7e8$var$floor_
});

});

parcelRegister("j8sic", function(module, exports) {

$parcel$export(module.exports, "randomUniform", () => $dee4b5fc7aecfad3$export$bd6fd37822e292fa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");

var $iG87S = parcelRequire("iG87S");

var $jqSCG = parcelRequire("jqSCG");

var $7QK6b = parcelRequire("7QK6b");
/**
 * Creates a `tf.Tensor` with values sampled from a uniform distribution.
 *
 * The generated values follow a uniform distribution in the range [minval,
 * maxval). The lower bound minval is included in the range, while the upper
 * bound maxval is excluded.
 *
 * ```js
 * tf.randomUniform([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param minval The lower bound on the range of random values to generate.
 *   Defaults to 0.
 * @param maxval The upper bound on the range of random values to generate.
 *   Defaults to 1.
 * @param dtype The data type of the output tensor. Defaults to 'float32'.
 * @param seed An optional int. Defaults to 0. If seed is set to be non-zero,
 *   the random number generator is seeded by the given seed. Otherwise, it is
 *   seeded by a random seed.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $dee4b5fc7aecfad3$var$randomUniform_(shape, minval = 0, maxval = 1, dtype = 'float32', seed) {
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
    const res = (0, $iG87S.buffer)(shape, dtype);
    const random = new (0, $7QK6b.UniformRandom)(minval, maxval, null, seed);
    for(let i = 0; i < res.values.length; i++)res.values[i] = random.nextValue();
    return res.toTensor();
}
const $dee4b5fc7aecfad3$export$bd6fd37822e292fa = /* @__PURE__ */ (0, $jqSCG.op)({
    randomUniform_: $dee4b5fc7aecfad3$var$randomUniform_
});

});
parcelRegister("7QK6b", function(module, exports) {

$parcel$export(module.exports, "MPRandGauss", () => $5b7125fa6f9f7784$export$d23b64058df0188a);
$parcel$export(module.exports, "RandGamma", () => $5b7125fa6f9f7784$export$bffe1ad508acdb18);
$parcel$export(module.exports, "UniformRandom", () => $5b7125fa6f9f7784$export$1e4a6d1367ace404);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3mnBW = parcelRequire("3mnBW");

var $6thPa = parcelRequire("6thPa");
class $5b7125fa6f9f7784$export$d23b64058df0188a {
    constructor(mean, stdDeviation, dtype, truncated, seed){
        this.mean = mean;
        this.stdDev = stdDeviation;
        this.dtype = dtype;
        this.nextVal = NaN;
        this.truncated = truncated;
        if (this.truncated) {
            this.upper = this.mean + this.stdDev * 2;
            this.lower = this.mean - this.stdDev * 2;
        }
        const seedValue = seed ? seed : Math.random();
        this.random = $3mnBW.alea(seedValue.toString());
    }
    /** Returns next sample from a Gaussian distribution. */ nextValue() {
        if (!isNaN(this.nextVal)) {
            const value = this.nextVal;
            this.nextVal = NaN;
            return value;
        }
        let resultX, resultY;
        let isValid = false;
        while(!isValid){
            let v1, v2, s;
            do {
                v1 = 2 * this.random() - 1;
                v2 = 2 * this.random() - 1;
                s = v1 * v1 + v2 * v2;
            }while (s >= 1 || s === 0);
            const mul = Math.sqrt(-2 * Math.log(s) / s);
            resultX = this.mean + this.stdDev * v1 * mul;
            resultY = this.mean + this.stdDev * v2 * mul;
            if (!this.truncated || this.isValidTruncated(resultX)) isValid = true;
        }
        if (!this.truncated || this.isValidTruncated(resultY)) this.nextVal = this.convertValue(resultY);
        return this.convertValue(resultX);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(value) {
        if (this.dtype == null || this.dtype === 'float32') return value;
        return Math.round(value);
    }
    /** Returns true if less than 2-standard-deviations from the mean. */ isValidTruncated(value) {
        return value <= this.upper && value >= this.lower;
    }
}
class $5b7125fa6f9f7784$export$bffe1ad508acdb18 {
    constructor(alpha, beta, dtype, seed){
        this.alpha = alpha;
        this.beta = 1 / beta; // convert rate to scale parameter
        this.dtype = dtype;
        const seedValue = seed ? seed : Math.random();
        this.randu = $3mnBW.alea(seedValue.toString());
        this.randn = new $5b7125fa6f9f7784$export$d23b64058df0188a(0, 1, dtype, false, this.randu());
        if (alpha < 1) this.d = alpha + 2 / 3;
        else this.d = alpha - 1 / 3;
        this.c = 1 / Math.sqrt(9 * this.d);
    }
    /** Returns next sample from a gamma distribution. */ nextValue() {
        let x2, v0, v1, x, u, v;
        while(true){
            do {
                x = this.randn.nextValue();
                v = 1 + this.c * x;
            }while (v <= 0);
            v *= v * v;
            x2 = x * x;
            v0 = 1 - 0.331 * x2 * x2;
            v1 = 0.5 * x2 + this.d * (1 - v + Math.log(v));
            u = this.randu();
            if (u < v0 || Math.log(u) < v1) break;
        }
        v = 1 / this.beta * this.d * v;
        if (this.alpha < 1) v *= Math.pow(this.randu(), 1 / this.alpha);
        return this.convertValue(v);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(value) {
        if (this.dtype === 'float32') return value;
        return Math.round(value);
    }
}
class $5b7125fa6f9f7784$export$1e4a6d1367ace404 {
    constructor(min = 0, max = 1, dtype, seed){
        /** Handles proper rounding for non floating point numbers. */ this.canReturnFloat = ()=>this.dtype == null || this.dtype === 'float32';
        this.min = min;
        this.range = max - min;
        this.dtype = dtype;
        if (seed == null) seed = Math.random();
        if (typeof seed === 'number') seed = seed.toString();
        if (!this.canReturnFloat() && this.range <= 1) throw new Error(`The difference between ${min} - ${max} <= 1 and dtype is not float`);
        this.random = $3mnBW.alea(seed);
    }
    convertValue(value) {
        if (this.canReturnFloat()) return value;
        return Math.round(value);
    }
    nextValue() {
        return this.convertValue(this.min + this.range * this.random());
    }
}
function $5b7125fa6f9f7784$export$5f38b2eb2df54d68(values) {
    // https://en.wikipedia.org/wiki/Jarque%E2%80%93Bera_test
    const n = values.length;
    const s = $5b7125fa6f9f7784$var$skewness(values);
    const k = $5b7125fa6f9f7784$var$kurtosis(values);
    const jb = n / 6 * (Math.pow(s, 2) + 0.25 * Math.pow(k - 3, 2));
    // JB test requires 2-degress of freedom from Chi-Square @ 0.95:
    // http://www.itl.nist.gov/div898/handbook/eda/section3/eda3674.htm
    const CHI_SQUARE_2DEG = 5.991;
    if (jb > CHI_SQUARE_2DEG) throw new Error(`Invalid p-value for JB: ${jb}`);
}
function $5b7125fa6f9f7784$export$3286e17febe230d(actual, expectedMean, expectedStdDev, epsilon) {
    if (epsilon == null) epsilon = (0, $6thPa.testEpsilon)();
    const actualMean = $5b7125fa6f9f7784$var$mean(actual);
    (0, $6thPa.expectNumbersClose)(actualMean, expectedMean, epsilon);
    (0, $6thPa.expectNumbersClose)($5b7125fa6f9f7784$var$standardDeviation(actual, actualMean), expectedStdDev, epsilon);
}
function $5b7125fa6f9f7784$var$mean(values) {
    let sum = 0;
    for(let i = 0; i < values.length; i++)sum += values[i];
    return sum / values.length;
}
function $5b7125fa6f9f7784$var$standardDeviation(values, mean) {
    let squareDiffSum = 0;
    for(let i = 0; i < values.length; i++){
        const diff = values[i] - mean;
        squareDiffSum += diff * diff;
    }
    return Math.sqrt(squareDiffSum / values.length);
}
function $5b7125fa6f9f7784$var$kurtosis(values) {
    // https://en.wikipedia.org/wiki/Kurtosis
    const valuesMean = $5b7125fa6f9f7784$var$mean(values);
    const n = values.length;
    let sum2 = 0;
    let sum4 = 0;
    for(let i = 0; i < n; i++){
        const v = values[i] - valuesMean;
        sum2 += Math.pow(v, 2);
        sum4 += Math.pow(v, 4);
    }
    return 1 / n * sum4 / Math.pow(1 / n * sum2, 2);
}
function $5b7125fa6f9f7784$var$skewness(values) {
    // https://en.wikipedia.org/wiki/Skewness
    const valuesMean = $5b7125fa6f9f7784$var$mean(values);
    const n = values.length;
    let sum2 = 0;
    let sum3 = 0;
    for(let i = 0; i < n; i++){
        const v = values[i] - valuesMean;
        sum2 += Math.pow(v, 2);
        sum3 += Math.pow(v, 3);
    }
    return 1 / n * sum3 / Math.pow(1 / (n - 1) * sum2, 1.5);
}

});
parcelRegister("3mnBW", function(module, exports) {
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $cmoHh = parcelRequire("cmoHh");

var $euRi5 = parcelRequire("euRi5");

var $hDsEw = parcelRequire("hDsEw");

var $3J2Zm = parcelRequire("3J2Zm");

var $6Px8M = parcelRequire("6Px8M");

var $lDm0S = parcelRequire("lDm0S");

var $ixfky = parcelRequire("ixfky");
$ixfky.alea = $cmoHh;
$ixfky.xor128 = $euRi5;
$ixfky.xorwow = $hDsEw;
$ixfky.xorshift7 = $3J2Zm;
$ixfky.xor4096 = $6Px8M;
$ixfky.tychei = $lDm0S;
module.exports = $ixfky;

});
parcelRegister("cmoHh", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(' ');
        me.s1 = mash(' ');
        me.s2 = mash(' ');
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("euRi5", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("hDsEw", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("3J2Zm", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = '' + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("6Px8M", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + '\0';
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("lDm0S", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("ixfky", function(module, exports) {

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = 'random', startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == 'object') {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == 'string' ? obj : obj + '\0';
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if (module.exports) {
        module.exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("kjyEk"));
        } catch (ex) {}
    } else if (typeof define == 'function' && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math['seed' + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== 'undefined' ? self : module.exports, [], Math // math: package containing random, pow, and seedrandom
);

});


parcelRegister("6thPa", function(module, exports) {

$parcel$export(module.exports, "testEpsilon", () => $4b634705d248be81$export$e73bb4a504595b05);
$parcel$export(module.exports, "expectNumbersClose", () => $4b634705d248be81$export$a09d1668dd6f88b6);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");
var $jjNRA = parcelRequire("jjNRA");
const $4b634705d248be81$var$TEST_EPSILON_FLOAT32 = 1e-3;
const $4b634705d248be81$export$a86b4427e7a62065 = 1e-1;
function $4b634705d248be81$export$33c766a1062be5b2(actual, expected, epsilon) {
    if (epsilon == null) epsilon = $4b634705d248be81$export$e73bb4a504595b05();
    return $4b634705d248be81$var$expectArraysPredicate(actual, expected, (a, b)=>$4b634705d248be81$var$areClose(a, b, epsilon));
}
function $4b634705d248be81$export$e73bb4a504595b05() {
    return (0, $38WwN.ENGINE).backend.floatPrecision() === 32 ? $4b634705d248be81$var$TEST_EPSILON_FLOAT32 : $4b634705d248be81$export$a86b4427e7a62065;
}
function $4b634705d248be81$var$expectArraysPredicate(actual, expected, predicate) {
    let checkClassType = true;
    if ((0, $jjNRA.isTypedArray)(actual) || (0, $jjNRA.isTypedArray)(expected)) checkClassType = false;
    if ((0, $jjNRA.isTypedArray)(actual) && (0, $jjNRA.isTypedArray)(expected)) checkClassType = true;
    if (checkClassType) {
        const aType = actual.constructor.name;
        const bType = expected.constructor.name;
        if (aType !== bType) throw new Error(`Arrays are of different type. Actual: ${aType}. ` + `Expected: ${bType}`);
    }
    if (Array.isArray(actual) && Array.isArray(expected)) {
        const actualShape = (0, $5xBLk.inferShape)(actual);
        const expectedShape = (0, $5xBLk.inferShape)(expected);
        if (!(0, $8cCb2.arraysEqual)(actualShape, expectedShape)) throw new Error(`Arrays have different shapes. ` + `Actual: [${actualShape}]. Expected: [${expectedShape}]`);
    }
    const actualFlat = (0, $jjNRA.isTypedArray)(actual) ? actual : (0, $jjNRA.flatten)(actual);
    const expectedFlat = (0, $jjNRA.isTypedArray)(expected) ? expected : (0, $jjNRA.flatten)(expected);
    if (actualFlat.length !== expectedFlat.length) throw new Error(`Arrays have different lengths actual: ${actualFlat.length} vs ` + `expected: ${expectedFlat.length}.\n` + `Actual:   ${actualFlat}.\n` + `Expected: ${expectedFlat}.`);
    for(let i = 0; i < expectedFlat.length; ++i){
        const a = actualFlat[i];
        const e = expectedFlat[i];
        if (!predicate(a, e)) throw new Error(`Arrays differ: actual[${i}] = ${a}, expected[${i}] = ${e}.\n` + `Actual:   ${actualFlat}.\n` + `Expected: ${expectedFlat}.`);
    }
    if (typeof expect !== 'undefined') expect().nothing();
}
function $4b634705d248be81$export$f1ce55133f3520c4(fn, done) {
    fn().then(()=>done.fail(), ()=>done());
    if (typeof expect !== 'undefined') expect().nothing();
}
function $4b634705d248be81$export$347f1ed9dcafca0d(actual, expected) {
    const exp = typeof expected === 'string' || typeof expected === 'number' || typeof expected === 'boolean' ? [
        expected
    ] : expected;
    if ((0, $8cCb2.isString)(actual) || (0, $8cCb2.isString)(actual[0]) || (0, $8cCb2.isString)(expected) || (0, $8cCb2.isString)(expected[0])) // tslint:disable-next-line: triple-equals
    return $4b634705d248be81$var$expectArraysPredicate(actual, exp, (a, b)=>a == b);
    return $4b634705d248be81$var$expectArraysPredicate(actual, expected, (a, b)=>$4b634705d248be81$var$areClose(a, b, 0));
}
function $4b634705d248be81$export$a09d1668dd6f88b6(a, e, epsilon) {
    if (epsilon == null) epsilon = $4b634705d248be81$export$e73bb4a504595b05();
    if (!$4b634705d248be81$var$areClose(a, e, epsilon)) throw new Error(`Numbers differ: actual === ${a}, expected === ${e}`);
    if (typeof expect !== 'undefined') expect().nothing();
}
function $4b634705d248be81$var$areClose(a, e, epsilon) {
    if (!isFinite(a) && !isFinite(e)) return true;
    if (isNaN(a) || isNaN(e) || Math.abs(a - e) > epsilon) return false;
    return true;
}
function $4b634705d248be81$export$1af4797b1eac800b(actual, low, high) {
    for(let i = 0; i < actual.length; i++){
        if (actual[i] < low || actual[i] > high) throw new Error(`Value out of range:${actual[i]} low: ${low}, high: ${high}`);
    }
}
function $4b634705d248be81$export$28801b43871bdbc0(actual, expected) {
    // Safari does not like comparing ArrayBuffers directly. Wrapping in
    // a Float32Array solves this issue.
    const actualArray = new Float32Array(actual);
    const expectedArray = new Float32Array(expected);
    if (actualArray.length !== expectedArray.length) throw new Error('Expected ArrayBuffer to be of length ' + `${expectedArray.length}, but it was ${actualArray.length}`);
    for(let i = 0; i < expectedArray.length; i++){
        if (actualArray[i] !== expectedArray[i]) throw new Error(`Expected ArrayBuffer value at ${i} to be ` + `${expectedArray[i]} but got ${actualArray[i]} instead`);
    }
}
function $4b634705d248be81$export$a3027a992fa03b9e(a) {
    for(let i = 0; i < a.length; i++){
        const val = a[i];
        if (Array.isArray(val)) $4b634705d248be81$export$a3027a992fa03b9e(val);
        else a[i] = (0, $jjNRA.encodeString)(val);
    }
    return a;
}
function $4b634705d248be81$export$f4f3d816544d7e44(source) {
    const video = document.createElement('video');
    if ('playsInline' in video) // tslint:disable-next-line:no-any
    video.playsInline = true;
    video.muted = true;
    video.loop = true;
    video.style.position = 'fixed';
    video.style.left = '0px';
    video.style.top = '0px';
    video.preload = 'auto';
    video.appendChild(source);
    return new Promise((resolve)=>{
        video.addEventListener('loadeddata', (_)=>resolve(video));
        video.load();
    });
}
async function $4b634705d248be81$export$899fbdb5fa08b653(video) {
    await video.play();
    if ('requestVideoFrameCallback' in video) await new Promise((resolve)=>{
        // tslint:disable-next-line:no-any
        video.requestVideoFrameCallback(resolve);
    });
}

});




parcelRegister("7R9HC", function(module, exports) {

$parcel$export(module.exports, "equal", () => $5b85025852d3ccbe$export$411ce8e5a71e3069);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the truth value of (a == b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.equal(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $5b85025852d3ccbe$var$equal_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'equal', 'string_or_numeric');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'equal', 'string_or_numeric');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Equal), inputs);
}
const $5b85025852d3ccbe$export$411ce8e5a71e3069 = /* @__PURE__ */ (0, $jqSCG.op)({
    equal_: $5b85025852d3ccbe$var$equal_
});

});

parcelRegister("3q8h0", function(module, exports) {

$parcel$export(module.exports, "erf", () => $27da37b0d1c5f650$export$d3896f355fc09423);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $inFmq = parcelRequire("inFmq");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes Gauss error function of the input `tf.Tensor` element-wise:
 * `erf(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, .1, -.1, .7]);
 *
 * x.erf().print(); // or tf.erf(x);
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $27da37b0d1c5f650$var$erf_(x) {
    let $x = (0, $5xBLk.convertToTensor)(x, 'x', 'erf');
    $8cCb2.assert($x.dtype === 'int32' || $x.dtype === 'float32', ()=>'Input dtype must be `int32` or `float32`.');
    if ($x.dtype === 'int32') $x = (0, $inFmq.cast)($x, 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Erf), inputs);
}
const $27da37b0d1c5f650$export$d3896f355fc09423 = /* @__PURE__ */ (0, $jqSCG.op)({
    erf_: $27da37b0d1c5f650$var$erf_
});

});

parcelRegister("2PcQK", function(module, exports) {

$parcel$export(module.exports, "exp", () => $20ea4fdf69fd4a26$export$b310ec824aaee37f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes exponential of the input `tf.Tensor` element-wise. `e ^ x`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, -3]);
 *
 * x.exp().print();  // or tf.exp(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $20ea4fdf69fd4a26$var$exp_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'exp');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Exp), inputs);
}
const $20ea4fdf69fd4a26$export$b310ec824aaee37f = /* @__PURE__ */ (0, $jqSCG.op)({
    exp_: $20ea4fdf69fd4a26$var$exp_
});

});

parcelRegister("iPDWZ", function(module, exports) {

$parcel$export(module.exports, "expandDims", () => $db5bfab98435c6cf$export$d660d8ed21f46635);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns a `tf.Tensor` that has expanded rank, by inserting a dimension
 * into the tensor's shape.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const axis = 1;
 * x.expandDims(axis).print();
 * ```
 *
 * @param x The input tensor whose dimensions are to be expanded.
 * @param axis The dimension index at which to insert shape of `1`. Defaults
 *     to 0 (the first dimension).
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $db5bfab98435c6cf$var$expandDims_(x, axis = 0) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'expandDims', 'string_or_numeric');
    $8cCb2.assert(axis <= $x.rank, ()=>'Axis must be <= rank of the tensor');
    const inputs = {
        input: $x
    };
    const attrs = {
        dim: axis
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.ExpandDims), inputs, attrs);
}
const $db5bfab98435c6cf$export$d660d8ed21f46635 = /* @__PURE__ */ (0, $jqSCG.op)({
    expandDims_: $db5bfab98435c6cf$var$expandDims_
});

});

parcelRegister("9gIZb", function(module, exports) {

$parcel$export(module.exports, "eye", () => $6bf880f08dec68a4$export$4e18cf730a59887e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $iG87S = parcelRequire("iG87S");

var $iPDWZ = parcelRequire("iPDWZ");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");

var $61ay4 = parcelRequire("61ay4");
/**
 * Create an identity matrix.
 *
 * @param numRows Number of rows.
 * @param numColumns Number of columns. Defaults to `numRows`.
 * @param batchShape If provided, will add the batch shape to the beginning
 *   of the shape of the returned `tf.Tensor` by repeating the identity
 *   matrix.
 * @param dtype Data type.
 * @returns Identity matrix of the specified size and data type, possibly
 *   with batch repetition if `batchShape` is specified.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $6bf880f08dec68a4$var$eye_(numRows, numColumns, batchShape, dtype = 'float32') {
    if (numColumns == null) numColumns = numRows;
    const buff = (0, $iG87S.buffer)([
        numRows,
        numColumns
    ], dtype);
    const n = numRows <= numColumns ? numRows : numColumns;
    for(let i = 0; i < n; ++i)buff.set(1, i, i);
    const out = (0, $4sqA7.reshape)(buff.toTensor(), [
        numRows,
        numColumns
    ]);
    if (batchShape == null) return out;
    else {
        if (batchShape.length === 1) return (0, $61ay4.tile)((0, $iPDWZ.expandDims)(out, 0), [
            batchShape[0],
            1,
            1
        ]);
        else if (batchShape.length === 2) // tslint:disable-next-line:no-unnecessary-type-assertion
        return (0, $61ay4.tile)((0, $iPDWZ.expandDims)((0, $iPDWZ.expandDims)(out, 0), 0), [
            batchShape[0],
            batchShape[1],
            1,
            1
        ]);
        else if (batchShape.length === 3) // tslint:disable-next-line:no-unnecessary-type-assertion
        return (0, $61ay4.tile)((0, $iPDWZ.expandDims)((0, $iPDWZ.expandDims)((0, $iPDWZ.expandDims)(out, 0), 0), 0), [
            batchShape[0],
            batchShape[1],
            batchShape[2],
            1,
            1
        ]);
        else throw new Error(`eye() currently supports only 1D and 2D ` + // tslint:disable-next-line:no-any
        `batchShapes, but received ${batchShape.length}D.`);
    }
}
const $6bf880f08dec68a4$export$4e18cf730a59887e = /* @__PURE__ */ (0, $jqSCG.op)({
    eye_: $6bf880f08dec68a4$var$eye_
});

});
parcelRegister("61ay4", function(module, exports) {

$parcel$export(module.exports, "tile", () => $461b04d030518b80$export$3c17558da18e4d75);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Construct a tensor by repeating it the number of times given by reps.
 *
 * This operation creates a new tensor by replicating `input` `reps`
 * times. The output tensor's `i`th dimension has `input.shape[i] *
 * reps[i]` elements, and the values of `input` are replicated
 * `reps[i]` times along the `i`th dimension. For example, tiling
 * `[a, b, c, d]` by `[2]` produces `[a, b, c, d, a, b, c, d]`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 *
 * a.tile([2]).print();    // or tf.tile(a, [2])
 * ```
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * a.tile([1, 2]).print();  // or tf.tile(a, [1,2])
 * ```
 * @param x The tensor to tile.
 * @param reps Determines the number of replications per dimension.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $461b04d030518b80$var$tile_(x, reps) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'tile', 'string_or_numeric');
    $8cCb2.assert($x.rank === reps.length, ()=>`Error in transpose: rank of input ${$x.rank} ` + `must match length of reps ${reps}.`);
    const inputs = {
        x: $x
    };
    const attrs = {
        reps: reps
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Tile), inputs, attrs);
}
const $461b04d030518b80$export$3c17558da18e4d75 = /* @__PURE__ */ (0, $jqSCG.op)({
    tile_: $461b04d030518b80$var$tile_
});

});


parcelRegister("jDZRN", function(module, exports) {

$parcel$export(module.exports, "conv2d", () => (parcelRequire("6GXo4")).conv2d);
$parcel$export(module.exports, "depthwiseConv2d", () => (parcelRequire("d71bK")).depthwiseConv2d);
$parcel$export(module.exports, "matMul", () => (parcelRequire("1q6Gm")).matMul);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6GXo4 = parcelRequire("6GXo4");

var $d71bK = parcelRequire("d71bK");

var $1q6Gm = parcelRequire("1q6Gm");

});
parcelRegister("6GXo4", function(module, exports) {

$parcel$export(module.exports, "conv2d", () => $4df4bb602b8b2d4d$export$188f9215482e3db8);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $92fpA = parcelRequire("92fpA");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $hgacW = parcelRequire("hgacW");

var $8BaGO = parcelRequire("8BaGO");

var $5Nkm1 = parcelRequire("5Nkm1");

var $4Tgmn = parcelRequire("4Tgmn");

var $6eptr = parcelRequire("6eptr");

var $frznq = parcelRequire("frznq");

var $bzoAL = parcelRequire("bzoAL");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes a 2D convolution over the input x, optionally fused with adding a
 * bias and applying an activation.
 *
 * ```js
 * const inputDepth = 2;
 * const inShape = [2, 2, 2, inputDepth];
 * const outputDepth = 2;
 * const fSize = 1;
 * const pad = 0;
 * const strides = 1;
 *
 * const x = tf.tensor4d( [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
 * 16], inShape);
 * const w = tf.tensor4d([-1, 1, -2, 0.5], [fSize, fSize, inputDepth,
 * outputDepth]);
 *
 * tf.fused.conv2d({ x, filter: w, strides, pad, dataFormat: 'NHWC',
 * dilations: [1, 1], bias: tf.scalar(5), activation: 'relu' }).print();
 * ```
 *
 * @param obj An object with the following properties:
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid` output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param bias Tensor to be added to the result.
 * @param activation Name of activation kernel (defaults to `linear`) to be
 *     applied
 *      after biasAdd.
 * @param preluActivationWeights Tensor of prelu weights to be applied as part
 *     of a `prelu` activation, typically the same shape as `x`.
 * @param leakyreluAlpha Optional. Alpha to be applied as part of a `leakyrelu`
 *     activation.
 */ function $4df4bb602b8b2d4d$var$fusedConv2d_({ x: x, filter: filter, strides: strides, pad: pad, dataFormat: dataFormat = 'NHWC', dilations: dilations = [
    1,
    1
], dimRoundingMode: dimRoundingMode, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha }) {
    activation = activation || 'linear';
    if ((0, $bzoAL.shouldFuse)((0, $38WwN.ENGINE).state.gradientDepth, activation) === false) {
        // TODO: Transpose bias and preluActivationWeights properly for NCHW
        // format before computation.
        $8cCb2.assert(dataFormat === 'NHWC', ()=>`Error in fused conv2d: got dataFormat of ${dataFormat} but ` + `only NHWC is currently supported for the case of gradient depth ` + `is 0 and the activation is not linear.`);
        let result = (0, $5Nkm1.conv2d)(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
        if (bias != null) result = (0, $hgacW.add)(result, bias);
        return (0, $bzoAL.applyActivation)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'conv2d', 'float32');
    const $filter = (0, $5xBLk.convertToTensor)(filter, 'filter', 'conv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $8cCb2.assert(x4D.rank === 4, ()=>`Error in fused conv2d: input must be rank 4, but got rank ` + `${x4D.rank}.`);
    $8cCb2.assert($filter.rank === 4, ()=>`Error in fused conv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    $frznq.checkPadOnDimRoundingMode('fused conv2d', pad, dimRoundingMode);
    const inputChannels = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $8cCb2.assert($filter.shape[2] === inputChannels, ()=>`Error in conv2d: depth of input (${inputChannels}) must match ` + `input depth for filter ${$filter.shape[2]}.`);
    $8cCb2.assert($frznq.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in conv2D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = $frznq.computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode);
    let $bias;
    if (bias != null) {
        $bias = (0, $5xBLk.convertToTensor)(bias, 'bias', 'fused conv2d');
        [$bias] = (0, $3w4Rg.makeTypesMatch)($bias, $x);
        // According to TensorFlow, the bias is supposed be a 1-D tensor or a
        // scalar.
        //
        // 3-D or 4-D bias is not disabled for NHWC format, because they are
        // currently being used in some cases. For examplem in our code base,
        // https://github.com/tensorflow/tfjs/blob/b53bd47e880367ae57493f0ea628abaf08db2d5d/tfjs-core/src/ops/fused/fused_conv2d_test.ts#L1972.
        if (dataFormat === 'NHWC') $8BaGO.assertAndGetBroadcastShape(convInfo.outShape, $bias.shape);
        else {
            $8cCb2.assert($bias.shape.length <= 1, ()=>`Error in fused conv2d: only supports scalar or 1-D Tensor ` + `bias for NCHW format but got the bias of ` + `rank-${$bias.shape.length}.`);
            $8cCb2.assert($bias.shape.length === 0 || $bias.shape[0] === convInfo.outChannels || $bias.shape[0] === 1, ()=>`Error in fused conv2d: bias shape (${$bias.shape}) is not ` + `compatible with the number of output channels ` + `(${convInfo.outChannels})`);
        }
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) {
        // PReLU's activation weights could be a scalar, a 1-D tensor or a 3-D
        // tensor.
        const alphaShape = preluActivationWeights.shape;
        $8cCb2.assert(alphaShape.length <= 1 || alphaShape.length === 3, ()=>`Error in fused conv2d: only supports scalar, 1-D Tensor or ` + `3-D Tensor PReLU activation weights but got a tensor of ` + `rank-${alphaShape.length}.`);
        if (alphaShape.length === 1) // Whether the data format is NCHW or NHWC, the 1-D PReLU activation
        // weights tensor should be aligned with the output channels of conv2d
        // result.
        $8cCb2.assert(alphaShape[0] === 1 || alphaShape[0] === convInfo.outChannels, ()=>`Error in fused conv2d: PReLU activation weights ` + `(${alphaShape}) is not compatible with the number of output ` + `channels (${convInfo.outChannels}).`);
        else if (alphaShape.length === 3) // Whether the data format is NCHW or NHWC, the PReLU activation weights
        // tensor should has the compatible shape with the result of conv2d.
        try {
            $8BaGO.assertAndGetBroadcastShape(alphaShape, convInfo.outShape);
        } catch (e) {
            const errMsg = `Error in fused conv2d: PReLU activation weights (${alphaShape}) ` + `is not compatible with the output shape of the conv2d ` + `(${convInfo.outShape}).`;
            throw Error(errMsg);
        }
        $preluActivationWeights = (0, $5xBLk.convertToTensor)(preluActivationWeights, 'prelu weights', 'fused conv2d');
    }
    const grad = (dy, saved)=>{
        $8cCb2.assert(dataFormat === 'NHWC', ()=>`Error in gradient of fused conv2D: got dataFormat of ${dataFormat} but only NHWC is currently supported.`);
        const [$filter, x4D, y, $bias] = saved;
        const dyActivation = (0, $bzoAL.getFusedDyActivation)(dy, y, activation);
        $8cCb2.assert($frznq.tupleValuesAreOne(dilations), ()=>'Error in gradient of fused conv2D: ' + `dilation rates greater than 1 ` + `are not yet supported in gradients. Got dilations '${dilations}'`);
        const xDer = (0, $6eptr.conv2DBackpropInput)(x4D.shape, dyActivation, $filter, strides, pad);
        const filterDer = (0, $4Tgmn.conv2DBackpropFilter)(x4D, dyActivation, $filter.shape, strides, pad);
        const der = [
            xDer,
            filterDer
        ];
        if ($bias != null) {
            const biasDer = (0, $bzoAL.getFusedBiasGradient)($bias, dyActivation);
            der.push(biasDer);
        }
        return der;
    };
    const inputs = {
        x: x4D,
        filter: $filter,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $92fpA.customGrad)((x4D, filter, save)=>{
            let res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $38WwN.ENGINE).runKernel((0, $hl418.FusedConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $4sqA7.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOp(x4D, $filter);
    } else {
        const customOpWithBias = (0, $92fpA.customGrad)((x4D, filter, bias, save)=>{
            let res = (0, $38WwN.ENGINE).runKernel((0, $hl418.FusedConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res,
                bias
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $4sqA7.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOpWithBias(x4D, $filter, $bias);
    }
}
const $4df4bb602b8b2d4d$export$188f9215482e3db8 = /* @__PURE__ */ (0, $jqSCG.op)({
    fusedConv2d_: $4df4bb602b8b2d4d$var$fusedConv2d_
});

});
parcelRegister("4Tgmn", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropFilter", () => $38f8fd3cc4e72bb6$export$652a30c9379f3de7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $8cCb2 = parcelRequire("8cCb2");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the derivative of the filter of a 2D convolution.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     [batch, height, width, inChannels]. If rank 3, batch of 1 is assumed.
 * @param dy The dy image, of rank 4 or rank 3, of shape
 *     [batch, height, width, outDepth]. If rank 3, batch of 1 is assumed.
 * @param filterShape The shape of the filter, length 4,
 *     [filterHeight, filterWidth, inDepth, outDepth].
 * @param strides The strides of the convolution: [strideHeight,
 * strideWidth].
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $38f8fd3cc4e72bb6$var$conv2DBackpropFilter_(x, dy, filterShape, strides, pad, dataFormat = 'NHWC', dimRoundingMode) {
    let x4D = x;
    if (x.rank === 3) x4D = (0, $4sqA7.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    let dy4D = dy;
    if (dy4D.rank === 3) dy4D = (0, $4sqA7.reshape)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2]
    ]);
    $8cCb2.assert(x4D.rank === 4, ()=>`Error in conv2dDerFilter: input must be rank 4, but got shape ` + `${x4D.shape}.`);
    $8cCb2.assert(dy4D.rank === 4, ()=>`Error in conv2dDerFilter: dy must be rank 4, but got shape ` + `${dy4D.shape}.`);
    $8cCb2.assert(filterShape.length === 4, ()=>`Error in conv2dDerFilter: filterShape must be length 4, but got ` + `${filterShape}.`);
    const inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    const outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
    $8cCb2.assert(inDepth === filterShape[2], ()=>`Error in conv2dDerFilter: depth of input ${inDepth}) must ` + `match input depth in filter (${filterShape[2]}.`);
    $8cCb2.assert(outDepth === filterShape[3], ()=>`Error in conv2dDerFilter: depth of dy (${outDepth}) must ` + `match output depth for filter (${filterShape[3]}).`);
    $frznq.checkPadOnDimRoundingMode('conv2dDerFilter', pad, dimRoundingMode);
    const inputs = {
        x: x4D,
        dy: dy4D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dimRoundingMode: dimRoundingMode,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Conv2DBackpropFilter), inputs, attrs);
}
const $38f8fd3cc4e72bb6$export$652a30c9379f3de7 = /* @__PURE__ */ (0, $jqSCG.op)({
    conv2DBackpropFilter_: $38f8fd3cc4e72bb6$var$conv2DBackpropFilter_
});

});


parcelRegister("d71bK", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2d", () => $98bcd9d17e6878df$export$48a8ad9494a8fad8);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $92fpA = parcelRequire("92fpA");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $hgacW = parcelRequire("hgacW");

var $8BaGO = parcelRequire("8BaGO");

var $frznq = parcelRequire("frznq");

var $182Rc = parcelRequire("182Rc");

var $j2Gyr = parcelRequire("j2Gyr");

var $1C2e1 = parcelRequire("1C2e1");

var $bzoAL = parcelRequire("bzoAL");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes depthwise 2D convolution, optionally fused with adding a
 * bias and applying an activation.
 *
 * Given a 4D `input` array and a `filter` array of shape
 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
 * `inChannels` convolutional filters of depth 1, this op applies a
 * different filter to each input channel (expanding from 1 channel to
 * `channelMultiplier` channels for each), then concatenates the results
 * together. The output has `inChannels * channelMultiplier` channels.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
 * for more details.
 *
 * @param obj An object with the following properties:
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param bias Tensor to be added to the result.
 * @param activation Name of activation kernel (defaults to `linear`).
 * @param preluActivationWeights Tensor of prelu weights to be applied as part
 *     of a `prelu` activation, typically the same shape as `x`.
 * @param leakyreluAlpha Optional. Alpha to be applied as part of a `leakyrelu`
 *     activation.
 */ function $98bcd9d17e6878df$var$fusedDepthwiseConv2d_({ x: x, filter: filter, strides: strides, pad: pad, dataFormat: dataFormat = 'NHWC', dilations: dilations = [
    1,
    1
], dimRoundingMode: dimRoundingMode, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha }) {
    if ((0, $bzoAL.shouldFuse)((0, $38WwN.ENGINE).state.gradientDepth, activation) === false) {
        let result = (0, $182Rc.depthwiseConv2d)(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
        if (bias != null) result = (0, $hgacW.add)(result, bias);
        return (0, $bzoAL.applyActivation)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'depthwiseConv2d', 'float32');
    const $filter = (0, $5xBLk.convertToTensor)(filter, 'filter', 'depthwiseConv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $8cCb2.assert(x4D.rank === 4, ()=>`Error in fused depthwiseConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $8cCb2.assert($filter.rank === 4, ()=>`Error in fused depthwiseConv2d: filter must be rank 4, ` + `but got rank ${$filter.rank}.`);
    $8cCb2.assert(x4D.shape[3] === $filter.shape[2], ()=>`Error in fused depthwiseConv2d: number of input channels ` + `(${x4D.shape[3]}) must match the inChannels dimension in ` + `filter ${$filter.shape[2]}.`);
    if (dilations == null) dilations = [
        1,
        1
    ];
    $8cCb2.assert($frznq.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in fused depthwiseConv2d: Either strides or dilations must ' + `be 1. Got strides ${strides} and dilations '${dilations}'`);
    $frznq.checkPadOnDimRoundingMode('fused depthwiseConv2d', pad, dimRoundingMode);
    const convInfo = $frznq.computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode, true);
    let $bias;
    if (bias != null) {
        $bias = (0, $5xBLk.convertToTensor)(bias, 'bias', 'fused conv2d');
        [$bias] = (0, $3w4Rg.makeTypesMatch)($bias, $x);
        $8BaGO.assertAndGetBroadcastShape(convInfo.outShape, $bias.shape);
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) $preluActivationWeights = (0, $5xBLk.convertToTensor)(preluActivationWeights, 'prelu weights', 'fused depthwiseConv2d');
    const grad = (dy, saved)=>{
        $8cCb2.assert($frznq.tupleValuesAreOne(dilations), ()=>'Error in gradient of fused depthwiseConv2d: dilation rates ' + `greater than 1 are not yet supported. Got dilations ` + `'${dilations}'`);
        const [$filter, x4D, y, bias] = saved;
        const dyActivation = (0, $bzoAL.getFusedDyActivation)(dy, y, activation);
        const xDer = (0, $1C2e1.depthwiseConv2dNativeBackpropInput)(x4D.shape, dyActivation, $filter, strides, pad, dilations, dimRoundingMode);
        const filterDer = (0, $j2Gyr.depthwiseConv2dNativeBackpropFilter)(x4D, dyActivation, $filter.shape, strides, pad, dilations, dimRoundingMode);
        if (bias != null) {
            const biasDer = (0, $bzoAL.getFusedBiasGradient)($bias, dyActivation);
            return [
                xDer,
                filterDer,
                biasDer
            ];
        }
        return [
            xDer,
            filterDer
        ];
    };
    const inputs = {
        x: x4D,
        filter: $filter,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $92fpA.customGrad)((x4D, filter, save)=>{
            // tslint:disable-next-line: no-unnecessary-type-assertion
            let res = (0, $38WwN.ENGINE).runKernel((0, $hl418.FusedDepthwiseConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $4sqA7.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOp(x4D, $filter);
    } else {
        const customOpWithBias = (0, $92fpA.customGrad)((x4D, filter, bias, save)=>{
            // tslint:disable-next-line: no-unnecessary-type-assertion
            let res = (0, $38WwN.ENGINE).runKernel((0, $hl418.FusedDepthwiseConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res,
                bias
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $4sqA7.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOpWithBias(x4D, $filter, $bias);
    }
}
const $98bcd9d17e6878df$export$48a8ad9494a8fad8 = /* @__PURE__ */ (0, $jqSCG.op)({
    fusedDepthwiseConv2d_: $98bcd9d17e6878df$var$fusedDepthwiseConv2d_
});

});
parcelRegister("j2Gyr", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropFilter", () => $ddcf36ad6325e4f6$export$cc0ae65e9edc7e1a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
function $ddcf36ad6325e4f6$var$depthwiseConv2dNativeBackpropFilter_(x, dy, filterShape, strides, pad, dilations = [
    1,
    1
], dimRoundingMode) {
    let x4D = x;
    if (x.rank === 3) x4D = (0, $4sqA7.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    let dy4D = dy;
    if (dy4D.rank === 3) dy4D = (0, $4sqA7.reshape)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2]
    ]);
    const inputs = {
        x: x4D,
        dy: dy4D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dilations: dilations,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.DepthwiseConv2dNativeBackpropFilter), inputs, attrs);
}
const $ddcf36ad6325e4f6$export$cc0ae65e9edc7e1a = (0, $jqSCG.op)({
    depthwiseConv2dNativeBackpropFilter_: $ddcf36ad6325e4f6$var$depthwiseConv2dNativeBackpropFilter_
});

});

parcelRegister("1C2e1", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropInput", () => $12cb10ef30bd47e6$export$37e2ab95a4a4c24b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
function $12cb10ef30bd47e6$var$depthwiseConv2dNativeBackpropInput_(xShape, dy, filter, strides, pad, dilations = [
    1,
    1
], dimRoundingMode) {
    let dy4D = dy;
    let reshapedTo4D = false;
    if (dy.rank === 3) {
        reshapedTo4D = true;
        dy4D = (0, $4sqA7.reshape)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2]
        ]);
    }
    const inputs = {
        dy: dy4D,
        filter: filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dilations: dilations,
        inputShape: xShape
    };
    const res = // tslint:disable-next-line: no-unnecessary-type-assertion
    (0, $38WwN.ENGINE).runKernel((0, $hl418.DepthwiseConv2dNativeBackpropInput), inputs, attrs);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $12cb10ef30bd47e6$export$37e2ab95a4a4c24b = (0, $jqSCG.op)({
    depthwiseConv2dNativeBackpropInput_: $12cb10ef30bd47e6$var$depthwiseConv2dNativeBackpropInput_
});

});


parcelRegister("1q6Gm", function(module, exports) {

$parcel$export(module.exports, "matMul", () => $108d671c8c951392$export$6706882a873e9a8f);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $92fpA = parcelRequire("92fpA");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $hgacW = parcelRequire("hgacW");

var $8BaGO = parcelRequire("8BaGO");

var $bzoAL = parcelRequire("bzoAL");

var $aUFou = parcelRequire("aUFou");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the dot product of two matrices with optional activation and bias.
 *
 * ```js
 * const a = tf.tensor2d([-1, -2], [1, 2]);
 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const bias = tf.tensor2d([1, 2], [1, 2]);
 *
 * tf.fused.matMul({a, b, bias, activation: 'relu'}).print();
 * ```
 *
 * @param obj An object with the following properties:
 * - `a` First matrix in dot product operation.
 * - `b` Second matrix in dot product operation.
 * - `transposeA` If true, `a` is transposed before multiplication.
 * - `transposeB` If true, `b` is transposed before multiplication.
 * - `bias` Matrix to be added to the result.
 * - `activation` Name of activation kernel (defaults to `linear`).
 * - `preluActivationWeights` Tensor of prelu weights.
 * - `leakyreluAlpha` Alpha of leakyrelu.
 */ function $108d671c8c951392$var$fusedMatMul_({ a: a, b: b, transposeA: transposeA = false, transposeB: transposeB = false, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha = 0.2 }) {
    if ((0, $bzoAL.shouldFuse)((0, $38WwN.ENGINE).state.gradientDepth, activation) === false) {
        let result = (0, $aUFou.matMul)(a, b, transposeA, transposeB);
        if (bias != null) result = (0, $hgacW.add)(result, bias);
        return (0, $bzoAL.applyActivation)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'fused matMul');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'fused matMul');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    const innerShapeA = transposeA ? $a.shape[$a.rank - 2] : $a.shape[$a.rank - 1];
    const innerShapeB = transposeB ? $b.shape[$b.rank - 1] : $b.shape[$b.rank - 2];
    const outerShapeA = transposeA ? $a.shape[$a.rank - 1] : $a.shape[$a.rank - 2];
    const outerShapeB = transposeB ? $b.shape[$b.rank - 2] : $b.shape[$b.rank - 1];
    const outerDimsA = $a.shape.slice(0, -2);
    const outerDimsB = $b.shape.slice(0, -2);
    const batchDimA = $8cCb2.sizeFromShape(outerDimsA);
    const batchDimB = $8cCb2.sizeFromShape(outerDimsB);
    $8cCb2.assert(innerShapeA === innerShapeB, ()=>`Error in fused matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${$a.shape} and ` + `${$b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const outShapeOuterDims = $8BaGO.assertAndGetBroadcastShape($a.shape.slice(0, -2), $b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    const a3D = transposeA ? (0, $4sqA7.reshape)($a, [
        batchDimA,
        innerShapeA,
        outerShapeA
    ]) : (0, $4sqA7.reshape)($a, [
        batchDimA,
        outerShapeA,
        innerShapeA
    ]);
    const b3D = transposeB ? (0, $4sqA7.reshape)($b, [
        batchDimB,
        outerShapeB,
        innerShapeB
    ]) : (0, $4sqA7.reshape)($b, [
        batchDimB,
        innerShapeB,
        outerShapeB
    ]);
    let $bias;
    if (bias != null) {
        $bias = (0, $5xBLk.convertToTensor)(bias, 'bias', 'fused matMul');
        [$bias] = (0, $3w4Rg.makeTypesMatch)($bias, $a);
        $8BaGO.assertAndGetBroadcastShape(outShape, $bias.shape);
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) $preluActivationWeights = (0, $5xBLk.convertToTensor)(preluActivationWeights, 'prelu weights', 'fused matMul');
    const grad = (dy, saved)=>{
        const [a3D, b3D, y, $bias] = saved;
        // we reshape dy because the result of the forward is not
        // necessarily going to be a 3d tensor due to a reshape done at the end of
        // the customOp.
        const dyActivation = (0, $bzoAL.getFusedDyActivation)((0, $4sqA7.reshape)(dy, y.shape), y, activation);
        let aDer;
        let bDer;
        if (!transposeA && !transposeB) {
            aDer = (0, $aUFou.matMul)(dyActivation, b3D, false, true);
            bDer = (0, $aUFou.matMul)(a3D, dyActivation, true, false);
        } else if (!transposeA && transposeB) {
            aDer = (0, $aUFou.matMul)(dyActivation, b3D, false, false);
            bDer = (0, $aUFou.matMul)(dyActivation, a3D, true, false);
        } else if (transposeA && !transposeB) {
            aDer = (0, $aUFou.matMul)(b3D, dyActivation, false, true);
            bDer = (0, $aUFou.matMul)(a3D, dyActivation, false, false);
        } else {
            aDer = (0, $aUFou.matMul)(b3D, dyActivation, true, true);
            bDer = (0, $aUFou.matMul)(dyActivation, a3D, true, true);
        }
        if (bias != null) {
            const biasDer = (0, $bzoAL.getFusedBiasGradient)($bias, dyActivation);
            return [
                aDer,
                bDer,
                biasDer
            ];
        } else return [
            aDer,
            bDer
        ];
    };
    const inputs = {
        a: a3D,
        b: b3D,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        transposeA: transposeA,
        transposeB: transposeB,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $92fpA.customGrad)((a3D, b3D, save)=>{
            const res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $38WwN.ENGINE).runKernel((0, $hl418._FusedMatMul), inputs, attrs);
            save([
                a3D,
                b3D,
                res
            ]);
            return {
                value: (0, $4sqA7.reshape)(res, outShape),
                gradFunc: grad
            };
        });
        return customOp(a3D, b3D);
    } else {
        const customOpWithBias = (0, $92fpA.customGrad)((a3D, b3D, $bias, save)=>{
            const res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $38WwN.ENGINE).runKernel((0, $hl418._FusedMatMul), inputs, attrs);
            save([
                a3D,
                b3D,
                res,
                $bias
            ]);
            return {
                value: (0, $4sqA7.reshape)(res, outShape),
                gradFunc: grad
            };
        });
        return customOpWithBias(a3D, b3D, $bias);
    }
}
const $108d671c8c951392$export$6706882a873e9a8f = /* @__PURE__ */ (0, $jqSCG.op)({
    fusedMatMul_: $108d671c8c951392$var$fusedMatMul_
});

});
parcelRegister("aUFou", function(module, exports) {

$parcel$export(module.exports, "matMul", () => $7f1f3e54d78420da$export$6706882a873e9a8f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the dot product of two matrices, A * B. These must be matrices.
 *
 * ```js
 * const a = tf.tensor2d([1, 2], [1, 2]);
 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * a.matMul(b).print();  // or tf.matMul(a, b)
 * ```
 * @param a First matrix in dot product operation.
 * @param b Second matrix in dot product operation.
 * @param transposeA If true, `a` is transposed before multiplication.
 * @param transposeB If true, `b` is transposed before multiplication.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $7f1f3e54d78420da$var$matMul_(a, b, transposeA = false, transposeB = false) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'matMul');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'matMul');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {
        transposeA: transposeA,
        transposeB: transposeB
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.BatchMatMul), inputs, attrs);
}
const $7f1f3e54d78420da$export$6706882a873e9a8f = /* @__PURE__ */ (0, $jqSCG.op)({
    matMul_: $7f1f3e54d78420da$var$matMul_
});

});



parcelRegister("3qUjU", function(module, exports) {

$parcel$export(module.exports, "gather", () => $27ff7ccdc5033e17$export$9e05546f00427e8);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Gather slices from tensor `x`'s axis `axis` according to `indices`.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const indices = tf.tensor1d([1, 3, 3], 'int32');
 *
 * x.gather(indices).print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const indices = tf.tensor1d([1, 1, 0], 'int32');
 *
 * x.gather(indices).print();
 * ```
 * @param x The input tensor whose slices are to be gathered.
 * @param indices The indices of the values to extract.
 * @param axis The axis over which to select values. Defaults to 0.
 * @param batchDims Optional. The number of batch dimensions. It must be less
 *     than or equal to rank(indices). Defaults to 0.
 *     The output tensor will have shape of
 *     `x.shape[:axis] + indices.shape[batchDims:] + x.shape[axis + 1:]`
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $27ff7ccdc5033e17$var$gather_(x, indices, axis = 0, batchDims = 0) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'gather');
    const $indices = (0, $5xBLk.convertToTensor)(indices, 'indices', 'gather', 'int32');
    const inputs = {
        x: $x,
        indices: $indices
    };
    const attrs = {
        axis: axis,
        batchDims: batchDims
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.GatherV2), inputs, attrs);
}
const $27ff7ccdc5033e17$export$9e05546f00427e8 = /* @__PURE__ */ (0, $jqSCG.op)({
    gather_: $27ff7ccdc5033e17$var$gather_
});

});

parcelRegister("bRRKf", function(module, exports) {

$parcel$export(module.exports, "greater", () => $8a3e558d5bb76a4c$export$9dca161faaf6308b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the truth value of (a > b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.greater(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $8a3e558d5bb76a4c$var$greater_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'greater', 'string_or_numeric');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'greater', 'string_or_numeric');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Greater), inputs);
}
const $8a3e558d5bb76a4c$export$9dca161faaf6308b = /* @__PURE__ */ (0, $jqSCG.op)({
    greater_: $8a3e558d5bb76a4c$var$greater_
});

});

parcelRegister("l0Zxl", function(module, exports) {

$parcel$export(module.exports, "greaterEqual", () => $f4c954f893cb9ce6$export$c2fd4164cadc1fa2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the truth value of (a >= b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.greaterEqual(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $f4c954f893cb9ce6$var$greaterEqual_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'greaterEqual', 'string_or_numeric');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'greaterEqual', 'string_or_numeric');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.GreaterEqual), inputs);
}
const $f4c954f893cb9ce6$export$c2fd4164cadc1fa2 = /* @__PURE__ */ (0, $jqSCG.op)({
    greaterEqual_: $f4c954f893cb9ce6$var$greaterEqual_
});

});

parcelRegister("aosGd", function(module, exports) {

$parcel$export(module.exports, "spectral", () => $7912647d6e7a4ee9$export$e0ccf6166915bd59);
$parcel$export(module.exports, "signal", () => $7912647d6e7a4ee9$export$e2ef10f86a8d60e8);
$parcel$export(module.exports, "image", () => $7912647d6e7a4ee9$export$5c452ff88e35e47d);
$parcel$export(module.exports, "linalg", () => $7912647d6e7a4ee9$export$dbc5be37a4415193);
$parcel$export(module.exports, "losses", () => $7912647d6e7a4ee9$export$24b113a95118cbdc);
$parcel$export(module.exports, "sparse", () => $7912647d6e7a4ee9$export$b6b7e189aa5d134c);
$parcel$export(module.exports, "string", () => $7912647d6e7a4ee9$export$22b082955e083ec3);
$parcel$export(module.exports, "abs", () => (parcelRequire("7j49I")).abs);
$parcel$export(module.exports, "acos", () => (parcelRequire("lhgWX")).acos);
$parcel$export(module.exports, "acosh", () => (parcelRequire("c0yr6")).acosh);
$parcel$export(module.exports, "add", () => (parcelRequire("hgacW")).add);
$parcel$export(module.exports, "addN", () => (parcelRequire("rRJGt")).addN);
$parcel$export(module.exports, "all", () => (parcelRequire("baxp3")).all);
$parcel$export(module.exports, "any", () => (parcelRequire("3cXYO")).any);
$parcel$export(module.exports, "argMax", () => (parcelRequire("jctS7")).argMax);
$parcel$export(module.exports, "argMin", () => (parcelRequire("hNrdr")).argMin);
$parcel$export(module.exports, "asin", () => (parcelRequire("8ZwsA")).asin);
$parcel$export(module.exports, "asinh", () => (parcelRequire("9a9km")).asinh);
$parcel$export(module.exports, "atan", () => (parcelRequire("PYQvk")).atan);
$parcel$export(module.exports, "atan2", () => (parcelRequire("8ikBQ")).atan2);
$parcel$export(module.exports, "atanh", () => (parcelRequire("5vfVv")).atanh);
$parcel$export(module.exports, "avgPool", () => (parcelRequire("j4oHC")).avgPool);
$parcel$export(module.exports, "avgPool3d", () => (parcelRequire("ku2lx")).avgPool3d);
$parcel$export(module.exports, "basicLSTMCell", () => (parcelRequire("eHiMt")).basicLSTMCell);
$parcel$export(module.exports, "batchToSpaceND", () => (parcelRequire("31sZ7")).batchToSpaceND);
$parcel$export(module.exports, "batchNorm", () => (parcelRequire("5ULLz")).batchNorm);
$parcel$export(module.exports, "batchNorm2d", () => (parcelRequire("kKS8R")).batchNorm2d);
$parcel$export(module.exports, "batchNorm3d", () => (parcelRequire("3KWPF")).batchNorm3d);
$parcel$export(module.exports, "batchNorm4d", () => (parcelRequire("34sL5")).batchNorm4d);
$parcel$export(module.exports, "bincount", () => (parcelRequire("f3UMy")).bincount);
$parcel$export(module.exports, "bitwiseAnd", () => (parcelRequire("dmptO")).bitwiseAnd);
$parcel$export(module.exports, "broadcastArgs", () => (parcelRequire("k4fG6")).broadcastArgs);
$parcel$export(module.exports, "broadcastTo", () => (parcelRequire("aeB3Z")).broadcastTo);
$parcel$export(module.exports, "buffer", () => (parcelRequire("iG87S")).buffer);
$parcel$export(module.exports, "cast", () => (parcelRequire("inFmq")).cast);
$parcel$export(module.exports, "ceil", () => (parcelRequire("jDrkY")).ceil);
$parcel$export(module.exports, "clipByValue", () => (parcelRequire("cOWuO")).clipByValue);
$parcel$export(module.exports, "clone", () => (parcelRequire("5TuCW")).clone);
$parcel$export(module.exports, "complex", () => (parcelRequire("20oDZ")).complex);
$parcel$export(module.exports, "concat", () => (parcelRequire("iTu6j")).concat);
$parcel$export(module.exports, "concat1d", () => (parcelRequire("4TU82")).concat1d);
$parcel$export(module.exports, "concat2d", () => (parcelRequire("7PZdE")).concat2d);
$parcel$export(module.exports, "concat3d", () => (parcelRequire("ljqPW")).concat3d);
$parcel$export(module.exports, "concat4d", () => (parcelRequire("9Grxx")).concat4d);
$parcel$export(module.exports, "conv1d", () => (parcelRequire("ebPOp")).conv1d);
$parcel$export(module.exports, "conv2d", () => (parcelRequire("5Nkm1")).conv2d);
$parcel$export(module.exports, "conv2dTranspose", () => (parcelRequire("5rn1J")).conv2dTranspose);
$parcel$export(module.exports, "conv3d", () => (parcelRequire("kj7tM")).conv3d);
$parcel$export(module.exports, "conv3dTranspose", () => (parcelRequire("7Zgyq")).conv3dTranspose);
$parcel$export(module.exports, "cos", () => (parcelRequire("3BU7G")).cos);
$parcel$export(module.exports, "cosh", () => (parcelRequire("bTdqT")).cosh);
$parcel$export(module.exports, "cumprod", () => (parcelRequire("bhhSS")).cumprod);
$parcel$export(module.exports, "cumsum", () => (parcelRequire("7lqwF")).cumsum);
$parcel$export(module.exports, "denseBincount", () => (parcelRequire("8maH5")).denseBincount);
$parcel$export(module.exports, "depthToSpace", () => (parcelRequire("lIVEL")).depthToSpace);
$parcel$export(module.exports, "depthwiseConv2d", () => (parcelRequire("182Rc")).depthwiseConv2d);
$parcel$export(module.exports, "diag", () => (parcelRequire("4VHSw")).diag);
$parcel$export(module.exports, "dilation2d", () => (parcelRequire("leKzP")).dilation2d);
$parcel$export(module.exports, "div", () => (parcelRequire("1QPqB")).div);
$parcel$export(module.exports, "divNoNan", () => (parcelRequire("3pBq5")).divNoNan);
$parcel$export(module.exports, "dot", () => (parcelRequire("67T3W")).dot);
$parcel$export(module.exports, "einsum", () => (parcelRequire("1mzpU")).einsum);
$parcel$export(module.exports, "elu", () => (parcelRequire("7UQTl")).elu);
$parcel$export(module.exports, "ensureShape", () => (parcelRequire("8jXAt")).ensureShape);
$parcel$export(module.exports, "equal", () => (parcelRequire("7R9HC")).equal);
$parcel$export(module.exports, "erf", () => (parcelRequire("3q8h0")).erf);
$parcel$export(module.exports, "euclideanNorm", () => (parcelRequire("4PmMp")).euclideanNorm);
$parcel$export(module.exports, "exp", () => (parcelRequire("2PcQK")).exp);
$parcel$export(module.exports, "expandDims", () => (parcelRequire("iPDWZ")).expandDims);
$parcel$export(module.exports, "expm1", () => (parcelRequire("cUuFo")).expm1);
$parcel$export(module.exports, "eye", () => (parcelRequire("9gIZb")).eye);
$parcel$export(module.exports, "fill", () => (parcelRequire("gYive")).fill);
$parcel$export(module.exports, "floor", () => (parcelRequire("4ZUCz")).floor);
$parcel$export(module.exports, "floorDiv", () => (parcelRequire("6a2Ft")).floorDiv);
$parcel$export(module.exports, "gather", () => (parcelRequire("3qUjU")).gather);
$parcel$export(module.exports, "greater", () => (parcelRequire("bRRKf")).greater);
$parcel$export(module.exports, "greaterEqual", () => (parcelRequire("l0Zxl")).greaterEqual);
$parcel$export(module.exports, "imag", () => (parcelRequire("1d8KH")).imag);
$parcel$export(module.exports, "isFinite", () => (parcelRequire("eaZNC")).isFinite);
$parcel$export(module.exports, "isInf", () => (parcelRequire("ahjR1")).isInf);
$parcel$export(module.exports, "isNaN", () => (parcelRequire("5FmUe")).isNaN);
$parcel$export(module.exports, "leakyRelu", () => (parcelRequire("3XskU")).leakyRelu);
$parcel$export(module.exports, "less", () => (parcelRequire("jTDVJ")).less);
$parcel$export(module.exports, "lessEqual", () => (parcelRequire("7LQ38")).lessEqual);
$parcel$export(module.exports, "linspace", () => (parcelRequire("9ntOC")).linspace);
$parcel$export(module.exports, "localResponseNormalization", () => (parcelRequire("k8D3u")).localResponseNormalization);
$parcel$export(module.exports, "log", () => (parcelRequire("dcoCo")).log);
$parcel$export(module.exports, "log1p", () => (parcelRequire("5QUXI")).log1p);
$parcel$export(module.exports, "logSigmoid", () => (parcelRequire("7hYeW")).logSigmoid);
$parcel$export(module.exports, "logSoftmax", () => (parcelRequire("2NPdY")).logSoftmax);
$parcel$export(module.exports, "logSumExp", () => (parcelRequire("9dGIC")).logSumExp);
$parcel$export(module.exports, "logicalAnd", () => (parcelRequire("kg1Wp")).logicalAnd);
$parcel$export(module.exports, "logicalNot", () => (parcelRequire("7NVSX")).logicalNot);
$parcel$export(module.exports, "logicalOr", () => (parcelRequire("iok2K")).logicalOr);
$parcel$export(module.exports, "logicalXor", () => (parcelRequire("iIobM")).logicalXor);
$parcel$export(module.exports, "lowerBound", () => (parcelRequire("jAFVi")).lowerBound);
$parcel$export(module.exports, "matMul", () => (parcelRequire("aUFou")).matMul);
$parcel$export(module.exports, "max", () => (parcelRequire("05cMR")).max);
$parcel$export(module.exports, "maxPool", () => (parcelRequire("gscJF")).maxPool);
$parcel$export(module.exports, "maxPool3d", () => (parcelRequire("gF4tm")).maxPool3d);
$parcel$export(module.exports, "maxPoolWithArgmax", () => (parcelRequire("9K0B1")).maxPoolWithArgmax);
$parcel$export(module.exports, "maximum", () => (parcelRequire("g5Jt1")).maximum);
$parcel$export(module.exports, "mean", () => (parcelRequire("67GCc")).mean);
$parcel$export(module.exports, "meshgrid", () => (parcelRequire("e6A1c")).meshgrid);
$parcel$export(module.exports, "min", () => (parcelRequire("fySTI")).min);
$parcel$export(module.exports, "minimum", () => (parcelRequire("6V8xR")).minimum);
$parcel$export(module.exports, "mirrorPad", () => (parcelRequire("ejlRR")).mirrorPad);
$parcel$export(module.exports, "mod", () => (parcelRequire("jR4my")).mod);
$parcel$export(module.exports, "moments", () => (parcelRequire("jV1KY")).moments);
$parcel$export(module.exports, "mul", () => (parcelRequire("jZc0w")).mul);
$parcel$export(module.exports, "multiRNNCell", () => (parcelRequire("culYm")).multiRNNCell);
$parcel$export(module.exports, "multinomial", () => (parcelRequire("b2OB7")).multinomial);
$parcel$export(module.exports, "neg", () => (parcelRequire("15cGp")).neg);
$parcel$export(module.exports, "notEqual", () => (parcelRequire("8WSnu")).notEqual);
$parcel$export(module.exports, "oneHot", () => (parcelRequire("i3U4j")).oneHot);
$parcel$export(module.exports, "ones", () => (parcelRequire("fOBRA")).ones);
$parcel$export(module.exports, "onesLike", () => (parcelRequire("67iid")).onesLike);
$parcel$export(module.exports, "outerProduct", () => (parcelRequire("8lsKt")).outerProduct);
$parcel$export(module.exports, "pad", () => (parcelRequire("fSZF6")).pad);
$parcel$export(module.exports, "pad1d", () => (parcelRequire("d3x5E")).pad1d);
$parcel$export(module.exports, "pad2d", () => (parcelRequire("lbRCf")).pad2d);
$parcel$export(module.exports, "pad3d", () => (parcelRequire("kZSbJ")).pad3d);
$parcel$export(module.exports, "pad4d", () => (parcelRequire("ghY1H")).pad4d);
$parcel$export(module.exports, "pool", () => (parcelRequire("9PaVS")).pool);
$parcel$export(module.exports, "pow", () => (parcelRequire("ad1of")).pow);
$parcel$export(module.exports, "prelu", () => (parcelRequire("a3pvF")).prelu);
$parcel$export(module.exports, "print", () => (parcelRequire("bSp5U")).print);
$parcel$export(module.exports, "prod", () => (parcelRequire("bWQC3")).prod);
$parcel$export(module.exports, "raggedGather", () => (parcelRequire("3MjiG")).raggedGather);
$parcel$export(module.exports, "raggedRange", () => (parcelRequire("6df7Q")).raggedRange);
$parcel$export(module.exports, "raggedTensorToTensor", () => (parcelRequire("hRiiN")).raggedTensorToTensor);
$parcel$export(module.exports, "rand", () => (parcelRequire("bTXL0")).rand);
$parcel$export(module.exports, "randomGamma", () => (parcelRequire("SB4J3")).randomGamma);
$parcel$export(module.exports, "randomNormal", () => (parcelRequire("h2Vnz")).randomNormal);
$parcel$export(module.exports, "randomStandardNormal", () => (parcelRequire("kVqJN")).randomStandardNormal);
$parcel$export(module.exports, "randomUniform", () => (parcelRequire("j8sic")).randomUniform);
$parcel$export(module.exports, "randomUniformInt", () => (parcelRequire("edlzT")).randomUniformInt);
$parcel$export(module.exports, "range", () => (parcelRequire("80Ety")).range);
$parcel$export(module.exports, "real", () => (parcelRequire("b7x1G")).real);
$parcel$export(module.exports, "reciprocal", () => (parcelRequire("3aqJ6")).reciprocal);
$parcel$export(module.exports, "relu", () => (parcelRequire("8wbQq")).relu);
$parcel$export(module.exports, "relu6", () => (parcelRequire("fvNYr")).relu6);
$parcel$export(module.exports, "reshape", () => (parcelRequire("4sqA7")).reshape);
$parcel$export(module.exports, "reverse", () => (parcelRequire("6act6")).reverse);
$parcel$export(module.exports, "reverse1d", () => (parcelRequire("2KcE1")).reverse1d);
$parcel$export(module.exports, "reverse2d", () => (parcelRequire("8EvRg")).reverse2d);
$parcel$export(module.exports, "reverse3d", () => (parcelRequire("c9r0k")).reverse3d);
$parcel$export(module.exports, "reverse4d", () => (parcelRequire("bFrHw")).reverse4d);
$parcel$export(module.exports, "round", () => (parcelRequire("9YKoa")).round);
$parcel$export(module.exports, "rsqrt", () => (parcelRequire("5pj7R")).rsqrt);
$parcel$export(module.exports, "scalar", () => (parcelRequire("3xp7o")).scalar);
$parcel$export(module.exports, "selu", () => (parcelRequire("b636r")).selu);
$parcel$export(module.exports, "separableConv2d", () => (parcelRequire("8uLn4")).separableConv2d);
$parcel$export(module.exports, "setdiff1dAsync", () => (parcelRequire("d05b8")).setdiff1dAsync);
$parcel$export(module.exports, "sigmoid", () => (parcelRequire("jvtSq")).sigmoid);
$parcel$export(module.exports, "sign", () => (parcelRequire("3zBCT")).sign);
$parcel$export(module.exports, "sin", () => (parcelRequire("4xqM7")).sin);
$parcel$export(module.exports, "sinh", () => (parcelRequire("fAOzm")).sinh);
$parcel$export(module.exports, "slice", () => (parcelRequire("79KOG")).slice);
$parcel$export(module.exports, "slice1d", () => (parcelRequire("5vfHb")).slice1d);
$parcel$export(module.exports, "slice2d", () => (parcelRequire("gKBEV")).slice2d);
$parcel$export(module.exports, "slice3d", () => (parcelRequire("22oMq")).slice3d);
$parcel$export(module.exports, "slice4d", () => (parcelRequire("8hEpb")).slice4d);
$parcel$export(module.exports, "softmax", () => (parcelRequire("dnEu5")).softmax);
$parcel$export(module.exports, "softplus", () => (parcelRequire("4Udpd")).softplus);
$parcel$export(module.exports, "spaceToBatchND", () => (parcelRequire("ePI8Y")).spaceToBatchND);
$parcel$export(module.exports, "fft", () => (parcelRequire("1Lg9u")).fft);
$parcel$export(module.exports, "ifft", () => (parcelRequire("3l9Cr")).ifft);
$parcel$export(module.exports, "irfft", () => (parcelRequire("hrsi6")).irfft);
$parcel$export(module.exports, "rfft", () => (parcelRequire("cafDa")).rfft);
$parcel$export(module.exports, "split", () => (parcelRequire("9fmAX")).split);
$parcel$export(module.exports, "sqrt", () => (parcelRequire("iAb3z")).sqrt);
$parcel$export(module.exports, "square", () => (parcelRequire("iDd8d")).square);
$parcel$export(module.exports, "squaredDifference", () => (parcelRequire("ay2Nw")).squaredDifference);
$parcel$export(module.exports, "squeeze", () => (parcelRequire("kX8Hd")).squeeze);
$parcel$export(module.exports, "stack", () => (parcelRequire("8BrLX")).stack);
$parcel$export(module.exports, "step", () => (parcelRequire("lWdx1")).step);
$parcel$export(module.exports, "stridedSlice", () => (parcelRequire("dqRnt")).stridedSlice);
$parcel$export(module.exports, "sub", () => (parcelRequire("7kouu")).sub);
$parcel$export(module.exports, "sum", () => (parcelRequire("9NgTx")).sum);
$parcel$export(module.exports, "tan", () => (parcelRequire("l8Hok")).tan);
$parcel$export(module.exports, "tanh", () => (parcelRequire("etcYL")).tanh);
$parcel$export(module.exports, "tensor", () => (parcelRequire("erbmM")).tensor);
$parcel$export(module.exports, "tensor1d", () => (parcelRequire("lalFM")).tensor1d);
$parcel$export(module.exports, "tensor2d", () => (parcelRequire("gmMlv")).tensor2d);
$parcel$export(module.exports, "tensor3d", () => (parcelRequire("6Fl9Q")).tensor3d);
$parcel$export(module.exports, "tensor4d", () => (parcelRequire("6BSQ6")).tensor4d);
$parcel$export(module.exports, "tensor5d", () => (parcelRequire("fjd6b")).tensor5d);
$parcel$export(module.exports, "tensor6d", () => (parcelRequire("gCuDf")).tensor6d);
$parcel$export(module.exports, "tensorScatterUpdate", () => (parcelRequire("4om7p")).tensorScatterUpdate);
$parcel$export(module.exports, "tile", () => (parcelRequire("61ay4")).tile);
$parcel$export(module.exports, "topk", () => (parcelRequire("cRAvI")).topk);
$parcel$export(module.exports, "truncatedNormal", () => (parcelRequire("dE1HO")).truncatedNormal);
$parcel$export(module.exports, "unique", () => (parcelRequire("aEpp6")).unique);
$parcel$export(module.exports, "unsortedSegmentSum", () => (parcelRequire("djGEF")).unsortedSegmentSum);
$parcel$export(module.exports, "unstack", () => (parcelRequire("gBOC6")).unstack);
$parcel$export(module.exports, "upperBound", () => (parcelRequire("igCyu")).upperBound);
$parcel$export(module.exports, "variable", () => (parcelRequire("eoViB")).variable);
$parcel$export(module.exports, "where", () => (parcelRequire("l2P14")).where);
$parcel$export(module.exports, "whereAsync", () => (parcelRequire("5t2or")).whereAsync);
$parcel$export(module.exports, "zeros", () => (parcelRequire("hxi4c")).zeros);
$parcel$export(module.exports, "zerosLike", () => (parcelRequire("8EjnK")).zerosLike);
$parcel$export(module.exports, "op", () => (parcelRequire("jqSCG")).op);
$parcel$export(module.exports, "OP_SCOPE_SUFFIX", () => (parcelRequire("jqSCG")).OP_SCOPE_SUFFIX);
$parcel$export(module.exports, "fused", () => (parcelRequire("jDZRN")));
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Modularized ops.

var $7j49I = parcelRequire("7j49I");

var $lhgWX = parcelRequire("lhgWX");

var $c0yr6 = parcelRequire("c0yr6");

var $hgacW = parcelRequire("hgacW");

var $rRJGt = parcelRequire("rRJGt");

var $baxp3 = parcelRequire("baxp3");

var $3cXYO = parcelRequire("3cXYO");

var $jctS7 = parcelRequire("jctS7");

var $hNrdr = parcelRequire("hNrdr");

var $8ZwsA = parcelRequire("8ZwsA");

var $9a9km = parcelRequire("9a9km");

var $PYQvk = parcelRequire("PYQvk");

var $8ikBQ = parcelRequire("8ikBQ");

var $5vfVv = parcelRequire("5vfVv");

var $j4oHC = parcelRequire("j4oHC");

var $ku2lx = parcelRequire("ku2lx");

var $eHiMt = parcelRequire("eHiMt");

var $31sZ7 = parcelRequire("31sZ7");

var $5ULLz = parcelRequire("5ULLz");

var $kKS8R = parcelRequire("kKS8R");

var $3KWPF = parcelRequire("3KWPF");

var $34sL5 = parcelRequire("34sL5");

var $f3UMy = parcelRequire("f3UMy");

var $dmptO = parcelRequire("dmptO");

var $k4fG6 = parcelRequire("k4fG6");

var $aeB3Z = parcelRequire("aeB3Z");

var $iG87S = parcelRequire("iG87S");

var $inFmq = parcelRequire("inFmq");

var $jDrkY = parcelRequire("jDrkY");

var $cOWuO = parcelRequire("cOWuO");

var $5TuCW = parcelRequire("5TuCW");

var $20oDZ = parcelRequire("20oDZ");

var $iTu6j = parcelRequire("iTu6j");

var $4TU82 = parcelRequire("4TU82");

var $7PZdE = parcelRequire("7PZdE");

var $ljqPW = parcelRequire("ljqPW");

var $9Grxx = parcelRequire("9Grxx");

var $ebPOp = parcelRequire("ebPOp");

var $5Nkm1 = parcelRequire("5Nkm1");

var $5rn1J = parcelRequire("5rn1J");

var $kj7tM = parcelRequire("kj7tM");

var $7Zgyq = parcelRequire("7Zgyq");

var $3BU7G = parcelRequire("3BU7G");

var $bTdqT = parcelRequire("bTdqT");

var $bhhSS = parcelRequire("bhhSS");

var $7lqwF = parcelRequire("7lqwF");

var $8maH5 = parcelRequire("8maH5");

var $lIVEL = parcelRequire("lIVEL");

var $182Rc = parcelRequire("182Rc");

var $4VHSw = parcelRequire("4VHSw");

var $leKzP = parcelRequire("leKzP");

var $1QPqB = parcelRequire("1QPqB");

var $3pBq5 = parcelRequire("3pBq5");

var $67T3W = parcelRequire("67T3W");

var $1mzpU = parcelRequire("1mzpU");

var $7UQTl = parcelRequire("7UQTl");

var $8jXAt = parcelRequire("8jXAt");

var $7R9HC = parcelRequire("7R9HC");

var $3q8h0 = parcelRequire("3q8h0");

var $4PmMp = parcelRequire("4PmMp");

var $2PcQK = parcelRequire("2PcQK");

var $iPDWZ = parcelRequire("iPDWZ");

var $cUuFo = parcelRequire("cUuFo");

var $9gIZb = parcelRequire("9gIZb");

var $gYive = parcelRequire("gYive");

var $4ZUCz = parcelRequire("4ZUCz");

var $6a2Ft = parcelRequire("6a2Ft");

var $3qUjU = parcelRequire("3qUjU");

var $bRRKf = parcelRequire("bRRKf");

var $l0Zxl = parcelRequire("l0Zxl");

var $1d8KH = parcelRequire("1d8KH");

var $eaZNC = parcelRequire("eaZNC");

var $ahjR1 = parcelRequire("ahjR1");

var $5FmUe = parcelRequire("5FmUe");

var $3XskU = parcelRequire("3XskU");

var $jTDVJ = parcelRequire("jTDVJ");

var $7LQ38 = parcelRequire("7LQ38");

var $9ntOC = parcelRequire("9ntOC");

var $k8D3u = parcelRequire("k8D3u");

var $dcoCo = parcelRequire("dcoCo");

var $5QUXI = parcelRequire("5QUXI");

var $7hYeW = parcelRequire("7hYeW");

var $2NPdY = parcelRequire("2NPdY");

var $9dGIC = parcelRequire("9dGIC");

var $kg1Wp = parcelRequire("kg1Wp");

var $7NVSX = parcelRequire("7NVSX");

var $iok2K = parcelRequire("iok2K");

var $iIobM = parcelRequire("iIobM");

var $jAFVi = parcelRequire("jAFVi");

var $aUFou = parcelRequire("aUFou");

var $05cMR = parcelRequire("05cMR");

var $gscJF = parcelRequire("gscJF");

var $gF4tm = parcelRequire("gF4tm");

var $9K0B1 = parcelRequire("9K0B1");

var $g5Jt1 = parcelRequire("g5Jt1");

var $67GCc = parcelRequire("67GCc");

var $e6A1c = parcelRequire("e6A1c");

var $fySTI = parcelRequire("fySTI");

var $6V8xR = parcelRequire("6V8xR");

var $ejlRR = parcelRequire("ejlRR");

var $jR4my = parcelRequire("jR4my");

var $jV1KY = parcelRequire("jV1KY");

var $jZc0w = parcelRequire("jZc0w");

var $culYm = parcelRequire("culYm");

var $b2OB7 = parcelRequire("b2OB7");

var $15cGp = parcelRequire("15cGp");

var $8WSnu = parcelRequire("8WSnu");

var $i3U4j = parcelRequire("i3U4j");

var $fOBRA = parcelRequire("fOBRA");

var $67iid = parcelRequire("67iid");

var $8lsKt = parcelRequire("8lsKt");

var $fSZF6 = parcelRequire("fSZF6");

var $d3x5E = parcelRequire("d3x5E");

var $lbRCf = parcelRequire("lbRCf");

var $kZSbJ = parcelRequire("kZSbJ");

var $ghY1H = parcelRequire("ghY1H");

var $9PaVS = parcelRequire("9PaVS");

var $ad1of = parcelRequire("ad1of");

var $a3pvF = parcelRequire("a3pvF");

var $bSp5U = parcelRequire("bSp5U");

var $bWQC3 = parcelRequire("bWQC3");

var $3MjiG = parcelRequire("3MjiG");

var $6df7Q = parcelRequire("6df7Q");

var $hRiiN = parcelRequire("hRiiN");

var $bTXL0 = parcelRequire("bTXL0");

var $SB4J3 = parcelRequire("SB4J3");

var $h2Vnz = parcelRequire("h2Vnz");

var $kVqJN = parcelRequire("kVqJN");

var $j8sic = parcelRequire("j8sic");

var $edlzT = parcelRequire("edlzT");

var $80Ety = parcelRequire("80Ety");

var $b7x1G = parcelRequire("b7x1G");

var $3aqJ6 = parcelRequire("3aqJ6");

var $8wbQq = parcelRequire("8wbQq");

var $fvNYr = parcelRequire("fvNYr");

var $4sqA7 = parcelRequire("4sqA7");

var $6act6 = parcelRequire("6act6");

var $2KcE1 = parcelRequire("2KcE1");

var $8EvRg = parcelRequire("8EvRg");

var $c9r0k = parcelRequire("c9r0k");

var $bFrHw = parcelRequire("bFrHw");

var $9YKoa = parcelRequire("9YKoa");

var $5pj7R = parcelRequire("5pj7R");

var $3xp7o = parcelRequire("3xp7o");

var $b636r = parcelRequire("b636r");

var $8uLn4 = parcelRequire("8uLn4");

var $d05b8 = parcelRequire("d05b8");

var $jvtSq = parcelRequire("jvtSq");

var $3zBCT = parcelRequire("3zBCT");

var $4xqM7 = parcelRequire("4xqM7");

var $fAOzm = parcelRequire("fAOzm");

var $79KOG = parcelRequire("79KOG");

var $5vfHb = parcelRequire("5vfHb");

var $gKBEV = parcelRequire("gKBEV");

var $22oMq = parcelRequire("22oMq");

var $8hEpb = parcelRequire("8hEpb");

var $dnEu5 = parcelRequire("dnEu5");

var $4Udpd = parcelRequire("4Udpd");

var $ePI8Y = parcelRequire("ePI8Y");

var $1Lg9u = parcelRequire("1Lg9u");

var $3l9Cr = parcelRequire("3l9Cr");

var $hrsi6 = parcelRequire("hrsi6");

var $cafDa = parcelRequire("cafDa");

var $9fmAX = parcelRequire("9fmAX");

var $iAb3z = parcelRequire("iAb3z");

var $iDd8d = parcelRequire("iDd8d");

var $ay2Nw = parcelRequire("ay2Nw");

var $kX8Hd = parcelRequire("kX8Hd");

var $8BrLX = parcelRequire("8BrLX");

var $lWdx1 = parcelRequire("lWdx1");

var $dqRnt = parcelRequire("dqRnt");

var $7kouu = parcelRequire("7kouu");

var $9NgTx = parcelRequire("9NgTx");

var $l8Hok = parcelRequire("l8Hok");

var $etcYL = parcelRequire("etcYL");

var $erbmM = parcelRequire("erbmM");

var $lalFM = parcelRequire("lalFM");

var $gmMlv = parcelRequire("gmMlv");

var $6Fl9Q = parcelRequire("6Fl9Q");

var $6BSQ6 = parcelRequire("6BSQ6");

var $fjd6b = parcelRequire("fjd6b");

var $gCuDf = parcelRequire("gCuDf");

var $4om7p = parcelRequire("4om7p");

var $61ay4 = parcelRequire("61ay4");

var $cRAvI = parcelRequire("cRAvI");

var $dE1HO = parcelRequire("dE1HO");

var $aEpp6 = parcelRequire("aEpp6");

var $djGEF = parcelRequire("djGEF");

var $gBOC6 = parcelRequire("gBOC6");

var $igCyu = parcelRequire("igCyu");

var $eoViB = parcelRequire("eoViB");

var $l2P14 = parcelRequire("l2P14");

var $5t2or = parcelRequire("5t2or");

var $hxi4c = parcelRequire("hxi4c");

var $8EjnK = parcelRequire("8EjnK");

var $4xhB2 = parcelRequire("4xhB2");

var $aDHKy = parcelRequire("aDHKy");

var $7k6dx = parcelRequire("7k6dx");

var $gIiMY = parcelRequire("gIiMY");

var $4wiJQ = parcelRequire("4wiJQ");

var $6PrVj = parcelRequire("6PrVj");

var $kMXcY = parcelRequire("kMXcY");

var $5FwF9 = parcelRequire("5FwF9");

var $5kLyC = parcelRequire("5kLyC");

var $j5jow = parcelRequire("j5jow");

var $8mg8Q = parcelRequire("8mg8Q");

var $jqSCG = parcelRequire("jqSCG");

var $jDZRN = parcelRequire("jDZRN");

var $dGKlF = parcelRequire("dGKlF");

var $gicu0 = parcelRequire("gicu0");

var $lLT0m = parcelRequire("lLT0m");

var $hGoJt = parcelRequire("hGoJt");

var $jLoMm = parcelRequire("jLoMm");

var $jAPwM = parcelRequire("jAPwM");

var $7xYxa = parcelRequire("7xYxa");

var $iStMK = parcelRequire("iStMK");

var $gF4CQ = parcelRequire("gF4CQ");

var $3Dhm5 = parcelRequire("3Dhm5");

var $ihqU7 = parcelRequire("ihqU7");

var $gxykK = parcelRequire("gxykK");

var $8357p = parcelRequire("8357p");

var $gzUbZ = parcelRequire("gzUbZ");

var $bq0nG = parcelRequire("bq0nG");

var $6zgXB = parcelRequire("6zgXB");

var $ek5OW = parcelRequire("ek5OW");

var $2uj2A = parcelRequire("2uj2A");

var $53uSk = parcelRequire("53uSk");

var $kGYDg = parcelRequire("kGYDg");

var $bI4CH = parcelRequire("bI4CH");

var $ipM8K = parcelRequire("ipM8K");

var $beFbS = parcelRequire("beFbS");

var $aQ3Nu = parcelRequire("aQ3Nu");

var $315ft = parcelRequire("315ft");

var $aqAKz = parcelRequire("aqAKz");

var $2lNlw = parcelRequire("2lNlw");

var $8Bzf4 = parcelRequire("8Bzf4");

var $2Tkqe = parcelRequire("2Tkqe");

var $7tTB0 = parcelRequire("7tTB0");

var $5FlUs = parcelRequire("5FlUs");

var $gXzaa = parcelRequire("gXzaa");

var $fMgdQ = parcelRequire("fMgdQ");

var $22SmX = parcelRequire("22SmX");

var $6wGr9 = parcelRequire("6wGr9");

var $brFzl = parcelRequire("brFzl");

var $VUiwf = parcelRequire("VUiwf");

var $g7F6x = parcelRequire("g7F6x");

var $bZL8f = parcelRequire("bZL8f");
const $7912647d6e7a4ee9$export$e0ccf6166915bd59 = {
    fft: $1Lg9u.fft,
    ifft: $3l9Cr.ifft,
    rfft: $cafDa.rfft,
    irfft: $hrsi6.irfft
};
const $7912647d6e7a4ee9$export$e2ef10f86a8d60e8 = {
    hammingWindow: $dGKlF.hammingWindow,
    hannWindow: $gicu0.hannWindow,
    frame: $lLT0m.frame,
    stft: $hGoJt.stft
};
const $7912647d6e7a4ee9$export$5c452ff88e35e47d = {
    flipLeftRight: $jAPwM.flipLeftRight,
    grayscaleToRGB: $7xYxa.grayscaleToRGB,
    resizeNearestNeighbor: $ek5OW.resizeNearestNeighbor,
    resizeBilinear: $6zgXB.resizeBilinear,
    rgbToGrayscale: $iStMK.rgbToGrayscale,
    rotateWithOffset: $gF4CQ.rotateWithOffset,
    cropAndResize: $jLoMm.cropAndResize,
    nonMaxSuppression: $3Dhm5.nonMaxSuppression,
    nonMaxSuppressionAsync: $ihqU7.nonMaxSuppressionAsync,
    nonMaxSuppressionWithScore: $gxykK.nonMaxSuppressionWithScore,
    nonMaxSuppressionWithScoreAsync: $8357p.nonMaxSuppressionWithScoreAsync,
    nonMaxSuppressionPadded: $gzUbZ.nonMaxSuppressionPadded,
    nonMaxSuppressionPaddedAsync: $bq0nG.nonMaxSuppressionPaddedAsync,
    threshold: $2uj2A.threshold,
    transform: $53uSk.transform
};
const $7912647d6e7a4ee9$export$dbc5be37a4415193 = {
    bandPart: $kGYDg.bandPart,
    gramSchmidt: $bI4CH.gramSchmidt,
    qr: $ipM8K.qr
};
const $7912647d6e7a4ee9$export$24b113a95118cbdc = {
    absoluteDifference: $beFbS.absoluteDifference,
    computeWeightedLoss: $aQ3Nu.computeWeightedLoss,
    cosineDistance: $315ft.cosineDistance,
    hingeLoss: $aqAKz.hingeLoss,
    huberLoss: $2lNlw.huberLoss,
    logLoss: $8Bzf4.logLoss,
    meanSquaredError: $2Tkqe.meanSquaredError,
    sigmoidCrossEntropy: $7tTB0.sigmoidCrossEntropy,
    softmaxCrossEntropy: $5FlUs.softmaxCrossEntropy
};
const $7912647d6e7a4ee9$export$b6b7e189aa5d134c = {
    sparseFillEmptyRows: $gXzaa.sparseFillEmptyRows,
    sparseReshape: $fMgdQ.sparseReshape,
    sparseSegmentMean: $22SmX.sparseSegmentMean,
    sparseSegmentSum: $6wGr9.sparseSegmentSum
};
// tslint:disable-next-line:variable-name
const $7912647d6e7a4ee9$export$22b082955e083ec3 = {
    stringNGrams: $brFzl.stringNGrams,
    stringSplit: $VUiwf.stringSplit,
    stringToHashBucketFast: $g7F6x.stringToHashBucketFast,
    staticRegexReplace: $bZL8f.staticRegexReplace
};
$parcel$exportWildcard(module.exports, $4xhB2);
$parcel$exportWildcard(module.exports, $aDHKy);
$parcel$exportWildcard(module.exports, $7k6dx);
$parcel$exportWildcard(module.exports, $gIiMY);
$parcel$exportWildcard(module.exports, $4wiJQ);
$parcel$exportWildcard(module.exports, $6PrVj);
$parcel$exportWildcard(module.exports, $kMXcY);
$parcel$exportWildcard(module.exports, $5FwF9);
$parcel$exportWildcard(module.exports, $5kLyC);
$parcel$exportWildcard(module.exports, $j5jow);
$parcel$exportWildcard(module.exports, $8mg8Q);

});
parcelRegister("lhgWX", function(module, exports) {

$parcel$export(module.exports, "acos", () => $f7d85568d01690da$export$fd6306be3fde5b04);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes acos of the input `tf.Tensor` element-wise: `acos(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.acos().print();  // or tf.acos(x)
 * ```
 * @param x The input tensor.
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $f7d85568d01690da$var$acos_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'acos');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Acos), inputs);
}
const $f7d85568d01690da$export$fd6306be3fde5b04 = /* @__PURE__ */ (0, $jqSCG.op)({
    acos_: $f7d85568d01690da$var$acos_
});

});

parcelRegister("c0yr6", function(module, exports) {

$parcel$export(module.exports, "acosh", () => $8be0326fb8f6cca9$export$b26caf0f29211d08);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the inverse hyperbolic cos of the input `tf.Tensor` element-wise:
 * `acosh(x)`
 *
 * ```js
 * const x = tf.tensor1d([10, 1, 3, 5.7]);
 *
 * x.acosh().print();  // or tf.acosh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $8be0326fb8f6cca9$var$acosh_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'acosh');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Acosh), inputs);
}
const $8be0326fb8f6cca9$export$b26caf0f29211d08 = /* @__PURE__ */ (0, $jqSCG.op)({
    acosh_: $8be0326fb8f6cca9$var$acosh_
});

});

parcelRegister("rRJGt", function(module, exports) {

$parcel$export(module.exports, "addN", () => $053c348cc86e4948$export$37b75d0026f96b8d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Adds a list of `tf.Tensor`s element-wise, each with the same shape and dtype.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 *
 * tf.addN([a, b, c]).print();
 * ```
 * @param tensors A list of tensors with the same shape and dtype.
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $053c348cc86e4948$var$addN_(tensors) {
    $8cCb2.assert(Array.isArray(tensors), ()=>'The argument passed to tf.addN() must be a list of tensors');
    $8cCb2.assert(tensors.length >= 1, ()=>`Must pass at least one tensor to tf.addN(), but got ` + `${tensors.length}`);
    const $tensors = tensors.map((t, i)=>(0, $5xBLk.convertToTensor)(t, `tensors${i}`, 'addN'));
    const firstTensor = $tensors[0];
    $tensors.forEach((t)=>{
        if (t.dtype !== firstTensor.dtype) throw new Error('All tensors passed to tf.addN() must have the same dtype');
    });
    $tensors.forEach((t)=>{
        if (!$8cCb2.arraysEqual(t.shape, firstTensor.shape)) throw new Error('All tensors passed to tf.addN() must have the same shape');
    });
    const inputs = $tensors;
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.AddN), inputs);
}
const $053c348cc86e4948$export$37b75d0026f96b8d = /* @__PURE__ */ (0, $jqSCG.op)({
    addN_: $053c348cc86e4948$var$addN_
});

});

parcelRegister("hNrdr", function(module, exports) {

$parcel$export(module.exports, "argMin", () => $cf4c1fc826cdf2d0$export$ec99a91cddfb29a2);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the indices of the minimum values along an `axis`.
 *
 * The result has the same shape as `input` with the dimension along `axis`
 * removed.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.argMin().print();  // or tf.argMin(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
 *
 * const axis = 1;
 * x.argMin(axis).print();  // or tf.argMin(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $cf4c1fc826cdf2d0$var$argMin_(x, axis = 0) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'argMin');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.ArgMin), inputs, attrs);
}
const $cf4c1fc826cdf2d0$export$ec99a91cddfb29a2 = /* @__PURE__ */ (0, $jqSCG.op)({
    argMin_: $cf4c1fc826cdf2d0$var$argMin_
});

});

parcelRegister("8ZwsA", function(module, exports) {

$parcel$export(module.exports, "asin", () => $68bd33264cc50f31$export$41726bdb1fc63f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes asin of the input `tf.Tensor` element-wise: `asin(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.asin().print();  // or tf.asin(x)
 * ```
 * @param x The input tensor.
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $68bd33264cc50f31$var$asin_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'asin');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Asin), inputs);
}
const $68bd33264cc50f31$export$41726bdb1fc63f = /* @__PURE__ */ (0, $jqSCG.op)({
    asin_: $68bd33264cc50f31$var$asin_
});

});

parcelRegister("9a9km", function(module, exports) {

$parcel$export(module.exports, "asinh", () => $6abc48723e475246$export$839d8a01b6af4fc0);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes inverse hyperbolic sin of the input `tf.Tensor` element-wise:
 * `asinh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.asinh().print();  // or tf.asinh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $6abc48723e475246$var$asinh_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'asinh');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Asinh), inputs);
}
const $6abc48723e475246$export$839d8a01b6af4fc0 = /* @__PURE__ */ (0, $jqSCG.op)({
    asinh_: $6abc48723e475246$var$asinh_
});

});

parcelRegister("PYQvk", function(module, exports) {

$parcel$export(module.exports, "atan", () => $09c3f64090287437$export$628dc4eed22b0fbd);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes atan of the input `tf.Tensor` element-wise: `atan(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.atan().print();  // or tf.atan(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $09c3f64090287437$var$atan_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'atan');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Atan), inputs);
}
const $09c3f64090287437$export$628dc4eed22b0fbd = /* @__PURE__ */ (0, $jqSCG.op)({
    atan_: $09c3f64090287437$var$atan_
});

});

parcelRegister("8ikBQ", function(module, exports) {

$parcel$export(module.exports, "atan2", () => $609ffdbffef81474$export$b8b770ee6a0d9760);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes arctangent of `tf.Tensor`s a / b element-wise: `atan2(a, b)`.
 * Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1.0, 1.0, -1.0, .7]);
 * const b = tf.tensor1d([2.0, 13.0, 3.5, .21]);
 *
 * tf.atan2(a, b).print()
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $609ffdbffef81474$var$atan2_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'atan2');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'atan2');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Atan2), inputs);
}
const $609ffdbffef81474$export$b8b770ee6a0d9760 = /* @__PURE__ */ (0, $jqSCG.op)({
    atan2_: $609ffdbffef81474$var$atan2_
});

});

parcelRegister("5vfVv", function(module, exports) {

$parcel$export(module.exports, "atanh", () => $401c33b19c5b0094$export$21ea955025ceb08b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes inverse hyperbolic tan of the input `tf.Tensor` element-wise:
 * `atanh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, .1, -.1, .7]);
 *
 * x.atanh().print();  // or tf.atanh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $401c33b19c5b0094$var$atanh_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'atanh');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Atanh), inputs);
}
const $401c33b19c5b0094$export$21ea955025ceb08b = /* @__PURE__ */ (0, $jqSCG.op)({
    atanh_: $401c33b19c5b0094$var$atanh_
});

});

parcelRegister("eHiMt", function(module, exports) {

$parcel$export(module.exports, "basicLSTMCell", () => $ab33a6501fc905fb$export$5f13ab10a3272278);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $hgacW = parcelRequire("hgacW");

var $iTu6j = parcelRequire("iTu6j");

var $aUFou = parcelRequire("aUFou");

var $jZc0w = parcelRequire("jZc0w");

var $jqSCG = parcelRequire("jqSCG");

var $jvtSq = parcelRequire("jvtSq");

var $79KOG = parcelRequire("79KOG");

var $etcYL = parcelRequire("etcYL");
/**
 * Computes the next state and output of a BasicLSTMCell.
 *
 * Returns `[newC, newH]`.
 *
 * Derived from tf.contrib.rnn.BasicLSTMCell.
 *
 * @param forgetBias Forget bias for the cell.
 * @param lstmKernel The weights for the cell.
 * @param lstmBias The bias for the cell.
 * @param data The input to the cell.
 * @param c Previous cell state.
 * @param h Previous cell output.
 *
 * @doc {heading: 'Operations', subheading: 'RNN'}
 */ function $ab33a6501fc905fb$var$basicLSTMCell_(forgetBias, lstmKernel, lstmBias, data, c, h) {
    const $forgetBias = (0, $5xBLk.convertToTensor)(forgetBias, 'forgetBias', 'basicLSTMCell');
    const $lstmKernel = (0, $5xBLk.convertToTensor)(lstmKernel, 'lstmKernel', 'basicLSTMCell');
    const $lstmBias = (0, $5xBLk.convertToTensor)(lstmBias, 'lstmBias', 'basicLSTMCell');
    const $data = (0, $5xBLk.convertToTensor)(data, 'data', 'basicLSTMCell');
    const $c = (0, $5xBLk.convertToTensor)(c, 'c', 'basicLSTMCell');
    const $h = (0, $5xBLk.convertToTensor)(h, 'h', 'basicLSTMCell');
    const combined = (0, $iTu6j.concat)([
        $data,
        $h
    ], 1);
    const weighted = (0, $aUFou.matMul)(combined, $lstmKernel);
    const res = (0, $hgacW.add)(weighted, $lstmBias);
    // i = input_gate, j = new_input, f = forget_gate, o = output_gate
    const batchSize = res.shape[0];
    const sliceCols = res.shape[1] / 4;
    const sliceSize = [
        batchSize,
        sliceCols
    ];
    const i = (0, $79KOG.slice)(res, [
        0,
        0
    ], sliceSize);
    const j = (0, $79KOG.slice)(res, [
        0,
        sliceCols
    ], sliceSize);
    const f = (0, $79KOG.slice)(res, [
        0,
        sliceCols * 2
    ], sliceSize);
    const o = (0, $79KOG.slice)(res, [
        0,
        sliceCols * 3
    ], sliceSize);
    const newC = (0, $hgacW.add)((0, $jZc0w.mul)((0, $jvtSq.sigmoid)(i), (0, $etcYL.tanh)(j)), (0, $jZc0w.mul)($c, (0, $jvtSq.sigmoid)((0, $hgacW.add)($forgetBias, f))));
    const newH = (0, $jZc0w.mul)((0, $etcYL.tanh)(newC), (0, $jvtSq.sigmoid)(o));
    return [
        newC,
        newH
    ];
}
const $ab33a6501fc905fb$export$5f13ab10a3272278 = /* @__PURE__ */ (0, $jqSCG.op)({
    basicLSTMCell_: $ab33a6501fc905fb$var$basicLSTMCell_
});

});
parcelRegister("79KOG", function(module, exports) {

$parcel$export(module.exports, "slice", () => $535db06fef6716ec$export$58adb3bec8346d0f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Extracts a slice from a `tf.Tensor` starting at coordinates `begin`
 * and is of size `size`.
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that `x` is of the given rank:
 *   - `tf.slice1d`
 *   - `tf.slice2d`
 *   - `tf.slice3d`
 *   - `tf.slice4d`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.slice([1], [2]).print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * x.slice([1, 0], [1, 2]).print();
 * ```
 * @param x The input `tf.Tensor` to slice from.
 * @param begin The coordinates to start the slice from. The length can be
 *     less than the rank of x - the rest of the axes will have implicit 0 as
 *     start. Can also be a single number, in which case it specifies the
 *     first axis.
 * @param size The size of the slice. The length can be less than the rank of
 *     x - the rest of the axes will have implicit -1. A value of -1 requests
 *     the rest of the dimensions in the axis. Can also be a single number,
 *     in which case it specifies the size of the first axis.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $535db06fef6716ec$var$slice_(x, begin, size) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'slice', 'string_or_numeric');
    if ($x.rank === 0) throw new Error('Slicing scalar is not possible');
    const inputs = {
        x: $x
    };
    const attrs = {
        begin: begin,
        size: size
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Slice), inputs, attrs);
}
const $535db06fef6716ec$export$58adb3bec8346d0f = /* @__PURE__ */ (0, $jqSCG.op)({
    slice_: $535db06fef6716ec$var$slice_
});

});

parcelRegister("etcYL", function(module, exports) {

$parcel$export(module.exports, "tanh", () => $a88dd77d13a4ba8f$export$7128670e45beef9a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes hyperbolic tangent of the input `tf.Tensor` element-wise: `tanh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, 70]);
 *
 * x.tanh().print();  // or tf.tanh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $a88dd77d13a4ba8f$var$tanh_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'tanh', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Tanh), inputs);
}
const $a88dd77d13a4ba8f$export$7128670e45beef9a = /* @__PURE__ */ (0, $jqSCG.op)({
    tanh_: $a88dd77d13a4ba8f$var$tanh_
});

});


parcelRegister("31sZ7", function(module, exports) {

$parcel$export(module.exports, "batchToSpaceND", () => $2337f2e1e82e1c80$export$ea37d960c1808536);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * This operation reshapes the "batch" dimension 0 into `M + 1` dimensions of
 * shape `blockShape + [batch]`, interleaves these blocks back into the grid
 * defined by the spatial dimensions `[1, ..., M]`, to obtain a result with
 * the same rank as the input. The spatial dimensions of this intermediate
 * result are then optionally cropped according to `crops` to produce the
 * output. This is the reverse of `tf.spaceToBatchND`. See below for a precise
 * description.
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [4, 1, 1, 1]);
 * const blockShape = [2, 2];
 * const crops = [[0, 0], [0, 0]];
 *
 * x.batchToSpaceND(blockShape, crops).print();
 * ```
 *
 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
 * remainingShape`, where spatialShape has `M` dimensions.
 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
 * be >= 1.
 * @param crops A 2-D array.  Must have shape `[M, 2]`, all values must be >= 0.
 * `crops[i] = [cropStart, cropEnd]` specifies the amount to crop from input
 * dimension `i + 1`, which corresponds to spatial dimension `i`. It is required
 * that `cropStart[i] + cropEnd[i] <= blockShape[i] * inputShape[i + 1]`
 *
 * This operation is equivalent to the following steps:
 *
 * 1. Reshape `x` to `reshaped` of shape: `[blockShape[0], ...,
 * blockShape[M-1], batch / prod(blockShape), x.shape[1], ...,
 * x.shape[N-1]]`
 *
 * 2. Permute dimensions of `reshaped` to produce `permuted` of shape `[batch /
 * prod(blockShape),x.shape[1], blockShape[0], ..., x.shape[M],
 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * 3. Reshape `permuted` to produce `reshapedPermuted` of shape `[batch /
 * prod(blockShape),x.shape[1] * blockShape[0], ..., x.shape[M] *
 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * 4. Crop the start and end of dimensions `[1, ..., M]` of `reshapedPermuted`
 * according to `crops` to produce the output of shape: `[batch /
 * prod(blockShape),x.shape[1] * blockShape[0] - crops[0,0] - crops[0,1],
 * ..., x.shape[M] * blockShape[M-1] - crops[M-1,0] -
 * crops[M-1,1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $2337f2e1e82e1c80$var$batchToSpaceND_(x, blockShape, crops) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'batchToSpaceND');
    const prod = blockShape.reduce((a, b)=>a * b);
    $8cCb2.assert($x.rank >= 1 + blockShape.length, ()=>`input rank is ${$x.rank} but should be > than blockShape.length ${blockShape.length}`);
    $8cCb2.assert(crops.length === blockShape.length, ()=>`crops.length is ${crops.length} but should be equal to blockShape.length  ${blockShape.length}`);
    $8cCb2.assert($x.shape[0] % prod === 0, ()=>`input tensor batch is ${$x.shape[0]} but is not divisible by the product of ` + `the elements of blockShape ${blockShape.join(' * ')} === ${prod}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockShape: blockShape,
        crops: crops
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.BatchToSpaceND), inputs, attrs);
}
const $2337f2e1e82e1c80$export$ea37d960c1808536 = /* @__PURE__ */ (0, $jqSCG.op)({
    batchToSpaceND_: $2337f2e1e82e1c80$var$batchToSpaceND_
});

});

parcelRegister("f3UMy", function(module, exports) {

$parcel$export(module.exports, "bincount", () => $af732e8d9c378509$export$7e474bab088ed182);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Outputs a vector with length `size` and the same dtype as `weights`.
 *
 * If `weights` are empty, then index `i` stores the number of times the value
 * `i` is counted in `x`. If `weights` are non-empty, then index `i` stores the
 * sum of the value in `weights` at each index where the corresponding value in
 * `x` is `i`.
 *
 * Values in `x` outside of the range [0, size) are ignored.
 *
 * @param x The input int tensor, rank 1.
 * @param weights The weights tensor, must have the same shape as x, or a
 *     length-0 Tensor, in which case it acts as all weights equal to 1.
 * @param size Non-negative integer.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $af732e8d9c378509$var$bincount_(x, weights, size) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'bincount');
    const $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'bincount');
    $8cCb2.assert($x.dtype === 'int32', ()=>`Error in bincount: input ` + `dtype must be int32, but got ${$x.dtype}`);
    $8cCb2.assert(size >= 0, ()=>`size must be non-negative, but got ${size}.`);
    $8cCb2.assert($weights.size === $x.size || $weights.size === 0, ()=>`Error in bincount: weights must have the same size as input or` + `0-length, but got input shape: ${$x.shape}, weights shape: ` + `${$weights.shape}.`);
    const inputs = {
        x: $x,
        weights: $weights
    };
    const attrs = {
        size: size
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Bincount), inputs, attrs);
}
const $af732e8d9c378509$export$7e474bab088ed182 = /* @__PURE__ */ (0, $jqSCG.op)({
    bincount_: $af732e8d9c378509$var$bincount_
});

});

parcelRegister("dmptO", function(module, exports) {

$parcel$export(module.exports, "bitwiseAnd", () => $9ba11836a7a0e3b8$export$84529b0ad3b42cd1);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Bitwise `AND` operation for input tensors.
 *
 * Given two input tensors, returns a new tensor
 * with the `AND` calculated values.
 *
 * The method supports int32 values
 *
 *
 * ```js
 * const x = tf.tensor1d([0, 5, 3, 14], 'int32');
 * const y = tf.tensor1d([5, 0, 7, 11], 'int32');
 * tf.bitwiseAnd(x, y).print();
 * ```
 *
 * @param x The input tensor to be calculated.
 * @param y The input tensor to be calculated.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $9ba11836a7a0e3b8$var$bitwiseAnd_(x, y) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'bitwiseAnd');
    const $y = (0, $5xBLk.convertToTensor)(y, 'y', 'bitwiseAnd');
    if (!(0, $8cCb2.arraysEqual)($x.shape, $y.shape)) throw new Error(`BitwiseAnd: Tensors must have the same shape. x: ${$x.shape}, y: ${$y.shape}`);
    if ($x.dtype !== 'int32' || $y.dtype !== 'int32') throw new Error(`BitwiseAnd: Only supports 'int32' values in tensor, found type of x: ${$x.dtype} and type of y: ${$y.dtype}`);
    const inputs = {
        a: $x,
        b: $y
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.BitwiseAnd), inputs);
}
const $9ba11836a7a0e3b8$export$84529b0ad3b42cd1 = /* @__PURE__ */ (0, $jqSCG.op)({
    bitwiseAnd_: $9ba11836a7a0e3b8$var$bitwiseAnd_
});

});

parcelRegister("k4fG6", function(module, exports) {

$parcel$export(module.exports, "broadcastArgs", () => $e9c057b2b5ab831a$export$d226d344aedce941);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Return the shape of s0 op s1 with broadcast.
 *
 * compute r0, the broadcasted shape as a tensor.
 * s0, s1 and r0 are all integer vectors.
 *
 * This function returns the shape of the result of an operation between
 * two tensors of size s0 and s1 performed with broadcast.
 *
 * @param s0 A tensor representing a shape
 * @param s1 A tensor representing a shape
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $e9c057b2b5ab831a$var$broadcastArgs_(s0, s1) {
    const shape1Input = (0, $5xBLk.convertToTensor)(s0, 's0', 'broadcastArgs', 'int32');
    const shape2Input = (0, $5xBLk.convertToTensor)(s1, 's1', 'broadcastArgs', 'int32');
    if (shape1Input.rank !== 1) throw new Error('broadcastArgs(): first input must be a vector (rank=1). ' + `Has rank ${shape1Input.rank}`);
    if (shape2Input.rank !== 1) throw new Error('broadcastArgs(): second input must be a vector (rank=1). ' + `Has rank ${shape2Input.rank}`);
    const inputs = {
        s0: shape1Input,
        s1: shape2Input
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.BroadcastArgs), inputs);
}
const $e9c057b2b5ab831a$export$d226d344aedce941 = /* @__PURE__ */ (0, $jqSCG.op)({
    broadcastArgs_: $e9c057b2b5ab831a$var$broadcastArgs_
});

});

parcelRegister("jDrkY", function(module, exports) {

$parcel$export(module.exports, "ceil", () => $e4b6dd76ad5b047e$export$803ce6b71a0a94b2);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes ceiling of input `tf.Tensor` element-wise: `ceil(x)`
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.ceil().print();  // or tf.ceil(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $e4b6dd76ad5b047e$var$ceil_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'ceil', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Ceil), inputs);
}
const $e4b6dd76ad5b047e$export$803ce6b71a0a94b2 = /* @__PURE__ */ (0, $jqSCG.op)({
    ceil_: $e4b6dd76ad5b047e$var$ceil_
});

});

parcelRegister("3BU7G", function(module, exports) {

$parcel$export(module.exports, "cos", () => $2a105ca58e08bbc3$export$50d414a77b60d802);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes cos of the input `tf.Tensor` element-wise: `cos(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.cos().print();  // or tf.cos(x)
 * ```
 * @param x The input tensor. Must be float32 type.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $2a105ca58e08bbc3$var$cos_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'cos', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Cos), inputs);
}
const $2a105ca58e08bbc3$export$50d414a77b60d802 = /* @__PURE__ */ (0, $jqSCG.op)({
    cos_: $2a105ca58e08bbc3$var$cos_
});

});

parcelRegister("bTdqT", function(module, exports) {

$parcel$export(module.exports, "cosh", () => $8a7f403fda14de62$export$2e2fd1ad24e4d350);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes hyperbolic cos of the input `tf.Tensor` element-wise: `cosh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.cosh().print();  // or tf.cosh(x)
 * ```
 * @param x The input tensor. Must be float32 type.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $8a7f403fda14de62$var$cosh_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'cosh', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Cosh), inputs);
}
const $8a7f403fda14de62$export$2e2fd1ad24e4d350 = /* @__PURE__ */ (0, $jqSCG.op)({
    cosh_: $8a7f403fda14de62$var$cosh_
});

});

parcelRegister("bhhSS", function(module, exports) {

$parcel$export(module.exports, "cumprod", () => $835f27a7a6e6bb41$export$dc7513e907e94b8d);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the cumulative product of a `tf.Tensor` along `axis`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4]);
 * x.cumprod().print();
 * ```
 * ```js
 * const x = tf.tensor([[1, 2], [3, 4]]);
 * x.cumprod().print();
 * ```
 *
 * @param x The input tensor to cumulatively multiply.
 * @param axis The axis along which to multiply. Optional. Defaults to 0.
 * @param exclusive Whether to perform exclusive cumulative product. Optional.
 *     Defaults to false. If set to true then the product of each tensor entry
 *     does not include its own value, but only the values previous to it
 *     along the specified axis.
 * @param reverse Whether to multiply in the opposite direction. Optional.
 *     Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Scan'}
 */ function $835f27a7a6e6bb41$var$cumprod_(x, axis = 0, exclusive = false, reverse = false) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'cumprod');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        exclusive: exclusive,
        reverse: reverse
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Cumprod), inputs, attrs);
}
const $835f27a7a6e6bb41$export$dc7513e907e94b8d = /* @__PURE__ */ (0, $jqSCG.op)({
    cumprod_: $835f27a7a6e6bb41$var$cumprod_
});

});

parcelRegister("7lqwF", function(module, exports) {

$parcel$export(module.exports, "cumsum", () => $558f12105d46bb41$export$71990b1e1c4912fe);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the cumulative sum of a `tf.Tensor` along `axis`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4]);
 * x.cumsum().print();
 * ```
 * ```js
 * const x = tf.tensor([[1, 2], [3, 4]]);
 * x.cumsum().print();
 * ```
 *
 * @param x The input tensor to be summed.
 * @param axis The axis along which to sum. Optional. Defaults to 0.
 * @param exclusive Whether to perform exclusive cumulative sum. Optional.
 *     Defaults to false. If set to true then the sum of each tensor entry
 *     does not include its own value, but only the values previous to it
 *     along the specified axis.
 * @param reverse Whether to sum in the opposite direction. Optional.
 *     Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Scan'}
 */ function $558f12105d46bb41$var$cumsum_(x, axis = 0, exclusive = false, reverse = false) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'cumsum');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        exclusive: exclusive,
        reverse: reverse
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Cumsum), inputs, attrs);
}
const $558f12105d46bb41$export$71990b1e1c4912fe = /* @__PURE__ */ (0, $jqSCG.op)({
    cumsum_: $558f12105d46bb41$var$cumsum_
});

});

parcelRegister("lIVEL", function(module, exports) {

$parcel$export(module.exports, "depthToSpace", () => $fd0a6e62c5011c86$export$3b50daec0f185f12);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Rearranges data from depth into blocks of spatial data. More specifically,
 * this op outputs a copy of the input tensor where values from the `depth`
 * dimension are moved in spatial blocks to the `height` and `width` dimensions.
 * The attr `blockSize` indicates the input block size and how the data is
 * moved.
 *
 *  - Chunks of data of size `blockSize * blockSize` from depth are rearranged
 * into non-overlapping blocks of size `blockSize x blockSize`
 *
 *  - The width the output tensor is `inputWidth * blockSize`, whereas the
 * height is `inputHeight * blockSize`
 *
 *  - The Y, X coordinates within each block of the output image are determined
 * by the high order component of the input channel index
 *
 *  - The depth of the input tensor must be divisible by `blockSize *
 * blockSize`
 *
 * The `dataFormat` attr specifies the layout of the input and output tensors
 * with the following options: "NHWC": [ `batch, height, width, channels` ]
 * "NCHW": [ `batch, channels, height, width` ]
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [1, 1, 1, 4]);
 * const blockSize = 2;
 * const dataFormat = "NHWC";
 *
 * tf.depthToSpace(x, blockSize, dataFormat).print();
 * ```
 *
 * @param x The input tensor of rank 4
 * @param blockSIze  An `int` that is `>= 2`. The size of the spatial block
 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to "NHWC"
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $fd0a6e62c5011c86$var$depthToSpace_(x, blockSize, dataFormat = 'NHWC') {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'depthToSpace', 'float32');
    const inputHeight = dataFormat === 'NHWC' ? $x.shape[1] : $x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? $x.shape[2] : $x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? $x.shape[3] : $x.shape[1];
    $8cCb2.assert(blockSize > 1, ()=>`blockSize should be > 1 for depthToSpace, but was: ${blockSize}`);
    $8cCb2.assert(inputHeight * blockSize >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${inputHeight} and ${blockSize}  for depthToSpace with input shape
    ${$x.shape}`);
    $8cCb2.assert(inputWidth * blockSize >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${inputWidth} and ${blockSize} for depthToSpace with input shape
        ${$x.shape}`);
    $8cCb2.assert(inputDepth % (blockSize * blockSize) === 0, ()=>`Dimension size must be evenly divisible by ${blockSize * blockSize} but is ${inputDepth} for depthToSpace with input shape ${$x.shape}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockSize: blockSize,
        dataFormat: dataFormat
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.DepthToSpace), inputs, attrs);
}
const $fd0a6e62c5011c86$export$3b50daec0f185f12 = /* @__PURE__ */ (0, $jqSCG.op)({
    depthToSpace_: $fd0a6e62c5011c86$var$depthToSpace_
});

});

parcelRegister("4VHSw", function(module, exports) {

$parcel$export(module.exports, "diag", () => $396e859bb9bd07d1$export$c042e7c2f59bc046);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns a diagonal tensor with given diagonal values.
 *
 * Given a diagonal, this operation returns a tensor with the diagonal and
 * everything else padded with zeros.
 *
 * Assume the input has dimensions `[D1,..., Dk]`, then the output is a tensor
 * of rank 2k with dimensions `[D1,..., Dk, D1,..., Dk]`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * tf.diag(x).print()
 * ```
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 7, 8], [4, 2])
 *
 * tf.diag(x).print()
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $396e859bb9bd07d1$var$diag_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'diag');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Diag), inputs);
}
const $396e859bb9bd07d1$export$c042e7c2f59bc046 = /* @__PURE__ */ (0, $jqSCG.op)({
    diag_: $396e859bb9bd07d1$var$diag_
});

});

parcelRegister("leKzP", function(module, exports) {

$parcel$export(module.exports, "dilation2d", () => $f75f08fee6d6d2ca$export$d9b8f675671875b9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the grayscale dilation over the input `x`.
 *
 * @param x The input tensor, rank 3 or rank 4 of shape
 *     `[batch, height, width, depth]`. If rank 3, batch of 1 is assumed.
 * @param filter The filter tensor, rank 3, of shape
 *     `[filterHeight, filterWidth, depth]`.
 * @param strides The strides of the sliding window for each dimension of the
 *     input tensor: `[strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat Specify the data format of the input and output data.
 *      Defaults to 'NHWC'. Only 'NHWC' is currently supported. With the
 *      default format "NHWC", the data is stored in the order of: [batch,
 *      height, width, channels].
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     for atrous morphological dilation. Defaults to `[1, 1]`. If `dilations`
 *     is a single number, then `dilationHeight == dilationWidth`. If it is
 *     greater than 1, then all values of `strides` must be 1.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $f75f08fee6d6d2ca$var$dilation2d_(x, filter, strides, pad, dilations = [
    1,
    1
], dataFormat = 'NHWC') {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'dilation2d');
    const $filter = (0, $5xBLk.convertToTensor)(filter, 'filter', 'dilation2d');
    $8cCb2.assert($x.rank === 3 || $x.rank === 4, ()=>`Error in dilation2d: input must be rank 3 or 4, but got rank ` + `${$x.rank}.`);
    $8cCb2.assert($filter.rank === 3, ()=>`Error in dilation2d: filter must be rank 3, but got rank ` + `${$filter.rank}.`);
    $8cCb2.assert(dataFormat === 'NHWC', ()=>`Error in dilation2d: Only NHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        x4D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
        reshapedTo4D = true;
    }
    $8cCb2.assert(x4D.shape[3] === $filter.shape[2], ()=>`Error in dilation2d:  input and filter must have the same depth: ${x4D.shape[3]} vs ${$filter.shape[2]}`);
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dilations: dilations
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.Dilation2D), inputs, attrs);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $f75f08fee6d6d2ca$export$d9b8f675671875b9 = /* @__PURE__ */ (0, $jqSCG.op)({
    dilation2d_: $f75f08fee6d6d2ca$var$dilation2d_
});

});

parcelRegister("3pBq5", function(module, exports) {

$parcel$export(module.exports, "divNoNan", () => $27c0bba8a735dbc2$export$9c5df3eb9e56f19e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $1QPqB = parcelRequire("1QPqB");

var $7R9HC = parcelRequire("7R9HC");

var $jqSCG = parcelRequire("jqSCG");

var $l2P14 = parcelRequire("l2P14");

var $8EjnK = parcelRequire("8EjnK");
/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting. Return 0
 * if denominator is 0.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 * const c = tf.tensor1d([0, 0, 0, 0]);
 *
 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 * const c = tf.scalar(0);
 *
 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $27c0bba8a735dbc2$var$divNoNan_(a, b) {
    // TODO: Make this into its own kernel.
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'div');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'div');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    const divResult = (0, $1QPqB.div)($a, $b);
    const zeros = (0, $8EjnK.zerosLike)(divResult);
    const bEqualsZero = (0, $7R9HC.equal)($b, zeros);
    return (0, $l2P14.where)(bEqualsZero, zeros, divResult);
}
const $27c0bba8a735dbc2$export$9c5df3eb9e56f19e = /* @__PURE__ */ (0, $jqSCG.op)({
    divNoNan_: $27c0bba8a735dbc2$var$divNoNan_
});

});
parcelRegister("l2P14", function(module, exports) {

$parcel$export(module.exports, "where", () => $f5215ba964de19ce$export$9c59b80dda569a6e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $aeB3Z = parcelRequire("aeB3Z");

var $8BaGO = parcelRequire("8BaGO");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the elements, either `a` or `b` depending on the `condition`.
 *
 * If the condition is true, select from `a`, otherwise select from `b`.
 *
 * ```js
 * const cond = tf.tensor1d([false, false, true], 'bool');
 * const a = tf.tensor1d([1 , 2, 3]);
 * const b = tf.tensor1d([-1, -2, -3]);
 *
 * a.where(cond, b).print();
 * ```
 *
 * @param condition The input condition. Must be of dtype bool.
 * @param a If `condition` is rank 1, `a` may have a higher rank but
 *     its first dimension must match the size of `condition`.
 * @param b A tensor with the same dtype as `a` and with shape that is
 *     compatible with `a`.
 * @return A tensor with same dtype as `a` and `b`, and shape that is
 *     broadcastable from `a` and `b`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $f5215ba964de19ce$var$where_(condition, a, b) {
    const $a = (0, $5xBLk.convertToTensor)(a, 'a', 'where');
    const $b = (0, $5xBLk.convertToTensor)(b, 'b', 'where');
    const $condition = (0, $5xBLk.convertToTensor)(condition, 'condition', 'where', 'bool');
    // TODO: move this logic to forward function when the broadcastTo op is
    // implemented in WASM.
    // Find the broadcastable shape for $condition, $a, and $b.
    const broadcastShape = (0, $8BaGO.assertAndGetBroadcastShape)((0, $8BaGO.assertAndGetBroadcastShape)($condition.shape, $a.shape), $b.shape);
    const $broadcastedCondition = (0, $aeB3Z.broadcastTo)($condition, broadcastShape);
    const $broadcastedA = (0, $aeB3Z.broadcastTo)($a, broadcastShape);
    const $broadcastedB = (0, $aeB3Z.broadcastTo)($b, broadcastShape);
    const inputs = {
        condition: $broadcastedCondition,
        t: $broadcastedA,
        e: $broadcastedB
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Select), inputs);
}
const $f5215ba964de19ce$export$9c59b80dda569a6e = /* @__PURE__ */ (0, $jqSCG.op)({
    where_: $f5215ba964de19ce$var$where_
});

});


parcelRegister("67T3W", function(module, exports) {

$parcel$export(module.exports, "dot", () => $475e1bc880e1fa62$export$94132a0e348806d4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $aUFou = parcelRequire("aUFou");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the dot product of two matrices and/or vectors, `t1` and `t2`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor2d([[1, 2], [3, 4]]);
 * const c = tf.tensor2d([[1, 2, 3], [4, 5, 6]]);
 *
 * a.dot(b).print();  // or tf.dot(a, b)
 * b.dot(a).print();
 * b.dot(c).print();
 * ```
 * @param t1 The first tensor in the dot operation.
 * @param t2 The second tensor in the dot operation.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $475e1bc880e1fa62$var$dot_(t1, t2) {
    const $t1 = (0, $5xBLk.convertToTensor)(t1, 't1', 'dot');
    const $t2 = (0, $5xBLk.convertToTensor)(t2, 't2', 'dot');
    $8cCb2.assert(($t1.rank === 1 || $t1.rank === 2) && ($t2.rank === 1 || $t2.rank === 2), ()=>`Error in dot: inputs must all be rank 1 or 2, but got ranks ` + `${$t1.rank} and ${$t2.rank}.`);
    const t1Inner = $t1.rank === 1 ? $t1.size : $t1.shape[1];
    const t2Inner = $t2.rank === 1 ? $t2.size : $t2.shape[0];
    $8cCb2.assert(t1Inner === t2Inner, ()=>`Error in dot: inner dimensions of inputs must match, but got ` + `${t1Inner} and ${t2Inner}.`);
    if ($t1.rank === 1 && $t2.rank === 1) {
        const t12D = (0, $4sqA7.reshape)($t1, [
            1,
            -1
        ]);
        const t22D = (0, $4sqA7.reshape)($t2, [
            -1,
            1
        ]);
        const t1t2 = (0, $aUFou.matMul)(t12D, t22D);
        return (0, $4sqA7.reshape)(t1t2, []);
    } else if ($t1.rank === 1 && $t2.rank === 2) {
        const t12D = (0, $4sqA7.reshape)($t1, [
            1,
            -1
        ]);
        const t22D = (0, $4sqA7.reshape)($t2, [
            $t2.shape[0],
            $t2.shape[1]
        ]);
        const t1t2 = (0, $aUFou.matMul)(t12D, t22D);
        return (0, $4sqA7.reshape)(t1t2, [
            t1t2.size
        ]);
    } else if ($t1.rank === 2 && $t2.rank === 1) {
        const t22D = (0, $4sqA7.reshape)($t2, [
            -1,
            1
        ]);
        const t1t2 = (0, $aUFou.matMul)($t1, t22D);
        return (0, $4sqA7.reshape)(t1t2, [
            t1t2.size
        ]);
    } else {
        const t22D = (0, $4sqA7.reshape)($t2, [
            $t2.shape[0],
            $t2.shape[1]
        ]);
        const t1t2 = (0, $aUFou.matMul)($t1, t22D);
        return t1t2;
    }
}
const $475e1bc880e1fa62$export$94132a0e348806d4 = /* @__PURE__ */ (0, $jqSCG.op)({
    dot_: $475e1bc880e1fa62$var$dot_
});

});

parcelRegister("1mzpU", function(module, exports) {

$parcel$export(module.exports, "einsum", () => $0fe351921eebd33a$export$27265e7daac5c403);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
function $0fe351921eebd33a$export$f6fde01e521435e1(equation, ...tensors) {
    const $tensors = tensors.map((t, i)=>(0, $5xBLk.convertToTensor)(t, `tensors${i}`, 'einsum'));
    const attrs = {
        equation: equation
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Einsum), $tensors, attrs);
}
const $0fe351921eebd33a$export$27265e7daac5c403 = /* @__PURE__ */ (0, $jqSCG.op)({
    einsum_: $0fe351921eebd33a$export$f6fde01e521435e1
});

});

parcelRegister("8jXAt", function(module, exports) {

$parcel$export(module.exports, "ensureShape", () => $60ee51dd648d18e0$export$6699c34d603c5978);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Checks the input tensor mathes the given shape.
 *
 * Given an input tensor, returns a new tensor with the same values as the
 * input tensor with shape `shape`.
 *
 * The method supports the null value in tensor. It will still check the shapes,
 * and null is a placeholder.
 *
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const y = tf.tensor1d([1, null, 3, 4]);
 * const z = tf.tensor2d([1, 2, 3, 4], [2,2]);
 * tf.ensureShape(x, [4]).print();
 * tf.ensureShape(y, [4]).print();
 * tf.ensureShape(z, [null, 2]).print();
 * ```
 *
 * @param x The input tensor to be ensured.
 * @param shape A TensorShape representing the shape of this tensor, an array
 *     or null.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $60ee51dd648d18e0$var$ensureShape_(x, shape) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'ensureShape', 'string_or_numeric');
    if (!(0, $8cCb2.arraysEqualWithNull)($x.shape, shape)) throw new Error(`EnsureShape: Shape of tensor ${$x.shape} is not compatible with expected shape ${shape}`);
    return x;
}
const $60ee51dd648d18e0$export$6699c34d603c5978 = /* @__PURE__ */ (0, $jqSCG.op)({
    ensureShape_: $60ee51dd648d18e0$var$ensureShape_
});

});

parcelRegister("4PmMp", function(module, exports) {

$parcel$export(module.exports, "euclideanNorm", () => $383d98731541f461$export$38d83b337e7c2edd);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7k6dx = parcelRequire("7k6dx");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the Euclidean norm of scalar, vectors, and matrices.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.euclideanNorm().print();  // or tf.euclideanNorm(x)
 * ```
 *
 * @param x The input array.
 * @param axis Optional. If axis is null (the default), the input is
 * considered a vector and a single vector norm is computed over the entire
 * set of values in the Tensor, i.e. euclideanNorm(x) is equivalent
 * to euclideanNorm(x.reshape([-1])). If axis is an integer, the input
 * is considered a batch of vectors, and axis determines the axis in x
 * over which to compute vector norms. If axis is a 2-tuple of integer it is
 * considered a batch of matrices and axis determines the axes in NDArray
 * over which to compute a matrix norm.
 * @param keepDims Optional. If true, the norm has the same dimensionality
 * as the input.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $383d98731541f461$var$euclideanNorm_(x, axis = null, keepDims = false) {
    return (0, $7k6dx.norm)(x, 'euclidean', axis, keepDims);
}
const $383d98731541f461$export$38d83b337e7c2edd = /* @__PURE__ */ (0, $jqSCG.op)({
    euclideanNorm_: $383d98731541f461$var$euclideanNorm_
});

});
parcelRegister("7k6dx", function(module, exports) {

$parcel$export(module.exports, "norm", () => $554f394697e806e8$export$1991ecd29cc92c6b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $7j49I = parcelRequire("7j49I");

var $kTunp = parcelRequire("kTunp");

var $05cMR = parcelRequire("05cMR");

var $fySTI = parcelRequire("fySTI");

var $jqSCG = parcelRequire("jqSCG");

var $ad1of = parcelRequire("ad1of");

var $4sqA7 = parcelRequire("4sqA7");

var $3xp7o = parcelRequire("3xp7o");

var $iAb3z = parcelRequire("iAb3z");

var $iDd8d = parcelRequire("iDd8d");

var $9NgTx = parcelRequire("9NgTx");
/**
 * Computes the norm of scalar, vectors, and matrices.
 * This function can compute several different vector norms (the 1-norm, the
 * Euclidean or 2-norm, the inf-norm, and in general the p-norm for p > 0)
 * and matrix norms (Frobenius, 1-norm, and inf-norm).
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.norm().print();  // or tf.norm(x)
 * ```
 *
 * @param x The input array.
 * @param ord Optional. Order of the norm. Supported norm types are
 * following:
 *
 *  | ord        | norm for matrices         | norm for vectors
 *  |------------|---------------------------|---------------------
 *  |'euclidean' |Frobenius norm             |2-norm
 *  |'fro'       |Frobenius norm	           |
 *  |Infinity    |max(sum(abs(x), axis=1))   |max(abs(x))
 *  |-Infinity   |min(sum(abs(x), axis=1))   |min(abs(x))
 *  |1           |max(sum(abs(x), axis=0))   |sum(abs(x))
 *  |2           |                           |sum(abs(x)^2)^(1/2)
 *
 * @param axis Optional. If axis is null (the default), the input is
 * considered a vector and a single vector norm is computed over the entire
 * set of values in the Tensor, i.e. norm(x, ord) is equivalent
 * to norm(x.reshape([-1]), ord). If axis is an integer, the input
 * is considered a batch of vectors, and axis determines the axis in x
 * over which to compute vector norms. If axis is a 2-tuple of integer it is
 * considered a batch of matrices and axis determines the axes in NDArray
 * over which to compute a matrix norm.
 * @param keepDims Optional. If true, the norm has the same dimensionality
 * as the input.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $554f394697e806e8$var$norm_(x, ord = 'euclidean', axis = null, keepDims = false) {
    x = (0, $5xBLk.convertToTensor)(x, 'x', 'norm');
    const norm = $554f394697e806e8$var$normImpl(x, ord, axis);
    let keepDimsShape = norm.shape;
    if (keepDims) {
        const axes = (0, $8cCb2.parseAxisParam)(axis, x.shape);
        keepDimsShape = $kTunp.expandShapeToKeepDim(norm.shape, axes);
    }
    return (0, $4sqA7.reshape)(norm, keepDimsShape);
}
function $554f394697e806e8$var$normImpl(x, p, axis = null) {
    if (x.rank === 0) return (0, $7j49I.abs)(x);
    // consider vector when no axis is specified
    if (x.rank !== 1 && axis === null) return $554f394697e806e8$var$normImpl((0, $4sqA7.reshape)(x, [
        -1
    ]), p, axis);
    // vector
    if (x.rank === 1 || typeof axis === 'number' || Array.isArray(axis) && axis.length === 1) {
        if (p === 1) return (0, $9NgTx.sum)((0, $7j49I.abs)(x), axis);
        if (p === Infinity) return (0, $05cMR.max)((0, $7j49I.abs)(x), axis);
        if (p === -Infinity) return (0, $fySTI.min)((0, $7j49I.abs)(x), axis);
        if (p === 'euclidean' || p === 2) // norm(x, 2) = sum(abs(xi) ^ 2) ^ 1/2
        return (0, $iAb3z.sqrt)((0, $9NgTx.sum)((0, $ad1of.pow)((0, $7j49I.abs)(x), (0, $3xp7o.scalar)(2, 'int32')), axis));
        throw new Error(`Error in norm: invalid ord value: ${p}`);
    }
    // matrix (assumption axis[0] < axis[1])
    if (Array.isArray(axis) && axis.length === 2) {
        if (p === 1) return (0, $05cMR.max)((0, $9NgTx.sum)((0, $7j49I.abs)(x), axis[0]), axis[1] - 1);
        if (p === Infinity) return (0, $05cMR.max)((0, $9NgTx.sum)((0, $7j49I.abs)(x), axis[1]), axis[0]);
        if (p === -Infinity) return (0, $fySTI.min)((0, $9NgTx.sum)((0, $7j49I.abs)(x), axis[1]), axis[0]);
        if (p === 'fro' || p === 'euclidean') // norm(x) = sqrt(sum(pow(x, 2)))
        return (0, $iAb3z.sqrt)((0, $9NgTx.sum)((0, $iDd8d.square)(x), axis));
        throw new Error(`Error in norm: invalid ord value: ${p}`);
    }
    throw new Error(`Error in norm: invalid axis: ${axis}`);
}
const $554f394697e806e8$export$1991ecd29cc92c6b = /* @__PURE__ */ (0, $jqSCG.op)({
    norm_: $554f394697e806e8$var$norm_
});

});
parcelRegister("05cMR", function(module, exports) {

$parcel$export(module.exports, "max", () => $00fa62f8df8ea40d$export$8960430cfd85939f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the maximum of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.max().print();  // or tf.max(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.max(axis).print();  // or tf.max(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $00fa62f8df8ea40d$var$max_(x, axis = null, keepDims = false) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'max');
    const inputs = {
        x: $x
    };
    const attrs = {
        reductionIndices: axis,
        keepDims: keepDims
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Max), inputs, attrs);
}
const $00fa62f8df8ea40d$export$8960430cfd85939f = /* @__PURE__ */ (0, $jqSCG.op)({
    max_: $00fa62f8df8ea40d$var$max_
});

});

parcelRegister("fySTI", function(module, exports) {

$parcel$export(module.exports, "min", () => $b5449d8a4698bd43$export$96ec731ed4dcb222);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the minimum value from the input.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the array is reduced by 1 for each entry in `axes`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axes` has no entries, all dimensions are reduced, and an array with a
 * single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.min().print();  // or tf.min(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.min(axis).print();  // or tf.min(x, axis)
 * ```
 *
 * @param x The input Tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $b5449d8a4698bd43$var$min_(x, axis = null, keepDims = false) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'min');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Min), inputs, attrs);
}
const $b5449d8a4698bd43$export$96ec731ed4dcb222 = /* @__PURE__ */ (0, $jqSCG.op)({
    min_: $b5449d8a4698bd43$var$min_
});

});



parcelRegister("cUuFo", function(module, exports) {

$parcel$export(module.exports, "expm1", () => $966280c1f426de32$export$b6c0a80d46d3391d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes exponential of the input `tf.Tensor` minus one element-wise.
 * `e ^ x - 1`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, -3]);
 *
 * x.expm1().print();  // or tf.expm1(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $966280c1f426de32$var$expm1_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'expm1');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Expm1), inputs);
}
const $966280c1f426de32$export$b6c0a80d46d3391d = /* @__PURE__ */ (0, $jqSCG.op)({
    expm1_: $966280c1f426de32$var$expm1_
});

});

parcelRegister("1d8KH", function(module, exports) {

$parcel$export(module.exports, "imag", () => $0e1dcb58360d86cd$export$d78fab5778ab392b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the imaginary part of a complex (or real) tensor.
 *
 * Given a tensor input, this operation returns a tensor of type float that is
 * the imaginary part of each element in input considered as a complex number.
 * If input is real, a tensor of all zeros is returned.
 *
 * ```js
 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
 * tf.imag(x).print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $0e1dcb58360d86cd$var$imag_(input) {
    const $input = (0, $5xBLk.convertToTensor)(input, 'input', 'imag');
    const inputs = {
        input: $input
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Imag), inputs);
}
const $0e1dcb58360d86cd$export$d78fab5778ab392b = /* @__PURE__ */ (0, $jqSCG.op)({
    imag_: $0e1dcb58360d86cd$var$imag_
});

});

parcelRegister("eaZNC", function(module, exports) {

$parcel$export(module.exports, "isFinite", () => $a521efe7e5aac3f8$export$65f0b13f2f82375a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns which elements of x are finite.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isFinite().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $a521efe7e5aac3f8$var$isFinite_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'isFinite');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.IsFinite), inputs);
}
const $a521efe7e5aac3f8$export$65f0b13f2f82375a = /* @__PURE__ */ (0, $jqSCG.op)({
    isFinite_: $a521efe7e5aac3f8$var$isFinite_
});

});

parcelRegister("ahjR1", function(module, exports) {

$parcel$export(module.exports, "isInf", () => $77bae48f55795afc$export$e5d3415c656f7096);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns which elements of x are Infinity or -Infinity.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isInf().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $77bae48f55795afc$var$isInf_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'isInf');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.IsInf), inputs);
}
const $77bae48f55795afc$export$e5d3415c656f7096 = /* @__PURE__ */ (0, $jqSCG.op)({
    isInf_: $77bae48f55795afc$var$isInf_
});

});

parcelRegister("5FmUe", function(module, exports) {

$parcel$export(module.exports, "isNaN", () => $42028cbc7490170f$export$c9f5652083b8129d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns which elements of x are NaN.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isNaN().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $42028cbc7490170f$var$isNaN_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'isNaN');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.IsNan), inputs);
}
const $42028cbc7490170f$export$c9f5652083b8129d = /* @__PURE__ */ (0, $jqSCG.op)({
    isNaN_: $42028cbc7490170f$var$isNaN_
});

});

parcelRegister("jTDVJ", function(module, exports) {

$parcel$export(module.exports, "less", () => $e7c220a817a7d6b0$export$bb1a638da8ad190f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the truth value of (a < b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.less(b).print();
 * ```
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $e7c220a817a7d6b0$var$less_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'less', 'string_or_numeric');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'less', 'string_or_numeric');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Less), inputs);
}
const $e7c220a817a7d6b0$export$bb1a638da8ad190f = /* @__PURE__ */ (0, $jqSCG.op)({
    less_: $e7c220a817a7d6b0$var$less_
});

});

parcelRegister("7LQ38", function(module, exports) {

$parcel$export(module.exports, "lessEqual", () => $5a854c2455432f6a$export$c24ad19a692bb92);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the truth value of (a <= b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.lessEqual(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $5a854c2455432f6a$var$lessEqual_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'lessEqual', 'string_or_numeric');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'lessEqual', 'string_or_numeric');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.LessEqual), inputs);
}
const $5a854c2455432f6a$export$c24ad19a692bb92 = /* @__PURE__ */ (0, $jqSCG.op)({
    lessEqual_: $5a854c2455432f6a$var$lessEqual_
});

});

parcelRegister("9ntOC", function(module, exports) {

$parcel$export(module.exports, "linspace", () => $6d3d63bd566c765a$export$71255ea3f595147c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");
function $6d3d63bd566c765a$export$71255ea3f595147c(start, stop, num) {
    if (num <= 0) throw new Error('The number of values should be positive.');
    const attrs = {
        start: start,
        stop: stop,
        num: num
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.LinSpace), {}, attrs);
}

});

parcelRegister("k8D3u", function(module, exports) {

$parcel$export(module.exports, "localResponseNormalization", () => $ea92d98dece5e886$export$b6127073705f6321);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Normalizes the activation of a local neighborhood across or within
 * channels.
 *
 * @param x The input tensor. The 4-D input tensor is treated as a 3-D array
 *     of 1D vectors (along the last dimension), and each vector is
 *     normalized independently.
 * @param depthRadius The number of adjacent channels in the 1D normalization
 *     window.
 * @param bias A constant bias term for the basis.
 * @param alpha A scale factor, usually positive.
 * @param beta An exponent.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $ea92d98dece5e886$var$localResponseNormalization_(x, depthRadius = 5, bias = 1, alpha = 1, beta = 0.5) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'localResponseNormalization');
    $8cCb2.assert($x.rank === 4 || $x.rank === 3, ()=>`Error in localResponseNormalization: x must be rank 3 or 4 but got
               rank ${$x.rank}.`);
    $8cCb2.assert($8cCb2.isInt(depthRadius), ()=>`Error in localResponseNormalization: depthRadius must be an ` + `integer but got depthRadius ${depthRadius}.`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    const inputs = {
        x: x4D
    };
    const attrs = {
        depthRadius: depthRadius,
        bias: bias,
        alpha: alpha,
        beta: beta
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.LRN), inputs, attrs);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    else return res;
}
const $ea92d98dece5e886$export$b6127073705f6321 = /* @__PURE__ */ (0, $jqSCG.op)({
    localResponseNormalization_: $ea92d98dece5e886$var$localResponseNormalization_
});

});

parcelRegister("dcoCo", function(module, exports) {

$parcel$export(module.exports, "log", () => $99bf7e02d49647cf$export$bef1f36f5486a6a3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes natural logarithm of the input `tf.Tensor` element-wise: `ln(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.E]);
 *
 * x.log().print();  // or tf.log(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $99bf7e02d49647cf$var$log_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'log', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Log), inputs);
}
const $99bf7e02d49647cf$export$bef1f36f5486a6a3 = /* @__PURE__ */ (0, $jqSCG.op)({
    log_: $99bf7e02d49647cf$var$log_
});

});

parcelRegister("5QUXI", function(module, exports) {

$parcel$export(module.exports, "log1p", () => $442dfe97b70d73dc$export$144dcf16adfb9698);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes natural logarithm of the input `tf.Tensor` plus one
 * element-wise: `ln(1 + x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.E - 1]);
 *
 * x.log1p().print();  // or tf.log1p(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $442dfe97b70d73dc$var$log1p_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'log1p');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Log1p), inputs);
}
const $442dfe97b70d73dc$export$144dcf16adfb9698 = /* @__PURE__ */ (0, $jqSCG.op)({
    log1p_: $442dfe97b70d73dc$var$log1p_
});

});

parcelRegister("7hYeW", function(module, exports) {

$parcel$export(module.exports, "logSigmoid", () => $54e8d955c4d71e65$export$9e0b8feed033df47);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $92fpA = parcelRequire("92fpA");

var $5xBLk = parcelRequire("5xBLk");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $jqSCG = parcelRequire("jqSCG");

var $jvtSq = parcelRequire("jvtSq");

var $4Udpd = parcelRequire("4Udpd");
/**
 * Computes log sigmoid of the input `tf.Tensor` element-wise:
 * `logSigmoid(x)`. For numerical stability, we use `-tf.softplus(-x)`.
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.logSigmoid().print();  // or tf.logSigmoid(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $54e8d955c4d71e65$var$logSigmoid_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'logSigmoid');
    // Use a custom gradient to maintain previous implementation.
    // There is no LogSigmoid kernel in TF so we can't use engine.runKernel
    // directly
    const customOp = (0, $92fpA.customGrad)((x)=>{
        // TODO(yassogba) we can remove the chained softplus call here only
        // after backends have modualrized softplus at which point we can call
        // engine runKernel(..., Sotfplus, ...) directly.
        const value = (0, $15cGp.neg)((0, $4Udpd.softplus)((0, $15cGp.neg)(x)));
        const gradFunc = (dy)=>{
            const derX = (0, $jZc0w.mul)(dy, (0, $jvtSq.sigmoid)((0, $15cGp.neg)(x)));
            return derX;
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp($x);
}
const $54e8d955c4d71e65$export$9e0b8feed033df47 = /* @__PURE__ */ (0, $jqSCG.op)({
    logSigmoid_: $54e8d955c4d71e65$var$logSigmoid_
});

});
parcelRegister("15cGp", function(module, exports) {

$parcel$export(module.exports, "neg", () => $0ca018ac52410371$export$d9493ff0dfa0fdd5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes `-1 * x` element-wise.
 *
 * ```js
 * const x = tf.tensor2d([1, 2, -2, 0], [2, 2]);
 *
 * x.neg().print();  // or tf.neg(x)
 * ```
 *
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0ca018ac52410371$var$neg_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'neg');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Neg), inputs);
}
const $0ca018ac52410371$export$d9493ff0dfa0fdd5 = /* @__PURE__ */ (0, $jqSCG.op)({
    neg_: $0ca018ac52410371$var$neg_
});

});

parcelRegister("4Udpd", function(module, exports) {

$parcel$export(module.exports, "softplus", () => $3926ca7a31ecf655$export$76aa560a8c2b0055);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes softplus of the input `tf.Tensor` element-wise: `log(exp(x) + 1)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.softplus().print();  // or tf.softplus(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $3926ca7a31ecf655$var$softplus_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'softplus');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Softplus), inputs);
}
const $3926ca7a31ecf655$export$76aa560a8c2b0055 = /* @__PURE__ */ (0, $jqSCG.op)({
    softplus_: $3926ca7a31ecf655$var$softplus_
});

});


parcelRegister("2NPdY", function(module, exports) {

$parcel$export(module.exports, "logSoftmax", () => $20a7e47c51889579$export$676379a046a2e437);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $92fpA = parcelRequire("92fpA");

var $5xBLk = parcelRequire("5xBLk");

var $inFmq = parcelRequire("inFmq");

var $2PcQK = parcelRequire("2PcQK");

var $dcoCo = parcelRequire("dcoCo");

var $05cMR = parcelRequire("05cMR");

var $jZc0w = parcelRequire("jZc0w");

var $jqSCG = parcelRequire("jqSCG");

var $7kouu = parcelRequire("7kouu");

var $9NgTx = parcelRequire("9NgTx");
/**
 * Computes the log softmax.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 *
 * a.logSoftmax().print();  // or tf.logSoftmax(a)
 * ```
 *
 * ```js
 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
 *
 * a.logSoftmax().print();  // or tf.logSoftmax(a)
 * ```
 *
 * @param logits The logits array.
 * @param axis The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $20a7e47c51889579$var$logSoftmax_(logits, axis = -1) {
    const $logits = (0, $5xBLk.convertToTensor)(logits, 'logits', 'logSoftmax');
    if (axis === -1) axis = $logits.rank - 1;
    if (axis !== $logits.rank - 1) throw Error('Log Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${$logits.rank} and axis was ${axis}`);
    // const forward: ForwardFunc<Tensor> = (backend, save) => {
    //   const keepDims = true;
    //   const xMax = max(logits, axis, true);
    //   const shifted = sub(logits, xMax);
    //   const value =
    //       sub(cast(shifted, 'float32'), log(sum(exp(shifted), axis,
    //       keepDims)));
    //   save([value]);
    //   return value;
    // };
    // Use a custom gradient for numerical stability.
    const customOp = (0, $92fpA.customGrad)((logits, save)=>{
        const keepDims = true;
        const xMax = (0, $05cMR.max)(logits, axis, true);
        const shifted = (0, $7kouu.sub)(logits, xMax);
        const value = (0, $7kouu.sub)((0, $inFmq.cast)(shifted, 'float32'), (0, $dcoCo.log)((0, $9NgTx.sum)((0, $2PcQK.exp)(shifted), axis, keepDims)));
        save([
            value
        ]);
        const gradFunc = (dy, saved)=>{
            const [value] = saved;
            const keepDims = true;
            const softmax = (0, $2PcQK.exp)(value);
            return (0, $7kouu.sub)(dy, (0, $jZc0w.mul)((0, $9NgTx.sum)(dy, axis, keepDims), softmax));
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp($logits);
// TODO Use Engine.runKernel when CPU/WebGL/WASM backends implement this.
// const inputs: LogSoftmaxInputs = {logits: $logits};
// const attrs: LogSoftmaxAttrs = {axis};
// return ENGINE.runKernel(
//            LogSoftmax, inputs as unknown as NamedTensorMap,
//            attrs as unknown as NamedAttrMap);
}
const $20a7e47c51889579$export$676379a046a2e437 = /* @__PURE__ */ (0, $jqSCG.op)({
    logSoftmax_: $20a7e47c51889579$var$logSoftmax_
});

});

parcelRegister("9dGIC", function(module, exports) {

$parcel$export(module.exports, "logSumExp", () => $6b6676f787cc0273$export$e20aca1e89397787);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $hgacW = parcelRequire("hgacW");

var $kTunp = parcelRequire("kTunp");

var $2PcQK = parcelRequire("2PcQK");

var $dcoCo = parcelRequire("dcoCo");

var $05cMR = parcelRequire("05cMR");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");

var $7kouu = parcelRequire("7kouu");

var $9NgTx = parcelRequire("9NgTx");
/**
 * Computes the log(sum(exp(elements across the reduction dimensions))).
 *
 * Reduces the input along the dimensions given in `axis`. Unless `keepDims`
 * is true, the rank of the array is reduced by 1 for each entry in `axis`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axis` has no entries, all dimensions are reduced, and an array with a
 * single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.logSumExp().print();  // or tf.logSumExp(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.logSumExp(axis).print();  // or tf.logSumExp(a, axis)
 * ```
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. If null (the default),
 *     reduces all dimensions.
 * @param keepDims If true, retains reduced dimensions with length
 *     of 1. Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $6b6676f787cc0273$var$logSumExp_(x, axis = null, keepDims = false) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'logSumExp');
    const axes = (0, $8cCb2.parseAxisParam)(axis, $x.shape);
    const xMax = (0, $05cMR.max)($x, axes, true);
    const a = (0, $7kouu.sub)($x, xMax);
    const b = (0, $2PcQK.exp)(a);
    const c = (0, $9NgTx.sum)(b, axes);
    const d = (0, $dcoCo.log)(c);
    const res = (0, $hgacW.add)((0, $4sqA7.reshape)(xMax, d.shape), d);
    if (keepDims) {
        const newShape = (0, $kTunp.expandShapeToKeepDim)(res.shape, axes);
        return (0, $4sqA7.reshape)(res, newShape);
    }
    return res;
}
const $6b6676f787cc0273$export$e20aca1e89397787 = /* @__PURE__ */ (0, $jqSCG.op)({
    logSumExp_: $6b6676f787cc0273$var$logSumExp_
});

});

parcelRegister("kg1Wp", function(module, exports) {

$parcel$export(module.exports, "logicalAnd", () => $ebf6cebe68ef2a79$export$db5dd0ef9d505f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the truth value of `a AND b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalAnd(b).print();
 * ```
 *
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $ebf6cebe68ef2a79$var$logicalAnd_(a, b) {
    const $a = (0, $5xBLk.convertToTensor)(a, 'a', 'logicalAnd', 'bool');
    const $b = (0, $5xBLk.convertToTensor)(b, 'b', 'logicalAnd', 'bool');
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.LogicalAnd), inputs);
}
const $ebf6cebe68ef2a79$export$db5dd0ef9d505f = /* @__PURE__ */ (0, $jqSCG.op)({
    logicalAnd_: $ebf6cebe68ef2a79$var$logicalAnd_
});

});

parcelRegister("7NVSX", function(module, exports) {

$parcel$export(module.exports, "logicalNot", () => $5aea02d79d421e58$export$c836ff7b605b1617);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the truth value of `NOT x` element-wise.
 *
 * ```js
 * const a = tf.tensor1d([false, true], 'bool');
 *
 * a.logicalNot().print();
 * ```
 *
 * @param x The input tensor. Must be of dtype 'bool'.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $5aea02d79d421e58$var$logicalNot_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'logicalNot', 'bool');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.LogicalNot), inputs);
}
const $5aea02d79d421e58$export$c836ff7b605b1617 = /* @__PURE__ */ (0, $jqSCG.op)({
    logicalNot_: $5aea02d79d421e58$var$logicalNot_
});

});

parcelRegister("iok2K", function(module, exports) {

$parcel$export(module.exports, "logicalOr", () => $d63a04143271ccd2$export$e2a73975983cadd8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the truth value of `a OR b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalOr(b).print();
 * ```
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $d63a04143271ccd2$var$logicalOr_(a, b) {
    const $a = (0, $5xBLk.convertToTensor)(a, 'a', 'logicalOr', 'bool');
    const $b = (0, $5xBLk.convertToTensor)(b, 'b', 'logicalOr', 'bool');
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.LogicalOr), inputs);
}
const $d63a04143271ccd2$export$e2a73975983cadd8 = /* @__PURE__ */ (0, $jqSCG.op)({
    logicalOr_: $d63a04143271ccd2$var$logicalOr_
});

});

parcelRegister("iIobM", function(module, exports) {

$parcel$export(module.exports, "logicalXor", () => $d9ff197708e7fc0d$export$20f90b62b30dbaef);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $kg1Wp = parcelRequire("kg1Wp");

var $7NVSX = parcelRequire("7NVSX");

var $iok2K = parcelRequire("iok2K");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the truth value of `a XOR b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalXor(b).print();
 * ```
 *
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $d9ff197708e7fc0d$var$logicalXor_(a, b) {
    const $a = (0, $5xBLk.convertToTensor)(a, 'a', 'logicalXor', 'bool');
    const $b = (0, $5xBLk.convertToTensor)(b, 'b', 'logicalXor', 'bool');
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    // x ^ y = (x | y) & ~(x & y)
    return (0, $kg1Wp.logicalAnd)((0, $iok2K.logicalOr)(a, b), (0, $7NVSX.logicalNot)((0, $kg1Wp.logicalAnd)(a, b)));
}
const $d9ff197708e7fc0d$export$20f90b62b30dbaef = /* @__PURE__ */ (0, $jqSCG.op)({
    logicalXor_: $d9ff197708e7fc0d$var$logicalXor_
});

});

parcelRegister("jAFVi", function(module, exports) {

$parcel$export(module.exports, "lowerBound", () => $e431e62c480471c9$export$450bb71ab40039dc);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6PrVj = parcelRequire("6PrVj");
function $e431e62c480471c9$export$450bb71ab40039dc(sortedSequence, values) {
    return (0, $6PrVj.searchSorted)(sortedSequence, values, 'left');
}

});
parcelRegister("6PrVj", function(module, exports) {

$parcel$export(module.exports, "searchSorted", () => $4f8d2a80bf60195c$export$56fad8d65b0adbdd);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
const $4f8d2a80bf60195c$var$INT32_MAX = 2147483648;
/**
 * Searches for where a value would go in a sorted sequence.
 *
 * This is not a method for checking containment (like javascript in).
 *
 * The typical use case for this operation is "binning", "bucketing", or
 * "discretizing". The values are assigned to bucket-indices based on the edges
 * listed in 'sortedSequence'. This operation returns the bucket-index for each
 * value.
 *
 * The side argument controls which index is returned if a value lands exactly
 * on an edge.
 *
 * The axis is not settable for this operation. It always operates on the
 * innermost dimension (axis=-1). The operation will accept any number of outer
 * dimensions.
 *
 * Note: This operation assumes that 'sortedSequence' is sorted along the
 * innermost axis, maybe using 'sort(..., axis=-1)'. If the sequence is not
 * sorted no error is raised and the content of the returned tensor is not well
 * defined.
 *
 * ```js
 * const edges = tf.tensor1d([-1, 3.3, 9.1, 10.0]);
 * let values = tf.tensor1d([0.0, 4.1, 12.0]);
 * const result1 = tf.searchSorted(edges, values, 'left');
 * result1.print(); // [1, 2, 4]
 *
 * const seq = tf.tensor1d([0, 3, 9, 10, 10]);
 * values = tf.tensor1d([0, 4, 10]);
 * const result2 = tf.searchSorted(seq, values, 'left');
 * result2.print(); // [0, 2, 3]
 * const result3 = tf.searchSorted(seq, values, 'right');
 * result3.print(); // [1, 2, 5]
 *
 * const sortedSequence = tf.tensor2d([[0., 3., 8., 9., 10.],
 *                                     [1., 2., 3., 4., 5.]]);
 * values = tf.tensor2d([[9.8, 2.1, 4.3],
 *                       [0.1, 6.6, 4.5, ]]);
 * const result4 = tf.searchSorted(sortedSequence, values, 'left');
 * result4.print(); // [[4, 1, 2], [0, 5, 4]]
 * ```
 * @param sortedSequence: N-D. Sorted sequence.
 * @param values: N-D. Search values.
 * @param side: 'left'|'right'. Defaults to 'left'. 'left' corresponds to lower
 *     bound and 'right' to upper bound.
 * @return An N-D int32 tensor the size of values containing the result of
 *     applying either lower bound or upper bound (depending on side) to each
 *     value. The result is not a global index to the entire Tensor, but the
 *     index in the last dimension.
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $4f8d2a80bf60195c$var$searchSorted_(sortedSequence, values, side = 'left') {
    const $sortedSequence = (0, $5xBLk.convertToTensor)(sortedSequence, 'sortedSequence', 'searchSorted');
    const $values = (0, $5xBLk.convertToTensor)(values, 'values', 'searchSorted');
    const sequenceSize = $sortedSequence.shape[$sortedSequence.shape.length - 1];
    const valuesSize = $values.shape[$values.shape.length - 1];
    const $sortedSequence2D = (0, $4sqA7.reshape)($sortedSequence, [
        -1,
        sequenceSize
    ]);
    const $values2D = (0, $4sqA7.reshape)($values, [
        -1,
        valuesSize
    ]);
    if ($sortedSequence2D.rank < 2) throw new Error(`Sorted input argument must be at least 2-dimensional`);
    if ($sortedSequence2D.shape[0] !== $values2D.shape[0]) throw new Error(`Leading dimension of 'sortedSequence' and 'values' must match.`);
    if ((0, $8cCb2.sizeFromShape)($values2D.shape) >= $4f8d2a80bf60195c$var$INT32_MAX) throw new Error(`values tensor size must less than ${$4f8d2a80bf60195c$var$INT32_MAX}`);
    if ($sortedSequence2D.shape[1] >= $4f8d2a80bf60195c$var$INT32_MAX) throw new Error(`trailing dim_size must less than ${$4f8d2a80bf60195c$var$INT32_MAX} for int32 output type, was ${$sortedSequence2D.shape[1]}`);
    const inputs = {
        sortedSequence: $sortedSequence2D,
        values: $values2D
    };
    const attrs = {
        side: side
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.SearchSorted), inputs, attrs);
}
const $4f8d2a80bf60195c$export$56fad8d65b0adbdd = /* @__PURE__ */ (0, $jqSCG.op)({
    searchSorted_: $4f8d2a80bf60195c$var$searchSorted_
});

});


parcelRegister("gscJF", function(module, exports) {

$parcel$export(module.exports, "maxPool", () => $bfa923df51c4e9fb$export$e4aadcf115842782);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the 2D max pooling of an image.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in dilated pooling. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $bfa923df51c4e9fb$var$maxPool_(x, filterSize, strides, pad, dimRoundingMode) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'maxPool');
    const dilations = 1;
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $8cCb2.assert(x4D.rank === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x4D.rank}.`);
    $8cCb2.assert($frznq.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $frznq.checkPadOnDimRoundingMode('maxPool', pad, dimRoundingMode);
    const inputs = {
        x: x4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.MaxPool), inputs, attrs);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $bfa923df51c4e9fb$export$e4aadcf115842782 = /* @__PURE__ */ (0, $jqSCG.op)({
    maxPool_: $bfa923df51c4e9fb$var$maxPool_
});

});

parcelRegister("gF4tm", function(module, exports) {

$parcel$export(module.exports, "maxPool3d", () => $c213f1d37ed322ef$export$822a6e53be1125f9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the 3D max pooling.
 *
 * ```js
 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
 * const result = tf.maxPool3d(x, 2, 1, 'valid');
 * result.print();
 * ```
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     `[batch, depth, height, width, inChannels]`.
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     If `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideDepth == strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $c213f1d37ed322ef$var$maxPool3d_(x, filterSize = [
    1,
    1,
    1
], strides, pad, dimRoundingMode, dataFormat = 'NDHWC') {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'maxPool3d');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $8cCb2.assert(x5D.rank === 5, ()=>`Error in maxPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
    $8cCb2.assert(dataFormat === 'NDHWC', ()=>`Error in maxPool3d: Only NDHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    (0, $frznq.checkPadOnDimRoundingMode)('maxPool3d', pad, dimRoundingMode);
    const inputs = {
        x: x5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dataFormat: dataFormat
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.MaxPool3D), inputs, attrs);
    if (reshapedTo5D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $c213f1d37ed322ef$export$822a6e53be1125f9 = /* @__PURE__ */ (0, $jqSCG.op)({
    maxPool3d_: $c213f1d37ed322ef$var$maxPool3d_
});

});

parcelRegister("9K0B1", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmax", () => $7178df567939d474$export$3d8b1b819d23351e);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the 2D max pooling of an image with Argmax index.
 * The indices in argmax are flattened, so that a maximum value at position `[b,
 * y, x, c]` becomes flattened index: `(y * width + x) * channels + c` if
 * include_batch_in_index is False; `((b * height + y) * width + x) * channels
 * +c` if include_batch_in_index is True.
 *
 * The indices returned are always in `[0, height) x [0, width)` before
 * flattening.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param includeBatchIndex Defaults to False. Whether to include batch
 *    dimension in flattened index of argmax.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $7178df567939d474$var$maxPoolWithArgmax_(x, filterSize, strides, pad, includeBatchInIndex = false) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'maxPoolWithArgmax');
    const inputs = {
        x: $x
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        includeBatchInIndex: includeBatchInIndex
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $38WwN.ENGINE).runKernel((0, $hl418.MaxPoolWithArgmax), inputs, attrs);
    return {
        result: result[0],
        indexes: result[1]
    };
}
const $7178df567939d474$export$3d8b1b819d23351e = /* @__PURE__ */ (0, $jqSCG.op)({
    maxPoolWithArgmax_: $7178df567939d474$var$maxPoolWithArgmax_
});

});

parcelRegister("67GCc", function(module, exports) {

$parcel$export(module.exports, "mean", () => $475473fd3a900b08$export$1ce691f85baaa52);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the mean of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces `x` along the dimensions given in `axis`. Unless `keepDims` is
 * true, the rank of the `tf.Tensor` is reduced by 1 for each entry in `axis`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axis` has no entries, all dimensions are reduced, and a `tf.Tensor` with
 * a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.mean().print();  // or tf.mean(a)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.mean(axis).print();  // or tf.mean(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $475473fd3a900b08$var$mean_(x, axis = null, keepDims = false) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'mean');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Mean), inputs, attrs);
}
const $475473fd3a900b08$export$1ce691f85baaa52 = /* @__PURE__ */ (0, $jqSCG.op)({
    mean_: $475473fd3a900b08$var$mean_
});

});

parcelRegister("e6A1c", function(module, exports) {

$parcel$export(module.exports, "meshgrid", () => $a44d90bdd666156a$export$2fab8e71e5fefc1a);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aUFou = parcelRequire("aUFou");

var $fOBRA = parcelRequire("fOBRA");

var $4sqA7 = parcelRequire("4sqA7");

var $9jCh7 = parcelRequire("9jCh7");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");
function $a44d90bdd666156a$export$2fab8e71e5fefc1a(x, y, { indexing: indexing = 'xy' } = {}) {
    if (indexing !== 'xy' && indexing !== 'ij') throw new TypeError(`${indexing} is not a valid third argument to meshgrid`);
    if (x === undefined) return [];
    let $x = (0, $5xBLk.convertToTensor)(x, 'x', 'meshgrid', x instanceof (0, $9jCh7.Tensor) ? x.dtype : 'float32');
    if (y === undefined) return [
        $x
    ];
    let $y = (0, $5xBLk.convertToTensor)(y, 'y', 'meshgrid', y instanceof (0, $9jCh7.Tensor) ? y.dtype : 'float32');
    const w = (0, $8cCb2.sizeFromShape)($x.shape);
    const h = (0, $8cCb2.sizeFromShape)($y.shape);
    if (indexing === 'xy') {
        $x = (0, $4sqA7.reshape)($x, [
            1,
            -1
        ]);
        $y = (0, $4sqA7.reshape)($y, [
            -1,
            1
        ]);
        return [
            (0, $aUFou.matMul)((0, $fOBRA.ones)([
                h,
                1
            ], $x.dtype), $x),
            (0, $aUFou.matMul)($y, (0, $fOBRA.ones)([
                1,
                w
            ], $y.dtype))
        ];
    }
    $x = (0, $4sqA7.reshape)($x, [
        -1,
        1
    ]);
    $y = (0, $4sqA7.reshape)($y, [
        1,
        -1
    ]);
    return [
        (0, $aUFou.matMul)($x, (0, $fOBRA.ones)([
            1,
            h
        ], $x.dtype)),
        (0, $aUFou.matMul)((0, $fOBRA.ones)([
            w,
            1
        ], $y.dtype), $y)
    ];
}

});
parcelRegister("fOBRA", function(module, exports) {

$parcel$export(module.exports, "ones", () => $b838e56973f13fe0$export$21041dee6b8001b0);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $8cCb2 = parcelRequire("8cCb2");

var $8cCb2 = parcelRequire("8cCb2");

var $20oDZ = parcelRequire("20oDZ");

var $hxi4c = parcelRequire("hxi4c");
function $b838e56973f13fe0$export$21041dee6b8001b0(shape, dtype = 'float32') {
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
    if (dtype === 'complex64') {
        const real = $b838e56973f13fe0$export$21041dee6b8001b0(shape, 'float32');
        const imag = (0, $hxi4c.zeros)(shape, 'float32');
        return (0, $20oDZ.complex)(real, imag);
    }
    const values = (0, $8cCb2.makeOnesTypedArray)((0, $8cCb2.sizeFromShape)(shape), dtype);
    return (0, $38WwN.ENGINE).makeTensor(values, shape, dtype);
}

});
parcelRegister("hxi4c", function(module, exports) {

$parcel$export(module.exports, "zeros", () => $cc4388674ebc96d5$export$4445a00dafa2633b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $8cCb2 = parcelRequire("8cCb2");

var $20oDZ = parcelRequire("20oDZ");
function $cc4388674ebc96d5$export$4445a00dafa2633b(shape, dtype = 'float32') {
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
    if (dtype === 'complex64') {
        const real = $cc4388674ebc96d5$export$4445a00dafa2633b(shape, 'float32');
        const imag = $cc4388674ebc96d5$export$4445a00dafa2633b(shape, 'float32');
        return (0, $20oDZ.complex)(real, imag);
    }
    const values = (0, $8cCb2.makeZerosTypedArray)((0, $8cCb2.sizeFromShape)(shape), dtype);
    return (0, $38WwN.ENGINE).makeTensor(values, shape, dtype);
}

});



parcelRegister("6V8xR", function(module, exports) {

$parcel$export(module.exports, "minimum", () => $509eb1d608c78c8e$export$916782c1f0ddb132);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $inFmq = parcelRequire("inFmq");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the min of a and b (`a < b ? a : b`) element-wise.
 * Supports broadcasting.
 *
 * We also expose `minimumStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.minimum(b).print();  // or tf.minimum(a, b)
 * ```
 *
 * ```js
 * // Broadcast minimum a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.minimum(b).print();  // or tf.minimum(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $509eb1d608c78c8e$var$minimum_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'minimum');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'minimum');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    if ($a.dtype === 'bool') {
        $a = (0, $inFmq.cast)($a, 'int32');
        $b = (0, $inFmq.cast)($b, 'int32');
    }
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Minimum), inputs);
}
const $509eb1d608c78c8e$export$916782c1f0ddb132 = /* @__PURE__ */ (0, $jqSCG.op)({
    minimum_: $509eb1d608c78c8e$var$minimum_
});

});

parcelRegister("ejlRR", function(module, exports) {

$parcel$export(module.exports, "mirrorPad", () => $a6b3cd7f35f32ec3$export$c0b11600e90b86ae);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Pads a `tf.Tensor` using mirror padding.
 *
 * This operation implements the `REFLECT` and `SYMMETRIC` modes of pad.
 *
 * ```js
 * const x = tf.range(0, 9).reshape([1, 1, 3, 3]);
 * x.mirrorPad([[0, 0], [0, 0], [2, 2], [2, 2]], 'reflect').print();
 * ```
 * @param x The tensor to pad.
 * @param paddings An array of length `R` (the rank of the tensor), where
 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
 * specifying how much to pad along each dimension of the tensor.
 * In "reflect" mode, the padded regions do not include the borders,
 * while in "symmetric" mode the padded regions do include the borders.
 * For example, if the input is `[1, 2, 3]` and paddings is `[0, 2]`,
 * then the output is `[1, 2, 3, 2, 1]` in "reflect" mode, and
 * `[1, 2, 3, 3, 2]` in "symmetric" mode.
 * If `mode` is "reflect" then both `paddings[D, 0]` and `paddings[D, 1]`
 * must be no greater than `x.shape[D] - 1`. If mode is "symmetric"
 * then both `paddings[D, 0]` and `paddings[D, 1]` must be no greater than
 * `x.shape[D]`
 * @param mode String to specify padding mode. Can be `'reflect' | 'symmetric'`
 */ /** @doc {heading: 'Tensors', subheading: 'Transformations'} */ function $a6b3cd7f35f32ec3$var$mirrorPad_(x, paddings, mode) {
    $8cCb2.assert(mode === 'reflect' || mode === 'symmetric', ()=>`Invalid mode. Mode must be either reflect or symmetric. ` + `Got ${mode}.`);
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'mirrorPad');
    if ($x.rank === 0) throw new Error("mirrorPad(scalar) is not defined. Pass non-scalar to mirrorPad");
    $8cCb2.assert(paddings.length === $x.rank, ()=>`Padding doesn't match input. Must be ${$x.rank}. ` + `Got ${paddings.length}.`);
    const shapeOffset = mode === 'reflect' ? 1 : 0;
    for(let i = 0; i < $x.rank; i++){
        $8cCb2.assert(paddings[i].length === 2, ()=>`Invalid number of paddings. Must be length of 2 each.`);
        $8cCb2.assert(paddings[i][0] >= 0 && paddings[i][0] <= $x.shape[i] - shapeOffset && paddings[i][1] >= 0 && paddings[i][1] <= $x.shape[i] - shapeOffset, ()=>`Padding in dimension ${i} cannot be greater than or equal ` + `to ${$x.shape[i] - shapeOffset} or less than 0 for input of ` + `shape ${$x.shape}`);
    }
    const attrs = {
        paddings: paddings,
        mode: mode
    };
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.MirrorPad), inputs, attrs);
}
const $a6b3cd7f35f32ec3$export$c0b11600e90b86ae = /* @__PURE__ */ (0, $jqSCG.op)({
    mirrorPad_: $a6b3cd7f35f32ec3$var$mirrorPad_
});

});

parcelRegister("jR4my", function(module, exports) {

$parcel$export(module.exports, "mod", () => $e74659ea6de4ec41$export$842a2cf37af977e1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the mod of a and b element-wise.
 * `floor(x / y) * y + mod(x, y) = x`
 * Supports broadcasting.
 *
 * We also expose `tf.modStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.mod(b).print();  // or tf.mod(a, b)
 * ```
 *
 * ```js
 * // Broadcast a mod b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.mod(b).print();  // or tf.mod(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $e74659ea6de4ec41$var$mod_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'mod');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'mod');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Mod), inputs);
}
const $e74659ea6de4ec41$export$842a2cf37af977e1 = /* @__PURE__ */ (0, $jqSCG.op)({
    mod_: $e74659ea6de4ec41$var$mod_
});

});

parcelRegister("jV1KY", function(module, exports) {

$parcel$export(module.exports, "moments", () => $e804b403d2801180$export$19ef085469537740);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $kTunp = parcelRequire("kTunp");

var $inFmq = parcelRequire("inFmq");

var $67GCc = parcelRequire("67GCc");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");

var $iDd8d = parcelRequire("iDd8d");

var $7kouu = parcelRequire("7kouu");
/**
 * Calculates the mean and variance of `x`. The mean and variance are
 * calculated by aggregating the contents of `x` across `axes`. If `x` is
 * 1-D and `axes = [0]` this is just the mean and variance of a vector.
 *
 * @param x The input tensor.
 * @param axis The dimension(s) along with to compute mean and
 *     variance. By default it reduces all dimensions.
 * @param keepDims If true, the moments have the same dimensionality as the
 *     input.
 * @return An object with two keys: `mean` and `variance`.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $e804b403d2801180$var$moments_(x, axis = null, keepDims = false) {
    x = (0, $5xBLk.convertToTensor)(x, 'x', 'moments');
    const axes = (0, $8cCb2.parseAxisParam)(axis, x.shape);
    const xMean = (0, $67GCc.mean)(x, axes, keepDims);
    let keepDimsShape = xMean.shape;
    if (!keepDims) keepDimsShape = (0, $kTunp.expandShapeToKeepDim)(xMean.shape, axes);
    const devSquared = (0, $iDd8d.square)((0, $7kouu.sub)((0, $inFmq.cast)(x, 'float32'), (0, $4sqA7.reshape)(xMean, keepDimsShape)));
    const variance = (0, $67GCc.mean)(devSquared, axes, keepDims);
    return {
        mean: xMean,
        variance: variance
    };
}
const $e804b403d2801180$export$19ef085469537740 = /* @__PURE__ */ (0, $jqSCG.op)({
    moments_: $e804b403d2801180$var$moments_
});

});

parcelRegister("culYm", function(module, exports) {

$parcel$export(module.exports, "multiRNNCell", () => $917954a7b3cdf6bb$export$cc05b5217b9b924f);

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the next states and outputs of a stack of LSTMCells.
 *
 * Each cell output is used as input to the next cell.
 *
 * Returns `[cellState, cellOutput]`.
 *
 * Derived from tf.contrib.rn.MultiRNNCell.
 *
 * @param lstmCells Array of LSTMCell functions.
 * @param data The input to the cell.
 * @param c Array of previous cell states.
 * @param h Array of previous cell outputs.
 *
 * @doc {heading: 'Operations', subheading: 'RNN'}
 */ function $917954a7b3cdf6bb$var$multiRNNCell_(lstmCells, data, c, h) {
    const $data = (0, $5xBLk.convertToTensor)(data, 'data', 'multiRNNCell');
    const $c = (0, $5xBLk.convertToTensorArray)(c, 'c', 'multiRNNCell');
    const $h = (0, $5xBLk.convertToTensorArray)(h, 'h', 'multiRNNCell');
    let input = $data;
    const newStates = [];
    for(let i = 0; i < lstmCells.length; i++){
        const output = lstmCells[i](input, $c[i], $h[i]);
        newStates.push(output[0]);
        newStates.push(output[1]);
        input = output[1];
    }
    const newC = [];
    const newH = [];
    for(let i = 0; i < newStates.length; i += 2){
        newC.push(newStates[i]);
        newH.push(newStates[i + 1]);
    }
    return [
        newC,
        newH
    ];
}
const $917954a7b3cdf6bb$export$cc05b5217b9b924f = /* @__PURE__ */ (0, $jqSCG.op)({
    multiRNNCell_: $917954a7b3cdf6bb$var$multiRNNCell_
});

});

parcelRegister("b2OB7", function(module, exports) {

$parcel$export(module.exports, "multinomial", () => $80a721450e7ef1a8$export$f4d580f3101a1c7e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Creates a `tf.Tensor` with values drawn from a multinomial distribution.
 *
 * ```js
 * const probs = tf.tensor([.75, .25]);
 * tf.multinomial(probs, 3).print();
 * ```
 *
 * @param logits 1D array with unnormalized log-probabilities, or
 *     2D array of shape `[batchSize, numOutcomes]`. See the `normalized`
 *     parameter.
 * @param numSamples Number of samples to draw for each row slice.
 * @param seed The seed number.
 * @param normalized Whether the provided `logits` are normalized true
 *     probabilities (sum to 1). Defaults to false.
 * @return 1D array of shape `[numSamples]`, or 2D array of shape
 *     `[batchSize, numSamples]`, depending on the rank of the input.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $80a721450e7ef1a8$var$multinomial_(logits, numSamples, seed, normalized = false) {
    const $logits = (0, $5xBLk.convertToTensor)(logits, 'logits', 'multinomial');
    const numOutcomes = $logits.size;
    const origRank = $logits.rank;
    if (numOutcomes < 2) throw new Error(`Error in multinomial: you need at least 2 outcomes, but got ` + `${numOutcomes}.`);
    if (origRank > 2) throw new Error(`Rank of probabilities must be 1 or 2, but is ${origRank}`);
    // TODO(lina128): Investigate correct seed behavior. The code seems not allow
    // setting see to 0.
    seed = seed || Math.random();
    // The kernel only accepts (and returns) rank 2 tensors.
    const logits2D = origRank === 1 ? (0, $4sqA7.reshape)($logits, [
        1,
        -1
    ]) : $logits;
    const inputs = {
        logits: logits2D
    };
    const attrs = {
        numSamples: numSamples,
        seed: seed,
        normalized: normalized
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.Multinomial), inputs, attrs);
    // tslint:disable-next-line:no-unnecessary-type-assertion
    return origRank === 1 ? (0, $4sqA7.reshape)(res, [
        res.size
    ]) : res;
}
const $80a721450e7ef1a8$export$f4d580f3101a1c7e = /* @__PURE__ */ (0, $jqSCG.op)({
    multinomial_: $80a721450e7ef1a8$var$multinomial_
});

});

parcelRegister("8WSnu", function(module, exports) {

$parcel$export(module.exports, "notEqual", () => $683debd13acf606f$export$53a6892c50694894);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the truth value of (a != b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([0, 2, 3]);
 *
 * a.notEqual(b).print();
 * ```
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $683debd13acf606f$var$notEqual_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'notEqual', 'string_or_numeric');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'notEqual', 'string_or_numeric');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.NotEqual), inputs);
}
const $683debd13acf606f$export$53a6892c50694894 = /* @__PURE__ */ (0, $jqSCG.op)({
    notEqual_: $683debd13acf606f$var$notEqual_
});

});

parcelRegister("i3U4j", function(module, exports) {

$parcel$export(module.exports, "oneHot", () => $d263ffd91bb8ab3a$export$341b5490a776d041);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Creates a one-hot `tf.Tensor`. The locations represented by `indices` take
 * value `onValue` (defaults to 1), while all other locations take value
 * `offValue` (defaults to 0). If `indices` is rank `R`, the output has rank
 * `R+1` with the last axis of size `depth`.
 * `indices` used to encode prediction class must start from 0. For example,
 *  if you have 3 classes of data, class 1 should be encoded as 0, class 2
 *  should be 1, and class 3 should be 2.
 *
 * ```js
 * tf.oneHot(tf.tensor1d([0, 1], 'int32'), 3).print();
 * ```
 *
 * @param indices `tf.Tensor` of indices with dtype `int32`. Indices must
 * start from 0.
 * @param depth The depth of the one hot dimension.
 * @param onValue A number used to fill in the output when the index matches
 * the location.
 * @param offValue A number used to fill in the output when the index does
 *     not match the location.
 * @param dtype The dtype of the output tensor, default to 'int32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $d263ffd91bb8ab3a$var$oneHot_(indices, depth, onValue = 1, offValue = 0, dtype = 'int32') {
    if (depth < 2) throw new Error(`Error in oneHot: depth must be >=2, but it is ${depth}`);
    const $indices = (0, $5xBLk.convertToTensor)(indices, 'indices', 'oneHot', 'int32');
    const inputs = {
        indices: $indices
    };
    const attrs = {
        dtype: dtype,
        depth: depth,
        onValue: onValue,
        offValue: offValue
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.OneHot), inputs, attrs);
}
const $d263ffd91bb8ab3a$export$341b5490a776d041 = /* @__PURE__ */ (0, $jqSCG.op)({
    oneHot_: $d263ffd91bb8ab3a$var$oneHot_
});

});

parcelRegister("67iid", function(module, exports) {

$parcel$export(module.exports, "onesLike", () => $4741961218c2e183$export$fb6afd6214fee9e9);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Creates a `tf.Tensor` with all elements set to 1 with the same shape as the
 * given tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 * tf.onesLike(x).print();
 * ```
 * @param x A tensor.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $4741961218c2e183$var$onesLike_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'onesLike');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.OnesLike), inputs);
}
const $4741961218c2e183$export$fb6afd6214fee9e9 = /* @__PURE__ */ (0, $jqSCG.op)({
    onesLike_: $4741961218c2e183$var$onesLike_
});

});

parcelRegister("8lsKt", function(module, exports) {

$parcel$export(module.exports, "outerProduct", () => $613695c2f6bda44d$export$8481b38c75c91cc7);

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $aUFou = parcelRequire("aUFou");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the outer product of two vectors, `v1` and `v2`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([3, 4, 5]);
 *
 * tf.outerProduct(a, b).print();
 * ```
 * @param v1 The first vector in the outer product operation.
 * @param v2 The second vector in the outer product operation.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $613695c2f6bda44d$var$outerProduct_(v1, v2) {
    const $v1 = (0, $5xBLk.convertToTensor)(v1, 'v1', 'outerProduct');
    const $v2 = (0, $5xBLk.convertToTensor)(v2, 'v2', 'outerProduct');
    $8cCb2.assert($v1.rank === 1 && $v2.rank === 1, ()=>`Error in outerProduct: inputs must be rank 1, but got ranks ` + `${$v1.rank} and ${$v2.rank}.`);
    const v12D = (0, $4sqA7.reshape)($v1, [
        -1,
        1
    ]);
    const v22D = (0, $4sqA7.reshape)($v2, [
        1,
        -1
    ]);
    return (0, $aUFou.matMul)(v12D, v22D);
}
const $613695c2f6bda44d$export$8481b38c75c91cc7 = /* @__PURE__ */ (0, $jqSCG.op)({
    outerProduct_: $613695c2f6bda44d$var$outerProduct_
});

});

parcelRegister("fSZF6", function(module, exports) {

$parcel$export(module.exports, "pad", () => $b90bbaefd48f2353$export$5d04458e2a6c373e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Pads a `tf.Tensor` with a given value and paddings.
 *
 * This operation implements `CONSTANT` mode. For `REFLECT` and `SYMMETRIC`,
 * refer to `tf.mirrorPad`.
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that `paddings` is of given length.
 *   - `tf.pad1d`
 *   - `tf.pad2d`
 *   - `tf.pad3d`
 *   - `tf.pad4d`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * x.pad([[1, 2]]).print();
 * ```
 * @param x The tensor to pad.
 * @param paddings An array of length `R` (the rank of the tensor), where
 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
 * specifying how much to pad along each dimension of the tensor.
 * @param constantValue The pad value to use. Defaults to 0.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $b90bbaefd48f2353$var$pad_(x, paddings, constantValue = 0) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'pad');
    if ($x.rank === 0) throw new Error('pad(scalar) is not defined. Pass non-scalar to pad');
    const attrs = {
        paddings: paddings,
        constantValue: constantValue
    };
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.PadV2), inputs, attrs);
}
const $b90bbaefd48f2353$export$5d04458e2a6c373e = /* @__PURE__ */ (0, $jqSCG.op)({
    pad_: $b90bbaefd48f2353$var$pad_
});

});

parcelRegister("d3x5E", function(module, exports) {

$parcel$export(module.exports, "pad1d", () => $9815392d4669cf13$export$be67ff622a7fd5);

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $fSZF6 = parcelRequire("fSZF6");
/**
 * Pads a `tf.Tensor1D` with a given value and paddings. See `pad` for details.
 */ function $9815392d4669cf13$var$pad1d_(x, paddings, constantValue = 0) {
    (0, $8cCb2.assert)(paddings.length === 2, ()=>'Invalid number of paddings. Must be length of 2.');
    return (0, $fSZF6.pad)(x, [
        paddings
    ], constantValue);
}
const $9815392d4669cf13$export$be67ff622a7fd5 = /* @__PURE__ */ (0, $jqSCG.op)({
    pad1d_: $9815392d4669cf13$var$pad1d_
});

});

parcelRegister("lbRCf", function(module, exports) {

$parcel$export(module.exports, "pad2d", () => $f6d43711f5079033$export$38e9137d79715c2d);

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $fSZF6 = parcelRequire("fSZF6");
/**
 * Pads a `tf.Tensor2D` with a given value and paddings. See `pad` for details.
 */ function $f6d43711f5079033$var$pad2d_(x, paddings, constantValue = 0) {
    (0, $8cCb2.assert)(paddings.length === 2 && paddings[0].length === 2 && paddings[1].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $fSZF6.pad)(x, paddings, constantValue);
}
const $f6d43711f5079033$export$38e9137d79715c2d = /* @__PURE__ */ (0, $jqSCG.op)({
    pad2d_: $f6d43711f5079033$var$pad2d_
});

});

parcelRegister("kZSbJ", function(module, exports) {

$parcel$export(module.exports, "pad3d", () => $f49389cdab278f98$export$880821ebecb16ceb);

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $fSZF6 = parcelRequire("fSZF6");
/**
 * Pads a `tf.Tensor3D` with a given value and paddings. See `pad` for details.
 */ function $f49389cdab278f98$var$pad3d_(x, paddings, constantValue = 0) {
    (0, $8cCb2.assert)(paddings.length === 3 && paddings[0].length === 2 && paddings[1].length === 2 && paddings[2].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $fSZF6.pad)(x, paddings, constantValue);
}
const $f49389cdab278f98$export$880821ebecb16ceb = /* @__PURE__ */ (0, $jqSCG.op)({
    pad3d_: $f49389cdab278f98$var$pad3d_
});

});

parcelRegister("ghY1H", function(module, exports) {

$parcel$export(module.exports, "pad4d", () => $bdbccbe431e53b87$export$4aef6fb43f1346f4);

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $fSZF6 = parcelRequire("fSZF6");
/**
 * Pads a `tf.Tensor4D` with a given value and paddings. See `pad` for details.
 */ function $bdbccbe431e53b87$var$pad4d_(x, paddings, constantValue = 0) {
    (0, $8cCb2.assert)(paddings.length === 4 && paddings[0].length === 2 && paddings[1].length === 2 && paddings[2].length === 2 && paddings[3].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $fSZF6.pad)(x, paddings, constantValue);
}
const $bdbccbe431e53b87$export$4aef6fb43f1346f4 = /* @__PURE__ */ (0, $jqSCG.op)({
    pad4d_: $bdbccbe431e53b87$var$pad4d_
});

});

parcelRegister("9PaVS", function(module, exports) {

$parcel$export(module.exports, "pool", () => $72715b6f4ed888f7$export$7a0e2789ec54f0db);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $j4oHC = parcelRequire("j4oHC");

var $31sZ7 = parcelRequire("31sZ7");

var $frznq = parcelRequire("frznq");

var $gscJF = parcelRequire("gscJF");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");

var $ePI8Y = parcelRequire("ePI8Y");
/**
 * Performs an N-D pooling operation
 *
 * @param input The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param windowShape The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param poolingType The type of pooling, either 'max' or 'avg'.
 * @param pad The type of padding algorithm:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
 *         https://www.tensorflow.org/api_guides/python/nn#Convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in dilated pooling. Defaults to `[1, 1]`. If `dilationRate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $72715b6f4ed888f7$var$pool_(input, windowShape, poolingType, pad, dilations, strides, dimRoundingMode) {
    if (dilations == null) dilations = [
        1,
        1
    ];
    if (strides == null) strides = 1;
    if (pad === 0) pad = 'valid';
    const $x = (0, $5xBLk.convertToTensor)(input, 'x', 'maxPool');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $8cCb2.assert($frznq.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in pool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = $frznq.computePool2DInfo(x4D.shape, windowShape, strides, dilations, pad);
    const dilation = [
        convInfo.dilationHeight,
        convInfo.dilationWidth
    ];
    // The following implementation does batchToSpace(pool(spaceToBatch(x)))
    // whenever dilation > 1 since the TF kernels do not support dilation > 1.
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L1037
    let basePadding;
    if (pad === 'same') basePadding = $72715b6f4ed888f7$var$withSpaceToBatchBasePaddings([
        convInfo.filterHeight,
        convInfo.filterWidth
    ], dilation);
    else basePadding = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    const isDilationOne = dilation[0] === 1 && dilation[1] === 1;
    const [adjustedPadding, adjustedCrops] = $72715b6f4ed888f7$var$requiredSpaceToBatchPaddings([
        convInfo.inHeight,
        convInfo.inWidth
    ], dilation, basePadding);
    const convertedPad = isDilationOne ? pad : 'valid';
    const convertedX = isDilationOne ? x4D : (0, $ePI8Y.spaceToBatchND)(x4D, dilation, adjustedPadding);
    const forwardOp = poolingType === 'avg' ? ()=>(0, $j4oHC.avgPool)(convertedX, windowShape, strides, convertedPad, dimRoundingMode) : ()=>(0, $gscJF.maxPool)(convertedX, windowShape, strides, convertedPad, dimRoundingMode);
    const y = forwardOp();
    const res = isDilationOne ? y : (0, $31sZ7.batchToSpaceND)(y, dilation, adjustedCrops);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
// Helper function to compute crops and paddings for pool with dilation > 1.
// tslint:disable-next-line:max-line-length
// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/array_ops.py#L2184
function $72715b6f4ed888f7$var$requiredSpaceToBatchPaddings(inputShape, blockShape, basePadding) {
    const padStart = basePadding.map((b)=>b[0]);
    const origPadEnd = basePadding.map((b)=>b[1]);
    const fullInputShape = inputShape.concat(padStart, origPadEnd);
    const padEndExtra = blockShape.map((b, i)=>(b - fullInputShape[i] % b) % b);
    const padEnd = origPadEnd.map((s, i)=>s + padEndExtra[i]);
    const paddings = blockShape.map((_, i)=>[
            padStart[i],
            padEnd[i]
        ]);
    const crops = blockShape.map((_, i)=>[
            0,
            padEndExtra[i]
        ]);
    return [
        paddings,
        crops
    ];
}
// Helper function to compute base paddings for pool with dilation > 1.
// tslint:disable-next-line:max-line-length
// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L524
function $72715b6f4ed888f7$var$withSpaceToBatchBasePaddings(filterShape, dilation) {
    // Spatial dimensions of the filters and the upsampled filters in which we
    // introduce (rate - 1) zeros between consecutive filter values.
    const dilatedFilterShape = filterShape.map((s, i)=>{
        return s + (s - 1) * (dilation[i] - 1);
    });
    const padExtraShape = dilatedFilterShape.map((s)=>s - 1);
    // When padding is odd, we pad more at end, following the same
    // convention as conv2d.
    const padExtraStart = padExtraShape.map((s)=>Math.floor(s / 2));
    const padExtraEnd = padExtraShape.map((s, i)=>s - padExtraStart[i]);
    return padExtraShape.map((_, i)=>{
        return [
            padExtraStart[i],
            padExtraEnd[i]
        ];
    });
}
const $72715b6f4ed888f7$export$7a0e2789ec54f0db = /* @__PURE__ */ (0, $jqSCG.op)({
    pool_: $72715b6f4ed888f7$var$pool_
});

});
parcelRegister("ePI8Y", function(module, exports) {

$parcel$export(module.exports, "spaceToBatchND", () => $acc81226aaa46db7$export$effb9d7cae92012f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * This operation divides "spatial" dimensions `[1, ..., M]` of the input into
 * a grid of blocks of shape `blockShape`, and interleaves these blocks with
 * the "batch" dimension (0) such that in the output, the spatial
 * dimensions `[1, ..., M]` correspond to the position within the grid,
 * and the batch dimension combines both the position within a spatial block
 * and the original batch position. Prior to division into blocks,
 * the spatial dimensions of the input are optionally zero padded
 * according to `paddings`. See below for a precise description.
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [1, 2, 2, 1]);
 * const blockShape = [2, 2];
 * const paddings = [[0, 0], [0, 0]];
 *
 * x.spaceToBatchND(blockShape, paddings).print();
 * ```
 *
 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
 * remainingShape`, where spatialShape has `M` dimensions.
 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
 * be >= 1.
 * @param paddings A 2-D array. Must have shape `[M, 2]`, all values must be >=
 *     0. `paddings[i] = [padStart, padEnd]` specifies the amount to zero-pad
 * from input dimension `i + 1`, which corresponds to spatial dimension `i`. It
 * is required that
 * `(inputShape[i + 1] + padStart + padEnd) % blockShape[i] === 0`
 *
 * This operation is equivalent to the following steps:
 *
 * 1. Zero-pad the start and end of dimensions `[1, ..., M]` of the input
 * according to `paddings` to produce `padded` of shape paddedShape.
 *
 * 2. Reshape `padded` to `reshapedPadded` of shape:
 * `[batch] + [paddedShape[1] / blockShape[0], blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1], blockShape[M-1]] + remainingShape`
 *
 * 3. Permute dimensions of `reshapedPadded` to produce `permutedReshapedPadded`
 * of shape: `blockShape + [batch] + [paddedShape[1] / blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1]] + remainingShape`
 *
 * 4. Reshape `permutedReshapedPadded` to flatten `blockShape` into the
 * batch dimension, producing an output tensor of shape:
 * `[batch * prod(blockShape)] + [paddedShape[1] / blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1]] + remainingShape`
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $acc81226aaa46db7$var$spaceToBatchND_(x, blockShape, paddings) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'spaceToBatchND');
    $8cCb2.assert($x.rank >= 1 + blockShape.length, ()=>`input rank ${$x.rank} should be > than [blockShape] ${blockShape.length}`);
    $8cCb2.assert(paddings.length === blockShape.length, ()=>`paddings.shape[0] ${paddings.length} must be equal to [blockShape] ${blockShape.length}`);
    $8cCb2.assert($x.shape.reduce((a, b, i)=>{
        if (i > 0 && i <= blockShape.length) return a && (b + paddings[i - 1][0] + paddings[i - 1][1]) % blockShape[i - 1] === 0;
        return a;
    }, true), ()=>`input spatial dimensions ${$x.shape.slice(1)} with paddings ${paddings.toString()} must be divisible by blockShapes ${blockShape.toString()}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockShape: blockShape,
        paddings: paddings
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.SpaceToBatchND), inputs, attrs);
}
const $acc81226aaa46db7$export$effb9d7cae92012f = /* @__PURE__ */ (0, $jqSCG.op)({
    spaceToBatchND_: $acc81226aaa46db7$var$spaceToBatchND_
});

});


parcelRegister("bWQC3", function(module, exports) {

$parcel$export(module.exports, "prod", () => $8b2dec4eec8fb3b3$export$5e143010dea16c85);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $inFmq = parcelRequire("inFmq");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the product of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.prod().print();  // or tf.prod(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.prod(axis).print();  // or tf.prod(x, axis)
 * ```
 *
 * @param x The input tensor to compute the product over. If the dtype is `bool`
 *   it will be converted to `int32` and the output dtype will be `int32`.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $8b2dec4eec8fb3b3$var$prod_(x, axis = null, keepDims = false) {
    let $x = (0, $5xBLk.convertToTensor)(x, 'x', 'prod');
    if ($x.dtype === 'bool') // bool is not an allowed type for the underlying kernel.
    $x = (0, $inFmq.cast)($x, 'int32');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Prod), inputs, attrs);
}
const $8b2dec4eec8fb3b3$export$5e143010dea16c85 = /* @__PURE__ */ (0, $jqSCG.op)({
    prod_: $8b2dec4eec8fb3b3$var$prod_
});

});

parcelRegister("3MjiG", function(module, exports) {

$parcel$export(module.exports, "raggedGather", () => $2c04d370930bbd05$export$e7118f605df251dd);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
function $2c04d370930bbd05$var$raggedGather_(paramsNestedSplits, paramsDenseValues, indices, outputRaggedRank) {
    const $paramsNestedSplits = paramsNestedSplits.map((t, i)=>(0, $5xBLk.convertToTensor)(t, `tensors${i}`, 'raggedGather', 'int32'));
    const $paramsDenseValues = (0, $5xBLk.convertToTensor)(paramsDenseValues, 'paramsDenseValues', 'raggedGather');
    const $indices = (0, $5xBLk.convertToTensor)(indices, 'indices', 'raggedGather', 'int32');
    const inputs = {
        paramsNestedSplits: $paramsNestedSplits,
        paramsDenseValues: $paramsDenseValues,
        indices: $indices
    };
    const attrs = {
        outputRaggedRank: outputRaggedRank
    };
    const result = (0, $38WwN.ENGINE).runKernel((0, $hl418.RaggedGather), inputs, attrs);
    return {
        outputNestedSplits: result.slice(0, result.length - 1),
        outputDenseValues: result[result.length - 1]
    };
}
const $2c04d370930bbd05$export$e7118f605df251dd = /* @__PURE__ */ (0, $jqSCG.op)({
    raggedGather_: $2c04d370930bbd05$var$raggedGather_
});

});

parcelRegister("6df7Q", function(module, exports) {

$parcel$export(module.exports, "raggedRange", () => $012ad56de118f1c5$export$a173be400c6762b5);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns a RaggedTensor result composed from rtDenseValues and rtNestedSplits,
 * such that result[i] = [starts[i], starts[i] + deltas[i], ..., limits[i]]).
 *
 * @param starts: A Tensor. Must be one of the following types:
 *     'float32', 'int32'. The starts of each range.
 * @param limits: A Tensor. Must have the same type as starts. The limits of
 *     each range.
 * @param deltas: A Tensor. Must have the same type as starts. The deltas of
 *     each range.
 * @return A map with the following properties:
 *     - rtNestedSplits: A Tensor of type 'int32'.
 *     - rtDenseValues: A Tensor. Has the same type as starts.
 */ function $012ad56de118f1c5$var$raggedRange_(starts, limits, deltas) {
    const $starts = (0, $5xBLk.convertToTensor)(starts, 'starts', 'raggedRange');
    const $limits = (0, $5xBLk.convertToTensor)(limits, 'limits', 'raggedRange', $starts.dtype);
    const $deltas = (0, $5xBLk.convertToTensor)(deltas, 'deltas', 'raggedRange', $starts.dtype);
    const inputs = {
        starts: $starts,
        limits: $limits,
        deltas: $deltas
    };
    const result = (0, $38WwN.ENGINE).runKernel((0, $hl418.RaggedRange), inputs);
    return {
        rtNestedSplits: result[0],
        rtDenseValues: result[1]
    };
}
const $012ad56de118f1c5$export$a173be400c6762b5 = /* @__PURE__ */ (0, $jqSCG.op)({
    raggedRange_: $012ad56de118f1c5$var$raggedRange_
});

});

parcelRegister("hRiiN", function(module, exports) {

$parcel$export(module.exports, "raggedTensorToTensor", () => $d005955acffcb7e3$export$621e390307cbbaa1);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Create a dense tensor from a ragged tensor, possibly altering its shape.
 *
 * The raggedTensorToTensor op creates a dense tensor from am array of row
 * partition tensors, a value vector, and default values. If the shape is
 * unspecified, the minimal shape required to contain all the elements in the
 * ragged tensor (the natural shape) will be used. If some dimensions are left
 * unspecified, then the size of the natural shape is used in that dimension.
 *
 * The defaultValue will be broadcast to the output shape. After that, the
 * values from the ragged tensor overwrite the default values. Note that the
 * defaultValue must have less dimensions than the value.
 *
 * The row partition tensors are in the order of the dimensions. At present, the
 * types can be: "ROW_SPLITS": the row_splits tensor from the ragged tensor.
 *   "VALUE_ROWIDS": the value_rowids tensor from the ragged tensor.
 *   "FIRST_DIM_SIZE": if value_rowids is used for the first dimension, then it
 * is preceded by "FIRST_DIM_SIZE".
 * ```
 * @param shape: A Tensor. Must be one of the following types: 'int32'. The
 *     desired shape of the output tensor. If left unspecified (empty), the
 *     minimal shape required to contain all the elements in the ragged tensor
 *     (the natural shape) will be used. If some dimensions are left
 *     unspecified, then the size of the natural shape is used in that
 *     dimension.
 *
 *     Note that dense dimensions cannot be modified by the shape argument.
 *     Trying to change the size of a dense dimension will cause the op to fail.
 *     Examples: natural shape: [4, 5, 6] shape: -1 output shape: [4, 5, 6]
 *
 *     natural shape: [4, 5, 6] shape: [3, -1, 2] output shape: [3, 5, 2]
 *
 *     natural shape: [4, 5, 6] shape: [3, 7, 2] output shape: [3, 7, 2]
 * @param values: A Tensor. A 1D tensor representing the values of the ragged
 *     tensor.
 * @param defaultValue: A Tensor. Must have the same type as values. The
 *     defaultValue when the shape is larger than the ragged tensor. The
 *     defaultValue is broadcast until it is the shape of the output tensor,
 *     and then overwritten by values in the ragged tensor. The default value
 *     must be compatible with this broadcast operation, and must have fewer
 *     dimensions than the value tensor.
 * @param rowPartitionTensors: A list of at least 1 Tensor objects with the same
 *     type in: 'int32'.
 * @param rowPartitionTypes: A list of strings. The types of the row partition
 *     tensors. At present, these can be:
 *     "ROW_SPLITS": the row_splits tensor from the ragged tensor.
 *     "VALUE_ROWIDS": the value_rowids tensor from the ragged tensor.
 *     "FIRST_DIM_SIZE": if value_rowids is used for the first dimension, then
 *         it is preceded by "FIRST_DIM_SIZE". The tensors are in the order of
 *         the dimensions.
 * @return A Tensor. Has the same type as values.
 * @doc {heading: 'Operations', subheading: 'Ragged'}
 */ function $d005955acffcb7e3$var$raggedTensorToTensor_(shape, values, defaultValue, rowPartitionTensors, rowPartitionTypes) {
    const $shape = (0, $5xBLk.convertToTensor)(shape, 'shape', 'raggedTensorToTensor', 'int32');
    const $values = (0, $5xBLk.convertToTensor)(values, 'values', 'raggedTensorToTensor');
    const $defaultValue = (0, $5xBLk.convertToTensor)(defaultValue, 'defaultValue', 'raggedTensorToTensor', $values.dtype);
    const $rowPartitionTensors = rowPartitionTensors.map((t, i)=>(0, $5xBLk.convertToTensor)(t, `tensors${i}`, 'raggedTensorToTensor', 'int32'));
    const inputs = {
        shape: $shape,
        values: $values,
        defaultValue: $defaultValue,
        rowPartitionTensors: $rowPartitionTensors
    };
    const attrs = {
        rowPartitionTypes: rowPartitionTypes
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.RaggedTensorToTensor), inputs, attrs);
}
const $d005955acffcb7e3$export$621e390307cbbaa1 = /* @__PURE__ */ (0, $jqSCG.op)({
    raggedTensorToTensor_: $d005955acffcb7e3$var$raggedTensorToTensor_
});

});

parcelRegister("bTXL0", function(module, exports) {

$parcel$export(module.exports, "rand", () => $8aa32f484b90fe36$export$bb0a9c36cf454ea0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $8cCb2 = parcelRequire("8cCb2");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Creates a `tf.Tensor` with values sampled from a random number generator
 * function defined by the user.
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param randFunction A random number generator function which is called
 * for each element in the output tensor.
 * @param dtype The data type of the output tensor. Defaults to 'float32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $8aa32f484b90fe36$var$rand_(shape, randFunction, dtype) {
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
    const size = (0, $8cCb2.sizeFromShape)(shape);
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    for(let i = 0; i < size; i++)values[i] = randFunction();
    return (0, $38WwN.ENGINE).makeTensor(values, shape, dtype);
}
const $8aa32f484b90fe36$export$bb0a9c36cf454ea0 = /* @__PURE__ */ (0, $jqSCG.op)({
    rand_: $8aa32f484b90fe36$var$rand_
});

});

parcelRegister("SB4J3", function(module, exports) {

$parcel$export(module.exports, "randomGamma", () => $0a41cda08b4fd1d5$export$63a8048b65295cb7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");

var $iG87S = parcelRequire("iG87S");

var $jqSCG = parcelRequire("jqSCG");

var $7QK6b = parcelRequire("7QK6b");
/**
 * Creates a `tf.Tensor` with values sampled from a gamma distribution.
 *
 * ```js
 * tf.randomGamma([2, 2], 1).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param alpha The shape parameter of the gamma distribution.
 * @param beta The inverse scale parameter of the gamma distribution. Defaults
 *     to 1.
 * @param dtype The data type of the output. Defaults to float32.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $0a41cda08b4fd1d5$var$randomGamma_(shape, alpha, beta = 1, dtype = 'float32', seed) {
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
    if (beta == null) beta = 1;
    if (dtype == null) dtype = 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new Error(`Unsupported data type ${dtype}`);
    const rgamma = new (0, $7QK6b.RandGamma)(alpha, beta, dtype, seed);
    const res = (0, $iG87S.buffer)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = rgamma.nextValue();
    return res.toTensor();
}
const $0a41cda08b4fd1d5$export$63a8048b65295cb7 = /* @__PURE__ */ (0, $jqSCG.op)({
    randomGamma_: $0a41cda08b4fd1d5$var$randomGamma_
});

});

parcelRegister("h2Vnz", function(module, exports) {

$parcel$export(module.exports, "randomNormal", () => $c68f21db59d988e8$export$a0ac5549a8bec918);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");

var $iG87S = parcelRequire("iG87S");

var $jqSCG = parcelRequire("jqSCG");

var $7QK6b = parcelRequire("7QK6b");
/**
 * Creates a `tf.Tensor` with values sampled from a normal distribution.
 *
 * ```js
 * tf.randomNormal([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param mean The mean of the normal distribution.
 * @param stdDev The standard deviation of the normal distribution.
 * @param dtype The data type of the output.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $c68f21db59d988e8$var$randomNormal_(shape, mean = 0, stdDev = 1, dtype, seed) {
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type ${dtype}`);
    const randGauss = new (0, $7QK6b.MPRandGauss)(mean, stdDev, dtype, false, seed);
    const res = (0, $iG87S.buffer)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = randGauss.nextValue();
    return res.toTensor();
}
const $c68f21db59d988e8$export$a0ac5549a8bec918 = /* @__PURE__ */ (0, $jqSCG.op)({
    randomNormal_: $c68f21db59d988e8$var$randomNormal_
});

});

parcelRegister("kVqJN", function(module, exports) {

$parcel$export(module.exports, "randomStandardNormal", () => $f3bddf0c4680dee4$export$5a8aa20f8ebaee69);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jqSCG = parcelRequire("jqSCG");

var $h2Vnz = parcelRequire("h2Vnz");
/**
 * Creates a `tf.Tensor` with values sampled from a normal distribution.
 *
 * The generated values will have mean 0 and standard deviation 1.
 *
 * ```js
 * tf.randomStandardNormal([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param dtype The data type of the output.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $f3bddf0c4680dee4$var$randomStandardNormal_(shape, dtype, seed) {
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type ${dtype}`);
    return (0, $h2Vnz.randomNormal)(shape, 0, 1, dtype, seed);
}
const $f3bddf0c4680dee4$export$5a8aa20f8ebaee69 = /* @__PURE__ */ (0, $jqSCG.op)({
    randomStandardNormal_: $f3bddf0c4680dee4$var$randomStandardNormal_
});

});

parcelRegister("edlzT", function(module, exports) {

$parcel$export(module.exports, "randomUniformInt", () => $a5930481412268a3$export$134fe7f07fd7b492);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jqSCG = parcelRequire("jqSCG");

var $j8sic = parcelRequire("j8sic");
/**
 * Creates a `tf.Tensor` with integers sampled from a uniform distribution.
 *
 * The generated values are uniform integers in the range [minval, maxval). The
 * lower bound minval is included in the range, while the upper bound maxval is
 * excluded.
 *
 * ```js
 * tf.randomUniformInt([2, 2], 0, 10).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param minval Inclusive lower bound on the generated integers.
 * @param maxval Exclusive upper bound on the generated integers.
 * @param seed An optional int. Defaults to 0. If seed is set to be non-zero,
 *   the random number generator is seeded by the given seed. Otherwise, it is
 *   seeded by a random seed.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $a5930481412268a3$var$randomUniformInt_(shape, minval, maxval, seed) {
    // TODO(mattsoulanille): Handle optional seed2 input.
    return (0, $j8sic.randomUniform)(shape, minval, maxval, 'int32', seed);
}
const $a5930481412268a3$export$134fe7f07fd7b492 = /* @__PURE__ */ (0, $jqSCG.op)({
    randomUniformInt_: $a5930481412268a3$var$randomUniformInt_
});

});

parcelRegister("80Ety", function(module, exports) {

$parcel$export(module.exports, "range", () => $5d4db871afef7031$export$d02631cccf789723);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");
function $5d4db871afef7031$export$d02631cccf789723(start, stop, step = 1, dtype = 'float32') {
    if (step === 0) throw new Error('Cannot have a step of zero');
    const attrs = {
        start: start,
        stop: stop,
        step: step,
        dtype: dtype
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Range), {} /* inputs */ , attrs);
}

});

parcelRegister("b7x1G", function(module, exports) {

$parcel$export(module.exports, "real", () => $8189f77a6a673bd0$export$9fc57fb453bdbd67);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns the real part of a complex (or real) tensor.
 *
 * Given a tensor input, this operation returns a tensor of type float that is
 * the real part of each element in input considered as a complex number.
 *
 * If the input is real, it simply makes a clone.
 *
 * ```js
 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
 * tf.real(x).print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $8189f77a6a673bd0$var$real_(input) {
    const $input = (0, $5xBLk.convertToTensor)(input, 'input', 'real');
    const inputs = {
        input: $input
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Real), inputs);
}
const $8189f77a6a673bd0$export$9fc57fb453bdbd67 = /* @__PURE__ */ (0, $jqSCG.op)({
    real_: $8189f77a6a673bd0$var$real_
});

});

parcelRegister("3aqJ6", function(module, exports) {

$parcel$export(module.exports, "reciprocal", () => $24e709942a18bc8e$export$163bc8c839a1ac04);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes reciprocal of x element-wise: `1 / x`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, 2]);
 *
 * x.reciprocal().print();  // or tf.reciprocal(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $24e709942a18bc8e$var$reciprocal_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'reciprocal');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Reciprocal), inputs);
}
const $24e709942a18bc8e$export$163bc8c839a1ac04 = /* @__PURE__ */ (0, $jqSCG.op)({
    reciprocal_: $24e709942a18bc8e$var$reciprocal_
});

});

parcelRegister("6act6", function(module, exports) {

$parcel$export(module.exports, "reverse", () => $47cd593c7f6553f1$export$66c1ae025e96b4bc);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Reverses a `tf.Tensor` along a specified axis.
 *
 * Also available are stricter rank-specific methods that assert that `x` is
 * of the given rank:
 *   - `tf.reverse1d`
 *   - `tf.reverse2d`
 *   - `tf.reverse3d`
 *   - `tf.reverse4d`
 *
 * Except `tf.reverse1d` (which does not have axis param), all methods have
 * same signature as this method.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.reverse().print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.reverse(axis).print();
 * ```
 * @param x The input tensor to be reversed.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $47cd593c7f6553f1$var$reverse_(x, axis) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'reverse');
    const inputs = {
        x: $x
    };
    const attrs = {
        dims: axis
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Reverse), inputs, attrs);
}
const $47cd593c7f6553f1$export$66c1ae025e96b4bc = /* @__PURE__ */ (0, $jqSCG.op)({
    reverse_: $47cd593c7f6553f1$var$reverse_
});

});

parcelRegister("2KcE1", function(module, exports) {

$parcel$export(module.exports, "reverse1d", () => $1ff9af9aa5e82ce6$export$ec29ded9cbde7103);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $6act6 = parcelRequire("6act6");
/**
 * Reverses a `tf.Tensor1D`.
 *
 * @param x The input tensor.
 */ function $1ff9af9aa5e82ce6$var$reverse1d_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'reverse');
    $8cCb2.assert($x.rank === 1, ()=>`Error in reverse1D: x must be rank 1 but got rank ${$x.rank}.`);
    return (0, $6act6.reverse)($x, 0);
}
const $1ff9af9aa5e82ce6$export$ec29ded9cbde7103 = /* @__PURE__ */ (0, $jqSCG.op)({
    reverse1d_: $1ff9af9aa5e82ce6$var$reverse1d_
});

});

parcelRegister("8EvRg", function(module, exports) {

$parcel$export(module.exports, "reverse2d", () => $64cac5866b1d4ce7$export$12170f5f8cb48014);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $6act6 = parcelRequire("6act6");
/**
 * Reverses a `tf.Tensor2D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $64cac5866b1d4ce7$var$reverse2d_(x, axis) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'reverse');
    $8cCb2.assert($x.rank === 2, ()=>`Error in reverse2D: x must be rank 2 but got rank ${$x.rank}.`);
    return (0, $6act6.reverse)($x, axis);
}
const $64cac5866b1d4ce7$export$12170f5f8cb48014 = /* @__PURE__ */ (0, $jqSCG.op)({
    reverse2d_: $64cac5866b1d4ce7$var$reverse2d_
});

});

parcelRegister("c9r0k", function(module, exports) {

$parcel$export(module.exports, "reverse3d", () => $8d8b45c71f7c374d$export$1ecb65b2ca41f0e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $6act6 = parcelRequire("6act6");
/**
 * Reverses a `tf.Tensor3D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $8d8b45c71f7c374d$var$reverse3d_(x, axis) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'reverse');
    $8cCb2.assert($x.rank === 3, ()=>`Error in reverse3D: x must be rank 3 but got rank ${$x.rank}.`);
    return (0, $6act6.reverse)($x, axis);
}
const $8d8b45c71f7c374d$export$1ecb65b2ca41f0e = /* @__PURE__ */ (0, $jqSCG.op)({
    reverse3d_: $8d8b45c71f7c374d$var$reverse3d_
});

});

parcelRegister("bFrHw", function(module, exports) {

$parcel$export(module.exports, "reverse4d", () => $87e902ddeaa5429c$export$76a1df46e0e42da4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $6act6 = parcelRequire("6act6");
/**
 * Reverses a `tf.Tensor4D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $87e902ddeaa5429c$var$reverse4d_(x, axis) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'reverse');
    $8cCb2.assert($x.rank === 4, ()=>`Error in reverse4D: x must be rank 4 but got rank ${$x.rank}.`);
    return (0, $6act6.reverse)($x, axis);
}
const $87e902ddeaa5429c$export$76a1df46e0e42da4 = /* @__PURE__ */ (0, $jqSCG.op)({
    reverse4d_: $87e902ddeaa5429c$var$reverse4d_
});

});

parcelRegister("9YKoa", function(module, exports) {

$parcel$export(module.exports, "round", () => $743db37ae6b6e648$export$2077e0241d6afd3c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes round of input `tf.Tensor` element-wise: `round(x)`.
 * It implements banker's rounding.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.round().print();  // or tf.round(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $743db37ae6b6e648$var$round_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'round');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Round), inputs);
}
const $743db37ae6b6e648$export$2077e0241d6afd3c = /* @__PURE__ */ (0, $jqSCG.op)({
    round_: $743db37ae6b6e648$var$round_
});

});

parcelRegister("5pj7R", function(module, exports) {

$parcel$export(module.exports, "rsqrt", () => $3efe1f83a3e5837d$export$1cc01d192953037e);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes reciprocal of square root of the input `tf.Tensor` element-wise:
 * `y = 1 / sqrt(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 4, -1]);
 *
 * x.rsqrt().print();  // or tf.rsqrt(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $3efe1f83a3e5837d$var$rsqrt_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'rsqrt', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Rsqrt), inputs);
}
const $3efe1f83a3e5837d$export$1cc01d192953037e = /* @__PURE__ */ (0, $jqSCG.op)({
    rsqrt_: $3efe1f83a3e5837d$var$rsqrt_
});

});

parcelRegister("b636r", function(module, exports) {

$parcel$export(module.exports, "selu", () => $8142a96555db4d0b$export$a5f8240d9e99b438);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes scaled exponential linear element-wise.
 *
 * `x < 0 ? scale * alpha * (exp(x) - 1) : scale * x`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.selu().print();  // or tf.selu(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $8142a96555db4d0b$var$selu_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'selu');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Selu), inputs);
}
const $8142a96555db4d0b$export$a5f8240d9e99b438 = /* @__PURE__ */ (0, $jqSCG.op)({
    selu_: $8142a96555db4d0b$var$selu_
});

});

parcelRegister("8uLn4", function(module, exports) {

$parcel$export(module.exports, "separableConv2d", () => $62f5def725189d23$export$2586c92899c2d0fb);

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $5Nkm1 = parcelRequire("5Nkm1");

var $182Rc = parcelRequire("182Rc");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * 2-D convolution with separable filters.
 *
 * Performs a depthwise convolution that acts separately on channels followed
 * by a pointwise convolution that mixes channels. Note that this is
 * separability between dimensions [1, 2] and 3, not spatial separability
 * between dimensions 1 and 2.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d)
 * for more details.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param depthwiseFilter The depthwise filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`. This is
 *     the filter used in the first step.
 * @param pointwiseFilter The pointwise filter tensor, rank 4, of shape
 *     `[1, 1, inChannels * channelMultiplier, outChannels]`. This is
 *     the filter used in the second step.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $62f5def725189d23$var$separableConv2d_(x, depthwiseFilter, pointwiseFilter, strides, pad, dilation = [
    1,
    1
], dataFormat = 'NHWC') {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'separableConv2d');
    const $depthwiseFilter = (0, $5xBLk.convertToTensor)(depthwiseFilter, 'depthwiseFilter', 'separableConv2d');
    const $pointwiseFilter = (0, $5xBLk.convertToTensor)(pointwiseFilter, 'pointwiseFilter', 'separableConv2d');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $4sqA7.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    if (dataFormat === 'NCHW') throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
    $8cCb2.assert(x4D.rank === 4, ()=>`Error in separableConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $8cCb2.assert($depthwiseFilter.rank === 4, ()=>`Error in separableConv2d: depthwise filter must be rank 4, but ` + `got rank ${$depthwiseFilter.rank}.`);
    $8cCb2.assert($pointwiseFilter.rank === 4, ()=>`Error in separableConv2d: pointwise filter must be rank 4, but ` + `got rank ${$depthwiseFilter.rank}.`);
    $8cCb2.assert($pointwiseFilter.shape[0] === 1, ()=>`Error in separableConv2d: the first dimension of pointwise filter ` + ` must be 1, but got ${$pointwiseFilter.shape[0]}.`);
    $8cCb2.assert($pointwiseFilter.shape[1] === 1, ()=>`Error in separableConv2d: the second dimension of pointwise ` + `filter must be 1, but got ${$pointwiseFilter.shape[1]}.`);
    const inChannels = $depthwiseFilter.shape[2];
    const channelMultiplier = $depthwiseFilter.shape[3];
    $8cCb2.assert($pointwiseFilter.shape[2] === inChannels * channelMultiplier, ()=>`Error in separableConv2d: the third dimension of pointwise filter ` + `must be ${inChannels * channelMultiplier}, ` + `but got ${$pointwiseFilter.shape[2]}.`);
    const depthwise = (0, $182Rc.depthwiseConv2d)(x4D, $depthwiseFilter, strides, pad, dataFormat, dilation);
    const pointwiseStride = 1;
    const res = (0, $5Nkm1.conv2d)(depthwise, $pointwiseFilter, pointwiseStride, 'valid', dataFormat);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $62f5def725189d23$export$2586c92899c2d0fb = /* @__PURE__ */ (0, $jqSCG.op)({
    separableConv2d_: $62f5def725189d23$var$separableConv2d_
});

});

parcelRegister("d05b8", function(module, exports) {

$parcel$export(module.exports, "setdiff1dAsync", () => $976f4ad32ff317f5$export$cd50e5d116ec1774);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9jCh7 = parcelRequire("9jCh7");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");
/**
 * Computes the difference between two lists of numbers.
 *
 * Given a Tensor `x` and a Tensor `y`, this operation returns a Tensor `out`
 * that represents all values that are in `x` but not in `y`. The returned
 * Tensor `out` is sorted in the same order that the numbers appear in `x`
 * (duplicates are preserved). This operation also returns a Tensor indices that
 * represents the position of each out element in `x`. In other words:
 *
 * `out[i] = x[idx[i]] for i in [0, 1, ..., out.length - 1]`
 *
 * ```js
 * const x = [1, 2, 3, 4, 5, 6];
 * const y = [1, 3, 5];
 *
 * const [out, indices] = await tf.setdiff1dAsync(x, y);
 * out.print(); // [2, 4, 6]
 * indices.print(); // [1, 3, 5]
 * ```
 *
 * @param x 1-D Tensor. Values to keep.
 * @param y 1-D Tensor. Must have the same type as x. Values to exclude in the
 *     output.
 * @returns Promise of Tensor tuple [out, indices].
 *  out: Tensor with the same type as x.
 *  indices: A Tensor of type int32.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ async function $976f4ad32ff317f5$var$setdiff1dAsync_(x, y) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'setdiff1d');
    const $y = (0, $5xBLk.convertToTensor)(y, 'y', 'setdiff1d');
    $8cCb2.assert($x.dtype === $y.dtype, ()=>`x and y should have the same dtype, but got x (${$x.dtype}) and y (${$y.dtype}).`);
    $8cCb2.assert($x.rank === 1, ()=>`x should be 1D tensor, but got x (${$x.shape}).`);
    $8cCb2.assert($y.rank === 1, ()=>`y should be 1D tensor, but got y (${$y.shape}).`);
    const xVals = await $x.data();
    const yVals = await $y.data();
    const ySet = new Set(yVals);
    let outputSize = 0;
    for(let i = 0; i < xVals.length; i++)if (!ySet.has(xVals[i])) outputSize++;
    const buffer = new (0, $9jCh7.TensorBuffer)([
        outputSize
    ], $x.dtype);
    const indices = new (0, $9jCh7.TensorBuffer)([
        outputSize
    ], 'int32');
    for(let i = 0, p = 0; i < xVals.length; i++)if (!ySet.has(xVals[i])) {
        buffer.values[p] = xVals[i];
        indices.values[p] = i;
        p++;
    }
    return [
        buffer.toTensor(),
        indices.toTensor()
    ];
}
const $976f4ad32ff317f5$export$cd50e5d116ec1774 = $976f4ad32ff317f5$var$setdiff1dAsync_;

});

parcelRegister("3zBCT", function(module, exports) {

$parcel$export(module.exports, "sign", () => $29a1d3c837b8ed64$export$c5552dfdbc7cec71);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns an element-wise indication of the sign of a number.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3, NaN, 0]);
 *
 * x.sign().print();  // or tf.sign(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $29a1d3c837b8ed64$var$sign_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'sign');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Sign), inputs);
}
const $29a1d3c837b8ed64$export$c5552dfdbc7cec71 = /* @__PURE__ */ (0, $jqSCG.op)({
    sign_: $29a1d3c837b8ed64$var$sign_
});

});

parcelRegister("4xqM7", function(module, exports) {

$parcel$export(module.exports, "sin", () => $34df037cb95cd0bc$export$5de3937cb4b592ed);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes sin of the input Tensor element-wise: `sin(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.sin().print();  // or tf.sin(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $34df037cb95cd0bc$var$sin_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'sin', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Sin), inputs);
}
const $34df037cb95cd0bc$export$5de3937cb4b592ed = /* @__PURE__ */ (0, $jqSCG.op)({
    sin_: $34df037cb95cd0bc$var$sin_
});

});

parcelRegister("fAOzm", function(module, exports) {

$parcel$export(module.exports, "sinh", () => $b5a171d6413337da$export$545004b505d7c555);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes hyperbolic sin of the input `tf.Tensor` element-wise: `sinh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.sinh().print();  // or tf.sinh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $b5a171d6413337da$var$sinh_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'sinh');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Sinh), inputs);
}
const $b5a171d6413337da$export$545004b505d7c555 = /* @__PURE__ */ (0, $jqSCG.op)({
    sinh_: $b5a171d6413337da$var$sinh_
});

});

parcelRegister("5vfHb", function(module, exports) {

$parcel$export(module.exports, "slice1d", () => $401c05c68cc4ac4b$export$95433662b275eb82);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $79KOG = parcelRequire("79KOG");
/**
 * Extracts a 1D slice from 1D array starting at coordinates `begin` and is
 * of length `size`. See `slice` for details.
 */ function $401c05c68cc4ac4b$var$slice1d_(x, begin, size) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'slice1d');
    $8cCb2.assert($x.rank === 1, ()=>`slice1d expects a rank-1 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $79KOG.slice)($x, [
        begin
    ], [
        size
    ]);
}
const $401c05c68cc4ac4b$export$95433662b275eb82 = /* @__PURE__ */ (0, $jqSCG.op)({
    slice1d_: $401c05c68cc4ac4b$var$slice1d_
});

});

parcelRegister("gKBEV", function(module, exports) {

$parcel$export(module.exports, "slice2d", () => $c31e278a3cb12d98$export$e5c6a6611cb43a9d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $79KOG = parcelRequire("79KOG");
/**
 * Extracts a 2D slice from a 2D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $c31e278a3cb12d98$var$slice2d_(x, begin, size) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'slice2d');
    $8cCb2.assert($x.rank === 2, ()=>`slice2d expects a rank-2 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $79KOG.slice)($x, begin, size);
}
const $c31e278a3cb12d98$export$e5c6a6611cb43a9d = /* @__PURE__ */ (0, $jqSCG.op)({
    slice2d_: $c31e278a3cb12d98$var$slice2d_
});

});

parcelRegister("22oMq", function(module, exports) {

$parcel$export(module.exports, "slice3d", () => $17befd7bb6856a0b$export$dec56af20749d733);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $79KOG = parcelRequire("79KOG");
/**
 * Extracts a 3D slice from a 3D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $17befd7bb6856a0b$var$slice3d_(x, begin, size) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'slice3d');
    $8cCb2.assert($x.rank === 3, ()=>`slice3d expects a rank-3 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $79KOG.slice)($x, begin, size);
}
const $17befd7bb6856a0b$export$dec56af20749d733 = /* @__PURE__ */ (0, $jqSCG.op)({
    slice3d_: $17befd7bb6856a0b$var$slice3d_
});

});

parcelRegister("8hEpb", function(module, exports) {

$parcel$export(module.exports, "slice4d", () => $607f40e3463324cc$export$9833e35e879da26c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $79KOG = parcelRequire("79KOG");
/**
 * Extracts a 4D slice from a 4D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $607f40e3463324cc$var$slice4d_(x, begin, size) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'slice4d');
    $8cCb2.assert($x.rank === 4, ()=>`slice4d expects a rank-4 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $79KOG.slice)($x, begin, size);
}
const $607f40e3463324cc$export$9833e35e879da26c = /* @__PURE__ */ (0, $jqSCG.op)({
    slice4d_: $607f40e3463324cc$var$slice4d_
});

});

parcelRegister("dnEu5", function(module, exports) {

$parcel$export(module.exports, "softmax", () => $9bdcd3abf3c06921$export$e008137e76238601);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the softmax normalized vector given the logits.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 *
 * a.softmax().print();  // or tf.softmax(a)
 * ```
 *
 * ```js
 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
 *
 * a.softmax().print();  // or tf.softmax(a)
 * ```
 *
 * @param logits The logits array.
 * @param dim The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $9bdcd3abf3c06921$var$softmax_(logits, dim = -1) {
    const $logits = (0, $5xBLk.convertToTensor)(logits, 'logits', 'softmax', 'float32');
    if (dim === -1) dim = $logits.rank - 1;
    if (dim !== $logits.rank - 1) throw Error('Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${$logits.rank} and dim was ${dim}`);
    const inputs = {
        logits: $logits
    };
    const attrs = {
        dim: dim
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Softmax), inputs, attrs);
}
const $9bdcd3abf3c06921$export$e008137e76238601 = /* @__PURE__ */ (0, $jqSCG.op)({
    softmax_: $9bdcd3abf3c06921$var$softmax_
});

});

parcelRegister("1Lg9u", function(module, exports) {

$parcel$export(module.exports, "fft", () => $1486b5b57f2c7550$export$a535ef183b6128fa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Fast Fourier transform.
 *
 * Computes the 1-dimensional discrete Fourier transform over the inner-most
 * dimension of input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([1, 2, 3]);
 * const x = tf.complex(real, imag);
 *
 * x.fft().print();  // tf.spectral.fft(x).print();
 * ```
 * @param input The complex input to compute an fft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $1486b5b57f2c7550$var$fft_(input) {
    (0, $8cCb2.assert)(input.dtype === 'complex64', ()=>`The dtype for tf.spectral.fft() must be complex64 ` + `but got ${input.dtype}.`);
    const inputs = {
        input: input
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.FFT), inputs);
}
const $1486b5b57f2c7550$export$a535ef183b6128fa = /* @__PURE__ */ (0, $jqSCG.op)({
    fft_: $1486b5b57f2c7550$var$fft_
});

});

parcelRegister("3l9Cr", function(module, exports) {

$parcel$export(module.exports, "ifft", () => $26eacb6258cb10d5$export$776649b0bf8ce1fd);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Inverse fast Fourier transform.
 *
 * Computes the inverse 1-dimensional discrete Fourier transform over the
 * inner-most dimension of input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([1, 2, 3]);
 * const x = tf.complex(real, imag);
 *
 * x.ifft().print();  // tf.spectral.ifft(x).print();
 * ```
 * @param input The complex input to compute an ifft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $26eacb6258cb10d5$var$ifft_(input) {
    (0, $8cCb2.assert)(input.dtype === 'complex64', ()=>`The dtype for tf.spectral.ifft() must be complex64 ` + `but got ${input.dtype}.`);
    const inputs = {
        input: input
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.IFFT), inputs);
}
const $26eacb6258cb10d5$export$776649b0bf8ce1fd = /* @__PURE__ */ (0, $jqSCG.op)({
    ifft_: $26eacb6258cb10d5$var$ifft_
});

});

parcelRegister("hrsi6", function(module, exports) {

$parcel$export(module.exports, "irfft", () => $cb2ae7445ffa5769$export$f47f4e5bcd3d6a66);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $20oDZ = parcelRequire("20oDZ");

var $iTu6j = parcelRequire("iTu6j");

var $1d8KH = parcelRequire("1d8KH");

var $jZc0w = parcelRequire("jZc0w");

var $jqSCG = parcelRequire("jqSCG");

var $b7x1G = parcelRequire("b7x1G");

var $4sqA7 = parcelRequire("4sqA7");

var $6act6 = parcelRequire("6act6");

var $3xp7o = parcelRequire("3xp7o");

var $79KOG = parcelRequire("79KOG");

var $3l9Cr = parcelRequire("3l9Cr");
/**
 * Inversed real value input fast Fourier transform.
 *
 * Computes the 1-dimensional inversed discrete Fourier transform over the
 * inner-most dimension of the real input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([0, 0, 0]);
 * const x = tf.complex(real, imag);
 *
 * x.irfft().print();
 * ```
 * @param input The real value input to compute an irfft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $cb2ae7445ffa5769$var$irfft_(input) {
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = input.size / innerDimensionSize;
    let ret;
    if (innerDimensionSize <= 2) {
        const complexInput = (0, $4sqA7.reshape)(input, [
            batch,
            innerDimensionSize
        ]);
        ret = (0, $3l9Cr.ifft)(complexInput);
    } else {
        // The length of unique components of the DFT of a real-valued signal
        // is 2 * (input_len - 1)
        const outputShape = [
            batch,
            2 * (innerDimensionSize - 1)
        ];
        const realInput = (0, $4sqA7.reshape)((0, $b7x1G.real)(input), [
            batch,
            innerDimensionSize
        ]);
        const imagInput = (0, $4sqA7.reshape)((0, $1d8KH.imag)(input), [
            batch,
            innerDimensionSize
        ]);
        const realConjugate = (0, $6act6.reverse)((0, $79KOG.slice)(realInput, [
            0,
            1
        ], [
            batch,
            innerDimensionSize - 2
        ]), 1);
        const imagConjugate = (0, $jZc0w.mul)((0, $6act6.reverse)((0, $79KOG.slice)(imagInput, [
            0,
            1
        ], [
            batch,
            innerDimensionSize - 2
        ]), 1), (0, $3xp7o.scalar)(-1));
        const r = (0, $iTu6j.concat)([
            realInput,
            realConjugate
        ], 1);
        const i = (0, $iTu6j.concat)([
            imagInput,
            imagConjugate
        ], 1);
        const complexInput = (0, $4sqA7.reshape)((0, $20oDZ.complex)(r, i), [
            outputShape[0],
            outputShape[1]
        ]);
        ret = (0, $3l9Cr.ifft)(complexInput);
    }
    ret = (0, $b7x1G.real)(ret);
    // reshape the result if the input is 3D tensor.
    if (input.rank === 3 && input.shape[0] !== 0) {
        const temp = ret;
        const batch = input.shape[0];
        ret = (0, $4sqA7.reshape)(ret, [
            batch,
            ret.shape[0] / batch,
            ret.shape[1]
        ]);
        temp.dispose();
    }
    return ret;
}
const $cb2ae7445ffa5769$export$f47f4e5bcd3d6a66 = /* @__PURE__ */ (0, $jqSCG.op)({
    irfft_: $cb2ae7445ffa5769$var$irfft_
});

});

parcelRegister("cafDa", function(module, exports) {

$parcel$export(module.exports, "rfft", () => $8db28b200f22d7be$export$72aff1768917e9e5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");

var $20oDZ = parcelRequire("20oDZ");

var $iTu6j = parcelRequire("iTu6j");

var $1d8KH = parcelRequire("1d8KH");

var $jqSCG = parcelRequire("jqSCG");

var $b7x1G = parcelRequire("b7x1G");

var $4sqA7 = parcelRequire("4sqA7");

var $79KOG = parcelRequire("79KOG");

var $9fmAX = parcelRequire("9fmAX");

var $hxi4c = parcelRequire("hxi4c");

var $8EjnK = parcelRequire("8EjnK");

var $1Lg9u = parcelRequire("1Lg9u");
/**
 * Real value input fast Fourier transform.
 *
 * Computes the 1-dimensional discrete Fourier transform over the
 * inner-most dimension of the real input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 *
 * real.rfft().print();
 * ```
 * @param input The real value input to compute an rfft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $8db28b200f22d7be$var$rfft_(input, fftLength) {
    (0, $8cCb2.assert)(input.dtype === 'float32', ()=>`The dtype for rfft() must be real value but got ${input.dtype}`);
    let innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = input.size / innerDimensionSize;
    let adjustedInput;
    if (fftLength != null && fftLength < innerDimensionSize) {
        // Need to crop
        const begin = input.shape.map((v)=>0);
        const size = input.shape.map((v)=>v);
        size[input.shape.length - 1] = fftLength;
        adjustedInput = (0, $79KOG.slice)(input, begin, size);
        innerDimensionSize = fftLength;
    } else if (fftLength != null && fftLength > innerDimensionSize) {
        // Need to pad with zeros
        const zerosShape = input.shape.map((v)=>v);
        zerosShape[input.shape.length - 1] = fftLength - innerDimensionSize;
        adjustedInput = (0, $iTu6j.concat)([
            input,
            (0, $hxi4c.zeros)(zerosShape)
        ], input.shape.length - 1);
        innerDimensionSize = fftLength;
    } else adjustedInput = input;
    // Complement the input with zero imaginary numbers.
    const zerosInput = (0, $8EjnK.zerosLike)(adjustedInput);
    const complexInput = (0, $4sqA7.reshape)((0, $20oDZ.complex)(adjustedInput, zerosInput), [
        batch,
        innerDimensionSize
    ]);
    const ret = (0, $1Lg9u.fft)(complexInput);
    // Exclude complex conjugations. These conjugations are put symmetrically.
    const half = Math.floor(innerDimensionSize / 2) + 1;
    const realValues = (0, $b7x1G.real)(ret);
    const imagValues = (0, $1d8KH.imag)(ret);
    const realComplexConjugate = (0, $9fmAX.split)(realValues, [
        half,
        innerDimensionSize - half
    ], realValues.shape.length - 1);
    const imagComplexConjugate = (0, $9fmAX.split)(imagValues, [
        half,
        innerDimensionSize - half
    ], imagValues.shape.length - 1);
    const outputShape = adjustedInput.shape.slice();
    outputShape[adjustedInput.shape.length - 1] = half;
    return (0, $4sqA7.reshape)((0, $20oDZ.complex)(realComplexConjugate[0], imagComplexConjugate[0]), outputShape);
}
const $8db28b200f22d7be$export$72aff1768917e9e5 = /* @__PURE__ */ (0, $jqSCG.op)({
    rfft_: $8db28b200f22d7be$var$rfft_
});

});
parcelRegister("9fmAX", function(module, exports) {

$parcel$export(module.exports, "split", () => $6bb70aae893ea3fa$export$65980d18b75784e2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Splits a `tf.Tensor` into sub tensors.
 *
 * If `numOrSizeSplits` is a number, splits `x` along dimension `axis`
 * into `numOrSizeSplits` smaller tensors.
 * Requires that `numOrSizeSplits` evenly divides `x.shape[axis]`.
 *
 * If `numOrSizeSplits` is a number array, splits `x` into
 * `numOrSizeSplits.length` pieces. The shape of the `i`-th piece has the
 * same size as `x` except along dimension `axis` where the size is
 * `numOrSizeSplits[i]`.
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 7, 8], [2, 4]);
 * const [a, b] = tf.split(x, 2, 1);
 * a.print();
 * b.print();
 *
 * const [c, d, e] = tf.split(x, [1, 2, 1], 1);
 * c.print();
 * d.print();
 * e.print();
 * ```
 *
 * @param x The input tensor to split.
 * @param numOrSizeSplits Either an integer indicating the number of
 * splits along the axis or an array of integers containing the sizes of
 * each output tensor along the axis. If a number then it must evenly divide
 * `x.shape[axis]`; otherwise the sum of sizes must match `x.shape[axis]`.
 * Can contain one -1 indicating that dimension is to be inferred.
 * @param axis The dimension along which to split. Defaults to 0 (the first
 * dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $6bb70aae893ea3fa$var$split_(x, numOrSizeSplits, axis = 0) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'split');
    const inputs = {
        x: $x
    };
    const attr = {
        numOrSizeSplits: numOrSizeSplits,
        axis: axis
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.SplitV), inputs, attr);
}
const $6bb70aae893ea3fa$export$65980d18b75784e2 = /* @__PURE__ */ (0, $jqSCG.op)({
    split_: $6bb70aae893ea3fa$var$split_
});

});


parcelRegister("ay2Nw", function(module, exports) {

$parcel$export(module.exports, "squaredDifference", () => $7adf3ff43b38d937$export$b178697fb6d0b37f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8BaGO = parcelRequire("8BaGO");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Returns (a - b) * (a - b) element-wise.
 * Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
 * ```
 *
 * ```js
 * // Broadcast squared difference  a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $7adf3ff43b38d937$var$squaredDifference_(a, b) {
    let $a = (0, $5xBLk.convertToTensor)(a, 'a', 'squaredDifference');
    let $b = (0, $5xBLk.convertToTensor)(b, 'b', 'squaredDifference');
    [$a, $b] = (0, $3w4Rg.makeTypesMatch)($a, $b);
    (0, $8BaGO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {};
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.SquaredDifference), inputs, attrs);
}
const $7adf3ff43b38d937$export$b178697fb6d0b37f = /* @__PURE__ */ (0, $jqSCG.op)({
    squaredDifference_: $7adf3ff43b38d937$var$squaredDifference_
});

});

parcelRegister("kX8Hd", function(module, exports) {

$parcel$export(module.exports, "squeeze", () => $f41010297af56801$export$889c931173b77c2f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Removes dimensions of size 1 from the shape of a `tf.Tensor`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4], [1, 1, 4]);
 * x.squeeze().print();
 * ```
 *
 * @param x The input tensor to be squeezed.
 * @param axis An optional list of numbers. If specified, only
 *     squeezes the dimensions listed. The dimension index starts at 0. It
 * is an error to squeeze a dimension that is not 1.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $f41010297af56801$var$squeeze_(x, axis) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'squeeze', 'string_or_numeric');
    return (0, $4sqA7.reshape)($x, (0, $8cCb2.squeezeShape)($x.shape, axis).newShape);
}
const $f41010297af56801$export$889c931173b77c2f = /* @__PURE__ */ (0, $jqSCG.op)({
    squeeze_: $f41010297af56801$var$squeeze_
});

});

parcelRegister("8BrLX", function(module, exports) {

$parcel$export(module.exports, "stack", () => $6437527469582bc5$export$a57ab32f40f83ea9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Stacks a list of rank-`R` `tf.Tensor`s into one rank-`(R+1)` `tf.Tensor`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 * tf.stack([a, b, c]).print();
 * ```
 *
 * @param tensors A list of tensor objects with the same shape and dtype.
 * @param axis The axis to stack along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $6437527469582bc5$var$stack_(tensors, axis = 0) {
    const $tensors = (0, $5xBLk.convertToTensorArray)(tensors, 'tensors', 'stack', 'string_or_numeric');
    $8cCb2.assert($tensors.length >= 1, ()=>'Pass at least one tensor to tf.stack');
    if ($tensors.length > 0) $8cCb2.assert(axis <= $tensors[0].rank, ()=>'Axis must be <= rank of the tensor');
    const inputs = $tensors;
    const attrs = {
        axis: axis
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Pack), inputs, attrs);
}
const $6437527469582bc5$export$a57ab32f40f83ea9 = /* @__PURE__ */ (0, $jqSCG.op)({
    stack_: $6437527469582bc5$var$stack_
});

});

parcelRegister("dqRnt", function(module, exports) {

$parcel$export(module.exports, "stridedSlice", () => $9c771bc0944a917c$export$4ae57224f3b0605c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Extracts a strided slice of a tensor.
 *
 * Roughly speaking, this op extracts a slice of size (end-begin)/stride from
 * the given input tensor (x). Starting at the location specified by begin the
 * slice continues by adding stride to the index until all dimensions are not
 * less than end. Note that a stride can be negative, which causes a reverse
 * slice.
 *
 * ```js
 * const t = tf.tensor3d([1, 1, 1 ,2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6],
 *    [3, 2, 3]);
 * t.stridedSlice([1, 0, 0], [2, 1, 3], [1, 1, 1]).print()  // [[[3, 3, 3]]]
 * t.stridedSlice([1, 0, 0], [2, 2, 3], [1, 1, 1]).print()  // [[[3, 3, 3],
 *                                                     // [4, 4, 4]]]
 * t.stridedSlice([1, -1, 0], [2, -3, 3], [1, -1, 1]).print() // [[[4, 4, 4],
 *                                                     // [3, 3, 3]]]
 * ```
 *
 * @param x The tensor to stride slice.
 * @param begin The coordinates to start the slice from.
 * @param end: The coordinates to end the slice at.
 * @param strides: The size of the slice.
 * @param beginMask: If the ith bit of beginMask is set, begin[i] is ignored
 *      and the fullest possible range in that dimension is used instead.
 * @param endMask: If the ith bit of endMask is set, end[i] is ignored
 *      and the fullest possible range in that dimension is used instead.
 * @param shrinkAxisMask: a bitmask where bit i implies that
 * the ith specification should shrink the dimensionality. begin and end must
 * imply a slice of size 1 in the dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $9c771bc0944a917c$var$stridedSlice_(x, begin, end, strides, beginMask = 0, endMask = 0, ellipsisMask = 0, newAxisMask = 0, shrinkAxisMask = 0) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'stridedSlice', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    const attrs = {
        begin: begin,
        end: end,
        strides: strides,
        beginMask: beginMask,
        endMask: endMask,
        ellipsisMask: ellipsisMask,
        newAxisMask: newAxisMask,
        shrinkAxisMask: shrinkAxisMask
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.StridedSlice), inputs, attrs);
}
const $9c771bc0944a917c$export$4ae57224f3b0605c = /* @__PURE__ */ (0, $jqSCG.op)({
    stridedSlice_: $9c771bc0944a917c$var$stridedSlice_
});

});

parcelRegister("l8Hok", function(module, exports) {

$parcel$export(module.exports, "tan", () => $f63c00f5c65721ae$export$fcdd3b0b3246a325);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes tan of the input `tf.Tensor` element-wise, `tan(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.tan().print();  // or tf.tan(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $f63c00f5c65721ae$var$tan_(x) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'tan', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Tan), inputs);
}
const $f63c00f5c65721ae$export$fcdd3b0b3246a325 = /* @__PURE__ */ (0, $jqSCG.op)({
    tan_: $f63c00f5c65721ae$var$tan_
});

});

parcelRegister("lalFM", function(module, exports) {

$parcel$export(module.exports, "tensor1d", () => $f68b57eba454beb7$export$8133e3bf3cd8f464);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $dKr4X = parcelRequire("dKr4X");
function $f68b57eba454beb7$export$8133e3bf3cd8f464(values, dtype) {
    (0, $8cCb2.assertNonNull)(values);
    const inferredShape = (0, $5xBLk.inferShape)(values, dtype);
    if (inferredShape.length !== 1) throw new Error('tensor1d() requires values to be a flat/TypedArray');
    const shape = null;
    return (0, $dKr4X.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("gmMlv", function(module, exports) {

$parcel$export(module.exports, "tensor2d", () => $bea433ea0b14d5fb$export$b5469a65e8732256);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $dKr4X = parcelRequire("dKr4X");
function $bea433ea0b14d5fb$export$b5469a65e8732256(values, shape, dtype) {
    (0, $8cCb2.assertNonNull)(values);
    if (shape != null && shape.length !== 2) throw new Error('tensor2d() requires shape to have two numbers');
    const inferredShape = (0, $5xBLk.inferShape)(values, dtype);
    if (inferredShape.length !== 2 && inferredShape.length !== 1) throw new Error('tensor2d() requires values to be number[][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
    return (0, $dKr4X.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("6BSQ6", function(module, exports) {

$parcel$export(module.exports, "tensor4d", () => $4d00bcbc9bb89eab$export$b43603ce4e7542a7);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $dKr4X = parcelRequire("dKr4X");
function $4d00bcbc9bb89eab$export$b43603ce4e7542a7(values, shape, dtype) {
    (0, $8cCb2.assertNonNull)(values);
    if (shape != null && shape.length !== 4) throw new Error('tensor4d() requires shape to have four numbers');
    const inferredShape = (0, $5xBLk.inferShape)(values, dtype);
    if (inferredShape.length !== 4 && inferredShape.length !== 1) throw new Error('tensor4d() requires values to be number[][][][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");
    return (0, $dKr4X.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("fjd6b", function(module, exports) {

$parcel$export(module.exports, "tensor5d", () => $b252ca7efcfee5b9$export$ab0278981fc9e727);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $dKr4X = parcelRequire("dKr4X");
function $b252ca7efcfee5b9$export$ab0278981fc9e727(values, shape, dtype) {
    (0, $8cCb2.assertNonNull)(values);
    if (shape != null && shape.length !== 5) throw new Error('tensor5d() requires shape to have five numbers');
    const inferredShape = (0, $5xBLk.inferShape)(values, dtype);
    if (inferredShape.length !== 5 && inferredShape.length !== 1) throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");
    return (0, $dKr4X.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("gCuDf", function(module, exports) {

$parcel$export(module.exports, "tensor6d", () => $c197f4d49e2608e8$export$7b9f27dd2306a502);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $dKr4X = parcelRequire("dKr4X");
function $c197f4d49e2608e8$export$7b9f27dd2306a502(values, shape, dtype) {
    (0, $8cCb2.assertNonNull)(values);
    if (shape != null && shape.length !== 6) throw new Error('tensor6d() requires shape to have six numbers');
    const inferredShape = (0, $5xBLk.inferShape)(values, dtype);
    if (inferredShape.length !== 6 && inferredShape.length !== 1) throw new Error("tensor6d() requires values to be number[][][][][][] or flat/TypedArray");
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");
    shape = shape || inferredShape;
    return (0, $dKr4X.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("4om7p", function(module, exports) {

$parcel$export(module.exports, "tensorScatterUpdate", () => $332a8f98d69e0a66$export$d3ac02769385eb36);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");

var $7wQGW = parcelRequire("7wQGW");
/**
 * Creates a new tensor by applying sparse updates to individual
 * values or slices to the passed in tensor according to
 * indices. This operator is the similar to scatterNd op, except that the
 * udpates are scattered on an existing tensor (as opposed to a zero-tensor).
 *
 * If indices contains duplicates, then we pick the last update for the index.
 *
 * If an out of bound index is found on CPU, an error is returned.
 *
 * Warning: There are some GPU specific semantics for this operation.
 *  - If an out of bound index is found, the index is ignored.
 *  - The order in which updates are applied is nondeterministic, so the output
 * will be nondeterministic if indices contains duplicates.
 * ```js
 * const shape = [8];
 * const tensor = tf.ones(shape);
 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
 * const updates = tf.tensor1d([9, 10, 11, 12]);
 *
 * tf.tensorScatterUpdate(tensor, indices, updates).print();
 *    //[1, 11, 1, 10, 9, 1, 1, 12]
 * ```
 *
 * @param tensor A Tensor. Tensor to copy/update.
 * @param indices The tensor contains the indices into the output tensor, must
 *     have at least 2 axes: (num_updates, index_depth).
 * @param updates The tensor contains the value for the indices.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $332a8f98d69e0a66$var$tensorScatterUpdate_(tensor, indices, updates) {
    const $tensor = (0, $5xBLk.convertToTensor)(tensor, 'tensor', 'tensorScatterupdate');
    const $indices = (0, $5xBLk.convertToTensor)(indices, 'indices', 'tensorScatterupdate', 'int32');
    const $updates = (0, $5xBLk.convertToTensor)(updates, 'updates', 'tensorScatterupdate');
    $7wQGW.validateInput($updates, $indices, $tensor.shape);
    if ($tensor.dtype !== $updates.dtype) throw new Error(`tensor and updates must have the same dtype, instead they are ${$tensor.dtype} and ${$updates.dtype}.`);
    const inputs = {
        tensor: $tensor,
        indices: $indices,
        updates: $updates
    };
    const attrs = {};
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.TensorScatterUpdate), inputs, attrs);
}
const $332a8f98d69e0a66$export$d3ac02769385eb36 = (0, $jqSCG.op)({
    tensorScatterUpdate_: $332a8f98d69e0a66$var$tensorScatterUpdate_
});

});

parcelRegister("cRAvI", function(module, exports) {

$parcel$export(module.exports, "topk", () => $95d6c1822e5bc026$export$4e6b28a600f8b4df);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Finds the values and indices of the `k` largest entries along the last
 * dimension.
 *
 * If the input is a vector (rank=1), finds the k largest entries in the vector
 * and outputs their values and indices as vectors. Thus values[j] is the j-th
 * largest entry in input, and its index is indices[j].
 * For higher rank inputs, computes the top k entries along the last dimension.
 *
 * If two elements are equal, the lower-index element appears first.
 *
 * ```js
 * const a = tf.tensor2d([[1, 5], [4, 3]]);
 * const {values, indices} = tf.topk(a);
 * values.print();
 * indices.print();
 * ```
 * @param x 1-D or higher `tf.Tensor` with last dimension being at least `k`.
 * @param k Number of top elements to look for along the last dimension.
 * @param sorted If true, the resulting `k` elements will be sorted by the
 *     values in descending order.
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $95d6c1822e5bc026$var$topk_(x, k = 1, sorted = true) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'topk');
    if ($x.rank === 0) throw new Error('topk() expects the input to be of rank 1 or higher');
    const lastDim = $x.shape[$x.shape.length - 1];
    if (k < 0) throw new Error(`'k' passed to topk() must be >= 0 but got ${k}`);
    if (k > lastDim) throw new Error(`'k' passed to topk() must be <= the last dimension (${lastDim}) ` + `but got ${k}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        k: k,
        sorted: sorted
    };
    const [values, indices] = (0, $38WwN.ENGINE).runKernel((0, $hl418.TopK), inputs, attrs);
    return {
        values: values,
        indices: indices
    };
}
const $95d6c1822e5bc026$export$4e6b28a600f8b4df = /* @__PURE__ */ (0, $jqSCG.op)({
    topk_: $95d6c1822e5bc026$var$topk_
});

});

parcelRegister("dE1HO", function(module, exports) {

$parcel$export(module.exports, "truncatedNormal", () => $9ef055855a9c1b37$export$8ad5625727f3fa1d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");

var $iG87S = parcelRequire("iG87S");

var $jqSCG = parcelRequire("jqSCG");

var $7QK6b = parcelRequire("7QK6b");
/**
 * Creates a `tf.Tensor` with values sampled from a truncated normal
 * distribution.
 *
 * ```js
 * tf.truncatedNormal([2, 2]).print();
 * ```
 *
 * The generated values follow a normal distribution with specified mean and
 * standard deviation, except that values whose magnitude is more than 2
 * standard deviations from the mean are dropped and re-picked.
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param mean The mean of the normal distribution.
 * @param stdDev The standard deviation of the normal distribution.
 * @param dtype The data type of the output tensor.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $9ef055855a9c1b37$var$truncatedNormal_(shape, mean = 0, stdDev = 1, dtype, seed) {
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type $ { dtype }`);
    const randGauss = new (0, $7QK6b.MPRandGauss)(mean, stdDev, dtype, true, seed);
    const res = (0, $iG87S.buffer)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = randGauss.nextValue();
    return res.toTensor();
}
const $9ef055855a9c1b37$export$8ad5625727f3fa1d = /* @__PURE__ */ (0, $jqSCG.op)({
    truncatedNormal_: $9ef055855a9c1b37$var$truncatedNormal_
});

});

parcelRegister("aEpp6", function(module, exports) {

$parcel$export(module.exports, "unique", () => $7c1158843694185a$export$7a5d5c156e7dc406);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Finds unique elements along an axis of a tensor.
 *
 * It returns a tensor `values` containing all of the unique elements along the
 * `axis` of the given tensor `x` in the same order that they occur along the
 * `axis` in `x`; `x` does not need to be sorted. It also returns a tensor
 * `indices` the same size as the number of the elements in `x` along the `axis`
 * dimension. It contains the index in the unique output `values`.
 *
 * ```js
 * // A 1-D tensor
 * const a = tf.tensor1d([1, 1, 2, 4, 4, 4, 7, 8, 8]);
 * const {values, indices} = tf.unique(a);
 * values.print();   // [1, 2, 4, 7, 8,]
 * indices.print();  // [0, 0, 1, 2, 2, 2, 3, 4, 4]
 * ```
 *
 * ```js
 * // A 2-D tensor with axis=0
 * //
 * // 'a' is: [[1, 0, 0],
 * //          [1, 0, 0],
 * //          [2, 0, 0]]
 * const a = tf.tensor2d([[1, 0, 0], [1, 0, 0], [2, 0, 0]]);
 * const {values, indices} = tf.unique(a, 0)
 * values.print();   // [[1, 0, 0],
 *                   //  [2, 0, 0]]
 * indices.print();  // [0, 0, 1]
 * ```
 *
 * ```js
 * // A 2-D tensor with axis=1
 * //
 * // 'a' is: [[1, 0, 0],
 * //          [1, 0, 0],
 * //          [2, 0, 0]]
 * const a = tf.tensor2d([[1, 0, 0], [1, 0, 0], [2, 0, 0]]);
 * const {values, indices} = tf.unique(a, 1)
 * values.print();   // [[1, 0],
 *                   //  [1, 0],
 *                   //  [2, 0]]
 * indices.print();  // [0, 1, 1]
 * ```
 * @param x A tensor (int32, string, bool).
 * @param axis The axis of the tensor to find the unique elements.
 * @returns [uniqueElements, indices] (see above for details)
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $7c1158843694185a$var$unique_(x, axis = 0) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'unique', 'string_or_numeric');
    (0, $8cCb2.assert)($x.rank > 0, ()=>'The input tensor must be at least 1D');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    const [values, indices] = (0, $38WwN.ENGINE).runKernel((0, $hl418.Unique), inputs, attrs);
    return {
        values: values,
        indices: indices
    };
}
const $7c1158843694185a$export$7a5d5c156e7dc406 = /* @__PURE__ */ (0, $jqSCG.op)({
    unique_: $7c1158843694185a$var$unique_
});

});

parcelRegister("djGEF", function(module, exports) {

$parcel$export(module.exports, "unsortedSegmentSum", () => $9b1e231b583c89e6$export$ba7c4d144d85a309);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the sum along segments of a `tf.Tensor`.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const segmentIds = tf.tensor1d([1, 2, 0, 1], 'int32');
 * const numSegments = 3;
 *
 * x.unsortedSegmentSum(segmentIds, numSegments).print()
 * //or tf.unsortedSegmentSum(x, segmentIds, numSegments)
 * ```
 * @param x The `tf.Tensor` that will be summed along its segments.
 * @param segmentIds A `tf.Tensor1D` whose rank is equal to the rank of `x`'s
 * dimension along the `axis`.  Maps each element of `x` to a segment.
 * @param numSegments The number of distinct `segmentIds`.
 *
 * @doc {heading: 'Operations', subheading: 'Segment'}
 */ function $9b1e231b583c89e6$var$unsortedSegmentSum_(x, segmentIds, numSegments) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'unsortedSegmentSum');
    const $segmentIds = (0, $5xBLk.convertToTensor)(segmentIds, 'segmentIds', 'unsortedSegmentSum', 'int32');
    (0, $8cCb2.assert)((0, $8cCb2.isInt)(numSegments), ()=>'numSegments must be of dtype int');
    const inputs = {
        x: $x,
        segmentIds: $segmentIds
    };
    const attrs = {
        numSegments: numSegments
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.UnsortedSegmentSum), inputs, attrs);
}
const $9b1e231b583c89e6$export$ba7c4d144d85a309 = /* @__PURE__ */ (0, $jqSCG.op)({
    unsortedSegmentSum_: $9b1e231b583c89e6$var$unsortedSegmentSum_
});

});

parcelRegister("gBOC6", function(module, exports) {

$parcel$export(module.exports, "unstack", () => $c1775cdc84f05f72$export$3c05285afa115eec);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Unstacks a `tf.Tensor` of rank-`R` into a list of rank-`(R-1)` `tf.Tensor`s.
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * tf.unstack(a).forEach(tensor => tensor.print());
 * ```
 *
 * @param x A tensor object.
 * @param axis The axis to unstack along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $c1775cdc84f05f72$var$unstack_(x, axis = 0) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'unstack', 'string_or_numeric');
    $8cCb2.assert(axis >= -$x.shape.length && axis < $x.shape.length, ()=>`Axis = ${axis} is not in [-${$x.shape.length}, ${$x.shape.length})`);
    const inputs = {
        value: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Unpack), inputs, attrs);
}
const $c1775cdc84f05f72$export$3c05285afa115eec = /* @__PURE__ */ (0, $jqSCG.op)({
    unstack_: $c1775cdc84f05f72$var$unstack_
});

});

parcelRegister("igCyu", function(module, exports) {

$parcel$export(module.exports, "upperBound", () => $d4c7a0e45e12e674$export$1e7f253df265a2ba);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6PrVj = parcelRequire("6PrVj");
function $d4c7a0e45e12e674$export$1e7f253df265a2ba(sortedSequence, values) {
    return (0, $6PrVj.searchSorted)(sortedSequence, values, 'right');
}

});

parcelRegister("eoViB", function(module, exports) {

$parcel$export(module.exports, "variable", () => $a7bfc0fb62924a2a$export$3a9d57cefcd2c285);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");
function $a7bfc0fb62924a2a$export$3a9d57cefcd2c285(initialValue, trainable = true, name, dtype) {
    return (0, $38WwN.ENGINE).makeVariable(initialValue, trainable, name, dtype);
}

});

parcelRegister("5t2or", function(module, exports) {

$parcel$export(module.exports, "whereAsync", () => $3fb1846d1fd1e918$export$b95962138b7a377d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kNeGS = parcelRequire("kNeGS");

var $5xBLk = parcelRequire("5xBLk");
/**
 * Returns the coordinates of true elements of condition.
 *
 * The coordinates are returned in a 2-D tensor where the first dimension (rows)
 * represents the number of true elements, and the second dimension (columns)
 * represents the coordinates of the true elements. Keep in mind, the shape of
 * the output tensor can vary depending on how many true values there are in
 * input. Indices are output in row-major order. The resulting tensor has the
 * shape `[numTrueElems, condition.rank]`.
 *
 * This is analogous to calling the python `tf.where(cond)` without an x or y.
 *
 * ```js
 * const cond = tf.tensor1d([false, false, true], 'bool');
 * const result = await tf.whereAsync(cond);
 * result.print();
 * ```
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ async function $3fb1846d1fd1e918$var$whereAsync_(condition) {
    const $condition = (0, $5xBLk.convertToTensor)(condition, 'condition', 'whereAsync', 'bool');
    const vals = await $condition.data();
    const res = (0, $kNeGS.whereImpl)($condition.shape, vals);
    if (condition !== $condition) $condition.dispose();
    return res;
}
const $3fb1846d1fd1e918$export$b95962138b7a377d = $3fb1846d1fd1e918$var$whereAsync_;

});
parcelRegister("kNeGS", function(module, exports) {

$parcel$export(module.exports, "whereImpl", () => $f233c777c497de5b$export$3a1005f93c3f4453);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /** An implementation of the Where kernel shared between cpu and webgl */ 
var $iG87S = parcelRequire("iG87S");
function $f233c777c497de5b$export$3a1005f93c3f4453(condShape, condVals) {
    const indices = [];
    for(let i = 0; i < condVals.length; i++)if (condVals[i]) indices.push(i);
    const inBuffer = (0, $iG87S.buffer)(condShape, 'int32');
    const out = (0, $iG87S.buffer)([
        indices.length,
        condShape.length
    ], 'int32');
    for(let i = 0; i < indices.length; i++){
        const loc = inBuffer.indexToLoc(indices[i]);
        const offset = i * condShape.length;
        out.values.set(loc, offset);
    }
    return out.toTensor();
}

});


parcelRegister("4xhB2", function(module, exports) {

$parcel$export(module.exports, "booleanMaskAsync", () => $34d7e4c14c617766$export$358a56c181f796b3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $3qUjU = parcelRequire("3qUjU");

var $4sqA7 = parcelRequire("4sqA7");

var $kX8Hd = parcelRequire("kX8Hd");

var $5t2or = parcelRequire("5t2or");
/**
 * Apply boolean mask to tensor.
 *
 * ```js
 * const tensor = tf.tensor2d([1, 2, 3, 4, 5, 6], [3, 2]);
 * const mask = tf.tensor1d([1, 0, 1], 'bool');
 * const result = await tf.booleanMaskAsync(tensor, mask);
 * result.print();
 * ```
 *
 * @param tensor N-D tensor.
 * @param mask K-D boolean tensor, K <= N and K must be known statically.
 * @param axis A 0-D int Tensor representing the axis in tensor to mask from.
 *     By default, axis is 0 which will mask from the first dimension.
 *     Otherwise K + axis <= N.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ async function $34d7e4c14c617766$var$booleanMaskAsync_(tensor, mask, axis) {
    const $tensor = (0, $5xBLk.convertToTensor)(tensor, 'tensor', 'boolMask');
    const $mask = (0, $5xBLk.convertToTensor)(mask, 'mask', 'boolMask', 'bool');
    const axisFrom = axis == null ? 0 : axis;
    const maskDim = $mask.rank;
    const tensorShape = $tensor.shape;
    $8cCb2.assert(maskDim > 0, ()=>'mask cannot be scalar');
    $8cCb2.assertShapesMatch(tensorShape.slice(axisFrom, axisFrom + maskDim), $mask.shape, `mask's shape must match the first K dimensions of tensor's shape,`);
    let leadingSize = 1;
    for(let i = axisFrom; i < axisFrom + maskDim; i++)leadingSize *= tensorShape[i];
    const targetTensorShape = tensorShape.slice(0, axisFrom).concat([
        leadingSize
    ], tensorShape.slice(axisFrom + maskDim));
    const reshapedTensor = (0, $4sqA7.reshape)($tensor, targetTensorShape);
    const reshapedMask = (0, $4sqA7.reshape)($mask, [
        -1
    ]);
    const positivePositions = await (0, $5t2or.whereAsync)(reshapedMask);
    const indices = (0, $kX8Hd.squeeze)(positivePositions, [
        1
    ]);
    const res = (0, $3qUjU.gather)(reshapedTensor, indices, axisFrom);
    // Ensure no memory leak.
    if (tensor !== $tensor) $tensor.dispose();
    if (mask !== $mask) $mask.dispose();
    indices.dispose();
    reshapedTensor.dispose();
    reshapedMask.dispose();
    positivePositions.dispose();
    return res;
}
const $34d7e4c14c617766$export$358a56c181f796b3 = $34d7e4c14c617766$var$booleanMaskAsync_;

});

parcelRegister("aDHKy", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $7bef7bb1507e4cb8$export$9cb09a71b7d66923);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $c2DT1 = parcelRequire("c2DT1");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $20oDZ = parcelRequire("20oDZ");

var $1d8KH = parcelRequire("1d8KH");

var $15cGp = parcelRequire("15cGp");

var $jqSCG = parcelRequire("jqSCG");

var $b7x1G = parcelRequire("b7x1G");
/**
 * Transposes the `tf.Tensor`. Permutes the dimensions according to `perm`.
 *
 * The returned `tf.Tensor`'s dimension `i` will correspond to the input
 * dimension `perm[i]`. If `perm` is not given, it is set to `[n-1...0]`,
 * where `n` is the rank of the input `tf.Tensor`. Hence by default, this
 * operation performs a regular matrix transpose on 2-D input `tf.Tensor`s.
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4, 5, 6], [2, 3]);
 *
 * a.transpose().print();  // or tf.transpose(a)
 * ```
 *
 * @param x The tensor to transpose.
 * @param perm The permutation of the dimensions of a.
 * @param conjugate Will conjugate complex input if true.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $7bef7bb1507e4cb8$var$transpose_(x, perm, conjugate) {
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'transpose');
    if (perm == null) perm = $x.shape.map((s, i)=>i).reverse();
    $8cCb2.assert($x.rank === perm.length, ()=>`Error in transpose: rank of input ${$x.rank} ` + `must match length of perm ${perm}.`);
    perm.forEach((axis)=>{
        $8cCb2.assert(axis >= 0 && axis < $x.rank, ()=>`All entries in 'perm' must be between 0 and ${$x.rank - 1}` + ` but got ${perm}`);
    });
    if ($x.rank <= 1) return $x.clone();
    const inputs = {
        x: $x
    };
    const attrs = {
        perm: perm
    };
    if ($x.dtype === 'complex64') return (0, $c2DT1.tidy)(()=>{
        let $real = (0, $b7x1G.real)($x);
        let $imag = (0, $1d8KH.imag)($x);
        $real = (0, $38WwN.ENGINE).runKernel((0, $hl418.Transpose), {
            x: $real
        }, attrs);
        $imag = (0, $38WwN.ENGINE).runKernel((0, $hl418.Transpose), {
            x: $imag
        }, attrs);
        if (conjugate) $imag = (0, $15cGp.neg)($imag);
        return (0, $20oDZ.complex)($real, $imag);
    });
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Transpose), inputs, attrs);
}
const $7bef7bb1507e4cb8$export$9cb09a71b7d66923 = /* @__PURE__ */ (0, $jqSCG.op)({
    transpose_: $7bef7bb1507e4cb8$var$transpose_
});

});

parcelRegister("gIiMY", function(module, exports) {

$parcel$export(module.exports, "movingAverage", () => $c2af547bb790802f$export$e0ccbd22a5b3aab6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3w4Rg = parcelRequire("3w4Rg");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $hgacW = parcelRequire("hgacW");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $jqSCG = parcelRequire("jqSCG");

var $ad1of = parcelRequire("ad1of");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");
/**
 * Compute the moving average of a variable.
 *
 * Without zeroDebias, the moving average operation is defined by:
 *   `v += delta`
 * where
 *   `delta = (1 - decay) * (x - v)`
 *
 * With zeroDebias (default), the `delta` term is scaled to debias the
 * effect of the (assumed) zero-initialization of `v`.
 *   `delta /= (1 - decay ^ step)`
 *
 * For more details on the zero-debiasing algorithm, see:
 *   https://arxiv.org/abs/1412.6980
 *
 * Note that this function is completely stateless and does not keep track of
 * step count. The step count needs to be maintained by the caller and passed
 * in as `step`.
 *
 * @param v The current moving average value.
 * @param x New input value, must have the same shape and dtype as `v`.
 * @param decay The decay factor. Typical values are 0.95 and 0.99.
 * @param step Step count.
 * @param zeroDebias: Whether zeroDebias is to be performed (default: `true`).
 * @returns The new moving average value.
 *
 * @doc {heading: 'Operations', subheading: 'Moving Average'}
 */ function $c2af547bb790802f$var$movingAverage_(v, x, decay, step, zeroDebias = true) {
    const $v = (0, $5xBLk.convertToTensor)(v, 'v', 'movingAverage');
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'movingAverage');
    const $decay = (0, $5xBLk.convertToTensor)(decay, 'decay', 'movingAverage');
    (0, $3w4Rg.assertTypesMatch)($v, $x);
    $8cCb2.assert($8cCb2.arraysEqual($v.shape, $x.shape), ()=>'Shape mismatch in v and x');
    const one = (0, $3xp7o.scalar)(1);
    const oneMinusDecay = (0, $7kouu.sub)(one, $decay);
    let update = (0, $jZc0w.mul)((0, $7kouu.sub)($x, $v), oneMinusDecay);
    if (zeroDebias) {
        $8cCb2.assert(step != null, ()=>'When using zeroDebias: true, step is required.');
        const $step = (0, $5xBLk.convertToTensor)(step, 'step', 'movingAverage');
        update = (0, $1QPqB.div)(update, (0, $7kouu.sub)(one, (0, $ad1of.pow)($decay, $step)));
    }
    return (0, $hgacW.add)($v, update);
}
const $c2af547bb790802f$export$e0ccbd22a5b3aab6 = /* @__PURE__ */ (0, $jqSCG.op)({
    movingAverage_: $c2af547bb790802f$var$movingAverage_
});

});

parcelRegister("4wiJQ", function(module, exports) {

$parcel$export(module.exports, "scatterND", () => $34a8afa76c8632d3$export$5349ba4fee4e4c76);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $7wQGW = parcelRequire("7wQGW");
/**
 * Creates a new tensor by applying sparse updates to individual
 * values or slices within a zero tensor of the given shape tensor according to
 * indices. This operator is the inverse of the `tf.gatherND` operator which
 * extracts values or slices from a given tensor.
 *
 * ```js
 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
 * const updates = tf.tensor1d([9, 10, 11, 12]);
 * const shape = [8];
 * tf.scatterND(indices, updates, shape).print() //[0, 11, 0, 10, 9, 0, 0, 12]
 * ```
 *
 * @param indices The tensor contains the indices into the output tensor.
 * @param updates The tensor contains the value for the indices.
 * @param shape: The shape of the output tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $34a8afa76c8632d3$var$scatterND_(indices, updates, shape) {
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(shape);
    const $indices = (0, $5xBLk.convertToTensor)(indices, 'indices', 'scatterND', 'int32');
    const $updates = (0, $5xBLk.convertToTensor)(updates, 'updates', 'scatterND');
    $7wQGW.validateInput($updates, $indices, shape);
    const inputs = {
        indices: $indices,
        updates: $updates
    };
    const attrs = {
        shape: shape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.ScatterNd), inputs, attrs);
}
const $34a8afa76c8632d3$export$5349ba4fee4e4c76 = /* @__PURE__ */ (0, $jqSCG.op)({
    scatterND_: $34a8afa76c8632d3$var$scatterND_
});

});

parcelRegister("kMXcY", function(module, exports) {

$parcel$export(module.exports, "sparseToDense", () => $f22637d8b9b4b458$export$1be4b823dd1a3080);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $ch6b2 = parcelRequire("ch6b2");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Converts a sparse representation into a dense tensor.
 *
 * Builds an array dense with shape outputShape such that:
 *
 * // If sparseIndices is scalar
 * dense[i] = (i == sparseIndices ? sparseValues : defaultValue)
 *
 * // If sparseIndices is a vector, then for each i
 * dense[sparseIndices[i]] = sparseValues[i]
 *
 * // If sparseIndices is an n by d matrix, then for each i in [0, n)
 * dense[sparseIndices[i][0], ..., sparseIndices[i][d-1]] = sparseValues[i]
 * All other values in dense are set to defaultValue. If sparseValues is a
 * scalar, all sparse indices are set to this single value.
 *
 * If indices are repeated the final value is summed over all values for those
 * indices.
 *
 * ```js
 * const indices = tf.tensor1d([4, 5, 6, 1, 2, 3], 'int32');
 * const values = tf.tensor1d([10, 11, 12, 13, 14, 15], 'float32');
 * const shape = [8];
 * tf.sparseToDense(indices, values, shape).print();
 * ```
 *
 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
 * sparseIndices[i] contains the complete index where sparseValues[i] will be
 * placed.
 * @param sparseValues A 0-D or 1-D Tensor. Values
 * corresponding to each row of sparseIndices, or a scalar value to be used for
 * all sparse indices.
 * @param outputShape Shape of the dense output tensor. The type is inferred.
 * @param defaultValue Scalar. Value to set for indices not specified in
 * sparseIndices. Defaults to zero.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $f22637d8b9b4b458$var$sparseToDense_(sparseIndices, sparseValues, outputShape, defaultValue = 0) {
    (0, $8cCb2.assertNonNegativeIntegerDimensions)(outputShape);
    const $sparseIndices = (0, $5xBLk.convertToTensor)(sparseIndices, 'sparseIndices', 'sparseToDense', 'int32');
    const $sparseValues = (0, $5xBLk.convertToTensor)(sparseValues, 'sparseValues', 'sparseToDense', 'string_or_numeric');
    const $defaultValue = (0, $5xBLk.convertToTensor)(defaultValue, 'defaultValue', 'sparseToDense', $sparseValues.dtype);
    $ch6b2.validateInput($sparseIndices, $sparseValues, outputShape, $defaultValue);
    const inputs = {
        sparseIndices: $sparseIndices,
        sparseValues: $sparseValues,
        defaultValue: $defaultValue
    };
    const attrs = {
        outputShape: outputShape
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.SparseToDense), inputs, attrs);
}
const $f22637d8b9b4b458$export$1be4b823dd1a3080 = /* @__PURE__ */ (0, $jqSCG.op)({
    sparseToDense_: $f22637d8b9b4b458$var$sparseToDense_
});

});
parcelRegister("ch6b2", function(module, exports) {

$parcel$export(module.exports, "validateInput", () => $8efbdd38ab89bffe$export$4d09d4ac8ba225dd);
/**
 * Validate sparseToDense inputs.
 *
 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
 * sparseIndices[i] contains the complete index where sparseValues[i] will be
 * placed.
 * @param sparseValues A 0-D or 1-D Tensor. Values
 * corresponding to each row of sparseIndices, or a scalar value to be used for
 * all sparse indices.
 * @param outputShape number[]. Shape of the dense output tensor.
 * @param validateIndices boolean. indice validation is not supported, error
 * will be thrown if it is set.
 */ function $8efbdd38ab89bffe$export$4d09d4ac8ba225dd(sparseIndices, sparseValues, outputShape, defaultValues) {
    if (sparseIndices.dtype !== 'int32') throw new Error('tf.sparseToDense() expects the indices to be int32 type,' + ` but the dtype was ${sparseIndices.dtype}.`);
    if (sparseIndices.rank > 2) throw new Error('sparseIndices should be a scalar, vector, or matrix,' + ` but got shape ${sparseIndices.shape}.`);
    const numElems = sparseIndices.rank > 0 ? sparseIndices.shape[0] : 1;
    const numDims = sparseIndices.rank > 1 ? sparseIndices.shape[1] : 1;
    if (outputShape.length !== numDims) throw new Error('outputShape has incorrect number of elements:,' + ` ${outputShape.length}, should be: ${numDims}.`);
    const numValues = sparseValues.size;
    if (!(sparseValues.rank === 0 || sparseValues.rank === 1 && numValues === numElems)) throw new Error('sparseValues has incorrect shape ' + `${sparseValues.shape}, should be [] or [${numElems}]`);
    if (sparseValues.dtype !== defaultValues.dtype) throw new Error('sparseValues.dtype must match defaultValues.dtype');
}

});


parcelRegister("5FwF9", function(module, exports) {

$parcel$export(module.exports, "gatherND", () => $420a1e3ced22d90d$export$15ec1b40f43d319f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Gather slices from input tensor into a Tensor with shape specified by
 * `indices`.
 *
 * `indices` is a K-dimensional integer tensor, best thought of as a
 * (K-1)-dimensional tensor of indices into input, where each element defines a
 * slice of input:
 * output[\\(i_0, ..., i_{K-2}\\)] = input[indices[\\(i_0, ..., i_{K-2}\\)]]
 *
 * Whereas in `tf.gather`, `indices` defines slices into the first dimension of
 * input, in `tf.gatherND`, `indices` defines slices into the first N dimensions
 * of input, where N = indices.shape[-1].
 *
 * The last dimension of indices can be at most the rank of input:
 * indices.shape[-1] <= input.rank
 *
 * The last dimension of `indices` corresponds to elements
 * (if indices.shape[-1] == input.rank) or slices
 * (if indices.shape[-1] < input.rank) along dimension indices.shape[-1] of
 * input.
 * The output tensor has shape
 * indices.shape[:-1] + input.shape[indices.shape[-1]:]
 *
 * Note that on CPU, if an out of bound index is found, an error is returned. On
 * GPU, if an out of bound index is found, a 0 is stored in the corresponding
 * output value.
 *
 * ```js
 * const indices = tf.tensor2d([0, 1, 1, 0], [2,2], 'int32');
 * const input = tf.tensor2d([9, 10, 11, 12], [2, 2]);
 * tf.gatherND(input, indices).print() // [10, 11]
 * ```
 *
 * @param x The tensor from which to gather values.
 * @param indices Index tensor, must be of type int32.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $420a1e3ced22d90d$var$gatherND_(x, indices) {
    const $indices = (0, $5xBLk.convertToTensor)(indices, 'indices', 'gatherND', 'int32');
    const $x = (0, $5xBLk.convertToTensor)(x, 'x', 'gatherND', 'string_or_numeric');
    const inputs = {
        params: $x,
        indices: $indices
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.GatherNd), inputs);
}
const $420a1e3ced22d90d$export$15ec1b40f43d319f = /* @__PURE__ */ (0, $jqSCG.op)({
    gatherND_: $420a1e3ced22d90d$var$gatherND_
});

});

parcelRegister("j5jow", function(module, exports) {

$parcel$export(module.exports, "enclosingPowerOfTwo", () => $de4d87485d0c1285$export$6fc2fe3b19043bf3);
$parcel$export(module.exports, "cosineWindow", () => $de4d87485d0c1285$export$e875398ce092ee45);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $lalFM = parcelRequire("lalFM");
function $de4d87485d0c1285$export$6fc2fe3b19043bf3(value) {
    // Return 2**N for integer N such that 2**N >= value.
    return Math.floor(Math.pow(2, Math.ceil(Math.log(value) / Math.log(2.0))));
}
function $de4d87485d0c1285$export$e875398ce092ee45(windowLength, a, b) {
    const even = 1 - windowLength % 2;
    const newValues = new Float32Array(windowLength);
    for(let i = 0; i < windowLength; ++i){
        const cosArg = 2.0 * Math.PI * i / (windowLength + even - 1);
        newValues[i] = a - b * Math.cos(cosArg);
    }
    return (0, $lalFM.tensor1d)(newValues, 'float32');
}

});

parcelRegister("8mg8Q", function(module, exports) {

$parcel$export(module.exports, "inTopKAsync", () => $019203b68c50a423$export$395be9a27e7de9f0);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $erbmM = parcelRequire("erbmM");
/**
 * Returns whether the targets are in the top K predictions.
 *
 * ```js
 * const predictions = tf.tensor2d([[20, 10, 40, 30], [30, 50, -20, 10]]);
 * const targets = tf.tensor1d([2, 0]);
 * const precision = await tf.inTopKAsync(predictions, targets);
 * precision.print();
 * ```
 * @param predictions 2-D or higher `tf.Tensor` with last dimension being
 *     at least `k`.
 * @param targets 1-D or higher `tf.Tensor`.
 * @param k Optional Number of top elements to look at for computing precision,
 *     default to 1.
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ async function $019203b68c50a423$var$inTopKAsync_(predictions, targets, k = 1) {
    const $predictions = (0, $5xBLk.convertToTensor)(predictions, 'predictions', 'inTopK');
    const $targets = (0, $5xBLk.convertToTensor)(targets, 'targets', 'inTopK');
    (0, $8cCb2.assert)($predictions.rank > 1, ()=>'inTopK() expects the predictions to be of rank 2 or higher, ' + `but got ${$predictions.rank}`);
    (0, $8cCb2.assert)($predictions.rank - 1 === $targets.rank, ()=>`predictions rank should be 1 larger than ` + `targets rank, but got predictions rank ` + `${$predictions.rank} and targets rank ${$targets.rank}`);
    (0, $8cCb2.assertShapesMatch)($predictions.shape.slice(0, $predictions.shape.length - 1), $targets.shape, `predictions's shape should be align with the targets' shape, ` + 'except the last dimension.');
    const lastDim = $predictions.shape[$predictions.shape.length - 1];
    (0, $8cCb2.assert)(k > 0 && k <= lastDim, ()=>`'k' passed to inTopK() must be > 0 && <= the predictions last ` + `dimension (${lastDim}), but got ${k}`);
    const predictionsVals = await $predictions.data();
    const targetsVals = await $targets.data();
    // Reshape predictionsVals into a 2d tensor [batch, lastDim]
    // and look up topK along lastDim.
    const [batch, size] = [
        predictionsVals.length / lastDim,
        lastDim
    ];
    const precision = (0, $8cCb2.getTypedArrayFromDType)('bool', batch);
    for(let b = 0; b < batch; b++){
        const offset = b * size;
        const vals = predictionsVals.subarray(offset, offset + size);
        const valAndInd = [];
        for(let i = 0; i < vals.length; i++)valAndInd.push({
            value: vals[i],
            index: i
        });
        valAndInd.sort((a, b)=>b.value - a.value);
        precision[b] = 0;
        for(let i = 0; i < k; i++)if (valAndInd[i].index === targetsVals[b]) {
            precision[b] = 1;
            break;
        }
    }
    if (predictions !== $predictions) $predictions.dispose();
    if (targets !== $targets) $targets.dispose();
    // Output precision has the same shape as targets.
    return (0, $erbmM.tensor)(precision, $targets.shape, 'bool');
}
const $019203b68c50a423$export$395be9a27e7de9f0 = $019203b68c50a423$var$inTopKAsync_;

});

parcelRegister("dGKlF", function(module, exports) {

$parcel$export(module.exports, "hammingWindow", () => $02925f9669efedc1$export$941eafcc99b559fa);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jqSCG = parcelRequire("jqSCG");

var $j5jow = parcelRequire("j5jow");
/**
 * Generate a hamming window.
 *
 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
 *
 * ```js
 * tf.signal.hammingWindow(10).print();
 * ```
 * @param The length of window
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $02925f9669efedc1$var$hammingWindow_(windowLength) {
    return (0, $j5jow.cosineWindow)(windowLength, 0.54, 0.46);
}
const $02925f9669efedc1$export$941eafcc99b559fa = /* @__PURE__ */ (0, $jqSCG.op)({
    hammingWindow_: $02925f9669efedc1$var$hammingWindow_
});

});

parcelRegister("gicu0", function(module, exports) {

$parcel$export(module.exports, "hannWindow", () => $bdc802a5a22bb768$export$f498cfeee84e5e59);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jqSCG = parcelRequire("jqSCG");

var $j5jow = parcelRequire("j5jow");
/**
 * Generate a Hann window.
 *
 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
 *
 * ```js
 * tf.signal.hannWindow(10).print();
 * ```
 * @param The length of window
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $bdc802a5a22bb768$var$hannWindow_(windowLength) {
    return (0, $j5jow.cosineWindow)(windowLength, 0.5, 0.5);
}
const $bdc802a5a22bb768$export$f498cfeee84e5e59 = /* @__PURE__ */ (0, $jqSCG.op)({
    hannWindow_: $bdc802a5a22bb768$var$hannWindow_
});

});

parcelRegister("lLT0m", function(module, exports) {

$parcel$export(module.exports, "frame", () => $fd98a793f0920716$export$2cef06c20297c17d);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $iTu6j = parcelRequire("iTu6j");

var $gYive = parcelRequire("gYive");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");

var $79KOG = parcelRequire("79KOG");

var $gmMlv = parcelRequire("gmMlv");
/**
 * Expands input into frames of frameLength.
 * Slides a window size with frameStep.
 *
 * ```js
 * tf.signal.frame([1, 2, 3], 2, 1).print();
 * ```
 * @param signal The input tensor to be expanded
 * @param frameLength Length of each frame
 * @param frameStep The frame hop size in samples.
 * @param padEnd Whether to pad the end of signal with padValue.
 * @param padValue A number to use where the input signal does
 *     not exist when padEnd is True.
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $fd98a793f0920716$var$frame_(signal, frameLength, frameStep, padEnd = false, padValue = 0) {
    let start = 0;
    const output = [];
    while(start + frameLength <= signal.size){
        output.push((0, $79KOG.slice)(signal, start, frameLength));
        start += frameStep;
    }
    if (padEnd) while(start < signal.size){
        const padLen = start + frameLength - signal.size;
        const pad = (0, $iTu6j.concat)([
            (0, $79KOG.slice)(signal, start, frameLength - padLen),
            (0, $gYive.fill)([
                padLen
            ], padValue)
        ]);
        output.push(pad);
        start += frameStep;
    }
    if (output.length === 0) return (0, $gmMlv.tensor2d)([], [
        0,
        frameLength
    ]);
    return (0, $4sqA7.reshape)((0, $iTu6j.concat)(output), [
        output.length,
        frameLength
    ]);
}
const $fd98a793f0920716$export$2cef06c20297c17d = /* @__PURE__ */ (0, $jqSCG.op)({
    frame_: $fd98a793f0920716$var$frame_
});

});

parcelRegister("hGoJt", function(module, exports) {

$parcel$export(module.exports, "stft", () => $cdf98b3fb379599a$export$eb1cf9b274257b4a);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jZc0w = parcelRequire("jZc0w");

var $jqSCG = parcelRequire("jqSCG");

var $j5jow = parcelRequire("j5jow");

var $cafDa = parcelRequire("cafDa");

var $lLT0m = parcelRequire("lLT0m");

var $gicu0 = parcelRequire("gicu0");
/**
 * Computes the Short-time Fourier Transform of signals
 * See: https://en.wikipedia.org/wiki/Short-time_Fourier_transform
 *
 * ```js
 * const input = tf.tensor1d([1, 1, 1, 1, 1])
 * tf.signal.stft(input, 3, 1).print();
 * ```
 * @param signal 1-dimensional real value tensor.
 * @param frameLength The window length of samples.
 * @param frameStep The number of samples to step.
 * @param fftLength The size of the FFT to apply.
 * @param windowFn A callable that takes a window length and returns 1-d tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $cdf98b3fb379599a$var$stft_(signal, frameLength, frameStep, fftLength, windowFn = (0, $gicu0.hannWindow)) {
    if (fftLength == null) fftLength = (0, $j5jow.enclosingPowerOfTwo)(frameLength);
    const framedSignal = (0, $lLT0m.frame)(signal, frameLength, frameStep);
    const windowedSignal = (0, $jZc0w.mul)(framedSignal, windowFn(frameLength));
    return (0, $cafDa.rfft)(windowedSignal, fftLength);
}
const $cdf98b3fb379599a$export$eb1cf9b274257b4a = /* @__PURE__ */ (0, $jqSCG.op)({
    stft_: $cdf98b3fb379599a$var$stft_
});

});

parcelRegister("jLoMm", function(module, exports) {

$parcel$export(module.exports, "cropAndResize", () => $e635a0b2cf6a009d$export$6f0f0090e1f6cd3c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Extracts crops from the input image tensor and resizes them using bilinear
 * sampling or nearest neighbor sampling (possibly with aspect ratio change)
 * to a common output size specified by cropSize.
 *
 * @param image 4d tensor of shape `[batch,imageHeight,imageWidth, depth]`,
 *     where imageHeight and imageWidth must be positive, specifying the
 *     batch of images from which to take crops
 * @param boxes 2d float32 tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the normalized
 *     coordinates of the box in the `boxInd[i]`th image in the batch
 * @param boxInd 1d int32 tensor of shape `[numBoxes]` with values in range
 *     `[0, batch)` that specifies the image that the `i`-th box refers to.
 * @param cropSize 1d int32 tensor of 2 elements `[cropHeigh, cropWidth]`
 *     specifying the size to which all crops are resized to.
 * @param method Optional string from `'bilinear' | 'nearest'`,
 *     defaults to bilinear, which specifies the sampling method for resizing
 * @param extrapolationValue A threshold for deciding when to remove boxes based
 *     on score. Defaults to 0.
 * @return A 4D tensor of the shape `[numBoxes,cropHeight,cropWidth,depth]`
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $e635a0b2cf6a009d$var$cropAndResize_(image, boxes, boxInd, cropSize, method = 'bilinear', extrapolationValue = 0) {
    const $image = (0, $5xBLk.convertToTensor)(image, 'image', 'cropAndResize');
    const $boxes = (0, $5xBLk.convertToTensor)(boxes, 'boxes', 'cropAndResize', 'float32');
    const $boxInd = (0, $5xBLk.convertToTensor)(boxInd, 'boxInd', 'cropAndResize', 'int32');
    const numBoxes = $boxes.shape[0];
    $8cCb2.assert($image.rank === 4, ()=>'Error in cropAndResize: image must be rank 4,' + `but got rank ${$image.rank}.`);
    $8cCb2.assert($boxes.rank === 2 && $boxes.shape[1] === 4, ()=>`Error in cropAndResize: boxes must be have size [${numBoxes},4] ` + `but had shape ${$boxes.shape}.`);
    $8cCb2.assert($boxInd.rank === 1 && $boxInd.shape[0] === numBoxes, ()=>`Error in cropAndResize: boxInd must be have size [${numBoxes}] ` + `but had shape ${$boxes.shape}.`);
    $8cCb2.assert(cropSize.length === 2, ()=>`Error in cropAndResize: cropSize must be of length 2, but got ` + `length ${cropSize.length}.`);
    $8cCb2.assert(cropSize[0] >= 1 && cropSize[1] >= 1, ()=>`cropSize must be atleast [1,1], but was ${cropSize}`);
    $8cCb2.assert(method === 'bilinear' || method === 'nearest', ()=>`method must be bilinear or nearest, but was ${method}`);
    const inputs = {
        image: $image,
        boxes: $boxes,
        boxInd: $boxInd
    };
    const attrs = {
        method: method,
        extrapolationValue: extrapolationValue,
        cropSize: cropSize
    };
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.CropAndResize), inputs, attrs);
    return res;
}
const $e635a0b2cf6a009d$export$6f0f0090e1f6cd3c = /* @__PURE__ */ (0, $jqSCG.op)({
    cropAndResize_: $e635a0b2cf6a009d$var$cropAndResize_
});

});

parcelRegister("jAPwM", function(module, exports) {

$parcel$export(module.exports, "flipLeftRight", () => $e439596fc3f8d37a$export$8358b9c43b687b22);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Flips the image left to right. Currently available in the CPU, WebGL, and
 * WASM backends.
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 */ /** @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'} */ function $e439596fc3f8d37a$var$flipLeftRight_(image) {
    const $image = (0, $5xBLk.convertToTensor)(image, 'image', 'flipLeftRight', 'float32');
    $8cCb2.assert($image.rank === 4, ()=>'Error in flipLeftRight: image must be rank 4,' + `but got rank ${$image.rank}.`);
    const inputs = {
        image: $image
    };
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.FlipLeftRight), inputs, {});
    return res;
}
const $e439596fc3f8d37a$export$8358b9c43b687b22 = /* @__PURE__ */ (0, $jqSCG.op)({
    flipLeftRight_: $e439596fc3f8d37a$var$flipLeftRight_
});

});

parcelRegister("7xYxa", function(module, exports) {

$parcel$export(module.exports, "grayscaleToRGB", () => $57ea923baa314bcd$export$f68e334bfd7e4be6);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $61ay4 = parcelRequire("61ay4");
/**
 * Converts images from grayscale to RGB format.
 *
 * @param image A grayscale tensor to convert. The `image`'s last dimension must
 *     be size 1 with at least a two-dimensional shape.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $57ea923baa314bcd$var$grayscaleToRGB_(image) {
    const $image = (0, $5xBLk.convertToTensor)(image, 'image', 'grayscaleToRGB');
    const lastDimsIdx = $image.rank - 1;
    const lastDims = $image.shape[lastDimsIdx];
    $8cCb2.assert($image.rank >= 2, ()=>'Error in grayscaleToRGB: images must be at least rank 2, ' + `but got rank ${$image.rank}.`);
    $8cCb2.assert(lastDims === 1, ()=>'Error in grayscaleToRGB: last dimension of a grayscale image ' + `should be size 1, but got size ${lastDims}.`);
    const reps = new Array($image.rank);
    reps.fill(1, 0, lastDimsIdx);
    reps[lastDimsIdx] = 3;
    return (0, $61ay4.tile)($image, reps);
}
const $57ea923baa314bcd$export$f68e334bfd7e4be6 = /* @__PURE__ */ (0, $jqSCG.op)({
    grayscaleToRGB_: $57ea923baa314bcd$var$grayscaleToRGB_
});

});

parcelRegister("iStMK", function(module, exports) {

$parcel$export(module.exports, "rgbToGrayscale", () => $dbe45fdb7a5f64e9$export$490c4fde2e852c50);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $inFmq = parcelRequire("inFmq");

var $1mzpU = parcelRequire("1mzpU");

var $iPDWZ = parcelRequire("iPDWZ");

var $jqSCG = parcelRequire("jqSCG");

var $lalFM = parcelRequire("lalFM");
/**
 * Converts images from RGB format to grayscale.
 *
 * @param image A RGB tensor to convert. The `image`'s last dimension must
 *     be size 3 with at least a two-dimensional shape.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $dbe45fdb7a5f64e9$var$rgbToGrayscale_(image) {
    const $image = (0, $5xBLk.convertToTensor)(image, 'image', 'RGBToGrayscale');
    const lastDimsIdx = $image.rank - 1;
    const lastDims = $image.shape[lastDimsIdx];
    $8cCb2.assert($image.rank >= 2, ()=>'Error in RGBToGrayscale: images must be at least rank 2, ' + `but got rank ${$image.rank}.`);
    $8cCb2.assert(lastDims === 3, ()=>'Error in RGBToGrayscale: last dimension of an RGB image ' + `should be size 3, but got size ${lastDims}.`);
    // Remember original dtype so we can convert back if needed
    const origDtype = $image.dtype;
    const fltImage = (0, $inFmq.cast)($image, 'float32');
    const rgbWeights = (0, $lalFM.tensor1d)([
        0.2989,
        0.5870,
        0.1140
    ]);
    let grayFloat;
    switch($image.rank){
        case 2:
            grayFloat = (0, $1mzpU.einsum)('ij,j->i', fltImage, rgbWeights);
            break;
        case 3:
            grayFloat = (0, $1mzpU.einsum)('ijk,k->ij', fltImage, rgbWeights);
            break;
        case 4:
            grayFloat = (0, $1mzpU.einsum)('ijkl,l->ijk', fltImage, rgbWeights);
            break;
        case 5:
            grayFloat = (0, $1mzpU.einsum)('ijklm,m->ijkl', fltImage, rgbWeights);
            break;
        case 6:
            grayFloat = (0, $1mzpU.einsum)('ijklmn,n->ijklm', fltImage, rgbWeights);
            break;
        default:
            throw new Error('Not a valid tensor rank.');
    }
    grayFloat = (0, $iPDWZ.expandDims)(grayFloat, -1);
    return (0, $inFmq.cast)(grayFloat, origDtype);
}
const $dbe45fdb7a5f64e9$export$490c4fde2e852c50 = /* @__PURE__ */ (0, $jqSCG.op)({
    rgbToGrayscale_: $dbe45fdb7a5f64e9$var$rgbToGrayscale_
});

});

parcelRegister("gF4CQ", function(module, exports) {

$parcel$export(module.exports, "rotateWithOffset", () => $c2141030b1b397d1$export$66462c489f5f29d2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Rotates the input image tensor counter-clockwise with an optional offset
 * center of rotation. Currently available in the CPU, WebGL, and WASM backends.
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 * @param radians The amount of rotation.
 * @param fillValue The value to fill in the empty space leftover
 *     after rotation. Can be either a single grayscale value (0-255), or an
 *     array of three numbers `[red, green, blue]` specifying the red, green,
 *     and blue channels. Defaults to `0` (black).
 * @param center The center of rotation. Can be either a single value (0-1), or
 *     an array of two numbers `[centerX, centerY]`. Defaults to `0.5` (rotates
 *     the image around its center).
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $c2141030b1b397d1$var$rotateWithOffset_(image, radians, fillValue = 0, center = 0.5) {
    const $image = (0, $5xBLk.convertToTensor)(image, 'image', 'rotateWithOffset', 'float32');
    $8cCb2.assert($image.rank === 4, ()=>'Error in rotateWithOffset: image must be rank 4,' + `but got rank ${$image.rank}.`);
    const inputs = {
        image: $image
    };
    const attrs = {
        radians: radians,
        fillValue: fillValue,
        center: center
    };
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.RotateWithOffset), inputs, attrs);
    return res;
}
const $c2141030b1b397d1$export$66462c489f5f29d2 = /* @__PURE__ */ (0, $jqSCG.op)({
    rotateWithOffset_: $c2141030b1b397d1$var$rotateWithOffset_
});

});

parcelRegister("3Dhm5", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppression", () => $2a5279fb7ed7e00c$export$b7d265b19ca1d628);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $dpIoR = parcelRequire("dpIoR");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @return A 1D tensor with the selected box indices.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $2a5279fb7ed7e00c$var$nonMaxSuppression_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
    const $boxes = (0, $5xBLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppression', 'float32');
    const $scores = (0, $5xBLk.convertToTensor)(scores, 'scores', 'nonMaxSuppression', 'float32');
    const inputs = (0, $dpIoR.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
    maxOutputSize = inputs.maxOutputSize;
    iouThreshold = inputs.iouThreshold;
    scoreThreshold = inputs.scoreThreshold;
    const attrs = {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.NonMaxSuppressionV3), {
        boxes: $boxes,
        scores: $scores
    }, attrs);
}
const $2a5279fb7ed7e00c$export$b7d265b19ca1d628 = /* @__PURE__ */ (0, $jqSCG.op)({
    nonMaxSuppression_: $2a5279fb7ed7e00c$var$nonMaxSuppression_
});

});
parcelRegister("dpIoR", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppSanityCheck", () => $9c400d108974778f$export$ccf61bcb3b4e6ac6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
function $9c400d108974778f$export$ccf61bcb3b4e6ac6(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
    if (iouThreshold == null) iouThreshold = 0.5;
    if (scoreThreshold == null) scoreThreshold = Number.NEGATIVE_INFINITY;
    if (softNmsSigma == null) softNmsSigma = 0.0;
    const numBoxes = boxes.shape[0];
    maxOutputSize = Math.min(maxOutputSize, numBoxes);
    $8cCb2.assert(0 <= iouThreshold && iouThreshold <= 1, ()=>`iouThreshold must be in [0, 1], but was '${iouThreshold}'`);
    $8cCb2.assert(boxes.rank === 2, ()=>`boxes must be a 2D tensor, but was of rank '${boxes.rank}'`);
    $8cCb2.assert(boxes.shape[1] === 4, ()=>`boxes must have 4 columns, but 2nd dimension was ${boxes.shape[1]}`);
    $8cCb2.assert(scores.rank === 1, ()=>'scores must be a 1D tensor');
    $8cCb2.assert(scores.shape[0] === numBoxes, ()=>`scores has incompatible shape with boxes. Expected ${numBoxes}, ` + `but was ${scores.shape[0]}`);
    $8cCb2.assert(0 <= softNmsSigma && softNmsSigma <= 1, ()=>`softNmsSigma must be in [0, 1], but was '${softNmsSigma}'`);
    return {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
}

});


parcelRegister("ihqU7", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionAsync", () => $d4eeaf2379910934$export$cc6d94dffac2ee1a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $KPYos = parcelRequire("KPYos");

var $5xBLk = parcelRequire("5xBLk");

var $dpIoR = parcelRequire("dpIoR");

var $lalFM = parcelRequire("lalFM");
/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This is the async version of `nonMaxSuppression`
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @return A 1D tensor with the selected box indices.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $d4eeaf2379910934$var$nonMaxSuppressionAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
    const $boxes = (0, $5xBLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $5xBLk.convertToTensor)(scores, 'scores', 'nonMaxSuppressionAsync');
    const inputs = (0, $dpIoR.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
    maxOutputSize = inputs.maxOutputSize;
    iouThreshold = inputs.iouThreshold;
    scoreThreshold = inputs.scoreThreshold;
    const boxesAndScores = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    const boxesVals = boxesAndScores[0];
    const scoresVals = boxesAndScores[1];
    // We call a cpu based impl directly with the typedarray data  here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices } = (0, $KPYos.nonMaxSuppressionV3Impl)(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return (0, $lalFM.tensor1d)(selectedIndices, 'int32');
}
const $d4eeaf2379910934$export$cc6d94dffac2ee1a = $d4eeaf2379910934$var$nonMaxSuppressionAsync_;

});
parcelRegister("KPYos", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Impl", () => $08cc9cc3eb1dc63f$export$89e22275998c2878);
$parcel$export(module.exports, "nonMaxSuppressionV4Impl", () => $08cc9cc3eb1dc63f$export$697e7a8cdfefe3a);
$parcel$export(module.exports, "nonMaxSuppressionV5Impl", () => $08cc9cc3eb1dc63f$export$4ff849794bce73c5);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $k4JiJ = parcelRequire("k4JiJ");
function $08cc9cc3eb1dc63f$export$89e22275998c2878(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
    return $08cc9cc3eb1dc63f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0 /* softNmsSigma */ );
}
function $08cc9cc3eb1dc63f$export$697e7a8cdfefe3a(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize) {
    return $08cc9cc3eb1dc63f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0 /* softNmsSigma */ , false, padToMaxOutputSize /* padToMaxOutputSize */ , true);
}
function $08cc9cc3eb1dc63f$export$4ff849794bce73c5(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
    return $08cc9cc3eb1dc63f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, true);
}
function $08cc9cc3eb1dc63f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, returnScoresTensor = false, padToMaxOutputSize = false, returnValidOutputs = false) {
    // The list is sorted in ascending order, so that we can always pop the
    // candidate with the largest score in O(1) time.
    const candidates = [];
    for(let i = 0; i < scores.length; i++)if (scores[i] > scoreThreshold) candidates.push({
        score: scores[i],
        boxIndex: i,
        suppressBeginIndex: 0
    });
    candidates.sort($08cc9cc3eb1dc63f$var$ascendingComparator);
    // If softNmsSigma is 0, the outcome of this algorithm is exactly same as
    // before.
    const scale = softNmsSigma > 0 ? -0.5 / softNmsSigma : 0.0;
    const selectedIndices = [];
    const selectedScores = [];
    while(selectedIndices.length < maxOutputSize && candidates.length > 0){
        const candidate = candidates.pop();
        const { score: originalScore, boxIndex: boxIndex, suppressBeginIndex: suppressBeginIndex } = candidate;
        if (originalScore < scoreThreshold) break;
        // Overlapping boxes are likely to have similar scores, therefore we
        // iterate through the previously selected boxes backwards in order to
        // see if candidate's score should be suppressed. We use
        // suppressBeginIndex to track and ensure a candidate can be suppressed
        // by a selected box no more than once. Also, if the overlap exceeds
        // iouThreshold, we simply ignore the candidate.
        let ignoreCandidate = false;
        for(let j = selectedIndices.length - 1; j >= suppressBeginIndex; --j){
            const iou = $08cc9cc3eb1dc63f$var$intersectionOverUnion(boxes, boxIndex, selectedIndices[j]);
            if (iou >= iouThreshold) {
                ignoreCandidate = true;
                break;
            }
            candidate.score = candidate.score * $08cc9cc3eb1dc63f$var$suppressWeight(iouThreshold, scale, iou);
            if (candidate.score <= scoreThreshold) break;
        }
        // At this point, if `candidate.score` has not dropped below
        // `scoreThreshold`, then we know that we went through all of the
        // previous selections and can safely update `suppressBeginIndex` to the
        // end of the selected array. Then we can re-insert the candidate with
        // the updated score and suppressBeginIndex back in the candidate list.
        // If on the other hand, `candidate.score` has dropped below the score
        // threshold, we will not add it back to the candidates list.
        candidate.suppressBeginIndex = selectedIndices.length;
        if (!ignoreCandidate) {
            // Candidate has passed all the tests, and is not suppressed, so
            // select the candidate.
            if (candidate.score === originalScore) {
                selectedIndices.push(boxIndex);
                selectedScores.push(candidate.score);
            } else if (candidate.score > scoreThreshold) // Candidate's score is suppressed but is still high enough to be
            // considered, so add back to the candidates list.
            (0, $k4JiJ.binaryInsert)(candidates, candidate, $08cc9cc3eb1dc63f$var$ascendingComparator);
        }
    }
    // NonMaxSuppressionV4 feature: padding output to maxOutputSize.
    const validOutputs = selectedIndices.length;
    const elemsToPad = maxOutputSize - validOutputs;
    if (padToMaxOutputSize && elemsToPad > 0) {
        selectedIndices.push(...new Array(elemsToPad).fill(0));
        selectedScores.push(...new Array(elemsToPad).fill(0.0));
    }
    const result = {
        selectedIndices: selectedIndices
    };
    if (returnScoresTensor) result['selectedScores'] = selectedScores;
    if (returnValidOutputs) result['validOutputs'] = validOutputs;
    return result;
}
function $08cc9cc3eb1dc63f$var$intersectionOverUnion(boxes, i, j) {
    const iCoord = boxes.subarray(i * 4, i * 4 + 4);
    const jCoord = boxes.subarray(j * 4, j * 4 + 4);
    const yminI = Math.min(iCoord[0], iCoord[2]);
    const xminI = Math.min(iCoord[1], iCoord[3]);
    const ymaxI = Math.max(iCoord[0], iCoord[2]);
    const xmaxI = Math.max(iCoord[1], iCoord[3]);
    const yminJ = Math.min(jCoord[0], jCoord[2]);
    const xminJ = Math.min(jCoord[1], jCoord[3]);
    const ymaxJ = Math.max(jCoord[0], jCoord[2]);
    const xmaxJ = Math.max(jCoord[1], jCoord[3]);
    const areaI = (ymaxI - yminI) * (xmaxI - xminI);
    const areaJ = (ymaxJ - yminJ) * (xmaxJ - xminJ);
    if (areaI <= 0 || areaJ <= 0) return 0.0;
    const intersectionYmin = Math.max(yminI, yminJ);
    const intersectionXmin = Math.max(xminI, xminJ);
    const intersectionYmax = Math.min(ymaxI, ymaxJ);
    const intersectionXmax = Math.min(xmaxI, xmaxJ);
    const intersectionArea = Math.max(intersectionYmax - intersectionYmin, 0.0) * Math.max(intersectionXmax - intersectionXmin, 0.0);
    return intersectionArea / (areaI + areaJ - intersectionArea);
}
// A Gaussian penalty function, this method always returns values in [0, 1].
// The weight is a function of similarity, the more overlap two boxes are, the
// smaller the weight is,meaning highly overlapping boxes will be significantly
// penalized. On the other hand, a non-overlapping box will not be penalized.
function $08cc9cc3eb1dc63f$var$suppressWeight(iouThreshold, scale, iou) {
    const weight = Math.exp(scale * iou * iou);
    return iou <= iouThreshold ? weight : 0.0;
}
function $08cc9cc3eb1dc63f$var$ascendingComparator(c1, c2) {
    // For objects with same scores, we make the object with the larger index go
    // first. In an array that pops from the end, this means that the object with
    // the smaller index will be popped first. This ensures the same output as
    // the TensorFlow python version.
    return c1.score - c2.score || c1.score === c2.score && c2.boxIndex - c1.boxIndex;
}

});
parcelRegister("k4JiJ", function(module, exports) {

$parcel$export(module.exports, "binaryInsert", () => $e9d7523e791ea809$export$a64fad5e27f22af5);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Inserts a value into a sorted array. This method allows duplicate, meaning it
 * allows inserting duplicate value, in which case, the element will be inserted
 * at the lowest index of the value.
 * @param arr The array to modify.
 * @param element The element to insert.
 * @param comparator Optional. If no comparator is specified, elements are
 * compared using array_util.defaultComparator, which is suitable for Strings
 * and Numbers in ascending arrays. If the array contains multiple instances of
 * the target value, the left-most instance will be returned. To provide a
 * comparator, it should take 2 arguments to compare and return a negative,
 * zero, or a positive number.
 */ function $e9d7523e791ea809$export$a64fad5e27f22af5(arr, element, comparator) {
    const index = $e9d7523e791ea809$export$2e0ae67339d5f1ac(arr, element, comparator);
    const insertionPoint = index < 0 ? -(index + 1) : index;
    arr.splice(insertionPoint, 0, element);
}
function $e9d7523e791ea809$export$2e0ae67339d5f1ac(arr, target, comparator) {
    return $e9d7523e791ea809$var$binarySearch_(arr, target, comparator || $e9d7523e791ea809$var$defaultComparator);
}
/**
 * Compares its two arguments for order.
 * @param a The first element to be compared.
 * @param b The second element to be compared.
 * @return A negative number, zero, or a positive number as the first
 *     argument is less than, equal to, or greater than the second.
 */ function $e9d7523e791ea809$var$defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $e9d7523e791ea809$var$binarySearch_(arr, target, comparator) {
    let left = 0;
    let right = arr.length;
    let middle = 0;
    let found = false;
    while(left < right){
        middle = left + (right - left >>> 1);
        const compareResult = comparator(target, arr[middle]);
        if (compareResult > 0) left = middle + 1;
        else {
            right = middle;
            // If compareResult is 0, the value is found. We record it is found,
            // and then keep looking because there may be duplicate.
            found = !compareResult;
        }
    }
    return found ? left : -left - 1;
}

});



parcelRegister("gxykK", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionWithScore", () => $c0aa5c5c9595bb66$export$d65fe1460f8c5b4e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $dpIoR = parcelRequire("dpIoR");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This op also supports a Soft-NMS mode (cf.
 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
 * of other overlapping boxes, therefore favoring different regions of the image
 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
 * parameter to be larger than 0.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
 *     When sigma is 0, it falls back to nonMaxSuppression.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - selectedScores: A 1D tensor with the corresponding scores for each
 *       selected box.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $c0aa5c5c9595bb66$var$nonMaxSuppressionWithScore_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0.0) {
    const $boxes = (0, $5xBLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppression');
    const $scores = (0, $5xBLk.convertToTensor)(scores, 'scores', 'nonMaxSuppression');
    const params = (0, $dpIoR.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    maxOutputSize = params.maxOutputSize;
    iouThreshold = params.iouThreshold;
    scoreThreshold = params.scoreThreshold;
    softNmsSigma = params.softNmsSigma;
    const inputs = {
        boxes: $boxes,
        scores: $scores
    };
    const attrs = {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $38WwN.ENGINE).runKernel((0, $hl418.NonMaxSuppressionV5), inputs, attrs);
    return {
        selectedIndices: result[0],
        selectedScores: result[1]
    };
}
const $c0aa5c5c9595bb66$export$d65fe1460f8c5b4e = /* @__PURE__ */ (0, $jqSCG.op)({
    nonMaxSuppressionWithScore_: $c0aa5c5c9595bb66$var$nonMaxSuppressionWithScore_
});

});

parcelRegister("8357p", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionWithScoreAsync", () => $5dc292f419a7c34a$export$d1826570c883f7cf);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $KPYos = parcelRequire("KPYos");

var $5xBLk = parcelRequire("5xBLk");

var $dpIoR = parcelRequire("dpIoR");

var $lalFM = parcelRequire("lalFM");
/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This op also supports a Soft-NMS mode (cf.
 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
 * of other overlapping boxes, therefore favoring different regions of the image
 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
 * parameter to be larger than 0.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
 *     When sigma is 0, it falls back to nonMaxSuppression.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - selectedScores: A 1D tensor with the corresponding scores for each
 *       selected box.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $5dc292f419a7c34a$var$nonMaxSuppressionWithScoreAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0.0) {
    const $boxes = (0, $5xBLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $5xBLk.convertToTensor)(scores, 'scores', 'nonMaxSuppressionAsync');
    const params = (0, $dpIoR.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    maxOutputSize = params.maxOutputSize;
    iouThreshold = params.iouThreshold;
    scoreThreshold = params.scoreThreshold;
    softNmsSigma = params.softNmsSigma;
    const boxesAndScores = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    const boxesVals = boxesAndScores[0];
    const scoresVals = boxesAndScores[1];
    // We call a cpu based impl directly with the typedarray data  here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = (0, $KPYos.nonMaxSuppressionV5Impl)(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return {
        selectedIndices: (0, $lalFM.tensor1d)(selectedIndices, 'int32'),
        selectedScores: (0, $lalFM.tensor1d)(selectedScores)
    };
}
const $5dc292f419a7c34a$export$d1826570c883f7cf = $5dc292f419a7c34a$var$nonMaxSuppressionWithScoreAsync_;

});

parcelRegister("gzUbZ", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionPadded", () => $c11b80e2eb953c6d$export$d8d10e31c41c95dc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $dpIoR = parcelRequire("dpIoR");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union), with an option to pad results.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param padToMaxOutputSize Defaults to false. If true, size of output
 *     `selectedIndices` is padded to maxOutputSize.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - validOutputs: A scalar denoting how many elements in `selectedIndices`
 *       are valid. Valid elements occur first, then padding.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $c11b80e2eb953c6d$var$nonMaxSuppressionPadded_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
    const $boxes = (0, $5xBLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppression');
    const $scores = (0, $5xBLk.convertToTensor)(scores, 'scores', 'nonMaxSuppression');
    const params = (0, $dpIoR.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
    const $maxOutputSize = params.maxOutputSize;
    const $iouThreshold = params.iouThreshold;
    const $scoreThreshold = params.scoreThreshold;
    const inputs = {
        boxes: $boxes,
        scores: $scores
    };
    const attrs = {
        maxOutputSize: $maxOutputSize,
        iouThreshold: $iouThreshold,
        scoreThreshold: $scoreThreshold,
        padToMaxOutputSize: padToMaxOutputSize
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $38WwN.ENGINE).runKernel((0, $hl418.NonMaxSuppressionV4), inputs, attrs);
    return {
        selectedIndices: result[0],
        validOutputs: result[1]
    };
}
const $c11b80e2eb953c6d$export$d8d10e31c41c95dc = /* @__PURE__ */ (0, $jqSCG.op)({
    nonMaxSuppressionPadded_: $c11b80e2eb953c6d$var$nonMaxSuppressionPadded_
});

});

parcelRegister("bq0nG", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionPaddedAsync", () => $85026b125f5bbb1e$export$4c5691f9710b88a8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $KPYos = parcelRequire("KPYos");

var $5xBLk = parcelRequire("5xBLk");

var $dpIoR = parcelRequire("dpIoR");

var $3xp7o = parcelRequire("3xp7o");

var $lalFM = parcelRequire("lalFM");
/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union), with an option to pad results.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param padToMaxOutputSize Defaults to false. If true, size of output
 *     `selectedIndices` is padded to maxOutputSize.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - validOutputs: A scalar denoting how many elements in `selectedIndices`
 *       are valid. Valid elements occur first, then padding.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $85026b125f5bbb1e$var$nonMaxSuppressionPaddedAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
    const $boxes = (0, $5xBLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $5xBLk.convertToTensor)(scores, 'scores', 'nonMaxSuppressionAsync');
    const params = (0, $dpIoR.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
    const $maxOutputSize = params.maxOutputSize;
    const $iouThreshold = params.iouThreshold;
    const $scoreThreshold = params.scoreThreshold;
    const [boxesVals, scoresVals] = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    // We call a cpu based impl directly with the typedarray data here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = (0, $KPYos.nonMaxSuppressionV4Impl)(boxesVals, scoresVals, $maxOutputSize, $iouThreshold, $scoreThreshold, padToMaxOutputSize);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return {
        selectedIndices: (0, $lalFM.tensor1d)(selectedIndices, 'int32'),
        validOutputs: (0, $3xp7o.scalar)(validOutputs, 'int32')
    };
}
const $85026b125f5bbb1e$export$4c5691f9710b88a8 = $85026b125f5bbb1e$var$nonMaxSuppressionPaddedAsync_;

});

parcelRegister("6zgXB", function(module, exports) {

$parcel$export(module.exports, "resizeBilinear", () => $4c832af1e8d94834$export$1f1cbc7da93d06a0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Bilinear resize a single 3D image or a batch of 3D images to a new shape.
 *
 * @param images The images, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param size The new shape `[newHeight, newWidth]` to resize the
 *     images to. Each channel is resized individually.
 * @param alignCorners Defaults to `false`. If true, rescale
 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
 *     corners of images and resized images. If false, rescale by
 *     `new_height / height`. Treat similarly the width dimension.
 * @param halfPixelCenters Defaults to `false`. Whether to assume pixel centers
 *     are at 0.5, which would make the floating point coordinates of the top
 *     left pixel 0.5, 0.5.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $4c832af1e8d94834$var$resizeBilinear_(images, size, alignCorners = false, halfPixelCenters = false) {
    const $images = (0, $5xBLk.convertToTensor)(images, 'images', 'resizeBilinear');
    $8cCb2.assert($images.rank === 3 || $images.rank === 4, ()=>`Error in resizeBilinear: x must be rank 3 or 4, but got ` + `rank ${$images.rank}.`);
    $8cCb2.assert(size.length === 2, ()=>`Error in resizeBilinear: new shape must 2D, but got shape ` + `${size}.`);
    $8cCb2.assert(halfPixelCenters === false || alignCorners === false, ()=>`Error in resizeBilinear: If halfPixelCenters is true, ` + `alignCorners must be false.`);
    let batchImages = $images;
    let reshapedTo4D = false;
    if ($images.rank === 3) {
        reshapedTo4D = true;
        batchImages = (0, $4sqA7.reshape)($images, [
            1,
            $images.shape[0],
            $images.shape[1],
            $images.shape[2]
        ]);
    }
    const [] = size;
    const inputs = {
        images: batchImages
    };
    const attrs = {
        alignCorners: alignCorners,
        halfPixelCenters: halfPixelCenters,
        size: size
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.ResizeBilinear), inputs, attrs);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $4c832af1e8d94834$export$1f1cbc7da93d06a0 = /* @__PURE__ */ (0, $jqSCG.op)({
    resizeBilinear_: $4c832af1e8d94834$var$resizeBilinear_
});

});

parcelRegister("ek5OW", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighbor", () => $a6d772d3dc572a5d$export$74a902ae74ac2560);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * NearestNeighbor resize a batch of 3D images to a new shape.
 *
 * @param images The images, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param size The new shape `[newHeight, newWidth]` to resize the
 *     images to. Each channel is resized individually.
 * @param alignCorners Defaults to False. If true, rescale
 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
 *     corners of images and resized images. If false, rescale by
 *     `new_height / height`. Treat similarly the width dimension.
 * @param halfPixelCenters Defaults to `false`. Whether to assume pixels are of
 *      half the actual dimensions, and yield more accurate resizes. This flag
 *      would also make the floating point coordinates of the top left pixel
 *      0.5, 0.5.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $a6d772d3dc572a5d$var$resizeNearestNeighbor_(images, size, alignCorners = false, halfPixelCenters = false) {
    const $images = (0, $5xBLk.convertToTensor)(images, 'images', 'resizeNearestNeighbor');
    $8cCb2.assert($images.rank === 3 || $images.rank === 4, ()=>`Error in resizeNearestNeighbor: x must be rank 3 or 4, but got ` + `rank ${$images.rank}.`);
    $8cCb2.assert(size.length === 2, ()=>`Error in resizeNearestNeighbor: new shape must 2D, but got shape ` + `${size}.`);
    $8cCb2.assert($images.dtype === 'float32' || $images.dtype === 'int32', ()=>'`images` must have `int32` or `float32` as dtype');
    $8cCb2.assert(halfPixelCenters === false || alignCorners === false, ()=>`Error in resizeNearestNeighbor: If halfPixelCenters is true, ` + `alignCorners must be false.`);
    let batchImages = $images;
    let reshapedTo4D = false;
    if ($images.rank === 3) {
        reshapedTo4D = true;
        batchImages = (0, $4sqA7.reshape)($images, [
            1,
            $images.shape[0],
            $images.shape[1],
            $images.shape[2]
        ]);
    }
    const [] = size;
    const inputs = {
        images: batchImages
    };
    const attrs = {
        alignCorners: alignCorners,
        halfPixelCenters: halfPixelCenters,
        size: size
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.ResizeNearestNeighbor), inputs, attrs);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $a6d772d3dc572a5d$export$74a902ae74ac2560 = /* @__PURE__ */ (0, $jqSCG.op)({
    resizeNearestNeighbor_: $a6d772d3dc572a5d$var$resizeNearestNeighbor_
});

});

parcelRegister("2uj2A", function(module, exports) {

$parcel$export(module.exports, "threshold", () => $1cfd2736c3bd16df$export$454d09aca5f3ea63);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $lalFM = parcelRequire("lalFM");

var $jqSCG = parcelRequire("jqSCG");

var $inFmq = parcelRequire("inFmq");

var $9fmAX = parcelRequire("9fmAX");

var $f3UMy = parcelRequire("f3UMy");

var $7LQ38 = parcelRequire("7LQ38");

var $bRRKf = parcelRequire("bRRKf");

var $9NgTx = parcelRequire("9NgTx");

var $hgacW = parcelRequire("hgacW");

var $jZc0w = parcelRequire("jZc0w");

var $1QPqB = parcelRequire("1QPqB");

var $7kouu = parcelRequire("7kouu");

var $9YKoa = parcelRequire("9YKoa");

var $l2P14 = parcelRequire("l2P14");

var $gYive = parcelRequire("gYive");

var $79KOG = parcelRequire("79KOG");

var $80Ety = parcelRequire("80Ety");

var $erbmM = parcelRequire("erbmM");

var $8cCb2 = parcelRequire("8cCb2");

var $5xBLk = parcelRequire("5xBLk");
/**
 * Performs image binarization with corresponding threshold
 * (depends on the method)value, which creates a binary image from a grayscale.
 * @param image 3d tensor of shape [imageHeight,imageWidth, depth],
 * where imageHeight and imageWidth must be positive.The image color
 * range should be [0, 255].
 * @param method Optional string from `'binary' | 'otsu'`
 * which specifies the method for thresholding. Defaults to 'binary'.
 * @param inverted Optional boolean whichspecifies
 * if colours should be inverted. Defaults to false.
 * @param threshValue Optional number which defines threshold value from 0 to 1.
 * Defaults to 0.5.
 * @return A 3d tensor of shape [imageHeight,imageWidth, depth], which
 * contains binarized image.
 */ function $1cfd2736c3bd16df$var$threshold_(image, method = 'binary', inverted = false, threshValue = 0.5) {
    const $image = (0, $5xBLk.convertToTensor)(image, 'image', 'threshold');
    /* 0.2989, 0.5870, 0.1140 are represent luma coefficients in CCIR601.
    Reference for converting between RGB and grayscale: https://en.wikipedia.org/wiki/Luma_%28video%29  */ const RED_INTENCITY_COEF = 0.2989;
    const GREEN_INTENCITY_COEF = 0.5870;
    const BLUE_INTENCITY_COEF = 0.1140;
    const totalPixelsInImage = $image.shape[0] * $image.shape[1];
    let $threshold = (0, $jZc0w.mul)((0, $lalFM.tensor1d)([
        threshValue
    ]), 255);
    let r, g, b, grayscale;
    $8cCb2.assert($image.rank === 3, ()=>'Error in threshold: image must be rank 3,' + `but got rank ${$image.rank}.`);
    $8cCb2.assert($image.shape[2] === 3 || $image.shape[2] === 1, ()=>"Error in threshold: image color channel must be equal to 3 or 1" + `but got ${$image.shape[2]}.`);
    $8cCb2.assert($image.dtype === 'int32' || $image.dtype === 'float32', ()=>'Error in dtype: image dtype must be int32 or float32,' + `but got dtype ${$image.dtype}.`);
    $8cCb2.assert(method === 'otsu' || method === 'binary', ()=>`Method must be binary or otsu, but was ${method}`);
    if ($image.shape[2] === 3) {
        [r, g, b] = (0, $9fmAX.split)($image, [
            1,
            1,
            1
        ], -1);
        const $r = (0, $jZc0w.mul)(r, RED_INTENCITY_COEF);
        const $g = (0, $jZc0w.mul)(g, GREEN_INTENCITY_COEF);
        const $b = (0, $jZc0w.mul)(b, BLUE_INTENCITY_COEF);
        grayscale = (0, $hgacW.add)((0, $hgacW.add)($r, $g), $b);
    } else grayscale = image;
    if (method === 'otsu') {
        const $histogram = (0, $f3UMy.bincount)((0, $inFmq.cast)((0, $9YKoa.round)(grayscale), 'int32'), (0, $erbmM.tensor)([]), 256);
        $threshold = $1cfd2736c3bd16df$var$otsu($histogram, totalPixelsInImage);
    }
    const invCondition = inverted ? (0, $7LQ38.lessEqual)(grayscale, $threshold) : (0, $bRRKf.greater)(grayscale, $threshold);
    const result = (0, $inFmq.cast)((0, $jZc0w.mul)(invCondition, 255), 'int32');
    return result;
}
function $1cfd2736c3bd16df$var$otsu(histogram, total) {
    let bestThresh = (0, $lalFM.tensor1d)([
        -1
    ]);
    let bestInBetVar = (0, $lalFM.tensor1d)([
        0
    ]);
    let cInBetVar = (0, $lalFM.tensor1d)([
        0
    ]);
    let classFirst, classSecond, meanFirst, meanSec, weightForeground, weightBack;
    for(let index = 0; index < histogram.size - 1; index++){
        classFirst = (0, $79KOG.slice)(histogram, 0, index + 1);
        classSecond = (0, $79KOG.slice)(histogram, index + 1);
        weightForeground = (0, $1QPqB.div)((0, $9NgTx.sum)(classFirst), total);
        weightBack = (0, $1QPqB.div)((0, $9NgTx.sum)(classSecond), total);
        const meanFirstDivA = (0, $9NgTx.sum)((0, $jZc0w.mul)(classFirst, (0, $80Ety.range)(0, classFirst.size)));
        meanFirst = (0, $1QPqB.div)(meanFirstDivA, (0, $9NgTx.sum)(classFirst));
        const meanSecFill = (0, $gYive.fill)(classSecond.shape, classFirst.size);
        const meanSecAdd = (0, $hgacW.add)((0, $80Ety.range)(0, classSecond.size), meanSecFill);
        const meanSecMul = (0, $jZc0w.mul)(classSecond, meanSecAdd);
        meanSec = (0, $1QPqB.div)((0, $9NgTx.sum)(meanSecMul), (0, $9NgTx.sum)(classSecond));
        const cInBetVarSubA = (0, $7kouu.sub)(meanFirst, meanSec);
        const cInBetVarSubB = (0, $7kouu.sub)(meanFirst, meanSec);
        const cInBetVarMul = (0, $jZc0w.mul)(weightForeground, weightBack);
        cInBetVar = (0, $jZc0w.mul)((0, $jZc0w.mul)(cInBetVarMul, cInBetVarSubA), cInBetVarSubB);
        const condition = (0, $bRRKf.greater)(cInBetVar, bestInBetVar);
        bestInBetVar = (0, $l2P14.where)(condition, cInBetVar, bestInBetVar);
        bestThresh = (0, $l2P14.where)(condition, (0, $lalFM.tensor1d)([
            index
        ]), bestThresh);
    }
    return bestThresh;
}
const $1cfd2736c3bd16df$export$454d09aca5f3ea63 = /* @__PURE__ */ (0, $jqSCG.op)({
    threshold_: $1cfd2736c3bd16df$var$threshold_
});

});

parcelRegister("53uSk", function(module, exports) {

$parcel$export(module.exports, "transform", () => $3ae52ebe9b17d3a8$export$51186ad6e864892a);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Applies the given transform(s) to the image(s).
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 * @param transforms Projective transform matrix/matrices. A tensor1d of length
 *     8 or tensor of size N x 8. If one row of transforms is [a0, a1, a2, b0,
 *     b1, b2, c0, c1], then it maps the output point (x, y) to a transformed
 *     input point (x', y') = ((a0 x + a1 y + a2) / k, (b0 x + b1 y + b2) / k),
 *     where k = c0 x + c1 y + 1. The transforms are inverted compared to the
 *     transform mapping input points to output points.
 * @param interpolation Interpolation mode.
 *     Supported values: 'nearest', 'bilinear'. Default to 'nearest'.
 * @param fillMode Points outside the boundaries of the input are filled
 *     according to the given mode, one of 'constant', 'reflect', 'wrap',
 *     'nearest'. Default to 'constant'.
 *     'reflect': (d c b a | a b c d | d c b a ) The input is extended by
 *     reflecting about the edge of the last pixel.
 *     'constant': (k k k k | a b c d | k k k k) The input is extended by
 *     filling all values beyond the edge with the same constant value k.
 *     'wrap': (a b c d | a b c d | a b c d) The input is extended by
 *     wrapping around to the opposite edge.
 *     'nearest': (a a a a | a b c d | d d d d) The input is extended by
 *     the nearest pixel.
 * @param fillValue A float represents the value to be filled outside the
 *     boundaries when fillMode is 'constant'.
 * @param Output dimension after the transform, [height, width]. If undefined,
 *     output is the same size as input image.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $3ae52ebe9b17d3a8$var$transform_(image, transforms, interpolation = 'nearest', fillMode = 'constant', fillValue = 0, outputShape) {
    const $image = (0, $5xBLk.convertToTensor)(image, 'image', 'transform', 'float32');
    const $transforms = (0, $5xBLk.convertToTensor)(transforms, 'transforms', 'transform', 'float32');
    $8cCb2.assert($image.rank === 4, ()=>'Error in transform: image must be rank 4,' + `but got rank ${$image.rank}.`);
    $8cCb2.assert($transforms.rank === 2 && ($transforms.shape[0] === $image.shape[0] || $transforms.shape[0] === 1) && $transforms.shape[1] === 8, ()=>`Error in transform: Input transform should be batch x 8 or 1 x 8`);
    $8cCb2.assert(outputShape == null || outputShape.length === 2, ()=>'Error in transform: outputShape must be [height, width] or null, ' + `but got ${outputShape}.`);
    const inputs = {
        image: $image,
        transforms: $transforms
    };
    const attrs = {
        interpolation: interpolation,
        fillMode: fillMode,
        fillValue: fillValue,
        outputShape: outputShape
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Transform), inputs, attrs);
}
const $3ae52ebe9b17d3a8$export$51186ad6e864892a = /* @__PURE__ */ (0, $jqSCG.op)({
    transform_: $3ae52ebe9b17d3a8$var$transform_
});

});

parcelRegister("kGYDg", function(module, exports) {

$parcel$export(module.exports, "bandPart", () => $f106c3304c20e7b0$export$8a3da9cb9e5610a0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $l0Zxl = parcelRequire("l0Zxl");

var $jTDVJ = parcelRequire("jTDVJ");

var $7LQ38 = parcelRequire("7LQ38");

var $kg1Wp = parcelRequire("kg1Wp");

var $6V8xR = parcelRequire("6V8xR");

var $15cGp = parcelRequire("15cGp");

var $jqSCG = parcelRequire("jqSCG");

var $80Ety = parcelRequire("80Ety");

var $4sqA7 = parcelRequire("4sqA7");

var $8BrLX = parcelRequire("8BrLX");

var $7kouu = parcelRequire("7kouu");

var $gBOC6 = parcelRequire("gBOC6");

var $l2P14 = parcelRequire("l2P14");

var $hxi4c = parcelRequire("hxi4c");
/**
 * Copy a tensor setting everything outside a central band in each innermost
 * matrix to zero.
 *
 * The band part is computed as follows: Assume input has `k` dimensions
 * `[I, J, K, ..., M, N]`, then the output is a tensor with the same shape where
 * `band[i, j, k, ..., m, n] = in_band(m, n) * input[i, j, k, ..., m, n]`.
 * The indicator function
 * `in_band(m, n) = (num_lower < 0 || (m-n) <= num_lower)`
 * `&& (num_upper < 0 || (n-m) <= num_upper)`
 *
 * ```js
 * const x = tf.tensor2d([[ 0,  1,  2, 3],
 *                        [-1,  0,  1, 2],
 *                        [-2, -1,  0, 1],
 *                        [-3, -2, -1, 0]]);
 * let y = tf.linalg.bandPart(x, 1, -1);
 * y.print(); // [[ 0,  1,  2, 3],
 *            //  [-1,  0,  1, 2],
 *            //  [ 0, -1,  0, 1],
 *            //  [ 0, 0 , -1, 0]]
 * let z = tf.linalg.bandPart(x, 2, 1);
 * z.print(); // [[ 0,  1,  0, 0],
 *            //  [-1,  0,  1, 0],
 *            //  [-2, -1,  0, 1],
 *            //  [ 0, -2, -1, 0]]
 * ```
 *
 * @param x Rank `k` tensor
 * @param numLower Number of subdiagonals to keep.
 *   If negative, keep entire lower triangle.
 * @param numUpper Number of subdiagonals to keep.
 *   If negative, keep entire upper triangle.
 * @returns Rank `k` tensor of the same shape as input.
 *   The extracted banded tensor.
 *
 * @doc {heading:'Operations', subheading:'Linear Algebra', namespace:'linalg'}
 */ function $f106c3304c20e7b0$var$bandPart_(a, numLower, numUpper) {
    const $a = (0, $5xBLk.convertToTensor)(a, 'a', 'bandPart');
    (0, $8cCb2.assert)($a.rank >= 2, ()=>`bandPart(): Rank must be at least 2, got ${$a.rank}.`);
    const shape = $a.shape;
    const [M, N] = $a.shape.slice(-2);
    let $numLower;
    let $numUpper;
    if (typeof numLower === 'number') {
        (0, $8cCb2.assert)(numLower % 1 === 0, ()=>`bandPart(): numLower must be an integer, got ${numLower}.`);
        (0, $8cCb2.assert)(numLower <= M, ()=>`bandPart(): numLower (${numLower})` + ` must not be greater than the number of rows (${M}).`);
        $numLower = (0, $5xBLk.convertToTensor)(numLower < 0 ? M : numLower, 'numLower', 'bandPart');
    } else {
        (0, $8cCb2.assert)(numLower.dtype === 'int32', ()=>`bandPart(): numLower's dtype must be an int32.`);
        // If numLower is a Scalar, checking `numLower <= M` could hurt performance,
        // but minimum(numLower, M) could avoid unexpected results.
        $numLower = (0, $l2P14.where)((0, $jTDVJ.less)(numLower, 0), M, (0, $6V8xR.minimum)(numLower, M));
    }
    if (typeof numUpper === 'number') {
        (0, $8cCb2.assert)(numUpper % 1 === 0, ()=>`bandPart(): numUpper must be an integer, got ${numUpper}.`);
        (0, $8cCb2.assert)(numUpper <= N, ()=>`bandPart(): numUpper (${numUpper})` + ` must not be greater than the number of columns (${N}).`);
        $numUpper = (0, $5xBLk.convertToTensor)(numUpper < 0 ? N : numUpper, 'numUpper', 'bandPart');
    } else {
        (0, $8cCb2.assert)(numUpper.dtype === 'int32', ()=>`bandPart(): numUpper's dtype must be an int32.`);
        $numUpper = (0, $l2P14.where)((0, $jTDVJ.less)(numUpper, 0), N, (0, $6V8xR.minimum)(numUpper, N));
    }
    const i = (0, $4sqA7.reshape)((0, $80Ety.range)(0, M, 1, 'int32'), [
        -1,
        1
    ]);
    const j = (0, $80Ety.range)(0, N, 1, 'int32');
    const ij = (0, $7kouu.sub)(i, j);
    const inBand = (0, $kg1Wp.logicalAnd)((0, $7LQ38.lessEqual)(ij, $numLower), (0, $l0Zxl.greaterEqual)(ij, (0, $15cGp.neg)($numUpper)));
    const zero = (0, $hxi4c.zeros)([
        M,
        N
    ], $a.dtype);
    return (0, $4sqA7.reshape)((0, $8BrLX.stack)((0, $gBOC6.unstack)((0, $4sqA7.reshape)($a, [
        -1,
        M,
        N
    ])).map((mat)=>(0, $l2P14.where)(inBand, mat, zero))), shape);
}
const $f106c3304c20e7b0$export$8a3da9cb9e5610a0 = /* @__PURE__ */ (0, $jqSCG.op)({
    bandPart_: $f106c3304c20e7b0$var$bandPart_
});

});

parcelRegister("bI4CH", function(module, exports) {

$parcel$export(module.exports, "gramSchmidt", () => $886763dc106f4c3d$export$d505610386a600de);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $8cCb2 = parcelRequire("8cCb2");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $7k6dx = parcelRequire("7k6dx");

var $jqSCG = parcelRequire("jqSCG");

var $9fmAX = parcelRequire("9fmAX");

var $kX8Hd = parcelRequire("kX8Hd");

var $8BrLX = parcelRequire("8BrLX");

var $7kouu = parcelRequire("7kouu");

var $9NgTx = parcelRequire("9NgTx");
/**
 * Gram-Schmidt orthogonalization.
 *
 * ```js
 * const x = tf.tensor2d([[1, 2], [3, 4]]);
 * let y = tf.linalg.gramSchmidt(x);
 * y.print();
 * console.log('Orthogonalized:');
 * y.dot(y.transpose()).print();  // should be nearly the identity matrix.
 * console.log('First row direction maintained:');
 * const data = await y.array();
 * console.log(data[0][1] / data[0][0]);  // should be nearly 2.
 * ```
 *
 * @param xs The vectors to be orthogonalized, in one of the two following
 *   formats:
 *   - An Array of `tf.Tensor1D`.
 *   - A `tf.Tensor2D`, i.e., a matrix, in which case the vectors are the rows
 *     of `xs`.
 *   In each case, all the vectors must have the same length and the length
 *   must be greater than or equal to the number of vectors.
 * @returns The orthogonalized and normalized vectors or matrix.
 *   Orthogonalization means that the vectors or the rows of the matrix
 *   are orthogonal (zero inner products). Normalization means that each
 *   vector or each row of the matrix has an L2 norm that equals `1`.
 *
 * @doc {heading:'Operations', subheading:'Linear Algebra', namespace:'linalg'}
 */ function $886763dc106f4c3d$var$gramSchmidt_(xs) {
    let inputIsTensor2D;
    if (Array.isArray(xs)) {
        inputIsTensor2D = false;
        (0, $8cCb2.assert)(xs != null && xs.length > 0, ()=>"Gram-Schmidt process: input must not be null, undefined, or empty");
        const dim = xs[0].shape[0];
        for(let i = 1; i < xs.length; ++i)(0, $8cCb2.assert)(xs[i].shape[0] === dim, ()=>'Gram-Schmidt: Non-unique lengths found in the input vectors: ' + `(${xs[i].shape[0]} vs. ${dim})`);
    } else {
        inputIsTensor2D = true;
        xs = (0, $9fmAX.split)(xs, xs.shape[0], 0).map((x)=>(0, $kX8Hd.squeeze)(x, [
                0
            ]));
    }
    (0, $8cCb2.assert)(xs.length <= xs[0].shape[0], ()=>`Gram-Schmidt: Number of vectors (${xs.length}) exceeds ` + `number of dimensions (${xs[0].shape[0]}).`);
    const ys = [];
    const xs1d = xs;
    for(let i = 0; i < xs.length; ++i)ys.push((0, $38WwN.ENGINE).tidy(()=>{
        let x = xs1d[i];
        if (i > 0) for(let j = 0; j < i; ++j){
            const proj = (0, $jZc0w.mul)((0, $9NgTx.sum)((0, $jZc0w.mul)(ys[j], x)), ys[j]);
            x = (0, $7kouu.sub)(x, proj);
        }
        return (0, $1QPqB.div)(x, (0, $7k6dx.norm)(x, 'euclidean'));
    }));
    if (inputIsTensor2D) return (0, $8BrLX.stack)(ys, 0);
    else return ys;
}
const $886763dc106f4c3d$export$d505610386a600de = /* @__PURE__ */ (0, $jqSCG.op)({
    gramSchmidt_: $886763dc106f4c3d$var$gramSchmidt_
});

});

parcelRegister("ipM8K", function(module, exports) {

$parcel$export(module.exports, "qr", () => $d67fe76a3cc8e71b$export$7c27fb47516129d9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $c2DT1 = parcelRequire("c2DT1");

var $8cCb2 = parcelRequire("8cCb2");

var $5TuCW = parcelRequire("5TuCW");

var $iTu6j = parcelRequire("iTu6j");

var $1QPqB = parcelRequire("1QPqB");

var $9gIZb = parcelRequire("9gIZb");

var $bRRKf = parcelRequire("bRRKf");

var $aUFou = parcelRequire("aUFou");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $7k6dx = parcelRequire("7k6dx");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");

var $79KOG = parcelRequire("79KOG");

var $8BrLX = parcelRequire("8BrLX");

var $7kouu = parcelRequire("7kouu");

var $gmMlv = parcelRequire("gmMlv");

var $aDHKy = parcelRequire("aDHKy");

var $gBOC6 = parcelRequire("gBOC6");

var $l2P14 = parcelRequire("l2P14");
/**
 * Compute QR decomposition of m-by-n matrix using Householder transformation.
 *
 * Implementation based on
 *   [http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf]
 * (http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf)
 *
 * ```js
 * const a = tf.tensor2d([[1, 2], [3, 4]]);
 * let [q, r] = tf.linalg.qr(a);
 * console.log('Q');
 * q.print();
 * console.log('R');
 * r.print();
 * console.log('Orthogonalized');
 * q.dot(q.transpose()).print()  // should be nearly the identity matrix.
 * console.log('Reconstructed');
 * q.dot(r).print(); // should be nearly [[1, 2], [3, 4]];
 * ```
 *
 * @param x The `tf.Tensor` to be QR-decomposed. Must have rank >= 2. Suppose
 *   it has the shape `[..., M, N]`.
 * @param fullMatrices An optional boolean parameter. Defaults to `false`.
 *   If `true`, compute full-sized `Q`. If `false` (the default),
 *   compute only the leading N columns of `Q` and `R`.
 * @returns An `Array` of two `tf.Tensor`s: `[Q, R]`. `Q` is a unitary matrix,
 *   i.e., its columns all have unit norm and are mutually orthogonal.
 *   If `M >= N`,
 *     If `fullMatrices` is `false` (default),
 *       - `Q` has a shape of `[..., M, N]`,
 *       - `R` has a shape of `[..., N, N]`.
 *     If `fullMatrices` is `true` (default),
 *       - `Q` has a shape of `[..., M, M]`,
 *       - `R` has a shape of `[..., M, N]`.
 *   If `M < N`,
 *     - `Q` has a shape of `[..., M, M]`,
 *     - `R` has a shape of `[..., M, N]`.
 * @throws If the rank of `x` is less than 2.
 *
 * @doc {heading:'Operations',
 *       subheading:'Linear Algebra',
 *       namespace:'linalg'}
 */ function $d67fe76a3cc8e71b$var$qr_(x, fullMatrices = false) {
    (0, $8cCb2.assert)(x.rank >= 2, ()=>`qr() requires input tensor to have a rank >= 2, but got rank ${x.rank}`);
    if (x.rank === 2) return $d67fe76a3cc8e71b$var$qr2d(x, fullMatrices);
    else {
        // Rank > 2.
        // TODO(cais): Below we split the input into individual 2D tensors,
        //   perform QR decomposition on them and then stack the results back
        //   together. We should explore whether this can be parallelized.
        const outerDimsProd = x.shape.slice(0, x.shape.length - 2).reduce((value, prev)=>value * prev);
        const x2ds = (0, $gBOC6.unstack)((0, $4sqA7.reshape)(x, [
            outerDimsProd,
            x.shape[x.shape.length - 2],
            x.shape[x.shape.length - 1]
        ]), 0);
        const q2ds = [];
        const r2ds = [];
        x2ds.forEach((x2d)=>{
            const [q2d, r2d] = $d67fe76a3cc8e71b$var$qr2d(x2d, fullMatrices);
            q2ds.push(q2d);
            r2ds.push(r2d);
        });
        const q = (0, $4sqA7.reshape)((0, $8BrLX.stack)(q2ds, 0), x.shape);
        const r = (0, $4sqA7.reshape)((0, $8BrLX.stack)(r2ds, 0), x.shape);
        return [
            q,
            r
        ];
    }
}
function $d67fe76a3cc8e71b$var$qr2d(x, fullMatrices = false) {
    return (0, $38WwN.ENGINE).tidy(()=>{
        (0, $8cCb2.assert)(x.shape.length === 2, ()=>`qr2d() requires a 2D Tensor, but got a ${x.shape.length}D Tensor.`);
        const m = x.shape[0];
        const n = x.shape[1];
        let q = (0, $9gIZb.eye)(m); // Orthogonal transform so far.
        let r = (0, $5TuCW.clone)(x); // Transformed matrix so far.
        const one2D = (0, $gmMlv.tensor2d)([
            [
                1
            ]
        ], [
            1,
            1
        ]);
        let w = (0, $5TuCW.clone)(one2D);
        const iters = m >= n ? n : m;
        for(let j = 0; j < iters; ++j){
            // This tidy within the for-loop ensures we clean up temporary
            // tensors as soon as they are no longer needed.
            const rTemp = r;
            const wTemp = w;
            const qTemp = q;
            [w, r, q] = (0, $38WwN.ENGINE).tidy(()=>{
                // Find H = I - tau * w * w', to put zeros below R(j, j).
                const rjEnd1 = (0, $79KOG.slice)(r, [
                    j,
                    j
                ], [
                    m - j,
                    1
                ]);
                const normX = (0, $7k6dx.norm)(rjEnd1);
                const rjj = (0, $79KOG.slice)(r, [
                    j,
                    j
                ], [
                    1,
                    1
                ]);
                // The sign() function returns 0 on 0, which causes division by zero.
                const s = (0, $l2P14.where)((0, $bRRKf.greater)(rjj, 0), (0, $gmMlv.tensor2d)([
                    [
                        -1
                    ]
                ]), (0, $gmMlv.tensor2d)([
                    [
                        1
                    ]
                ]));
                const u1 = (0, $7kouu.sub)(rjj, (0, $jZc0w.mul)(s, normX));
                const wPre = (0, $1QPqB.div)(rjEnd1, u1);
                if (wPre.shape[0] === 1) w = (0, $5TuCW.clone)(one2D);
                else w = (0, $iTu6j.concat)([
                    one2D,
                    (0, $79KOG.slice)(wPre, [
                        1,
                        0
                    ], [
                        wPre.shape[0] - 1,
                        wPre.shape[1]
                    ])
                ], 0);
                const tau = (0, $15cGp.neg)((0, $1QPqB.div)((0, $aUFou.matMul)(s, u1), normX));
                // -- R := HR, Q := QH.
                const rjEndAll = (0, $79KOG.slice)(r, [
                    j,
                    0
                ], [
                    m - j,
                    n
                ]);
                const tauTimesW = (0, $jZc0w.mul)(tau, w);
                const wT = (0, $aDHKy.transpose)(w);
                if (j === 0) r = (0, $7kouu.sub)(rjEndAll, (0, $aUFou.matMul)(tauTimesW, (0, $aUFou.matMul)(wT, rjEndAll)));
                else {
                    const rTimesTau = (0, $7kouu.sub)(rjEndAll, (0, $aUFou.matMul)(tauTimesW, (0, $aUFou.matMul)(wT, rjEndAll)));
                    r = (0, $iTu6j.concat)([
                        (0, $79KOG.slice)(r, [
                            0,
                            0
                        ], [
                            j,
                            n
                        ]),
                        rTimesTau
                    ], 0);
                }
                const tawTimesWT = (0, $aDHKy.transpose)(tauTimesW);
                const qAllJEnd = (0, $79KOG.slice)(q, [
                    0,
                    j
                ], [
                    m,
                    q.shape[1] - j
                ]);
                if (j === 0) q = (0, $7kouu.sub)(qAllJEnd, (0, $aUFou.matMul)((0, $aUFou.matMul)(qAllJEnd, w), tawTimesWT));
                else {
                    const qTimesTau = (0, $7kouu.sub)(qAllJEnd, (0, $aUFou.matMul)((0, $aUFou.matMul)(qAllJEnd, w), tawTimesWT));
                    q = (0, $iTu6j.concat)([
                        (0, $79KOG.slice)(q, [
                            0,
                            0
                        ], [
                            m,
                            j
                        ]),
                        qTimesTau
                    ], 1);
                }
                return [
                    w,
                    r,
                    q
                ];
            });
            (0, $c2DT1.dispose)([
                rTemp,
                wTemp,
                qTemp
            ]);
        }
        if (!fullMatrices && m > n) {
            q = (0, $79KOG.slice)(q, [
                0,
                0
            ], [
                m,
                n
            ]);
            r = (0, $79KOG.slice)(r, [
                0,
                0
            ], [
                n,
                n
            ]);
        }
        return [
            q,
            r
        ];
    });
}
const $d67fe76a3cc8e71b$export$7c27fb47516129d9 = /* @__PURE__ */ (0, $jqSCG.op)({
    qr_: $d67fe76a3cc8e71b$var$qr_
});

});

parcelRegister("beFbS", function(module, exports) {

$parcel$export(module.exports, "absoluteDifference", () => $82e0f41f88acdfa8$export$d81f35aebafd8971);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $7j49I = parcelRequire("7j49I");

var $i8gZm = parcelRequire("i8gZm");

var $jqSCG = parcelRequire("jqSCG");

var $7kouu = parcelRequire("7kouu");

var $aQ3Nu = parcelRequire("aQ3Nu");
/**
 * Computes the absolute difference loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $82e0f41f88acdfa8$var$absoluteDifference_(labels, predictions, weights, reduction = (0, $i8gZm.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $5xBLk.convertToTensor)(labels, 'labels', 'absoluteDifference');
    const $predictions = (0, $5xBLk.convertToTensor)(predictions, 'predictions', 'absoluteDifference');
    let $weights = null;
    if (weights != null) $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'absoluteDifference');
    (0, $8cCb2.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in absoluteDifference: ');
    const losses = (0, $7j49I.abs)((0, $7kouu.sub)($labels, $predictions));
    return (0, $aQ3Nu.computeWeightedLoss)(losses, $weights, reduction);
}
const $82e0f41f88acdfa8$export$d81f35aebafd8971 = /* @__PURE__ */ (0, $jqSCG.op)({
    absoluteDifference_: $82e0f41f88acdfa8$var$absoluteDifference_
});

});
parcelRegister("i8gZm", function(module, exports) {

$parcel$export(module.exports, "Reduction", () => $d33626f0529b69e1$export$cc9fa7113d70efba);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $d33626f0529b69e1$export$cc9fa7113d70efba;
(function(Reduction) {
    Reduction[Reduction["NONE"] = 0] = "NONE";
    Reduction[Reduction["MEAN"] = 1] = "MEAN";
    Reduction[Reduction["SUM"] = 2] = "SUM";
    Reduction[Reduction["SUM_BY_NONZERO_WEIGHTS"] = 3] = "SUM_BY_NONZERO_WEIGHTS";
})($d33626f0529b69e1$export$cc9fa7113d70efba || ($d33626f0529b69e1$export$cc9fa7113d70efba = {}));

});

parcelRegister("aQ3Nu", function(module, exports) {

$parcel$export(module.exports, "computeWeightedLoss", () => $7e41b4c5c17c7f73$export$23bdc4cea2e28782);

var $5xBLk = parcelRequire("5xBLk");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $i8gZm = parcelRequire("i8gZm");

var $67GCc = parcelRequire("67GCc");

var $jZc0w = parcelRequire("jZc0w");

var $8WSnu = parcelRequire("8WSnu");

var $fOBRA = parcelRequire("fOBRA");

var $jqSCG = parcelRequire("jqSCG");

var $3xp7o = parcelRequire("3xp7o");

var $9NgTx = parcelRequire("9NgTx");
/**
 * Computes the weighted loss between two tensors.
 *
 * @param losses Tensor of shape `[batch_size, d1, ..., dN]`.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `losses`, and must be broadcastable to `losses` (i.e., all
 *    dimensions must be either `1`, or the same as the corresponding
 *    `losses` dimension).
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $7e41b4c5c17c7f73$var$computeWeightedLoss_(losses, weights, reduction = (0, $i8gZm.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $losses = (0, $5xBLk.convertToTensor)(losses, 'losses', 'computeWeightedLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'computeWeightedLoss');
    const weightedLoss = $weights == null ? $losses : (0, $jZc0w.mul)($losses, $weights);
    if (reduction === (0, $i8gZm.Reduction).NONE) return weightedLoss;
    if (reduction === (0, $i8gZm.Reduction).SUM) return (0, $9NgTx.sum)(weightedLoss);
    if (reduction === (0, $i8gZm.Reduction).MEAN) {
        if ($weights == null) return (0, $67GCc.mean)(weightedLoss);
        else {
            const broadcastFactor = $losses.size / $weights.size;
            const result = (0, $1QPqB.div)((0, $9NgTx.sum)(weightedLoss), (0, $9NgTx.sum)($weights));
            return broadcastFactor > 1 ? (0, $1QPqB.div)(result, (0, $3xp7o.scalar)(broadcastFactor)) : result;
        }
    }
    if (reduction === (0, $i8gZm.Reduction).SUM_BY_NONZERO_WEIGHTS) {
        if ($weights == null) return (0, $1QPqB.div)((0, $9NgTx.sum)(weightedLoss), (0, $3xp7o.scalar)($losses.size));
        else {
            const broadcastedWeights = (0, $jZc0w.mul)($weights, (0, $fOBRA.ones)($losses.shape));
            const numNonZeros = (0, $inFmq.cast)((0, $9NgTx.sum)((0, $8WSnu.notEqual)(broadcastedWeights, (0, $3xp7o.scalar)(0))), 'float32');
            return (0, $1QPqB.div)((0, $9NgTx.sum)(weightedLoss), numNonZeros);
        }
    }
    throw Error(`Unknown reduction: ${reduction}`);
}
const $7e41b4c5c17c7f73$export$23bdc4cea2e28782 = /* @__PURE__ */ (0, $jqSCG.op)({
    computeWeightedLoss_: $7e41b4c5c17c7f73$var$computeWeightedLoss_
});

});


parcelRegister("315ft", function(module, exports) {

$parcel$export(module.exports, "cosineDistance", () => $2325895a8bf09f42$export$6168ae03858f836b);

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $i8gZm = parcelRequire("i8gZm");

var $jZc0w = parcelRequire("jZc0w");

var $jqSCG = parcelRequire("jqSCG");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");

var $9NgTx = parcelRequire("9NgTx");

var $aQ3Nu = parcelRequire("aQ3Nu");
/**
 * Computes the cosine distance loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param axis The dimension along which the cosine distance is computed.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $2325895a8bf09f42$var$cosineDistance_(labels, predictions, axis, weights, reduction = (0, $i8gZm.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $5xBLk.convertToTensor)(labels, 'labels', 'cosineDistance');
    const $predictions = (0, $5xBLk.convertToTensor)(predictions, 'predictions', 'cosineDistance');
    let $weights = null;
    if (weights != null) $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'cosineDistance');
    (0, $8cCb2.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in cosineDistance: ');
    const one = (0, $3xp7o.scalar)(1);
    const losses = (0, $7kouu.sub)(one, (0, $9NgTx.sum)((0, $jZc0w.mul)($labels, $predictions), axis, true));
    return (0, $aQ3Nu.computeWeightedLoss)(losses, $weights, reduction);
}
const $2325895a8bf09f42$export$6168ae03858f836b = /* @__PURE__ */ (0, $jqSCG.op)({
    cosineDistance_: $2325895a8bf09f42$var$cosineDistance_
});

});

parcelRegister("aqAKz", function(module, exports) {

$parcel$export(module.exports, "hingeLoss", () => $7978d6e60cc0aafc$export$fc7754731492f43f);

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $i8gZm = parcelRequire("i8gZm");

var $jZc0w = parcelRequire("jZc0w");

var $jqSCG = parcelRequire("jqSCG");

var $8wbQq = parcelRequire("8wbQq");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");

var $aQ3Nu = parcelRequire("aQ3Nu");
/**
 * Computes the Hinge loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $7978d6e60cc0aafc$var$hingeLoss_(labels, predictions, weights, reduction = (0, $i8gZm.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    let $labels = (0, $5xBLk.convertToTensor)(labels, 'labels', 'hingeLoss');
    const $predictions = (0, $5xBLk.convertToTensor)(predictions, 'predictions', 'hingeLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'hingeLoss');
    (0, $8cCb2.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in hingeLoss: ');
    const one = (0, $3xp7o.scalar)(1);
    // Convert binary labels to (-1, 1)
    $labels = (0, $7kouu.sub)((0, $jZc0w.mul)((0, $3xp7o.scalar)(2), $labels), one);
    const losses = (0, $8wbQq.relu)((0, $7kouu.sub)(one, (0, $jZc0w.mul)($labels, $predictions)));
    return (0, $aQ3Nu.computeWeightedLoss)(losses, $weights, reduction);
}
const $7978d6e60cc0aafc$export$fc7754731492f43f = /* @__PURE__ */ (0, $jqSCG.op)({
    hingeLoss_: $7978d6e60cc0aafc$var$hingeLoss_
});

});

parcelRegister("2lNlw", function(module, exports) {

$parcel$export(module.exports, "huberLoss", () => $1b63d20f6bf329ec$export$ad2dd557b367bf2b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $7j49I = parcelRequire("7j49I");

var $hgacW = parcelRequire("hgacW");

var $i8gZm = parcelRequire("i8gZm");

var $6V8xR = parcelRequire("6V8xR");

var $jZc0w = parcelRequire("jZc0w");

var $jqSCG = parcelRequire("jqSCG");

var $3xp7o = parcelRequire("3xp7o");

var $iDd8d = parcelRequire("iDd8d");

var $7kouu = parcelRequire("7kouu");

var $aQ3Nu = parcelRequire("aQ3Nu");
/**
 * Computes the Huber loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param delta Point where Huber loss changes from quadratic to linear.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`.
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $1b63d20f6bf329ec$var$huberLoss_(labels, predictions, weights, delta = 1.0, reduction = (0, $i8gZm.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $5xBLk.convertToTensor)(labels, 'labels', 'huberLoss');
    const $predictions = (0, $5xBLk.convertToTensor)(predictions, 'predictions', 'huberLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'huberLoss');
    (0, $8cCb2.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in huberLoss: ');
    const deltaScalar = (0, $3xp7o.scalar)(delta);
    const error = (0, $7j49I.abs)((0, $7kouu.sub)($predictions, $labels));
    const quadratic = (0, $6V8xR.minimum)(error, deltaScalar);
    const linear = (0, $7kouu.sub)(error, quadratic);
    const losses = (0, $hgacW.add)((0, $jZc0w.mul)((0, $3xp7o.scalar)(0.5), (0, $iDd8d.square)(quadratic)), (0, $jZc0w.mul)(deltaScalar, linear));
    return (0, $aQ3Nu.computeWeightedLoss)(losses, $weights, reduction);
}
const $1b63d20f6bf329ec$export$ad2dd557b367bf2b = /* @__PURE__ */ (0, $jqSCG.op)({
    huberLoss_: $1b63d20f6bf329ec$var$huberLoss_
});

});

parcelRegister("8Bzf4", function(module, exports) {

$parcel$export(module.exports, "logLoss", () => $643d1dca5449e87b$export$5ca6937b99935214);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $hgacW = parcelRequire("hgacW");

var $dcoCo = parcelRequire("dcoCo");

var $i8gZm = parcelRequire("i8gZm");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $jqSCG = parcelRequire("jqSCG");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");

var $aQ3Nu = parcelRequire("aQ3Nu");
/**
 * Computes the log loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param epsilon A small increment to avoid taking log of zero
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $643d1dca5449e87b$var$logLoss_(labels, predictions, weights, epsilon = 1e-7, reduction = (0, $i8gZm.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $5xBLk.convertToTensor)(labels, 'labels', 'logLoss');
    const $predictions = (0, $5xBLk.convertToTensor)(predictions, 'predictions', 'logLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'logLoss');
    (0, $8cCb2.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in logLoss: ');
    const one = (0, $3xp7o.scalar)(1);
    const epsilonScalar = (0, $3xp7o.scalar)(epsilon);
    const l1 = (0, $15cGp.neg)((0, $jZc0w.mul)($labels, (0, $dcoCo.log)((0, $hgacW.add)($predictions, epsilonScalar))));
    const l2 = (0, $jZc0w.mul)((0, $7kouu.sub)(one, $labels), (0, $dcoCo.log)((0, $hgacW.add)((0, $7kouu.sub)(one, $predictions), epsilonScalar)));
    const losses = (0, $7kouu.sub)(l1, l2);
    return (0, $aQ3Nu.computeWeightedLoss)(losses, $weights, reduction);
}
const $643d1dca5449e87b$export$5ca6937b99935214 = /* @__PURE__ */ (0, $jqSCG.op)({
    logLoss_: $643d1dca5449e87b$var$logLoss_
});

});

parcelRegister("2Tkqe", function(module, exports) {

$parcel$export(module.exports, "meanSquaredError", () => $21b08f37b92a1b63$export$33de16355e97f7fb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $i8gZm = parcelRequire("i8gZm");

var $jqSCG = parcelRequire("jqSCG");

var $ay2Nw = parcelRequire("ay2Nw");

var $aQ3Nu = parcelRequire("aQ3Nu");
/**
 * Computes the mean squared error between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $21b08f37b92a1b63$var$meanSquaredError_(labels, predictions, weights, reduction = (0, $i8gZm.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $5xBLk.convertToTensor)(labels, 'labels', 'meanSquaredError');
    const $predictions = (0, $5xBLk.convertToTensor)(predictions, 'predictions', 'meanSquaredError');
    let $weights = null;
    if (weights != null) $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'meanSquaredError');
    (0, $8cCb2.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in meanSquaredError: ');
    const losses = (0, $ay2Nw.squaredDifference)($labels, $predictions);
    return (0, $aQ3Nu.computeWeightedLoss)(losses, $weights, reduction);
}
const $21b08f37b92a1b63$export$33de16355e97f7fb = /* @__PURE__ */ (0, $jqSCG.op)({
    meanSquaredError_: $21b08f37b92a1b63$var$meanSquaredError_
});

});

parcelRegister("7tTB0", function(module, exports) {

$parcel$export(module.exports, "sigmoidCrossEntropy", () => $57265e077d51af65$export$d099e04c73e0aede);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $7j49I = parcelRequire("7j49I");

var $hgacW = parcelRequire("hgacW");

var $2PcQK = parcelRequire("2PcQK");

var $5QUXI = parcelRequire("5QUXI");

var $i8gZm = parcelRequire("i8gZm");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $jqSCG = parcelRequire("jqSCG");

var $8wbQq = parcelRequire("8wbQq");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");

var $aQ3Nu = parcelRequire("aQ3Nu");
function $57265e077d51af65$var$sigmoidCrossEntropyWithLogits_(labels, logits) {
    const $labels = (0, $5xBLk.convertToTensor)(labels, 'labels', 'sigmoidCrossEntropyWithLogits');
    const $logits = (0, $5xBLk.convertToTensor)(logits, 'logits', 'sigmoidCrossEntropyWithLogits');
    (0, $8cCb2.assertShapesMatch)($labels.shape, $logits.shape, 'Error in sigmoidCrossEntropyWithLogits: ');
    /**
     * Implementation Details:
     *
     * For brevity, let `x = logits`, `z = labels`.  The logistic loss is
     *     z * -log(sigmoid(x)) + (1 - z) * -log(1 - sigmoid(x))
     *   = z * -log(1 / (1 + exp(-x))) + (1 - z) * -log(exp(-x) / (1 + exp(-x)))
     *   = z * log(1 + exp(-x)) + (1 - z) * (-log(exp(-x)) + log(1 + exp(-x)))
     *   = z * log(1 + exp(-x)) + (1 - z) * (x + log(1 + exp(-x))
     *   = (1 - z) * x + log(1 + exp(-x))
     *   = x - x * z + log(1 + exp(-x))
     *
     *   For x < 0, to avoid overflow in exp(-x), we reformulate the above
     *     x - x * z + log(1 + exp(-x))
     *   = log(exp(x)) - x * z + log(1 + exp(-x))
     *   = - x * z + log(1 + exp(x))
     *
     * Hence, to ensure stability and avoid overflow, the implementation uses
     * this equivalent formulation:
     *     max(x, 0) - x * z + log(1 + exp(-abs(x)))
     */ const maxOutput = (0, $8wbQq.relu)($logits);
    const outputXTarget = (0, $jZc0w.mul)($logits, $labels);
    const sigmoidOutput = (0, $5QUXI.log1p)((0, $2PcQK.exp)((0, $15cGp.neg)((0, $7j49I.abs)($logits))));
    return (0, $hgacW.add)((0, $7kouu.sub)(maxOutput, outputXTarget), sigmoidOutput);
}
/**
 * Computes the sigmoid cross entropy loss between two tensors.
 *
 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
 *
 *   newMulticlassLabels = multiclassLabels * (1 - labelSmoothing)
 *                         + 0.5 * labelSmoothing
 *
 * @param multiClassLabels The ground truth output tensor of shape
 * [batch_size, num_classes], same dimensions as 'predictions'.
 * @param logits The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param labelSmoothing If greater than 0, then smooth the labels.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' }
 */ function $57265e077d51af65$var$sigmoidCrossEntropy_(multiClassLabels, logits, weights, labelSmoothing = 0, reduction = (0, $i8gZm.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    let $multiClassLabels = (0, $5xBLk.convertToTensor)(multiClassLabels, 'multiClassLabels', 'sigmoidCrossEntropy');
    const $logits = (0, $5xBLk.convertToTensor)(logits, 'logits', 'sigmoidCrossEntropy');
    let $weights = null;
    if (weights != null) $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'sigmoidCrossEntropy');
    (0, $8cCb2.assertShapesMatch)($multiClassLabels.shape, $logits.shape, 'Error in sigmoidCrossEntropy: ');
    if (labelSmoothing > 0) {
        const labelSmoothingScalar = (0, $3xp7o.scalar)(labelSmoothing);
        const one = (0, $3xp7o.scalar)(1);
        const half = (0, $3xp7o.scalar)(0.5);
        $multiClassLabels = (0, $hgacW.add)((0, $jZc0w.mul)($multiClassLabels, (0, $7kouu.sub)(one, labelSmoothingScalar)), (0, $jZc0w.mul)(half, labelSmoothingScalar));
    }
    const losses = $57265e077d51af65$var$sigmoidCrossEntropyWithLogits_($multiClassLabels, $logits);
    return (0, $aQ3Nu.computeWeightedLoss)(losses, $weights, reduction);
}
const $57265e077d51af65$export$d099e04c73e0aede = /* @__PURE__ */ (0, $jqSCG.op)({
    sigmoidCrossEntropy_: $57265e077d51af65$var$sigmoidCrossEntropy_
});

});

parcelRegister("5FlUs", function(module, exports) {

$parcel$export(module.exports, "softmaxCrossEntropy", () => $01108b7743df9572$export$38869aa02829577);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $92fpA = parcelRequire("92fpA");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $hgacW = parcelRequire("hgacW");

var $kTunp = parcelRequire("kTunp");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $2PcQK = parcelRequire("2PcQK");

var $9dGIC = parcelRequire("9dGIC");

var $i8gZm = parcelRequire("i8gZm");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");

var $9NgTx = parcelRequire("9NgTx");

var $aQ3Nu = parcelRequire("aQ3Nu");
/**
 * Computes softmax cross entropy between logits and labels.
 *
 * Measures the probability error in discrete classification tasks in which
 * the classes are mutually exclusive (each entry is in exactly one class).
 * For example, each CIFAR-10 image is labeled with one and only one label: an
 * image can be a dog or a truck, but not both.
 *
 * `NOTE`: While the classes are mutually exclusive, their probabilities need
 * not be. All that is required is that each row of labels is a valid
 * probability distribution. If they are not, the computation of the gradient
 * will be incorrect.
 *
 * `WARNING`: This op expects unscaled logits, since it performs a softmax on
 * logits internally for efficiency. Do not call this op with the output of
 * softmax, as it will produce incorrect results.
 *
 * logits and labels must have the same shape, e.g. [batch_size, num_classes]
 * and the same dtype.
 * @param labels The labels array.
 * @param logits The logits array.
 * @param dim The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 */ function $01108b7743df9572$var$softmaxCrossEntropyWithLogits_(labels, logits, dim = -1) {
    if (dim === -1) dim = logits.rank - 1;
    if (dim !== logits.rank - 1) throw Error(`Softmax cross entropy along a non-last dimension is not yet ` + `supported. Labels / logits was rank ${logits.rank} ` + `and dim was ${dim}`);
    // Use a custom gradient for numerical stability.
    const customOp = (0, $92fpA.customGrad)((labels, logits, save)=>{
        // Reference:
        //   1. http://cs231n.github.io/linear-classify/#softmax
        //   2. https://blog.feedly.com/tricks-of-the-trade-logsumexp/
        const keepDims = true;
        const lse = (0, $9dGIC.logSumExp)(logits, [
            dim
        ], keepDims);
        const logResult = (0, $7kouu.sub)((0, $inFmq.cast)(logits, 'float32'), lse);
        save([
            labels,
            logResult
        ]);
        const costVector = (0, $15cGp.neg)((0, $jZc0w.mul)(logResult, labels));
        const value = (0, $9NgTx.sum)(costVector, [
            dim
        ]);
        const gradFunc = (dy, saved)=>{
            const [labels, logResult] = saved;
            const dyShape = (0, $kTunp.expandShapeToKeepDim)(dy.shape, [
                dim
            ]);
            return [
                (0, $jZc0w.mul)((0, $4sqA7.reshape)(dy, dyShape), (0, $7kouu.sub)((0, $inFmq.cast)(labels, 'float32'), (0, $2PcQK.exp)(logResult))),
                (0, $jZc0w.mul)((0, $4sqA7.reshape)(dy, dyShape), (0, $7kouu.sub)((0, $2PcQK.exp)(logResult), (0, $inFmq.cast)(labels, 'float32')))
            ];
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp(labels, logits);
}
/**
 * Computes the softmax cross entropy loss between two tensors.
 *
 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
 *
 *   newOnehotLabels = onehotLabels * (1 - labelSmoothing)
 *                         + labelSmoothing / numClasses
 *
 * @param onehotLabels One hot encoded labels
 *    [batch_size, num_classes], same dimensions as 'predictions'.
 * @param logits The predicted outputs.
 * @param weights Tensor whose rank is either 0, or 1, and must be
 *    broadcastable to `loss`  of shape [batch_size]
 * @param labelSmoothing If greater than 0, then smooth the labels.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' }
 */ function $01108b7743df9572$var$softmaxCrossEntropy_(onehotLabels, logits, weights, labelSmoothing = 0, reduction = (0, $i8gZm.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    let $onehotLabels = (0, $5xBLk.convertToTensor)(onehotLabels, 'onehotLabels', 'softmaxCrossEntropy');
    const $logits = (0, $5xBLk.convertToTensor)(logits, 'logits', 'softmaxCrossEntropy');
    let $weights = null;
    if (weights != null) $weights = (0, $5xBLk.convertToTensor)(weights, 'weights', 'softmaxCrossEntropy');
    (0, $8cCb2.assertShapesMatch)($onehotLabels.shape, $logits.shape, 'Error in softmaxCrossEntropy: ');
    if (labelSmoothing > 0) {
        const labelSmoothingScalar = (0, $3xp7o.scalar)(labelSmoothing);
        const one = (0, $3xp7o.scalar)(1);
        const numClasses = (0, $3xp7o.scalar)($onehotLabels.shape[1]);
        $onehotLabels = (0, $hgacW.add)((0, $jZc0w.mul)($onehotLabels, (0, $7kouu.sub)(one, labelSmoothingScalar)), (0, $1QPqB.div)(labelSmoothingScalar, numClasses));
    }
    const losses = $01108b7743df9572$var$softmaxCrossEntropyWithLogits_($onehotLabels, $logits);
    return (0, $aQ3Nu.computeWeightedLoss)(losses, $weights, reduction);
}
const $01108b7743df9572$export$38869aa02829577 = /* @__PURE__ */ (0, $jqSCG.op)({
    softmaxCrossEntropy_: $01108b7743df9572$var$softmaxCrossEntropy_
});

});

parcelRegister("gXzaa", function(module, exports) {

$parcel$export(module.exports, "sparseFillEmptyRows", () => $c58d6ea91d141f41$export$c82a1904a15b5028);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * The input SparseTensor is represented via the map of inputs {`indices`,
 * `values`, `denseShape`}. The output SparseTensor has the same `denseShape`
 * but with indices `outputIndices` and values `outputValues`. This op inserts a
 * single entry for every row that doesn't have any values. The index is created
 * as `[row, 0, ..., 0]` and the inserted value is `defaultValue`.
 *
 * For example, suppose `spInput` has shape [5, 6] and non-empty values:
 * [0, 1]: a
 * [0, 3]: b
 * [2, 0]: c
 * [3, 1]: d
 *
 * Rows 1 and 4 are empty, so the output will be of shape [5, 6] with values:
 * [0, 1]: a
 * [0, 3]: b
 * [1, 0]: `defaultValue`
 * [2, 0]: c
 * [3, 1]: d
 * [4, 0]: `defaultValue`
 *
 * The output SparseTensor will be in row-major order and will have the same
 * shape as the input.
 *
 * This op also returns an indicator vector shaped [dense_shape[0]] such that
 * emptyRowIndicator[i] = True iff row i was an empty row.
 *
 * And a reverse index map vector shaped [indices.shape[0]] that is used during
 * backpropagation, reverseIndexMap[i] = outi s.t. indices[i, j] ==
 * outputIndices[outi, j] for all j
 *
 * ```js
 * const result = tf.sparse.sparseFillEmptyRows(
 *   [[0, 0], [1, 0], [1, 3], [1, 4], [3, 2], [3, 3]],
 *   [0, 10, 13, 14, 32, 33], [5, 6], -1);
 * console.log(result);
 * result['outputIndices'].print(); // [[0, 0], [1, 0], [1, 3], [1, 4],
 *                                  //  [2, 0], [3, 2], [3, 3], [4, 0]]
 * result['outputValues'].print(); // [0, 10, 13, 14,-1, 32, 33, -1]
 * result['emptyRowIndicator'].print(); // [false, false, true, false, true]
 * result['reverseIndexMap'].print(); // [0, 1, 2, 3, 5, 6]
 * ```
 * @param indices: 2-D. The indices of the sparse tensor.
 * @param values: 1-D. The values of the sparse tensor.
 * @param denseShape: 1-D. The shape of the sparse tensor.
 * @param defaultValue: 0-D. Default value to insert into location [row, 0, ...,
 *     0] for rows missing from the input sparse tensor.
 * @return A map with the following properties:
 *     - outputIndices
 *     - outputValues: 1-D. The values of the filled sparse tensor.
 *     - emptyRowIndicator: 1-D. Whether the dense row was missing in the input
 * sparse tensor.
 *     - reverseIndexMap: 1-D. A map from the input indices to the output
 * indices.
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $c58d6ea91d141f41$var$sparseFillEmptyRows_(indices, values, denseShape, defaultValue) {
    const $indices = (0, $5xBLk.convertToTensor)(indices, 'indices', 'sparseFillEmptyRows', 'int32');
    const $values = (0, $5xBLk.convertToTensor)(values, 'values', 'sparseFillEmptyRows');
    const $denseShape = (0, $5xBLk.convertToTensor)(denseShape, 'denseShape', 'sparseFillEmptyRows', 'int32');
    const $defaultValue = (0, $5xBLk.convertToTensor)(defaultValue, 'defaultValue', 'sparseFillEmptyRows', $values.dtype);
    if ($indices.rank !== 2) throw new Error(`Indices should be Tensor2D but received shape
        ${$indices.shape}`);
    if ($values.rank !== 1) throw new Error(`Values should be Tensor1D but received shape ${$values.shape}`);
    if ($denseShape.rank !== 1) throw new Error(`Dense shape should be Tensor1D but received shape ${$denseShape.shape}`);
    if ($defaultValue.rank !== 0) throw new Error(`Default value should be a scalar but received shape ${$defaultValue.shape}`);
    const inputs = {
        indices: $indices,
        values: $values,
        denseShape: $denseShape,
        defaultValue: $defaultValue
    };
    const result = (0, $38WwN.ENGINE).runKernel((0, $hl418.SparseFillEmptyRows), inputs);
    return {
        outputIndices: result[0],
        outputValues: result[1],
        emptyRowIndicator: result[2],
        reverseIndexMap: result[3]
    };
}
const $c58d6ea91d141f41$export$c82a1904a15b5028 = /* @__PURE__ */ (0, $jqSCG.op)({
    sparseFillEmptyRows_: $c58d6ea91d141f41$var$sparseFillEmptyRows_
});

});

parcelRegister("fMgdQ", function(module, exports) {

$parcel$export(module.exports, "sparseReshape", () => $b7c7ec20f4bc8879$export$1408c45865e11fc6);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * This operation has the same semantics as reshape on the represented dense
 * tensor. The `inputIndices` are recomputed based on the requested `newShape`.
 * If one component of `newShape` is the special value -1, the size of that
 * dimension is computed so that the total dense size remains constant. At most
 * one component of `newShape` can be -1. The number of dense elements implied
 * by `newShape` must be the same as the number of dense elements originally
 * implied by `inputShape`. Reshaping does not affect the order of values in the
 * SparseTensor. If the input tensor has rank R_in and N non-empty values, and
 * `newShape` has length R_out, then `inputIndices` has shape [N, R_in],
 * `inputShape` has length R_in, `outputIndices` has shape [N, R_out], and
 * `outputShape` has length R_out.
 *
 * ```js
 * const result = tf.sparse.sparseReshape(
 *   [[0, 0, 0], [0, 0, 1], [0, 1, 0], [1, 0, 0], [1, 2, 3]],
 *   [2, 3, 6], [9, -1]);
 * console.log(result);
 * result['outputIndices'].print(); //[[0, 0], [0, 1], [1, 2], [4, 2], [8, 1]]
 * result['outputShape'].print(); // [9, 4]
 * ```
 * @param inputIndices: 2-D. N x R_in matrix with the indices of non-empty
 * values in a SparseTensor.
 * @param inputShape: 1-D. R_in Tensor1D with the input SparseTensor's dense
 * shape.
 * @param newShape: 1-D. R_out Tensor1D with the requested new dense shape.
 * @return A map with the following properties:
 *     - outputIndices: 2-D. N x R_out matrix with the updated indices of
 *       non-empty values in the output SparseTensor.
 *     - outputShape: 1-D. R_out vector with the full dense shape of the output
 *       SparseTensor. This is the same as newShape but with any -1 dimensions
 *        filled in.
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $b7c7ec20f4bc8879$var$sparseReshape_(inputIndices, inputShape, newShape) {
    const $inputIndices = (0, $5xBLk.convertToTensor)(inputIndices, 'inputIndices', 'sparseReshape', 'int32');
    const $inputShape = (0, $5xBLk.convertToTensor)(inputShape, 'inputShape', 'sparseReshape', 'int32');
    const $newShape = (0, $5xBLk.convertToTensor)(newShape, 'newShape', 'sparseReshape', 'int32');
    if ($inputIndices.rank !== 2) throw new Error(`Input indices should be Tensor2D but received shape
        ${$inputIndices.shape}`);
    if ($inputShape.rank !== 1) throw new Error(`Input shape should be Tensor1D but received shape ${$inputShape.shape}`);
    if ($newShape.rank !== 1) throw new Error(`New shape should be Tensor1D but received shape ${$newShape.shape}`);
    const inputs = {
        inputIndices: $inputIndices,
        inputShape: $inputShape,
        newShape: $newShape
    };
    const result = (0, $38WwN.ENGINE).runKernel((0, $hl418.SparseReshape), inputs);
    return {
        outputIndices: result[0],
        outputShape: result[1]
    };
}
const $b7c7ec20f4bc8879$export$1408c45865e11fc6 = /* @__PURE__ */ (0, $jqSCG.op)({
    sparseReshape_: $b7c7ec20f4bc8879$var$sparseReshape_
});

});

parcelRegister("22SmX", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentMean", () => $17d5f1474b4a6bff$export$dbc0c9096869d04e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the mean along sparse segments of a tensor.
 *
 * ```js
 * const c = tf.tensor2d([[1,2,3,4], [-1,-2,-3,-4], [6,7,8,9]]);
 * // Select two rows, one segment.
 * const result1 = tf.sparse.sparseSegmentMean(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 0], 'int32'));
 * result1.print(); // [[0, 0, 0, 0]]
 *
 * // Select two rows, two segments.
 * const result2 = tf.sparse.sparseSegmentMean(c,
 *                                             tf.tensor1d([0, 1], 'int32'),
 *                                             tf.tensor1d([0, 1], 'int32'));
 * result2.print(); // [[1, 2, 3, 4], [-1, -2, -3, -4]]
 *
 * // Select all rows, two segments.
 * const result3 = tf.sparse.sparseSegmentMean(c,
 *                                             tf.tensor1d([0, 1, 2], 'int32'),
 *                                             tf.tensor1d([0, 1, 1], 'int32'));
 * result3.print(); // [[1.0, 2.0, 3.0, 4.0], [2.5, 2.5, 2.5, 2.5]]
 * ```
 * @param data: A Tensor of at least one dimension with data that will be
 *     assembled in the output.
 * @param indices: A 1-D Tensor with indices into data. Has same rank as
 *     segmentIds.
 * @param segmentIds: A 1-D Tensor with indices into the output Tensor. Values
 *     should be sorted and can be repeated.
 * @return Has same shape as data, except for dimension 0 which has equal to
 *         the number of segments.
 *
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $17d5f1474b4a6bff$var$sparseSegmentMean_(data, indices, segmentIds) {
    const $data = (0, $5xBLk.convertToTensor)(data, 'data', 'sparseSegmentMean');
    const $indices = (0, $5xBLk.convertToTensor)(indices, 'indices', 'sparseSegmentMean', 'int32');
    const $segmentIds = (0, $5xBLk.convertToTensor)(segmentIds, 'segmentIds', 'sparseSegmentMean', 'int32');
    if ($data.rank < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if ($indices.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
          ${$indices.shape}`);
    if ($segmentIds.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
          ${$segmentIds.shape}`);
    const inputs = {
        data: $data,
        indices: $indices,
        segmentIds: $segmentIds
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.SparseSegmentMean), inputs);
}
const $17d5f1474b4a6bff$export$dbc0c9096869d04e = /* @__PURE__ */ (0, $jqSCG.op)({
    sparseSegmentMean_: $17d5f1474b4a6bff$var$sparseSegmentMean_
});

});

parcelRegister("6wGr9", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentSum", () => $4c06a6535631585e$export$2255ce53fc777865);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the sum along sparse segments of a tensor.
 *
 * ```js
 * const c = tf.tensor2d([[1,2,3,4], [-1,-2,-3,-4], [5,6,7,8]]);
 * // Select two rows, one segment.
 * const result1 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 0], 'int32'));
 * result1.print(); // [[0, 0, 0, 0]]
 *
 * // Select two rows, two segments.
 * const result2 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 1], 'int32'));
 * result2.print(); // [[1, 2, 3, 4], [-1, -2, -3, -4]]
 *
 * // Select all rows, two segments.
 * const result3 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1, 2], 'int32'),
 *                                           tf.tensor1d([0, 0, 1], 'int32'));
 * result3.print(); // [[0, 0, 0, 0], [5, 6, 7, 8]]
 * ```
 * @param data: A Tensor of at least one dimension with data that will be
 *     assembled in the output.
 * @param indices: A 1-D Tensor with indices into data. Has same rank as
 *     segmentIds.
 * @param segmentIds: A 1-D Tensor with indices into the output Tensor. Values
 *     should be sorted and can be repeated.
 * @return Has same shape as data, except for dimension 0 which has equal to
 *         the number of segments.
 *
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $4c06a6535631585e$var$sparseSegmentSum_(data, indices, segmentIds) {
    const $data = (0, $5xBLk.convertToTensor)(data, 'data', 'sparseSegmentSum');
    const $indices = (0, $5xBLk.convertToTensor)(indices, 'indices', 'sparseSegmentSum', 'int32');
    const $segmentIds = (0, $5xBLk.convertToTensor)(segmentIds, 'segmentIds', 'sparseSegmentSum', 'int32');
    if ($data.rank < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if ($indices.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
         ${$indices.shape}`);
    if ($segmentIds.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
         ${$segmentIds.shape}`);
    const inputs = {
        data: $data,
        indices: $indices,
        segmentIds: $segmentIds
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.SparseSegmentSum), inputs);
}
const $4c06a6535631585e$export$2255ce53fc777865 = /* @__PURE__ */ (0, $jqSCG.op)({
    sparseSegmentSum_: $4c06a6535631585e$var$sparseSegmentSum_
});

});

parcelRegister("brFzl", function(module, exports) {

$parcel$export(module.exports, "stringNGrams", () => $855276121844dfd0$export$3490514dcc63b044);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Creates ngrams from ragged string data.
 *
 * This op accepts a ragged tensor with 1 ragged dimension containing only
 * strings and outputs a ragged tensor with 1 ragged dimension containing ngrams
 * of that string, joined along the innermost axis.
 *
 * ```js
 * const result = tf.string.stringNGrams(
 *   ['a', 'b', 'c', 'd'], tf.tensor1d([0, 2, 4], 'int32'),
 *   '|', [1, 2], 'LP', 'RP', -1, false);
 * result['nGrams'].print(); // ['a', 'b', 'LP|a', 'a|b', 'b|RP',
 *                           //  'c', 'd', 'LP|c', 'c|d', 'd|RP']
 * result['nGramsSplits'].print(); // [0, 5, 10]
 * ```
 * @param data: The values tensor of the ragged string tensor to make ngrams out
 *     of. Must be a 1D string tensor.
 * @param dataSplits: The splits tensor of the ragged string tensor to make
 *     ngrams out of.
 * @param separator: The string to append between elements of the token. Use ""
 *     for no separator.
 * @param nGramWidths: The sizes of the ngrams to create.
 * @param leftPad: The string to use to pad the left side of the ngram sequence.
 *     Only used if pad_width !== 0.
 * @param rightPad: The string to use to pad the right side of the ngram
 *     sequence. Only used if pad_width !== 0.
 * @param padWidth: The number of padding elements to add to each side of each
 *     sequence. Note that padding will never be greater than `nGramWidths`-1
 *     regardless of this value. If `padWidth`=-1, then add max(`nGramWidths`)-1
 *     elements.
 * @param preserveShortSequences: If true, then ensure that at least one ngram
 *     is generated for each input sequence. In particular, if an input sequence
 *     is shorter than min(ngramWidth) + 2*padWidth, then generate a single
 *     ngram containing the entire sequence. If false, then no ngrams are
 *     generated for these short input sequences.
 * @return A map with the following properties:
 *     - nGrams: The values tensor of the output ngrams ragged tensor.
 *     - nGramsSplits: The splits tensor of the output ngrams ragged tensor.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $855276121844dfd0$var$stringNGrams_(data, dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences) {
    const $data = (0, $5xBLk.convertToTensor)(data, 'data', 'stringNGrams', 'string');
    if ($data.dtype !== 'string') throw new Error('Data must be of datatype string');
    if ($data.shape.length !== 1) throw new Error(`Data must be a vector, saw: ${$data.shape}`);
    const $dataSplits = (0, $5xBLk.convertToTensor)(dataSplits, 'dataSplits', 'stringNGrams');
    if ($dataSplits.dtype !== 'int32') throw new Error('Data splits must be of datatype int32');
    const attrs = {
        separator: separator,
        nGramWidths: nGramWidths,
        leftPad: leftPad,
        rightPad: rightPad,
        padWidth: padWidth,
        preserveShortSequences: preserveShortSequences
    };
    const inputs = {
        data: $data,
        dataSplits: $dataSplits
    };
    const result = (0, $38WwN.ENGINE).runKernel((0, $hl418.StringNGrams), inputs, attrs);
    return {
        nGrams: result[0],
        nGramsSplits: result[1]
    };
}
const $855276121844dfd0$export$3490514dcc63b044 = /* @__PURE__ */ (0, $jqSCG.op)({
    stringNGrams_: $855276121844dfd0$var$stringNGrams_
});

});

parcelRegister("VUiwf", function(module, exports) {

$parcel$export(module.exports, "stringSplit", () => $0ae0fe890110e667$export$aa7f8babb17e7672);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Split elements of `input` based on `delimiter` into a SparseTensor .
 *
 * Let N be the size of source (typically N will be the batch size). Split each
 * element of `input` based on `delimiter` and return a SparseTensor containing
 * the splitted tokens. Empty tokens are ignored if `skipEmpty` is set to True.
 *
 * `delimiter` can be empty, or a string of split characters. If `delimiter` is
 * an empty string, each element of `input` is split into individual
 * character strings. Otherwise every character of `delimiter` is a potential
 * split point.
 *
 * ```js
 * const result = tf.string.stringSplit(['hello world',  'a b c'], ' ');
 * result['indices'].print(); // [[0, 0], [0, 1], [1, 0], [1, 1], [1, 2]]
 * result['values'].print(); // ['hello', 'world', 'a', 'b', 'c']
 * result['shape'].print(); // [2, 3]
 * ```
 * @param input: 1-D. Strings to split.
 * @param delimiter: 0-D. Delimiter characters, or empty string.
 * @param skipEmpty: Optional. If true, skip the empty strings from the result.
 *     Defaults to true.
 * @return A map with the following properties:
 *     - indices: A dense matrix of int32 representing the indices of the sparse
 *       tensor.
 *     - values: A vector of strings corresponding to the splited values.
 *     - shape: a length-2 vector of int32 representing the shape of the sparse
 * tensor, where the first value is N and the second value is the maximum number
 * of tokens in a single input entry.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $0ae0fe890110e667$var$stringSplit_(input, delimiter, skipEmpty = true) {
    const $input = (0, $5xBLk.convertToTensor)(input, 'input', 'stringSplit', 'string');
    const $delimiter = (0, $5xBLk.convertToTensor)(delimiter, 'delimiter', 'stringSplit', 'string');
    if ($input.rank !== 1) throw new Error(`Input should be Tensor1D but received shape ${$input.shape}`);
    if ($delimiter.rank !== 0) throw new Error(`Delimiter should be a scalar but received shape ${$delimiter.shape}`);
    const attrs = {
        skipEmpty: skipEmpty
    };
    const inputs = {
        input: $input,
        delimiter: $delimiter
    };
    const result = (0, $38WwN.ENGINE).runKernel((0, $hl418.StringSplit), inputs, attrs);
    return {
        indices: result[0],
        values: result[1],
        shape: result[2]
    };
}
const $0ae0fe890110e667$export$aa7f8babb17e7672 = /* @__PURE__ */ (0, $jqSCG.op)({
    stringSplit_: $0ae0fe890110e667$var$stringSplit_
});

});

parcelRegister("g7F6x", function(module, exports) {

$parcel$export(module.exports, "stringToHashBucketFast", () => $bbcd2f4086631904$export$6195616d6fd0c848);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Converts each string in the input Tensor to its hash mod by a number of
 * buckets.
 *
 * The hash function is deterministic on the content of the string within the
 * process and will never change. However, it is not suitable for cryptography.
 * This function may be used when CPU time is scarce and inputs are trusted or
 * unimportant. There is a risk of adversaries constructing inputs that all hash
 * to the same bucket.
 *
 * ```js
 * const result = tf.string.stringToHashBucketFast(
 *   ['Hello', 'TensorFlow', '2.x'], 3);
 * result.print(); // [0, 2, 2]
 * ```
 * @param input: The strings to assign a hash bucket.
 * @param numBuckets: The number of buckets.
 * @return A Tensor of the same shape as the input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $bbcd2f4086631904$var$stringToHashBucketFast_(input, numBuckets) {
    const $input = (0, $5xBLk.convertToTensor)(input, 'input', 'stringToHashBucketFast', 'string');
    const attrs = {
        numBuckets: numBuckets
    };
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const inputs = {
        input: $input
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.StringToHashBucketFast), inputs, attrs);
}
const $bbcd2f4086631904$export$6195616d6fd0c848 = /* @__PURE__ */ (0, $jqSCG.op)({
    stringToHashBucketFast_: $bbcd2f4086631904$var$stringToHashBucketFast_
});

});

parcelRegister("bZL8f", function(module, exports) {

$parcel$export(module.exports, "staticRegexReplace", () => $8bb9f3a220558625$export$2bdfdc7ae087914d);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Replace the match of a `pattern` in `input` with `rewrite`.
 *
 * ```js
 * const result = tf.string.staticRegexReplace(
 *     ['format       this   spacing      better'], ' +', ' ');
 * result.print(); // ['format this spacing better']
 * ```
 * @param input: A Tensor of type string. The text to be processed.
 * @param pattern: A string. The regular expression to match the input.
 * @param rewrite: A string. The rewrite to be applied to the matched
 *     expression.
 * @param replaceGlobal: An optional bool. Defaults to True. If True, the
 *     replacement is global, otherwise the replacement is done only on the
 *     first match.
 * @return A Tensor of type string.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $8bb9f3a220558625$var$staticRegexReplace_(input, pattern, rewrite, replaceGlobal = true) {
    const $input = (0, $5xBLk.convertToTensor)(input, 'input', 'staticRegexReplace', 'string');
    const attrs = {
        pattern: pattern,
        rewrite: rewrite,
        replaceGlobal: replaceGlobal
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.StaticRegexReplace), {
        x: $input
    }, attrs);
}
const $8bb9f3a220558625$export$2bdfdc7ae087914d = /* @__PURE__ */ (0, $jqSCG.op)({
    staticRegexReplace_: $8bb9f3a220558625$var$staticRegexReplace_
});

});


parcelRegister("9ELKf", function(module, exports) {

$parcel$export(module.exports, "copyModel", () => (parcelRequire("1PMKz")).copyModel);
$parcel$export(module.exports, "listModels", () => (parcelRequire("1PMKz")).listModels);
$parcel$export(module.exports, "moveModel", () => (parcelRequire("1PMKz")).moveModel);
$parcel$export(module.exports, "removeModel", () => (parcelRequire("1PMKz")).removeModel);
$parcel$export(module.exports, "browserFiles", () => (parcelRequire("GOEuS")).browserFiles);
$parcel$export(module.exports, "browserHTTPRequest", () => (parcelRequire("jbPC7")).browserHTTPRequest);
$parcel$export(module.exports, "CompositeArrayBuffer", () => (parcelRequire("hBb8J")).CompositeArrayBuffer);
$parcel$export(module.exports, "concatenateArrayBuffers", () => (parcelRequire("4FRLN")).concatenateArrayBuffers);
$parcel$export(module.exports, "decodeWeights", () => (parcelRequire("4FRLN")).decodeWeights);
$parcel$export(module.exports, "decodeWeightsStream", () => (parcelRequire("4FRLN")).decodeWeightsStream);
$parcel$export(module.exports, "encodeWeights", () => (parcelRequire("4FRLN")).encodeWeights);
$parcel$export(module.exports, "fromMemory", () => (parcelRequire("hfd1o")).fromMemory);
$parcel$export(module.exports, "fromMemorySync", () => (parcelRequire("hfd1o")).fromMemorySync);
$parcel$export(module.exports, "getLoadHandlers", () => (parcelRequire("9RUNn")).getLoadHandlers);
$parcel$export(module.exports, "getModelArtifactsForJSON", () => (parcelRequire("4FRLN")).getModelArtifactsForJSON);
$parcel$export(module.exports, "getModelArtifactsForJSONSync", () => (parcelRequire("4FRLN")).getModelArtifactsForJSONSync);
$parcel$export(module.exports, "getModelArtifactsInfoForJSON", () => (parcelRequire("4FRLN")).getModelArtifactsInfoForJSON);
$parcel$export(module.exports, "getSaveHandlers", () => (parcelRequire("9RUNn")).getSaveHandlers);
$parcel$export(module.exports, "getWeightSpecs", () => (parcelRequire("4FRLN")).getWeightSpecs);
$parcel$export(module.exports, "http", () => (parcelRequire("jbPC7")).http);
$parcel$export(module.exports, "isHTTPScheme", () => (parcelRequire("jbPC7")).isHTTPScheme);
$parcel$export(module.exports, "loadWeights", () => (parcelRequire("wfkqW")).loadWeights);
$parcel$export(module.exports, "registerLoadRouter", () => (parcelRequire("9RUNn")).registerLoadRouter);
$parcel$export(module.exports, "registerSaveRouter", () => (parcelRequire("9RUNn")).registerSaveRouter);
$parcel$export(module.exports, "weightsLoaderFactory", () => (parcelRequire("wfkqW")).weightsLoaderFactory);
$parcel$export(module.exports, "withSaveHandler", () => (parcelRequire("hfd1o")).withSaveHandler);
$parcel$export(module.exports, "withSaveHandlerSync", () => (parcelRequire("hfd1o")).withSaveHandlerSync);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Importing local_storage and indexed_db is necessary for the routers to be
// registered.
parcelRequire("caMdQ");
parcelRequire("h6KCl");

var $GOEuS = parcelRequire("GOEuS");

var $jbPC7 = parcelRequire("jbPC7");

var $4FRLN = parcelRequire("4FRLN");

var $hfd1o = parcelRequire("hfd1o");

var $9RUNn = parcelRequire("9RUNn");

var $wfkqW = parcelRequire("wfkqW");

var $hBb8J = parcelRequire("hBb8J");

var $1PMKz = parcelRequire("1PMKz");

});
parcelRegister("GOEuS", function(module, exports) {

$parcel$export(module.exports, "browserFiles", () => $080b36d35603200b$export$6729643cf069471c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * IOHandlers related to files, such as browser-triggered file downloads,
 * user-selected files in browser.
 */ parcelRequire("dcHSK");

var $ibsdL = parcelRequire("ibsdL");

var $4FRLN = parcelRequire("4FRLN");

var $9RUNn = parcelRequire("9RUNn");

var $hBb8J = parcelRequire("hBb8J");
const $080b36d35603200b$var$DEFAULT_FILE_NAME_PREFIX = 'model';
const $080b36d35603200b$var$DEFAULT_JSON_EXTENSION_NAME = '.json';
const $080b36d35603200b$var$DEFAULT_WEIGHT_DATA_EXTENSION_NAME = '.weights.bin';
function $080b36d35603200b$var$defer(f) {
    return new Promise((resolve)=>setTimeout(resolve)).then(f);
}
class $080b36d35603200b$export$cc3c076530f2848f {
    constructor(fileNamePrefix){
        if (!(0, $ibsdL.env)().getBool('IS_BROWSER')) // TODO(cais): Provide info on what IOHandlers are available under the
        //   current environment.
        throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
        if (fileNamePrefix.startsWith($080b36d35603200b$export$cc3c076530f2848f.URL_SCHEME)) fileNamePrefix = fileNamePrefix.slice($080b36d35603200b$export$cc3c076530f2848f.URL_SCHEME.length);
        if (fileNamePrefix == null || fileNamePrefix.length === 0) fileNamePrefix = $080b36d35603200b$var$DEFAULT_FILE_NAME_PREFIX;
        this.modelJsonFileName = fileNamePrefix + $080b36d35603200b$var$DEFAULT_JSON_EXTENSION_NAME;
        this.weightDataFileName = fileNamePrefix + $080b36d35603200b$var$DEFAULT_WEIGHT_DATA_EXTENSION_NAME;
    }
    async save(modelArtifacts) {
        if (typeof document === 'undefined') throw new Error("Browser downloads are not supported in this environment since `document` is not present");
        // TODO(mattsoulanille): Support saving models over 2GB that exceed
        // Chrome's ArrayBuffer size limit.
        const weightBuffer = (0, $hBb8J.CompositeArrayBuffer).join(modelArtifacts.weightData);
        const weightsURL = window.URL.createObjectURL(new Blob([
            weightBuffer
        ], {
            type: 'application/octet-stream'
        }));
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");
        else {
            const weightsManifest = [
                {
                    paths: [
                        './' + this.weightDataFileName
                    ],
                    weights: modelArtifacts.weightSpecs
                }
            ];
            const modelJSON = (0, $4FRLN.getModelJSONForModelArtifacts)(modelArtifacts, weightsManifest);
            const modelJsonURL = window.URL.createObjectURL(new Blob([
                JSON.stringify(modelJSON)
            ], {
                type: 'application/json'
            }));
            // If anchor elements are not provided, create them without attaching them
            // to parents, so that the downloaded file names can be controlled.
            const jsonAnchor = this.modelJsonAnchor == null ? document.createElement('a') : this.modelJsonAnchor;
            jsonAnchor.download = this.modelJsonFileName;
            jsonAnchor.href = modelJsonURL;
            // Trigger downloads by evoking a click event on the download anchors.
            // When multiple downloads are started synchronously, Firefox will only
            // save the last one.
            await $080b36d35603200b$var$defer(()=>jsonAnchor.dispatchEvent(new MouseEvent('click')));
            if (modelArtifacts.weightData != null) {
                const weightDataAnchor = this.weightDataAnchor == null ? document.createElement('a') : this.weightDataAnchor;
                weightDataAnchor.download = this.weightDataFileName;
                weightDataAnchor.href = weightsURL;
                await $080b36d35603200b$var$defer(()=>weightDataAnchor.dispatchEvent(new MouseEvent('click')));
            }
            return {
                modelArtifactsInfo: (0, $4FRLN.getModelArtifactsInfoForJSON)(modelArtifacts)
            };
        }
    }
}
$080b36d35603200b$export$cc3c076530f2848f.URL_SCHEME = 'downloads://';
class $080b36d35603200b$var$BrowserFiles {
    constructor(files){
        if (files == null || files.length < 1) throw new Error(`When calling browserFiles, at least 1 file is required, ` + `but received ${files}`);
        this.jsonFile = files[0];
        this.weightsFiles = files.slice(1);
    }
    async load() {
        return new Promise((resolve, reject)=>{
            const jsonReader = new FileReader();
            jsonReader.onload = (event)=>{
                // tslint:disable-next-line:no-any
                const modelJSON = JSON.parse(event.target.result);
                const modelTopology = modelJSON.modelTopology;
                if (modelTopology == null) {
                    reject(new Error(`modelTopology field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                const weightsManifest = modelJSON.weightsManifest;
                if (weightsManifest == null) {
                    reject(new Error(`weightManifest field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                if (this.weightsFiles.length === 0) {
                    resolve({
                        modelTopology: modelTopology
                    });
                    return;
                }
                const modelArtifactsPromise = (0, $4FRLN.getModelArtifactsForJSON)(modelJSON, (weightsManifest)=>this.loadWeights(weightsManifest));
                resolve(modelArtifactsPromise);
            };
            jsonReader.onerror = (error)=>reject(`Failed to read model topology and weights manifest JSON ` + `from file '${this.jsonFile.name}'. BrowserFiles supports loading ` + `Keras-style tf.Model artifacts only.`);
            jsonReader.readAsText(this.jsonFile);
        });
    }
    loadWeights(weightsManifest) {
        const weightSpecs = [];
        const paths = [];
        for (const entry of weightsManifest){
            weightSpecs.push(...entry.weights);
            paths.push(...entry.paths);
        }
        const pathToFile = this.checkManifestAndWeightFiles(weightsManifest);
        const promises = paths.map((path)=>this.loadWeightsFile(path, pathToFile[path]));
        return Promise.all(promises).then((buffers)=>[
                weightSpecs,
                buffers
            ]);
    }
    loadWeightsFile(path, file) {
        return new Promise((resolve, reject)=>{
            const weightFileReader = new FileReader();
            weightFileReader.onload = (event)=>{
                // tslint:disable-next-line:no-any
                const weightData = event.target.result;
                resolve(weightData);
            };
            weightFileReader.onerror = (error)=>reject(`Failed to weights data from file of path '${path}'.`);
            weightFileReader.readAsArrayBuffer(file);
        });
    }
    /**
     * Check the compatibility between weights manifest and weight files.
     */ checkManifestAndWeightFiles(manifest) {
        const basenames = [];
        const fileNames = this.weightsFiles.map((file)=>(0, $4FRLN.basename)(file.name));
        const pathToFile = {};
        for (const group of manifest)group.paths.forEach((path)=>{
            const pathBasename = (0, $4FRLN.basename)(path);
            if (basenames.indexOf(pathBasename) !== -1) throw new Error(`Duplicate file basename found in weights manifest: ` + `'${pathBasename}'`);
            basenames.push(pathBasename);
            if (fileNames.indexOf(pathBasename) === -1) throw new Error(`Weight file with basename '${pathBasename}' is not provided.`);
            else pathToFile[path] = this.weightsFiles[fileNames.indexOf(pathBasename)];
        });
        if (basenames.length !== this.weightsFiles.length) throw new Error(`Mismatch in the number of files in weights manifest ` + `(${basenames.length}) and the number of weight files provided ` + `(${this.weightsFiles.length}).`);
        return pathToFile;
    }
}
const $080b36d35603200b$export$6149c5f14395749b = (url)=>{
    if (!(0, $ibsdL.env)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($080b36d35603200b$export$cc3c076530f2848f.URL_SCHEME)) return $080b36d35603200b$export$8fbc9551c735f788(url.slice($080b36d35603200b$export$cc3c076530f2848f.URL_SCHEME.length));
        else return null;
    }
};
(0, $9RUNn.IORouterRegistry).registerSaveRouter($080b36d35603200b$export$6149c5f14395749b);
function $080b36d35603200b$export$8fbc9551c735f788(fileNamePrefix = 'model') {
    return new $080b36d35603200b$export$cc3c076530f2848f(fileNamePrefix);
}
function $080b36d35603200b$export$6729643cf069471c(files) {
    return new $080b36d35603200b$var$BrowserFiles(files);
}

});

parcelRegister("jbPC7", function(module, exports) {

$parcel$export(module.exports, "isHTTPScheme", () => $df8714d527b2cee6$export$18a721ae4733601b);
$parcel$export(module.exports, "http", () => $df8714d527b2cee6$export$7d6f1c8842f9f527);
$parcel$export(module.exports, "browserHTTPRequest", () => $df8714d527b2cee6$export$624ff5bc4e3a9d72);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * IOHandler implementations based on HTTP requests in the web browser.
 *
 * Uses [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
 */ 
var $ibsdL = parcelRequire("ibsdL");

var $8cCb2 = parcelRequire("8cCb2");

var $4FRLN = parcelRequire("4FRLN");

var $hBb8J = parcelRequire("hBb8J");

var $9RUNn = parcelRequire("9RUNn");

var $wfkqW = parcelRequire("wfkqW");
const $df8714d527b2cee6$var$OCTET_STREAM_MIME_TYPE = 'application/octet-stream';
const $df8714d527b2cee6$var$JSON_TYPE = 'application/json';
class $df8714d527b2cee6$export$3df08bb5d0f8b499 {
    constructor(path, loadOptions){
        this.DEFAULT_METHOD = 'POST';
        if (loadOptions == null) loadOptions = {};
        this.weightPathPrefix = loadOptions.weightPathPrefix;
        this.weightUrlConverter = loadOptions.weightUrlConverter;
        if (loadOptions.fetchFunc != null) {
            (0, $8cCb2.assert)(typeof loadOptions.fetchFunc === 'function', ()=>"Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)");
            this.fetch = loadOptions.fetchFunc;
        } else this.fetch = (0, $ibsdL.env)().platform.fetch;
        (0, $8cCb2.assert)(path != null && path.length > 0, ()=>"URL path for http must not be null, undefined or empty.");
        if (Array.isArray(path)) (0, $8cCb2.assert)(path.length === 2, ()=>'URL paths for http must have a length of 2, ' + `(actual length is ${path.length}).`);
        this.path = path;
        if (loadOptions.requestInit != null && loadOptions.requestInit.body != null) throw new Error('requestInit is expected to have no pre-existing body, but has one.');
        this.requestInit = loadOptions.requestInit || {};
        this.loadOptions = loadOptions;
    }
    async save(modelArtifacts) {
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
        const init = Object.assign({
            method: this.DEFAULT_METHOD
        }, this.requestInit);
        init.body = new FormData();
        const weightsManifest = [
            {
                paths: [
                    './model.weights.bin'
                ],
                weights: modelArtifacts.weightSpecs
            }
        ];
        const modelTopologyAndWeightManifest = (0, $4FRLN.getModelJSONForModelArtifacts)(modelArtifacts, weightsManifest);
        init.body.append('model.json', new Blob([
            JSON.stringify(modelTopologyAndWeightManifest)
        ], {
            type: $df8714d527b2cee6$var$JSON_TYPE
        }), 'model.json');
        if (modelArtifacts.weightData != null) {
            // TODO(mattsoulanille): Support saving models over 2GB that exceed
            // Chrome's ArrayBuffer size limit.
            const weightBuffer = (0, $hBb8J.CompositeArrayBuffer).join(modelArtifacts.weightData);
            init.body.append('model.weights.bin', new Blob([
                weightBuffer
            ], {
                type: $df8714d527b2cee6$var$OCTET_STREAM_MIME_TYPE
            }), 'model.weights.bin');
        }
        const response = await this.fetch(this.path, init);
        if (response.ok) return {
            modelArtifactsInfo: (0, $4FRLN.getModelArtifactsInfoForJSON)(modelArtifacts),
            responses: [
                response
            ]
        };
        else throw new Error(`BrowserHTTPRequest.save() failed due to HTTP response status ` + `${response.status}.`);
    }
    async loadModelJSON() {
        const modelConfigRequest = await this.fetch(this.path, this.requestInit);
        if (!modelConfigRequest.ok) throw new Error(`Request to ${this.path} failed with status code ` + `${modelConfigRequest.status}. Please verify this URL points to ` + `the model JSON of the model to load.`);
        let modelJSON;
        try {
            modelJSON = await modelConfigRequest.json();
        } catch (e) {
            let message = `Failed to parse model JSON of response from ${this.path}.`;
            // TODO(nsthorat): Remove this after some time when we're comfortable that
            // .pb files are mostly gone.
            if (this.path.endsWith('.pb')) message += " Your path contains a .pb file extension. Support for .pb models have been removed in TensorFlow.js 1.0 in favor of .json models. You can re-convert your Python TensorFlow model using the TensorFlow.js 1.0 conversion scripts or you can convert your.pb models with the 'pb2json'NPM script in the tensorflow/tfjs-converter repository.";
            else message += " Please make sure the server is serving valid JSON for this request.";
            throw new Error(message);
        }
        // We do not allow both modelTopology and weightsManifest to be missing.
        const modelTopology = modelJSON.modelTopology;
        const weightsManifest = modelJSON.weightsManifest;
        if (modelTopology == null && weightsManifest == null) throw new Error(`The JSON from HTTP path ${this.path} contains neither model ` + `topology or manifest for weights.`);
        return modelJSON;
    }
    /**
     * Load model artifacts via HTTP request(s).
     *
     * See the documentation to `tf.io.http` for details on the saved
     * artifacts.
     *
     * @returns The loaded model artifacts (if loading succeeds).
     */ async load() {
        if (this.loadOptions.streamWeights) return this.loadStream();
        const modelJSON = await this.loadModelJSON();
        return (0, $4FRLN.getModelArtifactsForJSON)(modelJSON, (weightsManifest)=>this.loadWeights(weightsManifest));
    }
    async loadStream() {
        const modelJSON = await this.loadModelJSON();
        const fetchURLs = await this.getWeightUrls(modelJSON.weightsManifest);
        const weightSpecs = (0, $4FRLN.getWeightSpecs)(modelJSON.weightsManifest);
        const stream = ()=>(0, $wfkqW.streamWeights)(fetchURLs, this.loadOptions);
        return Object.assign(Object.assign({}, modelJSON), {
            weightSpecs: weightSpecs,
            getWeightStream: stream
        });
    }
    async getWeightUrls(weightsManifest) {
        const weightPath = Array.isArray(this.path) ? this.path[1] : this.path;
        const [prefix, suffix] = $df8714d527b2cee6$export$7a5253c0f62e0150(weightPath);
        const pathPrefix = this.weightPathPrefix || prefix;
        const fetchURLs = [];
        const urlPromises = [];
        for (const weightsGroup of weightsManifest){
            for (const path of weightsGroup.paths)if (this.weightUrlConverter != null) urlPromises.push(this.weightUrlConverter(path));
            else fetchURLs.push(pathPrefix + path + suffix);
        }
        if (this.weightUrlConverter) fetchURLs.push(...await Promise.all(urlPromises));
        return fetchURLs;
    }
    async loadWeights(weightsManifest) {
        const fetchURLs = await this.getWeightUrls(weightsManifest);
        const weightSpecs = (0, $4FRLN.getWeightSpecs)(weightsManifest);
        const buffers = await (0, $wfkqW.loadWeightsAsArrayBuffer)(fetchURLs, this.loadOptions);
        return [
            weightSpecs,
            buffers
        ];
    }
}
$df8714d527b2cee6$export$3df08bb5d0f8b499.URL_SCHEME_REGEX = /^https?:\/\//;
function $df8714d527b2cee6$export$7a5253c0f62e0150(url) {
    const lastSlash = url.lastIndexOf('/');
    const lastSearchParam = url.lastIndexOf('?');
    const prefix = url.substring(0, lastSlash);
    const suffix = lastSearchParam > lastSlash ? url.substring(lastSearchParam) : '';
    return [
        prefix + '/',
        suffix
    ];
}
function $df8714d527b2cee6$export$18a721ae4733601b(url) {
    return url.match($df8714d527b2cee6$export$3df08bb5d0f8b499.URL_SCHEME_REGEX) != null;
}
const $df8714d527b2cee6$export$696b487c8ad531d2 = (url, loadOptions)=>{
    if (typeof fetch === 'undefined' && (loadOptions == null || loadOptions.fetchFunc == null)) // `http` uses `fetch` or `node-fetch`, if one wants to use it in
    // an environment that is not the browser or node they have to setup a
    // global fetch polyfill.
    return null;
    else {
        let isHTTP = true;
        if (Array.isArray(url)) isHTTP = url.every((urlItem)=>$df8714d527b2cee6$export$18a721ae4733601b(urlItem));
        else isHTTP = $df8714d527b2cee6$export$18a721ae4733601b(url);
        if (isHTTP) return $df8714d527b2cee6$export$7d6f1c8842f9f527(url, loadOptions);
    }
    return null;
};
(0, $9RUNn.IORouterRegistry).registerSaveRouter($df8714d527b2cee6$export$696b487c8ad531d2);
(0, $9RUNn.IORouterRegistry).registerLoadRouter($df8714d527b2cee6$export$696b487c8ad531d2);
function $df8714d527b2cee6$export$7d6f1c8842f9f527(path, loadOptions) {
    return new $df8714d527b2cee6$export$3df08bb5d0f8b499(path, loadOptions);
}
function $df8714d527b2cee6$export$624ff5bc4e3a9d72(path, loadOptions) {
    return $df8714d527b2cee6$export$7d6f1c8842f9f527(path, loadOptions);
}

});
parcelRegister("wfkqW", function(module, exports) {

$parcel$export(module.exports, "loadWeightsAsArrayBuffer", () => $060ee13579f28267$export$6873c1a1d3325bf7);
$parcel$export(module.exports, "streamWeights", () => $060ee13579f28267$export$4fc61cabab0a1e7e);
$parcel$export(module.exports, "loadWeights", () => $060ee13579f28267$export$55f7d42d35356096);
$parcel$export(module.exports, "weightsLoaderFactory", () => $060ee13579f28267$export$635f986c4ab6ebe2);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ibsdL = parcelRequire("ibsdL");

var $8cCb2 = parcelRequire("8cCb2");

var $hBb8J = parcelRequire("hBb8J");

var $4FRLN = parcelRequire("4FRLN");

var $cYV5g = parcelRequire("cYV5g");

var $2bXta = parcelRequire("2bXta");
async function $060ee13579f28267$export$6873c1a1d3325bf7(fetchURLs, loadOptions) {
    if (loadOptions == null) loadOptions = {};
    const fetchFunc = loadOptions.fetchFunc == null ? (0, $ibsdL.env)().platform.fetch : loadOptions.fetchFunc;
    // Create the requests for all of the weights in parallel.
    const requests = fetchURLs.map((fetchURL)=>fetchFunc(fetchURL, loadOptions.requestInit, {
            isBinary: true
        }));
    const fetchStartFraction = 0;
    const fetchEndFraction = 0.5;
    const responses = loadOptions.onProgress == null ? await Promise.all(requests) : await (0, $cYV5g.monitorPromisesProgress)(requests, loadOptions.onProgress, fetchStartFraction, fetchEndFraction);
    const bufferPromises = responses.map((response)=>response.arrayBuffer());
    const bufferStartFraction = 0.5;
    const bufferEndFraction = 1;
    const buffers = loadOptions.onProgress == null ? await Promise.all(bufferPromises) : await (0, $cYV5g.monitorPromisesProgress)(bufferPromises, loadOptions.onProgress, bufferStartFraction, bufferEndFraction);
    return buffers;
}
function $060ee13579f28267$export$4fc61cabab0a1e7e(fetchURLs, loadOptions) {
    var _a;
    const fetchFunc = loadOptions.fetchFunc == null ? (0, $ibsdL.env)().platform.fetch : loadOptions.fetchFunc;
    let fetchIndex = 0;
    let chunkReader;
    (_a = loadOptions.onProgress) === null || _a === void 0 || _a.call(loadOptions, 0);
    return new ReadableStream({
        pull: async (controller)=>{
            var _a;
            while(fetchIndex < fetchURLs.length){
                if (!chunkReader) {
                    const body = (await fetchFunc(fetchURLs[fetchIndex], loadOptions.requestInit, {
                        isBinary: true
                    })).body;
                    chunkReader = body.getReader();
                }
                const { done: done, value: value } = await chunkReader.read();
                if (done) {
                    fetchIndex++;
                    chunkReader = undefined;
                    (_a = loadOptions.onProgress) === null || _a === void 0 || _a.call(loadOptions, fetchIndex / fetchURLs.length);
                    continue;
                }
                controller.enqueue(value);
                return;
            }
            controller.close();
        }
    });
}
async function $060ee13579f28267$export$55f7d42d35356096(manifest, filePathPrefix = '', weightNames, requestInit) {
    // TODO(nsthorat): Groups are currently fetched atomically. If you need a
    // single weight from a group, the whole group will be fetched. At a future
    // date, we should support fetching only the individual shards within a
    // group that are needed to reconstruct the requested weight.
    // TODO(cais): Use `decodeWeights` for implementation.
    const fetchWeights = (fetchUrls)=>$060ee13579f28267$export$6873c1a1d3325bf7(fetchUrls, {
            requestInit: requestInit
        });
    const loadWeights1 = $060ee13579f28267$export$635f986c4ab6ebe2(fetchWeights);
    return loadWeights1(manifest, filePathPrefix, weightNames);
}
function $060ee13579f28267$export$635f986c4ab6ebe2(fetchWeightsFunction) {
    return async (manifest, filePathPrefix = '', weightNames)=>{
        // Collect all the groups, weights, and their relative offsets to be
        // fetched.
        const groupIndicesToFetchMap = manifest.map(()=>false);
        const groupWeightsToFetch = {};
        const weightsFound = weightNames != null ? weightNames.map(()=>false) : [];
        const allManifestWeightNames = [];
        manifest.forEach((manifestGroupConfig, groupIndex)=>{
            let groupOffset = 0;
            manifestGroupConfig.weights.forEach((weightsEntry)=>{
                const rawDtype = 'quantization' in weightsEntry ? weightsEntry.quantization.dtype : weightsEntry.dtype;
                const weightsBytes = (0, $2bXta.DTYPE_VALUE_SIZE_MAP)[rawDtype] * $8cCb2.sizeFromShape(weightsEntry.shape);
                const enqueueWeightsForFetchingFn = ()=>{
                    groupIndicesToFetchMap[groupIndex] = true;
                    if (groupWeightsToFetch[groupIndex] == null) groupWeightsToFetch[groupIndex] = [];
                    groupWeightsToFetch[groupIndex].push({
                        manifestEntry: weightsEntry,
                        groupOffset: groupOffset,
                        sizeBytes: weightsBytes
                    });
                };
                if (weightNames != null) weightNames.forEach((weightName, weightIndex)=>{
                    if (weightName === weightsEntry.name) {
                        enqueueWeightsForFetchingFn();
                        weightsFound[weightIndex] = true;
                    }
                });
                else enqueueWeightsForFetchingFn();
                allManifestWeightNames.push(weightsEntry.name);
                groupOffset += weightsBytes;
            });
        });
        if (!weightsFound.every((found)=>found)) {
            const weightsNotFound = weightNames.filter((_, i)=>!weightsFound[i]);
            throw new Error(`Could not find weights in manifest with names: ` + `${weightsNotFound.join(', ')}. \n` + `Manifest JSON has weights with names: ` + `${allManifestWeightNames.join(', ')}.`);
        }
        // Convert the one-hot boolean groupId => shouldFetch map to a list of group
        // IDs.
        const groupIndicesToFetch = groupIndicesToFetchMap.reduce((accumulator, shouldFetch, i)=>{
            if (shouldFetch) accumulator.push(i);
            return accumulator;
        }, []);
        const fetchUrls = [];
        groupIndicesToFetch.forEach((i)=>{
            manifest[i].paths.forEach((filepath)=>{
                const fetchUrl = filePathPrefix + (!filePathPrefix.endsWith('/') ? '/' : '') + filepath;
                fetchUrls.push(fetchUrl);
            });
        });
        const buffers = await fetchWeightsFunction(fetchUrls);
        const weightsTensorMap = {};
        let bufferIndexOffset = 0;
        groupIndicesToFetch.forEach((i)=>{
            const numBuffers = manifest[i].paths.length;
            const weightsBuffer = new (0, $hBb8J.CompositeArrayBuffer)(buffers.slice(bufferIndexOffset, bufferIndexOffset + numBuffers));
            const weightsEntries = groupWeightsToFetch[i];
            weightsEntries.forEach((weightsEntry)=>{
                const byteBuffer = weightsBuffer.slice(weightsEntry.groupOffset, weightsEntry.groupOffset + weightsEntry.sizeBytes);
                const nameToTensorMap = (0, $4FRLN.decodeWeights)(byteBuffer, [
                    weightsEntry.manifestEntry
                ]);
                for(const name in nameToTensorMap)weightsTensorMap[name] = nameToTensorMap[name];
            });
            bufferIndexOffset += numBuffers;
        });
        return weightsTensorMap;
    };
}

});
parcelRegister("cYV5g", function(module, exports) {

$parcel$export(module.exports, "monitorPromisesProgress", () => $97375e54bf64bee5$export$b88cae388b9e062e);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8cCb2 = parcelRequire("8cCb2");
function $97375e54bf64bee5$export$b88cae388b9e062e(promises, onProgress, startFraction, endFraction) {
    checkPromises(promises);
    startFraction = startFraction == null ? 0 : startFraction;
    endFraction = endFraction == null ? 1 : endFraction;
    checkFraction(startFraction, endFraction);
    let resolvedPromise = 0;
    const registerMonitor = (promise)=>{
        promise.then((value)=>{
            const fraction = startFraction + ++resolvedPromise / promises.length * (endFraction - startFraction);
            // pass fraction as parameter to callback function.
            onProgress(fraction);
            return value;
        });
        return promise;
    };
    function checkPromises(promises) {
        (0, $8cCb2.assert)(promises != null && Array.isArray(promises) && promises.length > 0, ()=>'promises must be a none empty array');
    }
    function checkFraction(startFraction, endFraction) {
        (0, $8cCb2.assert)(startFraction >= 0 && startFraction <= 1, ()=>`Progress fraction must be in range [0, 1], but ` + `got startFraction ${startFraction}`);
        (0, $8cCb2.assert)(endFraction >= 0 && endFraction <= 1, ()=>`Progress fraction must be in range [0, 1], but ` + `got endFraction ${endFraction}`);
        (0, $8cCb2.assert)(endFraction >= startFraction, ()=>`startFraction must be no more than endFraction, but ` + `got startFraction ${startFraction} and endFraction ` + `${endFraction}`);
    }
    return Promise.all(promises.map(registerMonitor));
}

});



parcelRegister("hfd1o", function(module, exports) {

$parcel$export(module.exports, "fromMemory", () => $c8ddf02cd96cceaf$export$89ba941c7951a2e8);
$parcel$export(module.exports, "fromMemorySync", () => $c8ddf02cd96cceaf$export$c22472cb1d774f45);
$parcel$export(module.exports, "withSaveHandler", () => $c8ddf02cd96cceaf$export$fa4a26428614aae7);
$parcel$export(module.exports, "withSaveHandlerSync", () => $c8ddf02cd96cceaf$export$53913891eb9f0585);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $c8ddf02cd96cceaf$var$PassthroughLoader {
    constructor(modelArtifacts){
        this.modelArtifacts = modelArtifacts;
    }
    load() {
        return this.modelArtifacts;
    }
}
class $c8ddf02cd96cceaf$var$PassthroughSaver {
    constructor(saveHandler){
        this.saveHandler = saveHandler;
    }
    save(modelArtifacts) {
        return this.saveHandler(modelArtifacts);
    }
}
class $c8ddf02cd96cceaf$var$PassthroughAsync {
    constructor(handler){
        if (handler.load) this.load = ()=>Promise.resolve(handler.load());
        if (handler.save) this.save = (modelArtifacts)=>Promise.resolve(handler.save(modelArtifacts));
    }
}
function $c8ddf02cd96cceaf$export$89ba941c7951a2e8(modelArtifacts, weightSpecs, weightData, trainingConfig) {
    const args = arguments;
    return new $c8ddf02cd96cceaf$var$PassthroughAsync($c8ddf02cd96cceaf$export$c22472cb1d774f45(...args));
}
function $c8ddf02cd96cceaf$export$c22472cb1d774f45(modelArtifacts, weightSpecs, weightData, trainingConfig) {
    if (arguments.length === 1) {
        const isModelArtifacts = modelArtifacts.modelTopology != null || modelArtifacts.weightSpecs != null;
        if (isModelArtifacts) return new $c8ddf02cd96cceaf$var$PassthroughLoader(modelArtifacts);
        else {
            // Legacy support: with only modelTopology.
            // TODO(cais): Remove this deprecated API.
            console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release.");
            return new $c8ddf02cd96cceaf$var$PassthroughLoader({
                modelTopology: modelArtifacts
            });
        }
    } else {
        // Legacy support.
        // TODO(cais): Remove this deprecated API.
        console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release.");
        return new $c8ddf02cd96cceaf$var$PassthroughLoader({
            modelTopology: modelArtifacts,
            weightSpecs: weightSpecs,
            weightData: weightData,
            trainingConfig: trainingConfig
        });
    }
}
function $c8ddf02cd96cceaf$export$fa4a26428614aae7(saveHandler) {
    return new $c8ddf02cd96cceaf$var$PassthroughSaver(saveHandler);
}
function $c8ddf02cd96cceaf$export$53913891eb9f0585(saveHandler) {
    return new $c8ddf02cd96cceaf$var$PassthroughSaver(saveHandler);
}

});


parcelRegister("lzjc8", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Impl", () => (parcelRequire("KPYos")).nonMaxSuppressionV3Impl);
$parcel$export(module.exports, "nonMaxSuppressionV4Impl", () => (parcelRequire("KPYos")).nonMaxSuppressionV4Impl);
$parcel$export(module.exports, "nonMaxSuppressionV5Impl", () => (parcelRequire("KPYos")).nonMaxSuppressionV5Impl);
$parcel$export(module.exports, "whereImpl", () => (parcelRequire("kNeGS")).whereImpl);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $KPYos = parcelRequire("KPYos");

var $kNeGS = parcelRequire("kNeGS");

});

parcelRegister("9LtVT", function(module, exports) {

$parcel$export(module.exports, "nextFrame", () => $71bfb8d913b21bbc$export$68d2d147c928d1dd);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $71bfb8d913b21bbc$var$delayCallback = (()=>{
    if (typeof requestAnimationFrame !== 'undefined') return requestAnimationFrame;
    else if (typeof setImmediate !== 'undefined') return setImmediate;
    return (f)=>f(); // no delays
})();
/**
 * Returns a promise that resolves when a requestAnimationFrame has completed.
 *
 * On Node.js this uses setImmediate instead of requestAnimationFrame.
 *
 * This is simply a sugar method so that users can do the following:
 * `await tf.nextFrame();`
 *
 * @doc {heading: 'Performance', subheading: 'Timing'}
 */ function $71bfb8d913b21bbc$export$68d2d147c928d1dd() {
    return new Promise((resolve)=>$71bfb8d913b21bbc$var$delayCallback(()=>resolve()));
}

});

parcelRegister("dXS8M", function(module, exports) {

$parcel$export(module.exports, "train", () => $a2aac83cc2c20bd7$export$9af937cf8bcbf96);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bO4Xu = parcelRequire("bO4Xu");
const $a2aac83cc2c20bd7$export$9af937cf8bcbf96 = (0, $bO4Xu.OptimizerConstructors);

});
parcelRegister("bO4Xu", function(module, exports) {

$parcel$export(module.exports, "OptimizerConstructors", () => $898835df87cf1c26$export$1babc3d7b10c0cf6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $Haryc = parcelRequire("Haryc");

var $7740A = parcelRequire("7740A");

var $cdIoP = parcelRequire("cdIoP");

var $9sl63 = parcelRequire("9sl63");

var $7GJGN = parcelRequire("7GJGN");

var $7qglv = parcelRequire("7qglv");

var $hR6PP = parcelRequire("hR6PP");
class $898835df87cf1c26$export$1babc3d7b10c0cf6 {
    /**
     * Constructs a `tf.SGDOptimizer` that uses stochastic gradient descent.
     *
     * ```js
     * // Fit a quadratic function by learning the coefficients a, b, c.
     * const xs = tf.tensor1d([0, 1, 2, 3]);
     * const ys = tf.tensor1d([1.1, 5.9, 16.8, 33.9]);
     *
     * const a = tf.scalar(Math.random()).variable();
     * const b = tf.scalar(Math.random()).variable();
     * const c = tf.scalar(Math.random()).variable();
     *
     * // y = a * x^2 + b * x + c.
     * const f = x => a.mul(x.square()).add(b.mul(x)).add(c);
     * const loss = (pred, label) => pred.sub(label).square().mean();
     *
     * const learningRate = 0.01;
     * const optimizer = tf.train.sgd(learningRate);
     *
     * // Train the model.
     * for (let i = 0; i < 10; i++) {
     *   optimizer.minimize(() => loss(f(xs), ys));
     * }
     *
     * // Make predictions.
     * console.log(
     *     `a: ${a.dataSync()}, b: ${b.dataSync()}, c: ${c.dataSync()}`);
     * const preds = f(xs).dataSync();
     * preds.forEach((pred, i) => {
     *   console.log(`x: ${i}, pred: ${pred}`);
     * });
     * ```
     *
     * @param learningRate The learning rate to use for the SGD algorithm.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static sgd(learningRate) {
        return new (0, $hR6PP.SGDOptimizer)(learningRate);
    }
    /**
     * Constructs a `tf.MomentumOptimizer` that uses momentum gradient
     * descent.
     *
     * See
     * [http://proceedings.mlr.press/v28/sutskever13.pdf](
     * http://proceedings.mlr.press/v28/sutskever13.pdf)
     *
     * @param learningRate The learning rate to use for the Momentum gradient
     * descent algorithm.
     * @param momentum The momentum to use for the momentum gradient descent
     * algorithm.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static momentum(learningRate, momentum, useNesterov = false) {
        return new (0, $7GJGN.MomentumOptimizer)(learningRate, momentum, useNesterov);
    }
    /**
     * Constructs a `tf.RMSPropOptimizer` that uses RMSProp gradient
     * descent. This implementation uses plain momentum and is not centered
     * version of RMSProp.
     *
     * See
     * [http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf](
     * http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf)
     *
     * @param learningRate The learning rate to use for the RMSProp gradient
     * descent algorithm.
     * @param decay The discounting factor for the history/coming gradient.
     * @param momentum The momentum to use for the RMSProp gradient descent
     * algorithm.
     * @param epsilon Small value to avoid zero denominator.
     * @param centered If true, gradients are normalized by the estimated
     * variance of the gradient.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static rmsprop(learningRate, decay = .9, momentum = 0.0, epsilon = null, centered = false) {
        return new (0, $7qglv.RMSPropOptimizer)(learningRate, decay, momentum, epsilon, centered);
    }
    /**
     * Constructs a `tf.AdamOptimizer` that uses the Adam algorithm.
     * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
     *
     * @param learningRate The learning rate to use for the Adam gradient
     * descent algorithm.
     * @param beta1 The exponential decay rate for the 1st moment estimates.
     * @param beta2 The exponential decay rate for the 2nd moment estimates.
     * @param epsilon A small constant for numerical stability.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adam(learningRate = 0.001, beta1 = 0.9, beta2 = 0.999, epsilon = null) {
        return new (0, $cdIoP.AdamOptimizer)(learningRate, beta1, beta2, epsilon);
    }
    /**
     * Constructs a `tf.AdadeltaOptimizer` that uses the Adadelta algorithm.
     * See [https://arxiv.org/abs/1212.5701](https://arxiv.org/abs/1212.5701)
     *
     * @param learningRate The learning rate to use for the Adadelta gradient
     * descent algorithm.
     * @param rho The learning rate decay over each update.
     * @param epsilon A constant epsilon used to better condition the grad
     * update.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adadelta(learningRate = .001, rho = .95, epsilon = null) {
        return new (0, $Haryc.AdadeltaOptimizer)(learningRate, rho, epsilon);
    }
    /**
     * Constructs a `tf.AdamaxOptimizer` that uses the Adamax algorithm.
     * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
     *
     * @param learningRate The learning rate to use for the Adamax gradient
     * descent algorithm.
     * @param beta1 The exponential decay rate for the 1st moment estimates.
     * @param beta2 The exponential decay rate for the 2nd moment estimates.
     * @param epsilon A small constant for numerical stability.
     * @param decay The learning rate decay over each update.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adamax(learningRate = 0.002, beta1 = 0.9, beta2 = 0.999, epsilon = null, decay = 0.0) {
        return new (0, $9sl63.AdamaxOptimizer)(learningRate, beta1, beta2, epsilon, decay);
    }
    /**
     * Constructs a `tf.AdagradOptimizer` that uses the Adagrad algorithm.
     * See
     * [http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf](
     * http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf)
     * or
     * [http://ruder.io/optimizing-gradient-descent/index.html#adagrad](
     * http://ruder.io/optimizing-gradient-descent/index.html#adagrad)
     *
     * @param learningRate The learning rate to use for the Adagrad gradient
     * descent algorithm.
     * @param initialAccumulatorValue Starting value for the accumulators, must be
     * positive.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adagrad(learningRate, initialAccumulatorValue = 0.1) {
        return new (0, $7740A.AdagradOptimizer)(learningRate, initialAccumulatorValue);
    }
}

});


parcelRegister("kWDmn", function(module, exports) {

$parcel$export(module.exports, "version", () => $f3f7c17932263fce$export$83d89fbfd8236492);
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $f3f7c17932263fce$export$83d89fbfd8236492 = '4.22.0';

});


parcelRegister("40l72", function(module, exports) {

$parcel$export(module.exports, "loadGraphModel", () => (parcelRequire("bVQtG")).loadGraphModel);
$parcel$export(module.exports, "version_converter", () => (parcelRequire("1SddR")).version);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("1DtTd");

var $bVQtG = parcelRequire("bVQtG");

var $dWfqP = parcelRequire("dWfqP");

var $1SddR = parcelRequire("1SddR");

});
parcelRegister("1DtTd", function(module, exports) {
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $ibsdL = parcelRequire("ibsdL");
const $13109e66f2098a0a$var$ENV = (0, $ibsdL.env)();
/** Whether to keep intermediate tensors. */ $13109e66f2098a0a$var$ENV.registerFlag('KEEP_INTERMEDIATE_TENSORS', ()=>false, (debugValue)=>{
    if (debugValue) console.warn("Keep intermediate tensors is ON. This will print the values of all intermediate tensors during model inference. Not all models support this mode. For details, check e2e/benchmarks/ model_config.js. This significantly impacts performance.");
});

});

parcelRegister("bVQtG", function(module, exports) {

$parcel$export(module.exports, "loadGraphModel", () => $8afdb9914f122011$export$f077572b5d896ffd);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $c2DT1 = parcelRequire("c2DT1");
var $9ELKf = parcelRequire("9ELKf");
var $9jCh7 = parcelRequire("9jCh7");
var $jjNRA = parcelRequire("jjNRA");

var $jRFPP = parcelRequire("jRFPP");

var $eZl48 = parcelRequire("eZl48");

var $kqYp1 = parcelRequire("kqYp1");

var $4FRLN = parcelRequire("4FRLN");
const $8afdb9914f122011$export$a9bc79b23e178599 = '?tfjs-format=file';
const $8afdb9914f122011$export$9ffb2eac80132860 = 'model.json';
class $8afdb9914f122011$export$357a78c279dfa8cf {
    // Returns the version information for the tensorflow model GraphDef.
    get modelVersion() {
        return this.version;
    }
    get inputNodes() {
        return this.executor.inputNodes;
    }
    get outputNodes() {
        return this.executor.outputNodes;
    }
    get inputs() {
        return this.executor.inputs;
    }
    get outputs() {
        return this.executor.outputs;
    }
    get weights() {
        return this.executor.weightMap;
    }
    get metadata() {
        return this.artifacts.userDefinedMetadata;
    }
    get modelSignature() {
        return this.signature;
    }
    get modelStructuredOutputKeys() {
        return this.structuredOutputKeys;
    }
    /**
     * @param modelUrl url for the model, or an `io.IOHandler`.
     * @param weightManifestUrl url for the weight file generated by
     * scripts/convert.py script.
     * @param requestOption options for Request, which allows to send credentials
     * and custom headers.
     * @param onProgress Optional, progress callback function, fired periodically
     * before the load is completed.
     */ constructor(modelUrl, loadOptions = {}, tfio = (0, $9ELKf)){
        this.modelUrl = modelUrl;
        this.loadOptions = loadOptions;
        this.version = 'n/a';
        this.io = tfio;
        if (loadOptions == null) this.loadOptions = {};
        this.resourceManager = new (0, $kqYp1.ResourceManager)();
    }
    findIOHandler() {
        const path = this.modelUrl;
        if (path.load != null) // Path is an IO Handler.
        this.handler = path;
        else if (this.loadOptions.requestInit != null) this.handler = this.io.browserHTTPRequest(path, this.loadOptions);
        else {
            const handlers = this.io.getLoadHandlers(path, this.loadOptions);
            if (handlers.length === 0) // For backward compatibility: if no load handler can be found,
            // assume it is a relative http path.
            handlers.push(this.io.browserHTTPRequest(path, this.loadOptions));
            else if (handlers.length > 1) throw new Error(`Found more than one (${handlers.length}) load handlers for ` + `URL '${[
                path
            ]}'`);
            this.handler = handlers[0];
        }
    }
    /**
     * Loads the model and weight files, construct the in memory weight map and
     * compile the inference graph.
     */ load() {
        this.findIOHandler();
        if (this.handler.load == null) throw new Error("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
        const loadResult = this.handler.load();
        if ((0, $jjNRA).isPromise(loadResult)) return loadResult.then((artifacts)=>{
            if (artifacts.getWeightStream == null) return this.loadSync(artifacts);
            return this.loadStreaming(artifacts);
        });
        return this.loadSync(loadResult);
    }
    /**
     * Synchronously construct the in memory weight map and
     * compile the inference graph.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ loadSync(artifacts) {
        const weightMap = this.io.decodeWeights(artifacts.weightData, artifacts.weightSpecs);
        return this.loadWithWeightMap(artifacts, weightMap);
    }
    async loadStreaming(artifacts) {
        if (artifacts.getWeightStream == null) throw new Error('Model artifacts missing streamWeights function');
        const weightMap = await (0, $4FRLN.decodeWeightsStream)(artifacts.getWeightStream(), artifacts.weightSpecs);
        return this.loadWithWeightMap(artifacts, weightMap);
    }
    loadWithWeightMap(artifacts, weightMap) {
        this.artifacts = artifacts;
        const graph = this.artifacts.modelTopology;
        let signature = this.artifacts.signature;
        if (this.artifacts.userDefinedMetadata != null) {
            const metadata = this.artifacts.userDefinedMetadata;
            if (metadata.signature != null) signature = metadata.signature;
            if (metadata.structuredOutputKeys != null) this.structuredOutputKeys = metadata.structuredOutputKeys;
        }
        this.signature = signature;
        this.version = `${graph.versions.producer}.${graph.versions.minConsumer}`;
        this.executor = new (0, $eZl48.GraphExecutor)((0, $jRFPP.OperationMapper).Instance.transformGraph(graph, this.signature));
        this.executor.weightMap = this.convertTensorMapToTensorsMap(weightMap);
        // Attach a model-level resourceManager to each executor to share resources,
        // such as `HashTable`.
        this.executor.resourceManager = this.resourceManager;
        if (artifacts.modelInitializer != null && artifacts.modelInitializer.node != null) {
            const initializer = (0, $jRFPP.OperationMapper).Instance.transformGraph(artifacts.modelInitializer);
            this.initializer = new (0, $eZl48.GraphExecutor)(initializer);
            this.initializer.weightMap = this.executor.weightMap;
            // Attach a model-level resourceManager to the initializer, the
            // hashTables created from when executing the initializer will be stored
            // in the resourceManager.
            this.initializer.resourceManager = this.resourceManager;
            this.initializerSignature = artifacts.initializerSignature;
        }
        return true;
    }
    /**
     * Save the configuration and/or weights of the GraphModel.
     *
     * An `IOHandler` is an object that has a `save` method of the proper
     * signature defined. The `save` method manages the storing or
     * transmission of serialized data ("artifacts") that represent the
     * model's topology and weights onto or via a specific medium, such as
     * file downloads, local storage, IndexedDB in the web browser and HTTP
     * requests to a server. TensorFlow.js provides `IOHandler`
     * implementations for a number of frequently used saving mediums, such as
     * `tf.io.browserDownloads` and `tf.io.browserLocalStorage`. See `tf.io`
     * for more details.
     *
     * This method also allows you to refer to certain types of `IOHandler`s
     * as URL-like string shortcuts, such as 'localstorage://' and
     * 'indexeddb://'.
     *
     * Example 1: Save `model`'s topology and weights to browser [local
     * storage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage);
     * then load it back.
     *
     * ```js
     * const modelUrl =
     *    'https://storage.googleapis.com/tfjs-models/savedmodel/mobilenet_v2_1.0_224/model.json';
     * const model = await tf.loadGraphModel(modelUrl);
     * const zeros = tf.zeros([1, 224, 224, 3]);
     * model.predict(zeros).print();
     *
     * const saveResults = await model.save('localstorage://my-model-1');
     *
     * const loadedModel = await tf.loadGraphModel('localstorage://my-model-1');
     * console.log('Prediction from loaded model:');
     * model.predict(zeros).print();
     * ```
     *
     * @param handlerOrURL An instance of `IOHandler` or a URL-like,
     * scheme-based string shortcut for `IOHandler`.
     * @param config Options for saving the model.
     * @returns A `Promise` of `SaveResult`, which summarizes the result of
     * the saving, such as byte sizes of the saved artifacts for the model's
     *   topology and weight values.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async save(handlerOrURL, config) {
        if (typeof handlerOrURL === 'string') {
            const handlers = this.io.getSaveHandlers(handlerOrURL);
            if (handlers.length === 0) throw new Error(`Cannot find any save handlers for URL '${handlerOrURL}'`);
            else if (handlers.length > 1) throw new Error(`Found more than one (${handlers.length}) save handlers for ` + `URL '${handlerOrURL}'`);
            handlerOrURL = handlers[0];
        }
        if (handlerOrURL.save == null) throw new Error("GraphModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        return handlerOrURL.save(this.artifacts);
    }
    addStructuredOutputNames(outputTensors) {
        if (this.structuredOutputKeys) {
            const outputTensorsArray = outputTensors instanceof (0, $9jCh7.Tensor) ? [
                outputTensors
            ] : outputTensors;
            const outputTensorMap = {};
            outputTensorsArray.forEach((outputTensor, i)=>outputTensorMap[this.structuredOutputKeys[i]] = outputTensor);
            return outputTensorMap;
        }
        return outputTensors;
    }
    /**
     * Execute the inference for the input tensors.
     *
     * @param input The input tensors, when there is single input for the model,
     * inputs param should be a `tf.Tensor`. For models with multiple inputs,
     * inputs params should be in either `tf.Tensor`[] if the input order is
     * fixed, or otherwise NamedTensorMap format.
     *
     * For model with multiple inputs, we recommend you use NamedTensorMap as the
     * input type, if you use `tf.Tensor`[], the order of the array needs to
     * follow the
     * order of inputNodes array. @see {@link GraphModel.inputNodes}
     *
     * You can also feed any intermediate nodes using the NamedTensorMap as the
     * input type. For example, given the graph
     *    InputNode => Intermediate => OutputNode,
     * you can execute the subgraph Intermediate => OutputNode by calling
     *    model.execute('IntermediateNode' : tf.tensor(...));
     *
     * This is useful for models that uses tf.dynamic_rnn, where the intermediate
     * state needs to be fed manually.
     *
     * For batch inference execution, the tensors for each input need to be
     * concatenated together. For example with mobilenet, the required input shape
     * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
     * If we are provide a batched data of 100 images, the input tensor should be
     * in the shape of [100, 244, 244, 3].
     *
     * @param config Prediction configuration for specifying the batch size.
     * Currently the batch size option is ignored for graph model.
     *
     * @returns Inference result tensors. If the model is converted and it
     * originally had structured_outputs in tensorflow, then a NamedTensorMap
     * will be returned matching the structured_outputs. If no structured_outputs
     * are present, the output will be single `tf.Tensor` if the model has single
     * output node, otherwise Tensor[].
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(inputs, config) {
        const outputTensors = this.execute(inputs, this.outputNodes);
        return this.addStructuredOutputNames(outputTensors);
    }
    /**
     * Execute the inference for the input tensors in async fashion, use this
     * method when your model contains control flow ops.
     *
     * @param input The input tensors, when there is single input for the model,
     * inputs param should be a `tf.Tensor`. For models with mutliple inputs,
     * inputs params should be in either `tf.Tensor`[] if the input order is
     * fixed, or otherwise NamedTensorMap format.
     *
     * For model with multiple inputs, we recommend you use NamedTensorMap as the
     * input type, if you use `tf.Tensor`[], the order of the array needs to
     * follow the
     * order of inputNodes array. @see {@link GraphModel.inputNodes}
     *
     * You can also feed any intermediate nodes using the NamedTensorMap as the
     * input type. For example, given the graph
     *    InputNode => Intermediate => OutputNode,
     * you can execute the subgraph Intermediate => OutputNode by calling
     *    model.execute('IntermediateNode' : tf.tensor(...));
     *
     * This is useful for models that uses tf.dynamic_rnn, where the intermediate
     * state needs to be fed manually.
     *
     * For batch inference execution, the tensors for each input need to be
     * concatenated together. For example with mobilenet, the required input shape
     * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
     * If we are provide a batched data of 100 images, the input tensor should be
     * in the shape of [100, 244, 244, 3].
     *
     * @param config Prediction configuration for specifying the batch size.
     * Currently the batch size option is ignored for graph model.
     *
     * @returns A Promise of inference result tensors. If the model is converted
     * and it originally had structured_outputs in tensorflow, then a
     * NamedTensorMap will be returned matching the structured_outputs. If no
     * structured_outputs are present, the output will be single `tf.Tensor` if
     * the model has single output node, otherwise Tensor[].
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async predictAsync(inputs, config) {
        const outputTensors = await this.executeAsync(inputs, this.outputNodes);
        return this.addStructuredOutputNames(outputTensors);
    }
    normalizeInputs(inputs) {
        var _a;
        if (!(inputs instanceof (0, $9jCh7.Tensor)) && !Array.isArray(inputs)) {
            // The input is already a NamedTensorMap.
            const signatureInputs = (_a = this.signature) === null || _a === void 0 ? void 0 : _a.inputs;
            if (signatureInputs != null) for(const input in signatureInputs){
                const tensor = signatureInputs[input];
                if (tensor.resourceId != null) inputs[input] = this.resourceIdToCapturedInput[tensor.resourceId];
            }
            return inputs;
        }
        inputs = Array.isArray(inputs) ? inputs : [
            inputs
        ];
        const numCapturedInputs = Object.keys(this.resourceIdToCapturedInput).length;
        if (inputs.length + numCapturedInputs !== this.inputNodes.length) throw new Error(`Input tensor count mismatch, the graph model has ${this.inputNodes.length - numCapturedInputs} non-resource placeholders, while there are ${inputs.length} input tensors provided.`);
        let inputIndex = 0;
        return this.inputNodes.reduce((map, inputName)=>{
            var _a, _b, _c;
            const resourceId = (_c = (_b = (_a = this.signature) === null || _a === void 0 ? void 0 : _a.inputs) === null || _b === void 0 ? void 0 : _b[inputName]) === null || _c === void 0 ? void 0 : _c.resourceId;
            if (resourceId != null) map[inputName] = this.resourceIdToCapturedInput[resourceId];
            else map[inputName] = inputs[inputIndex++];
            return map;
        }, {});
    }
    normalizeOutputs(outputs) {
        outputs = outputs || this.outputNodes;
        return !Array.isArray(outputs) ? [
            outputs
        ] : outputs;
    }
    executeInitializerGraph() {
        if (this.initializer == null) return [];
        if (this.initializerSignature == null) return this.initializer.execute({}, []);
        else return this.initializer.execute({}, Object.keys(this.initializerSignature.outputs));
    }
    async executeInitializerGraphAsync() {
        if (this.initializer == null) return [];
        if (this.initializerSignature == null) return this.initializer.executeAsync({}, []);
        else return this.initializer.executeAsync({}, Object.keys(this.initializerSignature.outputs));
    }
    setResourceIdToCapturedInput(outputs) {
        this.resourceIdToCapturedInput = {};
        if (this.initializerSignature) {
            const signatureOutputs = this.initializerSignature.outputs;
            const outputNames = Object.keys(signatureOutputs);
            for(let i = 0; i < outputNames.length; i++){
                const outputName = outputNames[i];
                const tensorInfo = signatureOutputs[outputName];
                this.resourceIdToCapturedInput[tensorInfo.resourceId] = outputs[i];
            }
        }
    }
    /**
     * Executes inference for the model for given input tensors.
     * @param inputs tensor, tensor array or tensor map of the inputs for the
     * model, keyed by the input node names.
     * @param outputs output node name from the TensorFlow model, if no
     * outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     *
     * @returns A single tensor if provided with a single output or no outputs
     * are provided and there is only one default output, otherwise return a
     * tensor array. The order of the tensor array is the same as the outputs
     * if provided, otherwise the order of outputNodes attribute of the model.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ execute(inputs, outputs) {
        if (this.resourceIdToCapturedInput == null) this.setResourceIdToCapturedInput(this.executeInitializerGraph());
        inputs = this.normalizeInputs(inputs);
        outputs = this.normalizeOutputs(outputs);
        const result = this.executor.execute(inputs, outputs);
        return result.length > 1 ? result : result[0];
    }
    /**
     * Executes inference for the model for given input tensors in async
     * fashion, use this method when your model contains control flow ops.
     * @param inputs tensor, tensor array or tensor map of the inputs for the
     * model, keyed by the input node names.
     * @param outputs output node name from the TensorFlow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     *
     * @returns A Promise of single tensor if provided with a single output or
     * no outputs are provided and there is only one default output, otherwise
     * return a tensor map.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async executeAsync(inputs, outputs) {
        if (this.resourceIdToCapturedInput == null) this.setResourceIdToCapturedInput(await this.executeInitializerGraphAsync());
        inputs = this.normalizeInputs(inputs);
        outputs = this.normalizeOutputs(outputs);
        const result = await this.executor.executeAsync(inputs, outputs);
        return result.length > 1 ? result : result[0];
    }
    /**
     * Get intermediate tensors for model debugging mode (flag
     * KEEP_INTERMEDIATE_TENSORS is true).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ getIntermediateTensors() {
        return this.executor.getIntermediateTensors();
    }
    /**
     * Dispose intermediate tensors for model debugging mode (flag
     * KEEP_INTERMEDIATE_TENSORS is true).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ disposeIntermediateTensors() {
        this.executor.disposeIntermediateTensors();
    }
    convertTensorMapToTensorsMap(map) {
        return Object.keys(map).reduce((newMap, key)=>{
            newMap[key] = [
                map[key]
            ];
            return newMap;
        }, {});
    }
    /**
     * Releases the memory used by the weight tensors and resourceManager.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ dispose() {
        this.executor.dispose();
        if (this.initializer) {
            this.initializer.dispose();
            if (this.resourceIdToCapturedInput) (0, $c2DT1.dispose)(this.resourceIdToCapturedInput);
        }
        this.resourceManager.dispose();
    }
}
async function $8afdb9914f122011$export$f077572b5d896ffd(modelUrl, options = {}, tfio = (0, $9ELKf)) {
    if (modelUrl == null) throw new Error("modelUrl in loadGraphModel() cannot be null. Please provide a url or an IOHandler that loads the model");
    if (options == null) options = {};
    if (options.fromTFHub && typeof modelUrl === 'string') modelUrl = $8afdb9914f122011$var$getTFHubUrl(modelUrl);
    const model = new $8afdb9914f122011$export$357a78c279dfa8cf(modelUrl, options, tfio);
    await model.load();
    return model;
}
function $8afdb9914f122011$export$64fa41ef6cfbfdd7(modelSource) {
    if (modelSource == null) throw new Error("modelUrl in loadGraphModelSync() cannot be null. Please provide model artifacts or an IOHandler that loads the model");
    let ioHandler;
    if (modelSource instanceof Array) {
        const [modelJSON, weights] = modelSource;
        if (!modelJSON) throw new Error('modelJSON must be the first element of the array');
        if (!weights || !(weights instanceof ArrayBuffer)) throw new Error("An ArrayBuffer of weights must be the second element of the array");
        if (!('modelTopology' in modelJSON)) throw new Error('Model JSON is missing \'modelTopology\'');
        if (!('weightsManifest' in modelJSON)) throw new Error('Model JSON is missing \'weightsManifest\'');
        const weightSpecs = (0, $9ELKf).getWeightSpecs(modelJSON.weightsManifest);
        const modelArtifacts = (0, $9ELKf).getModelArtifactsForJSONSync(modelJSON, weightSpecs, weights);
        ioHandler = (0, $9ELKf).fromMemorySync(modelArtifacts);
    } else if ('load' in modelSource) // Then modelSource is already an IOHandlerSync.
    ioHandler = modelSource;
    else if ('modelTopology' in modelSource && 'weightSpecs' in modelSource && 'weightData' in modelSource) // modelSource is of type ModelArtifacts.
    ioHandler = (0, $9ELKf).fromMemorySync(modelSource);
    else throw new Error('Unknown model format');
    const model = new $8afdb9914f122011$export$357a78c279dfa8cf(ioHandler);
    model.load();
    return model;
}
function $8afdb9914f122011$var$getTFHubUrl(modelUrl) {
    if (!modelUrl.endsWith('/')) modelUrl = modelUrl + '/';
    return `${modelUrl}${$8afdb9914f122011$export$9ffb2eac80132860}${$8afdb9914f122011$export$a9bc79b23e178599}`;
}

});
parcelRegister("jRFPP", function(module, exports) {

$parcel$export(module.exports, "OperationMapper", () => $e7636b16c8ece759$export$712e670bcbcf1315);
$parcel$export(module.exports, "getStringParam", () => $e7636b16c8ece759$export$88878e8ea979e9e0);
$parcel$export(module.exports, "getStringArrayParam", () => $e7636b16c8ece759$export$3ad7c1b82be1673b);
$parcel$export(module.exports, "getNumberParam", () => $e7636b16c8ece759$export$9bb8d6def7820923);
$parcel$export(module.exports, "getNumericArrayParam", () => $e7636b16c8ece759$export$a5181f35ff520ed9);
$parcel$export(module.exports, "getBoolParam", () => $e7636b16c8ece759$export$2dc362e9c5612e66);
$parcel$export(module.exports, "getBoolArrayParam", () => $e7636b16c8ece759$export$71dea7cc6cfe5d6);
$parcel$export(module.exports, "getTensorShapeParam", () => $e7636b16c8ece759$export$2f3f0447f2b6ba0c);
$parcel$export(module.exports, "getTensorShapeArrayParam", () => $e7636b16c8ece759$export$296050a88ff1b217);
$parcel$export(module.exports, "getDtypeParam", () => $e7636b16c8ece759$export$8ff555328ef39a1b);
$parcel$export(module.exports, "getDtypeArrayParam", () => $e7636b16c8ece759$export$4d8018dacba67c5a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $ibsdL = parcelRequire("ibsdL");

var $iILH2 = parcelRequire("iILH2");

var $dWfqP = parcelRequire("dWfqP");

var $9PnRL = parcelRequire("9PnRL");

var $cCcNy = parcelRequire("cCcNy");

var $6T10F = parcelRequire("6T10F");

var $25do8 = parcelRequire("25do8");

var $kQhpu = parcelRequire("kQhpu");

var $iKevB = parcelRequire("iKevB");

var $gul1X = parcelRequire("gul1X");

var $8ADHf = parcelRequire("8ADHf");

var $cf9s6 = parcelRequire("cf9s6");

var $agimj = parcelRequire("agimj");

var $j4qIR = parcelRequire("j4qIR");

var $gUOFE = parcelRequire("gUOFE");

var $6seiJ = parcelRequire("6seiJ");

var $1st1Z = parcelRequire("1st1Z");

var $l0Shb = parcelRequire("l0Shb");

var $eTKRE = parcelRequire("eTKRE");

var $5vXpX = parcelRequire("5vXpX");

var $kuUeg = parcelRequire("kuUeg");

var $3Fxik = parcelRequire("3Fxik");

var $3km3B = parcelRequire("3km3B");

var $6ZWSX = parcelRequire("6ZWSX");
var $e7636b16c8ece759$require$Buffer = $6ZWSX.Buffer;
class $e7636b16c8ece759$export$712e670bcbcf1315 {
    // Singleton instance for the mapper
    static get Instance() {
        return this._instance || (this._instance = new this());
    }
    // Loads the op mapping from the JSON file.
    constructor(){
        const ops = [
            $cCcNy,
            $6T10F,
            $25do8,
            $kQhpu,
            $iKevB,
            $gul1X,
            $8ADHf,
            $cf9s6,
            $agimj,
            $j4qIR,
            $gUOFE,
            $6seiJ,
            $1st1Z,
            $l0Shb,
            $eTKRE,
            $5vXpX,
            $kuUeg,
            $3Fxik,
            $3km3B
        ];
        const mappersJson = [].concat(...ops.map((op)=>op.json));
        this.opMappers = mappersJson.reduce((map, mapper)=>{
            map[mapper.tfOpName] = mapper;
            return map;
        }, {});
    }
    // Converts the model inference graph from Tensorflow GraphDef to local
    // representation for TensorFlow.js API
    transformGraph(graph, signature = {}) {
        const tfNodes = graph.node;
        const placeholders = [];
        const weights = [];
        const initNodes = [];
        const nodes = tfNodes.reduce((map, node)=>{
            map[node.name] = this.mapNode(node);
            if (node.op.startsWith('Placeholder')) placeholders.push(map[node.name]);
            else if (node.op === 'Const') weights.push(map[node.name]);
            else if (node.input == null || node.input.length === 0) initNodes.push(map[node.name]);
            return map;
        }, {});
        let inputs = [];
        const outputs = [];
        let inputNodeNameToKey = {};
        let outputNodeNameToKey = {};
        if (signature != null) {
            inputNodeNameToKey = this.mapSignatureEntries(signature.inputs);
            outputNodeNameToKey = this.mapSignatureEntries(signature.outputs);
        }
        const allNodes = Object.keys(nodes);
        allNodes.forEach((key)=>{
            const node = nodes[key];
            node.inputNames.forEach((name, index)=>{
                const [nodeName, , outputName] = (0, $9PnRL.getNodeNameAndIndex)(name);
                const inputNode = nodes[nodeName];
                if (inputNode.outputs != null) {
                    const outputIndex = inputNode.outputs.indexOf(outputName);
                    if (outputIndex !== -1) {
                        const inputName = `${nodeName}:${outputIndex}`;
                        // update the input name to use the mapped output index directly.
                        node.inputNames[index] = inputName;
                    }
                }
                node.inputs.push(inputNode);
                inputNode.children.push(node);
            });
        });
        // if signature has not outputs set, add any node that does not have
        // outputs.
        if (Object.keys(outputNodeNameToKey).length === 0) allNodes.forEach((key)=>{
            const node = nodes[key];
            if (node.children.length === 0) outputs.push(node);
        });
        else Object.keys(outputNodeNameToKey).forEach((name)=>{
            const [nodeName] = (0, $9PnRL.getNodeNameAndIndex)(name);
            const node = nodes[nodeName];
            if (node != null) {
                node.signatureKey = outputNodeNameToKey[name];
                outputs.push(node);
            }
        });
        if (Object.keys(inputNodeNameToKey).length > 0) Object.keys(inputNodeNameToKey).forEach((name)=>{
            const [nodeName] = (0, $9PnRL.getNodeNameAndIndex)(name);
            const node = nodes[nodeName];
            if (node) {
                node.signatureKey = inputNodeNameToKey[name];
                inputs.push(node);
            }
        });
        else inputs = placeholders;
        let functions = {};
        if (graph.library != null && graph.library.function != null) functions = graph.library.function.reduce((functions, func)=>{
            functions[func.signature.name] = this.mapFunction(func);
            return functions;
        }, {});
        const result = {
            nodes: nodes,
            inputs: inputs,
            outputs: outputs,
            weights: weights,
            placeholders: placeholders,
            signature: signature,
            functions: functions
        };
        if (initNodes.length > 0) result.initNodes = initNodes;
        return result;
    }
    mapSignatureEntries(entries) {
        return Object.keys(entries || {}).reduce((prev, curr)=>{
            prev[entries[curr].name] = curr;
            return prev;
        }, {});
    }
    mapNode(node) {
        // Unsupported ops will cause an error at run-time (not parse time), since
        // they may not be used by the actual execution subgraph.
        const mapper = (0, $dWfqP.getRegisteredOp)(node.op) || this.opMappers[node.op] || {};
        if (node.attr == null) node.attr = {};
        const newNode = {
            name: node.name,
            op: node.op,
            category: mapper.category,
            inputNames: (node.input || []).map((input)=>input.startsWith('^') ? input.slice(1) : input),
            inputs: [],
            children: [],
            inputParams: {},
            attrParams: {},
            rawAttrs: node.attr,
            outputs: mapper.outputs
        };
        if (mapper.inputs != null) newNode.inputParams = mapper.inputs.reduce((map, param)=>{
            map[param.name] = {
                type: param.type,
                inputIndexStart: param.start,
                inputIndexEnd: param.end
            };
            return map;
        }, {});
        if (mapper.attrs != null) newNode.attrParams = mapper.attrs.reduce((map, param)=>{
            const type = param.type;
            let value = undefined;
            switch(param.type){
                case 'string':
                    value = $e7636b16c8ece759$export$88878e8ea979e9e0(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$88878e8ea979e9e0(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'string[]':
                    value = $e7636b16c8ece759$export$3ad7c1b82be1673b(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$3ad7c1b82be1673b(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'number':
                    value = $e7636b16c8ece759$export$9bb8d6def7820923(node.attr, param.tfName, param.defaultValue || 0);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$9bb8d6def7820923(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'number[]':
                    value = $e7636b16c8ece759$export$a5181f35ff520ed9(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$a5181f35ff520ed9(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'bool':
                    value = $e7636b16c8ece759$export$2dc362e9c5612e66(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$2dc362e9c5612e66(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'bool[]':
                    value = $e7636b16c8ece759$export$71dea7cc6cfe5d6(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$71dea7cc6cfe5d6(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'shape':
                    value = $e7636b16c8ece759$export$2f3f0447f2b6ba0c(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$2f3f0447f2b6ba0c(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'shape[]':
                    value = $e7636b16c8ece759$export$296050a88ff1b217(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$296050a88ff1b217(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'dtype':
                    value = $e7636b16c8ece759$export$8ff555328ef39a1b(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$8ff555328ef39a1b(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'dtype[]':
                    value = $e7636b16c8ece759$export$4d8018dacba67c5a(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$4d8018dacba67c5a(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'func':
                    value = $e7636b16c8ece759$export$aafe7fbc7c8a8284(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$aafe7fbc7c8a8284(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'tensor':
                case 'tensors':
                    break;
                default:
                    throw new Error(`Unsupported param type: ${param.type} for op: ${node.op}`);
            }
            map[param.name] = {
                value: value,
                type: type
            };
            return map;
        }, {});
        return newNode;
    }
    // map the TFunctionDef to TFJS graph object
    mapFunction(functionDef) {
        const tfNodes = functionDef.nodeDef;
        const placeholders = [];
        const weights = [];
        let nodes = {};
        if (tfNodes != null) nodes = tfNodes.reduce((map, node)=>{
            map[node.name] = this.mapNode(node);
            if (node.op === 'Const') weights.push(map[node.name]);
            return map;
        }, {});
        const inputs = [];
        const outputs = [];
        functionDef.signature.inputArg.forEach((arg)=>{
            const [nodeName] = (0, $9PnRL.getNodeNameAndIndex)(arg.name);
            const node = {
                name: nodeName,
                op: 'Placeholder',
                inputs: [],
                inputNames: [],
                category: 'graph',
                inputParams: {},
                attrParams: {
                    dtype: {
                        value: $e7636b16c8ece759$export$863992a6f00f04d8(arg.type),
                        type: 'dtype'
                    }
                },
                children: []
            };
            node.signatureKey = arg.name;
            inputs.push(node);
            nodes[nodeName] = node;
        });
        const allNodes = Object.keys(nodes);
        allNodes.forEach((key)=>{
            const node = nodes[key];
            node.inputNames.forEach((name, index)=>{
                const [nodeName, , outputName] = (0, $9PnRL.getNodeNameAndIndex)(name);
                const inputNode = nodes[nodeName];
                if (inputNode.outputs != null) {
                    const outputIndex = inputNode.outputs.indexOf(outputName);
                    if (outputIndex !== -1) {
                        const inputName = `${nodeName}:${outputIndex}`;
                        // update the input name to use the mapped output index directly.
                        node.inputNames[index] = inputName;
                    }
                }
                node.inputs.push(inputNode);
                inputNode.children.push(node);
            });
        });
        const returnNodeMap = functionDef.ret;
        functionDef.signature.outputArg.forEach((output)=>{
            const [nodeName, index] = (0, $9PnRL.getNodeNameAndIndex)(returnNodeMap[output.name]);
            const node = nodes[nodeName];
            if (node != null) {
                node.defaultOutput = index;
                outputs.push(node);
            }
        });
        const signature = this.mapArgsToSignature(functionDef);
        return {
            nodes: nodes,
            inputs: inputs,
            outputs: outputs,
            weights: weights,
            placeholders: placeholders,
            signature: signature
        };
    }
    mapArgsToSignature(functionDef) {
        return {
            methodName: functionDef.signature.name,
            inputs: functionDef.signature.inputArg.reduce((map, arg)=>{
                map[arg.name] = this.mapArgToTensorInfo(arg);
                return map;
            }, {}),
            outputs: functionDef.signature.outputArg.reduce((map, arg)=>{
                map[arg.name] = this.mapArgToTensorInfo(arg, functionDef.ret);
                return map;
            }, {})
        };
    }
    mapArgToTensorInfo(arg, nameMap) {
        let name = arg.name;
        if (nameMap != null) name = nameMap[name];
        return {
            name: name,
            dtype: arg.type
        };
    }
}
function $e7636b16c8ece759$export$94fdf11bafc8de6b(text) {
    const global = (0, $ibsdL.env)().global;
    if (typeof global.atob !== 'undefined') return global.atob(text);
    else if (typeof $e7636b16c8ece759$require$Buffer !== 'undefined') return new $e7636b16c8ece759$require$Buffer(text, 'base64').toString();
    else throw new Error("Unable to decode base64 in this environment. Missing built-in atob() or Buffer()");
}
function $e7636b16c8ece759$export$a112ee1a9f1f58d1(s, keepCase) {
    const value = Array.isArray(s) ? String.fromCharCode.apply(null, s) : $e7636b16c8ece759$export$94fdf11bafc8de6b(s);
    return keepCase ? value : value.toLowerCase();
}
function $e7636b16c8ece759$export$88878e8ea979e9e0(attrs, name, def, keepCase = false) {
    const param = attrs[name];
    if (param != null) return $e7636b16c8ece759$export$a112ee1a9f1f58d1(param.s, keepCase);
    return def;
}
function $e7636b16c8ece759$export$2dc362e9c5612e66(attrs, name, def) {
    const param = attrs[name];
    return param ? param.b : def;
}
function $e7636b16c8ece759$export$9bb8d6def7820923(attrs, name, def) {
    const param = attrs[name] || {};
    const value = param['i'] != null ? param['i'] : param['f'] != null ? param['f'] : def;
    return typeof value === 'number' ? value : parseInt(value, 10);
}
function $e7636b16c8ece759$export$863992a6f00f04d8(value) {
    if (typeof value === 'string') // tslint:disable-next-line:no-any
    value = $iILH2.DataType[value];
    switch(value){
        case $iILH2.DataType.DT_FLOAT:
        case $iILH2.DataType.DT_HALF:
            return 'float32';
        case $iILH2.DataType.DT_INT32:
        case $iILH2.DataType.DT_INT64:
        case $iILH2.DataType.DT_INT8:
        case $iILH2.DataType.DT_UINT8:
            return 'int32';
        case $iILH2.DataType.DT_BOOL:
            return 'bool';
        case $iILH2.DataType.DT_DOUBLE:
            return 'float32';
        case $iILH2.DataType.DT_STRING:
            return 'string';
        case $iILH2.DataType.DT_COMPLEX64:
        case $iILH2.DataType.DT_COMPLEX128:
            return 'complex64';
        default:
            // Unknown dtype error will happen at runtime (instead of parse time),
            // since these nodes might not be used by the actual subgraph execution.
            return null;
    }
}
function $e7636b16c8ece759$export$aafe7fbc7c8a8284(attrs, name, def) {
    const param = attrs[name];
    if (param && param.func) return param.func.name;
    return def;
}
function $e7636b16c8ece759$export$8ff555328ef39a1b(attrs, name, def) {
    const param = attrs[name];
    if (param && param.type) return $e7636b16c8ece759$export$863992a6f00f04d8(param.type);
    return def;
}
function $e7636b16c8ece759$export$4d8018dacba67c5a(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.type) return param.list.type.map((v)=>$e7636b16c8ece759$export$863992a6f00f04d8(v));
    return def;
}
function $e7636b16c8ece759$export$e22e6990f4767045(shape) {
    if (shape.unknownRank) return undefined;
    if (shape.dim != null) return shape.dim.map((dim)=>typeof dim.size === 'number' ? dim.size : parseInt(dim.size, 10));
    return [];
}
function $e7636b16c8ece759$export$2f3f0447f2b6ba0c(attrs, name, def) {
    const param = attrs[name];
    if (param && param.shape) return $e7636b16c8ece759$export$e22e6990f4767045(param.shape);
    return def;
}
function $e7636b16c8ece759$export$a5181f35ff520ed9(attrs, name, def) {
    const param = attrs[name];
    if (param) return ((param.list.f && param.list.f.length ? param.list.f : param.list.i) || []).map((v)=>typeof v === 'number' ? v : parseInt(v, 10));
    return def;
}
function $e7636b16c8ece759$export$3ad7c1b82be1673b(attrs, name, def, keepCase = false) {
    const param = attrs[name];
    if (param && param.list && param.list.s) return param.list.s.map((v)=>{
        return $e7636b16c8ece759$export$a112ee1a9f1f58d1(v, keepCase);
    });
    return def;
}
function $e7636b16c8ece759$export$296050a88ff1b217(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.shape) return param.list.shape.map((v)=>{
        return $e7636b16c8ece759$export$e22e6990f4767045(v);
    });
    return def;
}
function $e7636b16c8ece759$export$71dea7cc6cfe5d6(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.b) return param.list.b;
    return def;
}

});
parcelRegister("iILH2", function(module, exports) {

$parcel$export(module.exports, "DataType", () => $da1154ef7a939058$export$45c69700ee30a78c);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /** DataType enum. */ var $da1154ef7a939058$export$45c69700ee30a78c;
(function(DataType) {
    // These properties must be quoted since they are used by parseDtypeParam
    // in tfjs-converter/src/operations/operation_mapper.ts to look up dtypes
    // by string name. If they are not quoted, Closure will mangle their names.
    // Not a legal value for DataType.  Used to indicate a DataType field
    // has not been set.
    DataType[DataType["DT_INVALID"] = 0] = "DT_INVALID";
    // Data types that all computation devices are expected to be
    // capable to support.
    DataType[DataType["DT_FLOAT"] = 1] = "DT_FLOAT";
    DataType[DataType["DT_DOUBLE"] = 2] = "DT_DOUBLE";
    DataType[DataType["DT_INT32"] = 3] = "DT_INT32";
    DataType[DataType["DT_UINT8"] = 4] = "DT_UINT8";
    DataType[DataType["DT_INT16"] = 5] = "DT_INT16";
    DataType[DataType["DT_INT8"] = 6] = "DT_INT8";
    DataType[DataType["DT_STRING"] = 7] = "DT_STRING";
    DataType[DataType["DT_COMPLEX64"] = 8] = "DT_COMPLEX64";
    DataType[DataType["DT_INT64"] = 9] = "DT_INT64";
    DataType[DataType["DT_BOOL"] = 10] = "DT_BOOL";
    DataType[DataType["DT_QINT8"] = 11] = "DT_QINT8";
    DataType[DataType["DT_QUINT8"] = 12] = "DT_QUINT8";
    DataType[DataType["DT_QINT32"] = 13] = "DT_QINT32";
    DataType[DataType["DT_BFLOAT16"] = 14] = "DT_BFLOAT16";
    DataType[DataType["DT_QINT16"] = 15] = "DT_QINT16";
    DataType[DataType["DT_QUINT16"] = 16] = "DT_QUINT16";
    DataType[DataType["DT_UINT16"] = 17] = "DT_UINT16";
    DataType[DataType["DT_COMPLEX128"] = 18] = "DT_COMPLEX128";
    DataType[DataType["DT_HALF"] = 19] = "DT_HALF";
    DataType[DataType["DT_RESOURCE"] = 20] = "DT_RESOURCE";
    DataType[DataType["DT_VARIANT"] = 21] = "DT_VARIANT";
    DataType[DataType["DT_UINT32"] = 22] = "DT_UINT32";
    DataType[DataType["DT_UINT64"] = 23] = "DT_UINT64";
    // Do not use!  These are only for parameters.  Every enum above
    // should have a corresponding value below (verified by types_test).
    DataType[DataType["DT_FLOAT_REF"] = 101] = "DT_FLOAT_REF";
    DataType[DataType["DT_DOUBLE_REF"] = 102] = "DT_DOUBLE_REF";
    DataType[DataType["DT_INT32_REF"] = 103] = "DT_INT32_REF";
    DataType[DataType["DT_UINT8_REF"] = 104] = "DT_UINT8_REF";
    DataType[DataType["DT_INT16_REF"] = 105] = "DT_INT16_REF";
    DataType[DataType["DT_INT8_REF"] = 106] = "DT_INT8_REF";
    DataType[DataType["DT_STRING_REF"] = 107] = "DT_STRING_REF";
    DataType[DataType["DT_COMPLEX64_REF"] = 108] = "DT_COMPLEX64_REF";
    DataType[DataType["DT_INT64_REF"] = 109] = "DT_INT64_REF";
    DataType[DataType["DT_BOOL_REF"] = 110] = "DT_BOOL_REF";
    DataType[DataType["DT_QINT8_REF"] = 111] = "DT_QINT8_REF";
    DataType[DataType["DT_QUINT8_REF"] = 112] = "DT_QUINT8_REF";
    DataType[DataType["DT_QINT32_REF"] = 113] = "DT_QINT32_REF";
    DataType[DataType["DT_BFLOAT16_REF"] = 114] = "DT_BFLOAT16_REF";
    DataType[DataType["DT_QINT16_REF"] = 115] = "DT_QINT16_REF";
    DataType[DataType["DT_QUINT16_REF"] = 116] = "DT_QUINT16_REF";
    DataType[DataType["DT_UINT16_REF"] = 117] = "DT_UINT16_REF";
    DataType[DataType["DT_COMPLEX128_REF"] = 118] = "DT_COMPLEX128_REF";
    DataType[DataType["DT_HALF_REF"] = 119] = "DT_HALF_REF";
    DataType[DataType["DT_RESOURCE_REF"] = 120] = "DT_RESOURCE_REF";
    DataType[DataType["DT_VARIANT_REF"] = 121] = "DT_VARIANT_REF";
    DataType[DataType["DT_UINT32_REF"] = 122] = "DT_UINT32_REF";
    DataType[DataType["DT_UINT64_REF"] = 123] = "DT_UINT64_REF";
})($da1154ef7a939058$export$45c69700ee30a78c || ($da1154ef7a939058$export$45c69700ee30a78c = {}));
var $da1154ef7a939058$export$c7aebf4a33f92df2;
(function(SaverDef) {
    /** CheckpointFormatVersion enum. */ let CheckpointFormatVersion;
    (function(CheckpointFormatVersion) {
        CheckpointFormatVersion[CheckpointFormatVersion["LEGACY"] = 0] = "LEGACY";
        CheckpointFormatVersion[CheckpointFormatVersion["V1"] = 1] = "V1";
        CheckpointFormatVersion[CheckpointFormatVersion["V2"] = 2] = "V2";
    })(CheckpointFormatVersion = SaverDef.CheckpointFormatVersion || (SaverDef.CheckpointFormatVersion = {}));
})($da1154ef7a939058$export$c7aebf4a33f92df2 || ($da1154ef7a939058$export$c7aebf4a33f92df2 = {}));

});

parcelRegister("dWfqP", function(module, exports) {

$parcel$export(module.exports, "getRegisteredOp", () => $a25ca992a33088d7$export$ad480e5d0b303fdc);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $a25ca992a33088d7$var$CUSTOM_OPS = {};
function $a25ca992a33088d7$export$670e5ae0b581ed28(name, opFunc) {
    const opMapper = {
        tfOpName: name,
        category: 'custom',
        inputs: [],
        attrs: [],
        customExecutor: opFunc
    };
    $a25ca992a33088d7$var$CUSTOM_OPS[name] = opMapper;
}
function $a25ca992a33088d7$export$ad480e5d0b303fdc(name) {
    return $a25ca992a33088d7$var$CUSTOM_OPS[name];
}
function $a25ca992a33088d7$export$26ff69eae92eb5cb(name) {
    delete $a25ca992a33088d7$var$CUSTOM_OPS[name];
}

});

parcelRegister("9PnRL", function(module, exports) {

$parcel$export(module.exports, "getParamValue", () => $727b63cbe12c1384$export$390042a9afe1baa5);
$parcel$export(module.exports, "getTensor", () => $727b63cbe12c1384$export$c5e50df225428195);
$parcel$export(module.exports, "parseNodeName", () => $727b63cbe12c1384$export$67aec20b8c372baf);
$parcel$export(module.exports, "getTensorsForCurrentContext", () => $727b63cbe12c1384$export$d8cd584ff358961a);
$parcel$export(module.exports, "getNodeNameAndIndex", () => $727b63cbe12c1384$export$6cbb65bf9e07a72);
$parcel$export(module.exports, "getPadding", () => $727b63cbe12c1384$export$d7501e6bee71bfee);
$parcel$export(module.exports, "cloneTensor", () => $727b63cbe12c1384$export$c2185cfeaef7ba84);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $5TuCW = parcelRequire("5TuCW");
var $jjNRA = parcelRequire("jjNRA");
function $727b63cbe12c1384$export$390042a9afe1baa5(paramName, node, tensorMap, context, resourceManager) {
    const inputParam = node.inputParams[paramName];
    if (inputParam && inputParam.inputIndexStart !== undefined) {
        const start = inputParam.inputIndexStart;
        const end = inputParam.inputIndexEnd === 0 ? undefined : inputParam.inputIndexEnd === undefined ? start + 1 : inputParam.inputIndexEnd;
        const shiftedStart = start < 0 ? node.inputNames.length + start : start;
        if (inputParam.type === 'tensor') return $727b63cbe12c1384$export$c5e50df225428195(node.inputNames[shiftedStart], tensorMap, context, resourceManager);
        if (inputParam.type === 'tensors') {
            // TODO(mattSoulanille): This filters out NoOp nodes during execution, but
            // these should really never be in the execution graph in the first place.
            // They're necessary for ordering the graph, but should not be visible
            // during execution. Perhaps have different sets of children, one for
            // control dependencies and another for real dependencies.
            const inputs = node.inputs.slice(start, end);
            const inputNames = node.inputNames.slice(start, end).filter((_name, index)=>{
                var _a;
                return ((_a = inputs[index]) === null || _a === void 0 ? void 0 : _a.op) !== 'NoOp';
            });
            return inputNames.map((name)=>$727b63cbe12c1384$export$c5e50df225428195(name, tensorMap, context, resourceManager));
        }
        const tensor = $727b63cbe12c1384$export$c5e50df225428195(node.inputNames[shiftedStart], tensorMap, context, resourceManager);
        const data = tensor.dataSync();
        return inputParam.type === 'number' ? data[0] : (0, $jjNRA).toNestedArray(tensor.shape, data);
    }
    const attrParam = node.attrParams[paramName];
    return attrParam && attrParam.value;
}
function $727b63cbe12c1384$export$c5e50df225428195(name, tensorsMap, context, resourceManager) {
    const [nodeName, index] = $727b63cbe12c1384$export$67aec20b8c372baf(name, context);
    if (resourceManager != null) {
        const tensor = resourceManager.getHashTableHandleByName(nodeName);
        if (tensor != null) return tensor;
    }
    const contextId = context.currentContextIds.find((contextId)=>{
        return !!tensorsMap[$727b63cbe12c1384$var$getNodeNameWithContextId(nodeName, contextId)];
    });
    return contextId !== undefined ? tensorsMap[$727b63cbe12c1384$var$getNodeNameWithContextId(nodeName, contextId)][index] : undefined;
}
function $727b63cbe12c1384$export$d8cd584ff358961a(name, tensorsMap, context) {
    return tensorsMap[$727b63cbe12c1384$var$getNodeNameWithContextId(name, context.currentContextId)];
}
function $727b63cbe12c1384$export$6cbb65bf9e07a72(inputName, context) {
    const [nodeName, index, outputName] = $727b63cbe12c1384$export$67aec20b8c372baf(inputName, context);
    return [
        $727b63cbe12c1384$var$getNodeNameWithContextId(nodeName, context && context.currentContextId),
        index,
        outputName
    ];
}
function $727b63cbe12c1384$var$getNodeNameWithContextId(name, contextId) {
    return !!contextId ? `${name}-${contextId}` : name;
}
function $727b63cbe12c1384$export$67aec20b8c372baf(name, context) {
    if (name === '') return [
        '',
        0,
        undefined
    ];
    const isCacheEnabled = context != null && context.parseNodeNameCache != null;
    if (isCacheEnabled) {
        const cachedResult = context.parseNodeNameCache.get(name);
        if (cachedResult != null) return cachedResult;
    }
    const parts = name.split(':');
    let result;
    if (parts.length === 1) result = [
        name,
        0,
        undefined
    ];
    else {
        const nodeName = parts[0];
        const outputName = parts.length === 3 ? parts[1] : undefined;
        const index = Number(parts[parts.length - 1]);
        result = [
            nodeName,
            index,
            outputName
        ];
    }
    if (isCacheEnabled) context.parseNodeNameCache.set(name, result);
    return result;
}
function $727b63cbe12c1384$export$65980d18b75784e2(arr, size) {
    const res = [];
    for(let i = 0; i < arr.length; i += size)res.push(arr.slice(i, i + size));
    return res;
}
function $727b63cbe12c1384$export$d7501e6bee71bfee(node, tensorMap, context) {
    let pad = $727b63cbe12c1384$export$390042a9afe1baa5('pad', node, tensorMap, context);
    if (pad === 'explicit') {
        // This is 1d array, we need to convert it to 2d array
        pad = $727b63cbe12c1384$export$390042a9afe1baa5('explicitPaddings', node, tensorMap, context);
        const explicitPadding = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        for(let i = 0; i < 4; i++){
            explicitPadding[i][0] = pad[i * 2];
            explicitPadding[i][1] = pad[i * 2 + 1];
        }
        return explicitPadding;
    }
    return pad;
}
function $727b63cbe12c1384$export$c2185cfeaef7ba84(tensor) {
    return tensor.kept ? tensor : (0, $5TuCW.clone)(tensor);
}

});

parcelRegister("cCcNy", function(module, exports) {

$parcel$export(module.exports, "json", () => $92f2f618b7788456$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $92f2f618b7788456$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Add',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AddV2',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AddN',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'BiasAdd',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sub',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RealDiv',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Div',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'DivNoNan',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FloorDiv',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Mul',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Maximum',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Minimum',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Pow',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SquaredDifference',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Mod',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FloorMod',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("6T10F", function(module, exports) {

$parcel$export(module.exports, "json", () => $5038a9a026061abc$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $5038a9a026061abc$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Abs',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Acos',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Asin',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atan2',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Ceil',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ClipByValue',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'clipValueMin',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'clipValueMax',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Complex',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'real',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'imag',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ComplexAbs',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cos',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cosh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Elu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Exp',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Floor',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Log',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Imag',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'outputType',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Neg',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Real',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'outputType',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Prelu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'alpha',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Relu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Relu6',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Selu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sigmoid',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sin',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sinh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sqrt',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Rsqrt',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Square',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tanh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sign',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Round',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Expm1',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Log1p',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Reciprocal',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Softplus',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Asinh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Acosh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atanh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Erf',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LeakyRelu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'alpha',
                'name': 'alpha',
                'type': 'number',
                'defaultValue': 0.2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsNan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsFinite',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsInf',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("25do8", function(module, exports) {

$parcel$export(module.exports, "json", () => $18466f05b5f0cde0$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $18466f05b5f0cde0$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'EmptyTensorList',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 1,
                'name': 'maxNumElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LoopCond',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'pred',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Switch',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'pred',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Merge',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Enter',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'frame_name',
                'name': 'frameName',
                'type': 'string'
            },
            {
                'tfName': 'is_constant',
                'name': 'isConstant',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Exit',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'NextIteration',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'size',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'dynamic_size',
                'name': 'dynamicSize',
                'type': 'bool'
            },
            {
                'tfName': 'clear_after_read',
                'name': 'clearAfterRead',
                'type': 'bool'
            },
            {
                'tfName': 'identical_element_shapes',
                'name': 'identicalElementShapes',
                'type': 'bool'
            },
            {
                'tfName': 'tensor_array_name',
                'name': 'name',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayWriteV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayReadV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayGatherV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayScatterV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayConcatV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape_except0',
                'name': 'elementShapeExcept0',
                'type': 'shape',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArraySplitV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'lengths',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorArraySizeV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'flowIn',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayCloseV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'StatelessIf',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'cond',
                'type': 'tensor'
            },
            {
                'start': 1,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'then_branch',
                'name': 'thenBranch',
                'type': 'func'
            },
            {
                'tfName': 'else_branch',
                'name': 'elseBranch',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'If',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'cond',
                'type': 'tensor'
            },
            {
                'start': 1,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'then_branch',
                'name': 'thenBranch',
                'type': 'func'
            },
            {
                'tfName': 'else_branch',
                'name': 'elseBranch',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'StatelessWhile',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'cond',
                'name': 'cond',
                'type': 'func'
            },
            {
                'tfName': 'body',
                'name': 'body',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'While',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'cond',
                'name': 'cond',
                'type': 'func'
            },
            {
                'tfName': 'body',
                'name': 'body',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'TensorListScatter',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListScatterV2',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 3,
                'name': 'numElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListGather',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListGetItem',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListSetItem',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListReserve',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 1,
                'name': 'numElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListFromTensor',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListStack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            },
            {
                'tfName': 'num_elements',
                'name': 'numElements',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListSplit',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 2,
                'name': 'lengths',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListConcat',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListConcatV2',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListPopBack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListPushBack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListLength',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'TensorListResize',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("kQhpu", function(module, exports) {

$parcel$export(module.exports, "json", () => $f2c62b406e0cb44f$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $f2c62b406e0cb44f$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'AvgPool',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPool',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': [],
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPoolWithArgmax',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'include_batch_in_index',
                'name': 'includeBatchInIndex',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AvgPool3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPool3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Conv1D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'stride',
                'name': 'stride',
                'type': 'number'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NWC'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'dilation',
                'name': 'dilation',
                'type': 'number',
                'defaultValue': 1
            }
        ]
    },
    {
        'tfOpName': 'Conv2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'useCudnnOnGpu',
                'name': 'useCudnnOnGpu',
                'type': 'bool'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': '_FusedConv2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'use_cudnn_on_gpu',
                'name': 'useCudnnOnGpu',
                'type': 'bool',
                'defaultValue': true
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'defaultValue': [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.0001
            },
            {
                'tfName': 'leakyrelu_alpha',
                'name': 'leakyreluAlpha',
                'type': 'number',
                'defaultValue': 0.2
            }
        ]
    },
    {
        'tfOpName': 'Conv2DBackpropInput',
        'category': 'convolution',
        'inputs': [
            {
                'start': 2,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 0,
                'name': 'outputShape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'DepthwiseConv2d',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'DepthwiseConv2dNative',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'FusedDepthwiseConv2dNative',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'defaultValue': [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            }
        ]
    },
    {
        'tfOpName': 'Conv3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Dilation2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'rates',
                'name': 'dilations',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            }
        ]
    }
];

});

parcelRegister("iKevB", function(module, exports) {

$parcel$export(module.exports, "json", () => $da57c6fbc0e8e275$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $da57c6fbc0e8e275$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Fill',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            },
            {
                'start': 1,
                'name': 'value',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LinSpace',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'start',
                'type': 'number'
            },
            {
                'start': 1,
                'name': 'stop',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'num',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'OneHot',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'depth',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'onValue',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'start': 3,
                'name': 'offValue',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Ones',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'OnesLike',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'RandomStandardNormal',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RandomUniform',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'minval',
                'name': 'minval',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'maxval',
                'name': 'maxval',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RandomUniformInt',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'minval',
                'name': 'minval',
                'type': 'number'
            },
            {
                'tfName': 'maxval',
                'name': 'maxval',
                'type': 'number'
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Range',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'start',
                'type': 'number'
            },
            {
                'start': 1,
                'name': 'stop',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'step',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'Tidx',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TruncatedNormal',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'means',
                'name': 'mean',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'stddev',
                'name': 'stdDev',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number'
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Zeros',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'ZerosLike',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Multinomial',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'logits',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numSamples',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number'
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'output_dtype',
                'name': 'output_dtype',
                'type': 'dtype'
            }
        ]
    }
];

});

parcelRegister("gul1X", function(module, exports) {

$parcel$export(module.exports, "json", () => $c00fc2ecdf828344$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $c00fc2ecdf828344$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'NonMaxSuppressionV2',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV3',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV4',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'T_threshold',
                'name': 'threshold',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'pad_to_max_output_size',
                'name': 'padToMaxOutputSize',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV5',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            },
            {
                'start': 5,
                'name': 'softNmsSigma',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'Where',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ListDiff',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("8ADHf", function(module, exports) {

$parcel$export(module.exports, "json", () => $64107a6ca6735dbb$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $64107a6ca6735dbb$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'LowerBound',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'sortedSequence',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'TopKV2',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'k',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'sorted',
                'name': 'sorted',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'UpperBound',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'sortedSequence',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Unique',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'UniqueV2',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("cf9s6", function(module, exports) {

$parcel$export(module.exports, "json", () => $8e9e37ca1fe0a351$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $8e9e37ca1fe0a351$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'PlaceholderWithDefault',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'default',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'shape',
                'name': 'shape',
                'type': 'shape'
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Placeholder',
        'category': 'graph',
        'attrs': [
            {
                'tfName': 'shape',
                'name': 'shape',
                'type': 'shape'
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Const',
        'category': 'graph'
    },
    {
        'tfOpName': 'Identity',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'IdentityN',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'x',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Snapshot',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Rank',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Size',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Shape',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'ShapeN',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'x',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Print',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'data',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'message',
                'name': 'message',
                'type': 'string'
            },
            {
                'tfName': 'first_n',
                'name': 'firstN',
                'type': 'number',
                'notSupported': true
            },
            {
                'tfName': 'summarize',
                'name': 'summarize',
                'type': 'number',
                'defaultValue': 3
            }
        ]
    },
    {
        'tfOpName': 'NoOp',
        'category': 'graph',
        'inputs': []
    },
    {
        'tfOpName': 'StopGradient',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'FakeQuantWithMinMaxVars',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'min',
                'name': 'min',
                'type': 'number'
            },
            {
                'tfName': 'max',
                'name': 'max',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("agimj", function(module, exports) {

$parcel$export(module.exports, "json", () => $7789a3b787b221c4$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $7789a3b787b221c4$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'HashTable',
        'category': 'hash_table',
        'inputs': [],
        'attrs': [
            {
                'tfName': 'shared_name',
                'name': 'sharedName',
                'type': 'string'
            },
            {
                'tfName': 'use_node_name_sharing',
                'name': 'useNodeNameSharing',
                'type': 'bool'
            },
            {
                'tfName': 'key_dtype',
                'name': 'keyDType',
                'type': 'dtype'
            },
            {
                'tfName': 'value_dtype',
                'name': 'valueDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'HashTableV2',
        'category': 'hash_table',
        'inputs': [],
        'attrs': [
            {
                'tfName': 'shared_name',
                'name': 'sharedName',
                'type': 'string'
            },
            {
                'tfName': 'use_node_name_sharing',
                'name': 'useNodeNameSharing',
                'type': 'bool'
            },
            {
                'tfName': 'key_dtype',
                'name': 'keyDType',
                'type': 'dtype'
            },
            {
                'tfName': 'value_dtype',
                'name': 'valueDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LookupTableImport',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableImportV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableFind',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableFindV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableSize',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'LookupTableSizeV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'InitializeTable',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'InitializeTableV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("j4qIR", function(module, exports) {

$parcel$export(module.exports, "json", () => $de231e99c3a957b4$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $de231e99c3a957b4$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'ResizeBilinear',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'align_corners',
                'name': 'alignCorners',
                'type': 'bool'
            },
            {
                'tfName': 'half_pixel_centers',
                'name': 'halfPixelCenters',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ResizeNearestNeighbor',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'align_corners',
                'name': 'alignCorners',
                'type': 'bool'
            },
            {
                'tfName': 'half_pixel_centers',
                'name': 'halfPixelCenters',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'CropAndResize',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'image',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'boxInd',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'cropSize',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'method',
                'name': 'method',
                'type': 'string'
            },
            {
                'tfName': 'extrapolation_value',
                'name': 'extrapolationValue',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'ImageProjectiveTransformV3',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'transforms',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'fillValue',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'interpolation',
                'name': 'interpolation',
                'type': 'string'
            },
            {
                'tfName': 'fill_mode',
                'name': 'fillMode',
                'type': 'string'
            }
        ]
    }
];

});

parcelRegister("gUOFE", function(module, exports) {

$parcel$export(module.exports, "json", () => $c5092e77366f20b6$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $c5092e77366f20b6$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Equal',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'NotEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Greater',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'GreaterEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Less',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LessEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalAnd',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalNot',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalOr',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Select',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SelectV2',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BitwiseAnd',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("6seiJ", function(module, exports) {

$parcel$export(module.exports, "json", () => $4b307384703dd93a$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $4b307384703dd93a$export$7b419323e6ed4f31 = [
    {
        'tfOpName': '_FusedMatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.0001
            },
            {
                'tfName': 'transpose_a',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'transpose_b',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'leakyrelu_alpha',
                'name': 'leakyreluAlpha',
                'type': 'number',
                'defaultValue': 0.2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'transpose_a',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'transpose_b',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BatchMatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'adj_x',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'adj_y',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BatchMatMulV2',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'adj_x',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'adj_y',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Transpose',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'perm',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Einsum',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'equation',
                'name': 'equation',
                'type': 'string'
            },
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'MatrixBandPart',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numLower',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numUpper',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("1st1Z", function(module, exports) {

$parcel$export(module.exports, "json", () => $10feecedb5ca137c$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $10feecedb5ca137c$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'EuclideanNorm',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool',
                'defaultValue': false
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNorm',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNormV2',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNormV3',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LRN',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'depth_radius',
                'name': 'radius',
                'type': 'number',
                'defaultValue': 5
            },
            {
                'tfName': 'bias',
                'name': 'bias',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'alpha',
                'name': 'alpha',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'beta',
                'name': 'beta',
                'type': 'number',
                'defaultValue': 0.5
            }
        ]
    },
    {
        'tfOpName': 'Softmax',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'LogSoftmax',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("l0Shb", function(module, exports) {

$parcel$export(module.exports, "json", () => $f4c3b3292cb4fff9$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $f4c3b3292cb4fff9$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Bincount',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'weights',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'DenseBincount',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'weights',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'binary_output',
                'name': 'binaryOutput',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Max',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Mean',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Min',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Sum',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'All',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Any',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'ArgMax',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'ArgMin',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'Prod',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cumprod',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'exclusive',
                'name': 'exclusive',
                'type': 'bool'
            },
            {
                'tfName': 'reverse',
                'name': 'reverse',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Cumsum',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'exclusive',
                'name': 'exclusive',
                'type': 'bool'
            },
            {
                'tfName': 'reverse',
                'name': 'reverse',
                'type': 'bool'
            }
        ]
    }
];

});

parcelRegister("eTKRE", function(module, exports) {

$parcel$export(module.exports, "json", () => $ad8a8e039d544a71$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $ad8a8e039d544a71$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'ConcatV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'end': -1,
                'name': 'tensors',
                'type': 'tensors'
            },
            {
                'start': -1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            }
        ]
    },
    {
        'tfOpName': 'Concat',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 1,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            },
            {
                'start': 0,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            }
        ]
    },
    {
        'tfOpName': 'GatherV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'batch_dims',
                'name': 'batchDims',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Gather',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Reverse',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'dims',
                'type': 'bool[]'
            }
        ]
    },
    {
        'tfOpName': 'ReverseV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Slice',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'begin',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'size',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'StridedSlice',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'begin',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'end',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'strides',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'begin_mask',
                'name': 'beginMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'end_mask',
                'name': 'endMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'new_axis_mask',
                'name': 'newAxisMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'ellipsis_mask',
                'name': 'ellipsisMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'shrink_axis_mask',
                'name': 'shrinkAxisMask',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Pack',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Unpack',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'num',
                'name': 'num',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tile',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'reps',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Split',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'start': 1,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_split',
                'name': 'numOrSizeSplits',
                'type': 'number',
                'defaultValue': 1
            }
        ]
    },
    {
        'tfOpName': 'SplitV',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numOrSizeSplits',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'ScatterNd',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'GatherNd',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseToDense',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'sparseIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'sparseValues',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'defaultValue': false,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorScatterUpdate',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("5vXpX", function(module, exports) {

$parcel$export(module.exports, "json", () => $403df01f4cd348e9$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $403df01f4cd348e9$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'SparseFillEmptyRows',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'denseShape',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseReshape',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'inputIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'inputShape',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'newShape',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SparseSegmentMean',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'segmentIds',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseSegmentSum',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'segmentIds',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("kuUeg", function(module, exports) {

$parcel$export(module.exports, "json", () => $eec239eec40164f1$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $eec239eec40164f1$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'FFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'IFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'RFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'fft_length',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IRFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'fft_length',
                'type': 'number',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("3Fxik", function(module, exports) {

$parcel$export(module.exports, "json", () => $2abf07103affb121$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $2abf07103affb121$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'StaticRegexReplace',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'pattern',
                'name': 'pattern',
                'type': 'string'
            },
            {
                'tfName': 'rewrite',
                'name': 'rewrite',
                'type': 'string'
            },
            {
                'tfName': 'replace_global',
                'name': 'replaceGlobal',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'StringNGrams',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'dataSplits',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'separator',
                'name': 'separator',
                'type': 'string'
            },
            {
                'tfName': 'ngram_widths',
                'name': 'nGramWidths',
                'type': 'number[]'
            },
            {
                'tfName': 'left_pad',
                'name': 'leftPad',
                'type': 'string'
            },
            {
                'tfName': 'right_pad',
                'name': 'rightPad',
                'type': 'string'
            },
            {
                'tfName': 'pad_width',
                'name': 'padWidth',
                'type': 'number'
            },
            {
                'tfName': 'preserve_short_sequences',
                'name': 'preserveShortSequences',
                'type': 'bool'
            }
        ],
        'outputs': [
            'ngrams',
            'ngrams_splits'
        ]
    },
    {
        'tfOpName': 'StringSplit',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'delimiter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'skip_empty',
                'name': 'skipEmpty',
                'type': 'bool'
            }
        ],
        'outputs': [
            'indices',
            'values',
            'shape'
        ]
    },
    {
        'tfOpName': 'StringToHashBucketFast',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_buckets',
                'name': 'numBuckets',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("3km3B", function(module, exports) {

$parcel$export(module.exports, "json", () => $26c4596fea9f489e$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $26c4596fea9f489e$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Cast',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'SrcT',
                'name': 'sdtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'DstT',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'ExpandDims',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'MirrorPad',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'mode',
                'name': 'mode',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'Pad',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'constant_value',
                'name': 'constantValue',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'PadV2',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'constantValue',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Reshape',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'EnsureShape',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Squeeze',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'tfDeprecatedName': 'squeeze_dims',
                'name': 'axis',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'SpaceToBatchND',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'blockShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'paddings',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'BatchToSpaceND',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'blockShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'crops',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'DepthToSpace',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'block_size',
                'name': 'blockSize',
                'type': 'number'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'BroadcastTo',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': []
    },
    {
        'tfOpName': 'BroadcastArgs',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 's0',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 's1',
                'type': 'tensor'
            }
        ],
        'attrs': []
    }
];

});


parcelRegister("eZl48", function(module, exports) {

$parcel$export(module.exports, "GraphExecutor", () => $ae971a607c14eb85$export$289b3892ec35f79a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $ibsdL = parcelRequire("ibsdL");
var $c2DT1 = parcelRequire("c2DT1");
var $jjNRA = parcelRequire("jjNRA");

var $9PnRL = parcelRequire("9PnRL");

var $11iKq = parcelRequire("11iKq");

var $hv42p = parcelRequire("hv42p");

var $a96bd = parcelRequire("a96bd");
class $ae971a607c14eb85$export$289b3892ec35f79a {
    get weightIds() {
        return this.parent ? this.parent.weightIds : this._weightIds;
    }
    get functionExecutorMap() {
        return this.parent ? this.parent.functionExecutorMap : this._functionExecutorMap;
    }
    get weightMap() {
        return this.parent ? this.parent.weightMap : this._weightMap;
    }
    set weightMap(weightMap) {
        const weightIds = Object.keys(weightMap).map((key)=>weightMap[key].map((tensor)=>tensor.id));
        this._weightIds = [].concat(...weightIds);
        this._weightMap = weightMap;
    }
    /**
     * Set `ResourceManager` shared by executors of a model.
     * @param resourceManager: `ResourceManager` of the `GraphModel`.
     */ set resourceManager(resourceManager) {
        this._resourceManager = resourceManager;
    }
    get inputs() {
        return this._inputs.map((node)=>{
            return {
                name: node.name,
                shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
                dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
            };
        });
    }
    get outputs() {
        return this._outputs.map((node)=>{
            return {
                name: node.name,
                shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
                dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
            };
        });
    }
    get inputNodes() {
        return this._inputs.map((node)=>node.signatureKey || node.name);
    }
    get outputNodes() {
        return this._outputs.map((node)=>{
            const name = node.signatureKey || node.name;
            return node.defaultOutput ? `${name}:${node.defaultOutput}` : name;
        });
    }
    get functions() {
        return Object.keys(this._functions).reduce((map, key)=>{
            map[key] = this._functions[key].signature;
            return map;
        }, {});
    }
    /**
     *
     * @param graph Graph the model or function graph to be executed.
     * @param parent When building function exector you need to set the parent
     * executor. Since the weights and function executor maps are set at parant
     * level, that function executor can access the function maps and weight maps
     * through the parent.
     */ constructor(graph, parent){
        this.graph = graph;
        this.parent = parent;
        this.compiledMap = new Map();
        this.parseNodeNameCache = new Map();
        this._weightMap = {};
        this.SEPARATOR = ',';
        this._functions = {};
        this._functionExecutorMap = {};
        this.keepIntermediateTensors = false;
        this._outputs = graph.outputs;
        this._inputs = graph.inputs;
        this._initNodes = graph.initNodes;
        this._signature = graph.signature;
        this._functions = graph.functions;
        // create sub-graph executors
        if (graph.functions != null) Object.keys(graph.functions).forEach((name)=>{
            this._functionExecutorMap[name] = new $ae971a607c14eb85$export$289b3892ec35f79a(graph.functions[name], this);
        });
    }
    getCompilationKey(inputs, outputs) {
        const sortedInputs = inputs.map((node)=>node.name).sort();
        const sortedOutputs = outputs.map((node)=>node.name).sort();
        return sortedInputs.join(this.SEPARATOR) + '--' + sortedOutputs.join(this.SEPARATOR);
    }
    /**
     * Compiles the inference graph and returns the minimal set of nodes that are
     * required for execution, in the correct execution order.
     * @returns {Object} compilation The compile result.
     * @returns {Node[]} compilation.orderedNodes Nodes in the correct execution
     *     order.
     * @returns {Map<string, Node[]>} compilation.nodeLiveUntilMap A map from node
     *     to disposable nodes after its execution. That is, for a node `x`,
     *     `nodeLiveUntilMap[x]` indicates all nodes whose intermediate
     *     tensors should be disposed after `x` is executed.
     */ compile(inputs, outputs) {
        const executionInfo = (0, $a96bd.getExecutionSubgraph)(inputs, outputs, this.weightMap, this._initNodes);
        const { missingInputs: missingInputs, dynamicNode: dynamicNode, syncInputs: syncInputs } = executionInfo;
        if (dynamicNode != null) throw new Error(`This execution contains the node '${dynamicNode.name}', which has ` + `the dynamic op '${dynamicNode.op}'. Please use ` + `model.executeAsync() instead. Alternatively, to avoid the ` + `dynamic ops, specify the inputs [${syncInputs}]`);
        if (missingInputs.length > 0) {
            const outNames = outputs.map((n)=>n.name);
            const inNames = Object.keys(inputs);
            throw new Error(`Cannot compute the outputs [${outNames}] from the provided inputs ` + `[${inNames}]. Missing the following inputs: [${missingInputs}]`);
        }
        const orderedNodes = (0, $a96bd.getNodesInTopologicalOrder)(this.graph, executionInfo);
        const nodeLiveUntilMap = (0, $a96bd.getNodeLiveUntilMap)(orderedNodes);
        return {
            orderedNodes: orderedNodes,
            nodeLiveUntilMap: nodeLiveUntilMap
        };
    }
    cloneAndKeepTensor(tensor) {
        if (tensor == null) return null;
        const clone = tensor.clone();
        // Keep the clone because`model.execute()` may be called within
        // a `tidy()`, but the user may inspect these tensors after the
        // tidy.
        (0, $c2DT1.keep)(clone);
        return clone;
    }
    cloneTensorList(tensors) {
        if (!tensors) return null;
        const clonedTensor = tensors.map((tensor)=>{
            return this.cloneAndKeepTensor(tensor);
        });
        return clonedTensor;
    }
    cloneTensorMap(tensorsMap) {
        return Object.fromEntries(Object.entries(tensorsMap).map(([name, tensorsList])=>{
            return [
                name,
                this.cloneTensorList(tensorsList)
            ];
        }));
    }
    /**
     * Executes the inference for given input tensors.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model, if
     * no outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     */ execute(inputs, outputs) {
        // Dispose any tensors from a prior run to avoid leaking them.
        this.disposeIntermediateTensors();
        inputs = this.mapInputs(inputs);
        const names = Object.keys(inputs).sort();
        this.checkInputs(inputs);
        this.checkInputShapeAndType(inputs);
        outputs = this.mapOutputs(outputs);
        this.checkOutputs(outputs);
        const inputNodes = names.map((name)=>this.graph.nodes[(0, $9PnRL.parseNodeName)(name)[0]]);
        const outputNodeNames = outputs.map((name)=>(0, $9PnRL.parseNodeName)(name)[0]);
        const outputNodeNameSet = new Set(outputNodeNames);
        let outputNodes = outputNodeNames.map((name)=>this.graph.nodes[name]);
        // If no outputs are specified, then use the default outputs of the model.
        if (outputNodes.length === 0) outputNodes = this._outputs;
        const compilationKey = this.getCompilationKey(inputNodes, outputNodes);
        // Do nothing if the compiled graph cache contains the input.
        let compilation = this.compiledMap.get(compilationKey);
        if (compilation == null) {
            compilation = this.compile(inputs, outputNodes);
            this.compiledMap.set(compilationKey, compilation);
        }
        // Keep tensors if KEEP_INTERMEDIATE_TENSORS is on.
        try {
            this.keepIntermediateTensors = (0, $ibsdL.env)().getBool('KEEP_INTERMEDIATE_TENSORS');
        } catch (e) {
            this.keepIntermediateTensors = false;
            console.warn(e.message);
        }
        const tensorArrayMap = {};
        const tensorListMap = {};
        return (0, $c2DT1.tidy)(()=>{
            const context = new (0, $hv42p.ExecutionContext)(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap, this.parseNodeNameCache);
            const tensorsMap = Object.assign({}, this.weightMap);
            if (this.keepIntermediateTensors) this.clonedTensorsMap = this.cloneTensorMap(this.weightMap);
            Object.keys(inputs).forEach((name)=>{
                const [nodeName, index] = (0, $9PnRL.parseNodeName)(name, context);
                const tensors = [];
                tensors[index] = inputs[name];
                tensorsMap[nodeName] = tensors;
                if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(tensors);
            });
            const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
            const { orderedNodes: orderedNodes, nodeLiveUntilMap: nodeLiveUntilMap } = compilation;
            for (const node of orderedNodes){
                if (tensorsMap[node.name]) continue;
                const tensors = (0, $11iKq.executeOp)(node, tensorsMap, context, this._resourceManager);
                if ((0, $jjNRA).isPromise(tensors)) throw new Error(`The execution of the op '${node.op}' returned a promise. ` + `Please use model.executeAsync() instead.`);
                tensorsMap[node.name] = tensors;
                if (this.keepIntermediateTensors) this.clonedTensorsMap[node.name] = this.cloneTensorList(tensors);
                this.checkTensorForDisposalWithNodeLiveUntilInfo(node, tensorsMap, context, tensorsToKeep, outputNodeNameSet, nodeLiveUntilMap.get(node.name));
            }
            // dispose the context for the root executor
            if (this.parent == null) context.dispose(tensorsToKeep);
            return outputs.map((name)=>(0, $9PnRL.getTensor)(name, tensorsMap, context));
        });
    }
    getFrozenTensorIds(tensorMap) {
        const ids = [].concat.apply([], Object.keys(tensorMap).map((key)=>tensorMap[key]).map((tensors)=>tensors.map((tensor)=>tensor.id)));
        return new Set(ids);
    }
    checkTensorForDisposal(nodeName, node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount) {
        // Skip output nodes and any control flow nodes, since its dependency is
        // tricky to track correctly.
        if ((0, $a96bd.isControlFlow)(node) || outputNodeNameSet.has(nodeName)) return;
        for (const tensor of tensorMap[nodeName]){
            if (tensor == null) continue;
            intermediateTensorConsumerCount[tensor.id] = (intermediateTensorConsumerCount[tensor.id] || 0) + node.children.length;
        }
        for (const input of node.inputs){
            // Skip any control flow nodes, since its dependency is tricky to track
            // correctly.
            if ((0, $a96bd.isControlFlow)(input)) continue;
            const tensors = (0, $9PnRL.getTensorsForCurrentContext)(input.name, tensorMap, context);
            if (tensors == null) continue;
            for (const tensor of tensors){
                if (!tensor || tensor.kept || tensorsToKeep.has(tensor.id)) continue;
                // Only intermediate nodes' tensors have counts set, not marked as
                // kept, and not in `tensorsToKeep`.
                // Input and weight nodes' tensors should exist in `tensorsToKeep`.
                // Output and control flow nodes' tensors should never have count set.
                const count = intermediateTensorConsumerCount[tensor.id];
                if (count === 1) {
                    tensor.dispose();
                    delete intermediateTensorConsumerCount[tensor.id];
                } else if (count != null) intermediateTensorConsumerCount[tensor.id]--;
            }
        }
    }
    checkTensorForDisposalWithNodeLiveUntilInfo(node, tensorMap, context, tensorsToKeep, outputNodeNameSet, liveUntilNodes) {
        function isNonDisposableNode(node) {
            // Skip output nodes and any control flow nodes, since its dependency is
            // tricky to track correctly.
            return (0, $a96bd.isControlFlow)(node) || outputNodeNameSet.has(node.name);
        }
        if ((0, $a96bd.isControlFlow)(node) || liveUntilNodes == null) return;
        for (const nodeToDispose of liveUntilNodes){
            if (isNonDisposableNode(nodeToDispose)) continue;
            const tensors = (0, $9PnRL.getTensorsForCurrentContext)(nodeToDispose.name, tensorMap, context);
            for (const tensor of tensors){
                if (!tensor || tensor.kept || tensorsToKeep.has(tensor.id)) continue;
                tensor.dispose();
            }
        }
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs output node name from the Tensorflow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     */ async executeAsync(inputs, outputs) {
        return this._executeAsync(inputs, outputs);
    }
    disposeIntermediateTensors() {
        if (!this.clonedTensorsMap) return;
        Object.values(this.clonedTensorsMap).forEach((tensorsList)=>{
            for (const tensor of tensorsList)if (tensor && !tensor.isDisposed) tensor.dispose();
        });
        this.clonedTensorsMap = null;
    }
    getIntermediateTensors() {
        return this.clonedTensorsMap;
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to
     * the outputs array.
     * @param isFunctionExecution Optional. Flag for executing a function.
     * @param tensorArrayMap Optional, global TensorArray map by id. Used for
     * function execution.
     * @param tensorArrayMap Optional global TensorList map by id. Used for
     * function execution.
     */ async _executeAsync(inputs, outputs, isFunctionExecution = false, tensorArrayMap = {}, tensorListMap = {}) {
        // Dispose any tensors from a prior run to avoid leaking them.
        this.disposeIntermediateTensors();
        if (!isFunctionExecution) {
            inputs = this.mapInputs(inputs);
            this.checkInputs(inputs);
            this.checkInputShapeAndType(inputs);
            outputs = this.mapOutputs(outputs);
            this.checkOutputs(outputs);
        }
        // Keep tensors if KEEP_INTERMEDIATE_TENSORS is on.
        try {
            this.keepIntermediateTensors = (0, $ibsdL.env)().getBool('KEEP_INTERMEDIATE_TENSORS');
        } catch (e) {
            this.keepIntermediateTensors = false;
            console.warn(e.message);
        }
        const context = new (0, $hv42p.ExecutionContext)(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap, this.parseNodeNameCache);
        if (this.keepIntermediateTensors) this.clonedTensorsMap = this.cloneTensorMap(this.weightMap);
        // Graph with control flow op requires runtime evaluation of the execution
        // order, while without control flow the execution order is pre-determined
        // in the compile method.
        const tensorsMap = await this.executeWithControlFlow(inputs, context, outputs, isFunctionExecution);
        const results = outputs.map((name)=>(0, $9PnRL.getTensor)(name, tensorsMap, context));
        // dispose all the intermediate tensors
        const outputIds = results.map((t)=>t.id);
        const inputIds = Object.keys(inputs).map((name)=>inputs[name].id);
        const keepIds = new Set([
            ...outputIds,
            ...inputIds,
            ...this.weightIds
        ]);
        Object.values(tensorsMap).forEach((tensorsList)=>{
            tensorsList.forEach((tensor)=>{
                if (tensor && !tensor.isDisposed && !keepIds.has(tensor.id)) tensor.dispose();
            });
        });
        // dispose the context for the root executor
        if (this.parent == null) context.dispose(keepIds);
        return results;
    }
    async executeFunctionAsync(inputs, tensorArrayMap, tensorListMap) {
        const mappedInputs = inputs.reduce((map, tensor, index)=>{
            map[this.inputs[index].name] = tensor;
            return map;
        }, {});
        return this._executeAsync(mappedInputs, this.outputNodes, true, tensorArrayMap, tensorListMap);
    }
    /**
     * When there are control flow nodes in the graph, the graph execution use
     * ExecutionContext to keep track of the frames and loop iterators.
     * @param inputs placeholder tensors for the graph.
     * @param context the execution context object for current execution.
     * @param outputNames Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to
     * the outputs array.
     * @param isFunctionExecution Flag for executing a function.
     */ async executeWithControlFlow(inputs, context, outputNames, isFunctionExecution) {
        const names = Object.keys(inputs);
        const inputNodes = names.map((name)=>this.graph.nodes[(0, $9PnRL.parseNodeName)(name)[0]]);
        const outputNodeNames = outputNames.map((name)=>(0, $9PnRL.parseNodeName)(name)[0]);
        const outputNodeNameSet = new Set(outputNodeNames);
        let outputNodes = outputNodeNames.map((name)=>this.graph.nodes[name]);
        // If no outputs are specified, then use the default outputs of the model.
        if (outputNodes.length === 0) outputNodes = this._outputs;
        const { usedNodes: usedNodes, missingInputs: missingInputs, dynamicNode: dynamicNode, syncInputs: syncInputs } = (0, $a96bd.getExecutionSubgraph)(inputs, outputNodes, this.weightMap, this._initNodes);
        // First nodes to execute include inputNodes, weights, and initNodes.
        const stack = [
            ...inputNodes,
            ...this.graph.weights,
            ...this._initNodes || []
        ].map((node)=>{
            return {
                node: node,
                contexts: context.currentContext
            };
        });
        const tensorsMap = Object.assign({}, this.weightMap);
        Object.keys(inputs).forEach((name)=>{
            const [nodeName, index] = (0, $9PnRL.parseNodeName)(name);
            const tensors = [];
            tensors[index] = inputs[name];
            tensorsMap[nodeName] = tensors;
        });
        const intermediateTensorConsumerCount = {};
        const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
        const added = {};
        while(stack.length > 0){
            const promises = this.processStack(inputNodes, stack, context, tensorsMap, added, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount, usedNodes);
            await Promise.all(promises);
        }
        if (dynamicNode == null && !isFunctionExecution) console.warn(`This model execution did not contain any nodes with control flow ` + `or dynamic output shapes. You can use model.execute() instead.`);
        const missingOutputs = outputNodes.filter((node)=>!(0, $a96bd.isControlFlow)(node) && !(0, $9PnRL.getTensor)(node.name, tensorsMap, context)).map((node)=>node.name);
        if (missingOutputs.length > 0) {
            let alternativeMsg = '';
            if (dynamicNode != null) alternativeMsg = `Alternatively, to avoid the dynamic ops, use model.execute() ` + `and specify the inputs [${syncInputs}]`;
            throw new Error(`Cannot compute the outputs [${missingOutputs}] from the provided ` + `inputs [${names}]. Consider providing the following inputs: ` + `[${missingInputs}]. ${alternativeMsg}`);
        }
        return tensorsMap;
    }
    processStack(inputNodes, stack, context, tensorMap, added, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount, usedNodes) {
        const promises = [];
        while(stack.length > 0){
            const item = stack.pop();
            context.currentContext = item.contexts;
            let nodeName = '';
            // The tensor of the Enter op with isConstant set should be set
            // in the parent scope, so it will be available as constant for the
            // whole loop.
            if (item.node.op === 'Enter' && (0, $9PnRL.getParamValue)('isConstant', item.node, tensorMap, context)) [nodeName] = (0, $9PnRL.getNodeNameAndIndex)(item.node.name, context);
            // only process nodes that are not in the tensorMap yet, this include
            // inputNodes and internal initNodes.
            if (tensorMap[item.node.name] == null) {
                const tensors = (0, $11iKq.executeOp)(item.node, tensorMap, context, this._resourceManager);
                if (!nodeName) [nodeName] = (0, $9PnRL.getNodeNameAndIndex)(item.node.name, context);
                const currentContext = context.currentContext;
                if ((0, $jjNRA).isPromise(tensors)) promises.push(tensors.then((t)=>{
                    tensorMap[nodeName] = t;
                    if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(t);
                    context.currentContext = currentContext;
                    this.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount);
                    this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
                    return t;
                }));
                else {
                    tensorMap[nodeName] = tensors;
                    if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(tensors);
                    this.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount);
                    this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
                }
            } else this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
        }
        return promises;
    }
    processChildNodes(node, stack, context, tensorMap, added, usedNodes) {
        node.children.forEach((childNode)=>{
            const [nodeName] = (0, $9PnRL.getNodeNameAndIndex)(childNode.name, context);
            if (added[nodeName] || !usedNodes.has(childNode.name)) return;
            // Merge op can be pushed if any of its inputs has value.
            if (childNode.op === 'Merge') {
                if (childNode.inputNames.some((name)=>{
                    return !!(0, $9PnRL.getTensor)(name, tensorMap, context);
                })) {
                    added[nodeName] = true;
                    stack.push({
                        contexts: context.currentContext,
                        node: childNode
                    });
                }
            } else if (childNode.inputNames.every((name)=>{
                return !!(0, $9PnRL.getTensor)(name, tensorMap, context);
            })) {
                added[nodeName] = true;
                stack.push({
                    contexts: context.currentContext,
                    node: childNode
                });
            }
        });
    }
    /**
     * Releases the memory used by the weight tensors.
     */ dispose() {
        Object.keys(this.weightMap).forEach((key)=>this.weightMap[key].forEach((tensor)=>tensor.dispose()));
    }
    checkInputShapeAndType(inputs) {
        Object.keys(inputs).forEach((name)=>{
            const input = inputs[name];
            const [nodeName] = (0, $9PnRL.parseNodeName)(name);
            const node = this.graph.nodes[nodeName];
            if (node.attrParams['shape'] && node.attrParams['shape'].value) {
                const shape = node.attrParams['shape'].value;
                const match = shape.length === input.shape.length && input.shape.every((dim, index)=>shape[index] === -1 || shape[index] === dim);
                (0, $jjNRA).assert(match, ()=>`The shape of dict['${node.name}'] provided in ` + `model.execute(dict) must be [${shape}], but was ` + `[${input.shape}]`);
            }
            if (node.attrParams['dtype'] && node.attrParams['dtype'].value) (0, $jjNRA).assert(input.dtype === node.attrParams['dtype'].value, ()=>`The dtype of dict['${node.name}'] provided in ` + `model.execute(dict) must be ` + `${node.attrParams['dtype'].value}, but was ${input.dtype}`);
        });
    }
    mapInputs(inputs) {
        var _a, _b;
        const result = {};
        for(const inputName in inputs){
            const tensor = (_b = (_a = this._signature) === null || _a === void 0 ? void 0 : _a.inputs) === null || _b === void 0 ? void 0 : _b[inputName];
            if (tensor != null) result[tensor.name] = inputs[inputName];
            else result[inputName] = inputs[inputName];
        }
        return result;
    }
    checkInputs(inputs) {
        const notInGraph = Object.keys(inputs).filter((name)=>{
            const [nodeName] = (0, $9PnRL.parseNodeName)(name);
            return this.graph.nodes[nodeName] == null;
        });
        if (notInGraph.length > 0) throw new Error(`The dict provided in model.execute(dict) has ` + `keys: [${notInGraph}] that are not part of graph`);
    }
    mapOutputs(outputs) {
        return outputs.map((name)=>{
            var _a, _b;
            const tensor = (_b = (_a = this._signature) === null || _a === void 0 ? void 0 : _a.outputs) === null || _b === void 0 ? void 0 : _b[name];
            if (tensor != null) return tensor.name;
            return name;
        }, {});
    }
    checkOutputs(outputs) {
        outputs.forEach((name)=>{
            const [normalizedName] = (0, $9PnRL.parseNodeName)(name);
            if (!this.graph.nodes[normalizedName]) throw new Error(`The output '${name}' is not found in the graph`);
        });
    }
}

});
parcelRegister("11iKq", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $0be46d614b171346$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $c2DT1 = parcelRequire("c2DT1");
var $jjNRA = parcelRequire("jjNRA");

var $1EcJz = parcelRequire("1EcJz");

var $dWfqP = parcelRequire("dWfqP");

var $cWPX8 = parcelRequire("cWPX8");

var $4c4iS = parcelRequire("4c4iS");

var $c3X9P = parcelRequire("c3X9P");

var $gT6Ou = parcelRequire("gT6Ou");

var $3TPMs = parcelRequire("3TPMs");

var $c0ywX = parcelRequire("c0ywX");

var $gPS1H = parcelRequire("gPS1H");

var $ln7DR = parcelRequire("ln7DR");

var $c6NzH = parcelRequire("c6NzH");

var $dQiCM = parcelRequire("dQiCM");

var $h1Kl3 = parcelRequire("h1Kl3");

var $7TMBo = parcelRequire("7TMBo");

var $9lSzv = parcelRequire("9lSzv");

var $bPan9 = parcelRequire("bPan9");

var $bHY7p = parcelRequire("bHY7p");

var $9Buta = parcelRequire("9Buta");

var $3pwdq = parcelRequire("3pwdq");

var $7RSIj = parcelRequire("7RSIj");

var $j4Rla = parcelRequire("j4Rla");

var $cXzgX = parcelRequire("cXzgX");
function $0be46d614b171346$export$7be88578e558e499(node, tensorMap, context, resourceManager, tidy = $c2DT1.tidy) {
    const value = ((node, tensorMap, context)=>{
        switch(node.category){
            case 'arithmetic':
                return tidy(()=>$cWPX8.executeOp(node, tensorMap, context));
            case 'basic_math':
                return tidy(()=>$4c4iS.executeOp(node, tensorMap, context));
            case 'control':
                return $c3X9P.executeOp(node, tensorMap, context);
            case 'convolution':
                return tidy(()=>$gT6Ou.executeOp(node, tensorMap, context));
            case 'creation':
                return tidy(()=>$3TPMs.executeOp(node, tensorMap, context));
            case 'dynamic':
                return $c0ywX.executeOp(node, tensorMap, context);
            case 'evaluation':
                return tidy(()=>$gPS1H.executeOp(node, tensorMap, context));
            case 'image':
                return tidy(()=>$dQiCM.executeOp(node, tensorMap, context));
            case 'graph':
                return tidy(()=>$ln7DR.executeOp(node, tensorMap, context));
            case 'logical':
                return tidy(()=>$h1Kl3.executeOp(node, tensorMap, context));
            case 'matrices':
                return tidy(()=>$7TMBo.executeOp(node, tensorMap, context));
            case 'normalization':
                return tidy(()=>$9lSzv.executeOp(node, tensorMap, context));
            case 'ragged':
                return tidy(()=>$bPan9.executeOp(node, tensorMap, context));
            case 'reduction':
                return tidy(()=>$bHY7p.executeOp(node, tensorMap, context));
            case 'slice_join':
                return tidy(()=>$9Buta.executeOp(node, tensorMap, context));
            case 'sparse':
                return tidy(()=>$3pwdq.executeOp(node, tensorMap, context));
            case 'spectral':
                return tidy(()=>$7RSIj.executeOp(node, tensorMap, context));
            case 'string':
                return tidy(()=>$j4Rla.executeOp(node, tensorMap, context));
            case 'transformation':
                return tidy(()=>$cXzgX.executeOp(node, tensorMap, context));
            case 'hash_table':
                return $c6NzH.executeOp(node, tensorMap, context, resourceManager);
            case 'custom':
                const opMapper = (0, $dWfqP.getRegisteredOp)(node.op);
                if (opMapper && opMapper.customExecutor) return opMapper.customExecutor(new (0, $1EcJz.NodeValueImpl)(node, tensorMap, context));
                else throw TypeError(`Custom op ${node.op} is not registered.`);
            default:
                throw TypeError(`Unknown op '${node.op}'. File an issue at ` + `https://github.com/tensorflow/tfjs/issues so we can add it` + `, or register a custom execution with tf.registerOp()`);
        }
    })(node, tensorMap, context);
    if ($jjNRA.isPromise(value)) return value.then((data)=>[].concat(data));
    return [].concat(value);
}

});
parcelRegister("1EcJz", function(module, exports) {

$parcel$export(module.exports, "NodeValueImpl", () => $13336795b5ffd0da$export$2964c493e854c8ad);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9PnRL = parcelRequire("9PnRL");

var $jRFPP = parcelRequire("jRFPP");
class $13336795b5ffd0da$export$2964c493e854c8ad {
    constructor(node, tensorMap, context){
        this.node = node;
        this.tensorMap = tensorMap;
        this.context = context;
        this.inputs = [];
        this.attrs = {};
        this.inputs = node.inputNames.map((name)=>this.getInput(name));
        if (node.rawAttrs != null) this.attrs = Object.keys(node.rawAttrs).reduce((attrs, key)=>{
            attrs[key] = this.getAttr(key);
            return attrs;
        }, {});
    }
    /**
     * Return the value of the attribute or input param.
     * @param name String: name of attribute or input param.
     */ getInput(name) {
        return (0, $9PnRL.getTensor)(name, this.tensorMap, this.context);
    }
    /**
     * Return the value of the attribute or input param.
     * @param name String: name of attribute or input param.
     */ getAttr(name, defaultValue) {
        const value = this.node.rawAttrs[name];
        if (value.tensor != null) return (0, $9PnRL.getTensor)(name, this.tensorMap, this.context);
        if (value.i != null || value.f != null) return (0, $jRFPP.getNumberParam)(this.node.rawAttrs, name, defaultValue);
        if (value.s != null) return (0, $jRFPP.getStringParam)(this.node.rawAttrs, name, defaultValue);
        if (value.b != null) return (0, $jRFPP.getBoolParam)(this.node.rawAttrs, name, defaultValue);
        if (value.shape != null) return (0, $jRFPP.getTensorShapeParam)(this.node.rawAttrs, name, defaultValue);
        if (value.type != null) return (0, $jRFPP.getDtypeParam)(this.node.rawAttrs, name, defaultValue);
        if (value.list != null) {
            if (value.list.i != null || value.list.f != null) return (0, $jRFPP.getNumericArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.s != null) return (0, $jRFPP.getStringArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.shape != null) return (0, $jRFPP.getTensorShapeArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.b != null) return (0, $jRFPP.getBoolArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.type != null) return (0, $jRFPP.getDtypeArrayParam)(this.node.rawAttrs, name, defaultValue);
        }
        return defaultValue;
    }
}

});

parcelRegister("cWPX8", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $96d33391e4514d4b$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $96d33391e4514d4b$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'BiasAdd':
        case 'AddV2':
        case 'Add':
            return [
                ops.add((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'AddN':
            return [
                ops.addN((0, $9PnRL.getParamValue)('tensors', node, tensorMap, context))
            ];
        case 'FloorMod':
        case 'Mod':
            return [
                ops.mod((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Mul':
            return [
                ops.mul((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'RealDiv':
        case 'Div':
            return [
                ops.div((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'DivNoNan':
            return [
                ops.divNoNan((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'FloorDiv':
            return [
                ops.floorDiv((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Sub':
            return [
                ops.sub((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Minimum':
            return [
                ops.minimum((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Maximum':
            return [
                ops.maximum((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Pow':
            return [
                ops.pow((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'SquaredDifference':
            return [
                ops.squaredDifference((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $96d33391e4514d4b$export$2c04807512a22510 = 'arithmetic';

});
parcelRegister("h8nZK", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * This file exports ops used by the converters executors. By default it
 * re-exports all ops. In a custom build this is aliased to a file that will
 * only exports ops for a given model.json.
 */ 
var $aosGd = parcelRequire("aosGd");
$parcel$exportWildcard(module.exports, $aosGd);

});


parcelRegister("4c4iS", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $30db9efeda54c353$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $30db9efeda54c353$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'Abs':
        case 'ComplexAbs':
            return [
                ops.abs((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Acos':
            return [
                ops.acos((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Acosh':
            return [
                ops.acosh((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Asin':
            return [
                ops.asin((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Asinh':
            return [
                ops.asinh((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Atan':
            return [
                ops.atan((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Atan2':
            return [
                ops.atan2((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('y', node, tensorMap, context))
            ];
        case 'Atanh':
            return [
                ops.atanh((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Ceil':
            return [
                ops.ceil((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Complex':
            return [
                ops.complex((0, $9PnRL.getParamValue)('real', node, tensorMap, context), (0, $9PnRL.getParamValue)('imag', node, tensorMap, context))
            ];
        case 'Cos':
            return [
                ops.cos((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Cosh':
            return [
                ops.cosh((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Elu':
            return [
                ops.elu((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Erf':
            return [
                ops.erf((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Exp':
            return [
                ops.exp((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Expm1':
            return [
                ops.expm1((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Floor':
            return [
                ops.floor((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Log':
            return [
                ops.log((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Log1p':
            return [
                ops.log1p((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Imag':
            return [
                ops.imag((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Neg':
            return [
                ops.neg((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Reciprocal':
            return [
                ops.reciprocal((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Real':
            return [
                ops.real((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Relu':
            return [
                ops.relu((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Round':
            return [
                ops.round((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Selu':
            return [
                ops.selu((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sigmoid':
            return [
                ops.sigmoid((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sin':
            return [
                ops.sin((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sign':
            return [
                ops.sign((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sinh':
            return [
                ops.sinh((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Softplus':
            return [
                ops.softplus((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sqrt':
            return [
                ops.sqrt((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Square':
            return [
                ops.square((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Tanh':
            return [
                ops.tanh((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Tan':
            return [
                ops.tan((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'ClipByValue':
            return [
                ops.clipByValue((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('clipValueMin', node, tensorMap, context), (0, $9PnRL.getParamValue)('clipValueMax', node, tensorMap, context))
            ];
        case 'Relu6':
            return [
                ops.relu6((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Rsqrt':
            return [
                ops.rsqrt((0, $9PnRL.getTensor)(node.inputNames[0], tensorMap, context))
            ];
        case 'LeakyRelu':
            return [
                ops.leakyRelu((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('alpha', node, tensorMap, context))
            ];
        case 'Prelu':
            return [
                ops.prelu((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('alpha', node, tensorMap, context))
            ];
        case 'IsNan':
            return [
                ops.isNaN((0, $9PnRL.getTensor)(node.inputNames[0], tensorMap, context))
            ];
        case 'IsInf':
            return [
                ops.isInf((0, $9PnRL.getTensor)(node.inputNames[0], tensorMap, context))
            ];
        case 'IsFinite':
            return [
                ops.isFinite((0, $9PnRL.getTensor)(node.inputNames[0], tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $30db9efeda54c353$export$2c04807512a22510 = 'basic_math';

});

parcelRegister("c3X9P", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $8c83a74940ef156e$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $3xp7o = parcelRequire("3xp7o");

var $gwwf3 = parcelRequire("gwwf3");

var $7TU8D = parcelRequire("7TU8D");

var $9PnRL = parcelRequire("9PnRL");
const $8c83a74940ef156e$export$7be88578e558e499 = async (node, tensorMap, context)=>{
    switch(node.op){
        case 'If':
        case 'StatelessIf':
            {
                const thenFunc = (0, $9PnRL.getParamValue)('thenBranch', node, tensorMap, context);
                const elseFunc = (0, $9PnRL.getParamValue)('elseBranch', node, tensorMap, context);
                const cond = (0, $9PnRL.getParamValue)('cond', node, tensorMap, context);
                const args = (0, $9PnRL.getParamValue)('args', node, tensorMap, context);
                const condValue = await cond.data();
                if (condValue[0]) return context.functionMap[thenFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
                else return context.functionMap[elseFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
            }
        case 'While':
        case 'StatelessWhile':
            {
                const bodyFunc = (0, $9PnRL.getParamValue)('body', node, tensorMap, context);
                const condFunc = (0, $9PnRL.getParamValue)('cond', node, tensorMap, context);
                const args = (0, $9PnRL.getParamValue)('args', node, tensorMap, context);
                // Calculate the condition of the loop
                const condResult = await context.functionMap[condFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
                const argIds = args.map((tensor)=>tensor.id);
                let condValue = await condResult[0].data();
                // Dispose the intermediate tensors for condition function
                condResult.forEach((tensor)=>{
                    if (!tensor.kept && argIds.indexOf(tensor.id) === -1) tensor.dispose();
                });
                let result = args;
                while(condValue[0]){
                    // Record the previous result for intermediate tensor tracking
                    const origResult = result;
                    // Execution the body of the loop
                    result = await context.functionMap[bodyFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);
                    const resultIds = result.map((tensor)=>tensor.id);
                    // Dispose the intermediate tensor for body function that is not global
                    // kept, not input/output of the body function
                    origResult.forEach((tensor)=>{
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) tensor.dispose();
                    });
                    // Recalcuate the condition of the loop using the latest results.
                    const condResult = await context.functionMap[condFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);
                    condValue = await condResult[0].data();
                    // Dispose the intermediate tensors for condition function
                    condResult.forEach((tensor)=>{
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) tensor.dispose();
                    });
                }
                return result;
            }
        case 'LoopCond':
            {
                const pred = (0, $9PnRL.getParamValue)('pred', node, tensorMap, context);
                return [
                    (0, $9PnRL.cloneTensor)(pred)
                ];
            }
        case 'Switch':
            {
                const pred = (0, $9PnRL.getParamValue)('pred', node, tensorMap, context);
                let data = (0, $9PnRL.getParamValue)('data', node, tensorMap, context);
                if (!data.kept) data = (0, $9PnRL.cloneTensor)(data);
                // Outputs nodes :0 => false, :1 => true
                return (await pred.data())[0] ? [
                    undefined,
                    data
                ] : [
                    data,
                    undefined
                ];
            }
        case 'Merge':
            {
                const inputName = node.inputNames.find((name)=>(0, $9PnRL.getTensor)(name, tensorMap, context) !== undefined);
                if (inputName) {
                    const data = (0, $9PnRL.getTensor)(inputName, tensorMap, context);
                    return [
                        (0, $9PnRL.cloneTensor)(data)
                    ];
                }
                return undefined;
            }
        case 'Enter':
            {
                const frameId = (0, $9PnRL.getParamValue)('frameName', node, tensorMap, context);
                const data = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                context.enterFrame(frameId);
                return [
                    (0, $9PnRL.cloneTensor)(data)
                ];
            }
        case 'Exit':
            {
                const data = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                context.exitFrame();
                return [
                    (0, $9PnRL.cloneTensor)(data)
                ];
            }
        case 'NextIteration':
            {
                const data = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                context.nextIteration();
                return [
                    (0, $9PnRL.cloneTensor)(data)
                ];
            }
        case 'TensorArrayV3':
            {
                const size = (0, $9PnRL.getParamValue)('size', node, tensorMap, context);
                const dtype = (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context);
                const elementShape = (0, $9PnRL.getParamValue)('elementShape', node, tensorMap, context);
                const dynamicSize = (0, $9PnRL.getParamValue)('dynamicSize', node, tensorMap, context);
                const clearAfterRead = (0, $9PnRL.getParamValue)('clearAfterRead', node, tensorMap, context);
                const identicalElementShapes = (0, $9PnRL.getParamValue)('identicalElementShapes', node, tensorMap, context);
                const name = (0, $9PnRL.getParamValue)('name', node, tensorMap, context);
                const tensorArray = new (0, $gwwf3.TensorArray)(name, dtype, size, elementShape, identicalElementShapes, dynamicSize, clearAfterRead);
                context.addTensorArray(tensorArray);
                return [
                    tensorArray.idTensor,
                    (0, $3xp7o.scalar)(1.0)
                ];
            }
        case 'TensorArrayWriteV3':
            {
                const id = (0, $9PnRL.getParamValue)('tensorArrayId', node, tensorMap, context);
                const index = (0, $9PnRL.getParamValue)('index', node, tensorMap, context);
                const writeTensor = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                const writeTensorArray = context.getTensorArray(id.id);
                writeTensorArray.write(index, writeTensor);
                return [
                    writeTensorArray.idTensor
                ];
            }
        case 'TensorArrayReadV3':
            {
                const readId = (0, $9PnRL.getParamValue)('tensorArrayId', node, tensorMap, context);
                const readIndex = (0, $9PnRL.getParamValue)('index', node, tensorMap, context);
                const readTensorArray = context.getTensorArray(readId.id);
                return [
                    readTensorArray.read(readIndex)
                ];
            }
        case 'TensorArrayGatherV3':
            {
                const gatherId = (0, $9PnRL.getParamValue)('tensorArrayId', node, tensorMap, context);
                const gatherIndices = (0, $9PnRL.getParamValue)('indices', node, tensorMap, context);
                const gatherDtype = (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context);
                const gatherTensorArray = context.getTensorArray(gatherId.id);
                return [
                    gatherTensorArray.gather(gatherIndices, gatherDtype)
                ];
            }
        case 'TensorArrayScatterV3':
            {
                const scatterId = (0, $9PnRL.getParamValue)('tensorArrayId', node, tensorMap, context);
                const scatterIndices = (0, $9PnRL.getParamValue)('indices', node, tensorMap, context);
                const scatterTensor = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                const scatterTensorArray = context.getTensorArray(scatterId.id);
                scatterTensorArray.scatter(scatterIndices, scatterTensor);
                return [
                    scatterTensorArray.idTensor
                ];
            }
        case 'TensorArrayConcatV3':
            {
                const concatId = (0, $9PnRL.getParamValue)('tensorArrayId', node, tensorMap, context);
                const concatTensorArray = context.getTensorArray(concatId.id);
                const concatDtype = (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context);
                return [
                    concatTensorArray.concat(concatDtype)
                ];
            }
        case 'TensorArraySplitV3':
            {
                const splitId = (0, $9PnRL.getParamValue)('tensorArrayId', node, tensorMap, context);
                const splitTensor = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                const lengths = (0, $9PnRL.getParamValue)('lengths', node, tensorMap, context);
                const splitTensorArray = context.getTensorArray(splitId.id);
                splitTensorArray.split(lengths, splitTensor);
                return [
                    splitTensorArray.idTensor
                ];
            }
        case 'TensorArraySizeV3':
            {
                const sizeId = (0, $9PnRL.getParamValue)('tensorArrayId', node, tensorMap, context);
                const sizeTensorArray = context.getTensorArray(sizeId.id);
                return [
                    (0, $3xp7o.scalar)(sizeTensorArray.size(), 'int32')
                ];
            }
        case 'TensorArrayCloseV3':
            {
                const closeId = (0, $9PnRL.getParamValue)('tensorArrayId', node, tensorMap, context);
                const closeTensorArray = context.getTensorArray(closeId.id);
                closeTensorArray.clearAndClose();
                return [
                    closeTensorArray.idTensor
                ];
            }
        case 'TensorListSetItem':
            {
                const idTensor = (0, $9PnRL.getParamValue)('tensorListId', node, tensorMap, context);
                const index = (0, $9PnRL.getParamValue)('index', node, tensorMap, context);
                const writeTensor = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                tensorList.setItem(index, writeTensor);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListGetItem':
            {
                const idTensor = (0, $9PnRL.getParamValue)('tensorListId', node, tensorMap, context);
                const readIndex = (0, $9PnRL.getParamValue)('index', node, tensorMap, context);
                const elementShape = (0, $9PnRL.getParamValue)('elementShape', node, tensorMap, context);
                const elementDType = (0, $9PnRL.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.getItem(readIndex, elementShape, elementDType)
                ];
            }
        case 'TensorListScatterV2':
        case 'TensorListScatter':
            {
                const scatterIndices = (0, $9PnRL.getParamValue)('indices', node, tensorMap, context);
                const scatterTensor = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                const elementShape = (0, $9PnRL.getParamValue)('elementShape', node, tensorMap, context);
                const numElements = (0, $9PnRL.getParamValue)('numElements', node, tensorMap, context);
                const tensorList = (0, $7TU8D.scatter)(scatterTensor, scatterIndices, elementShape, numElements);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListReserve':
        case 'EmptyTensorList':
            {
                const elementShape = (0, $9PnRL.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $9PnRL.getParamValue)('elementDType', node, tensorMap, context);
                let numElementsParam;
                if (node.op === 'TensorListReserve') numElementsParam = 'numElements';
                else numElementsParam = 'maxNumElements';
                const numElements = (0, $9PnRL.getParamValue)(numElementsParam, node, tensorMap, context);
                const maxNumElements = node.op === 'TensorListReserve' ? -1 : numElements;
                const tensorList = (0, $7TU8D.reserve)(elementShape, elementDtype, numElements, maxNumElements);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListGather':
            {
                const gatherId = (0, $9PnRL.getParamValue)('tensorListId', node, tensorMap, context);
                const gatherIndices = (0, $9PnRL.getParamValue)('indices', node, tensorMap, context);
                const elementShape = (0, $9PnRL.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $9PnRL.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(gatherId.id);
                return [
                    tensorList.gather(gatherIndices, elementDtype, elementShape)
                ];
            }
        case 'TensorListStack':
            {
                const idTensor = (0, $9PnRL.getParamValue)('tensorListId', node, tensorMap, context);
                const elementShape = (0, $9PnRL.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $9PnRL.getParamValue)('elementDType', node, tensorMap, context);
                const numElements = (0, $9PnRL.getParamValue)('numElements', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.stack(elementShape, elementDtype, numElements)
                ];
            }
        case 'TensorListFromTensor':
            {
                const tensor = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                const elementShape = (0, $9PnRL.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $9PnRL.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = (0, $7TU8D.fromTensor)(tensor, elementShape, elementDtype);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListConcat':
        case 'TensorListConcatV2':
            {
                const concatId = (0, $9PnRL.getParamValue)('tensorListId', node, tensorMap, context);
                const tensorList = context.getTensorList(concatId.id);
                const concatDtype = (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context);
                const elementShape = (0, $9PnRL.getParamValue)('elementShape', node, tensorMap, context);
                return [
                    tensorList.concat(concatDtype, elementShape)
                ];
            }
        case 'TensorListPushBack':
            {
                const idTensor = (0, $9PnRL.getParamValue)('tensorListId', node, tensorMap, context);
                const writeTensor = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                tensorList.pushBack(writeTensor);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListPopBack':
            {
                const idTensor = (0, $9PnRL.getParamValue)('tensorListId', node, tensorMap, context);
                const elementShape = (0, $9PnRL.getParamValue)('elementShape', node, tensorMap, context);
                const elementDType = (0, $9PnRL.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.popBack(elementShape, elementDType)
                ];
            }
        case 'TensorListSplit':
            {
                const splitTensor = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                const elementShape = (0, $9PnRL.getParamValue)('elementShape', node, tensorMap, context);
                const lengths = (0, $9PnRL.getParamValue)('lengths', node, tensorMap, context);
                const tensorList = (0, $7TU8D.split)(splitTensor, lengths, elementShape);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListLength':
            {
                const idTensor = (0, $9PnRL.getParamValue)('tensorListId', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    (0, $3xp7o.scalar)(tensorList.size(), 'int32')
                ];
            }
        case 'TensorListResize':
            {
                const idTensor = (0, $9PnRL.getParamValue)('tensorListId', node, tensorMap, context);
                const size = (0, $9PnRL.getParamValue)('size', node, tensorMap, context);
                const srcTensorList = context.getTensorList(idTensor.id);
                const destTensorList = srcTensorList.resize(size);
                context.addTensorList(destTensorList);
                return [
                    destTensorList.idTensor
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $8c83a74940ef156e$export$2c04807512a22510 = 'control';

});
parcelRegister("gwwf3", function(module, exports) {

$parcel$export(module.exports, "TensorArray", () => $c078a50831c724a0$export$854ca114072d2abc);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $iTu6j = parcelRequire("iTu6j");
var $c2DT1 = parcelRequire("c2DT1");
var $4sqA7 = parcelRequire("4sqA7");
var $3xp7o = parcelRequire("3xp7o");
var $79KOG = parcelRequire("79KOG");
var $8BrLX = parcelRequire("8BrLX");
var $erbmM = parcelRequire("erbmM");
var $gBOC6 = parcelRequire("gBOC6");

var $cC9h5 = parcelRequire("cC9h5");
class $c078a50831c724a0$export$854ca114072d2abc {
    constructor(name, dtype, maxSize, elementShape, identicalElementShapes, dynamicSize, clearAfterRead){
        this.name = name;
        this.dtype = dtype;
        this.maxSize = maxSize;
        this.elementShape = elementShape;
        this.identicalElementShapes = identicalElementShapes;
        this.dynamicSize = dynamicSize;
        this.clearAfterRead = clearAfterRead;
        this.tensors = [];
        this.closed_ = false;
        this.idTensor = (0, $3xp7o.scalar)(0);
        (0, $c2DT1.keep)(this.idTensor);
    }
    get id() {
        return this.idTensor.id;
    }
    get closed() {
        return this.closed_;
    }
    /**
     * Dispose the tensors and idTensor and mark the TensoryArray as closed.
     */ clearAndClose(keepIds) {
        this.tensors.forEach((tensor)=>{
            if (keepIds == null || !keepIds.has(tensor.tensor.id)) tensor.tensor.dispose();
        });
        this.tensors = [];
        this.closed_ = true;
        this.idTensor.dispose();
    }
    size() {
        return this.tensors.length;
    }
    /**
     * Read the value at location index in the TensorArray.
     * @param index Number the index to read from.
     */ read(index) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (index < 0 || index >= this.size()) throw new Error(`Tried to read from index ${index}, but array size is: ${this.size()}`);
        const tensorWithState = this.tensors[index];
        if (tensorWithState.cleared) throw new Error(`TensorArray ${this.name}: Could not read index ${index} twice because it was cleared after a previous read ` + `(perhaps try setting clear_after_read = false?).`);
        if (this.clearAfterRead) tensorWithState.cleared = true;
        tensorWithState.read = true;
        return tensorWithState.tensor;
    }
    /**
     * Helper method to read multiple tensors from the specified indices.
     */ readMany(indices) {
        return indices.map((index)=>this.read(index));
    }
    /**
     * Write value into the index of the TensorArray.
     * @param index number the index to write to.
     * @param tensor
     */ write(index, tensor) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (index < 0 || !this.dynamicSize && index >= this.maxSize) throw new Error(`Tried to write to index ${index}, but array is not resizeable and size is: ${this.maxSize}`);
        const t = this.tensors[index] || {};
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index},
          because the value dtype is ${tensor.dtype}, but TensorArray dtype is ${this.dtype}.`);
        // Set the shape for the first time write to unknow shape tensor array
        if (this.size() === 0 && (this.elementShape == null || this.elementShape.length === 0)) this.elementShape = tensor.shape;
        (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensor.shape, `TensorArray ${this.name}: Could not write to TensorArray index ${index}.`);
        if (t.read) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index}, because it has already been read.`);
        if (t.written) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index}, because it has already been written.`);
        t.tensor = tensor;
        (0, $c2DT1.keep)(tensor);
        t.written = true;
        this.tensors[index] = t;
    }
    /**
     * Helper method to write multiple tensors to the specified indices.
     */ writeMany(indices, tensors) {
        if (indices.length !== tensors.length) throw new Error(`TensorArray ${this.name}: could not write multiple tensors,` + `because the index size: ${indices.length} is not the same as tensors size: ${tensors.length}.`);
        indices.forEach((i, index)=>this.write(i, tensors[index]));
    }
    /**
     * Return selected values in the TensorArray as a packed Tensor. All of
     * selected values must have been written and their shapes must all match.
     * @param [indices] number[] Optional. Taking values in [0, max_value). If the
     *    TensorArray is not dynamic, max_value=size(). If not specified returns
     *    all tensors in the original order.
     * @param [dtype]
     */ gather(indices, dtype) {
        if (!!dtype && dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but gather requested dtype ${dtype}`);
        if (!indices) {
            indices = [];
            for(let i = 0; i < this.size(); i++)indices.push(i);
        } else indices = indices.slice(0, this.size());
        if (indices.length === 0) return (0, $erbmM.tensor)([], [
            0
        ].concat(this.elementShape));
        // Read all the PersistentTensors into a vector to keep track of
        // their memory.
        const tensors = this.readMany(indices);
        (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensors[0].shape, 'TensorArray shape mismatch: ');
        return (0, $8BrLX.stack)(tensors, 0);
    }
    /**
     * Return the values in the TensorArray as a concatenated Tensor.
     */ concat(dtype) {
        if (!!dtype && dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but concat requested dtype ${dtype}`);
        if (this.size() === 0) return (0, $erbmM.tensor)([], [
            0
        ].concat(this.elementShape));
        const indices = [];
        for(let i = 0; i < this.size(); i++)indices.push(i);
        // Collect all the tensors from the tensors array.
        const tensors = this.readMany(indices);
        (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensors[0].shape, `TensorArray shape mismatch: tensor array shape (${this.elementShape}) vs first tensor shape (${tensors[0].shape})`);
        return (0, $iTu6j.concat)(tensors, 0);
    }
    /**
     * Scatter the values of a Tensor in specific indices of a TensorArray.
     * @param indices number[] values in [0, max_value). If the
     *    TensorArray is not dynamic, max_value=size().
     * @param tensor Tensor input tensor.
     */ scatter(indices, tensor) {
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor.dtype}`);
        if (indices.length !== tensor.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor.shape[0]}`);
        const maxIndex = Math.max(...indices);
        if (!this.dynamicSize && maxIndex >= this.maxSize) throw new Error(`Max index must be < array size (${maxIndex}  vs. ${this.maxSize})`);
        this.writeMany(indices, (0, $gBOC6.unstack)(tensor, 0));
    }
    /**
     * Split the values of a Tensor into the TensorArray.
     * @param length number[] with the lengths to use when splitting value along
     *    its first dimension.
     * @param tensor Tensor, the tensor to split.
     */ split(length, tensor) {
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor.dtype}`);
        let totalLength = 0;
        const cumulativeLengths = length.map((len)=>{
            totalLength += len;
            return totalLength;
        });
        if (totalLength !== tensor.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor.shape}`);
        if (!this.dynamicSize && length.length !== this.maxSize) throw new Error(`TensorArray's size is not equal to the size of lengths (${this.maxSize} vs. ${length.length}), ` + 'and the TensorArray is not marked as dynamically resizeable');
        const elementPerRow = totalLength === 0 ? 0 : tensor.size / totalLength;
        const tensors = [];
        (0, $c2DT1.tidy)(()=>{
            tensor = (0, $4sqA7.reshape)(tensor, [
                1,
                totalLength,
                elementPerRow
            ]);
            for(let i = 0; i < length.length; ++i){
                const previousLength = i === 0 ? 0 : cumulativeLengths[i - 1];
                const indices = [
                    0,
                    previousLength,
                    0
                ];
                const sizes = [
                    1,
                    length[i],
                    elementPerRow
                ];
                tensors[i] = (0, $4sqA7.reshape)((0, $79KOG.slice)(tensor, indices, sizes), this.elementShape);
            }
            return tensors;
        });
        const indices = [];
        for(let i = 0; i < length.length; i++)indices[i] = i;
        this.writeMany(indices, tensors);
    }
}

});
parcelRegister("cC9h5", function(module, exports) {

$parcel$export(module.exports, "assertShapesMatchAllowUndefinedSize", () => $92f03a63a0936b26$export$c20af1b3c2621826);
$parcel$export(module.exports, "inferElementShape", () => $92f03a63a0936b26$export$48aa6d00714ed79b);
$parcel$export(module.exports, "mergeElementShape", () => $92f03a63a0936b26$export$455cf61aa434d74b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * This differs from util.assertShapesMatch in that it allows values of
 * negative one, an undefined size of a dimensinon, in a shape to match
 * anything.
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
function $92f03a63a0936b26$export$c20af1b3c2621826(shapeA, shapeB, errorMessagePrefix = '') {
    // constant shape means unknown rank
    if (typeof shapeA === 'number' || typeof shapeB === 'number') return;
    (0, $jjNRA).assert(shapeA.length === shapeB.length, ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
    for(let i = 0; i < shapeA.length; i++){
        const dim0 = shapeA[i];
        const dim1 = shapeB[i];
        (0, $jjNRA).assert(dim0 < 0 || dim1 < 0 || dim0 === dim1, ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
    }
}
function $92f03a63a0936b26$export$caa10238f73d8dc2(elementShape) {
    if (typeof elementShape === 'number' || elementShape.some((dim)=>dim < 0)) return false;
    return true;
}
function $92f03a63a0936b26$export$48aa6d00714ed79b(listElementShape, tensors, elementShape) {
    let partialShape = $92f03a63a0936b26$export$455cf61aa434d74b(listElementShape, elementShape);
    const notfullDefinedShape = !$92f03a63a0936b26$export$caa10238f73d8dc2(partialShape);
    if (notfullDefinedShape && tensors.length === 0) throw new Error(`Tried to calculate elements of an empty list` + ` with non-fully-defined elementShape: ${partialShape}`);
    if (notfullDefinedShape) tensors.forEach((tensor)=>{
        partialShape = $92f03a63a0936b26$export$455cf61aa434d74b(tensor.shape, partialShape);
    });
    if (!$92f03a63a0936b26$export$caa10238f73d8dc2(partialShape)) throw new Error(`Non-fully-defined elementShape: ${partialShape}`);
    return partialShape;
}
function $92f03a63a0936b26$export$455cf61aa434d74b(elementShapeA, elementShapeB) {
    if (typeof elementShapeA === 'number') return elementShapeB;
    if (typeof elementShapeB === 'number') return elementShapeA;
    if (elementShapeA.length !== elementShapeB.length) throw new Error(`Incompatible ranks during merge: ${elementShapeA} vs. ${elementShapeB}`);
    const result = [];
    for(let i = 0; i < elementShapeA.length; ++i){
        const dim0 = elementShapeA[i];
        const dim1 = elementShapeB[i];
        if (dim0 >= 0 && dim1 >= 0 && dim0 !== dim1) throw new Error(`Incompatible shape during merge: ${elementShapeA} vs. ${elementShapeB}`);
        result[i] = dim0 >= 0 ? dim0 : dim1;
    }
    return result;
}

});


parcelRegister("7TU8D", function(module, exports) {

$parcel$export(module.exports, "fromTensor", () => $5c09375ed812532e$export$1bc9ee297bacb6e5);
$parcel$export(module.exports, "reserve", () => $5c09375ed812532e$export$12d6b2bf497a6811);
$parcel$export(module.exports, "scatter", () => $5c09375ed812532e$export$c97954fff4307550);
$parcel$export(module.exports, "split", () => $5c09375ed812532e$export$65980d18b75784e2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $iTu6j = parcelRequire("iTu6j");
var $c2DT1 = parcelRequire("c2DT1");
var $4sqA7 = parcelRequire("4sqA7");
var $3xp7o = parcelRequire("3xp7o");
var $79KOG = parcelRequire("79KOG");
var $8BrLX = parcelRequire("8BrLX");
var $erbmM = parcelRequire("erbmM");
var $gBOC6 = parcelRequire("gBOC6");

var $cC9h5 = parcelRequire("cC9h5");
class $5c09375ed812532e$export$97d48a41015c8fa8 {
    get id() {
        return this.idTensor.id;
    }
    /**
     *
     * @param tensors list of tensors
     * @param elementShape shape of each tensor, this can be a single number (any
     * shape is allowed) or partial shape (dim = -1).
     * @param elementDtype data type of each tensor
     * @param maxNumElements The maximum allowed size of `tensors`. Defaults to -1
     *   meaning that the size of `tensors` is unbounded.
     */ constructor(tensors, elementShape, elementDtype, maxNumElements = -1){
        this.tensors = tensors;
        this.elementShape = elementShape;
        this.elementDtype = elementDtype;
        if (tensors != null) tensors.forEach((tensor)=>{
            if (elementDtype !== tensor.dtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${tensor.dtype}`);
            (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(elementShape, tensor.shape, 'TensorList shape mismatch: ');
            (0, $c2DT1.keep)(tensor);
        });
        this.idTensor = (0, $3xp7o.scalar)(0);
        this.maxNumElements = maxNumElements;
        (0, $c2DT1.keep)(this.idTensor);
    }
    /**
     * Get a new TensorList containing a copy of the underlying tensor container.
     */ copy() {
        return new $5c09375ed812532e$export$97d48a41015c8fa8([
            ...this.tensors
        ], this.elementShape, this.elementDtype);
    }
    /**
     * Dispose the tensors and idTensor and clear the tensor list.
     */ clearAndClose(keepIds) {
        this.tensors.forEach((tensor)=>{
            if (keepIds == null || !keepIds.has(tensor.id)) tensor.dispose();
        });
        this.tensors.length = 0;
        this.idTensor.dispose();
    }
    /**
     * The size of the tensors in the tensor list.
     */ size() {
        return this.tensors.length;
    }
    /**
     * Return a tensor that stacks a list of rank-R tf.Tensors into one rank-(R+1)
     * tf.Tensor.
     * @param elementShape shape of each tensor
     * @param elementDtype data type of each tensor
     * @param numElements the number of elements to stack
     */ stack(elementShape, elementDtype, numElements = -1) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (numElements !== -1 && this.tensors.length !== numElements) throw new Error(`Operation expected a list with ${numElements} elements but got a list with ${this.tensors.length} elements.`);
        (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(elementShape, this.elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $cC9h5.inferElementShape)(this.elementShape, this.tensors, elementShape);
        return (0, $c2DT1.tidy)(()=>{
            const reshapedTensors = this.tensors.map((tensor)=>(0, $4sqA7.reshape)(tensor, outputElementShape));
            return (0, $8BrLX.stack)(reshapedTensors, 0);
        });
    }
    /**
     * Pop a tensor from the end of the list.
     * @param elementShape shape of the tensor
     * @param elementDtype data type of the tensor
     */ popBack(elementShape, elementDtype) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (this.size() === 0) throw new Error('Trying to pop from an empty list.');
        const outputElementShape = (0, $cC9h5.inferElementShape)(this.elementShape, this.tensors, elementShape);
        const tensor = this.tensors.pop();
        tensor.kept = false;
        (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(tensor.shape, elementShape, 'TensorList shape mismatch: ');
        return (0, $4sqA7.reshape)(tensor, outputElementShape);
    }
    /**
     * Push a tensor to the end of the list.
     * @param tensor Tensor to be pushed.
     */ pushBack(tensor) {
        if (tensor.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${this.elementDtype}`);
        (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(tensor.shape, this.elementShape, 'TensorList shape mismatch: ');
        if (this.maxNumElements === this.size()) throw new Error(`Trying to push element into a full list.`);
        (0, $c2DT1.keep)(tensor);
        this.tensors.push(tensor);
    }
    /**
     * Update the size of the list.
     * @param size the new size of the list.
     */ resize(size) {
        if (size < 0) throw new Error(`TensorListResize expects size to be non-negative. Got: ${size}`);
        if (this.maxNumElements !== -1 && size > this.maxNumElements) throw new Error(`TensorListResize input size ${size} is greater maxNumElement ${this.maxNumElements}.`);
        const destTensorList = new $5c09375ed812532e$export$97d48a41015c8fa8([], this.elementShape, this.elementDtype, this.maxNumElements);
        destTensorList.tensors.length = size;
        for(let i = 0; i < Math.min(this.tensors.length, size); ++i)destTensorList.tensors[i] = this.tensors[i];
        return destTensorList;
    }
    /**
     * Retrieve the element at the provided index
     * @param elementShape shape of the tensor
     * @param elementDtype dtype of the tensor
     * @param elementIndex index of the tensor
     */ getItem(elementIndex, elementShape, elementDtype) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (elementIndex < 0 || elementIndex > this.tensors.length) throw new Error(`Trying to access element ${elementIndex} in a list with ${this.tensors.length} elements.`);
        if (this.tensors[elementIndex] == null) throw new Error(`element at index ${elementIndex} is null.`);
        (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(this.tensors[elementIndex].shape, elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $cC9h5.inferElementShape)(this.elementShape, this.tensors, elementShape);
        return (0, $4sqA7.reshape)(this.tensors[elementIndex], outputElementShape);
    }
    /**
     * Set the tensor at the index
     * @param elementIndex index of the tensor
     * @param tensor the tensor to be inserted into the list
     */ setItem(elementIndex, tensor) {
        if (tensor.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${this.elementDtype}`);
        if (elementIndex < 0 || this.maxNumElements !== -1 && elementIndex >= this.maxNumElements) throw new Error(`Trying to set element ${elementIndex} in a list with max ${this.maxNumElements} elements.`);
        (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensor.shape, 'TensorList shape mismatch: ');
        (0, $c2DT1.keep)(tensor);
        // dispose the previous value if it is replacing.
        if (this.tensors[elementIndex] != null) this.tensors[elementIndex].kept = false;
        this.tensors[elementIndex] = tensor;
    }
    /**
     * Return selected values in the TensorList as a stacked Tensor. All of
     * selected values must have been written and their shapes must all match.
     * @param indices indices of tensors to gather
     * @param elementDtype output tensor dtype
     * @param elementShape output tensor element shape
     */ gather(indices, elementDtype, elementShape) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(this.elementShape, elementShape, 'TensorList shape mismatch: ');
        // When indices is greater than the size of the list, indices beyond the
        // size of the list are ignored.
        indices = indices.slice(0, this.size());
        const outputElementShape = (0, $cC9h5.inferElementShape)(this.elementShape, this.tensors, elementShape);
        if (indices.length === 0) return (0, $erbmM.tensor)([], [
            0
        ].concat(outputElementShape));
        return (0, $c2DT1.tidy)(()=>{
            const tensors = indices.map((i)=>(0, $4sqA7.reshape)(this.tensors[i], outputElementShape));
            return (0, $8BrLX.stack)(tensors, 0);
        });
    }
    /**
     * Return the values in the TensorList as a concatenated Tensor.
     * @param elementDtype output tensor dtype
     * @param elementShape output tensor element shape
     */ concat(elementDtype, elementShape) {
        if (!!elementDtype && elementDtype !== this.elementDtype) throw new Error(`TensorList dtype is ${this.elementDtype} but concat requested dtype ${elementDtype}`);
        (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(this.elementShape, elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $cC9h5.inferElementShape)(this.elementShape, this.tensors, elementShape);
        if (this.size() === 0) return (0, $erbmM.tensor)([], [
            0
        ].concat(outputElementShape));
        return (0, $c2DT1.tidy)(()=>{
            const tensors = this.tensors.map((t)=>(0, $4sqA7.reshape)(t, outputElementShape));
            return (0, $iTu6j.concat)(tensors, 0);
        });
    }
}
function $5c09375ed812532e$export$1bc9ee297bacb6e5(tensor, elementShape, elementDtype) {
    const dtype = tensor.dtype;
    if (tensor.shape.length < 1) throw new Error(`Tensor must be at least a vector, but saw shape: ${tensor.shape}`);
    if (tensor.dtype !== elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${elementDtype}`);
    const tensorElementShape = tensor.shape.slice(1);
    (0, $cC9h5.assertShapesMatchAllowUndefinedSize)(tensorElementShape, elementShape, 'TensorList shape mismatch: ');
    const tensorList = (0, $gBOC6.unstack)(tensor);
    return new $5c09375ed812532e$export$97d48a41015c8fa8(tensorList, elementShape, dtype);
}
function $5c09375ed812532e$export$12d6b2bf497a6811(elementShape, elementDtype, numElements, maxNumElements) {
    return new $5c09375ed812532e$export$97d48a41015c8fa8([], elementShape, elementDtype, maxNumElements);
}
function $5c09375ed812532e$export$c97954fff4307550(tensor, indices, elementShape, numElements) {
    if (indices.length !== tensor.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor.shape[0]}`);
    const maxIndex = Math.max(...indices);
    if (numElements != null && numElements !== -1 && maxIndex >= numElements) throw new Error(`Max index must be < array size (${maxIndex}  vs. ${numElements})`);
    const list = new $5c09375ed812532e$export$97d48a41015c8fa8([], elementShape, tensor.dtype, numElements);
    const tensors = (0, $gBOC6.unstack)(tensor, 0);
    indices.forEach((value, index)=>{
        list.setItem(value, tensors[index]);
    });
    return list;
}
function $5c09375ed812532e$export$65980d18b75784e2(tensor, length, elementShape) {
    let totalLength = 0;
    const cumulativeLengths = length.map((len)=>{
        totalLength += len;
        return totalLength;
    });
    if (totalLength !== tensor.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor.shape}`);
    const shapeWithoutFirstDim = tensor.shape.slice(1);
    const outputElementShape = (0, $cC9h5.mergeElementShape)(shapeWithoutFirstDim, elementShape);
    const elementPerRow = totalLength === 0 ? 0 : tensor.size / totalLength;
    const tensors = (0, $c2DT1.tidy)(()=>{
        const tensors = [];
        tensor = (0, $4sqA7.reshape)(tensor, [
            1,
            totalLength,
            elementPerRow
        ]);
        for(let i = 0; i < length.length; ++i){
            const previousLength = i === 0 ? 0 : cumulativeLengths[i - 1];
            const indices = [
                0,
                previousLength,
                0
            ];
            const sizes = [
                1,
                length[i],
                elementPerRow
            ];
            tensors[i] = (0, $4sqA7.reshape)((0, $79KOG.slice)(tensor, indices, sizes), outputElementShape);
        }
        tensor.dispose();
        return tensors;
    });
    const list = new $5c09375ed812532e$export$97d48a41015c8fa8([], elementShape, tensor.dtype, length.length);
    for(let i = 0; i < tensors.length; i++)list.setItem(i, tensors[i]);
    return list;
}

});


parcelRegister("gT6Ou", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $c4b7115ed5899ad3$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
function $c4b7115ed5899ad3$var$fusedConvAndDepthWiseParams(node, tensorMap, context) {
    const [extraOp, activationFunc] = (0, $9PnRL.getParamValue)('fusedOps', node, tensorMap, context);
    const isBiasAdd = extraOp === 'biasadd';
    const noBiasAdd = !isBiasAdd;
    const isPrelu = activationFunc === 'prelu';
    const isBatchNorm = extraOp === 'fusedbatchnorm';
    const numArgs = (0, $9PnRL.getParamValue)('numArgs', node, tensorMap, context);
    if (isBiasAdd) {
        if (isPrelu && numArgs !== 2) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
        if (!isPrelu && isBiasAdd && numArgs !== 1) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd must have one extra argument: bias.");
    }
    if (isBatchNorm) throw new Error('FusedConv2d and DepthwiseConv2d with FusedBatchNorm is not supported');
    const stride = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
    const pad = (0, $9PnRL.getPadding)(node, tensorMap, context);
    const dataFormat = (0, $9PnRL.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
    const dilations = (0, $9PnRL.getParamValue)('dilations', node, tensorMap, context);
    let [biasArg, preluArg] = (0, $9PnRL.getParamValue)('args', node, tensorMap, context);
    if (noBiasAdd) {
        preluArg = biasArg;
        biasArg = undefined;
    }
    const leakyreluAlpha = (0, $9PnRL.getParamValue)('leakyreluAlpha', node, tensorMap, context);
    return {
        stride: stride,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        biasArg: biasArg,
        preluArg: preluArg,
        activationFunc: activationFunc,
        leakyreluAlpha: leakyreluAlpha
    };
}
const $c4b7115ed5899ad3$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'Conv1D':
            {
                const stride = (0, $9PnRL.getParamValue)('stride', node, tensorMap, context);
                const pad = (0, $9PnRL.getParamValue)('pad', node, tensorMap, context);
                const dataFormat = (0, $9PnRL.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilation = (0, $9PnRL.getParamValue)('dilation', node, tensorMap, context);
                return [
                    ops.conv1d((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('filter', node, tensorMap, context), stride, pad, dataFormat, dilation)
                ];
            }
        case 'Conv2D':
            {
                const stride = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $9PnRL.getPadding)(node, tensorMap, context);
                const dataFormat = (0, $9PnRL.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilations = (0, $9PnRL.getParamValue)('dilations', node, tensorMap, context);
                return [
                    ops.conv2d((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2]
                    ])
                ];
            }
        case '_FusedConv2D':
            {
                const { stride: stride, pad: pad, dataFormat: dataFormat, dilations: dilations, biasArg: biasArg, preluArg: preluArg, activationFunc: activationFunc, leakyreluAlpha: leakyreluAlpha } = $c4b7115ed5899ad3$var$fusedConvAndDepthWiseParams(node, tensorMap, context);
                return [
                    ops.fused.conv2d({
                        x: (0, $9PnRL.getParamValue)('x', node, tensorMap, context),
                        filter: (0, $9PnRL.getParamValue)('filter', node, tensorMap, context),
                        strides: [
                            stride[1],
                            stride[2]
                        ],
                        pad: pad,
                        dataFormat: dataFormat,
                        dilations: [
                            dilations[1],
                            dilations[2]
                        ],
                        bias: biasArg,
                        activation: activationFunc,
                        preluActivationWeights: preluArg,
                        leakyreluAlpha: leakyreluAlpha
                    })
                ];
            }
        case 'FusedDepthwiseConv2dNative':
            {
                const { stride: stride, pad: pad, dataFormat: dataFormat, dilations: dilations, biasArg: biasArg, preluArg: preluArg, activationFunc: activationFunc, leakyreluAlpha: leakyreluAlpha } = $c4b7115ed5899ad3$var$fusedConvAndDepthWiseParams(node, tensorMap, context);
                return [
                    ops.fused.depthwiseConv2d({
                        x: (0, $9PnRL.getParamValue)('x', node, tensorMap, context),
                        filter: (0, $9PnRL.getParamValue)('filter', node, tensorMap, context),
                        strides: [
                            stride[1],
                            stride[2]
                        ],
                        pad: pad,
                        dataFormat: dataFormat,
                        dilations: [
                            dilations[1],
                            dilations[2]
                        ],
                        bias: biasArg,
                        activation: activationFunc,
                        preluActivationWeights: preluArg,
                        leakyreluAlpha: leakyreluAlpha
                    })
                ];
            }
        case 'Conv2DBackpropInput':
        case 'Conv2dTranspose':
            {
                const shape = (0, $9PnRL.getParamValue)('outputShape', node, tensorMap, context);
                const stride = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $9PnRL.getPadding)(node, tensorMap, context);
                return [
                    ops.conv2dTranspose((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('filter', node, tensorMap, context), shape, [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'DepthwiseConv2dNative':
        case 'DepthwiseConv2d':
            {
                const stride = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $9PnRL.getPadding)(node, tensorMap, context);
                const dilations = (0, $9PnRL.getParamValue)('dilations', node, tensorMap, context);
                const dataFormat = (0, $9PnRL.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                return [
                    ops.depthwiseConv2d((0, $9PnRL.getParamValue)('input', node, tensorMap, context), (0, $9PnRL.getParamValue)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2]
                    ])
                ];
            }
        case 'Conv3D':
            {
                const stride = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $9PnRL.getParamValue)('pad', node, tensorMap, context);
                const dataFormat = (0, $9PnRL.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilations = (0, $9PnRL.getParamValue)('dilations', node, tensorMap, context);
                return [
                    ops.conv3d((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2],
                        dilations[3]
                    ])
                ];
            }
        case 'AvgPool':
            {
                const stride = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $9PnRL.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $9PnRL.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.avgPool((0, $9PnRL.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2]
                    ], [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'MaxPool':
            {
                const stride = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $9PnRL.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $9PnRL.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.maxPool((0, $9PnRL.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2]
                    ], [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'MaxPoolWithArgmax':
            {
                const stride = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $9PnRL.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $9PnRL.getParamValue)('kernelSize', node, tensorMap, context);
                const includeBatchInIndex = (0, $9PnRL.getParamValue)('includeBatchInIndex', node, tensorMap, context);
                const { result: result, indexes: indexes } = ops.maxPoolWithArgmax((0, $9PnRL.getParamValue)('x', node, tensorMap, context), [
                    kernelSize[1],
                    kernelSize[2]
                ], [
                    stride[1],
                    stride[2]
                ], pad, includeBatchInIndex);
                return [
                    result,
                    indexes
                ];
            }
        case 'AvgPool3D':
            {
                const stride = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $9PnRL.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $9PnRL.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.avgPool3d((0, $9PnRL.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2],
                        kernelSize[3]
                    ], [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad)
                ];
            }
        case 'MaxPool3D':
            {
                const stride = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $9PnRL.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $9PnRL.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.maxPool3d((0, $9PnRL.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2],
                        kernelSize[3]
                    ], [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad)
                ];
            }
        case 'Dilation2D':
            {
                const strides = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $9PnRL.getParamValue)('pad', node, tensorMap, context);
                const dilations = (0, $9PnRL.getParamValue)('dilations', node, tensorMap, context);
                // strides: [1, stride_height, stride_width, 1].
                const strideHeight = strides[1];
                const strideWidth = strides[2];
                // dilations: [1, dilation_height, dilation_width, 1].
                const dilationHeight = dilations[1];
                const dilationWidth = dilations[2];
                return [
                    ops.dilation2d((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('filter', node, tensorMap, context), [
                        strideHeight,
                        strideWidth
                    ], pad, [
                        dilationHeight,
                        dilationWidth
                    ], 'NHWC' /* dataFormat */ )
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c4b7115ed5899ad3$export$2c04807512a22510 = 'convolution';

});

parcelRegister("3TPMs", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $2d6eacb28dd145d3$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $2d6eacb28dd145d3$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'Fill':
            {
                const shape = (0, $9PnRL.getParamValue)('shape', node, tensorMap, context);
                const dtype = (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context);
                const value = (0, $9PnRL.getParamValue)('value', node, tensorMap, context);
                return [
                    ops.fill(shape, value, dtype)
                ];
            }
        case 'LinSpace':
            {
                const start = (0, $9PnRL.getParamValue)('start', node, tensorMap, context);
                const stop = (0, $9PnRL.getParamValue)('stop', node, tensorMap, context);
                const num = (0, $9PnRL.getParamValue)('num', node, tensorMap, context);
                return [
                    ops.linspace(start, stop, num)
                ];
            }
        case 'Multinomial':
            {
                const logits = (0, $9PnRL.getParamValue)('logits', node, tensorMap, context);
                const numSamples = (0, $9PnRL.getParamValue)('numSamples', node, tensorMap, context);
                const seed = (0, $9PnRL.getParamValue)('seed', node, tensorMap, context);
                return [
                    ops.multinomial(logits, numSamples, seed)
                ];
            }
        case 'OneHot':
            {
                const indices = (0, $9PnRL.getParamValue)('indices', node, tensorMap, context);
                const depth = (0, $9PnRL.getParamValue)('depth', node, tensorMap, context);
                const onValue = (0, $9PnRL.getParamValue)('onValue', node, tensorMap, context);
                const offValue = (0, $9PnRL.getParamValue)('offValue', node, tensorMap, context);
                const dtype = (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context);
                return [
                    ops.oneHot(indices, depth, onValue, offValue, dtype)
                ];
            }
        case 'Ones':
            return [
                ops.ones((0, $9PnRL.getParamValue)('shape', node, tensorMap, context), (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'OnesLike':
            return [
                ops.onesLike((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'RandomStandardNormal':
            return [
                ops.randomStandardNormal((0, $9PnRL.getParamValue)('shape', node, tensorMap, context), (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context), (0, $9PnRL.getParamValue)('seed', node, tensorMap, context))
            ];
        case 'RandomUniform':
            return [
                ops.randomUniform(// tslint:disable-next-line:no-any
                (0, $9PnRL.getParamValue)('shape', node, tensorMap, context), (0, $9PnRL.getParamValue)('minval', node, tensorMap, context), (0, $9PnRL.getParamValue)('maxval', node, tensorMap, context), (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'RandomUniformInt':
            return [
                ops.randomUniformInt((0, $9PnRL.getParamValue)('shape', node, tensorMap, context), (0, $9PnRL.getParamValue)('minval', node, tensorMap, context), (0, $9PnRL.getParamValue)('maxval', node, tensorMap, context), (0, $9PnRL.getParamValue)('seed', node, tensorMap, context))
            ];
        case 'Range':
            {
                const start = (0, $9PnRL.getParamValue)('start', node, tensorMap, context);
                const stop = (0, $9PnRL.getParamValue)('stop', node, tensorMap, context);
                const step = (0, $9PnRL.getParamValue)('step', node, tensorMap, context);
                return [
                    ops.range(start, stop, step, (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context))
                ];
            }
        case 'TruncatedNormal':
            {
                const shape = (0, $9PnRL.getParamValue)('shape', node, tensorMap, context);
                const mean = (0, $9PnRL.getParamValue)('mean', node, tensorMap, context);
                const stdDev = (0, $9PnRL.getParamValue)('stdDev', node, tensorMap, context);
                const seed = (0, $9PnRL.getParamValue)('seed', node, tensorMap, context);
                return [
                    ops.truncatedNormal(shape, mean, stdDev, (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context), seed)
                ];
            }
        case 'Zeros':
            return [
                ops.zeros((0, $9PnRL.getParamValue)('shape', node, tensorMap, context), (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'ZerosLike':
            return [
                ops.zerosLike((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $2d6eacb28dd145d3$export$2c04807512a22510 = 'creation';

});

parcelRegister("c0ywX", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $8be045277287a719$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
function $8be045277287a719$var$nmsParams(node, tensorMap, context) {
    const boxes = (0, $9PnRL.getParamValue)('boxes', node, tensorMap, context);
    const scores = (0, $9PnRL.getParamValue)('scores', node, tensorMap, context);
    const maxOutputSize = (0, $9PnRL.getParamValue)('maxOutputSize', node, tensorMap, context);
    const iouThreshold = (0, $9PnRL.getParamValue)('iouThreshold', node, tensorMap, context);
    const scoreThreshold = (0, $9PnRL.getParamValue)('scoreThreshold', node, tensorMap, context);
    const softNmsSigma = (0, $9PnRL.getParamValue)('softNmsSigma', node, tensorMap, context);
    return {
        boxes: boxes,
        scores: scores,
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
}
const $8be045277287a719$export$7be88578e558e499 = async (node, tensorMap, context, resourceManager, ops = $h8nZK)=>{
    switch(node.op){
        case 'NonMaxSuppressionV5':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = $8be045277287a719$var$nmsParams(node, tensorMap, context);
                const result = await ops.image.nonMaxSuppressionWithScoreAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
                return [
                    result.selectedIndices,
                    result.selectedScores
                ];
            }
        case 'NonMaxSuppressionV4':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = $8be045277287a719$var$nmsParams(node, tensorMap, context);
                const padToMaxOutputSize = (0, $9PnRL.getParamValue)('padToMaxOutputSize', node, tensorMap, context);
                const result = await ops.image.nonMaxSuppressionPaddedAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
                return [
                    result.selectedIndices,
                    result.validOutputs
                ];
            }
        case 'NonMaxSuppressionV3':
        case 'NonMaxSuppressionV2':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = $8be045277287a719$var$nmsParams(node, tensorMap, context);
                return [
                    await ops.image.nonMaxSuppressionAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold)
                ];
            }
        case 'Where':
            {
                const condition = ops.cast((0, $9PnRL.getParamValue)('condition', node, tensorMap, context), 'bool');
                const result = [
                    await ops.whereAsync(condition)
                ];
                condition.dispose();
                return result;
            }
        case 'ListDiff':
            return ops.setdiff1dAsync((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('y', node, tensorMap, context));
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $8be045277287a719$export$2c04807512a22510 = 'dynamic';

});

parcelRegister("gPS1H", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $c41b514af3513033$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $c41b514af3513033$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'LowerBound':
            {
                const sortedSequence = (0, $9PnRL.getParamValue)('sortedSequence', node, tensorMap, context);
                const values = (0, $9PnRL.getParamValue)('values', node, tensorMap, context);
                return [
                    ops.lowerBound(sortedSequence, values)
                ];
            }
        case 'TopKV2':
            {
                const x = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                const k = (0, $9PnRL.getParamValue)('k', node, tensorMap, context);
                const sorted = (0, $9PnRL.getParamValue)('sorted', node, tensorMap, context);
                const result = ops.topk(x, k, sorted);
                return [
                    result.values,
                    result.indices
                ];
            }
        case 'UpperBound':
            {
                const sortedSequence = (0, $9PnRL.getParamValue)('sortedSequence', node, tensorMap, context);
                const values = (0, $9PnRL.getParamValue)('values', node, tensorMap, context);
                return [
                    ops.upperBound(sortedSequence, values)
                ];
            }
        case 'Unique':
            {
                const x = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                const result = ops.unique(x);
                return [
                    result.values,
                    result.indices
                ];
            }
        case 'UniqueV2':
            {
                const x = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const result = ops.unique(x, axis);
                return [
                    result.values,
                    result.indices
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c41b514af3513033$export$2c04807512a22510 = 'evaluation';

});

parcelRegister("ln7DR", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $f8f1ac7b25597c83$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $f8f1ac7b25597c83$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'Const':
            return tensorMap[node.name];
        case 'PlaceholderWithDefault':
            const def = (0, $9PnRL.getParamValue)('default', node, tensorMap, context);
            return [
                (0, $9PnRL.getTensor)(node.name, tensorMap, context) || def
            ];
        case 'Placeholder':
            return [
                (0, $9PnRL.getTensor)(node.name, tensorMap, context)
            ];
        case 'Identity':
        case 'StopGradient':
        case 'FakeQuantWithMinMaxVars':
            {
                const data = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                return [
                    (0, $9PnRL.cloneTensor)(data)
                ];
            }
        case 'IdentityN':
            return (0, $9PnRL.getParamValue)('x', node, tensorMap, context).map((t)=>(0, $9PnRL.cloneTensor)(t));
        case 'Snapshot':
            const snapshot = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
            return [
                (0, $9PnRL.cloneTensor)(snapshot)
            ];
        case 'Shape':
            return [
                ops.tensor1d((0, $9PnRL.getParamValue)('x', node, tensorMap, context).shape, 'int32')
            ];
        case 'ShapeN':
            return (0, $9PnRL.getParamValue)('x', node, tensorMap, context).map((t)=>ops.tensor1d(t.shape));
        case 'Size':
            return [
                ops.scalar((0, $9PnRL.getParamValue)('x', node, tensorMap, context).size, 'int32')
            ];
        case 'Rank':
            return [
                ops.scalar((0, $9PnRL.getParamValue)('x', node, tensorMap, context).rank, 'int32')
            ];
        case 'NoOp':
            return [
                ops.scalar(1)
            ];
        case 'Print':
            const input = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
            const data = (0, $9PnRL.getParamValue)('data', node, tensorMap, context);
            const message = (0, $9PnRL.getParamValue)('message', node, tensorMap, context);
            const summarize = (0, $9PnRL.getParamValue)('summarize', node, tensorMap, context);
            console.warn("The graph has a tf.print() operation,usually used for debugging, which slows down performance.");
            console.log(message);
            for(let i = 0; i < data.length; i++)console.log(Array.prototype.slice.call(data[i].dataSync()).slice(0, summarize));
            return [
                input
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $f8f1ac7b25597c83$export$2c04807512a22510 = 'graph';

});

parcelRegister("c6NzH", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $8d0c801a69328189$export$7be88578e558e499);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8pINL = parcelRequire("8pINL");

var $9PnRL = parcelRequire("9PnRL");
const $8d0c801a69328189$export$7be88578e558e499 = async (node, tensorMap, context, resourceManager)=>{
    switch(node.op){
        case 'HashTable':
        case 'HashTableV2':
            {
                const existingTableHandle = resourceManager.getHashTableHandleByName(node.name);
                // Table is shared with initializer.
                if (existingTableHandle != null) return [
                    existingTableHandle
                ];
                else {
                    const keyDType = (0, $9PnRL.getParamValue)('keyDType', node, tensorMap, context);
                    const valueDType = (0, $9PnRL.getParamValue)('valueDType', node, tensorMap, context);
                    const hashTable = new (0, $8pINL.HashTable)(keyDType, valueDType);
                    resourceManager.addHashTable(node.name, hashTable);
                    return [
                        hashTable.handle
                    ];
                }
            }
        case 'InitializeTable':
        case 'InitializeTableV2':
        case 'LookupTableImport':
        case 'LookupTableImportV2':
            {
                const handle = (0, $9PnRL.getParamValue)('tableHandle', node, tensorMap, context, resourceManager);
                const keys = (0, $9PnRL.getParamValue)('keys', node, tensorMap, context);
                const values = (0, $9PnRL.getParamValue)('values', node, tensorMap, context);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    await hashTable.import(keys, values)
                ];
            }
        case 'LookupTableFind':
        case 'LookupTableFindV2':
            {
                const handle = (0, $9PnRL.getParamValue)('tableHandle', node, tensorMap, context, resourceManager);
                const keys = (0, $9PnRL.getParamValue)('keys', node, tensorMap, context);
                const defaultValue = (0, $9PnRL.getParamValue)('defaultValue', node, tensorMap, context);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    await hashTable.find(keys, defaultValue)
                ];
            }
        case 'LookupTableSize':
        case 'LookupTableSizeV2':
            {
                const handle = (0, $9PnRL.getParamValue)('tableHandle', node, tensorMap, context, resourceManager);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    hashTable.tensorSize()
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $8d0c801a69328189$export$2c04807512a22510 = 'hash_table';

});
parcelRegister("8pINL", function(module, exports) {

$parcel$export(module.exports, "HashTable", () => $62036930e8dbd6ca$export$b3bcf29b77543c46);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $c2DT1 = parcelRequire("c2DT1");
var $3xp7o = parcelRequire("3xp7o");
var $8BrLX = parcelRequire("8BrLX");
var $gBOC6 = parcelRequire("gBOC6");
var $jjNRA = parcelRequire("jjNRA");

var $3xp7o = parcelRequire("3xp7o");
class $62036930e8dbd6ca$export$b3bcf29b77543c46 {
    get id() {
        return this.handle.id;
    }
    /**
     * Constructor of HashTable. Creates a hash table.
     *
     * @param keyDType `dtype` of the table keys.
     * @param valueDType `dtype` of the table values.
     */ constructor(keyDType, valueDType){
        this.keyDType = keyDType;
        this.valueDType = valueDType;
        this.handle = (0, $3xp7o.scalar)(0);
        // tslint:disable-next-line: no-any
        this.tensorMap = new Map();
        (0, $c2DT1.keep)(this.handle);
    }
    /**
     * Dispose the tensors and handle and clear the hashtable.
     */ clearAndClose() {
        this.tensorMap.forEach((value)=>value.dispose());
        this.tensorMap.clear();
        this.handle.dispose();
    }
    /**
     * The number of items in the hash table.
     */ size() {
        return this.tensorMap.size;
    }
    /**
     * The number of items in the hash table as a rank-0 tensor.
     */ tensorSize() {
        return $3xp7o.scalar(this.size(), 'int32');
    }
    /**
     * Replaces the contents of the table with the specified keys and values.
     * @param keys Keys to store in the hashtable.
     * @param values Values to store in the hashtable.
     */ async import(keys, values) {
        this.checkKeyAndValueTensor(keys, values);
        // We only store the primitive values of the keys, this allows lookup
        // to be O(1).
        const $keys = await keys.data();
        // Clear the hashTable before inserting new values.
        this.tensorMap.forEach((value)=>value.dispose());
        this.tensorMap.clear();
        return (0, $c2DT1.tidy)(()=>{
            const $values = (0, $gBOC6.unstack)(values);
            const keysLength = $keys.length;
            const valuesLength = $values.length;
            (0, $jjNRA).assert(keysLength === valuesLength, ()=>`The number of elements doesn't match, keys has ` + `${keysLength} elements, the values has ${valuesLength} ` + `elements.`);
            for(let i = 0; i < keysLength; i++){
                const key = $keys[i];
                const value = $values[i];
                (0, $c2DT1.keep)(value);
                this.tensorMap.set(key, value);
            }
            return this.handle;
        });
    }
    /**
     * Looks up keys in a hash table, outputs the corresponding values.
     *
     * Performs batch lookups, for every element in the key tensor, `find`
     * stacks the corresponding value into the return tensor.
     *
     * If an element is not present in the table, the given `defaultValue` is
     * used.
     *
     * @param keys Keys to look up. Must have the same type as the keys of the
     *     table.
     * @param defaultValue The scalar `defaultValue` is the value output for keys
     *     not present in the table. It must also be of the same type as the
     *     table values.
     */ async find(keys, defaultValue) {
        this.checkKeyAndValueTensor(keys, defaultValue);
        const $keys = await keys.data();
        return (0, $c2DT1.tidy)(()=>{
            const result = [];
            for(let i = 0; i < $keys.length; i++){
                const key = $keys[i];
                const value = this.findWithDefault(key, defaultValue);
                result.push(value);
            }
            return (0, $8BrLX.stack)(result);
        });
    }
    // tslint:disable-next-line: no-any
    findWithDefault(key, defaultValue) {
        const result = this.tensorMap.get(key);
        return result != null ? result : defaultValue;
    }
    checkKeyAndValueTensor(key, value) {
        if (key.dtype !== this.keyDType) throw new Error(`Expect key dtype ${this.keyDType}, but got ` + `${key.dtype}`);
        if (value.dtype !== this.valueDType) throw new Error(`Expect value dtype ${this.valueDType}, but got ` + `${value.dtype}`);
    }
}

});


parcelRegister("dQiCM", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $a13e941b4812d120$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $a13e941b4812d120$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'ResizeBilinear':
            {
                const images = (0, $9PnRL.getParamValue)('images', node, tensorMap, context);
                const size = (0, $9PnRL.getParamValue)('size', node, tensorMap, context);
                const alignCorners = (0, $9PnRL.getParamValue)('alignCorners', node, tensorMap, context);
                const halfPixelCenters = (0, $9PnRL.getParamValue)('halfPixelCenters', node, tensorMap, context);
                return [
                    ops.image.resizeBilinear(images, [
                        size[0],
                        size[1]
                    ], alignCorners, halfPixelCenters)
                ];
            }
        case 'ResizeNearestNeighbor':
            {
                const images = (0, $9PnRL.getParamValue)('images', node, tensorMap, context);
                const size = (0, $9PnRL.getParamValue)('size', node, tensorMap, context);
                const alignCorners = (0, $9PnRL.getParamValue)('alignCorners', node, tensorMap, context);
                const halfPixelCenters = (0, $9PnRL.getParamValue)('halfPixelCenters', node, tensorMap, context);
                return [
                    ops.image.resizeNearestNeighbor(images, [
                        size[0],
                        size[1]
                    ], alignCorners, halfPixelCenters)
                ];
            }
        case 'CropAndResize':
            {
                const image = (0, $9PnRL.getParamValue)('image', node, tensorMap, context);
                const boxes = (0, $9PnRL.getParamValue)('boxes', node, tensorMap, context);
                const boxInd = (0, $9PnRL.getParamValue)('boxInd', node, tensorMap, context);
                const cropSize = (0, $9PnRL.getParamValue)('cropSize', node, tensorMap, context);
                const method = (0, $9PnRL.getParamValue)('method', node, tensorMap, context);
                const extrapolationValue = (0, $9PnRL.getParamValue)('extrapolationValue', node, tensorMap, context);
                return [
                    ops.image.cropAndResize(image, boxes, boxInd, cropSize, method, extrapolationValue)
                ];
            }
        case 'ImageProjectiveTransformV3':
            {
                const images = (0, $9PnRL.getParamValue)('images', node, tensorMap, context);
                const transforms = (0, $9PnRL.getParamValue)('transforms', node, tensorMap, context);
                const outputShape = (0, $9PnRL.getParamValue)('outputShape', node, tensorMap, context);
                const fillValue = (0, $9PnRL.getParamValue)('fillValue', node, tensorMap, context);
                const interpolation = (0, $9PnRL.getParamValue)('interpolation', node, tensorMap, context);
                const fillMode = (0, $9PnRL.getParamValue)('fillMode', node, tensorMap, context);
                return [
                    ops.image.transform(images, transforms, interpolation.toLowerCase(), fillMode.toLowerCase(), fillValue, outputShape)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $a13e941b4812d120$export$2c04807512a22510 = 'image';

});

parcelRegister("h1Kl3", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $c6567984b1dc615f$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $c6567984b1dc615f$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'Equal':
            return [
                ops.equal((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'NotEqual':
            return [
                ops.notEqual((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Greater':
            return [
                ops.greater((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'GreaterEqual':
            return [
                ops.greaterEqual((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Less':
            return [
                ops.less((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'LessEqual':
            return [
                ops.lessEqual((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'LogicalAnd':
            return [
                ops.logicalAnd((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'LogicalNot':
            return [
                ops.logicalNot((0, $9PnRL.getParamValue)('a', node, tensorMap, context))
            ];
        case 'LogicalOr':
            return [
                ops.logicalOr((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Select':
        case 'SelectV2':
            return [
                ops.where((0, $9PnRL.getParamValue)('condition', node, tensorMap, context), (0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        case 'BitwiseAnd':
            return [
                ops.bitwiseAnd((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c6567984b1dc615f$export$2c04807512a22510 = 'logical';

});

parcelRegister("7TMBo", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $5c035ed45fb383d4$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $5c035ed45fb383d4$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'BatchMatMul':
        case 'BatchMatMulV2':
        case 'MatMul':
            return [
                ops.matMul((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('b', node, tensorMap, context), (0, $9PnRL.getParamValue)('transposeA', node, tensorMap, context), (0, $9PnRL.getParamValue)('transposeB', node, tensorMap, context))
            ];
        case 'Einsum':
            return [
                ops.einsum((0, $9PnRL.getParamValue)('equation', node, tensorMap, context), ...(0, $9PnRL.getParamValue)('tensors', node, tensorMap, context))
            ];
        case 'Transpose':
            return [
                ops.transpose((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('perm', node, tensorMap, context))
            ];
        case '_FusedMatMul':
            const [extraOp, activationFunc] = (0, $9PnRL.getParamValue)('fusedOps', node, tensorMap, context);
            const isBiasAdd = extraOp === 'biasadd';
            const isPrelu = activationFunc === 'prelu';
            const numArgs = (0, $9PnRL.getParamValue)('numArgs', node, tensorMap, context);
            const leakyreluAlpha = (0, $9PnRL.getParamValue)('leakyreluAlpha', node, tensorMap, context);
            if (isBiasAdd) {
                if (isPrelu && numArgs !== 2) throw new Error("Fused MatMul with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
                if (!isPrelu && numArgs !== 1) throw new Error('Fused MatMul with BiasAdd must have one extra argument: bias.');
            }
            const [biasArg, preluArg] = (0, $9PnRL.getParamValue)('args', node, tensorMap, context);
            return [
                ops.fused.matMul({
                    a: (0, $9PnRL.getParamValue)('a', node, tensorMap, context),
                    b: (0, $9PnRL.getParamValue)('b', node, tensorMap, context),
                    transposeA: (0, $9PnRL.getParamValue)('transposeA', node, tensorMap, context),
                    transposeB: (0, $9PnRL.getParamValue)('transposeB', node, tensorMap, context),
                    bias: biasArg,
                    activation: activationFunc,
                    preluActivationWeights: preluArg,
                    leakyreluAlpha: leakyreluAlpha
                })
            ];
        case 'MatrixBandPart':
            return [
                ops.linalg.bandPart((0, $9PnRL.getParamValue)('a', node, tensorMap, context), (0, $9PnRL.getParamValue)('numLower', node, tensorMap, context), (0, $9PnRL.getParamValue)('numUpper', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $5c035ed45fb383d4$export$2c04807512a22510 = 'matrices';

});

parcelRegister("9lSzv", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $6cf068095bcef4e0$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $6cf068095bcef4e0$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'EuclideanNorm':
            return [
                ops.euclideanNorm((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('axis', node, tensorMap, context), (0, $9PnRL.getParamValue)('keepDims', node, tensorMap, context))
            ];
        case 'FusedBatchNorm':
        case 'FusedBatchNormV2':
            return [
                ops.batchNorm((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('mean', node, tensorMap, context), (0, $9PnRL.getParamValue)('variance', node, tensorMap, context), (0, $9PnRL.getParamValue)('offset', node, tensorMap, context), (0, $9PnRL.getParamValue)('scale', node, tensorMap, context), (0, $9PnRL.getParamValue)('epsilon', node, tensorMap, context))
            ];
        case 'FusedBatchNormV3':
            return [
                ops.batchNorm((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('mean', node, tensorMap, context), (0, $9PnRL.getParamValue)('variance', node, tensorMap, context), (0, $9PnRL.getParamValue)('offset', node, tensorMap, context), (0, $9PnRL.getParamValue)('scale', node, tensorMap, context), (0, $9PnRL.getParamValue)('epsilon', node, tensorMap, context))
            ];
        case 'LRN':
            return [
                ops.localResponseNormalization((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('radius', node, tensorMap, context), (0, $9PnRL.getParamValue)('bias', node, tensorMap, context), (0, $9PnRL.getParamValue)('alpha', node, tensorMap, context), (0, $9PnRL.getParamValue)('beta', node, tensorMap, context))
            ];
        case 'Softmax':
            return [
                ops.softmax((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'LogSoftmax':
            return [
                ops.logSoftmax((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $6cf068095bcef4e0$export$2c04807512a22510 = 'normalization';

});

parcelRegister("bPan9", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $89bc80e340dd8862$export$7be88578e558e499);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $89bc80e340dd8862$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'RaggedGather':
            {
                const { outputNestedSplits: outputNestedSplits, outputDenseValues: outputDenseValues } = ops.raggedGather((0, $9PnRL.getParamValue)('paramsNestedSplits', node, tensorMap, context), (0, $9PnRL.getParamValue)('paramsDenseValues', node, tensorMap, context), (0, $9PnRL.getParamValue)('indices', node, tensorMap, context), (0, $9PnRL.getParamValue)('outputRaggedRank', node, tensorMap, context));
                return outputNestedSplits.concat(outputDenseValues);
            }
        case 'RaggedRange':
            {
                const { rtNestedSplits: rtNestedSplits, rtDenseValues: rtDenseValues } = ops.raggedRange((0, $9PnRL.getParamValue)('starts', node, tensorMap, context), (0, $9PnRL.getParamValue)('limits', node, tensorMap, context), (0, $9PnRL.getParamValue)('splits', node, tensorMap, context));
                return [
                    rtNestedSplits,
                    rtDenseValues
                ];
            }
        case 'RaggedTensorToTensor':
            return [
                ops.raggedTensorToTensor((0, $9PnRL.getParamValue)('shape', node, tensorMap, context), (0, $9PnRL.getParamValue)('values', node, tensorMap, context), (0, $9PnRL.getParamValue)('defaultValue', node, tensorMap, context), (0, $9PnRL.getParamValue)('rowPartitionTensors', node, tensorMap, context), (0, $9PnRL.getParamValue)('rowPartitionTypes', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $89bc80e340dd8862$export$2c04807512a22510 = 'ragged';

});

parcelRegister("bHY7p", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $88625822056e3201$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $88625822056e3201$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'Max':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $9PnRL.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.max((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Mean':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $9PnRL.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.mean((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Min':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $9PnRL.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.min((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Sum':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $9PnRL.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.sum((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'All':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $9PnRL.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.all((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Any':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $9PnRL.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.any((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'ArgMax':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.argMax((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'ArgMin':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.argMin((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Prod':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $9PnRL.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.prod((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Cumprod':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const exclusive = (0, $9PnRL.getParamValue)('exclusive', node, tensorMap, context);
                const reverse = (0, $9PnRL.getParamValue)('reverse', node, tensorMap, context);
                return [
                    ops.cumprod((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis, exclusive, reverse)
                ];
            }
        case 'Cumsum':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const exclusive = (0, $9PnRL.getParamValue)('exclusive', node, tensorMap, context);
                const reverse = (0, $9PnRL.getParamValue)('reverse', node, tensorMap, context);
                return [
                    ops.cumsum((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis, exclusive, reverse)
                ];
            }
        case 'Bincount':
            const x = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
            const weights = (0, $9PnRL.getParamValue)('weights', node, tensorMap, context);
            const size = (0, $9PnRL.getParamValue)('size', node, tensorMap, context);
            return [
                ops.bincount(x, weights, size)
            ];
        case 'DenseBincount':
            {
                const x = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                const weights = (0, $9PnRL.getParamValue)('weights', node, tensorMap, context);
                const size = (0, $9PnRL.getParamValue)('size', node, tensorMap, context);
                const binaryOutput = (0, $9PnRL.getParamValue)('binaryOutput', node, tensorMap, context);
                return [
                    ops.denseBincount(x, weights, size, binaryOutput)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $88625822056e3201$export$2c04807512a22510 = 'reduction';

});

parcelRegister("9Buta", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $6fdf345a87642b8d$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $c2DT1 = parcelRequire("c2DT1");
var $jjNRA = parcelRequire("jjNRA");

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $6fdf345a87642b8d$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'ConcatV2':
        case 'Concat':
            {
                const n = (0, $9PnRL.getParamValue)('n', node, tensorMap, context);
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                let inputs = (0, $9PnRL.getParamValue)('tensors', node, tensorMap, context);
                inputs = inputs.slice(0, n);
                return [
                    ops.concat(inputs, axis)
                ];
            }
        case 'Gather':
            {
                const input = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                const indices = (0, $9PnRL.getParamValue)('indices', node, tensorMap, context);
                return [
                    ops.gather(input, ops.cast(indices, 'int32'), 0)
                ];
            }
        case 'GatherV2':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const batchDims = (0, $9PnRL.getParamValue)('batchDims', node, tensorMap, context);
                const input = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                const indices = (0, $9PnRL.getParamValue)('indices', node, tensorMap, context);
                return [
                    ops.gather(input, ops.cast(indices, 'int32'), axis, batchDims)
                ];
            }
        case 'Reverse':
            {
                const dims = (0, $9PnRL.getParamValue)('dims', node, tensorMap, context);
                const axis = [];
                for(let i = 0; i < dims.length; i++)if (dims[i]) axis.push(i);
                const input = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                return [
                    ops.reverse(input, axis)
                ];
            }
        case 'ReverseV2':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const input = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                return [
                    ops.reverse(input, axis)
                ];
            }
        case 'Slice':
            {
                // tslint:disable-next-line:no-any
                const begin = (0, $9PnRL.getParamValue)('begin', node, tensorMap, context);
                // tslint:disable-next-line:no-any
                const size = (0, $9PnRL.getParamValue)('size', node, tensorMap, context);
                return [
                    ops.slice((0, $9PnRL.getParamValue)('x', node, tensorMap, context), begin, size)
                ];
            }
        case 'StridedSlice':
            {
                const begin = (0, $9PnRL.getParamValue)('begin', node, tensorMap, context);
                const end = (0, $9PnRL.getParamValue)('end', node, tensorMap, context);
                const strides = (0, $9PnRL.getParamValue)('strides', node, tensorMap, context);
                const beginMask = (0, $9PnRL.getParamValue)('beginMask', node, tensorMap, context);
                const endMask = (0, $9PnRL.getParamValue)('endMask', node, tensorMap, context);
                const ellipsisMask = (0, $9PnRL.getParamValue)('ellipsisMask', node, tensorMap, context);
                const newAxisMask = (0, $9PnRL.getParamValue)('newAxisMask', node, tensorMap, context);
                const shrinkAxisMask = (0, $9PnRL.getParamValue)('shrinkAxisMask', node, tensorMap, context);
                const tensor = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                return [
                    ops.stridedSlice(tensor, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask)
                ];
            }
        case 'Pack':
            return (0, $c2DT1.tidy)(()=>{
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const tensors = (0, $9PnRL.getParamValue)('tensors', node, tensorMap, context);
                // Reshape the tensors to the first tensor's shape if they don't
                // match.
                const shape = tensors[0].shape;
                const squeezedShape = ops.squeeze(tensors[0]).shape;
                const mapped = tensors.map((tensor)=>{
                    const sameShape = (0, $jjNRA).arraysEqual(tensor.shape, shape);
                    if (!sameShape && !(0, $jjNRA).arraysEqual(ops.squeeze(tensor).shape, squeezedShape)) throw new Error('the input tensors shape does not match');
                    return sameShape ? tensor : ops.reshape(tensor, shape);
                });
                return [
                    ops.stack(mapped, axis)
                ];
            });
        case 'Unpack':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const tensor = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                return ops.unstack(tensor, axis);
            }
        case 'Tile':
            {
                const reps = (0, $9PnRL.getParamValue)('reps', node, tensorMap, context);
                return [
                    ops.tile((0, $9PnRL.getParamValue)('x', node, tensorMap, context), reps)
                ];
            }
        case 'Split':
        case 'SplitV':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                const numOrSizeSplits = (0, $9PnRL.getParamValue)('numOrSizeSplits', node, tensorMap, context);
                const tensor = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                return ops.split(tensor, numOrSizeSplits, axis);
            }
        case 'ScatterNd':
            {
                const indices = (0, $9PnRL.getParamValue)('indices', node, tensorMap, context);
                const values = (0, $9PnRL.getParamValue)('values', node, tensorMap, context);
                const shape = (0, $9PnRL.getParamValue)('shape', node, tensorMap, context);
                return [
                    ops.scatterND(indices, values, shape)
                ];
            }
        case 'GatherNd':
            {
                const x = (0, $9PnRL.getParamValue)('x', node, tensorMap, context);
                const indices = (0, $9PnRL.getParamValue)('indices', node, tensorMap, context);
                return [
                    ops.gatherND(x, indices)
                ];
            }
        case 'SparseToDense':
            {
                const indices = (0, $9PnRL.getParamValue)('sparseIndices', node, tensorMap, context);
                const shape = (0, $9PnRL.getParamValue)('outputShape', node, tensorMap, context);
                const sparseValues = (0, $9PnRL.getParamValue)('sparseValues', node, tensorMap, context);
                const defaultValue = (0, $9PnRL.getParamValue)('defaultValue', node, tensorMap, context);
                return [
                    ops.sparseToDense(indices, sparseValues, shape, sparseValues.dtype === defaultValue.dtype ? defaultValue : ops.cast(defaultValue, sparseValues.dtype))
                ];
            }
        case 'TensorScatterUpdate':
            {
                const indices = (0, $9PnRL.getParamValue)('indices', node, tensorMap, context);
                const values = (0, $9PnRL.getParamValue)('values', node, tensorMap, context);
                const tensor = (0, $9PnRL.getParamValue)('tensor', node, tensorMap, context);
                return [
                    ops.tensorScatterUpdate(tensor, indices, values)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $6fdf345a87642b8d$export$2c04807512a22510 = 'slice_join';

});

parcelRegister("3pwdq", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $27bcb23aad64f19e$export$7be88578e558e499);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $27bcb23aad64f19e$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'SparseFillEmptyRows':
            {
                const { outputIndices: outputIndices, outputValues: outputValues, emptyRowIndicator: emptyRowIndicator, reverseIndexMap: reverseIndexMap } = ops.sparse.sparseFillEmptyRows((0, $9PnRL.getParamValue)('indices', node, tensorMap, context), (0, $9PnRL.getParamValue)('values', node, tensorMap, context), (0, $9PnRL.getParamValue)('denseShape', node, tensorMap, context), (0, $9PnRL.getParamValue)('defaultValue', node, tensorMap, context));
                return [
                    outputIndices,
                    outputValues,
                    emptyRowIndicator,
                    reverseIndexMap
                ];
            }
        case 'SparseReshape':
            {
                const { outputIndices: outputIndices, outputShape: outputShape } = ops.sparse.sparseReshape((0, $9PnRL.getParamValue)('inputIndices', node, tensorMap, context), (0, $9PnRL.getParamValue)('inputShape', node, tensorMap, context), (0, $9PnRL.getParamValue)('newShape', node, tensorMap, context));
                return [
                    outputIndices,
                    outputShape
                ];
            }
        case 'SparseSegmentMean':
            {
                const outputData = ops.sparse.sparseSegmentMean((0, $9PnRL.getParamValue)('data', node, tensorMap, context), (0, $9PnRL.getParamValue)('indices', node, tensorMap, context), (0, $9PnRL.getParamValue)('segmentIds', node, tensorMap, context));
                return [
                    outputData
                ];
            }
        case 'SparseSegmentSum':
            {
                const outputData = ops.sparse.sparseSegmentSum((0, $9PnRL.getParamValue)('data', node, tensorMap, context), (0, $9PnRL.getParamValue)('indices', node, tensorMap, context), (0, $9PnRL.getParamValue)('segmentIds', node, tensorMap, context));
                return [
                    outputData
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $27bcb23aad64f19e$export$2c04807512a22510 = 'sparse';

});

parcelRegister("7RSIj", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $5ba7eca525afd1a8$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $5ba7eca525afd1a8$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'FFT':
            return [
                ops.fft((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'IFFT':
            return [
                ops.ifft((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'RFFT':
            return [
                ops.rfft((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        case 'IRFFT':
            return [
                ops.irfft((0, $9PnRL.getParamValue)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $5ba7eca525afd1a8$export$2c04807512a22510 = 'spectral';

});

parcelRegister("j4Rla", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $de37c451bea39463$export$7be88578e558e499);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $de37c451bea39463$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'StaticRegexReplace':
            return [
                ops.string.staticRegexReplace((0, $9PnRL.getParamValue)('input', node, tensorMap, context), (0, $9PnRL.getParamValue)('pattern', node, tensorMap, context), (0, $9PnRL.getParamValue)('rewrite', node, tensorMap, context), (0, $9PnRL.getParamValue)('replaceGlobal', node, tensorMap, context))
            ];
        case 'StringNGrams':
            {
                const { nGrams: nGrams, nGramsSplits: nGramsSplits } = ops.string.stringNGrams((0, $9PnRL.getParamValue)('data', node, tensorMap, context), (0, $9PnRL.getParamValue)('dataSplits', node, tensorMap, context), (0, $9PnRL.getParamValue)('separator', node, tensorMap, context), (0, $9PnRL.getParamValue)('nGramWidths', node, tensorMap, context), (0, $9PnRL.getParamValue)('leftPad', node, tensorMap, context), (0, $9PnRL.getParamValue)('rightPad', node, tensorMap, context), (0, $9PnRL.getParamValue)('padWidth', node, tensorMap, context), (0, $9PnRL.getParamValue)('preserveShortSequences', node, tensorMap, context));
                return [
                    nGrams,
                    nGramsSplits
                ];
            }
        case 'StringSplit':
            {
                const { indices: indices, values: values, shape: shape } = ops.string.stringSplit((0, $9PnRL.getParamValue)('input', node, tensorMap, context), (0, $9PnRL.getParamValue)('delimiter', node, tensorMap, context), (0, $9PnRL.getParamValue)('skipEmpty', node, tensorMap, context));
                return [
                    indices,
                    values,
                    shape
                ];
            }
        case 'StringToHashBucketFast':
            {
                const output = ops.string.stringToHashBucketFast((0, $9PnRL.getParamValue)('input', node, tensorMap, context), (0, $9PnRL.getParamValue)('numBuckets', node, tensorMap, context));
                return [
                    output
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $de37c451bea39463$export$2c04807512a22510 = 'string';

});

parcelRegister("cXzgX", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $96f65b1bb42dfff1$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $h8nZK = parcelRequire("h8nZK");

var $9PnRL = parcelRequire("9PnRL");
const $96f65b1bb42dfff1$export$7be88578e558e499 = (node, tensorMap, context, ops = $h8nZK)=>{
    switch(node.op){
        case 'Cast':
            return [
                ops.cast((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'ExpandDims':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.expandDims((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Squeeze':
            {
                const axis = (0, $9PnRL.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.squeeze((0, $9PnRL.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Reshape':
            return [
                ops.reshape((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('shape', node, tensorMap, context))
            ];
        case 'EnsureShape':
            return [
                ops.ensureShape((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('shape', node, tensorMap, context))
            ];
        case 'MirrorPad':
            return [
                ops.mirrorPad((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('padding', node, tensorMap, context), (0, $9PnRL.getParamValue)('mode', node, tensorMap, context))
            ];
        case 'PadV2':
        case 'Pad':
            return [
                ops.pad((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('padding', node, tensorMap, context), (0, $9PnRL.getParamValue)('constantValue', node, tensorMap, context))
            ];
        case 'SpaceToBatchND':
            {
                const blockShape = (0, $9PnRL.getParamValue)('blockShape', node, tensorMap, context);
                const paddings = (0, $9PnRL.getParamValue)('paddings', node, tensorMap, context);
                return [
                    ops.spaceToBatchND((0, $9PnRL.getParamValue)('x', node, tensorMap, context), blockShape, paddings)
                ];
            }
        case 'BatchToSpaceND':
            {
                const blockShape = (0, $9PnRL.getParamValue)('blockShape', node, tensorMap, context);
                const crops = (0, $9PnRL.getParamValue)('crops', node, tensorMap, context);
                return [
                    ops.batchToSpaceND((0, $9PnRL.getParamValue)('x', node, tensorMap, context), blockShape, crops)
                ];
            }
        case 'DepthToSpace':
            {
                const blockSize = (0, $9PnRL.getParamValue)('blockSize', node, tensorMap, context);
                const dataFormat = (0, $9PnRL.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                return [
                    ops.depthToSpace((0, $9PnRL.getParamValue)('x', node, tensorMap, context), blockSize, dataFormat)
                ];
            }
        case 'BroadcastTo':
            return [
                ops.broadcastTo((0, $9PnRL.getParamValue)('x', node, tensorMap, context), (0, $9PnRL.getParamValue)('shape', node, tensorMap, context))
            ];
        case 'BroadcastArgs':
            return [
                ops.broadcastArgs((0, $9PnRL.getParamValue)('s0', node, tensorMap, context), (0, $9PnRL.getParamValue)('s1', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $96f65b1bb42dfff1$export$2c04807512a22510 = 'transformation';

});


parcelRegister("hv42p", function(module, exports) {

$parcel$export(module.exports, "ExecutionContext", () => $cbd876c4994cdbd2$export$f7c638676c8af91d);
/**
 * ExecutionContext captures the runtime environment of the node. It keeps
 * track of the current frame and iteration for the control flow ops.
 *
 * For example, typical Dynamic RNN model may contain loops, for which
 * TensorFlow will generate graphs with Enter/Exit nodes to control the
 * current execution frame, and NextIteration Nodes for iteration id increment.
 * For model with branch logic, TensorFLow will generate Switch/Merge ops.
 */ class $cbd876c4994cdbd2$export$f7c638676c8af91d {
    constructor(weightMap = {}, tensorArrayMap = {}, tensorListMap = {}, functionMap = {}, parseNodeNameCache){
        this.weightMap = weightMap;
        this.tensorArrayMap = tensorArrayMap;
        this.tensorListMap = tensorListMap;
        this.functionMap = functionMap;
        this.parseNodeNameCache = parseNodeNameCache;
        this.rootContext = {
            id: 0,
            frameName: '',
            iterationId: 0
        };
        this.contexts = [
            this.rootContext
        ];
        this.lastId = 0;
        this.generateCurrentContextIds();
    }
    newFrame(id, frameName) {
        return {
            id: id,
            frameName: frameName,
            iterationId: 0
        };
    }
    /**
     * Set the current context
     * @param contexts: ExecutionContextInfo[] the current path of execution
     * frames
     */ set currentContext(contexts) {
        if (this.contexts !== contexts) {
            this.contexts = contexts;
            this.generateCurrentContextIds();
        }
    }
    get currentContext() {
        return this.contexts;
    }
    /**
     * Returns the current context in string format.
     */ get currentContextId() {
        return this._currentContextIds[0];
    }
    /**
     * Returns the current context and all parent contexts in string format.
     * This allow access to the nodes in the current and parent frames.
     */ get currentContextIds() {
        return this._currentContextIds;
    }
    generateCurrentContextIds() {
        const names = [];
        for(let i = 0; i < this.contexts.length - 1; i++){
            const contexts = this.contexts.slice(0, this.contexts.length - i);
            names.push(this.contextIdforContexts(contexts));
        }
        names.push('');
        this._currentContextIds = names;
    }
    contextIdforContexts(contexts) {
        return contexts ? contexts.map((context)=>context.id === 0 && context.iterationId === 0 ? '' : `${context.frameName}-${context.iterationId}`).join('/') : '';
    }
    /**
     * Enter a new frame, a new context is pushed on the current context list.
     * @param frameId new frame id
     */ enterFrame(frameId) {
        if (this.contexts) {
            this.lastId++;
            this.contexts = this.contexts.slice();
            this.contexts.push(this.newFrame(this.lastId, frameId));
            this._currentContextIds.unshift(this.contextIdforContexts(this.contexts));
        }
    }
    /**
     * Exit the current frame, the last context is removed from the current
     * context list.
     */ exitFrame() {
        if (this.contexts && this.contexts.length > 1) {
            this.contexts = this.contexts.slice();
            this.contexts.splice(-1);
            this.currentContextIds.shift();
        } else throw new Error('Cannot exit frame, the context is empty');
    }
    /**
     * Enter the next iteration of a loop, the iteration id of last context is
     * increased.
     */ nextIteration() {
        if (this.contexts && this.contexts.length > 0) {
            this.contexts = this.contexts.slice();
            this.lastId++;
            const context = Object.assign({}, this.contexts[this.contexts.length - 1]);
            context.iterationId += 1;
            context.id = this.lastId;
            this.contexts.splice(-1, 1, context);
            this._currentContextIds.splice(0, 1, this.contextIdforContexts(this.contexts));
        } else throw new Error('Cannot increase frame iteration, the context is empty');
    }
    getWeight(name) {
        return this.weightMap[name];
    }
    addTensorArray(tensorArray) {
        this.tensorArrayMap[tensorArray.id] = tensorArray;
    }
    getTensorArray(id) {
        return this.tensorArrayMap[id];
    }
    addTensorList(tensorList) {
        this.tensorListMap[tensorList.id] = tensorList;
    }
    getTensorList(id) {
        return this.tensorListMap[id];
    }
    dispose(keepIds) {
        for(const key in this.tensorArrayMap)this.tensorArrayMap[key].clearAndClose(keepIds);
        for(const key in this.tensorListMap)this.tensorListMap[key].clearAndClose(keepIds);
    }
}

});

parcelRegister("a96bd", function(module, exports) {

$parcel$export(module.exports, "getExecutionSubgraph", () => $762f89dd007c9432$export$73c2416e6ab509c5);
$parcel$export(module.exports, "isControlFlow", () => $762f89dd007c9432$export$683ae22d42a16fd1);
$parcel$export(module.exports, "getNodesInTopologicalOrder", () => $762f89dd007c9432$export$66747854b63761e1);
$parcel$export(module.exports, "getNodeLiveUntilMap", () => $762f89dd007c9432$export$1b4890839d1091f5);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9PnRL = parcelRequire("9PnRL");
function $762f89dd007c9432$export$73c2416e6ab509c5(inputs, outputs, weightMap, initNodes) {
    const usedNodes = new Set();
    const missingInputs = [];
    let dynamicNode = null;
    let syncInputs = null;
    // Start with the outputs, going backwards and find all the nodes that are
    // needed to compute those outputs.
    const seen = new Set();
    const inputNodeNames = new Set(Object.keys(inputs).map((name)=>(0, $9PnRL.parseNodeName)(name)[0]));
    initNodes = initNodes || [];
    const initNodeNames = new Set(initNodes.map((node)=>(0, $9PnRL.parseNodeName)(node.name)[0]));
    const frontier = [
        ...outputs
    ];
    while(frontier.length > 0){
        const node = frontier.pop();
        if ($762f89dd007c9432$export$683ae22d42a16fd1(node) || $762f89dd007c9432$export$eee9c104bd05368d(node) || $762f89dd007c9432$export$ad7e54a7e645a447(node)) {
            if (dynamicNode == null) {
                dynamicNode = node;
                syncInputs = dynamicNode.children.map((child)=>child.name).filter((name)=>usedNodes.has(name));
            }
        }
        usedNodes.add(node.name);
        // Weights are dead end since we already have their values.
        if (weightMap[node.name] != null) continue;
        // This node is a dead end since it's one of the user-provided inputs.
        if (inputNodeNames.has(node.name)) continue;
        // This node is a dead end since it doesn't have any inputs.
        if (initNodeNames.has(node.name)) continue;
        if (node.inputs.length === 0) {
            missingInputs.push(node.name);
            continue;
        }
        node.inputs.forEach((input)=>{
            // Don't add to the frontier if it is already there.
            if (seen.has(input.name)) return;
            seen.add(input.name);
            frontier.push(input);
        });
    }
    return {
        inputs: inputs,
        outputs: outputs,
        usedNodes: usedNodes,
        missingInputs: missingInputs,
        dynamicNode: dynamicNode,
        syncInputs: syncInputs
    };
}
function $762f89dd007c9432$export$66747854b63761e1(graph, executionInfo) {
    const { usedNodes: usedNodes, inputs: inputs } = executionInfo;
    const inputNodes = Object.keys(inputs).map((name)=>(0, $9PnRL.parseNodeName)(name)[0]).map((name)=>graph.nodes[name]);
    const initNodes = graph.initNodes || [];
    const isUsed = (node)=>usedNodes.has(typeof node === 'string' ? node : node.name);
    function unique(nodes) {
        return [
            ...new Map(nodes.map((node)=>[
                    node.name,
                    node
                ])).values()
        ];
    }
    const predefinedNodes = unique([
        ...inputNodes,
        ...graph.weights,
        ...initNodes
    ]).filter(isUsed);
    const allNodes = unique([
        ...predefinedNodes,
        ...Object.values(graph.nodes)
    ]).filter(isUsed);
    const nameToNode = new Map(allNodes.map((node)=>[
            node.name,
            node
        ]));
    const inCounts = {};
    for (const node of allNodes){
        inCounts[node.name] = inCounts[node.name] || 0;
        for (const child of node.children){
            // When the child is unused, set in counts to infinity so that it will
            // never be decreased to 0 and added to the execution list.
            if (!isUsed(child)) inCounts[child.name] = Number.POSITIVE_INFINITY;
            inCounts[child.name] = (inCounts[child.name] || 0) + 1;
        }
    }
    // Build execution order for all used nodes regardless whether they are
    // predefined or not.
    const frontier = Object.entries(inCounts).filter(([, inCount])=>inCount === 0).map(([name])=>name);
    const orderedNodeNames = [
        ...frontier
    ];
    while(frontier.length > 0){
        const nodeName = frontier.pop();
        const node = nameToNode.get(nodeName);
        for (const child of node.children.filter(isUsed))if (--inCounts[child.name] === 0) {
            orderedNodeNames.push(child.name);
            frontier.push(child.name);
        }
    }
    const orderedNodes = orderedNodeNames.map((name)=>nameToNode.get(name));
    const filteredOrderedNodes = $762f89dd007c9432$var$filterPredefinedReachableNodes(orderedNodes, predefinedNodes);
    // TODO: Turn validation on/off with tf env flag.
    $762f89dd007c9432$var$validateNodesExecutionOrder(filteredOrderedNodes, predefinedNodes);
    return filteredOrderedNodes;
}
/**
 * This is a helper function of `getNodesInTopologicalOrder`.
 * Returns ordered nodes reachable by at least one predefined node.
 * This can help us filter out redundant nodes from the returned node list.
 * For example:
 * If we have four nodes with dependencies like this:
 *   a --> b --> c --> d
 * when node `c` is predefined (e.g. given as an input tensor), we can
 * skip node `a` and `b` since their outputs will never be used.
 *
 * @param orderedNodes Graph nodes in execution order.
 * @param predefinedNodes Graph inputs, weights, and init nodes. Nodes in this
 *     list must have distinct names.
 */ function $762f89dd007c9432$var$filterPredefinedReachableNodes(orderedNodes, predefinedNodes) {
    const nameToNode = new Map(orderedNodes.map((node)=>[
            node.name,
            node
        ]));
    // TODO: Filter out more nodes when >=2 nodes are predefined in a path.
    const stack = predefinedNodes.map((node)=>node.name);
    const predefinedReachableNodeNames = new Set(stack);
    // Perform a DFS starting from the set of all predefined nodes
    // to find the set of all nodes reachable from the predefined nodes.
    while(stack.length > 0){
        const nodeName = stack.pop();
        const node = nameToNode.get(nodeName);
        for (const child of node.children){
            if (!nameToNode.has(child.name) || predefinedReachableNodeNames.has(child.name)) continue;
            predefinedReachableNodeNames.add(child.name);
            stack.push(child.name);
        }
    }
    // Filter out unreachable nodes and build the ordered node list.
    const filteredOrderedNodes = orderedNodes.filter((node)=>predefinedReachableNodeNames.has(node.name));
    return filteredOrderedNodes;
}
class $762f89dd007c9432$var$NodesExecutionOrderError extends Error {
    constructor(message){
        super(`NodesExecutionOrderError: ${message}`);
    }
}
/**
 * This is a helper function of `getNodesInTopologicalOrder`.
 * Validates property: given nodes `a` and `b`, Order(a) > Order(b) if `a`
 * is a child of `b`. This function throws an error if validation fails.
 *
 * @param orderedNodes Graph nodes in execution order.
 * @param predefinedNodes Graph inputs, weights, and init nodes. Nodes in this
 *     list must have distinct names.
 */ function $762f89dd007c9432$var$validateNodesExecutionOrder(orderedNodes, predefinedNodes) {
    const nodeNameToOrder = new Map(orderedNodes.map((node, order)=>[
            node.name,
            order
        ]));
    const predefinedNodeNames = new Set(predefinedNodes.map((node)=>node.name));
    const isPredefined = (node)=>predefinedNodeNames.has(typeof node === 'string' ? node : node.name);
    const willBeExecutedNodeNames = new Set(orderedNodes.map((node)=>node.name));
    const willBeExecuted = (node)=>willBeExecutedNodeNames.has(typeof node === 'string' ? node : node.name);
    for (const node of orderedNodes){
        for (const child of node.children.filter(willBeExecuted)){
            if (!nodeNameToOrder.has(child.name)) throw new $762f89dd007c9432$var$NodesExecutionOrderError(`Child ${child.name} of node ${node.name} is unreachable.`);
            if (nodeNameToOrder.get(node.name) > nodeNameToOrder.get(child.name)) throw new $762f89dd007c9432$var$NodesExecutionOrderError(`Node ${node.name} is scheduled to run after its child ${child.name}.`);
        }
        if (!isPredefined(node)) for (const input of node.inputs){
            if (!nodeNameToOrder.has(input.name)) throw new $762f89dd007c9432$var$NodesExecutionOrderError(`Input ${input.name} of node ${node.name} is unreachable.`);
            if (nodeNameToOrder.get(input.name) > nodeNameToOrder.get(node.name)) throw new $762f89dd007c9432$var$NodesExecutionOrderError(`Node ${node.name} is scheduled to run before its input ${input.name}.`);
        }
    }
}
function $762f89dd007c9432$export$1b4890839d1091f5(orderedNodes) {
    const nodeNameToOrder = new Map(orderedNodes.map((node, order)=>[
            node.name,
            order
        ]));
    const INF_LIFE = Number.MAX_SAFE_INTEGER;
    // Make control flow nodes (and consequently their direct parents)
    // live forever since they're tricky to track correctly.
    const selfLifespans = orderedNodes.map((node, nodeOrder)=>$762f89dd007c9432$export$683ae22d42a16fd1(node) ? INF_LIFE : nodeOrder);
    const getSelfLifeSpan = (node)=>{
        const selfLife = selfLifespans[nodeNameToOrder.get(node.name)];
        if (selfLife == null) // If nodeToOrder does not contain the node, it is unused or
        // unreachable in graph.
        return -1;
        return selfLife;
    };
    // `liveUntil[i]` points to the last node in the `orderedNodes` array that
    // may depend on tensors from node `i`. It indicates that all the
    // intermediate tensors from `orderedNodes[i]` should be disposed after
    // `orderedNodes[liveUntil[i]]` is executed.
    // A node lives long enough to pass on its tensors to its children.
    // It lives until at least `max(node's position, children's positions)`.
    const liveUntilOrders = orderedNodes.map((node, nodeOrder)=>{
        return node.children.map(getSelfLifeSpan).reduce((a, b)=>Math.max(a, b), selfLifespans[nodeOrder]);
    });
    // liveUntilMap:
    // - Key: Name of a node `x`
    // - Values: All nodes whose intermediate tensors should be disposed
    //           after `x` is executed.
    const liveUntilMap = new Map();
    for(let nodeOrder = 0; nodeOrder < orderedNodes.length; ++nodeOrder){
        const liveUntilOrder = liveUntilOrders[nodeOrder];
        if (liveUntilOrder === INF_LIFE) continue;
        const node = orderedNodes[nodeOrder];
        const liveUntilNode = orderedNodes[liveUntilOrder];
        if (!liveUntilMap.has(liveUntilNode.name)) liveUntilMap.set(liveUntilNode.name, []);
        liveUntilMap.get(liveUntilNode.name).push(node);
    }
    return liveUntilMap;
}
const $762f89dd007c9432$var$CONTROL_FLOW_OPS = new Set([
    'Switch',
    'Merge',
    'Enter',
    'Exit',
    'NextIteration',
    'StatelessIf',
    'StatelessWhile',
    'if',
    'While'
]);
const $762f89dd007c9432$var$DYNAMIC_SHAPE_OPS = new Set([
    'NonMaxSuppressionV2',
    'NonMaxSuppressionV3',
    'NonMaxSuppressionV5',
    'Where'
]);
const $762f89dd007c9432$var$HASH_TABLE_OPS = new Set([
    'HashTable',
    'HashTableV2',
    'LookupTableImport',
    'LookupTableImportV2',
    'LookupTableFind',
    'LookupTableFindV2',
    'LookupTableSize',
    'LookupTableSizeV2'
]);
function $762f89dd007c9432$export$683ae22d42a16fd1(node) {
    return $762f89dd007c9432$var$CONTROL_FLOW_OPS.has(node.op);
}
function $762f89dd007c9432$export$eee9c104bd05368d(node) {
    return $762f89dd007c9432$var$DYNAMIC_SHAPE_OPS.has(node.op);
}
function $762f89dd007c9432$export$ad7e54a7e645a447(node) {
    return $762f89dd007c9432$var$HASH_TABLE_OPS.has(node.op);
}

});


parcelRegister("kqYp1", function(module, exports) {

$parcel$export(module.exports, "ResourceManager", () => $ee051708509f1ea6$export$60667f9de734e56);
/**
 * Contains global resources of a model.
 */ class $ee051708509f1ea6$export$60667f9de734e56 {
    constructor(hashTableNameToHandle = {}, hashTableMap = {}){
        this.hashTableNameToHandle = hashTableNameToHandle;
        this.hashTableMap = hashTableMap;
    }
    /**
     * Register a `HashTable` in the resource manager.
     *
     * The `HashTable` can be retrieved by `resourceManager.getHashTableById`,
     * where id is the table handle tensor's id.
     *
     * @param name Op node name that creates the `HashTable`.
     * @param hashTable The `HashTable` to be added to resource manager.
     */ addHashTable(name, hashTable) {
        this.hashTableNameToHandle[name] = hashTable.handle;
        this.hashTableMap[hashTable.id] = hashTable;
    }
    /**
     * Get the table handle by node name.
     * @param name Op node name that creates the `HashTable`. This name is also
     *     used in the inputs list of lookup and import `HashTable` ops.
     */ getHashTableHandleByName(name) {
        return this.hashTableNameToHandle[name];
    }
    /**
     * Get the actual `HashTable` by its handle tensor's id.
     * @param id The id of the handle tensor.
     */ getHashTableById(id) {
        return this.hashTableMap[id];
    }
    /**
     * Dispose `ResourceManager`, including its hashTables and tensors in them.
     */ dispose() {
        for(const key in this.hashTableMap){
            this.hashTableMap[key].clearAndClose();
            delete this.hashTableMap[key];
        }
        for(const name in this.hashTableNameToHandle){
            this.hashTableNameToHandle[name].dispose();
            delete this.hashTableNameToHandle[name];
        }
    }
}

});


parcelRegister("1SddR", function(module, exports) {

$parcel$export(module.exports, "version", () => $15d517509cfbc24d$export$83d89fbfd8236492);
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $15d517509cfbc24d$export$83d89fbfd8236492 = '4.22.0';

});


parcelRegister("3Rm2E", function(module, exports) {
$parcel$export(module.exports, "webgpu_util", () => (parcelRequire("9Dn6G")));
$parcel$export(module.exports, "WebGPUBackend", () => (parcelRequire("j8LvK")).WebGPUBackend);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("VITgv");
parcelRequire("c8TDA");

});
parcelRegister("VITgv", function(module, exports) {
$parcel$export(module.exports, "webgpu_util", () => (parcelRequire("9Dn6G")));
$parcel$export(module.exports, "WebGPUBackend", () => (parcelRequire("j8LvK")).WebGPUBackend);
/**
 * @license
 * Copyright 2022 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("9dJWF");
parcelRequire("i64bB");
var $ibsdL = parcelRequire("ibsdL");
var $c2DT1 = parcelRequire("c2DT1");

var $j8LvK = parcelRequire("j8LvK");

var $9Dn6G = parcelRequire("9Dn6G");
parcelRequire("7HGX2");
if ((0, $9Dn6G.isWebGPUSupported)()) (0, $c2DT1.registerBackend)('webgpu', async ()=>{
    const gpuDescriptor = {
        powerPreference: (0, $ibsdL.env)().get('WEBGPU_USE_LOW_POWER_GPU') ? 'low-power' : 'high-performance'
    };
    const adapter = await navigator.gpu.requestAdapter(gpuDescriptor);
    const deviceDescriptor = {};
    const requiredFeatures = [];
    if (adapter.features.has('timestamp-query')) requiredFeatures.push('timestamp-query');
    if (adapter.features.has('bgra8unorm-storage')) requiredFeatures.push([
        'bgra8unorm-storage'
    ]);
    deviceDescriptor.requiredFeatures = requiredFeatures;
    const adapterLimits = adapter.limits;
    deviceDescriptor.requiredLimits = {
        'maxComputeWorkgroupStorageSize': adapterLimits.maxComputeWorkgroupStorageSize,
        'maxComputeWorkgroupsPerDimension': adapterLimits.maxComputeWorkgroupsPerDimension,
        'maxStorageBufferBindingSize': adapterLimits.maxStorageBufferBindingSize,
        'maxBufferSize': adapterLimits.maxBufferSize,
        'maxComputeWorkgroupSizeX': adapterLimits.maxComputeWorkgroupSizeX,
        'maxComputeInvocationsPerWorkgroup': adapterLimits.maxComputeInvocationsPerWorkgroup
    };
    const device = await adapter.requestDevice(deviceDescriptor);
    const adapterInfo = 'info' in adapter ? adapter.info : 'requestAdapterInfo' in adapter ? await adapter.requestAdapterInfo() : undefined;
    return new (0, $j8LvK.WebGPUBackend)(device, adapterInfo);
}, 3 /*priority*/ );

});
parcelRegister("9dJWF", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $ibsdL = parcelRequire("ibsdL");
const $6b68f7b4a69dea68$var$ENV = (0, $ibsdL.env)();
/** The batched dispatching calls size in the device queue. */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_DEFERRED_SUBMIT_BATCH_SIZE', ()=>15);
/**
 * Whether we forward execution to the CPU backend if tensors are small and
 * reside on the CPU.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_CPU_FORWARD', ()=>true);
/**
 * This flag is used to test different types of matmul programs.
 *
 * See MatMulProgramType in webgpu_util.ts for a list of available values.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_MATMUL_PROGRAM_TYPE', ()=>-1);
/**
 * Whether to use conv2dTranspose_naive which directly implement the
 * conv2dTranspose logic rather than using a matmul to simulate.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_USE_NAIVE_CONV2D_TRANSPOSE', ()=>true);
/**
 * Whether we use low power GPU. Otherwise, a high performance GPU will be
 * requested.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_USE_LOW_POWER_GPU', ()=>false);
/**
 * Threshold for input tensor size that determines whether WebGPU backend will
 * delegate computation to CPU.
 *
 * Default value is 1000.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_CPU_HANDOFF_SIZE_THRESHOLD', ()=>1000);
/**
 * Whether to use a dummy canvas to make profiling tools like PIX work with
 * TFJS webgpu backend.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_USE_PROFILE_TOOL', ()=>false);
/**
 * Whether to use import API.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_IMPORT_EXTERNAL_TEXTURE', ()=>true);
/**
 * Whether to use conv2dNaive for debugging.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_USE_NAIVE_CONV2D_DEBUG', ()=>false);
/**
 * Threshold to increase dispatched workgroups for matmul. If too few workgroups
 * are dispatched, it means the hardware may be in low occupancy.
 * -1 means it's not set by the user. A default strategy will be applied.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_THRESHOLD_TO_INCREASE_WORKGROUPS_FOR_MATMUL', ()=>-1);
/**
 * Whether we will run im2col as a separate shader for convolution.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_CONV_SEPARATE_IM2COL_SHADER', ()=>false);
/**
 * A string used to match shader key. If any matches, print the related shader.
 * Seperated by comma. 'all' to print all. 'binary' to print binary(add, mul,
 * etc.). 'unary,conv2d' to print both unary and conv2d.
 */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_PRINT_SHADER', ()=>'');
/** Experimental flag, whether enter compile only phase. */ $6b68f7b4a69dea68$var$ENV.registerFlag('WEBGPU_ENGINE_COMPILE_ONLY', ()=>false);

});

parcelRegister("j8LvK", function(module, exports) {

$parcel$export(module.exports, "WebGPUBackend", () => $def39e621b8a256c$export$6f9bc39baf8c093a);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("9dJWF");
parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $iG87S = parcelRequire("iG87S");
var $fJqML = parcelRequire("fJqML");
var $c2DT1 = parcelRequire("c2DT1");
var $ibsdL = parcelRequire("ibsdL");
var $jjNRA = parcelRequire("jjNRA");

var $eVz64 = parcelRequire("eVz64");

var $4S73i = parcelRequire("4S73i");

var $hBMar = parcelRequire("hBMar");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
// Empirically determined constant used to determine size threshold for handing
// off execution to the CPU.
const $def39e621b8a256c$var$CPU_HANDOFF_SIZE_THRESHOLD = (0, $ibsdL.env)().getNumber('WEBGPU_CPU_HANDOFF_SIZE_THRESHOLD');
// Reshape dispatch, not to exceed device limits.
const $def39e621b8a256c$var$reshapeDispatch = (device, program)=>{
    const MAX_COMPUTE_PER_DIMENSION_DISPATCH_SIZE = device.limits.maxComputeWorkgroupsPerDimension;
    const layout = program['dispatchLayout'];
    const dispatch = program['dispatch'];
    if (dispatch.every((d)=>d <= MAX_COMPUTE_PER_DIMENSION_DISPATCH_SIZE)) return dispatch;
    (0, $jjNRA).assert(dispatch[0] > MAX_COMPUTE_PER_DIMENSION_DISPATCH_SIZE && layout.y === undefined && layout.z === undefined, ()=>'Dispatch size exceeds WebGPU limits in Y or Z dimension.');
    let dispatchAverage = Math.ceil(Math.sqrt(dispatch[0]));
    if (dispatchAverage > MAX_COMPUTE_PER_DIMENSION_DISPATCH_SIZE) {
        dispatchAverage = Math.ceil(Math.cbrt(dispatch[0]));
        (0, $jjNRA).assert(dispatchAverage <= MAX_COMPUTE_PER_DIMENSION_DISPATCH_SIZE, ()=>'Total dispatch size exceeds WebGPU maximum.');
        return [
            dispatchAverage,
            dispatchAverage,
            dispatchAverage
        ];
    } else return [
        dispatchAverage,
        dispatchAverage,
        1
    ];
};
class $def39e621b8a256c$export$6f9bc39baf8c093a extends (0, $fJqML.KernelBackend) {
    nextDataId() {
        return $def39e621b8a256c$export$6f9bc39baf8c093a.nextDataId++;
    }
    constructor(device, adapterInfo){
        super();
        this.commandQueueOwnedIds = new WeakSet();
        this.dispatchCountInPass = 0;
        this.disposed = false;
        this.downloadWaitMs = 0;
        this.tensorDataPendingDisposal = [];
        this.queryResolveBuffer = null;
        this.querySet = null;
        this.querySetCount = 2;
        this.stagingPendingDisposal = [];
        this.uniformPendingDisposal = [];
        this.uploadWaitMs = 0;
        this.hasReadSyncWarned = false;
        this.hasTimestampQueryWarned = false;
        if (!$9Dn6G.isWebGPUSupported()) throw new Error('WebGPU is not supported on this device');
        this.pipelineCache = {};
        this.device = device;
        this.queue = device.queue;
        this.commandEncoder = null;
        this.computePassEncoder = null;
        this.adapterInfo = new (0, $eVz64.AdapterInfo)(adapterInfo);
        this.supportTimestampQuery = this.device.features.has('timestamp-query');
        this.thresholdToIncreaseWorkgroups = this.adapterInfo.intelGPUGeneration >= 12 ? 16 : 8;
        this.bufferManager = new (0, $4S73i.BufferManager)(this.device);
        this.textureManager = new (0, $hBMar.TextureManager)(this.device);
        this.tensorMap = new (0, $fJqML.DataStorage)(this, (0, $c2DT1.engine)());
        // Profiling tools like PIX needs this dummy canvas to
        // trigger capturing a frame.
        if ((0, $ibsdL.env)().getBool('WEBGPU_USE_PROFILE_TOOL')) {
            this.dummyCanvas = document.createElement('canvas');
            this.dummyCanvas.width = 1;
            this.dummyCanvas.height = 1;
            this.dummyContext = this.dummyCanvas.getContext('webgpu');
            this.dummyContext.configure({
                device: device,
                format: 'bgra8unorm'
            });
            document.body.appendChild(this.dummyCanvas);
        }
    }
    floatPrecision() {
        return 32;
    }
    /**
     * Dispose the memory if the dataId has 0 refCount. Return true if the memory
     * is released or delayed in this backend, false if there are still
     * references.
     * @param dataId
     * @oaram force Optional, remove the data regardless of refCount
     */ disposeData(dataId, force = false) {
        // No-op if already disposed.
        if (!this.tensorMap.has(dataId)) return true;
        const tensorData = this.tensorMap.get(dataId);
        if (force) tensorData.refCount = 0;
        else tensorData.refCount--;
        if (tensorData.refCount > 0) return false;
        if (tensorData.complexTensorInfos != null) {
            this.disposeData(tensorData.complexTensorInfos.real.dataId);
            this.disposeData(tensorData.complexTensorInfos.imag.dataId);
        }
        if (this.commandQueueOwnedIds.has(dataId)) {
            this.tensorDataPendingDisposal.push(dataId);
            return true;
        }
        this.releaseResource(dataId);
        this.tensorMap.delete(dataId);
        return true;
    }
    memory() {
        return {
            numBytesInGPU: this.bufferManager.numBytesUsed,
            numBytesAllocatedInGPU: this.bufferManager.numBytesAllocated,
            unreliable: false
        };
    }
    releaseResource(dataId) {
        const tensorData = this.tensorMap.get(dataId);
        if (!tensorData || !tensorData.resource) return;
        // If tensor's resource is from external, do not release.
        if (tensorData.external) {
            tensorData.resource = null;
            return;
        }
        if (tensorData.resource instanceof GPUBuffer) this.bufferManager.releaseBuffer(tensorData.resource);
        else if (tensorData.resource instanceof GPUTexture) this.textureManager.releaseTexture(tensorData.resource);
        tensorData.resource = null;
    }
    /** Return refCount of a `TensorData`. */ refCount(dataId) {
        if (this.tensorMap.has(dataId)) {
            const tensorData = this.tensorMap.get(dataId);
            return tensorData.refCount;
        }
        return 0;
    }
    /** Increase refCount of a `TensorData`. */ incRef(dataId) {
        const tensorData = this.tensorMap.get(dataId);
        tensorData.refCount++;
    }
    /** Decrease refCount of a `TensorData`. */ decRef(dataId) {
        if (this.tensorMap.has(dataId)) {
            const tensorData = this.tensorMap.get(dataId);
            tensorData.refCount--;
        }
    }
    write(values, shape, dtype) {
        if (dtype === 'complex64' && values != null) throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        const dataId = {
            id: this.nextDataId()
        };
        this.tensorMap.set(dataId, {
            dtype: dtype,
            shape: shape,
            values: values,
            refCount: 1
        });
        return dataId;
    }
    move(dataId, values, shape, dtype, refCount) {
        if (dtype === 'complex64') throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        this.tensorMap.set(dataId, {
            dtype: dtype,
            shape: shape,
            values: values,
            refCount: refCount
        });
    }
    submitQueue() {
        this.queue.submit([
            this.commandEncoder.finish()
        ]);
        this.commandEncoder = null;
        this.dispatchCountInPass = 0;
        this.commandQueueOwnedIds = new WeakSet();
        this.tensorDataPendingDisposal.forEach((d)=>{
            this.releaseResource(d);
            this.tensorMap.delete(d);
        });
        this.uniformPendingDisposal.forEach((b)=>this.bufferManager.releaseBuffer(b));
        this.stagingPendingDisposal.forEach((b)=>this.bufferManager.releaseBuffer(b, false));
        this.tensorDataPendingDisposal = [];
        this.uniformPendingDisposal = [];
        this.stagingPendingDisposal = [];
    }
    ensureCommandEncoderReady() {
        if (!this.commandEncoder) this.commandEncoder = this.device.createCommandEncoder();
    }
    endComputePassEncoder() {
        if (this.computePassEncoder) {
            this.computePassEncoder.end();
            this.computePassEncoder = null;
        }
    }
    // Check if parallel compilation is done.
    async checkCompileCompletionAsync() {
        let pipelines;
        try {
            pipelines = await Promise.all(Object.values(this.pipelineCache));
        } catch (e) {
            // TODO: Add test case to catch this exception.
            throw new Error(e.message);
        }
        Object.keys(this.pipelineCache).map((key, i)=>{
            this.pipelineCache[key] = pipelines[i];
        });
    }
    async getBufferData(buffer) {
        if ((0, $ibsdL.env)().getBool('WEBGPU_ENGINE_COMPILE_ONLY')) {
            console.warn('The data may be invalid since WEBGPU_ENGINE_COMPILE_ONLY is true, this can only be called when WEBGPU_ENGINE_COMPILE_ONLY is false');
            return null;
        }
        const size = buffer.size;
        const stagingBuffer = this.bufferManager.acquireBuffer(size, GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ);
        this.ensureCommandEncoderReady();
        this.endComputePassEncoder();
        this.commandEncoder.copyBufferToBuffer(buffer, 0, stagingBuffer, 0, size);
        this.submitQueue();
        await stagingBuffer.mapAsync(GPUMapMode.READ);
        const values = stagingBuffer.getMappedRange().slice(0);
        stagingBuffer.unmap();
        if (stagingBuffer != null) this.bufferManager.releaseBuffer(stagingBuffer);
        // Need to get texture from swapChain to enable profiling tool
        // to capture a frame
        if ((0, $ibsdL.env)().getBool('WEBGPU_USE_PROFILE_TOOL')) {
            (0, $jjNRA).assert(this.dummyContext !== undefined, ()=>`Fail to get context for profiling tool`);
            this.dummyContext.getCurrentTexture();
        }
        return values;
    }
    convertAndCacheOnCPU(dataId, data) {
        const tensorData = this.tensorMap.get(dataId);
        tensorData.values = data;
        return tensorData.values;
    }
    readSync(dataId) {
        const tensorData = this.tensorMap.get(dataId);
        const { values: values, complexTensorInfos: complexTensorInfos } = tensorData;
        if (values != null || tensorData.dtype === 'string') return values;
        if (tensorData.dtype === 'complex64') {
            const realValues = this.readSync(complexTensorInfos.real.dataId);
            const imagValues = this.readSync(complexTensorInfos.imag.dataId);
            const complexVals = (0, $jjNRA).convertBackendValuesAndArrayBuffer((0, $7MaPk).mergeRealAndImagArrays(realValues, imagValues).buffer, 'float32');
            this.convertAndCacheOnCPU(dataId, complexVals);
            return complexVals;
        }
        if (!this.hasReadSyncWarned) {
            this.hasReadSyncWarned = true;
            console.warn(`The performance of synchronously reading data from GPU to CPU is ` + `poor on the webgpu backend, please use asynchronous APIs instead.`);
        }
        const alphaModes = [
            'opaque',
            'premultiplied'
        ];
        const buffer = tensorData.resource;
        const bufferSize = buffer.size;
        (0, $jjNRA).assert(bufferSize % 4 === 0, ()=>"Because there is 4 bytes for one pixel, buffer size must be multiple of 4.");
        const pixelsSize = bufferSize / 4;
        const valsGPU = new ArrayBuffer(bufferSize);
        // TODO: adjust the reading window size according the `bufferSize`.
        const canvasWidth = 256, canvasHeight = 256;
        const stagingDeviceStorage = alphaModes.map((_)=>new OffscreenCanvas(canvasWidth, canvasHeight));
        const stagingHostStorage = new OffscreenCanvas(canvasWidth, canvasHeight);
        this.endComputePassEncoder();
        stagingDeviceStorage.map((storage, index)=>{
            const context = storage.getContext('webgpu');
            // TODO: use rgba8unorm format when this format is supported on Mac.
            // https://bugs.chromium.org/p/chromium/issues/detail?id=1298618
            context.configure({
                device: this.device,
                format: 'bgra8unorm',
                usage: GPUTextureUsage.COPY_DST,
                alphaMode: alphaModes[index]
            });
            return context.getCurrentTexture();
        }).map((texture, index)=>{
            const bytesPerRow = canvasWidth * 4;
            const readDataGPUToCPU = (width, height, offset)=>{
                this.ensureCommandEncoderReady();
                this.commandEncoder.copyBufferToTexture({
                    buffer: buffer,
                    bytesPerRow: bytesPerRow,
                    offset: offset
                }, {
                    texture: texture
                }, {
                    width: width,
                    height: height
                });
                this.submitQueue();
                const context = stagingHostStorage.getContext('2d', {
                    willReadFrequently: true
                });
                context.clearRect(0, 0, width, height);
                context.drawImage(stagingDeviceStorage[index], 0, 0);
                const stagingValues = context.getImageData(0, 0, width, height).data;
                const alphaMode = alphaModes[index];
                const span = new Uint8ClampedArray(valsGPU, offset, width * height * 4);
                for(let k = 0; k < span.length; k += 4)if (alphaMode === 'premultiplied') span[k + 3] = stagingValues[k + 3];
                else {
                    const value = stagingValues[k];
                    span[k] = stagingValues[k + 2];
                    span[k + 1] = stagingValues[k + 1];
                    span[k + 2] = value;
                }
            };
            const fullyReadCount = Math.floor(pixelsSize / (canvasWidth * canvasHeight));
            let width = canvasWidth, height = canvasHeight, offset = 0;
            for(let i = 0; i < fullyReadCount; i++){
                // Read the buffer data, which fully fill the whole canvas.
                readDataGPUToCPU(width, height, offset);
                offset += canvasWidth * canvasHeight * 4;
            }
            const remainSize = pixelsSize % (canvasWidth * canvasHeight);
            height = Math.floor(remainSize / canvasWidth);
            if (height > 0) {
                // Read the buffer data, which fully fill certain rows of canvas.
                readDataGPUToCPU(width, height, offset);
                offset += height * (canvasWidth * 4);
            }
            width = remainSize % canvasWidth;
            if (width > 0) // Read the buffer data, which not fully fill one row of canvas.
            readDataGPUToCPU(width, 1, offset);
        });
        const vals = (0, $jjNRA).convertBackendValuesAndArrayBuffer(valsGPU, tensorData.dtype);
        this.convertAndCacheOnCPU(dataId, vals);
        return vals;
    }
    async read(dataId) {
        if (!this.tensorMap.has(dataId)) throw new Error(`Tensor ${dataId} was not registered!`);
        const tensorData = this.tensorMap.get(dataId);
        const { values: values } = tensorData;
        if (values != null) return values;
        // Download the values from the GPU.
        let vals;
        if (tensorData.dtype === 'complex64') {
            const ps = await Promise.all([
                this.read(tensorData.complexTensorInfos.real.dataId),
                this.read(tensorData.complexTensorInfos.imag.dataId)
            ]);
            const realValues = ps[0];
            const imagValues = ps[1];
            vals = (0, $7MaPk).mergeRealAndImagArrays(realValues, imagValues);
        } else {
            const data = await this.getBufferData(tensorData.resource);
            vals = (0, $jjNRA).convertBackendValuesAndArrayBuffer(data, tensorData.dtype);
        }
        this.convertAndCacheOnCPU(dataId, vals);
        return vals;
    }
    // The source GPUBuffer and destination GPUBuffer have the same size and
    // usage.
    copyBuffer(srcBuffer) {
        const size = srcBuffer.size;
        const usage = srcBuffer.usage;
        const dstBuffer = this.bufferManager.acquireBuffer(size, usage);
        this.ensureCommandEncoderReady();
        this.endComputePassEncoder();
        this.commandEncoder.copyBufferToBuffer(srcBuffer, 0, dstBuffer, 0, size);
        this.submitQueue();
        return dstBuffer;
    }
    /**
     * Create a TF.js tensor out of an existing WebGPU buffer.
     */ createTensorFromGPUData(webGPUData, shape, dtype) {
        let buffer = webGPUData.buffer;
        if (dtype === 'complex64') throw new Error(`Cannot write to a complex64 dtype. `);
        const dataId = {
            id: this.nextDataId()
        };
        this.tensorMap.set(dataId, {
            dtype: dtype,
            shape: shape,
            values: null,
            refCount: 1,
            external: webGPUData.zeroCopy
        });
        const tensorData = this.tensorMap.get(dataId);
        const size = $9Dn6G.GPUBytesPerElement(tensorData.dtype) * (0, $jjNRA).sizeFromShape(tensorData.shape);
        if (webGPUData.buffer.size < size) throw new Error(`GPUBuffer size(${webGPUData.buffer.size}) is smaller than tensor size(${size})!`);
        else if ((webGPUData.buffer.usage & (GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC)) !== (GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC)) throw new Error('GPUBuffer.usage should include GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC!');
        // Do buffer copy by default.
        if (webGPUData.zeroCopy !== true) buffer = this.copyBuffer(buffer);
        tensorData.resource = buffer;
        return (0, $c2DT1.engine)().makeTensorFromDataId(dataId, shape, dtype, this);
    }
    /**
     * Read tensor to a new GPUBuffer.
     * @param dataId The source tensor.
     */ readToGPU(dataId) {
        const srcTensorData = this.tensorMap.get(dataId);
        const { values: values, dtype: dtype, shape: shape, resource: resource } = srcTensorData;
        if (dtype === 'complex64') throw new Error('Does not support reading buffer for complex64 dtype.');
        if (resource == null) {
            if (values != null) throw new Error('Data is not on GPU but on CPU.');
            else throw new Error('There is no data on GPU or CPU.');
        }
        const srcBuffer = resource;
        const size = srcBuffer.size;
        const usage = srcBuffer.usage;
        const buffer = this.bufferManager.acquireBuffer(size, usage);
        this.ensureCommandEncoderReady();
        this.endComputePassEncoder();
        this.commandEncoder.copyBufferToBuffer(resource, 0, buffer, 0, size);
        this.submitQueue();
        const tensorInfo = this.makeTensorInfo(shape, dtype);
        // Make engine track this tensor, so that we can dispose it later.
        const tensorRef = (0, $c2DT1.engine)().makeTensorFromTensorInfo(tensorInfo);
        const tensorData = this.tensorMap.get(tensorInfo.dataId);
        tensorData.resource = buffer;
        return {
            tensorRef: tensorRef,
            buffer: buffer
        };
    }
    bufferSync(t) {
        const data = this.readSync(t.dataId);
        if (t.dtype === 'string') try {
            // Decode the bytes into string.
            const strings = data.map((d)=>(0, $jjNRA).decodeString(d));
            return (0, $iG87S.buffer)(t.shape, t.dtype, strings);
        } catch (_a) {
            throw new Error('Failed to decode encoded string bytes into utf-8');
        }
        return (0, $iG87S.buffer)(t.shape, t.dtype, data);
    }
    async time(f) {
        if (!this.supportTimestampQuery && !this.hasTimestampQueryWarned) {
            console.warn(`This device doesn't support timestamp-query extension. ` + `Start Chrome browser with flag ` + `--enable-dawn-features=allow_unsafe_apis to try it again. ` + `Otherwise, zero will be shown for the kernel time when profiling ` + `mode is enabled.`);
            this.hasTimestampQueryWarned = true;
        }
        const oldActiveTimers = this.activeTimers;
        const newActiveTimers = [];
        let outerMostTime = false;
        if (this.programTimersStack == null) {
            this.programTimersStack = newActiveTimers;
            outerMostTime = true;
        } else this.activeTimers.push(newActiveTimers);
        this.activeTimers = newActiveTimers;
        f();
        const flattenedActiveTimerQueries = (0, $jjNRA).flatten(this.activeTimers.map((d)=>d.query)).filter((d)=>d != null);
        const flattenedActiveTimerNames = (0, $jjNRA).flatten(this.activeTimers.map((d)=>d.name)).filter((d)=>d != null);
        this.activeTimers = oldActiveTimers;
        if (outerMostTime) this.programTimersStack = null;
        const res = {
            uploadWaitMs: this.uploadWaitMs,
            downloadWaitMs: this.downloadWaitMs,
            kernelMs: null,
            wallMs: null
        };
        const kernelMs = await Promise.all(flattenedActiveTimerQueries);
        res['kernelMs'] = (0, $jjNRA).sum(kernelMs);
        res['getExtraProfileInfo'] = ()=>kernelMs.map((d, i)=>({
                    name: flattenedActiveTimerNames[i],
                    ms: d
                })).map((d)=>`${d.name}: ${d.ms}`).join(', ');
        this.uploadWaitMs = 0;
        this.downloadWaitMs = 0;
        return res;
    }
    makeTensorInfo(shape, dtype, values) {
        if (dtype === 'string' && values != null && values.length > 0 && (0, $jjNRA).isString(values[0])) values = values.map((d)=>(0, $jjNRA).encodeString(d));
        const dataId = this.write(values, shape, dtype);
        return {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
    }
    tensorToBinding(tensor) {
        if (!tensor) return null;
        const tensorData = this.tensorMap.get(tensor.dataId);
        const resource = tensorData.resource;
        if (resource instanceof GPUBuffer) return {
            buffer: resource
        };
        if (resource instanceof GPUTexture) return resource.createView();
        // GPUExternalTexture
        return resource;
    }
    uploadToGPU(dataId) {
        const tensorData = this.tensorMap.get(dataId);
        // Already on the GPU.
        if (tensorData.resource != null) return;
        const size = $9Dn6G.GPUBytesPerElement(tensorData.dtype) * (0, $jjNRA).sizeFromShape(tensorData.shape);
        let buffer;
        const usage = GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST;
        if (tensorData.values) {
            buffer = this.bufferManager.acquireBuffer(size, usage, true);
            if (buffer.mapState === 'unmapped') {
                const stagingBuffer = this.bufferManager.acquireBuffer(size, GPUBufferUsage.MAP_WRITE | GPUBufferUsage.COPY_SRC, true, false);
                const arrayBuffer = stagingBuffer.getMappedRange();
                if (tensorData.dtype === 'int32' || tensorData.dtype === 'bool') new Int32Array(arrayBuffer).set(tensorData.values);
                else new Float32Array(arrayBuffer).set(tensorData.values);
                stagingBuffer.unmap();
                this.ensureCommandEncoderReady();
                this.endComputePassEncoder();
                this.commandEncoder.copyBufferToBuffer(stagingBuffer, 0, buffer, 0, size);
                this.stagingPendingDisposal.push(stagingBuffer);
            } else {
                const arrayBuffer = buffer.getMappedRange();
                if (tensorData.dtype === 'int32' || tensorData.dtype === 'bool') new Int32Array(arrayBuffer).set(tensorData.values);
                else new Float32Array(arrayBuffer).set(tensorData.values);
                buffer.unmap();
            }
            // Once uploaded, don't store the values on cpu.
            tensorData.values = null;
        } else buffer = this.bufferManager.acquireBuffer(size, usage);
        tensorData.resource = buffer;
    }
    makeUniforms(programUniform) {
        let currentOffset = 0;
        let preLength = 0;
        const offsets = [];
        let maxAlignmentOfField = 1;
        programUniform.forEach((d)=>{
            if (d.data.length === 0) d.data = [
                1
            ];
            // https://www.w3.org/TR/WGSL/#alignof
            let baseAlignment;
            switch(d.data.length){
                case 1:
                    baseAlignment = 4;
                    break;
                case 2:
                    baseAlignment = 8;
                    break;
                case 3:
                    baseAlignment = 16;
                    break;
                case 4:
                    baseAlignment = 16;
                    break;
                case 5:
                    baseAlignment = 16;
                    break;
                case 6:
                    baseAlignment = 16;
                    break;
                default:
                    (0, $jjNRA).assert(false, ()=>`Unsupported ${d.data.length}D shape`);
            }
            if (preLength === 5 || preLength === 6) baseAlignment = 16;
            if (baseAlignment > maxAlignmentOfField) maxAlignmentOfField = baseAlignment;
            currentOffset = Math.ceil(currentOffset / baseAlignment) * baseAlignment;
            preLength = d.data.length;
            offsets.push(currentOffset);
            currentOffset += d.data.length * 4;
        });
        currentOffset = Math.ceil(currentOffset / maxAlignmentOfField) * maxAlignmentOfField;
        const arrayBuffer = new ArrayBuffer(currentOffset);
        programUniform.forEach((d, i)=>{
            const offset = offsets[i];
            if (d.type === 'int32') new Int32Array(arrayBuffer, offset, d.data.length).set(d.data);
            else if (d.type === 'uint32') new Uint32Array(arrayBuffer, offset, d.data.length).set(d.data);
            else new Float32Array(arrayBuffer, offset, d.data.length).set(d.data);
        });
        const uniformBuffer = this.bufferManager.acquireBuffer(currentOffset, GPUBufferUsage.COPY_DST | GPUBufferUsage.UNIFORM);
        this.queue.writeBuffer(uniformBuffer, 0, arrayBuffer, 0, currentOffset);
        this.uniformPendingDisposal.push(uniformBuffer);
        return {
            offset: 0,
            size: currentOffset,
            buffer: uniformBuffer
        };
    }
    runWebGPUProgram(program, inputs, outputDtype, programDefinedUniform, output) {
        if (!output) output = this.makeTensorInfo(program.outputShape, outputDtype);
        if ((0, $jjNRA).sizeFromShape(output.shape) === 0) {
            // Short-circuit the computation since the result is empty (has 0 in its
            // shape).
            this.tensorMap.get(output.dataId).values = (0, $jjNRA).getTypedArrayFromDType(output.dtype, 0);
            return output;
        }
        this.uploadToGPU(output.dataId);
        program.dispatch = $def39e621b8a256c$var$reshapeDispatch(this.device, program);
        const inputsData = inputs.map((input, i)=>{
            if (input.dtype === 'complex64') throw new Error(`GPGPUProgram does not support complex64 input. For complex64 ` + `dtypes, please separate the program into real and imaginary ` + `parts.`);
            this.uploadToGPU(input.dataId);
            return {
                // Returning dtype from tensorMap because it reflects dtype
                // of underlying buffer, rather than abstract dtype.
                dtype: this.tensorMap.get(input.dataId).dtype,
                shape: input.shape,
                name: program.variableNames[i]
            };
        });
        program.shaderKey = $oGQBh.makeShaderKey(program, inputsData, output);
        const parallelCompilation = (0, $ibsdL.env)().getBool('WEBGPU_ENGINE_COMPILE_ONLY');
        if (!(program.shaderKey in this.pipelineCache)) this.pipelineCache[program.shaderKey] = $oGQBh.compileProgram(this.device, program, inputsData, output, parallelCompilation);
        program.pipeline = this.pipelineCache[program.shaderKey];
        if (!parallelCompilation) this.recordAndSubmit(program, output, inputs, programDefinedUniform);
        return output;
    }
    recordAndSubmit(program, output, inputs, programDefinedUniform) {
        if (program.pipeline instanceof Promise) throw new Error('Please call checkCompileCompletionAsync to ensure parallel compilation is done!');
        // There are six kinds of uniforms: NAN, INFINITY, shapes, shape strides,
        // program size, program defined uniforms.
        let programUniform = [];
        let bufferShapes = [];
        const uniformsType = 'int32';
        if (program.pixelsOpType == null) {
            programUniform.push({
                type: 'float32',
                data: [
                    NaN
                ]
            }, {
                type: 'float32',
                data: [
                    Infinity
                ]
            });
            bufferShapes = inputs.concat(output).map((d)=>d.shape);
            const uniformsType = 'int32';
            bufferShapes.map((d)=>{
                programUniform.push({
                    type: uniformsType,
                    data: d
                });
                const strides = (0, $jjNRA).computeStrides(d);
                programUniform.push({
                    type: uniformsType,
                    data: strides
                });
            });
        } else {
            const strides = (0, $jjNRA).computeStrides(output.shape);
            programUniform.push({
                type: uniformsType,
                data: strides
            });
        }
        if (program.size) {
            const size = (0, $jjNRA).sizeFromShape(program.outputShape);
            programUniform.push({
                type: uniformsType,
                data: [
                    program.outputComponent ? size / program.outputComponent : size
                ]
            });
        }
        if (programDefinedUniform) programUniform = [
            ...programUniform,
            ...programDefinedUniform
        ];
        const bindings = [
            this.tensorToBinding(output),
            ...inputs.map((t)=>this.tensorToBinding(t)),
            this.makeUniforms(programUniform)
        ];
        inputs.forEach((input)=>{
            this.commandQueueOwnedIds.add(input.dataId);
        });
        this.commandQueueOwnedIds.add(output.dataId);
        const bindGroup = this.device.createBindGroup({
            layout: program.pipeline.getBindGroupLayout(0),
            entries: bindings.map((b, i)=>({
                    binding: i,
                    resource: b
                }))
        });
        const shouldTimeProgram = this.activeTimers != null;
        this.ensureCommandEncoderReady();
        const computePassDescriptor = {};
        if (shouldTimeProgram && this.supportTimestampQuery) {
            this.endComputePassEncoder();
            if (this.querySet == null) this.querySet = this.device.createQuerySet({
                type: 'timestamp',
                count: this.querySetCount
            });
            computePassDescriptor.timestampWrites = {
                querySet: this.querySet,
                beginningOfPassWriteIndex: 0,
                endOfPassWriteIndex: 1
            };
            this.computePassEncoder = this.commandEncoder.beginComputePass(computePassDescriptor);
        } else if (!this.computePassEncoder) this.computePassEncoder = this.commandEncoder.beginComputePass(computePassDescriptor);
        this.computePassEncoder.setPipeline(program.pipeline);
        this.computePassEncoder.setBindGroup(0, bindGroup);
        this.computePassEncoder.dispatchWorkgroups(program.dispatch[0], program.dispatch[1], program.dispatch[2]);
        this.dispatchCountInPass++;
        if (shouldTimeProgram || (0, $ibsdL.env)().get('WEBGPU_DEFERRED_SUBMIT_BATCH_SIZE') <= this.dispatchCountInPass || program.pixelsOpType === $oGQBh.PixelsOpType.DRAW) {
            this.endComputePassEncoder();
            if (shouldTimeProgram) this.activeTimers.push({
                name: program.constructor.name,
                query: this.getQueryTime()
            });
            else this.submitQueue();
        }
    }
    async getQueryTime() {
        if (!this.supportTimestampQuery) return 0;
        if (this.queryResolveBuffer == null) this.queryResolveBuffer = this.bufferManager.acquireBuffer(this.querySetCount * 8, GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST | GPUBufferUsage.QUERY_RESOLVE);
        this.commandEncoder.resolveQuerySet(this.querySet, 0, this.querySetCount, this.queryResolveBuffer, 0);
        const queryStagingBuffer = this.bufferManager.acquireBuffer(this.querySetCount * 8, GPUBufferUsage.MAP_READ | GPUBufferUsage.COPY_DST);
        this.commandEncoder.copyBufferToBuffer(this.queryResolveBuffer, 0, queryStagingBuffer, 0, this.querySetCount * 8);
        this.submitQueue();
        await queryStagingBuffer.mapAsync(GPUMapMode.READ);
        const arrayBuffer = new BigUint64Array(queryStagingBuffer.getMappedRange());
        const time = Number(arrayBuffer[1] - arrayBuffer[0]) / 1000000;
        queryStagingBuffer.unmap();
        this.bufferManager.releaseBuffer(queryStagingBuffer);
        return time;
    }
    shouldExecuteOnCPU(inputs, sizeThreshold = $def39e621b8a256c$var$CPU_HANDOFF_SIZE_THRESHOLD) {
        return (0, $ibsdL.env)().getBool('WEBGPU_CPU_FORWARD') && inputs.every((input)=>this.tensorMap.get(input.dataId).resource == null && (0, $jjNRA).sizeFromShape(input.shape) < sizeThreshold);
    }
    numDataIds() {
        return this.tensorMap.numDataIds() - this.tensorDataPendingDisposal.length;
    }
    dispose() {
        if (this.disposed) return;
        if (this.querySet != null) this.querySet.destroy();
        this.bufferManager.dispose();
        this.textureManager.dispose();
        this.disposed = true;
    }
}
$def39e621b8a256c$export$6f9bc39baf8c093a.nextDataId = 0;

});
parcelRegister("eVz64", function(module, exports) {

$parcel$export(module.exports, "AdapterInfo", () => $ade19d0fb9c015b6$export$addafb2fcad183eb);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $ade19d0fb9c015b6$export$addafb2fcad183eb {
    constructor(adapterInfo){
        if (adapterInfo) {
            this.vendor = adapterInfo.vendor;
            this.architecture = adapterInfo.architecture;
            this.intelGPUGeneration = this.getIntelGPUGeneration();
        }
    }
    getIntelGPUGeneration() {
        if (this.isIntel()) {
            if (this.architecture.startsWith('gen')) return Number(this.architecture.match(/\d+/));
            else if (this.architecture.startsWith('xe')) return 12;
        }
        return 0;
    }
    isIntel() {
        return this.vendor === 'intel';
    }
}

});

parcelRegister("4S73i", function(module, exports) {

$parcel$export(module.exports, "BufferManager", () => $38c1acf9e7a516cc$export$f9938eb95a77a185);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $38c1acf9e7a516cc$export$f9938eb95a77a185 {
    constructor(device){
        this.device = device;
        this.numUsedBuffers = 0;
        this.numFreeBuffers = 0;
        this.freeBuffers = new Map();
        this.usedBuffers = new Map();
        this.numBytesUsed = 0;
        this.numBytesAllocated = 0;
    }
    acquireBuffer(size, usage, mappedAtCreation = false, reuse = true) {
        let buffer;
        const key = $38c1acf9e7a516cc$var$getBufferKey(size, usage);
        if (reuse) {
            if (!this.freeBuffers.has(key)) this.freeBuffers.set(key, []);
            if (this.freeBuffers.get(key).length > 0) {
                buffer = this.freeBuffers.get(key).pop();
                this.numFreeBuffers--;
            } else {
                buffer = this.device.createBuffer({
                    size: size,
                    usage: usage,
                    mappedAtCreation: mappedAtCreation
                });
                this.numBytesAllocated += size;
            }
        } else {
            buffer = this.device.createBuffer({
                size: size,
                usage: usage,
                mappedAtCreation: mappedAtCreation
            });
            this.numBytesAllocated += size;
        }
        if (!this.usedBuffers.has(key)) this.usedBuffers.set(key, []);
        this.usedBuffers.get(key).push(buffer);
        this.numUsedBuffers++;
        this.numBytesUsed += size;
        return buffer;
    }
    releaseBuffer(buffer, reuse = true) {
        if (this.freeBuffers.size === 0) return;
        const size = buffer.size;
        const usage = buffer.usage;
        const key = $38c1acf9e7a516cc$var$getBufferKey(size, usage);
        const bufferArray = this.usedBuffers.get(key);
        const index = bufferArray.indexOf(buffer);
        if (index < 0) throw new Error('Cannot find the buffer in buffer manager');
        bufferArray[index] = bufferArray[bufferArray.length - 1];
        bufferArray.pop();
        this.numUsedBuffers--;
        this.numBytesUsed -= size;
        if (reuse) {
            this.freeBuffers.get(key).push(buffer);
            this.numFreeBuffers++;
        } else {
            buffer.destroy();
            this.numBytesAllocated -= size;
        }
    }
    getNumUsedBuffers() {
        return this.numUsedBuffers;
    }
    getNumFreeBuffers() {
        return this.numFreeBuffers;
    }
    dispose() {
        this.freeBuffers.forEach((buffers, key)=>{
            buffers.forEach((buffer)=>{
                buffer.destroy();
            });
        });
        this.usedBuffers.forEach((buffers, key)=>{
            buffers.forEach((buffer)=>{
                buffer.destroy();
            });
        });
        this.freeBuffers = new Map();
        this.usedBuffers = new Map();
        this.numUsedBuffers = 0;
        this.numFreeBuffers = 0;
        this.numBytesUsed = 0;
        this.numBytesAllocated = 0;
    }
}
function $38c1acf9e7a516cc$var$getBufferKey(size, usage) {
    return `${size}_${usage}`;
}

});

parcelRegister("hBMar", function(module, exports) {

$parcel$export(module.exports, "TextureManager", () => $cd1b416d3fc5fddd$export$337f59f8fd79d24f);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $cd1b416d3fc5fddd$export$337f59f8fd79d24f {
    constructor(device){
        this.device = device;
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this.freeTextures = new Map();
        this.usedTextures = new Map();
        this.numBytesUsed = 0;
        this.numBytesAllocated = 0;
    }
    acquireTexture(width, height, format, usage) {
        const bytesPerElement = $cd1b416d3fc5fddd$var$getBytesPerElement(format);
        const byteSize = width * height * bytesPerElement;
        const key = $cd1b416d3fc5fddd$var$getTextureKey(width, height, format, usage);
        if (!this.freeTextures.has(key)) this.freeTextures.set(key, []);
        if (!this.usedTextures.has(key)) this.usedTextures.set(key, []);
        this.numBytesUsed += byteSize;
        this.numUsedTextures++;
        if (this.freeTextures.get(key).length > 0) {
            this.numFreeTextures--;
            const newTexture = this.freeTextures.get(key).shift();
            this.usedTextures.get(key).push(newTexture);
            return newTexture;
        }
        this.numBytesAllocated += byteSize;
        const newTexture = this.device.createTexture({
            size: [
                width,
                height
            ],
            format: format,
            usage: usage
        });
        this.usedTextures.get(key).push(newTexture);
        return newTexture;
    }
    releaseTexture(texture) {
        if (this.freeTextures.size === 0) return;
        const width = texture.width;
        const height = texture.height;
        const format = texture.format;
        const usage = texture.usage;
        const key = $cd1b416d3fc5fddd$var$getTextureKey(width, height, format, usage);
        if (!this.freeTextures.has(key)) this.freeTextures.set(key, []);
        this.freeTextures.get(key).push(texture);
        this.numFreeTextures++;
        this.numUsedTextures--;
        const textureList = this.usedTextures.get(key);
        const textureIndex = textureList.indexOf(texture);
        if (textureIndex < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");
        textureList.splice(textureIndex, 1);
        const bytesPerElement = $cd1b416d3fc5fddd$var$getBytesPerElement(format);
        const byteSize = width * height * bytesPerElement;
        this.numBytesUsed -= byteSize;
    }
    getNumUsedTextures() {
        return this.numUsedTextures;
    }
    getNumFreeTextures() {
        return this.numFreeTextures;
    }
    dispose() {
        this.freeTextures.forEach((textures, key)=>{
            textures.forEach((texture)=>{
                texture.destroy();
            });
        });
        this.usedTextures.forEach((textures, key)=>{
            textures.forEach((texture)=>{
                texture.destroy();
            });
        });
        this.freeTextures = new Map();
        this.usedTextures = new Map();
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this.numBytesUsed = 0;
        this.numBytesAllocated = 0;
    }
}
function $cd1b416d3fc5fddd$var$getTextureKey(width, height, format, usage) {
    return `${width}_${height}_${format}_${usage}`;
}
function $cd1b416d3fc5fddd$var$getBytesPerElement(format) {
    if (format === 'rgba8unorm') return 16;
    else throw new Error(`${format} is not supported!`);
}

});

parcelRegister("oGQBh", function(module, exports) {

$parcel$export(module.exports, "PixelsOpType", () => $04a37a9ad1193786$export$62104db1eb296622);
$parcel$export(module.exports, "compileProgram", () => $04a37a9ad1193786$export$5ca2cb6073dd12df);
$parcel$export(module.exports, "typeSnippet", () => $04a37a9ad1193786$export$85f585983df3fed3);
$parcel$export(module.exports, "getCoordsDataType", () => $04a37a9ad1193786$export$859efd105c10c755);
$parcel$export(module.exports, "getCoordsXYZ", () => $04a37a9ad1193786$export$9e429db2fd13bb35);
$parcel$export(module.exports, "getMainHeaderString", () => $04a37a9ad1193786$export$28aacf05d5e9d731);
$parcel$export(module.exports, "dataTypeToGPUType", () => $04a37a9ad1193786$export$342fcff7270d2d1a);
$parcel$export(module.exports, "getCoordsFromIndexSnippet", () => $04a37a9ad1193786$export$a9674693e382741e);
$parcel$export(module.exports, "makeShaderKey", () => $04a37a9ad1193786$export$2a17a6d53fe6f5d9);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $ibsdL = parcelRequire("ibsdL");
var $jjNRA = parcelRequire("jjNRA");

var $arOgS = parcelRequire("arOgS");
var $04a37a9ad1193786$export$62104db1eb296622;
(function(PixelsOpType) {
    PixelsOpType[PixelsOpType["FROM_PIXELS"] = 0] = "FROM_PIXELS";
    PixelsOpType[PixelsOpType["DRAW"] = 1] = "DRAW";
})($04a37a9ad1193786$export$62104db1eb296622 || ($04a37a9ad1193786$export$62104db1eb296622 = {}));
const $04a37a9ad1193786$export$5ca2cb6073dd12df = (device, program, inputsData, output, parallelCompilation)=>{
    const outputData = {
        dtype: output.dtype,
        shape: output.shape
    };
    const source = $04a37a9ad1193786$var$makeShader(inputsData, outputData, program);
    const module = device.createShaderModule({
        code: source,
        label: program.constructor.name
    });
    let printShaderString = (0, $ibsdL.env)().get('WEBGPU_PRINT_SHADER');
    if (printShaderString !== '') {
        printShaderString = printShaderString.toLowerCase();
        const printShaderArray = printShaderString.split(',');
        if (printShaderString === 'all' || printShaderArray.some((item)=>program.shaderKey.toLowerCase().includes(item))) {
            console.group(program.shaderKey);
            console.debug(source);
            console.groupEnd();
        }
    }
    if (parallelCompilation) return device.createComputePipelineAsync({
        compute: {
            module: module,
            entryPoint: '_start'
        },
        label: program.constructor.name,
        layout: 'auto'
    });
    else return device.createComputePipeline({
        compute: {
            module: module,
            entryPoint: '_start'
        },
        label: program.constructor.name,
        layout: 'auto'
    });
};
const $04a37a9ad1193786$export$85f585983df3fed3 = (component, type = 'f32')=>{
    switch(component){
        case 1:
            return `${type}`;
        case 2:
            return `vec2<${type}>`;
        case 3:
            return `vec3<${type}>`;
        case 4:
            return `vec4<${type}>`;
        default:
            throw new Error(`${component}-component ${type} is not supported.`);
    }
};
function $04a37a9ad1193786$export$859efd105c10c755(rank) {
    if (rank <= 1) return 'i32';
    else if (rank === 2) return `vec2<i32>`;
    else if (rank === 3) return `vec3<i32>`;
    else if (rank === 4) return `vec4<i32>`;
    else if (rank === 5) return `vec5`;
    else if (rank === 6) return `vec6`;
    else throw Error(`GPU for rank ${rank} is not yet supported`);
}
function $04a37a9ad1193786$export$9e429db2fd13bb35(index) {
    if (index === 0) return 'x';
    else if (index === 1) return 'y';
    else if (index === 2) return 'z';
    else if (index === 3) return 'w';
    else if (index === 4) return 'u';
    else if (index === 5) return 'v';
    else throw Error(`Index ${index} is not yet supported`);
}
function $04a37a9ad1193786$export$28aacf05d5e9d731(...params) {
    let snippet;
    switch(params.length){
        case 0:
            snippet = `
        fn main()
      `;
            break;
        case 1:
            snippet = `
        fn main(${params[0]} : i32)
      `;
            break;
        default:
            throw Error('Unreachable');
    }
    return snippet;
}
function $04a37a9ad1193786$export$7032d63a04b4010d(useGlobalIndex, program) {
    let snippet;
    snippet = `
     ${$04a37a9ad1193786$export$4a68c343179bae1c(program)}
      fn _start(@builtin(local_invocation_id) LocalId : vec3<u32>,
                @builtin(global_invocation_id) GlobalId : vec3<u32>,
                @builtin(local_invocation_index) LocalIndex: u32,
                @builtin(workgroup_id) WorkgroupId : vec3<u32>,
                @builtin(num_workgroups) NumWorkgroups : vec3<u32>) {
        localId = LocalId;
        localIndex = LocalIndex;
        globalId = GlobalId;
        numWorkgroups = NumWorkgroups;
        workgroupId = WorkgroupId;
        ${useGlobalIndex ? `main(getGlobalIndex());` : `main();`};
      }
    `;
    return snippet;
}
function $04a37a9ad1193786$export$4a68c343179bae1c(program) {
    return `
  @compute @workgroup_size(${program.workgroupSize[0]}, ${program.workgroupSize[1]}, ${program.workgroupSize[2]})
`;
}
function $04a37a9ad1193786$var$makeShader(inputInfo, outputData, program) {
    const prefixSnippets = [];
    const flatWorkgroupSize = program.workgroupSize[0] * program.workgroupSize[1] * program.workgroupSize[2];
    program.outputComponent = program.outputComponent ? program.outputComponent : 1;
    prefixSnippets.push(`

      var<private> localId: vec3<u32>;
      var<private> localIndex: u32;
      var<private> globalId: vec3<u32>;
      var<private> numWorkgroups: vec3<u32>;
      var<private> workgroupId: vec3<u32>;

      // Only used when the y/z dimension of workgroup size is 1.
      fn getGlobalIndex() -> i32 {
        ${$04a37a9ad1193786$var$isFlatDispatch(program) ? `  return i32(globalId.x);` : `  return i32((workgroupId.z * numWorkgroups.x * numWorkgroups.y +
                workgroupId.y * numWorkgroups.x + workgroupId.x) * ${flatWorkgroupSize}u +
                localIndex);
        `}
      }
    `);
    if (program.pixelsOpType != null) {
        const inoutSnippet = program.pixelsOpType === $04a37a9ad1193786$export$62104db1eb296622.FROM_PIXELS ? `@group(0) @binding(0) var<storage, read_write> result: array<${$04a37a9ad1193786$export$342fcff7270d2d1a(outputData.dtype, program.outputComponent)}>;` : `@group(0) @binding(1) var<storage, read> inBuf : array<${$04a37a9ad1193786$export$342fcff7270d2d1a(inputInfo[0].dtype, program.outputComponent)}>;`;
        const outShapeStridesType = outputData.shape.length === 3 ? 'vec2<i32>' : 'i32';
        prefixSnippets.push(`
        struct Uniform {
          outShapeStrides : ${outShapeStridesType},
          size            : i32,
          numChannels     : i32,
          alpha           : f32,
        };

        ${inoutSnippet}
        @group(0) @binding(2) var<uniform> uniforms: Uniform;
      `);
        const useGlobalIndex = $04a37a9ad1193786$var$isFlatDispatchLayout(program);
        return [
            $04a37a9ad1193786$var$commonSnippet,
            prefixSnippets.join('\n'),
            $04a37a9ad1193786$export$a9674693e382741e(outputData.shape),
            program.getUserCode(),
            $04a37a9ad1193786$export$7032d63a04b4010d(useGlobalIndex, program)
        ].join('\n');
    }
    let stridesLength;
    let stridesDataType;
    let uniformDeclaration = 'struct Uniforms { NAN : f32, INFINITY : f32, ';
    program.variableNames.forEach((x, i)=>{
        const perDataType = $04a37a9ad1193786$export$859efd105c10c755(inputInfo[i].shape.length);
        uniformDeclaration += `${x.charAt(0).toLowerCase() + x.slice(1)}Shape : ${perDataType}, `;
        stridesLength = inputInfo[i].shape.length - 1;
        stridesDataType = $04a37a9ad1193786$export$859efd105c10c755(stridesLength);
        uniformDeclaration += `${x.charAt(0).toLowerCase() + x.slice(1)}ShapeStrides: ${stridesDataType}, `;
    });
    const outputDataType = $04a37a9ad1193786$export$859efd105c10c755(outputData.shape.length);
    uniformDeclaration += `outShape : ${outputDataType}, `;
    stridesLength = outputData.shape.length - 1;
    stridesDataType = $04a37a9ad1193786$export$859efd105c10c755(stridesLength);
    uniformDeclaration += `
         outShapeStrides: ${stridesDataType}, `;
    if (program.size) uniformDeclaration += 'size : i32, ';
    if (program.uniforms) uniformDeclaration += program.uniforms;
    uniformDeclaration += '};';
    uniformDeclaration = $04a37a9ad1193786$var$insertAlignment(uniformDeclaration);
    prefixSnippets.push(uniformDeclaration);
    // Output buffer.
    if (program.atomic) prefixSnippets.push(`
      @group(0) @binding(0) var<storage, read_write> result: array<atomic<i32>>;
    `);
    else prefixSnippets.push(`
      @group(0) @binding(0) var<storage, read_write> result: array<${$04a37a9ad1193786$export$342fcff7270d2d1a(outputData.dtype, program.outputComponent)}>;
    `);
    program.variableNames.forEach((x, i)=>{
        prefixSnippets.push(`
      @group(0) @binding(${1 + i}) var<storage, read> ${x}: array<${program.variableComponents ? $04a37a9ad1193786$export$342fcff7270d2d1a(inputInfo[i].dtype, program.variableComponents[i]) : $04a37a9ad1193786$export$342fcff7270d2d1a(inputInfo[i].dtype, program.outputComponent)}>;
        `);
    });
    if (uniformDeclaration !== '') prefixSnippets.push(`
      @group(0) @binding(${1 + program.variableNames.length}) var<uniform> uniforms: Uniforms;
      `);
    const coordsSnippet = $04a37a9ad1193786$var$getOutputCoordsSnippet(outputData.shape, program.dispatchLayout);
    const sources = [
        $04a37a9ad1193786$var$commonSnippet,
        prefixSnippets.join('\n') + $04a37a9ad1193786$var$isInfSnippet,
        $04a37a9ad1193786$export$a9674693e382741e(outputData.shape),
        coordsSnippet,
        $04a37a9ad1193786$var$getOutputIndexFromCoordsSnippet(outputData.shape.length)
    ];
    if (!program.atomic) sources.push($04a37a9ad1193786$var$setOutputSnippet(outputData.shape, outputData.dtype, program.outputComponent));
    program.variableNames.forEach((x, i)=>{
        sources.push(`${$04a37a9ad1193786$export$a9674693e382741e(inputInfo[i].shape, x)}`);
    });
    const inputSnippet = inputInfo.map((x, i)=>$04a37a9ad1193786$var$getInputSnippet(x, outputData.shape, program.variableComponents ? program.variableComponents[i] : program.outputComponent, program.dispatchLayout.x.length === outputData.shape.length)).join('\n');
    sources.push(inputSnippet);
    sources.push(program.getUserCode());
    const useGlobalIndex = $04a37a9ad1193786$var$isFlatDispatchLayout(program);
    sources.push($04a37a9ad1193786$export$7032d63a04b4010d(useGlobalIndex, program));
    const source = sources.join('\n');
    return source;
}
function $04a37a9ad1193786$export$2a17a6d53fe6f5d9(program, inputsData, output) {
    let key = program.shaderKey;
    if (program.pixelsOpType != null) return key;
    const shapes = [];
    const types = [];
    inputsData.forEach((element)=>{
        shapes.push(element.shape);
        types.push(element.dtype);
    });
    shapes.push(output.shape);
    types.push(output.dtype);
    const broadcastDims = inputsData.map((d)=>(0, $7MaPk).getBroadcastDims(d.shape, output.shape));
    const inputShapesEqualsOutShape = inputsData.map((d)=>(0, $jjNRA).arraysEqual(d.shape, output.shape)).join('_');
    const broadcastDimsKey = broadcastDims.map((d)=>d.join('_')).join(';');
    const flatDispatchString = $04a37a9ad1193786$var$isFlatDispatch(program) ? 'flatDispatch' : '';
    key += '_' + (program.workgroupSize ? program.workgroupSize.join(',') : '') + shapes.map((shape)=>shape.length).join(',') + types.join(',') + program.variableNames.join(',') + broadcastDimsKey + inputShapesEqualsOutShape + flatDispatchString;
    return key;
}
const $04a37a9ad1193786$var$commonSnippet = `
  struct vec5 {x: i32, y: i32, z: i32, w: i32, u: i32};
  struct vec6 {x: i32, y: i32, z: i32, w: i32, u: i32, v: i32};

  // Checks whether coordinates lie within the bounds of the shape.
  fn coordsInBounds2D(coord : vec2<i32>, shape : vec2<i32>) -> bool {
    return all(coord >= vec2<i32>(0)) && all(coord < shape);
  }
  fn coordsInBounds3D(coord : vec3<i32>, shape : vec3<i32>) -> bool {
    return all(coord >= vec3<i32>(0)) && all(coord < shape);
  }
  fn coordsInBounds4D(coord : vec4<i32>, shape : vec4<i32>) -> bool {
    return all(coord >= vec4<i32>(0)) && all(coord < shape);
  }

  fn getIndexFromCoords1D(coord : i32, shape : i32) -> i32 {
    return coord;
  }
  fn getIndexFromCoords2D(coords : vec2<i32>, shape : vec2<i32>) -> i32 {
    return dot(coords, vec2<i32>(shape.y, 1));
  }
  fn getIndexFromCoords3D(coords : vec3<i32>, shape : vec3<i32>) -> i32 {
    return dot(coords, vec3<i32>(shape.y * shape.z, shape.z, 1));
  }
  fn getIndexFromCoords4D(coords : vec4<i32>, shape : vec4<i32>) -> i32 {
    return dot(coords, vec4<i32>(
        shape.y * shape.z * shape.w, shape.z * shape.w, shape.w, 1));
  }
  fn getIndexFromCoords5D(coords : vec5, shape : vec5) -> i32 {
    let shapeStrides: vec5 = vec5(shape.y * shape.z * shape.w * shape.u, shape.z * shape.w * shape.u, shape.w * shape.u, shape.u, 1);
    return coords.x*shapeStrides.x + coords.y*shapeStrides.y + coords.z*shapeStrides.z + coords.w*shapeStrides.w + coords.u*shapeStrides.u;
  }
  fn getIndexFromCoords6D(coords : vec6, shape : vec6) -> i32 {
    let shapeStrides: vec6 = vec6(shape.y * shape.z * shape.w * shape.u * shape.v, shape.z * shape.w * shape.u * shape.v, shape.w * shape.u * shape.v, shape.u * shape.v, shape.v, 1);
    return coords.x*shapeStrides.x + coords.y*shapeStrides.y + coords.z*shapeStrides.z + coords.w*shapeStrides.w + coords.u*shapeStrides.u + coords.v*shapeStrides.v;
  }

  // NaN defination in IEEE 754-1985 is :
  //   - sign = either 0 or 1.
  //   - biased exponent = all 1 bits.
  //   - fraction = anything except all 0 bits (since all 0 bits represents infinity).
  // https://en.wikipedia.org/wiki/IEEE_754-1985#Representation_of_non-numbers
  fn isnan(val: f32) -> bool {
    let floatToUint: u32 = bitcast<u32>(val);
    return (floatToUint & 0x7fffffffu) > 0x7f800000u;
  }
  fn isnanVec4(val : vec4<f32>) -> vec4<bool> {
    let floatToUint: vec4<u32> = bitcast<vec4<u32>>(val);
    return (floatToUint & vec4<u32>(0x7fffffffu)) > vec4<u32>(0x7f800000u);
  }
`;
const $04a37a9ad1193786$var$isInfSnippet = `
  fn isinf(val: f32) -> bool {
    return abs(val) == uniforms.INFINITY;
  }
`;
function $04a37a9ad1193786$export$a9674693e382741e(shape, name = '') {
    const rank = shape.length;
    const funcName = name !== '' ? `get${name.charAt(0).toUpperCase() + name.slice(1)}CoordsFromIndex` : 'getCoordsFromIndex';
    const stridesName = name !== '' ? `${name.charAt(0).toLowerCase() + name.slice(1)}ShapeStrides` : `outShapeStrides`;
    if (rank <= 1) return `fn ${funcName}(index : i32) -> i32 { return index; }`;
    const strides = (0, $jjNRA).computeStrides(shape);
    const dtype = $04a37a9ad1193786$export$859efd105c10c755(rank);
    const coords = [];
    for(let i = 0; i < rank; i++)coords.push(`d${i}`);
    if (strides.length === 1) return `    fn ${funcName}(index : i32) -> vec2<i32> {
      let d0 = index / uniforms.${stridesName}; let d1 = index - d0 * uniforms.${stridesName};
      return vec2<i32>(d0, d1);
    }`;
    let snippet;
    snippet = 'var index2 = index;' + strides.map((_, i)=>{
        const line1 = `let ${coords[i]} = index2 / uniforms.${stridesName}.${$04a37a9ad1193786$export$9e429db2fd13bb35(i)}`;
        const line2 = i === strides.length - 1 ? `let ${coords[i + 1]} = index2 - ${coords[i]} * uniforms.${stridesName}.${$04a37a9ad1193786$export$9e429db2fd13bb35(i)}` : `index2 = index2 - ${coords[i]} * uniforms.${stridesName}.${$04a37a9ad1193786$export$9e429db2fd13bb35(i)}`;
        return `${line1}; ${line2};`;
    }).join('');
    return `
    fn ${funcName}(index : i32) -> ${dtype} {
      ${snippet}
      return ${dtype}(${coords.join(',')});
    }
  `;
}
function $04a37a9ad1193786$var$getInputAtCoordsSnippet(inputInfo, component) {
    const texName = inputInfo.name;
    const rank = inputInfo.shape.length;
    const type = $04a37a9ad1193786$export$859efd105c10c755(rank);
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const dims = [
        'd0',
        'd1',
        'd2',
        'd3',
        'd4',
        'd5'
    ].slice(0, rank);
    const inputs = dims.map((d)=>`${d} : i32`).join(', ');
    if (rank < 1) return `
      fn ${funcName}() -> ${$04a37a9ad1193786$export$85f585983df3fed3(component)} {
        return ${$04a37a9ad1193786$export$85f585983df3fed3(component)}(${texName}[0]);
      }
    `;
    const shapeStr = `uniforms.${texName.charAt(0).toLowerCase() + texName.slice(1)}Shape`;
    let rankStr = `${rank}D`;
    if (rank === 0) rankStr = '1D';
    return `
    fn ${funcName}(${inputs}) -> ${$04a37a9ad1193786$export$85f585983df3fed3(component)} {
      return ${$04a37a9ad1193786$export$85f585983df3fed3(component)}(${texName}[getIndexFromCoords${rankStr}(${type}(${dims.join(',')}),
        ${shapeStr})${component === 1 ? '' : ` / ${component}`}]);
    }
   `;
}
function $04a37a9ad1193786$var$getInputByOutputSnippet(inputInfo, outShape, component, isFlatDispatchLayout) {
    const texName = inputInfo.name;
    const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
    const funcName = 'get' + texFuncSnippet + 'ByOutput';
    const inRank = inputInfo.shape.length;
    const outRank = outShape.length;
    const type = $04a37a9ad1193786$export$859efd105c10c755(outRank);
    // If the inShape equals the outShape and the dispatch layout is flat, we can
    // directly use |gl_GlobalInvocationID.x| as the index and don't need coords
    // conversion between these two shapes.
    if ((0, $jjNRA).arraysEqual(inputInfo.shape, outShape) && isFlatDispatchLayout) return `
    fn ${funcName}Index(globalIndex : i32) -> ${$04a37a9ad1193786$export$85f585983df3fed3(component)} {
      return ${$04a37a9ad1193786$export$85f585983df3fed3(component)}(${texName}[globalIndex]);
    }

    fn ${funcName}Coords(coords : ${type}) -> ${$04a37a9ad1193786$export$85f585983df3fed3(component)} {
      return ${$04a37a9ad1193786$export$85f585983df3fed3(component)}(${texName}[${outRank > 1 ? 'getOutputIndexFromCoords(coords)' : 'coords'}${component === 1 ? '' : ` / ${component}`}]);
    }
    `;
    const broadcastDims = (0, $7MaPk).getBroadcastDims(inputInfo.shape, outShape);
    const rankDiff = outRank - inRank;
    let coordsSnippet = '';
    if (inRank === 0) return `
    fn ${funcName}Index(globalIndex : i32) -> ${$04a37a9ad1193786$export$85f585983df3fed3(component)}{
      return get${texFuncSnippet}();
    }

    fn ${funcName}Coords(coords : ${type}) -> ${$04a37a9ad1193786$export$85f585983df3fed3(component)}{
      return get${texFuncSnippet}();
    }
  `;
    else if (outRank < 2 && broadcastDims.length >= 1) coordsSnippet = 'coords = 0;';
    else coordsSnippet = broadcastDims.map((d)=>`coords.${$04a37a9ad1193786$export$9e429db2fd13bb35(d + rankDiff)} = 0;`).join('\n');
    let unpackedCoordsSnippet = '';
    if (outRank < 2 && inRank > 0) unpackedCoordsSnippet = 'coords';
    else if (outRank > 1) {
        const coordsType = $04a37a9ad1193786$export$859efd105c10c755(inRank);
        const coordsValues = inputInfo.shape.map((s, i)=>`coords.${$04a37a9ad1193786$export$9e429db2fd13bb35(i + rankDiff)}`).join(', ');
        unpackedCoordsSnippet = `${coordsType}(${coordsValues})`;
    } else unpackedCoordsSnippet = 'coords';
    const shapeStr = `uniforms.${texName.charAt(0).toLowerCase() + texName.slice(1)}Shape`;
    const rankStr = `${inRank}D`;
    return `
  fn ${funcName}Index(globalIndex : i32) -> ${$04a37a9ad1193786$export$85f585983df3fed3(component)} {
    var coords = getCoordsFromIndex(globalIndex);
    ${coordsSnippet}
    return ${$04a37a9ad1193786$export$85f585983df3fed3(component)}(${texName}[getIndexFromCoords${rankStr}(${unpackedCoordsSnippet}, ${shapeStr})${component === 1 ? '' : ` / ${component}`}]);
  }

  fn ${funcName}Coords(coordsIn : ${type}) -> ${$04a37a9ad1193786$export$85f585983df3fed3(component)} {
    var coords = coordsIn;
    ${coordsSnippet}
    return ${$04a37a9ad1193786$export$85f585983df3fed3(component)}(${texName}[getIndexFromCoords${rankStr}(${unpackedCoordsSnippet}, ${shapeStr})${component === 1 ? '' : ` / ${component}`}]);
  }
`;
}
function $04a37a9ad1193786$var$getInputSnippet(inputInfo, outShape, component, isFlatDispatchLayout) {
    let res = $04a37a9ad1193786$var$getInputAtCoordsSnippet(inputInfo, component);
    const inShape = inputInfo.shape;
    if (inShape.length <= outShape.length) res += $04a37a9ad1193786$var$getInputByOutputSnippet(inputInfo, outShape, component, isFlatDispatchLayout);
    return res;
}
/**
 * Generates getOutputCoords() function that computes output coordinates
 * from dispatch geometry to reduce arithmetic.
 */ function $04a37a9ad1193786$var$getOutputCoordsSnippet(outShape, dispatchLayout) {
    const { x: x, y: y = [], z: z = [] } = dispatchLayout;
    const outRank = outShape.length;
    const rank = x.length + y.length + z.length;
    // getOutputCoords is only meaningful when the output rank is same with
    // dispatch layout rank.
    if (rank !== outRank) return '';
    if (x.length === outRank) {
        const dtype = $04a37a9ad1193786$export$859efd105c10c755(outRank);
        const snippet = `fn getOutputCoords() -> ${dtype}{
    let globalIndex = getGlobalIndex();
    return getCoordsFromIndex(globalIndex);
  }
  `;
        return snippet;
    }
    let gatherDimensionsStr = '';
    const dims = [
        x,
        y,
        z
    ];
    for(let i = 0; i < dims.length; i++){
        const arr = dims[i];
        if (arr.length === 0) continue;
        if (arr.length === 1) gatherDimensionsStr += `let d${arr[0]} = i32(globalId[${i}]);`;
        else {
            const strides = (0, $arOgS.symbolicallyComputeStrides)(arr, 'uniforms.outShape');
            gatherDimensionsStr += `var index${i} = i32(globalId[${i}]);`;
            for(let j = 0; j < strides.length; j++){
                gatherDimensionsStr += `let d${arr[j]} = index${i} / ${strides[j]};`;
                if (j === strides.length - 1) gatherDimensionsStr += `let d${arr[j + 1]} = ` + `index${i} - d${arr[j]} * ${strides[j]};`;
                else gatherDimensionsStr += `index${i} = index${i} - d${arr[j]} * ${strides[j]};`;
            }
        }
    }
    const dimensions = [];
    for(let i = 0; i < rank; i++)dimensions.push(`d${i}`);
    const dtype = $04a37a9ad1193786$export$859efd105c10c755(rank);
    let snippet = `fn getOutputCoords() -> ${dtype} {
  ${gatherDimensionsStr}
`;
    if (dimensions.length === 0) snippet += `return ${dtype}(0); }`;
    else snippet += `return ${dtype}(${dimensions.join(',')}); }`;
    return snippet;
}
function $04a37a9ad1193786$var$getOutputIndexFromCoordsSnippet(outRank) {
    let snippet = '';
    switch(outRank){
        case 0:
        case 1:
            snippet += `
        fn getOutputIndexFromCoords(coords : i32) -> i32 {
          return coords;
        }
        `;
            break;
        case 2:
            snippet += `
        fn getOutputIndexFromCoords(coords : vec2<i32>) -> i32 {
          return dot(coords, vec2<i32>(uniforms.outShapeStrides, 1));
        }
        `;
            break;
        case 3:
            snippet += `
        fn getOutputIndexFromCoords(coords : vec3<i32>) -> i32 {
          return dot(coords, vec3<i32>(uniforms.outShapeStrides.x, uniforms.outShapeStrides.y, 1));
        }
        `;
            break;
        case 4:
            snippet += `
        fn getOutputIndexFromCoords(coords : vec4<i32>) -> i32 {
          return dot(coords, vec4<i32>(
            uniforms.outShapeStrides.x, uniforms.outShapeStrides.y, uniforms.outShapeStrides.z, 1));
        }
        `;
            break;
        case 5:
            snippet += `
        fn getOutputIndexFromCoords(coords : vec5) -> i32 {
          return coords.x * uniforms.outShapeStrides.x +
              coords.y * uniforms.outShapeStrides.y +
              coords.z * uniforms.outShapeStrides.z +
              coords.w * uniforms.outShapeStrides.w +
              coords.u;
        }
        `;
            break;
        case 6:
            snippet += `
        fn getOutputIndexFromCoords(coords : vec6) -> i32 {
          return coords.x * uniforms.outShapeStrides.x +
              coords.y * uniforms.outShapeStrides.y +
              coords.z * uniforms.outShapeStrides.z +
              coords.w * uniforms.outShapeStrides.w +
              coords.u * uniforms.outShapeStrides.u +
              coords.v;
        }
        `;
            break;
        default:
            (0, $jjNRA).assert(false, ()=>`Unsupported ${outRank}D shape`);
            break;
    }
    return snippet;
}
function $04a37a9ad1193786$var$isFlatDispatch(program) {
    return program.dispatch[1] === 1 && program.dispatch[2] === 1;
}
function $04a37a9ad1193786$export$342fcff7270d2d1a(type, component = 1) {
    if (type === 'float32') return $04a37a9ad1193786$export$85f585983df3fed3(component, 'f32');
    else if (type === 'int32' || type === 'bool') return $04a37a9ad1193786$export$85f585983df3fed3(component, 'i32');
    throw new Error(`type ${type} is not supported.`);
}
function $04a37a9ad1193786$var$setOutputSnippet(outShape, outBufferType, component) {
    const outRank = outShape.length;
    const gpuType = $04a37a9ad1193786$export$342fcff7270d2d1a(outBufferType, component);
    let snippet = `fn setOutputAtIndex(flatIndex : i32, value : ${$04a37a9ad1193786$export$85f585983df3fed3(component)}) {
      result[flatIndex] = ${gpuType}(value);
    }

    fn setOutputAtIndexI32(flatIndex : i32, value : ${$04a37a9ad1193786$export$85f585983df3fed3(component, 'i32')}) {
      result[flatIndex] = ${gpuType}(value);
    }
    `;
    if (outRank >= 2) {
        const dims = [
            'd0',
            'd1',
            'd2',
            'd3',
            'd4',
            'd5'
        ].slice(0, outRank);
        const type = $04a37a9ad1193786$export$859efd105c10c755(outRank);
        snippet += `
      fn setOutputAtCoords(${dims.map((d)=>`${d} : i32`).join(', ')}, value : ${$04a37a9ad1193786$export$85f585983df3fed3(component)}) {
        let flatIndex = getOutputIndexFromCoords(${type}(${dims.join(', ')}));
        setOutputAtIndex(flatIndex${component === 1 ? '' : ` / ${component}`}, value);
      }
      fn setOutputAtCoordsI32(${dims.map((d)=>`${d} : i32`).join(', ')}, value : ${$04a37a9ad1193786$export$85f585983df3fed3(component, 'i32')}) {
        let flatIndex = getOutputIndexFromCoords(${type}(${dims.join(', ')}));
        setOutputAtIndexI32(flatIndex${component === 1 ? '' : ` / ${component}`}, value);
      }
    `;
    }
    return snippet;
}
function $04a37a9ad1193786$var$insertAlignment(uniformShader) {
    // insert alignment when current pattern is vec5 or vec6
    const curInsertRe = /(\w+)\s*:\s*vec(5|6)/g;
    uniformShader = uniformShader.replace(curInsertRe, (match)=>{
        return '@align(16) ' + match;
    });
    // insert alignment when previous pattern is vec5 or vec6
    const preInsertRe = /vec(5|6)\s*,\s*(\w+)/g;
    uniformShader = uniformShader.replace(preInsertRe, (_, p1, p2)=>{
        return `vec${p1}, @align(16) ${p2}`;
    });
    return uniformShader;
}
function $04a37a9ad1193786$var$isFlatDispatchLayout(program) {
    if (program.dispatchLayout.hasOwnProperty('y') && program.dispatchLayout.y.length !== 0) return false;
    if (program.dispatchLayout.hasOwnProperty('z') && program.dispatchLayout.z.length !== 0) return false;
    return true;
}

});
parcelRegister("arOgS", function(module, exports) {

$parcel$export(module.exports, "symbolicallyComputeStrides", () => $79b36bd24b3b4b9b$export$e21dd4b371e59d34);
$parcel$export(module.exports, "atomicAddSnippet", () => $79b36bd24b3b4b9b$export$95fdaaf661ca4063);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Generates WGSL that computes strides.
function $79b36bd24b3b4b9b$export$e21dd4b371e59d34(indicesArr, variableName) {
    if (Math.max(...indicesArr) > 5) throw new Error('Cannot symbolically compute strides for rank > 6 tensor.');
    const numCoords = indicesArr.length;
    const indicesStr = 'xyzwuv';
    const shape = indicesArr.map((d)=>`${variableName}.${indicesStr[d]}`);
    const strides = new Array(numCoords - 1);
    strides[numCoords - 2] = shape[numCoords - 1];
    for(let i = numCoords - 3; i >= 0; --i)strides[i] = `(${strides[i + 1]} * ${shape[i + 1]})`;
    return strides;
}
const $79b36bd24b3b4b9b$export$95fdaaf661ca4063 = (ptr, v, type)=>{
    if (type === 'int32') return `atomicAdd(${ptr}, bitcast<i32>(${v}));`;
    else // atomicAdd only supports uint/int type. For float, we use
    // atomicCompareExchangeWeak to simulate.
    return `
          {
            var oldValue = 0;
            loop {
              let newValueF32 = bitcast<f32>(oldValue) + (${v});
              let newValue = bitcast<i32>(newValueF32);
              let res = atomicCompareExchangeWeak(${ptr}, oldValue, newValue);
              if res.exchanged {
                break;
              }
              oldValue = res.old_value;
            }
          }`;
};

});


parcelRegister("9Dn6G", function(module, exports) {

$parcel$export(module.exports, "tilesFitEvenlyIntoShape", () => $7039ae17e40a27b0$export$a32f526834c8fb8a);
$parcel$export(module.exports, "computeDispatch", () => $7039ae17e40a27b0$export$e8b81faf4b51e34b);
$parcel$export(module.exports, "computeWorkgroupInfoForMatMul", () => $7039ae17e40a27b0$export$f6bf47abf12e6a8a);
$parcel$export(module.exports, "computeWorkgroupSizeForConv2d", () => $7039ae17e40a27b0$export$c017ff3929b35682);
$parcel$export(module.exports, "computeWorkPerThreadForConv2d", () => $7039ae17e40a27b0$export$1f250f140443453c);
$parcel$export(module.exports, "flatDispatchLayout", () => $7039ae17e40a27b0$export$9f192dff395c74d);
$parcel$export(module.exports, "GPUBytesPerElement", () => $7039ae17e40a27b0$export$3b5bd9c5c24b50c9);
$parcel$export(module.exports, "isWebGPUSupported", () => $7039ae17e40a27b0$export$216169f30082c873);
$parcel$export(module.exports, "assertNotComplex", () => $7039ae17e40a27b0$export$1412c17b2531581a);
$parcel$export(module.exports, "MatMulProgramType", () => $7039ae17e40a27b0$export$b83d75b9ab62b8b5);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
const $7039ae17e40a27b0$var$arrayProduct = (arr)=>{
    let product = 1;
    for(let i = 0; i < arr.length; i++)product *= arr[i];
    return product;
};
function $7039ae17e40a27b0$export$a32f526834c8fb8a(tileSize, shape) {
    if (tileSize.length !== shape.length) throw new Error(`Cannot compute whether rank ${tileSize.length}` + ` tiles fit evenly into rank ${shape.length} shape` + ` - ranks must match.`);
    return shape.every((dim, dimIdx)=>dim % tileSize[dimIdx] === 0);
}
function $7039ae17e40a27b0$export$e8b81faf4b51e34b(layout, outputShape, workgroupSize = [
    1,
    1,
    1
], elementsPerThread = [
    1,
    1,
    1
]) {
    const [dispatchX, dispatchY, dispatchZ] = [
        Math.ceil($7039ae17e40a27b0$var$arrayProduct(layout.x.map((d)=>outputShape[d])) / (workgroupSize[0] * elementsPerThread[0])),
        layout.y ? Math.ceil($7039ae17e40a27b0$var$arrayProduct(layout.y.map((d)=>outputShape[d])) / (workgroupSize[1] * elementsPerThread[1])) : 1,
        layout.z ? Math.ceil($7039ae17e40a27b0$var$arrayProduct(layout.z.map((d)=>outputShape[d])) / (workgroupSize[2] * elementsPerThread[2])) : 1
    ];
    return [
        dispatchX,
        dispatchY,
        dispatchZ
    ];
}
function $7039ae17e40a27b0$export$f6bf47abf12e6a8a(dimAOuter, dimInner, dimBOuter, transposeA = false) {
    // These are experimental values. Usually, we need to adjust the work group
    // size based on the input shapes to improve the EU occupancy.
    // TODO: WebGPU limits the maximum allowed shared memory size as 16K. To make
    // sure it doesn't exceed this limitations. Temporarily reduce the work group
    // size to [8, 8, 1] and the work per thread size is [4, 4, 1]. But we should
    // revisit it and find the balance between work group size and work per thread
    // size.
    const workgroupSize = [
        8,
        8,
        1
    ];
    const elementsPerThread = [
        4,
        4,
        1
    ];
    if (!transposeA) {
        if (dimAOuter <= 8) elementsPerThread[1] = 1;
        if (dimInner <= 16 && dimBOuter <= 16) workgroupSize[0] = 4;
    }
    return {
        workgroupSize: workgroupSize,
        elementsPerThread: elementsPerThread
    };
}
function $7039ae17e40a27b0$export$c017ff3929b35682(layout, outputShape, isVec4 = false) {
    if (isVec4) return [
        8,
        8,
        1
    ];
    const dim0 = $7039ae17e40a27b0$var$arrayProduct(layout.x.map((d)=>outputShape[d]));
    const dim1 = $7039ae17e40a27b0$var$arrayProduct(layout.y.map((d)=>outputShape[d]));
    // TODO(jiajia.qin@intel.com): More fine tune based on outputShape.
    // These are experimental values. Usually, we need to adjust the work group
    // size based on the output shape. For example, when one dimension is smaller
    // than 4, it will be wasteful if we assign a larger size for this dimension,
    // which results lots of threads doing useless work and reduces parallelism
    // of hardware threads. But it is always a balance between work group size
    // and shared memory. If one dimension is too small, such as 1, shared memory
    // will won't be fully utilized.
    if (dim0 <= 4) return [
        4,
        16,
        1
    ];
    if (dim1 <= 4) return [
        16,
        4,
        1
    ];
    return [
        16,
        16,
        1
    ];
}
function $7039ae17e40a27b0$export$1f250f140443453c(layout, outputShape, isVec4 = false) {
    if (isVec4) return [
        4,
        4,
        1
    ];
    const dim0 = $7039ae17e40a27b0$var$arrayProduct(layout.x.map((d)=>outputShape[d]));
    const dim1 = $7039ae17e40a27b0$var$arrayProduct(layout.y.map((d)=>outputShape[d]));
    // TODO(jiajia.qin@intel.com): More fine tune based on outputShape.
    // The following conditions correspond to the values set in
    // computeWorkgroupSizeForConv2d.
    if (dim0 <= 4) return [
        1,
        2,
        1
    ];
    if (dim1 <= 4) return [
        2,
        1,
        1
    ];
    return [
        2,
        2,
        1
    ];
}
function $7039ae17e40a27b0$export$9f192dff395c74d(shape) {
    return {
        x: shape.map((d, i)=>i)
    };
}
function $7039ae17e40a27b0$export$3b5bd9c5c24b50c9(dtype) {
    if (dtype === 'float32' || dtype === 'int32' || dtype === 'bool' || dtype === 'string') return 4;
    else if (dtype === 'complex64') return 8;
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $7039ae17e40a27b0$export$216169f30082c873() {
    return !!(typeof globalThis !== 'undefined' && globalThis.navigator && globalThis.navigator.gpu);
}
function $7039ae17e40a27b0$export$1412c17b2531581a(tensor, opName) {
    if (!Array.isArray(tensor)) tensor = [
        tensor
    ];
    tensor.forEach((t)=>{
        if (t != null) (0, $jjNRA).assert(t.dtype !== 'complex64', ()=>`${opName} does not support complex64 tensors ` + 'in the WebGPU backend.');
    });
}
var $7039ae17e40a27b0$export$b83d75b9ab62b8b5;
(function(MatMulProgramType) {
    MatMulProgramType[MatMulProgramType["MatMulReduceProgram"] = 0] = "MatMulReduceProgram";
    MatMulProgramType[MatMulProgramType["MatMulSplitKProgram"] = 1] = "MatMulSplitKProgram";
    MatMulProgramType[MatMulProgramType["MatMulSmallOutputSizeProgram"] = 2] = "MatMulSmallOutputSizeProgram";
    MatMulProgramType[MatMulProgramType["MatMulPackedProgram"] = 3] = "MatMulPackedProgram";
    MatMulProgramType[MatMulProgramType["MatMulMax"] = 4] = "MatMulMax";
})($7039ae17e40a27b0$export$b83d75b9ab62b8b5 || ($7039ae17e40a27b0$export$b83d75b9ab62b8b5 = {}));

});


parcelRegister("7HGX2", function(module, exports) {

$parcel$export(module.exports, "WebGPUBackend", () => (parcelRequire("j8LvK")).WebGPUBackend);
$parcel$export(module.exports, "webgpu_util", () => (parcelRequire("9Dn6G")));
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9Dn6G = parcelRequire("9Dn6G");

var $j8LvK = parcelRequire("j8LvK");

});


parcelRegister("c8TDA", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $eky5o = parcelRequire("eky5o");

var $9VZae = parcelRequire("9VZae");

var $kcF8C = parcelRequire("kcF8C");

var $8s9nH = parcelRequire("8s9nH");

var $ioNsO = parcelRequire("ioNsO");

var $9Vvdb = parcelRequire("9Vvdb");

var $3IxST = parcelRequire("3IxST");

var $hweGq = parcelRequire("hweGq");

var $hsc0m = parcelRequire("hsc0m");

var $6re1B = parcelRequire("6re1B");

var $fV48O = parcelRequire("fV48O");

var $35IWR = parcelRequire("35IWR");

var $hLrr1 = parcelRequire("hLrr1");

var $6Py2B = parcelRequire("6Py2B");

var $9FPPD = parcelRequire("9FPPD");

var $e3UCc = parcelRequire("e3UCc");

var $lD0Yf = parcelRequire("lD0Yf");

var $fYP8d = parcelRequire("fYP8d");

var $kWL8q = parcelRequire("kWL8q");

var $3IpNJ = parcelRequire("3IpNJ");

var $bpf6O = parcelRequire("bpf6O");

var $eQfS6 = parcelRequire("eQfS6");

var $4aAZr = parcelRequire("4aAZr");

var $3pEnr = parcelRequire("3pEnr");

var $1bpZT = parcelRequire("1bpZT");

var $eK7Cu = parcelRequire("eK7Cu");

var $ehw4q = parcelRequire("ehw4q");

var $lbBov = parcelRequire("lbBov");

var $2LChF = parcelRequire("2LChF");

var $2UdAg = parcelRequire("2UdAg");

var $9mHBc = parcelRequire("9mHBc");

var $eNRYg = parcelRequire("eNRYg");

var $2uuGe = parcelRequire("2uuGe");

var $2s8kP = parcelRequire("2s8kP");

var $JUqmg = parcelRequire("JUqmg");

var $5EFKx = parcelRequire("5EFKx");

var $l74vR = parcelRequire("l74vR");

var $bp7kF = parcelRequire("bp7kF");

var $kcn61 = parcelRequire("kcn61");

var $5Zq4J = parcelRequire("5Zq4J");

var $8EKrN = parcelRequire("8EKrN");

var $bYGZt = parcelRequire("bYGZt");

var $75tpS = parcelRequire("75tpS");

var $emH1U = parcelRequire("emH1U");

var $KsDlA = parcelRequire("KsDlA");

var $6Vc6c = parcelRequire("6Vc6c");

var $1u97N = parcelRequire("1u97N");

var $jZCQ0 = parcelRequire("jZCQ0");

var $dyuo6 = parcelRequire("dyuo6");

var $ceC11 = parcelRequire("ceC11");

var $9AFtF = parcelRequire("9AFtF");

var $5Sa2q = parcelRequire("5Sa2q");

var $hdOid = parcelRequire("hdOid");

var $708SQ = parcelRequire("708SQ");

var $aGE3x = parcelRequire("aGE3x");

var $gJoRs = parcelRequire("gJoRs");

var $a9fYB = parcelRequire("a9fYB");

var $5N59B = parcelRequire("5N59B");

var $5Xa36 = parcelRequire("5Xa36");

var $5j54h = parcelRequire("5j54h");

var $cFwkm = parcelRequire("cFwkm");

var $56gjc = parcelRequire("56gjc");

var $75xq5 = parcelRequire("75xq5");

var $fhYvD = parcelRequire("fhYvD");

var $55sfy = parcelRequire("55sfy");

var $ifc9b = parcelRequire("ifc9b");

var $d1gHK = parcelRequire("d1gHK");

var $4OOm5 = parcelRequire("4OOm5");

var $6464m = parcelRequire("6464m");

var $gDTrm = parcelRequire("gDTrm");

var $4AQDR = parcelRequire("4AQDR");

var $jvsZZ = parcelRequire("jvsZZ");

var $17o8l = parcelRequire("17o8l");

var $cPOux = parcelRequire("cPOux");

var $2hp6b = parcelRequire("2hp6b");

var $iZrAY = parcelRequire("iZrAY");

var $kjTzZ = parcelRequire("kjTzZ");

var $dzkXT = parcelRequire("dzkXT");

var $kI39w = parcelRequire("kI39w");

var $dhxU8 = parcelRequire("dhxU8");

var $47AIY = parcelRequire("47AIY");

var $cYAkQ = parcelRequire("cYAkQ");

var $1281S = parcelRequire("1281S");

var $fNtds = parcelRequire("fNtds");

var $gNgxW = parcelRequire("gNgxW");

var $afxB8 = parcelRequire("afxB8");

var $8TTdn = parcelRequire("8TTdn");

var $lqP2B = parcelRequire("lqP2B");

var $lfAX4 = parcelRequire("lfAX4");

var $avTob = parcelRequire("avTob");

var $h4Kie = parcelRequire("h4Kie");

var $i5HLG = parcelRequire("i5HLG");

var $k0RoI = parcelRequire("k0RoI");

var $lqK20 = parcelRequire("lqK20");

var $8x2FH = parcelRequire("8x2FH");

var $f1aWD = parcelRequire("f1aWD");

var $aIxzD = parcelRequire("aIxzD");

var $1gwEz = parcelRequire("1gwEz");

var $4qe56 = parcelRequire("4qe56");

var $iUD6m = parcelRequire("iUD6m");

var $7Q00V = parcelRequire("7Q00V");

var $kW16T = parcelRequire("kW16T");

var $19OU2 = parcelRequire("19OU2");

var $5qXhN = parcelRequire("5qXhN");

var $lS3ay = parcelRequire("lS3ay");

var $ixZRO = parcelRequire("ixZRO");

var $cXttH = parcelRequire("cXttH");

var $8Gjn7 = parcelRequire("8Gjn7");

var $9F9Bf = parcelRequire("9F9Bf");

var $bidIZ = parcelRequire("bidIZ");

var $HZHMf = parcelRequire("HZHMf");

var $8pdtS = parcelRequire("8pdtS");

var $8UebA = parcelRequire("8UebA");

var $hv5Ke = parcelRequire("hv5Ke");

var $RdQ8e = parcelRequire("RdQ8e");

var $6QjI0 = parcelRequire("6QjI0");

var $2Graj = parcelRequire("2Graj");

var $avwwZ = parcelRequire("avwwZ");

var $jcy8m = parcelRequire("jcy8m");

var $eQ0Bk = parcelRequire("eQ0Bk");

var $gj4T5 = parcelRequire("gj4T5");

var $gV44p = parcelRequire("gV44p");

var $gZHal = parcelRequire("gZHal");

var $cqK1h = parcelRequire("cqK1h");

var $fp3ip = parcelRequire("fp3ip");

var $74ZZK = parcelRequire("74ZZK");

var $aDjD8 = parcelRequire("aDjD8");

var $31gFw = parcelRequire("31gFw");

var $eu0UJ = parcelRequire("eu0UJ");

var $i89sa = parcelRequire("i89sa");

var $acUBN = parcelRequire("acUBN");

var $NUQCf = parcelRequire("NUQCf");

var $i164A = parcelRequire("i164A");

var $bO3Wh = parcelRequire("bO3Wh");

var $ae3G5 = parcelRequire("ae3G5");

var $cWpcA = parcelRequire("cWpcA");

var $dxrYi = parcelRequire("dxrYi");

var $klUog = parcelRequire("klUog");

var $hnITQ = parcelRequire("hnITQ");

var $haqGf = parcelRequire("haqGf");

var $8zbc3 = parcelRequire("8zbc3");

var $873vJ = parcelRequire("873vJ");

var $237nX = parcelRequire("237nX");

var $ie8pe = parcelRequire("ie8pe");

var $2ROFn = parcelRequire("2ROFn");

var $5TAZG = parcelRequire("5TAZG");

var $arv0j = parcelRequire("arv0j");

var $3HiU0 = parcelRequire("3HiU0");

var $lSSve = parcelRequire("lSSve");

var $5B730 = parcelRequire("5B730");

var $1OFx6 = parcelRequire("1OFx6");

var $jTbfI = parcelRequire("jTbfI");

var $6CMjm = parcelRequire("6CMjm");

var $iCQZ1 = parcelRequire("iCQZ1");

var $77tYE = parcelRequire("77tYE");

var $dR0Tc = parcelRequire("dR0Tc");

var $Lxcvj = parcelRequire("Lxcvj");

var $ceTsM = parcelRequire("ceTsM");

var $k57O2 = parcelRequire("k57O2");

var $f9YmZ = parcelRequire("f9YmZ");

var $cuybR = parcelRequire("cuybR");

var $liTL6 = parcelRequire("liTL6");

var $gX70G = parcelRequire("gX70G");
// List all kernel configs here
const $8d7163dcf97201e9$var$kernelConfigs = [
    (0, $9VZae._fusedMatMulConfig),
    (0, $kcF8C.absConfig),
    (0, $8s9nH.acosConfig),
    (0, $ioNsO.acoshConfig),
    (0, $9Vvdb.addConfig),
    (0, $3IxST.addNConfig),
    (0, $hweGq.allConfig),
    (0, $hsc0m.anyConfig),
    (0, $6re1B.argMaxConfig),
    (0, $fV48O.argMinConfig),
    (0, $35IWR.asinConfig),
    (0, $hLrr1.asinhConfig),
    (0, $6Py2B.atanConfig),
    (0, $9FPPD.atan2Config),
    (0, $e3UCc.atanhConfig),
    (0, $lD0Yf.avgPoolConfig),
    (0, $fYP8d.avgPool3DConfig),
    (0, $kWL8q.avgPool3DGradConfig),
    (0, $3IpNJ.avgPoolGradConfig),
    (0, $bpf6O.batchMatMulConfig),
    (0, $eQfS6.batchToSpaceNDConfig),
    (0, $4aAZr.bincountConfig),
    (0, $3pEnr.broadcastArgsConfig),
    (0, $1bpZT.castConfig),
    (0, $eK7Cu.ceilConfig),
    (0, $ehw4q.clipByValueConfig),
    (0, $lbBov.complexConfig),
    (0, $2LChF.complexAbsConfig),
    (0, $2UdAg.concatConfig),
    (0, $9mHBc.conv2DConfig),
    (0, $eNRYg.conv2DBackpropFilterConfig),
    (0, $2uuGe.conv2DBackpropInputConfig),
    (0, $2s8kP.conv3DConfig),
    (0, $JUqmg.conv3DBackpropFilterV2Config),
    (0, $5EFKx.conv3DBackpropInputV2Config),
    (0, $l74vR.cosConfig),
    (0, $bp7kF.coshConfig),
    (0, $kcn61.cropAndResizeConfig),
    (0, $5Zq4J.cumprodConfig),
    (0, $8EKrN.cumsumConfig),
    (0, $bYGZt.denseBincountConfig),
    (0, $75tpS.depthToSpaceConfig),
    (0, $KsDlA.depthwiseConv2dNativeBackpropFilterConfig),
    (0, $6Vc6c.depthwiseConv2dNativeBackpropInputConfig),
    (0, $emH1U.depthwiseConv2dNativeConfig),
    (0, $1u97N.diagConfig),
    (0, $jZCQ0.dilation2DConfig),
    (0, $dyuo6.dilation2DBackpropFilterConfig),
    (0, $ceC11.dilation2DBackpropInputConfig),
    (0, $9AFtF.drawConfig),
    (0, $5Sa2q.einsumConfig),
    (0, $hdOid.eluConfig),
    (0, $708SQ.eluGradConfig),
    (0, $aGE3x.equalConfig),
    (0, $gJoRs.erfConfig),
    (0, $a9fYB.expConfig),
    (0, $5N59B.expandDimsConfig),
    (0, $5Xa36.expm1Config),
    (0, $5j54h.fftConfig),
    (0, $cFwkm.fillConfig),
    (0, $56gjc.flipLeftRightConfig),
    (0, $55sfy.fromPixelsConfig),
    (0, $75xq5.floorConfig),
    (0, $fhYvD.floorDivConfig),
    (0, $ifc9b.fusedBatchNormConfig),
    (0, $d1gHK.fusedConv2DConfig),
    (0, $4OOm5.fusedDepthwiseConv2DConfig),
    (0, $6464m.gatherNdConfig),
    (0, $gDTrm.gatherV2Config),
    (0, $4AQDR.greaterConfig),
    (0, $jvsZZ.greaterEqualConfig),
    (0, $17o8l.identityConfig),
    (0, $cPOux.ifftConfig),
    (0, $2hp6b.imagConfig),
    (0, $iZrAY.isFiniteConfig),
    (0, $kjTzZ.isInfConfig),
    (0, $dzkXT.isNaNConfig),
    (0, $kI39w.leakyReluConfig),
    (0, $dhxU8.lessConfig),
    (0, $47AIY.lessEqualConfig),
    (0, $cYAkQ.linSpaceConfig),
    (0, $fNtds.log1pConfig),
    (0, $1281S.logConfig),
    (0, $gNgxW.logicalAndConfig),
    (0, $afxB8.logicalNotConfig),
    (0, $8TTdn.logicalOrConfig),
    (0, $lqP2B.lrnConfig),
    (0, $lfAX4.lrnGradConfig),
    (0, $avTob.maxConfig),
    (0, $h4Kie.maximumConfig),
    (0, $i5HLG.maxPoolConfig),
    (0, $8x2FH.maxPoolGradConfig),
    (0, $k0RoI.maxPool3DConfig),
    (0, $lqK20.maxPool3DGradConfig),
    (0, $f1aWD.maxPoolWithArgmaxConfig),
    (0, $aIxzD.meanConfig),
    (0, $1gwEz.minConfig),
    (0, $4qe56.minimumConfig),
    (0, $iUD6m.mirrorPadConfig),
    (0, $7Q00V.modConfig),
    (0, $kW16T.multinomialConfig),
    (0, $19OU2.multiplyConfig),
    (0, $5qXhN.negConfig),
    (0, $lS3ay.nonMaxSuppressionV3Config),
    (0, $ixZRO.nonMaxSuppressionV5Config),
    (0, $cXttH.notEqualConfig),
    (0, $8Gjn7.oneHotConfig),
    (0, $9F9Bf.onesLikeConfig),
    (0, $bidIZ.packConfig),
    (0, $HZHMf.padV2Config),
    (0, $8pdtS.powConfig),
    (0, $8UebA.preluConfig),
    (0, $hv5Ke.prodConfig),
    (0, $RdQ8e.rangeConfig),
    (0, $6QjI0.realConfig),
    (0, $2Graj.realDivConfig),
    (0, $avwwZ.reciprocalConfig),
    (0, $jcy8m.reluConfig),
    (0, $eQ0Bk.relu6Config),
    (0, $gj4T5.reshapeConfig),
    (0, $gV44p.resizeBilinearConfig),
    (0, $gZHal.resizeBilinearGradConfig),
    (0, $cqK1h.resizeNearestNeighborConfig),
    (0, $fp3ip.resizeNearestNeighborGradConfig),
    (0, $74ZZK.reverseConfig),
    (0, $aDjD8.rotateWithOffsetConfig),
    (0, $31gFw.roundConfig),
    (0, $eu0UJ.rsqrtConfig),
    (0, $i89sa.scatterNdConfig),
    (0, $acUBN.searchSortedConfig),
    (0, $NUQCf.selectConfig),
    (0, $i164A.seluConfig),
    (0, $bO3Wh.sigmoidConfig),
    (0, $ae3G5.signConfig),
    (0, $cWpcA.sinConfig),
    (0, $dxrYi.sinhConfig),
    (0, $klUog.sliceConfig),
    (0, $lSSve.stepConfig),
    (0, $5B730.stridedSliceConfig),
    (0, $1OFx6.stringNGramsConfig),
    (0, $hnITQ.softmaxConfig),
    (0, $haqGf.softplusConfig),
    (0, $8zbc3.spaceToBatchNDConfig),
    (0, $873vJ.sparseSegmentMeanConfig),
    (0, $237nX.sparseSegmentSumConfig),
    (0, $ie8pe.sparseToDenseConfig),
    (0, $2ROFn.splitVConfig),
    (0, $5TAZG.sqrtConfig),
    (0, $arv0j.squareConfig),
    (0, $3HiU0.squaredDifferenceConfig),
    (0, $jTbfI.subConfig),
    (0, $6CMjm.sumConfig),
    (0, $iCQZ1.tanConfig),
    (0, $77tYE.tanhConfig),
    (0, $dR0Tc.tensorScatterUpdateConfig),
    (0, $Lxcvj.tileConfig),
    (0, $ceTsM.topKConfig),
    (0, $k57O2.transformConfig),
    (0, $f9YmZ.transposeConfig),
    (0, $cuybR.unpackConfig),
    (0, $liTL6.unsortedSegmentSumConfig),
    (0, $gX70G.zerosLikeConfig)
];
for (const kernelConfig of $8d7163dcf97201e9$var$kernelConfigs)(0, $eky5o.registerKernel)(kernelConfig);

});
parcelRegister("9VZae", function(module, exports) {

$parcel$export(module.exports, "_fusedMatMulConfig", () => $73b8e1d4b0aa64ac$export$f70d36da1c218f84);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $die3l = parcelRequire("die3l");
function $73b8e1d4b0aa64ac$export$d86ca0bbe0236889(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { transposeA: transposeA, transposeB: transposeB, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    return (0, $die3l.batchMatMulImpl)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend,
        bias: bias,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha,
        activation: activation
    });
}
const $73b8e1d4b0aa64ac$export$f70d36da1c218f84 = {
    kernelName: (0, $hl418._FusedMatMul),
    backendName: 'webgpu',
    kernelFunc: $73b8e1d4b0aa64ac$export$d86ca0bbe0236889
};

});
parcelRegister("die3l", function(module, exports) {

$parcel$export(module.exports, "batchMatMulImpl", () => $9ad7db6af386b24d$export$d524d65e88e1168b);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $8BaGO = parcelRequire("8BaGO");
var $ibsdL = parcelRequire("ibsdL");
var $jjNRA = parcelRequire("jjNRA");

var $8UfUr = parcelRequire("8UfUr");

var $94yrr = parcelRequire("94yrr");

var $ix1Ig = parcelRequire("ix1Ig");

var $02wJs = parcelRequire("02wJs");

var $9Dn6G = parcelRequire("9Dn6G");

var $cFwkm = parcelRequire("cFwkm");

var $gj4T5 = parcelRequire("gj4T5");
function $9ad7db6af386b24d$export$d524d65e88e1168b({ a: a, b: b, transposeA: transposeA, transposeB: transposeB, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    const aRank = a.shape.length;
    const bRank = b.shape.length;
    const innerShapeA = transposeA ? a.shape[aRank - 2] : a.shape[aRank - 1];
    const innerShapeB = transposeB ? b.shape[bRank - 1] : b.shape[bRank - 2];
    const outerShapeA = transposeA ? a.shape[aRank - 1] : a.shape[aRank - 2];
    const outerShapeB = transposeB ? b.shape[bRank - 2] : b.shape[bRank - 1];
    const outerDimsA = a.shape.slice(0, -2);
    const outerDimsB = b.shape.slice(0, -2);
    const batchDimA = (0, $jjNRA).sizeFromShape(outerDimsA);
    const batchDimB = (0, $jjNRA).sizeFromShape(outerDimsB);
    const outShapeOuterDims = (0, $8BaGO).assertAndGetBroadcastShape(a.shape.slice(0, -2), b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    (0, $jjNRA).assert(innerShapeA === innerShapeB, ()=>`Error in matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${a.shape} and ` + `${b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const a3dShape = transposeA ? [
        batchDimA,
        innerShapeA,
        outerShapeA
    ] : [
        batchDimA,
        outerShapeA,
        innerShapeA
    ];
    const b3dShape = transposeB ? [
        batchDimB,
        outerShapeB,
        innerShapeB
    ] : [
        batchDimB,
        innerShapeB,
        outerShapeB
    ];
    // The rest of the implementation is designed to operate on rank-3 tensors
    const a3d = (0, $gj4T5.reshape)({
        inputs: {
            x: a
        },
        backend: backend,
        attrs: {
            shape: a3dShape
        }
    });
    const b3d = (0, $gj4T5.reshape)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            shape: b3dShape
        }
    });
    const intermediates = [
        a3d,
        b3d
    ];
    const batchDim = Math.max(batchDimA, batchDimB);
    const inputs = [
        a3d,
        b3d
    ];
    const dimensions = [
        {
            type: 'int32',
            data: [
                outerShapeA
            ]
        },
        {
            type: 'int32',
            data: [
                outerShapeB
            ]
        },
        {
            type: 'int32',
            data: [
                innerShapeA
            ]
        }
    ];
    let program;
    let out;
    const outputShape = [
        batchDim,
        outerShapeA,
        outerShapeB
    ];
    let matmulProgramType = (0, $ibsdL.env)().get('WEBGPU_MATMUL_PROGRAM_TYPE');
    if (matmulProgramType < 0) {
        // Usually increasing workgroups is a good way to gain more performance for
        // few workgroups by tiling 32x32 (default matmul algorithm). Currently,
        // there are three ways to increase workgroups. 1) MatMulReduceProgram,
        // which is used only when the output size is very small (128 for now). 2)
        // MatMulSplitKProgram, increasing workgroups by spliting K. 3)
        // MatMulSmallOutputSizeProgram, increasing workgroups by small tile size.
        // For different devices, the minimum optimal workgroups may be different.
        // So here we set a |thresholdToIncreaseWorkgroups| to indicate whether we
        // need to increase workgroups. And the literal number is an empirical
        // value.
        const thresholdFlagValue = (0, $ibsdL.env)().getNumber('WEBGPU_THRESHOLD_TO_INCREASE_WORKGROUPS_FOR_MATMUL');
        const thresholdToIncreaseWorkgroups = thresholdFlagValue > 0 ? thresholdFlagValue : backend.thresholdToIncreaseWorkgroups;
        const workgroupsBy32x32 = batchDim * Math.ceil(outerShapeA / 32) * Math.ceil(outerShapeB / 32);
        const hasFewWorkgroups = workgroupsBy32x32 <= thresholdToIncreaseWorkgroups || outerShapeA <= 8 && workgroupsBy32x32 <= thresholdToIncreaseWorkgroups * 2;
        if (hasFewWorkgroups) {
            if (batchDim * outerShapeA * outerShapeB <= 128) matmulProgramType = (0, $9Dn6G.MatMulProgramType).MatMulReduceProgram;
            else if (batchDim === 1 && innerShapeB >= 2000) matmulProgramType = (0, $9Dn6G.MatMulProgramType).MatMulSplitKProgram;
            else matmulProgramType = (0, $9Dn6G.MatMulProgramType).MatMulSmallOutputSizeProgram;
        } else matmulProgramType = (0, $9Dn6G.MatMulProgramType).MatMulPackedProgram;
    }
    switch(matmulProgramType){
        case (0, $9Dn6G.MatMulProgramType).MatMulReduceProgram:
            program = new (0, $94yrr.MatMulReduceProgram)(outputShape, transposeA, transposeB, bias, activation, preluActivationWeights);
            break;
        case (0, $9Dn6G.MatMulProgramType).MatMulSplitKProgram:
            // The output buffer must be initailzed to zero before using since we
            // use atomicAdd in MatMulSplitKProgram.
            out = (0, $cFwkm.fill)({
                backend: backend,
                attrs: {
                    shape: outputShape,
                    value: 0,
                    dtype: a.dtype
                }
            });
            program = new (0, $02wJs.MatMulSplitKProgram)(outputShape, innerShapeB, transposeA, transposeB);
            if (bias || activation) {
                out = backend.runWebGPUProgram(program, inputs, a.dtype, dimensions, out);
                const biasActivationProgram = new (0, $02wJs.BiasActivationProgram)(out.shape, bias, activation, preluActivationWeights);
                let uniformData = null;
                const activationInputs = [
                    out
                ];
                if (bias) activationInputs.push(bias);
                if (preluActivationWeights) activationInputs.push(preluActivationWeights);
                if (activation === 'leakyrelu') {
                    uniformData = [
                        {
                            type: 'float32',
                            data: [
                                leakyreluAlpha
                            ]
                        }
                    ];
                    biasActivationProgram.uniforms += ' alpha : f32,';
                }
                const outActivated = backend.runWebGPUProgram(biasActivationProgram, activationInputs, out.dtype, uniformData);
                intermediates.push(out);
                const outReshaped = (0, $gj4T5.reshape)({
                    inputs: {
                        x: outActivated
                    },
                    backend: backend,
                    attrs: {
                        shape: outShape
                    }
                });
                intermediates.push(outActivated);
                for (const i of intermediates)backend.disposeData(i.dataId);
                return outReshaped;
            }
            break;
        case (0, $9Dn6G.MatMulProgramType).MatMulSmallOutputSizeProgram:
            program = new (0, $ix1Ig.MatMulSmallOutputSizeProgram)(a3dShape, b3dShape, outputShape, transposeA, transposeB, bias, activation, preluActivationWeights);
            break;
        case (0, $9Dn6G.MatMulProgramType).MatMulPackedProgram:
            // Experiments show that sequential access is more friendly for Intel
            // GPUs.
            const sequentialAccessByThreads = backend.adapterInfo.isIntel();
            program = new (0, $8UfUr.MatMulPackedProgram)(a3dShape, outputShape, transposeA, transposeB, bias, activation, preluActivationWeights, sequentialAccessByThreads);
            break;
        default:
            throw new Error(`Unsupported MatMulProgramType ${matmulProgramType}.`);
    }
    if (bias) inputs.push(bias);
    if (preluActivationWeights) inputs.push(preluActivationWeights);
    if (activation === 'leakyrelu') {
        dimensions.push({
            type: 'float32',
            data: [
                leakyreluAlpha
            ]
        });
        program.uniforms += ' alpha : f32,';
    }
    out = backend.runWebGPUProgram(program, inputs, a.dtype, dimensions, out);
    const outReshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    intermediates.push(out);
    for (const i of intermediates)backend.disposeData(i.dataId);
    return outReshaped;
}

});
parcelRegister("8UfUr", function(module, exports) {

$parcel$export(module.exports, "matMulReadFnSource", () => $67bfe4f74b96a4ec$export$4831bc2078546fa);
$parcel$export(module.exports, "matMulReadWriteFnSource", () => $67bfe4f74b96a4ec$export$be50c46a8ed085fb);
$parcel$export(module.exports, "makeMatMulPackedVec4Source", () => $67bfe4f74b96a4ec$export$4690dafda830f3a);
$parcel$export(module.exports, "makeMatMulPackedSource", () => $67bfe4f74b96a4ec$export$b3a48535ed1d015);
$parcel$export(module.exports, "MatMulPackedProgram", () => $67bfe4f74b96a4ec$export$21e5f112101779d8);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");

var $7t2XD = parcelRequire("7t2XD");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
function $67bfe4f74b96a4ec$export$4831bc2078546fa(transposeA, transposeB, fitAOuter = false, fitBOuter = false, fitInner = false, component = 1) {
    (0, $jjNRA).assert(transposeA && component === 1 || !transposeA, ()=>`transposeA ${transposeA} is not compatible with component size ${component}`);
    const sampleA = `
      ${transposeA ? `value = getA(batch, col, row);` : `value = getA(batch, row, col);`}

    `;
    const sampleB = transposeB ? `value = getB(batch, col, row);` : `value = getB(batch, row, col);`;
    return `
  fn mm_readA(batch: i32, row: i32, col: i32) -> ${(0, $oGQBh.typeSnippet)(component)} {
    var value = ${(0, $oGQBh.typeSnippet)(component)}(0.0);
    ${fitAOuter && fitInner ? sampleA : `
    ${transposeA ? `if(row < uniforms.dimAOuter && col < uniforms.dimInner)` : `if(row < uniforms.aShape[1] && col < uniforms.aShape[2])`}
    {
      ${sampleA}
    }
    `}
    return value;
  }

  fn mm_readB(batch: i32, row: i32, col: i32) -> ${(0, $oGQBh.typeSnippet)(component)} {
    var value = ${(0, $oGQBh.typeSnippet)(component)}(0.0);
    ${sampleB}
    return value;
  }
  `;
}
function $67bfe4f74b96a4ec$export$be50c46a8ed085fb(hasBias, activation, transposeA, transposeB, fitAOuter = false, fitBOuter = false, fitInner = false, component = 1) {
    return `
  ${$67bfe4f74b96a4ec$export$4831bc2078546fa(transposeA, transposeB, fitAOuter, fitBOuter, fitInner, component)}
  fn mm_write(batch: i32, row: i32, col: i32, valueIn: ${(0, $oGQBh.typeSnippet)(component)}) {
    ${fitAOuter && fitBOuter ? '' : 'if (row < uniforms.dimAOuter && col < uniforms.dimBOuter)'}
    {
      var value = valueIn;
      let coords = vec3<i32>(batch, row, col);
      ${(0, $7t2XD.biasActivationSnippet)(hasBias, activation)}
      setOutputAtCoords(coords[0], coords[1], coords[2], value);
    }
  }
  `;
}
const $67bfe4f74b96a4ec$var$writeDataToSubAVec4Snippet = (transpose, innerElementSize)=>{
    if (transpose) return `
        mm_Asub[inputRow][inputCol] = mm_readA(batchA,
          kStart + inputRow,
          globalRowStart + inputCol * ${innerElementSize});
        `;
    else return `
        mm_Asub[inputRow][inputCol] = mm_readA(batchA,
          globalRow + innerRow,
          kStart + inputCol * ${innerElementSize});
        `;
};
const $67bfe4f74b96a4ec$var$calculateResultSnippet = (transposeA, innerElementSize, rowPerThread, tileInner)=>{
    if (transposeA) return `
      for (var k = 0; k < ${tileInner}; k++) {
        let BCached0 = mm_Bsub[k][tileCol];
        let ACached0 = mm_Asub[k][localRow];
        for (var i = 0; i < ${rowPerThread}; i++) {
          acc[i] = fma(BCached0, vec4<f32>(ACached0[i]), acc[i]);
        }
      }`;
    else {
        let bCachedStr = '';
        let accStr = '';
        for(let i = 0; i < innerElementSize; i++){
            bCachedStr += `let BCached${i} = mm_Bsub[k * ${innerElementSize} + ${i}][tileCol];`;
            accStr += `acc[i] = fma(BCached${i}, vec4<f32>(ACached[${i}]), acc[i]);`;
        }
        return `
      for (var k = 0; k < ${tileInner / innerElementSize}; k++) {
        ${bCachedStr}
        for (var i = 0; i < ${rowPerThread}; i++) {
          let ACached = mm_Asub[tileRow + i][k];
          ${accStr}
        }
      }`;
    }
};
function $67bfe4f74b96a4ec$export$4690dafda830f3a(workPerThread, workgroupSize, transposeA = false, tileInner = 32, splitK = false, splitedDimInner = 32, broadcastBatch = false) {
    const tileAOuter = workgroupSize[1] * workPerThread[1];
    const tileBOuter = workgroupSize[0] * workPerThread[0];
    const tileAWidth = transposeA ? tileAOuter : tileInner;
    const tileAHight = transposeA ? tileInner : tileAOuter;
    const innerElementSize = tileAWidth / workgroupSize[0];
    const rowPerThreadB = tileInner / workgroupSize[1];
    const rowPerThread = workPerThread[1];
    const colPerThread = workPerThread[0];
    (0, $jjNRA).assert((transposeA && innerElementSize === 4 && workPerThread[1] === 4 || !transposeA && (innerElementSize === 3 || innerElementSize === 4)) && tileAWidth % workgroupSize[0] === 0 && tileInner % workgroupSize[1] === 0 && workPerThread[0] === 4, ()=>`If transposeA ${transposeA} is true, innerElementSize ${innerElementSize} and workPerThread[1] ${workPerThread[1]} must be 4.
          Otherwise, innerElementSize ${innerElementSize} must be 3 or 4.
      tileAWidth ${tileAWidth} must be divisible by workgroupSize[0]${workgroupSize[0]}. tileInner ${tileInner} must be divisible by workgroupSize[1] ${workgroupSize[1]}. colPerThread ${workPerThread[0]} must be 4.`);
    return `
  var<workgroup> mm_Asub : array<array<vec${innerElementSize}<f32>, ${tileAWidth / innerElementSize}>, ${tileAHight}>;
  var<workgroup> mm_Bsub : array<array<vec4<f32>, ${tileBOuter / workPerThread[0]}>, ${tileInner}>;

  ${(0, $oGQBh.getMainHeaderString)()} {
    let localRow = i32(localId.y);
    let tileRow = localRow * ${rowPerThread};
    let tileCol = i32(localId.x);

    let globalRow = i32(globalId.y) * ${rowPerThread};
    let globalCol = i32(globalId.x) * ${colPerThread};
    let batch = ${splitK ? '0' : 'i32(globalId.z)'};
    let batchA = ${splitK || !broadcastBatch ? 'batch' : 'batch % uniforms.aShape[0]'};
    let batchB = ${splitK || !broadcastBatch ? 'batch' : 'batch % uniforms.bShape[0]'};
    let globalRowStart = i32(workgroupId.y) * ${tileAOuter};

    let numTiles = ${splitK ? `${Math.ceil(splitedDimInner / tileInner)}` : `(uniforms.dimInner - 1) / ${tileInner} + 1`};
    var kStart = ${splitK ? `i32(globalId.z) * ${splitedDimInner}` : '0'};

    var acc: array<vec4<f32>, ${rowPerThread}>;

    // Loop over shared dimension.
    let tileRowB = localRow * ${rowPerThreadB};
    for (var t = 0; t < numTiles; t++) {
        // Load one tile of A into local memory.
        for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
            let inputRow = tileRow + innerRow;
            let inputCol = tileCol;
            ${$67bfe4f74b96a4ec$var$writeDataToSubAVec4Snippet(transposeA, innerElementSize)}
        }

        // Load one tile of B into local memory.
        for (var innerRow = 0; innerRow < ${rowPerThreadB}; innerRow++) {
            let inputRow = tileRowB + innerRow;
            let inputCol = tileCol;
            mm_Bsub[inputRow][inputCol] = mm_readB(batchB, kStart + inputRow, globalCol);
        }
        kStart = kStart + ${tileInner};
        workgroupBarrier();

        // Compute acc values for a single thread.
        ${$67bfe4f74b96a4ec$var$calculateResultSnippet(transposeA, innerElementSize, rowPerThread, tileInner)}
        workgroupBarrier();
    }

    for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
        mm_write(batch, globalRow + innerRow, globalCol, acc[innerRow]);
    }
  }`;
}
const $67bfe4f74b96a4ec$var$writeDataToSubASnippet = (transpose)=>{
    if (transpose) return `
        mm_Asub[inputRow][inputCol] = mm_readA(batchA,
          kStart + inputRow,
          globalRowStart + inputCol);
        `;
    else return `
        mm_Asub[inputRow][inputCol] = mm_readA(batchA,
          globalRowStart + inputRow,
          kStart + inputCol);
        `;
};
const $67bfe4f74b96a4ec$var$readDataFromSubASnippet = (transposeA)=>{
    return transposeA ? 'let ACached = mm_Asub[k][tileRow + innerRow];' : 'let ACached = mm_Asub[tileRow + innerRow][k];';
};
function $67bfe4f74b96a4ec$export$b3a48535ed1d015(workPerThread, workgroupSize, transposeA = false, tileInner = 32, splitK = false, splitedDimInner = 32, sequentialAccessByThreads = false, broadcastBatch = false) {
    const tileAOuter = workPerThread[1] * workgroupSize[1];
    const tileBOuter = workPerThread[0] * workgroupSize[0];
    const tileAWidth = transposeA ? tileAOuter : tileInner;
    const tileAHight = transposeA ? tileInner : tileAOuter;
    (0, $jjNRA).assert(tileAHight % workgroupSize[1] === 0 && tileAWidth % workgroupSize[0] === 0 && tileInner % workgroupSize[1] === 0, ()=>`tileAHight ${tileAHight} must be divisible by workgroupSize[1]${workgroupSize[1]}, tileAWidth ${tileAWidth} must be divisible by workgroupSize[0]${workgroupSize[0]}, tileInner ${tileInner} must be divisible by workgroupSize[1]${workgroupSize[1]}`);
    const rowPerThreadA = tileAHight / workgroupSize[1];
    const colPerThreadA = tileAWidth / workgroupSize[0];
    const rowPerThreadB = tileInner / workgroupSize[1];
    const rowPerThread = workPerThread[1];
    const colPerThread = workPerThread[0];
    const matmulSnippet = sequentialAccessByThreads ? `
      let localRow = i32(localId.y);
      let localCol = i32(localId.x);
      let globalRowStart = i32(workgroupId.y) * ${tileAOuter};
      let globalColStart = i32(workgroupId.x) * ${tileBOuter};

      // Loop over shared dimension.
      for (var t = 0; t < numTiles; t++) {
        // Load one tile of A into local memory.
        for (var inputRow = localRow; inputRow < ${tileAHight}; inputRow = inputRow + ${workgroupSize[1]}) {
          for (var inputCol = localCol; inputCol < ${tileAWidth}; inputCol = inputCol + ${workgroupSize[0]}) {
            ${$67bfe4f74b96a4ec$var$writeDataToSubASnippet(transposeA)}
          }
        }
        // Load one tile of B into local memory.
        for (var inputRow = localRow; inputRow < ${tileInner}; inputRow = inputRow + ${workgroupSize[1]}) {
              for (var inputCol = localCol; inputCol < ${tileBOuter}; inputCol = inputCol + ${workgroupSize[0]}) {
            mm_Bsub[inputRow][inputCol] = mm_readB(batchB,
              kStart + inputRow,
              globalColStart + inputCol);
          }
        }
        kStart = kStart + ${tileInner};
        workgroupBarrier();

        // Compute acc values for a single thread.
        var BCached : array<f32, ${colPerThread}>;
        for (var k = 0; k < ${tileInner}; k++) {
          for (var inner = 0; inner < ${colPerThread}; inner++) {
            BCached[inner] = mm_Bsub[k][localCol + inner * ${workgroupSize[0]}];
          }
          for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
            let ACached = ${transposeA ? `mm_Asub[k][localRow + innerRow * ${workgroupSize[1]}];` : `mm_Asub[localRow + innerRow * ${workgroupSize[1]}][k];`}
            for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
              acc[innerRow][innerCol] =
                  fma(ACached, BCached[innerCol], acc[innerRow][innerCol]);
            }
          }
        }
        workgroupBarrier();
      }
      for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
        let gRow = globalRowStart + localRow + innerRow * ${workgroupSize[1]};
        for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
          let gCol = globalColStart + localCol + innerCol * ${workgroupSize[0]};
          mm_write(batch, gRow, gCol, acc[innerRow][innerCol]);
        }
      }
      ` : `
  let tileRow = i32(localId.y) * ${rowPerThread};
  let tileCol = i32(localId.x) * ${colPerThread};

  let globalRow = i32(globalId.y) * ${rowPerThread};
  let globalCol = i32(globalId.x) * ${colPerThread};
  let globalRowStart = i32(workgroupId.y) * ${tileAOuter};

  let tileRowA = i32(localId.y) * ${rowPerThreadA};
  let tileColA = i32(localId.x) * ${colPerThreadA};
  let tileRowB = i32(localId.y) * ${rowPerThreadB};
  // Loop over shared dimension.
  for (var t = 0; t < numTiles; t++) {
    // Load one tile of A into local memory.
    for (var innerRow = 0; innerRow < ${rowPerThreadA}; innerRow++) {
      for (var innerCol = 0; innerCol < ${colPerThreadA}; innerCol++) {
        let inputRow = tileRowA + innerRow;
        let inputCol = tileColA + innerCol;
        ${$67bfe4f74b96a4ec$var$writeDataToSubASnippet(transposeA)}
      }
    }

    // Load one tile of B into local memory.
    for (var innerRow = 0; innerRow < ${rowPerThreadB}; innerRow++) {
      for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
        let inputRow = tileRowB + innerRow;
        let inputCol = tileCol + innerCol;
        mm_Bsub[inputRow][inputCol] = mm_readB(batchB,
          kStart + inputRow,
          globalCol + innerCol);
      }
    }
    kStart = kStart + ${tileInner};
    workgroupBarrier();

    // Compute acc values for a single thread.
    var BCached : array<f32, ${colPerThread}>;
    for (var k = 0; k < ${tileInner}; k++) {
      for (var inner = 0; inner < ${colPerThread}; inner++) {
        BCached[inner] = mm_Bsub[k][tileCol + inner];
      }

      for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
        ${$67bfe4f74b96a4ec$var$readDataFromSubASnippet(transposeA)}
        for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
          acc[innerRow][innerCol] =
              fma(ACached, BCached[innerCol], acc[innerRow][innerCol]);
        }
      }
    }

    workgroupBarrier();
  }

  for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
    for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
      mm_write(batch, globalRow + innerRow, globalCol + innerCol,
          acc[innerRow][innerCol]);
    }
  }
  `;
    return `
    var<workgroup> mm_Asub : array<array<f32, ${tileAWidth}>, ${tileAHight}>;
    var<workgroup> mm_Bsub : array<array<f32, ${tileBOuter}>, ${tileInner}>;

    ${(0, $oGQBh.getMainHeaderString)()} {
      let batch = ${splitK ? '0' : 'i32(globalId.z)'};
      let batchA = ${splitK || !broadcastBatch ? 'batch' : 'batch % uniforms.aShape[0]'};
      let batchB = ${splitK || !broadcastBatch ? 'batch' : 'batch % uniforms.bShape[0]'};
      let numTiles = ${splitK ? `${Math.ceil(splitedDimInner / tileInner)}` : `(uniforms.dimInner - 1) / ${tileInner} + 1`};
      var kStart = ${splitK ? `i32(globalId.z) * ${splitedDimInner}` : '0'};

      var acc : array<array<f32, ${colPerThread}>, ${rowPerThread}>;

      // Without this initialization strange values show up in acc.
      for (var innerRow = 0; innerRow < ${rowPerThread}; innerRow++) {
        for (var innerCol = 0; innerCol < ${colPerThread}; innerCol++) {
          acc[innerRow][innerCol] = 0.0;
        }
      }
      ${matmulSnippet}
    }
  `;
}
const $67bfe4f74b96a4ec$var$readVectorASnippet = (transpose)=>{
    return transpose ? `
      mm_readA(batchA, colA, globalRow),
      mm_readA(batchA, colA + 1, globalRow),
      mm_readA(batchA, colA + 2, globalRow),
      mm_readA(batchA, colA + 3, globalRow)
  ` : `
      mm_readA(batchA, globalRow, colA),
      mm_readA(batchA, globalRow, colA + 1),
      mm_readA(batchA, globalRow, colA + 2),
      mm_readA(batchA, globalRow, colA + 3)
  `;
};
function $67bfe4f74b96a4ec$export$7f5627c650f57947(workgroupSize, transposeA = false) {
    (0, $jjNRA).assert(workgroupSize[1] === 1 && workgroupSize[2] === 1, ()=>`A linear work group size is required. But got ${workgroupSize}.`);
    const tileSize = workgroupSize[0] * 4;
    return `
    var<workgroup> mm_Asub : array<vec4<f32>, ${workgroupSize[0]}>;

    ${(0, $oGQBh.getMainHeaderString)()} {
      let tileCol = i32(localId.x);
      let globalCol = i32(globalId.x);
      let globalRow = i32(globalId.y);

      let numTiles = (uniforms.dimInner - 1) / ${tileSize} + 1;
      let batch = i32(globalId.z);
      let batchA = batch % uniforms.aShape[0];
      let batchB = batch % uniforms.bShape[0];
      // Without this initialization strange values show up in acc.
      var acc = 0.0;

      // Loop over shared dimension.
      for (var t = 0; t < numTiles; t++) {
        // Load one tile of A into local memory.
        let colA = t * ${tileSize} + tileCol * 4;
        mm_Asub[tileCol] = vec4<f32>(${$67bfe4f74b96a4ec$var$readVectorASnippet(transposeA)});
        workgroupBarrier();

        // Compute acc values for a single thread.
        for (var k = 0; k < ${tileSize / 4}; k++) {
          let rowB = t * ${tileSize} + k * 4;
          let BCached = vec4<f32>(mm_readB(batchB, rowB, globalCol),
                              mm_readB(batchB, rowB + 1, globalCol),
                              mm_readB(batchB, rowB + 2, globalCol),
                              mm_readB(batchB, rowB + 3, globalCol));

          let ACached = mm_Asub[k];
          acc = acc + dot(ACached, BCached);
        }

        workgroupBarrier();
      }

      mm_write(batch, globalRow, globalCol, acc);
    }
  `;
}
class $67bfe4f74b96a4ec$export$21e5f112101779d8 {
    constructor(aShape, outputShape, transposeA = false, transposeB = false, bias = null, activation = null, preluActivationWeights = null, sequentialAccessByThreads = false){
        this.variableNames = [
            'A',
            'B'
        ];
        this.uniforms = `dimAOuter : i32, dimBOuter : i32, dimInner : i32,`;
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [
                2
            ],
            y: [
                1
            ],
            z: [
                0
            ]
        };
        const dimInner = transposeA ? aShape[1] : aShape[2];
        this.isVec4 = (dimInner % 4 === 0 && !transposeA || outputShape[1] % 4 === 0 && transposeA) && outputShape[2] % 4 === 0 && !transposeB;
        this.outputComponent = this.isVec4 ? 4 : 1;
        this.isVectorA = outputShape[1] === 1 && !transposeA;
        if (!this.isVec4 && this.isVectorA) {
            // For makeVectorMatrixProductSource
            this.elementsPerThread = [
                1,
                1,
                1
            ];
            this.workgroupSize = [
                32,
                1,
                1
            ];
        } else {
            const workgroupInfo = (0, $9Dn6G.computeWorkgroupInfoForMatMul)(outputShape[1], dimInner, outputShape[2], transposeA);
            this.workgroupSize = workgroupInfo.workgroupSize;
            this.elementsPerThread = workgroupInfo.elementsPerThread;
        }
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, this.elementsPerThread);
        const addBias = bias != null;
        const hasPreluActivationWeights = preluActivationWeights != null;
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        this.sequentialAccessByThreads = sequentialAccessByThreads;
        this.transposeA = transposeA;
        this.transposeB = transposeB;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivationWeights = hasPreluActivationWeights;
        [this.fitAOuter, this.fitBOuter, this.fitInner] = this.getShapeFit(outputShape[1], outputShape[2], dimInner);
        this.shaderKey = `matMulPacked_${this.elementsPerThread}_${transposeA}_${transposeB}_${this.activation}_${this.fitAOuter}_${this.fitBOuter}_${this.fitInner}_${this.isVec4}_${this.isVectorA}_${this.sequentialAccessByThreads}`;
    }
    getShapeFit(dimAOuter, dimBOuter, dimInner) {
        const tileAOuter = this.workgroupSize[1] * this.elementsPerThread[1];
        const tileBOuter = this.workgroupSize[0] * this.elementsPerThread[0];
        if (!this.isVec4 && this.isVectorA) // For makeVectorMatrixProductSource
        this.tileInner = this.workgroupSize[0] * 4;
        else this.tileInner = tileBOuter;
        const fitAOuter = dimAOuter % tileAOuter === 0;
        const fitBOuter = dimBOuter % tileBOuter === 0;
        const fitInner = dimInner % this.tileInner === 0;
        return [
            fitAOuter,
            fitBOuter,
            fitInner
        ];
    }
    getUserCode() {
        const userCode = `
      ${(0, $7t2XD.activationFnSnippet)(this.activation, this.hasPreluActivationWeights, this.isVec4)}
      ${$67bfe4f74b96a4ec$export$be50c46a8ed085fb(this.addBias, this.activation, false, this.transposeB, this.fitAOuter, this.fitBOuter, this.fitInner, this.isVec4 ? 4 : 1)}
      ${this.isVec4 ? $67bfe4f74b96a4ec$export$4690dafda830f3a(this.elementsPerThread, this.workgroupSize, this.transposeA, this.tileInner, false, null, true) : this.isVectorA ? $67bfe4f74b96a4ec$export$7f5627c650f57947(this.workgroupSize, this.transposeA) : $67bfe4f74b96a4ec$export$b3a48535ed1d015(this.elementsPerThread, this.workgroupSize, this.transposeA, this.tileInner, false, null, this.sequentialAccessByThreads, true)}
    `;
        return userCode;
    }
}

});
parcelRegister("7t2XD", function(module, exports) {

$parcel$export(module.exports, "activationFnSnippet", () => $56fd89cd25e06ead$export$f79ce230bc90dd9f);
$parcel$export(module.exports, "biasActivationSnippet", () => $56fd89cd25e06ead$export$9766e8742a87dc55);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jJAz1 = parcelRequire("jJAz1");

var $8Y5Lq = parcelRequire("8Y5Lq");

var $oGQBh = parcelRequire("oGQBh");
function $56fd89cd25e06ead$export$f79ce230bc90dd9f(activation, hasPreluActivationWeights = false, packed = false, coordsLength = 3) {
    if (activation === null) return '';
    let activationOpSnippet = '';
    if (activation === 'linear') activationOpSnippet = (0, $8Y5Lq.getUnaryOpString)((0, $8Y5Lq.UnaryOpType).LINEAR);
    else if (activation === 'relu') activationOpSnippet = (0, $8Y5Lq.getUnaryOpString)((0, $8Y5Lq.UnaryOpType).RELU, packed);
    else if (activation === 'elu') activationOpSnippet = (0, $8Y5Lq.getUnaryOpString)((0, $8Y5Lq.UnaryOpType).ELU, packed);
    else if (activation === 'relu6') activationOpSnippet = (0, $8Y5Lq.getUnaryOpString)((0, $8Y5Lq.UnaryOpType).RELU6, packed);
    else if (activation === 'prelu') activationOpSnippet = (0, $jJAz1.getBinaryOpString)((0, $jJAz1.BinaryOpType).PRELU, packed);
    else if (activation === 'sigmoid') activationOpSnippet = (0, $8Y5Lq.getUnaryOpString)((0, $8Y5Lq.UnaryOpType).SIGMOID, packed);
    else if (activation === 'leakyrelu') activationOpSnippet = (0, $8Y5Lq.getUnaryOpString)((0, $8Y5Lq.UnaryOpType).LEAKYRELU, packed);
    else throw new Error(`Activation ${activation} has not been implemented for the WebGPU backend.`);
    const elementSize = packed ? 4 : 1;
    const dataType = (0, $oGQBh.typeSnippet)(elementSize);
    let activationFnSnippet1 = '';
    if (hasPreluActivationWeights) activationFnSnippet1 = `
      fn activation(a : ${dataType}, coords : vec${coordsLength}<i32>) -> ${dataType} {
        let b = getPreluActivationWeightsByOutputCoords(coords);
        ${activationOpSnippet}
      }`;
    else activationFnSnippet1 = `
      fn activation(a : ${dataType}, coords : vec${coordsLength}<i32>) -> ${dataType} {
        ${activationOpSnippet}
      }`;
    return activationFnSnippet1;
}
function $56fd89cd25e06ead$export$9766e8742a87dc55(hasBias, activation) {
    return `
      ${hasBias ? 'value = value + getBiasByOutputCoords(coords);' : ''}
      ${activation ? 'value = activation(value, coords);' : ''}
      `;
}

});
parcelRegister("jJAz1", function(module, exports) {

$parcel$export(module.exports, "BinaryOpType", () => $e5de951844bc8501$export$e5d009af261ea0bd);
$parcel$export(module.exports, "getBinaryOpString", () => $e5de951844bc8501$export$20c350df8f4933ab);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $e5de951844bc8501$export$e5d009af261ea0bd;
(function(BinaryOpType) {
    BinaryOpType[BinaryOpType["ADD"] = 0] = "ADD";
    BinaryOpType[BinaryOpType["ATAN2"] = 1] = "ATAN2";
    BinaryOpType[BinaryOpType["COMPLEX_MULTIPLY_IMAG"] = 2] = "COMPLEX_MULTIPLY_IMAG";
    BinaryOpType[BinaryOpType["COMPLEX_MULTIPLY_REAL"] = 3] = "COMPLEX_MULTIPLY_REAL";
    BinaryOpType[BinaryOpType["DIV"] = 4] = "DIV";
    BinaryOpType[BinaryOpType["ELU_DER"] = 5] = "ELU_DER";
    BinaryOpType[BinaryOpType["EQUAL"] = 6] = "EQUAL";
    BinaryOpType[BinaryOpType["FLOOR_DIV"] = 7] = "FLOOR_DIV";
    BinaryOpType[BinaryOpType["GREATER"] = 8] = "GREATER";
    BinaryOpType[BinaryOpType["GREATER_EQUAL"] = 9] = "GREATER_EQUAL";
    BinaryOpType[BinaryOpType["LESS"] = 10] = "LESS";
    BinaryOpType[BinaryOpType["LESS_EQUAL"] = 11] = "LESS_EQUAL";
    BinaryOpType[BinaryOpType["LOGICAL_AND"] = 12] = "LOGICAL_AND";
    BinaryOpType[BinaryOpType["LOGICAL_OR"] = 13] = "LOGICAL_OR";
    BinaryOpType[BinaryOpType["MAX"] = 14] = "MAX";
    BinaryOpType[BinaryOpType["MIN"] = 15] = "MIN";
    BinaryOpType[BinaryOpType["MOD"] = 16] = "MOD";
    BinaryOpType[BinaryOpType["MUL"] = 17] = "MUL";
    BinaryOpType[BinaryOpType["NOT_EQUAL"] = 18] = "NOT_EQUAL";
    BinaryOpType[BinaryOpType["POW"] = 19] = "POW";
    BinaryOpType[BinaryOpType["PRELU"] = 20] = "PRELU";
    BinaryOpType[BinaryOpType["SQUARED_DIFFERENCE"] = 21] = "SQUARED_DIFFERENCE";
    BinaryOpType[BinaryOpType["SUB"] = 22] = "SUB";
})($e5de951844bc8501$export$e5d009af261ea0bd || ($e5de951844bc8501$export$e5d009af261ea0bd = {}));
const $e5de951844bc8501$var$ADD = 'let resultTemp = a + b;';
const $e5de951844bc8501$var$ATAN2 = 'let resultTemp = atan2(a, b);';
// (Ar + Ai)(Br + Bi) =
// ArBr + ArBi + AiBr + AiBi = ArBr - AB + ArBi + AiBr
// Yr = ArBr - AB
// Yi = ArBi + AiBr
const $e5de951844bc8501$var$COMPLEX_MULTIPLY_REAL = 'let resultTemp = areal * breal - aimag * bimag;';
const $e5de951844bc8501$var$COMPLEX_MULTIPLY_IMAG = 'let resultTemp = areal * bimag + aimag * breal;';
const $e5de951844bc8501$var$DIV = 'let resultTemp = a / b;';
const $e5de951844bc8501$var$ELU_DER = 'let resultTemp = select(a * (b + 1.0), a, b >= b - b);';
const $e5de951844bc8501$var$EQUAL = `
  let zero = sign(a) * 0 + 0;
  let one = sign(b) * 0 + 1;
  let resultTemp = select(zero, one, a == b);
`;
const $e5de951844bc8501$var$FLOOR_DIV = `
  let remainder =
      select(a % b, round(a % b), (round(a) == a) & (round(b) == b));
  let quotient = (a - remainder) / b;
  let resultTemp =
      round(select(quotient, quotient - 1, sign(remainder) == -sign(b)));
`;
const $e5de951844bc8501$var$GREATER = `
  let zero = sign(a) * 0 + 0;
  let one = sign(b) * 0 + 1;
  let resultTemp = select(zero, one, a > b);
`;
const $e5de951844bc8501$var$GREATER_EQUAL = `
  let zero = sign(a) * 0 + 0;
  let one = sign(b) * 0 + 1;
  let resultTemp = select(zero, one, a >= b);
`;
const $e5de951844bc8501$var$LESS = `
  let zero = sign(a) * 0 + 0;
  let one = sign(b) * 0 + 1;
  let resultTemp = select(zero, one, a < b);
`;
const $e5de951844bc8501$var$LESS_EQUAL = `
  let zero = sign(a) * 0 + 0;
  let one = sign(b) * 0 + 1;
  let resultTemp = select(zero, one, a <= b);
`;
const $e5de951844bc8501$var$LOGICAL_AND = 'return f32(a >= 1.0 && b >= 1.0);';
const $e5de951844bc8501$var$LOGICAL_AND_VEC4 = `return (vec4<f32>(a >= vec4<f32>(1.0)) *
  vec4<f32>(b >= vec4<f32>(1.0)));`;
const $e5de951844bc8501$var$LOGICAL_OR = 'return f32(a >= 1.0 || b >= 1.0);';
const $e5de951844bc8501$var$LOGICAL_OR_VEC4 = `return min(vec4<f32>(a >= vec4<f32>(1.0)) +
  vec4<f32>(b >= vec4<f32>(1.0)), vec4<f32>(1.0));`;
const $e5de951844bc8501$var$MAX = 'let resultTemp = max(a, b);';
const $e5de951844bc8501$var$MIN = 'let resultTemp = min(a, b);';
const $e5de951844bc8501$var$MOD = `
  let isNaN = b == 0.;
  var resultTemp = a % b;
  resultTemp = select((resultTemp + b) % b, resultTemp,
      (a < 0. && b < 0.) || (a >= 0. && b > 0.));
`;
const $e5de951844bc8501$var$MOD_VEC4 = `
  let isNaN = !vec4<bool>(b);
  var resultTemp = vec4<f32>(a % b);
  if (!((a[0] < 0. && b[0] < 0.) || (a[0] >= 0. && b[0] > 0.))) {
    resultTemp[0] = (resultTemp[0] + b[0]) % b[0];
  }
  if (!((a[1] < 0. && b[1] < 0.) || (a[1] >= 0. && b[1] > 0.))) {
    resultTemp[1] = (resultTemp[1] + b[1]) % b[1];
  }
  if (!((a[2] < 0. && b[2] < 0.) || (a[2] >= 0. && b[2] > 0.))) {
    resultTemp[2] = (resultTemp[2] + b[2]) % b[2];
  }
  if (!((a[3] < 0. && b[3] < 0.) || (a[3] >= 0. && b[3] > 0.))) {
    resultTemp[3] = (resultTemp[3] + b[3]) % b[3];
  }
`;
const $e5de951844bc8501$var$MUL = 'let resultTemp = a * b;';
const $e5de951844bc8501$var$NOT_EQUAL = `
  var resultTemp = f32(a != b);
  let valueForNaN = 1.0;
`;
const $e5de951844bc8501$var$NOT_EQUAL_VEC4 = `
  var resultTemp = vec4<f32>(a != b);
  let valueForNaN = 1.0;
`;
const $e5de951844bc8501$var$POW = `
  let isNaN = a < 0.0 && floor(b) < b;
  if (b == 0.0) {
    return 1.0;
  }
  var resultTemp = select(sign(a) * pow(abs(a), b), pow(abs(a), b),
      round(abs(b) % 2.0) != 1.0);
`;
const $e5de951844bc8501$var$POW_VEC4 = `
  let isModRound1Bool = vec4<i32>(round(abs(b) % vec4<f32>(2.0))) == vec4<i32>(1);
  let isModRound1 = vec4<f32>(isModRound1Bool);
  let multiplier = sign(a) * isModRound1 + (vec4<f32>(1.0) - isModRound1);
  var resultTemp = multiplier * pow(abs(a), b);

  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS
  let isExpZero = b == vec4<f32>(0.0);
  if (isExpZero.r) {
    resultTemp.r = 1.0;
  }
  if (isExpZero.g) {
    resultTemp.g = 1.0;
  }
  if (isExpZero.b) {
    resultTemp.b = 1.0;
  }
  if (isExpZero.a) {
    resultTemp.a = 1.0;
  }
  let isNaN = (a < vec4<f32>(0.0)) & (floor(b) < b);
`;
const $e5de951844bc8501$var$PRELU = `if (a < 0.0) { return b * a; }  return a;`;
const $e5de951844bc8501$var$PRELU_VEC4 = `
  let aLessThanZero = vec4<f32>(a < vec4<f32>(0.0));
  return (aLessThanZero * (b * a)) + ((vec4<f32>(1.0) - aLessThanZero) * a);
`;
const $e5de951844bc8501$var$SQUARED_DIFFERENCE = 'let resultTemp = (a - b) * (a - b);';
const $e5de951844bc8501$var$SUB = 'let resultTemp = a - b;';
function $e5de951844bc8501$export$20c350df8f4933ab(type, useVec4) {
    let doOpSnippet;
    // Ops with NaN check
    do {
        switch(type){
            case $e5de951844bc8501$export$e5d009af261ea0bd.ATAN2:
                doOpSnippet = $e5de951844bc8501$var$ATAN2;
                break;
            case $e5de951844bc8501$export$e5d009af261ea0bd.MAX:
                doOpSnippet = $e5de951844bc8501$var$MAX;
                break;
            case $e5de951844bc8501$export$e5d009af261ea0bd.MIN:
                doOpSnippet = $e5de951844bc8501$var$MIN;
                break;
            case $e5de951844bc8501$export$e5d009af261ea0bd.MOD:
                doOpSnippet = useVec4 ? $e5de951844bc8501$var$MOD_VEC4 : $e5de951844bc8501$var$MOD;
                break;
            case $e5de951844bc8501$export$e5d009af261ea0bd.NOT_EQUAL:
                doOpSnippet = useVec4 ? $e5de951844bc8501$var$NOT_EQUAL_VEC4 : $e5de951844bc8501$var$NOT_EQUAL;
                break;
            case $e5de951844bc8501$export$e5d009af261ea0bd.POW:
                doOpSnippet = useVec4 ? $e5de951844bc8501$var$POW_VEC4 : $e5de951844bc8501$var$POW;
                break;
            default:
                continue;
        }
        let isNaN;
        let dTypeN;
        let boolN;
        if (useVec4) {
            isNaN = 'isnanVec4';
            dTypeN = 'vec4<f32>';
            boolN = 'vec4<bool>';
        } else {
            isNaN = 'isnan';
            dTypeN = 'f32';
            boolN = 'bool';
        }
        return `
      let aIsNaN = ${isNaN}(a);
      let aPostLegalization = select(a, ${dTypeN}(42), aIsNaN);
      let bIsNaN = ${isNaN}(b);
      let bPostLegalization = select(b, ${dTypeN}(42), bIsNaN);
      let isNaN = false;
      let valueForNaN = uniforms.NAN;
      {
        let a = aPostLegalization;
        let b = bPostLegalization;
        ${doOpSnippet}
        return select(
            resultTemp, ${dTypeN}(valueForNaN),
            ${boolN}(isNaN) | aIsNaN | bIsNaN);
      }
    `;
    }while (false);
    // Ops without NaN check
    switch(type){
        case $e5de951844bc8501$export$e5d009af261ea0bd.ADD:
            doOpSnippet = $e5de951844bc8501$var$ADD;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.COMPLEX_MULTIPLY_IMAG:
            doOpSnippet = $e5de951844bc8501$var$COMPLEX_MULTIPLY_IMAG;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.COMPLEX_MULTIPLY_REAL:
            doOpSnippet = $e5de951844bc8501$var$COMPLEX_MULTIPLY_REAL;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.DIV:
            doOpSnippet = $e5de951844bc8501$var$DIV;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.ELU_DER:
            doOpSnippet = $e5de951844bc8501$var$ELU_DER;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.EQUAL:
            doOpSnippet = $e5de951844bc8501$var$EQUAL;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.FLOOR_DIV:
            doOpSnippet = $e5de951844bc8501$var$FLOOR_DIV;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.GREATER:
            doOpSnippet = $e5de951844bc8501$var$GREATER;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.GREATER_EQUAL:
            doOpSnippet = $e5de951844bc8501$var$GREATER_EQUAL;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.LESS:
            doOpSnippet = $e5de951844bc8501$var$LESS;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.LESS_EQUAL:
            doOpSnippet = $e5de951844bc8501$var$LESS_EQUAL;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.LOGICAL_AND:
            return useVec4 ? $e5de951844bc8501$var$LOGICAL_AND_VEC4 : $e5de951844bc8501$var$LOGICAL_AND;
        case $e5de951844bc8501$export$e5d009af261ea0bd.LOGICAL_OR:
            return useVec4 ? $e5de951844bc8501$var$LOGICAL_OR_VEC4 : $e5de951844bc8501$var$LOGICAL_OR;
        case $e5de951844bc8501$export$e5d009af261ea0bd.MUL:
            doOpSnippet = $e5de951844bc8501$var$MUL;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.PRELU:
            return useVec4 ? $e5de951844bc8501$var$PRELU_VEC4 : $e5de951844bc8501$var$PRELU;
        case $e5de951844bc8501$export$e5d009af261ea0bd.SQUARED_DIFFERENCE:
            doOpSnippet = $e5de951844bc8501$var$SQUARED_DIFFERENCE;
            break;
        case $e5de951844bc8501$export$e5d009af261ea0bd.SUB:
            doOpSnippet = $e5de951844bc8501$var$SUB;
            break;
        default:
    }
    return `
    ${doOpSnippet}
    return resultTemp;
  `;
}

});

parcelRegister("8Y5Lq", function(module, exports) {

$parcel$export(module.exports, "UnaryOpType", () => $687865e752d42598$export$5adefdb0f928033b);
$parcel$export(module.exports, "getUnaryOpString", () => $687865e752d42598$export$bf824beefaa2c9b9);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $687865e752d42598$export$5adefdb0f928033b;
(function(UnaryOpType) {
    UnaryOpType[UnaryOpType["ABS"] = 0] = "ABS";
    UnaryOpType[UnaryOpType["ACOS"] = 1] = "ACOS";
    UnaryOpType[UnaryOpType["ACOSH"] = 2] = "ACOSH";
    UnaryOpType[UnaryOpType["ASIN"] = 3] = "ASIN";
    UnaryOpType[UnaryOpType["ASINH"] = 4] = "ASINH";
    UnaryOpType[UnaryOpType["ATAN"] = 5] = "ATAN";
    UnaryOpType[UnaryOpType["ATANH"] = 6] = "ATANH";
    UnaryOpType[UnaryOpType["CEIL"] = 7] = "CEIL";
    UnaryOpType[UnaryOpType["COS"] = 8] = "COS";
    UnaryOpType[UnaryOpType["COSH"] = 9] = "COSH";
    UnaryOpType[UnaryOpType["ELU"] = 10] = "ELU";
    UnaryOpType[UnaryOpType["ERF"] = 11] = "ERF";
    UnaryOpType[UnaryOpType["EXP"] = 12] = "EXP";
    UnaryOpType[UnaryOpType["EXPM1"] = 13] = "EXPM1";
    UnaryOpType[UnaryOpType["FLOOR"] = 14] = "FLOOR";
    UnaryOpType[UnaryOpType["IS_FINITE"] = 15] = "IS_FINITE";
    UnaryOpType[UnaryOpType["IS_INF"] = 16] = "IS_INF";
    UnaryOpType[UnaryOpType["IS_NAN"] = 17] = "IS_NAN";
    UnaryOpType[UnaryOpType["LINEAR"] = 18] = "LINEAR";
    UnaryOpType[UnaryOpType["LOG"] = 19] = "LOG";
    UnaryOpType[UnaryOpType["LOG1P"] = 20] = "LOG1P";
    UnaryOpType[UnaryOpType["LOGICAL_NOT"] = 21] = "LOGICAL_NOT";
    UnaryOpType[UnaryOpType["NEG"] = 22] = "NEG";
    UnaryOpType[UnaryOpType["RELU"] = 23] = "RELU";
    UnaryOpType[UnaryOpType["RELU6"] = 24] = "RELU6";
    UnaryOpType[UnaryOpType["LEAKYRELU"] = 25] = "LEAKYRELU";
    UnaryOpType[UnaryOpType["RECIPROCAL"] = 26] = "RECIPROCAL";
    UnaryOpType[UnaryOpType["ROUND"] = 27] = "ROUND";
    UnaryOpType[UnaryOpType["RSQRT"] = 28] = "RSQRT";
    UnaryOpType[UnaryOpType["SELU"] = 29] = "SELU";
    UnaryOpType[UnaryOpType["SIGMOID"] = 30] = "SIGMOID";
    UnaryOpType[UnaryOpType["SIGN"] = 31] = "SIGN";
    UnaryOpType[UnaryOpType["SIN"] = 32] = "SIN";
    UnaryOpType[UnaryOpType["SINH"] = 33] = "SINH";
    UnaryOpType[UnaryOpType["SOFTPLUS"] = 34] = "SOFTPLUS";
    UnaryOpType[UnaryOpType["SQRT"] = 35] = "SQRT";
    UnaryOpType[UnaryOpType["SQUARE"] = 36] = "SQUARE";
    UnaryOpType[UnaryOpType["STEP"] = 37] = "STEP";
    UnaryOpType[UnaryOpType["TAN"] = 38] = "TAN";
    UnaryOpType[UnaryOpType["TANH"] = 39] = "TANH";
    UnaryOpType[UnaryOpType["TO_INT"] = 40] = "TO_INT";
})($687865e752d42598$export$5adefdb0f928033b || ($687865e752d42598$export$5adefdb0f928033b = {}));
const $687865e752d42598$var$ABS = `return abs(a);`;
const $687865e752d42598$var$ACOS = `
  if (abs(a) > 1.) {
    return uniforms.NAN;
  }
  return acos(a);
`;
const $687865e752d42598$var$ACOSH = `
  if (a < 1.) {
    return uniforms.NAN;
  }
  return acosh(a);
`;
const $687865e752d42598$var$ASIN = `
  if (abs(a) > 1.) {
    return uniforms.NAN;
  }
  return asin(a);
`;
const $687865e752d42598$var$ASINH = `return asinh(a);`;
const $687865e752d42598$var$ATAN = `
  if (isnan(a)) {
    return uniforms.NAN;
  }
  return atan(a);
`;
const $687865e752d42598$var$ATANH = `
  if (abs(a) > 1.) {
    return uniforms.NAN;
  }
  if (a == 1.) {
    return uniforms.INFINITY;
  }
  if (a == -1.) {
    return -uniforms.INFINITY;
  }
  return atanh(a);
`;
const $687865e752d42598$var$CEIL = `return ceil(a);`;
const $687865e752d42598$var$COS = `return cos(a);`;
const $687865e752d42598$var$COSH = `
  let e2x = exp(-a);
  return (e2x + 1.0 / e2x) / 2.0;
`;
const $687865e752d42598$var$EXPM1 = `return exp(a) - 1.0;`;
const $687865e752d42598$var$ELU = `if (a >= 0.0) { return a; }  return (exp(a) - 1.0);`;
const $687865e752d42598$var$ELU_VEC4 = `
  var resFloat = exp(a) - vec4<f32>(1.0);
  if (a.r >= 0.0) {
    resFloat.r = a.r;
  }
  if (a.g >= 0.0) {
    resFloat.g = a.g;
  }
  if (a.b >= 0.0) {
    resFloat.b = a.b;
  }
  if (a.a >= 0.0) {
    resFloat.a = a.a;
  }
  return resFloat;
`;
const $687865e752d42598$var$ERF = `
  // Error function is calculated approximately with elementary function.
  // See "Handbook of Mathematical Functions with Formulas,
  // Graphs, and Mathematical Tables", Abramowitz and Stegun.
  let p = ${(0, $7MaPk).ERF_P};
  let a1 = ${(0, $7MaPk).ERF_A1};
  let a2 = ${(0, $7MaPk).ERF_A2};
  let a3 = ${(0, $7MaPk).ERF_A3};
  let a4 = ${(0, $7MaPk).ERF_A4};
  let a5 = ${(0, $7MaPk).ERF_A5};

  let sign = sign(a);
  let absA = abs(a);
  let t = 1.0 / (1.0 + p * absA);
  return sign * (1.0 - (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t * exp(-absA * absA));
`;
const $687865e752d42598$var$EXP = `return exp(a);`;
const $687865e752d42598$var$FLOOR = `return floor(a);`;
const $687865e752d42598$var$IS_FINITE = `return f32(!isnan(a) && !isinf(a));`;
const $687865e752d42598$var$IS_INF = `return f32(isinf(a));`;
const $687865e752d42598$var$IS_NAN = `return f32(isnan(a));`;
const $687865e752d42598$var$LINEAR = `return a;`;
const $687865e752d42598$var$LOG = `if (a < 0.0) { return uniforms.NAN; }
  return log(a);`;
const $687865e752d42598$var$LOG1P = `
  if (isnan(a)) { return a; }
  return log(1.0 + a);
`;
const $687865e752d42598$var$LOGICAL_NOT = `return f32(!(a >= 1.0));`;
const $687865e752d42598$var$NEG = `return -a;`;
const $687865e752d42598$var$LEAKYRELU = `if (a < 0.0) { return uniforms.alpha * a; } return a;`;
const $687865e752d42598$var$LEAKYRELU_VEC4 = `
  let aLessThanZero = vec4<f32>(a < vec4<f32>(0.0));
  return (aLessThanZero * (uniforms.alpha * a)) + ((vec4<f32>(1.0) - aLessThanZero) * a);
`;
const $687865e752d42598$var$RECIPROCAL = `return 1.0 / a;`;
const $687865e752d42598$var$RELU = `return select(a, 0.0, a < 0.0);`;
const $687865e752d42598$var$RELU6 = 'return clamp(a, 0.0, 6.0);';
const $687865e752d42598$var$RELU6_VEC4 = 'return clamp(a, vec4<f32>(0.0, 0.0, 0.0, 0.0), vec4<f32>(6.0, 6.0, 6.0, 6.0));';
const $687865e752d42598$var$RELU_VEC4 = `
  return select(a, vec4<f32>(0.0), a < vec4<f32>(0.0));
`;
const $687865e752d42598$var$ROUND = `return round(a);`;
const $687865e752d42598$var$RSQRT = `return inverseSqrt(a);`;
// Stable and Attracting Fixed Point (0, 1) for Normalized Weights.
// See: https://arxiv.org/abs/1706.02515
const $687865e752d42598$var$SELU = `
  if (a >= 0.0) {
    return ${(0, $7MaPk).SELU_SCALE} * a;
  } else {
    return ${(0, $7MaPk).SELU_SCALEALPHA} * (exp(a) - 1.0);
  }
`;
const $687865e752d42598$var$SIGMOID = `return 1.0 / (1.0 + exp(-1.0 * a));`;
const $687865e752d42598$var$SIGN = `return sign(a);`;
const $687865e752d42598$var$SIN = `return sin(a);`;
const $687865e752d42598$var$SINH = `
  let e2x = exp(a);
  return (e2x - 1.0 / e2x) / 2.0;
`;
const $687865e752d42598$var$SOFTPLUS = `
  let epsilon = 1.1920928955078125e-7;
  let threshold = log(epsilon) + 2.0;

  let too_large = a > -threshold;
  let too_small = a < threshold;
  let exp_a = exp(a);

  if (too_large) {
    return a;
  } else if (too_small) {
    return exp_a;
  } else {
    return log(exp_a + 1.0);
  }
`;
const $687865e752d42598$var$SQRT = `return sqrt(a);`;
const $687865e752d42598$var$SQUARE = `return a * a;`;
const $687865e752d42598$var$STEP = `
  if (isnan(a)) {
    return a;
  }

  return select(uniforms.stepAlpha, 1.0, a > 0.0);
`;
const $687865e752d42598$var$TAN = `return tan(a);`;
const $687865e752d42598$var$TANH = `
  let e2x = exp(-2.0 * abs(a));
  return sign(a) * (1.0 - e2x) / (1.0 + e2x);
`;
const $687865e752d42598$var$TO_INT = `return f32(i32((a)));`;
function $687865e752d42598$export$bf824beefaa2c9b9(type, useVec4) {
    switch(type){
        case $687865e752d42598$export$5adefdb0f928033b.ABS:
            return $687865e752d42598$var$ABS;
        case $687865e752d42598$export$5adefdb0f928033b.ACOS:
            return $687865e752d42598$var$ACOS;
        case $687865e752d42598$export$5adefdb0f928033b.ACOSH:
            return $687865e752d42598$var$ACOSH;
        case $687865e752d42598$export$5adefdb0f928033b.ASIN:
            return $687865e752d42598$var$ASIN;
        case $687865e752d42598$export$5adefdb0f928033b.ASINH:
            return $687865e752d42598$var$ASINH;
        case $687865e752d42598$export$5adefdb0f928033b.ATAN:
            return $687865e752d42598$var$ATAN;
        case $687865e752d42598$export$5adefdb0f928033b.ATANH:
            return $687865e752d42598$var$ATANH;
        case $687865e752d42598$export$5adefdb0f928033b.COS:
            return $687865e752d42598$var$COS;
        case $687865e752d42598$export$5adefdb0f928033b.COSH:
            return $687865e752d42598$var$COSH;
        case $687865e752d42598$export$5adefdb0f928033b.CEIL:
            return $687865e752d42598$var$CEIL;
        case $687865e752d42598$export$5adefdb0f928033b.ELU:
            return useVec4 ? $687865e752d42598$var$ELU_VEC4 : $687865e752d42598$var$ELU;
        case $687865e752d42598$export$5adefdb0f928033b.ERF:
            return $687865e752d42598$var$ERF;
        case $687865e752d42598$export$5adefdb0f928033b.EXP:
            return $687865e752d42598$var$EXP;
        case $687865e752d42598$export$5adefdb0f928033b.EXPM1:
            return $687865e752d42598$var$EXPM1;
        case $687865e752d42598$export$5adefdb0f928033b.FLOOR:
            return $687865e752d42598$var$FLOOR;
        case $687865e752d42598$export$5adefdb0f928033b.IS_FINITE:
            return $687865e752d42598$var$IS_FINITE;
        case $687865e752d42598$export$5adefdb0f928033b.IS_INF:
            return $687865e752d42598$var$IS_INF;
        case $687865e752d42598$export$5adefdb0f928033b.IS_NAN:
            return $687865e752d42598$var$IS_NAN;
        case $687865e752d42598$export$5adefdb0f928033b.LINEAR:
            return $687865e752d42598$var$LINEAR;
        case $687865e752d42598$export$5adefdb0f928033b.LOG:
            return $687865e752d42598$var$LOG;
        case $687865e752d42598$export$5adefdb0f928033b.LOG1P:
            return $687865e752d42598$var$LOG1P;
        case $687865e752d42598$export$5adefdb0f928033b.LOGICAL_NOT:
            return $687865e752d42598$var$LOGICAL_NOT;
        case $687865e752d42598$export$5adefdb0f928033b.NEG:
            return $687865e752d42598$var$NEG;
        case $687865e752d42598$export$5adefdb0f928033b.LEAKYRELU:
            return useVec4 ? $687865e752d42598$var$LEAKYRELU_VEC4 : $687865e752d42598$var$LEAKYRELU;
        case $687865e752d42598$export$5adefdb0f928033b.RECIPROCAL:
            return $687865e752d42598$var$RECIPROCAL;
        case $687865e752d42598$export$5adefdb0f928033b.RELU:
            return useVec4 ? $687865e752d42598$var$RELU_VEC4 : $687865e752d42598$var$RELU;
        case $687865e752d42598$export$5adefdb0f928033b.RELU6:
            return useVec4 ? $687865e752d42598$var$RELU6_VEC4 : $687865e752d42598$var$RELU6;
        case $687865e752d42598$export$5adefdb0f928033b.ROUND:
            return $687865e752d42598$var$ROUND;
        case $687865e752d42598$export$5adefdb0f928033b.RSQRT:
            return $687865e752d42598$var$RSQRT;
        case $687865e752d42598$export$5adefdb0f928033b.SELU:
            return $687865e752d42598$var$SELU;
        case $687865e752d42598$export$5adefdb0f928033b.SIGMOID:
            return $687865e752d42598$var$SIGMOID;
        case $687865e752d42598$export$5adefdb0f928033b.SIGN:
            return $687865e752d42598$var$SIGN;
        case $687865e752d42598$export$5adefdb0f928033b.SIN:
            return $687865e752d42598$var$SIN;
        case $687865e752d42598$export$5adefdb0f928033b.SINH:
            return $687865e752d42598$var$SINH;
        case $687865e752d42598$export$5adefdb0f928033b.SOFTPLUS:
            return $687865e752d42598$var$SOFTPLUS;
        case $687865e752d42598$export$5adefdb0f928033b.SQRT:
            return $687865e752d42598$var$SQRT;
        case $687865e752d42598$export$5adefdb0f928033b.SQUARE:
            return $687865e752d42598$var$SQUARE;
        case $687865e752d42598$export$5adefdb0f928033b.STEP:
            return $687865e752d42598$var$STEP;
        case $687865e752d42598$export$5adefdb0f928033b.TAN:
            return $687865e752d42598$var$TAN;
        case $687865e752d42598$export$5adefdb0f928033b.TANH:
            return $687865e752d42598$var$TANH;
        case $687865e752d42598$export$5adefdb0f928033b.TO_INT:
            return $687865e752d42598$var$TO_INT;
        default:
            throw new Error(`BinaryType ${type} is not implemented!`);
    }
}

});



parcelRegister("94yrr", function(module, exports) {

$parcel$export(module.exports, "MatMulReduceProgram", () => $69af342ce4695597$export$f47918074674a3c4);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7t2XD = parcelRequire("7t2XD");

var $8UfUr = parcelRequire("8UfUr");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
function $69af342ce4695597$export$9983c79defd8d9aa(workgroupSizeX) {
    return `
    var<workgroup> sumValues : array<f32, ${workgroupSizeX}>;
    ${(0, $oGQBh.getMainHeaderString)()} {
      let coords = getOutputCoords();
      let batch = coords[0];
      let batchA = batch % uniforms.aShape[0];
      let batchB = batch % uniforms.bShape[0];
      let row = coords[1];
      let col = coords[2];
      var sum = 0.0;
      let Length = uniforms.dimInner;
      for (var k = i32(localId.x); k < Length; k = k + ${workgroupSizeX}) {
        let dataA = mm_readA(batchA, row, k);
        let dataB = mm_readB(batchB, k, col);
        sum = sum + dataA * dataB;
      }
      sumValues[localId.x] = sum;
      workgroupBarrier();

      for(var currentSize = ${workgroupSizeX / 2}u; currentSize > 1u;
          currentSize = currentSize / 2u) {
        if (localId.x < currentSize)
        {
          sumValues[localId.x] = sumValues[localId.x] + sumValues[localId.x + currentSize];
        }
        workgroupBarrier();
      }

      if (localId.x == 0u) {
        sum = sumValues[0] + sumValues[1];
        mm_write(batch, row, col, sum);
      }
    }
  `;
}
class $69af342ce4695597$export$f47918074674a3c4 {
    constructor(outputShape, transposeA = false, transposeB = false, bias = null, activation = null, preluActivationWeights = null){
        this.variableNames = [
            'A',
            'B'
        ];
        this.uniforms = `dimAOuter : i32, dimBOuter : i32, dimInner : i32,`;
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [],
            y: [
                1,
                2
            ],
            z: [
                0
            ]
        };
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        const addBias = bias != null;
        const hasPreluActivationWeights = preluActivationWeights != null;
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        this.transposeA = transposeA;
        this.transposeB = transposeB;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivationWeights = hasPreluActivationWeights;
        this.shaderKey = `matMulReduce_${this.activation}_${transposeA}_${transposeB}`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $7t2XD.activationFnSnippet)(this.activation, this.hasPreluActivationWeights)}
      ${(0, $8UfUr.matMulReadWriteFnSource)(this.addBias, this.activation, this.transposeA, this.transposeB)}
      ${$69af342ce4695597$export$9983c79defd8d9aa(this.workgroupSize[0])}
    `;
        return userCode;
    }
}

});

parcelRegister("ix1Ig", function(module, exports) {

$parcel$export(module.exports, "MatMulSmallOutputSizeProgram", () => $d7dca3330877c3b3$export$6437443af4f6bfc0);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7t2XD = parcelRequire("7t2XD");

var $8UfUr = parcelRequire("8UfUr");

var $oGQBh = parcelRequire("oGQBh");
function $d7dca3330877c3b3$export$6a4ab46bf6cbb17(workgroupSize) {
    const tileAOuter = workgroupSize[1];
    const tileBOuter = workgroupSize[0];
    const tileInner = tileAOuter > tileBOuter ? tileAOuter : tileBOuter;
    return `
  var<workgroup> mm_Asub : array<array<f32, ${tileInner}>, ${tileAOuter}>;
  var<workgroup> mm_Bsub : array<array<f32, ${tileBOuter}>, ${tileInner}>;

  // If the output size is small for matrix multiplication, avoid to use vec4
  // and handle some elements per thread to optimally utilize the ALU.
  // Read data from global memory to registers firstly, then store them into
  // shared memory, so it is instruction-Level parallelism for arithmetic
  // operations and others handle IO operations between barrier api, makes ALU
  // and load/store units work simultaneously, could improves the performance.
  ${(0, $oGQBh.getMainHeaderString)()} {
    let tileRow = i32(localId.y);
    let tileCol = i32(localId.x);
    let globalRow = i32(globalId.y);
    let globalCol = i32(globalId.x);
    let batch = i32(globalId.z);
    let batchA = batch % uniforms.aShape[0];
    let batchB = batch % uniforms.bShape[0];

    // uniforms.dimInner should be greater than 0.
    let numTiles = (uniforms.dimInner - 1) / ${tileInner} + 1;
    var acc = 0.0;

    var globalColA = tileCol;
    var globalRowB = 0;
    var regA = mm_readA(batchA, globalRow, globalColA);
    var regB0 = mm_readB(batchB, globalRowB + 2 * tileRow, globalCol);
    var regB1 = mm_readB(batchB, globalRowB + 2 * tileRow + 1, globalCol);
    globalColA = globalColA + ${tileInner};
    globalRowB = globalRowB + ${tileInner};

    for (var t = 0; t < numTiles; t = t + 1) {
      mm_Asub[tileRow][tileCol] = regA;
      mm_Bsub[2 * tileRow][tileCol] = regB0;
      mm_Bsub[2 * tileRow + 1][tileCol] = regB1;

      workgroupBarrier();

      regA = mm_readA(batchA, globalRow, globalColA);
      regB0 = mm_readB(batchB, globalRowB + 2 * tileRow, globalCol);
      regB1 = mm_readB(batchB, globalRowB + 2 * tileRow + 1, globalCol);
      globalColA = globalColA + ${tileInner};
      globalRowB = globalRowB + ${tileInner};

      for (var k = 0; k < ${tileInner}; k = k + 1) {
        acc = acc + mm_Asub[tileRow][k] * mm_Bsub[k][tileCol];
      }
      workgroupBarrier();
    }

    mm_write(batch, globalRow, globalCol, acc);
  }
  `;
}
class $d7dca3330877c3b3$export$6437443af4f6bfc0 {
    constructor(aShape, bShape, outputShape, transposeA = false, transposeB = false, bias = null, activation = null, preluActivationWeights = null){
        this.variableNames = [
            'A',
            'B'
        ];
        this.uniforms = `dimAOuter : i32, dimBOuter : i32, dimInner : i32,`;
        this.workgroupSize = [
            16,
            8,
            1
        ];
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [
                2
            ],
            y: [
                1
            ],
            z: [
                0
            ]
        };
        this.dispatch = [
            Math.ceil(outputShape[2] / this.workgroupSize[0]),
            Math.ceil(outputShape[1] / this.workgroupSize[1]),
            outputShape[0]
        ];
        const addBias = bias != null;
        if (addBias) this.variableNames.push('bias');
        const hasPreluActivationWeights = preluActivationWeights != null;
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        this.transposeA = transposeA;
        this.transposeB = transposeB;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivationWeights = hasPreluActivationWeights;
        this.shaderKey = `matMulSmallOutputSize_${this.activation}_${transposeA}_${transposeB}`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $7t2XD.activationFnSnippet)(this.activation, this.hasPreluActivationWeights)}
      ${(0, $8UfUr.matMulReadWriteFnSource)(this.addBias, this.activation, this.transposeA, this.transposeB)}
      ${$d7dca3330877c3b3$export$6a4ab46bf6cbb17(this.workgroupSize)}
    `;
        return userCode;
    }
}

});

parcelRegister("02wJs", function(module, exports) {

$parcel$export(module.exports, "MatMulSplitKProgram", () => $007993f02ff6f7de$export$5ffddbb35586921b);
$parcel$export(module.exports, "BiasActivationProgram", () => $007993f02ff6f7de$export$2533d1b002ed82e6);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");

var $7t2XD = parcelRequire("7t2XD");

var $8UfUr = parcelRequire("8UfUr");

var $arOgS = parcelRequire("arOgS");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $007993f02ff6f7de$export$5ffddbb35586921b {
    constructor(outputShape, dimInner, transposeA = false, transposeB = false){
        this.variableNames = [
            'A',
            'B'
        ];
        this.uniforms = `dimAOuter : i32, dimBOuter : i32, dimInner : i32,`;
        this.workgroupSize = [
            8,
            8,
            1
        ];
        this.atomic = true;
        this.splitedDimInner = 128;
        (0, $jjNRA).assert(outputShape[0] === 1, ()=>'MatMulSplitKProgram only supports batch = 1.');
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [
                2
            ],
            y: [
                1
            ],
            z: [
                0,
                3
            ]
        };
        const isVec4 = (transposeA && this.outputShape[1] % 4 === 0 || !transposeA && dimInner % 4 === 0) && this.outputShape[2] % 4 === 0;
        this.elementsPerThread = [
            4,
            4,
            this.splitedDimInner
        ];
        this.outputComponent = isVec4 ? 4 : 1;
        if (!isVec4) {
            if (this.outputShape[1] < 16) this.elementsPerThread[1] = 1;
            if (this.outputShape[2] < 16) this.elementsPerThread[0] = 1;
        }
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, [
            this.outputShape[0],
            this.outputShape[1],
            this.outputShape[2],
            dimInner
        ], this.workgroupSize, this.elementsPerThread);
        this.transposeA = transposeA;
        this.transposeB = transposeB;
        this.shaderKey = `matMulSplitK_${transposeA}_${transposeB}_${this.elementsPerThread}_${this.outputComponent}`;
    }
    getUserCode() {
        const component = this.outputComponent;
        const userCode = `
      ${(0, $8UfUr.matMulReadFnSource)(false, this.transposeB, false, false, false, component)}
      fn mm_write(batch: i32, row : i32, col : i32, value : ${(0, $oGQBh.typeSnippet)(component)}) {
        if (row < uniforms.dimAOuter && col < uniforms.dimBOuter) {
          let coords = vec3<i32>(batch, row, col);
          let flatIndex = getOutputIndexFromCoords(coords);
          // The problem is that we should initialize output to zero before using.
          // Otherwise, the original value will be added to the result.
          for (var i = 0; i < ${component}; i = i + 1) {
            ${(0, $arOgS.atomicAddSnippet)('&result[flatIndex + i]', `${component > 1 ? 'value[i]' : 'value'}`, 'float32')}
          }
        }
      }
      ${component === 4 ? (0, $8UfUr.makeMatMulPackedVec4Source)(this.elementsPerThread, this.workgroupSize, this.transposeA, 32, true, this.splitedDimInner) : (0, $8UfUr.makeMatMulPackedSource)(this.elementsPerThread, this.workgroupSize, this.transposeA, 32, true, this.splitedDimInner)}
    `;
        return userCode;
    }
}
class $007993f02ff6f7de$export$2533d1b002ed82e6 {
    constructor(outputShape, bias = null, activation = null, preluActivationWeights = null){
        this.uniforms = '';
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.addBias = bias != null;
        this.hasPreluActivationWeights = preluActivationWeights != null;
        this.activation = activation;
        if (this.addBias) this.variableNames.push('bias');
        if (this.hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        this.shaderKey = `biasActivation_${activation}`;
    }
    getUserCode() {
        return `
    ${(0, $7t2XD.activationFnSnippet)(this.activation, this.hasPreluActivationWeights)}
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        var value = getXByOutputIndex(index);
        ${(0, $7t2XD.biasActivationSnippet)(this.addBias, this.activation)}
        setOutputAtIndex(index, value);
      }
    }
    `;
    }
}

});

parcelRegister("cFwkm", function(module, exports) {

$parcel$export(module.exports, "fill", () => $939263ec191cee76$export$9563e054e6f787fb);
$parcel$export(module.exports, "fillConfig", () => $939263ec191cee76$export$c953bf474b2bde62);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $gbWny = parcelRequire("gbWny");
function $939263ec191cee76$export$9563e054e6f787fb(args) {
    const { backend: backend, attrs: attrs } = args;
    const { shape: shape, value: value } = attrs;
    let { dtype: dtype } = attrs;
    dtype = dtype || (0, $jjNRA).inferDtype(value);
    if (dtype === 'string') {
        // String type should be handled in CPU memory.
        const values = (0, $jjNRA).getArrayFromDType(dtype, (0, $jjNRA).sizeFromShape(shape));
        values.fill(value);
        return backend.makeTensorInfo(shape, dtype, values);
    } else {
        const program = new (0, $gbWny.FillProgram)(shape);
        const uniformData = [
            {
                type: 'float32',
                data: [
                    value
                ]
            }
        ];
        return backend.runWebGPUProgram(program, [], dtype, uniformData);
    }
}
const $939263ec191cee76$export$c953bf474b2bde62 = {
    kernelName: (0, $hl418.Fill),
    backendName: 'webgpu',
    kernelFunc: $939263ec191cee76$export$9563e054e6f787fb
};

});
parcelRegister("gbWny", function(module, exports) {

$parcel$export(module.exports, "FillProgram", () => $bc9af545fc0b67c9$export$758181b12323e997);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $bc9af545fc0b67c9$export$758181b12323e997 {
    constructor(shape){
        this.variableNames = [];
        this.outputShape = [];
        this.uniforms = 'value : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'fill';
    }
    getUserCode() {
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        setOutputAtIndex(index, uniforms.value);
      }
    }
  `;
        return userCode;
    }
}

});


parcelRegister("gj4T5", function(module, exports) {

$parcel$export(module.exports, "reshape", () => $bdf2363c82cd9cba$export$9eaad88cf88cee2b);
$parcel$export(module.exports, "reshapeConfig", () => $bdf2363c82cd9cba$export$cfa02e698602aca2);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");
function $bdf2363c82cd9cba$export$9eaad88cf88cee2b(args) {
    const { inputs: inputs, attrs: attrs } = args;
    const { x: x } = inputs;
    const { shape: shape } = attrs;
    const xSize = (0, $jjNRA).sizeFromShape(x.shape);
    const $shape = (0, $jjNRA).inferFromImplicitShape(shape, xSize);
    const $xSize = (0, $jjNRA).sizeFromShape($shape);
    (0, $jjNRA).assert(xSize === $xSize, ()=>`The new shape (${$shape}) has ${$xSize} elements and the old ` + `shape (${x.shape}) has ${xSize} elements. The new shape and old ` + `shape must have the same number of elements.`);
    // Backend needs to track refCount for the dataId for reshape op
    args.backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: $shape,
        dtype: x.dtype
    };
}
const $bdf2363c82cd9cba$export$cfa02e698602aca2 = {
    kernelName: (0, $hl418.Reshape),
    backendName: 'webgpu',
    kernelFunc: $bdf2363c82cd9cba$export$9eaad88cf88cee2b
};

});



parcelRegister("kcF8C", function(module, exports) {

$parcel$export(module.exports, "absConfig", () => $eb54d6cbda6c7082$export$d66f48648b9d5ec7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $eb54d6cbda6c7082$export$2335f513bbd82c6d = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).ABS,
    cpuKernelImpl: (0, $aLZc7.simpleAbsImplCPU)
});
const $eb54d6cbda6c7082$export$d66f48648b9d5ec7 = {
    kernelName: (0, $hl418.Abs),
    backendName: 'webgpu',
    kernelFunc: $eb54d6cbda6c7082$export$2335f513bbd82c6d
};

});
parcelRegister("amx4s", function(module, exports) {

$parcel$export(module.exports, "unaryKernelFunc", () => $78b59ca075374638$export$ba4daf5748026fba);
$parcel$export(module.exports, "binaryKernelFunc", () => $78b59ca075374638$export$29353c66e70e3e16);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $2MDja = parcelRequire("2MDja");

var $lUJRJ = parcelRequire("lUJRJ");

var $jJAz1 = parcelRequire("jJAz1");

var $25rfU = parcelRequire("25rfU");

var $lbBov = parcelRequire("lbBov");

var $2b4Nh = parcelRequire("2b4Nh");
function $78b59ca075374638$export$ba4daf5748026fba({ opType: opType, cpuKernelImpl: cpuKernelImpl, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const webgpuBackend = backend;
        const $dtype = dtype || x.dtype;
        if (webgpuBackend.shouldExecuteOnCPU([
            x
        ]) && cpuKernelImpl != null) {
            const xData = webgpuBackend.tensorMap.get(x.dataId);
            const outValues = cpuKernelImpl(xData.values, $dtype);
            return webgpuBackend.makeTensorInfo(x.shape, $dtype, outValues);
        }
        const program = new (0, $2b4Nh.UnaryOpProgram)(x.shape, opType);
        return webgpuBackend.runWebGPUProgram(program, [
            x
        ], $dtype);
    };
}
function $78b59ca075374638$export$29353c66e70e3e16({ opType: opType, cpuKernelImpl: cpuKernelImpl, supportsComplex: supportsComplex = false, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const webgpuBackend = backend;
        if (supportsComplex && a.dtype === 'complex64') {
            const aData = webgpuBackend.tensorMap.get(a.dataId);
            const bData = webgpuBackend.tensorMap.get(b.dataId);
            let real, imag;
            if (opType !== (0, $jJAz1.BinaryOpType).MUL) [real, imag] = [
                [
                    aData.complexTensorInfos.real,
                    bData.complexTensorInfos.real
                ],
                [
                    aData.complexTensorInfos.imag,
                    bData.complexTensorInfos.imag
                ]
            ].map((complexParts)=>{
                const [aPart, bPart] = complexParts;
                const aHandle = {
                    dataId: aPart.dataId,
                    dtype: aPart.dtype,
                    shape: a.shape
                };
                const bHandle = {
                    dataId: bPart.dataId,
                    dtype: bPart.dtype,
                    shape: b.shape
                };
                const program = new (0, $25rfU.BinaryOpProgram)(opType, a.shape, b.shape);
                return webgpuBackend.runWebGPUProgram(program, [
                    aHandle,
                    bHandle
                ], (0, $2MDja.upcastType)(aPart.dtype, bPart.dtype));
            });
            else {
                const realProgram = new (0, $lUJRJ.BinaryOpComplexProgram)((0, $jJAz1.BinaryOpType).COMPLEX_MULTIPLY_REAL, a.shape, b.shape);
                const imagProgram = new (0, $lUJRJ.BinaryOpComplexProgram)((0, $jJAz1.BinaryOpType).COMPLEX_MULTIPLY_IMAG, a.shape, b.shape);
                const inputs = [
                    {
                        dataId: aData.complexTensorInfos.real.dataId,
                        dtype: aData.complexTensorInfos.real.dtype,
                        shape: a.shape
                    },
                    {
                        dataId: aData.complexTensorInfos.imag.dataId,
                        dtype: aData.complexTensorInfos.imag.dtype,
                        shape: a.shape
                    },
                    {
                        dataId: bData.complexTensorInfos.real.dataId,
                        dtype: bData.complexTensorInfos.real.dtype,
                        shape: b.shape
                    },
                    {
                        dataId: bData.complexTensorInfos.imag.dataId,
                        dtype: bData.complexTensorInfos.imag.dtype,
                        shape: b.shape
                    }
                ];
                real = webgpuBackend.runWebGPUProgram(realProgram, inputs, 'float32');
                imag = webgpuBackend.runWebGPUProgram(imagProgram, inputs, 'float32');
            }
            const complexOutput = (0, $lbBov.complex)({
                inputs: {
                    real: real,
                    imag: imag
                },
                backend: webgpuBackend
            });
            webgpuBackend.disposeData(real.dataId);
            webgpuBackend.disposeData(imag.dataId);
            // TODO: Implement CPU forwarding for complex inputs.
            return complexOutput;
        }
        const $dtype = dtype || (0, $2MDja.upcastType)(a.dtype, b.dtype);
        if ((a.dtype === 'string' || b.dtype === 'string' || webgpuBackend.shouldExecuteOnCPU([
            a,
            b
        ])) && cpuKernelImpl != null) {
            const aData = webgpuBackend.tensorMap.get(a.dataId).values;
            const bData = webgpuBackend.tensorMap.get(b.dataId).values;
            const decodedAVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $7MaPk).fromUint8ToStringArray(aData) : aData;
            const decodedBVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $7MaPk).fromUint8ToStringArray(bData) : bData;
            const [outValues, outShape] = cpuKernelImpl(a.shape, b.shape, decodedAVals, decodedBVals, $dtype);
            return webgpuBackend.makeTensorInfo(outShape, $dtype, outValues);
        }
        const program = new (0, $25rfU.BinaryOpProgram)(opType, a.shape, b.shape);
        return webgpuBackend.runWebGPUProgram(program, [
            a,
            b
        ], $dtype);
    };
}

});
parcelRegister("lUJRJ", function(module, exports) {

$parcel$export(module.exports, "BinaryOpComplexProgram", () => $ff4267e253639d43$export$d4e4851a08b0c91);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");

var $jJAz1 = parcelRequire("jJAz1");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $ff4267e253639d43$export$d4e4851a08b0c91 {
    constructor(op, aShape, bShape){
        this.variableNames = [
            'AReal',
            'AImag',
            'BReal',
            'BImag'
        ];
        this.workgroupSize = [
            128,
            1,
            1
        ];
        this.size = true;
        this.outputShape = (0, $7MaPk).assertAndGetBroadcastShape(aShape, bShape);
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `binaryOpComplex_${op}`;
        this.op = op;
    }
    getUserCode() {
        const opStr = (0, $jJAz1.getBinaryOpString)(this.op, false);
        const userCode = `
      fn binaryOpComplex(
          areal : f32, aimag : f32, breal : f32, bimag : f32) -> f32 {
        ${opStr}
      }

      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if(index < uniforms.size) {
          let areal = getARealByOutputIndex(index);
          let aimag = getAImagByOutputIndex(index);
          let breal = getBRealByOutputIndex(index);
          let bimag = getBImagByOutputIndex(index);
          setOutputAtIndex(index, binaryOpComplex(areal, aimag, breal, bimag));
        }
      }
    `;
        return userCode;
    }
}

});

parcelRegister("25rfU", function(module, exports) {

$parcel$export(module.exports, "BinaryOpProgram", () => $185130c548e98725$export$9045e9161086790b);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");

var $jJAz1 = parcelRequire("jJAz1");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $185130c548e98725$export$9045e9161086790b {
    constructor(op, aShape, bShape){
        this.size = true;
        this.variableNames = [
            'A',
            'B'
        ];
        this.outputShape = (0, $7MaPk).assertAndGetBroadcastShape(aShape, bShape);
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.op = op;
        this.useSharedMemoryWithA = aShape.length <= 1 && bShape.length > 1 && aShape[0] < 128;
        this.useSharedMemoryWithB = bShape.length <= 1 && aShape.length > 1 && bShape[0] < 128;
        if (this.useSharedMemoryWithA || this.useSharedMemoryWithB) {
            this.outputComponent = 1;
            this.variableComponents = [
                1,
                1
            ];
            // lastDimensionSize is used as sharedBuf array size, so can not be
            // used as uniform.
            this.lastDimensionSize = this.useSharedMemoryWithB ? bShape[0] : aShape[0];
            this.shaderKey = `binary_${op}_${this.lastDimensionSize}`;
            this.type = 'shared';
            // This is an experimental value when using shared memory.
            // Note that the maximum of workgroup X dimension is 256.
            this.workgroupSize = [
                256,
                1,
                1
            ];
        } else {
            const aDivisibleBy4 = aShape.length > 0 && aShape[aShape.length - 1] % 4 === 0;
            const bDivisibleBy4 = bShape.length > 0 && bShape[bShape.length - 1] % 4 === 0;
            if (aDivisibleBy4 && bDivisibleBy4) {
                this.outputComponent = 4;
                this.variableComponents = [
                    4,
                    4
                ];
            } else if (aDivisibleBy4 && ((0, $jjNRA).isScalarShape(bShape) || bShape[bShape.length - 1] === 1) || bDivisibleBy4 && ((0, $jjNRA).isScalarShape(aShape) || aShape[aShape.length - 1] === 1)) {
                this.outputComponent = 4;
                this.variableComponents = aDivisibleBy4 ? [
                    4,
                    1
                ] : [
                    1,
                    4
                ];
            } else {
                this.outputComponent = 1;
                this.variableComponents = [
                    1,
                    1
                ];
            }
            this.type = 'nonshared';
            this.shaderKey = `binary_${op}_${this.variableComponents}`;
            // TODO(jiajia.qin@intel.com): Heuristically select a good work group
            // size.
            this.workgroupSize = [
                128,
                1,
                1
            ];
        }
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.outputComponent,
            1,
            1
        ]);
    }
    getUserCode() {
        let userCode;
        const dType = this.outputComponent === 4 ? 'vec4<f32>' : 'f32';
        const opFnStr = `
    fn binaryOperation(a : ${dType}, b : ${dType}) -> ${dType} {
      ${(0, $jJAz1.getBinaryOpString)(this.op, this.outputComponent === 4)}
    };
    `;
        if (this.type === 'shared') {
            const sharedIndexSnippet = this.lastDimensionSize > 1 ? `coords[${this.outputShape.length - 1}]` : '0';
            const accessDataSnippet = this.useSharedMemoryWithB ? `let a = getAByOutputIndex(index);
          let b = sharedBuf[${sharedIndexSnippet}];` : `let a = sharedBuf[${sharedIndexSnippet}];
          let b = getBByOutputIndex(index);`;
            userCode = `
        ${opFnStr}
        var<workgroup> sharedBuf : array<f32, ${this.lastDimensionSize}>;
        ${(0, $oGQBh.getMainHeaderString)('index')} {
          // Fill in the shared memory buffer.
          let localIndex = i32(localId.x);
          if(localIndex < ${this.lastDimensionSize}) {
            sharedBuf[localIndex] = f32(${this.useSharedMemoryWithB ? 'B' : 'A'}[localIndex]);
          }
          workgroupBarrier();

          if(index < uniforms.size) {
            let coords = getCoordsFromIndex(index);
            ${accessDataSnippet}
            setOutputAtIndex(index, binaryOperation(a, b));
          }
        }
        `;
        } else userCode = `
       ${opFnStr}
       ${(0, $oGQBh.getMainHeaderString)('index')} {
         if (index < uniforms.size) {
           let coords = getCoordsFromIndex(index * ${this.outputComponent});
           let a = ${dType}(getAByOutputCoords(coords));
           let b = ${dType}(getBByOutputCoords(coords));
           setOutputAtIndex(index, binaryOperation(a, b));
         }
       }
       `;
        return userCode;
    }
}

});

parcelRegister("lbBov", function(module, exports) {

$parcel$export(module.exports, "complex", () => $f6c7a1c8a935223b$export$83a0e34f1302825b);
$parcel$export(module.exports, "complexConfig", () => $f6c7a1c8a935223b$export$67917f7910d27fd8);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $17o8l = parcelRequire("17o8l");
function $f6c7a1c8a935223b$export$83a0e34f1302825b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { real: real, imag: imag } = inputs;
    const complexInfo = backend.makeTensorInfo(real.shape, 'complex64');
    const complex = backend.tensorMap.get(complexInfo.dataId);
    const realTensorInfo = (0, $17o8l.identity)({
        inputs: {
            x: real
        },
        backend: backend
    });
    const imagTensorInfo = (0, $17o8l.identity)({
        inputs: {
            x: imag
        },
        backend: backend
    });
    complex.complexTensorInfos = {
        real: realTensorInfo,
        imag: imagTensorInfo
    };
    return complexInfo;
}
const $f6c7a1c8a935223b$export$67917f7910d27fd8 = {
    kernelName: (0, $hl418.Complex),
    backendName: 'webgpu',
    kernelFunc: $f6c7a1c8a935223b$export$83a0e34f1302825b
};

});
parcelRegister("17o8l", function(module, exports) {

$parcel$export(module.exports, "identity", () => $0d092a514ec663e6$export$f0954fd7d5368655);
$parcel$export(module.exports, "identityConfig", () => $0d092a514ec663e6$export$c426d3942537ad84);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
function $0d092a514ec663e6$export$f0954fd7d5368655(args) {
    const { inputs: inputs } = args;
    const { x: x } = inputs;
    args.backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: x.shape,
        dtype: x.dtype
    };
}
const $0d092a514ec663e6$export$c426d3942537ad84 = {
    kernelName: (0, $hl418.Identity),
    backendName: 'webgpu',
    kernelFunc: $0d092a514ec663e6$export$f0954fd7d5368655
};

});


parcelRegister("2b4Nh", function(module, exports) {

$parcel$export(module.exports, "UnaryOpProgram", () => $196053d3402cc532$export$f93811a5a466fd42);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8Y5Lq = parcelRequire("8Y5Lq");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $196053d3402cc532$export$f93811a5a466fd42 {
    constructor(outputShape, op, uniforms = ''){
        this.variableNames = [
            'A'
        ];
        this.size = true;
        // TODO(jiajia.qin@intel.com): Heuristically select a good work group size.
        const workgroupSizeX = 128;
        this.workgroupSize = [
            workgroupSizeX,
            1,
            1
        ];
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.op = op;
        if (uniforms !== '') this.uniforms = uniforms;
        this.shaderKey = `unary_${op}`;
    }
    getUserCode() {
        return `
      fn unaryOperation(a : f32) -> f32 {
        ${(0, $8Y5Lq.getUnaryOpString)(this.op, false)}
      }
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let a = getAByOutputIndex(index);
          setOutputAtIndex(index, unaryOperation(a));
        }
      }
      `;
    }
}

});


parcelRegister("aLZc7", function(module, exports) {

$parcel$export(module.exports, "addImplCPU", () => $7d7dc31ab4b53a26$export$c7f405723b4a93e7);
$parcel$export(module.exports, "castImplCPU", () => $7d7dc31ab4b53a26$export$babf602309dd6292);
$parcel$export(module.exports, "ceilImplCPU", () => $7d7dc31ab4b53a26$export$bb3ce81256fe261b);
$parcel$export(module.exports, "concatImplCPU", () => $7d7dc31ab4b53a26$export$95e7342d25849d64);
$parcel$export(module.exports, "equalImplCPU", () => $7d7dc31ab4b53a26$export$13d1298222b29d06);
$parcel$export(module.exports, "expImplCPU", () => $7d7dc31ab4b53a26$export$f72e179c9610cb8c);
$parcel$export(module.exports, "expm1ImplCPU", () => $7d7dc31ab4b53a26$export$5903785c29f035f5);
$parcel$export(module.exports, "floorImplCPU", () => $7d7dc31ab4b53a26$export$195a28e6add8ab7e);
$parcel$export(module.exports, "floorDivImplCPU", () => $7d7dc31ab4b53a26$export$afb5f31ac42ca629);
$parcel$export(module.exports, "gatherNdImplCPU", () => $7d7dc31ab4b53a26$export$e3196a12dce24214);
$parcel$export(module.exports, "gatherV2ImplCPU", () => $7d7dc31ab4b53a26$export$cffe0fde89e98de6);
$parcel$export(module.exports, "greaterEqualImplCPU", () => $7d7dc31ab4b53a26$export$a3d2e203d979d298);
$parcel$export(module.exports, "greaterImplCPU", () => $7d7dc31ab4b53a26$export$eabb8927944259dd);
$parcel$export(module.exports, "lessEqualImplCPU", () => $7d7dc31ab4b53a26$export$6d1533a3ea9565f);
$parcel$export(module.exports, "lessImplCPU", () => $7d7dc31ab4b53a26$export$74c893b3c5e74e60);
$parcel$export(module.exports, "logImplCPU", () => $7d7dc31ab4b53a26$export$e88dde64a338f813);
$parcel$export(module.exports, "maxImplCPU", () => $7d7dc31ab4b53a26$export$a94164c9f637858e);
$parcel$export(module.exports, "maximumImplCPU", () => $7d7dc31ab4b53a26$export$b3afdc53a543e175);
$parcel$export(module.exports, "minimumImplCPU", () => $7d7dc31ab4b53a26$export$1f01be3f637863fa);
$parcel$export(module.exports, "multiplyImplCPU", () => $7d7dc31ab4b53a26$export$598d1d66b05a298f);
$parcel$export(module.exports, "negImplCPU", () => $7d7dc31ab4b53a26$export$1cbcde7624effb15);
$parcel$export(module.exports, "notEqualImplCPU", () => $7d7dc31ab4b53a26$export$b91372753635df24);
$parcel$export(module.exports, "prodImplCPU", () => $7d7dc31ab4b53a26$export$2d654219115cec80);
$parcel$export(module.exports, "rangeImplCPU", () => $7d7dc31ab4b53a26$export$fbee6deed7e76443);
$parcel$export(module.exports, "rsqrtImplCPU", () => $7d7dc31ab4b53a26$export$431ccb02913a1aee);
$parcel$export(module.exports, "scatterImplCPU", () => $7d7dc31ab4b53a26$export$2295c910080b5ca7);
$parcel$export(module.exports, "simpleAbsImplCPU", () => $7d7dc31ab4b53a26$export$d7efa3585619eabe);
$parcel$export(module.exports, "sliceImplCPU", () => $7d7dc31ab4b53a26$export$45812d0d8578899);
$parcel$export(module.exports, "stridedSliceImplCPU", () => $7d7dc31ab4b53a26$export$efd4e188e5de0188);
$parcel$export(module.exports, "stringNGramsImplCPU", () => $7d7dc31ab4b53a26$export$bb9e83cb65884ef3);
$parcel$export(module.exports, "subImplCPU", () => $7d7dc31ab4b53a26$export$be7474e96b733333);
$parcel$export(module.exports, "tileImplCPU", () => $7d7dc31ab4b53a26$export$349e02a266ab3131);
$parcel$export(module.exports, "topKImplCPU", () => $7d7dc31ab4b53a26$export$cc4aa6851cf96e2b);
$parcel$export(module.exports, "transposeImplCPU", () => $7d7dc31ab4b53a26$export$a0105d4a7143676c);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Import shared functionality from tfjs-backend-cpu without triggering
// side effects.
// tslint:disable-next-line: no-imports-from-dist

var $9nCi0 = parcelRequire("9nCi0");
const { addImpl: $7d7dc31ab4b53a26$export$c7f405723b4a93e7, castImpl: $7d7dc31ab4b53a26$export$babf602309dd6292, ceilImpl: $7d7dc31ab4b53a26$export$bb3ce81256fe261b, concatImpl: $7d7dc31ab4b53a26$export$95e7342d25849d64, equalImpl: $7d7dc31ab4b53a26$export$13d1298222b29d06, expImpl: $7d7dc31ab4b53a26$export$f72e179c9610cb8c, expm1Impl: $7d7dc31ab4b53a26$export$5903785c29f035f5, floorImpl: $7d7dc31ab4b53a26$export$195a28e6add8ab7e, floorDivImpl: $7d7dc31ab4b53a26$export$afb5f31ac42ca629, gatherNdImpl: $7d7dc31ab4b53a26$export$e3196a12dce24214, gatherV2Impl: $7d7dc31ab4b53a26$export$cffe0fde89e98de6, greaterEqualImpl: $7d7dc31ab4b53a26$export$a3d2e203d979d298, greaterImpl: $7d7dc31ab4b53a26$export$eabb8927944259dd, lessEqualImpl: $7d7dc31ab4b53a26$export$6d1533a3ea9565f, lessImpl: $7d7dc31ab4b53a26$export$74c893b3c5e74e60, logImpl: $7d7dc31ab4b53a26$export$e88dde64a338f813, maxImpl: $7d7dc31ab4b53a26$export$a94164c9f637858e, maximumImpl: $7d7dc31ab4b53a26$export$b3afdc53a543e175, minimumImpl: $7d7dc31ab4b53a26$export$1f01be3f637863fa, multiplyImpl: $7d7dc31ab4b53a26$export$598d1d66b05a298f, negImpl: $7d7dc31ab4b53a26$export$1cbcde7624effb15, notEqualImpl: $7d7dc31ab4b53a26$export$b91372753635df24, prodImpl: $7d7dc31ab4b53a26$export$2d654219115cec80, rangeImpl: $7d7dc31ab4b53a26$export$fbee6deed7e76443, rsqrtImpl: $7d7dc31ab4b53a26$export$431ccb02913a1aee, scatterImpl: $7d7dc31ab4b53a26$export$2295c910080b5ca7, simpleAbsImpl: $7d7dc31ab4b53a26$export$d7efa3585619eabe, sliceImpl: $7d7dc31ab4b53a26$export$45812d0d8578899, stridedSliceImpl: $7d7dc31ab4b53a26$export$efd4e188e5de0188, stringNGramsImpl: $7d7dc31ab4b53a26$export$bb9e83cb65884ef3, subImpl: $7d7dc31ab4b53a26$export$be7474e96b733333, tileImpl: $7d7dc31ab4b53a26$export$349e02a266ab3131, topKImpl: $7d7dc31ab4b53a26$export$cc4aa6851cf96e2b, transposeImpl: $7d7dc31ab4b53a26$export$a0105d4a7143676c, uniqueImpl: $7d7dc31ab4b53a26$export$c417de669ad2e148 } = $9nCi0;

});
parcelRegister("9nCi0", function(module, exports) {

$parcel$export(module.exports, "simpleAbsImpl", () => (parcelRequire("ep8sG")).simpleAbsImpl);
$parcel$export(module.exports, "addImpl", () => (parcelRequire("e8yCG")).addImpl);
$parcel$export(module.exports, "bincountImpl", () => (parcelRequire("34gHf")).bincountImpl);
$parcel$export(module.exports, "bincountReduceImpl", () => (parcelRequire("34gHf")).bincountReduceImpl);
$parcel$export(module.exports, "bitwiseAndImpl", () => (parcelRequire("eYl2h")).bitwiseAndImpl);
$parcel$export(module.exports, "castImpl", () => (parcelRequire("7LLjQ")).castImpl);
$parcel$export(module.exports, "ceilImpl", () => (parcelRequire("bs8Xr")).ceilImpl);
$parcel$export(module.exports, "concatImpl", () => (parcelRequire("3wcyL")).concatImpl);
$parcel$export(module.exports, "equalImpl", () => (parcelRequire("diO4l")).equalImpl);
$parcel$export(module.exports, "expImpl", () => (parcelRequire("2ANRn")).expImpl);
$parcel$export(module.exports, "expm1Impl", () => (parcelRequire("jqUkN")).expm1Impl);
$parcel$export(module.exports, "floorImpl", () => (parcelRequire("Jvx9v")).floorImpl);
$parcel$export(module.exports, "floorDivImpl", () => (parcelRequire("hj1kT")).floorDivImpl);
$parcel$export(module.exports, "gatherNdImpl", () => (parcelRequire("cC9SN")).gatherNdImpl);
$parcel$export(module.exports, "gatherV2Impl", () => (parcelRequire("hNUKd")).gatherV2Impl);
$parcel$export(module.exports, "greaterImpl", () => (parcelRequire("2Apjw")).greaterImpl);
$parcel$export(module.exports, "greaterEqualImpl", () => (parcelRequire("9yHtq")).greaterEqualImpl);
$parcel$export(module.exports, "lessImpl", () => (parcelRequire("jJNGT")).lessImpl);
$parcel$export(module.exports, "lessEqualImpl", () => (parcelRequire("bwE16")).lessEqualImpl);
$parcel$export(module.exports, "linSpaceImpl", () => (parcelRequire("6U5ue")).linSpaceImpl);
$parcel$export(module.exports, "logImpl", () => (parcelRequire("2La7K")).logImpl);
$parcel$export(module.exports, "maxImpl", () => (parcelRequire("cjSsc")).maxImpl);
$parcel$export(module.exports, "maximumImpl", () => (parcelRequire("IzL7H")).maximumImpl);
$parcel$export(module.exports, "minimumImpl", () => (parcelRequire("g7Z3x")).minimumImpl);
$parcel$export(module.exports, "multiplyImpl", () => (parcelRequire("gQOIy")).multiplyImpl);
$parcel$export(module.exports, "negImpl", () => (parcelRequire("9NYY4")).negImpl);
$parcel$export(module.exports, "notEqualImpl", () => (parcelRequire("QHoEG")).notEqualImpl);
$parcel$export(module.exports, "prodImpl", () => (parcelRequire("86TES")).prodImpl);
$parcel$export(module.exports, "raggedGatherImpl", () => (parcelRequire("4hb6Q")).raggedGatherImpl);
$parcel$export(module.exports, "raggedRangeImpl", () => (parcelRequire("2uK9D")).raggedRangeImpl);
$parcel$export(module.exports, "raggedTensorToTensorImpl", () => (parcelRequire("6AvWp")).raggedTensorToTensorImpl);
$parcel$export(module.exports, "rangeImpl", () => (parcelRequire("caGrw")).rangeImpl);
$parcel$export(module.exports, "rsqrtImpl", () => (parcelRequire("GbeHD")).rsqrtImpl);
$parcel$export(module.exports, "scatterImpl", () => (parcelRequire("YcuAy")).scatterImpl);
$parcel$export(module.exports, "sigmoidImpl", () => (parcelRequire("dMdBj")).sigmoidImpl);
$parcel$export(module.exports, "sliceImpl", () => (parcelRequire("aYBRE")).sliceImpl);
$parcel$export(module.exports, "sparseFillEmptyRowsImpl", () => (parcelRequire("dkwAe")).sparseFillEmptyRowsImpl);
$parcel$export(module.exports, "sparseReshapeImpl", () => (parcelRequire("9VxEX")).sparseReshapeImpl);
$parcel$export(module.exports, "sparseSegmentReductionImpl", () => (parcelRequire("8ENVF")).sparseSegmentReductionImpl);
$parcel$export(module.exports, "sqrtImpl", () => (parcelRequire("2a43t")).sqrtImpl);
$parcel$export(module.exports, "squaredDifferenceImpl", () => (parcelRequire("4QLZo")).squaredDifferenceImpl);
$parcel$export(module.exports, "staticRegexReplaceImpl", () => (parcelRequire("hRUGg")).staticRegexReplaceImpl);
$parcel$export(module.exports, "stridedSliceImpl", () => (parcelRequire("6Syfk")).stridedSliceImpl);
$parcel$export(module.exports, "stringNGramsImpl", () => (parcelRequire("fopkM")).stringNGramsImpl);
$parcel$export(module.exports, "stringSplitImpl", () => (parcelRequire("5xLgA")).stringSplitImpl);
$parcel$export(module.exports, "stringToHashBucketFastImpl", () => (parcelRequire("cWacD")).stringToHashBucketFastImpl);
$parcel$export(module.exports, "subImpl", () => (parcelRequire("aT9VE")).subImpl);
$parcel$export(module.exports, "tileImpl", () => (parcelRequire("bzU8O")).tileImpl);
$parcel$export(module.exports, "topKImpl", () => (parcelRequire("8tNzN")).topKImpl);
$parcel$export(module.exports, "transposeImpl", () => (parcelRequire("4m8st")).transposeImpl);
$parcel$export(module.exports, "uniqueImpl", () => (parcelRequire("fjkAl")).uniqueImpl);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Shared functionality among backends.

var $ep8sG = parcelRequire("ep8sG");

var $e8yCG = parcelRequire("e8yCG");

var $34gHf = parcelRequire("34gHf");

var $eYl2h = parcelRequire("eYl2h");

var $7LLjQ = parcelRequire("7LLjQ");

var $bs8Xr = parcelRequire("bs8Xr");

var $3wcyL = parcelRequire("3wcyL");

var $diO4l = parcelRequire("diO4l");

var $2ANRn = parcelRequire("2ANRn");

var $jqUkN = parcelRequire("jqUkN");

var $Jvx9v = parcelRequire("Jvx9v");

var $hj1kT = parcelRequire("hj1kT");

var $cC9SN = parcelRequire("cC9SN");

var $hNUKd = parcelRequire("hNUKd");

var $2Apjw = parcelRequire("2Apjw");

var $9yHtq = parcelRequire("9yHtq");

var $jJNGT = parcelRequire("jJNGT");

var $bwE16 = parcelRequire("bwE16");

var $6U5ue = parcelRequire("6U5ue");

var $2La7K = parcelRequire("2La7K");

var $cjSsc = parcelRequire("cjSsc");

var $IzL7H = parcelRequire("IzL7H");

var $g7Z3x = parcelRequire("g7Z3x");

var $gQOIy = parcelRequire("gQOIy");

var $9NYY4 = parcelRequire("9NYY4");

var $QHoEG = parcelRequire("QHoEG");

var $86TES = parcelRequire("86TES");

var $4hb6Q = parcelRequire("4hb6Q");

var $2uK9D = parcelRequire("2uK9D");

var $6AvWp = parcelRequire("6AvWp");

var $caGrw = parcelRequire("caGrw");

var $GbeHD = parcelRequire("GbeHD");

var $YcuAy = parcelRequire("YcuAy");

var $dMdBj = parcelRequire("dMdBj");

var $aYBRE = parcelRequire("aYBRE");

var $dkwAe = parcelRequire("dkwAe");

var $9VxEX = parcelRequire("9VxEX");

var $8ENVF = parcelRequire("8ENVF");

var $2a43t = parcelRequire("2a43t");

var $4QLZo = parcelRequire("4QLZo");

var $hRUGg = parcelRequire("hRUGg");

var $6Syfk = parcelRequire("6Syfk");

var $fopkM = parcelRequire("fopkM");

var $5xLgA = parcelRequire("5xLgA");

var $cWacD = parcelRequire("cWacD");

var $aT9VE = parcelRequire("aT9VE");

var $bzU8O = parcelRequire("bzU8O");

var $8tNzN = parcelRequire("8tNzN");

var $4m8st = parcelRequire("4m8st");

var $fjkAl = parcelRequire("fjkAl");

});
parcelRegister("ep8sG", function(module, exports) {

$parcel$export(module.exports, "simpleAbsImpl", () => $a7c9f6c99950c664$export$9e7ee8a1798ec2d5);
$parcel$export(module.exports, "absConfig", () => $a7c9f6c99950c664$export$d66f48648b9d5ec7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $csahy = parcelRequire("csahy");
function $a7c9f6c99950c664$export$9e7ee8a1798ec2d5(vals) {
    const resultValues = new Float32Array(vals.length);
    for(let i = 0; i < vals.length; ++i)resultValues[i] = Math.abs(vals[i]);
    return resultValues;
}
const $a7c9f6c99950c664$export$2335f513bbd82c6d = (args)=>{
    const { x: x } = args.inputs;
    const cpuBackend = args.backend;
    (0, $csahy.assertNotComplex)(x, 'abs');
    let resultValues = new Float32Array((0, $jjNRA).sizeFromShape(x.shape));
    const values = cpuBackend.data.get(x.dataId).values;
    resultValues = $a7c9f6c99950c664$export$9e7ee8a1798ec2d5(values);
    return cpuBackend.makeOutput(resultValues, x.shape, x.dtype);
};
const $a7c9f6c99950c664$export$d66f48648b9d5ec7 = {
    kernelName: (0, $hl418.Abs),
    backendName: 'cpu',
    kernelFunc: $a7c9f6c99950c664$export$2335f513bbd82c6d
};

});
parcelRegister("csahy", function(module, exports) {

$parcel$export(module.exports, "assertNotComplex", () => $9110135fad4c6fb0$export$1412c17b2531581a);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
function $9110135fad4c6fb0$export$1412c17b2531581a(tensor, opName) {
    if (!Array.isArray(tensor)) tensor = [
        tensor
    ];
    tensor.forEach((t)=>{
        if (t != null) (0, $jjNRA).assert(t.dtype !== 'complex64', ()=>`${opName} does not support complex64 tensors in the CPU backend.`);
    });
}

});


parcelRegister("e8yCG", function(module, exports) {

$parcel$export(module.exports, "addImpl", () => $a4acab724ac083eb$export$da57353b24bb5e2);
$parcel$export(module.exports, "add", () => $a4acab724ac083eb$export$e16d8520af44a096);
$parcel$export(module.exports, "addConfig", () => $a4acab724ac083eb$export$b1f3a580afb68e4c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $a4acab724ac083eb$export$da57353b24bb5e2 = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a + b);
const $a4acab724ac083eb$export$ace1d0de36b43ba2 = (0, $kgSwn.createComplexBinaryKernelImpl)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal + bReal,
        imag: aImag + bImag
    };
});
const $a4acab724ac083eb$export$e16d8520af44a096 = (0, $kgSwn.binaryKernelFunc)((0, $hl418.Add), $a4acab724ac083eb$export$da57353b24bb5e2, $a4acab724ac083eb$export$ace1d0de36b43ba2);
const $a4acab724ac083eb$export$b1f3a580afb68e4c = {
    kernelName: (0, $hl418.Add),
    backendName: 'cpu',
    kernelFunc: $a4acab724ac083eb$export$e16d8520af44a096
};

});
parcelRegister("jQJ39", function(module, exports) {

$parcel$export(module.exports, "createSimpleBinaryKernelImpl", () => $e735d1a14b8ad57c$export$28de919591fae5d9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");
function $e735d1a14b8ad57c$export$28de919591fae5d9(op) {
    return (aShape, bShape, aVals, bVals, dtype)=>{
        const newShape = (0, $7MaPk).assertAndGetBroadcastShape(aShape, bShape);
        const resultRank = newShape.length;
        const resultStrides = (0, $jjNRA).computeStrides(newShape);
        const resultSize = (0, $jjNRA).sizeFromShape(newShape);
        const result = (0, $jjNRA).getTypedArrayFromDType(dtype, resultSize);
        const aRank = aShape.length;
        const bRank = bShape.length;
        const aStrides = (0, $jjNRA).computeStrides(aShape);
        const bStrides = (0, $jjNRA).computeStrides(bShape);
        const aBroadcastDims = (0, $7MaPk).getBroadcastDims(aShape, newShape);
        const bBroadcastDims = (0, $7MaPk).getBroadcastDims(bShape, newShape);
        if (aBroadcastDims.length + bBroadcastDims.length === 0) for(let i = 0; i < result.length; ++i)result[i] = op(aVals[i % aVals.length], bVals[i % bVals.length]);
        else for(let i = 0; i < result.length; ++i){
            const loc = (0, $jjNRA).indexToLoc(i, resultRank, resultStrides);
            const aLoc = loc.slice(-aRank);
            aBroadcastDims.forEach((d)=>aLoc[d] = 0);
            const aIndex = (0, $jjNRA).locToIndex(aLoc, aRank, aStrides);
            const bLoc = loc.slice(-bRank);
            bBroadcastDims.forEach((d)=>bLoc[d] = 0);
            const bIndex = (0, $jjNRA).locToIndex(bLoc, bRank, bStrides);
            result[i] = op(aVals[aIndex], bVals[bIndex]);
        }
        return [
            result,
            newShape
        ];
    };
}

});

parcelRegister("kgSwn", function(module, exports) {

$parcel$export(module.exports, "binaryKernelFunc", () => $ec1f980b9bc029ed$export$29353c66e70e3e16);
$parcel$export(module.exports, "createComplexBinaryKernelImpl", () => $ec1f980b9bc029ed$export$79261d982c3c14a7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");

var $csahy = parcelRequire("csahy");

var $7LLjQ = parcelRequire("7LLjQ");

var $bwMVz = parcelRequire("bwMVz");
function $ec1f980b9bc029ed$export$29353c66e70e3e16(name, simpleImpl, complexImpl, dtype) {
    if (complexImpl == null) return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const cpuBackend = backend;
        (0, $csahy.assertNotComplex)([
            a,
            b
        ], name);
        const aVals = cpuBackend.data.get(a.dataId).values;
        const bVals = cpuBackend.data.get(b.dataId).values;
        const decodedAVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
        (0, $7MaPk).fromUint8ToStringArray(aVals) : aVals;
        const decodedBVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
        (0, $7MaPk).fromUint8ToStringArray(bVals) : bVals;
        const $dtype = dtype || a.dtype;
        const [resultData, resultShape] = simpleImpl(a.shape, b.shape, decodedAVals, decodedBVals, $dtype);
        return cpuBackend.makeTensorInfo(resultShape, $dtype, resultData);
    };
    return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const cpuBackend = backend;
        if (a.dtype === 'complex64' || b.dtype === 'complex64') {
            const $aComplex = (0, $7LLjQ.cast)({
                inputs: {
                    x: a
                },
                backend: cpuBackend,
                attrs: {
                    dtype: 'complex64'
                }
            });
            const $aComplexVals = cpuBackend.data.get($aComplex.dataId);
            const aReal = $aComplexVals.complexTensorInfos.real;
            const aImag = $aComplexVals.complexTensorInfos.imag;
            const aRealVals = cpuBackend.data.get(aReal.dataId).values;
            const aImagVals = cpuBackend.data.get(aImag.dataId).values;
            const $bComplex = (0, $7LLjQ.cast)({
                inputs: {
                    x: b
                },
                backend: cpuBackend,
                attrs: {
                    dtype: 'complex64'
                }
            });
            const $bComplexVals = cpuBackend.data.get($bComplex.dataId);
            const bReal = $bComplexVals.complexTensorInfos.real;
            const bImag = $bComplexVals.complexTensorInfos.imag;
            const bRealVals = cpuBackend.data.get(bReal.dataId).values;
            const bImagVals = cpuBackend.data.get(bImag.dataId).values;
            const [resultRealData, resultImagData, resultShape] = complexImpl(a.shape, b.shape, aRealVals, aImagVals, bRealVals, bImagVals);
            const resultReal = cpuBackend.makeTensorInfo(resultShape, 'float32', resultRealData);
            const resultImag = cpuBackend.makeTensorInfo(resultShape, 'float32', resultImagData);
            const result = (0, $bwMVz.complex)({
                inputs: {
                    real: resultReal,
                    imag: resultImag
                },
                backend: cpuBackend
            });
            cpuBackend.disposeIntermediateTensorInfo($aComplex);
            cpuBackend.disposeIntermediateTensorInfo($bComplex);
            cpuBackend.disposeIntermediateTensorInfo(resultReal);
            cpuBackend.disposeIntermediateTensorInfo(resultImag);
            return result;
        } else {
            const aVals = cpuBackend.data.get(a.dataId).values;
            const bVals = cpuBackend.data.get(b.dataId).values;
            const $dtype = dtype || a.dtype;
            const [resultData, resultShape] = simpleImpl(a.shape, b.shape, aVals, bVals, $dtype);
            return cpuBackend.makeTensorInfo(resultShape, $dtype, resultData);
        }
    };
}
function $ec1f980b9bc029ed$export$79261d982c3c14a7(op) {
    return (aShape, bShape, aRealVals, aImagVals, bRealVals, bImagVals)=>{
        const resultShape = (0, $7MaPk).assertAndGetBroadcastShape(aShape, bShape);
        const resultSize = (0, $jjNRA).sizeFromShape(resultShape);
        const resultRank = resultShape.length;
        const resultStrides = (0, $jjNRA).computeStrides(resultShape);
        const resultRealVals = (0, $jjNRA).getTypedArrayFromDType('float32', resultSize);
        const resultImagVals = (0, $jjNRA).getTypedArrayFromDType('float32', resultSize);
        const aBroadcastDims = (0, $7MaPk).getBroadcastDims(aShape, resultShape);
        const bBroadcastDims = (0, $7MaPk).getBroadcastDims(bShape, resultShape);
        const aVals = (0, $7MaPk).mergeRealAndImagArrays(aRealVals, aImagVals);
        const bVals = (0, $7MaPk).mergeRealAndImagArrays(bRealVals, bImagVals);
        const aRank = aShape.length;
        const aStrides = (0, $jjNRA).computeStrides(aShape);
        const bRank = bShape.length;
        const bStrides = (0, $jjNRA).computeStrides(bShape);
        if (aBroadcastDims.length + bBroadcastDims.length === 0) for(let i = 0; i < resultRealVals.length; i++){
            const aIdx = i % aVals.length;
            const bIdx = i % bVals.length;
            const result = op(aVals[aIdx * 2], aVals[aIdx * 2 + 1], bVals[bIdx * 2], bVals[bIdx * 2 + 1]);
            resultRealVals[i] = result.real;
            resultImagVals[i] = result.imag;
        }
        else for(let i = 0; i < resultRealVals.length; i++){
            const loc = (0, $jjNRA).indexToLoc(i, resultRank, resultStrides);
            const aLoc = loc.slice(-aRank);
            aBroadcastDims.forEach((d)=>aLoc[d] = 0);
            const aIndex = (0, $jjNRA).locToIndex(aLoc, aRank, aStrides);
            const bLoc = loc.slice(-bRank);
            bBroadcastDims.forEach((d)=>bLoc[d] = 0);
            const bIndex = (0, $jjNRA).locToIndex(bLoc, bRank, bStrides);
            const opResult = op(aVals[aIndex * 2], aVals[aIndex * 2 + 1], bVals[bIndex * 2], bVals[bIndex * 2 + 1]);
            resultRealVals[i] = opResult.real;
            resultImagVals[i] = opResult.imag;
        }
        return [
            resultRealVals,
            resultImagVals,
            resultShape
        ];
    };
}

});
parcelRegister("7LLjQ", function(module, exports) {

$parcel$export(module.exports, "castImpl", () => $5a81a0c9d5a7fc55$export$aeeb3b33e2cee0c5);
$parcel$export(module.exports, "cast", () => $5a81a0c9d5a7fc55$export$f2db7d5238e1d23f);
$parcel$export(module.exports, "castConfig", () => $5a81a0c9d5a7fc55$export$ac4d0f0f3927a8f3);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $jQJ39 = parcelRequire("jQJ39");

var $3THkf = parcelRequire("3THkf");

var $bwMVz = parcelRequire("bwMVz");

var $lcqBv = parcelRequire("lcqBv");

var $linqd = parcelRequire("linqd");
function $5a81a0c9d5a7fc55$export$aeeb3b33e2cee0c5(values, shape, inputType, dtype) {
    if (dtype === 'int32') {
        const resultValues = Int32Array.from(values);
        return [
            shape,
            'int32',
            resultValues
        ];
    }
    if (dtype === 'bool') {
        // This is essentially the result of notEqual(x, 0). We avoid using
        // kernel notEqual to avoid circular dependency, i.e. binary_utils ->
        // cast -> notEqual -> binary_utils.
        const zero = (0, $jjNRA).toTypedArray([
            0
        ], inputType);
        const [resultData, resultShape] = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a !== b ? 1 : 0)(shape, [], values, zero, 'bool');
        return [
            resultShape,
            'bool',
            resultData
        ];
    }
    throw new Error(`Error in Cast: failed to cast ${inputType} to ${dtype}`);
}
function $5a81a0c9d5a7fc55$export$f2db7d5238e1d23f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dtype: dtype } = attrs;
    // Casting to complex64.
    if (dtype === 'complex64') {
        if (x.dtype === 'complex64') return (0, $lcqBv.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        const zerosTensorInfo = (0, $3THkf.zeros)(backend, x.shape, x.dtype);
        const floatX = $5a81a0c9d5a7fc55$export$f2db7d5238e1d23f({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const result = (0, $bwMVz.complex)({
            inputs: {
                real: floatX,
                imag: zerosTensorInfo
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(zerosTensorInfo);
        backend.disposeIntermediateTensorInfo(floatX);
        return result;
    }
    // Casting from complex64
    if (x.dtype === 'complex64') {
        const realPart = (0, $linqd.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const result = $5a81a0c9d5a7fc55$export$f2db7d5238e1d23f({
            inputs: {
                x: realPart
            },
            backend: backend,
            attrs: {
                dtype: dtype
            }
        });
        backend.disposeIntermediateTensorInfo(realPart);
        return result;
    }
    if (!(0, $jjNRA).hasEncodingLoss(x.dtype, dtype)) {
        // We don't change the underlying data, since we cast to higher
        // precision.
        const result = (0, $lcqBv.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        return {
            dataId: result.dataId,
            shape: result.shape,
            dtype: dtype
        };
    }
    const values = backend.data.get(x.dataId).values;
    const [resultShape, resultType, resultData] = $5a81a0c9d5a7fc55$export$aeeb3b33e2cee0c5(values, x.shape, x.dtype, dtype);
    return backend.makeTensorInfo(resultShape, resultType, resultData);
}
const $5a81a0c9d5a7fc55$export$ac4d0f0f3927a8f3 = {
    kernelName: (0, $hl418.Cast),
    backendName: 'cpu',
    kernelFunc: $5a81a0c9d5a7fc55$export$f2db7d5238e1d23f
};

});
parcelRegister("3THkf", function(module, exports) {

$parcel$export(module.exports, "zeros", () => $2d681db12026e5bf$export$4445a00dafa2633b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");

var $bwMVz = parcelRequire("bwMVz");
function $2d681db12026e5bf$export$4445a00dafa2633b(backend, shape, dtype = 'float32') {
    if (dtype === 'complex64') {
        const real = $2d681db12026e5bf$export$4445a00dafa2633b(backend, shape, 'float32');
        const imag = $2d681db12026e5bf$export$4445a00dafa2633b(backend, shape, 'float32');
        return (0, $bwMVz.complex)({
            inputs: {
                real: real,
                imag: imag
            },
            backend: backend
        });
    }
    const values = (0, $jjNRA).makeZerosTypedArray((0, $jjNRA).sizeFromShape(shape), dtype);
    return backend.makeTensorInfo(shape, dtype, values);
}

});
parcelRegister("bwMVz", function(module, exports) {

$parcel$export(module.exports, "complex", () => $8648a2d97d5180a4$export$83a0e34f1302825b);
$parcel$export(module.exports, "complexConfig", () => $8648a2d97d5180a4$export$67917f7910d27fd8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
function $8648a2d97d5180a4$export$83a0e34f1302825b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { real: real, imag: imag } = inputs;
    const realVals = backend.data.get(real.dataId).values;
    const imagVals = backend.data.get(imag.dataId).values;
    const complexInfo = backend.makeTensorInfo(real.shape, 'complex64');
    const complex = backend.data.get(complexInfo.dataId);
    // The complex tensor owns the underlying real and imag tensorInfos, only the
    // complex tensor tracks refCount, when complexData is disposed the
    // underlying tensorData will be disposed.
    complex.complexTensorInfos = {
        real: backend.makeTensorInfo(real.shape, 'float32', realVals),
        imag: backend.makeTensorInfo(imag.shape, 'float32', imagVals)
    };
    return complexInfo;
}
const $8648a2d97d5180a4$export$67917f7910d27fd8 = {
    kernelName: (0, $hl418.Complex),
    backendName: 'cpu',
    kernelFunc: $8648a2d97d5180a4$export$83a0e34f1302825b
};

});


parcelRegister("lcqBv", function(module, exports) {

$parcel$export(module.exports, "identity", () => $f6ef5af6c2f181e6$export$f0954fd7d5368655);
$parcel$export(module.exports, "identityConfig", () => $f6ef5af6c2f181e6$export$c426d3942537ad84);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
function $f6ef5af6c2f181e6$export$f0954fd7d5368655(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: x.shape,
        dtype: x.dtype
    };
}
const $f6ef5af6c2f181e6$export$c426d3942537ad84 = {
    kernelName: (0, $hl418.Identity),
    backendName: 'cpu',
    kernelFunc: $f6ef5af6c2f181e6$export$f0954fd7d5368655
};

});

parcelRegister("linqd", function(module, exports) {

$parcel$export(module.exports, "real", () => $f80d7280b12b6047$export$9fc57fb453bdbd67);
$parcel$export(module.exports, "realConfig", () => $f80d7280b12b6047$export$4b7bce57557ae68b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
function $f80d7280b12b6047$export$9fc57fb453bdbd67(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const real = backend.data.get(input.dataId).complexTensorInfos.real;
    const realVal = backend.data.get(real.dataId).values;
    // When complex tensor is disposed, its underlying parts will be disposed too.
    // Make new tensor out of the real value of the complex. This makes sure the
    // value is still accessible even if complex tensor is disposed.
    return backend.makeTensorInfo(real.shape, real.dtype, realVal);
}
const $f80d7280b12b6047$export$4b7bce57557ae68b = {
    kernelName: (0, $hl418.Real),
    backendName: 'cpu',
    kernelFunc: $f80d7280b12b6047$export$9fc57fb453bdbd67
};

});




parcelRegister("34gHf", function(module, exports) {

$parcel$export(module.exports, "bincountImpl", () => $23beb26606c25d94$export$8e4da6ec633bf0a6);
$parcel$export(module.exports, "bincountReduceImpl", () => $23beb26606c25d94$export$486b8d48edd28ba5);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $iG87S = parcelRequire("iG87S");
var $jjNRA = parcelRequire("jjNRA");
function $23beb26606c25d94$export$8e4da6ec633bf0a6(xVals, weightsVals, weightsDtype, weightsShape, size) {
    const weightsSize = (0, $jjNRA).sizeFromShape(weightsShape);
    const outVals = (0, $jjNRA).makeZerosTypedArray(size, weightsDtype);
    for(let i = 0; i < xVals.length; i++){
        const value = xVals[i];
        if (value < 0) throw new Error('Input x must be non-negative!');
        if (value >= size) continue;
        if (weightsSize > 0) outVals[value] += weightsVals[i];
        else outVals[value] += 1;
    }
    return outVals;
}
function $23beb26606c25d94$export$486b8d48edd28ba5(xBuf, weightsBuf, size, binaryOutput = false) {
    const numRows = xBuf.shape[0];
    const numCols = xBuf.shape[1];
    const outBuf = (0, $iG87S.buffer)([
        numRows,
        size
    ], weightsBuf.dtype);
    for(let i = 0; i < numRows; i++)for(let j = 0; j < numCols; j++){
        const value = xBuf.get(i, j);
        if (value < 0) throw new Error('Input x must be non-negative!');
        if (value >= size) continue;
        if (binaryOutput) outBuf.set(1, i, value);
        else if (weightsBuf.size > 0) outBuf.set(outBuf.get(i, value) + weightsBuf.get(i, j), i, value);
        else outBuf.set(outBuf.get(i, value) + 1, i, value);
    }
    return outBuf;
}

});

parcelRegister("eYl2h", function(module, exports) {

$parcel$export(module.exports, "bitwiseAndImpl", () => $02d01cd9130bfdfa$export$54cf4ba005fa5753);
$parcel$export(module.exports, "bitwiseAndConfig", () => $02d01cd9130bfdfa$export$6d53927dafa38bf9);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $02d01cd9130bfdfa$export$54cf4ba005fa5753 = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a & b);
const $02d01cd9130bfdfa$export$84529b0ad3b42cd1 = (0, $kgSwn.binaryKernelFunc)((0, $hl418.BitwiseAnd), $02d01cd9130bfdfa$export$54cf4ba005fa5753);
const $02d01cd9130bfdfa$export$6d53927dafa38bf9 = {
    kernelName: (0, $hl418.BitwiseAnd),
    backendName: 'cpu',
    kernelFunc: $02d01cd9130bfdfa$export$84529b0ad3b42cd1
};

});

parcelRegister("bs8Xr", function(module, exports) {

$parcel$export(module.exports, "ceilImpl", () => $85694209e73f1378$export$72486f20c97f6da8);
$parcel$export(module.exports, "ceilConfig", () => $85694209e73f1378$export$df387212b1898306);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $19W3p = parcelRequire("19W3p");

var $l6afd = parcelRequire("l6afd");
const $85694209e73f1378$export$72486f20c97f6da8 = (0, $19W3p.createSimpleUnaryImpl)((xi)=>Math.ceil(xi));
const $85694209e73f1378$export$803ce6b71a0a94b2 = (0, $l6afd.unaryKernelFuncFromImpl)((0, $hl418.Ceil), $85694209e73f1378$export$72486f20c97f6da8);
const $85694209e73f1378$export$df387212b1898306 = {
    kernelName: (0, $hl418.Ceil),
    backendName: 'cpu',
    kernelFunc: $85694209e73f1378$export$803ce6b71a0a94b2
};

});
parcelRegister("19W3p", function(module, exports) {

$parcel$export(module.exports, "createSimpleUnaryImpl", () => $0d83a9feb8cc310c$export$ef8b4452872ef3fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
function $0d83a9feb8cc310c$export$ef8b4452872ef3fc(op) {
    return (values, dtype, attrs)=>{
        const newValues = (0, $jjNRA).getArrayFromDType(dtype, values.length);
        for(let i = 0; i < values.length; ++i)newValues[i] = op(values[i], attrs);
        return newValues;
    };
}

});

parcelRegister("l6afd", function(module, exports) {

$parcel$export(module.exports, "unaryKernelFunc", () => $f5c21ad6971617ad$export$ba4daf5748026fba);
$parcel$export(module.exports, "unaryKernelFuncFromImpl", () => $f5c21ad6971617ad$export$34f6865a07ad09b6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");

var $csahy = parcelRequire("csahy");

var $19W3p = parcelRequire("19W3p");
function $f5c21ad6971617ad$export$ba4daf5748026fba(name, op, dtype) {
    const impl = (0, $19W3p.createSimpleUnaryImpl)(op);
    return $f5c21ad6971617ad$export$34f6865a07ad09b6(name, impl, dtype);
}
function $f5c21ad6971617ad$export$34f6865a07ad09b6(name, unaryImpl, dtype) {
    return ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        (0, $csahy.assertNotComplex)(x, name);
        const cpuBackend = backend;
        const values = cpuBackend.data.get(x.dataId).values;
        let decoded;
        if (x.dtype === 'string') {
            if (!Array.isArray(values)) throw new Error('String tensor\'s value was not an instance of Array');
            decoded = (0, $7MaPk).fromUint8ToStringArray(values);
        } else decoded = values;
        const $dtype = dtype || x.dtype;
        const newValues = unaryImpl(decoded, $dtype, attrs);
        return cpuBackend.makeTensorInfo(x.shape, $dtype, newValues);
    };
}

});


parcelRegister("3wcyL", function(module, exports) {

$parcel$export(module.exports, "concatImpl", () => $28fe1a54ae03984c$export$777da59f594f497d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");
function $28fe1a54ae03984c$export$777da59f594f497d(inputs, outShape, dtype, simplyConcat) {
    const outVals = (0, $jjNRA).getArrayFromDType(dtype, (0, $jjNRA).sizeFromShape(outShape));
    if (simplyConcat && dtype !== 'string') {
        // Use built-in TypedArray.set() method for speed.
        let offset = 0;
        inputs.forEach((input)=>{
            const size = (0, $jjNRA).sizeFromShape(input.shape);
            outVals.set(input.vals, offset);
            offset += size;
        });
    } else {
        let colOffset = 0;
        inputs.forEach((input)=>{
            const decodedData = dtype === 'string' ? (0, $7MaPk).fromUint8ToStringArray(input.vals) : input.vals;
            let tIdx = 0;
            for(let row = 0; row < input.shape[0]; ++row){
                const resIdx = row * outShape[1] + colOffset;
                for(let col = 0; col < input.shape[1]; ++col)outVals[resIdx + col] = decodedData[tIdx++];
            }
            colOffset += input.shape[1];
        });
    }
    return outVals;
}

});

parcelRegister("diO4l", function(module, exports) {

$parcel$export(module.exports, "equalImpl", () => $9af3cb7d5e0d6c04$export$437b1c87795f120c);
$parcel$export(module.exports, "equal", () => $9af3cb7d5e0d6c04$export$411ce8e5a71e3069);
$parcel$export(module.exports, "equalConfig", () => $9af3cb7d5e0d6c04$export$3c8bc3d8ee318217);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $9af3cb7d5e0d6c04$export$437b1c87795f120c = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a === b ? 1 : 0);
const $9af3cb7d5e0d6c04$export$411ce8e5a71e3069 = (0, $kgSwn.binaryKernelFunc)((0, $hl418.Equal), $9af3cb7d5e0d6c04$export$437b1c87795f120c, null, 'bool');
const $9af3cb7d5e0d6c04$export$3c8bc3d8ee318217 = {
    kernelName: (0, $hl418.Equal),
    backendName: 'cpu',
    kernelFunc: $9af3cb7d5e0d6c04$export$411ce8e5a71e3069
};

});

parcelRegister("2ANRn", function(module, exports) {

$parcel$export(module.exports, "expImpl", () => $1e359eaf71040cb9$export$823000b70594f385);
$parcel$export(module.exports, "exp", () => $1e359eaf71040cb9$export$b310ec824aaee37f);
$parcel$export(module.exports, "expConfig", () => $1e359eaf71040cb9$export$2fd7ea0fcf021f34);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $19W3p = parcelRequire("19W3p");

var $l6afd = parcelRequire("l6afd");
const $1e359eaf71040cb9$export$823000b70594f385 = (0, $19W3p.createSimpleUnaryImpl)((xi)=>Math.exp(xi));
const $1e359eaf71040cb9$export$b310ec824aaee37f = (0, $l6afd.unaryKernelFuncFromImpl)((0, $hl418.Exp), $1e359eaf71040cb9$export$823000b70594f385, 'float32');
const $1e359eaf71040cb9$export$2fd7ea0fcf021f34 = {
    kernelName: (0, $hl418.Exp),
    backendName: 'cpu',
    kernelFunc: $1e359eaf71040cb9$export$b310ec824aaee37f
};

});

parcelRegister("jqUkN", function(module, exports) {

$parcel$export(module.exports, "expm1Impl", () => $e25c24db8ac91e73$export$44f6c1b1ff8db911);
$parcel$export(module.exports, "expm1Config", () => $e25c24db8ac91e73$export$16db8a08b36f938);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $19W3p = parcelRequire("19W3p");

var $l6afd = parcelRequire("l6afd");
const $e25c24db8ac91e73$export$44f6c1b1ff8db911 = (0, $19W3p.createSimpleUnaryImpl)((xi)=>Math.expm1(xi));
const $e25c24db8ac91e73$export$b6c0a80d46d3391d = (0, $l6afd.unaryKernelFuncFromImpl)((0, $hl418.Expm1), $e25c24db8ac91e73$export$44f6c1b1ff8db911);
const $e25c24db8ac91e73$export$16db8a08b36f938 = {
    kernelName: (0, $hl418.Expm1),
    backendName: 'cpu',
    kernelFunc: $e25c24db8ac91e73$export$b6c0a80d46d3391d
};

});

parcelRegister("Jvx9v", function(module, exports) {

$parcel$export(module.exports, "floorImpl", () => $088caa05e84a8fbe$export$c365361068e97c87);
$parcel$export(module.exports, "floorConfig", () => $088caa05e84a8fbe$export$7e9a0f96fa6bd01c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $19W3p = parcelRequire("19W3p");

var $l6afd = parcelRequire("l6afd");
const $088caa05e84a8fbe$export$c365361068e97c87 = (0, $19W3p.createSimpleUnaryImpl)((xi)=>Math.floor(xi));
const $088caa05e84a8fbe$export$a3fe094919f356fd = (0, $l6afd.unaryKernelFuncFromImpl)((0, $hl418.Floor), $088caa05e84a8fbe$export$c365361068e97c87);
const $088caa05e84a8fbe$export$7e9a0f96fa6bd01c = {
    kernelName: (0, $hl418.Floor),
    backendName: 'cpu',
    kernelFunc: $088caa05e84a8fbe$export$a3fe094919f356fd
};

});

parcelRegister("hj1kT", function(module, exports) {

$parcel$export(module.exports, "floorDivImpl", () => $c9953f52bad222db$export$9b7f64e28e98c78e);
$parcel$export(module.exports, "floorDivConfig", () => $c9953f52bad222db$export$7eac933a0c7fd37f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $c9953f52bad222db$export$9b7f64e28e98c78e = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>Math.floor(a / b));
const $c9953f52bad222db$export$112397bc52715a8 = (0, $kgSwn.binaryKernelFunc)((0, $hl418.FloorDiv), $c9953f52bad222db$export$9b7f64e28e98c78e, null, 'int32');
const $c9953f52bad222db$export$7eac933a0c7fd37f = {
    kernelName: (0, $hl418.FloorDiv),
    backendName: 'cpu',
    kernelFunc: $c9953f52bad222db$export$112397bc52715a8
};

});

parcelRegister("cC9SN", function(module, exports) {

$parcel$export(module.exports, "gatherNdImpl", () => $92f0b32f09132bbf$export$eed1912b07a3c4d5);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $iG87S = parcelRequire("iG87S");
function $92f0b32f09132bbf$export$eed1912b07a3c4d5(indicesData, paramsBuf, dtype, numSlices, sliceRank, sliceSize, strides, paramsShape, paramsSize) {
    const outBuf = (0, $iG87S.buffer)([
        numSlices,
        sliceSize
    ], dtype);
    for(let i = 0; i < numSlices; i++){
        const index = [];
        let flattenIndex = 0;
        for(let j = 0; j < sliceRank; j++){
            const dim = indicesData[i * sliceRank + j];
            flattenIndex += dim * strides[j];
            index.push(dim);
        }
        if (flattenIndex < 0 || flattenIndex >= paramsSize / sliceSize) throw new Error(`Invalid indices: ${index} does not index into ${paramsShape}`);
        for(let k = 0; k < sliceSize; k++)outBuf.values[i * sliceSize + k] = paramsBuf.get(...paramsBuf.indexToLoc(flattenIndex * sliceSize + k));
    }
    return outBuf;
}

});

parcelRegister("hNUKd", function(module, exports) {

$parcel$export(module.exports, "gatherV2Impl", () => $cf630781bd63387f$export$d7b732f2e62ccc09);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $iG87S = parcelRequire("iG87S");
function $cf630781bd63387f$export$d7b732f2e62ccc09(xBuf, indicesBuf, flattenOutputShape) {
    const outBuf = (0, $iG87S.buffer)(flattenOutputShape, xBuf.dtype);
    for(let i = 0; i < outBuf.size; ++i){
        const newLoc = outBuf.indexToLoc(i);
        const originalLoc = newLoc.slice();
        const batchIdx = originalLoc[0];
        const indicesIdx = originalLoc[2];
        const indicesIndex = indicesBuf.locToIndex([
            batchIdx,
            indicesIdx
        ]);
        originalLoc[2] = indicesBuf.values[indicesIndex];
        const originalIndex = xBuf.locToIndex(originalLoc);
        if (0 <= originalIndex && originalIndex < xBuf.values.length) outBuf.values[i] = xBuf.values[originalIndex];
         // Else, index is out of bounds, so leave the default zero val in outBuf.
    }
    return outBuf;
}

});

parcelRegister("2Apjw", function(module, exports) {

$parcel$export(module.exports, "greaterImpl", () => $1e229458f052f892$export$bec57aa1d63b78bc);
$parcel$export(module.exports, "greaterConfig", () => $1e229458f052f892$export$8c4f7e92d92310f8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $1e229458f052f892$export$bec57aa1d63b78bc = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a > b ? 1 : 0);
const $1e229458f052f892$export$9dca161faaf6308b = (0, $kgSwn.binaryKernelFunc)((0, $hl418.Greater), $1e229458f052f892$export$bec57aa1d63b78bc, null, 'bool');
const $1e229458f052f892$export$8c4f7e92d92310f8 = {
    kernelName: (0, $hl418.Greater),
    backendName: 'cpu',
    kernelFunc: $1e229458f052f892$export$9dca161faaf6308b
};

});

parcelRegister("9yHtq", function(module, exports) {

$parcel$export(module.exports, "greaterEqualImpl", () => $6f5903011bfd61d0$export$3cea60aeb61ae586);
$parcel$export(module.exports, "greaterEqualConfig", () => $6f5903011bfd61d0$export$7a6926f9fcac24ca);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $6f5903011bfd61d0$export$3cea60aeb61ae586 = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a >= b ? 1 : 0);
const $6f5903011bfd61d0$export$c2fd4164cadc1fa2 = (0, $kgSwn.binaryKernelFunc)((0, $hl418.GreaterEqual), $6f5903011bfd61d0$export$3cea60aeb61ae586, null, 'bool');
const $6f5903011bfd61d0$export$7a6926f9fcac24ca = {
    kernelName: (0, $hl418.GreaterEqual),
    backendName: 'cpu',
    kernelFunc: $6f5903011bfd61d0$export$c2fd4164cadc1fa2
};

});

parcelRegister("jJNGT", function(module, exports) {

$parcel$export(module.exports, "lessImpl", () => $e5e8c3d94a7b43b0$export$d4d22ddbe6cd91a5);
$parcel$export(module.exports, "lessConfig", () => $e5e8c3d94a7b43b0$export$8d4530ce8b6ffc3c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $e5e8c3d94a7b43b0$export$d4d22ddbe6cd91a5 = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a < b ? 1 : 0);
const $e5e8c3d94a7b43b0$export$bb1a638da8ad190f = (0, $kgSwn.binaryKernelFunc)((0, $hl418.Less), $e5e8c3d94a7b43b0$export$d4d22ddbe6cd91a5, null, 'bool');
const $e5e8c3d94a7b43b0$export$8d4530ce8b6ffc3c = {
    kernelName: (0, $hl418.Less),
    backendName: 'cpu',
    kernelFunc: $e5e8c3d94a7b43b0$export$bb1a638da8ad190f
};

});

parcelRegister("bwE16", function(module, exports) {

$parcel$export(module.exports, "lessEqualImpl", () => $8641b95e4d233276$export$27397851733876fa);
$parcel$export(module.exports, "lessEqualConfig", () => $8641b95e4d233276$export$9f26bd257393dd8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $8641b95e4d233276$export$27397851733876fa = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a <= b ? 1 : 0);
const $8641b95e4d233276$export$c24ad19a692bb92 = (0, $kgSwn.binaryKernelFunc)((0, $hl418.LessEqual), $8641b95e4d233276$export$27397851733876fa, null, 'bool');
const $8641b95e4d233276$export$9f26bd257393dd8 = {
    kernelName: (0, $hl418.LessEqual),
    backendName: 'cpu',
    kernelFunc: $8641b95e4d233276$export$c24ad19a692bb92
};

});

parcelRegister("6U5ue", function(module, exports) {

$parcel$export(module.exports, "linSpaceImpl", () => $506c3a94fd92a48f$export$31412d657cd1cc08);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
function $506c3a94fd92a48f$export$31412d657cd1cc08(start, stop, num) {
    const step = (stop - start) / (num - 1);
    const values = (0, $jjNRA).makeZerosTypedArray(num, 'float32');
    values[0] = start;
    for(let i = 1; i < values.length; i++)values[i] = values[i - 1] + step;
    return values;
}

});

parcelRegister("2La7K", function(module, exports) {

$parcel$export(module.exports, "logImpl", () => $2027d2fb99bf520d$export$8a107ec4d5b0e907);
$parcel$export(module.exports, "logConfig", () => $2027d2fb99bf520d$export$a4ae1f00643ddd14);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $19W3p = parcelRequire("19W3p");

var $l6afd = parcelRequire("l6afd");
const $2027d2fb99bf520d$export$8a107ec4d5b0e907 = (0, $19W3p.createSimpleUnaryImpl)((xi)=>Math.log(xi));
const $2027d2fb99bf520d$export$bef1f36f5486a6a3 = (0, $l6afd.unaryKernelFuncFromImpl)((0, $hl418.Log), $2027d2fb99bf520d$export$8a107ec4d5b0e907);
const $2027d2fb99bf520d$export$a4ae1f00643ddd14 = {
    kernelName: (0, $hl418.Log),
    backendName: 'cpu',
    kernelFunc: $2027d2fb99bf520d$export$bef1f36f5486a6a3
};

});

parcelRegister("cjSsc", function(module, exports) {

$parcel$export(module.exports, "maxImpl", () => $8f817fca98ff3694$export$23c9b99bdac85be0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
function $8f817fca98ff3694$export$23c9b99bdac85be0(aVals, reduceSize, outShape, dtype) {
    const vals = (0, $jjNRA).getTypedArrayFromDType(dtype, (0, $jjNRA).sizeFromShape(outShape));
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let max = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (Number.isNaN(value) || value > max) max = value;
        }
        vals[i] = max;
    }
    return vals;
}

});

parcelRegister("IzL7H", function(module, exports) {

$parcel$export(module.exports, "maximumImpl", () => $085fd92da62b3f8a$export$4e233ba825c9b60e);
$parcel$export(module.exports, "maximumConfig", () => $085fd92da62b3f8a$export$45b97bdc342e72a2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $085fd92da62b3f8a$export$4e233ba825c9b60e = (0, $jQJ39.createSimpleBinaryKernelImpl)((aValue, bValue)=>Math.max(aValue, bValue));
const $085fd92da62b3f8a$export$b25e0be55f42c9a = (0, $kgSwn.binaryKernelFunc)((0, $hl418.Maximum), $085fd92da62b3f8a$export$4e233ba825c9b60e);
const $085fd92da62b3f8a$export$45b97bdc342e72a2 = {
    kernelName: (0, $hl418.Maximum),
    backendName: 'cpu',
    kernelFunc: $085fd92da62b3f8a$export$b25e0be55f42c9a
};

});

parcelRegister("g7Z3x", function(module, exports) {

$parcel$export(module.exports, "minimumImpl", () => $bbdca93e5777cf36$export$756c08a3fa64d43);
$parcel$export(module.exports, "minimumConfig", () => $bbdca93e5777cf36$export$ea24ffbbbce8d546);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $bbdca93e5777cf36$export$756c08a3fa64d43 = (0, $jQJ39.createSimpleBinaryKernelImpl)((aValue, bValue)=>Math.min(aValue, bValue));
const $bbdca93e5777cf36$export$916782c1f0ddb132 = (0, $kgSwn.binaryKernelFunc)((0, $hl418.Minimum), $bbdca93e5777cf36$export$756c08a3fa64d43);
const $bbdca93e5777cf36$export$ea24ffbbbce8d546 = {
    kernelName: (0, $hl418.Minimum),
    backendName: 'cpu',
    kernelFunc: $bbdca93e5777cf36$export$916782c1f0ddb132
};

});

parcelRegister("gQOIy", function(module, exports) {

$parcel$export(module.exports, "multiplyImpl", () => $c448d81d39befc98$export$ac59ae2be94ddda3);
$parcel$export(module.exports, "multiply", () => $c448d81d39befc98$export$2060d2db72cce88f);
$parcel$export(module.exports, "multiplyConfig", () => $c448d81d39befc98$export$745576778aafee88);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $c448d81d39befc98$export$ac59ae2be94ddda3 = (0, $jQJ39.createSimpleBinaryKernelImpl)((aValue, bValue)=>aValue * bValue);
const $c448d81d39befc98$export$93ff634b9c7cb5b9 = (0, $kgSwn.createComplexBinaryKernelImpl)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal * bReal - aImag * bImag,
        imag: aReal * bImag + aImag * bReal
    };
});
const $c448d81d39befc98$export$2060d2db72cce88f = (0, $kgSwn.binaryKernelFunc)((0, $hl418.Multiply), $c448d81d39befc98$export$ac59ae2be94ddda3, $c448d81d39befc98$export$93ff634b9c7cb5b9);
const $c448d81d39befc98$export$745576778aafee88 = {
    kernelName: (0, $hl418.Multiply),
    backendName: 'cpu',
    kernelFunc: $c448d81d39befc98$export$2060d2db72cce88f
};

});

parcelRegister("9NYY4", function(module, exports) {

$parcel$export(module.exports, "negImpl", () => $7237fb9fd86136d2$export$e9053236ce0e659b);
$parcel$export(module.exports, "negConfig", () => $7237fb9fd86136d2$export$cc7b18b8229c3db);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $csahy = parcelRequire("csahy");

var $gQOIy = parcelRequire("gQOIy");
function $7237fb9fd86136d2$export$e9053236ce0e659b(xVals, xShape, xDtype) {
    const minusOne = (0, $jjNRA).createScalarValue(-1, xDtype);
    return (0, $gQOIy.multiplyImpl)([], xShape, minusOne, xVals, xDtype);
}
function $7237fb9fd86136d2$export$d9493ff0dfa0fdd5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    (0, $csahy.assertNotComplex)(x, 'neg');
    const xVals = backend.data.get(x.dataId).values;
    const [res, newShape] = $7237fb9fd86136d2$export$e9053236ce0e659b(xVals, x.shape, x.dtype);
    return backend.makeTensorInfo(newShape, x.dtype, res);
}
const $7237fb9fd86136d2$export$cc7b18b8229c3db = {
    kernelName: (0, $hl418.Neg),
    backendName: 'cpu',
    kernelFunc: $7237fb9fd86136d2$export$d9493ff0dfa0fdd5
};

});

parcelRegister("QHoEG", function(module, exports) {

$parcel$export(module.exports, "notEqualImpl", () => $09e6851de9045a29$export$eaea354630818ed4);
$parcel$export(module.exports, "notEqualConfig", () => $09e6851de9045a29$export$d003d4d7e1500775);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $09e6851de9045a29$export$eaea354630818ed4 = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a !== b ? 1 : 0);
const $09e6851de9045a29$export$53a6892c50694894 = (0, $kgSwn.binaryKernelFunc)((0, $hl418.NotEqual), $09e6851de9045a29$export$eaea354630818ed4, null, 'bool');
const $09e6851de9045a29$export$d003d4d7e1500775 = {
    kernelName: (0, $hl418.NotEqual),
    backendName: 'cpu',
    kernelFunc: $09e6851de9045a29$export$53a6892c50694894
};

});

parcelRegister("86TES", function(module, exports) {

$parcel$export(module.exports, "prodImpl", () => $5e7a0eda1307e836$export$a3c8a5271f6bb700);
$parcel$export(module.exports, "prodConfig", () => $5e7a0eda1307e836$export$d556aa935cef5c0c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $2MDja = parcelRequire("2MDja");
var $jjNRA = parcelRequire("jjNRA");

var $csahy = parcelRequire("csahy");

var $EOTYn = parcelRequire("EOTYn");
function $5e7a0eda1307e836$export$a3c8a5271f6bb700(xShape, xDtype, xVals, reductionAxes) {
    const [outShape, reduceShape] = (0, $7MaPk).computeOutAndReduceShapes(xShape, reductionAxes);
    const outDtype = (0, $2MDja.upcastType)(xDtype, 'int32');
    const outVals = (0, $jjNRA).makeZerosTypedArray((0, $jjNRA).sizeFromShape(outShape), outDtype);
    const reduceSize = (0, $jjNRA).sizeFromShape(reduceShape);
    for(let i = 0; i < outVals.length; ++i){
        const offset = i * reduceSize;
        let prod = 1;
        for(let j = 0; j < reduceSize; ++j)prod *= xVals[offset + j];
        outVals[i] = prod;
    }
    return {
        outVals: outVals,
        outShape: outShape,
        outDtype: outDtype
    };
}
function $5e7a0eda1307e836$export$5e143010dea16c85(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $csahy.assertNotComplex)(x, 'prod');
    const xRank = x.shape.length;
    const axes = (0, $jjNRA).parseAxisParam(axis, x.shape);
    const permutation = (0, $7MaPk).getAxesPermutation(axes, xRank);
    let reductionAxes = axes;
    let permutedX = x;
    const intermediateTensorInfos = [];
    if (permutation != null) {
        permutedX = (0, $EOTYn.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        intermediateTensorInfos.push(permutedX);
        reductionAxes = (0, $7MaPk).getInnerMostAxes(reductionAxes.length, xRank);
    }
    const xVals = backend.data.get(permutedX.dataId).values;
    const { outVals: outVals, outShape: outShape, outDtype: outDtype } = $5e7a0eda1307e836$export$a3c8a5271f6bb700(permutedX.shape, permutedX.dtype, xVals, reductionAxes);
    let resultShape = outShape;
    if (keepDims) resultShape = (0, $7MaPk).expandShapeToKeepDim(outShape, axes);
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return backend.makeTensorInfo(resultShape, outDtype, outVals);
}
const $5e7a0eda1307e836$export$d556aa935cef5c0c = {
    kernelName: (0, $hl418.Prod),
    backendName: 'cpu',
    kernelFunc: $5e7a0eda1307e836$export$5e143010dea16c85
};

});
parcelRegister("EOTYn", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $07ab389373429439$export$9cb09a71b7d66923);
$parcel$export(module.exports, "transposeConfig", () => $07ab389373429439$export$895a002a39b774be);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $csahy = parcelRequire("csahy");

var $4m8st = parcelRequire("4m8st");
function $07ab389373429439$export$9cb09a71b7d66923(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { x: x } = inputs;
    const { perm: perm } = attrs;
    (0, $csahy.assertNotComplex)(x, 'transpose');
    const xRank = x.shape.length;
    const newShape = new Array(xRank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[perm[i]];
    const values = backend.data.get(x.dataId).values;
    const result = (0, $4m8st.transposeImpl)(values, x.shape, x.dtype, perm, newShape);
    const dataId = backend.write(result, newShape, x.dtype);
    return {
        dataId: dataId,
        shape: newShape,
        dtype: x.dtype
    };
}
const $07ab389373429439$export$895a002a39b774be = {
    kernelName: (0, $hl418.Transpose),
    backendName: 'cpu',
    kernelFunc: $07ab389373429439$export$9cb09a71b7d66923
};

});
parcelRegister("4m8st", function(module, exports) {

$parcel$export(module.exports, "transposeImpl", () => $32bfc71f0862a696$export$986b9e65182e08d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
function $32bfc71f0862a696$export$986b9e65182e08d(xVals, xShape, dtype, perm, newShape) {
    const xRank = xShape.length;
    const xSize = (0, $jjNRA).sizeFromShape(xShape);
    const xStrides = (0, $jjNRA).computeStrides(xShape);
    const newStrides = (0, $jjNRA).computeStrides(newShape);
    const result = (0, $jjNRA).getTypedArrayFromDType(dtype, (0, $jjNRA).sizeFromShape(newShape));
    for(let i = 0; i < xSize; ++i){
        const loc = (0, $jjNRA).indexToLoc(i, xRank, xStrides);
        // Permute location.
        const newLoc = new Array(loc.length);
        for(let i = 0; i < newLoc.length; i++)newLoc[i] = loc[perm[i]];
        const newIndex = (0, $jjNRA).locToIndex(newLoc, xRank, newStrides);
        result[newIndex] = xVals[i];
    }
    return result;
}

});



parcelRegister("4hb6Q", function(module, exports) {

$parcel$export(module.exports, "raggedGatherImpl", () => $31d15e10c6da25b4$export$4104e3de41455909);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
function $31d15e10c6da25b4$var$validateIndices(indices, indicesShape, numParams) {
    indices.forEach((index, i)=>{
        if (index < 0 || index >= numParams) {
            const locString = (0, $jjNRA).indexToLoc(i, indicesShape.length, (0, $jjNRA).computeStrides(indicesShape)).join(',');
            throw new Error(`indices[${locString}] = ${index} is not in [0, ${numParams})`);
        }
    });
}
function $31d15e10c6da25b4$var$validateSplits(paramsNestedSplits, numParamsDenseValues) {
    // Validate
    for(let dim = 0; dim < paramsNestedSplits.length; ++dim){
        const splits = paramsNestedSplits[dim];
        const lastSplit = dim === paramsNestedSplits.length - 1 ? numParamsDenseValues : paramsNestedSplits[dim + 1].length;
        if (splits.length === 0) throw new Error('Ragged splits may not be empty');
        if (splits[0] < 0) throw new Error('Ragged splits must be non-negative');
        if (splits[splits.length - 1] > lastSplit) throw new Error('Ragged splits must not point past values');
        for(let i = 1; i < splits.length; ++i){
            if (splits[i - 1] > splits[i]) throw new Error('Ragged splits must be sorted in ascending order');
        }
    }
}
// Construct the `splits` output tensors, encoded using a nested vector.
// Also find the slices of values that need to be copied, and store them
// in `valueSlices`.  The total number of values that will be copied (which
// we need for allocating the output values tensor) is stored in `numValues`.
function $31d15e10c6da25b4$var$makeSplits(indices, indicesShape, paramsNestedSplits, numParamsDenseValues) {
    const valueSlices = [];
    let numValues = 0;
    const numSplits = indicesShape.length - 1 + paramsNestedSplits.length;
    const outSplits = new Array(numSplits).fill(null).map(()=>[
            0
        ]);
    $31d15e10c6da25b4$var$validateSplits(paramsNestedSplits, numParamsDenseValues);
    // Add `splits` that come from all but the last dimension of the dense
    // Tensor `indices`.  In particular, for each dimension D, we add a
    // splits tensor whose values are:
    //   range(reduceProd(splits.shape[:D]) + 1) * splits.shape[D+1]
    // E.g., if indices.shape=[2, 3, 4] then we will add splits tensors:
    //   [0, 3, 6]                    # length=2+1, stride=3
    //   [0, 4, 8, 12, 16, 20, 24]    # length=2*3+1, stride=4
    let nrows = 1;
    for(let dim = 0; dim < indicesShape.length - 1; ++dim){
        nrows *= indicesShape[dim];
        const rowLength = indicesShape[dim + 1];
        for(let i = 1; i < nrows + 1; ++i)outSplits[dim].push(i * rowLength);
    }
    // Add `splits` that come from `paramsNestedSplits`.  Starting with the
    // outermost ragged dimension (i.e., the first `splits` tensor), we work
    // our way in, finding the range of values that should be copied.  As we
    // go, we update the output `splits` for each dimension with the appropriate
    // values.  In particular, the *lengths* of the slices from `param_splits`
    // should be copied to generate corresponding slice lengths in the output
    // splits.  E.g., if we are copying a ragged row with length 4, then we
    // should add a new split point to outSplits that is 4 greater than the
    // previous split point in outSplits.
    for(let i = 0; i < indices.length; ++i){
        let start = indices[i];
        let limit = indices[i] + 1;
        // Copy splits.
        for(let dim = 0; dim < paramsNestedSplits.length; ++dim){
            const splits = paramsNestedSplits[dim];
            const outDim = dim + indicesShape.length - 1;
            if (outDim >= 0) {
                const outSplitsOutDim = outSplits[outDim];
                const delta = outSplitsOutDim[outSplitsOutDim.length - 1] - splits[start];
                for(let j = start; j < limit; ++j)outSplits[outDim].push(splits[j + 1] + delta);
            }
            start = splits[start];
            limit = splits[limit];
        }
        if (limit !== start) {
            valueSlices.push([
                start,
                limit
            ]);
            numValues += limit - start;
        }
    }
    return {
        outSplits: outSplits,
        valueSlices: valueSlices,
        numValues: numValues
    };
}
function $31d15e10c6da25b4$var$getSplits(outSplits) {
    const splitsOut = [];
    for(let i = 0; i < outSplits.length; ++i){
        const numSplits = outSplits[i].length;
        const splits = (0, $jjNRA).getArrayFromDType('int32', numSplits);
        splitsOut.push(splits);
        outSplits[i].forEach((value, j)=>splits[j] = value);
    }
    return splitsOut;
}
function $31d15e10c6da25b4$var$computeFlatOuterDims(orig, numOutDims) {
    const outDims = orig.slice(0, numOutDims);
    while(outDims.length < numOutDims)outDims.push(1);
    for(let inDim = numOutDims; inDim < orig.length; inDim++)outDims[numOutDims - 1] *= orig[inDim];
    return outDims;
}
// For each slice in `(start, limit)` in `valueSlices`, append
// `paramsDenseValues[start,...,limit] to `values`.  `valueSize` indicates
// the number of scalars contained in each value paramsDenseValues[i].
function $31d15e10c6da25b4$var$writeValueSlices(paramsDenseValues, paramsDenseValuesShape, valueSlices, valueSize, values, valuesShape) {
    const denseM = $31d15e10c6da25b4$var$computeFlatOuterDims(paramsDenseValuesShape, 2)[1];
    const valuesM = $31d15e10c6da25b4$var$computeFlatOuterDims(valuesShape, 2)[1];
    let outPos = 0;
    for (const slice of valueSlices)for(let i = slice[0]; i < slice[1]; ++i){
        for(let j = 0; j < valueSize; ++j)values[outPos * valuesM + j] = paramsDenseValues[i * denseM + j];
        ++outPos;
    }
}
function $31d15e10c6da25b4$var$getValues(paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, valueSlices, numValues) {
    const valuesShape = paramsDenseValuesShape.slice();
    valuesShape[0] = numValues;
    const valuesOut = (0, $jjNRA).getArrayFromDType(paramsDenseValuesDType, (0, $jjNRA).sizeFromShape(valuesShape));
    const numElements = paramsDenseValues.length;
    const valueSize = numElements === 0 ? 0 : numElements / paramsDenseValuesShape[0];
    $31d15e10c6da25b4$var$writeValueSlices(paramsDenseValues, paramsDenseValuesShape, valueSlices, valueSize, valuesOut, valuesShape);
    return [
        valuesOut,
        valuesShape
    ];
}
function $31d15e10c6da25b4$export$4104e3de41455909(paramsNestedSplits, paramsNestedSplitsShapes, paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, indices, indicesShape, outputRaggedRank) {
    if (paramsNestedSplits.length === 0) throw new Error('paramsNestedSplits must be non empty');
    if (paramsNestedSplitsShapes[0].length === 0) throw new Error('Split tensors must not be scalars');
    const numParams = paramsNestedSplitsShapes[0][0] - 1;
    $31d15e10c6da25b4$var$validateIndices(indices, indicesShape, numParams);
    if (paramsDenseValuesShape.length === 0) throw new Error('params.rank must be nonzero');
    const numParamsDenseValues = paramsDenseValuesShape[0];
    // Calculate the `splits`, and store the value slices that we need to
    // copy in `valueSlices`.
    const { outSplits: outSplits, valueSlices: valueSlices, numValues: numValues } = $31d15e10c6da25b4$var$makeSplits(indices, indicesShape, paramsNestedSplits, numParamsDenseValues);
    // Write the output tensors.
    const outputNestedSplits = $31d15e10c6da25b4$var$getSplits(outSplits);
    const outputDenseValues = $31d15e10c6da25b4$var$getValues(paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, valueSlices, numValues);
    return [
        outputNestedSplits,
        outputDenseValues[0],
        outputDenseValues[1]
    ];
}

});

parcelRegister("2uK9D", function(module, exports) {

$parcel$export(module.exports, "raggedRangeImpl", () => $1d122f66124f8118$export$af0dda5a37ea8d94);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
const $1d122f66124f8118$var$INT32_MAX = 2147483647;
function $1d122f66124f8118$export$af0dda5a37ea8d94(starts, startsShape, startsDType, limits, limitsShape, deltas, deltasShape) {
    // Check input tensor shapes.
    if (startsShape.length > 1) throw new Error('starts must be a scalar or vector');
    if (limitsShape.length > 1) throw new Error('limits must be a scalar or vector');
    if (deltasShape.length > 1) throw new Error('deltas must be a scalar or vector');
    // Determine which tensors we need to broadcast.
    const broadcastStarts = startsShape.length === 0;
    const broadcastLimits = limitsShape.length === 0;
    const broadcastDeltas = deltasShape.length === 0;
    // nRows (number of output rows) is the size of the non-broadcast inputs,
    // or 1 if all inputs are scalars.
    const inSizes = [];
    if (!broadcastStarts) inSizes.push(startsShape[0]);
    if (!broadcastLimits) inSizes.push(limitsShape[0]);
    if (!broadcastDeltas) inSizes.push(deltasShape[0]);
    for(let i = 1; i < inSizes.length; ++i){
        if (inSizes[i] !== inSizes[i - 1]) throw new Error('starts, limits, and deltas must have the same shape');
    }
    const nRows = inSizes.length === 0 ? 1 : inSizes[0];
    // Construct the rtNestedSplits tensor.
    const rtNestedSplits = (0, $jjNRA).getArrayFromDType('int32', nRows + 1);
    rtNestedSplits[0] = 0;
    for(let row = 0; row < nRows; ++row){
        const start = broadcastStarts ? starts[0] : starts[row];
        const limit = broadcastLimits ? limits[0] : limits[row];
        const delta = broadcastDeltas ? deltas[0] : deltas[row];
        if (delta === 0) throw new Error('Requires delta != 0');
        let size; // The number of elements in the specified range.
        if (delta > 0 && limit < start || delta < 0 && limit > start) size = 0;
        else {
            size = Math.ceil(Math.abs((limit - start) / delta));
            if (size > $1d122f66124f8118$var$INT32_MAX) throw new Error(`Requires ((limit - start) / delta) <= ${$1d122f66124f8118$var$INT32_MAX}`);
        }
        rtNestedSplits[row + 1] = rtNestedSplits[row] + size;
    }
    const nVals = rtNestedSplits[nRows];
    // Construct the rtDenseValues tensor.
    const rtDenseValues = (0, $jjNRA).getArrayFromDType(startsDType, nVals);
    let valueIndex = 0;
    for(let row = 0; row < nRows; ++row){
        const rowSize = rtNestedSplits[row + 1] - rtNestedSplits[row];
        let value = broadcastStarts ? starts[0] : starts[row];
        const delta = broadcastDeltas ? deltas[0] : deltas[row];
        for(let i = 0; i < rowSize; ++i){
            rtDenseValues[valueIndex++] = value;
            value += delta;
        }
    }
    return [
        rtNestedSplits,
        rtDenseValues
    ];
}

});

parcelRegister("6AvWp", function(module, exports) {

$parcel$export(module.exports, "raggedTensorToTensorImpl", () => $4cbee1b0eadd4e60$export$8194a77b1066327a);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $aeB3Z = parcelRequire("aeB3Z");
var $4sqA7 = parcelRequire("4sqA7");
var $c2DT1 = parcelRequire("c2DT1");
var $jjNRA = parcelRequire("jjNRA");
var $4cbee1b0eadd4e60$var$RowPartitionType = (0, $7MaPk).RowPartitionType;
// Based on
// https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/ragged_tensor_to_tensor_op.cc
class $4cbee1b0eadd4e60$var$RaggedTensorToTensorOp {
    constructor(shape, shapeShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypeStrings){
        this.shape = shape;
        this.shapeShape = shapeShape;
        this.values = values;
        this.valuesShape = valuesShape;
        this.valuesDType = valuesDType;
        this.defaultValue = defaultValue;
        this.defaultValueShape = defaultValueShape;
        this.rowPartitionValues = rowPartitionValues;
        this.rowPartitionValuesShapes = rowPartitionValuesShapes;
        this.rowPartitionTypes = (0, $7MaPk).getRowPartitionTypesHelper(rowPartitionTypeStrings);
        this.raggedRank = (0, $7MaPk).getRaggedRank(this.rowPartitionTypes);
    }
    getRowPartitionTypeByDimension(dimension) {
        if (this.rowPartitionTypes[0] === $4cbee1b0eadd4e60$var$RowPartitionType.FIRST_DIM_SIZE) return this.rowPartitionTypes[dimension + 1];
        else return this.rowPartitionTypes[dimension];
    }
    // Returns the relationship between dimension and dimension + 1.
    getRowPartitionTensor(dimension) {
        if (this.rowPartitionTypes[0] === $4cbee1b0eadd4e60$var$RowPartitionType.FIRST_DIM_SIZE) return this.rowPartitionValues[dimension + 1];
        else return this.rowPartitionValues[dimension];
    }
    getMaxWidth(dimension) {
        const rowPartitionTensor = this.getRowPartitionTensor(dimension - 1);
        switch(this.getRowPartitionTypeByDimension(dimension - 1)){
            case $4cbee1b0eadd4e60$var$RowPartitionType.VALUE_ROWIDS:
                return $4cbee1b0eadd4e60$var$RaggedTensorToTensorOp.getMaxWidthValueRowID(rowPartitionTensor);
            case $4cbee1b0eadd4e60$var$RowPartitionType.ROW_SPLITS:
                return $4cbee1b0eadd4e60$var$RaggedTensorToTensorOp.getMaxWidthRowSplit(rowPartitionTensor);
            default:
                throw new Error(`Cannot handle partition type ${$4cbee1b0eadd4e60$var$RowPartitionType[this.getRowPartitionTypeByDimension(dimension - 1)]}`);
        }
    }
    static getMaxWidthRowSplit(rowSplit) {
        const tensorLength = rowSplit.length;
        if (tensorLength === 0 || tensorLength === 1) return 0;
        let maxWidth = 0;
        for(let i = 0; i < tensorLength - 1; ++i){
            const currentWidth = rowSplit[i + 1] - rowSplit[i];
            if (currentWidth > maxWidth) maxWidth = currentWidth;
        }
        return maxWidth;
    }
    static getMaxWidthValueRowID(valueRowIds) {
        const indexLength = valueRowIds.length;
        if (indexLength === 0) return 0;
        let firstEqualIndex = 0;
        let firstEqualIndexValue = valueRowIds[0];
        let maxWidth = 0;
        for(let i = 1; i < indexLength; ++i){
            const value = valueRowIds[i];
            if (value !== firstEqualIndexValue) {
                firstEqualIndexValue = value;
                maxWidth = Math.max(i - firstEqualIndex, maxWidth);
                firstEqualIndex = i;
            }
        }
        return Math.max(indexLength - firstEqualIndex, maxWidth);
    }
    tensorShapeFromTensor(t, tShape, isPartial = true) {
        if (tShape.length === 0) {
            if (t[0] === -1) return [];
            throw new Error(`The only valid scalar shape tensor is the fully unknown shape specified as -1.`);
        }
        // MakePartialShape/MakeShapeHelper.
        return $4cbee1b0eadd4e60$var$makeShape(t, isPartial);
    }
    calculateOutputSize(firstDim) {
        const valueShape = this.valuesShape;
        const defaultValueShape = this.defaultValueShape;
        (0, $7MaPk).validateDefaultValueShape(defaultValueShape, valueShape);
        const shape = this.tensorShapeFromTensor(this.shape, this.shapeShape);
        const outputShape = (0, $7MaPk).combineRaggedTensorToTensorShapes(this.raggedRank, shape, valueShape);
        const result = outputShape;
        if (result[0] < 0) result[0] = firstDim;
        for(let i = 1; i <= this.raggedRank; ++i)if (result[i] < 0) result[i] = this.getMaxWidth(i);
        return result;
    }
    /**
     * The outputIndex represents the index in the output tensor
     * where the first element of a particular dimension would be written.
     * If it is -1, it indicates that the index is out of scope.
     * Example, given firstDimension = 10, firstDimensionOutput = 6,
     * and outputIndexMultiplier = 100:
     * result = [0 100 200 300 400 500 -1 -1 -1 -1]
     * If firstDimensionOutput = 11 instead, then:
     * result = [0 100 200 300 400 500 600 700 800 900]
     */ calculateFirstParentOutputIndex(firstDimension, outputIndexMultiplier, firstDimensionOutput) {
        const minDimension = Math.min(firstDimension, firstDimensionOutput);
        const result = [];
        let currentOutputIndex = 0;
        for(let i = 0; i < minDimension; ++i, currentOutputIndex += outputIndexMultiplier)result.push(currentOutputIndex);
        for(let i = minDimension; i < firstDimension; ++i)result.push(-1);
        (0, $jjNRA).assert(result.length === firstDimension, ()=>'Final length of result must be equal to firstDimension.');
        return result;
    }
    calculateOutputIndexRowSplit(rowSplit, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const rowSplitSize = rowSplit.length;
        const result = [];
        for(let i = 0; i < rowSplitSize - 1; ++i){
            const rowLength = rowSplit[i + 1] - rowSplit[i];
            let realLength = Math.min(outputSize, rowLength);
            let parentOutputIndexCurrent = parentOutputIndex[i];
            if (parentOutputIndexCurrent === -1) realLength = 0;
            for(let j = 0; j < realLength; ++j){
                result.push(parentOutputIndexCurrent);
                parentOutputIndexCurrent += outputIndexMultiplier;
            }
            for(let j = 0; j < rowLength - realLength; ++j)result.push(-1);
        }
        if (rowSplitSize > 0 && result.length !== rowSplit[rowSplitSize - 1]) throw new Error('Invalid row split size.');
        return result;
    }
    // Calculate the output index of the first element of a list.
    // The parentOutputIndex is the same computation for the previous list.
    // -1 indicates an element or list that is out of range.
    // The outputIndexMultiplier is the number of output indices one moves
    // forward for each column.
    // E.g., given:
    // valueRowIds:[0 1 2 2 2 3 5 5 6]
    // parentOutputIndex:[1000 1100 2000 2100 -1 3000 4000]
    // outputIndexMultiplier: 10
    // outputSize: 2
    // You get:
    // result = [1000 1100 2000 2010 -1 2100 -1 -1 3000]
    // result[0] = parentOutputIndex[valueRowIds[0]]
    // result[1] = parentOutputIndex[valueRowIds[1]]
    // result[2] = parentOutputIndex[valueRowIds[2]]
    // result[3] = parentOutputIndex[valueRowIds[2] + 10]
    // result[4] = -1 because it is the third element the size is 2.
    // result[5] = parentOutputIndex[valueRowIds[3]]
    // result[6] = -1 because parentOutputIndex[valueRowIds[6]] == -1
    // result[7] = -1 because parentOutputIndex[valueRowIds[6]] == -1
    // result[8] = parentOutputIndex[valueRowIds[7]]
    calculateOutputIndexValueRowID(valueRowIds, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const indexSize = valueRowIds.length;
        const result = [];
        if (indexSize === 0) return [];
        let currentOutputColumn = 0;
        let currentValueRowId = valueRowIds[0];
        if (currentValueRowId >= parentOutputIndex.length) throw new Error(`Got currentValueRowId=${currentValueRowId}, which is not less than ${parentOutputIndex.length}`);
        let currentOutputIndex = parentOutputIndex[currentValueRowId];
        result.push(currentOutputIndex);
        for(let i = 1; i < indexSize; ++i){
            const nextValueRowId = valueRowIds[i];
            if (nextValueRowId === currentValueRowId) {
                if (currentOutputIndex >= 0) {
                    ++currentOutputColumn;
                    if (currentOutputColumn < outputSize) currentOutputIndex += outputIndexMultiplier;
                    else currentOutputIndex = -1;
                }
            } else {
                currentOutputColumn = 0;
                currentValueRowId = nextValueRowId;
                if (nextValueRowId >= parentOutputIndex.length) throw new Error(`Got nextValueRowId=${nextValueRowId} which is not less than ${parentOutputIndex.length}`);
                currentOutputIndex = parentOutputIndex[nextValueRowId];
            }
            result.push(currentOutputIndex);
        }
        if (result.length !== valueRowIds.length) throw new Error('Invalid row ids.');
        return result;
    }
    calculateOutputIndex(dimension, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const rowPartitionTensor = this.getRowPartitionTensor(dimension);
        const partitionType = this.getRowPartitionTypeByDimension(dimension);
        switch(partitionType){
            case $4cbee1b0eadd4e60$var$RowPartitionType.VALUE_ROWIDS:
                return this.calculateOutputIndexValueRowID(rowPartitionTensor, parentOutputIndex, outputIndexMultiplier, outputSize);
            case $4cbee1b0eadd4e60$var$RowPartitionType.ROW_SPLITS:
                if (rowPartitionTensor.length - 1 > parentOutputIndex.length) throw new Error(`Row partition size is greater than output size: ${rowPartitionTensor.length - 1} > ${parentOutputIndex.length}`);
                return this.calculateOutputIndexRowSplit(rowPartitionTensor, parentOutputIndex, outputIndexMultiplier, outputSize);
            default:
                throw new Error(`Unsupported partition type: ${$4cbee1b0eadd4e60$var$RowPartitionType[partitionType]}`);
        }
    }
    getFirstDimensionSize() {
        const firstPartitionTensor = this.rowPartitionValues[0];
        if (this.rowPartitionTypes.length === 0) throw new Error('No row_partition_types given.');
        const firstPartitionType = this.rowPartitionTypes[0];
        switch(firstPartitionType){
            case $4cbee1b0eadd4e60$var$RowPartitionType.FIRST_DIM_SIZE:
                return firstPartitionTensor[0];
            case $4cbee1b0eadd4e60$var$RowPartitionType.VALUE_ROWIDS:
                throw new Error('Cannot handle VALUE_ROWIDS in first dimension.');
            case $4cbee1b0eadd4e60$var$RowPartitionType.ROW_SPLITS:
                return this.rowPartitionValuesShapes[0][0] - 1;
            default:
                throw new Error(`Cannot handle type ${$4cbee1b0eadd4e60$var$RowPartitionType[firstPartitionType]}`);
        }
    }
    compute() {
        const firstPartitionTensor = this.rowPartitionValues[0];
        if (firstPartitionTensor.length <= 0) throw new Error("Invalid first partition input. Tensor requires at least one element.");
        const firstDimension = this.getFirstDimensionSize();
        const outputSize = this.calculateOutputSize(firstDimension);
        const multiplier = new Array(this.raggedRank + 1);
        multiplier[multiplier.length - 1] = 1;
        for(let i = multiplier.length - 2; i >= 0; --i)multiplier[i] = multiplier[i + 1] * outputSize[i + 1];
        // Full size of the tensor.
        const outputShape = $4cbee1b0eadd4e60$var$makeShape(outputSize, false);
        const outputTensor = (0, $jjNRA).getArrayFromDType(this.valuesDType, (0, $jjNRA).sizeFromShape(outputShape));
        const fullSize = multiplier[0] * outputSize[0];
        if (fullSize > 0) {
            let outputIndex = this.calculateFirstParentOutputIndex(firstDimension, multiplier[0], outputSize[0]);
            for(let i = 1; i <= this.raggedRank; ++i){
                const newOutputIndex = this.calculateOutputIndex(i - 1, outputIndex, multiplier[i], outputSize[i]);
                outputIndex = newOutputIndex;
            }
            this.setOutput(this.raggedRank, outputIndex, outputTensor, outputShape);
        }
        return [
            outputShape,
            outputTensor
        ];
    }
    setOutput(raggedRank, outputIndex, outputTensor, outputShape) {
        if (outputTensor.length === 0) return;
        const valuesBase = this.values;
        const outputBase = outputTensor;
        let elementShape = outputShape.slice();
        elementShape = elementShape.slice(raggedRank + 1);
        const valueElementSize = (0, $jjNRA).sizeFromShape(elementShape);
        const outputIndexSize = outputIndex.length;
        // Broadcast the default value to value_element_size.  (We can skip this
        // if defaultValueTensor.size == 1, since we use fill when that's true.)
        let defaultValue = this.defaultValue;
        if (defaultValue.length !== valueElementSize && defaultValue.length !== 1) {
            const srcShape = this.defaultValueShape;
            (0, $c2DT1.tidy)(()=>{
                const defaultValueTensor = (0, $4sqA7.reshape)(defaultValue, srcShape);
                const bCastDefault = (0, $aeB3Z.broadcastTo)(defaultValueTensor, elementShape);
                defaultValue = bCastDefault.dataSync();
            });
        }
        // Loop through the outputIndex array, finding contiguous regions that
        // should be copied.  Once we find the end of a contiguous region, copy it
        // and add any necessary padding (with defaultValue).
        let srcStart = 0; // Start of contiguous region (in values)
        let dstStart = 0; // Destination for contiguous region (in output)
        let dstEnd = 0; // Destination for contiguous region (in output)
        for(let srcI = 0; srcI <= outputIndexSize; ++srcI){
            // dstI is the destination where the value at srcI should be copied.
            let dstI = srcI < outputIndexSize ? outputIndex[srcI] : -1;
            // If we're still in a contiguous region, then update dstEnd go to the
            // next srcI.
            if (dstI === dstEnd) {
                ++dstEnd;
                continue;
            }
            // We found the end of contiguous region.  This can be because we found
            // a gap (dstI > dstEnd), or a source value that shouldn't be copied
            // because it's out-of-bounds (dstI == -1), or the end of the tensor
            // (dstI === -1).
            if (dstStart < dstEnd) {
                // Copy the contiguous region.
                const src = valuesBase.subarray(srcStart * valueElementSize);
                const dst = outputBase.subarray(dstStart * valueElementSize);
                const nVals = (dstEnd - dstStart) * valueElementSize;
                $4cbee1b0eadd4e60$var$copyArray(dst, src, nVals);
            }
            // Add any necessary padding (w/ defaultValue).
            if (srcI >= outputIndexSize) {
                // We reached the end of values: pad to the end of output.
                const outputSize = outputTensor.length;
                dstI = Math.floor(outputSize / valueElementSize);
            }
            if (dstI > dstEnd) {
                if (this.defaultValue.length === 1) {
                    outputBase.subarray(dstEnd * valueElementSize, dstI * valueElementSize).fill(this.defaultValue[0]);
                    dstEnd = dstI;
                } else while(dstI > dstEnd){
                    const dst = outputBase.slice(dstEnd * valueElementSize);
                    $4cbee1b0eadd4e60$var$copyArray(dst, defaultValue, valueElementSize);
                    ++dstEnd;
                }
            }
            // Update indices.
            if (dstI < 0) {
                // srcI should be skipped -- leave it out of the contiguous region.
                srcStart = srcI + 1;
                dstStart = dstEnd;
            } else {
                // srcI should be copied -- include it in the contiguous region.
                srcStart = srcI;
                dstStart = dstEnd;
                dstEnd = dstStart + 1;
            }
        }
    }
}
function $4cbee1b0eadd4e60$var$copyArray(dst, src, size) {
    for(let i = 0; i < size; i++)dst[i] = src[i];
}
function $4cbee1b0eadd4e60$var$makeShape(shape, isPartial) {
    const out = [];
    for (let dim of shape){
        if (dim < 0) {
            if (!isPartial) throw new Error(`Dimension ${dim} must be >= 0`);
            if (dim < -1) throw new Error(`Dimension ${dim} must be >= -1`);
            dim = -1;
        }
        out.push(dim);
    }
    return out;
}
function $4cbee1b0eadd4e60$export$8194a77b1066327a(shape, shapesShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes) {
    return new $4cbee1b0eadd4e60$var$RaggedTensorToTensorOp(shape, shapesShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes).compute();
}

});

parcelRegister("caGrw", function(module, exports) {

$parcel$export(module.exports, "rangeImpl", () => $8dc75778df5b7199$export$3561205b7dff20bf);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
function $8dc75778df5b7199$export$3561205b7dff20bf(start, stop, step, dtype) {
    const sameStartStop = start === stop;
    const increasingRangeNegativeStep = start < stop && step < 0;
    const decreasingRangePositiveStep = stop < start && step > 1;
    if (sameStartStop || increasingRangeNegativeStep || decreasingRangePositiveStep) return (0, $jjNRA).makeZerosTypedArray(0, dtype);
    const numElements = Math.abs(Math.ceil((stop - start) / step));
    const values = (0, $jjNRA).makeZerosTypedArray(numElements, dtype);
    if (stop < start && step === 1) // Auto adjust the step's sign if it hasn't been set
    // (or was set to 1)
    step = -1;
    values[0] = start;
    for(let i = 1; i < values.length; i++)values[i] = values[i - 1] + step;
    return values;
}

});

parcelRegister("GbeHD", function(module, exports) {

$parcel$export(module.exports, "rsqrtImpl", () => $07eca39f3e0e58e8$export$7ec24de9bffc6b90);
$parcel$export(module.exports, "rsqrtConfig", () => $07eca39f3e0e58e8$export$941104b789956ef6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $19W3p = parcelRequire("19W3p");

var $l6afd = parcelRequire("l6afd");
const $07eca39f3e0e58e8$export$7ec24de9bffc6b90 = (0, $19W3p.createSimpleUnaryImpl)((xi)=>1 / Math.sqrt(xi));
const $07eca39f3e0e58e8$export$1cc01d192953037e = (0, $l6afd.unaryKernelFuncFromImpl)((0, $hl418.Rsqrt), $07eca39f3e0e58e8$export$7ec24de9bffc6b90);
const $07eca39f3e0e58e8$export$941104b789956ef6 = {
    kernelName: (0, $hl418.Rsqrt),
    backendName: 'cpu',
    kernelFunc: $07eca39f3e0e58e8$export$1cc01d192953037e
};

});

parcelRegister("YcuAy", function(module, exports) {

$parcel$export(module.exports, "scatterImpl", () => $0b4f4b6f434a9a95$export$5fc9b0358a19bd54);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $iG87S = parcelRequire("iG87S");
var $9jCh7 = parcelRequire("9jCh7");
function $0b4f4b6f434a9a95$export$5fc9b0358a19bd54(indices, updates, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, defaultValue, sumDupeIndices) {
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    const indicesData = indices.values;
    const updatesData = updates.values;
    if (outputSize === 0) return (0, $iG87S.buffer)(shape, updates.dtype);
    const outBuf = defaultValue instanceof (0, $9jCh7.TensorBuffer) ? defaultValue : (0, $iG87S.buffer)(flattenShape, updates.dtype);
    if (typeof defaultValue === 'string') outBuf.values.fill(defaultValue);
    else if (typeof defaultValue === 'number') outBuf.values.fill(defaultValue);
    else if (typeof defaultValue === 'boolean') outBuf.values.fill(+defaultValue);
    for(let i = 0; i < numUpdates; i++){
        const index = [];
        let flattenIndex = 0;
        for(let j = 0; j < sliceRank; j++){
            const dim = indicesData[i * sliceRank + j];
            index.push(dim);
            flattenIndex += dim * strides[j];
        }
        if (flattenIndex < 0 || flattenIndex >= outputSize / sliceSize) throw new Error(`Invalid indices: ${index} does not index into ${shape}`);
        for(let k = 0; k < sliceSize; k++)if (sumDupeIndices) outBuf.values[flattenIndex * sliceSize + k] += updatesData[i * sliceSize + k];
        else outBuf.values[flattenIndex * sliceSize + k] = updates.rank === 0 ? updatesData[0] : updatesData[i * sliceSize + k];
    }
    return outBuf;
}

});

parcelRegister("dMdBj", function(module, exports) {

$parcel$export(module.exports, "sigmoidImpl", () => $a07a4ee1ba724b45$export$e31bae35ce8238b3);
$parcel$export(module.exports, "sigmoid", () => $a07a4ee1ba724b45$export$3b295495ca3cad7c);
$parcel$export(module.exports, "sigmoidConfig", () => $a07a4ee1ba724b45$export$195d1cf7c59f3ef);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $19W3p = parcelRequire("19W3p");

var $l6afd = parcelRequire("l6afd");
const $a07a4ee1ba724b45$export$e31bae35ce8238b3 = (0, $19W3p.createSimpleUnaryImpl)((xi)=>1 / (1 + Math.exp(-xi)));
const $a07a4ee1ba724b45$export$3b295495ca3cad7c = (0, $l6afd.unaryKernelFunc)((0, $hl418.Sigmoid), (xi)=>1 / (1 + Math.exp(-xi)));
const $a07a4ee1ba724b45$export$195d1cf7c59f3ef = {
    kernelName: (0, $hl418.Sigmoid),
    backendName: 'cpu',
    kernelFunc: $a07a4ee1ba724b45$export$3b295495ca3cad7c
};

});

parcelRegister("aYBRE", function(module, exports) {

$parcel$export(module.exports, "sliceImpl", () => $7fdce109e161013a$export$4bdf1ac3fa5d3d6a);
$parcel$export(module.exports, "slice", () => $7fdce109e161013a$export$58adb3bec8346d0f);
$parcel$export(module.exports, "sliceConfig", () => $7fdce109e161013a$export$8d8a1e11dd2cc6c4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $iG87S = parcelRequire("iG87S");
var $hl418 = parcelRequire("hl418");
var $bszZn = parcelRequire("bszZn");
var $jjNRA = parcelRequire("jjNRA");

var $csahy = parcelRequire("csahy");
function $7fdce109e161013a$export$4bdf1ac3fa5d3d6a(vals, begin, size, shape, dtype) {
    const isContinous = (0, $bszZn).isSliceContinous(shape, begin, size);
    const length = (0, $jjNRA).sizeFromShape(size);
    const xStrides = (0, $jjNRA).computeStrides(shape);
    if (isContinous) {
        const flatOffset = (0, $bszZn).computeFlatOffset(begin, xStrides);
        if (dtype === 'string') return vals.slice(flatOffset, flatOffset + length);
        return vals.subarray(flatOffset, flatOffset + length);
    }
    const decodedData = dtype === 'string' ? (0, $7MaPk).fromUint8ToStringArray(vals) : vals;
    const inBuf = (0, $iG87S.buffer)(shape, dtype, decodedData);
    const outBuf = (0, $iG87S.buffer)(size, dtype);
    for(let i = 0; i < outBuf.size; ++i){
        const outLoc = outBuf.indexToLoc(i);
        const inLoc = outLoc.map((idx, j)=>idx + begin[j]);
        outBuf.set(inBuf.get(...inLoc), ...outLoc);
    }
    if (dtype === 'string') return (0, $7MaPk).fromStringArrayToUint8(outBuf.values);
    return outBuf.values;
}
function $7fdce109e161013a$export$58adb3bec8346d0f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, size: size } = attrs;
    (0, $csahy.assertNotComplex)(x, 'slice');
    const [$begin, $size] = (0, $bszZn).parseSliceParams(x, begin, size);
    (0, $bszZn).assertParamsValid(x, $begin, $size);
    const vals = backend.data.get(x.dataId).values;
    const outVals = $7fdce109e161013a$export$4bdf1ac3fa5d3d6a(vals, $begin, $size, x.shape, x.dtype);
    return backend.makeTensorInfo($size, x.dtype, outVals);
}
const $7fdce109e161013a$export$8d8a1e11dd2cc6c4 = {
    kernelName: (0, $hl418.Slice),
    backendName: 'cpu',
    kernelFunc: $7fdce109e161013a$export$58adb3bec8346d0f
};

});

parcelRegister("dkwAe", function(module, exports) {

$parcel$export(module.exports, "sparseFillEmptyRowsImpl", () => $9b466afd00a4b6df$export$9db01208a1bec190);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");
function $9b466afd00a4b6df$export$9db01208a1bec190(indices, indicesShape, indicesDType, values, valuesDType, denseShape, defaultValue) {
    const indicesCount = indicesShape[0];
    const denseRows = denseShape[0];
    const emptyRowIndicator = new Array(denseRows);
    const reverseIndexMap = new Array(indicesCount);
    const rank = indicesShape[1];
    if (denseRows === 0) {
        if (indicesCount !== 0) throw new Error((0, $7MaPk).getSparseFillEmptyRowsIndicesDenseShapeMismatch(indicesCount));
        const outputIndices = (0, $jjNRA).getArrayFromDType(indicesDType, 0);
        const outputValues = (0, $jjNRA).getArrayFromDType(valuesDType, 0);
        return [
            outputIndices,
            [
                0,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    }
    let rowsAreOrdered = true;
    let lastIndicesRow = 0;
    const csrOffset = new Array(denseRows).fill(0);
    for(let i = 0; i < indicesCount; ++i){
        // indices is a 2d tensor with shape of [N, rank]
        const row = indices[i * rank];
        if (row < 0) throw new Error((0, $7MaPk).getSparseFillEmptyRowsNegativeIndexErrorMessage(i, row));
        if (row >= denseRows) throw new Error((0, $7MaPk).getSparseFillEmptyRowsOutOfRangeIndexErrorMessage(i, row, denseRows));
        ++csrOffset[row];
        rowsAreOrdered = rowsAreOrdered && row >= lastIndicesRow;
        lastIndicesRow = row;
    }
    let allRowsFull = true;
    for(let row = 0; row < denseRows; ++row){
        // csrOffset here describes the number of elements in this dense row
        const rowEmpty = csrOffset[row] === 0;
        emptyRowIndicator[row] = rowEmpty;
        allRowsFull = allRowsFull && !rowEmpty;
        // In filled version, each row has at least one element.
        csrOffset[row] = Math.max(csrOffset[row], 1);
        // Update csrOffset to represent the number of elements up to and
        // including denseRows + 1:
        //  csrOffset[0] == #{elements of row 0}
        //  csrOffset[1] == #{elements of row 1} + #{elements of row 0}
        //  ..
        //  csrOffset[i] == starting index for elements in row i + 1.
        if (row > 0) csrOffset[row] += csrOffset[row - 1];
    }
    if (allRowsFull && rowsAreOrdered) {
        const outputIndices = indices;
        const outputValues = values;
        for(let i = 0; i < indicesCount; ++i)reverseIndexMap[i] = i;
        return [
            outputIndices,
            [
                indicesCount,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    } else {
        const fullIndicesCount = csrOffset[denseRows - 1];
        const outputIndices = (0, $jjNRA).getArrayFromDType(indicesDType, fullIndicesCount * rank);
        const outputValues = (0, $jjNRA).getArrayFromDType(valuesDType, fullIndicesCount);
        const filledCount = new Array(denseRows).fill(0);
        // Fill in values for rows that are not missing
        for(let i = 0; i < indicesCount; ++i){
            // indices is a 2d tensor with shape of [N, rank]
            const row = indices[i * rank];
            const offset = filledCount[row];
            const outputI = (row === 0 ? 0 : csrOffset[row - 1]) + offset;
            filledCount[row]++; // Increment the filled count for this row.
            for(let j = 0; j < rank; ++j)// indices and outputIndices are 2d tensors with shape of [N, rank]
            outputIndices[outputI * rank + j] = indices[i * rank + j];
            outputValues[outputI] = values[i];
            // We'll need this reverse index map to backprop correctly.
            reverseIndexMap[i] = outputI;
        }
        // Fill in values for rows that are missing
        for(let row = 0; row < denseRows; ++row){
            const rowCount = filledCount[row];
            if (rowCount === 0) {
                const startingIndex = row === 0 ? 0 : csrOffset[row - 1];
                // Remaining index values were set to zero already.
                // Just need to set the row index in the right location.
                // outputIndices is a 2d tensor with shape of [N, rank]
                outputIndices[startingIndex * rank + 0] = row;
                for(let col = 1; col < rank; ++col)outputIndices[startingIndex * rank + col] = 0;
                outputValues[startingIndex] = defaultValue;
            }
        }
        return [
            outputIndices,
            [
                fullIndicesCount,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    }
}

});

parcelRegister("9VxEX", function(module, exports) {

$parcel$export(module.exports, "sparseReshapeImpl", () => $73a38c07f2fb3e58$export$a65a15ebab81f5cd);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");
function $73a38c07f2fb3e58$export$a65a15ebab81f5cd(inputIndices, inputIndicesShape, inputDType, inputShape, targetShape) {
    const denseSize = (0, $jjNRA).sizeFromShape(inputShape);
    const nnz = inputIndicesShape[0];
    const outputRank = targetShape.length;
    // Compute the output shape. Determine product of specified dimensions, and
    // find the index of the unspecified one.
    const outputShape = [];
    let product = 1;
    let unknownIndex = -1;
    for(let d = 0; d < outputRank; ++d){
        const size = targetShape[d];
        if (size === -1) {
            if (unknownIndex !== -1) throw new Error((0, $7MaPk).getSparseReshapeMultipleNegativeOneOutputDimErrorMessage(unknownIndex, d));
            unknownIndex = d;
            outputShape.push(1);
        } else {
            if (size < 0) throw new Error((0, $7MaPk).getSparseReshapeNegativeOutputDimErrorMessage(d, size));
            product *= size;
            outputShape.push(size);
        }
    }
    if (unknownIndex !== -1) {
        if (product <= 0) throw new Error((0, $7MaPk).getSparseReshapeEmptyTensorZeroOutputDimErrorMessage());
        const missing = Math.trunc(denseSize / product);
        if (product * missing !== denseSize) throw new Error((0, $7MaPk).getSparseReshapeInputOutputMultipleErrorMessage(inputShape, outputShape));
        outputShape[unknownIndex] = missing;
    }
    const outputSize = (0, $jjNRA).sizeFromShape(outputShape);
    if (outputSize !== denseSize) throw new Error((0, $7MaPk).getSparseReshapeInputOutputMismatchErrorMessage(inputShape, outputShape));
    const inputRank = inputShape.length;
    const inputStrides = [];
    if (inputRank > 0) {
        inputStrides[inputRank - 1] = 1;
        for(let d = inputRank - 2; d >= 0; --d)inputStrides[d] = inputStrides[d + 1] * inputShape[d + 1];
    }
    const outputStrides = [];
    if (outputRank > 0) {
        outputStrides[outputRank - 1] = 1;
        for(let d = outputRank - 2; d >= 0; --d)outputStrides[d] = outputStrides[d + 1] * outputShape[d + 1];
    }
    const newIndices = (0, $jjNRA).getArrayFromDType(inputDType, nnz * outputRank);
    for(let i = 0; i < nnz; ++i){
        let id = 0;
        for(let j = 0; j < inputRank; ++j)// inputIndices is a 2d tensor with shape of [nnz, inputRank]
        id += inputIndices[i * inputRank + j] * inputStrides[j];
        for(let j = 0; j < outputRank; ++j){
            // newIndices is a 2d tensor with shape of [nnz, outputRank]
            newIndices[i * outputRank + j] = Math.trunc(id / outputStrides[j]);
            id %= outputStrides[j];
        }
    }
    return [
        newIndices,
        [
            nnz,
            outputRank
        ],
        outputShape
    ];
}

});

parcelRegister("8ENVF", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentReductionImpl", () => $64d8ca051654819c$export$7d3f7130c4245e65);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");
function $64d8ca051654819c$export$7d3f7130c4245e65(input, inputShape, inputDType, indices, segmentIds, isMean = false, defaultValue = 0) {
    const numIndices = indices.length;
    // Flatten the array to two dimensions
    const inputFlat = [
        inputShape[0],
        input.length / inputShape[0]
    ];
    const numCol = inputFlat[1];
    // Note that the current implementation assumes that segmentIds values are
    // sorted.
    const lastSegmentIdPlusOne = numIndices > 0 ? segmentIds[numIndices - 1] + 1 : 0;
    const outputRows = lastSegmentIdPlusOne;
    if (outputRows < 0) throw new Error((0, $7MaPk).getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
    const outputShape = inputShape.slice();
    outputShape[0] = outputRows;
    const outputLength = outputShape.reduce((product, value)=>product * value, 1);
    // Output array is initialized with the value 0 by default.
    const output = (0, $jjNRA).getArrayFromDType(inputDType, outputLength);
    // Note that we do not initialize the output buffer with a default value, so
    // we need to explicitly set missing indices to the default value.
    if (numIndices === 0) {
        if (outputRows > 0) output.fill(defaultValue);
        return [
            output,
            outputShape
        ];
    }
    if (outputRows <= 0) throw new Error((0, $7MaPk).getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
    let start = 0, end = 1;
    // Index from which the output is not initialized.
    let uninitializedIndex = 0;
    let outIndex = segmentIds[start];
    while(true){
        // We initialize nextIndex to 0 to avoid may be uninitialized warning
        let nextIndex = 0;
        if (end < numIndices) {
            nextIndex = segmentIds[end];
            if (outIndex === nextIndex) {
                ++end;
                continue;
            }
            // We have a new segment here.  Verify that the segment ids are growing.
            if (outIndex >= nextIndex) throw new Error((0, $7MaPk).getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage());
        }
        if (outIndex < 0 || outIndex >= outputRows) throw new Error((0, $7MaPk).getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage(outIndex, outputRows));
        // If there is a gap between two indices, we need to set that gap to the
        // default value.
        if (outIndex > uninitializedIndex) output.fill(defaultValue, uninitializedIndex * numCol, outIndex * numCol);
        for(let i = start; i < end; ++i){
            const index = indices[i];
            if (index < 0 || index >= inputFlat[0]) throw new Error((0, $7MaPk).getSparseSegmentReductionIndicesOutOfRangeErrorMessage(i, indices[i], inputFlat[0]));
            for(let j = 0; j < numCol; j++)output[outIndex * numCol + j] += input[index * numCol + j];
        }
        if (isMean) for(let j = 0; j < numCol; j++)output[outIndex * numCol + j] /= end - start;
        start = end;
        ++end;
        uninitializedIndex = outIndex + 1;
        outIndex = nextIndex;
        if (end > numIndices) break;
    }
    // Fill the gap at the end with the default value.
    if (uninitializedIndex < outputRows) output.fill(defaultValue, uninitializedIndex * numCol, outputRows * numCol);
    return [
        output,
        outputShape
    ];
}

});

parcelRegister("2a43t", function(module, exports) {

$parcel$export(module.exports, "sqrtImpl", () => $192fa93631ecc8b3$export$c6f4fdf945028fb);
$parcel$export(module.exports, "sqrtConfig", () => $192fa93631ecc8b3$export$a592ba9268f10eeb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $19W3p = parcelRequire("19W3p");

var $l6afd = parcelRequire("l6afd");
const $192fa93631ecc8b3$export$c6f4fdf945028fb = (0, $19W3p.createSimpleUnaryImpl)((xi)=>Math.sqrt(xi));
const $192fa93631ecc8b3$export$eba8049fb5020b81 = (0, $l6afd.unaryKernelFunc)((0, $hl418.Sqrt), (xi)=>Math.sqrt(xi));
const $192fa93631ecc8b3$export$a592ba9268f10eeb = {
    kernelName: (0, $hl418.Sqrt),
    backendName: 'cpu',
    kernelFunc: $192fa93631ecc8b3$export$eba8049fb5020b81
};

});

parcelRegister("4QLZo", function(module, exports) {

$parcel$export(module.exports, "squaredDifferenceImpl", () => $38813e6e5782d77d$export$11806d7b3158c032);
$parcel$export(module.exports, "squaredDifferenceConfig", () => $38813e6e5782d77d$export$9ed4691d69db8a43);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $38813e6e5782d77d$export$11806d7b3158c032 = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>{
    const diff = a - b;
    return diff * diff;
});
const $38813e6e5782d77d$export$b178697fb6d0b37f = (0, $kgSwn.binaryKernelFunc)((0, $hl418.SquaredDifference), $38813e6e5782d77d$export$11806d7b3158c032);
const $38813e6e5782d77d$export$9ed4691d69db8a43 = {
    kernelName: (0, $hl418.SquaredDifference),
    backendName: 'cpu',
    kernelFunc: $38813e6e5782d77d$export$b178697fb6d0b37f
};

});

parcelRegister("hRUGg", function(module, exports) {

$parcel$export(module.exports, "staticRegexReplaceImpl", () => $d0235a7fdb0a671c$export$d0ac9d977b12e2a1);
$parcel$export(module.exports, "staticRegexReplaceConfig", () => $d0235a7fdb0a671c$export$1069b2f6977254f4);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $19W3p = parcelRequire("19W3p");

var $l6afd = parcelRequire("l6afd");
const $d0235a7fdb0a671c$export$d0ac9d977b12e2a1 = (0, $19W3p.createSimpleUnaryImpl)((x, attrs)=>{
    const { pattern: pattern, replaceGlobal: replaceGlobal, rewrite: rewrite } = attrs;
    // TODO(mattSoulanille): Don't create a regex each time.
    return x.replace(new RegExp(pattern, replaceGlobal ? 'g' : ''), rewrite);
});
const $d0235a7fdb0a671c$var$staticRegexReplace = (0, $l6afd.unaryKernelFuncFromImpl)((0, $hl418.StaticRegexReplace), $d0235a7fdb0a671c$export$d0ac9d977b12e2a1);
const $d0235a7fdb0a671c$export$1069b2f6977254f4 = {
    kernelName: (0, $hl418.StaticRegexReplace),
    backendName: 'cpu',
    kernelFunc: $d0235a7fdb0a671c$var$staticRegexReplace
};

});

parcelRegister("6Syfk", function(module, exports) {

$parcel$export(module.exports, "stridedSliceImpl", () => $502259d1d8c1a2b8$export$b7c450ffe7e10d88);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $iG87S = parcelRequire("iG87S");
function $502259d1d8c1a2b8$export$b7c450ffe7e10d88(outShape, xBuf, strides, begin) {
    const outBuf = (0, $iG87S.buffer)(outShape, xBuf.dtype);
    for(let i = 0; i < outBuf.size; i++){
        const loc = outBuf.indexToLoc(i);
        const newLoc = new Array(loc.length);
        for(let j = 0; j < newLoc.length; j++)newLoc[j] = loc[j] * strides[j] + begin[j];
        outBuf.set(xBuf.get(...newLoc), ...loc);
    }
    return outBuf;
}

});

parcelRegister("fopkM", function(module, exports) {

$parcel$export(module.exports, "stringNGramsImpl", () => $b34cbfc3c2be7992$export$67c0958e8184138b);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
/**
 * The StringNGramsOp class creates ngrams from ragged string data.
 * The constructor contains all attributes related to the operation such as
 * padding widths and strings, and the compute function can be used to
 * compute the ngrams for different ragged tensor inputs.
 */ class $b34cbfc3c2be7992$var$StringNGramsOp {
    constructor(separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences){
        this.separator = (0, $jjNRA).encodeString(separator);
        this.nGramWidths = nGramWidths;
        this.leftPad = (0, $jjNRA).encodeString(leftPad);
        this.rightPad = (0, $jjNRA).encodeString(rightPad);
        this.padWidth = padWidth;
        this.preserveShort = preserveShortSequences;
    }
    getPadWidth(nGramWidth) {
        // Ngrams can be padded with either a fixed pad width or a dynamic pad
        // width depending on the 'padWidth' arg, but in no case should the padding
        // ever be wider than 'nGramWidth' - 1.
        return Math.min(this.padWidth < 0 ? nGramWidth - 1 : this.padWidth, nGramWidth - 1);
    }
    getNumNGrams(length, nGramWidth) {
        const padWidth = this.getPadWidth(nGramWidth);
        return Math.max(0, length + 2 * padWidth - nGramWidth + 1);
    }
    createNGrams(data, splitIndex, output, outputStartIndex, numNGrams, nGramWidth) {
        for(let nGramIndex = 0; nGramIndex < numNGrams; ++nGramIndex){
            const padWidth = this.getPadWidth(nGramWidth);
            const leftPadding = Math.max(0, padWidth - nGramIndex);
            const rightPadding = Math.max(0, padWidth - (numNGrams - (nGramIndex + 1)));
            const numTokens = nGramWidth - (leftPadding + rightPadding);
            const dataStartIndex = splitIndex + (leftPadding > 0 ? 0 : nGramIndex - padWidth);
            // Calculate the total expected size of the nGram so we can reserve the
            // correct amount of space in the string.
            let nGramSize = 0;
            // Size of the left padding.
            nGramSize += leftPadding * this.leftPad.length;
            // Size of the tokens.
            for(let n = 0; n < numTokens; ++n)nGramSize += data[dataStartIndex + n].length;
            // Size of the right padding.
            nGramSize += rightPadding * this.rightPad.length;
            // Size of the separators.
            const numSeparators = leftPadding + rightPadding + numTokens - 1;
            nGramSize += numSeparators * this.separator.length;
            // Build the nGram.
            output[outputStartIndex + nGramIndex] = new Uint8Array(nGramSize);
            const nGram = output[outputStartIndex + nGramIndex];
            let nextNGramIndex = 0;
            const appendToNGram = (str)=>str.forEach((value)=>nGram[nextNGramIndex++] = value);
            for(let n = 0; n < leftPadding; ++n){
                appendToNGram(this.leftPad);
                appendToNGram(this.separator);
            }
            // Only output first numTokens - 1 pairs of data and separator
            for(let n = 0; n < numTokens - 1; ++n){
                appendToNGram(data[dataStartIndex + n]);
                appendToNGram(this.separator);
            }
            // Handle case when there are no tokens or no right padding as these
            // can result in consecutive separators.
            if (numTokens > 0) {
                // If we have tokens, then output last and then pair each separator
                // with the right padding that follows, to ensure nGram ends either with
                // the token or with the right pad.
                appendToNGram(data[dataStartIndex + numTokens - 1]);
                for(let n = 0; n < rightPadding; ++n){
                    appendToNGram(this.separator);
                    appendToNGram(this.rightPad);
                }
            } else {
                // If we don't have tokens, then the last item inserted into the nGram
                // has been the separator from the left padding loop above. Hence,
                // output right pad and separator and make sure to finish with a
                // padding, not a separator.
                for(let n = 0; n < rightPadding - 1; ++n){
                    appendToNGram(this.rightPad);
                    appendToNGram(this.separator);
                }
                appendToNGram(this.rightPad);
            }
        }
    }
    // Data and splits together form the definition of the ragged tensor,
    // where data is 1 dimensional and contains the values of the tensor
    // and splits denotes the indices at which each row starts.
    compute(data, splits) {
        // Validate that the splits are valid indices into data, only if there are
        // splits specified.
        const inputDataSize = data.length;
        const splitsSize = splits.length;
        if (splitsSize > 0) {
            let prevSplit = splits[0];
            if (prevSplit !== 0) throw new Error(`First split value must be 0, got ${prevSplit}`);
            for(let i = 1; i < splitsSize; ++i){
                let validSplits = splits[i] >= prevSplit;
                validSplits = validSplits && splits[i] <= inputDataSize;
                if (!validSplits) throw new Error(`Invalid split value ${splits[i]}, must be in [${prevSplit}, ${inputDataSize}]`);
                prevSplit = splits[i];
            }
            if (prevSplit !== inputDataSize) throw new Error(`Last split value must be data size. Expected ${inputDataSize}, got ${prevSplit}`);
        }
        const numBatchItems = splitsSize - 1;
        const nGramsSplits = (0, $jjNRA).getArrayFromDType('int32', splitsSize);
        // If there is no data or size, return an empty ragged tensor.
        if (inputDataSize === 0 || splitsSize === 0) {
            const empty = new Array(inputDataSize);
            for(let i = 0; i <= numBatchItems; ++i)nGramsSplits[i] = 0;
            return [
                empty,
                nGramsSplits
            ];
        }
        nGramsSplits[0] = 0;
        for(let i = 1; i <= numBatchItems; ++i){
            const length = splits[i] - splits[i - 1];
            let numNGrams = 0;
            this.nGramWidths.forEach((nGramWidth)=>{
                numNGrams += this.getNumNGrams(length, nGramWidth);
            });
            if (this.preserveShort && length > 0 && numNGrams === 0) numNGrams = 1;
            nGramsSplits[i] = nGramsSplits[i - 1] + numNGrams;
        }
        const nGrams = new Array(nGramsSplits[numBatchItems]);
        for(let i = 0; i < numBatchItems; ++i){
            const splitIndex = splits[i];
            let outputStartIdx = nGramsSplits[i];
            this.nGramWidths.forEach((nGramWidth)=>{
                const length = splits[i + 1] - splits[i];
                const numNGrams = this.getNumNGrams(length, nGramWidth);
                this.createNGrams(data, splitIndex, nGrams, outputStartIdx, numNGrams, nGramWidth);
                outputStartIdx += numNGrams;
            });
            // If we're preserving short sequences, check to see if no sequence was
            // generated by comparing the current output start idx to the original
            // one (nGramSplitsdata). If no ngrams were generated, then they will
            // be equal (since we increment outputStartIdx by numNGrams every
            // time we create a set of ngrams.)
            if (this.preserveShort && outputStartIdx === nGramsSplits[i]) {
                const dataLength = splits[i + 1] - splits[i];
                // One legitimate reason to not have any ngrams when this.preserveShort
                // is true is if the sequence itself is empty. In that case, move on.
                if (dataLength === 0) continue;
                // We don't have to worry about dynamic padding sizes here: if padding
                // was dynamic, every sequence would have had sufficient padding to
                // generate at least one nGram.
                const nGramWidth = dataLength + 2 * this.padWidth;
                const numNGrams = 1;
                this.createNGrams(data, splitIndex, nGrams, outputStartIdx, numNGrams, nGramWidth);
            }
        }
        return [
            nGrams,
            nGramsSplits
        ];
    }
}
function $b34cbfc3c2be7992$export$67c0958e8184138b(data, dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences) {
    return new $b34cbfc3c2be7992$var$StringNGramsOp(separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences).compute(data, dataSplits);
}

});

parcelRegister("5xLgA", function(module, exports) {

$parcel$export(module.exports, "stringSplitImpl", () => $4094b2f1bed37f56$export$c3b08e43aa36d65d);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
function $4094b2f1bed37f56$var$split(str, delimiters, skipEmpty, result) {
    if (!str.length) return;
    // When the delimiter is empty, the input is split into individual characters.
    if (delimiters.length === 0) {
        for(let i = 0; i < str.length; ++i)result.push(str.subarray(i, i + 1));
        return;
    }
    // When there is one delimiter, the input is split only at that delimiter.
    if (delimiters.length === 1) {
        const delimiter = delimiters[0];
        let f = str.indexOf(delimiter);
        while(f !== -1){
            const token = str.subarray(0, f);
            if (!skipEmpty || token.length !== 0) result.push(token);
            str = str.subarray(f + 1);
            f = str.indexOf(delimiter);
        }
        if (!skipEmpty || str.length !== 0) result.push(str);
        return;
    }
    // When there are multiple delimiters, the input is split at every instance
    // one of the delimiters appears.
    let tokenStart = 0;
    for(let i = 0; i < str.length + 1; i++)if (i === str.length || delimiters.indexOf(str[i]) !== -1) {
        const token = str.subarray(tokenStart, i);
        if (!skipEmpty || token.length !== 0) result.push(token);
        tokenStart = i + 1;
    }
}
function $4094b2f1bed37f56$export$c3b08e43aa36d65d(input, delimiter, skipEmpty) {
    const batchSize = input.length;
    // Empty delimiter means split the input character by character.
    const tokens = [];
    let outputSize = 0;
    let maxNumEntries = 0;
    const numIndices = new Array(batchSize);
    for(let i = 0; i < batchSize; ++i){
        const prevTokensLength = tokens.length;
        $4094b2f1bed37f56$var$split(input[i], delimiter, skipEmpty, tokens);
        const nEntries = tokens.length - prevTokensLength;
        numIndices[i] = nEntries;
        outputSize += nEntries;
        maxNumEntries = Math.max(maxNumEntries, nEntries);
    }
    const indices = (0, $jjNRA).getArrayFromDType('int32', outputSize * 2);
    const values = new Array(outputSize);
    const shape = [
        batchSize,
        maxNumEntries
    ];
    let c = 0;
    for(let i = 0; i < batchSize; ++i)for(let j = 0; j < numIndices[i]; ++j){
        // indices is a 2d tensor with shape of [outputSize, 2]
        indices[c * 2] = i;
        indices[c * 2 + 1] = j;
        values[c] = tokens[c];
        ++c;
    }
    return [
        indices,
        values,
        shape
    ];
}

});

parcelRegister("cWacD", function(module, exports) {

$parcel$export(module.exports, "stringToHashBucketFastImpl", () => $96b2d0e293164c5b$export$37cbed4d0b2fe56a);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");
function $96b2d0e293164c5b$export$37cbed4d0b2fe56a(input, numBuckets) {
    const output = (0, $jjNRA).getArrayFromDType('int32', input.length);
    for(let i = 0; i < input.length; ++i)output[i] = (0, $jjNRA).fingerPrint64(input[i]).modulo(numBuckets).getLowBitsUnsigned();
    return output;
}

});

parcelRegister("aT9VE", function(module, exports) {

$parcel$export(module.exports, "subImpl", () => $7ed6be13946455c6$export$ad8defe68e22c8c1);
$parcel$export(module.exports, "sub", () => $7ed6be13946455c6$export$f93b5905241a7cca);
$parcel$export(module.exports, "subConfig", () => $7ed6be13946455c6$export$5d068476dad60c4d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $7ed6be13946455c6$export$ad8defe68e22c8c1 = (0, $jQJ39.createSimpleBinaryKernelImpl)((aValue, bValue)=>aValue - bValue);
const $7ed6be13946455c6$export$e56bd24b892e7ec5 = (0, $kgSwn.createComplexBinaryKernelImpl)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal - bReal,
        imag: aImag - bImag
    };
});
const $7ed6be13946455c6$export$f93b5905241a7cca = (0, $kgSwn.binaryKernelFunc)((0, $hl418.Sub), $7ed6be13946455c6$export$ad8defe68e22c8c1, $7ed6be13946455c6$export$e56bd24b892e7ec5);
const $7ed6be13946455c6$export$5d068476dad60c4d = {
    kernelName: (0, $hl418.Sub),
    backendName: 'cpu',
    kernelFunc: $7ed6be13946455c6$export$f93b5905241a7cca
};

});

parcelRegister("bzU8O", function(module, exports) {

$parcel$export(module.exports, "tileImpl", () => $86de830738bbdf53$export$f3e554b937559516);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $iG87S = parcelRequire("iG87S");
function $86de830738bbdf53$export$f3e554b937559516(xBuf, reps) {
    const newShape = new Array(xBuf.rank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = xBuf.shape[i] * reps[i];
    const result = (0, $iG87S.buffer)(newShape, xBuf.dtype);
    for(let i = 0; i < result.values.length; ++i){
        const newLoc = result.indexToLoc(i);
        const originalLoc = new Array(xBuf.rank);
        for(let j = 0; j < originalLoc.length; j++)originalLoc[j] = newLoc[j] % xBuf.shape[j];
        const originalIndex = xBuf.locToIndex(originalLoc);
        result.values[i] = xBuf.values[originalIndex];
    }
    return result;
}

});

parcelRegister("8tNzN", function(module, exports) {

$parcel$export(module.exports, "topKImpl", () => $62c77cff30bd68d4$export$b083239978762299);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /** An implementation of the TopK kernel shared between webgl and cpu. */ parcelRequire("i64bB");
var $iG87S = parcelRequire("iG87S");
var $jjNRA = parcelRequire("jjNRA");
const $62c77cff30bd68d4$var$comparePair = (a, b)=>{
    const valueDiff = b.value - a.value;
    return valueDiff === 0 ? a.index - b.index : valueDiff;
};
/**
 * Partitions array where all elements smaller than the (k+1) smallest element
 * are found to the left of it, and all larger to the right of it.
 * Based on the Floyd-Rivest Algorithm, ref:
 * https://en.wikipedia.org/wiki/Floyd%E2%80%93Rivest_algorithm
 * @param array: Array to partition
 * @param left: Left index for the interval
 * @param right: Right index for the interval
 * @param k: Desired index value, where array[k] is the (k+1)th smallest element
 *           when left = 0
 */ function $62c77cff30bd68d4$var$select(array, k, left = 0, right = array.length - 1) {
    while(right > left){
        // Use select recursively to sample a smaller set of size s
        // the arbitrary constants 600 and 0.5 are used in the original
        // version to minimize execution time.
        if (right - left > 600) {
            const n = right - left + 1;
            const i = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * Math.sign(i - n / 2);
            const newLeft = Math.max(left, Math.floor(k - i * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - i) * s / n + sd));
            $62c77cff30bd68d4$var$select(array, k, newLeft, newRight);
        }
        // partition the elements between left and right around t
        const t = array[k];
        let i = left;
        let j = right;
        (0, $jjNRA).swap(array, left, k);
        if ($62c77cff30bd68d4$var$comparePair(array[right], t) > 0) (0, $jjNRA).swap(array, left, right);
        while(i < j){
            (0, $jjNRA).swap(array, i, j);
            i++;
            j--;
            while($62c77cff30bd68d4$var$comparePair(array[i], t) < 0)i = i + 1;
            while($62c77cff30bd68d4$var$comparePair(array[j], t) > 0)j = j - 1;
        }
        if ($62c77cff30bd68d4$var$comparePair(array[left], t) === 0) (0, $jjNRA).swap(array, left, j);
        else {
            j = j + 1;
            (0, $jjNRA).swap(array, j, right);
        }
        // Adjust left and right towards the boundaries of the subset
        // containing the (k - left + 1)th smallest element.
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
function $62c77cff30bd68d4$export$b083239978762299(x, xShape, xDtype, k, sorted) {
    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
    const lastDim = xShape[xShape.length - 1];
    const [batch, size] = [
        x.length / lastDim,
        lastDim
    ];
    const allTopKVals = (0, $jjNRA).getTypedArrayFromDType(xDtype, batch * k);
    const allTopKIndices = (0, $jjNRA).getTypedArrayFromDType('int32', batch * k);
    for(let b = 0; b < batch; b++){
        const offset = b * size;
        const vals = x.subarray(offset, offset + size);
        let valAndInd = new Array(vals.length);
        vals.forEach((value, index)=>valAndInd[index] = {
                value: value,
                index: index
            });
        if (k < valAndInd.length) {
            $62c77cff30bd68d4$var$select(valAndInd, k);
            valAndInd = valAndInd.slice(0, k);
        }
        if (sorted) valAndInd.sort($62c77cff30bd68d4$var$comparePair);
        const outOffset = b * k;
        const topKVals = allTopKVals.subarray(outOffset, outOffset + k);
        const topKIndices = allTopKIndices.subarray(outOffset, outOffset + k);
        for(let i = 0; i < k; i++){
            topKVals[i] = valAndInd[i].value;
            topKIndices[i] = valAndInd[i].index;
        }
    }
    // Reshape back to the original input shape, except that the last
    // dimension is k.
    const outputShape = xShape.slice();
    outputShape[outputShape.length - 1] = k;
    return [
        (0, $iG87S.buffer)(outputShape, xDtype, allTopKVals),
        (0, $iG87S.buffer)(outputShape, 'int32', allTopKIndices)
    ];
}

});

parcelRegister("fjkAl", function(module, exports) {

$parcel$export(module.exports, "uniqueImpl", () => $b2589921922a3916$export$58be9cc013c994e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $9jCh7 = parcelRequire("9jCh7");
var $jjNRA = parcelRequire("jjNRA");
function $b2589921922a3916$export$58be9cc013c994e(values, axis, shape, dtype) {
    // Normalize and validate axis.
    const $axis = (0, $jjNRA).parseAxisParam(axis, shape)[0];
    // Calculate the new shape that is suitable for extracting data along the
    // given axis.
    //
    // The rank is 3.
    // The size of the 1st dimension is the size of all the axes < the given axis.
    // The size of the 2nd dimension is the same as the size of the given axis.
    // The size of the 3rd dimension is the size of all the axes > the given axis.
    //
    // For example, for a 4D tensor with shape=[2, 3, 5, 4] and axis=2, the
    // newShape would be: [2*3, 5, 4].
    //
    // Note that this is not the final output shape. This will be the shape for an
    // intermediate TensorBuffer (see inputBuffer below) to allow us to extract
    // values along the given axis. To demonstrate how it works, consider the
    // following example:
    //
    // Input: a 3D tensor, with shape [1, 2, 3]
    // [
    //   [
    //      [1,2,3],
    //      [4,5,6]
    //   ]
    // ]
    // Axis: 2 (the last axis).
    // Along axis 2, we expect to extract 3 tensors: [1,4], [2,5], [3,6].
    //
    // For this example, newShape would be: [2, 3, 1], where 2 is calculated from
    // 1*2. The re-shaped data would look like:
    //
    // [
    //   [
    //     [1], [2], [3]
    //   ],
    //   [
    //     [4], [5], [6]
    //   ]
    // ]
    //
    // Then, we can construct a 3-level nested loop by the following dimension
    // order to extract the values along the axis (dimension1):
    // i: dimension1       // 0,1,2 (newShape[1])
    //   m: dimension0     // 0,1   (newShape[0])
    //     n: dimension2   // 0     (newShape[2])
    //
    //                       m, i, n
    //                      ---------
    // Iteration 0: data at [0, 0, 0] => "1"
    // Iteration 1: data at [1, 0, 0] => "4"
    // We got [1,4].
    // Iteration 2: data at [0, 1, 0] => "2"
    // Iteration 3: data at [1, 1, 0] => "5"
    // We got [2,5].
    // Iteration 4: data at [0, 2, 0] => "3"
    // Iteration 5: data at [1, 2, 0] => "6"
    // We got [3,6].
    const newShape = [
        1,
        shape[0],
        1
    ];
    for(let i = 0; i < $axis; i++)newShape[0] *= shape[i];
    newShape[1] = shape[$axis];
    for(let i = $axis + 1; i < shape.length; i++)newShape[2] *= shape[i];
    // A map from unique elements (their string representations) to their values
    // in "indices" (below).
    const uniqueElements = new Map();
    // The indices of each unique element in the original tensor along the given
    // axis. It is 1D and has the same size as the given axis.
    const indices = new Int32Array(shape[$axis]);
    // Create a buffer so we can easily extract value at a given location.
    const inputBuffer = new (0, $9jCh7.TensorBuffer)(newShape, dtype, values);
    // The indices along the given axis that have unique elements. This is a
    // de-duped version of "indices" above.
    const uniqueIndices = [];
    const is1DTensor = newShape[0] === 1 && newShape[2] === 1;
    for(let i = 0; i < shape[$axis]; i++){
        // Extract values along the axis.
        let element;
        if (is1DTensor) // Fast path for 1D tensor input.
        element = values[i].toString();
        else {
            const axisValues = [];
            for(let m = 0; m < newShape[0]; m++)for(let n = 0; n < newShape[2]; n++)axisValues.push(inputBuffer.get(m, i, n));
            element = axisValues.join(',');
        }
        // Dedup and update various indices.
        const existingIndex = uniqueElements.get(element);
        if (existingIndex != null) indices[i] = existingIndex;
        else {
            const uniqueIndex = uniqueElements.size;
            uniqueElements.set(element, uniqueIndex);
            indices[i] = uniqueIndex;
            uniqueIndices.push(i);
        }
    }
    // Now we know where each of the unique elements are located along the axis
    // (uniqueIndices). Extract them from input buffer and store them in the
    // output buffer.
    const outputTmpShape = newShape.slice();
    outputTmpShape[1] = uniqueElements.size;
    const outputBuffer = new (0, $9jCh7.TensorBuffer)(outputTmpShape, dtype);
    uniqueIndices.forEach((uniqueElementIndex, i)=>{
        for(let m = 0; m < newShape[0]; m++)for(let n = 0; n < newShape[2]; n++)outputBuffer.set(inputBuffer.get(m, uniqueElementIndex, n), m, i, n);
    });
    // The output shape can be calculated from the input shape with the size of
    // the given axis replaced by the number of unique elements along that axis.
    const outputShape = shape.slice();
    outputShape[$axis] = outputTmpShape[1];
    return {
        outputValues: outputBuffer.values,
        outputShape: outputShape,
        indices: indices
    };
}

});




parcelRegister("8s9nH", function(module, exports) {

$parcel$export(module.exports, "acosConfig", () => $6278372986111688$export$255826ca70737275);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $6278372986111688$export$fd6306be3fde5b04 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).ACOS
});
const $6278372986111688$export$255826ca70737275 = {
    kernelName: (0, $hl418.Acos),
    backendName: 'webgpu',
    kernelFunc: $6278372986111688$export$fd6306be3fde5b04
};

});

parcelRegister("ioNsO", function(module, exports) {

$parcel$export(module.exports, "acoshConfig", () => $d650d6541f582485$export$3f520b71a56c9e70);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $d650d6541f582485$export$b26caf0f29211d08 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).ACOSH
});
const $d650d6541f582485$export$3f520b71a56c9e70 = {
    kernelName: (0, $hl418.Acosh),
    backendName: 'webgpu',
    kernelFunc: $d650d6541f582485$export$b26caf0f29211d08
};

});

parcelRegister("9Vvdb", function(module, exports) {

$parcel$export(module.exports, "addConfig", () => $73a1a5e3f6d9337e$export$b1f3a580afb68e4c);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $73a1a5e3f6d9337e$export$d50bf7e4980f70a9 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).ADD,
    cpuKernelImpl: (0, $aLZc7.addImplCPU),
    supportsComplex: true
});
const $73a1a5e3f6d9337e$export$b1f3a580afb68e4c = {
    kernelName: (0, $hl418.Add),
    backendName: 'webgpu',
    kernelFunc: $73a1a5e3f6d9337e$export$d50bf7e4980f70a9
};

});

parcelRegister("3IxST", function(module, exports) {

$parcel$export(module.exports, "addNConfig", () => $2b4fc3e3caa07844$export$ff8000bc6f0313e1);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $2MDja = parcelRequire("2MDja");

var $ckCl5 = parcelRequire("ckCl5");

var $17o8l = parcelRequire("17o8l");
function $2b4fc3e3caa07844$export$37b75d0026f96b8d(args) {
    const { inputs: inputs, backend: backend } = args;
    const tensors = inputs;
    if (tensors.length === 1) return (0, $17o8l.identity)({
        inputs: {
            x: tensors[0]
        },
        backend: backend
    });
    const dtype = tensors.map((t)=>t.dtype).reduce((d1, d2)=>(0, $2MDja.upcastType)(d1, d2));
    const shapes = tensors.map((t)=>t.shape);
    const program = new (0, $ckCl5.AddNPackedProgram)(shapes);
    return backend.runWebGPUProgram(program, tensors, dtype);
}
const $2b4fc3e3caa07844$export$ff8000bc6f0313e1 = {
    kernelName: (0, $hl418.AddN),
    backendName: 'webgpu',
    kernelFunc: $2b4fc3e3caa07844$export$37b75d0026f96b8d
};

});
parcelRegister("ckCl5", function(module, exports) {

$parcel$export(module.exports, "AddNPackedProgram", () => $8fa517a9369762c5$export$156b01c0aab97d90);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $8fa517a9369762c5$export$156b01c0aab97d90 {
    constructor(shapes){
        this.workPerThread = 1;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shapes[0];
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        this.shaderKey = 'addN';
    }
    getUserCode() {
        const snippets = [];
        // Get target elements from every input tensor.
        this.variableNames.forEach((variable)=>{
            snippets.push(`let v${variable} = get${variable}ByOutputCoords(coords);`);
        });
        // Calculate the sum of all elements.
        const operation = this.variableNames.map((variable)=>{
            return `v${variable}`;
        }).join(' + ');
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        for (var i = 0; i < ${this.workPerThread}; i = i + 1) {
          let flatIndex = index * ${this.workPerThread} + i;
          if (flatIndex < uniforms.size) {
            let coords = getCoordsFromIndex(flatIndex);
            ${snippets.join('\n        ')}
            setOutputAtIndex(flatIndex, ${operation});
          }
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("hweGq", function(module, exports) {

$parcel$export(module.exports, "allConfig", () => $cc10d0a536940236$export$4e3f081eb1a330fa);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $qiVpd = parcelRequire("qiVpd");
function $cc10d0a536940236$export$84bf76cd7afc7469(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { keepDims: keepDims, axis: axis } = attrs;
    return (0, $qiVpd.reduce)(x, axis, keepDims, 'all', backend);
}
const $cc10d0a536940236$export$4e3f081eb1a330fa = {
    kernelName: (0, $hl418.All),
    backendName: 'webgpu',
    kernelFunc: $cc10d0a536940236$export$84bf76cd7afc7469
};

});
parcelRegister("qiVpd", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $04f11be9ca3c1559$export$533b26079ad0b4b);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $2MDja = parcelRequire("2MDja");
var $jjNRA = parcelRequire("jjNRA");

var $gj4T5 = parcelRequire("gj4T5");

var $f9YmZ = parcelRequire("f9YmZ");

var $lna1T = parcelRequire("lna1T");

var $aLZc7 = parcelRequire("aLZc7");
const $04f11be9ca3c1559$var$RETURN_TYPES = {
    'mean': 'float32',
    'all': 'bool',
    'any': 'bool'
};
function $04f11be9ca3c1559$export$533b26079ad0b4b(x, axis, keepDims, reduceType, backend) {
    const xRank = x.shape.length;
    const toDispose = [];
    const origAxes = (0, $jjNRA).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $7MaPk).getAxesPermutation(axes, xRank);
    let input = x;
    if (permutedAxes != null) {
        input = (0, $f9YmZ.transpose)({
            inputs: {
                x: x
            },
            attrs: {
                perm: permutedAxes
            },
            backend: backend
        });
        axes = (0, $7MaPk).getInnerMostAxes(axes.length, xRank);
        toDispose.push(input);
    }
    (0, $7MaPk).assertAxesAreInnerMostDims(reduceType, axes, xRank);
    const [reduceOutShape, reduceShape] = (0, $7MaPk).computeOutAndReduceShapes(input.shape, axes);
    let resOutShape = reduceOutShape;
    if (keepDims) // rather than reshape at the end, set the target shape here.
    resOutShape = (0, $7MaPk).expandShapeToKeepDim(reduceOutShape, origAxes);
    let res;
    if ((reduceType === 'max' || reduceType === 'prod') && backend.shouldExecuteOnCPU([
        input
    ])) {
        const xVals = backend.tensorMap.get(input.dataId).values;
        switch(reduceType){
            case 'max':
                const outValues = (0, $aLZc7.maxImplCPU)(xVals, (0, $jjNRA).sizeFromShape(reduceShape), resOutShape, x.dtype);
                res = backend.makeTensorInfo(resOutShape, x.dtype, outValues);
                break;
            case 'prod':
                const { outVals: outVals, outShape: outShape, outDtype: outDtype } = (0, $aLZc7.prodImplCPU)(input.shape, input.dtype, xVals, axes);
                res = backend.makeTensorInfo(outShape, outDtype, outVals);
                break;
            default:
                throw new Error(`${reduceType} CPU implementation is not yet supported.`);
        }
    } else {
        const inSize = (0, $jjNRA).sizeFromShape(reduceShape);
        const xSize = (0, $jjNRA).sizeFromShape(input.shape);
        const batchSize = xSize / inSize;
        const reduceInfo = {
            windowSize: inSize,
            inSize: inSize,
            batchSize: batchSize,
            outSize: 1
        };
        const dtype = $04f11be9ca3c1559$var$RETURN_TYPES[reduceType] || (0, $2MDja.sumOutType)(x.dtype);
        const uniformData = [
            {
                type: 'int32',
                data: [
                    inSize
                ]
            }
        ];
        const program = new (0, $lna1T.ReduceProgram)(reduceInfo, reduceType, backend.device.limits.maxComputeWorkgroupSizeX);
        const reduced = backend.runWebGPUProgram(program, [
            input
        ], dtype, uniformData);
        toDispose.push(reduced);
        res = (0, $gj4T5.reshape)({
            inputs: {
                x: reduced
            },
            attrs: {
                shape: resOutShape
            },
            backend: backend
        });
    }
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return res;
}

});
parcelRegister("f9YmZ", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $b09686769ac29f91$export$9cb09a71b7d66923);
$parcel$export(module.exports, "transposeConfig", () => $b09686769ac29f91$export$895a002a39b774be);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $aLZc7 = parcelRequire("aLZc7");

var $cslAs = parcelRequire("cslAs");

var $lCb9L = parcelRequire("lCb9L");
function $b09686769ac29f91$export$9cb09a71b7d66923(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { perm: perm } = attrs;
    const webgpuBackend = backend;
    const xRank = x.shape.length;
    const newShape = new Array(xRank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[perm[i]];
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const xData = webgpuBackend.tensorMap.get(x.dataId);
        const values = xData.values;
        const outValues = (0, $aLZc7.transposeImplCPU)(values, x.shape, x.dtype, perm, newShape);
        return backend.makeTensorInfo(newShape, x.dtype, outValues);
    }
    if (x.shape.length === 2 && (0, $jjNRA).arraysEqual(perm, [
        1,
        0
    ])) {
        const program = new (0, $cslAs.TransposeSharedProgram)(x.shape, perm);
        return webgpuBackend.runWebGPUProgram(program, [
            x
        ], x.dtype);
    }
    const program = new (0, $lCb9L.TransposeProgram)(x.shape, perm);
    return webgpuBackend.runWebGPUProgram(program, [
        x
    ], x.dtype);
}
const $b09686769ac29f91$export$895a002a39b774be = {
    kernelName: (0, $hl418.Transpose),
    backendName: 'webgpu',
    kernelFunc: $b09686769ac29f91$export$9cb09a71b7d66923
};

});
parcelRegister("cslAs", function(module, exports) {

$parcel$export(module.exports, "TransposeSharedProgram", () => $9118d84fe44daef2$export$bc7d0d329ecc3b4f);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $9118d84fe44daef2$export$bc7d0d329ecc3b4f {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        // Note that the maximum number of workgroup invocations by webgpu is 256.
        this.workgroupSize = [
            16,
            16,
            1
        ];
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [
                0
            ],
            y: [
                1
            ]
        };
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            1,
            1,
            1
        ]);
        this.shaderKey = 'transposeShared';
    }
    getUserCode() {
        (0, $jjNRA).assert(this.workgroupSize[0] === this.workgroupSize[1], ()=>`Must be a square tile, current tile shape is ${this.workgroupSize[0]} x ${this.workgroupSize[1]}`);
        const tileSize = this.workgroupSize[0];
        const userCode = `
      var<workgroup> tile : array<array<f32, ${this.workgroupSize[0] + 1}>, ${this.workgroupSize[0]}>;
      ${(0, $oGQBh.getMainHeaderString)()} {
        var x = i32(workgroupId.x) * ${tileSize} + i32(localId.x);
        var y = i32(workgroupId.y) * ${tileSize} + i32(localId.y);
        let width = uniforms.outShape[0];
        let height = uniforms.outShape[1];
        if (x < width && y < height) {
          tile[localId.y][localId.x] = f32(A[y * width + x]);
        }
        workgroupBarrier();

        x = i32(workgroupId.y) * ${tileSize} + i32(localId.x);
        y = i32(workgroupId.x) * ${tileSize} + i32(localId.y);
        if (x < height && y < width) {
          setOutputAtIndex((y * height + x), tile[localId.x]
            [localId.y]);
        }
      }
    `;
        return userCode;
    }
}

});

parcelRegister("lCb9L", function(module, exports) {

$parcel$export(module.exports, "TransposeProgram", () => $fbc5cd035a69d956$export$e48ac6bd7e0ddfac);
$parcel$export(module.exports, "getSwitchedCoords", () => $fbc5cd035a69d956$export$2fa044c45543b8d9);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $fbc5cd035a69d956$export$e48ac6bd7e0ddfac {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        this.workPerThread = 1;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        this.newDim = newDim;
        this.shaderKey = `transpose_${newDim}`;
    }
    getUserCode() {
        const dtype = (0, $oGQBh.getCoordsDataType)(this.outputShape.length);
        const switched = $fbc5cd035a69d956$export$2fa044c45543b8d9(this.newDim);
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        for(var i = 0; i < ${this.workPerThread}; i = i + 1) {
          let flatIndex = index * ${this.workPerThread} + i;
          if(flatIndex < uniforms.size) {
            let coords = getCoordsFromIndex(flatIndex);
            setOutputAtIndex(flatIndex, A[getIndexFromCoords${this.outputShape.length}D(
              ${dtype}(${switched}), uniforms.aShape)]);
          }
        }
      }
    `;
        return userCode;
    }
}
function $fbc5cd035a69d956$export$2fa044c45543b8d9(newDim) {
    const rank = newDim.length;
    if (rank > 6) throw Error(`Transpose for rank ${rank} is not yet supported`);
    const switchedCoords = new Array(rank);
    for(let i = 0; i < newDim.length; i++)switchedCoords[newDim[i]] = `coords.${(0, $oGQBh.getCoordsXYZ)(i)}`;
    return switchedCoords.join();
}

});


parcelRegister("lna1T", function(module, exports) {

$parcel$export(module.exports, "ReduceProgram", () => $f8f3869a504c3e68$export$14f07173aed228a5);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $f8f3869a504c3e68$export$14f07173aed228a5 {
    constructor(reduceInfo, reduceType, maxComputeWorkgroupSizeX){
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'reduceSize : i32,';
        this.size = true;
        this.inputShape = [
            reduceInfo.batchSize,
            reduceInfo.inSize
        ];
        const [outputShape] = (0, $7MaPk).computeOutAndReduceShapes(this.inputShape, [
            1
        ]);
        this.outputShape = outputShape.length === 0 ? [
            1
        ] : outputShape;
        // If reduceSize |reduceInfo.inSize| is very large, the I/O accessing will
        // become the bottleneck. Increasing workgroupSize can reduce the times of
        // accessing global memory. The threshold value is just to make sure the
        // reduceSize is large enough for a bigger workgroupSize.
        if (reduceInfo.inSize >= 32768 && maxComputeWorkgroupSizeX >= 512) this.workgroupSize = [
            512,
            1,
            1
        ];
        else if (reduceInfo.inSize >= 4096) this.workgroupSize = [
            256,
            1,
            1
        ];
        else this.workgroupSize = [
            64,
            1,
            1
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        // A work group only outputs a data, so we transfer [1, 1, 1] to compute
        // dispatch size.
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, [
            1,
            1,
            1
        ]);
        this.reduceType = reduceType;
        this.shaderKey = `reduce_${reduceType}`;
    }
    getUserCode() {
        let reduceOp = ``;
        let initValue = '0.0';
        const workgroupSizeX = this.workgroupSize[0];
        if (this.reduceType === 'min' || this.reduceType === 'max') {
            reduceOp = `
         if (isnan(candidate)) {
          bestValue = uniforms.NAN;
         } else if (!isnan(bestValue) && candidate ${this.reduceType === 'min' ? '<' : '>'} bestValue)
           {  bestValue = candidate; }`;
            initValue = 'f32(x[offset])';
        } else if (this.reduceType === 'sum' || this.reduceType === 'mean') reduceOp = ' bestValue = bestValue + candidate; ';
        else if (this.reduceType === 'prod') {
            reduceOp = ' bestValue = bestValue * candidate; ';
            initValue = '1.0';
        } else if (this.reduceType === 'all') {
            reduceOp = ' bestValue = f32(bestValue >= 1.0 && candidate >= 1.0); ';
            initValue = '1.0';
        } else if (this.reduceType === 'any') {
            reduceOp = ' bestValue = f32(bestValue >= 1.0 || candidate >= 1.0); ';
            initValue = '0.0';
        }
        const outputSnippet = this.reduceType === 'mean' ? // tslint:disable-next-line:max-line-length
        `setOutputAtIndex(outputIndex, bestValue / f32(uniforms.reduceSize));` : `setOutputAtIndex(outputIndex, bestValue);`;
        const sharedMemorySnippet = `
         var<workgroup> xBestValues : array<f32, ${workgroupSizeX}>;
       `;
        const userCode = `
       fn DIV_CEIL(a : u32, b : u32) -> u32 {
        return ((a - 1u) / b + 1u);
       }

       ${sharedMemorySnippet}
       fn getOffset(outputIndex : i32) -> i32 {
         let outputCoords = getCoordsFromIndex(outputIndex);
         let offset = ${this.outputShape.length === 1 ? 'outputCoords' : 'outputCoords[0]'} * uniforms.reduceSize;
          return offset;
       }
       ${(0, $oGQBh.getMainHeaderString)('index')} {
         let outputIndex = index / ${workgroupSizeX};
         let offset = getOffset(outputIndex);
         var bestValue = ${initValue};
         let Length = uniforms.reduceSize;
         let WorkPerThread = DIV_CEIL(u32(Length), ${workgroupSizeX}u);
         for (var k = i32(localId.x); k < Length && outputIndex < uniforms.size;
             k = k + ${workgroupSizeX}) {
           let candidate = f32(x[offset + k]);
           ${reduceOp}
         }
         xBestValues[localId.x] = bestValue;
         workgroupBarrier();

         var reduceSize = min(u32(Length), ${workgroupSizeX}u);
         for (var currentSize = reduceSize / 2u; reduceSize > 1u;
             currentSize = reduceSize / 2u) {
           let interval = DIV_CEIL(reduceSize, 2u);
           if (localId.x < currentSize) {
            let candidate = xBestValues[localId.x + interval];
            ${reduceOp}
            xBestValues[localId.x] = bestValue;
           }
           reduceSize = interval;
           workgroupBarrier();
         }

         if (localId.x == 0u && outputIndex < uniforms.size) {
          ${outputSnippet}
        }
       }
     `;
        return userCode;
    }
}

});



parcelRegister("hsc0m", function(module, exports) {

$parcel$export(module.exports, "anyConfig", () => $cb4e5d1e192901ea$export$1a8ff634f2df3da6);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $qiVpd = parcelRequire("qiVpd");
function $cb4e5d1e192901ea$export$4154a199d7d90455(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { keepDims: keepDims, axis: axis } = attrs;
    return (0, $qiVpd.reduce)(x, axis, keepDims, 'any', backend);
}
const $cb4e5d1e192901ea$export$1a8ff634f2df3da6 = {
    kernelName: (0, $hl418.Any),
    backendName: 'webgpu',
    kernelFunc: $cb4e5d1e192901ea$export$4154a199d7d90455
};

});

parcelRegister("6re1B", function(module, exports) {

$parcel$export(module.exports, "argMaxConfig", () => $4b0024bbc0cacebc$export$ec7419fc9ad0069e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");

var $8HST9 = parcelRequire("8HST9");

var $f9YmZ = parcelRequire("f9YmZ");
function $4b0024bbc0cacebc$export$7980a683c1b852b4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $jjNRA).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $7MaPk).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $f9YmZ.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $7MaPk).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $7MaPk).assertAxesAreInnerMostDims('argMax', [
        axes[0]
    ], $x.shape.length);
    const program = new (0, $8HST9.ArgMinMaxProgram)($x.shape, axes[0], 'max');
    const uniformData = [
        {
            type: 'float32',
            data: [
                Number.NEGATIVE_INFINITY
            ]
        }
    ];
    const out = backend.runWebGPUProgram(program, [
        $x
    ], 'int32', uniformData);
    intermediateTensorInfos.forEach((t)=>backend.disposeData(t.dataId));
    return out;
}
const $4b0024bbc0cacebc$export$ec7419fc9ad0069e = {
    kernelName: (0, $hl418.ArgMax),
    backendName: 'webgpu',
    kernelFunc: $4b0024bbc0cacebc$export$7980a683c1b852b4
};

});
parcelRegister("8HST9", function(module, exports) {

$parcel$export(module.exports, "ArgMinMaxProgram", () => $656cea994207a339$export$7fa5759722b57eba);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $656cea994207a339$export$7fa5759722b57eba {
    constructor(inputShape, axis, reduceType){
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'infinityValue : f32,';
        this.size = true;
        const axes = [
            axis
        ];
        this.op = reduceType === 'min' ? '<' : '>';
        // |outShape| is the shape with the removed axis
        const [outputShape, reduceShape] = (0, $7MaPk).computeOutAndReduceShapes(inputShape, axes);
        this.outputShape = outputShape.length === 0 ? [
            1
        ] : outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        // The shared algorithm is mainly used for large reduce size. It fully
        // utilizes the threads in one workgroup to do the reduction. However,
        // when the reduce size is very small, it's better to use the plain
        // algorithm to reduce the number of workgroups to speedup. The threthold
        // can be further tuned.
        if ((0, $jjNRA).sizeFromShape(reduceShape) < 32) {
            this.type = 'plain';
            this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        } else {
            this.type = 'shared';
            // A work group only outputs a data, so we transfer [1, 1, 1] to compute
            // dispatch size.
            this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, [
                1,
                1,
                1
            ]);
        }
        this.inputShape = inputShape;
        this.shaderKey = `argMinMax_${this.op}_${this.type}`;
    }
    getUserCode() {
        const workgroupSizeX = this.workgroupSize[0];
        const getInputShapeLastDim = ()=>{
            if (this.inputShape.length === 1) return 'uniforms.xShape';
            else return `uniforms.xShape.${(0, $oGQBh.getCoordsXYZ)(this.inputShape.length - 1)}`;
        };
        const splitOutputCoords = ()=>{
            let snippet = '';
            if (this.outputShape.length === 1) {
                if (this.inputShape.length !== 1) snippet += 'outputCoords,';
            } else for(let i = 0; i < this.outputShape.length; i++)snippet += `outputCoords.${(0, $oGQBh.getCoordsXYZ)(i)},`;
            return snippet;
        };
        if (this.type === 'shared') {
            const sharedMemorySnippet = `
      var<workgroup> xBestIndices : array<i32, ${workgroupSizeX}>;
      var<workgroup> xBestValues : array<f32, ${workgroupSizeX}>;
    `;
            const userCode = `
      fn DIV_CEIL(a : u32, b : u32) -> u32 {
        return ((a - 1u) / b + 1u);
      }

      ${sharedMemorySnippet}

      ${(0, $oGQBh.getMainHeaderString)('index')} {
        let outputIndex = index / ${workgroupSizeX};
        let reduceLength = ${getInputShapeLastDim()};

        var bestIndex = i32(localId.x);
        var bestValue = uniforms.infinityValue;
        let outputCoords = getCoordsFromIndex(outputIndex);
        for (var k = i32(localId.x); k < reduceLength && outputIndex < uniforms.size;
            k = k + ${workgroupSizeX}) {
          let candidate = getX(${splitOutputCoords()} k);
          if (!isnan(candidate) && candidate ${this.op} bestValue) {
            bestValue = candidate;
            bestIndex = k;
          }
        }
        xBestValues[localId.x] = bestValue;
        xBestIndices[localId.x] = bestIndex;
        workgroupBarrier();

        var reduceSize = min(u32(reduceLength), ${workgroupSizeX}u);
        for (var currentSize = reduceSize / 2u; reduceSize > 1u;
            currentSize = reduceSize / 2u) {
          let interval = DIV_CEIL(reduceSize, 2u);
          if (localId.x < currentSize) {
            let candidate = xBestValues[localId.x + interval];
            if (candidate ${this.op} bestValue) {
              bestValue = candidate;
              xBestValues[localId.x] = bestValue;
              xBestIndices[localId.x] = xBestIndices[localId.x + interval];
            }
          }
          reduceSize = interval;
          workgroupBarrier();
        }

        if (localId.x == 0u && outputIndex < uniforms.size) {
          setOutputAtIndexI32(outputIndex, xBestIndices[localId.x]);
        }
      }
    `;
            return userCode;
        } else {
            const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let outputCoords = getCoordsFromIndex(index);
          var bestIndex = 0;
          var bestValue = getX(${splitOutputCoords()} 0);
          let reduceLength = ${getInputShapeLastDim()};
          for (var i = 1; i < reduceLength; i++) {
            let candidate = getX(${splitOutputCoords()} i);
            if (candidate ${this.op} bestValue) {
              bestValue = candidate;
              bestIndex = i;
            }
          }
          setOutputAtIndexI32(index, bestIndex);
        }
      }
      `;
            return userCode;
        }
    }
}

});


parcelRegister("fV48O", function(module, exports) {

$parcel$export(module.exports, "argMinConfig", () => $b96f643598956f61$export$21836a5e5fa09eb4);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");

var $8HST9 = parcelRequire("8HST9");

var $f9YmZ = parcelRequire("f9YmZ");
function $b96f643598956f61$export$ec99a91cddfb29a2(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $jjNRA).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $7MaPk).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $f9YmZ.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $7MaPk).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $7MaPk).assertAxesAreInnerMostDims('argMin', [
        axes[0]
    ], $x.shape.length);
    const program = new (0, $8HST9.ArgMinMaxProgram)($x.shape, axes[0], 'min');
    const uniformData = [
        {
            type: 'float32',
            data: [
                Number.POSITIVE_INFINITY
            ]
        }
    ];
    const out = backend.runWebGPUProgram(program, [
        $x
    ], 'int32', uniformData);
    intermediateTensorInfos.forEach((t)=>backend.disposeData(t.dataId));
    return out;
}
const $b96f643598956f61$export$21836a5e5fa09eb4 = {
    kernelName: (0, $hl418.ArgMin),
    backendName: 'webgpu',
    kernelFunc: $b96f643598956f61$export$ec99a91cddfb29a2
};

});

parcelRegister("35IWR", function(module, exports) {

$parcel$export(module.exports, "asinConfig", () => $2404b48fb5e1151c$export$de5cb0ef95dd6700);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $2404b48fb5e1151c$export$41726bdb1fc63f = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).ASIN
});
const $2404b48fb5e1151c$export$de5cb0ef95dd6700 = {
    kernelName: (0, $hl418.Asin),
    backendName: 'webgpu',
    kernelFunc: $2404b48fb5e1151c$export$41726bdb1fc63f
};

});

parcelRegister("hLrr1", function(module, exports) {

$parcel$export(module.exports, "asinhConfig", () => $ceec1b745ffa8fdd$export$20d424616c76166);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $ceec1b745ffa8fdd$export$839d8a01b6af4fc0 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).ASINH
});
const $ceec1b745ffa8fdd$export$20d424616c76166 = {
    kernelName: (0, $hl418.Asinh),
    backendName: 'webgpu',
    kernelFunc: $ceec1b745ffa8fdd$export$839d8a01b6af4fc0
};

});

parcelRegister("6Py2B", function(module, exports) {

$parcel$export(module.exports, "atanConfig", () => $4f91e9584b5a1570$export$159d632e3ff13624);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $4f91e9584b5a1570$export$628dc4eed22b0fbd = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).ATAN
});
const $4f91e9584b5a1570$export$159d632e3ff13624 = {
    kernelName: (0, $hl418.Atan),
    backendName: 'webgpu',
    kernelFunc: $4f91e9584b5a1570$export$628dc4eed22b0fbd
};

});

parcelRegister("9FPPD", function(module, exports) {

$parcel$export(module.exports, "atan2Config", () => $70b02616a251ca39$export$c53c7ab019edb8a0);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");
const $70b02616a251ca39$export$b8b770ee6a0d9760 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).ATAN2
});
const $70b02616a251ca39$export$c53c7ab019edb8a0 = {
    kernelName: (0, $hl418.Atan2),
    backendName: 'webgpu',
    kernelFunc: $70b02616a251ca39$export$b8b770ee6a0d9760
};

});

parcelRegister("e3UCc", function(module, exports) {

$parcel$export(module.exports, "atanhConfig", () => $a3cd43114eccd9bb$export$e9ce1ba75fc9b746);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $a3cd43114eccd9bb$export$21ea955025ceb08b = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).ATANH
});
const $a3cd43114eccd9bb$export$e9ce1ba75fc9b746 = {
    kernelName: (0, $hl418.Atanh),
    backendName: 'webgpu',
    kernelFunc: $a3cd43114eccd9bb$export$21ea955025ceb08b
};

});

parcelRegister("lD0Yf", function(module, exports) {

$parcel$export(module.exports, "avgPoolConfig", () => $fbedfe42a3de3963$export$6c901824a23e6150);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $7MaPk = parcelRequire("7MaPk");

var $fnZve = parcelRequire("fnZve");
function $fbedfe42a3de3963$export$d5c65a2abd3d97dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    const convInfo = (0, $7MaPk).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    return (0, $fnZve.poolImpl)(x, convInfo, 'avg', backend);
}
const $fbedfe42a3de3963$export$6c901824a23e6150 = {
    kernelName: (0, $hl418.AvgPool),
    backendName: 'webgpu',
    kernelFunc: $fbedfe42a3de3963$export$d5c65a2abd3d97dc
};

});
parcelRegister("fnZve", function(module, exports) {

$parcel$export(module.exports, "poolImpl", () => $b338b624452416ca$export$297e48da7c82a356);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");

var $eDEdB = parcelRequire("eDEdB");

var $fmchZ = parcelRequire("fmchZ");

var $17o8l = parcelRequire("17o8l");

var $avTob = parcelRequire("avTob");

var $aIxzD = parcelRequire("aIxzD");

var $gj4T5 = parcelRequire("gj4T5");
function $b338b624452416ca$export$297e48da7c82a356(x, convInfo, poolType, backend) {
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $jjNRA).arraysEqual(convInfo.inShape, convInfo.outShape)) return (0, $17o8l.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    if (convInfo.filterWidth === convInfo.inWidth && convInfo.filterHeight === convInfo.inHeight && convInfo.batchSize === 1 && convInfo.padInfo.type === 'VALID') {
        const length = x.shape.length;
        const reshapeX = (0, $gj4T5.reshape)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                shape: [
                    x.shape[length - 3] * x.shape[length - 2],
                    x.shape[length - 1]
                ]
            }
        });
        let reduceX;
        if (poolType === 'avg') reduceX = (0, $aIxzD.mean)({
            inputs: {
                x: reshapeX
            },
            backend: backend,
            attrs: {
                axis: 0,
                keepDims: false
            }
        });
        else {
            (0, $jjNRA).assert(poolType === 'max', ()=>`Invalid pool type ${poolType}`);
            reduceX = (0, $avTob.max)({
                inputs: {
                    x: reshapeX
                },
                backend: backend,
                attrs: {
                    reductionIndices: 0,
                    keepDims: false
                }
            });
        }
        const result = (0, $gj4T5.reshape)({
            inputs: {
                x: reduceX
            },
            backend: backend,
            attrs: {
                shape: convInfo.outShape
            }
        });
        backend.disposeData(reshapeX.dataId);
        backend.disposeData(reduceX.dataId);
        return result;
    }
    let program;
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        }
    ];
    if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1) program = new (0, $eDEdB.PoolWithFilterSizeEqualsOneProgram)(convInfo);
    else {
        if (poolType === 'avg') program = new (0, $fmchZ.Pool2DProgram)(convInfo, 'avg');
        else {
            (0, $jjNRA).assert(poolType === 'max', ()=>`Invalid pool type ${poolType}`);
            program = new (0, $fmchZ.Pool2DProgram)(convInfo, 'max');
        }
        dimensions.push({
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        });
    }
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, dimensions);
}

});
parcelRegister("eDEdB", function(module, exports) {

$parcel$export(module.exports, "PoolWithFilterSizeEqualsOneProgram", () => $aa83e7c23cce12e3$export$d92105defeb38496);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $aa83e7c23cce12e3$export$d92105defeb38496 {
    constructor(convInfo){
        this.variableNames = [
            'x'
        ];
        this.uniforms = `strides : vec2<i32>,`;
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'poolWithFilterSizeEqualsOne';
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let batch = coords[0];
          let d = coords[3];

          let xRCCorner = coords.yz * uniforms.strides;
          let xRCorner = xRCCorner.x;
          let xCCorner = xRCCorner.y;

          let value = getX(batch, xRCorner, xCCorner, d);
          setOutputAtIndex(index, value);
        }
      }
    `;
        return userCode;
    }
}

});

parcelRegister("fmchZ", function(module, exports) {

$parcel$export(module.exports, "Pool2DProgram", () => $b2e2717ad76ea322$export$ddaa65439647a5ac);
$parcel$export(module.exports, "Pool3DProgram", () => $b2e2717ad76ea322$export$a835a97097fdbb0f);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $b2e2717ad76ea322$export$ddaa65439647a5ac {
    constructor(convInfo, poolType, computePositions = false, flattenPositions = false, includeBatchIndex = false){
        this.variableNames = [
            'x'
        ];
        this.uniforms = `strides : vec2<i32>, pads : vec2<i32>, dilations : vec2<i32>, convDims : vec2<i32>, filterDims : vec2<i32>,`;
        // TODO(jiajia.qin@intel.com): Dynamically choose different workgroupSize for
        // different output shapes.
        this.workgroupSize = [
            128,
            1,
            1
        ];
        this.size = true;
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.poolType = poolType;
        this.computePositions = computePositions;
        this.flattenPositions = flattenPositions;
        this.includeBatchIndex = includeBatchIndex;
        this.shaderKey = `pool2D_${poolType}_${computePositions}_${flattenPositions}_${includeBatchIndex}`;
    }
    getUserCode() {
        let updateSnippet;
        if (this.poolType === 'avg') updateSnippet = `resultValue = resultValue + value; count = count + 1.0;`;
        else if (this.computePositions) {
            const positionStr = this.flattenPositions ? this.includeBatchIndex ? `((batch * uniforms.xShape[1] + xR) * uniforms.xShape[2] + xC) * uniforms.xShape[3] + d` : `(xR * uniforms.xShape[2] + xC) * uniforms.xShape[3] + d` : `wR * uniforms.filterDims.y + wC`;
            updateSnippet = `let currMaxValue = mix(value, maxValue, maxValueFound);
      if (value >= currMaxValue) {
        maxValue = value;
        maxValueFound = 1.0;
        maxPosition = ${positionStr};
      }`;
        } else updateSnippet = `resultValue = max(value, resultValue);`;
        let returnValue = `resultValue`;
        if (this.poolType === 'avg') returnValue = `resultValue / max(count, 1.0)`;
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
          let batch = coords[0];
          let d = coords[3];
          let xRCCorner = vec2<i32>(coords.yz) * uniforms.strides - uniforms.pads;
          let xRCorner = xRCCorner.x;
          let xCCorner = xRCCorner.y;

          ${this.computePositions ? `var maxValue = 0.0;
            var maxValueFound = 0.0;
            var maxPosition = 0;` : `var resultValue = ${this.poolType === 'avg' ? '0.0' : '-1.0 / pow(10.0, -20.0)'};`}

          var count = 0.0;
          for (var wR = 0; wR < uniforms.filterDims.x; wR = wR + uniforms.dilations.x) {
            let xR = xRCorner + wR;

            if (xR < 0 || xR >= uniforms.convDims.x) {
              continue;
            }

            for (var wC = 0; wC < uniforms.filterDims.y; wC = wC + uniforms.dilations.y) {
              let xC = xCCorner + wC;
              if (xC < 0 || xC >= uniforms.convDims.y) {
                continue;
              }

              let value = getX(batch, xR, xC, d);
              ${updateSnippet}
            }
          }

          ${this.computePositions ? `setOutputAtIndexI32(index, maxPosition);` : `setOutputAtIndex(index, ${returnValue});`}
        }
      }
    `;
        return userCode;
    }
}
class $b2e2717ad76ea322$export$a835a97097fdbb0f {
    constructor(convInfo, poolType, computePositions = false, flattenPositions = false, includeBatchIndex = false){
        this.variableNames = [
            'x'
        ];
        this.uniforms = `strides : vec3<i32>, pads : vec3<i32>, convDims : vec3<i32>, filterDims : vec3<i32>,`;
        this.workgroupSize = [
            128,
            1,
            1
        ];
        this.size = true;
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.poolType = poolType;
        this.computePositions = computePositions;
        this.flattenPositions = flattenPositions;
        this.includeBatchIndex = includeBatchIndex;
        this.shaderKey = `pool3D_${poolType}_${computePositions}_${flattenPositions}_${includeBatchIndex}`;
    }
    getUserCode() {
        let updateSnippet;
        if (this.poolType === 'avg') updateSnippet = `resultValue += value; count += 1.0;`;
        else if (this.computePositions) {
            const positionStr = this.flattenPositions ? this.includeBatchIndex ? `(((batch * uniforms.xShape.y + xD) * uniforms.xShape.z + xR) * uniforms.xShape.w + xC) * uniforms.xShape.u + ch` : `((xD * uniforms.xShape.z + xR) * uniforms.xShape.w + xC) * uniforms.xShape.u + ch` : `wD * uniforms.filterDims.y * uniforms.filterDims.y + wR * uniforms.filterDims.z + wC`;
            updateSnippet = `let currMaxValue = mix(value, maxValue, maxValueFound);
      if (value >= currMaxValue) {
        maxValue = value;
        maxValueFound = 1.0;
        maxPosition = ${positionStr};
      }`;
        } else updateSnippet = `resultValue = max(value, resultValue);`;
        let returnValue = `resultValue`;
        if (this.poolType === 'avg') returnValue = `resultValue / max(count, 1.0)`;
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let batch = coords.x;
          let ch = coords.u;

          let xCorner = vec3<i32>(coords.y, coords.z, coords.w) * uniforms.strides - uniforms.pads;
          let xDCorner = xCorner.x;
          let xRCorner = xCorner.y;
          let xCCorner = xCorner.z;

          ${this.computePositions ? `var maxValue = 0.0;
            var maxValueFound = 0.0;
            var maxPosition = 0;` : `var resultValue = ${this.poolType === 'avg' ? '0.0' : '-1.0 / pow(10.0, -20.0)'};`}

          var count = 0.0;
          for (var wD = 0; wD < uniforms.filterDims.x; wD++) {
            let xD = xDCorner + wD;
            if (xD < 0 || xD >= uniforms.convDims.x) {
              continue;
            }

            for (var wR = 0; wR < uniforms.filterDims.y; wR++) {
              let xR = xRCorner + wR;
              if (xR < 0 || xR >= uniforms.convDims.y) {
                continue;
              }

              for (var wC = 0; wC < uniforms.filterDims.z; wC++) {
                let xC = xCCorner + wC;
                if (xC < 0 || xC >= uniforms.convDims.z) {
                  continue;
                }

                let value = getX(batch, xD, xR, xC, ch);
                ${updateSnippet}
              }
            }
          }

          ${this.computePositions ? `setOutputAtIndexI32(index, maxPosition);` : `setOutputAtIndex(index, ${returnValue});`}
        }
      }
    `;
        return userCode;
    }
}

});

parcelRegister("avTob", function(module, exports) {

$parcel$export(module.exports, "max", () => $7a77c3c291a3958f$export$8960430cfd85939f);
$parcel$export(module.exports, "maxConfig", () => $7a77c3c291a3958f$export$7d79147246e312bb);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $qiVpd = parcelRequire("qiVpd");
function $7a77c3c291a3958f$export$8960430cfd85939f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reductionIndices: reductionIndices, keepDims: keepDims } = attrs;
    return (0, $qiVpd.reduce)(x, reductionIndices, keepDims, 'max', backend);
}
const $7a77c3c291a3958f$export$7d79147246e312bb = {
    kernelName: (0, $hl418.Max),
    backendName: 'webgpu',
    kernelFunc: $7a77c3c291a3958f$export$8960430cfd85939f
};

});

parcelRegister("aIxzD", function(module, exports) {

$parcel$export(module.exports, "mean", () => $7cd80e7d348f0c0e$export$1ce691f85baaa52);
$parcel$export(module.exports, "meanConfig", () => $7cd80e7d348f0c0e$export$b934af0ccd0cdbe1);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $qiVpd = parcelRequire("qiVpd");
function $7cd80e7d348f0c0e$export$1ce691f85baaa52(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { keepDims: keepDims, axis: axis } = attrs;
    return (0, $qiVpd.reduce)(x, axis, keepDims, 'mean', backend);
}
const $7cd80e7d348f0c0e$export$b934af0ccd0cdbe1 = {
    kernelName: (0, $hl418.Mean),
    backendName: 'webgpu',
    kernelFunc: $7cd80e7d348f0c0e$export$1ce691f85baaa52
};

});



parcelRegister("fYP8d", function(module, exports) {

$parcel$export(module.exports, "avgPool3DConfig", () => $ba241f42a8fb0483$export$5a9c81d240244392);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $7MaPk = parcelRequire("7MaPk");

var $fmchZ = parcelRequire("fmchZ");
function $ba241f42a8fb0483$export$8e92f7d23b27f144(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $7MaPk).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const avgPoolProgram = new (0, $fmchZ.Pool3DProgram)(convInfo, 'avg');
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.front,
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inDepth,
                convInfo.inHeight,
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth,
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(avgPoolProgram, [
        x
    ], x.dtype, dimensions);
}
const $ba241f42a8fb0483$export$5a9c81d240244392 = {
    kernelName: (0, $hl418.AvgPool3D),
    backendName: 'webgpu',
    kernelFunc: $ba241f42a8fb0483$export$8e92f7d23b27f144
};

});

parcelRegister("kWL8q", function(module, exports) {

$parcel$export(module.exports, "avgPool3DGradConfig", () => $f3fdc973c174347b$export$1eeb8780807d0508);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $7MaPk = parcelRequire("7MaPk");

var $4KD5c = parcelRequire("4KD5c");
function $f3fdc973c174347b$export$798cb4034e996ff4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $7MaPk).computePool3DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const program = new (0, $4KD5c.AvgPool3DBackpropProgram)(convInfo);
    const avgMultiplier = 1 / (convInfo.filterDepth * convInfo.filterHeight * convInfo.filterWidth);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth - 1 - convInfo.padInfo.front,
                convInfo.effectiveFilterHeight - 1 - convInfo.padInfo.top,
                convInfo.effectiveFilterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth,
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outDepth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'float32',
            data: [
                avgMultiplier
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy
    ], x.dtype, uniformData);
}
const $f3fdc973c174347b$export$1eeb8780807d0508 = {
    kernelName: (0, $hl418.AvgPool3DGrad),
    backendName: 'webgpu',
    kernelFunc: $f3fdc973c174347b$export$798cb4034e996ff4
};

});
parcelRegister("4KD5c", function(module, exports) {

$parcel$export(module.exports, "AvgPool2DBackpropProgram", () => $3759c65a59c6a369$export$5dc4ec478e6759de);
$parcel$export(module.exports, "AvgPool3DBackpropProgram", () => $3759c65a59c6a369$export$f166702869bc274f);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $3759c65a59c6a369$export$5dc4ec478e6759de {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.uniforms = `strides : vec2<i32>, pads : vec2<i32>, dilations : vec2<i32>, filterDims : vec2<i32>,
       outHeight : i32, outWidth : i32, avgMultiplier : f32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `avgPool2DBackprop`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords[0];
        let d = coords[3];

        let dyRCCorner = vec2<i32>(coords.yz) - uniforms.pads;
        let dyRCorner = dyRCCorner.x;
        let dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        for (var wR = 0; wR < uniforms.filterDims[0]; wR = wR + uniforms.dilations[0]) {
          let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[0]);

          if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
            continue;
          }
          let idyR = i32(dyR);

          for (var wC = 0; wC < uniforms.filterDims[1]; wC = wC + uniforms.dilations[1]) {
            let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[1]);

            if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
              continue;
            }
            let idyC = i32(dyC);

            let dyValue = getDy(batch, idyR, idyC, d);

            dotProd = dotProd + dyValue * uniforms.avgMultiplier;
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}
class $3759c65a59c6a369$export$f166702869bc274f {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.uniforms = `strides : vec3<i32>, pads : vec3<i32>, filterDims : vec3<i32>,
       outDepth : i32, outHeight : i32, outWidth : i32, avgMultiplier : f32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `avgPool3DBackprop`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords.x;
        let ch = coords.u;

        let dyCorner = vec3<i32>(coords.y, coords.z, coords.w) - uniforms.pads;
        let dyDCorner = dyCorner.x;
        let dyRCorner = dyCorner.y;
        let dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        for (var wD = 0; wD < uniforms.filterDims[0]; wD++) {
          let dyD = f32(dyDCorner + wD) / f32(uniforms.strides[0]);

          if (dyD < 0.0 || dyD >= f32(uniforms.outDepth) || fract(dyD) > 0.0) {
            continue;
          }
          let idyD = i32(dyD);

          for (var wR = 0; wR < uniforms.filterDims[1]; wR++) {
            let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[1]);

            if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
              continue;
            }
            let idyR = i32(dyR);

            for (var wC = 0; wC < uniforms.filterDims[2]; wC++) {
              let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[2]);

              if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
                continue;
              }
              let idyC = i32(dyC);

              let dyValue = getDy(batch, idyD, idyR, idyC, ch);
              dotProd += dyValue * uniforms.avgMultiplier;
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}

});


parcelRegister("3IpNJ", function(module, exports) {

$parcel$export(module.exports, "avgPoolGradConfig", () => $2b497eb87bb5ac69$export$ac3f8709351ab225);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $7MaPk = parcelRequire("7MaPk");

var $4KD5c = parcelRequire("4KD5c");

var $9Dn6G = parcelRequire("9Dn6G");
function $2b497eb87bb5ac69$export$2f098171d1c79aea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    (0, $9Dn6G.assertNotComplex)([
        dy,
        input
    ], 'avgPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
    const convInfo = (0, $7MaPk).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad);
    const program = new (0, $4KD5c.AvgPool2DBackpropProgram)(convInfo);
    const avgMultiplier = 1 / (convInfo.filterHeight * convInfo.filterWidth);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight - 1 - convInfo.padInfo.top,
                convInfo.effectiveFilterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'float32',
            data: [
                avgMultiplier
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy
    ], x.dtype, uniformData);
}
const $2b497eb87bb5ac69$export$ac3f8709351ab225 = {
    kernelName: (0, $hl418.AvgPoolGrad),
    backendName: 'webgpu',
    kernelFunc: $2b497eb87bb5ac69$export$2f098171d1c79aea
};

});

parcelRegister("bpf6O", function(module, exports) {

$parcel$export(module.exports, "batchMatMulConfig", () => $84ddbfd064252036$export$d0dd993198185538);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $die3l = parcelRequire("die3l");
function $84ddbfd064252036$export$8f97894b482227f0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b } = inputs;
    const { transposeA: transposeA, transposeB: transposeB } = attrs;
    return (0, $die3l.batchMatMulImpl)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend
    });
}
const $84ddbfd064252036$export$d0dd993198185538 = {
    kernelName: (0, $hl418.BatchMatMul),
    backendName: 'webgpu',
    kernelFunc: $84ddbfd064252036$export$8f97894b482227f0
};

});

parcelRegister("eQfS6", function(module, exports) {

$parcel$export(module.exports, "batchToSpaceNDConfig", () => $ace23bcda5f29006$export$44e08e19f97e5513);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $gj4T5 = parcelRequire("gj4T5");

var $klUog = parcelRequire("klUog");

var $f9YmZ = parcelRequire("f9YmZ");
const $ace23bcda5f29006$export$ea37d960c1808536 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, crops: crops } = attrs;
    (0, $jjNRA).assert(x.shape.length <= 4, ()=>"batchToSpaceND for rank > 4 with a WebGPU backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const reshaped = (0, $7MaPk).getReshaped(x.shape, blockShape, prod);
    const permuted = (0, $7MaPk).getPermuted(reshaped.length, blockShape.length);
    const reshapedPermuted = (0, $7MaPk).getReshapedPermuted(x.shape, blockShape, prod);
    const sliceBeginCoords = (0, $7MaPk).getSliceBeginCoords(crops, blockShape.length);
    const sliceSize = (0, $7MaPk).getSliceSize(reshapedPermuted, crops, blockShape.length);
    const toDispose = [];
    const reshapedIntermediate = (0, $gj4T5.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: reshaped
        }
    });
    const transposedIntermediate = (0, $f9YmZ.transpose)({
        inputs: {
            x: reshapedIntermediate
        },
        backend: backend,
        attrs: {
            perm: permuted
        }
    });
    const reshapedIntermediate2 = (0, $gj4T5.reshape)({
        inputs: {
            x: transposedIntermediate
        },
        backend: backend,
        attrs: {
            shape: reshapedPermuted
        }
    });
    const sliced = (0, $klUog.slice)({
        inputs: {
            x: reshapedIntermediate2
        },
        backend: backend,
        attrs: {
            begin: sliceBeginCoords,
            size: sliceSize
        }
    });
    toDispose.push(reshapedIntermediate);
    toDispose.push(transposedIntermediate);
    toDispose.push(reshapedIntermediate2);
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return sliced;
};
const $ace23bcda5f29006$export$44e08e19f97e5513 = {
    kernelName: (0, $hl418.BatchToSpaceND),
    backendName: 'webgpu',
    kernelFunc: $ace23bcda5f29006$export$ea37d960c1808536
};

});
parcelRegister("klUog", function(module, exports) {

$parcel$export(module.exports, "slice", () => $ed1182bd3e84484c$export$58adb3bec8346d0f);
$parcel$export(module.exports, "sliceConfig", () => $ed1182bd3e84484c$export$8d8a1e11dd2cc6c4);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $bszZn = parcelRequire("bszZn");
var $jjNRA = parcelRequire("jjNRA");

var $aLZc7 = parcelRequire("aLZc7");

var $h3VQq = parcelRequire("h3VQq");
function $ed1182bd3e84484c$export$58adb3bec8346d0f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, size: size } = attrs;
    const [$begin, $size] = (0, $bszZn).parseSliceParams(x, begin, size);
    (0, $bszZn).assertParamsValid(x, $begin, $size);
    if (backend.shouldExecuteOnCPU([
        x
    ]) || x.dtype === 'string') {
        const xTensorData = backend.tensorMap.get(x.dataId);
        const outValues = (0, $aLZc7.sliceImplCPU)(xTensorData.values, $begin, $size, x.shape, x.dtype);
        return backend.makeTensorInfo($size, x.dtype, outValues);
    }
    if ((0, $jjNRA).sizeFromShape($size) === 0) return backend.makeTensorInfo($size, x.dtype, []);
    // TODO(xing.xu): Add shadow slice support.
    const program = new (0, $h3VQq.SliceProgram)($begin, $size);
    const uniformData = [
        {
            type: 'int32',
            data: $begin
        }
    ];
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
}
const $ed1182bd3e84484c$export$8d8a1e11dd2cc6c4 = {
    kernelName: (0, $hl418.Slice),
    backendName: 'webgpu',
    kernelFunc: $ed1182bd3e84484c$export$58adb3bec8346d0f
};

});
parcelRegister("h3VQq", function(module, exports) {

$parcel$export(module.exports, "SliceProgram", () => $c6bf9632aee78585$export$ef8bf52bc4951c85);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $c6bf9632aee78585$export$ef8bf52bc4951c85 {
    constructor(start, destSize){
        this.variableNames = [
            'source'
        ];
        this.workPerThread = 1;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = destSize;
        this.rank = destSize.length;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        this.start = start;
        this.uniforms = `start : ${(0, $oGQBh.getCoordsDataType)(start.length)}, `;
        this.shaderKey = 'slice';
    }
    getUserCode() {
        const dtype = (0, $oGQBh.getCoordsDataType)(this.rank);
        const sourceCoords = $c6bf9632aee78585$var$getCoords(this.rank);
        let coordSum;
        if (this.start.length === 1) coordSum = this.outputShape.map((_, i)=>{
            return `sourceLoc = uniforms.start + coords;`;
        });
        else coordSum = this.outputShape.map((_, i)=>{
            return `sourceLoc.${$c6bf9632aee78585$var$coords[i]} = uniforms.start.${(0, $oGQBh.getCoordsXYZ)(i)} + coords.${$c6bf9632aee78585$var$coords[i]};`;
        });
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          var sourceLoc : ${dtype};
          let coords = getCoordsFromIndex(index);
          ${coordSum.join('\n')}
          setOutputAtIndex(index, getSource(${sourceCoords}));
        }
      }
    `;
        return userCode;
    }
}
const $c6bf9632aee78585$var$coords = [
    'x',
    'y',
    'z',
    'w',
    'u',
    'v'
];
function $c6bf9632aee78585$var$getCoords(rank) {
    if (rank === 1) return 'sourceLoc';
    else if (rank <= 6) return $c6bf9632aee78585$var$coords.slice(0, rank).map((coord)=>`sourceLoc.${coord}`).join(',');
    else throw Error(`Slicing for rank ${rank} is not yet supported`);
}

});



parcelRegister("4aAZr", function(module, exports) {

$parcel$export(module.exports, "bincountConfig", () => $3094ca0953e44c40$export$af9f0093738840fb);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $brQWm = parcelRequire("brQWm");

var $cFwkm = parcelRequire("cFwkm");
function $3094ca0953e44c40$export$7e474bab088ed182(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size } = attrs;
    const xSize = (0, $jjNRA).sizeFromShape(x.shape);
    const weightsSize = (0, $jjNRA).sizeFromShape(weights.shape);
    const hasWeights = weightsSize > 0;
    const outputSize = [
        size
    ];
    const dtype = weights.dtype;
    const output = (0, $cFwkm.fill)({
        backend: backend,
        attrs: {
            shape: outputSize,
            value: 0,
            dtype: dtype
        }
    });
    const program = new (0, $brQWm.BincountProgram)([
        xSize
    ], hasWeights);
    const uniformData = [
        {
            type: 'int32',
            data: [
                size
            ]
        }
    ];
    const bincountInputs = hasWeights ? [
        x,
        weights
    ] : [
        x
    ];
    const res = backend.runWebGPUProgram(program, bincountInputs, dtype, uniformData, output);
    return res;
}
const $3094ca0953e44c40$export$af9f0093738840fb = {
    kernelName: (0, $hl418.Bincount),
    backendName: 'webgpu',
    kernelFunc: $3094ca0953e44c40$export$7e474bab088ed182
};

});
parcelRegister("brQWm", function(module, exports) {

$parcel$export(module.exports, "BincountProgram", () => $855b482f0904bf04$export$7535c7c7286368eb);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $arOgS = parcelRequire("arOgS");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
const $855b482f0904bf04$var$writeSnippet = `
  fn bincount_write(index: i32, value: f32) {
    ${(0, $arOgS.atomicAddSnippet)('&result[index]', 'value', 'float32')}
  }
`;
const $855b482f0904bf04$var$binaryWriteSnippet = `
  fn bincount_write(index: i32, value: f32) {
    atomicStore(&result[index], bitcast<i32>(value));
  }
`;
class $855b482f0904bf04$export$7535c7c7286368eb {
    constructor(shape, hasWeights, binaryOutput = false){
        this.outputShape = [];
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'binCountSize : i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.hasWeights = true;
        this.binaryOutput = false;
        this.outputShape = shape;
        this.rank = shape.length;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.binaryOutput = binaryOutput;
        if (binaryOutput) this.atomic = false;
        this.hasWeights = hasWeights;
        if (this.hasWeights) this.variableNames.push('w');
        this.shaderKey = `bincount_${this.hasWeights}_${this.binaryOutput}_${this.rank}`;
    }
    getUserCode() {
        const userCode = `
    ${this.binaryOutput ? $855b482f0904bf04$var$binaryWriteSnippet : $855b482f0904bf04$var$writeSnippet}
  ${(0, $oGQBh.getMainHeaderString)('index')} {
    ${this.rank === 1 ? `if (index < uniforms.xShape) {
      let indexVal = i32(getX(index));
      if (indexVal < uniforms.binCountSize) {
        let value = ${this.binaryOutput ? 1. : this.hasWeights ? 'getW(index)' : '1.'};
        bincount_write(indexVal, value);
      }
    }` : `let coord = getCoordsFromIndex(index);
    if (coordsInBounds2D(coord, uniforms.xShape)) {
      let indexVal = i32(getX(coord[0], coord[1]));
      if (indexVal < uniforms.binCountSize) {
        let value = ${this.binaryOutput ? 1. : this.hasWeights ? 'getW(coord[0], coord[1])' : '1.'};
        bincount_write(coord.x * uniforms.binCountSize + indexVal, value);
      }
    }`}
  }
  `;
        return userCode;
    }
}

});


parcelRegister("3pEnr", function(module, exports) {

$parcel$export(module.exports, "broadcastArgsConfig", () => $27c306f06c63c241$export$8f7b2ec0c6f08fb2);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $efuUJ = parcelRequire("efuUJ");
function $27c306f06c63c241$export$d226d344aedce941(args) {
    const { inputs: inputs, backend: backend } = args;
    const { s0: s0, s1: s1 } = inputs;
    if (backend.shouldExecuteOnCPU([
        s0,
        s1
    ])) {
        const s0TensorInfo = backend.tensorMap.get(s0.dataId);
        const s1TensorInfo = backend.tensorMap.get(s1.dataId);
        const s0Vals = s0TensorInfo.values;
        const s1Vals = s1TensorInfo.values;
        const broadcastShape = (0, $7MaPk).assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
        return backend.makeTensorInfo([
            broadcastShape.length
        ], 'int32', Int32Array.from(broadcastShape));
    }
    const s0Size = (0, $jjNRA).sizeFromShape(s0.shape);
    const s1Size = (0, $jjNRA).sizeFromShape(s1.shape);
    const outputSize = Math.max(s0Size, s1Size);
    const program = new (0, $efuUJ.BroadcastArgsProgram)(outputSize);
    const uniformData = [
        {
            type: 'int32',
            data: [
                s0Size
            ]
        },
        {
            type: 'int32',
            data: [
                s1Size
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        s0,
        s1
    ], 'int32', uniformData);
}
const $27c306f06c63c241$export$8f7b2ec0c6f08fb2 = {
    kernelName: (0, $hl418.BroadcastArgs),
    backendName: 'webgpu',
    kernelFunc: $27c306f06c63c241$export$d226d344aedce941
};

});
parcelRegister("efuUJ", function(module, exports) {

$parcel$export(module.exports, "BroadcastArgsProgram", () => $a5fa724981ea7fe4$export$de6bebf36995b14);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $a5fa724981ea7fe4$export$de6bebf36995b14 {
    constructor(shape){
        this.outputShape = [];
        this.variableNames = [
            's0',
            's1'
        ];
        this.uniforms = 's0Size : i32, s1Size : i32, ';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            shape
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'broadcastArgs';
    }
    getUserCode() {
        const userCode = `
  ${(0, $oGQBh.getMainHeaderString)('index')} {
    if (index < uniforms.size) {
      var s0 = 1.0;
      var s1 = 1.0;
      let indexS0 = index - uniforms.size + uniforms.s0Size;
      let indexS1 = index - uniforms.size + uniforms.s1Size;
      if (indexS0 >= 0) {
        s0 = getS0(indexS0);
      }
      if (indexS1 >= 0) {
        s1 = getS1(indexS1);
      }

      if (s0 == 1.0) {
        setOutputAtIndex(index, s1);
      } else if (s1 == 1.0) {
        setOutputAtIndex(index, s0);
      } else if (s0 != s1) {
        setOutputAtIndex(index, uniforms.NAN);
      } else {
        setOutputAtIndex(index, s0);
      }
    }
  }
  `;
        return userCode;
    }
}

});


parcelRegister("1bpZT", function(module, exports) {

$parcel$export(module.exports, "castConfig", () => $0dcafc04a643472d$export$ac4d0f0f3927a8f3);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");
var $hxi4c = parcelRequire("hxi4c");

var $aLZc7 = parcelRequire("aLZc7");

var $lbBov = parcelRequire("lbBov");

var $17o8l = parcelRequire("17o8l");

var $cXttH = parcelRequire("cXttH");

var $6QjI0 = parcelRequire("6QjI0");

var $5monx = parcelRequire("5monx");
function $0dcafc04a643472d$export$f2db7d5238e1d23f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dtype: dtype } = attrs;
    // Casting to complex64.
    if (dtype === 'complex64') {
        if (x.dtype === 'complex64') return (0, $17o8l.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        // TODO: Import kernel function once zeros is modularized.
        const zerosTensor = $hxi4c.zeros(x.shape);
        const floatX = $0dcafc04a643472d$export$f2db7d5238e1d23f({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const result = (0, $lbBov.complex)({
            inputs: {
                real: floatX,
                imag: zerosTensor
            },
            backend: backend
        });
        zerosTensor.dispose();
        backend.disposeData(floatX.dataId);
        return result;
    }
    // Casting from complex64
    if (x.dtype === 'complex64') {
        const realPart = (0, $6QjI0.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const result = $0dcafc04a643472d$export$f2db7d5238e1d23f({
            inputs: {
                x: realPart
            },
            backend: backend,
            attrs: {
                dtype: dtype
            }
        });
        backend.disposeData(realPart.dataId);
        return result;
    }
    if (!(0, $jjNRA).hasEncodingLoss(x.dtype, dtype)) {
        // We don't change the underlying data, since we cast to higher
        // precision.
        const result = (0, $17o8l.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        return {
            dataId: result.dataId,
            shape: result.shape,
            dtype: dtype
        };
    }
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const values = backend.tensorMap.get(x.dataId).values;
        const [resultShape, resultType, resultData] = (0, $aLZc7.castImplCPU)(values, x.shape, x.dtype, dtype);
        return backend.makeTensorInfo(resultShape, resultType, resultData);
    }
    if (dtype === 'int32') return (0, $5monx.int)(x, backend);
    if (dtype === 'bool') {
        const zerosTensorInfo = backend.makeTensorInfo([], 'bool', (0, $jjNRA).getTypedArrayFromDType('bool', 1));
        const binaryInputs = {
            a: x,
            b: zerosTensorInfo
        };
        const result = (0, $cXttH.notEqual)({
            inputs: binaryInputs,
            backend: backend
        });
        backend.disposeData(zerosTensorInfo.dataId);
        return result;
    }
    throw new Error(`Error in Cast: failed to cast ${x.dtype} to ${dtype}`);
}
const $0dcafc04a643472d$export$ac4d0f0f3927a8f3 = {
    kernelName: (0, $hl418.Cast),
    backendName: 'webgpu',
    kernelFunc: $0dcafc04a643472d$export$f2db7d5238e1d23f
};

});
parcelRegister("cXttH", function(module, exports) {

$parcel$export(module.exports, "notEqual", () => $96f1dc7003428c34$export$53a6892c50694894);
$parcel$export(module.exports, "notEqualConfig", () => $96f1dc7003428c34$export$d003d4d7e1500775);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $96f1dc7003428c34$export$53a6892c50694894 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).NOT_EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $aLZc7.notEqualImplCPU)
});
const $96f1dc7003428c34$export$d003d4d7e1500775 = {
    kernelName: (0, $hl418.NotEqual),
    backendName: 'webgpu',
    kernelFunc: $96f1dc7003428c34$export$53a6892c50694894
};

});

parcelRegister("6QjI0", function(module, exports) {

$parcel$export(module.exports, "real", () => $4fb6e324cdc31dc0$export$9fc57fb453bdbd67);
$parcel$export(module.exports, "realConfig", () => $4fb6e324cdc31dc0$export$4b7bce57557ae68b);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $17o8l = parcelRequire("17o8l");
function $4fb6e324cdc31dc0$export$9fc57fb453bdbd67(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.tensorMap.get(input.dataId);
    return (0, $17o8l.identity)({
        inputs: {
            x: inputData.complexTensorInfos.real
        },
        backend: backend
    });
}
const $4fb6e324cdc31dc0$export$4b7bce57557ae68b = {
    kernelName: (0, $hl418.Real),
    backendName: 'webgpu',
    kernelFunc: $4fb6e324cdc31dc0$export$9fc57fb453bdbd67
};

});

parcelRegister("5monx", function(module, exports) {

$parcel$export(module.exports, "int", () => $3e71eae6c59a271b$export$7d260a2a5f8bc19e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8Y5Lq = parcelRequire("8Y5Lq");

var $2b4Nh = parcelRequire("2b4Nh");
function $3e71eae6c59a271b$export$7d260a2a5f8bc19e(input, backend) {
    const program = new (0, $2b4Nh.UnaryOpProgram)(input.shape, (0, $8Y5Lq.UnaryOpType).TO_INT);
    const output = backend.runWebGPUProgram(program, [
        input
    ], 'int32');
    return {
        dataId: output.dataId,
        shape: output.shape,
        dtype: output.dtype
    };
}

});


parcelRegister("eK7Cu", function(module, exports) {

$parcel$export(module.exports, "ceilConfig", () => $abbb45b5256dbf30$export$df387212b1898306);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $abbb45b5256dbf30$export$803ce6b71a0a94b2 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).CEIL,
    cpuKernelImpl: (0, $aLZc7.ceilImplCPU)
});
const $abbb45b5256dbf30$export$df387212b1898306 = {
    kernelName: (0, $hl418.Ceil),
    backendName: 'webgpu',
    kernelFunc: $abbb45b5256dbf30$export$803ce6b71a0a94b2
};

});

parcelRegister("ehw4q", function(module, exports) {

$parcel$export(module.exports, "clipByValueConfig", () => $a65b87bddfd22193$export$f7ee8f07ce0ff4e1);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $gJRdw = parcelRequire("gJRdw");

var $24g1H = parcelRequire("24g1H");
function $a65b87bddfd22193$export$fa97baf70ad024c0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { clipValueMin: clipValueMin, clipValueMax: clipValueMax } = attrs;
    let program;
    const uniformData = [
        {
            type: 'float32',
            data: [
                clipValueMin
            ]
        },
        {
            type: 'float32',
            data: [
                clipValueMax
            ]
        }
    ];
    if ((0, $jjNRA).sizeFromShape(x.shape) % 4 === 0) program = new (0, $gJRdw.ClipVec4Program)(x.shape);
    else program = new (0, $24g1H.ClipProgram)(x.shape);
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
}
const $a65b87bddfd22193$export$f7ee8f07ce0ff4e1 = {
    kernelName: (0, $hl418.ClipByValue),
    backendName: 'webgpu',
    kernelFunc: $a65b87bddfd22193$export$fa97baf70ad024c0
};

});
parcelRegister("gJRdw", function(module, exports) {

$parcel$export(module.exports, "ClipVec4Program", () => $c2fa212030e3f25c$export$431f4d28c8da57b6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $c2fa212030e3f25c$export$431f4d28c8da57b6 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.uniforms = 'minVal : f32, maxVal : f32,';
        this.workPerThread = 4;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.outputComponent = 4;
        this.size = true;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        this.shaderKey = 'clipVec4';
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if(index < uniforms.size) {
          let value = getAByOutputIndex(index);
          var clampedValue = clamp(
              value, vec4<f32>(uniforms.minVal), vec4<f32>(uniforms.maxVal));
          clampedValue = select(clampedValue, value, isnanVec4(value));
          setOutputAtIndex(index, clampedValue);
        }
      }
    `;
        return userCode;
    }
}

});

parcelRegister("24g1H", function(module, exports) {

$parcel$export(module.exports, "ClipProgram", () => $181863069e7bb426$export$ce48b7c79e7985d1);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $181863069e7bb426$export$ce48b7c79e7985d1 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.uniforms = 'minVal : f32, maxVal : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'clip';
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if(index < uniforms.size) {
          let value = getAByOutputIndex(index);
          if (isnan(value)) {
            setOutputAtIndex(index, value);
            return;
          }
          setOutputAtIndex(index, clamp(value, uniforms.minVal, uniforms.maxVal));
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("2LChF", function(module, exports) {

$parcel$export(module.exports, "complexAbsConfig", () => $203daaf9a7804cf6$export$a4817d2978acc054);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $kYgzY = parcelRequire("kYgzY");
// Returns a TensorInfo with the complex shape and the dataId of the
// underlying part. We need to do this because a reshaped complex tensor is
// not reflected in its parts.
function $203daaf9a7804cf6$var$makeComplexComponentTensorInfo(complexTensor, complexPart) {
    return {
        dataId: complexPart.dataId,
        dtype: complexPart.dtype,
        shape: complexTensor.shape
    };
}
function $203daaf9a7804cf6$export$2837bc62566f8808(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const xData = backend.tensorMap.get(x.dataId);
    const program = new (0, $kYgzY.ComplexAbsProgram)(x.shape);
    const programInputs = [
        $203daaf9a7804cf6$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.real),
        $203daaf9a7804cf6$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.imag)
    ];
    return backend.runWebGPUProgram(program, programInputs, programInputs[0].dtype);
}
const $203daaf9a7804cf6$export$a4817d2978acc054 = {
    kernelName: (0, $hl418.ComplexAbs),
    backendName: 'webgpu',
    kernelFunc: $203daaf9a7804cf6$export$2837bc62566f8808
};

});
parcelRegister("kYgzY", function(module, exports) {

$parcel$export(module.exports, "ComplexAbsProgram", () => $f4464583468d9686$export$d03dbc86862098f5);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $f4464583468d9686$export$d03dbc86862098f5 {
    constructor(shape){
        this.outputShape = [];
        this.variableNames = [
            'real',
            'imag'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'complexAbs';
    }
    getUserCode() {
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let re = abs(getRealByOutputIndex(index));
        let im = abs(getImagByOutputIndex(index));
        let mx = max(re, im);

        // The length function in wgsl may be not underflow-safe on some GPUs.
        // So the safe solution is to ensure underflow-safety in all cases.
        setOutputAtIndex(index, select(mx * length(vec2<f32>(1, min(re, im)/mx)), 0.0, mx == 0.0));
      }
    }
  `;
        return userCode;
    }
}

});


parcelRegister("2UdAg", function(module, exports) {

$parcel$export(module.exports, "concat", () => $21db593675b289e2$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "concatConfig", () => $21db593675b289e2$export$c8cf96dae25282e5);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $7tFPU = parcelRequire("7tFPU");

var $17o8l = parcelRequire("17o8l");
function $21db593675b289e2$export$ee1b3e54f0441b22(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    const $axis = (0, $jjNRA).parseAxisParam(axis, inputs[0].shape)[0];
    const shapes = inputs.map((t)=>t.shape);
    (0, $7MaPk).assertParamsConsistent(shapes, $axis);
    const outShape = (0, $7MaPk).computeOutShape(inputs.map((t)=>t.shape), $axis);
    if ((0, $jjNRA).sizeFromShape(outShape) === 0) return backend.makeTensorInfo(outShape, inputs[0].dtype, []);
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $jjNRA).sizeFromShape(t.shape) > 0);
    if ($inputs.length === 1) return (0, $17o8l.identity)({
        inputs: {
            x: $inputs[0]
        },
        backend: backend
    });
    return (0, $7tFPU.concatImpl)($inputs, $axis, backend);
}
const $21db593675b289e2$export$c8cf96dae25282e5 = {
    kernelName: (0, $hl418.Concat),
    backendName: 'webgpu',
    kernelFunc: $21db593675b289e2$export$ee1b3e54f0441b22
};

});
parcelRegister("7tFPU", function(module, exports) {

$parcel$export(module.exports, "concatImpl", () => $571bb1a59771fdae$export$777da59f594f497d);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $jjNRA = parcelRequire("jjNRA");

var $i8hTE = parcelRequire("i8hTE");

var $aLZc7 = parcelRequire("aLZc7");

var $lbBov = parcelRequire("lbBov");

var $2hp6b = parcelRequire("2hp6b");

var $6QjI0 = parcelRequire("6QjI0");

var $gj4T5 = parcelRequire("gj4T5");
function $571bb1a59771fdae$export$777da59f594f497d(inputs, axis, backend) {
    const dtype = inputs[0].dtype;
    if (dtype === 'complex64') {
        const reals = inputs.map((t)=>(0, $6QjI0.real)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const imags = inputs.map((t)=>(0, $2hp6b.imag)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const realConcated = $571bb1a59771fdae$export$777da59f594f497d(reals, axis, backend);
        const imagConcated = $571bb1a59771fdae$export$777da59f594f497d(imags, axis, backend);
        const result = (0, $lbBov.complex)({
            inputs: {
                real: realConcated,
                imag: imagConcated
            },
            backend: backend
        });
        reals.forEach((r)=>backend.disposeData(r.dataId));
        imags.forEach((i)=>backend.disposeData(i.dataId));
        backend.disposeData(realConcated.dataId);
        backend.disposeData(imagConcated.dataId);
        return result;
    }
    let runOnCpu = backend.shouldExecuteOnCPU(inputs);
    // Run on cpu if dtype is string. For string, the backend represents it
    // as Uint8Array[], where each Uint8Array is a character. Given that the
    // computation is only on the outer array, uploading the whole data onto
    // gpu is wasteful. Also, currently webgpu doesn't have a design to
    // upload and retrieve Uint8Array[] between cpu and gpu. Therefore, we
    // just run the kernel on cpu if dtype is string.
    if (dtype === 'string') runOnCpu = true;
    if (runOnCpu) {
        // Any concat of n-dimensional tensors across any axis can be reduced to
        // a concatenation of two-dimensional tensors across the axis 1 by first
        // partitioning the axes of the original tensors into those less than the
        // axis to be concatenated and the rest. Then reshape the tensors
        // into a two-dimensional tensor by collapsing these two sets of axes and
        // concatenate the resulting matrices across the axis 1, finally reshaping
        // the result to have the proper shape.
        const tensors2D = inputs.map((t)=>{
            const innerSize = (0, $jjNRA).sizeFromShape(t.shape.slice(axis));
            const shape = [
                -1,
                innerSize
            ];
            return (0, $gj4T5.reshape)({
                inputs: {
                    x: t
                },
                backend: backend,
                attrs: {
                    shape: shape
                }
            });
        });
        const inputsValShapes = tensors2D.map((t)=>{
            return {
                vals: backend.readSync(t.dataId),
                shape: t.shape
            };
        });
        // Concats 2d tensors along axis=1.
        const outShape = (0, $7MaPk).computeOutShape(tensors2D.map((t)=>t.shape), 1 /* axis */ );
        const simplyConcat = tensors2D[0].shape[0] === 1;
        const outVals = (0, $aLZc7.concatImplCPU)(inputsValShapes, outShape, dtype, simplyConcat);
        const finalOutShape = (0, $7MaPk).computeOutShape(inputs.map((t)=>t.shape), axis);
        const outInfo = backend.makeTensorInfo(finalOutShape, dtype, outVals);
        tensors2D.forEach((t)=>backend.disposeData(t.dataId));
        return outInfo;
    }
    // There is a storage buffer limitation in compute stage, one for output so
    // the maximum for input is limits.maxStorageBuffersPerShaderStage - 1
    const maxInputNum = backend.device.limits.maxStorageBuffersPerShaderStage - 1;
    if (inputs.length > maxInputNum) {
        const reducedInputs = [];
        for(let i = 0; i < inputs.length; i += maxInputNum){
            const subArray = inputs.slice(i, i + maxInputNum);
            reducedInputs.push($571bb1a59771fdae$export$777da59f594f497d(subArray, axis, backend));
        }
        const result = $571bb1a59771fdae$export$777da59f594f497d(reducedInputs, axis, backend);
        for (const i of reducedInputs)backend.disposeData(i.dataId);
        return result;
    }
    const { tensors2D: tensors2D, outShape: outShape } = $571bb1a59771fdae$var$computeTensors2D(inputs, axis, backend);
    const shapes = tensors2D.map((t)=>t.shape);
    const program = new (0, $i8hTE.ConcatProgram)(shapes);
    const uniformData = [];
    const offsets = new Array(shapes.length - 1);
    if (offsets.length > 0) {
        offsets[0] = shapes[0][1];
        uniformData.push({
            type: 'int32',
            data: [
                offsets[0]
            ]
        });
        for(let i = 1; i < offsets.length; i++){
            offsets[i] = offsets[i - 1] + shapes[i][1];
            uniformData.push({
                type: 'int32',
                data: [
                    offsets[i]
                ]
            });
        }
    }
    const res = backend.runWebGPUProgram(program, tensors2D, tensors2D[0].dtype, uniformData);
    tensors2D.forEach((r)=>backend.disposeData(r.dataId));
    const reshapedResult = (0, $gj4T5.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeData(res.dataId);
    return reshapedResult;
}
function $571bb1a59771fdae$var$computeTensors2D(inputs, axis, backend) {
    const outShape = (0, $7MaPk).computeOutShape(inputs.map((t)=>t.shape), axis);
    const tensors2D = inputs.map((t)=>(0, $gj4T5.reshape)({
            inputs: {
                x: t
            },
            backend: backend,
            attrs: {
                shape: [
                    (0, $jjNRA).sizeFromShape(t.shape.slice(0, axis)),
                    (0, $jjNRA).sizeFromShape(t.shape.slice(axis))
                ]
            }
        }));
    return {
        tensors2D: tensors2D,
        outShape: outShape
    };
}

});
parcelRegister("i8hTE", function(module, exports) {

$parcel$export(module.exports, "ConcatProgram", () => $d336db3862e90a5d$export$9059cb52ee2cb142);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $d336db3862e90a5d$export$9059cb52ee2cb142 {
    constructor(shapes){
        this.uniforms = '';
        this.workPerThread = 1;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = (0, $7MaPk).computeOutShape(shapes, 1 /* axis */ );
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        this.offsetLength = shapes.length - 1;
        for(let i = 0; i < this.offsetLength; i++)this.uniforms += `offset${i} : i32,`;
        this.shaderKey = 'concat';
    }
    getUserCode() {
        const snippets = [];
        if (this.offsetLength > 0) {
            snippets.push(`if (yC < uniforms.offset0){ setOutputAtCoords(coords.x, coords.y, getT0(yR, yC)); }`);
            for(let i = 1; i < this.offsetLength; i++)snippets.push(`else if (yC < uniforms.offset${[
                i
            ]}){ ` + `setOutputAtCoords(coords.x, coords.y, getT${i}(yR, yC - uniforms.offset${i - 1})); }`);
            const lastIndex = this.offsetLength;
            const lastShiftIndex = this.offsetLength - 1;
            snippets.push(`else { setOutputAtCoords(coords.x, coords.y, getT${lastIndex}(yR, yC - uniforms.offset${lastShiftIndex})); }`);
        } else snippets.push(`setOutputAtCoords(coords.x, coords.y, getT0(yR, yC));`);
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        for(var i = 0; i < ${this.workPerThread}; i = i + 1) {
          let flatIndex = index * ${this.workPerThread} + i;
          if(flatIndex < uniforms.size) {
            let coords = getCoordsFromIndex(flatIndex);
            let yR = coords.x;
            let yC = coords.y;

            ${snippets.join('\n        ')}
          }
        }
      }
    `;
        return userCode;
    }
}

});

parcelRegister("2hp6b", function(module, exports) {

$parcel$export(module.exports, "imag", () => $1a90a35f061b1805$export$d78fab5778ab392b);
$parcel$export(module.exports, "imagConfig", () => $1a90a35f061b1805$export$ddfc128c2801add7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $17o8l = parcelRequire("17o8l");
function $1a90a35f061b1805$export$d78fab5778ab392b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.tensorMap.get(input.dataId);
    return (0, $17o8l.identity)({
        inputs: {
            x: inputData.complexTensorInfos.imag
        },
        backend: backend
    });
}
const $1a90a35f061b1805$export$ddfc128c2801add7 = {
    kernelName: (0, $hl418.Imag),
    backendName: 'webgpu',
    kernelFunc: $1a90a35f061b1805$export$d78fab5778ab392b
};

});



parcelRegister("9mHBc", function(module, exports) {

$parcel$export(module.exports, "conv2DConfig", () => $6d17fcfb39e8f88b$export$4a39bf13b4378042);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $1V6Ye = parcelRequire("1V6Ye");
function $6d17fcfb39e8f88b$export$188f9215482e3db8(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $7MaPk).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $7MaPk).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    return (0, $1V6Ye.conv2DImpl)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend
    });
}
const $6d17fcfb39e8f88b$export$4a39bf13b4378042 = {
    kernelName: (0, $hl418.Conv2D),
    backendName: 'webgpu',
    kernelFunc: $6d17fcfb39e8f88b$export$188f9215482e3db8
};

});
parcelRegister("1V6Ye", function(module, exports) {

$parcel$export(module.exports, "conv2DImpl", () => $1660858123d25b57$export$5d9f3221948b996);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $ibsdL = parcelRequire("ibsdL");

var $7qAlK = parcelRequire("7qAlK");

var $2hMTT = parcelRequire("2hMTT");

var $2JZnV = parcelRequire("2JZnV");

var $die3l = parcelRequire("die3l");

var $gj4T5 = parcelRequire("gj4T5");
// conv2dByMatMul fuses height and width into one dimension to compute
// batchMatMul, so bias and activation weights are also supposed to fuse the two
// dimensions into one.
//
// This function computes the target shape for fusing height and width
// dimensions. Returning null means the shape is already compatible.
function $1660858123d25b57$var$getShapeForBatchMatMul(shape, isChannelsLast) {
    const length = shape.length;
    if (length >= 3) return isChannelsLast ? [
        ...shape.slice(0, -3),
        shape[length - 3] * shape[length - 2],
        shape[length - 1]
    ] : [
        ...shape.slice(0, -3),
        shape[length - 3],
        shape[length - 2] * shape[length - 1]
    ];
    else if (!isChannelsLast && length === 1 && shape[0] > 1) return [
        shape[0],
        1
    ];
    else return null;
}
// For 1x1 kernels that iterate through every point in the input, convolution
// can be expressed as matrix multiplication (without need for memory
// remapping).
function $1660858123d25b57$var$conv2dByMatMul({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const transposeA = isChannelsLast ? false : true;
    const transposeB = false;
    const sameSize = isChannelsLast && convInfo.filterHeight === convInfo.inHeight && convInfo.filterWidth === convInfo.inWidth && convInfo.padInfo.type === 'VALID';
    const intermediates = [];
    let xReshaped;
    let filterReshaped;
    if (sameSize) {
        const sharedDim = convInfo.inHeight * convInfo.inWidth * convInfo.inChannels;
        xReshaped = (0, $gj4T5.reshape)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.batchSize,
                    sharedDim
                ]
            }
        });
        filterReshaped = (0, $gj4T5.reshape)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    sharedDim,
                    convInfo.outChannels
                ]
            }
        });
    } else {
        xReshaped = (0, $gj4T5.reshape)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                shape: isChannelsLast ? [
                    convInfo.batchSize,
                    convInfo.inHeight * convInfo.inWidth,
                    convInfo.inChannels
                ] : [
                    convInfo.batchSize,
                    convInfo.inChannels,
                    convInfo.inHeight * convInfo.inWidth
                ]
            }
        });
        filterReshaped = (0, $gj4T5.reshape)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.inChannels,
                    convInfo.outChannels
                ]
            }
        });
    }
    intermediates.push(xReshaped);
    intermediates.push(filterReshaped);
    if (preluActivationWeights != null) {
        const targetShape = $1660858123d25b57$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $gj4T5.reshape)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $1660858123d25b57$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $gj4T5.reshape)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    const result = (0, $die3l.batchMatMulImpl)({
        a: isChannelsLast ? xReshaped : filterReshaped,
        b: isChannelsLast ? filterReshaped : xReshaped,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    const out = (0, $gj4T5.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(result);
    for (const i of intermediates)backend.disposeData(i.dataId);
    return out;
}
// Implements the im2col algorithm as outlined in "High Performance
// Convolutional Neural Networks for Document Processing" (Suvisoft, 2006)
function $1660858123d25b57$var$conv2dWithIm2Col({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    // Rearranges conv2d input so each block to be convolved over forms the
    // row of a new matrix with shape [outHeight * outWidth,
    // filterWidth * filterHeight * inChannels]. The filter is also rearranged so
    // each output channel forms a col of a new matrix with shape [
    // filterWidth * filterHeight * inChannels, outChannels]. The convolution is
    // then computed by multiplying these matrices and reshaping the result.
    const { filterWidth: filterWidth, filterHeight: filterHeight, inChannels: inChannels, strideWidth: strideWidth, strideHeight: strideHeight, padInfo: padInfo, outWidth: outWidth, outHeight: outHeight, dilationWidth: dilationWidth, dilationHeight: dilationHeight, dataFormat: dataFormat } = convInfo;
    const isChannelsLast = dataFormat === 'channelsLast';
    const sharedDim = filterWidth * filterHeight * inChannels;
    const numCols = outHeight * outWidth;
    const x2ColShape = isChannelsLast ? [
        convInfo.batchSize,
        numCols,
        sharedDim
    ] : [
        convInfo.batchSize,
        sharedDim,
        numCols
    ];
    const im2ColProgram = new (0, $2JZnV.Im2ColProgram)(x2ColShape, isChannelsLast);
    const dimensions = [
        {
            type: 'int32',
            data: [
                padInfo.top,
                padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                strideHeight,
                strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                dilationHeight,
                dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                inChannels * filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                inChannels
            ]
        }
    ];
    const x2Col = backend.runWebGPUProgram(im2ColProgram, [
        x
    ], x.dtype, dimensions);
    const intermediates = [];
    intermediates.push(x2Col);
    const filterReshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: filter
        },
        backend: backend,
        attrs: {
            shape: [
                1,
                sharedDim,
                -1
            ]
        }
    });
    intermediates.push(filterReshaped);
    if (preluActivationWeights != null) {
        const targetShape = $1660858123d25b57$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $gj4T5.reshape)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $1660858123d25b57$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $gj4T5.reshape)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    const transposeA = isChannelsLast ? false : true;
    const transposeB = false;
    const result = (0, $die3l.batchMatMulImpl)({
        a: isChannelsLast ? x2Col : filterReshaped,
        b: isChannelsLast ? filterReshaped : x2Col,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    const out = (0, $gj4T5.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(result);
    for (const i of intermediates)backend.disposeData(i.dataId);
    return out;
}
function $1660858123d25b57$export$5d9f3221948b996({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const sameSize = isChannelsLast && convInfo.filterHeight === convInfo.inHeight && convInfo.filterWidth === convInfo.inWidth && convInfo.padInfo.type === 'VALID';
    const useNaiveConv2d = (0, $ibsdL.env)().getBool('WEBGPU_USE_NAIVE_CONV2D_DEBUG');
    if (!useNaiveConv2d && (sameSize || convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === 'SAME' || convInfo.padInfo.type === 'VALID'))) return $1660858123d25b57$var$conv2dByMatMul({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    const thresholdFlagValue = (0, $ibsdL.env)().getNumber('WEBGPU_THRESHOLD_TO_INCREASE_WORKGROUPS_FOR_MATMUL');
    const thresholdToIncreaseWorkgroups = thresholdFlagValue > -1 ? thresholdFlagValue : backend.thresholdToIncreaseWorkgroups;
    const workgroupsBy32x32 = convInfo.batchSize * Math.ceil(convInfo.outHeight * convInfo.outWidth / 32) * Math.ceil(convInfo.outChannels / 32);
    if ((0, $ibsdL.env)().getBool('WEBGPU_CONV_SEPARATE_IM2COL_SHADER') || workgroupsBy32x32 <= thresholdToIncreaseWorkgroups) return $1660858123d25b57$var$conv2dWithIm2Col({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha,
        activation: activation
    });
    let program;
    const padInfo = [
        convInfo.padInfo.top,
        convInfo.padInfo.left
    ];
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                ...padInfo
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        }
    ];
    if (useNaiveConv2d) program = new (0, $2hMTT.Conv2DNaiveProgram)(convInfo, hasBias, activation, hasPreluActivationWeights);
    else {
        const dimAOuter = isChannelsLast ? convInfo.outHeight * convInfo.outWidth : convInfo.outChannels;
        const dimBOuter = isChannelsLast ? convInfo.outChannels : convInfo.outHeight * convInfo.outWidth;
        const dimInner = convInfo.filterHeight * convInfo.filterWidth * convInfo.inChannels;
        dimensions.push({
            type: 'int32',
            data: [
                dimAOuter
            ]
        }, {
            type: 'int32',
            data: [
                dimBOuter
            ]
        }, {
            type: 'int32',
            data: [
                dimInner
            ]
        });
        // Experiments show that sequential access is more friendly for Intel GPUs.
        const sequentialAccessByThreads = backend.adapterInfo.isIntel();
        program = new (0, $7qAlK.Conv2DMMProgram)(convInfo, dimAOuter, dimBOuter, dimInner, hasBias, activation, hasPreluActivationWeights, sequentialAccessByThreads);
    }
    const intermediates = [];
    const inputVar = [
        x,
        filter
    ];
    if (hasBias) {
        if (!isChannelsLast && bias.shape.length === 1) {
            bias = (0, $gj4T5.reshape)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: [
                        bias.shape[0],
                        1,
                        1
                    ]
                }
            });
            intermediates.push(bias);
        }
        inputVar.push(bias);
    }
    if (hasPreluActivationWeights) {
        if (!isChannelsLast && preluActivationWeights.shape.length === 1) {
            preluActivationWeights = (0, $gj4T5.reshape)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: [
                        preluActivationWeights.shape[0],
                        1,
                        1
                    ]
                }
            });
            intermediates.push(preluActivationWeights);
        }
        inputVar.push(preluActivationWeights);
    }
    if (activation === 'leakyrelu') {
        dimensions.push({
            type: 'float32',
            data: [
                leakyreluAlpha
            ]
        });
        program.uniforms += ' alpha : f32,';
    }
    const out = backend.runWebGPUProgram(program, inputVar, x.dtype, dimensions);
    for (const i of intermediates)backend.disposeData(i.dataId);
    return out;
}

});
parcelRegister("7qAlK", function(module, exports) {

$parcel$export(module.exports, "Conv2DMMProgram", () => $016546d87bb87bbb$export$7cb7f21cacf510bc);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7t2XD = parcelRequire("7t2XD");

var $8UfUr = parcelRequire("8UfUr");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
function $016546d87bb87bbb$var$conv2dCommonSnippet(isChannelsLast, fitAOuter, fitBOuter, fitInner, addBias = false, activation = null, hasPreluActivationWeights = false, innerElementSizeX = 4, innerElementSizeW = 4, innerElementSize = 4) {
    const getXSnippet = (innerElementSize)=>{
        switch(innerElementSize){
            case 1:
                return 'resData = f32(x[xIndex]);';
            case 3:
                return 'resData = vec3<f32>(x[xIndex], x[xIndex + 1], x[xIndex + 2]);';
            case 4:
                return 'resData = vec4<f32>(x[xIndex / 4]);';
            default:
                throw new Error(`innerElementSize ${innerElementSize} is not supported.`);
        }
    };
    const getWSnippet = (innerElementSize)=>{
        switch(innerElementSize){
            case 1:
                return 'return f32(W[row * uniforms.wShape[3] + col]);';
            case 4:
                return 'return vec4<f32>(W[(row * uniforms.wShape[3] + col) / 4]);';
            default:
                throw new Error(`innerElementSize ${innerElementSize} is not supported.`);
        }
    };
    const coordASnippet = isChannelsLast ? `
      let coord = vec4<i32>(batch, xRow, xCol, xCh);
      ` : `
      let coord = vec4<i32>(batch, xCh, xRow, xCol);
      `;
    const coordResSnippet = isChannelsLast ? `
      let coords = vec4<i32>(
        batch,
        row / outWidth,
        row % outWidth,
        col);
      ` : `
      let coords = vec4<i32>(
        batch,
        row,
        col / outWidth,
        col % outWidth);
      `;
    const xHight = isChannelsLast ? 'uniforms.xShape[1]' : 'uniforms.xShape[2]';
    const xWidth = isChannelsLast ? 'uniforms.xShape[2]' : 'uniforms.xShape[3]';
    const row = isChannelsLast ? 'row' : 'col';
    const col = isChannelsLast ? 'col' : 'row';
    const readXSnippet = `
      let inChannels = uniforms.wShape[2];
      let outWidth = ${isChannelsLast ? 'uniforms.outShape[2]' : 'uniforms.outShape[3]'};
      let outRow = ${row} / outWidth;
      let outCol = ${row} % outWidth;

      let WRow = ${col} / (uniforms.filterDims[1] * inChannels);
      let WCol = ${col} / inChannels % uniforms.filterDims[1];
      let xRow = outRow * uniforms.strides[0] + uniforms.dilations[0] * WRow - uniforms.pads[0];
      let xCol = outCol * uniforms.strides[1] + uniforms.dilations[1] * WCol - uniforms.pads[1];
      let xCh = ${col} % inChannels;
      var resData = ${(0, $oGQBh.typeSnippet)(innerElementSizeX)}(0.0);
      // The bounds checking is always needed since we use it to pad zero for
      // the 'same' padding type.
      if (xRow >= 0 && xRow < ${xHight} && xCol >= 0 && xCol < ${xWidth}) {
        ${coordASnippet}
        let xIndex = getIndexFromCoords4D(coord, uniforms.xShape);
        ${getXSnippet(innerElementSizeX)}
      }
      return resData;`;
    const sampleX = isChannelsLast ? fitAOuter && fitInner ? `
      ${readXSnippet}` : `
      if (row < uniforms.dimAOuter && col < uniforms.dimInner) {
        ${readXSnippet}
      }
      return ${(0, $oGQBh.typeSnippet)(innerElementSizeX)}(0.0);` : fitInner && fitBOuter ? `
      ${readXSnippet}` : `
      if (row < uniforms.dimInner && col < uniforms.dimBOuter) {
        ${readXSnippet}
      }
      return ${(0, $oGQBh.typeSnippet)(innerElementSizeX)}(0.0);`;
    const sampleW = `${getWSnippet(innerElementSizeW)}`;
    const resType = (0, $oGQBh.typeSnippet)(innerElementSize);
    const aType = isChannelsLast ? (0, $oGQBh.typeSnippet)(innerElementSizeX) : (0, $oGQBh.typeSnippet)(innerElementSizeW);
    const bType = isChannelsLast ? (0, $oGQBh.typeSnippet)(innerElementSizeW) : (0, $oGQBh.typeSnippet)(innerElementSizeX);
    const userCode = `
      ${(0, $7t2XD.activationFnSnippet)(activation, hasPreluActivationWeights, innerElementSize === 4, 4)}
      fn mm_readA(batch: i32, row : i32, col : i32) -> ${aType} {
        ${isChannelsLast ? sampleX : sampleW}
      }

      fn mm_readB(batch: i32, row : i32, col : i32) -> ${bType} {
        ${isChannelsLast ? sampleW : sampleX}
      }

      fn mm_write(batch: i32, row : i32, col : i32, valueIn : ${resType}) {
        if (row < uniforms.dimAOuter && col < uniforms.dimBOuter)
        {
        var value = valueIn;
        let outWidth = ${isChannelsLast ? 'uniforms.outShape[2]' : 'uniforms.outShape[3]'};
        ${coordResSnippet}
        ${(0, $7t2XD.biasActivationSnippet)(addBias, activation)}
        setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], value);
        }
      }`;
    return userCode;
}
class $016546d87bb87bbb$export$7cb7f21cacf510bc {
    constructor(convInfo, dimAOuter, dimBOuter, dimInner, addBias = false, activation = null, hasPreluActivationWeights = false, sequentialAccessByThreads = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = `filterDims : vec2<i32>, pads : vec2<i32>, strides : vec2<i32>, dilations : vec2<i32>, dimAOuter : i32, dimBOuter : i32, dimInner : i32,`;
        this.outputShape = convInfo.outShape;
        this.isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.isVec4 = ((convInfo.inChannels % 4 === 0 || convInfo.inChannels % 3 === 0) && this.isChannelsLast || convInfo.outWidth % 4 === 0 && !this.isChannelsLast) && convInfo.outChannels % 4 === 0;
        this.dispatchLayout = this.isChannelsLast ? {
            x: [
                3
            ],
            y: [
                1,
                2
            ],
            z: [
                0
            ]
        } : {
            x: [
                2,
                3
            ],
            y: [
                1
            ],
            z: [
                0
            ]
        };
        this.workgroupSize = (0, $9Dn6G.computeWorkgroupSizeForConv2d)(this.dispatchLayout, this.outputShape, this.isVec4);
        this.elementsPerThread = (0, $9Dn6G.computeWorkPerThreadForConv2d)(this.dispatchLayout, this.outputShape, this.isVec4);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, this.elementsPerThread);
        if (this.isVec4) {
            this.outputComponent = 4;
            if (this.isChannelsLast && convInfo.inChannels % 4 !== 0) {
                this.innerElementSize = 3;
                this.variableComponents = [
                    1,
                    4
                ];
            } else {
                this.innerElementSize = 4;
                this.variableComponents = [
                    4,
                    4
                ];
            }
            if (addBias) {
                this.variableNames.push('bias');
                this.variableComponents.push(4);
            }
            if (hasPreluActivationWeights) {
                this.variableNames.push('preluActivationWeights');
                this.variableComponents.push(4);
            }
        } else {
            this.innerElementSize = this.elementsPerThread[0];
            if (addBias) this.variableNames.push('bias');
            if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        }
        this.sequentialAccessByThreads = sequentialAccessByThreads;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivationWeights = hasPreluActivationWeights;
        this.tileAOuter = this.workgroupSize[1] * this.elementsPerThread[1];
        this.tileBOuter = this.workgroupSize[0] * this.elementsPerThread[0];
        this.tileInner = Math.max(this.workgroupSize[0] * this.innerElementSize, this.workgroupSize[1]);
        this.fitAOuter = dimAOuter % this.tileAOuter === 0;
        this.fitBOuter = dimBOuter % this.tileBOuter === 0;
        this.fitInner = dimInner % this.tileInner === 0;
        this.shaderKey = `conv2DMM_${this.elementsPerThread}_${this.activation}}_${this.fitAOuter}_${this.fitBOuter}_${this.fitInner}_${this.isVec4}_${this.innerElementSize}_${this.isChannelsLast}_${this.sequentialAccessByThreads}`;
    }
    getUserCode() {
        const matMulSource = this.isVec4 ? (0, $8UfUr.makeMatMulPackedVec4Source)(this.elementsPerThread, this.workgroupSize, !this.isChannelsLast, this.tileInner) : (0, $8UfUr.makeMatMulPackedSource)(this.elementsPerThread, this.workgroupSize, !this.isChannelsLast, this.tileInner, false, null, this.sequentialAccessByThreads);
        const elementsSize = this.isVec4 ? [
            this.innerElementSize,
            4,
            4
        ] : [
            1,
            1,
            1
        ];
        const userCode = `
    ${$016546d87bb87bbb$var$conv2dCommonSnippet(this.isChannelsLast, this.fitAOuter, this.fitBOuter, this.fitInner, this.addBias, this.activation, this.hasPreluActivationWeights, elementsSize[0], elementsSize[1], elementsSize[2])}
    ${matMulSource}
  `;
        return userCode;
    }
}

});

parcelRegister("2hMTT", function(module, exports) {

$parcel$export(module.exports, "Conv2DNaiveProgram", () => $1aa319e6130a6924$export$38cbe6d4e5101719);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7t2XD = parcelRequire("7t2XD");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $1aa319e6130a6924$export$38cbe6d4e5101719 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivationWeights = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = 'filterDims: vec2<i32>, pads: vec2<i32>, strides: vec2<i32>, dilations: vec2<i32>,';
        this.workgroupSize = [
            4,
            4,
            8
        ];
        this.outputShape = convInfo.outShape;
        this.isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.dispatchLayout = this.isChannelsLast ? {
            x: [
                2
            ],
            y: [
                1
            ],
            z: [
                0,
                3
            ]
        } : {
            x: [
                3
            ],
            y: [
                2
            ],
            z: [
                0,
                1
            ]
        };
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivationWeights = hasPreluActivationWeights;
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        this.shaderKey = `conv2dnaive_${this.activation}_${this.isChannelsLast}`;
    }
    getUserCode() {
        const userCode = `
       ${(0, $7t2XD.activationFnSnippet)(this.activation, this.hasPreluActivationWeights, false, 4)}
       fn readInp(batch : i32, row : i32, col : i32, chan : i32) -> f32{
         let coords = vec4<i32>(batch, row, col, chan);
         if (coordsInBounds4D(coords, uniforms.xShape)) {
           return  getX(batch, row, col, chan);
         } else {
          return 0.0;
         }
       }
       fn readFilt(row : i32, col : i32, xChannel : i32, outChannel : i32) -> f32{
         let coords = vec4<i32>(row, col, xChannel, outChannel);
         if(coordsInBounds4D(coords, uniforms.wShape)) {
           return getW(row, col, xChannel, outChannel);
          } else {
            return 0.0;
          }
       }
       fn writeResult(batch : i32, row : i32, col : i32, chan : i32, valueIn : f32) {
         let coords = ${this.isChannelsLast ? `vec4<i32>(batch, row, col, chan);` : `vec4<i32>(batch, chan, row, col);`}
         if (coordsInBounds4D(coords, uniforms.outShape)) {
           var value = valueIn;
           ${(0, $7t2XD.biasActivationSnippet)(this.addBias, this.activation)}
           setOutputAtCoords(coords.x, coords.y, coords.z, coords.w, value);
         }
       }
       ${(0, $oGQBh.getMainHeaderString)('index')} {
         let coords = getOutputCoords();
         let batch = coords[0];
         let outChannel = ${this.isChannelsLast ? `coords[3];` : `coords[1];`}
         let outRow = ${this.isChannelsLast ? `coords[1];` : `coords[2];`}
         let outCol = ${this.isChannelsLast ? `coords[2];` : `coords[3];`}
         var acc : f32 = 0.0;
         for (var row = 0; row < uniforms.filterDims[0]; row = row + 1) {
           for (var col = 0; col < uniforms.filterDims[1]; col = col + 1) {
             let xRow = outRow * uniforms.strides[0] + uniforms.dilations[0] * row - uniforms.pads[0];
             let xCol = outCol * uniforms.strides[1] + uniforms.dilations[1] * col - uniforms.pads[1];
             for (var xChannel = 0; xChannel < ${this.isChannelsLast ? `uniforms.xShape[3];` : `uniforms.xShape[1];`} xChannel = xChannel + 1) {
               ${this.isChannelsLast ? `let v = readInp(batch, xRow, xCol, xChannel);` : `let v = readInp(batch, xChannel, xRow, xCol);`}
               let f = readFilt(row, col, xChannel, outChannel);
               acc = acc + v * f;
             }
           }
         }
         writeResult(batch, outRow, outCol, outChannel, acc);
       }
     `;
        return userCode;
    }
}

});

parcelRegister("2JZnV", function(module, exports) {

$parcel$export(module.exports, "Im2ColProgram", () => $1fef667a19720052$export$6f6c634918904ed8);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $1fef667a19720052$export$6f6c634918904ed8 {
    constructor(outputShape, isChannelsLast){
        this.variableNames = [
            'x'
        ];
        this.uniforms = `pads : vec2<i32>, strides : vec2<i32>, dilations : vec2<i32>, outWidth : i32, itemsPerBlockRow : i32,
       inChannels : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.isChannelsLast = isChannelsLast;
        this.shaderKey = `im2col_${this.isChannelsLast}`;
    }
    getUserCode() {
        const rowDim = this.isChannelsLast ? 1 : 2;
        const colDim = this.isChannelsLast ? 2 : 3;
        const row = this.isChannelsLast ? 'coords[1]' : 'coords[2]';
        const col = this.isChannelsLast ? 'coords[2]' : 'coords[1]';
        const getXSnippet = this.isChannelsLast ? 'getX(batch, xRow, xCol, ch)' : 'getX(batch, ch, xRow, xCol)';
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      let coords = getCoordsFromIndex(index);
      if(index < uniforms.size) {
        let batch = coords[0];
        let row = ${row};
        let col = ${col};
        let offsetY = (row / uniforms.outWidth) * uniforms.strides[0] - uniforms.pads[0];
        let xRow = offsetY + uniforms.dilations[0] * (col / uniforms.itemsPerBlockRow);
        var value = 0.0;
        if(xRow < uniforms.xShape[${rowDim}] && xRow >= 0) {
          let offsetX = (row % uniforms.outWidth) * uniforms.strides[1] -
              uniforms.pads[1];
          let xCol = offsetX + uniforms.dilations[1] * ((col %
              uniforms.itemsPerBlockRow) / uniforms.inChannels);
          let ch = col % uniforms.inChannels;
          if(xCol < uniforms.xShape[${colDim}] && xCol >= 0) {
            value = ${getXSnippet};
          }
        }
        setOutputAtIndex(index, value);
      }
    }
   `;
        return userCode;
    }
}

});



parcelRegister("eNRYg", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropFilterConfig", () => $ac6f81ca1578c8f8$export$7a95f55d2d2e7d24);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $kmYd1 = parcelRequire("kmYd1");
function $ac6f81ca1578c8f8$export$652a30c9379f3de7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const $dataFormat = (0, $7MaPk).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $7MaPk).computeConv2DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const program = new (0, $kmYd1.Conv2DDerFilterProgram)(convInfo);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.batchSize
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        x,
        dy
    ], x.dtype, uniformData);
}
const $ac6f81ca1578c8f8$export$7a95f55d2d2e7d24 = {
    kernelName: (0, $hl418.Conv2DBackpropFilter),
    backendName: 'webgpu',
    kernelFunc: $ac6f81ca1578c8f8$export$652a30c9379f3de7
};

});
parcelRegister("kmYd1", function(module, exports) {

$parcel$export(module.exports, "Conv2DDerInputProgram", () => $ed4490fa90e446b7$export$5dc650171c0f6623);
$parcel$export(module.exports, "Conv2DDerFilterProgram", () => $ed4490fa90e446b7$export$1223560f67be2f2d);
$parcel$export(module.exports, "Conv3DDerFilterProgram", () => $ed4490fa90e446b7$export$932d18866f409cf3);
$parcel$export(module.exports, "Conv3DDerInputProgram", () => $ed4490fa90e446b7$export$acda329ff653a25);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $ed4490fa90e446b7$export$5dc650171c0f6623 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.uniforms = 'filterDims : vec2<i32>, pads : vec2<i32>, strides : vec2<i32>, outBackprop : vec4<i32>,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = false;
        this.isVec4 = false;
        this.workPerThread = 1;
        this.outputShape = convInfo.inShape;
        this.isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.isVec4 = this.isChannelsLast && convInfo.outChannels % 4 === 0 && convInfo.inChannels % 4 === 0;
        if (this.isVec4) {
            // TODO: Expand to any value.
            this.workPerThread = 2;
            this.outputComponent = 4;
            this.workgroupSize = [
                4,
                4,
                4
            ];
            this.dispatchLayout = {
                x: [
                    3
                ],
                y: [
                    2
                ],
                z: [
                    0,
                    1
                ]
            };
            this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
                4,
                this.workPerThread,
                1
            ]);
        } else {
            this.size = true;
            this.workPerThread = 1;
            this.workgroupSize = [
                64,
                1,
                1
            ];
            this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
            this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        }
        this.shaderKey = `conv2DDerInput_${this.isChannelsLast}_${this.isVec4}_${this.workPerThread}`;
    }
    getUserCode() {
        const rowDim = this.isChannelsLast ? 1 : 2;
        const colDim = this.isChannelsLast ? 2 : 3;
        const channelDim = this.isChannelsLast ? 3 : 1;
        const vec4Snippet = `
    ${(0, $oGQBh.getMainHeaderString)()} {
      let batch = i32(globalId.z) / uniforms.outShape[1];
      let r = i32(globalId.z) % uniforms.outShape[1];
      let c = i32(globalId.y) * ${this.workPerThread};
      let d1 = i32(globalId.x) * 4;

      let dyCorner = vec2<i32>(r, c) - uniforms.pads;

      // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
      // ? = to be determined. : = across all values in that axis.
      var dotProd: array<vec4<f32>, ${this.workPerThread}>;
      for (var i = 0; i < ${this.workPerThread}; i++) {
        dotProd[i] = vec4<f32>(0.0);
      }
      for (var wR = 0; wR < uniforms.filterDims.x; wR = wR + 1) {
        let dyR = f32(dyCorner.x + wR) / f32(uniforms.strides.x);
        let wRPerm = uniforms.filterDims.x - 1 - wR;
        if (dyR < 0.0 || dyR >= f32(uniforms.outBackprop[1]) ||
            fract(dyR) > 0.0) {
          continue;
        }
        let idyR = i32(dyR);

        for (var wC = 0; wC < uniforms.filterDims.y; wC = wC + 1) {
          let dyC = f32(dyCorner.y + wC) / f32(uniforms.strides.y);
          let dyC2 = f32(dyCorner.y + 1 + wC) / f32(uniforms.strides.y);
          let wCPerm = uniforms.filterDims.y - 1 - wC;
          var bDyCVal = true;
          var bDyCVal2 = true;
          if (dyC < 0.0 || dyC >= f32(uniforms.outBackprop[2]) ||
              fract(dyC) > 0.0) {
            bDyCVal = false;
          }
          if (dyC2 < 0.0 || dyC2 >= f32(uniforms.outBackprop[2]) ||
              fract(dyC2) > 0.0) {
            bDyCVal2 = false;
          }

          let idyC = i32(dyC);
          let idyC2 = i32(dyC2);
          if (bDyCVal && bDyCVal2) {
            let d2Length = uniforms.outBackprop[3];
            for (var d2 = 0; d2 < d2Length; d2 = d2 + 4) {
              let wValue0 = getW(wRPerm, wCPerm, d1, d2);
              let wValue1 = getW(wRPerm, wCPerm, d1 + 1, d2);
              let wValue2 = getW(wRPerm, wCPerm, d1 + 2, d2);
              let wValue3 = getW(wRPerm, wCPerm, d1 + 3, d2);
              var xValue =  getDy(batch, idyR, idyC, d2);
              let tmpval = vec4<f32>(dot(xValue, wValue0),
                                     dot(xValue, wValue1),
                                     dot(xValue, wValue2),
                                     dot(xValue, wValue3));
              dotProd[0] = dotProd[0] + tmpval;
              xValue = getDy(batch, idyR, idyC2, d2);
              dotProd[1] = dotProd[1] + vec4<f32>(dot(xValue, wValue0),
                                                  dot(xValue, wValue1),
                                                  dot(xValue, wValue2),
                                                  dot(xValue, wValue3));
            }
          } else if (bDyCVal) {
            let d2Length = uniforms.outBackprop[3];
            for (var d2 = 0; d2 < d2Length; d2 = d2 + 4) {
              let wValue0 = getW(wRPerm, wCPerm, d1, d2);
              let wValue1 = getW(wRPerm, wCPerm, d1 + 1, d2);
              let wValue2 = getW(wRPerm, wCPerm, d1 + 2, d2);
              let wValue3 = getW(wRPerm, wCPerm, d1 + 3, d2);
              var xValue =  getDy(batch, idyR, idyC, d2);
              let tmpval = vec4<f32>(dot(xValue, wValue0),
                                     dot(xValue, wValue1),
                                     dot(xValue, wValue2),
                                     dot(xValue, wValue3));
              dotProd[0] = dotProd[0] + tmpval;
            }
          } else if (bDyCVal2) {
            let d2Length = uniforms.outBackprop[3];
            for (var d2 = 0; d2 < d2Length; d2 = d2 + 4) {
              let wValue0 = getW(wRPerm, wCPerm, d1, d2);
              let wValue1 = getW(wRPerm, wCPerm, d1 + 1, d2);
              let wValue2 = getW(wRPerm, wCPerm, d1 + 2, d2);
              let wValue3 = getW(wRPerm, wCPerm, d1 + 3, d2);
              var xValue =  getDy(batch, idyR, idyC2, d2);
              let tmpval = vec4<f32>(dot(xValue, wValue0),
                                     dot(xValue, wValue1),
                                     dot(xValue, wValue2),
                                     dot(xValue, wValue3));
              dotProd[1] = dotProd[1] + tmpval;
            }
          }
        }
      }

      for (var i = 0; i < ${this.workPerThread}; i = i + 1) {
        let coords = vec4<i32>(batch, r, c + i, d1);
        if (coordsInBounds4D(coords, uniforms.outShape)) {
          setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], dotProd[i]);
        }
      }
    }
    `;
        return this.isVec4 ? `
    ${vec4Snippet}
    ` : `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if(index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords[0];
        let d1 = coords[${channelDim}];

        let dyCorner = vec2<i32>(coords[${rowDim}], coords[${colDim}]) - uniforms.pads;
        let dyRCorner = dyCorner.x;
        let dyCCorner = dyCorner.y;

        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        for (var wR = 0; wR < uniforms.filterDims.x; wR = wR + 1) {
          let dyR = (f32(dyRCorner) + f32(wR)) / f32(uniforms.strides.x);
          let wRPerm = uniforms.filterDims.x - 1 - wR;
          if (dyR < 0.0 || dyR >= f32(uniforms.outBackprop[1]) || fract(dyR) > 0.0 ||
              wRPerm < 0) {
            continue;
          }
          let idyR = i32(dyR);

          for (var wC = 0; wC < uniforms.filterDims.y; wC = wC + 1) {
            let dyC = (f32(dyCCorner) + f32(wC)) / f32(uniforms.strides.y);
            let wCPerm = uniforms.filterDims.y - 1 - wC;
            if (dyC < 0.0 || dyC >= f32(uniforms.outBackprop[2]) ||
                fract(dyC) > 0.0 || wCPerm < 0) {
              continue;
            }
            let idyC = i32(dyC);

            for (var d2 = 0; d2 < uniforms.outBackprop[3]; d2 = d2 + 1) {
              let xValue = ${this.isChannelsLast ? 'getDy(batch, idyR, idyC, d2)' : 'getDy(batch, d2, idyR, idyC)'};
              let wValue = getW(wRPerm, wCPerm, d1, d2);
              dotProd = dotProd + xValue * wValue;
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
  `;
    }
}
class $ed4490fa90e446b7$export$1223560f67be2f2d {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.uniforms = 'pads : vec2<i32>, strides : vec2<i32>, batchSize : i32, outHeight : i32, outWidth : i32, inHeight : i32, inWidth : i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.filterShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.shaderKey = `conv2DDerFilter_${this.isChannelsLast}`;
    }
    getUserCode() {
        return `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if(index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let wR = coords[0];
        let wC = coords[1];
        let d1 = coords[2];
        let d2 = coords[3];

        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        for (var b = 0; b < uniforms.batchSize; b = b + 1) {
          for (var yR = 0; yR < uniforms.outHeight; yR = yR + 1) {
            let xR = wR + yR * uniforms.strides[0] - uniforms.pads[0];
            if (xR < 0 || xR >= uniforms.inHeight) {
              continue;
            }

            for (var yC = 0; yC < uniforms.outWidth; yC = yC + 1) {
              let xC = wC + yC * uniforms.strides[1] - uniforms.pads[1];

              if (xC < 0 || xC >= uniforms.inWidth) {
                continue;
              }

              if (${this.isChannelsLast}) {
                let dyValue = getDy(b, yR, yC, d2);
                let xValue = getX(b, xR, xC, d1);
                dotProd = dotProd + xValue * dyValue;
              } else {
                let dyValue = getDy(b, d2, yR, yC);
                let xValue = getX(b, d1, xR, xC);
                dotProd = dotProd + xValue * dyValue;
              }
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
  `;
    }
}
class $ed4490fa90e446b7$export$932d18866f409cf3 {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.uniforms = `pads : vec3<i32>, strides : vec3<i32>, batchSize : i32, outDepth : i32,
       outHeight : i32, outWidth : i32, inDepth : i32, inHeight : i32, inWidth : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.filterShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `conv3DDerFilter`;
    }
    getUserCode() {
        return `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if(index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let wF = coords.x;
        let wR = coords.y;
        let wC = coords.z;
        let d1 = coords.w;
        let d2 = coords.u;

        var dotProd = 0.0;
        for (var b = 0; b < uniforms.batchSize; b++) {
          for (var yF = 0; yF < uniforms.outDepth; yF++) {
            let xF = wF + yF * uniforms.strides[0] - uniforms.pads[0];
            if (xF < 0 || xF >= uniforms.inDepth) {
              continue;
            }

            for (var yR = 0; yR < uniforms.outHeight; yR++) {
              let xR = wR + yR * uniforms.strides[1] - uniforms.pads[1];
              if (xR < 0 || xR >= uniforms.inHeight) {
                continue;
              }

              for (var yC = 0; yC < uniforms.outWidth; yC++) {
                let xC = wC + yC * uniforms.strides[2] - uniforms.pads[2];
                if (xC < 0 || xC >= uniforms.inWidth) {
                  continue;
                }

                let dyValue = getDy(b, yF, yR, yC, d2);
                let xValue = getX(b, xF, xR, xC, d1);
                dotProd += xValue * dyValue;
              }
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
  `;
    }
}
class $ed4490fa90e446b7$export$acda329ff653a25 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.uniforms = `filterDims : vec3<i32>, pads : vec3<i32>, strides : vec3<i32>,
      outDepth : i32, outHeight : i32, outWidth : i32, outChannels : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `conv3DDerInput`;
    }
    getUserCode() {
        return `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if(index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords.x;
        let d1 = coords.u;

        let dyCorner = vec3<i32>(coords.y, coords.z, coords.w) - uniforms.pads;
        let dyFCorner = dyCorner.x;
        let dyRCorner = dyCorner.y;
        let dyCCorner = dyCorner.z;

        var dotProd = 0.0;
        for (var wF = 0; wF < uniforms.filterDims[0]; wF++) {
          let dyF = f32(dyFCorner + wF) / f32(uniforms.strides[0]);
          if (dyF < 0.0 || dyF >= f32(uniforms.outDepth) || fract(dyF) > 0.0) {
            continue;
          }
          let idyF = i32(dyF);

          let wFPerm = uniforms.filterDims[0] - 1 - wF;

          for (var wR = 0; wR < uniforms.filterDims[1]; wR++) {
            let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[1]);

            if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
              continue;
            }
            let idyR = i32(dyR);

            let wRPerm = uniforms.filterDims[1] - 1 - wR;

            for (var wC = 0; wC < uniforms.filterDims[2]; wC++) {
              let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[2]);

              if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
                continue;
              }
              let idyC = i32(dyC);

              let wCPerm = uniforms.filterDims[2] - 1 - wC;

              for (var d2 = 0; d2 < uniforms.outChannels; d2++) {
                let xValue = getDy(batch, idyF, idyR, idyC, d2);
                let wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
  `;
    }
}

});


parcelRegister("2uuGe", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropInputConfig", () => $1d062e8f3ebac0ea$export$19bbc19fff1ed26f);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $ibsdL = parcelRequire("ibsdL");

var $bYXWg = parcelRequire("bYXWg");

var $kmYd1 = parcelRequire("kmYd1");
function $1d062e8f3ebac0ea$export$633310eed0c26e72(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { inputShape: inputShape, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $7MaPk).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $7MaPk).computeConv2DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.filterHeight - 1 - convInfo.padInfo.top,
                convInfo.filterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.batchSize,
                convInfo.outHeight,
                convInfo.outWidth,
                convInfo.outChannels
            ]
        }
    ];
    let program;
    // TODO: Experiment when to use Conv2DDerInputMMProgram algorithm.
    if ((0, $ibsdL.env)().getBool('WEBGPU_USE_NAIVE_CONV2D_TRANSPOSE') || convInfo.dataFormat !== 'channelsLast') program = new (0, $kmYd1.Conv2DDerInputProgram)(convInfo);
    else {
        program = new (0, $bYXWg.Conv2DDerInputMMProgram)(convInfo);
        const dimAOuter = convInfo.inHeight * convInfo.inWidth;
        const dimBOuter = convInfo.inChannels;
        const dimInner = convInfo.filterHeight * convInfo.filterWidth * convInfo.outChannels;
        dimensions.push({
            type: 'uint32',
            data: [
                dimAOuter
            ]
        }, {
            type: 'uint32',
            data: [
                dimBOuter
            ]
        }, {
            type: 'uint32',
            data: [
                dimInner
            ]
        });
    }
    return backend.runWebGPUProgram(program, [
        dy,
        filter
    ], 'float32', dimensions);
}
const $1d062e8f3ebac0ea$export$19bbc19fff1ed26f = {
    kernelName: (0, $hl418.Conv2DBackpropInput),
    backendName: 'webgpu',
    kernelFunc: $1d062e8f3ebac0ea$export$633310eed0c26e72
};

});
parcelRegister("bYXWg", function(module, exports) {

$parcel$export(module.exports, "Conv2DDerInputMMProgram", () => $8b93cae76ef58b6f$export$274f8feb1a7dfb31);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");

var $8UfUr = parcelRequire("8UfUr");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
function $8b93cae76ef58b6f$var$conv2dTransposeCommonSnippet(innerElementSize = 4) {
    const getWSnippet = (innerElementSize)=>{
        switch(innerElementSize){
            case 1:
                return 'return W[getIndexFromCoords4D(coord, uniforms.wShape)];';
            case 4:
                return `
            let coord1 = vec4<i32>(coordX, coordY, col + 1, rowInner);
            let coord2 = vec4<i32>(coordX, coordY, col + 2, rowInner);
            let coord3 = vec4<i32>(coordX, coordY, col + 3, rowInner);
            let v0 = W[getIndexFromCoords4D(coord, uniforms.wShape)];
            let v1 = W[getIndexFromCoords4D(coord1, uniforms.wShape)];
            let v2 = W[getIndexFromCoords4D(coord2, uniforms.wShape)];
            let v3 = W[getIndexFromCoords4D(coord3, uniforms.wShape)];
            return vec4<f32>(v0, v1, v2, v3);
            `;
            default:
                throw new Error(`innerElementSize ${innerElementSize} is not supported.`);
        }
    };
    const readASnippet = `
      let outRow = row / uniforms.outShape[2];
      let outCol = row % uniforms.outShape[2];

      let WRow = col / (uniforms.filterDims[1] * uniforms.outBackprop[3]);
      let WCol = col / uniforms.outBackprop[3] % uniforms.filterDims[1];
      let xR = f32(outRow - uniforms.pads[0] + WRow) / f32(uniforms.strides[0]);
      let xC = f32(outCol - uniforms.pads[1] + WCol) / f32(uniforms.strides[1]);
      if (xR < 0.0 || xR >= f32(uniforms.outBackprop[1]) || fract(xR) > 0.0) {
        return ${(0, $oGQBh.typeSnippet)(innerElementSize)}(0.0);
      }
      if (xC < 0.0 || xC >= f32(uniforms.outBackprop[2]) || fract(xC) > 0.0) {
        return ${(0, $oGQBh.typeSnippet)(innerElementSize)}(0.0);
      }
      let coord = vec4<i32>(
          batch,
          i32(xR),
          i32(xC),
          col % uniforms.outBackprop[3]);
      return x[getIndexFromCoords4D(coord, uniforms.xShape)/${innerElementSize}];`;
    const sampleA = `if (row < uniforms.dimAOuter && col < uniforms.dimInner) {
        ${readASnippet}
      }
      return ${(0, $oGQBh.typeSnippet)(innerElementSize)}(0.0);`;
    const userCode = `
  fn mm_readA(batch: i32, row : i32, col : i32) -> ${(0, $oGQBh.typeSnippet)(innerElementSize)} {
    ${sampleA}
  }

  fn mm_readB(batch: i32, row : i32, col : i32) -> ${(0, $oGQBh.typeSnippet)(innerElementSize)} {
    let coordX = uniforms.filterDims.x - 1 -
        row / (uniforms.filterDims[1] * uniforms.outBackprop[3]);
    let coordY = uniforms.filterDims.y - 1 -
        (row / uniforms.outBackprop[3]) % uniforms.filterDims[1];
    if (row < uniforms.dimInner && col < uniforms.dimBOuter &&
        coordX >= 0 && coordY >= 0) {
      let rowInner = row % uniforms.outBackprop[3];
      let coord = vec4<i32>(coordX, coordY, col, rowInner);
      ${getWSnippet(innerElementSize)}
    }
    return ${(0, $oGQBh.typeSnippet)(innerElementSize)}(0.0);
  }

  fn mm_write(batch: i32, row : i32, col : i32, valueInput : ${(0, $oGQBh.typeSnippet)(innerElementSize)}) {
    if (row < uniforms.dimAOuter && col < uniforms.dimBOuter) {
      var value = valueInput;
      let outCoord = vec4<i32>(
          batch,
          row / uniforms.outShape[2],
          row % uniforms.outShape[2],
          col);
      result[getIndexFromCoords4D(outCoord, uniforms.outShape)/${innerElementSize}] = value;
    }
  }`;
    return userCode;
}
class $8b93cae76ef58b6f$export$274f8feb1a7dfb31 {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = 'filterDims : vec2<i32>, pads : vec2<i32>, strides : vec2<i32>, outBackprop : vec4<i32>, dimAOuter : i32, dimBOuter : i32, dimInner : i32,';
        this.outputShape = convInfo.inShape;
        (0, $jjNRA).assert(convInfo.dataFormat === 'channelsLast', ()=>'TODO: NCHW is unimplemented');
        this.isVec4 = convInfo.inChannels % 4 === 0 && convInfo.outChannels % 4 === 0;
        this.dispatchLayout = {
            x: [
                3
            ],
            y: [
                1,
                2
            ],
            z: [
                0
            ]
        };
        this.workgroupSize = (0, $9Dn6G.computeWorkgroupSizeForConv2d)(this.dispatchLayout, this.outputShape, this.isVec4);
        this.elementsPerThread = (0, $9Dn6G.computeWorkPerThreadForConv2d)(this.dispatchLayout, this.outputShape, this.isVec4);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, this.elementsPerThread);
        if (this.isVec4) {
            this.outputComponent = 4;
            this.variableComponents = [
                4,
                1
            ];
        }
        this.shaderKey = `conv2DDerInputMM_${this.isVec4}_${this.elementsPerThread}`;
    }
    getUserCode() {
        const matMulSource = this.isVec4 ? (0, $8UfUr.makeMatMulPackedVec4Source)(this.elementsPerThread, this.workgroupSize) : (0, $8UfUr.makeMatMulPackedSource)(this.elementsPerThread, this.workgroupSize);
        const userCode = `
    ${$8b93cae76ef58b6f$var$conv2dTransposeCommonSnippet(this.isVec4 ? 4 : 1)}
    ${matMulSource}
    `;
        return userCode;
    }
}

});


parcelRegister("2s8kP", function(module, exports) {

$parcel$export(module.exports, "conv3DConfig", () => $1c94a96d7b9d30ee$export$1fe590fda0829040);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $2MDja = parcelRequire("2MDja");

var $3pfqz = parcelRequire("3pfqz");
function $1c94a96d7b9d30ee$export$1929932f31d07956(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $7MaPk).computeConv3DInfo(x.shape, filter.shape, strides, dilations, pad);
    const padInfo = [
        convInfo.padInfo.front,
        convInfo.padInfo.top,
        convInfo.padInfo.left
    ];
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.filterDepth,
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                ...padInfo
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationDepth,
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        }
    ];
    const program = new (0, $3pfqz.Conv3DNaiveProgram)(convInfo);
    const dtype = (0, $2MDja.upcastType)(x.dtype, filter.dtype);
    return backend.runWebGPUProgram(program, [
        x,
        filter
    ], dtype, dimensions);
}
const $1c94a96d7b9d30ee$export$1fe590fda0829040 = {
    kernelName: (0, $hl418.Conv3D),
    backendName: 'webgpu',
    kernelFunc: $1c94a96d7b9d30ee$export$1929932f31d07956
};

});
parcelRegister("3pfqz", function(module, exports) {

$parcel$export(module.exports, "Conv3DNaiveProgram", () => $27afac7c80d87bc7$export$d39b613d7b183f3b);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $27afac7c80d87bc7$export$d39b613d7b183f3b {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = 'filterDims: vec3<i32>, pads: vec3<i32>, strides: vec3<i32>, dilations: vec3<i32>,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `conv3dnaive`;
    }
    getUserCode() {
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getOutputCoords();
        let batch = coords.x;
        let d2 = coords.u;

        let xFRCCorner = vec3<i32>(coords.y, coords.z, coords.w) * uniforms.strides - uniforms.pads;
        let xFCorner = xFRCCorner.x;
        let xRCorner = xFRCCorner.y;
        let xCCorner = xFRCCorner.z;

        let inputDepthNearestVec4 = (uniforms.xShape.u / 4) * 4;
        let inputDepthVec4Remainder = uniforms.xShape.u % 4;

        var dotProd = 0.0;
        for (var wF = 0; wF < uniforms.filterDims[0]; wF++) {
          let xF = xFCorner + wF * uniforms.dilations[0];
          if (xF < 0 || xF >= uniforms.xShape.y) {
            continue;
          }

          for (var wR = 0; wR < uniforms.filterDims[1]; wR++) {
            let xR = xRCorner + wR * uniforms.dilations[1];
            if (xR < 0 || xR >= uniforms.xShape.z) {
              continue;
            }

            for (var wC = 0; wC < uniforms.filterDims[2]; wC++) {
              let xC = xCCorner + wC * uniforms.dilations[2];
              if (xC < 0 || xC >= uniforms.xShape.w) {
                continue;
              }

              for (var d1 = 0; d1 < inputDepthNearestVec4; d1 += 4) {
                let xValues = vec4<f32>(
                  getX(batch, xF, xR, xC, d1),
                  getX(batch, xF, xR, xC, d1 + 1),
                  getX(batch, xF, xR, xC, d1 + 2),
                  getX(batch, xF, xR, xC, d1 + 3)
                );
                let wValues = vec4<f32>(
                  getW(wF, wR, wC, d1, d2),
                  getW(wF, wR, wC, d1 + 1, d2),
                  getW(wF, wR, wC, d1 + 2, d2),
                  getW(wF, wR, wC, d1 + 3, d2)
                );

                dotProd += dot(xValues, wValues);
              }

              if (inputDepthVec4Remainder == 1) {
                dotProd += getX(batch, xF, xR, xC, inputDepthNearestVec4) *
                  getW(wF, wR, wC, inputDepthNearestVec4, d2);
              } else if (inputDepthVec4Remainder == 2) {
                let xValues = vec2<f32>(
                  getX(batch, xF, xR, xC, inputDepthNearestVec4),
                  getX(batch, xF, xR, xC, inputDepthNearestVec4 + 1)
                );
                let wValues = vec2<f32>(
                  getW(wF, wR, wC, inputDepthNearestVec4, d2),
                  getW(wF, wR, wC, inputDepthNearestVec4 + 1, d2)
                );
                dotProd += dot(xValues, wValues);
              } else if (inputDepthVec4Remainder == 3) {
                let xValues = vec3<f32>(
                  getX(batch, xF, xR, xC, inputDepthNearestVec4),
                  getX(batch, xF, xR, xC, inputDepthNearestVec4 + 1),
                  getX(batch, xF, xR, xC, inputDepthNearestVec4 + 2)
                );
                let wValues = vec3<f32>(
                  getW(wF, wR, wC, inputDepthNearestVec4, d2),
                  getW(wF, wR, wC, inputDepthNearestVec4 + 1, d2),
                  getW(wF, wR, wC, inputDepthNearestVec4 + 2, d2)
                );
                dotProd += dot(xValues, wValues);
              }
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }`;
        return userCode;
    }
}

});


parcelRegister("JUqmg", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropFilterV2Config", () => $089ff8bdac8b88d8$export$6dce9169640850fa);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $kmYd1 = parcelRequire("kmYd1");
function $089ff8bdac8b88d8$export$b57760dc3101cea7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, filterShape: filterShape } = attrs;
    const convInfo = (0, $7MaPk).computeConv3DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad);
    const program = new (0, $kmYd1.Conv3DDerFilterProgram)(convInfo);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.padInfo.front,
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.batchSize
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outDepth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inDepth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        x,
        dy
    ], dy.dtype, uniformData);
}
const $089ff8bdac8b88d8$export$6dce9169640850fa = {
    kernelName: (0, $hl418.Conv3DBackpropFilterV2),
    backendName: 'webgpu',
    kernelFunc: $089ff8bdac8b88d8$export$b57760dc3101cea7
};

});

parcelRegister("5EFKx", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropInputV2Config", () => $41e112c44dfe735e$export$40ece1caaaf084b2);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $kmYd1 = parcelRequire("kmYd1");
function $41e112c44dfe735e$export$ab31b884dc9f0971(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, pad: pad, inputShape: inputShape } = attrs;
    const convInfo = (0, $7MaPk).computeConv3DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad);
    const program = new (0, $kmYd1.Conv3DDerInputProgram)(convInfo);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.filterDepth,
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.filterDepth - 1 - convInfo.padInfo.front,
                convInfo.filterHeight - 1 - convInfo.padInfo.top,
                convInfo.filterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outDepth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outChannels
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy,
        filter
    ], dy.dtype, uniformData);
}
const $41e112c44dfe735e$export$40ece1caaaf084b2 = {
    kernelName: (0, $hl418.Conv3DBackpropInputV2),
    backendName: 'webgpu',
    kernelFunc: $41e112c44dfe735e$export$ab31b884dc9f0971
};

});

parcelRegister("l74vR", function(module, exports) {

$parcel$export(module.exports, "cosConfig", () => $f5edc09aaee54fb4$export$ff099a1da5235a7e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $f5edc09aaee54fb4$export$50d414a77b60d802 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).COS
});
const $f5edc09aaee54fb4$export$ff099a1da5235a7e = {
    kernelName: (0, $hl418.Cos),
    backendName: 'webgpu',
    kernelFunc: $f5edc09aaee54fb4$export$50d414a77b60d802
};

});

parcelRegister("bp7kF", function(module, exports) {

$parcel$export(module.exports, "coshConfig", () => $84d7b78bcfcd6d13$export$c5824052b09ba0ed);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $84d7b78bcfcd6d13$export$2e2fd1ad24e4d350 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).COSH
});
const $84d7b78bcfcd6d13$export$c5824052b09ba0ed = {
    kernelName: (0, $hl418.Cosh),
    backendName: 'webgpu',
    kernelFunc: $84d7b78bcfcd6d13$export$2e2fd1ad24e4d350
};

});

parcelRegister("kcn61", function(module, exports) {

$parcel$export(module.exports, "cropAndResizeConfig", () => $eb46d80d931a9b8a$export$f7086edcf0050c7f);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $kITgU = parcelRequire("kITgU");
const $eb46d80d931a9b8a$export$6f0f0090e1f6cd3c = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, boxes: boxes, boxInd: boxInd } = inputs;
    const { cropSize: cropSize, method: method, extrapolationValue: extrapolationValue } = attrs;
    const program = new (0, $kITgU.CropAndResizeProgram)(image.shape[3], boxes.shape, cropSize, method);
    const uniformData = [
        {
            type: 'float32',
            data: [
                extrapolationValue
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        image,
        boxes,
        boxInd
    ], 'float32', uniformData);
};
const $eb46d80d931a9b8a$export$f7086edcf0050c7f = {
    kernelName: (0, $hl418.CropAndResize),
    backendName: 'webgpu',
    kernelFunc: $eb46d80d931a9b8a$export$6f0f0090e1f6cd3c
};

});
parcelRegister("kITgU", function(module, exports) {

$parcel$export(module.exports, "CropAndResizeProgram", () => $f162ca8774bec270$export$c889a58f7ea63106);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $f162ca8774bec270$export$c889a58f7ea63106 {
    constructor(channnel, boxShape, cropSize, method){
        this.variableNames = [
            'Image',
            'Boxes',
            'BoxInd'
        ];
        this.uniforms = 'extrapolationValue : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        const [numBoxes] = boxShape;
        this.outputShape = [
            numBoxes,
            cropSize[0],
            cropSize[1],
            channnel
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.methodId = method === 'bilinear' ? 1 : 0;
        this.cropHeightBiggerThan1 = this.outputShape[1] > 1;
        this.cropWidthBiggerThan1 = this.outputShape[2] > 1;
        this.shaderKey = `cropAndResize_${this.methodId}_${this.cropHeightBiggerThan1}_${this.cropWidthBiggerThan1}`;
    }
    getUserCode() {
        const [inputHeightFloat, inputWidthFloat] = [
            `f32(uniforms.imageShape[1] - 1)`,
            `f32(uniforms.imageShape[2] - 1)`
        ];
        const [heightRatio, heightScale, inY] = this.cropHeightBiggerThan1 ? [
            `(${inputHeightFloat} / f32(uniforms.outShape[1] - 1))`,
            '(y2-y1) * height_ratio',
            `y1*${inputHeightFloat} + f32(y)*(height_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (y1+y2) * ${inputHeightFloat}`
        ];
        const [widthRatio, widthScale, inX] = this.cropWidthBiggerThan1 ? [
            `(${inputWidthFloat} / f32(uniforms.outShape[2] - 1))`,
            '(x2-x1) * width_ratio',
            `x1*${inputWidthFloat} + f32(x)*(width_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (x1+x2) * ${inputWidthFloat}`
        ];
        // Reference implementation
        // tslint:disable-next-line:max-line-length
        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op_gpu.cu.cc
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let height_ratio = f32(${heightRatio});
        let width_ratio = f32(${widthRatio});
        let b = coords[0];
        let y = coords[1];
        let x = coords[2];
        let d = coords[3];
        // get box vals
        let y1 = getBoxes(b, 0);
        let x1 = getBoxes(b, 1);
        let y2 = getBoxes(b, 2);
        let x2 = getBoxes(b, 3);
        // get image in batch index
        let bInd = i32(round(getBoxInd(b)));
        if(bInd < 0 || bInd >= uniforms.outShape[0]) {
          return;
        }
        let height_scale = ${heightScale};
        let width_scale = ${widthScale};
        let in_y = ${inY};
        if( in_y < 0.0 || in_y > ${inputHeightFloat} ) {
          setOutputAtIndex(index, uniforms.extrapolationValue);
          return;
        }
        let in_x = ${inX};
        if( in_x < 0.0 || in_x > ${inputWidthFloat} ) {
          setOutputAtIndex(index, uniforms.extrapolationValue);
          return;
        }
        let sourceFracIndexCR = vec2<f32>(in_x,in_y);
        if(${this.methodId} == 1) {
          // Compute the four integer indices.
          let sourceFloorCR = vec2<i32>(sourceFracIndexCR);
          let sourceCeilCR = vec2<i32>(ceil(sourceFracIndexCR));
          let topLeft = getImage(bInd, sourceFloorCR.y, sourceFloorCR.x, d);
          let bottomLeft = getImage(bInd, sourceCeilCR.y, sourceFloorCR.x, d);
          let topRight = getImage(bInd, sourceFloorCR.y, sourceCeilCR.x, d);
          let bottomRight = getImage(bInd, sourceCeilCR.y, sourceCeilCR.x, d);
          let fracCR = sourceFracIndexCR - vec2<f32>(sourceFloorCR);
          let top = topLeft + (topRight - topLeft) * fracCR.x;
          let bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;
          let newValue = top + (bottom - top) * fracCR.y;
          setOutputAtIndex(index, newValue);
        } else {
          // Compute the coordinators of nearest neighbor point.
          let sourceNearestCR = vec2<i32>(floor(
            sourceFracIndexCR + vec2<f32>(0.5,0.5)));
          let newValue = getImage(
            bInd, sourceNearestCR.y, sourceNearestCR.x, d);
          setOutputAtIndex(index, newValue);
        }
      }
    }
    `;
        return userCode;
    }
}

});


parcelRegister("5Zq4J", function(module, exports) {

$parcel$export(module.exports, "cumprodConfig", () => $45c6e0431762dca1$export$db50d81ed60c5a35);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $1PfM1 = parcelRequire("1PfM1");

var $387AZ = parcelRequire("387AZ");
function $45c6e0431762dca1$export$dc7513e907e94b8d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $387AZ.cumImpl)((0, $1PfM1.CumOpType).Prod, x, backend, axis, exclusive, reverse);
}
const $45c6e0431762dca1$export$db50d81ed60c5a35 = {
    kernelName: (0, $hl418.Cumprod),
    backendName: 'webgpu',
    kernelFunc: $45c6e0431762dca1$export$dc7513e907e94b8d
};

});
parcelRegister("1PfM1", function(module, exports) {

$parcel$export(module.exports, "CumOpType", () => $1546ca26edf36261$export$5245168906ddd3d9);
$parcel$export(module.exports, "CumProgram", () => $1546ca26edf36261$export$6788a4605888e813);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
var $1546ca26edf36261$export$5245168906ddd3d9;
(function(CumOpType) {
    CumOpType["Prod"] = "*";
    CumOpType["Sum"] = "+";
})($1546ca26edf36261$export$5245168906ddd3d9 || ($1546ca26edf36261$export$5245168906ddd3d9 = {}));
class $1546ca26edf36261$export$6788a4605888e813 {
    constructor(op, shape, exclusive, reverse){
        this.variableNames = [
            'x'
        ];
        // pow(i32, i32) is not supported, use pow(f32, f32) instead.
        this.uniforms = 'index : f32,';
        this.size = true;
        this.workgroupSize = [
            128,
            1,
            1
        ];
        this.outputShape = shape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.exclusive = exclusive;
        this.reverse = reverse;
        this.op = op;
        this.shaderKey = `cum_${this.op}_${this.exclusive}_${this.reverse}`;
    }
    getUserCode() {
        const rank = this.outputShape.length;
        const initVal = this.op === $1546ca26edf36261$export$5245168906ddd3d9.Prod ? '1.0' : '0.0';
        const val = this.exclusive ? initVal : `getX(${$1546ca26edf36261$var$getCoords(rank, 'coords', this.op)})`;
        const length = this.outputShape[this.outputShape.length - 1];
        let condition = '';
        let idxString = '';
        // When exclusive is set, the cum op becomes roll op that copies the
        // value from the previous index based on the direction specified by the
        // reverse flag.
        if (this.exclusive) {
            condition = this.reverse ? `end != ${length - 1}` : 'end != 0';
            idxString = this.reverse ? 'end + 1' : 'end - 1';
        } else {
            condition = this.reverse ? `end + pow2 < ${length}` : 'end >= pow2';
            idxString = this.reverse ? 'end + pow2' : 'end - pow2';
        }
        return `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
       if (index < uniforms.size) {
         var coords = getCoordsFromIndex(index);

         let end = ${$1546ca26edf36261$var$getFinalCoord(rank, 'coords', this.op)};
         var val = ${val};
         let pow2 = i32(pow(2.0, uniforms.index));
         if (${condition}) {
           let idx = ${idxString};
           ${$1546ca26edf36261$var$getFinalCoord(rank, 'coords', this.op)} = idx;
           val ${this.op}= getX(${$1546ca26edf36261$var$getCoords(rank, 'coords', this.op)});
         }
         setOutputAtIndex(index, val);
       }
      }
    `;
    }
}
function $1546ca26edf36261$var$getCoords(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.x, ${name}.y`;
    else if (rank === 3) return `${name}.x, ${name}.y, ${name}.z`;
    else if (rank === 4) return `${name}.x, ${name}.y, ${name}.z, ${name}.w`;
    else throw Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}
function $1546ca26edf36261$var$getFinalCoord(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.y`;
    else if (rank === 3) return `${name}.z`;
    else if (rank === 4) return `${name}.w`;
    else throw Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}

});

parcelRegister("387AZ", function(module, exports) {

$parcel$export(module.exports, "cumImpl", () => $247802cb0456d4b5$export$88973bdd32b5a724);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");

var $1PfM1 = parcelRequire("1PfM1");

var $17o8l = parcelRequire("17o8l");

var $f9YmZ = parcelRequire("f9YmZ");
function $247802cb0456d4b5$export$88973bdd32b5a724(op, x, backend, axis, exclusive, reverse) {
    const xRank = x.shape.length;
    const permutation = (0, $7MaPk).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) permutedX = (0, $f9YmZ.transpose)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $7MaPk).getInnerMostAxes(1, xRank)[0];
    if (permutedAxis !== xRank - 1) throw new Error(`WebGPU cumprod shader expects an inner-most axis=${x.shape.length - 1} ` + `but got axis=${axis}`);
    const size = permutedX.shape[permutedAxis];
    let result = (0, $17o8l.identity)({
        inputs: {
            x: permutedX
        },
        backend: backend
    });
    // Use cum parallel algorithm, inspired by:
    // https://developer.nvidia.com/gpugems/gpugems3/part-vi-gpu-computing/chapter-39-parallel-prefix-sum-scan-cuda
    // Note: although the algorithm is called sum, it works for any associtative
    // operator with an identity.
    for(let i = 0; i <= Math.ceil(Math.log2(size)) - 1; i++){
        const program = new (0, $1PfM1.CumProgram)(op, permutedX.shape, false, reverse);
        const prevResult = result;
        const uniformData = [
            {
                type: 'float32',
                data: [
                    i
                ]
            }
        ];
        result = backend.runWebGPUProgram(program, [
            result
        ], result.dtype, uniformData);
        backend.disposeData(prevResult.dataId);
    }
    // For exclusive cum, shift the end result in the direction of product or sum
    // and add 1 for product or 0 for sum to the front index.
    if (exclusive) {
        const program = new (0, $1PfM1.CumProgram)(op, permutedX.shape, exclusive, reverse);
        const prevResult = result;
        const uniformData = [
            {
                type: 'float32',
                data: [
                    0
                ]
            }
        ];
        result = backend.runWebGPUProgram(program, [
            result
        ], result.dtype, uniformData);
        backend.disposeData(prevResult.dataId);
    }
    if (permutation != null) {
        const reversePermutation = (0, $7MaPk).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $f9YmZ.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeData(result.dataId);
        backend.disposeData(permutedX.dataId);
        return reverseTransposedResult;
    }
    return result;
}

});


parcelRegister("8EKrN", function(module, exports) {

$parcel$export(module.exports, "cumsumConfig", () => $64d6169b61b1ab57$export$2f6196f3316e7ed2);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $1PfM1 = parcelRequire("1PfM1");

var $387AZ = parcelRequire("387AZ");
function $64d6169b61b1ab57$export$71990b1e1c4912fe(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $387AZ.cumImpl)((0, $1PfM1.CumOpType).Sum, x, backend, axis, exclusive, reverse);
}
const $64d6169b61b1ab57$export$2f6196f3316e7ed2 = {
    kernelName: (0, $hl418.Cumsum),
    backendName: 'webgpu',
    kernelFunc: $64d6169b61b1ab57$export$71990b1e1c4912fe
};

});

parcelRegister("bYGZt", function(module, exports) {

$parcel$export(module.exports, "denseBincountConfig", () => $8b86a5506a04064f$export$88ba267b84334692);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $brQWm = parcelRequire("brQWm");

var $cFwkm = parcelRequire("cFwkm");
function $8b86a5506a04064f$export$436934e6cf1946f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size, binaryOutput: binaryOutput } = attrs;
    const xRankOne = x.shape.length === 1;
    const weightsSize = (0, $jjNRA).sizeFromShape(weights.shape);
    const hasWeights = weightsSize > 0;
    const dtype = weights.dtype;
    const xSize = xRankOne ? [
        x.shape[0]
    ] : [
        x.shape[0],
        x.shape[1]
    ];
    const outputSize = xRankOne ? [
        size
    ] : [
        x.shape[0],
        size
    ];
    const output = (0, $cFwkm.fill)({
        backend: backend,
        attrs: {
            shape: outputSize,
            value: 0,
            dtype: dtype
        }
    });
    const program = new (0, $brQWm.BincountProgram)(xSize, hasWeights, binaryOutput);
    const uniformData = [
        {
            type: 'int32',
            data: [
                size
            ]
        }
    ];
    const bincountInputs = hasWeights ? [
        x,
        weights
    ] : [
        x
    ];
    const res = backend.runWebGPUProgram(program, bincountInputs, dtype, uniformData, output);
    return res;
}
const $8b86a5506a04064f$export$88ba267b84334692 = {
    kernelName: (0, $hl418.DenseBincount),
    backendName: 'webgpu',
    kernelFunc: $8b86a5506a04064f$export$436934e6cf1946f1
};

});

parcelRegister("75tpS", function(module, exports) {

$parcel$export(module.exports, "depthToSpaceConfig", () => $528fd1817e25a214$export$9c5b88dcb1d2008b);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $Fr1IP = parcelRequire("Fr1IP");
function $528fd1817e25a214$export$3b50daec0f185f12(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockSize: blockSize, dataFormat: dataFormat } = attrs;
    const batchSize = x.shape[0];
    const inputHeight = dataFormat === 'NHWC' ? x.shape[1] : x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? x.shape[2] : x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? x.shape[3] : x.shape[1];
    const outputHeight = inputHeight * blockSize;
    const outputWidth = inputWidth * blockSize;
    const outputDepth = inputDepth / (blockSize * blockSize);
    const outputShape = dataFormat === 'NHWC' ? [
        batchSize,
        outputHeight,
        outputWidth,
        outputDepth
    ] : [
        batchSize,
        outputDepth,
        outputHeight,
        outputWidth
    ];
    const uniformData = [
        {
            type: 'int32',
            data: [
                blockSize
            ]
        }
    ];
    const program = new (0, $Fr1IP.DepthToSpaceProgram)(outputShape, dataFormat);
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
}
const $528fd1817e25a214$export$9c5b88dcb1d2008b = {
    kernelName: (0, $hl418.DepthToSpace),
    backendName: 'webgpu',
    kernelFunc: $528fd1817e25a214$export$3b50daec0f185f12
};

});
parcelRegister("Fr1IP", function(module, exports) {

$parcel$export(module.exports, "DepthToSpaceProgram", () => $07c8cb6799a24c82$export$eb07f17369165f28);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $07c8cb6799a24c82$export$eb07f17369165f28 {
    constructor(outputShape, dataFormat){
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.uniforms = 'blockSize : i32,';
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `depthToSpace_${dataFormat}`;
        this.dataFormat = dataFormat;
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let b = coords[0];
          let h = ${this.getHeightCoordString()};
          let w = ${this.getWidthCoordString()};
          let d = ${this.getDepthCoordString()};

          let in_h = h / uniforms.blockSize;
          let offset_h = h % uniforms.blockSize;
          let in_w = w / uniforms.blockSize;
          let offset_w = w % uniforms.blockSize;
          let offset_d = (offset_h * uniforms.blockSize + offset_w) *
            ${this.getOutputDepthSize()};
          let in_d = d + offset_d;

          let rlt = ${this.getInputSamplingString()};
          setOutputAtIndex(index, rlt);
        }
      }`;
        return userCode;
    }
    getHeightCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[1]`;
        else return `coords[2]`;
    }
    getWidthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[2]`;
        else return `coords[3]`;
    }
    getDepthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[3]`;
        else return `coords[1]`;
    }
    getOutputDepthSize() {
        if (this.dataFormat === 'NHWC') return `uniforms.outShape[3]`;
        else return `uniforms.outShape[1]`;
    }
    getInputSamplingString() {
        if (this.dataFormat === 'NHWC') return `getX(b, in_h, in_w, in_d)`;
        else return `getX(b, in_d, in_h, in_w)`;
    }
}

});


parcelRegister("emH1U", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeConfig", () => $a7547f9551ce8dc4$export$240667804b7c390e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $3rsVW = parcelRequire("3rsVW");

var $3Y3Qf = parcelRequire("3Y3Qf");

var $a50Md = parcelRequire("a50Md");
function $a7547f9551ce8dc4$export$14e793fe8822afd1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $7MaPk).convertConv2DDataFormat(dataFormat);
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    const convInfo = (0, $7MaPk).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true, $dataFormat);
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        }
    ];
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    let program;
    if (!isChannelsLast && convInfo.inHeight > 16 && convInfo.inWidth > 16 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && convInfo.dilationWidth === 1 && convInfo.dilationHeight === 1 && convInfo.inChannels === convInfo.outChannels) program = new (0, $3rsVW.DepthwiseConv2DNCHWSharedProgram)(convInfo.outShape, convInfo.filterHeight, convInfo.filterWidth);
    else if (isChannelsLast && convInfo.outHeight > 4 && convInfo.outWidth > 4 && convInfo.strideWidth <= 2 && convInfo.inChannels === convInfo.outChannels && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.inChannels % 4 === 0) {
        program = new (0, $3Y3Qf.DepthwiseConv2DVec4Program)(convInfo);
        dimensions.push({
            type: 'int32',
            data: [
                program.virtualWidth
            ]
        });
    } else {
        program = new (0, $a50Md.DepthwiseConv2DProgram)(convInfo);
        dimensions.push({
            type: 'int32',
            data: [
                convInfo.filterHeight
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.filterWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        });
    }
    return backend.runWebGPUProgram(program, [
        x,
        filter
    ], x.dtype, dimensions);
}
const $a7547f9551ce8dc4$export$240667804b7c390e = {
    kernelName: (0, $hl418.DepthwiseConv2dNative),
    backendName: 'webgpu',
    kernelFunc: $a7547f9551ce8dc4$export$14e793fe8822afd1
};

});
parcelRegister("3rsVW", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConv2DNCHWSharedProgram", () => $281a565312fa6482$export$c20669e15027e214);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7t2XD = parcelRequire("7t2XD");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $281a565312fa6482$export$c20669e15027e214 {
    constructor(outputShape, filterHeight, filterWidth, addBias = false, activation = null, hasPreluActivation = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = `pads : vec2<i32>, inDims : vec2<i32>,`;
        this.workgroupSize = [
            16,
            16,
            1
        ];
        this.outputShape = outputShape;
        this.dispatchLayout = {
            x: [
                3
            ],
            y: [
                2
            ],
            z: [
                0,
                1
            ]
        };
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivation = hasPreluActivation;
        this.filterHeight = filterHeight;
        this.filterWidth = filterWidth;
        this.shaderKey = `depthwiseNCHW_${this.activation}_${this.filterHeight}_${this.filterWidth}`;
    }
    getUserCode() {
        const filterSize = this.filterWidth * this.filterHeight;
        const flatWorkgroupSize = this.workgroupSize[0] * this.workgroupSize[1] * this.workgroupSize[2];
        const tileAHeight = this.workgroupSize[1] + this.filterHeight - 1;
        const tileAWidth = this.workgroupSize[0] + this.filterWidth - 1;
        const userCode = `
      ${(0, $7t2XD.activationFnSnippet)(this.activation, this.hasPreluActivation, false, 4)}

      var<workgroup> mm_Asub : array<array<f32, ${tileAWidth}>, ${tileAHeight}>;
      var<workgroup> mm_Bsub : array<array<f32, ${this.filterWidth}>, ${this.filterHeight}>;
      fn readX(batch : i32, channel : i32, row : i32, col : i32) -> f32 {
        var value = 0.0;
        if (row >=0 && row < uniforms.inDims[0] && col >=0 && col < uniforms.inDims[1])
        {
          value = getX(batch, channel, row, col);
        }
        return value;
      }

      ${(0, $oGQBh.getMainHeaderString)()} {
        let coords = getOutputCoords();
        let batch = coords[0];
        let xRCCorner = vec2<i32>(coords.zw) - uniforms.pads;
        let channelMul = uniforms.wShape[3];
        let d1 = coords[1] / channelMul;
        let q = coords[1] % channelMul;

        let inputRowStart = xRCCorner.x;
        let inputColStart = xRCCorner.y;

        let localRow = i32(localId.y);
        let localCol = i32(localId.x);

        // Load one tile of X into local memory.
        for (var inputRow = localRow; inputRow < ${tileAHeight}; inputRow = inputRow + ${this.workgroupSize[1]}) {
          for (var inputCol = localCol; inputCol < ${tileAWidth}; inputCol = inputCol + ${this.workgroupSize[0]}) {
            let rowOffset = inputRow - localRow;
            let colOffset = inputCol - localCol;
            mm_Asub[inputRow][inputCol] = readX(batch, d1, inputRowStart + rowOffset, inputColStart + colOffset);
          }
        }

        // Load one tile of W into local memory.
        var wIndex = i32(localIndex);
        ${filterSize < flatWorkgroupSize ? `if (wIndex < ${filterSize})` : `for(; wIndex < ${filterSize}; wIndex = wIndex + ${flatWorkgroupSize})`}

        {
          let wRow = wIndex / ${this.filterWidth};
          let wCol = wIndex % ${this.filterWidth};
          mm_Bsub[wRow][wCol] = getW(wRow, wCol, d1, q);
        }

        workgroupBarrier();

        var value = 0.0;
        for (var wR = 0; wR < ${this.filterHeight}; wR = wR + 1) {
          for (var wC = 0; wC < ${this.filterWidth}; wC = wC + 1) {
            let xVal = mm_Asub[localRow + wR][localCol + wC];
            let wVal = mm_Bsub[wR][wC];
            value = fma(xVal, wVal, value);
          }
        }
        ${(0, $7t2XD.biasActivationSnippet)(this.addBias, this.activation)}
        if (coordsInBounds4D(coords, uniforms.outShape)) {
          setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], value);
        }
      }
    `;
        return userCode;
    }
}

});

parcelRegister("3Y3Qf", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConv2DVec4Program", () => $2e39f493e3651bdc$export$6bf670667b9eeec7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");

var $7t2XD = parcelRequire("7t2XD");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $2e39f493e3651bdc$export$6bf670667b9eeec7 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = 'pads : vec2<i32>, inDims : vec2<i32>, virtualWidth : i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.workPerThread = 4;
        this.outputComponent = 4;
        this.outputShape = convInfo.outShape;
        this.virtualWidth = Math.ceil(this.outputShape[2] / this.workPerThread) * this.workPerThread;
        const virtualOutputShape = [
            this.outputShape[0],
            this.outputShape[1],
            this.virtualWidth,
            this.outputShape[3]
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(virtualOutputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, virtualOutputShape, this.workgroupSize, [
            this.outputComponent * this.workPerThread,
            1,
            1
        ]);
        (0, $jjNRA).assert(convInfo.dataFormat === 'channelsLast', ()=>'TODO: NCHW is unimplemented');
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        this.convInfo = convInfo;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivation = hasPreluActivation;
        this.shaderKey = `depthwiseVec4_${activation}_${this.convInfo.filterHeight}_${this.convInfo.filterWidth}_${this.convInfo.strideHeight}_${this.convInfo.strideWidth}_${this.workPerThread}`;
    }
    getUserCode() {
        const xNumber = (this.workPerThread - 1) * this.convInfo.strideWidth + this.convInfo.filterWidth;
        const strideHeight = this.convInfo.strideHeight;
        const strideWidth = this.convInfo.strideWidth;
        const userCode = `
      ${(0, $7t2XD.activationFnSnippet)(this.activation, this.hasPreluActivation, true, 4)}
      fn readX(batch : i32, row : i32, col : i32, channel : i32) -> vec4<f32> {
        var value = vec4<f32>(0.0);
        if (col >=0 && col < uniforms.inDims[1]) {
          value = getX(batch, row, col, channel);
        }
        return value;
      }

      ${(0, $oGQBh.getMainHeaderString)('index')} {
        let width0 = uniforms.outShape[3] / ${this.outputComponent};
        let d1 = (index % width0) * ${this.outputComponent};
        var index1 = index / width0;
        let width1 = uniforms.virtualWidth / ${this.workPerThread};
        let c = (index1 % width1) * ${this.workPerThread};
        index1 = index1 / width1;
        let r = index1 % uniforms.outShape[1];
        let batch = index1 / uniforms.outShape[1];

        let xRCCorner = vec2<i32>(r, c) * vec2<i32>(${strideHeight}, ${strideWidth}) - uniforms.pads;

        let xRCorner = xRCCorner.x;
        let xCCorner = xRCCorner.y;
        var xVals : array<vec4<f32>, ${xNumber}>;
        var dotProd : array<vec4<f32>, ${this.workPerThread}>;
        for (var i = 0; i < ${this.workPerThread}; i++) {
          dotProd[i] = vec4<f32>(0.0);
        }

        // Use constant instead of uniform can give better performance.
        for (var wR = 0; wR < ${this.convInfo.filterHeight}; wR = wR + 1) {
          let xR = xRCorner + wR;
          if (xR >=0 && xR < uniforms.inDims[0]) {
            for (var i = 0; i < ${xNumber}; i++) {
              xVals[i] = readX(batch, xR, xCCorner + i, d1);
            }
            for (var wC = 0; wC < ${this.convInfo.filterWidth}; wC = wC + 1) {
              let wValue = getW(wR, wC, d1, 0);
              for (var i = 0; i < ${this.workPerThread}; i++) {
                dotProd[i] = fma(xVals[i * ${strideWidth} + wC], wValue, dotProd[i]);
              }
            }
          }
        }

        for (var i = 0; i < ${this.workPerThread}; i = i + 1) {
          let coords = vec4<i32>(batch, r, c + i, d1);
          if (coordsInBounds4D(coords, uniforms.outShape)) {
            var value = dotProd[i];
            ${(0, $7t2XD.biasActivationSnippet)(this.addBias, this.activation)}
            setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], value);
          }
        }
      }
    `;
        return userCode;
    }
}

});

parcelRegister("a50Md", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConv2DProgram", () => $756af937b3edfe4c$export$4ead5a4ba22ede40);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7t2XD = parcelRequire("7t2XD");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $756af937b3edfe4c$export$4ead5a4ba22ede40 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.uniforms = `pads : vec2<i32>, inDims : vec2<i32>, filterHeight : i32,
      filterWidth : i32, strides : vec2<i32>, dilations : vec2<i32>,`;
        // This is an experimental value.
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.isChannelsLast = convInfo.dataFormat === 'channelsLast';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        this.convInfo = convInfo;
        this.addBias = addBias;
        this.activation = activation;
        this.hasPreluActivation = hasPreluActivation;
        this.shaderKey = `depthwise_${this.activation}_${this.isChannelsLast}`;
    }
    getUserCode() {
        const getXSnippet = this.isChannelsLast ? 'getX(batch, xR, xC, d1);' : 'getX(batch, d1, xR, xC);';
        const userCode = `
      ${(0, $7t2XD.activationFnSnippet)(this.activation, this.hasPreluActivation, false, 4)}

      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getOutputCoords();
          let batch = coords[0];
          let xRCCorner = vec2<i32>(coords.${this.isChannelsLast ? 'yz' : 'zw'}) * uniforms.strides - uniforms.pads;
          let d2 = coords[${this.isChannelsLast ? 3 : 1}];
          let channelMul = uniforms.wShape[3];
          let d1 = d2 / channelMul;
          let q = d2 % channelMul;

          let inputRowStart = xRCCorner.x;
          let inputColStart = xRCCorner.y;
          let inputRowEnd = inputRowStart + uniforms.filterHeight *
              uniforms.dilations[0];
          let inputColEnd = inputColStart + uniforms.filterWidth *
              uniforms.dilations[1];

          // Convolve x(?, ?, d1)|x(d1, ?, ?) with w(:, :, d1, q) to get
          // y(yR, yC, d2)|y(d2, yR, yC). ? = to be determined. : = across all
          // values in that axis. x(?, ?, d1) and y(yR, yC, d2) is for NHWC.
          // x(d1, ?, ?) and y(d2, yR, yC) is for NCHW.
          var value = 0.0;

          // Extract if checking out of for loop for performance.
          if (inputRowStart >= 0 && inputColStart >= 0 &&
            inputRowEnd < uniforms.inDims[0] &&
                inputColEnd < uniforms.inDims[1]) {
              for (var wR = 0; wR < uniforms.filterHeight; wR = wR + 1) {
                let xR = inputRowStart + wR * uniforms.dilations[0];

                for (var wC = 0; wC < uniforms.filterWidth; wC = wC + 1) {
                  let xC = inputColStart + wC * uniforms.dilations[1];

                  let xVal = ${getXSnippet};
                  let wVal = getW(wR, wC, d1, q);
                  value = value + xVal * wVal;
                }
              }
            } else {
              for (var wR = 0; wR < uniforms.filterHeight; wR = wR + 1) {
                let xR = inputRowStart + wR * uniforms.dilations[0];

                if (xR < 0 || xR >= uniforms.inDims[0]) {
                  continue;
                }

                for (var wC = 0; wC < uniforms.filterWidth; wC = wC + 1) {
                  let xC = inputColStart + wC * uniforms.dilations[1];

                  if (xC < 0 || xC >= uniforms.inDims[1]) {
                    continue;
                  }

                  let xVal = ${getXSnippet};
                  let wVal = getW(wR, wC, d1, q);
                  value = value + xVal * wVal;
                }
              }
            }
            ${(0, $7t2XD.biasActivationSnippet)(this.addBias, this.activation)}
          setOutputAtCoords(coords[0], coords[1], coords[2], coords[3], value);
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("KsDlA", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropFilterConfig", () => $08ba8208fbcf5209$export$30bc0ac3775583fc);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $coe83 = parcelRequire("coe83");
function $08ba8208fbcf5209$export$cc0ae65e9edc7e1a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const convInfo = (0, $7MaPk).computeConv2DInfo(x.shape, filterShape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $coe83.DepthwiseConv2DDerFilterProgram)(convInfo);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.batchSize
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outChannels / convInfo.inChannels
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        x,
        dy
    ], 'float32', uniformData);
}
const $08ba8208fbcf5209$export$30bc0ac3775583fc = {
    kernelName: (0, $hl418.DepthwiseConv2dNativeBackpropFilter),
    backendName: 'webgpu',
    kernelFunc: $08ba8208fbcf5209$export$cc0ae65e9edc7e1a
};

});
parcelRegister("coe83", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConv2DDerFilterProgram", () => $9052afa60dc94a5f$export$9f5b7866589daeae);
$parcel$export(module.exports, "DepthwiseConv2DDerInputProgram", () => $9052afa60dc94a5f$export$9b7e054f73b1374b);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $9052afa60dc94a5f$export$9f5b7866589daeae {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.uniforms = `strides : vec2<i32>, pads : vec2<i32>, filterDims : vec2<i32>, outHeight : i32,
      outWidth : i32, inHeight : i32, inWidth : i32, batchSize : i32, channelMul : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.filterShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `depthwise_conv2d_backprop_filter`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let wR = coords[0];
        let wC = coords[1];
        let d1 = coords[2];
        let dm = coords[3];
        let d2 = d1 * uniforms.channelMul + dm;

        var dotProd = 0.0;
        for (var b = 0; b < uniforms.batchSize; b++) {
          for (var yR = 0; yR < uniforms.outHeight; yR++) {
            let xR = wR + yR * uniforms.strides[0] - uniforms.pads[0];

            if (xR < 0 || xR >= uniforms.inHeight) {
              continue;
            }

            for (var yC = 0; yC < uniforms.outWidth; yC++) {
              let xC = wC + yC * uniforms.strides[1] - uniforms.pads[1];

              if (xC < 0 || xC >= uniforms.inWidth) {
                continue;
              }

              let dyValue = getDy(b, yR, yC, d2);
              let xValue = getX(b, xR, xC, d1);
              dotProd += xValue * dyValue;
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}
class $9052afa60dc94a5f$export$9b7e054f73b1374b {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.uniforms = `strides : vec2<i32>, pads : vec2<i32>, filterDims : vec2<i32>,
       outHeight : i32, outWidth : i32, channelMul : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `depthwise_conv2d_backprop_input`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords[0];
        let d1 = coords[3];
        let dyCorner = coords.yz - uniforms.pads;
        let dyRCorner = dyCorner.x;
        let dyCCorner = dyCorner.y;

        var dotProd = 0.0;
        for (var wR = 0; wR < uniforms.filterDims[0]; wR++) {
          let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[0]);

          if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
            continue;
          }

          let idyR = i32(dyR);
          let wRPerm = uniforms.filterDims[0] - 1 - wR;

          for (var wC = 0; wC < uniforms.filterDims[1]; wC++) {
            let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[1]);

            if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
              continue;
            }

            let idyC = i32(dyC);
            let wCPerm = uniforms.filterDims[1] - 1 - wC;

            for (var dm = 0; dm < uniforms.channelMul; dm++) {
              let d2 = d1 * uniforms.channelMul + dm;
              let xValue = getDy(batch, idyR, idyC, d2);
              let wValue = getW(wRPerm, wCPerm, d1, dm);
              dotProd += xValue * wValue;
            }
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}

});


parcelRegister("6Vc6c", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropInputConfig", () => $50a1738b7e03c658$export$55d12409e744bebe);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $coe83 = parcelRequire("coe83");
function $50a1738b7e03c658$export$37e2ab95a4a4c24b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, inputShape: inputShape } = attrs;
    const convInfo = (0, $7MaPk).computeConv2DInfo(inputShape, filter.shape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $coe83.DepthwiseConv2DDerInputProgram)(convInfo);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.filterHeight - 1 - convInfo.padInfo.top,
                convInfo.filterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outChannels / convInfo.inChannels
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy,
        filter
    ], dy.dtype, uniformData);
}
const $50a1738b7e03c658$export$55d12409e744bebe = {
    kernelName: (0, $hl418.DepthwiseConv2dNativeBackpropInput),
    backendName: 'webgpu',
    kernelFunc: $50a1738b7e03c658$export$37e2ab95a4a4c24b
};

});

parcelRegister("1u97N", function(module, exports) {

$parcel$export(module.exports, "diagConfig", () => $114fabca0e42d597$export$56dc5d812a22748f);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $bNHfY = parcelRequire("bNHfY");

var $gj4T5 = parcelRequire("gj4T5");
function $114fabca0e42d597$export$c042e7c2f59bc046(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const outShape = [
        ...x.shape,
        ...x.shape
    ];
    const xSize = (0, $jjNRA).sizeFromShape(x.shape);
    const flat = (0, $gj4T5.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                xSize
            ]
        }
    });
    const program = new (0, $bNHfY.DiagProgram)(xSize);
    const res = backend.runWebGPUProgram(program, [
        flat
    ], flat.dtype);
    const out = (0, $gj4T5.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeData(flat.dataId);
    backend.disposeData(res.dataId);
    return out;
}
const $114fabca0e42d597$export$56dc5d812a22748f = {
    kernelName: (0, $hl418.Diag),
    backendName: 'webgpu',
    kernelFunc: $114fabca0e42d597$export$c042e7c2f59bc046
};

});
parcelRegister("bNHfY", function(module, exports) {

$parcel$export(module.exports, "DiagProgram", () => $8975d32dfe852eff$export$d3d3824ae4245092);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $8975d32dfe852eff$export$d3d3824ae4245092 {
    constructor(size){
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            size,
            size
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'diag';
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getOutputCoords();
          let value = select(0.0, getX(coords[0]), coords[0] == coords[1]);
          setOutputAtIndex(index, value);
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("jZCQ0", function(module, exports) {

$parcel$export(module.exports, "dilation2DConfig", () => $e8e1d7392ac8fb79$export$36d3c11f61a8891a);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $7bmyi = parcelRequire("7bmyi");
function $e8e1d7392ac8fb79$export$544ec6096a7ab30(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $7MaPk).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
    const padInfo = [
        convInfo.padInfo.top,
        convInfo.padInfo.left
    ];
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                ...padInfo
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        }
    ];
    const program = new (0, $7bmyi.Dilation2DProgram)(convInfo);
    const out = backend.runWebGPUProgram(program, [
        x,
        filter
    ], x.dtype, uniformData);
    return out;
}
const $e8e1d7392ac8fb79$export$36d3c11f61a8891a = {
    kernelName: (0, $hl418.Dilation2D),
    backendName: 'webgpu',
    kernelFunc: $e8e1d7392ac8fb79$export$544ec6096a7ab30
};

});
parcelRegister("7bmyi", function(module, exports) {

$parcel$export(module.exports, "Dilation2DProgram", () => $53ab0de1b63af9f4$export$b3acfd0493b4c03e);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $53ab0de1b63af9f4$export$b3acfd0493b4c03e {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'w'
        ];
        this.uniforms = 'filterDims: vec2<i32>, pads: vec2<i32>, strides: vec2<i32>, dilations: vec2<i32>';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.outShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'dilation2d';
    }
    getUserCode() {
        const userCode = `
       ${(0, $oGQBh.getMainHeaderString)('index')} {
         if (index < uniforms.size) {
           let neg_infinity = -3.4e38;
           let coords = getOutputCoords();
           let batch = coords.x;
           let d1 = coords.w;
           let outTopLeftCorner = coords.yz * uniforms.strides - uniforms.pads;
           let hBeg = outTopLeftCorner.x;
           let wBeg = outTopLeftCorner.y;

           var curVal = neg_infinity;
           for (var h = 0; h < uniforms.filterDims[0]; h = h + 1) {
             let hIn = hBeg + h * uniforms.dilations[0];

             if (hIn >= 0 && hIn < uniforms.xShape[1]) {
               for (var w = 0; w < uniforms.filterDims[1]; w = w + 1) {
                 let wIn = wBeg + w * uniforms.dilations[1];

                 if (wIn >= 0 && wIn < uniforms.xShape[2]) {
                   let val = getX(batch, hIn, wIn, d1) + getW(h, w, d1);
                   if (val > curVal) {
                     curVal = val;
                   }
                 }
               }
             }
           }

           setOutputAtIndex(index, curVal);
         }
       }
     `;
        return userCode;
    }
}

});


parcelRegister("dyuo6", function(module, exports) {

$parcel$export(module.exports, "dilation2DBackpropFilterConfig", () => $9de605b92581b090$export$cf83abe0e8c87ce8);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $leSHp = parcelRequire("leSHp");

var $cFwkm = parcelRequire("cFwkm");
function $9de605b92581b090$export$5ccd66c3b92fb998(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, dy: dy } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $7MaPk).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
    const dtype = filter.dtype;
    const program = new (0, $leSHp.Dilation2DBackpropFilterProgram)(convInfo, filter.shape, dtype);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                (0, $jjNRA).sizeFromShape(convInfo.outShape)
            ]
        }
    ];
    const output = (0, $cFwkm.fill)({
        backend: backend,
        attrs: {
            shape: filter.shape,
            value: 0,
            dtype: dtype
        }
    });
    return backend.runWebGPUProgram(program, [
        x,
        filter,
        dy
    ], dtype, uniformData, output);
}
const $9de605b92581b090$export$cf83abe0e8c87ce8 = {
    kernelName: (0, $hl418.Dilation2DBackpropFilter),
    backendName: 'webgpu',
    kernelFunc: $9de605b92581b090$export$5ccd66c3b92fb998
};

});
parcelRegister("leSHp", function(module, exports) {

$parcel$export(module.exports, "Dilation2DBackpropInputProgram", () => $f76555e2f8e8ae3e$export$590f943d037e2e09);
$parcel$export(module.exports, "Dilation2DBackpropFilterProgram", () => $f76555e2f8e8ae3e$export$b593d838ca648ee3);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $arOgS = parcelRequire("arOgS");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $f76555e2f8e8ae3e$export$590f943d037e2e09 {
    constructor(convInfo, outputDtype){
        this.variableNames = [
            'x',
            'w',
            'dy'
        ];
        this.uniforms = 'filterDims: vec2<i32>, pads: vec2<i32>, strides: vec2<i32>, dilations: vec2<i32>, dySize: i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(convInfo.outShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, convInfo.outShape, this.workgroupSize);
        if (outputDtype !== 'float32' && outputDtype !== 'int32') throw new Error(`Dilation2DBackpropInput only supports float32 and int32
          types, does not support ${outputDtype} type.`);
        this.type = outputDtype;
        this.shaderKey = 'dilation2DBackpropInput';
    }
    getUserCode() {
        // This implementation follows the TF c++ cuda implementation:
        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/dilation_ops_gpu.cu.cc
        const userCode = `
       ${(0, $oGQBh.getMainHeaderString)('index')} {
         if (index < uniforms.dySize) {
           let coords = getDyCoordsFromIndex(index);
           let b = coords[0];
           let r = coords[1];
           let c = coords[2];
           let d = coords[3];

           let dyCorner = vec2<i32>(r, c) * uniforms.strides - uniforms.pads;
           var curVal = -3.4e38;  // neg_infinity
           var xRMax = 0;
           var xCMax = 0;

           // In the case of multiple argmax branches, we only back-propagate
           // along the last branch, i.e., the one with largest value of
           // 'wR * uniforms.filterDims[1] + wC', similarly to the max-pooling
           // backward routines.
           for (var wR = 0; wR < uniforms.filterDims[0]; wR++) {
             let xR = dyCorner.x + wR * uniforms.dilations[0];

             if (xR >= 0 && xR < uniforms.xShape[1]) {
               for (var wC = 0; wC < uniforms.filterDims[1]; wC++) {
                 let xC = dyCorner.y + wC * uniforms.dilations[1];

                 if (xC >= 0 && xC < uniforms.xShape[2]) {
                   let val = getX(b, xR, xC, d) + getW(wR, wC, d);
                   if (val > curVal) {
                     curVal = val;
                     xRMax = xR;
                     xCMax = xC;
                   }
                 }
               }
             }
           }

           let flatIndexIn = d + uniforms.xShape[3] *
               (xCMax + uniforms.xShape[2] * (xRMax + uniforms.xShape[1] * b));
           let value = getDy(b, r, c, d);
           ${(0, $arOgS.atomicAddSnippet)('&result[flatIndexIn]', 'value', this.type)}
         }
       }
     `;
        return userCode;
    }
}
class $f76555e2f8e8ae3e$export$b593d838ca648ee3 {
    constructor(convInfo, shape, outputDtype){
        this.variableNames = [
            'x',
            'w',
            'dy'
        ];
        this.uniforms = 'filterDims: vec2<i32>, pads: vec2<i32>, strides: vec2<i32>, dilations: vec2<i32>, dySize: i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = convInfo.filterShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(convInfo.outShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, convInfo.outShape, this.workgroupSize);
        if (outputDtype !== 'float32' && outputDtype !== 'int32') throw new Error(`Dilation2DBackpropFilter only supports float32 and int32
          types, does not support ${outputDtype} type.`);
        this.type = outputDtype;
        this.shaderKey = 'dilation2DBackpropFilter';
    }
    getUserCode() {
        // This implementation follows the TF c++ cuda implementation:
        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/dilation_ops_gpu.cu.cc
        const userCode = `
       ${(0, $oGQBh.getMainHeaderString)('index')} {
         if (index < uniforms.dySize) {
           let coords = getDyCoordsFromIndex(index);
           let b = coords[0];
           let r = coords[1];
           let c = coords[2];
           let d = coords[3];

           let dyCorner = vec2<i32>(r, c) * uniforms.strides - uniforms.pads;
           var curVal = -3.4e38;  // neg_infinity
           var wRMax = 0;
           var wCMax = 0;

           // In the case of multiple argmax branches, we only back-propagate
           // along the last branch, i.e., the one with largest value of
           // 'wR * uniforms.filterDims[1] + wC', similarly to the max-pooling
           // backward routines.
           for (var wR = 0; wR < uniforms.filterDims[0]; wR++) {
             let xR = dyCorner.x + wR * uniforms.dilations[0];

             if (xR >= 0 && xR < uniforms.xShape[1]) {
               for (var wC = 0; wC < uniforms.filterDims[1]; wC++) {
                 let xC = dyCorner.y + wC * uniforms.dilations[1];

                 if (xC >= 0 && xC < uniforms.xShape[2]) {
                   let val = getX(b, xR, xC, d) + getW(wR, wC, d);
                   if (val > curVal) {
                     curVal = val;
                     wRMax = wR;
                     wCMax = wC;
                   }
                 }
               }
             }
           }

           let flatIndexIn = d + uniforms.wShape[2] * (wCMax + wRMax * uniforms.wShape[1]);
           let value = getDy(b, r, c, d);
           ${(0, $arOgS.atomicAddSnippet)('&result[flatIndexIn]', 'value', this.type)}
         }
       }
     `;
        return userCode;
    }
}

});


parcelRegister("ceC11", function(module, exports) {

$parcel$export(module.exports, "dilation2DBackpropInputConfig", () => $8e8447ef6e2e2414$export$42e4451417dc5ea0);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $leSHp = parcelRequire("leSHp");

var $cFwkm = parcelRequire("cFwkm");
function $8e8447ef6e2e2414$export$7fbe49a07e48139e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, dy: dy } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $7MaPk).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
    const dtype = x.dtype;
    const program = new (0, $leSHp.Dilation2DBackpropInputProgram)(convInfo, dtype);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.filterHeight,
                convInfo.filterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                (0, $jjNRA).sizeFromShape(convInfo.outShape)
            ]
        }
    ];
    const output = (0, $cFwkm.fill)({
        backend: backend,
        attrs: {
            shape: convInfo.inShape,
            value: 0,
            dtype: dtype
        }
    });
    return backend.runWebGPUProgram(program, [
        x,
        filter,
        dy
    ], dtype, uniformData, output);
}
const $8e8447ef6e2e2414$export$42e4451417dc5ea0 = {
    kernelName: (0, $hl418.Dilation2DBackpropInput),
    backendName: 'webgpu',
    kernelFunc: $8e8447ef6e2e2414$export$7fbe49a07e48139e
};

});

parcelRegister("9AFtF", function(module, exports) {

$parcel$export(module.exports, "drawConfig", () => $6fb7a66cbde6a09b$export$917213cafa72964b);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use backend file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $gVE3R = parcelRequire("gVE3R");
function $6fb7a66cbde6a09b$export$e529deb2bfd496dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image } = inputs;
    const { canvas: canvas, options: options } = attrs;
    const [height, width] = image.shape.slice(0, 2);
    const { imageOptions: imageOptions } = options || {};
    const alpha = (imageOptions === null || imageOptions === void 0 ? void 0 : imageOptions.alpha) || 1;
    //  'rgba8unorm' should work on macOS according to
    //  https://bugs.chromium.org/p/chromium/issues/detail?id=1298618. But
    //  failed on macOS/M2. So use 'bgra8unorm' first when available.
    const format = backend.device.features.has('bgra8unorm-storage') ? 'bgra8unorm' : 'rgba8unorm';
    const outShape = [
        height,
        width
    ];
    const program = new (0, $gVE3R.DrawProgram)(outShape, image.dtype, format);
    canvas.width = width;
    canvas.height = height;
    const backendName = 'webgpu';
    let gpuContext = canvas.getContext(backendName);
    let canvasWebGPU;
    if (!gpuContext) {
        canvasWebGPU = new OffscreenCanvas(width, height);
        gpuContext = canvasWebGPU.getContext(backendName);
    }
    const numChannels = image.shape.length === 3 ? image.shape[2] : 1;
    gpuContext.configure({
        device: backend.device,
        format: format,
        usage: GPUTextureUsage.STORAGE_BINDING,
        alphaMode: 'premultiplied'
    });
    const outputDtype = 'int32';
    const output = backend.makeTensorInfo(outShape, outputDtype);
    const info = backend.tensorMap.get(output.dataId);
    info.resource = gpuContext.getCurrentTexture();
    info.external = true;
    const uniformData = [
        {
            type: 'uint32',
            data: [
                numChannels
            ]
        },
        {
            type: 'float32',
            data: [
                alpha
            ]
        }
    ];
    backend.runWebGPUProgram(program, [
        image
    ], outputDtype, uniformData, output);
    if (canvasWebGPU) {
        const canvas2dContext = canvas.getContext('2d');
        if (!canvas2dContext) throw new Error(`Please make sure this canvas has only been used for 2d or webgpu context!`);
        canvas2dContext.drawImage(canvasWebGPU, 0, 0);
    }
    backend.disposeData(output.dataId);
    return image;
}
const $6fb7a66cbde6a09b$export$917213cafa72964b = {
    kernelName: (0, $hl418.Draw),
    backendName: 'webgpu',
    kernelFunc: $6fb7a66cbde6a09b$export$e529deb2bfd496dc
};

});
parcelRegister("gVE3R", function(module, exports) {

$parcel$export(module.exports, "DrawProgram", () => $c5310b87585c3ae0$export$85a6e8018f8156c);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $c5310b87585c3ae0$export$85a6e8018f8156c {
    constructor(outShape, type, textureFormat){
        this.variableNames = [
            'Image'
        ];
        this.uniforms = 'alpha: f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.pixelsOpType = (0, $oGQBh.PixelsOpType).DRAW;
        this.size = true;
        this.outputShape = outShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.type = type;
        this.textureFormat = textureFormat;
        this.shaderKey = `draw_${type}_${textureFormat}`;
    }
    getUserCode() {
        let calculateResult;
        const value = this.type === 'float32' ? 'value' : 'value / 255.0';
        calculateResult = `
      if (uniforms.numChannels == 1) {
        rgba[0] = ${value};
        rgba[1] = ${value};
        rgba[2] = ${value};
      } else {
        rgba[d] = ${value};
      }`;
        const userCode = `
       @group(0) @binding(0) var outImage : texture_storage_2d<${this.textureFormat}, write>;
       ${(0, $oGQBh.getMainHeaderString)('index')} {
         if (index < uniforms.size) {
           var rgba = vec4<f32>(0.0, 0.0, 0.0, uniforms.alpha);
           for (var d = 0; d < uniforms.numChannels; d = d + 1) {
             let value = f32(inBuf[index * uniforms.numChannels + d]);
             ${calculateResult}
           }
           rgba.x = rgba.x * rgba.w;
           rgba.y = rgba.y * rgba.w;
           rgba.z = rgba.z * rgba.w;
           let coords = getCoordsFromIndex(index);
           textureStore(outImage, vec2<i32>(coords.yx), rgba);
         }
       }
      `;
        return userCode;
    }
}

});


parcelRegister("5Sa2q", function(module, exports) {

$parcel$export(module.exports, "einsumConfig", () => $4469c83bcd4a2ddb$export$40bbf341885a23b7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $19OU2 = parcelRequire("19OU2");

var $gj4T5 = parcelRequire("gj4T5");

var $6CMjm = parcelRequire("6CMjm");

var $f9YmZ = parcelRequire("f9YmZ");
function $4469c83bcd4a2ddb$export$27265e7daac5c403(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { equation: equation } = attrs;
    const tensors = inputs;
    const { allDims: allDims, summedDims: summedDims, idDims: idDims } = (0, $7MaPk).decodeEinsumEquation(equation, tensors.length);
    (0, $7MaPk).checkEinsumDimSizes(allDims.length, idDims, tensors);
    const { path: path, steps: steps } = (0, $7MaPk).getEinsumComputePath(summedDims, idDims);
    const nSteps = steps.length;
    let out = null;
    let numDimsRemaining = allDims.length;
    const tensorsToDispose = [];
    for(let i = 0; i < nSteps; ++i){
        for (const idTerm of steps[i]){
            const { permutationIndices: perm, expandDims: dimsToExpand } = (0, $7MaPk).getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
            let x;
            if ((0, $7MaPk).isIdentityPermutation(perm)) x = tensors[idTerm];
            else {
                x = (0, $f9YmZ.transpose)({
                    inputs: {
                        x: tensors[idTerm]
                    },
                    backend: backend,
                    attrs: {
                        perm: perm
                    }
                });
                tensorsToDispose.push(x);
            }
            const targetShape = x.shape.slice();
            for(let k = 0; k < dimsToExpand.length; ++k)targetShape.splice(dimsToExpand[k], 0, 1);
            if (!(0, $jjNRA).arraysEqual(x.shape, targetShape)) {
                x = (0, $gj4T5.reshape)({
                    inputs: {
                        x: x
                    },
                    backend: backend,
                    attrs: {
                        shape: targetShape
                    }
                });
                tensorsToDispose.push(x);
            }
            if (out === null) out = x;
            else {
                // tslint:disable-next-line: no-unnecessary-type-assertion
                out = (0, $19OU2.multiplyKernelFunc)({
                    inputs: {
                        a: x,
                        b: out
                    },
                    backend: backend
                });
                tensorsToDispose.push(out);
            }
        }
        if (i < nSteps - 1) {
            if (path[i] >= 0) {
                out = (0, $6CMjm.sum)({
                    inputs: {
                        x: out
                    },
                    backend: backend,
                    attrs: {
                        axis: path[i] - (allDims.length - numDimsRemaining),
                        keepDims: false
                    }
                });
                tensorsToDispose.push(out);
            }
            numDimsRemaining--;
        }
    }
    // Clean up intermediate tensors.
    for (const tensorInfo of tensorsToDispose){
        if (tensorInfo === out) continue;
        backend.disposeData(tensorInfo.dataId);
    }
    return out;
}
const $4469c83bcd4a2ddb$export$40bbf341885a23b7 = {
    kernelName: (0, $hl418.Einsum),
    backendName: 'webgpu',
    kernelFunc: $4469c83bcd4a2ddb$export$27265e7daac5c403
};

});
parcelRegister("19OU2", function(module, exports) {

$parcel$export(module.exports, "multiplyKernelFunc", () => $0d7e1df0fbb46353$export$813063b94243a885);
$parcel$export(module.exports, "multiplyConfig", () => $0d7e1df0fbb46353$export$745576778aafee88);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $0d7e1df0fbb46353$export$813063b94243a885 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).MUL,
    cpuKernelImpl: (0, $aLZc7.multiplyImplCPU),
    supportsComplex: true
});
const $0d7e1df0fbb46353$export$745576778aafee88 = {
    kernelName: (0, $hl418.Multiply),
    backendName: 'webgpu',
    kernelFunc: $0d7e1df0fbb46353$export$813063b94243a885
};

});

parcelRegister("6CMjm", function(module, exports) {

$parcel$export(module.exports, "sum", () => $4d2bc4497d766fd2$export$8a63f25cc62965f1);
$parcel$export(module.exports, "sumConfig", () => $4d2bc4497d766fd2$export$47edea402251c258);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $qiVpd = parcelRequire("qiVpd");
function $4d2bc4497d766fd2$export$8a63f25cc62965f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    return (0, $qiVpd.reduce)(x, axis, keepDims, 'sum', backend);
}
const $4d2bc4497d766fd2$export$47edea402251c258 = {
    kernelName: (0, $hl418.Sum),
    backendName: 'webgpu',
    kernelFunc: $4d2bc4497d766fd2$export$8a63f25cc62965f1
};

});


parcelRegister("hdOid", function(module, exports) {

$parcel$export(module.exports, "eluConfig", () => $c89aa9a9cd4e4e03$export$b990686634ee3cce);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $c89aa9a9cd4e4e03$export$796b583dd79d8524 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).ELU
});
const $c89aa9a9cd4e4e03$export$b990686634ee3cce = {
    kernelName: (0, $hl418.Elu),
    backendName: 'webgpu',
    kernelFunc: $c89aa9a9cd4e4e03$export$796b583dd79d8524
};

});

parcelRegister("708SQ", function(module, exports) {

$parcel$export(module.exports, "eluGradConfig", () => $518f6c9a138f30a5$export$59bb07dd04647a1d);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $25rfU = parcelRequire("25rfU");
const $518f6c9a138f30a5$export$a346244024505ff9 = (args)=>{
    const { inputs: inputs, backend: backend } = args;
    const { dy: dy, y: y } = inputs;
    const program = new (0, $25rfU.BinaryOpProgram)((0, $jJAz1.BinaryOpType).ELU_DER, dy.shape, y.shape);
    return backend.runWebGPUProgram(program, [
        dy,
        y
    ], dy.dtype);
};
const $518f6c9a138f30a5$export$59bb07dd04647a1d = {
    kernelName: (0, $hl418.EluGrad),
    backendName: 'webgpu',
    kernelFunc: $518f6c9a138f30a5$export$a346244024505ff9
};

});

parcelRegister("aGE3x", function(module, exports) {

$parcel$export(module.exports, "equalConfig", () => $7c7ce5eec7b1d2d5$export$3c8bc3d8ee318217);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $7c7ce5eec7b1d2d5$export$411ce8e5a71e3069 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $aLZc7.equalImplCPU)
});
const $7c7ce5eec7b1d2d5$export$3c8bc3d8ee318217 = {
    kernelName: (0, $hl418.Equal),
    backendName: 'webgpu',
    kernelFunc: $7c7ce5eec7b1d2d5$export$411ce8e5a71e3069
};

});

parcelRegister("gJoRs", function(module, exports) {

$parcel$export(module.exports, "erfConfig", () => $c2e4223d2d34a4e5$export$d044ffef16079bd);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $c2e4223d2d34a4e5$export$d3896f355fc09423 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).ERF
});
const $c2e4223d2d34a4e5$export$d044ffef16079bd = {
    kernelName: (0, $hl418.Erf),
    backendName: 'webgpu',
    kernelFunc: $c2e4223d2d34a4e5$export$d3896f355fc09423
};

});

parcelRegister("a9fYB", function(module, exports) {

$parcel$export(module.exports, "expConfig", () => $7637233e3d872648$export$2fd7ea0fcf021f34);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $7637233e3d872648$export$b310ec824aaee37f = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).EXP,
    cpuKernelImpl: (0, $aLZc7.expImplCPU),
    dtype: 'float32'
});
const $7637233e3d872648$export$2fd7ea0fcf021f34 = {
    kernelName: (0, $hl418.Exp),
    backendName: 'webgpu',
    kernelFunc: $7637233e3d872648$export$b310ec824aaee37f
};

});

parcelRegister("5N59B", function(module, exports) {

$parcel$export(module.exports, "expandDims", () => $437586d3b235740e$export$d660d8ed21f46635);
$parcel$export(module.exports, "expandDimsConfig", () => $437586d3b235740e$export$86341ba0ce5d8e60);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $gj4T5 = parcelRequire("gj4T5");
function $437586d3b235740e$export$d660d8ed21f46635(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { dim: dim } = attrs;
    const { input: input } = inputs;
    const inputRank = input.shape.length;
    const newShape = input.shape.slice();
    let $dim = dim;
    if (dim < 0) {
        // Negative value is counted from the tail of rank.
        (0, $jjNRA).assert(-(inputRank + 1) <= dim, ()=>`Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
        $dim = inputRank + dim + 1;
    }
    newShape.splice($dim, 0, 1);
    return (0, $gj4T5.reshape)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: newShape
        }
    });
}
const $437586d3b235740e$export$86341ba0ce5d8e60 = {
    kernelName: (0, $hl418.ExpandDims),
    backendName: 'webgpu',
    kernelFunc: $437586d3b235740e$export$d660d8ed21f46635
};

});

parcelRegister("5Xa36", function(module, exports) {

$parcel$export(module.exports, "expm1Config", () => $455a41f95a6b8b91$export$16db8a08b36f938);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $455a41f95a6b8b91$export$b6c0a80d46d3391d = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).EXPM1,
    cpuKernelImpl: (0, $aLZc7.expm1ImplCPU)
});
const $455a41f95a6b8b91$export$16db8a08b36f938 = {
    kernelName: (0, $hl418.Expm1),
    backendName: 'webgpu',
    kernelFunc: $455a41f95a6b8b91$export$b6c0a80d46d3391d
};

});

parcelRegister("5j54h", function(module, exports) {

$parcel$export(module.exports, "fftConfig", () => $3dd2a8853ac20e45$export$a4d564e380763c78);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $3GdZ3 = parcelRequire("3GdZ3");
function $3dd2a8853ac20e45$export$a535ef183b6128fa(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $3GdZ3.fftImpl)(input, false, backend);
}
const $3dd2a8853ac20e45$export$a4d564e380763c78 = {
    kernelName: (0, $hl418.FFT),
    backendName: 'webgpu',
    kernelFunc: $3dd2a8853ac20e45$export$a535ef183b6128fa
};

});
parcelRegister("3GdZ3", function(module, exports) {

$parcel$export(module.exports, "fftImpl", () => $2ae02436b38dacba$export$75d3742a7578721e);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");

var $i1yUH = parcelRequire("i1yUH");

var $lbBov = parcelRequire("lbBov");

var $gj4T5 = parcelRequire("gj4T5");
function $2ae02436b38dacba$export$75d3742a7578721e(x, inverse, backend) {
    const xData = backend.tensorMap.get(x.dataId);
    const inputSize = (0, $jjNRA).sizeFromShape(x.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = x.shape[x.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const toDispose = [];
    const input2D = (0, $gj4T5.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    toDispose.push(input2D);
    const xShape = input2D.shape;
    const realProgram = new (0, $i1yUH.FFTProgram)('real', xShape);
    const imagProgram = new (0, $i1yUH.FFTProgram)('imag', xShape);
    const inputs = [
        {
            dataId: xData.complexTensorInfos.real.dataId,
            dtype: xData.complexTensorInfos.real.dtype,
            shape: xShape
        },
        {
            dataId: xData.complexTensorInfos.imag.dataId,
            dtype: xData.complexTensorInfos.imag.dtype,
            shape: xShape
        }
    ];
    const exponentMultiplier = inverse ? 2.0 * Math.PI : -2 * Math.PI;
    const denominator = inverse ? xShape[1] : 1.0;
    const uniformData = [
        {
            type: 'float32',
            data: [
                exponentMultiplier
            ]
        },
        {
            type: 'float32',
            data: [
                denominator
            ]
        }
    ];
    const realPart = backend.runWebGPUProgram(realProgram, inputs, 'float32', uniformData);
    toDispose.push(realPart);
    const imagPart = backend.runWebGPUProgram(imagProgram, inputs, 'float32', uniformData);
    toDispose.push(imagPart);
    const complexOutput = (0, $lbBov.complex)({
        inputs: {
            real: realPart,
            imag: imagPart
        },
        backend: backend
    });
    toDispose.push(complexOutput);
    const complexOutputReshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: complexOutput
        },
        backend: backend,
        attrs: {
            shape: x.shape
        }
    });
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return complexOutputReshaped;
}

});
parcelRegister("i1yUH", function(module, exports) {

$parcel$export(module.exports, "FFTProgram", () => $d1f367164bce1b17$export$234ba885e3a114f6);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $d1f367164bce1b17$export$234ba885e3a114f6 {
    constructor(component, shape){
        this.variableNames = [
            'real',
            'imag'
        ];
        this.outputShape = [];
        this.uniforms = 'exponentMultiplier : f32, denominator: f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.component = component;
        this.shaderKey = `fft_${component}`;
    }
    getUserCode() {
        const opString = this.component === 'real' ? 'return real * expR - imag * expI;' : 'return real * expI + imag * expR;';
        const userCode = `
    fn unaryOpComplex(real: f32, expR: f32, imag: f32, expI: f32) -> f32 {
      ${opString}
    }

    fn mulMatDFT(batch: i32, index: i32) -> f32 {
      let indexRatio = f32(index) / f32(uniforms.realShape[1]);
      let exponentMultiplierTimesIndexRatio =
          uniforms.exponentMultiplier * indexRatio;

      var result = 0.0;

      for (var i = 0; i < uniforms.realShape[1]; i = i + 1) {
        // x = (-2|2 * PI / N) * index * i;
        let x = exponentMultiplierTimesIndexRatio * f32(i);
        let expR = cos(x);
        let expI = sin(x);
        let real = getReal(batch, i);
        let imag = getImag(batch, i);

        result = result +
            unaryOpComplex(real, expR, imag, expI) / uniforms.denominator;
      }

      return result;
    }

    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getOutputCoords();
        setOutputAtIndex(index, mulMatDFT(coords[0], coords[1]));
      }
    }
  `;
        return userCode;
    }
}

});



parcelRegister("56gjc", function(module, exports) {

$parcel$export(module.exports, "flipLeftRightConfig", () => $3b6a29d4610ef648$export$c9ec83cb23304466);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $7jGKK = parcelRequire("7jGKK");
const $3b6a29d4610ef648$export$c9ec83cb23304466 = {
    kernelName: (0, $hl418.FlipLeftRight),
    backendName: 'webgpu',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { image: image } = inputs;
        const webgpuBackend = backend;
        const program = new (0, $7jGKK.FlipLeftRightProgram)(image.shape);
        const output = webgpuBackend.runWebGPUProgram(program, [
            image
        ], image.dtype);
        return output;
    }
};

});
parcelRegister("7jGKK", function(module, exports) {

$parcel$export(module.exports, "FlipLeftRightProgram", () => $553b789f4ac0852c$export$872622c1de722f28);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $553b789f4ac0852c$export$872622c1de722f28 {
    constructor(imageShape){
        this.outputShape = [];
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = imageShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'flipLeftRight';
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let coordX = uniforms.xShape[2] - coords[2] - 1;
          let outputValue = getX(coords[0], coords[1], coordX, coords[3]);
          setOutputAtIndex(index, outputValue);
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("75xq5", function(module, exports) {

$parcel$export(module.exports, "floorConfig", () => $5292ec7fad7ebbda$export$7e9a0f96fa6bd01c);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $5292ec7fad7ebbda$export$a3fe094919f356fd = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).FLOOR,
    cpuKernelImpl: (0, $aLZc7.floorImplCPU)
});
const $5292ec7fad7ebbda$export$7e9a0f96fa6bd01c = {
    kernelName: (0, $hl418.Floor),
    backendName: 'webgpu',
    kernelFunc: $5292ec7fad7ebbda$export$a3fe094919f356fd
};

});

parcelRegister("fhYvD", function(module, exports) {

$parcel$export(module.exports, "floorDivConfig", () => $b217616b30a3cacc$export$7eac933a0c7fd37f);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $b217616b30a3cacc$export$112397bc52715a8 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).FLOOR_DIV,
    cpuKernelImpl: (0, $aLZc7.floorDivImplCPU),
    dtype: 'int32'
});
const $b217616b30a3cacc$export$7eac933a0c7fd37f = {
    kernelName: (0, $hl418.FloorDiv),
    backendName: 'webgpu',
    kernelFunc: $b217616b30a3cacc$export$112397bc52715a8
};

});

parcelRegister("55sfy", function(module, exports) {

$parcel$export(module.exports, "fromPixelsConfig", () => $3b435537c9ebbd4b$export$b22e14d614fc7178);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use backend file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $ibsdL = parcelRequire("ibsdL");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $j8zCo = parcelRequire("j8zCo");
const $3b435537c9ebbd4b$export$b22e14d614fc7178 = {
    kernelName: (0, $hl418.FromPixels),
    backendName: 'webgpu',
    kernelFunc: $3b435537c9ebbd4b$export$5a3bc84b10e77d32
};
let $3b435537c9ebbd4b$var$fromPixels2DContext;
let $3b435537c9ebbd4b$var$willReadFrequently = (0, $ibsdL.env)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
function $3b435537c9ebbd4b$export$5a3bc84b10e77d32(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    let { pixels: pixels } = inputs;
    const { numChannels: numChannels } = attrs;
    if (pixels == null) throw new Error('pixels passed to tf.browser.fromPixels() can not be null');
    const isVideo = typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement;
    const isImage = typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement;
    const isCanvas = typeof HTMLCanvasElement !== 'undefined' && pixels instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && pixels instanceof OffscreenCanvas;
    const isImageBitmap = typeof ImageBitmap !== 'undefined' && pixels instanceof ImageBitmap;
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    const outputShape = [
        height,
        width,
        numChannels
    ];
    const importVideo = (0, $ibsdL.env)().getBool('WEBGPU_IMPORT_EXTERNAL_TEXTURE') && isVideo;
    const isVideoOrImage = isVideo || isImage;
    if (isImageBitmap || isCanvas || isVideoOrImage) {
        let resource;
        if (importVideo) resource = backend.device.importExternalTexture({
            source: pixels
        });
        else {
            if (isVideoOrImage) {
                const newWillReadFrequently = (0, $ibsdL.env)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
                if ($3b435537c9ebbd4b$var$fromPixels2DContext == null || newWillReadFrequently !== $3b435537c9ebbd4b$var$willReadFrequently) {
                    $3b435537c9ebbd4b$var$willReadFrequently = newWillReadFrequently;
                    $3b435537c9ebbd4b$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                        willReadFrequently: $3b435537c9ebbd4b$var$willReadFrequently
                    });
                }
                $3b435537c9ebbd4b$var$fromPixels2DContext.canvas.width = width;
                $3b435537c9ebbd4b$var$fromPixels2DContext.canvas.height = height;
                $3b435537c9ebbd4b$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
                pixels = $3b435537c9ebbd4b$var$fromPixels2DContext.canvas;
            }
            const usage = GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING;
            const format = 'rgba8unorm';
            const texture = backend.textureManager.acquireTexture(outputShape[1], outputShape[0], format, usage);
            backend.queue.copyExternalImageToTexture({
                source: pixels
            }, {
                texture: texture
            }, [
                outputShape[1],
                outputShape[0]
            ]);
            resource = texture;
        }
        const size = (0, $jjNRA).sizeFromShape(outputShape);
        const strides = (0, $jjNRA).computeStrides(outputShape);
        const program = new (0, $j8zCo.FromPixelsProgram)(outputShape, numChannels, importVideo);
        const uniformData = [
            {
                type: 'uint32',
                data: [
                    size
                ]
            },
            {
                type: 'uint32',
                data: [
                    numChannels
                ]
            },
            {
                type: 'uint32',
                data: [
                    ...strides
                ]
            }
        ];
        const input = backend.makeTensorInfo([
            height,
            width
        ], 'int32');
        const info = backend.tensorMap.get(input.dataId);
        info.resource = resource;
        const result = backend.runWebGPUProgram(program, [
            input
        ], 'int32', uniformData);
        backend.disposeData(input.dataId);
        return result;
    }
    // TODO: Encoding should happen on GPU once we no longer have to download
    // image data to the CPU.
    const imageData = pixels.data;
    let pixelArray = imageData;
    if (numChannels != null && numChannels !== 4) {
        pixelArray = new Uint8Array(pixels.width * pixels.height * numChannels);
        const dataLength = imageData.length;
        let j = 0;
        for(let i = 0; i < dataLength; i++)if (i % 4 < numChannels) pixelArray[j++] = imageData[i];
    }
    const output = backend.makeTensorInfo(outputShape, 'int32', new Int32Array(pixelArray));
    backend.uploadToGPU(output.dataId);
    return output;
}

});
parcelRegister("j8zCo", function(module, exports) {

$parcel$export(module.exports, "FromPixelsProgram", () => $deea64bbe2cf3c02$export$7ffba7be7a218615);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $deea64bbe2cf3c02$export$7ffba7be7a218615 {
    constructor(outputShape, numChannels, importVideo = false){
        this.pixelsOpType = (0, $oGQBh.PixelsOpType).FROM_PIXELS;
        this.outputShape = [
            0
        ];
        this.variableNames = [];
        this.workgroupSize = [
            256,
            1,
            1
        ]; // The empirical value.
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            numChannels,
            1,
            1
        ]);
        this.importVideo = importVideo;
        this.shaderKey = `fromPixels_${this.importVideo}`;
    }
    getUserCode() {
        const textureLoad = this.importVideo ? 'textureLoad(src, vec2<i32>(coords.yx));' : 'textureLoad(src, vec2<i32>(coords.yx), 0)';
        const textureType = this.importVideo ? 'texture_external' : 'texture_2d<f32>';
        return `
      @binding(1) @group(0) var src: ${textureType};
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        let flatIndex = index * uniforms.numChannels;
        if (flatIndex < uniforms.size) {
          let coords = getCoordsFromIndex(flatIndex);
          let values = ${textureLoad};
          for (var i = 0; i < uniforms.numChannels; i = i + 1) {
            result[flatIndex + i] = i32(floor(255.0 * values[i]));
          }
        }
      }
  `;
    }
}

});


parcelRegister("ifc9b", function(module, exports) {

$parcel$export(module.exports, "fusedBatchNormConfig", () => $d4830ce278b6b72e$export$bfc6b905951b4903);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $30b97 = parcelRequire("30b97");
const $d4830ce278b6b72e$export$bfc6b905951b4903 = {
    kernelName: (0, $hl418.FusedBatchNorm),
    backendName: 'webgpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x, scale: scale, offset: offset, mean: mean, variance: variance } = inputs;
        const { varianceEpsilon: varianceEpsilon } = attrs;
        const webGPUBackend = backend;
        const batchNormInputs = [
            x,
            mean,
            variance
        ];
        let offsetShape = null;
        if (offset != null) {
            offsetShape = offset.shape;
            batchNormInputs.push(offset);
        }
        let scaleShape = null;
        if (scale != null) {
            scaleShape = scale.shape;
            batchNormInputs.push(scale);
        }
        const program = new (0, $30b97.BatchNormProgram)(x.shape, mean.shape, variance.shape, offsetShape, scaleShape);
        const uniformData = [
            {
                type: 'float32',
                data: [
                    varianceEpsilon
                ]
            }
        ];
        return webGPUBackend.runWebGPUProgram(program, batchNormInputs, x.dtype, uniformData);
    }
};

});
parcelRegister("30b97", function(module, exports) {

$parcel$export(module.exports, "BatchNormProgram", () => $22fa048ba6f5f54c$export$bd15a4172044baef);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $22fa048ba6f5f54c$export$bd15a4172044baef {
    constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape){
        this.uniforms = 'varianceEpsilon : f32,';
        // This is an experimental value.
        this.workgroupSize = [
            128,
            1,
            1
        ];
        this.size = true;
        this.variableNames = [
            'x',
            'mean',
            'variance'
        ];
        (0, $7MaPk).assertAndGetBroadcastShape(xShape, meanShape);
        (0, $7MaPk).assertAndGetBroadcastShape(xShape, varianceShape);
        this.outputShape = xShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        if (offsetShape != null) {
            (0, $7MaPk).assertAndGetBroadcastShape(xShape, offsetShape);
            this.variableNames.push('offset');
        }
        if (scaleShape != null) {
            (0, $7MaPk).assertAndGetBroadcastShape(xShape, scaleShape);
            this.variableNames.push('scale');
        }
        this.offsetShape = offsetShape;
        this.scaleShape = scaleShape;
        this.shaderKey = 'batchNorm';
    }
    getUserCode() {
        let offsetSnippet = '0.0';
        if (this.offsetShape != null) offsetSnippet = 'getOffsetByOutputIndex(index)';
        let scaleSnippet = '1.0';
        if (this.scaleShape != null) scaleSnippet = 'getScaleByOutputIndex(index)';
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size)
        {
          let xValue = getXByOutputIndex(index);
          let meanValue = getMeanByOutputIndex(index);
          let varianValue = getVarianceByOutputIndex(index);
          let offsetValue = ${offsetSnippet};
          let scaleValue = ${scaleSnippet};
          let inv = scaleValue * inverseSqrt(varianValue + f32(uniforms.varianceEpsilon));
          setOutputAtIndex(index,dot(vec3<f32>(xValue, -meanValue, offsetValue), vec3<f32>(inv, inv, 1.0)));
        }
      }
  `;
        return userCode;
    }
}

});


parcelRegister("d1gHK", function(module, exports) {

$parcel$export(module.exports, "fusedConv2DConfig", () => $97a8538ae36eb97f$export$5b64efa829ddf94e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $1V6Ye = parcelRequire("1V6Ye");
function $97a8538ae36eb97f$export$b4f4a900a93010a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    const $dataFormat = (0, $7MaPk).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $7MaPk).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    return (0, $1V6Ye.conv2DImpl)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha,
        activation: activation
    });
}
const $97a8538ae36eb97f$export$5b64efa829ddf94e = {
    kernelName: (0, $hl418.FusedConv2D),
    backendName: 'webgpu',
    kernelFunc: $97a8538ae36eb97f$export$b4f4a900a93010a
};

});

parcelRegister("4OOm5", function(module, exports) {

$parcel$export(module.exports, "fusedDepthwiseConv2DConfig", () => $3822e46c0ddf01ff$export$58481cc3409b412c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $3Y3Qf = parcelRequire("3Y3Qf");

var $a50Md = parcelRequire("a50Md");
function $3822e46c0ddf01ff$export$d61de7729228094b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $jjNRA).assert((0, $7MaPk).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $7MaPk).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    const programInputs = [
        x,
        filter
    ];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    if (hasBias) programInputs.push(bias);
    if (hasPreluActivationWeights) programInputs.push(preluActivationWeights);
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        }
    ];
    let program;
    if (convInfo.outHeight > 4 && convInfo.outWidth > 4 && convInfo.strideWidth <= 2 && convInfo.inChannels === convInfo.outChannels && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.inChannels % 4 === 0) {
        program = new (0, $3Y3Qf.DepthwiseConv2DVec4Program)(convInfo, hasBias, activation, hasPreluActivationWeights);
        dimensions.push({
            type: 'int32',
            data: [
                program.virtualWidth
            ]
        });
    } else {
        program = new (0, $a50Md.DepthwiseConv2DProgram)(convInfo, hasBias, activation, hasPreluActivationWeights);
        dimensions.push({
            type: 'int32',
            data: [
                convInfo.filterHeight
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.filterWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        }, {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        });
    }
    if (activation === 'leakyrelu') {
        dimensions.push({
            type: 'float32',
            data: [
                leakyreluAlpha
            ]
        });
        program.uniforms += ' alpha : f32,';
    }
    const result = backend.runWebGPUProgram(program, programInputs, 'float32', dimensions);
    return result;
}
const $3822e46c0ddf01ff$export$58481cc3409b412c = {
    kernelName: (0, $hl418.FusedDepthwiseConv2D),
    backendName: 'webgpu',
    kernelFunc: $3822e46c0ddf01ff$export$d61de7729228094b
};

});

parcelRegister("6464m", function(module, exports) {

$parcel$export(module.exports, "gatherNdConfig", () => $46a7d30850a4eb35$export$d9700eb1c7f5c969);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $2KKG5 = parcelRequire("2KKG5");

var $aLZc7 = parcelRequire("aLZc7");

var $gj4T5 = parcelRequire("gj4T5");
function $46a7d30850a4eb35$export$3c586830e482d2b9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { params: params, indices: indices } = inputs;
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    const paramsSize = (0, $jjNRA).sizeFromShape(params.shape);
    const [resultShape, numSlices, sliceSize, strides] = (0, $7MaPk).prepareAndValidate(params, indices);
    const flattenIndices = (0, $gj4T5.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numSlices,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $gj4T5.reshape)({
        inputs: {
            x: params
        },
        backend: backend,
        attrs: {
            shape: [
                (0, $jjNRA).sizeFromShape(params.shape) / sliceSize,
                sliceSize
            ]
        }
    });
    if (backend.shouldExecuteOnCPU([
        params,
        indices
    ]) || params.dtype === 'string') {
        const indicesData = backend.readSync(indices.dataId);
        const paramsBuf = backend.bufferSync(params);
        const outValue = (0, $aLZc7.gatherNdImplCPU)(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
        return backend.makeTensorInfo(resultShape, params.dtype, outValue.values);
    }
    const program = new (0, $2KKG5.GatherNDProgram)(sliceRank, [
        numSlices,
        sliceSize
    ]);
    const uniformData = [
        {
            type: 'int32',
            data: [
                sliceRank
            ]
        },
        {
            type: 'int32',
            data: strides
        }
    ];
    const res = backend.runWebGPUProgram(program, [
        flattenX,
        flattenIndices
    ], flattenX.dtype, uniformData);
    const reshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: resultShape
        }
    });
    backend.disposeData(flattenIndices.dataId);
    backend.disposeData(flattenX.dataId);
    backend.disposeData(res.dataId);
    return reshaped;
}
const $46a7d30850a4eb35$export$d9700eb1c7f5c969 = {
    kernelName: (0, $hl418.GatherNd),
    backendName: 'webgpu',
    kernelFunc: $46a7d30850a4eb35$export$3c586830e482d2b9
};

});
parcelRegister("2KKG5", function(module, exports) {

$parcel$export(module.exports, "GatherNDProgram", () => $201415e94c13ecca$export$ffd508d535a7dba1);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $201415e94c13ecca$export$ffd508d535a7dba1 {
    constructor(sliceDim, shape){
        this.variableNames = [
            'A',
            'indices'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `gathernd_${sliceDim}`;
        this.sliceDim = sliceDim;
        this.uniforms = `sliceDim : i32, strides : ${(0, $oGQBh.getCoordsDataType)(sliceDim)},`;
    }
    getUserCode() {
        let strideString;
        if (this.sliceDim > 1) strideString = 'uniforms.strides[j]';
        else strideString = 'uniforms.strides';
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          var flattenIndex = 0;
          for (var j = 0; j < uniforms.sliceDim; j = j + 1) {
            let indexTemp = i32(round(getIndices(coords[0], j)));
            let strideNum = ${strideString};
            flattenIndex = flattenIndex + indexTemp * strideNum;
          }

          setOutputAtIndex(index, getA(flattenIndex, coords[1]));
        }
      }
      `;
        return userCode;
    }
}

});


parcelRegister("gDTrm", function(module, exports) {

$parcel$export(module.exports, "gatherV2", () => $c1db4b2a76e853cf$export$3d75b4295ded9925);
$parcel$export(module.exports, "gatherV2Config", () => $c1db4b2a76e853cf$export$b1bd3139c91d8765);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $iG87S = parcelRequire("iG87S");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $bpViq = parcelRequire("bpViq");

var $aLZc7 = parcelRequire("aLZc7");

var $gj4T5 = parcelRequire("gj4T5");
function $c1db4b2a76e853cf$export$3d75b4295ded9925(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, indices: indices } = inputs;
    const { axis: axis, batchDims: batchDims } = attrs;
    // Unlike WebGL, WebGPU won't check if index is out of bound by calling
    // backend.readSync() function in debug mode.
    const parsedAxis = (0, $jjNRA).parseAxisParam(axis, x.shape)[0];
    const shapeInfo = (0, $7MaPk).segment_util.collectGatherOpShapeInfo(x, indices, parsedAxis, batchDims);
    const indicesSize = (0, $jjNRA).sizeFromShape(indices.shape);
    const toDispose = [];
    const flattenX = (0, $gj4T5.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                shapeInfo.outerSize,
                shapeInfo.dimSize,
                shapeInfo.sliceSize
            ]
        }
    });
    const flattenIndex = (0, $gj4T5.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                indicesSize / shapeInfo.batchSize
            ]
        }
    });
    toDispose.push(flattenX);
    toDispose.push(flattenIndex);
    const flattenOutputShape = [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        indicesSize / shapeInfo.batchSize,
        shapeInfo.sliceSize
    ];
    if (backend.shouldExecuteOnCPU([
        x,
        indices
    ])) {
        const indicesTensorData = backend.tensorMap.get(flattenIndex.dataId);
        const indicesValues = indicesTensorData.values;
        const indicesBuffer = (0, $iG87S.buffer)(flattenIndex.shape, flattenIndex.dtype, indicesValues);
        const flattenXTensorData = backend.tensorMap.get(flattenX.dataId);
        const xValues = flattenXTensorData.values;
        const xBuffer = (0, $iG87S.buffer)(flattenX.shape, flattenX.dtype, xValues);
        const outBuf = (0, $aLZc7.gatherV2ImplCPU)(xBuffer, indicesBuffer, flattenOutputShape);
        toDispose.forEach((t)=>backend.disposeData(t.dataId));
        return backend.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $bpViq.GatherProgram)(flattenX.shape, flattenOutputShape);
    const res = backend.runWebGPUProgram(program, [
        flattenX,
        flattenIndex
    ], flattenX.dtype);
    toDispose.push(res);
    const reshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shapeInfo.outputShape
        }
    });
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return reshaped;
}
const $c1db4b2a76e853cf$export$b1bd3139c91d8765 = {
    kernelName: (0, $hl418.GatherV2),
    backendName: 'webgpu',
    kernelFunc: $c1db4b2a76e853cf$export$3d75b4295ded9925
};

});
parcelRegister("bpViq", function(module, exports) {

$parcel$export(module.exports, "GatherProgram", () => $84fe795a21eb6dee$export$e8921930334c8ed5);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $84fe795a21eb6dee$export$e8921930334c8ed5 {
    constructor(aShape, outputShape){
        this.variableNames = [
            'A',
            'indices'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = aShape.slice();
        this.aShape = aShape;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `gather`;
    }
    getUserCode() {
        const sourceCoords = $84fe795a21eb6dee$var$getSourceCoords(this.aShape);
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let resRC = getCoordsFromIndex(index);
          let indexZ = i32(getIndices(resRC.x, resRC.z));
          let inBounds = select(0.0, 1.0, indexZ >= 0 && indexZ < uniforms.aShape[2]);
          setOutputAtIndex(index, inBounds * getA(${sourceCoords}));
        }
      }
    `;
        return userCode;
    }
}
// The input and output are always flattened into rank 4 tensors.
function $84fe795a21eb6dee$var$getSourceCoords(aShape) {
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w'
    ];
    const sourceCoords = [];
    for(let i = 0; i < aShape.length; i++)if (i === 2) sourceCoords.push('indexZ');
    else sourceCoords.push(`${currentCoords[i]}`);
    return sourceCoords.join();
}

});


parcelRegister("4AQDR", function(module, exports) {

$parcel$export(module.exports, "greaterConfig", () => $35835bcb860a393d$export$8c4f7e92d92310f8);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $35835bcb860a393d$export$9dca161faaf6308b = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).GREATER,
    cpuKernelImpl: (0, $aLZc7.greaterImplCPU),
    dtype: 'bool'
});
const $35835bcb860a393d$export$8c4f7e92d92310f8 = {
    kernelName: (0, $hl418.Greater),
    backendName: 'webgpu',
    kernelFunc: $35835bcb860a393d$export$9dca161faaf6308b
};

});

parcelRegister("jvsZZ", function(module, exports) {

$parcel$export(module.exports, "greaterEqualConfig", () => $e337681fafc688d8$export$7a6926f9fcac24ca);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $e337681fafc688d8$export$c2fd4164cadc1fa2 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).GREATER_EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $aLZc7.greaterEqualImplCPU)
});
const $e337681fafc688d8$export$7a6926f9fcac24ca = {
    kernelName: (0, $hl418.GreaterEqual),
    backendName: 'webgpu',
    kernelFunc: $e337681fafc688d8$export$c2fd4164cadc1fa2
};

});

parcelRegister("cPOux", function(module, exports) {

$parcel$export(module.exports, "ifftConfig", () => $95816a025ec5f17e$export$dc267425bf21b465);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $3GdZ3 = parcelRequire("3GdZ3");
function $95816a025ec5f17e$export$776649b0bf8ce1fd(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $3GdZ3.fftImpl)(input, true, backend);
}
const $95816a025ec5f17e$export$dc267425bf21b465 = {
    kernelName: (0, $hl418.IFFT),
    backendName: 'webgpu',
    kernelFunc: $95816a025ec5f17e$export$776649b0bf8ce1fd
};

});

parcelRegister("iZrAY", function(module, exports) {

$parcel$export(module.exports, "isFiniteConfig", () => $dd33545757e1acb6$export$4d45c8f7b9ffdaf1);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $dd33545757e1acb6$export$65f0b13f2f82375a = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).IS_FINITE,
    dtype: 'bool'
});
const $dd33545757e1acb6$export$4d45c8f7b9ffdaf1 = {
    kernelName: (0, $hl418.IsFinite),
    backendName: 'webgpu',
    kernelFunc: $dd33545757e1acb6$export$65f0b13f2f82375a
};

});

parcelRegister("kjTzZ", function(module, exports) {

$parcel$export(module.exports, "isInfConfig", () => $ecb0b1e5e9bb6ca4$export$bc383b82282e9b5a);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $ecb0b1e5e9bb6ca4$export$e5d3415c656f7096 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).IS_INF,
    dtype: 'bool'
});
const $ecb0b1e5e9bb6ca4$export$bc383b82282e9b5a = {
    kernelName: (0, $hl418.IsInf),
    backendName: 'webgpu',
    kernelFunc: $ecb0b1e5e9bb6ca4$export$e5d3415c656f7096
};

});

parcelRegister("dzkXT", function(module, exports) {

$parcel$export(module.exports, "isNaNConfig", () => $9e0ece752cefa4ae$export$d58ff790c765c1f0);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $9e0ece752cefa4ae$export$c9f5652083b8129d = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).IS_NAN,
    dtype: 'bool'
});
const $9e0ece752cefa4ae$export$d58ff790c765c1f0 = {
    kernelName: (0, $hl418.IsNan),
    backendName: 'webgpu',
    kernelFunc: $9e0ece752cefa4ae$export$c9f5652083b8129d
};

});

parcelRegister("kI39w", function(module, exports) {

$parcel$export(module.exports, "leakyReluConfig", () => $f13a5cbf33fe2bf5$export$aa04ab963fdf437f);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $8Y5Lq = parcelRequire("8Y5Lq");

var $2b4Nh = parcelRequire("2b4Nh");
function $f13a5cbf33fe2bf5$export$23a860e40a2c6b61(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { alpha: alpha } = attrs;
    const uniformData = [
        {
            type: 'float32',
            data: [
                alpha
            ]
        }
    ];
    const program = new (0, $2b4Nh.UnaryOpProgram)(x.shape, (0, $8Y5Lq.UnaryOpType).LEAKYRELU, 'alpha : f32,');
    return backend.runWebGPUProgram(program, [
        x
    ], 'float32', uniformData);
}
const $f13a5cbf33fe2bf5$export$aa04ab963fdf437f = {
    kernelName: (0, $hl418.LeakyRelu),
    backendName: 'webgpu',
    kernelFunc: $f13a5cbf33fe2bf5$export$23a860e40a2c6b61
};

});

parcelRegister("dhxU8", function(module, exports) {

$parcel$export(module.exports, "lessConfig", () => $9ab7299c66f36bbe$export$8d4530ce8b6ffc3c);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $9ab7299c66f36bbe$export$bb1a638da8ad190f = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).LESS,
    dtype: 'bool',
    cpuKernelImpl: (0, $aLZc7.lessImplCPU)
});
const $9ab7299c66f36bbe$export$8d4530ce8b6ffc3c = {
    kernelName: (0, $hl418.Less),
    backendName: 'webgpu',
    kernelFunc: $9ab7299c66f36bbe$export$bb1a638da8ad190f
};

});

parcelRegister("47AIY", function(module, exports) {

$parcel$export(module.exports, "lessEqualConfig", () => $30044d96a14e036d$export$9f26bd257393dd8);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $30044d96a14e036d$export$c24ad19a692bb92 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).LESS_EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $aLZc7.lessEqualImplCPU)
});
const $30044d96a14e036d$export$9f26bd257393dd8 = {
    kernelName: (0, $hl418.LessEqual),
    backendName: 'webgpu',
    kernelFunc: $30044d96a14e036d$export$c24ad19a692bb92
};

});

parcelRegister("cYAkQ", function(module, exports) {

$parcel$export(module.exports, "linSpaceConfig", () => $9727460a97c447bf$export$46b96f742c70959b);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $5JB4Y = parcelRequire("5JB4Y");
function $9727460a97c447bf$export$865a19adce4d7a46(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, num: num } = attrs;
    const step = (stop - start) / (num - 1);
    const program = new (0, $5JB4Y.LinSpaceProgram)(num);
    const uniformData = [
        {
            type: 'float32',
            data: [
                start
            ]
        },
        {
            type: 'float32',
            data: [
                step
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [], 'float32', uniformData);
}
const $9727460a97c447bf$export$46b96f742c70959b = {
    kernelName: (0, $hl418.LinSpace),
    backendName: 'webgpu',
    kernelFunc: $9727460a97c447bf$export$865a19adce4d7a46
};

});
parcelRegister("5JB4Y", function(module, exports) {

$parcel$export(module.exports, "LinSpaceProgram", () => $42cdeae186d86653$export$575158e615b03e10);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $42cdeae186d86653$export$575158e615b03e10 {
    constructor(shape){
        this.variableNames = [];
        this.outputShape = [];
        this.uniforms = 'start : f32, step : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            shape
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'linSpace';
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          setOutputAtIndex(index, uniforms.start + f32(index) * uniforms.step);
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("1281S", function(module, exports) {

$parcel$export(module.exports, "logConfig", () => $0c0c34cdb2da58ab$export$a4ae1f00643ddd14);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $0c0c34cdb2da58ab$export$bef1f36f5486a6a3 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).LOG,
    cpuKernelImpl: (0, $aLZc7.logImplCPU)
});
const $0c0c34cdb2da58ab$export$a4ae1f00643ddd14 = {
    kernelName: (0, $hl418.Log),
    backendName: 'webgpu',
    kernelFunc: $0c0c34cdb2da58ab$export$bef1f36f5486a6a3
};

});

parcelRegister("fNtds", function(module, exports) {

$parcel$export(module.exports, "log1pConfig", () => $b8021852fc6b30eb$export$c458b9e5ba980198);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $b8021852fc6b30eb$export$144dcf16adfb9698 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).LOG1P
});
const $b8021852fc6b30eb$export$c458b9e5ba980198 = {
    kernelName: (0, $hl418.Log1p),
    backendName: 'webgpu',
    kernelFunc: $b8021852fc6b30eb$export$144dcf16adfb9698
};

});

parcelRegister("gNgxW", function(module, exports) {

$parcel$export(module.exports, "logicalAndConfig", () => $c39e0ebf36ba38c2$export$257f1e82e69113fb);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");
const $c39e0ebf36ba38c2$export$db5dd0ef9d505f = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).LOGICAL_AND,
    dtype: 'bool'
});
const $c39e0ebf36ba38c2$export$257f1e82e69113fb = {
    kernelName: (0, $hl418.LogicalAnd),
    backendName: 'webgpu',
    kernelFunc: $c39e0ebf36ba38c2$export$db5dd0ef9d505f
};

});

parcelRegister("afxB8", function(module, exports) {

$parcel$export(module.exports, "logicalNotConfig", () => $77655dee6699e60d$export$68e2dd0840056271);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $77655dee6699e60d$export$c836ff7b605b1617 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).LOGICAL_NOT
});
const $77655dee6699e60d$export$68e2dd0840056271 = {
    kernelName: (0, $hl418.LogicalNot),
    backendName: 'webgpu',
    kernelFunc: $77655dee6699e60d$export$c836ff7b605b1617
};

});

parcelRegister("8TTdn", function(module, exports) {

$parcel$export(module.exports, "logicalOrConfig", () => $67ae4a47be9bfed3$export$ce04b6546987ef43);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");
const $67ae4a47be9bfed3$export$e2a73975983cadd8 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).LOGICAL_OR
});
const $67ae4a47be9bfed3$export$ce04b6546987ef43 = {
    kernelName: (0, $hl418.LogicalOr),
    backendName: 'webgpu',
    kernelFunc: $67ae4a47be9bfed3$export$e2a73975983cadd8
};

});

parcelRegister("lqP2B", function(module, exports) {

$parcel$export(module.exports, "lrnConfig", () => $f9a39e578a3229bf$export$8817e4cec9f1a309);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $bupo1 = parcelRequire("bupo1");
function $f9a39e578a3229bf$export$4e4a7896ae51c2f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    // When the adjacent channels is less than or equal to 16, which could cover
    // most cases, we use shared memory version to get better performance.
    // The theoretical adjacent channels may be very large, but the shared memory
    // size of hardware is limited, so we use the naive version when the adjacent
    // channels is large.
    let program;
    if (depthRadius > 16) program = new (0, $bupo1.LRNProgram)(x.shape);
    else program = new (0, $bupo1.LRNSharedProgram)(x.shape, depthRadius);
    const uniformData = [
        {
            type: 'int32',
            data: [
                depthRadius
            ]
        },
        {
            type: 'float32',
            data: [
                bias
            ]
        },
        {
            type: 'float32',
            data: [
                alpha
            ]
        },
        {
            type: 'float32',
            data: [
                beta
            ]
        }
    ];
    const res = backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
    return res;
}
const $f9a39e578a3229bf$export$8817e4cec9f1a309 = {
    kernelName: (0, $hl418.LRN),
    backendName: 'webgpu',
    kernelFunc: $f9a39e578a3229bf$export$4e4a7896ae51c2f1
};

});
parcelRegister("bupo1", function(module, exports) {

$parcel$export(module.exports, "LRNProgram", () => $85d6304b7fa486f5$export$2214c2ca22968528);
$parcel$export(module.exports, "LRNSharedProgram", () => $85d6304b7fa486f5$export$f1c3ae97c33db409);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
const $85d6304b7fa486f5$var$powOperatorSnippet = `
  var powValue = 0.0;
  let basis = uniforms.bias + uniforms.alpha * sum;
  if (uniforms.beta == 0.5) {
    powValue = inverseSqrt(basis);
  } else if (uniforms.beta == 1.0) {
    powValue = 1.0 / basis;
  } else {
    powValue = exp(log(basis) * (-uniforms.beta));
  }
`;
class $85d6304b7fa486f5$export$2214c2ca22968528 {
    constructor(xShape){
        this.outputShape = [];
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'radius : i32, bias : f32, alpha : f32, beta : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = xShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'lrn';
    }
    getUserCode() {
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getOutputCoords();
        let b = coords[0];
        let r = coords[1];
        let c = coords[2];
        let d = coords[3];

        let x = getX(b, r, c, d);
        var sum = 0.0;
        for (var i = -uniforms.radius; i <= uniforms.radius; i = i + 1) {
          let idx = d + i;
          if (idx >= 0 && idx < uniforms.xShape[3]) {
            let z = getX(b, r, c, idx);
            sum = sum + z * z;
          }
        }
        ${$85d6304b7fa486f5$var$powOperatorSnippet}

        setOutputAtIndex(index, x * powValue);
      }
    }
  `;
        return userCode;
    }
}
class $85d6304b7fa486f5$export$f1c3ae97c33db409 {
    constructor(xShape, radius){
        this.outputShape = [];
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'radius : i32, bias : f32, alpha : f32, beta : f32,';
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.maxAllowRadius = 16;
        (0, $jjNRA).assert(radius <= this.maxAllowRadius, ()=>`Radius must be less than or equal to ${this.maxAllowRadius}, current radius is ${radius}`);
        this.outputShape = xShape;
        // The reason why not using this.workgroupSize[0] + 2 * maxAllowRadius here
        // is to make sure that there is only one time global memory load access for
        // each thread.
        this.elementsPerWorkgroup = this.workgroupSize[0] - 2 * this.maxAllowRadius;
        this.dispatchLayout = {
            x: [
                3
            ],
            y: [
                2
            ],
            z: [
                0,
                1
            ]
        };
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, [
            this.elementsPerWorkgroup,
            this.workgroupSize[1],
            this.workgroupSize[2]
        ]);
        this.shaderKey = 'lrn_shared';
    }
    getUserCode() {
        const userCode = `
    var <workgroup>lrnSub: array<f32, ${this.workgroupSize[0]}>;
    const elementsPerWorkgroup = ${this.elementsPerWorkgroup};
    const maxAllowRadius = ${this.maxAllowRadius};

    ${(0, $oGQBh.getMainHeaderString)()} {
      let localDepth = i32(localId.x);
      let workgroupDepth = i32(workgroupId.x) * elementsPerWorkgroup;
      let xDepth = workgroupDepth + localDepth - maxAllowRadius;
      let b = i32(globalId.z) / uniforms.xShape[1];
      let r = i32(globalId.z) - b * uniforms.xShape[1];
      let c = i32(globalId.y);
      let d = workgroupDepth + localDepth;

      var x = 0.0;
      if (xDepth >= 0 && xDepth < uniforms.xShape[3]) {
        x = getX(b, r, c, xDepth);
      }
      lrnSub[localDepth] = x;
      workgroupBarrier();

      if (localDepth < elementsPerWorkgroup && d < uniforms.outShape[3]) {
        var sum = 0.0;
        let index = localDepth + maxAllowRadius;
        for (var i = -uniforms.radius; i <= uniforms.radius; i = i + 1) {
          let z = lrnSub[index + i];
          sum = sum + z * z;
        }
        ${$85d6304b7fa486f5$var$powOperatorSnippet}

        setOutputAtCoords(b, r, c, d, lrnSub[index] * powValue);
      }
    } `;
        return userCode;
    }
}

});


parcelRegister("lfAX4", function(module, exports) {

$parcel$export(module.exports, "lrnGradConfig", () => $f787a984b874ce54$export$9250622395b66a34);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $er4YK = parcelRequire("er4YK");
function $f787a984b874ce54$export$c1529e4348811bb5(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, y: y, dy: dy } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    const program = new (0, $er4YK.LRNGradProgram)(x.shape);
    const uniformData = [
        {
            type: 'int32',
            data: [
                depthRadius
            ]
        },
        {
            type: 'float32',
            data: [
                bias
            ]
        },
        {
            type: 'float32',
            data: [
                alpha
            ]
        },
        {
            type: 'float32',
            data: [
                beta
            ]
        }
    ];
    const res = backend.runWebGPUProgram(program, [
        x,
        y,
        dy
    ], x.dtype, uniformData);
    return res;
}
const $f787a984b874ce54$export$9250622395b66a34 = {
    kernelName: (0, $hl418.LRNGrad),
    backendName: 'webgpu',
    kernelFunc: $f787a984b874ce54$export$c1529e4348811bb5
};

});
parcelRegister("er4YK", function(module, exports) {

$parcel$export(module.exports, "LRNGradProgram", () => $a82772fc0ae06d97$export$f121c71e68d75e);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $a82772fc0ae06d97$export$f121c71e68d75e {
    constructor(inputShape){
        this.outputShape = [];
        this.variableNames = [
            'inputImage',
            'outputImage',
            'dy'
        ];
        this.uniforms = 'depthRadius : i32, bias : f32, alpha : f32, beta : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = inputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'lrn_grad';
    }
    getUserCode() {
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getOutputCoords();
        let b = coords[0];
        let r = coords[1];
        let c = coords[2];

        let MIN_DEPTH_BEGIN = 0;
        let MAX_DEPTH_END = uniforms.outShape[3];
        var result = 0.0;
        for (var d = MIN_DEPTH_BEGIN; d < MAX_DEPTH_END; d++) {
          let depthBegin = max(MIN_DEPTH_BEGIN, d - uniforms.depthRadius);
          let depthEnd = min(MAX_DEPTH_END, d + uniforms.depthRadius + 1);

          var norm = 0.0;
          for (var k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; k++) {
            if (k < depthBegin) {
              continue;
            } else if (k >= depthBegin && k < depthEnd) {
              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);
            } else {
              break;
            }
          }

          norm = uniforms.alpha * norm + uniforms.bias;

          for (var k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; k++) {
            if (k < depthBegin) {
              continue;
            } else if (k >= depthBegin && k < depthEnd) {
              var dyi = -2.0 * uniforms.alpha * uniforms.beta
                * getInputImage(b, r, c, k) * getOutputImage(b, r, c, d) / norm;
              if (k == d) {
                dyi += pow(norm, -1.0 * uniforms.beta);
              }
              if (k == coords[3]) {
                dyi *= getDy(b, r, c, d);
                result += dyi;
              }
            } else {
              break;
            }
          }
        }

        setOutputAtIndex(index, result);
      }
    }
  `;
        return userCode;
    }
}

});


parcelRegister("h4Kie", function(module, exports) {

$parcel$export(module.exports, "maximumConfig", () => $c6e6b835a0520364$export$45b97bdc342e72a2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $c6e6b835a0520364$export$b25e0be55f42c9a = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).MAX,
    cpuKernelImpl: (0, $aLZc7.maximumImplCPU)
});
const $c6e6b835a0520364$export$45b97bdc342e72a2 = {
    kernelName: (0, $hl418.Maximum),
    backendName: 'webgpu',
    kernelFunc: $c6e6b835a0520364$export$b25e0be55f42c9a
};

});

parcelRegister("i5HLG", function(module, exports) {

$parcel$export(module.exports, "maxPoolConfig", () => $d2baa5078966112c$export$45c8263b38f19e33);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $fnZve = parcelRequire("fnZve");
function $d2baa5078966112c$export$e4aadcf115842782(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    const convInfo = (0, $7MaPk).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    return (0, $fnZve.poolImpl)(x, convInfo, 'max', backend);
}
const $d2baa5078966112c$export$45c8263b38f19e33 = {
    kernelName: (0, $hl418.MaxPool),
    backendName: 'webgpu',
    kernelFunc: $d2baa5078966112c$export$e4aadcf115842782
};

});

parcelRegister("k0RoI", function(module, exports) {

$parcel$export(module.exports, "maxPool3DConfig", () => $e91d3a6a9f839053$export$91a8fc5da39ec855);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $fmchZ = parcelRequire("fmchZ");
function $e91d3a6a9f839053$export$822a6e53be1125f9(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $7MaPk).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const maxPoolProgram = new (0, $fmchZ.Pool3DProgram)(convInfo, 'max');
    const dimensions = [
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.front,
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inDepth,
                convInfo.inHeight,
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth,
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(maxPoolProgram, [
        x
    ], x.dtype, dimensions);
}
const $e91d3a6a9f839053$export$91a8fc5da39ec855 = {
    kernelName: (0, $hl418.MaxPool3D),
    backendName: 'webgpu',
    kernelFunc: $e91d3a6a9f839053$export$822a6e53be1125f9
};

});

parcelRegister("lqK20", function(module, exports) {

$parcel$export(module.exports, "maxPool3DGradConfig", () => $f99fbb8ad795ced0$export$5201426bb10bd5eb);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $i19KY = parcelRequire("i19KY");

var $fmchZ = parcelRequire("fmchZ");
function $f99fbb8ad795ced0$export$e68b9bef571dd4ea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $7MaPk).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    const maxPool3dPositionsProgram = new (0, $fmchZ.Pool3DProgram)(convInfo, 'max', true);
    let uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.front,
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inDepth,
                convInfo.inHeight,
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth,
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        }
    ];
    const maxPool3dPositions = backend.runWebGPUProgram(maxPool3dPositionsProgram, [
        x
    ], 'int32', uniformData);
    const maxPool3dBackpropProgram = new (0, $i19KY.MaxPool3DBackpropProgram)(convInfo);
    uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideDepth,
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth - 1 - convInfo.padInfo.front,
                convInfo.effectiveFilterHeight - 1 - convInfo.padInfo.top,
                convInfo.effectiveFilterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterDepth,
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outDepth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        }
    ];
    const result = backend.runWebGPUProgram(maxPool3dBackpropProgram, [
        dy,
        maxPool3dPositions
    ], x.dtype, uniformData);
    backend.disposeData(maxPool3dPositions.dataId);
    return result;
}
const $f99fbb8ad795ced0$export$5201426bb10bd5eb = {
    kernelName: (0, $hl418.MaxPool3DGrad),
    backendName: 'webgpu',
    kernelFunc: $f99fbb8ad795ced0$export$e68b9bef571dd4ea
};

});
parcelRegister("i19KY", function(module, exports) {

$parcel$export(module.exports, "MaxPool2DBackpropProgram", () => $d1dfe37963e5a93f$export$ab6144ed51884dd);
$parcel$export(module.exports, "MaxPool3DBackpropProgram", () => $d1dfe37963e5a93f$export$ae61ae287bf9d719);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $d1dfe37963e5a93f$export$ab6144ed51884dd {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.uniforms = `strides : vec2<i32>, pads : vec2<i32>, dilations : vec2<i32>, filterDims : vec2<i32>,
       outHeight : i32, outWidth : i32`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'maxPool2DBackprop';
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords[0];
        let d = coords[3];

        let dyRCCorner = vec2<i32>(coords.yz) - uniforms.pads;
        let dyRCorner = dyRCCorner.x;
        let dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        let lastIndex = uniforms.filterDims[0] * uniforms.filterDims[1] - 1;
        for (var wR = 0; wR < uniforms.filterDims[0]; wR += uniforms.dilations[0]) {
          let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[0]);

          if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
            continue;
          }
          let idyR = i32(dyR);

          for (var wC = 0; wC < uniforms.filterDims[1]; wC += uniforms.dilations[1]) {
            let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[1]);

            if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
              continue;
            }
            let idyC = i32(dyC);

            let dyValue = getDy(batch, idyR, idyC, d);
            let maxPosValue = lastIndex - i32(getMaxPos(batch, idyR, idyC, d));

            // Get the current value, check it against the value from the
            // position matrix.
            let curPosValue = wR * uniforms.filterDims[1] + wC;
            let mask = select(0.0, 1.0, maxPosValue == curPosValue);
            dotProd += dyValue * mask;
          }
        }
        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}
class $d1dfe37963e5a93f$export$ae61ae287bf9d719 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.uniforms = `strides : vec3<i32>, pads : vec3<i32>, filterDims : vec3<i32>,
      outDepth : i32, outHeight : i32, outWidth : i32`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = convInfo.inShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'maxPool3DBackprop';
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
        let batch = coords.x;
        let ch = coords.u;

        let dyCorner = vec3<i32>(coords.y, coords.z, coords.w) - uniforms.pads;
        let dyDCorner = dyCorner.x;
        let dyRCorner = dyCorner.y;
        let dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        var dotProd = 0.0;
        let lastIndex = uniforms.filterDims[0] * uniforms.filterDims[1] * uniforms.filterDims[2] - 1;

        for (var wD = 0; wD < uniforms.filterDims[0]; wD++) {
          let dyD = f32(dyDCorner + wD) / f32(uniforms.strides[0]);

          if (dyD < 0.0 || dyD >= f32(uniforms.outDepth) || fract(dyD) > 0.0) {
            continue;
          }
          let idyD = i32(dyD);

          for (var wR = 0; wR < uniforms.filterDims[1]; wR++) {
            let dyR = f32(dyRCorner + wR) / f32(uniforms.strides[1]);

            if (dyR < 0.0 || dyR >= f32(uniforms.outHeight) || fract(dyR) > 0.0) {
              continue;
            }
            let idyR = i32(dyR);

            for (var wC = 0; wC < uniforms.filterDims[2]; wC++) {
              let dyC = f32(dyCCorner + wC) / f32(uniforms.strides[2]);

              if (dyC < 0.0 || dyC >= f32(uniforms.outWidth) || fract(dyC) > 0.0) {
                continue;
              }
              let idyC = i32(dyC);

              let dyValue = getDy(batch, idyD, idyR, idyC, ch);
              let maxPosValue = lastIndex - i32(getMaxPos(batch, idyD, idyR, idyC, ch));

              // Get the current value, check it against the value from the
              // position matrix.
              let curPosValue = wD * uniforms.filterDims[1] * uniforms.filterDims[2] + wR * uniforms.filterDims[2] + wC;
              let mask = select(0.0, 1.0, maxPosValue == curPosValue);
              dotProd += dyValue * mask;
            }
          }
        }

        setOutputAtIndex(index, dotProd);
      }
    }
    `;
        return userCode;
    }
}

});


parcelRegister("8x2FH", function(module, exports) {

$parcel$export(module.exports, "maxPoolGradConfig", () => $63637a572d830f89$export$e01a7f8dbee29127);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $i19KY = parcelRequire("i19KY");

var $fmchZ = parcelRequire("fmchZ");

var $9Dn6G = parcelRequire("9Dn6G");
function $63637a572d830f89$export$85dfd1121f049514(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input, output: output } = inputs;
    const x = input;
    (0, $9Dn6G.assertNotComplex)([
        input,
        output
    ], 'maxPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $7MaPk).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const maxPoolPositionsProgram = new (0, $fmchZ.Pool2DProgram)(convInfo, 'max', true);
    let uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        }
    ];
    const maxPoolPositions = backend.runWebGPUProgram(maxPoolPositionsProgram, [
        x
    ], 'int32', uniformData);
    const maxPoolBackpropProgram = new (0, $i19KY.MaxPool2DBackpropProgram)(convInfo);
    uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight - 1 - convInfo.padInfo.top,
                convInfo.effectiveFilterWidth - 1 - convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outHeight
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.outWidth
            ]
        }
    ];
    const result = backend.runWebGPUProgram(maxPoolBackpropProgram, [
        dy,
        maxPoolPositions
    ], x.dtype, uniformData);
    backend.disposeData(maxPoolPositions.dataId);
    return result;
}
const $63637a572d830f89$export$e01a7f8dbee29127 = {
    kernelName: (0, $hl418.MaxPoolGrad),
    backendName: 'webgpu',
    kernelFunc: $63637a572d830f89$export$85dfd1121f049514
};

});

parcelRegister("f1aWD", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmaxConfig", () => $aeef706508ca2ca3$export$a069ee2247a7d1ce);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $fmchZ = parcelRequire("fmchZ");
function $aeef706508ca2ca3$export$3d8b1b819d23351e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { filterSize: filterSize, strides: strides, pad: pad, includeBatchInIndex: includeBatchInIndex } = attrs;
    const { x: x } = inputs;
    (0, $jjNRA).assert(x.shape.length === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x.shape.length}.`);
    const dilations = [
        1,
        1
    ];
    (0, $jjNRA).assert((0, $7MaPk).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $7MaPk).computePool2DInfo(x.shape, filterSize, strides, dilations, pad);
    const uniformData = [
        {
            type: 'int32',
            data: [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        },
        {
            type: 'int32',
            data: [
                convInfo.effectiveFilterHeight,
                convInfo.effectiveFilterWidth
            ]
        }
    ];
    let program = new (0, $fmchZ.Pool2DProgram)(convInfo, 'max', false);
    const poolOutput = backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
    program = new (0, $fmchZ.Pool2DProgram)(convInfo, 'max', true, true, includeBatchInIndex);
    const indexOutput = backend.runWebGPUProgram(program, [
        x
    ], 'int32', uniformData);
    return [
        poolOutput,
        indexOutput
    ];
}
const $aeef706508ca2ca3$export$a069ee2247a7d1ce = {
    kernelName: (0, $hl418.MaxPoolWithArgmax),
    backendName: 'webgpu',
    kernelFunc: $aeef706508ca2ca3$export$3d8b1b819d23351e
};

});

parcelRegister("1gwEz", function(module, exports) {

$parcel$export(module.exports, "minConfig", () => $0ec09d56b94fa62e$export$3cd9f9a31b38cf18);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $qiVpd = parcelRequire("qiVpd");
function $0ec09d56b94fa62e$export$96ec731ed4dcb222(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    return (0, $qiVpd.reduce)(x, axis, keepDims, 'min', backend);
}
const $0ec09d56b94fa62e$export$3cd9f9a31b38cf18 = {
    kernelName: (0, $hl418.Min),
    backendName: 'webgpu',
    kernelFunc: $0ec09d56b94fa62e$export$96ec731ed4dcb222
};

});

parcelRegister("4qe56", function(module, exports) {

$parcel$export(module.exports, "minimumConfig", () => $3384835e891d50e9$export$ea24ffbbbce8d546);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $3384835e891d50e9$export$916782c1f0ddb132 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).MIN,
    cpuKernelImpl: (0, $aLZc7.minimumImplCPU)
});
const $3384835e891d50e9$export$ea24ffbbbce8d546 = {
    kernelName: (0, $hl418.Minimum),
    backendName: 'webgpu',
    kernelFunc: $3384835e891d50e9$export$916782c1f0ddb132
};

});

parcelRegister("iUD6m", function(module, exports) {

$parcel$export(module.exports, "mirrorPadConfig", () => $dc4bc9b18e37fadc$export$2cfd6c6c7daeb5fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $efrMA = parcelRequire("efrMA");
const $dc4bc9b18e37fadc$export$2cfd6c6c7daeb5fc = {
    kernelName: (0, $hl418.MirrorPad),
    backendName: 'webgpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { paddings: paddings, mode: mode } = attrs;
        const webGPUBackend = backend;
        const uniformData = paddings.map((p)=>{
            return {
                type: 'int32',
                data: [
                    p[0],
                    p[1]
                ]
            };
        });
        const program = new (0, $efrMA.MirrorPadProgram)(x.shape, paddings, mode);
        const output = webGPUBackend.runWebGPUProgram(program, [
            x
        ], x.dtype, uniformData);
        return output;
    }
};

});
parcelRegister("efrMA", function(module, exports) {

$parcel$export(module.exports, "MirrorPadProgram", () => $a5f80478beb49602$export$284b676bb83fc2a7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $a5f80478beb49602$export$284b676bb83fc2a7 {
    constructor(xShape, paddings, mode){
        this.uniforms = '';
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.xShape = xShape;
        paddings.map((_, i)=>{
            this.uniforms += ` pad${i} : vec2<i32>,`;
        });
        this.offset = mode === 'reflect' ? 0 : 1;
        this.shaderKey = `mirrorPad_${mode}`;
    }
    getUserCode() {
        const rank = this.xShape.length;
        // The length of paddings are same with the rank of the input tensor.
        const start = this.xShape.map((_, i)=>`uniforms.pad${i}[0]`).join(',');
        const end = this.xShape.map((_, i)=>`uniforms.pad${i}[0] + uniforms.xShape${rank > 1 ? `[${i}]` : ''}`).join(',');
        const shaderStart = rank === 1 ? 'start' : 'start[i]';
        const shaderEnd = rank === 1 ? 'end' : 'end[i]';
        const shaderOutC = rank === 1 ? 'outC' : 'outC[i]';
        const dtype = (0, $oGQBh.getCoordsDataType)(rank);
        const unpackedCoords = rank > 1 ? [
            'coords[0]',
            'coords[1]',
            'coords[2]',
            'coords[3]'
        ].slice(0, rank) : 'coords';
        return `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let start = ${dtype}(${start});
          let end = ${dtype}(${end});
          var outC = getCoordsFromIndex(index);
          for (var i = 0; i < ${rank}; i = i + 1) {
            if (${shaderOutC} < ${shaderStart}) {
              ${shaderOutC} = ${shaderStart} * 2 - ${shaderOutC} - ${this.offset};
            } else if(${shaderOutC} >= ${shaderEnd}) {
              ${shaderOutC} = (${shaderEnd} - 1) * 2 - ${shaderOutC} + ${this.offset};
            }
          }
          let coords = outC - start;
          setOutputAtIndex(index, getX(${unpackedCoords}));
        }
      }
    `;
    }
}

});


parcelRegister("7Q00V", function(module, exports) {

$parcel$export(module.exports, "modConfig", () => $5b4d6682fba9cab9$export$9037685a81180a9c);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");
const $5b4d6682fba9cab9$export$842a2cf37af977e1 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).MOD
});
const $5b4d6682fba9cab9$export$9037685a81180a9c = {
    kernelName: (0, $hl418.Mod),
    backendName: 'webgpu',
    kernelFunc: $5b4d6682fba9cab9$export$842a2cf37af977e1
};

});

parcelRegister("kW16T", function(module, exports) {

$parcel$export(module.exports, "multinomialConfig", () => $f3da15e8f9f778ca$export$ad960e364767f0e2);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $8XOQD = parcelRequire("8XOQD");

var $hnITQ = parcelRequire("hnITQ");
function $f3da15e8f9f778ca$export$f4d580f3101a1c7e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { numSamples: numSamples, seed: seed, normalized: normalized } = attrs;
    const probs = normalized ? logits : (0, $hnITQ.softmax)({
        inputs: {
            logits: logits
        },
        backend: backend,
        attrs: {
            dim: logits.shape.length - 1
        }
    });
    const batchSize = probs.shape[0];
    const numOutcomes = probs.shape[1];
    const program = new (0, $8XOQD.MultinomialProgram)(batchSize, numSamples);
    const uniformData = [
        {
            type: 'float32',
            data: [
                seed
            ]
        },
        {
            type: 'int32',
            data: [
                numOutcomes
            ]
        }
    ];
    const res = backend.runWebGPUProgram(program, [
        probs
    ], 'int32', uniformData);
    if (!normalized) backend.disposeData(probs.dataId);
    return res;
}
const $f3da15e8f9f778ca$export$ad960e364767f0e2 = {
    kernelName: (0, $hl418.Multinomial),
    backendName: 'webgpu',
    kernelFunc: $f3da15e8f9f778ca$export$f4d580f3101a1c7e
};

});
parcelRegister("8XOQD", function(module, exports) {

$parcel$export(module.exports, "MultinomialProgram", () => $686b46c69f9942cc$export$f8cda6c8ea4f2110);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $686b46c69f9942cc$export$f8cda6c8ea4f2110 {
    constructor(batchSize, numSamples){
        this.variableNames = [
            'probs'
        ];
        this.outputShape = [];
        this.uniforms = 'seed : f32, numOutcomes: i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            batchSize,
            numSamples
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'multinomial';
    }
    getUserCode() {
        const userCode = `
    //Based on the work of Dave Hoskins
    //https://www.shadertoy.com/view/4djSRW
    fn random (seed : f32, resultUV : vec2<f32>) -> f32 {
      let HASHSCALE1 = 443.8975;
      let p = resultUV * seed;
      var p3  = fract(vec3<f32>(p.xyx) * HASHSCALE1);
      p3 = p3 + dot(p3, p3.yzx + 19.19);
      return fract((p3.x + p3.y) * p3.z);
    }

    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let coords = getOutputCoords();
        let batch = coords[0];

        let resUV = vec2<f32>(f32(coords[1]) / f32(uniforms.outShape[1]),
            f32(coords[0]) / f32(uniforms.outShape[0]));
        let r = random(uniforms.seed, resUV);
        var cdf = 0.0;
        for (var i = 0; i < uniforms.numOutcomes - 1; i = i + 1) {
          cdf = cdf + getProbs(batch, i);

          if (r < cdf) {
            setOutputAtIndexI32(index, i);
            return;
          }
        }

        // If no other event happened, last event happened.
        setOutputAtIndexI32(index, uniforms.numOutcomes - 1);
      }
    }
  `;
        return userCode;
    }
}

});

parcelRegister("hnITQ", function(module, exports) {

$parcel$export(module.exports, "softmax", () => $ca7769d2b2659656$export$e008137e76238601);
$parcel$export(module.exports, "softmaxConfig", () => $ca7769d2b2659656$export$c022691f23e2ee69);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $FZS30 = parcelRequire("FZS30");

var $gj4T5 = parcelRequire("gj4T5");
function $ca7769d2b2659656$export$e008137e76238601(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { dim: dim } = attrs;
    const logitsReshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: logits
        },
        backend: backend,
        attrs: {
            shape: [
                (0, $jjNRA).sizeFromShape(logits.shape) / logits.shape[dim],
                logits.shape[dim]
            ]
        }
    });
    const program = new (0, $FZS30.SoftmaxProgram)(logitsReshaped.shape);
    const res = backend.runWebGPUProgram(program, [
        logitsReshaped
    ], logits.dtype);
    const resReshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: logits.shape
        }
    });
    backend.disposeData(logitsReshaped.dataId);
    backend.disposeData(res.dataId);
    return resReshaped;
}
const $ca7769d2b2659656$export$c022691f23e2ee69 = {
    kernelName: (0, $hl418.Softmax),
    backendName: 'webgpu',
    kernelFunc: $ca7769d2b2659656$export$e008137e76238601
};

});
parcelRegister("FZS30", function(module, exports) {

$parcel$export(module.exports, "SoftmaxProgram", () => $07e3d2b076f74071$export$f5cbdf455df96cd3);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $07e3d2b076f74071$export$f5cbdf455df96cd3 {
    constructor(outputShape){
        this.variableNames = [
            'logits'
        ];
        this.outputShape = outputShape; // [rows, cols]
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = [
            this.outputShape[0],
            1,
            1
        ];
        if (this.outputShape[1] >= 4096) this.workgroupSize = [
            256,
            1,
            1
        ];
        else this.workgroupSize = [
            64,
            1,
            1
        ];
        this.shaderKey = 'softmax';
    }
    getUserCode() {
        const userCode = `
    var<workgroup> buf : array<f32, ${this.workgroupSize[0]}>;
    var<workgroup> rowMaxShared : f32;
    var<workgroup> rowSumShared : f32;
    const blockSize = ${this.workgroupSize[0]};
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      let row = index / blockSize;
      let tid = i32(localId.x);
      let cols = uniforms.outShape[1];

      var threadMax = -3.402823e+38f;
      for (var col = tid; col < cols; col += blockSize) {
        let value = getLogits(row, col);
        threadMax = max(threadMax, value);
      }
      if (tid < cols) {
        buf[tid] = threadMax;
      }
      workgroupBarrier();

      var reduceSize = min(cols, blockSize);
      for (var currSize = reduceSize >> 1;  currSize > 0; currSize = reduceSize >> 1) {
        reduceSize = currSize + (reduceSize & 1);
        if (tid < currSize) {
          buf[tid] = max(buf[tid], buf[tid + reduceSize]);
        }
        workgroupBarrier();
      }

      if (tid == 0) {
        rowMaxShared = buf[0];
      }
      workgroupBarrier();

      var threadSum = 0.0;
      for (var col = tid; col < cols; col += blockSize) {
        let subExp = exp(getLogits(row, col) - rowMaxShared);
        threadSum += subExp;
      }
      buf[tid] = threadSum;
      workgroupBarrier();

      for (var currSize = blockSize >> 1;  currSize > 0; currSize = currSize >> 1) {
        if (tid < currSize) {
          buf[tid] = buf[tid] + buf[tid + currSize];
        }
        workgroupBarrier();
      }

      if (tid == 0) {
        rowSumShared = buf[0];
      }
      workgroupBarrier();

      for (var col = tid; col < cols; col += blockSize) {
        let value = exp(getLogits(row, col) - rowMaxShared) / rowSumShared;
        setOutputAtCoords(row, col, value);
      }
  }
    `;
        return userCode;
    }
}

});



parcelRegister("5qXhN", function(module, exports) {

$parcel$export(module.exports, "negConfig", () => $3f4d5e6bf655014a$export$cc7b18b8229c3db);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $aLZc7 = parcelRequire("aLZc7");

var $8Y5Lq = parcelRequire("8Y5Lq");

var $2b4Nh = parcelRequire("2b4Nh");
function $3f4d5e6bf655014a$export$d9493ff0dfa0fdd5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const xData = backend.tensorMap.get(x.dataId);
        const [outValues, newShape] = (0, $aLZc7.negImplCPU)(xData.values, x.shape, x.dtype);
        return backend.makeTensorInfo(newShape, x.dtype, outValues);
    }
    const program = new (0, $2b4Nh.UnaryOpProgram)(x.shape, (0, $8Y5Lq.UnaryOpType).NEG);
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype);
}
const $3f4d5e6bf655014a$export$cc7b18b8229c3db = {
    kernelName: (0, $hl418.Neg),
    backendName: 'webgpu',
    kernelFunc: $3f4d5e6bf655014a$export$d9493ff0dfa0fdd5
};

});

parcelRegister("lS3ay", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Config", () => $fec1197200218bf6$export$549561cd158f260a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $lzjc8 = parcelRequire("lzjc8");
var $hl418 = parcelRequire("hl418");
function $fec1197200218bf6$export$8917e4bf7f7f5d42(args) {
    console.warn("tf.nonMaxSuppression() in webgpu locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const { selectedIndices: selectedIndices } = (0, $lzjc8).nonMaxSuppressionV3Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    return backend.makeTensorInfo([
        selectedIndices.length
    ], 'int32', new Int32Array(selectedIndices));
}
const $fec1197200218bf6$export$549561cd158f260a = {
    kernelName: (0, $hl418.NonMaxSuppressionV3),
    backendName: 'webgpu',
    kernelFunc: $fec1197200218bf6$export$8917e4bf7f7f5d42
};

});

parcelRegister("ixZRO", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV5Config", () => $d80b4c8c549c1975$export$4c00b682f309701d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $lzjc8 = parcelRequire("lzjc8");
var $hl418 = parcelRequire("hl418");
function $d80b4c8c549c1975$export$49e389fdbe01a534(args) {
    console.warn("tf.nonMaxSuppression() in webgpu locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const maxOutputSizeVal = maxOutputSize;
    const iouThresholdVal = iouThreshold;
    const scoreThresholdVal = scoreThreshold;
    const softNmsSigmaVal = softNmsSigma;
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = (0, $lzjc8).nonMaxSuppressionV5Impl(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([
            selectedScores.length
        ], 'float32', new Float32Array(selectedScores))
    ];
}
const $d80b4c8c549c1975$export$4c00b682f309701d = {
    kernelName: (0, $hl418.NonMaxSuppressionV5),
    backendName: 'webgpu',
    kernelFunc: $d80b4c8c549c1975$export$49e389fdbe01a534
};

});

parcelRegister("8Gjn7", function(module, exports) {

$parcel$export(module.exports, "oneHotConfig", () => $652145d1f02885eb$export$dde5645b472b80b2);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $ejU13 = parcelRequire("ejU13");

var $gj4T5 = parcelRequire("gj4T5");
function $652145d1f02885eb$export$341b5490a776d041(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices } = inputs;
    const { dtype: dtype, depth: depth, onValue: onValue, offValue: offValue } = attrs;
    const indicesSize = (0, $jjNRA).sizeFromShape(indices.shape);
    const program = new (0, $ejU13.OneHotProgram)(indicesSize, depth);
    const reshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                indicesSize
            ]
        }
    });
    const uniformData = [
        {
            type: 'float32',
            data: [
                onValue
            ]
        },
        {
            type: 'float32',
            data: [
                offValue
            ]
        }
    ];
    const result = backend.runWebGPUProgram(program, [
        reshaped
    ], dtype, uniformData);
    backend.disposeData(reshaped.dataId);
    const outShape = [
        ...indices.shape,
        depth
    ];
    const out = (0, $gj4T5.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeData(result.dataId);
    return out;
}
const $652145d1f02885eb$export$dde5645b472b80b2 = {
    kernelName: (0, $hl418.OneHot),
    backendName: 'webgpu',
    kernelFunc: $652145d1f02885eb$export$341b5490a776d041
};

});
parcelRegister("ejU13", function(module, exports) {

$parcel$export(module.exports, "OneHotProgram", () => $a6ce4aa3c63ac648$export$314e506cf5800fc5);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $a6ce4aa3c63ac648$export$314e506cf5800fc5 {
    constructor(numIndices, depth){
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'onValue : f32, offValue : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            numIndices,
            depth
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'onehot';
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if(index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          setOutputAtIndex(index, mix(uniforms.offValue, uniforms.onValue,
                                      f32(i32(round(getX(coords.x))) == coords.y)));
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("9F9Bf", function(module, exports) {

$parcel$export(module.exports, "onesLikeConfig", () => $708f63b377039421$export$d8d7015eb6ab37d0);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $lbBov = parcelRequire("lbBov");

var $cFwkm = parcelRequire("cFwkm");

var $2hp6b = parcelRequire("2hp6b");

var $6QjI0 = parcelRequire("6QjI0");

var $gX70G = parcelRequire("gX70G");
function $708f63b377039421$export$fb6afd6214fee9e9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('onesLike is not supported under string dtype');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $6QjI0.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $708f63b377039421$export$fb6afd6214fee9e9({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $2hp6b.imag)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = (0, $gX70G.zerosLike)({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $lbBov.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeData(realPart.dataId);
        backend.disposeData(r.dataId);
        backend.disposeData(imagPart.dataId);
        backend.disposeData(i.dataId);
        return result;
    } else return (0, $cFwkm.fill)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: 1
        },
        backend: backend
    });
}
const $708f63b377039421$export$d8d7015eb6ab37d0 = {
    kernelName: (0, $hl418.OnesLike),
    backendName: 'webgpu',
    kernelFunc: $708f63b377039421$export$fb6afd6214fee9e9
};

});
parcelRegister("gX70G", function(module, exports) {

$parcel$export(module.exports, "zerosLike", () => $c5779815860ce851$export$cb1f824e7733584d);
$parcel$export(module.exports, "zerosLikeConfig", () => $c5779815860ce851$export$15368df05c479e41);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $lbBov = parcelRequire("lbBov");

var $cFwkm = parcelRequire("cFwkm");

var $2hp6b = parcelRequire("2hp6b");

var $6QjI0 = parcelRequire("6QjI0");
function $c5779815860ce851$export$cb1f824e7733584d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'complex64') {
        const realPart = (0, $6QjI0.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $c5779815860ce851$export$cb1f824e7733584d({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $2hp6b.imag)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = $c5779815860ce851$export$cb1f824e7733584d({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $lbBov.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeData(realPart.dataId);
        backend.disposeData(r.dataId);
        backend.disposeData(imagPart.dataId);
        backend.disposeData(i.dataId);
        return result;
    } else return (0, $cFwkm.fill)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: x.dtype === 'string' ? '' : 0
        },
        backend: backend
    });
}
const $c5779815860ce851$export$15368df05c479e41 = {
    kernelName: (0, $hl418.ZerosLike),
    backendName: 'webgpu',
    kernelFunc: $c5779815860ce851$export$cb1f824e7733584d
};

});


parcelRegister("bidIZ", function(module, exports) {

$parcel$export(module.exports, "packConfig", () => $838c05987b12f392$export$1645fa8803aa1f86);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $2UdAg = parcelRequire("2UdAg");

var $5N59B = parcelRequire("5N59B");
function $838c05987b12f392$export$2a703dbb0cb35339(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    if (inputs.length === 1) return (0, $5N59B.expandDims)({
        inputs: {
            input: inputs[0]
        },
        backend: backend,
        attrs: {
            dim: axis
        }
    });
    const shape = inputs[0].shape;
    const dtype = inputs[0].dtype;
    inputs.forEach((t)=>{
        (0, $jjNRA).assertShapesMatch(shape, t.shape, 'All tensors passed to stack must have matching shapes');
        (0, $jjNRA).assert(dtype === t.dtype, ()=>'All tensors passed to stack must have matching dtypes');
    });
    const intermediateTensorInfos = [];
    const expandedTensors = inputs.map((t)=>{
        const expandedT = (0, $5N59B.expandDims)({
            inputs: {
                input: t
            },
            backend: backend,
            attrs: {
                dim: axis
            }
        });
        intermediateTensorInfos.push(expandedT);
        return expandedT;
    });
    const result = (0, $2UdAg.concat)({
        inputs: expandedTensors,
        backend: backend,
        attrs: {
            axis: axis
        }
    });
    intermediateTensorInfos.forEach((t)=>backend.disposeData(t.dataId));
    return result;
}
const $838c05987b12f392$export$1645fa8803aa1f86 = {
    kernelName: (0, $hl418.Pack),
    backendName: 'webgpu',
    kernelFunc: $838c05987b12f392$export$2a703dbb0cb35339
};

});

parcelRegister("HZHMf", function(module, exports) {

$parcel$export(module.exports, "padV2Config", () => $0843e19c656a3197$export$b0317e720bfd61fc);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $17o8l = parcelRequire("17o8l");

var $awJfI = parcelRequire("awJfI");

var $cFwkm = parcelRequire("cFwkm");
const $0843e19c656a3197$export$f676d6ad4f38bb89 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, constantValue: constantValue } = attrs;
    if (paddings.every((p)=>(0, $jjNRA).arraysEqual(p, [
            0,
            0
        ]))) return (0, $17o8l.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    if ((0, $jjNRA).sizeFromShape(x.shape) === 0) {
        // Short-circuit the computation, since x doesn't have value, only
        // the shape is used to compute output shape to pad.
        const outputShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
        return (0, $cFwkm.fill)({
            backend: backend,
            attrs: {
                shape: outputShape,
                value: constantValue,
                dtype: x.dtype
            }
        });
    }
    const uniformData = [
        {
            type: 'float32',
            data: [
                constantValue
            ]
        }
    ];
    paddings.map((p)=>uniformData.push({
            type: 'int32',
            data: [
                p[0],
                p[1]
            ]
        }));
    const program = new (0, $awJfI.PadProgram)(x.shape, paddings);
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
};
const $0843e19c656a3197$export$b0317e720bfd61fc = {
    kernelName: (0, $hl418.PadV2),
    backendName: 'webgpu',
    kernelFunc: $0843e19c656a3197$export$f676d6ad4f38bb89
};

});
parcelRegister("awJfI", function(module, exports) {

$parcel$export(module.exports, "padCommon", () => $7a9ffeb92b721089$export$dddcb5890916ec63);
$parcel$export(module.exports, "PadProgram", () => $7a9ffeb92b721089$export$15f19b307ce21f0a);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
function $7a9ffeb92b721089$export$dddcb5890916ec63(shape, fillZero = false) {
    const rank = shape.length;
    const type = (0, $oGQBh.getCoordsDataType)(rank);
    const start = shape.map((_, i)=>`uniforms.pad${i}[0]`).join(',');
    const end = shape.map((_, i)=>`uniforms.pad${i}[0] + uniforms.xShape${rank > 1 ? `[${i}]` : ''}`).join(',');
    const startValue = rank > 1 ? `${type}(${start})` : `${start}`;
    const endValue = rank > 1 ? `${type}(${end})` : `${end}`;
    const leftPadCondition = rank > 1 ? `any(paddedCoords < start)` : `paddedCoords < start`;
    const rightPadCondition = rank > 1 ? `any(paddedCoords >= end)` : `paddedCoords >= end`;
    const unpackedCoords = rank > 1 ? [
        'coords[0]',
        'coords[1]',
        'coords[2]',
        'coords[3]'
    ].slice(0, rank) : 'coords';
    return `
        let start = ${startValue};
        let end = ${endValue};
        if (${leftPadCondition} || ${rightPadCondition}) {
          setOutputAtIndex(index, ${fillZero ? 0.0 : 'uniforms.constantValue'});
        } else {
          let coords = paddedCoords - start;
          setOutputAtIndex(index, getX(${unpackedCoords}));
        }
  `;
}
class $7a9ffeb92b721089$export$15f19b307ce21f0a {
    constructor(xShape, paddings){
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'constantValue : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        paddings.map((_, i)=>{
            this.uniforms += ` pad${i} : vec2<i32>,`;
        });
        this.xShape = xShape;
        this.shaderKey = 'pad';
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let paddedCoords = getCoordsFromIndex(index);
          ${$7a9ffeb92b721089$export$dddcb5890916ec63(this.xShape)}
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("8pdtS", function(module, exports) {

$parcel$export(module.exports, "powConfig", () => $61eb1d8e2fcd42ff$export$b823d49786719761);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");
const $61eb1d8e2fcd42ff$export$9c297f60e22e3389 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).POW
});
const $61eb1d8e2fcd42ff$export$b823d49786719761 = {
    kernelName: (0, $hl418.Pow),
    backendName: 'webgpu',
    kernelFunc: $61eb1d8e2fcd42ff$export$9c297f60e22e3389
};

});

parcelRegister("8UebA", function(module, exports) {

$parcel$export(module.exports, "preluConfig", () => $67be8eba451efbc2$export$a5c4a9b694579636);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $25rfU = parcelRequire("25rfU");
function $67be8eba451efbc2$export$5882f235222e6729(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x, alpha: alpha } = inputs;
    const program = new (0, $25rfU.BinaryOpProgram)((0, $jJAz1.BinaryOpType).PRELU, x.shape, alpha.shape);
    return backend.runWebGPUProgram(program, [
        x,
        alpha
    ], 'float32');
}
const $67be8eba451efbc2$export$a5c4a9b694579636 = {
    kernelName: (0, $hl418.Prelu),
    backendName: 'webgpu',
    kernelFunc: $67be8eba451efbc2$export$5882f235222e6729
};

});

parcelRegister("hv5Ke", function(module, exports) {

$parcel$export(module.exports, "prodConfig", () => $cbd9c9b474482a57$export$d556aa935cef5c0c);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $qiVpd = parcelRequire("qiVpd");
function $cbd9c9b474482a57$export$5e143010dea16c85(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    return (0, $qiVpd.reduce)(x, axis, keepDims, 'prod', backend);
}
const $cbd9c9b474482a57$export$d556aa935cef5c0c = {
    kernelName: (0, $hl418.Prod),
    backendName: 'webgpu',
    kernelFunc: $cbd9c9b474482a57$export$5e143010dea16c85
};

});

parcelRegister("RdQ8e", function(module, exports) {

$parcel$export(module.exports, "rangeConfig", () => $09ffafa799e66bf9$export$361c4075706e31c2);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $aLZc7 = parcelRequire("aLZc7");
const $09ffafa799e66bf9$export$d02631cccf789723 = (args)=>{
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, step: step, dtype: dtype } = attrs;
    const values = (0, $aLZc7.rangeImplCPU)(start, stop, step, dtype);
    return backend.makeTensorInfo([
        values.length
    ], dtype, values);
};
const $09ffafa799e66bf9$export$361c4075706e31c2 = {
    kernelName: (0, $hl418.Range),
    backendName: 'webgpu',
    kernelFunc: $09ffafa799e66bf9$export$d02631cccf789723
};

});

parcelRegister("2Graj", function(module, exports) {

$parcel$export(module.exports, "realDivConfig", () => $1f4493767ee8a3bd$export$15c5d6176b30b9a6);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");
const $1f4493767ee8a3bd$export$f76766520aabd67 = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).DIV
});
const $1f4493767ee8a3bd$export$15c5d6176b30b9a6 = {
    kernelName: (0, $hl418.RealDiv),
    backendName: 'webgpu',
    kernelFunc: $1f4493767ee8a3bd$export$f76766520aabd67
};

});

parcelRegister("avwwZ", function(module, exports) {

$parcel$export(module.exports, "reciprocalConfig", () => $7a6608a46ec604e6$export$412a6b66203fdf72);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $7a6608a46ec604e6$export$163bc8c839a1ac04 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).RECIPROCAL
});
const $7a6608a46ec604e6$export$412a6b66203fdf72 = {
    kernelName: (0, $hl418.Reciprocal),
    backendName: 'webgpu',
    kernelFunc: $7a6608a46ec604e6$export$163bc8c839a1ac04
};

});

parcelRegister("jcy8m", function(module, exports) {

$parcel$export(module.exports, "reluConfig", () => $dfa99d99e6733f95$export$731f9199bde068eb);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $dfa99d99e6733f95$export$16d1e4612cc0139f = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).RELU
});
const $dfa99d99e6733f95$export$731f9199bde068eb = {
    kernelName: (0, $hl418.Relu),
    backendName: 'webgpu',
    kernelFunc: $dfa99d99e6733f95$export$16d1e4612cc0139f
};

});

parcelRegister("eQ0Bk", function(module, exports) {

$parcel$export(module.exports, "relu6Config", () => $acd6635ce87d6b96$export$92c30890ad649d53);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $acd6635ce87d6b96$export$4a62bcb95e9c44c4 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).RELU6
});
const $acd6635ce87d6b96$export$92c30890ad649d53 = {
    kernelName: (0, $hl418.Relu6),
    backendName: 'webgpu',
    kernelFunc: $acd6635ce87d6b96$export$4a62bcb95e9c44c4
};

});

parcelRegister("gV44p", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearConfig", () => $c515206dc74f65f1$export$a37a56137abc1357);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $dheTx = parcelRequire("dheTx");
function $c515206dc74f65f1$export$1f1cbc7da93d06a0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, size: size, halfPixelCenters: halfPixelCenters } = attrs;
    const [newHeight, newWidth] = size;
    const adjustHeight = alignCorners && newHeight > 1 ? 1.0 : 0.0;
    const adjustWidth = alignCorners && newWidth > 1 ? 1.0 : 0.0;
    const halfPixelCentersValue = halfPixelCenters ? 0.5 : 0.0;
    const uniformData = [
        {
            type: 'float32',
            data: [
                adjustHeight,
                adjustWidth
            ]
        },
        {
            type: 'float32',
            data: [
                halfPixelCentersValue
            ]
        }
    ];
    const program = new (0, $dheTx.ResizeBilinearProgram)(images.shape, newHeight, newWidth);
    return backend.runWebGPUProgram(program, [
        images
    ], 'float32', uniformData);
}
const $c515206dc74f65f1$export$a37a56137abc1357 = {
    kernelName: (0, $hl418.ResizeBilinear),
    backendName: 'webgpu',
    kernelFunc: $c515206dc74f65f1$export$1f1cbc7da93d06a0
};

});
parcelRegister("dheTx", function(module, exports) {

$parcel$export(module.exports, "ResizeBilinearProgram", () => $9aa86aaf38ec67f1$export$52b2ccd78b972549);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $9aa86aaf38ec67f1$export$52b2ccd78b972549 {
    constructor(inputShape, newHeight, newWidth){
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'adjustHeightWidth : vec2<f32>, halfPixelCenters : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            inputShape[0],
            newHeight,
            newWidth,
            inputShape[3]
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = `resizeBilinear`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
        let coords = getCoordsFromIndex(index);
          let b = coords[0];
          let d = coords[3];
          let rc = coords.yz;

          let effectiveInSize = vec2<f32>(
            f32(uniforms.xShape.y) - uniforms.adjustHeightWidth[0],
            f32(uniforms.xShape.z) - uniforms.adjustHeightWidth[1]);

          let effectiveOutSize = vec2<f32>(
            f32(uniforms.outShape.y) - uniforms.adjustHeightWidth[0],
            f32(uniforms.outShape.z) - uniforms.adjustHeightWidth[1]);

          let effectiveInputOverOutputRatioRC =
              effectiveInSize / effectiveOutSize;

          // Fractional source index
          let sourceFracIndexRC =
            (vec2<f32>(rc) + vec2<f32>(uniforms.halfPixelCenters)) *
            effectiveInputOverOutputRatioRC - vec2<f32>(uniforms.halfPixelCenters);

          // Compute the four integer indices.
          let sourceFloorRC = vec2<i32>(sourceFracIndexRC);
          let sourceCeilRC = vec2<i32>(
            min(vec2<f32>(uniforms.xShape.yz) - vec2<f32>(1.0), ceil(sourceFracIndexRC)));

          let topLeft = getX(b, sourceFloorRC.x, sourceFloorRC.y, d);
          let bottomLeft = getX(b, sourceCeilRC.x, sourceFloorRC.y, d);
          let topRight = getX(b, sourceFloorRC.x, sourceCeilRC.y, d);
          let bottomRight = getX(b, sourceCeilRC.x, sourceCeilRC.y, d);

          let fracRC = sourceFracIndexRC - vec2<f32>(sourceFloorRC);

          let top = topLeft + (topRight - topLeft) * fracRC.y;
          let bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;
          let newValue = top + (bottom - top) * fracRC.x;

          setOutputAtIndex(index, newValue);
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("gZHal", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearGradConfig", () => $c5f3d3acd6b6fe95$export$51f84ca614e84763);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $15zyG = parcelRequire("15zyG");
function $c5f3d3acd6b6fe95$export$8899506794ec394(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const [, xHeight, xWidth] = images.shape;
    const [, yHeight, yWidth] = dy.shape;
    const effectiveXSize = [
        alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
        alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
        alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
        alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    const invHeightScale = 1 / heightScale;
    const invWidthScale = 1 / widthScale;
    // This defines the size of the window of values around a particular
    // index in dy that we want to search for contributions to dx.
    const winHeight = Math.ceil(invHeightScale) * 2 + 2;
    const winWidth = Math.ceil(invWidthScale) * 2 + 2;
    const program = new (0, $15zyG.ResizeBilinearBackpropProgram)(images.shape, alignCorners);
    const uniformData = [
        {
            type: 'int32',
            data: effectiveXSize
        },
        {
            type: 'int32',
            data: effectiveYSize
        },
        {
            type: 'float32',
            data: [
                heightScale
            ]
        },
        {
            type: 'float32',
            data: [
                widthScale
            ]
        },
        {
            type: 'float32',
            data: [
                invHeightScale
            ]
        },
        {
            type: 'float32',
            data: [
                invWidthScale
            ]
        },
        {
            type: 'int32',
            data: [
                winHeight
            ]
        },
        {
            type: 'int32',
            data: [
                winWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy
    ], dy.dtype, uniformData);
}
const $c5f3d3acd6b6fe95$export$51f84ca614e84763 = {
    kernelName: (0, $hl418.ResizeBilinearGrad),
    backendName: 'webgpu',
    kernelFunc: $c5f3d3acd6b6fe95$export$8899506794ec394
};

});
parcelRegister("15zyG", function(module, exports) {

$parcel$export(module.exports, "ResizeBilinearBackpropProgram", () => $0cb1d73ca674df8a$export$dd552814323a3592);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $0cb1d73ca674df8a$export$dd552814323a3592 {
    constructor(inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.uniforms = `effectiveXSize : vec2<i32>, effectiveYSize : vec2<i32>, heightScale : f32, widthScale : f32,
       invHeightScale : f32, invWidthScale : f32, winHeight : i32, winWidth : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = inputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.alignCorners = alignCorners;
        this.shaderKey = `resizeBilinearBackprop_${alignCorners}`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getOutputCoords();
          let b = coords[0];
          let d = coords[3];
          let r = coords[1];
          let c = coords[2];

          var accumulator = 0.0;

          // Compute bounds for where in dy we will look
          let startRLerp = floor(f32(r) * uniforms.invHeightScale);
          let startDyR = i32(startRLerp - f32(uniforms.winHeight / 2));

          let startCLerp = floor(f32(c) * uniforms.invWidthScale);
          let startDyC = i32(startCLerp - f32(uniforms.winWidth / 2));

          // Loop over dy
          for (var dyROffset = 0; dyROffset < uniforms.winHeight; dyROffset++) {
            let dyR = startDyR + dyROffset;

            // Guard against the window exceeding the bounds of dy
            if (dyR < 0 || dyR >= uniforms.dyShape[1]) {
              continue;
            }

            for (var dyCOffset = 0; dyCOffset < uniforms.winWidth; dyCOffset++) {
              let dyC = startDyC + dyCOffset;

              // Guard against the window exceeding the bounds of dy
              if (dyC < 0 || dyC >= uniforms.dyShape[2]) {
                continue;
              }

              let dxR = f32(dyR) * uniforms.heightScale;
              let topDxRIndex = i32(floor(dxR));
              let bottomDxRIndex = i32(min(ceil(dxR), f32(uniforms.outShape[1] - 1)));
              let dxRLerp = dxR - f32(topDxRIndex);
              let inverseDxRLerp = 1.0 - dxRLerp;

              let dxC = f32(dyC) * uniforms.widthScale;
              let leftDxCIndex = i32(floor(dxC));
              let rightDxCIndex = i32(min(ceil(dxC), f32(uniforms.outShape[2] - 1)));
              let dxCLerp = dxC - f32(leftDxCIndex);
              let inverseDxCLerp = 1.0 - dxCLerp;

              if (r == topDxRIndex && c == leftDxCIndex) {
                // topLeft
                accumulator +=
                  getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;
              }

              if (r == topDxRIndex && c == rightDxCIndex) {
                // topRight
                accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;
              }

              if (r == bottomDxRIndex && c == leftDxCIndex) {
                // bottomLeft
                accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;
              }

              if (r == bottomDxRIndex && c == rightDxCIndex) {
                // bottomRight
                accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;
              }
            }
          }
          // End loop over dy

          setOutputAtIndex(index, accumulator);
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("cqK1h", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborConfig", () => $90cb9c4c12cdab90$export$2b6a92caba113b89);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $fmx94 = parcelRequire("fmx94");
function $90cb9c4c12cdab90$export$74a902ae74ac2560(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    const [newHeight, newWidth] = size;
    const adjustHeight = alignCorners && newHeight > 1 ? 1.0 : 0.0;
    const adjustWidth = alignCorners && newWidth > 1 ? 1.0 : 0.0;
    // When align corners is false, we rounds the value with floor.
    const roundBase = alignCorners ? 0.5 : 0.0;
    const uniformData = [
        {
            type: 'float32',
            data: [
                adjustHeight,
                adjustWidth
            ]
        },
        {
            type: 'float32',
            data: [
                roundBase
            ]
        }
    ];
    const program = new (0, $fmx94.ResizeNearestNeighborProgram)(images.shape, newHeight, newWidth, halfPixelCenters);
    return backend.runWebGPUProgram(program, [
        images
    ], images.dtype, uniformData);
}
const $90cb9c4c12cdab90$export$2b6a92caba113b89 = {
    kernelName: (0, $hl418.ResizeNearestNeighbor),
    backendName: 'webgpu',
    kernelFunc: $90cb9c4c12cdab90$export$74a902ae74ac2560
};

});
parcelRegister("fmx94", function(module, exports) {

$parcel$export(module.exports, "ResizeNearestNeighborProgram", () => $b2f29f1163479e99$export$2218952be90fb74a);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $b2f29f1163479e99$export$2218952be90fb74a {
    constructor(inputShape, newHeight, newWidth, halfPixelCenters){
        this.variableNames = [
            'x'
        ];
        this.uniforms = 'adjustHeightWidth : vec2<f32>, roundBase : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = [
            inputShape[0],
            newHeight,
            newWidth,
            inputShape[3]
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.halfPixelCenters = halfPixelCenters;
        this.shaderKey = `resizeNearest_${halfPixelCenters}`;
    }
    getUserCode() {
        let sourceFracIndexRC;
        if (this.halfPixelCenters) sourceFracIndexRC = `max((vec2<f32>(rc) + vec2<f32>(0.5)) * effectiveInputOverOutputRatioRC` + `, vec2<f32>(0.0))`;
        else sourceFracIndexRC = `vec2<f32>(rc) * effectiveInputOverOutputRatioRC`;
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let b = coords[0];
          let d = coords[3];
          let rc = coords.yz;

          let effectiveInSize = vec2<f32>(
            f32(uniforms.xShape.y) - uniforms.adjustHeightWidth[0],
            f32(uniforms.xShape.z) - uniforms.adjustHeightWidth[1]);

          let effectiveOutSize = vec2<f32>(
            f32(uniforms.outShape.y) - uniforms.adjustHeightWidth[0],
            f32(uniforms.outShape.z) - uniforms.adjustHeightWidth[1]);

          let effectiveInputOverOutputRatioRC =
              effectiveInSize / effectiveOutSize;

          // Fractional source index
          let sourceFracIndexRC = ${sourceFracIndexRC};

          // Compute the coordinators of nearest neighbor point.
          let inputShapeRC = vec2<f32>(f32(uniforms.xShape.y), f32(uniforms.xShape.z));
          let sourceNearestRC = vec2<i32>(
            min(inputShapeRC - 1.0, floor(sourceFracIndexRC + uniforms.roundBase)));
          let newValue = getX(b, sourceNearestRC.x, sourceNearestRC.y, d);

          setOutputAtIndex(index, newValue);
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("fp3ip", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborGradConfig", () => $b36bbf540f3feb81$export$2b08d810b5090fe1);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $iCeGW = parcelRequire("iCeGW");
function $b36bbf540f3feb81$export$2b75795f158f1b18(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const [, xHeight, xWidth] = images.shape;
    const [, yHeight, yWidth] = dy.shape;
    const effectiveXSize = [
        alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
        alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
        alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
        alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    const invHeightScale = 1 / heightScale;
    const invWidthScale = 1 / widthScale;
    // This defines the size of the window of values around a particular
    // index in dy that we want to search for contributions to dx.
    const winHeight = Math.ceil(invHeightScale) * 2 + 2;
    const winWidth = Math.ceil(invWidthScale) * 2 + 2;
    const program = new (0, $iCeGW.ResizeNearestNeigborBackpropProgram)(images.shape, alignCorners);
    const uniformData = [
        {
            type: 'int32',
            data: effectiveXSize
        },
        {
            type: 'int32',
            data: effectiveYSize
        },
        {
            type: 'float32',
            data: [
                invHeightScale
            ]
        },
        {
            type: 'float32',
            data: [
                invWidthScale
            ]
        },
        {
            type: 'int32',
            data: [
                winHeight
            ]
        },
        {
            type: 'int32',
            data: [
                winWidth
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        dy
    ], dy.dtype, uniformData);
}
const $b36bbf540f3feb81$export$2b08d810b5090fe1 = {
    kernelName: (0, $hl418.ResizeNearestNeighborGrad),
    backendName: 'webgpu',
    kernelFunc: $b36bbf540f3feb81$export$2b75795f158f1b18
};

});
parcelRegister("iCeGW", function(module, exports) {

$parcel$export(module.exports, "ResizeNearestNeigborBackpropProgram", () => $d8d72c077c664bc1$export$b6671a84abe827c4);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $d8d72c077c664bc1$export$b6671a84abe827c4 {
    constructor(inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.uniforms = `effectiveXSize : vec2<i32>, effectiveYSize : vec2<i32>, invHeightScale : f32, invWidthScale : f32,
       winHeight : i32, winWidth : i32,`;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = inputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.alignCorners = alignCorners;
        this.shaderKey = `resizeNearestNeigborBackprop_${alignCorners}`;
    }
    getUserCode() {
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getOutputCoords();
          let b = coords[0];
          let d = coords[3];
          let r = coords[1];
          let c = coords[2];

          var accumulator = 0.0;

          // Compute bounds for where in dy we will look
          let startRLerp = floor(f32(r) * uniforms.invHeightScale);
          let startDyR = i32(floor(startRLerp - f32(uniforms.winHeight / 2)));

          let startCLerp = floor(f32(c) * uniforms.invWidthScale);
          let startDyC = i32(floor(startCLerp - f32(uniforms.winWidth / 2)));

          // Loop over dy
          for (var dyROffset = 0; dyROffset < uniforms.winHeight; dyROffset++) {
            let dyR = startDyR + dyROffset;

            // Guard against the window exceeding the bounds of dy
            if (dyR < 0 || dyR >= uniforms.dyShape[1]) {
              continue;
            }

            for (var dyCOffset = 0; dyCOffset < uniforms.winWidth; dyCOffset++) {
              let dyC = startDyC + dyCOffset;

              // Guard against the window exceeding the bounds of dy
              if (dyC < 0 || dyC >= uniforms.dyShape[2]) {
                continue;
              }

              let sourceFracRow = f32(uniforms.effectiveXSize[0]) *
                  (f32(dyR) / f32(uniforms.effectiveYSize[0]));

              let sourceFracCol = f32(uniforms.effectiveXSize[1]) *
                  (f32(dyC) / f32(uniforms.effectiveYSize[1]));

              let sourceNearestRow =
                  i32(min(f32(uniforms.outShape[1] - 1),
                  ${this.alignCorners ? 'floor(sourceFracRow + 0.5)' : 'floor(sourceFracRow)'}));

              let sourceNearestCol =
                  i32(min(f32(uniforms.outShape[2] - 1),
                  ${this.alignCorners ? 'floor(sourceFracCol + 0.5)' : 'floor(sourceFracCol)'}));

              if (r == sourceNearestRow && c == sourceNearestCol) {
                accumulator += getDy(b, dyR, dyC, d);
              }
            }
          }
          // End loop over dy

          setOutputAtIndex(index, accumulator);
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("74ZZK", function(module, exports) {

$parcel$export(module.exports, "reverseConfig", () => $5278ff0173cd7698$export$cab6a4e8d2ed8e8d);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $4OB0M = parcelRequire("4OB0M");

var $17o8l = parcelRequire("17o8l");

var $gj4T5 = parcelRequire("gj4T5");
function $5278ff0173cd7698$export$66c1ae025e96b4bc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dims: dims } = attrs;
    const xRank = x.shape.length;
    if (xRank === 0) return (0, $17o8l.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const xShape = x.shape;
    const xShape4D = [
        1,
        1,
        1,
        1
    ];
    xShape.forEach((d, i)=>{
        const index = i + 4 - xRank;
        xShape4D[index] = d;
    });
    const axes = (0, $jjNRA).parseAxisParam(dims, x.shape);
    const dims4D = [
        0,
        0,
        0,
        0
    ];
    axes.forEach((ax)=>{
        const index = ax + 4 - xRank;
        dims4D[index] = 1;
    });
    const uniformData = [
        {
            type: 'int32',
            data: dims4D
        }
    ];
    const xReshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: xShape4D
        }
    });
    const program = new (0, $4OB0M.ReverseProgram)(xShape4D);
    const values = backend.runWebGPUProgram(program, [
        xReshaped
    ], xReshaped.dtype, uniformData);
    backend.disposeData(xReshaped.dataId);
    const result = (0, $gj4T5.reshape)({
        inputs: {
            x: values
        },
        backend: backend,
        attrs: {
            shape: xShape
        }
    });
    backend.disposeData(values.dataId);
    return result;
}
const $5278ff0173cd7698$export$cab6a4e8d2ed8e8d = {
    kernelName: (0, $hl418.Reverse),
    backendName: 'webgpu',
    kernelFunc: $5278ff0173cd7698$export$66c1ae025e96b4bc
};

});
parcelRegister("4OB0M", function(module, exports) {

$parcel$export(module.exports, "ReverseProgram", () => $38188aa8034507e7$export$abc2effa29e77e92);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $38188aa8034507e7$export$abc2effa29e77e92 {
    constructor(xShape){
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = xShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.uniforms = ` axis : vec4<i32>,`;
        this.shaderKey = 'reverse';
    }
    getUserCode() {
        const reverseCoordsSnippet = `
      // Using uniform variables as judging conditions, so the function has
      // coherent execution within all threads.
      fn getReverseCoords(coords : vec4<i32>) -> vec4<i32> {
        var reverseCoords = coords;
        if (uniforms.axis[0] == 1) {
          reverseCoords[0] = uniforms.xShape[0] - coords[0] - 1;
        }
        if (uniforms.axis[1] == 1) {
          reverseCoords[1] = uniforms.xShape[1] - coords[1] - 1;
        }
        if (uniforms.axis[2] == 1) {
          reverseCoords[2] = uniforms.xShape[2] - coords[2] - 1;
        }
        if (uniforms.axis[3] == 1) {
          reverseCoords[3] = uniforms.xShape[3] - coords[3] - 1;
        }

        return reverseCoords;
      }
    `;
        const userCode = `
      ${reverseCoordsSnippet}
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let reverseCoords = getReverseCoords(coords);
          setOutputAtIndex(index, getX(reverseCoords[0],
              reverseCoords[1], reverseCoords[2], reverseCoords[3]));
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("aDjD8", function(module, exports) {

$parcel$export(module.exports, "rotateWithOffsetConfig", () => $7bdcc6116f8e46f0$export$44ba8c83417ab668);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");

var $ludGt = parcelRequire("ludGt");
const $7bdcc6116f8e46f0$export$44ba8c83417ab668 = {
    kernelName: (0, $hl418.RotateWithOffset),
    backendName: 'webgpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const { radians: radians, fillValue: fillValue, center: center } = attrs;
        const webgpuBackend = backend;
        const program = new (0, $ludGt.RotateProgram)(image.shape, fillValue);
        const [centerX, centerY] = (0, $7MaPk).getImageCenter(center, image.shape[1], image.shape[2]);
        const uniformData = [
            {
                type: 'float32',
                data: [
                    centerX
                ]
            },
            {
                type: 'float32',
                data: [
                    centerY
                ]
            },
            {
                type: 'float32',
                data: [
                    Math.sin(radians)
                ]
            },
            {
                type: 'float32',
                data: [
                    Math.cos(radians)
                ]
            }
        ];
        if (typeof fillValue === 'number') uniformData.push({
            type: 'float32',
            data: [
                Number.parseFloat(fillValue.toFixed(2))
            ]
        });
        else uniformData.push({
            type: 'float32',
            data: fillValue
        });
        const output = webgpuBackend.runWebGPUProgram(program, [
            image
        ], image.dtype, uniformData);
        return output;
    }
};

});
parcelRegister("ludGt", function(module, exports) {

$parcel$export(module.exports, "RotateProgram", () => $fa4703af094d9686$export$a37df1d4e69844e7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $fa4703af094d9686$export$a37df1d4e69844e7 {
    constructor(imageShape, fillValue){
        this.outputShape = [];
        this.variableNames = [
            'x'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = imageShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.uniforms = `centerX : f32, centerY : f32, sinRadians : f32,
          cosRadians : f32,`;
        this.shaderKey = 'rotate';
        this.outputShape = imageShape;
        if (typeof fillValue === 'number') {
            this.uniforms += ` fillValue : f32,`;
            this.fillSnippet = `var outputValue = uniforms.fillValue;`;
            this.shaderKey += '_float';
        } else {
            this.uniforms += ` fillValue : vec3<f32>,`;
            this.fillSnippet = `var outputValue = uniforms.fillValue[coords[3]];`;
            this.shaderKey += '_vec3';
        }
    }
    getUserCode() {
        const userCode = `
        ${(0, $oGQBh.getMainHeaderString)('index')} {
          if (index < uniforms.size) {
            let coords = getCoordsFromIndex(index);
            let coordXFloat = (f32(coords[2]) - uniforms.centerX) *
                uniforms.cosRadians - (f32(coords[1]) - uniforms.centerY) *
                uniforms.sinRadians;
            let coordYFloat = (f32(coords[2]) - uniforms.centerX) *
                uniforms.sinRadians + (f32(coords[1]) - uniforms.centerY) *
                uniforms.cosRadians;
            let coordX = i32(round(coordXFloat + uniforms.centerX));
            let coordY = i32(round(coordYFloat + uniforms.centerY));
            ${this.fillSnippet}
            if(coordX >= 0 && coordX < uniforms.xShape[2] && coordY >= 0 &&
                coordY < uniforms.xShape[1]) {
              outputValue = getX(coords[0], coordY, coordX, coords[3]);
            }
            setOutputAtIndex(index, outputValue);
          }
        }
      `;
        return userCode;
    }
}

});


parcelRegister("31gFw", function(module, exports) {

$parcel$export(module.exports, "roundConfig", () => $232e6525816a5a30$export$6c09e3291f636503);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $232e6525816a5a30$export$2077e0241d6afd3c = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).ROUND
});
const $232e6525816a5a30$export$6c09e3291f636503 = {
    kernelName: (0, $hl418.Round),
    backendName: 'webgpu',
    kernelFunc: $232e6525816a5a30$export$2077e0241d6afd3c
};

});

parcelRegister("eu0UJ", function(module, exports) {

$parcel$export(module.exports, "rsqrtConfig", () => $a8b4938401c8d375$export$941104b789956ef6);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $a8b4938401c8d375$export$1cc01d192953037e = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).RSQRT,
    cpuKernelImpl: (0, $aLZc7.rsqrtImplCPU)
});
const $a8b4938401c8d375$export$941104b789956ef6 = {
    kernelName: (0, $hl418.Rsqrt),
    backendName: 'webgpu',
    kernelFunc: $a8b4938401c8d375$export$1cc01d192953037e
};

});

parcelRegister("i89sa", function(module, exports) {

$parcel$export(module.exports, "scatterNdConfig", () => $d3304e94569bcfc1$export$573371744f044f5);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $h6bNs = parcelRequire("h6bNs");

var $cFwkm = parcelRequire("cFwkm");

var $gj4T5 = parcelRequire("gj4T5");
function $d3304e94569bcfc1$export$b6f42038a536d877(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices, updates: updates } = inputs;
    const { shape: shape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $7MaPk).calculateShapes(updates, indices, shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(shape, indices.dtype);
    const flattenIndices = (0, $gj4T5.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $gj4T5.reshape)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    const type = flattenX.dtype;
    const output = (0, $cFwkm.fill)({
        backend: backend,
        attrs: {
            shape: flattenShape,
            value: 0,
            dtype: type
        }
    });
    const size = (0, $jjNRA).sizeFromShape(flattenX.shape);
    const uniformData = [
        {
            type: 'int32',
            data: [
                sliceRank
            ]
        },
        {
            type: 'int32',
            data: strides
        },
        {
            type: 'int32',
            data: [
                size
            ]
        }
    ];
    const program = new (0, $h6bNs.ScatterProgram)(flattenX.shape, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape, type);
    const res = backend.runWebGPUProgram(program, [
        flattenX,
        flattenIndices
    ], type, uniformData, output);
    const reshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shape
        }
    });
    backend.disposeData(flattenIndices.dataId);
    backend.disposeData(flattenX.dataId);
    backend.disposeData(res.dataId);
    return reshaped;
}
const $d3304e94569bcfc1$export$573371744f044f5 = {
    kernelName: (0, $hl418.ScatterNd),
    backendName: 'webgpu',
    kernelFunc: $d3304e94569bcfc1$export$b6f42038a536d877
};

});
parcelRegister("h6bNs", function(module, exports) {

$parcel$export(module.exports, "ScatterProgram", () => $c72c25c6be123f17$export$8d0317f5c5cbc1ac);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $arOgS = parcelRequire("arOgS");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $c72c25c6be123f17$export$8d0317f5c5cbc1ac {
    constructor(flattenXShape, sliceDim, indicesRank, updatesRank, strides, shape, outputDtype, sumDupeIndices = true){
        this.variableNames = [
            'updates',
            'indices'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = shape;
        this.type = outputDtype;
        this.sumDupeIndices = sumDupeIndices;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(flattenXShape);
        // Dispatching based on |updates| shape instead of output shape.
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, flattenXShape, this.workgroupSize);
        this.sliceDimGreaterThanOne = sliceDim > 1;
        this.shaderKey = `scatter_${indicesRank}_${updatesRank}_${this.sliceDimGreaterThanOne}_${outputDtype}_${sumDupeIndices}_${strides.length}`;
        const stridesType = (0, $oGQBh.getCoordsDataType)(strides.length);
        this.uniforms = `sliceDim : i32, strides: ${stridesType}, updatesSize: i32,`;
        this.updatesRank = updatesRank;
        this.indicesRank = indicesRank;
    }
    getUserCode() {
        let indicesString = '';
        if (this.indicesRank === 1) indicesString = 'coords[0]';
        else if (this.indicesRank === 2) indicesString = 'coords[0], j';
        const indicesSnippet = `getIndices(${indicesString})`;
        const strideString = this.sliceDimGreaterThanOne ? 'uniforms.strides[j]' : 'uniforms.strides';
        let outCoordsString = '';
        let getUpdatesCoordsFromFlatIndex = '';
        if (this.dispatchLayout.x.length === 1) {
            outCoordsString = 'flattenedIndex';
            getUpdatesCoordsFromFlatIndex = `
      fn getUpdatesCoordsFromFlatIndex(index : i32) -> i32 {
        return index;
      }
      `;
        } else if (this.dispatchLayout.x.length === 2) {
            outCoordsString = 'vec2<i32>(flattenedIndex, coords[1])';
            getUpdatesCoordsFromFlatIndex = `
      fn getUpdatesCoordsFromFlatIndex(index : i32) -> vec2<i32> {
        // N.B. |updates| could be a scalar tensor, conceptually representing a
        // 2D tensor with all values equal to that. By design, its size must be
        // the same as |outShape[1]| in one dimension, and |indicesShape[0]|
        // gives the other.
        let sliceSize = uniforms.outShape[1];
        let d0 = index / sliceSize;
        let d1 = index - d0 * sliceSize;
        return vec2<i32>(d0, d1);
      }
      `;
        }
        const updatesString = Array.from({
            length: this.updatesRank
        }, (_, idx)=>`coords[${idx}]`);
        const updatesSnippet = `getUpdates(${updatesString.join(', ')})`;
        const userCode = `
    ${getUpdatesCoordsFromFlatIndex}
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.updatesSize) {
          let coords = getUpdatesCoordsFromFlatIndex(index);
          var flattenedIndex = 0;
          for (var j = 0; j < uniforms.sliceDim; j = j + 1) {
            let indexInside = i32(round(${indicesSnippet}));
            flattenedIndex = flattenedIndex + indexInside * ${strideString};
          }
          let updateValue =
              ${(0, $oGQBh.dataTypeToGPUType)(this.type)}(${updatesSnippet});
          let flatIndex = getOutputIndexFromCoords(${outCoordsString});

          ${this.sumDupeIndices ? (0, $arOgS.atomicAddSnippet)('&result[flatIndex]', 'updateValue', this.type) : `atomicStore(&result[flatIndex], bitcast<i32>(updateValue));`}
        }
      }`;
        return userCode;
    }
}

});


parcelRegister("acUBN", function(module, exports) {

$parcel$export(module.exports, "searchSortedConfig", () => $76e6efa3b6f3c7f2$export$4b437b1a1aa6472f);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $qXW1n = parcelRequire("qXW1n");
function $76e6efa3b6f3c7f2$export$56fad8d65b0adbdd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sortedSequence: sortedSequence, values: values } = inputs;
    const { side: side } = attrs;
    const program = new (0, $qXW1n.SearchSortedProgram)([
        values.shape[0],
        values.shape[1]
    ], side);
    const uniformData = [
        {
            type: 'int32',
            data: [
                sortedSequence.shape[1]
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        sortedSequence,
        values
    ], 'int32', uniformData);
}
const $76e6efa3b6f3c7f2$export$4b437b1a1aa6472f = {
    kernelName: (0, $hl418.SearchSorted),
    backendName: 'webgpu',
    kernelFunc: $76e6efa3b6f3c7f2$export$56fad8d65b0adbdd
};

});
parcelRegister("qXW1n", function(module, exports) {

$parcel$export(module.exports, "SearchSortedProgram", () => $0510eba154c686e5$export$2511b5550383de5c);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $0510eba154c686e5$export$2511b5550383de5c {
    constructor(outputShape, side){
        this.outputShape = [];
        this.variableNames = [
            'sortedSequence',
            'values'
        ];
        this.uniforms = 'numInputs : i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.side = side;
        this.shaderKey = `search_sorted_${side}`;
    }
    getUserCode() {
        const boundComparator = this.side === 'left' ? '<' : '<=';
        const userCode = `
      fn findBound(batch: i32, value: f32) -> i32 {
        var left = i32(0);
        var right = uniforms.numInputs;
        while (left < right) {
          var mid = (left + right) / 2;
          if (getSortedSequence(batch, mid) ${boundComparator} value) {
            left = mid + 1;
          } else {
            right = mid;
          }
        }
        return right;
      }

      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let value = getValuesByOutputIndex(index);
          setOutputAtIndexI32(index, findBound(coords[0], value));
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("NUQCf", function(module, exports) {

$parcel$export(module.exports, "selectConfig", () => $0960ac79c89a10b6$export$7ff911e710ee72fc);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $2MDja = parcelRequire("2MDja");

var $cujsT = parcelRequire("cujsT");
function $0960ac79c89a10b6$export$2e6c959c16ff56b8(args) {
    const { inputs: inputs, backend: backend } = args;
    const { condition: condition, t: t, e: e } = inputs;
    const program = new (0, $cujsT.SelectProgram)(condition.shape.length, t.shape, t.shape.length);
    return backend.runWebGPUProgram(program, [
        condition,
        t,
        e
    ], (0, $2MDja.upcastType)(t.dtype, e.dtype));
}
const $0960ac79c89a10b6$export$7ff911e710ee72fc = {
    kernelName: (0, $hl418.Select),
    backendName: 'webgpu',
    kernelFunc: $0960ac79c89a10b6$export$2e6c959c16ff56b8
};

});
parcelRegister("cujsT", function(module, exports) {

$parcel$export(module.exports, "SelectProgram", () => $917762bafc8e9076$export$845ed2d1f74ef297);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $917762bafc8e9076$export$845ed2d1f74ef297 {
    constructor(cRank, shape, rank){
        this.variableNames = [
            'c',
            'a',
            'b'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.cRank = cRank;
        this.rank = rank;
        this.shaderKey = 'select';
    }
    getUserCode() {
        // TODO(WGSL): below code can be merged with getUserCode.
        let cCoords;
        let abCoords;
        if (this.rank > 4) throw Error(`Where for rank ${this.rank} is not yet supported`);
        if (this.rank === 1) {
            abCoords = `resRC`;
            cCoords = `resRC`;
        } else {
            const currentCoords = [
                'resRC.x',
                'resRC.y',
                'resRC.z',
                'resRC.w'
            ];
            const cCoordVars = [];
            const abCoordVars = [];
            for(let i = 0; i < this.outputShape.length; i++){
                abCoordVars.push(`${currentCoords[i]}`);
                if (i < this.cRank) cCoordVars.push(`${currentCoords[i]}`);
            }
            cCoords = cCoordVars.join();
            abCoords = abCoordVars.join();
        }
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let resRC = getCoordsFromIndex(index);
          let cVal = getC(${cCoords});
          if (cVal >= 1.0) {
            setOutputAtIndex(index, getA(${abCoords}));
          } else {
            setOutputAtIndex(index, getB(${abCoords}));
          }
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("i164A", function(module, exports) {

$parcel$export(module.exports, "seluConfig", () => $d1dd07f950d6db63$export$8afc8558705c1a39);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $d1dd07f950d6db63$export$a5f8240d9e99b438 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).SELU
});
const $d1dd07f950d6db63$export$8afc8558705c1a39 = {
    kernelName: (0, $hl418.Selu),
    backendName: 'webgpu',
    kernelFunc: $d1dd07f950d6db63$export$a5f8240d9e99b438
};

});

parcelRegister("bO3Wh", function(module, exports) {

$parcel$export(module.exports, "sigmoidConfig", () => $89876b66dd8ad386$export$195d1cf7c59f3ef);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $89876b66dd8ad386$export$3b295495ca3cad7c = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).SIGMOID
});
const $89876b66dd8ad386$export$195d1cf7c59f3ef = {
    kernelName: (0, $hl418.Sigmoid),
    backendName: 'webgpu',
    kernelFunc: $89876b66dd8ad386$export$3b295495ca3cad7c
};

});

parcelRegister("ae3G5", function(module, exports) {

$parcel$export(module.exports, "signConfig", () => $771e1080db2eb929$export$9c0fb3eb2124ceb7);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $771e1080db2eb929$export$c5552dfdbc7cec71 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).SIGN
});
const $771e1080db2eb929$export$9c0fb3eb2124ceb7 = {
    kernelName: (0, $hl418.Sign),
    backendName: 'webgpu',
    kernelFunc: $771e1080db2eb929$export$c5552dfdbc7cec71
};

});

parcelRegister("cWpcA", function(module, exports) {

$parcel$export(module.exports, "sinConfig", () => $96be7367100b3bff$export$d993ec4e5c253b66);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $96be7367100b3bff$export$5de3937cb4b592ed = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).SIN
});
const $96be7367100b3bff$export$d993ec4e5c253b66 = {
    kernelName: (0, $hl418.Sin),
    backendName: 'webgpu',
    kernelFunc: $96be7367100b3bff$export$5de3937cb4b592ed
};

});

parcelRegister("dxrYi", function(module, exports) {

$parcel$export(module.exports, "sinhConfig", () => $9db40e0016e358e0$export$b92766b47f18ac85);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $9db40e0016e358e0$export$545004b505d7c555 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).SINH
});
const $9db40e0016e358e0$export$b92766b47f18ac85 = {
    kernelName: (0, $hl418.Sinh),
    backendName: 'webgpu',
    kernelFunc: $9db40e0016e358e0$export$545004b505d7c555
};

});

parcelRegister("haqGf", function(module, exports) {

$parcel$export(module.exports, "softplusConfig", () => $c7f810fe099d318e$export$d9bcfe553d12d9e3);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $c7f810fe099d318e$export$76aa560a8c2b0055 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).SOFTPLUS
});
const $c7f810fe099d318e$export$d9bcfe553d12d9e3 = {
    kernelName: (0, $hl418.Softplus),
    backendName: 'webgpu',
    kernelFunc: $c7f810fe099d318e$export$76aa560a8c2b0055
};

});

parcelRegister("8zbc3", function(module, exports) {

$parcel$export(module.exports, "spaceToBatchNDConfig", () => $63ca466237f8f950$export$2f85417863d2050b);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $96CEx = parcelRequire("96CEx");

var $gj4T5 = parcelRequire("gj4T5");
const $63ca466237f8f950$export$effb9d7cae92012f = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, paddings: paddings } = attrs;
    (0, $jjNRA).assert(x.shape.length <= 4, ()=>"spaceToBatchND for rank > 4 with a WebGPU backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const completePaddings = [
        [
            0,
            0
        ]
    ];
    completePaddings.push(...paddings);
    for(let i = 1 + blockShape.length; i < x.shape.length; ++i)completePaddings.push([
        0,
        0
    ]);
    const paddedXShape = completePaddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
    const reshapedPaddedShape = (0, $7MaPk).getReshaped(paddedXShape, blockShape, prod, false);
    const permutedReshapedPaddedPermutation = (0, $7MaPk).getPermuted(reshapedPaddedShape.length, blockShape.length, false);
    const flattenShape = (0, $7MaPk).getReshapedPermuted(paddedXShape, blockShape, prod, false);
    const paddedXShapeStrides = (0, $jjNRA).computeStrides(paddedXShape);
    const program = new (0, $96CEx.SpaceToBatchNDProgram)(x.shape, paddedXShape, completePaddings, reshapedPaddedShape, permutedReshapedPaddedPermutation, paddedXShapeStrides.length);
    const uniformData = [
        {
            type: 'int32',
            data: reshapedPaddedShape
        },
        {
            type: 'int32',
            data: paddedXShapeStrides
        }
    ];
    completePaddings.map((p)=>uniformData.push({
            type: 'int32',
            data: [
                p[0],
                p[1]
            ]
        }));
    const paddedXT = backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
    const result = (0, $gj4T5.reshape)({
        inputs: {
            x: paddedXT
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    backend.disposeData(paddedXT.dataId);
    return result;
};
const $63ca466237f8f950$export$2f85417863d2050b = {
    kernelName: (0, $hl418.SpaceToBatchND),
    backendName: 'webgpu',
    kernelFunc: $63ca466237f8f950$export$effb9d7cae92012f
};

});
parcelRegister("96CEx", function(module, exports) {

$parcel$export(module.exports, "SpaceToBatchNDProgram", () => $6a12a8407f0a4d81$export$9c8dd2624b1658e3);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $awJfI = parcelRequire("awJfI");

var $lCb9L = parcelRequire("lCb9L");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $6a12a8407f0a4d81$export$9c8dd2624b1658e3 {
    constructor(xShape, paddedXShape, paddings, reshapedPaddedXShape, newDim, paddedXShapeStridesShapeLength){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        this.uniforms = '';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        const outputShape = new Array(reshapedPaddedXShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = reshapedPaddedXShape[newDim[i]];
        this.outputShape = outputShape;
        this.newDim = newDim;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.xShape = xShape;
        this.paddedXShape = paddedXShape;
        this.uniforms += `reshapedPaddedXShape : ${(0, $oGQBh.getCoordsDataType)(reshapedPaddedXShape.length)}, paddedXShapeStrides : ${(0, $oGQBh.getCoordsDataType)(paddedXShapeStridesShapeLength)}, `;
        paddings.map((_, i)=>{
            this.uniforms += ` pad${i} : vec2<i32>,`;
        });
        this.shaderKey = `spaceToBatchND_${newDim}`;
    }
    getUserCode() {
        const dtype = (0, $oGQBh.getCoordsDataType)(this.outputShape.length);
        const switched = (0, $lCb9L.getSwitchedCoords)(this.newDim);
        const userCode = `
      ${(0, $oGQBh.getCoordsFromIndexSnippet)(this.paddedXShape, 'PaddedX')}
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if(index < uniforms.size) {
          let coords = getCoordsFromIndex(index);
          let switchedIndex = getIndexFromCoords${this.outputShape.length}D(${dtype}(${switched}), uniforms.reshapedPaddedXShape);
          let paddedCoords = getPaddedXCoordsFromIndex(switchedIndex);
          ${(0, $awJfI.padCommon)(this.xShape, true)}
        }
      }
    `;
        return userCode;
    }
}

});


parcelRegister("873vJ", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentMeanConfig", () => $5e81b35f5dafd88f$export$51e7224ae14d7f78);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $1w45V = parcelRequire("1w45V");
function $5e81b35f5dafd88f$export$dbc0c9096869d04e(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    return (0, $1w45V.sparseSegmentReduce)(data, indices, segmentIds, false, backend);
}
const $5e81b35f5dafd88f$export$51e7224ae14d7f78 = {
    kernelName: (0, $hl418.SparseSegmentMean),
    backendName: 'webgpu',
    kernelFunc: $5e81b35f5dafd88f$export$dbc0c9096869d04e
};

});
parcelRegister("1w45V", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentReduce", () => $11abf4b76e6057d1$export$f1b2d24dec0cd5f);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $jjNRA = parcelRequire("jjNRA");

var $cFwkm = parcelRequire("cFwkm");

var $gzeZg = parcelRequire("gzeZg");
function $11abf4b76e6057d1$export$f1b2d24dec0cd5f(input, indices, segmentIds, isSum = false, backend) {
    const inputSize = (0, $jjNRA).sizeFromShape(input.shape);
    const segmentSize = inputSize / input.shape[0];
    const dtype = input.dtype;
    // Note that the current implementation assumes that segmentIds values are
    // sorted.
    const numIndices = (0, $jjNRA).sizeFromShape(indices.shape);
    const $segmentIds = backend.readSync(segmentIds.dataId);
    const lastSegmentIdPlusOne = numIndices > 0 ? $segmentIds[numIndices - 1] + 1 : 0;
    const outputRows = lastSegmentIdPlusOne;
    let program;
    const outputShape = input.shape.slice();
    outputShape[0] = outputRows;
    const sparseSize = numIndices * segmentSize;
    const sparseSegmentSum = (0, $cFwkm.fill)({
        backend: backend,
        attrs: {
            shape: outputShape,
            value: 0,
            dtype: dtype
        }
    });
    program = new (0, $gzeZg.SparseSegmentSumProgram)(outputShape, sparseSize, dtype);
    let uniformData = [
        {
            type: 'int32',
            data: [
                segmentSize
            ]
        },
        {
            type: 'int32',
            data: [
                sparseSize
            ]
        }
    ];
    const $sparseSegmentSum = backend.runWebGPUProgram(program, [
        input,
        indices,
        segmentIds
    ], dtype, uniformData, sparseSegmentSum);
    if (isSum) return $sparseSegmentSum;
    const sparseSegmentIdCount = (0, $cFwkm.fill)({
        backend: backend,
        attrs: {
            shape: [
                outputRows
            ],
            value: 0,
            dtype: 'int32'
        }
    });
    program = new (0, $gzeZg.SparseSegmentIdCountProgram)(outputRows, segmentIds.shape);
    const $sparseSegmentIdCount = backend.runWebGPUProgram(program, [
        segmentIds
    ], 'int32', null, sparseSegmentIdCount);
    const sparseSegmentMean = (0, $cFwkm.fill)({
        backend: backend,
        attrs: {
            shape: outputShape,
            value: 0,
            dtype: dtype
        }
    });
    program = new (0, $gzeZg.SparseSegmentMeanProgram)(outputShape, dtype);
    uniformData = [
        {
            type: 'int32',
            data: [
                segmentSize
            ]
        }
    ];
    const $sparseSegmentMean = backend.runWebGPUProgram(program, [
        $sparseSegmentSum,
        $sparseSegmentIdCount
    ], dtype, uniformData, sparseSegmentMean);
    backend.disposeData($sparseSegmentSum.dataId);
    backend.disposeData($sparseSegmentIdCount.dataId);
    return $sparseSegmentMean;
}

});
parcelRegister("gzeZg", function(module, exports) {

$parcel$export(module.exports, "SparseSegmentSumProgram", () => $c0fb8a5dff15fa4e$export$359edb6dd2233e21);
$parcel$export(module.exports, "SparseSegmentIdCountProgram", () => $c0fb8a5dff15fa4e$export$9a8d14fc8669d9b9);
$parcel$export(module.exports, "SparseSegmentMeanProgram", () => $c0fb8a5dff15fa4e$export$f8b388a7cda9eaff);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $arOgS = parcelRequire("arOgS");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $c0fb8a5dff15fa4e$export$359edb6dd2233e21 {
    constructor(outShape, sparseSize, outputDtype){
        this.variableNames = [
            'input',
            'indices',
            'segmentIds'
        ];
        this.outputShape = [];
        this.uniforms = 'segmentSize : i32, sparseSize : i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = outShape;
        this.type = outputDtype;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)([
            sparseSize
        ]);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, [
            sparseSize
        ], this.workgroupSize);
        this.shaderKey = 'sparseSegmentSum';
    }
    getUserCode() {
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.sparseSize) {
        let indexInSegmentIds = index / uniforms.segmentSize;
        let indexInSegment = index % uniforms.segmentSize;
        let indexInInput = indices[indexInSegmentIds];
        let segmentId = segmentIds[indexInSegmentIds];

        let value = input[indexInInput * uniforms.segmentSize + indexInSegment];
        let outIndex = segmentId * uniforms.segmentSize + indexInSegment;
        ${(0, $arOgS.atomicAddSnippet)('&result[outIndex]', 'value', this.type)}
      }
    }
  `;
        return userCode;
    }
}
class $c0fb8a5dff15fa4e$export$9a8d14fc8669d9b9 {
    constructor(outShape, segmentIdsShape){
        this.variableNames = [
            'segmentIds'
        ];
        this.outputShape = [];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = [
            outShape
        ];
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(segmentIdsShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, segmentIdsShape, this.workgroupSize);
        this.shaderKey = 'sparseSegmentIdCountProgram';
    }
    getUserCode() {
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.segmentIdsShape) {
        let segmentId = segmentIds[index];
        ${(0, $arOgS.atomicAddSnippet)('&result[segmentId]', '1', 'int32')}
      }
    }
  `;
        return userCode;
    }
}
class $c0fb8a5dff15fa4e$export$f8b388a7cda9eaff {
    constructor(outShape, outputDtype){
        this.variableNames = [
            'segmentSum',
            'sameSegmentIdCount'
        ];
        this.outputShape = [];
        this.uniforms = 'segmentSize : i32';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outShape;
        this.type = outputDtype;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(outShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, outShape, this.workgroupSize);
        this.shaderKey = 'sparseSegmentMean';
    }
    getUserCode() {
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.size) {
        let segmentId = index / uniforms.segmentSize;
        let count = sameSegmentIdCount[segmentId];
        if (count != 0) {
          ${this.type === 'float32' ? 'setOutputAtIndex(index, segmentSum[index] / f32(count));' : 'setOutputAtIndexI32(index, segmentSum[index] / count);'}
        }
      }
    }
  `;
        return userCode;
    }
}

});



parcelRegister("237nX", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentSumConfig", () => $17e1972c5c020686$export$73fa0270f28b9555);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $1w45V = parcelRequire("1w45V");
function $17e1972c5c020686$export$2255ce53fc777865(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    return (0, $1w45V.sparseSegmentReduce)(data, indices, segmentIds, true, backend);
}
const $17e1972c5c020686$export$73fa0270f28b9555 = {
    kernelName: (0, $hl418.SparseSegmentSum),
    backendName: 'webgpu',
    kernelFunc: $17e1972c5c020686$export$2255ce53fc777865
};

});

parcelRegister("ie8pe", function(module, exports) {

$parcel$export(module.exports, "sparseToDenseConfig", () => $d4500e063f7c9b10$export$7bc088f8ad44ef99);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $aLZc7 = parcelRequire("aLZc7");

var $h6bNs = parcelRequire("h6bNs");

var $17o8l = parcelRequire("17o8l");

var $gj4T5 = parcelRequire("gj4T5");

var $Lxcvj = parcelRequire("Lxcvj");
function $d4500e063f7c9b10$export$1be4b823dd1a3080(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sparseIndices: sparseIndices, sparseValues: sparseValues, defaultValue: defaultValue } = inputs;
    const { outputShape: outputShape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $7MaPk).calculateShapes(sparseValues, sparseIndices, outputShape);
    const sumDupeIndices = false;
    if (sparseValues.dtype === 'string') {
        const indicesBuf = backend.bufferSync(sparseIndices);
        const updatesBuf = backend.bufferSync(sparseValues);
        const $defaultValue = (0, $jjNRA).decodeString(backend.readSync(defaultValue.dataId)[0]);
        const outBuf = (0, $aLZc7.scatterImplCPU)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
        return backend.makeTensorInfo(outputShape, outBuf.dtype, outBuf.values);
    }
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    const $sparseIndices = (0, $gj4T5.reshape)({
        inputs: {
            x: sparseIndices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const $sparseValues = sparseValues.shape.length ? (0, $gj4T5.reshape)({
        inputs: {
            x: sparseValues
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    }) : (0, $17o8l.identity)({
        inputs: {
            x: sparseValues
        },
        backend: backend
    });
    const type = $sparseValues.dtype;
    const zero = backend.makeTensorInfo([], type, (0, $jjNRA).makeZerosTypedArray(1, type));
    // Fill output tensor with the default value.
    const $defaultValue = (0, $gj4T5.reshape)({
        inputs: {
            x: defaultValue
        },
        backend: backend,
        attrs: {
            shape: Array(flattenShape.length).fill(1)
        }
    });
    const $denseValues = (0, $Lxcvj.tile)({
        inputs: {
            x: $defaultValue
        },
        backend: backend,
        attrs: {
            reps: flattenShape
        }
    });
    const size = (0, $jjNRA).sizeFromShape([
        numUpdates,
        sliceSize
    ]);
    const uniformData = [
        {
            type: 'int32',
            data: [
                sliceRank
            ]
        },
        {
            type: 'int32',
            data: strides
        },
        {
            type: 'int32',
            data: [
                size
            ]
        }
    ];
    switch(numUpdates){
        case 0:
            break;
        case 1:
            {
                const program = new (0, $h6bNs.ScatterProgram)([
                    numUpdates,
                    sliceSize
                ], sliceRank, $sparseIndices.shape.length, $sparseValues.shape.length, strides, flattenShape, type, sumDupeIndices);
                backend.runWebGPUProgram(program, [
                    $sparseValues,
                    $sparseIndices
                ], type, uniformData, $denseValues);
            }
            break;
        default:
            {
                // First replace the default value with 0 at indices.
                const program = new (0, $h6bNs.ScatterProgram)([
                    numUpdates,
                    sliceSize
                ], sliceRank, $sparseIndices.shape.length, zero.shape.length, strides, flattenShape, type, sumDupeIndices);
                backend.runWebGPUProgram(program, [
                    zero,
                    $sparseIndices
                ], type, uniformData, $denseValues);
            }
            {
                // Then replace 0 with the (sum of) sparse value(s) at indices.
                const program = new (0, $h6bNs.ScatterProgram)([
                    numUpdates,
                    sliceSize
                ], sliceRank, $sparseIndices.shape.length, $sparseValues.shape.length, strides, flattenShape, type);
                backend.runWebGPUProgram(program, [
                    $sparseValues,
                    $sparseIndices
                ], type, uniformData, $denseValues);
            }
    }
    const denseValues = (0, $gj4T5.reshape)({
        inputs: {
            x: $denseValues
        },
        backend: backend,
        attrs: {
            shape: outputShape
        }
    });
    backend.disposeData($sparseIndices.dataId);
    backend.disposeData($sparseValues.dataId);
    backend.disposeData($defaultValue.dataId);
    backend.disposeData(zero.dataId);
    backend.disposeData($denseValues.dataId);
    return denseValues;
}
const $d4500e063f7c9b10$export$7bc088f8ad44ef99 = {
    kernelName: (0, $hl418.SparseToDense),
    backendName: 'webgpu',
    kernelFunc: $d4500e063f7c9b10$export$1be4b823dd1a3080
};

});
parcelRegister("Lxcvj", function(module, exports) {

$parcel$export(module.exports, "tile", () => $08ee24dd1a5e0ca1$export$3c17558da18e4d75);
$parcel$export(module.exports, "tileConfig", () => $08ee24dd1a5e0ca1$export$a5a9f8050ba7f41e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $iG87S = parcelRequire("iG87S");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $aLZc7 = parcelRequire("aLZc7");

var $bPFAL = parcelRequire("bPFAL");
function $08ee24dd1a5e0ca1$export$3c17558da18e4d75(params) {
    const { inputs: inputs, backend: backend, attrs: attrs } = params;
    const { x: x } = inputs;
    const { reps: reps } = attrs;
    // tile gpu program cannot handle rank >= 5 case.
    if (backend.shouldExecuteOnCPU([
        x
    ]) || x.dtype === 'string' || x.shape.length >= 5) {
        // Even thought string tensor is always on CPU, just to be consistent on how
        // to access tensor data.
        const data = backend.readSync(x.dataId);
        const value = x.dtype === 'string' ? data.map((d)=>(0, $jjNRA).decodeString(d)) : data;
        const buf = (0, $iG87S.buffer)(x.shape, x.dtype, value);
        const outBuf = (0, $aLZc7.tileImplCPU)(buf, reps);
        return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $bPFAL.TileProgram)(x.shape, reps);
    const output = backend.runWebGPUProgram(program, [
        x
    ], x.dtype);
    return output;
}
const $08ee24dd1a5e0ca1$export$a5a9f8050ba7f41e = {
    kernelName: (0, $hl418.Tile),
    backendName: 'webgpu',
    kernelFunc: $08ee24dd1a5e0ca1$export$3c17558da18e4d75
};

});
parcelRegister("bPFAL", function(module, exports) {

$parcel$export(module.exports, "TileProgram", () => $89d4b8739755c15e$export$215140f0ab19f420);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $89d4b8739755c15e$export$215140f0ab19f420 {
    constructor(aShape, reps){
        this.variableNames = [
            'A'
        ];
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[i] * reps[i];
        this.outputShape = outputShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.rank = this.outputShape.length;
        this.shaderKey = 'tile';
    }
    getUserCode() {
        const sourceCoords = $89d4b8739755c15e$var$getSourceCoords(this.rank, 'uniforms.');
        const userCode = `
      ${(0, $oGQBh.getMainHeaderString)('index')} {
        if (index < uniforms.size) {
          let resRC = getCoordsFromIndex(index);
          setOutputAtIndex(index, getA(${sourceCoords}));
        }
      }
    `;
        return userCode;
    }
}
function $89d4b8739755c15e$var$getSourceCoords(rank, uniformPrefix = '') {
    if (rank >= 5) throw Error(`Tile for rank ${rank} is not yet supported`);
    if (rank === 1) return `(resRC % ${uniformPrefix}aShape)`;
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w'
    ];
    const sourceCoords = [];
    for(let i = 0; i < rank; i++)sourceCoords.push(`(${currentCoords[i]} % ${uniformPrefix}aShape[${i}])`);
    return sourceCoords.join();
}

});



parcelRegister("2ROFn", function(module, exports) {

$parcel$export(module.exports, "splitVConfig", () => $2167d54b4169697f$export$317be24be3af9ea0);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $klUog = parcelRequire("klUog");
function $2167d54b4169697f$export$c0085d48b0a75d8f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { numOrSizeSplits: numOrSizeSplits, axis: axis } = attrs;
    const $axis = (0, $jjNRA).parseAxisParam(axis, x.shape)[0];
    const splitSizes = (0, $7MaPk).prepareSplitSize(x, numOrSizeSplits, $axis);
    const xRank = x.shape.length;
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    return splitSizes.map((s)=>{
        const sliceSize = [
            ...size
        ];
        sliceSize[$axis] = s;
        const sliceT = (0, $klUog.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: sliceSize
            }
        });
        begin[$axis] += s;
        return sliceT;
    });
}
const $2167d54b4169697f$export$317be24be3af9ea0 = {
    kernelName: (0, $hl418.SplitV),
    backendName: 'webgpu',
    kernelFunc: $2167d54b4169697f$export$c0085d48b0a75d8f
};

});

parcelRegister("5TAZG", function(module, exports) {

$parcel$export(module.exports, "sqrtConfig", () => $44aec908511974a1$export$a592ba9268f10eeb);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $44aec908511974a1$export$eba8049fb5020b81 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).SQRT
});
const $44aec908511974a1$export$a592ba9268f10eeb = {
    kernelName: (0, $hl418.Sqrt),
    backendName: 'webgpu',
    kernelFunc: $44aec908511974a1$export$eba8049fb5020b81
};

});

parcelRegister("arv0j", function(module, exports) {

$parcel$export(module.exports, "squareConfig", () => $01f644072706f6e3$export$7c77bece4d51efc4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $2b4Nh = parcelRequire("2b4Nh");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $01f644072706f6e3$export$7c77bece4d51efc4 = {
    kernelName: (0, $hl418.Square),
    backendName: 'webgpu',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const webGPUBackend = backend;
        const program = new (0, $2b4Nh.UnaryOpProgram)(x.shape, (0, $8Y5Lq.UnaryOpType).SQUARE);
        return webGPUBackend.runWebGPUProgram(program, [
            x
        ], x.dtype);
    }
};

});

parcelRegister("3HiU0", function(module, exports) {

$parcel$export(module.exports, "squaredDifferenceConfig", () => $2b140cde3d6966f0$export$9ed4691d69db8a43);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");
const $2b140cde3d6966f0$export$b178697fb6d0b37f = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).SQUARED_DIFFERENCE
});
const $2b140cde3d6966f0$export$9ed4691d69db8a43 = {
    kernelName: (0, $hl418.SquaredDifference),
    backendName: 'webgpu',
    kernelFunc: $2b140cde3d6966f0$export$b178697fb6d0b37f
};

});

parcelRegister("lSSve", function(module, exports) {

$parcel$export(module.exports, "stepConfig", () => $fee8eb3a375a1563$export$c42ffaf52eb2647);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $8Y5Lq = parcelRequire("8Y5Lq");

var $2b4Nh = parcelRequire("2b4Nh");
function $fee8eb3a375a1563$export$35d34bc0ed591a92({ inputs: inputs, attrs: attrs, backend: backend }) {
    const { x: x } = inputs;
    const program = new (0, $2b4Nh.UnaryOpProgram)(x.shape, (0, $8Y5Lq.UnaryOpType).STEP, 'stepAlpha : f32,');
    const uniformData = [
        {
            type: 'float32',
            data: [
                attrs.alpha
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        x
    ], x.dtype, uniformData);
}
const $fee8eb3a375a1563$export$c42ffaf52eb2647 = {
    kernelName: (0, $hl418.Step),
    backendName: 'webgpu',
    kernelFunc: $fee8eb3a375a1563$export$35d34bc0ed591a92
};

});

parcelRegister("5B730", function(module, exports) {

$parcel$export(module.exports, "stridedSliceConfig", () => $4135dff3eb26a842$export$81773633114187bd);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $iG87S = parcelRequire("iG87S");
var $bszZn = parcelRequire("bszZn");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $aLZc7 = parcelRequire("aLZc7");

var $gj4T5 = parcelRequire("gj4T5");

var $klUog = parcelRequire("klUog");

var $22Hqy = parcelRequire("22Hqy");
function $4135dff3eb26a842$export$4ae57224f3b0605c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, end: end, strides: strides, beginMask: beginMask, endMask: endMask, ellipsisMask: ellipsisMask, newAxisMask: newAxisMask, shrinkAxisMask: shrinkAxisMask } = attrs;
    const { finalShapeSparse: finalShapeSparse, finalShape: finalShape, isIdentity: isIdentity, sliceDim0: sliceDim0, isSimpleSlice: isSimpleSlice, begin: $begin, end: $end, strides: $strides } = (0, $bszZn).sliceInfo(x.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
    let result;
    if (isIdentity) // Optimization #1, slice is a no-op plus reshape
    result = (0, $gj4T5.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    else if (sliceDim0 || isSimpleSlice) {
        // Optimization #2, slice is memory contiguous (only occurs in dim 0)
        (0, $jjNRA).assert(x.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${x.shape.length}`);
        const size = (0, $bszZn).computeOutShape($begin, $end, $strides);
        // To tolerate begin[0] > end[0] (a 0-output slice), we min(begin, end).
        const sliced = (0, $klUog.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: $begin,
                size: size
            }
        });
        result = (0, $gj4T5.reshape)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: finalShape
            }
        });
        backend.disposeData(sliced.dataId);
    } else {
        const shouldExecuteOnCPU = backend.shouldExecuteOnCPU([
            x
        ]);
        if (shouldExecuteOnCPU) {
            const values = backend.readSync(x.dataId);
            const xBuf = (0, $iG87S.buffer)(x.shape, x.dtype, values);
            const resultValues = (0, $aLZc7.stridedSliceImplCPU)(finalShapeSparse, xBuf, $strides, $begin);
            result = backend.makeTensorInfo(finalShape, x.dtype, resultValues.values);
        } else {
            const program = new (0, $22Hqy.StridedSliceProgram)(finalShapeSparse);
            const uniformData = [
                {
                    type: 'int32',
                    data: $begin
                },
                {
                    type: 'int32',
                    data: $strides
                }
            ];
            const resultValues = backend.runWebGPUProgram(program, [
                x
            ], x.dtype, uniformData);
            result = (0, $gj4T5.reshape)({
                inputs: {
                    x: resultValues
                },
                backend: backend,
                attrs: {
                    shape: finalShape
                }
            });
            backend.disposeData(resultValues.dataId);
        }
    }
    return result;
}
const $4135dff3eb26a842$export$81773633114187bd = {
    kernelName: (0, $hl418.StridedSlice),
    backendName: 'webgpu',
    kernelFunc: $4135dff3eb26a842$export$4ae57224f3b0605c
};

});
parcelRegister("22Hqy", function(module, exports) {

$parcel$export(module.exports, "StridedSliceProgram", () => $17cd747139b87f89$export$335c52ce94f359f6);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $17cd747139b87f89$export$335c52ce94f359f6 {
    constructor(destSize){
        this.variableNames = [
            'x'
        ];
        // TODO(xing.xu): Increase the workPerThread.
        this.workPerThread = 1;
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = destSize;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize, [
            this.workPerThread,
            1,
            1
        ]);
        const dtype = (0, $oGQBh.getCoordsDataType)(this.outputShape.length);
        this.uniforms = `begin : ${dtype},  strides : ${dtype}, `;
        this.shaderKey = 'stridedSlice';
    }
    getUserCode() {
        const rank = this.outputShape.length;
        let newCoords = '';
        if (rank === 1) newCoords = 'coords * uniforms.strides + uniforms.begin';
        else {
            let outputAxis = 0;
            newCoords = this.outputShape.map((_, i)=>{
                outputAxis++;
                return this.outputShape.length === 1 ? `coords * uniforms.strides[${i}] + uniforms.begin[${i}]` : `coords[${outputAxis - 1}] * uniforms.strides[${i}] + uniforms.begin[${i}]`;
            }).join(',');
        }
        const userCode = `
       ${(0, $oGQBh.getMainHeaderString)('index')} {
         if (index < uniforms.size) {
           let coords = getCoordsFromIndex(index);
           setOutputAtIndex(index, getX(${newCoords}));
         }
       }
     `;
        return userCode;
    }
}

});


parcelRegister("1OFx6", function(module, exports) {

$parcel$export(module.exports, "stringNGramsConfig", () => $152aad80cd8b961b$export$35e13284eed34c22);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $aLZc7 = parcelRequire("aLZc7");
function $152aad80cd8b961b$export$3490514dcc63b044(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { separator: separator, nGramWidths: nGramWidths, leftPad: leftPad, rightPad: rightPad, padWidth: padWidth, preserveShortSequences: preserveShortSequences } = attrs;
    const { data: data, dataSplits: dataSplits } = inputs;
    const $data = backend.readSync(data.dataId);
    const $dataSplits = backend.readSync(dataSplits.dataId);
    const [nGrams, nGramsSplits] = (0, $aLZc7.stringNGramsImplCPU)($data, $dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences);
    return [
        backend.makeTensorInfo([
            nGrams.length
        ], 'string', nGrams),
        backend.makeTensorInfo(dataSplits.shape, 'int32', nGramsSplits)
    ];
}
const $152aad80cd8b961b$export$35e13284eed34c22 = {
    kernelName: (0, $hl418.StringNGrams),
    backendName: 'webgpu',
    kernelFunc: $152aad80cd8b961b$export$3490514dcc63b044
};

});

parcelRegister("jTbfI", function(module, exports) {

$parcel$export(module.exports, "subConfig", () => $e7abe1e1bc7ffba0$export$5d068476dad60c4d);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $jJAz1 = parcelRequire("jJAz1");

var $amx4s = parcelRequire("amx4s");

var $aLZc7 = parcelRequire("aLZc7");
const $e7abe1e1bc7ffba0$export$f93b5905241a7cca = (0, $amx4s.binaryKernelFunc)({
    opType: (0, $jJAz1.BinaryOpType).SUB,
    cpuKernelImpl: (0, $aLZc7.subImplCPU),
    supportsComplex: true
});
const $e7abe1e1bc7ffba0$export$5d068476dad60c4d = {
    kernelName: (0, $hl418.Sub),
    backendName: 'webgpu',
    kernelFunc: $e7abe1e1bc7ffba0$export$f93b5905241a7cca
};

});

parcelRegister("iCQZ1", function(module, exports) {

$parcel$export(module.exports, "tanConfig", () => $d8f4dffd9553a813$export$97648844df7611f3);
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $d8f4dffd9553a813$export$fcdd3b0b3246a325 = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).TAN
});
const $d8f4dffd9553a813$export$97648844df7611f3 = {
    kernelName: (0, $hl418.Tan),
    backendName: 'webgpu',
    kernelFunc: $d8f4dffd9553a813$export$fcdd3b0b3246a325
};

});

parcelRegister("77tYE", function(module, exports) {

$parcel$export(module.exports, "tanhConfig", () => $52f070b76f735b28$export$a2fc7de1a1e4eee0);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $amx4s = parcelRequire("amx4s");

var $8Y5Lq = parcelRequire("8Y5Lq");
const $52f070b76f735b28$export$7128670e45beef9a = (0, $amx4s.unaryKernelFunc)({
    opType: (0, $8Y5Lq.UnaryOpType).TANH
});
const $52f070b76f735b28$export$a2fc7de1a1e4eee0 = {
    kernelName: (0, $hl418.Tanh),
    backendName: 'webgpu',
    kernelFunc: $52f070b76f735b28$export$7128670e45beef9a
};

});

parcelRegister("dR0Tc", function(module, exports) {

$parcel$export(module.exports, "tensorScatterUpdateConfig", () => $a160ea336182c8c6$export$2819813ce8339b64);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $h6bNs = parcelRequire("h6bNs");

var $gj4T5 = parcelRequire("gj4T5");

var $Lxcvj = parcelRequire("Lxcvj");
function $a160ea336182c8c6$export$d3ac02769385eb36(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { tensor: tensor, indices: indices, updates: updates } = inputs;
    const {} = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $7MaPk).calculateShapes(updates, indices, tensor.shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(tensor.shape, indices.dtype);
    const toDispose = [];
    const flattenIndices = (0, $gj4T5.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    toDispose.push(flattenIndices);
    const flattenX = (0, $gj4T5.reshape)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    toDispose.push(flattenX);
    const flattenTensor = (0, $gj4T5.reshape)({
        inputs: {
            x: tensor
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    toDispose.push(flattenTensor);
    const output = (0, $Lxcvj.tile)({
        inputs: {
            x: flattenTensor
        },
        backend: backend,
        attrs: {
            reps: Array(flattenShape.length).fill(1)
        }
    });
    const program = new (0, $h6bNs.ScatterProgram)([
        numUpdates,
        sliceSize
    ], sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape, tensor.dtype, false);
    const size = (0, $jjNRA).sizeFromShape([
        numUpdates,
        sliceSize
    ]);
    const uniformData = [
        {
            type: 'int32',
            data: [
                sliceRank
            ]
        },
        {
            type: 'int32',
            data: strides
        },
        {
            type: 'int32',
            data: [
                size
            ]
        }
    ];
    const res = backend.runWebGPUProgram(program, [
        flattenX,
        flattenIndices
    ], flattenTensor.dtype, uniformData, output);
    toDispose.push(res);
    const reshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: tensor.shape
        }
    });
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return reshaped;
}
const $a160ea336182c8c6$export$2819813ce8339b64 = {
    kernelName: (0, $hl418.TensorScatterUpdate),
    backendName: 'webgpu',
    kernelFunc: $a160ea336182c8c6$export$d3ac02769385eb36
};

});

parcelRegister("ceTsM", function(module, exports) {

$parcel$export(module.exports, "topKConfig", () => $8e91d0a88cd01cbb$export$cffaee31213314ce);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $aLZc7 = parcelRequire("aLZc7");

var $hOZsx = parcelRequire("hOZsx");

var $cFwkm = parcelRequire("cFwkm");

var $gDTrm = parcelRequire("gDTrm");

var $gj4T5 = parcelRequire("gj4T5");

var $klUog = parcelRequire("klUog");
function $8e91d0a88cd01cbb$var$disposeIntermediateTensorInfoOrNull(backend, tensorInfo) {
    if (tensorInfo !== null) backend.disposeData(tensorInfo.dataId);
}
function $8e91d0a88cd01cbb$var$roundUpToPow2(num) {
    let pow2 = 1;
    while(pow2 < num)pow2 *= 2;
    return pow2;
}
function $8e91d0a88cd01cbb$export$7e641efc73a2d81(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { k: k, sorted: sorted } = attrs;
    const xShape = x.shape;
    const lastDim = xShape[xShape.length - 1];
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const xVals = backend.readSync(x.dataId);
        const [allTopKVals, allTopKIndices] = (0, $aLZc7.topKImplCPU)(xVals, xShape, x.dtype, k, sorted);
        return [
            backend.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
            backend.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
        ];
    }
    if (k === 0) {
        xShape[xShape.length - 1] = 0;
        return [
            backend.makeTensorInfo(xShape, x.dtype, []),
            backend.makeTensorInfo(xShape, 'int32', [])
        ];
    }
    if (lastDim === 1 /* firstPass */ ) return [
        x,
        (0, $cFwkm.fill)({
            attrs: {
                shape: xShape,
                dtype: 'int32',
                value: 0
            },
            backend: backend
        })
    ];
    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
    const xSize = (0, $jjNRA).sizeFromShape(xShape);
    const batch = xSize / lastDim;
    const x2D = (0, $gj4T5.reshape)({
        inputs: {
            x: x
        },
        attrs: {
            shape: [
                batch,
                lastDim
            ]
        },
        backend: backend
    });
    const kPow2 = $8e91d0a88cd01cbb$var$roundUpToPow2(k);
    const lastDimPow2 = $8e91d0a88cd01cbb$var$roundUpToPow2(lastDim);
    // Only the indices containing the top K are kept at every step to reduce
    // number of outputs in the GPU algorithms, so once the final set of indices
    // is computed then gather is used to grab the corresponding values
    // from the original input.
    let indices = null;
    // GPU algorithm always takes in an indices input but this input is not used
    // on the first run of a GPU algorithm, therefore if indices is null we simply
    // pass in x2D instead of it but the value will not actually be used
    const getInputs = ()=>indices === null ? [
            x2D,
            x2D
        ] : [
            x2D,
            indices
        ];
    const runSwap = (dir, inc, shape)=>{
        const inputs = getInputs();
        const program = new (0, $hOZsx.SwapProgram)(shape);
        const firstPass = indices === null ? 1 : 0;
        const uniformDataSwap = [
            {
                type: 'int32',
                data: [
                    lastDim
                ]
            },
            {
                type: 'int32',
                data: [
                    firstPass
                ]
            },
            {
                type: 'float32',
                data: [
                    Number.NEGATIVE_INFINITY
                ]
            },
            {
                type: 'int32',
                data: [
                    dir
                ]
            },
            {
                type: 'int32',
                data: [
                    inc
                ]
            }
        ];
        const prevIndices = indices;
        indices = backend.runWebGPUProgram(program, inputs, 'int32', uniformDataSwap);
        $8e91d0a88cd01cbb$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    };
    // Step 1: local sort
    for(let len = 1; len < kPow2; len *= 2){
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, [
            batch,
            lastDimPow2
        ]);
    }
    // Step 2: merge
    for(let indicesSize = lastDimPow2; indicesSize > kPow2; indicesSize /= 2){
        const inputs = getInputs();
        const mergeProgram = new (0, $hOZsx.MergeProgram)([
            batch,
            indicesSize / 2
        ]);
        const firstPass = indices === null ? 1 : 0;
        const uniformDataMerge = [
            {
                type: 'int32',
                data: [
                    lastDim
                ]
            },
            {
                type: 'int32',
                data: [
                    firstPass
                ]
            },
            {
                type: 'int32',
                data: [
                    kPow2
                ]
            }
        ];
        const prevIndices = indices;
        indices = backend.runWebGPUProgram(mergeProgram, inputs, 'int32', uniformDataMerge);
        $8e91d0a88cd01cbb$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
        // Step 3: rebuild
        const len = kPow2 / 2;
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, indices.shape);
    }
    // Keep only the requested top K results instead of kPow2
    let prevIndices = indices;
    indices = (0, $klUog.slice)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            begin: 0,
            size: [
                batch,
                k
            ]
        }
    });
    $8e91d0a88cd01cbb$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    // Gather values on last dimension
    let values = (0, $gDTrm.gatherV2)({
        inputs: {
            x: x2D,
            indices: indices
        },
        backend: backend,
        attrs: {
            axis: 1,
            batchDims: 1
        }
    });
    $8e91d0a88cd01cbb$var$disposeIntermediateTensorInfoOrNull(backend, x2D);
    // Reshape back to the original input shape, except that the last
    // dimension is k.
    const newShape = xShape.slice(0, -1);
    newShape.push(k);
    prevIndices = indices;
    indices = (0, $gj4T5.reshape)({
        inputs: {
            x: indices
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $8e91d0a88cd01cbb$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    const prevValues = values;
    values = (0, $gj4T5.reshape)({
        inputs: {
            x: values
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $8e91d0a88cd01cbb$var$disposeIntermediateTensorInfoOrNull(backend, prevValues);
    return [
        values,
        indices
    ];
}
const $8e91d0a88cd01cbb$export$cffaee31213314ce = {
    kernelName: (0, $hl418.TopK),
    backendName: 'webgpu',
    kernelFunc: $8e91d0a88cd01cbb$export$7e641efc73a2d81
};

});
parcelRegister("hOZsx", function(module, exports) {

$parcel$export(module.exports, "SwapProgram", () => $cf96c7b4f13db2d4$export$5ee54e3c81d6f6e7);
$parcel$export(module.exports, "MergeProgram", () => $cf96c7b4f13db2d4$export$c3fbf8b38d821ac9);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $cf96c7b4f13db2d4$export$5ee54e3c81d6f6e7 {
    constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.uniforms = `inputSize : i32, firstPass : i32, negativeInf : f32,
        dir : i32, inc : i32,`;
        this.shaderKey = 'swap';
    }
    getUserCode() {
        const userCode = `
        ${(0, $oGQBh.getMainHeaderString)('index')} {
          if (index < uniforms.size) {
            let outC = getCoordsFromIndex(index);
            let batch = outC[0];
            let elemIdx = outC[1];
            // We compare elements pair-wise within a group of size 2 * inc.
            // The comparing rule for each group alternates between ascending
            // and descending. Within each group, we compare each pair at
            // positions i and i+inc. To decide whether an element at position i
            // is x0 or x1, we mod it by 2 * inc, if the result is smaller than
            // inc, it is in the first half of the group, we denote it as x0,
            // otherwise we denote it as x1.
            // For example, as shown in the Bitonic top K paper referenced
            // above, Figure5(a) shows that element[1] is in the second half of
            // the group when group size is 2, but it is in the first half of
            // the group when group size is 4.
            let isFirstInPair = elemIdx % (2 * uniforms.inc) < uniforms.inc;
            var i = 0;
            if (isFirstInPair) {
              i = elemIdx;
            } else {
              i = elemIdx - uniforms.inc;
            }

            var i0 = 0;
            if (uniforms.firstPass == 1) {
              i0 = i;
            } else {
              i0 = i32(getIndices(batch, i));
            }

            var i1 = 0;
            if (uniforms.firstPass == 1) {
              i1 = i + uniforms.inc;
            } else {
              i1 = i32(getIndices(batch, i + uniforms.inc));
            }

            var x0 = f32(0.0);
            var x1 = f32(0.0);
            if (i0 < uniforms.inputSize) {
              x0 = getX(batch, i0);
            } else {
              x0 = uniforms.negativeInf;
            }
            if (i1 < uniforms.inputSize) {
              x1 = getX(batch, i1);
            } else {
              x1 = uniforms.negativeInf;
            }

            let reverse = elemIdx % (2 * uniforms.dir) >= uniforms.dir;
            let isGreater = x0 > x1 || (x0 == x1 && i1 > i0);
            if (reverse == isGreater) {
              // Elements in opposite order of direction
              let iTemp = i0;
              i0 = i1;
              i1 = iTemp;
            }
            if (isFirstInPair) {
              setOutputAtIndex(index, f32(i0));
            } else {
              setOutputAtIndex(index, f32(i1));
            }
          }
        }
      `;
        return userCode;
    }
}
class $cf96c7b4f13db2d4$export$c3fbf8b38d821ac9 {
    constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        this.workgroupSize = [
            256,
            1,
            1
        ];
        this.size = true;
        this.outputShape = shape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        // |n| Size of the original input of TopK
        // |firstPass| indicates if this is the first time swap is being used which
        // means no indices input containing the top K is present yet.
        // |k| Top k elements desired
        this.uniforms = `inputSize : i32, firstPass : i32, k : i32,`;
        this.shaderKey = 'merge';
    }
    getUserCode() {
        const userCode = `
        ${(0, $oGQBh.getMainHeaderString)('index')} {
          if (index < uniforms.size) {
            let outC = getCoordsFromIndex(index);
            let batch = outC[0];
            let elemIdx = outC[1];
            // The output size is half of the previous size.
            // If the previous sequence is | | | | _ _ _ _  | | | |  _ _ _ _
            // (k=4), we only need to output the indices at positions |, the
            // indices at positions _ can be thrown away, see Figure5(b) After
            // Phase 2 (Merge phase) in the Bitonic Top K paper referenced
            // above.
            // For example, the paper shows we only need to output the orange
            // bars. The output sequence should look like this | | | | | | | |.
            // Because the sequence is halved, to map the output index back to
            // the previous sequence to find the corresponding value, we need
            // to double the index. When we double the index, we basically
            // interpolate a position, so 2i looks like
            // | _ | _ | _ | _ | _ | _ | _. We move the | to the first k
            // position of each 2k positions by - elemIdx % k. E.g. for output
            // at index 4,5,6,7, we want to get the corresponding element at
            // original index 8,9,10,11, for output at index 8,9,10,11,
            // we want to get the corresponding element at original index
            // 16,17,18,19, so on and so forth.

            var i = 0;
            if (elemIdx < uniforms.k) {
              i = elemIdx;
            } else {
              i = elemIdx * 2 - elemIdx % uniforms.k;
            }
            var i0 = 0;
            if (uniforms.firstPass == 1) {
              i0 = i;
            } else {
              i0 = i32(getIndices(batch, i));
            }
            var i1 = 0;
            if (uniforms.firstPass == 1) {
              i1 = i + uniforms.k;
            } else {
              i1 = i32(getIndices(batch, i + uniforms.k));
            }

            let x0 = getX(batch, i0);
            var x1 = f32(0.0);
            if (i1 < uniforms.inputSize) {
              x1 = getX(batch, i1);
            } else {
              x1 = x0;
            }

            if (x0 >= x1) {
              setOutputAtIndex(index, f32(i0));
            } else {
              setOutputAtIndex(index, f32(i1));
            }
          }
        }
      `;
        return userCode;
    }
}

});


parcelRegister("k57O2", function(module, exports) {

$parcel$export(module.exports, "transformConfig", () => $e9ea546c5c25199c$export$1c7a3de6335954ed);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $85ai4 = parcelRequire("85ai4");
function $e9ea546c5c25199c$export$51186ad6e864892a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, transforms: transforms } = inputs;
    const { interpolation: interpolation, fillMode: fillMode, fillValue: fillValue, outputShape: outputShape } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const [outHeight, outWidth] = outputShape != null ? outputShape : [
        imageHeight,
        imageWidth
    ];
    const outShape = [
        batch,
        outHeight,
        outWidth,
        numChannels
    ];
    const program = new (0, $85ai4.TransformProgram)(outShape);
    const interpolationModeId = interpolation === 'nearest' ? 1 : 2;
    let fillModeId;
    switch(fillMode){
        case 'constant':
            fillModeId = 1;
            break;
        case 'reflect':
            fillModeId = 2;
            break;
        case 'wrap':
            fillModeId = 3;
            break;
        case 'nearest':
            fillModeId = 4;
            break;
        default:
            fillModeId = 1;
            break;
    }
    const uniformData = [
        {
            type: 'int32',
            data: [
                interpolationModeId
            ]
        },
        {
            type: 'int32',
            data: [
                fillModeId
            ]
        },
        {
            type: 'float32',
            data: [
                fillValue
            ]
        }
    ];
    return backend.runWebGPUProgram(program, [
        image,
        transforms
    ], 'float32', uniformData);
}
const $e9ea546c5c25199c$export$1c7a3de6335954ed = {
    kernelName: (0, $hl418.Transform),
    backendName: 'webgpu',
    kernelFunc: $e9ea546c5c25199c$export$51186ad6e864892a
};

});
parcelRegister("85ai4", function(module, exports) {

$parcel$export(module.exports, "TransformProgram", () => $5e26c5ce5bdbc131$export$c83a293baf8f269d);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $5e26c5ce5bdbc131$export$c83a293baf8f269d {
    constructor(outShape){
        this.variableNames = [
            'Image',
            'Transforms'
        ];
        this.uniforms = 'interpolationModeId : i32, fillModeId : i32, fillValue : f32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.size = true;
        this.outputShape = outShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(this.outputShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, this.outputShape, this.workgroupSize);
        this.shaderKey = 'transform';
    }
    getUserCode() {
        const userCode = `
          fn mapCoord(outCoord : f32, len : f32) -> f32{
            var inCoord = outCoord;
            if(uniforms.fillModeId == 2) {
              if (inCoord < 0.0) {
                if (len <= 1.0) {
                  inCoord = 0.0;
                } else {
                  let sz2 = 2.0 * len;
                  if (inCoord < sz2) {
                    inCoord = sz2 * f32(i32(f32(-inCoord / sz2))) +
                    inCoord;
                  }
                  if (inCoord < -len) {
                    inCoord = inCoord + sz2;
                  } else {
                    inCoord = -inCoord - 1.0;
                  }
                }
              } else if (inCoord > len - 1.0) {
                if (len <= 1.0) {
                  inCoord = 0.0;
                } else {
                  let sz2 = 2.0 * len;
                  inCoord = inCoord - sz2 * f32(i32(f32(inCoord / sz2)));
                  if (inCoord >= len) {
                    inCoord = sz2 - inCoord - 1.0;
                  }
                }
              }
              return clamp(inCoord, 0.0, len - 1.0);
            } else if (uniforms.fillModeId == 3) {
              if (inCoord < 0.0) {
                if (len <= 1.0) {
                  inCoord = 0.0;
                } else {
                  let sz = len - 1.0;
                  inCoord = inCoord + len * (f32(i32(f32(-inCoord / sz))) + 1.0);
                }
              } else if (inCoord > len - 1.0) {
                if (len <= 1.0) {
                  inCoord = 0.0;
                } else {
                  let sz = len - 1.0;
                  inCoord = inCoord - len * f32(i32(f32(inCoord / sz)));
                }
              }
              return clamp(inCoord, 0.0, len - 1.0);
            } else if (uniforms.fillModeId == 4) {
              return clamp(outCoord, 0.0, len - 1.0);
            }
            return outCoord;
          }
          fn readWithFillValue(batch : i32, coordY : i32, coordX : i32,
            channel : i32) -> f32 {
            var outputValue : f32;
            if (0 <= coordY && coordY < uniforms.imageShape[1] && 0 <= coordX && coordX < uniforms.imageShape[2]) {
                outputValue = getImage(batch, coordY, coordX, channel);
            } else {
              outputValue = uniforms.fillValue;
            }
            return outputValue;
          }

          ${(0, $oGQBh.getMainHeaderString)('index')} {
            if (index < uniforms.size) {
              let coords = getCoordsFromIndex(index);
              var outputValue : f32;
              let batch = coords[0];
              let x = coords[2];
              let y = coords[1];
              let channel = coords[3];
              let xf = f32(x);
              let yf = f32(y);
              let a1 = getTransforms(batch, 0);
              let a2 = getTransforms(batch, 1);
              let a3 = getTransforms(batch, 2);
              let b1 = getTransforms(batch, 3);
              let b2 = getTransforms(batch, 4);
              let b3 = getTransforms(batch, 5);
              let c1 = getTransforms(batch, 6);
              let c2 = getTransforms(batch, 7);
              let projection = c1 * xf + c2 * yf + 1.0;
              if (projection == 0.0) {
                outputValue = uniforms.fillValue;
              } else {
                let inX = (a1 * xf + a2 * yf + a3) / projection;
                let inY = (b1 * xf + b2 * yf + b3) / projection;
                let mapX = mapCoord(inX, f32(uniforms.imageShape[2]));
                let mapY = mapCoord(inY, f32(uniforms.imageShape[1]));

                if (uniforms.interpolationModeId == 1) {
                  let coordY = i32(round(mapY));
                  let coordX = i32(round(mapX));
                  outputValue = readWithFillValue(batch, coordY, coordX,
                    channel);
                } else {
                  let yFloor = floor(mapY);
                  let xFloor = floor(mapX);
                  let yCeil = yFloor + 1.0;
                  let xCeil = xFloor + 1.0;
                  let valueYFloor = (xCeil - mapX) *
                  readWithFillValue(batch, i32(yFloor), i32(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, i32(yFloor), i32(xCeil), channel);
                  let valueYCeil = (xCeil - mapX) *
                  readWithFillValue(batch, i32(yCeil), i32(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, i32(yCeil), i32(xCeil), channel);
                  outputValue = (yCeil - mapY) * valueYFloor +
                  (mapY - yFloor) * valueYCeil;
                }
              }
              setOutputAtIndex(index, outputValue);
            }
          }
        `;
        return userCode;
    }
}

});


parcelRegister("cuybR", function(module, exports) {

$parcel$export(module.exports, "unpackConfig", () => $9182cedb1ff1e357$export$d06292128cae50d6);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $hl418 = parcelRequire("hl418");

var $gj4T5 = parcelRequire("gj4T5");

var $klUog = parcelRequire("klUog");
function $9182cedb1ff1e357$export$417857010dc9287f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { value: value } = inputs;
    let { axis: axis } = attrs;
    if (axis < 0) axis += value.shape.length;
    const x = value;
    const xRank = x.shape.length;
    const num = value.shape[axis];
    const outShape = new Array(xRank - 1);
    let outIndex = 0;
    for(let i = 0; i < xRank; i++)if (i !== axis) outShape[outIndex++] = x.shape[i];
    const toDispose = [];
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    size[axis] = 1;
    const res = new Array(num);
    for(let i = 0; i < res.length; i++){
        begin[axis] = i;
        const sliced = (0, $klUog.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: size
            }
        });
        const reshaped = (0, $gj4T5.reshape)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        res[i] = reshaped;
        toDispose.push(sliced);
    }
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return res;
}
const $9182cedb1ff1e357$export$d06292128cae50d6 = {
    kernelName: (0, $hl418.Unpack),
    backendName: 'webgpu',
    kernelFunc: $9182cedb1ff1e357$export$417857010dc9287f
};

});

parcelRegister("liTL6", function(module, exports) {

$parcel$export(module.exports, "unsortedSegmentSumConfig", () => $f82687ef50650896$export$71e3626a4ca29968);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("i64bB");
var $7MaPk = parcelRequire("7MaPk");
var $hl418 = parcelRequire("hl418");
var $jjNRA = parcelRequire("jjNRA");

var $lwrbu = parcelRequire("lwrbu");

var $cFwkm = parcelRequire("cFwkm");

var $gj4T5 = parcelRequire("gj4T5");

var $f9YmZ = parcelRequire("f9YmZ");
function $f82687ef50650896$export$ba7c4d144d85a309(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, segmentIds: segmentIds } = inputs;
    const { numSegments: numSegments } = attrs;
    const xRank = x.shape.length;
    const toDispose = [];
    let axis = 0;
    const permutation = (0, $7MaPk).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) {
        permutedX = (0, $f9YmZ.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        toDispose.push(permutedX);
        axis = (0, $7MaPk).getInnerMostAxes(1, xRank)[0];
    }
    const outShape = (0, $7MaPk).segment_util.computeOutShape(permutedX.shape, axis, numSegments);
    const inSize = (0, $jjNRA).sizeFromShape([
        permutedX.shape[axis]
    ]);
    const a2D = (0, $gj4T5.reshape)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    toDispose.push(a2D);
    const dtype = x.dtype;
    const shape = [
        a2D.shape[0],
        numSegments
    ];
    const output = (0, $cFwkm.fill)({
        backend: backend,
        attrs: {
            shape: shape,
            value: 0,
            dtype: dtype
        }
    });
    const program = new (0, $lwrbu.UnsortedSegmentSumProgram)(a2D.shape, shape, dtype);
    const uniformData = [
        {
            type: 'int32',
            data: [
                numSegments
            ]
        },
        {
            type: 'int32',
            data: [
                (0, $jjNRA).sizeFromShape(a2D.shape)
            ]
        }
    ];
    const segResult = backend.runWebGPUProgram(program, [
        a2D,
        segmentIds
    ], dtype, uniformData, output);
    const reshaped = (0, $gj4T5.reshape)({
        inputs: {
            x: segResult
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    toDispose.push(segResult);
    let result = reshaped;
    if (permutation != null) {
        toDispose.push(reshaped);
        const perm = (0, $7MaPk).getUndoAxesPermutation(permutation);
        result = (0, $f9YmZ.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: perm
            }
        });
    }
    toDispose.forEach((t)=>backend.disposeData(t.dataId));
    return result;
}
const $f82687ef50650896$export$71e3626a4ca29968 = {
    kernelName: (0, $hl418.UnsortedSegmentSum),
    backendName: 'webgpu',
    kernelFunc: $f82687ef50650896$export$ba7c4d144d85a309
};

});
parcelRegister("lwrbu", function(module, exports) {

$parcel$export(module.exports, "UnsortedSegmentSumProgram", () => $fab1ac61e9a8ee29$export$71be9d28dd2ad236);
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $arOgS = parcelRequire("arOgS");

var $oGQBh = parcelRequire("oGQBh");

var $9Dn6G = parcelRequire("9Dn6G");
class $fab1ac61e9a8ee29$export$71be9d28dd2ad236 {
    constructor(inShape, outShape, outputDtype){
        this.outputShape = [];
        this.variableNames = [
            'x',
            'segmentIds'
        ];
        this.uniforms = 'numSegments : i32, xSize: i32,';
        this.workgroupSize = [
            64,
            1,
            1
        ];
        this.atomic = true;
        this.outputShape = outShape;
        this.dispatchLayout = (0, $9Dn6G.flatDispatchLayout)(inShape);
        this.dispatch = (0, $9Dn6G.computeDispatch)(this.dispatchLayout, inShape, this.workgroupSize);
        if (outputDtype !== 'float32' && outputDtype !== 'int32') throw new Error(`UnsortedSegmentSum only supports float32 and int32
              types, does not support ${outputDtype} type.`);
        this.type = outputDtype;
        this.shaderKey = 'unsortedSegmentSum';
    }
    getUserCode() {
        const userCode = `
    ${(0, $oGQBh.getMainHeaderString)('index')} {
      if (index < uniforms.xSize) {
        let coords = getXCoordsFromIndex(index);
        let b = coords[0];
        let inCol = coords[1];

        let segmentId = i32(getSegmentIds(inCol));
        if (segmentId >= 0) {
          let flatIndex = b * uniforms.numSegments + segmentId % uniforms.numSegments;
          let value = getX(b, inCol);

          ${(0, $arOgS.atomicAddSnippet)('&result[flatIndex]', 'value', this.type)}
        }
      }
    }
  `;
        return userCode;
    }
}

});





parcelRegister("3HJq6", function(module, exports) {

$parcel$export(module.exports, "MODEL", () => $6a01ba7fa677248b$export$12625b631ae5ca7f);
$parcel$export(module.exports, "default", () => $6a01ba7fa677248b$export$2e2bcd8739ae039);
// https://github.com/tensorflow/tfjs-models/tree/master/pose-detection/src/blazepose_mediapipe#usage

var $gvL88 = parcelRequire("gvL88");
const $6a01ba7fa677248b$export$12625b631ae5ca7f = $gvL88.SupportedModels.BlazePose;
class $6a01ba7fa677248b$export$2e2bcd8739ae039 {
    constructor(video){
        this.getDetector();
        this.video = video;
    }
    async getDetector() {
        if (!this._detector) this._detector = await $gvL88.createDetector($6a01ba7fa677248b$export$12625b631ae5ca7f, {
            runtime: "mediapipe",
            enableSegmentation: true,
            enableSmoothing: true,
            modelType: "lite",
            // model is copied with the site build via a Parcel plugin so it can be loaded locally
            // https://github.com/tensorflow/tfjs-models/tree/master/pose-detection/src/blazepose_mediapipe#create-a-detector
            // https://github.com/elwin013/parcel-reporter-static-files-copy#customization
            solutionPath: "node_modules/@mediapipe/pose"
        });
        return this._detector;
    }
    isReady() {
        return this.video.isLoaded();
    }
    reset() {
        this._detector?.reset();
    }
    async detect() {
        const detector = await this.getDetector();
        const poses = await detector.estimatePoses(this.video.el, {
            flipHorizontal: false
        });
        // their type signature is wrong
        const pose = poses[0];
        return pose;
    }
}

});

parcelRegister("8L83R", function(module, exports) {

$parcel$export(module.exports, "BLACK", () => $ce26799e6486e213$export$7a91b0fde7ec420f);
$parcel$export(module.exports, "CLEAR", () => $ce26799e6486e213$export$6c4d37c7f376a1de);
$parcel$export(module.exports, "RED", () => $ce26799e6486e213$export$aa201224bb439d47);
$parcel$export(module.exports, "getNext", () => $ce26799e6486e213$export$ee97db0b1eaef5b1);
$parcel$export(module.exports, "toRGBA", () => $ce26799e6486e213$export$8da5152a7cb9deca);

var $g1iMd = parcelRequire("g1iMd");
const $ce26799e6486e213$export$7a91b0fde7ec420f = {
    r: 0,
    g: 0,
    b: 0,
    a: 255
};
const $ce26799e6486e213$export$6c4d37c7f376a1de = {
    r: 0,
    g: 0,
    b: 0,
    a: 0
};
const $ce26799e6486e213$export$aa201224bb439d47 = {
    r: 234,
    g: 53,
    b: 70,
    a: 255
};
const $ce26799e6486e213$var$toHexVal = (val)=>{
    // https://css-tricks.com/converting-color-spaces-in-javascript/#aa-rgb-to-hex
    const hex = val.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
};
const $ce26799e6486e213$var$toHex = (color)=>{
    return "#" + $ce26799e6486e213$var$toHexVal(color.r) + $ce26799e6486e213$var$toHexVal(color.g) + $ce26799e6486e213$var$toHexVal(color.b);
};
// https://coolors.co/f86624-f14e35-ea3546-a83271-873086-662e9b
const $ce26799e6486e213$var$NUM = 6;
const $ce26799e6486e213$var$scale = new (0, (/*@__PURE__*/$parcel$interopDefault($g1iMd)))(0, $ce26799e6486e213$var$NUM - 1, [
    "#49008E",
    $ce26799e6486e213$var$toHex($ce26799e6486e213$export$aa201224bb439d47),
    "#FCC52F"
]);
let $ce26799e6486e213$var$counter = 0;
const $ce26799e6486e213$export$ee97db0b1eaef5b1 = ()=>{
    const colorIndex = $ce26799e6486e213$var$counter % ($ce26799e6486e213$var$NUM - 1);
    const color = $ce26799e6486e213$var$scale.getColor(colorIndex);
    // their alpha scale goes 0-1
    color.a = 255;
    $ce26799e6486e213$var$counter += 1;
    return color;
};
const $ce26799e6486e213$export$8da5152a7cb9deca = (color)=>`rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;

});
parcelRegister("g1iMd", function(module, exports) {
"use strict";

var $1Xjb7 = parcelRequire("1Xjb7");
module.exports = $1Xjb7;

});
parcelRegister("1Xjb7", function(module, exports) {
'use strict';

var $a7LCU = parcelRequire("a7LCU");

var $hiF9I = parcelRequire("hiF9I");
function $16ca2d8f58d76303$var$hexToRgb(hex, alpha) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result) return new $a7LCU(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), alpha);
    else throw new Error(`${hex} is not a valid hex value.`);
}
class $16ca2d8f58d76303$var$ColorScale {
    constructor(min, max, colorStops, alpha = 1){
        $hiF9I.validateMinMaxValues(min, max);
        $hiF9I.validateColorStops(colorStops);
        $hiF9I.validateAlphaValue(alpha);
        this.min = min;
        this.max = max;
        this.alpha = alpha;
        this.colorStops = colorStops.map((colorStop)=>$16ca2d8f58d76303$var$hexToRgb(colorStop, alpha));
    }
    getColor(value) {
        const numOfColorStops = this.colorStops.length;
        if (value < this.min) return this.colorStops[0];
        if (value > this.max) return this.colorStops[numOfColorStops - 1];
        const range = this.max - this.min;
        let weight = (value - this.min) / range;
        const colorStopIndex = Math.max(Math.ceil(weight * (numOfColorStops - 1)), 1);
        const minColor = this.colorStops[colorStopIndex - 1];
        const maxColor = this.colorStops[colorStopIndex];
        weight = weight * (numOfColorStops - 1) - (colorStopIndex - 1);
        const r = Math.floor(weight * maxColor.r + (1 - weight) * minColor.r);
        const g = Math.floor(weight * maxColor.g + (1 - weight) * minColor.g);
        const b = Math.floor(weight * maxColor.b + (1 - weight) * minColor.b);
        return new $a7LCU(r, g, b, this.alpha);
    }
}
module.exports = $16ca2d8f58d76303$var$ColorScale;

});
parcelRegister("a7LCU", function(module, exports) {
'use strict';

var $hiF9I = parcelRequire("hiF9I");
function $75ef807964943a63$var$componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}
function $75ef807964943a63$var$rgbaToHex(color) {
    const r = Math.floor(color.r * color.a);
    const g = Math.floor(color.g * color.a);
    const b = Math.floor(color.b * color.a);
    return `#${$75ef807964943a63$var$componentToHex(r)}${$75ef807964943a63$var$componentToHex(g)}${$75ef807964943a63$var$componentToHex(b)}`;
}
class $75ef807964943a63$var$Color {
    constructor(r, g, b, a = 1){
        $hiF9I.validateAlphaValue(a);
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    toRGBString() {
        return `rgb(${Math.floor(this.r * this.a)},${Math.floor(this.g * this.a)},${Math.floor(this.b * this.a)})`;
    }
    toRGBAString() {
        return `rgba(${this.r},${this.g},${this.b},${this.a})`;
    }
    toHexString() {
        return $75ef807964943a63$var$rgbaToHex(this);
    }
}
module.exports = $75ef807964943a63$var$Color;

});
parcelRegister("hiF9I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAlphaValue = module.exports.validateColorStops = module.exports.validateMinMaxValues = void 0;
function $c9840aca2f1f5489$var$validateMinMaxValues(min, max) {
    if (min === max) throw new Error('The minimum value cannot be equal to the maximum value.');
    else if (min > max) throw new Error('The minimum value must be less than the maximum value.');
}
module.exports.validateMinMaxValues = $c9840aca2f1f5489$var$validateMinMaxValues;
function $c9840aca2f1f5489$var$validateColorStops(colorStops) {
    if (colorStops.length < 2) throw new Error('At least two colors must be provided.');
}
module.exports.validateColorStops = $c9840aca2f1f5489$var$validateColorStops;
function $c9840aca2f1f5489$var$validateAlphaValue(alpha) {
    if (alpha < 0 || alpha > 1) throw new Error('The alpha value must be between 0 and 1.');
}
module.exports.validateAlphaValue = $c9840aca2f1f5489$var$validateAlphaValue;

});





parcelRegister("doWik", function(module, exports) {

$parcel$export(module.exports, "getAverageDepth", () => $749be968c43e932e$export$7e12eef2536b68a8);
$parcel$export(module.exports, "calculateLineWidth", () => $749be968c43e932e$export$839cc58e98a7b59a);

var $f1q41 = parcelRequire("f1q41");
// https://google.github.io/mediapipe/solutions/pose.html#pose-landmark-model-blazepose-ghum-3d
const $749be968c43e932e$var$useForDepth = (keypoint)=>keypoint.z && keypoint.name && /_(hip|shoulder)$/.test(keypoint.name);
/**
 * far from the camera
 */ const $749be968c43e932e$var$DEPTH_MIN = 0.05;
/**
 * close to the camera
 */ const $749be968c43e932e$var$DEPTH_MAX = 0.8;
const $749be968c43e932e$export$7e12eef2536b68a8 = (keypoints)=>{
    const keypointsToUse = keypoints.filter($749be968c43e932e$var$useForDepth);
    // the mean() type signature is wrong
    const avg = (0, $f1q41.mean)(keypointsToUse.map((kp)=>kp.z));
    if (!avg) return null;
    // console.log(avg);
    return Math.abs(avg);
};
// https://stats.stackexchange.com/a/281164
const $749be968c43e932e$var$scale = (value, r_min, r_max, t_min, t_max)=>{
    return (value - r_min) * (t_max - t_min) / (r_max - r_min) + t_min;
};
const $749be968c43e932e$export$839cc58e98a7b59a = (keypoints)=>{
    const depth = $749be968c43e932e$export$7e12eef2536b68a8(keypoints);
    // console.log(depth);
    // somewhat arbitrary values
    if (!depth) return 6;
    const LINE_WIDTH_MIN = 3;
    const LINE_WIDTH_MAX = 150;
    const width = $749be968c43e932e$var$scale(depth, $749be968c43e932e$var$DEPTH_MIN, $749be968c43e932e$var$DEPTH_MAX, LINE_WIDTH_MIN, LINE_WIDTH_MAX);
    // don't go below the minimum line width
    return Math.max(width, LINE_WIDTH_MIN);
};

});


parcelRegister("jaTVV", function(module, exports) {
"use strict";
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $df5a56ac77c8be30$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $df5a56ac77c8be30$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.blurBodyPart = module.exports.drawBokehEffect = module.exports.drawPixelatedMask = module.exports.drawMask = module.exports.toColoredMask = module.exports.toBinaryMask = void 0;
parcelRequire("i64bB");
var $cpgue = parcelRequire("cpgue");
var $9jCh7 = parcelRequire("9jCh7");
var $df5a56ac77c8be30$var$CANVAS_NAMES = {
    blurred: 'blurred',
    blurredMask: 'blurred-mask',
    mask: 'mask',
    lowresPartMask: 'lowres-part-mask',
    drawImage: 'draw-image'
};
var $df5a56ac77c8be30$var$offScreenCanvases = {};
function $df5a56ac77c8be30$var$isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function $df5a56ac77c8be30$var$assertSameDimensions(_a, _b, nameA, nameB) {
    var widthA = _a.width, heightA = _a.height;
    var widthB = _b.width, heightB = _b.height;
    if (widthA !== widthB || heightA !== heightB) throw new Error("error: dimensions must match. ".concat(nameA, " has dimensions ").concat(widthA, "x").concat(heightA, ", ").concat(nameB, " has dimensions ").concat(widthB, "x").concat(heightB));
}
function $df5a56ac77c8be30$var$getSizeFromImageLikeElement(input) {
    if ('offsetHeight' in input && input.offsetHeight !== 0 && 'offsetWidth' in input && input.offsetWidth !== 0) return [
        input.offsetHeight,
        input.offsetWidth
    ];
    else if (input.height != null && input.width != null) return [
        input.height,
        input.width
    ];
    else throw new Error("HTMLImageElement must have height and width attributes set.");
}
function $df5a56ac77c8be30$var$getSizeFromVideoElement(input) {
    if (input.hasAttribute('height') && input.hasAttribute('width')) // Prioritizes user specified height and width.
    // We can't test the .height and .width properties directly,
    // because they evaluate to 0 if unset.
    return [
        input.height,
        input.width
    ];
    else return [
        input.videoHeight,
        input.videoWidth
    ];
}
function $df5a56ac77c8be30$var$getInputSize(input) {
    if (typeof HTMLCanvasElement !== 'undefined' && input instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && input instanceof OffscreenCanvas || typeof HTMLImageElement !== 'undefined' && input instanceof HTMLImageElement) return $df5a56ac77c8be30$var$getSizeFromImageLikeElement(input);
    else if (typeof ImageData !== 'undefined' && input instanceof ImageData) return [
        input.height,
        input.width
    ];
    else if (typeof HTMLVideoElement !== 'undefined' && input instanceof HTMLVideoElement) return $df5a56ac77c8be30$var$getSizeFromVideoElement(input);
    else if (input instanceof $9jCh7.Tensor) return [
        input.shape[0],
        input.shape[1]
    ];
    else throw new Error("error: Unknown input type: ".concat(input, "."));
}
function $df5a56ac77c8be30$var$createOffScreenCanvas() {
    if (typeof document !== 'undefined') return document.createElement('canvas');
    else if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(0, 0);
    else throw new Error('Cannot create a canvas in this context');
}
function $df5a56ac77c8be30$var$ensureOffscreenCanvasCreated(id) {
    if (!$df5a56ac77c8be30$var$offScreenCanvases[id]) $df5a56ac77c8be30$var$offScreenCanvases[id] = $df5a56ac77c8be30$var$createOffScreenCanvas();
    return $df5a56ac77c8be30$var$offScreenCanvases[id];
}
/**
 * Draw image data on a canvas.
 */ function $df5a56ac77c8be30$var$renderImageDataToCanvas(image, canvas) {
    canvas.width = image.width;
    canvas.height = image.height;
    var ctx = canvas.getContext('2d');
    ctx.putImageData(image, 0, 0);
}
function $df5a56ac77c8be30$var$renderImageDataToOffScreenCanvas(image, canvasName) {
    var canvas = $df5a56ac77c8be30$var$ensureOffscreenCanvasCreated(canvasName);
    $df5a56ac77c8be30$var$renderImageDataToCanvas(image, canvas);
    return canvas;
}
/**
 * Draw image on a 2D rendering context.
 */ function $df5a56ac77c8be30$var$drawImage(ctx, image, dx, dy, dw, dh) {
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var pixels, _a, height, width;
        return $df5a56ac77c8be30$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!(image instanceof $9jCh7.Tensor)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        $cpgue.toPixels(image)
                    ];
                case 1:
                    pixels = _b.sent();
                    _a = $df5a56ac77c8be30$var$getInputSize(image), height = _a[0], width = _a[1];
                    image = new ImageData(pixels, width, height);
                    _b.label = 2;
                case 2:
                    if (image instanceof ImageData) image = $df5a56ac77c8be30$var$renderImageDataToOffScreenCanvas(image, $df5a56ac77c8be30$var$CANVAS_NAMES.drawImage);
                    if (dw == null || dh == null) ctx.drawImage(image, dx, dy);
                    else ctx.drawImage(image, dx, dy, dw, dh);
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Draw image on a canvas.
 */ function $df5a56ac77c8be30$var$renderImageToCanvas(image, canvas) {
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var _a, height, width, ctx;
        return $df5a56ac77c8be30$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = $df5a56ac77c8be30$var$getInputSize(image), height = _a[0], width = _a[1];
                    canvas.width = width;
                    canvas.height = height;
                    ctx = canvas.getContext('2d');
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawImage(ctx, image, 0, 0, width, height)
                    ];
                case 1:
                    _b.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $df5a56ac77c8be30$var$flipCanvasHorizontal(canvas) {
    var ctx = canvas.getContext('2d');
    ctx.scale(-1, 1);
    ctx.translate(-canvas.width, 0);
}
function $df5a56ac77c8be30$var$drawWithCompositing(ctx, image, compositeOperation) {
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        return $df5a56ac77c8be30$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    // TODO: Assert type 'compositeOperation as GlobalCompositeOperation' after
                    // typescript update to 4.6.0 or later
                    // tslint:disable-next-line: no-any
                    ctx.globalCompositeOperation = compositeOperation;
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawImage(ctx, image, 0, 0)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
// method copied from bGlur in https://codepen.io/zhaojun/pen/zZmRQe
function $df5a56ac77c8be30$var$cpuBlur(canvas, image, blur) {
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var ctx, sum, delta, alphaLeft, step, y, x, weight, y, x;
        return $df5a56ac77c8be30$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    ctx = canvas.getContext('2d');
                    sum = 0;
                    delta = 5;
                    alphaLeft = 1 / (2 * Math.PI * delta * delta);
                    step = blur < 3 ? 1 : 2;
                    for(y = -blur; y <= blur; y += step)for(x = -blur; x <= blur; x += step){
                        weight = alphaLeft * Math.exp(-(x * x + y * y) / (2 * delta * delta));
                        sum += weight;
                    }
                    y = -blur;
                    _a.label = 1;
                case 1:
                    if (!(y <= blur)) return [
                        3 /*break*/ ,
                        6
                    ];
                    x = -blur;
                    _a.label = 2;
                case 2:
                    if (!(x <= blur)) return [
                        3 /*break*/ ,
                        5
                    ];
                    ctx.globalAlpha = alphaLeft * Math.exp(-(x * x + y * y) / (2 * delta * delta)) / sum * blur;
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawImage(ctx, image, x, y)
                    ];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    x += step;
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 5:
                    y += step;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 6:
                    ctx.globalAlpha = 1;
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $df5a56ac77c8be30$var$drawAndBlurImageOnCanvas(image, blurAmount, canvas) {
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var _a, height, width, ctx;
        return $df5a56ac77c8be30$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = $df5a56ac77c8be30$var$getInputSize(image), height = _a[0], width = _a[1];
                    ctx = canvas.getContext('2d');
                    canvas.width = width;
                    canvas.height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.save();
                    if (!$df5a56ac77c8be30$var$isSafari()) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$cpuBlur(canvas, image, blurAmount)
                    ];
                case 1:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    // tslint:disable:no-any
                    ctx.filter = "blur(".concat(blurAmount, "px)");
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawImage(ctx, image, 0, 0, width, height)
                    ];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $df5a56ac77c8be30$var$drawAndBlurImageOnOffScreenCanvas(image, blurAmount, offscreenCanvasName) {
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var canvas;
        return $df5a56ac77c8be30$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    canvas = $df5a56ac77c8be30$var$ensureOffscreenCanvasCreated(offscreenCanvasName);
                    if (!(blurAmount === 0)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$renderImageToCanvas(image, canvas)
                    ];
                case 1:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawAndBlurImageOnCanvas(image, blurAmount, canvas)
                    ];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    return [
                        2 /*return*/ ,
                        canvas
                    ];
            }
        });
    });
}
function $df5a56ac77c8be30$var$drawStroke(bytes, row, column, width, radius, color) {
    if (color === void 0) color = {
        r: 0,
        g: 255,
        b: 255,
        a: 255
    };
    for(var i = -radius; i <= radius; i++){
        for(var j = -radius; j <= radius; j++)if (i !== 0 && j !== 0) {
            var n = (row + i) * width + (column + j);
            bytes[4 * n + 0] = color.r;
            bytes[4 * n + 1] = color.g;
            bytes[4 * n + 2] = color.b;
            bytes[4 * n + 3] = color.a;
        }
    }
}
function $df5a56ac77c8be30$var$isSegmentationBoundary(data, row, column, width, isForegroundId, alphaCutoff, radius) {
    if (radius === void 0) radius = 1;
    var numberBackgroundPixels = 0;
    for(var i = -radius; i <= radius; i++){
        for(var j = -radius; j <= radius; j++)if (i !== 0 && j !== 0) {
            var n = (row + i) * width + (column + j);
            if (!isForegroundId[data[4 * n]] || data[4 * n + 3] < alphaCutoff) numberBackgroundPixels += 1;
        }
    }
    return numberBackgroundPixels > 0;
}
/**
 * Given a segmentation or array of segmentations, generates an
 * image with foreground and background color at each pixel determined by the
 * corresponding binary segmentation value at the pixel from the output.  In
 * other words, pixels where there is a person will be colored with foreground
 * color and where there is not a person will be colored with background color.
 *
 * @param segmentation Single segmentation or array of segmentations.
 *
 * @param foreground Default to {r:0, g:0, b:0, a: 0}. The foreground color
 * (r,g,b,a) for visualizing pixels that belong to people.
 *
 * @param background Default to {r:0, g:0, b:0, a: 255}. The background color
 * (r,g,b,a) for visualizing pixels that don't belong to people.
 *
 * @param drawContour Default to false. Whether to draw the contour around each
 * person's segmentation mask or body part mask.
 *
 * @param foregroundThreshold Default to 0.5. The minimum probability
 * to color a pixel as foreground rather than background. The alpha channel
 * integer values will be taken as the probabilities (for more information refer
 * to `Segmentation` type's documentation).
 *
 * @param foregroundMaskValues Default to all mask values. The red channel
 *     integer values that represent foreground (for more information refer to
 * `Segmentation` type's documentation).
 *
 * @returns An ImageData with the same width and height of
 * the input segmentations, with opacity and
 * transparency at each pixel determined by the corresponding binary
 * segmentation value at the pixel from the output.
 */ function $df5a56ac77c8be30$var$toBinaryMask(segmentation, foreground, background, drawContour, foregroundThreshold, foregroundMaskValues) {
    if (foreground === void 0) foreground = {
        r: 0,
        g: 0,
        b: 0,
        a: 0
    };
    if (background === void 0) background = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (drawContour === void 0) drawContour = false;
    if (foregroundThreshold === void 0) foregroundThreshold = 0.5;
    if (foregroundMaskValues === void 0) foregroundMaskValues = Array.from(Array(256).keys());
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var segmentations, masks, _a, width, height, bytes, alphaCutoff, isForegroundId, i, j, n, _i, masks_1, mask;
        return $df5a56ac77c8be30$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    segmentations = !Array.isArray(segmentation) ? [
                        segmentation
                    ] : segmentation;
                    if (segmentations.length === 0) return [
                        2 /*return*/ ,
                        null
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(segmentations.map(function(segmentation) {
                            return segmentation.mask.toImageData();
                        }))
                    ];
                case 1:
                    masks = _b.sent();
                    _a = masks[0], width = _a.width, height = _a.height;
                    bytes = new Uint8ClampedArray(width * height * 4);
                    alphaCutoff = Math.round(255 * foregroundThreshold);
                    isForegroundId = new Array(256).fill(false);
                    foregroundMaskValues.forEach(function(id) {
                        return isForegroundId[id] = true;
                    });
                    for(i = 0; i < height; i++)for(j = 0; j < width; j++){
                        n = i * width + j;
                        bytes[4 * n + 0] = background.r;
                        bytes[4 * n + 1] = background.g;
                        bytes[4 * n + 2] = background.b;
                        bytes[4 * n + 3] = background.a;
                        for(_i = 0, masks_1 = masks; _i < masks_1.length; _i++){
                            mask = masks_1[_i];
                            if (isForegroundId[mask.data[4 * n]] && mask.data[4 * n + 3] >= alphaCutoff) {
                                bytes[4 * n] = foreground.r;
                                bytes[4 * n + 1] = foreground.g;
                                bytes[4 * n + 2] = foreground.b;
                                bytes[4 * n + 3] = foreground.a;
                                if (drawContour && i - 1 >= 0 && i + 1 < height && j - 1 >= 0 && j + 1 < width && $df5a56ac77c8be30$var$isSegmentationBoundary(mask.data, i, j, width, isForegroundId, alphaCutoff)) $df5a56ac77c8be30$var$drawStroke(bytes, i, j, width, 1);
                            }
                        }
                    }
                    return [
                        2 /*return*/ ,
                        new ImageData(bytes, width, height)
                    ];
            }
        });
    });
}
module.exports.toBinaryMask = $df5a56ac77c8be30$var$toBinaryMask;
/**
 * Given a segmentation or array of segmentations, and a function mapping
 * the red pixel values (representing body part labels) to colours,
 * generates an image with the corresponding color for each part at each pixel,
 * and background color used where there is no part.
 *
 * @param segmentation Single segmentation or array of segmentations.
 *
 * @param maskValueToColor A function mapping red channel mask values to
 * colors to use in output image.
 *
 * @param background Default to {r:0, g:0, b:0, a: 255}. The background color
 * (r,g,b,a) for visualizing pixels that don't belong to people.
 *
 * @param foregroundThreshold Default to 0.5. The minimum probability
 * to color a pixel as foreground rather than background. The alpha channel
 * integer values will be taken as the probabilities (for more information refer
 * to `Segmentation` type's documentation).
 *
 * @returns An ImageData with the same width and height of input segmentations,
 * with the corresponding color for each part at each pixel, and background
 * pixels where there is no part.
 */ function $df5a56ac77c8be30$var$toColoredMask(segmentation, maskValueToColor, background, foregroundThreshold) {
    if (background === void 0) background = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (foregroundThreshold === void 0) foregroundThreshold = 0.5;
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var segmentations, masks, _a, width, height, bytes, alphaCutoff, i, j, _i, masks_2, mask, maskValue, color;
        return $df5a56ac77c8be30$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    segmentations = !Array.isArray(segmentation) ? [
                        segmentation
                    ] : segmentation;
                    if (segmentations.length === 0) return [
                        2 /*return*/ ,
                        null
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(segmentations.map(function(segmentation) {
                            return segmentation.mask.toImageData();
                        }))
                    ];
                case 1:
                    masks = _b.sent();
                    _a = masks[0], width = _a.width, height = _a.height;
                    bytes = new Uint8ClampedArray(width * height * 4);
                    alphaCutoff = Math.round(255 * foregroundThreshold);
                    for(i = 0; i < height * width; ++i){
                        j = i * 4;
                        bytes[j + 0] = background.r;
                        bytes[j + 1] = background.g;
                        bytes[j + 2] = background.b;
                        bytes[j + 3] = background.a;
                        for(_i = 0, masks_2 = masks; _i < masks_2.length; _i++){
                            mask = masks_2[_i];
                            if (mask.data[j + 3] >= alphaCutoff) {
                                maskValue = mask.data[j];
                                color = maskValueToColor(maskValue);
                                bytes[j + 0] = color.r;
                                bytes[j + 1] = color.g;
                                bytes[j + 2] = color.b;
                                bytes[j + 3] = color.a;
                            }
                        }
                    }
                    return [
                        2 /*return*/ ,
                        new ImageData(bytes, width, height)
                    ];
            }
        });
    });
}
module.exports.toColoredMask = $df5a56ac77c8be30$var$toColoredMask;
/**
 * Given an image and a maskImage of type ImageData, draws the image with the
 * mask on top of it onto a canvas.
 *
 * @param canvas The canvas to be drawn onto.
 *
 * @param image The original image to apply the mask to.
 *
 * @param maskImage An ImageData containing the mask. Ideally this should be
 * generated by toBinaryMask or toColoredMask.
 *
 * @param maskOpacity The opacity of the mask when drawing it on top of the
 * image. Defaults to 0.7. Should be a float between 0 and 1.
 *
 * @param maskBlurAmount How many pixels to blur the mask by. Defaults to 0.
 * Should be an integer between 0 and 20.
 *
 * @param flipHorizontal If the result should be flipped horizontally.  Defaults
 * to false.
 */ function $df5a56ac77c8be30$var$drawMask(canvas, image, maskImage, maskOpacity, maskBlurAmount, flipHorizontal) {
    if (maskOpacity === void 0) maskOpacity = 0.7;
    if (maskBlurAmount === void 0) maskBlurAmount = 0;
    if (flipHorizontal === void 0) flipHorizontal = false;
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var _a, height, width, ctx, mask, blurredMask;
        return $df5a56ac77c8be30$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = $df5a56ac77c8be30$var$getInputSize(image), height = _a[0], width = _a[1];
                    canvas.width = width;
                    canvas.height = height;
                    ctx = canvas.getContext('2d');
                    ctx.save();
                    if (flipHorizontal) $df5a56ac77c8be30$var$flipCanvasHorizontal(canvas);
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawImage(ctx, image, 0, 0)
                    ];
                case 1:
                    _b.sent();
                    ctx.globalAlpha = maskOpacity;
                    if (!maskImage) return [
                        3 /*break*/ ,
                        3
                    ];
                    $df5a56ac77c8be30$var$assertSameDimensions({
                        width: width,
                        height: height
                    }, maskImage, 'image', 'mask');
                    mask = $df5a56ac77c8be30$var$renderImageDataToOffScreenCanvas(maskImage, $df5a56ac77c8be30$var$CANVAS_NAMES.mask);
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawAndBlurImageOnOffScreenCanvas(mask, maskBlurAmount, $df5a56ac77c8be30$var$CANVAS_NAMES.blurredMask)
                    ];
                case 2:
                    blurredMask = _b.sent();
                    ctx.drawImage(blurredMask, 0, 0, width, height);
                    _b.label = 3;
                case 3:
                    ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.drawMask = $df5a56ac77c8be30$var$drawMask;
/**
 * Given an image and a maskImage of type ImageData, draws the image with the
 * pixelated mask on top of it onto a canvas.
 *
 * @param canvas The canvas to be drawn onto.
 *
 * @param image The original image to apply the mask to.
 *
 * @param maskImage An ImageData containing the mask.  Ideally this should be
 * generated by toColoredmask.
 *
 * @param maskOpacity The opacity of the mask when drawing it on top of the
 * image. Defaults to 0.7. Should be a float between 0 and 1.
 *
 * @param maskBlurAmount How many pixels to blur the mask by. Defaults to 0.
 * Should be an integer between 0 and 20.
 *
 * @param flipHorizontal If the result should be flipped horizontally.  Defaults
 * to false.
 *
 * @param pixelCellWidth The width of each pixel cell. Default to 10 px.
 */ function $df5a56ac77c8be30$var$drawPixelatedMask(canvas, image, maskImage, maskOpacity, maskBlurAmount, flipHorizontal, pixelCellWidth) {
    if (maskOpacity === void 0) maskOpacity = 0.7;
    if (maskBlurAmount === void 0) maskBlurAmount = 0;
    if (flipHorizontal === void 0) flipHorizontal = false;
    if (pixelCellWidth === void 0) pixelCellWidth = 10.0;
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var _a, height, width, mask, blurredMask, ctx, offscreenCanvas, offscreenCanvasCtx, i, i;
        return $df5a56ac77c8be30$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = $df5a56ac77c8be30$var$getInputSize(image), height = _a[0], width = _a[1];
                    $df5a56ac77c8be30$var$assertSameDimensions({
                        width: width,
                        height: height
                    }, maskImage, 'image', 'mask');
                    mask = $df5a56ac77c8be30$var$renderImageDataToOffScreenCanvas(maskImage, $df5a56ac77c8be30$var$CANVAS_NAMES.mask);
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawAndBlurImageOnOffScreenCanvas(mask, maskBlurAmount, $df5a56ac77c8be30$var$CANVAS_NAMES.blurredMask)
                    ];
                case 1:
                    blurredMask = _b.sent();
                    canvas.width = blurredMask.width;
                    canvas.height = blurredMask.height;
                    ctx = canvas.getContext('2d');
                    ctx.save();
                    if (flipHorizontal) $df5a56ac77c8be30$var$flipCanvasHorizontal(canvas);
                    offscreenCanvas = $df5a56ac77c8be30$var$ensureOffscreenCanvasCreated($df5a56ac77c8be30$var$CANVAS_NAMES.lowresPartMask);
                    offscreenCanvasCtx = offscreenCanvas.getContext('2d');
                    offscreenCanvas.width = blurredMask.width * (1.0 / pixelCellWidth);
                    offscreenCanvas.height = blurredMask.height * (1.0 / pixelCellWidth);
                    offscreenCanvasCtx.drawImage(blurredMask, 0, 0, blurredMask.width, blurredMask.height, 0, 0, offscreenCanvas.width, offscreenCanvas.height);
                    ctx.imageSmoothingEnabled = false;
                    ctx.drawImage(offscreenCanvas, 0, 0, offscreenCanvas.width, offscreenCanvas.height, 0, 0, canvas.width, canvas.height);
                    // Draws vertical grid lines that are `pixelCellWidth` apart from each other.
                    for(i = 0; i < offscreenCanvas.width; i++){
                        ctx.beginPath();
                        ctx.strokeStyle = '#ffffff';
                        ctx.moveTo(pixelCellWidth * i, 0);
                        ctx.lineTo(pixelCellWidth * i, canvas.height);
                        ctx.stroke();
                    }
                    // Draws horizontal grid lines that are `pixelCellWidth` apart from each
                    // other.
                    for(i = 0; i < offscreenCanvas.height; i++){
                        ctx.beginPath();
                        ctx.strokeStyle = '#ffffff';
                        ctx.moveTo(0, pixelCellWidth * i);
                        ctx.lineTo(canvas.width, pixelCellWidth * i);
                        ctx.stroke();
                    }
                    ctx.globalAlpha = 1.0 - maskOpacity;
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawImage(ctx, image, 0, 0, blurredMask.width, blurredMask.height)
                    ];
                case 2:
                    _b.sent();
                    ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.drawPixelatedMask = $df5a56ac77c8be30$var$drawPixelatedMask;
function $df5a56ac77c8be30$var$createPersonMask(segmentation, foregroundThreshold, edgeBlurAmount) {
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var backgroundMaskImage, backgroundMask;
        return $df5a56ac77c8be30$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$toBinaryMask(segmentation, {
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 255
                        }, {
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 0
                        }, false, foregroundThreshold)
                    ];
                case 1:
                    backgroundMaskImage = _a.sent();
                    backgroundMask = $df5a56ac77c8be30$var$renderImageDataToOffScreenCanvas(backgroundMaskImage, $df5a56ac77c8be30$var$CANVAS_NAMES.mask);
                    if (edgeBlurAmount === 0) return [
                        2 /*return*/ ,
                        backgroundMask
                    ];
                    else return [
                        2 /*return*/ ,
                        $df5a56ac77c8be30$var$drawAndBlurImageOnOffScreenCanvas(backgroundMask, edgeBlurAmount, $df5a56ac77c8be30$var$CANVAS_NAMES.blurredMask)
                    ];
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Given a segmentation or array of segmentations, and an image, draws the image
 * with its background blurred onto the canvas.
 *
 * @param canvas The canvas to draw the background-blurred image onto.
 *
 * @param image The image to blur the background of and draw.
 *
 * @param segmentation Single segmentation or array of segmentations.
 *
 * @param foregroundThreshold Default to 0.5. The minimum probability
 * to color a pixel as foreground rather than background. The alpha channel
 * integer values will be taken as the probabilities (for more information refer
 * to `Segmentation` type's documentation).
 *
 * @param backgroundBlurAmount How many pixels in the background blend into each
 * other.  Defaults to 3. Should be an integer between 1 and 20.
 *
 * @param edgeBlurAmount How many pixels to blur on the edge between the person
 * and the background by.  Defaults to 3. Should be an integer between 0 and 20.
 *
 * @param flipHorizontal If the output should be flipped horizontally.  Defaults
 * to false.
 */ function $df5a56ac77c8be30$var$drawBokehEffect(canvas, image, segmentation, foregroundThreshold, backgroundBlurAmount, edgeBlurAmount, flipHorizontal) {
    if (foregroundThreshold === void 0) foregroundThreshold = 0.5;
    if (backgroundBlurAmount === void 0) backgroundBlurAmount = 3;
    if (edgeBlurAmount === void 0) edgeBlurAmount = 3;
    if (flipHorizontal === void 0) flipHorizontal = false;
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var blurredImage, ctx, personMask, _a, height, width;
        return $df5a56ac77c8be30$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawAndBlurImageOnOffScreenCanvas(image, backgroundBlurAmount, $df5a56ac77c8be30$var$CANVAS_NAMES.blurred)
                    ];
                case 1:
                    blurredImage = _b.sent();
                    canvas.width = blurredImage.width;
                    canvas.height = blurredImage.height;
                    ctx = canvas.getContext('2d');
                    if (Array.isArray(segmentation) && segmentation.length === 0) {
                        ctx.drawImage(blurredImage, 0, 0);
                        return [
                            2 /*return*/ 
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$createPersonMask(segmentation, foregroundThreshold, edgeBlurAmount)
                    ];
                case 2:
                    personMask = _b.sent();
                    ctx.save();
                    if (flipHorizontal) $df5a56ac77c8be30$var$flipCanvasHorizontal(canvas);
                    _a = $df5a56ac77c8be30$var$getInputSize(image), height = _a[0], width = _a[1];
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawImage(ctx, image, 0, 0, width, height)
                    ];
                case 3:
                    _b.sent();
                    // "destination-in" - "The existing canvas content is kept where both the
                    // new shape and existing canvas content overlap. Everything else is made
                    // transparent."
                    // crop what's not the person using the mask from the original image
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawWithCompositing(ctx, personMask, 'destination-in')
                    ];
                case 4:
                    // "destination-in" - "The existing canvas content is kept where both the
                    // new shape and existing canvas content overlap. Everything else is made
                    // transparent."
                    // crop what's not the person using the mask from the original image
                    _b.sent();
                    // "destination-over" - "The existing canvas content is kept where both the
                    // new shape and existing canvas content overlap. Everything else is made
                    // transparent."
                    // draw the blurred background on top of the original image where it doesn't
                    // overlap.
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawWithCompositing(ctx, blurredImage, 'destination-over')
                    ];
                case 5:
                    // "destination-over" - "The existing canvas content is kept where both the
                    // new shape and existing canvas content overlap. Everything else is made
                    // transparent."
                    // draw the blurred background on top of the original image where it doesn't
                    // overlap.
                    _b.sent();
                    ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.drawBokehEffect = $df5a56ac77c8be30$var$drawBokehEffect;
function $df5a56ac77c8be30$var$createBodyPartMask(segmentation, maskValuesToBlur, foregroundThreshold, edgeBlurAmount) {
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var backgroundMaskImage, backgroundMask;
        return $df5a56ac77c8be30$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$toBinaryMask(segmentation, {
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 0
                        }, {
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 255
                        }, true, foregroundThreshold, maskValuesToBlur)
                    ];
                case 1:
                    backgroundMaskImage = _a.sent();
                    backgroundMask = $df5a56ac77c8be30$var$renderImageDataToOffScreenCanvas(backgroundMaskImage, $df5a56ac77c8be30$var$CANVAS_NAMES.mask);
                    if (edgeBlurAmount === 0) return [
                        2 /*return*/ ,
                        backgroundMask
                    ];
                    else return [
                        2 /*return*/ ,
                        $df5a56ac77c8be30$var$drawAndBlurImageOnOffScreenCanvas(backgroundMask, edgeBlurAmount, $df5a56ac77c8be30$var$CANVAS_NAMES.blurredMask)
                    ];
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Given a personSegmentation and an image, draws the image with its background
 * blurred onto the canvas.
 *
 * @param canvas The canvas to draw the background-blurred image onto.
 *
 * @param image The image to blur the background of and draw.
 *
 * @param segmentation Single segmentation or array of segmentations.
 *
 * @param maskValuesToBlur An array of red channel mask values to blur
 *     (representing different body parts, refer to `Segmentation` interface
 * docs for more details).
 *
 * @param foregroundThreshold Default to 0.5. The minimum probability
 * to color a pixel as foreground rather than background. The alpha channel
 * integer values will be taken as the probabilities (for more information refer
 * to `Segmentation` type's documentation).
 *
 * @param backgroundBlurAmount How many pixels in the background blend into each
 * other.  Defaults to 3. Should be an integer between 1 and 20.
 *
 * @param edgeBlurAmount How many pixels to blur on the edge between the person
 * and the background by.  Defaults to 3. Should be an integer between 0 and 20.
 *
 * @param flipHorizontal If the output should be flipped horizontally.  Defaults
 * to false.
 */ function $df5a56ac77c8be30$var$blurBodyPart(canvas, image, segmentation, maskValuesToBlur, foregroundThreshold, backgroundBlurAmount, edgeBlurAmount, flipHorizontal) {
    if (foregroundThreshold === void 0) foregroundThreshold = 0.5;
    if (backgroundBlurAmount === void 0) backgroundBlurAmount = 3;
    if (edgeBlurAmount === void 0) edgeBlurAmount = 3;
    if (flipHorizontal === void 0) flipHorizontal = false;
    return $df5a56ac77c8be30$var$__awaiter(this, void 0, void 0, function() {
        var blurredImage, ctx, bodyPartMask, _a, height, width;
        return $df5a56ac77c8be30$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawAndBlurImageOnOffScreenCanvas(image, backgroundBlurAmount, $df5a56ac77c8be30$var$CANVAS_NAMES.blurred)
                    ];
                case 1:
                    blurredImage = _b.sent();
                    canvas.width = blurredImage.width;
                    canvas.height = blurredImage.height;
                    ctx = canvas.getContext('2d');
                    if (Array.isArray(segmentation) && segmentation.length === 0) {
                        ctx.drawImage(blurredImage, 0, 0);
                        return [
                            2 /*return*/ 
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$createBodyPartMask(segmentation, maskValuesToBlur, foregroundThreshold, edgeBlurAmount)
                    ];
                case 2:
                    bodyPartMask = _b.sent();
                    ctx.save();
                    if (flipHorizontal) $df5a56ac77c8be30$var$flipCanvasHorizontal(canvas);
                    _a = $df5a56ac77c8be30$var$getInputSize(image), height = _a[0], width = _a[1];
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawImage(ctx, image, 0, 0, width, height)
                    ];
                case 3:
                    _b.sent();
                    // "destination-in" - "The existing canvas content is kept where both the
                    // new shape and existing canvas content overlap. Everything else is made
                    // transparent."
                    // crop what's not the person using the mask from the original image
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawWithCompositing(ctx, bodyPartMask, 'destination-in')
                    ];
                case 4:
                    // "destination-in" - "The existing canvas content is kept where both the
                    // new shape and existing canvas content overlap. Everything else is made
                    // transparent."
                    // crop what's not the person using the mask from the original image
                    _b.sent();
                    // "destination-over" - "The existing canvas content is kept where both the
                    // new shape and existing canvas content overlap. Everything else is made
                    // transparent."
                    // draw the blurred background on top of the original image where it doesn't
                    // overlap.
                    return [
                        4 /*yield*/ ,
                        $df5a56ac77c8be30$var$drawWithCompositing(ctx, blurredImage, 'destination-over')
                    ];
                case 5:
                    // "destination-over" - "The existing canvas content is kept where both the
                    // new shape and existing canvas content overlap. Everything else is made
                    // transparent."
                    // draw the blurred background on top of the original image where it doesn't
                    // overlap.
                    _b.sent();
                    ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.blurBodyPart = $df5a56ac77c8be30$var$blurBodyPart;

});


parcelRegister("dOTXv", function(module, exports) {

$parcel$export(module.exports, "sortEfects", () => $503f966cbf824b4f$export$9dcdfc2ade4bc120);
$parcel$export(module.exports, "default", () => $503f966cbf824b4f$export$2e2bcd8739ae039);

var $doWik = parcelRequire("doWik");
const $503f966cbf824b4f$export$9dcdfc2ade4bc120 = (currentPose, effects)=>{
    effects.sort((a, b)=>{
        const aVal = a.sortVal(currentPose);
        const bVal = b.sortVal(currentPose);
        if (aVal && bVal) {
            if (aVal < bVal) return -1;
            if (aVal > bVal) return 1;
        }
        // a must be equal to b, or one doesn't have a sortVal()
        return 0;
    });
};
class $503f966cbf824b4f$export$2e2bcd8739ae039 {
    sortVal(currentPose) {
        return (0, $doWik.getAverageDepth)(currentPose.keypoints);
    }
}

});


parcelRegister("fRSJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab018f5a560ba411$export$2e2bcd8739ae039);

var $4ynSh = parcelRequire("4ynSh");

var $doWik = parcelRequire("doWik");

var $dOTXv = parcelRequire("dOTXv");

var $8L83R = parcelRequire("8L83R");
class $ab018f5a560ba411$export$2e2bcd8739ae039 extends (0, $dOTXv.default) {
    constructor(){
        super();
        this.color = $8L83R.getNext();
    }
    sortVal(_currentPose) {
        if (!this.frame) return null;
        return (0, $doWik.getAverageDepth)(this.frame.keypoints);
    }
    async onAnimationFrame(pose, canvas) {
        if (!this.frame) this.frame = pose;
        (0, $4ynSh.drawSkeleton)(this.frame, canvas, this.color);
    }
    /**
   * Adds a Freeze to the list of effects.
   * @param effects - gets modified
   */ static addTo(effects) {
        const freeze = new $ab018f5a560ba411$export$2e2bcd8739ae039();
        effects.push(freeze);
    }
}

});

parcelRegister("ls8n9", function(module, exports) {

$parcel$export(module.exports, "SORT_VAL", () => $58183b87fc31d4d5$export$20256598e125d8a9);
$parcel$export(module.exports, "default", () => $58183b87fc31d4d5$export$2e2bcd8739ae039);

var $dOTXv = parcelRequire("dOTXv");
const $58183b87fc31d4d5$export$20256598e125d8a9 = -1000;
class $58183b87fc31d4d5$export$2e2bcd8739ae039 extends (0, $dOTXv.default) {
    constructor(video){
        super();
        this.video = video;
    }
    /**
   * @returns an arbitrary low value, so that this effect always appears in the back
   */ sortVal(_currentPose) {
        return $58183b87fc31d4d5$export$20256598e125d8a9;
    }
    async onAnimationFrame(_pose, canvas) {
        canvas.context.drawImage(this.video.el, 0, 0);
    }
    static addTo(effects, video) {
        const effect = new $58183b87fc31d4d5$export$2e2bcd8739ae039(video);
        effects.unshift(effect);
    }
}

});

parcelRegister("8D2Sv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2cb238f7b2ce3f5$export$2e2bcd8739ae039);

var $4ynSh = parcelRequire("4ynSh");

var $dOTXv = parcelRequire("dOTXv");

var $8L83R = parcelRequire("8L83R");
class $b2cb238f7b2ce3f5$export$2e2bcd8739ae039 extends (0, $dOTXv.default) {
    constructor(){
        super();
        this.color = $8L83R.getNext();
    }
    async onAnimationFrame(pose, canvas) {
        if (pose?.segmentation) await (0, $4ynSh.drawMask)(pose.segmentation, canvas, this.color);
    }
    /**
   * Adds the Shadow to the list of effects if there isn't one already present.
   * @param effects - gets modified
   */ static addTo(effects) {
        const hasShadow = effects.some((effect)=>effect instanceof $b2cb238f7b2ce3f5$export$2e2bcd8739ae039);
        if (!hasShadow) {
            const effect = new $b2cb238f7b2ce3f5$export$2e2bcd8739ae039();
            // the Shadow needs to be first, because otherwise it overwrites the other effects
            effects.unshift(effect);
        }
    }
}

});

parcelRegister("51Ld3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab7971209f29d54e$export$2e2bcd8739ae039);

var $dOTXv = parcelRequire("dOTXv");

var $ls8n9 = parcelRequire("ls8n9");
class $ab7971209f29d54e$export$2e2bcd8739ae039 extends (0, $dOTXv.default) {
    /**
   * @returns an arbitrary low value, so that this effect always appears in the back
   */ sortVal(_currentPose) {
        // ensure the live video appears above this
        return $ls8n9.SORT_VAL - 1000;
    }
    async onAnimationFrame(_pose, canvas) {
        // https://stackoverflow.com/q/22003491/358804
        if (!this.idata || this.idata.width !== canvas.width() || this.idata.height !== canvas.height()) this.idata = canvas.context.createImageData(canvas.width(), canvas.height());
        for(let i = 0; i < this.idata.data.length; i += 4){
            const color = Math.random() < 0.5 ? 0 : 255;
            this.idata.data[i] = color;
            this.idata.data[i + 1] = color;
            this.idata.data[i + 2] = color;
            this.idata.data[i + 3] = 255;
        }
        canvas.context.putImageData(this.idata, 0, 0);
    }
    static addTo(effects) {
        // remove other Effects
        effects.splice(0);
        const effect = new $ab7971209f29d54e$export$2e2bcd8739ae039();
        effects.unshift(effect);
    }
}

});



//# sourceMappingURL=speech.f14ceeb8.js.map
